(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9b8c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9b8c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3pG7n", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $27c460ac8853a1cf$export$6503ec6e8aabbaf; }, function (v) { return $27c460ac8853a1cf$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $27c460ac8853a1cf$export$f7ad0328861e2f03; }, function (v) { return $27c460ac8853a1cf$export$f7ad0328861e2f03 = v; });
var $27c460ac8853a1cf$export$6503ec6e8aabbaf;
var $27c460ac8853a1cf$export$f7ad0328861e2f03;
"use strict";
var $27c460ac8853a1cf$var$mapping = new Map();
function $27c460ac8853a1cf$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$27c460ac8853a1cf$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $27c460ac8853a1cf$var$resolve(id) {
    var resolved = $27c460ac8853a1cf$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$27c460ac8853a1cf$export$6503ec6e8aabbaf = $27c460ac8853a1cf$var$register;
$27c460ac8853a1cf$export$f7ad0328861e2f03 = $27c460ac8853a1cf$var$resolve;

});

parcelRegister("9LRG6", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $71d22431f285798e$export$bdfd709ae4826697; }, function (v) { return $71d22431f285798e$export$bdfd709ae4826697 = v; });
var $71d22431f285798e$export$bdfd709ae4826697;
var $71d22431f285798e$export$c9e73fbda7da57b6;
var $71d22431f285798e$export$5a759dc7a1cfb72a;
"use strict";
var $71d22431f285798e$var$bundleURL = {};
function $71d22431f285798e$var$getBundleURLCached(id) {
    var value = $71d22431f285798e$var$bundleURL[id];
    if (!value) {
        value = $71d22431f285798e$var$getBundleURL();
        $71d22431f285798e$var$bundleURL[id] = value;
    }
    return value;
}
function $71d22431f285798e$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $71d22431f285798e$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $71d22431f285798e$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $71d22431f285798e$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$71d22431f285798e$export$bdfd709ae4826697 = $71d22431f285798e$var$getBundleURLCached;
$71d22431f285798e$export$c9e73fbda7da57b6 = $71d22431f285798e$var$getBaseURL;
$71d22431f285798e$export$5a759dc7a1cfb72a = $71d22431f285798e$var$getOrigin;

});

parcelRegister("3MRB0", function(module, exports) {




/*!
  * Bootstrap base-component.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory((parcelRequire("kAebX")), (parcelRequire("eFdKX")), (parcelRequire("hSuWC")), (parcelRequire("jpXV4")));
})(module.exports, function(Data, EventHandler, Config, index_js) {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap base-component.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const VERSION = "5.3.3";
    /**
   * Class definition
   */ class BaseComponent extends Config {
        // Public
        dispose() {
            Data.remove(this._element, this.constructor.DATA_KEY);
            EventHandler.off(this._element, this.constructor.EVENT_KEY);
            for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
        }
        _queueCallback(callback, element, isAnimated = true) {
            index_js.executeAfterTransition(callback, element, isAnimated);
        }
        _getConfig(config) {
            config = this._mergeConfigObj(config, this._element);
            config = this._configAfterMerge(config);
            this._typeCheckConfig(config);
            return config;
        }
        // Static
        static getInstance(element) {
            return Data.get(index_js.getElement(element), this.DATA_KEY);
        }
        static getOrCreateInstance(element, config = {}) {
            return this.getInstance(element) || new this(element, typeof config === "object" ? config : null);
        }
        static get VERSION() {
            return VERSION;
        }
        static get DATA_KEY() {
            return `bs.${this.NAME}`;
        }
        static get EVENT_KEY() {
            return `.${this.DATA_KEY}`;
        }
        static eventName(name) {
            return `${name}${this.EVENT_KEY}`;
        }
        constructor(element, config){
            super();
            element = index_js.getElement(element);
            if (!element) return;
            this._element = element;
            this._config = this._getConfig(config);
            Data.set(this._element, this.constructor.DATA_KEY, this);
        }
    }
    return BaseComponent;
});

});
parcelRegister("kAebX", function(module, exports) {
/*!
  * Bootstrap data.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/data.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const elementMap = new Map();
    const data = {
        set (element, key, instance) {
            if (!elementMap.has(element)) elementMap.set(element, new Map());
            const instanceMap = elementMap.get(element);
            // make it clear we only want one instance per element
            // can be removed later when multiple key/instances are fine to be used
            if (!instanceMap.has(key) && instanceMap.size !== 0) {
                // eslint-disable-next-line no-console
                console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
                return;
            }
            instanceMap.set(key, instance);
        },
        get (element, key) {
            if (elementMap.has(element)) return elementMap.get(element).get(key) || null;
            return null;
        },
        remove (element, key) {
            if (!elementMap.has(element)) return;
            const instanceMap = elementMap.get(element);
            instanceMap.delete(key);
            // free up element references if there are no instances left for an element
            if (instanceMap.size === 0) elementMap.delete(element);
        }
    };
    return data;
});

});

parcelRegister("eFdKX", function(module, exports) {

/*!
  * Bootstrap event-handler.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory((parcelRequire("jpXV4")));
})(module.exports, function(index_js) {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/event-handler.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const namespaceRegex = /[^.]*(?=\..*)\.|.*/;
    const stripNameRegex = /\..*/;
    const stripUidRegex = /::\d+$/;
    const eventRegistry = {}; // Events storage
    let uidEvent = 1;
    const customEvents = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    };
    const nativeEvents = new Set([
        "click",
        "dblclick",
        "mouseup",
        "mousedown",
        "contextmenu",
        "mousewheel",
        "DOMMouseScroll",
        "mouseover",
        "mouseout",
        "mousemove",
        "selectstart",
        "selectend",
        "keydown",
        "keypress",
        "keyup",
        "orientationchange",
        "touchstart",
        "touchmove",
        "touchend",
        "touchcancel",
        "pointerdown",
        "pointermove",
        "pointerup",
        "pointerleave",
        "pointercancel",
        "gesturestart",
        "gesturechange",
        "gestureend",
        "focus",
        "blur",
        "change",
        "reset",
        "select",
        "submit",
        "focusin",
        "focusout",
        "load",
        "unload",
        "beforeunload",
        "resize",
        "move",
        "DOMContentLoaded",
        "readystatechange",
        "error",
        "abort",
        "scroll"
    ]);
    /**
   * Private methods
   */ function makeEventUid(element, uid) {
        return uid && `${uid}::${uidEvent++}` || element.uidEvent || uidEvent++;
    }
    function getElementEvents(element) {
        const uid = makeEventUid(element);
        element.uidEvent = uid;
        eventRegistry[uid] = eventRegistry[uid] || {};
        return eventRegistry[uid];
    }
    function bootstrapHandler(element, fn) {
        return function handler(event) {
            hydrateObj(event, {
                delegateTarget: element
            });
            if (handler.oneOff) EventHandler.off(element, event.type, fn);
            return fn.apply(element, [
                event
            ]);
        };
    }
    function bootstrapDelegationHandler(element, selector, fn) {
        return function handler(event) {
            const domElements = element.querySelectorAll(selector);
            for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
                if (domElement !== target) continue;
                hydrateObj(event, {
                    delegateTarget: target
                });
                if (handler.oneOff) EventHandler.off(element, event.type, selector, fn);
                return fn.apply(target, [
                    event
                ]);
            }
        };
    }
    function findHandler(events, callable, delegationSelector = null) {
        return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
    }
    function normalizeParameters(originalTypeEvent, handler, delegationFunction) {
        const isDelegated = typeof handler === "string";
        // TODO: tooltip passes `false` instead of selector, so we need to check
        const callable = isDelegated ? delegationFunction : handler || delegationFunction;
        let typeEvent = getTypeEvent(originalTypeEvent);
        if (!nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
        return [
            isDelegated,
            callable,
            typeEvent
        ];
    }
    function addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
        if (typeof originalTypeEvent !== "string" || !element) return;
        let [isDelegated, callable, typeEvent] = normalizeParameters(originalTypeEvent, handler, delegationFunction);
        // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
        // this prevents the handler from being dispatched the same way as mouseover or mouseout does
        if (originalTypeEvent in customEvents) {
            const wrapFunction = (fn)=>{
                return function(event) {
                    if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
                };
            };
            callable = wrapFunction(callable);
        }
        const events = getElementEvents(element);
        const handlers = events[typeEvent] || (events[typeEvent] = {});
        const previousFunction = findHandler(handlers, callable, isDelegated ? handler : null);
        if (previousFunction) {
            previousFunction.oneOff = previousFunction.oneOff && oneOff;
            return;
        }
        const uid = makeEventUid(callable, originalTypeEvent.replace(namespaceRegex, ""));
        const fn = isDelegated ? bootstrapDelegationHandler(element, handler, callable) : bootstrapHandler(element, callable);
        fn.delegationSelector = isDelegated ? handler : null;
        fn.callable = callable;
        fn.oneOff = oneOff;
        fn.uidEvent = uid;
        handlers[uid] = fn;
        element.addEventListener(typeEvent, fn, isDelegated);
    }
    function removeHandler(element, events, typeEvent, handler, delegationSelector) {
        const fn = findHandler(events[typeEvent], handler, delegationSelector);
        if (!fn) return;
        element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
        delete events[typeEvent][fn.uidEvent];
    }
    function removeNamespacedHandlers(element, events, typeEvent, namespace) {
        const storeElementEvent = events[typeEvent] || {};
        for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
    }
    function getTypeEvent(event) {
        // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
        event = event.replace(stripNameRegex, "");
        return customEvents[event] || event;
    }
    const EventHandler = {
        on (element, event, handler, delegationFunction) {
            addHandler(element, event, handler, delegationFunction, false);
        },
        one (element, event, handler, delegationFunction) {
            addHandler(element, event, handler, delegationFunction, true);
        },
        off (element, originalTypeEvent, handler, delegationFunction) {
            if (typeof originalTypeEvent !== "string" || !element) return;
            const [isDelegated, callable, typeEvent] = normalizeParameters(originalTypeEvent, handler, delegationFunction);
            const inNamespace = typeEvent !== originalTypeEvent;
            const events = getElementEvents(element);
            const storeElementEvent = events[typeEvent] || {};
            const isNamespace = originalTypeEvent.startsWith(".");
            if (typeof callable !== "undefined") {
                // Simplest case: handler is passed, remove that listener ONLY.
                if (!Object.keys(storeElementEvent).length) return;
                removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
                return;
            }
            if (isNamespace) for (const elementEvent of Object.keys(events))removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
            for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
                const handlerKey = keyHandlers.replace(stripUidRegex, "");
                if (!inNamespace || originalTypeEvent.includes(handlerKey)) removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
            }
        },
        trigger (element, event, args) {
            if (typeof event !== "string" || !element) return null;
            const $ = index_js.getjQuery();
            const typeEvent = getTypeEvent(event);
            const inNamespace = event !== typeEvent;
            let jQueryEvent = null;
            let bubbles = true;
            let nativeDispatch = true;
            let defaultPrevented = false;
            if (inNamespace && $) {
                jQueryEvent = $.Event(event, args);
                $(element).trigger(jQueryEvent);
                bubbles = !jQueryEvent.isPropagationStopped();
                nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
                defaultPrevented = jQueryEvent.isDefaultPrevented();
            }
            const evt = hydrateObj(new Event(event, {
                bubbles: bubbles,
                cancelable: true
            }), args);
            if (defaultPrevented) evt.preventDefault();
            if (nativeDispatch) element.dispatchEvent(evt);
            if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
            return evt;
        }
    };
    function hydrateObj(obj, meta = {}) {
        for (const [key, value] of Object.entries(meta))try {
            obj[key] = value;
        } catch (_unused) {
            Object.defineProperty(obj, key, {
                configurable: true,
                get () {
                    return value;
                }
            });
        }
        return obj;
    }
    return EventHandler;
});

});
parcelRegister("jpXV4", function(module, exports) {
/*!
  * Bootstrap index.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const MAX_UID = 1000000;
    const MILLISECONDS_MULTIPLIER = 1000;
    const TRANSITION_END = "transitionend";
    /**
   * Properly escape IDs selectors to handle weird IDs
   * @param {string} selector
   * @returns {string}
   */ const parseSelector = (selector)=>{
        if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
        selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
        return selector;
    };
    // Shout-out Angus Croll (https://goo.gl/pxwQGp)
    const toType = (object)=>{
        if (object === null || object === undefined) return `${object}`;
        return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
    };
    /**
   * Public Util API
   */ const getUID = (prefix)=>{
        do prefix += Math.floor(Math.random() * MAX_UID);
        while (document.getElementById(prefix));
        return prefix;
    };
    const getTransitionDurationFromElement = (element)=>{
        if (!element) return 0;
        // Get transition-duration of the element
        let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
        const floatTransitionDuration = Number.parseFloat(transitionDuration);
        const floatTransitionDelay = Number.parseFloat(transitionDelay);
        // Return 0 if element or transition duration is not found
        if (!floatTransitionDuration && !floatTransitionDelay) return 0;
        // If multiple durations are defined, take the first
        transitionDuration = transitionDuration.split(",")[0];
        transitionDelay = transitionDelay.split(",")[0];
        return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
    };
    const triggerTransitionEnd = (element)=>{
        element.dispatchEvent(new Event(TRANSITION_END));
    };
    const isElement = (object)=>{
        if (!object || typeof object !== "object") return false;
        if (typeof object.jquery !== "undefined") object = object[0];
        return typeof object.nodeType !== "undefined";
    };
    const getElement = (object)=>{
        // it's a jQuery object or a node element
        if (isElement(object)) return object.jquery ? object[0] : object;
        if (typeof object === "string" && object.length > 0) return document.querySelector(parseSelector(object));
        return null;
    };
    const isVisible = (element)=>{
        if (!isElement(element) || element.getClientRects().length === 0) return false;
        const elementIsVisible = getComputedStyle(element).getPropertyValue("visibility") === "visible";
        // Handle `details` element as its content may falsie appear visible when it is closed
        const closedDetails = element.closest("details:not([open])");
        if (!closedDetails) return elementIsVisible;
        if (closedDetails !== element) {
            const summary = element.closest("summary");
            if (summary && summary.parentNode !== closedDetails) return false;
            if (summary === null) return false;
        }
        return elementIsVisible;
    };
    const isDisabled = (element)=>{
        if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
        if (element.classList.contains("disabled")) return true;
        if (typeof element.disabled !== "undefined") return element.disabled;
        return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
    };
    const findShadowRoot = (element)=>{
        if (!document.documentElement.attachShadow) return null;
        // Can find the shadow root otherwise it'll return the document
        if (typeof element.getRootNode === "function") {
            const root = element.getRootNode();
            return root instanceof ShadowRoot ? root : null;
        }
        if (element instanceof ShadowRoot) return element;
        // when we don't find a shadow root
        if (!element.parentNode) return null;
        return findShadowRoot(element.parentNode);
    };
    const noop = ()=>{};
    /**
   * Trick to restart an element's animation
   *
   * @param {HTMLElement} element
   * @return void
   *
   * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
   */ const reflow = (element)=>{
        element.offsetHeight; // eslint-disable-line no-unused-expressions
    };
    const getjQuery = ()=>{
        if (window.jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return window.jQuery;
        return null;
    };
    const DOMContentLoadedCallbacks = [];
    const onDOMContentLoaded = (callback)=>{
        if (document.readyState === "loading") {
            // add listener on the first call when the document is in loading state
            if (!DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
                for (const callback of DOMContentLoadedCallbacks)callback();
            });
            DOMContentLoadedCallbacks.push(callback);
        } else callback();
    };
    const isRTL = ()=>document.documentElement.dir === "rtl";
    const defineJQueryPlugin = (plugin)=>{
        onDOMContentLoaded(()=>{
            const $ = getjQuery();
            /* istanbul ignore if */ if ($) {
                const name = plugin.NAME;
                const JQUERY_NO_CONFLICT = $.fn[name];
                $.fn[name] = plugin.jQueryInterface;
                $.fn[name].Constructor = plugin;
                $.fn[name].noConflict = ()=>{
                    $.fn[name] = JQUERY_NO_CONFLICT;
                    return plugin.jQueryInterface;
                };
            }
        });
    };
    const execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
        return typeof possibleCallback === "function" ? possibleCallback(...args) : defaultValue;
    };
    const executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
        if (!waitForTransition) {
            execute(callback);
            return;
        }
        const durationPadding = 5;
        const emulatedDuration = getTransitionDurationFromElement(transitionElement) + durationPadding;
        let called = false;
        const handler = ({ target: target })=>{
            if (target !== transitionElement) return;
            called = true;
            transitionElement.removeEventListener(TRANSITION_END, handler);
            execute(callback);
        };
        transitionElement.addEventListener(TRANSITION_END, handler);
        setTimeout(()=>{
            if (!called) triggerTransitionEnd(transitionElement);
        }, emulatedDuration);
    };
    /**
   * Return the previous/next element of a list.
   *
   * @param {array} list    The list of elements
   * @param activeElement   The active element
   * @param shouldGetNext   Choose to get next or previous element
   * @param isCycleAllowed
   * @return {Element|elem} The proper element
   */ const getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
        const listLength = list.length;
        let index = list.indexOf(activeElement);
        // if the element does not exist in the list return an element
        // depending on the direction and if cycle is allowed
        if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
        index += shouldGetNext ? 1 : -1;
        if (isCycleAllowed) index = (index + listLength) % listLength;
        return list[Math.max(0, Math.min(index, listLength - 1))];
    };
    exports1.defineJQueryPlugin = defineJQueryPlugin;
    exports1.execute = execute;
    exports1.executeAfterTransition = executeAfterTransition;
    exports1.findShadowRoot = findShadowRoot;
    exports1.getElement = getElement;
    exports1.getNextActiveElement = getNextActiveElement;
    exports1.getTransitionDurationFromElement = getTransitionDurationFromElement;
    exports1.getUID = getUID;
    exports1.getjQuery = getjQuery;
    exports1.isDisabled = isDisabled;
    exports1.isElement = isElement;
    exports1.isRTL = isRTL;
    exports1.isVisible = isVisible;
    exports1.noop = noop;
    exports1.onDOMContentLoaded = onDOMContentLoaded;
    exports1.parseSelector = parseSelector;
    exports1.reflow = reflow;
    exports1.toType = toType;
    exports1.triggerTransitionEnd = triggerTransitionEnd;
    Object.defineProperty(exports1, Symbol.toStringTag, {
        value: "Module"
    });
});

});


parcelRegister("hSuWC", function(module, exports) {


/*!
  * Bootstrap config.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory((parcelRequire("hdUWU")), (parcelRequire("jpXV4")));
})(module.exports, function(Manipulator, index_js) {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/config.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Class definition
   */ class Config {
        // Getters
        static get Default() {
            return {};
        }
        static get DefaultType() {
            return {};
        }
        static get NAME() {
            throw new Error('You have to implement the static method "NAME", for each component!');
        }
        _getConfig(config) {
            config = this._mergeConfigObj(config);
            config = this._configAfterMerge(config);
            this._typeCheckConfig(config);
            return config;
        }
        _configAfterMerge(config) {
            return config;
        }
        _mergeConfigObj(config, element) {
            const jsonConfig = index_js.isElement(element) ? Manipulator.getDataAttribute(element, "config") : {}; // try to parse
            return {
                ...this.constructor.Default,
                ...typeof jsonConfig === "object" ? jsonConfig : {},
                ...index_js.isElement(element) ? Manipulator.getDataAttributes(element) : {},
                ...typeof config === "object" ? config : {}
            };
        }
        _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
            for (const [property, expectedTypes] of Object.entries(configTypes)){
                const value = config[property];
                const valueType = index_js.isElement(value) ? "element" : index_js.toType(value);
                if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
            }
        }
    }
    return Config;
});

});
parcelRegister("hdUWU", function(module, exports) {
/*!
  * Bootstrap manipulator.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/manipulator.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ function normalizeData(value) {
        if (value === "true") return true;
        if (value === "false") return false;
        if (value === Number(value).toString()) return Number(value);
        if (value === "" || value === "null") return null;
        if (typeof value !== "string") return value;
        try {
            return JSON.parse(decodeURIComponent(value));
        } catch (_unused) {
            return value;
        }
    }
    function normalizeDataKey(key) {
        return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
    }
    const Manipulator = {
        setDataAttribute (element, key, value) {
            element.setAttribute(`data-bs-${normalizeDataKey(key)}`, value);
        },
        removeDataAttribute (element, key) {
            element.removeAttribute(`data-bs-${normalizeDataKey(key)}`);
        },
        getDataAttributes (element) {
            if (!element) return {};
            const attributes = {};
            const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith("bs") && !key.startsWith("bsConfig"));
            for (const key of bsKeys){
                let pureKey = key.replace(/^bs/, "");
                pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
                attributes[pureKey] = normalizeData(element.dataset[key]);
            }
            return attributes;
        },
        getDataAttribute (element, key) {
            return normalizeData(element.getAttribute(`data-bs-${normalizeDataKey(key)}`));
        }
    };
    return Manipulator;
});

});



parcelRegister("8Bd7h", function(module, exports) {

/*!
  * Bootstrap selector-engine.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory((parcelRequire("jpXV4")));
})(module.exports, function(index_js) {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/selector-engine.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ const getSelector = (element)=>{
        let selector = element.getAttribute("data-bs-target");
        if (!selector || selector === "#") {
            let hrefAttribute = element.getAttribute("href");
            // The only valid content that could double as a selector are IDs or classes,
            // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
            // `document.querySelector` will rightfully complain it is invalid.
            // See https://github.com/twbs/bootstrap/issues/32273
            if (!hrefAttribute || !hrefAttribute.includes("#") && !hrefAttribute.startsWith(".")) return null;
            // Just in case some CMS puts out a full URL with the anchor appended
            if (hrefAttribute.includes("#") && !hrefAttribute.startsWith("#")) hrefAttribute = `#${hrefAttribute.split("#")[1]}`;
            selector = hrefAttribute && hrefAttribute !== "#" ? hrefAttribute.trim() : null;
        }
        return selector ? selector.split(",").map((sel)=>index_js.parseSelector(sel)).join(",") : null;
    };
    const SelectorEngine = {
        find (selector, element = document.documentElement) {
            return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
        },
        findOne (selector, element = document.documentElement) {
            return Element.prototype.querySelector.call(element, selector);
        },
        children (element, selector) {
            return [].concat(...element.children).filter((child)=>child.matches(selector));
        },
        parents (element, selector) {
            const parents = [];
            let ancestor = element.parentNode.closest(selector);
            while(ancestor){
                parents.push(ancestor);
                ancestor = ancestor.parentNode.closest(selector);
            }
            return parents;
        },
        prev (element, selector) {
            let previous = element.previousElementSibling;
            while(previous){
                if (previous.matches(selector)) return [
                    previous
                ];
                previous = previous.previousElementSibling;
            }
            return [];
        },
        // TODO: this is now unused; remove later along with prev()
        next (element, selector) {
            let next = element.nextElementSibling;
            while(next){
                if (next.matches(selector)) return [
                    next
                ];
                next = next.nextElementSibling;
            }
            return [];
        },
        focusableChildren (element) {
            const focusables = [
                "a",
                "button",
                "input",
                "textarea",
                "select",
                "details",
                "[tabindex]",
                '[contenteditable="true"]'
            ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(",");
            return this.find(focusables, element).filter((el)=>!index_js.isDisabled(el) && index_js.isVisible(el));
        },
        getSelectorFromElement (element) {
            const selector = getSelector(element);
            if (selector) return SelectorEngine.findOne(selector) ? selector : null;
            return null;
        },
        getElementFromSelector (element) {
            const selector = getSelector(element);
            return selector ? SelectorEngine.findOne(selector) : null;
        },
        getMultipleElementsFromSelector (element) {
            const selector = getSelector(element);
            return selector ? SelectorEngine.find(selector) : [];
        }
    };
    return SelectorEngine;
});

});

parcelRegister("8B3mG", function(module, exports) {

$parcel$export(module.exports, "createScope", function () { return createScope; });
$parcel$export(module.exports, "peek", function () { return peek; });
$parcel$export(module.exports, "untrack", function () { return untrack; });
$parcel$export(module.exports, "tick", function () { return tick; });
$parcel$export(module.exports, "getScope", function () { return getScope; });
$parcel$export(module.exports, "scoped", function () { return scoped; });
$parcel$export(module.exports, "onDispose", function () { return onDispose; });
$parcel$export(module.exports, "noop", function () { return noop; });
$parcel$export(module.exports, "isNull", function () { return isNull; });
$parcel$export(module.exports, "isUndefined", function () { return isUndefined; });
$parcel$export(module.exports, "isNil", function () { return isNil; });
$parcel$export(module.exports, "isObject", function () { return isObject; });
$parcel$export(module.exports, "isNumber", function () { return isNumber; });
$parcel$export(module.exports, "isString", function () { return isString; });
$parcel$export(module.exports, "isBoolean", function () { return isBoolean; });
$parcel$export(module.exports, "isFunction", function () { return isFunction; });
$parcel$export(module.exports, "isArray", function () { return isArray; });
$parcel$export(module.exports, "DOMEvent", function () { return DOMEvent; });
$parcel$export(module.exports, "EventsTarget", function () { return EventsTarget; });
$parcel$export(module.exports, "listenEvent", function () { return listenEvent; });
$parcel$export(module.exports, "EventsController", function () { return EventsController; });
$parcel$export(module.exports, "isPointerEvent", function () { return isPointerEvent; });
$parcel$export(module.exports, "isTouchEvent", function () { return isTouchEvent; });
$parcel$export(module.exports, "isMouseEvent", function () { return isMouseEvent; });
$parcel$export(module.exports, "isKeyboardEvent", function () { return isKeyboardEvent; });
$parcel$export(module.exports, "wasEnterKeyPressed", function () { return wasEnterKeyPressed; });
$parcel$export(module.exports, "isKeyboardClick", function () { return isKeyboardClick; });
$parcel$export(module.exports, "isDOMNode", function () { return isDOMNode; });
$parcel$export(module.exports, "setAttribute", function () { return setAttribute; });
$parcel$export(module.exports, "setStyle", function () { return setStyle; });
$parcel$export(module.exports, "toggleClass", function () { return toggleClass; });
$parcel$export(module.exports, "signal", function () { return signal; });
$parcel$export(module.exports, "computed", function () { return computed; });
$parcel$export(module.exports, "isWriteSignal", function () { return isWriteSignal; });
$parcel$export(module.exports, "effect", function () { return effect; });
$parcel$export(module.exports, "createContext", function () { return createContext; });
$parcel$export(module.exports, "provideContext", function () { return provideContext; });
$parcel$export(module.exports, "useContext", function () { return useContext; });
$parcel$export(module.exports, "hasProvidedContext", function () { return hasProvidedContext; });
$parcel$export(module.exports, "ViewController", function () { return ViewController; });
$parcel$export(module.exports, "Component", function () { return Component; });
$parcel$export(module.exports, "prop", function () { return prop; });
$parcel$export(module.exports, "method", function () { return method; });
$parcel$export(module.exports, "State", function () { return State; });
$parcel$export(module.exports, "useState", function () { return useState; });
$parcel$export(module.exports, "camelToKebabCase", function () { return camelToKebabCase; });
$parcel$export(module.exports, "kebabToCamelCase", function () { return kebabToCamelCase; });
$parcel$export(module.exports, "uppercaseFirstChar", function () { return uppercaseFirstChar; });
$parcel$export(module.exports, "unwrap", function () { return unwrap; });
$parcel$export(module.exports, "ariaBool", function () { return ariaBool; });
$parcel$export(module.exports, "createDisposalBin", function () { return createDisposalBin; });
$parcel$export(module.exports, "keysOf", function () { return keysOf; });
$parcel$export(module.exports, "deferredPromise", function () { return deferredPromise; });
$parcel$export(module.exports, "waitTimeout", function () { return waitTimeout; });
$parcel$export(module.exports, "animationFrameThrottle", function () { return animationFrameThrottle; });
$parcel$export(module.exports, "waitIdlePeriod", function () { return waitIdlePeriod; });
$parcel$export(module.exports, "fscreen", function () { return fscreen; });
$parcel$export(module.exports, "functionThrottle", function () { return functionThrottle; });
$parcel$export(module.exports, "functionDebounce", function () { return functionDebounce; });
$parcel$export(module.exports, "r", function () { return r; });
$parcel$export(module.exports, "BOOLEAN", function () { return BOOLEAN; });
$parcel$export(module.exports, "Host", function () { return Host; });
$parcel$export(module.exports, "defineCustomElement", function () { return defineCustomElement; });
$parcel$export(module.exports, "Icon$24", function () { return Icon$24; });
$parcel$export(module.exports, "Icon$0", function () { return Icon$0; });
$parcel$export(module.exports, "Icon$5", function () { return Icon$5; });
$parcel$export(module.exports, "Icon$8", function () { return Icon$8; });
$parcel$export(module.exports, "Icon$11", function () { return Icon$11; });
$parcel$export(module.exports, "Icon$13", function () { return Icon$13; });
$parcel$export(module.exports, "Icon$16", function () { return Icon$16; });
$parcel$export(module.exports, "Icon$19", function () { return Icon$19; });
$parcel$export(module.exports, "Icon$22", function () { return Icon$22; });
$parcel$export(module.exports, "Icon$26", function () { return Icon$26; });
$parcel$export(module.exports, "Icon$27", function () { return Icon$27; });
$parcel$export(module.exports, "Icon$31", function () { return Icon$31; });
$parcel$export(module.exports, "Icon$33", function () { return Icon$33; });
$parcel$export(module.exports, "Icon$34", function () { return Icon$34; });
$parcel$export(module.exports, "Icon$35", function () { return Icon$35; });
$parcel$export(module.exports, "Icon$39", function () { return Icon$39; });
$parcel$export(module.exports, "Icon$40", function () { return Icon$40; });
$parcel$export(module.exports, "Icon$53", function () { return Icon$53; });
$parcel$export(module.exports, "Icon$54", function () { return Icon$54; });
$parcel$export(module.exports, "Icon$56", function () { return Icon$56; });
$parcel$export(module.exports, "Icon$59", function () { return Icon$59; });
$parcel$export(module.exports, "Icon$60", function () { return Icon$60; });
$parcel$export(module.exports, "Icon$61", function () { return Icon$61; });
$parcel$export(module.exports, "Icon$62", function () { return Icon$62; });
$parcel$export(module.exports, "Icon$63", function () { return Icon$63; });
$parcel$export(module.exports, "Icon$74", function () { return Icon$74; });
$parcel$export(module.exports, "Icon$77", function () { return Icon$77; });
$parcel$export(module.exports, "Icon$81", function () { return Icon$81; });
$parcel$export(module.exports, "Icon$88", function () { return Icon$88; });
$parcel$export(module.exports, "Icon$104", function () { return Icon$104; });
$parcel$export(module.exports, "Icon$105", function () { return Icon$105; });

var $57dmi = parcelRequire("57dmi");

var $fhH8k = parcelRequire("fhH8k");

var $4vwVC = parcelRequire("4vwVC");

var $2u9SC = parcelRequire("2u9SC");

var $9P4tJ = parcelRequire("9P4tJ");

var $97zcJ = parcelRequire("97zcJ");
const SCOPE = Symbol(0);
let scheduledEffects = false, runningEffects = false, currentScope = null, currentObserver = null, currentObservers = null, currentObserversIndex = 0, effects = [], defaultContext = {};
const NOOP = ()=>{}, STATE_CLEAN = 0, STATE_CHECK = 1, STATE_DIRTY = 2, STATE_DISPOSED = 3;
function flushEffects() {
    scheduledEffects = true;
    queueMicrotask(runEffects);
}
function runEffects() {
    if (!effects.length) {
        scheduledEffects = false;
        return;
    }
    runningEffects = true;
    for(let i = 0; i < effects.length; i++)if (effects[i].$st !== STATE_CLEAN) runTop(effects[i]);
    effects = [];
    scheduledEffects = false;
    runningEffects = false;
}
function runTop(node) {
    let ancestors = [
        node
    ];
    while(node = node[SCOPE])if (node.$e && node.$st !== STATE_CLEAN) ancestors.push(node);
    for(let i = ancestors.length - 1; i >= 0; i--)updateCheck(ancestors[i]);
}
function root(init) {
    const scope = createScope();
    return compute(scope, !init.length ? init : init.bind(null, dispose.bind(scope)), null);
}
function peek(fn) {
    return compute(currentScope, fn, null);
}
function untrack(fn) {
    return compute(null, fn, null);
}
function tick() {
    if (!runningEffects) runEffects();
}
function getScope() {
    return currentScope;
}
function scoped(run, scope) {
    try {
        return compute(scope, run, null);
    } catch (error) {
        handleError(scope, error);
        return;
    }
}
function getContext(key, scope = currentScope) {
    return scope?.$cx[key];
}
function setContext(key, value, scope = currentScope) {
    if (scope) scope.$cx = {
        ...scope.$cx,
        [key]: value
    };
}
function onDispose(disposable) {
    if (!disposable || !currentScope) return disposable || NOOP;
    const node = currentScope;
    if (!node.$d) node.$d = disposable;
    else if (Array.isArray(node.$d)) node.$d.push(disposable);
    else node.$d = [
        node.$d,
        disposable
    ];
    return function removeDispose() {
        if (node.$st === STATE_DISPOSED) return;
        disposable.call(null);
        if (isFunction$1(node.$d)) node.$d = null;
        else if (Array.isArray(node.$d)) node.$d.splice(node.$d.indexOf(disposable), 1);
    };
}
function dispose(self = true) {
    if (this.$st === STATE_DISPOSED) return;
    if (this.$h) {
        if (Array.isArray(this.$h)) for(let i = this.$h.length - 1; i >= 0; i--)dispose.call(this.$h[i]);
        else dispose.call(this.$h);
    }
    if (self) {
        const parent = this[SCOPE];
        if (parent) {
            if (Array.isArray(parent.$h)) parent.$h.splice(parent.$h.indexOf(this), 1);
            else parent.$h = null;
        }
        disposeNode(this);
    }
}
function disposeNode(node) {
    node.$st = STATE_DISPOSED;
    if (node.$d) emptyDisposal(node);
    if (node.$s) removeSourceObservers(node, 0);
    node[SCOPE] = null;
    node.$s = null;
    node.$o = null;
    node.$h = null;
    node.$cx = defaultContext;
    node.$eh = null;
}
function emptyDisposal(scope) {
    try {
        if (Array.isArray(scope.$d)) for(let i = scope.$d.length - 1; i >= 0; i--){
            const callable = scope.$d[i];
            callable.call(callable);
        }
        else scope.$d.call(scope.$d);
        scope.$d = null;
    } catch (error) {
        handleError(scope, error);
    }
}
function compute(scope, compute2, observer) {
    const prevScope = currentScope, prevObserver = currentObserver;
    currentScope = scope;
    currentObserver = observer;
    try {
        return compute2.call(scope);
    } finally{
        currentScope = prevScope;
        currentObserver = prevObserver;
    }
}
function handleError(scope, error) {
    if (!scope || !scope.$eh) throw error;
    let i = 0, len = scope.$eh.length, currentError = error;
    for(i = 0; i < len; i++)try {
        scope.$eh[i](currentError);
        break;
    } catch (error2) {
        currentError = error2;
    }
    if (i === len) throw currentError;
}
function read() {
    if (this.$st === STATE_DISPOSED) return this.$v;
    if (currentObserver && !this.$e) {
        if (!currentObservers && currentObserver.$s && currentObserver.$s[currentObserversIndex] == this) currentObserversIndex++;
        else if (!currentObservers) currentObservers = [
            this
        ];
        else currentObservers.push(this);
    }
    if (this.$c) updateCheck(this);
    return this.$v;
}
function write(newValue) {
    const value = isFunction$1(newValue) ? newValue(this.$v) : newValue;
    if (this.$ch(this.$v, value)) {
        this.$v = value;
        if (this.$o) for(let i = 0; i < this.$o.length; i++)notify(this.$o[i], STATE_DIRTY);
    }
    return this.$v;
}
const ScopeNode = function Scope() {
    this[SCOPE] = null;
    this.$h = null;
    if (currentScope) currentScope.append(this);
};
const ScopeProto = ScopeNode.prototype;
ScopeProto.$cx = defaultContext;
ScopeProto.$eh = null;
ScopeProto.$c = null;
ScopeProto.$d = null;
ScopeProto.append = function(child) {
    child[SCOPE] = this;
    if (!this.$h) this.$h = child;
    else if (Array.isArray(this.$h)) this.$h.push(child);
    else this.$h = [
        this.$h,
        child
    ];
    child.$cx = child.$cx === defaultContext ? this.$cx : {
        ...this.$cx,
        ...child.$cx
    };
    if (this.$eh) child.$eh = !child.$eh ? this.$eh : [
        ...child.$eh,
        ...this.$eh
    ];
};
ScopeProto.dispose = function() {
    dispose.call(this);
};
function createScope() {
    return new ScopeNode();
}
const ComputeNode = function Computation(initialValue, compute2, options) {
    ScopeNode.call(this);
    this.$st = compute2 ? STATE_DIRTY : STATE_CLEAN;
    this.$i = false;
    this.$e = false;
    this.$s = null;
    this.$o = null;
    this.$v = initialValue;
    if (compute2) this.$c = compute2;
    if (options && options.dirty) this.$ch = options.dirty;
};
const ComputeProto = ComputeNode.prototype;
Object.setPrototypeOf(ComputeProto, ScopeProto);
ComputeProto.$ch = isNotEqual;
ComputeProto.call = read;
function createComputation(initialValue, compute2, options) {
    return new ComputeNode(initialValue, compute2, options);
}
function isNotEqual(a, b) {
    return a !== b;
}
function isFunction$1(value) {
    return typeof value === "function";
}
function updateCheck(node) {
    if (node.$st === STATE_CHECK) for(let i = 0; i < node.$s.length; i++){
        updateCheck(node.$s[i]);
        if (node.$st === STATE_DIRTY) break;
    }
    if (node.$st === STATE_DIRTY) update(node);
    else node.$st = STATE_CLEAN;
}
function cleanup(node) {
    if (node.$h) dispose.call(node, false);
    if (node.$d) emptyDisposal(node);
    node.$eh = node[SCOPE] ? node[SCOPE].$eh : null;
}
function update(node) {
    let prevObservers = currentObservers, prevObserversIndex = currentObserversIndex;
    currentObservers = null;
    currentObserversIndex = 0;
    try {
        cleanup(node);
        const result = compute(node, node.$c, node);
        updateObservers(node);
        if (!node.$e && node.$i) write.call(node, result);
        else {
            node.$v = result;
            node.$i = true;
        }
    } catch (error) {
        updateObservers(node);
        handleError(node, error);
    } finally{
        currentObservers = prevObservers;
        currentObserversIndex = prevObserversIndex;
        node.$st = STATE_CLEAN;
    }
}
function updateObservers(node) {
    if (currentObservers) {
        if (node.$s) removeSourceObservers(node, currentObserversIndex);
        if (node.$s && currentObserversIndex > 0) {
            node.$s.length = currentObserversIndex + currentObservers.length;
            for(let i = 0; i < currentObservers.length; i++)node.$s[currentObserversIndex + i] = currentObservers[i];
        } else node.$s = currentObservers;
        let source;
        for(let i = currentObserversIndex; i < node.$s.length; i++){
            source = node.$s[i];
            if (!source.$o) source.$o = [
                node
            ];
            else source.$o.push(node);
        }
    } else if (node.$s && currentObserversIndex < node.$s.length) {
        removeSourceObservers(node, currentObserversIndex);
        node.$s.length = currentObserversIndex;
    }
}
function notify(node, state) {
    if (node.$st >= state) return;
    if (node.$e && node.$st === STATE_CLEAN) {
        effects.push(node);
        if (!scheduledEffects) flushEffects();
    }
    node.$st = state;
    if (node.$o) for(let i = 0; i < node.$o.length; i++)notify(node.$o[i], STATE_CHECK);
}
function removeSourceObservers(node, index) {
    let source, swap;
    for(let i = index; i < node.$s.length; i++){
        source = node.$s[i];
        if (source.$o) {
            swap = source.$o.indexOf(node);
            source.$o[swap] = source.$o[source.$o.length - 1];
            source.$o.pop();
        }
    }
}
function noop(...args) {}
function isNull(value) {
    return value === null;
}
function isUndefined(value) {
    return typeof value === "undefined";
}
function isNil(value) {
    return isNull(value) || isUndefined(value);
}
function isObject(value) {
    return value?.constructor === Object;
}
function isNumber(value) {
    return typeof value === "number" && !Number.isNaN(value);
}
function isString(value) {
    return typeof value === "string";
}
function isBoolean(value) {
    return typeof value === "boolean";
}
function isFunction(value) {
    return typeof value === "function";
}
function isArray(value) {
    return Array.isArray(value);
}
const EVENT = Event, DOM_EVENT = Symbol("DOM_EVENT");
let _DOM_EVENT = DOM_EVENT;
class DOMEvent extends EVENT {
    /**
   * The preceding event that was responsible for this event being fired.
   */ get trigger() {
        return this.triggers.source;
    }
    /**
   * The origin event that lead to this event being fired.
   */ get originEvent() {
        return this.triggers.origin;
    }
    /**
   * Whether the origin event was triggered by the user.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Event/isTrusted}
   */ get isOriginTrusted() {
        return this.triggers.origin?.isTrusted ?? false;
    }
    constructor(type, ...init){
        super(type, init[0]);
        (0, $97zcJ._)(this, _DOM_EVENT, true);
        /**
   * The event detail.
   */ (0, $97zcJ._)(this, "detail", void 0);
        /**
   * The event trigger chain.
   */ (0, $97zcJ._)(this, "triggers", new EventTriggers());
        this.detail = init[0]?.detail;
        const trigger = init[0]?.trigger;
        if (trigger) this.triggers.add(trigger);
    }
}
let _Symbol_iterator = Symbol.iterator;
class EventTriggers {
    get source() {
        return this.chain[0];
    }
    get origin() {
        return this.chain[this.chain.length - 1];
    }
    /**
   * Appends the event to the end of the chain.
   */ add(event) {
        this.chain.push(event);
        if (isDOMEvent(event)) this.chain.push(...event.triggers);
    }
    /**
   * Removes the event from the chain and returns it (if found).
   */ remove(event) {
        return this.chain.splice(this.chain.indexOf(event), 1)[0];
    }
    /**
   * Returns whether the chain contains the given `event`.
   */ has(event) {
        return this.chain.some((e)=>e === event);
    }
    /**
   * Returns whether the chain contains the given event type.
   */ hasType(type) {
        return !!this.findType(type);
    }
    /**
   * Returns the first event with the given `type` found in the chain.
   */ findType(type) {
        return this.chain.find((e)=>e.type === type);
    }
    /**
   * Walks an event chain on a given `event`, and invokes the given `callback` for each trigger event.
   */ walk(callback) {
        for (const event of this.chain){
            const returnValue = callback(event);
            if (returnValue) return [
                event,
                returnValue
            ];
        }
    }
    [_Symbol_iterator]() {
        return this.chain.values();
    }
    constructor(){
        (0, $97zcJ._)(this, "chain", []);
    }
}
function isDOMEvent(event) {
    return !!event?.[DOM_EVENT];
}
function walkTriggerEventChain(event, callback) {
    if (!isDOMEvent(event)) return;
    return event.triggers.walk(callback);
}
function findTriggerEvent(event, type) {
    return isDOMEvent(event) ? event.triggers.findType(type) : void 0;
}
function hasTriggerEvent(event, type) {
    return !!findTriggerEvent(event, type);
}
function appendTriggerEvent(event, trigger) {
    if (trigger) event.triggers.add(trigger);
}
class EventsTarget extends EventTarget {
    addEventListener(type, callback, options) {
        return super.addEventListener(type, callback, options);
    }
    removeEventListener(type, callback, options) {
        return super.removeEventListener(type, callback, options);
    }
    constructor(...args){
        super(...args);
        /** @internal type only */ (0, $97zcJ._)(this, "$ts__events", void 0);
    }
}
function listenEvent(target, type, handler1, options) {
    target.addEventListener(type, handler1, options);
    return onDispose(()=>target.removeEventListener(type, handler1, options));
}
var _target = /*#__PURE__*/ new WeakMap(), _controller = /*#__PURE__*/ new WeakMap();
class EventsController {
    get signal() {
        return (0, $57dmi._)(this, _controller).signal;
    }
    add(type, handler1, options) {
        if (this.signal.aborted) throw Error("aborted");
        (0, $57dmi._)(this, _target).addEventListener(type, handler1, {
            ...options,
            signal: options?.signal ? anySignal(this.signal, options.signal) : this.signal
        });
        return this;
    }
    remove(type, handler1) {
        (0, $57dmi._)(this, _target).removeEventListener(type, handler1);
        return this;
    }
    abort(reason) {
        (0, $57dmi._)(this, _controller).abort(reason);
    }
    constructor(target){
        (0, $fhH8k._)(this, _target, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, _controller, {
            writable: true,
            value: void 0
        });
        (0, $4vwVC._)(this, _target, target);
        (0, $4vwVC._)(this, _controller, new AbortController());
        onDispose(this.abort.bind(this));
    }
}
function anySignal(...signals) {
    const controller = new AbortController(), options = {
        signal: controller.signal
    };
    function onAbort(event) {
        controller.abort(event.target.reason);
    }
    for (const signal of signals){
        if (signal.aborted) {
            controller.abort(signal.reason);
            break;
        }
        signal.addEventListener("abort", onAbort, options);
    }
    return controller.signal;
}
function isPointerEvent(event) {
    return !!event?.type.startsWith("pointer");
}
function isTouchEvent(event) {
    return !!event?.type.startsWith("touch");
}
function isMouseEvent(event) {
    return /^(click|mouse)/.test(event?.type ?? "");
}
function isKeyboardEvent(event) {
    return !!event?.type.startsWith("key");
}
function wasEnterKeyPressed(event) {
    return isKeyboardEvent(event) && event.key === "Enter";
}
function isKeyboardClick(event) {
    return isKeyboardEvent(event) && (event.key === "Enter" || event.key === " ");
}
function isDOMNode(node) {
    return node instanceof Node;
}
function setAttribute(host, name, value) {
    if (!host) return;
    else if (!value && value !== "" && value !== 0) host.removeAttribute(name);
    else {
        const attrValue = value === true ? "" : value + "";
        if (host.getAttribute(name) !== attrValue) host.setAttribute(name, attrValue);
    }
}
function setStyle(host, property, value) {
    if (!host) return;
    else if (!value && value !== 0) host.style.removeProperty(property);
    else host.style.setProperty(property, value + "");
}
function toggleClass(host, name, value) {
    host.classList[value ? "add" : "remove"](name);
}
function signal(initialValue, options) {
    const node = createComputation(initialValue, null, options), signal2 = read.bind(node);
    signal2[SCOPE] = true;
    signal2.set = write.bind(node);
    return signal2;
}
function isReadSignal(fn) {
    return isFunction$1(fn) && SCOPE in fn;
}
function computed(compute, options) {
    const node = createComputation(options?.initial, compute, options), signal2 = read.bind(node);
    signal2[SCOPE] = true;
    return signal2;
}
function effect$1(effect2, options) {
    const signal2 = createComputation(null, function runEffect() {
        let effectResult = effect2();
        isFunction$1(effectResult) && onDispose(effectResult);
        return null;
    }, void 0);
    signal2.$e = true;
    update(signal2);
    return dispose.bind(signal2, true);
}
function isWriteSignal(fn) {
    return isReadSignal(fn) && "set" in fn;
}
const effect = effect$1;
function createContext(provide) {
    return {
        id: Symbol(),
        provide: provide
    };
}
function provideContext(context, value, scope = getScope()) {
    const hasProvidedValue = !isUndefined(value);
    setContext(context.id, hasProvidedValue ? value : context.provide?.(), scope);
}
function useContext(context) {
    const value = getContext(context.id);
    return value;
}
function hasProvidedContext(context) {
    return !isUndefined(getContext(context.id));
}
const PROPS = /* @__PURE__ */ Symbol(0);
const METHODS = /* @__PURE__ */ Symbol(0);
const ON_DISPATCH = /* @__PURE__ */ Symbol(0);
const EMPTY_PROPS = {};
var _setupCallbacks = /*#__PURE__*/ new WeakMap(), _attachCallbacks = /*#__PURE__*/ new WeakMap(), _connectCallbacks = /*#__PURE__*/ new WeakMap(), _destroyCallbacks = /*#__PURE__*/ new WeakMap(), _attachAttrs = /*#__PURE__*/ new WeakSet(), _attachStyles = /*#__PURE__*/ new WeakSet(), _setAttr = /*#__PURE__*/ new WeakSet(), _setStyle = /*#__PURE__*/ new WeakSet();
let _ON_DISPATCH = ON_DISPATCH;
class Instance {
    setup() {
        scoped(()=>{
            for (const callback of (0, $57dmi._)(this, _setupCallbacks))callback();
        }, this.scope);
    }
    attach(el) {
        if (this.el) return;
        this.el = el;
        this.$el.set(el);
        scoped(()=>{
            this.attachScope = createScope();
            scoped(()=>{
                for (const callback of (0, $57dmi._)(this, _attachCallbacks))callback(this.el);
                (0, $2u9SC._)(this, _attachAttrs, attachAttrs).call(this);
                (0, $2u9SC._)(this, _attachStyles, attachStyles).call(this);
            }, this.attachScope);
        }, this.scope);
        el.dispatchEvent(new Event("attached"));
    }
    detach() {
        this.attachScope?.dispose();
        this.attachScope = null;
        this.connectScope = null;
        this.el = null;
        this.$el.set(null);
    }
    connect() {
        if (!this.el || !this.attachScope || !(0, $57dmi._)(this, _connectCallbacks).length) return;
        scoped(()=>{
            this.connectScope = createScope();
            scoped(()=>{
                for (const callback of (0, $57dmi._)(this, _connectCallbacks))callback(this.el);
            }, this.connectScope);
        }, this.attachScope);
    }
    disconnect() {
        this.connectScope?.dispose();
        this.connectScope = null;
    }
    destroy() {
        if (this.destroyed) return;
        this.destroyed = true;
        scoped(()=>{
            for (const callback of (0, $57dmi._)(this, _destroyCallbacks))callback(this.el);
        }, this.scope);
        const el = this.el;
        this.detach();
        this.scope.dispose();
        (0, $57dmi._)(this, _setupCallbacks).length = 0;
        (0, $57dmi._)(this, _attachCallbacks).length = 0;
        (0, $57dmi._)(this, _connectCallbacks).length = 0;
        (0, $57dmi._)(this, _destroyCallbacks).length = 0;
        this.component = null;
        this.attrs = null;
        this.styles = null;
        this.props = EMPTY_PROPS;
        this.scope = null;
        this.state = EMPTY_PROPS;
        this.$state = null;
        if (el) delete el.$;
    }
    addHooks(target) {
        if (target.onSetup) (0, $57dmi._)(this, _setupCallbacks).push(target.onSetup.bind(target));
        if (target.onAttach) (0, $57dmi._)(this, _attachCallbacks).push(target.onAttach.bind(target));
        if (target.onConnect) (0, $57dmi._)(this, _connectCallbacks).push(target.onConnect.bind(target));
        if (target.onDestroy) (0, $57dmi._)(this, _destroyCallbacks).push(target.onDestroy.bind(target));
    }
    constructor(Component, scope, init){
        (0, $9P4tJ._)(this, _attachAttrs);
        (0, $9P4tJ._)(this, _attachStyles);
        (0, $9P4tJ._)(this, _setAttr);
        (0, $9P4tJ._)(this, _setStyle);
        /** @internal type only */ (0, $97zcJ._)(this, "$ts__events", void 0);
        /** @internal type only */ (0, $97zcJ._)(this, "$ts__vars", void 0);
        /* @internal */ (0, $97zcJ._)(this, _ON_DISPATCH, null);
        (0, $97zcJ._)(this, "$el", signal(null));
        (0, $97zcJ._)(this, "el", null);
        (0, $97zcJ._)(this, "scope", null);
        (0, $97zcJ._)(this, "attachScope", null);
        (0, $97zcJ._)(this, "connectScope", null);
        (0, $97zcJ._)(this, "component", null);
        (0, $97zcJ._)(this, "destroyed", false);
        (0, $97zcJ._)(this, "props", EMPTY_PROPS);
        (0, $97zcJ._)(this, "attrs", null);
        (0, $97zcJ._)(this, "styles", null);
        (0, $97zcJ._)(this, "state", void 0);
        (0, $97zcJ._)(this, "$state", void 0);
        (0, $fhH8k._)(this, _setupCallbacks, {
            writable: true,
            value: []
        });
        (0, $fhH8k._)(this, _attachCallbacks, {
            writable: true,
            value: []
        });
        (0, $fhH8k._)(this, _connectCallbacks, {
            writable: true,
            value: []
        });
        (0, $fhH8k._)(this, _destroyCallbacks, {
            writable: true,
            value: []
        });
        this.scope = scope;
        if (init?.scope) init.scope.append(scope);
        let stateFactory = Component.state, props = Component.props;
        if (stateFactory) {
            this.$state = stateFactory.create();
            this.state = new Proxy(this.$state, {
                get: (_, prop)=>this.$state[prop]()
            });
            provideContext(stateFactory, this.$state);
        }
        if (props) {
            this.props = createInstanceProps(props);
            if (init?.props) for (const prop of Object.keys(init.props))this.props[prop]?.set(init.props[prop]);
        }
        onDispose(this.destroy.bind(this));
    }
}
function attachAttrs() {
    if (!this.attrs) return;
    for (const name of Object.keys(this.attrs))if (isFunction(this.attrs[name])) effect((0, $2u9SC._)(this, _setAttr, setAttr).bind(this, name));
    else setAttribute(this.el, name, this.attrs[name]);
}
function attachStyles() {
    if (!this.styles) return;
    for (const name of Object.keys(this.styles))if (isFunction(this.styles[name])) effect((0, $2u9SC._)(this, _setStyle, setStyle1).bind(this, name));
    else setStyle(this.el, name, this.styles[name]);
}
function setAttr(name) {
    setAttribute(this.el, name, this.attrs[name].call(this.component));
}
function setStyle1(name) {
    setStyle(this.el, name, this.styles[name].call(this.component));
}
function createInstanceProps(props) {
    const $props = {};
    for (const name of Object.keys(props)){
        const def = props[name];
        $props[name] = signal(def, def);
    }
    return $props;
}
let currentInstance = {
    $$: null
};
function createComponent(Component, init) {
    return root(()=>{
        currentInstance.$$ = new Instance(Component, getScope(), init);
        const component = new Component();
        currentInstance.$$.component = component;
        currentInstance.$$ = null;
        return component;
    });
}
class ViewController extends EventTarget {
    get el() {
        return this.$$.el;
    }
    get $el() {
        return this.$$.$el();
    }
    get scope() {
        return this.$$.scope;
    }
    get attachScope() {
        return this.$$.attachScope;
    }
    get connectScope() {
        return this.$$.connectScope;
    }
    /** @internal */ get $props() {
        return this.$$.props;
    }
    /** @internal */ get $state() {
        return this.$$.$state;
    }
    get state() {
        return this.$$.state;
    }
    attach({ $$ }) {
        this.$$ = $$;
        $$.addHooks(this);
        return this;
    }
    addEventListener(type, callback, options) {
        this.listen(type, callback, options);
    }
    removeEventListener(type, callback, options) {
        this.el?.removeEventListener(type, callback, options);
    }
    /**
   * The given callback is invoked when the component is ready to be set up.
   *
   * - This hook will run once.
   * - This hook is called both client-side and server-side.
   * - It's safe to use context inside this hook.
   * - The host element has not attached yet - wait for `onAttach`.
   */ /**
   * This method can be used to specify attributes that should be set on the host element. Any
   * attributes that are assigned to a function will be considered a signal and updated accordingly.
   */ setAttributes(attributes) {
        if (!this.$$.attrs) this.$$.attrs = {};
        Object.assign(this.$$.attrs, attributes);
    }
    /**
   * This method can be used to specify styles that should set be set on the host element. Any
   * styles that are assigned to a function will be considered a signal and updated accordingly.
   */ setStyles(styles) {
        if (!this.$$.styles) this.$$.styles = {};
        Object.assign(this.$$.styles, styles);
    }
    /**
   * This method is used to satisfy the CSS variables contract specified on the current
   * component. Other CSS variables can be set via the `setStyles` method.
   */ setCSSVars(vars) {
        this.setStyles(vars);
    }
    /**
   * Type-safe utility for creating component DOM events.
   */ createEvent(type, ...init) {
        return new DOMEvent(type, init[0]);
    }
    /**
   * Creates a `DOMEvent` and dispatches it from the host element. This method is typed to
   * match all component events.
   */ dispatch(type, ...init) {
        if (!this.el) return false;
        const event = type instanceof Event ? type : new DOMEvent(type, init[0]);
        Object.defineProperty(event, "target", {
            get: ()=>this.$$.component
        });
        return untrack(()=>{
            this.$$[ON_DISPATCH]?.(event);
            return this.el.dispatchEvent(event);
        });
    }
    dispatchEvent(event) {
        return this.dispatch(event);
    }
    /**
   * Adds an event listener for the given `type` and returns a function which can be invoked to
   * remove the event listener.
   *
   * - The listener is removed if the current scope is disposed.
   * - This method is safe to use on the server (noop).
   */ listen(type, handler1, options) {
        if (!this.el) return noop;
        return listenEvent(this.el, type, handler1, options);
    }
    constructor(){
        super();
        /** @internal */ (0, $97zcJ._)(this, "$$", void 0);
        if (currentInstance.$$) this.attach(currentInstance);
    }
}
class Component extends ViewController {
    subscribe(callback) {
        return scoped(()=>effect(()=>callback(this.state)), this.$$.scope);
    }
    destroy() {
        this.$$.destroy();
    }
}
function prop(target, propertyKey, descriptor) {
    if (!target[PROPS]) target[PROPS] = /* @__PURE__ */ new Set();
    target[PROPS].add(propertyKey);
}
function method(target, propertyKey, descriptor) {
    if (!target[METHODS]) target[METHODS] = /* @__PURE__ */ new Set();
    target[METHODS].add(propertyKey);
}
var _descriptors = /*#__PURE__*/ new WeakMap();
class State {
    create() {
        const store = {}, state = new Proxy(store, {
            get: (_, prop2)=>store[prop2]()
        });
        for (const name of Object.keys(this.record)){
            const getter = (0, $57dmi._)(this, _descriptors)[name].get;
            store[name] = getter ? computed(getter.bind(state)) : signal(this.record[name]);
        }
        return store;
    }
    reset(record, filter) {
        for (const name of Object.keys(record))if (!(0, $57dmi._)(this, _descriptors)[name].get && (!filter || filter(name))) record[name].set(this.record[name]);
    }
    constructor(record){
        (0, $97zcJ._)(this, "id", Symbol(0));
        (0, $97zcJ._)(this, "record", void 0);
        (0, $fhH8k._)(this, _descriptors, {
            writable: true,
            value: void 0
        });
        this.record = record;
        (0, $4vwVC._)(this, _descriptors, Object.getOwnPropertyDescriptors(record));
    }
}
function useState(state) {
    return useContext(state);
}
function runAll(fns, arg) {
    for (const fn of fns)fn(arg);
}
function camelToKebabCase(str) {
    return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function kebabToCamelCase(str) {
    return str.replace(/-./g, (x)=>x[1].toUpperCase());
}
function uppercaseFirstChar(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
function unwrap(fn) {
    return isFunction(fn) ? fn() : fn;
}
function ariaBool(value) {
    return value ? "true" : "false";
}
function createDisposalBin() {
    const disposal = /* @__PURE__ */ new Set();
    return {
        add (...callbacks) {
            for (const callback of callbacks)disposal.add(callback);
        },
        empty () {
            for (const callback of disposal)callback();
            disposal.clear();
        }
    };
}
function keysOf(obj) {
    return Object.keys(obj);
}
function deferredPromise() {
    let resolve, reject;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}
function waitTimeout(delay) {
    return new Promise((resolve)=>setTimeout(resolve, delay));
}
function animationFrameThrottle(func) {
    let id = -1, lastArgs;
    function throttle(...args) {
        lastArgs = args;
        if (id >= 0) return;
        id = window.requestAnimationFrame(()=>{
            func.apply(this, lastArgs);
            id = -1;
            lastArgs = void 0;
        });
    }
    return throttle;
}
const requestIdleCallback = typeof window !== "undefined" ? "requestIdleCallback" in window ? window.requestIdleCallback : (cb)=>window.setTimeout(cb, 1) : noop;
function waitIdlePeriod(callback, options) {
    return new Promise((resolve)=>{
        requestIdleCallback((deadline)=>{
            callback?.(deadline);
            resolve();
        }, options);
    });
}
var key = {
    fullscreenEnabled: 0,
    fullscreenElement: 1,
    requestFullscreen: 2,
    exitFullscreen: 3,
    fullscreenchange: 4,
    fullscreenerror: 5,
    fullscreen: 6
};
var webkit = [
    "webkitFullscreenEnabled",
    "webkitFullscreenElement",
    "webkitRequestFullscreen",
    "webkitExitFullscreen",
    "webkitfullscreenchange",
    "webkitfullscreenerror",
    "-webkit-full-screen"
];
var moz = [
    "mozFullScreenEnabled",
    "mozFullScreenElement",
    "mozRequestFullScreen",
    "mozCancelFullScreen",
    "mozfullscreenchange",
    "mozfullscreenerror",
    "-moz-full-screen"
];
var ms = [
    "msFullscreenEnabled",
    "msFullscreenElement",
    "msRequestFullscreen",
    "msExitFullscreen",
    "MSFullscreenChange",
    "MSFullscreenError",
    "-ms-fullscreen"
];
var document$1 = typeof window !== "undefined" && typeof window.document !== "undefined" ? window.document : {};
var vendor = "fullscreenEnabled" in document$1 && Object.keys(key) || webkit[0] in document$1 && webkit || moz[0] in document$1 && moz || ms[0] in document$1 && ms || [];
var fscreen = {
    requestFullscreen: function(element) {
        return element[vendor[key.requestFullscreen]]();
    },
    requestFullscreenFunction: function(element) {
        return element[vendor[key.requestFullscreen]];
    },
    get exitFullscreen () {
        return document$1[vendor[key.exitFullscreen]].bind(document$1);
    },
    get fullscreenPseudoClass () {
        return ":" + vendor[key.fullscreen];
    },
    addEventListener: function(type, handler1, options) {
        return document$1.addEventListener(vendor[key[type]], handler1, options);
    },
    removeEventListener: function(type, handler1, options) {
        return document$1.removeEventListener(vendor[key[type]], handler1, options);
    },
    get fullscreenEnabled () {
        return Boolean(document$1[vendor[key.fullscreenEnabled]]);
    },
    set fullscreenEnabled (val){},
    get fullscreenElement () {
        return document$1[vendor[key.fullscreenElement]];
    },
    set fullscreenElement (val){},
    get onfullscreenchange () {
        return document$1[("on" + vendor[key.fullscreenchange]).toLowerCase()];
    },
    set onfullscreenchange (handler){
        return document$1[("on" + vendor[key.fullscreenchange]).toLowerCase()] = handler;
    },
    get onfullscreenerror () {
        return document$1[("on" + vendor[key.fullscreenerror]).toLowerCase()];
    },
    set onfullscreenerror (handler){
        return document$1[("on" + vendor[key.fullscreenerror]).toLowerCase()] = handler;
    }
};
var functionThrottle = throttle;
function throttle(fn, interval, options) {
    var timeoutId = null;
    var throttledFn = null;
    var leading = options && options.leading;
    var trailing = options && options.trailing;
    if (leading == null) leading = true; // default
    if (trailing == null) trailing = !leading; //default
    if (leading == true) trailing = false; // forced because there should be invocation per call
    var cancel = function() {
        if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
    };
    var flush = function() {
        var call = throttledFn;
        cancel();
        if (call) call();
    };
    var throttleWrapper = function() {
        var callNow = leading && !timeoutId;
        var context = this;
        var args = arguments;
        throttledFn = function() {
            return fn.apply(context, args);
        };
        if (!timeoutId) timeoutId = setTimeout(function() {
            timeoutId = null;
            if (trailing) return throttledFn();
        }, interval);
        if (callNow) {
            callNow = false;
            return throttledFn();
        }
    };
    throttleWrapper.cancel = cancel;
    throttleWrapper.flush = flush;
    return throttleWrapper;
}
var functionDebounce = debounce;
function debounce(fn, wait, callFirst) {
    var timeout = null;
    var debouncedFn = null;
    var clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            debouncedFn = null;
            timeout = null;
        }
    };
    var flush = function() {
        var call = debouncedFn;
        clear();
        if (call) call();
    };
    var debounceWrapper = function() {
        if (!wait) return fn.apply(this, arguments);
        var context = this;
        var args = arguments;
        var callNow = callFirst && !timeout;
        clear();
        debouncedFn = function() {
            fn.apply(context, args);
        };
        timeout = setTimeout(function() {
            timeout = null;
            if (!callNow) {
                var call = debouncedFn;
                debouncedFn = null;
                return call();
            }
        }, wait);
        if (callNow) return debouncedFn();
    };
    debounceWrapper.cancel = clear;
    debounceWrapper.flush = flush;
    return debounceWrapper;
}
const t = (t2)=>"object" == typeof t2 && null != t2 && 1 === t2.nodeType, e = (t2, e2)=>(!e2 || "hidden" !== t2) && "visible" !== t2 && "clip" !== t2, n = (t2, n2)=>{
    if (t2.clientHeight < t2.scrollHeight || t2.clientWidth < t2.scrollWidth) {
        const o2 = getComputedStyle(t2, null);
        return e(o2.overflowY, n2) || e(o2.overflowX, n2) || ((t3)=>{
            const e2 = ((t4)=>{
                if (!t4.ownerDocument || !t4.ownerDocument.defaultView) return null;
                try {
                    return t4.ownerDocument.defaultView.frameElement;
                } catch (t5) {
                    return null;
                }
            })(t3);
            return !!e2 && (e2.clientHeight < t3.scrollHeight || e2.clientWidth < t3.scrollWidth);
        })(t2);
    }
    return false;
}, o = (t2, e2, n2, o2, l2, r2, i, s)=>r2 < t2 && i > e2 || r2 > t2 && i < e2 ? 0 : r2 <= t2 && s <= n2 || i >= e2 && s >= n2 ? r2 - t2 - o2 : i > e2 && s < n2 || r2 < t2 && s > n2 ? i - e2 + l2 : 0, l = (t2)=>{
    const e2 = t2.parentElement;
    return null == e2 ? t2.getRootNode().host || null : e2;
}, r = (e2, r2)=>{
    var i, s, d, h;
    if ("undefined" == typeof document) return [];
    const { scrollMode: c, block: f, inline: u, boundary: a, skipOverflowHiddenElements: g } = r2, p = "function" == typeof a ? a : (t2)=>t2 !== a;
    if (!t(e2)) throw new TypeError("Invalid target");
    const m = document.scrollingElement || document.documentElement, w = [];
    let W = e2;
    for(; t(W) && p(W);){
        if (W = l(W), W === m) {
            w.push(W);
            break;
        }
        null != W && W === document.body && n(W) && !n(document.documentElement) || null != W && n(W, g) && w.push(W);
    }
    const b = null != (s = null == (i = window.visualViewport) ? void 0 : i.width) ? s : innerWidth, H = null != (h = null == (d = window.visualViewport) ? void 0 : d.height) ? h : innerHeight, { scrollX: y, scrollY: M } = window, { height: v, width: E, top: x, right: C, bottom: I, left: R } = e2.getBoundingClientRect(), { top: T, right: B, bottom: F, left: V } = ((t2)=>{
        const e3 = window.getComputedStyle(t2);
        return {
            top: parseFloat(e3.scrollMarginTop) || 0,
            right: parseFloat(e3.scrollMarginRight) || 0,
            bottom: parseFloat(e3.scrollMarginBottom) || 0,
            left: parseFloat(e3.scrollMarginLeft) || 0
        };
    })(e2);
    let k = "start" === f || "nearest" === f ? x - T : "end" === f ? I + F : x + v / 2 - T + F, D = "center" === u ? R + E / 2 - V + B : "end" === u ? C + B : R - V;
    const L = [];
    for(let t2 = 0; t2 < w.length; t2++){
        const e3 = w[t2], { height: n2, width: l2, top: r3, right: i2, bottom: s2, left: d2 } = e3.getBoundingClientRect();
        if ("if-needed" === c && x >= 0 && R >= 0 && I <= H && C <= b && x >= r3 && I <= s2 && R >= d2 && C <= i2) return L;
        const h2 = getComputedStyle(e3), a2 = parseInt(h2.borderLeftWidth, 10), g2 = parseInt(h2.borderTopWidth, 10), p2 = parseInt(h2.borderRightWidth, 10), W2 = parseInt(h2.borderBottomWidth, 10);
        let T2 = 0, B2 = 0;
        const F2 = "offsetWidth" in e3 ? e3.offsetWidth - e3.clientWidth - a2 - p2 : 0, V2 = "offsetHeight" in e3 ? e3.offsetHeight - e3.clientHeight - g2 - W2 : 0, S = "offsetWidth" in e3 ? 0 === e3.offsetWidth ? 0 : l2 / e3.offsetWidth : 0, X = "offsetHeight" in e3 ? 0 === e3.offsetHeight ? 0 : n2 / e3.offsetHeight : 0;
        if (m === e3) T2 = "start" === f ? k : "end" === f ? k - H : "nearest" === f ? o(M, M + H, H, g2, W2, M + k, M + k + v, v) : k - H / 2, B2 = "start" === u ? D : "center" === u ? D - b / 2 : "end" === u ? D - b : o(y, y + b, b, a2, p2, y + D, y + D + E, E), T2 = Math.max(0, T2 + M), B2 = Math.max(0, B2 + y);
        else {
            T2 = "start" === f ? k - r3 - g2 : "end" === f ? k - s2 + W2 + V2 : "nearest" === f ? o(r3, s2, n2, g2, W2 + V2, k, k + v, v) : k - (r3 + n2 / 2) + V2 / 2, B2 = "start" === u ? D - d2 - a2 : "center" === u ? D - (d2 + l2 / 2) + F2 / 2 : "end" === u ? D - i2 + p2 + F2 : o(d2, i2, l2, a2, p2 + F2, D, D + E, E);
            const { scrollLeft: t3, scrollTop: h3 } = e3;
            T2 = 0 === X ? 0 : Math.max(0, Math.min(h3 + T2 / X, e3.scrollHeight - n2 / X + V2)), B2 = 0 === S ? 0 : Math.max(0, Math.min(t3 + B2 / S, e3.scrollWidth - l2 / S + F2)), k += h3 - T2, D += t3 - B2;
        }
        L.push({
            el: e3,
            top: T2,
            left: B2
        });
    }
    return L;
};
const STRING = (v)=>v === null ? "" : v + "";
const NULLABLE_STRING = (v)=>v === null ? null : v + "";
const NUMBER = (v)=>v === null ? 0 : Number(v);
const BOOLEAN = (v)=>v !== null;
const FUNCTION = ()=>null;
const ARRAY = (v)=>v === null ? [] : JSON.parse(v);
const OBJECT = (v)=>v === null ? {} : JSON.parse(v);
function inferAttributeConverter(value) {
    if (value === null) return NULLABLE_STRING;
    switch(typeof value){
        case "undefined":
            return STRING;
        case "string":
            return STRING;
        case "boolean":
            return BOOLEAN;
        case "number":
            return NUMBER;
        case "function":
            return FUNCTION;
        case "object":
            return isArray(value) ? ARRAY : OBJECT;
        default:
            return STRING;
    }
}
const ATTRS = /* @__PURE__ */ Symbol(0);
const SETUP = /* @__PURE__ */ Symbol(0);
const SETUP_STATE = /* @__PURE__ */ Symbol(0);
const SETUP_CALLBACKS = /* @__PURE__ */ Symbol(0);
var SetupState;
(function(SetupState2) {
    const Idle = 0;
    SetupState2[SetupState2["Idle"] = Idle] = "Idle";
    const Pending = 1;
    SetupState2[SetupState2["Pending"] = Pending] = "Pending";
    const Ready = 2;
    SetupState2[SetupState2["Ready"] = Ready] = "Ready";
})(SetupState || (SetupState = {}));
function Host(Super, Component) {
    let _SETUP_STATE = SETUP_STATE, _SETUP_CALLBACKS = SETUP_CALLBACKS, _SETUP = SETUP;
    class MaverickElement extends Super {
        static get observedAttributes() {
            if (!this[ATTRS] && Component.props) {
                const map = /* @__PURE__ */ new Map();
                for (const propName of Object.keys(Component.props)){
                    let attr = this.attrs?.[propName], attrName = isString(attr) ? attr : !attr ? attr : attr?.attr;
                    if (attrName === false) continue;
                    if (!attrName) attrName = camelToKebabCase(propName);
                    map.set(attrName, {
                        prop: propName,
                        converter: attr && !isString(attr) && attr?.converter || inferAttributeConverter(Component.props[propName])
                    });
                }
                this[ATTRS] = map;
            }
            return this[ATTRS] ? Array.from(this[ATTRS].keys()) : [];
        }
        get scope() {
            return this.$.$$.scope;
        }
        get attachScope() {
            return this.$.$$.attachScope;
        }
        get connectScope() {
            return this.$.$$.connectScope;
        }
        get $props() {
            return this.$.$$.props;
        }
        get $state() {
            return this.$.$$.$state;
        }
        get state() {
            return this.$.state;
        }
        attributeChangedCallback(name, _, newValue) {
            const Ctor = this.constructor;
            if (!Ctor[ATTRS]) {
                super.attributeChangedCallback?.(name, _, newValue);
                return;
            }
            const def = Ctor[ATTRS].get(name);
            if (def) this[def.prop] = def.converter(newValue);
        }
        connectedCallback() {
            const instance = this.$?.$$;
            if (!instance || instance.destroyed) return;
            if (this[SETUP_STATE] !== SetupState.Ready) {
                setup.call(this);
                return;
            }
            if (!this.isConnected) return;
            if (this.hasAttribute("keep-alive")) this.keepAlive = true;
            instance.connect();
            if (isArray(this[SETUP_CALLBACKS])) runAll(this[SETUP_CALLBACKS], this);
            this[SETUP_CALLBACKS] = null;
            const callback = super.connectedCallback;
            if (callback) scoped(()=>callback.call(this), this.connectScope);
            return;
        }
        disconnectedCallback() {
            const instance = this.$?.$$;
            if (!instance || instance.destroyed) return;
            instance.disconnect();
            const callback = super.disconnectedCallback;
            if (callback) callback.call(this);
            if (!this.keepAlive && !this.hasAttribute("keep-alive")) setTimeout(()=>{
                requestAnimationFrame(()=>{
                    if (!this.isConnected) instance.destroy();
                });
            }, 0);
        }
        [_SETUP]() {
            const instance = this.$.$$, Ctor = this.constructor;
            if (instance.destroyed) return;
            const attrs = Ctor[ATTRS];
            if (attrs) for (const attr of this.attributes){
                let def = attrs.get(attr.name);
                if (def && def.converter) instance.props[def.prop].set(def.converter(this.getAttribute(attr.name)));
            }
            instance.setup();
            instance.attach(this);
            this[SETUP_STATE] = SetupState.Ready;
            this.connectedCallback();
        }
        // @ts-expect-error
        subscribe(callback) {
            return this.$.subscribe(callback);
        }
        destroy() {
            this.disconnectedCallback();
            this.$.destroy();
        }
        constructor(...args){
            super(...args);
            (0, $97zcJ._)(this, "$", void 0);
            (0, $97zcJ._)(this, _SETUP_STATE, SetupState.Idle);
            (0, $97zcJ._)(this, _SETUP_CALLBACKS, null);
            (0, $97zcJ._)(this, "keepAlive", false);
            (0, $97zcJ._)(this, "forwardKeepAlive", true);
            this.$ = scoped(()=>createComponent(Component), null);
            this.$.$$.addHooks(this);
            if (Component.props) {
                const props = this.$props, descriptors = Object.getOwnPropertyDescriptors(this);
                for (const prop of Object.keys(descriptors))if (prop in Component.props) {
                    props[prop].set(this[prop]);
                    delete this[prop];
                }
            }
        }
    }
    (0, $97zcJ._)(MaverickElement, "attrs", void 0);
    (0, $97zcJ._)(MaverickElement, ATTRS, null);
    extendProto(MaverickElement, Component);
    return MaverickElement;
}
function extendProto(Element, Component) {
    const ElementProto = Element.prototype, ComponentProto = Component.prototype;
    if (Component.props) for (const prop of Object.keys(Component.props))Object.defineProperty(ElementProto, prop, {
        enumerable: true,
        configurable: true,
        get () {
            return this.$props[prop]();
        },
        set (value) {
            this.$props[prop].set(value);
        }
    });
    if (ComponentProto[PROPS]) for (const name of ComponentProto[PROPS])Object.defineProperty(ElementProto, name, {
        enumerable: true,
        configurable: true,
        get () {
            return this.$[name];
        },
        set (value) {
            this.$[name] = value;
        }
    });
    if (ComponentProto[METHODS]) for (const name of ComponentProto[METHODS])ElementProto[name] = function(...args) {
        return this.$[name](...args);
    };
}
function setup() {
    if (this[SETUP_STATE] !== SetupState.Idle) return;
    this[SETUP_STATE] = SetupState.Pending;
    const parent = findParent(this), isParentRegistered = parent && window.customElements.get(parent.localName), isParentSetup = parent && parent[SETUP_STATE] === SetupState.Ready;
    if (parent && (!isParentRegistered || !isParentSetup)) {
        waitForParent.call(this, parent);
        return;
    }
    attach.call(this, parent);
}
async function waitForParent(parent) {
    await window.customElements.whenDefined(parent.localName);
    if (parent[SETUP_STATE] !== SetupState.Ready) await new Promise((res)=>(parent[SETUP_CALLBACKS] ??= []).push(res));
    attach.call(this, parent);
}
function attach(parent) {
    if (!this.isConnected) return;
    if (parent) {
        if (parent.keepAlive && parent.forwardKeepAlive) {
            this.keepAlive = true;
            this.setAttribute("keep-alive", "");
        }
        const scope = this.$.$$.scope;
        if (scope) parent.$.$$.attachScope.append(scope);
    }
    this[SETUP]();
}
function findParent(host) {
    let node = host.parentNode, prefix = host.localName.split("-", 1)[0] + "-";
    while(node){
        if (node.nodeType === 1 && node.localName.startsWith(prefix)) return node;
        node = node.parentNode;
    }
    return null;
}
function defineCustomElement(element, throws = false) {
    if (throws || !window.customElements.get(element.tagName)) window.customElements.define(element.tagName, element);
}
var Icon$24 = `<path fill-rule="evenodd" clip-rule="evenodd" d="M6 7C5.63181 7 5.33333 7.29848 5.33333 7.66667V14.8667C5.33333 14.9403 5.39361 14.9999 5.46724 15.0009C10.8844 15.0719 15.2614 19.449 15.3325 24.8661C15.3334 24.9397 15.393 25 15.4667 25H26C26.3682 25 26.6667 24.7015 26.6667 24.3333V7.66667C26.6667 7.29848 26.3682 7 26 7H6ZM17.0119 22.2294C17.0263 22.29 17.0802 22.3333 17.1425 22.3333H23.3333C23.7015 22.3333 24 22.0349 24 21.6667V10.3333C24 9.96514 23.7015 9.66667 23.3333 9.66667H8.66667C8.29848 9.66667 8 9.96514 8 10.3333V13.1909C8 13.2531 8.04332 13.3071 8.10392 13.3214C12.5063 14.3618 15.9715 17.827 17.0119 22.2294Z" fill="currentColor"/> <path d="M13.2 25C13.2736 25 13.3334 24.9398 13.3322 24.8661C13.2615 20.5544 9.77889 17.0718 5.46718 17.0011C5.39356 16.9999 5.33333 17.0597 5.33333 17.1333V18.8667C5.33333 18.9403 5.39348 18.9999 5.4671 19.0015C8.67465 19.0716 11.2617 21.6587 11.3319 24.8662C11.3335 24.9399 11.393 25 11.4667 25H13.2Z" fill="currentColor"/> <path d="M5.33333 21.1333C5.33333 21.0597 5.39332 20.9998 5.46692 21.0022C7.57033 21.0712 9.26217 22.763 9.33114 24.8664C9.33356 24.94 9.27364 25 9.2 25H6C5.63181 25 5.33333 24.7015 5.33333 24.3333V21.1333Z" fill="currentColor"/>`;
var Icon$0 = `<path fill-rule="evenodd" clip-rule="evenodd" d="M15.0007 28.7923C15.0007 29.0152 14.9774 29.096 14.9339 29.1775C14.8903 29.259 14.8263 29.323 14.7449 29.3665C14.6634 29.4101 14.5826 29.4333 14.3597 29.4333H12.575C12.3521 29.4333 12.2713 29.4101 12.1898 29.3665C12.1083 29.323 12.0443 29.259 12.0008 29.1775C11.9572 29.096 11.934 29.0152 11.934 28.7923V12.2993L5.97496 12.3C5.75208 12.3 5.67125 12.2768 5.58977 12.2332C5.50829 12.1896 5.44434 12.1257 5.40077 12.0442C5.35719 11.9627 5.33398 11.8819 5.33398 11.659V9.87429C5.33398 9.65141 5.35719 9.57059 5.40077 9.48911C5.44434 9.40762 5.50829 9.34368 5.58977 9.3001C5.67125 9.25652 5.75208 9.23332 5.97496 9.23332H26.0263C26.2492 9.23332 26.33 9.25652 26.4115 9.3001C26.493 9.34368 26.557 9.40762 26.6005 9.48911C26.6441 9.57059 26.6673 9.65141 26.6673 9.87429V11.659C26.6673 11.8819 26.6441 11.9627 26.6005 12.0442C26.557 12.1257 26.493 12.1896 26.4115 12.2332C26.33 12.2768 26.2492 12.3 26.0263 12.3L20.067 12.2993L20.0673 28.7923C20.0673 29.0152 20.0441 29.096 20.0005 29.1775C19.957 29.259 19.893 29.323 19.8115 29.3665C19.73 29.4101 19.6492 29.4333 19.4263 29.4333H17.6416C17.4187 29.4333 17.3379 29.4101 17.2564 29.3665C17.175 29.323 17.111 29.259 17.0674 29.1775C17.0239 29.096 17.0007 29.0152 17.0007 28.7923L17 22.7663H15L15.0007 28.7923Z" fill="currentColor"/> <path d="M16.0007 7.89998C17.4734 7.89998 18.6673 6.70608 18.6673 5.23332C18.6673 3.76056 17.4734 2.56665 16.0007 2.56665C14.5279 2.56665 13.334 3.76056 13.334 5.23332C13.334 6.70608 14.5279 7.89998 16.0007 7.89998Z" fill="currentColor"/>`;
var Icon$5 = `<path d="M5.33334 6.00001C5.33334 5.63182 5.63181 5.33334 6 5.33334H26C26.3682 5.33334 26.6667 5.63182 26.6667 6.00001V20.6667C26.6667 21.0349 26.3682 21.3333 26 21.3333H23.7072C23.4956 21.3333 23.2966 21.233 23.171 21.0628L22.1859 19.7295C21.8607 19.2894 22.1749 18.6667 22.7221 18.6667H23.3333C23.7015 18.6667 24 18.3682 24 18V8.66668C24 8.29849 23.7015 8.00001 23.3333 8.00001H8.66667C8.29848 8.00001 8 8.29849 8 8.66668V18C8 18.3682 8.29848 18.6667 8.66667 18.6667H9.29357C9.84072 18.6667 10.1549 19.2894 9.82976 19.7295L8.84467 21.0628C8.71898 21.233 8.52 21.3333 8.30848 21.3333H6C5.63181 21.3333 5.33334 21.0349 5.33334 20.6667V6.00001Z" fill="currentColor"/> <path d="M8.78528 25.6038C8.46013 26.0439 8.77431 26.6667 9.32147 26.6667L22.6785 26.6667C23.2256 26.6667 23.5398 26.0439 23.2146 25.6038L16.5358 16.5653C16.2693 16.2046 15.73 16.2047 15.4635 16.5653L8.78528 25.6038Z" fill="currentColor"/>`;
var Icon$8 = `<path d="M17.4853 18.9093C17.4853 19.0281 17.6289 19.0875 17.7129 19.0035L22.4185 14.2979C22.6788 14.0376 23.1009 14.0376 23.3613 14.2979L24.7755 15.7122C25.0359 15.9725 25.0359 16.3946 24.7755 16.655L16.2902 25.1403C16.0299 25.4006 15.6078 25.4006 15.3474 25.1403L13.9332 23.726L13.9319 23.7247L6.86189 16.6547C6.60154 16.3944 6.60154 15.9723 6.86189 15.7119L8.2761 14.2977C8.53645 14.0373 8.95856 14.0373 9.21891 14.2977L13.9243 19.0031C14.0083 19.0871 14.1519 19.0276 14.1519 18.9088L14.1519 6.00004C14.1519 5.63185 14.4504 5.33337 14.8186 5.33337L16.8186 5.33337C17.1868 5.33337 17.4853 5.63185 17.4853 6.00004L17.4853 18.9093Z" fill="currentColor"/>`;
var Icon$11 = `<path d="M13.0908 14.3334C12.972 14.3334 12.9125 14.1898 12.9965 14.1058L17.7021 9.40022C17.9625 9.13987 17.9625 8.71776 17.7021 8.45741L16.2879 7.04319C16.0275 6.78284 15.6054 6.78284 15.3451 7.04319L6.8598 15.5285C6.59945 15.7888 6.59945 16.2109 6.8598 16.4713L8.27401 17.8855L8.27536 17.8868L15.3453 24.9568C15.6057 25.2172 16.0278 25.2172 16.2881 24.9568L17.7024 23.5426C17.9627 23.2822 17.9627 22.8601 17.7024 22.5998L12.9969 17.8944C12.9129 17.8104 12.9724 17.6668 13.0912 17.6668L26 17.6668C26.3682 17.6668 26.6667 17.3683 26.6667 17.0001V15.0001C26.6667 14.6319 26.3682 14.3334 26 14.3334L13.0908 14.3334Z" fill="currentColor"/>`;
var Icon$13 = `<path d="M14.1521 13.0929C14.1521 12.9741 14.0085 12.9147 13.9245 12.9987L9.21891 17.7043C8.95856 17.9646 8.53645 17.9646 8.2761 17.7043L6.86189 16.29C6.60154 16.0297 6.60154 15.6076 6.86189 15.3472L15.3472 6.86195C15.6075 6.6016 16.0296 6.6016 16.29 6.86195L17.7042 8.27616L17.7055 8.27751L24.7755 15.3475C25.0359 15.6078 25.0359 16.0299 24.7755 16.2903L23.3613 17.7045C23.1009 17.9649 22.6788 17.9649 22.4185 17.7045L17.7131 12.9991C17.6291 12.9151 17.4855 12.9746 17.4855 13.0934V26.0022C17.4855 26.3704 17.187 26.6688 16.8188 26.6688H14.8188C14.4506 26.6688 14.1521 26.3704 14.1521 26.0022L14.1521 13.0929Z" fill="currentColor"/>`;
var Icon$16 = `<path d="M16.6927 25.3346C16.3245 25.3346 16.026 25.0361 16.026 24.6679L16.026 7.3346C16.026 6.96641 16.3245 6.66794 16.6927 6.66794L18.6927 6.66794C19.0609 6.66794 19.3594 6.96642 19.3594 7.3346L19.3594 24.6679C19.3594 25.0361 19.0609 25.3346 18.6927 25.3346H16.6927Z" fill="currentColor"/> <path d="M24.026 25.3346C23.6578 25.3346 23.3594 25.0361 23.3594 24.6679L23.3594 7.3346C23.3594 6.96641 23.6578 6.66794 24.026 6.66794L26.026 6.66794C26.3942 6.66794 26.6927 6.96642 26.6927 7.3346V24.6679C26.6927 25.0361 26.3942 25.3346 26.026 25.3346H24.026Z" fill="currentColor"/> <path d="M5.48113 23.9407C5.38584 24.2963 5.59689 24.6619 5.95254 24.7572L7.88439 25.2748C8.24003 25.3701 8.60559 25.159 8.70089 24.8034L13.1871 8.06067C13.2824 7.70503 13.0713 7.33947 12.7157 7.24417L10.7838 6.72654C10.4282 6.63124 10.0626 6.8423 9.96733 7.19794L5.48113 23.9407Z" fill="currentColor"/>`;
var Icon$19 = `<path fill-rule="evenodd" clip-rule="evenodd" d="M24.9266 7.57992C25.015 7.60672 25.0886 7.64746 25.2462 7.80506L26.956 9.51488C27.1136 9.67248 27.1543 9.74604 27.1811 9.83447C27.2079 9.9229 27.2079 10.0133 27.1811 10.1018C27.1543 10.1902 27.1136 10.2638 26.956 10.4214L13.1822 24.1951C13.0246 24.3527 12.951 24.3935 12.8626 24.4203C12.797 24.4402 12.7304 24.4453 12.6642 24.4357L12.7319 24.4203C12.6435 24.4471 12.553 24.4471 12.4646 24.4203C12.3762 24.3935 12.3026 24.3527 12.145 24.1951L5.04407 17.0942C4.88647 16.9366 4.84573 16.863 4.81893 16.7746C4.79213 16.6862 4.79213 16.5957 4.81893 16.5073C4.84573 16.4189 4.88647 16.3453 5.04407 16.1877L6.7539 14.4779C6.9115 14.3203 6.98506 14.2796 7.07349 14.2528C7.16191 14.226 7.25235 14.226 7.34078 14.2528C7.42921 14.2796 7.50277 14.3203 7.66037 14.4779L12.6628 19.4808L24.3397 7.80506C24.4973 7.64746 24.5709 7.60672 24.6593 7.57992C24.7477 7.55311 24.8382 7.55311 24.9266 7.57992Z" fill="currentColor"/>`;
var Icon$22 = `<path d="M17.947 16.095C17.999 16.043 17.999 15.9585 17.947 15.9065L11.6295 9.58899C11.3691 9.32864 11.3691 8.90653 11.6295 8.64618L13.2323 7.04341C13.4926 6.78306 13.9147 6.78306 14.1751 7.04341L21.0289 13.8973C21.0392 13.9064 21.0493 13.9158 21.0591 13.9257L22.6619 15.5285C22.9223 15.7888 22.9223 16.2109 22.6619 16.4713L14.1766 24.9565C13.9163 25.2169 13.4942 25.2169 13.2338 24.9565L11.631 23.3538C11.3707 23.0934 11.3707 22.6713 11.631 22.411L17.947 16.095Z" fill="currentColor"/>`;
var Icon$26 = `<path d="M8 28.0003C8 27.6321 8.29848 27.3336 8.66667 27.3336H23.3333C23.7015 27.3336 24 27.6321 24 28.0003V29.3336C24 29.7018 23.7015 30.0003 23.3333 30.0003H8.66667C8.29848 30.0003 8 29.7018 8 29.3336V28.0003Z" fill="currentColor"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M4.66602 6.66699C4.29783 6.66699 3.99935 6.96547 3.99935 7.33366V24.667C3.99935 25.0352 4.29783 25.3337 4.66602 25.3337H27.3327C27.7009 25.3337 27.9994 25.0352 27.9994 24.667V7.33366C27.9994 6.96547 27.7009 6.66699 27.3327 6.66699H4.66602ZM8.66659 21.3333C8.2984 21.3333 7.99992 21.0349 7.99992 20.6667V11.3333C7.99992 10.9651 8.2984 10.6667 8.66659 10.6667H13.9999C14.3681 10.6667 14.6666 10.9651 14.6666 11.3333V12.6667C14.6666 13.0349 14.3681 13.3333 13.9999 13.3333H10.7999C10.7263 13.3333 10.6666 13.393 10.6666 13.4667V18.5333C10.6666 18.607 10.7263 18.6667 10.7999 18.6667H13.9999C14.3681 18.6667 14.6666 18.9651 14.6666 19.3333V20.6667C14.6666 21.0349 14.3681 21.3333 13.9999 21.3333H8.66659ZM17.9999 21.3333C17.6317 21.3333 17.3333 21.0349 17.3333 20.6667V11.3333C17.3333 10.9651 17.6317 10.6667 17.9999 10.6667H23.3333C23.7014 10.6667 23.9999 10.9651 23.9999 11.3333V12.6667C23.9999 13.0349 23.7014 13.3333 23.3333 13.3333H20.1333C20.0596 13.3333 19.9999 13.393 19.9999 13.4667V18.5333C19.9999 18.607 20.0596 18.6667 20.1333 18.6667H23.3333C23.7014 18.6667 23.9999 18.9651 23.9999 19.3333V20.6667C23.9999 21.0349 23.7014 21.3333 23.3333 21.3333H17.9999Z" fill="currentColor"/>`;
var Icon$27 = `<path fill-rule="evenodd" clip-rule="evenodd" d="M4.6661 6.66699C4.29791 6.66699 3.99943 6.96547 3.99943 7.33366V24.667C3.99943 25.0352 4.29791 25.3337 4.6661 25.3337H27.3328C27.701 25.3337 27.9994 25.0352 27.9994 24.667V7.33366C27.9994 6.96547 27.701 6.66699 27.3328 6.66699H4.6661ZM8.66667 21.3333C8.29848 21.3333 8 21.0349 8 20.6667V11.3333C8 10.9651 8.29848 10.6667 8.66667 10.6667H14C14.3682 10.6667 14.6667 10.9651 14.6667 11.3333V12.6667C14.6667 13.0349 14.3682 13.3333 14 13.3333H10.8C10.7264 13.3333 10.6667 13.393 10.6667 13.4667V18.5333C10.6667 18.607 10.7264 18.6667 10.8 18.6667H14C14.3682 18.6667 14.6667 18.9651 14.6667 19.3333V20.6667C14.6667 21.0349 14.3682 21.3333 14 21.3333H8.66667ZM18 21.3333C17.6318 21.3333 17.3333 21.0349 17.3333 20.6667V11.3333C17.3333 10.9651 17.6318 10.6667 18 10.6667H23.3333C23.7015 10.6667 24 10.9651 24 11.3333V12.6667C24 13.0349 23.7015 13.3333 23.3333 13.3333H20.1333C20.0597 13.3333 20 13.393 20 13.4667V18.5333C20 18.607 20.0597 18.6667 20.1333 18.6667H23.3333C23.7015 18.6667 24 18.9651 24 19.3333V20.6667C24 21.0349 23.7015 21.3333 23.3333 21.3333H18Z" fill="currentColor"/>`;
var Icon$31 = `<path d="M14.2225 13.7867C14.3065 13.8706 14.4501 13.8112 14.4501 13.6924V5.99955C14.4501 5.63136 14.7486 5.33289 15.1167 5.33289H16.8501C17.2183 5.33289 17.5167 5.63136 17.5167 5.99955V13.6916C17.5167 13.8104 17.6604 13.8699 17.7444 13.7859L19.9433 11.5869C20.2037 11.3266 20.6258 11.3266 20.8861 11.5869L22.1118 12.8126C22.3722 13.0729 22.3722 13.4951 22.1118 13.7554L16.4549 19.4123C16.1946 19.6726 15.772 19.6731 15.5116 19.4128L9.85479 13.7559C9.59444 13.4956 9.59444 13.0734 9.85479 12.8131L11.0804 11.5874C11.3408 11.3271 11.7629 11.3271 12.0233 11.5874L14.2225 13.7867Z" fill="currentColor"/> <path d="M5.99998 20.267C5.63179 20.267 5.33331 20.5654 5.33331 20.9336V25.9997C5.33331 26.3678 5.63179 26.6663 5.99998 26.6663H26C26.3682 26.6663 26.6666 26.3678 26.6666 25.9997V20.9336C26.6666 20.5654 26.3682 20.267 26 20.267H24.2666C23.8985 20.267 23.6 20.5654 23.6 20.9336V22.9333C23.6 23.3014 23.3015 23.5999 22.9333 23.5999H9.06638C8.69819 23.5999 8.39972 23.3014 8.39972 22.9333V20.9336C8.39972 20.5654 8.10124 20.267 7.73305 20.267H5.99998Z" fill="currentColor"/>`;
var Icon$33 = `<path d="M16 20C18.2091 20 20 18.2092 20 16C20 13.7909 18.2091 12 16 12C13.7909 12 12 13.7909 12 16C12 18.2092 13.7909 20 16 20Z" fill="currentColor"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M28 16.0058C28 18.671 23.5 25.3334 16 25.3334C8.5 25.3334 4 18.6762 4 16.0058C4 13.3354 8.50447 6.66669 16 6.66669C23.4955 6.66669 28 13.3406 28 16.0058ZM25.3318 15.9934C25.3328 16.0017 25.3328 16.0099 25.3318 16.0182C25.3274 16.0571 25.3108 16.1728 25.2485 16.3708C25.1691 16.6229 25.0352 16.9462 24.8327 17.3216C24.4264 18.0749 23.7969 18.9398 22.9567 19.754C21.2791 21.3798 18.9148 22.6667 16 22.6667C13.0845 22.6667 10.7202 21.3805 9.04298 19.7557C8.20295 18.9419 7.57362 18.0773 7.16745 17.3241C6.96499 16.9486 6.83114 16.6252 6.75172 16.3729C6.67942 16.1431 6.66856 16.0243 6.66695 16.0066L6.66695 16.005C6.66859 15.9871 6.67951 15.8682 6.75188 15.6383C6.83145 15.3854 6.96554 15.0614 7.16831 14.6853C7.57507 13.9306 8.20514 13.0644 9.04577 12.249C10.7245 10.6208 13.0886 9.33335 16 9.33335C18.9108 9.33335 21.2748 10.6215 22.9539 12.2507C23.7947 13.0664 24.4249 13.933 24.8318 14.6877C25.0346 15.0639 25.1688 15.3878 25.2483 15.6404C25.3107 15.8386 25.3274 15.9545 25.3318 15.9934Z" fill="currentColor"/>`;
var Icon$34 = `<path d="M15.8747 8.11857C16.3148 7.79342 16.9375 8.10759 16.9375 8.65476V14.2575C16.9375 14.3669 17.0621 14.4297 17.1501 14.3647L25.6038 8.11857C26.0439 7.79342 26.6667 8.10759 26.6667 8.65476V23.3451C26.6667 23.8923 26.0439 24.2064 25.6038 23.8813L17.1501 17.6346C17.0621 17.5695 16.9375 17.6324 16.9375 17.7418L16.9375 23.3451C16.9375 23.8923 16.3147 24.2064 15.8747 23.8813L5.93387 16.5358C5.57322 16.2693 5.57323 15.7299 5.93389 15.4634L15.8747 8.11857Z" fill="currentColor"/>`;
var Icon$35 = `<path d="M16.1253 8.11866C15.6852 7.7935 15.0625 8.10768 15.0625 8.65484V14.2576C15.0625 14.367 14.9379 14.4298 14.8499 14.3648L6.39615 8.11866C5.95607 7.7935 5.33331 8.10768 5.33331 8.65484V23.3452C5.33331 23.8923 5.9561 24.2065 6.39617 23.8813L14.8499 17.6347C14.9379 17.5696 15.0625 17.6325 15.0625 17.7419L15.0625 23.3452C15.0625 23.8923 15.6853 24.2065 16.1253 23.8813L26.0661 16.5358C26.4268 16.2694 26.4268 15.73 26.0661 15.4635L16.1253 8.11866Z" fill="currentColor"/>`;
var Icon$39 = `<path d="M19.3334 13.3333C18.9652 13.3333 18.6667 13.0349 18.6667 12.6667L18.6667 7.33333C18.6667 6.96514 18.9652 6.66666 19.3334 6.66666H21.3334C21.7015 6.66666 22 6.96514 22 7.33333V9.86666C22 9.9403 22.0597 10 22.1334 10L24.6667 10C25.0349 10 25.3334 10.2985 25.3334 10.6667V12.6667C25.3334 13.0349 25.0349 13.3333 24.6667 13.3333L19.3334 13.3333Z" fill="currentColor"/> <path d="M13.3334 19.3333C13.3334 18.9651 13.0349 18.6667 12.6667 18.6667H7.33335C6.96516 18.6667 6.66669 18.9651 6.66669 19.3333V21.3333C6.66669 21.7015 6.96516 22 7.33335 22H9.86669C9.94032 22 10 22.0597 10 22.1333L10 24.6667C10 25.0349 10.2985 25.3333 10.6667 25.3333H12.6667C13.0349 25.3333 13.3334 25.0349 13.3334 24.6667L13.3334 19.3333Z" fill="currentColor"/> <path d="M18.6667 24.6667C18.6667 25.0349 18.9652 25.3333 19.3334 25.3333H21.3334C21.7015 25.3333 22 25.0349 22 24.6667V22.1333C22 22.0597 22.0597 22 22.1334 22H24.6667C25.0349 22 25.3334 21.7015 25.3334 21.3333V19.3333C25.3334 18.9651 25.0349 18.6667 24.6667 18.6667L19.3334 18.6667C18.9652 18.6667 18.6667 18.9651 18.6667 19.3333L18.6667 24.6667Z" fill="currentColor"/> <path d="M10.6667 13.3333H12.6667C13.0349 13.3333 13.3334 13.0349 13.3334 12.6667L13.3334 10.6667V7.33333C13.3334 6.96514 13.0349 6.66666 12.6667 6.66666H10.6667C10.2985 6.66666 10 6.96514 10 7.33333L10 9.86666C10 9.9403 9.94033 10 9.86669 10L7.33335 10C6.96516 10 6.66669 10.2985 6.66669 10.6667V12.6667C6.66669 13.0349 6.96516 13.3333 7.33335 13.3333L10.6667 13.3333Z" fill="currentColor"/>`;
var Icon$40 = `<path d="M25.3299 7.26517C25.2958 6.929 25.0119 6.66666 24.6667 6.66666H19.3334C18.9652 6.66666 18.6667 6.96514 18.6667 7.33333V9.33333C18.6667 9.70152 18.9652 10 19.3334 10L21.8667 10C21.9403 10 22 10.0597 22 10.1333V12.6667C22 13.0349 22.2985 13.3333 22.6667 13.3333H24.6667C25.0349 13.3333 25.3334 13.0349 25.3334 12.6667V7.33333C25.3334 7.31032 25.3322 7.28758 25.3299 7.26517Z" fill="currentColor"/> <path d="M22 21.8667C22 21.9403 21.9403 22 21.8667 22L19.3334 22C18.9652 22 18.6667 22.2985 18.6667 22.6667V24.6667C18.6667 25.0349 18.9652 25.3333 19.3334 25.3333L24.6667 25.3333C25.0349 25.3333 25.3334 25.0349 25.3334 24.6667V19.3333C25.3334 18.9651 25.0349 18.6667 24.6667 18.6667H22.6667C22.2985 18.6667 22 18.9651 22 19.3333V21.8667Z" fill="currentColor"/> <path d="M12.6667 22H10.1334C10.0597 22 10 21.9403 10 21.8667V19.3333C10 18.9651 9.70154 18.6667 9.33335 18.6667H7.33335C6.96516 18.6667 6.66669 18.9651 6.66669 19.3333V24.6667C6.66669 25.0349 6.96516 25.3333 7.33335 25.3333H12.6667C13.0349 25.3333 13.3334 25.0349 13.3334 24.6667V22.6667C13.3334 22.2985 13.0349 22 12.6667 22Z" fill="currentColor"/> <path d="M10 12.6667V10.1333C10 10.0597 10.0597 10 10.1334 10L12.6667 10C13.0349 10 13.3334 9.70152 13.3334 9.33333V7.33333C13.3334 6.96514 13.0349 6.66666 12.6667 6.66666H7.33335C6.96516 6.66666 6.66669 6.96514 6.66669 7.33333V12.6667C6.66669 13.0349 6.96516 13.3333 7.33335 13.3333H9.33335C9.70154 13.3333 10 13.0349 10 12.6667Z" fill="currentColor"/>`;
var Icon$53 = `<path fill-rule="evenodd" clip-rule="evenodd" d="M26.6667 5.99998C26.6667 5.63179 26.3682 5.33331 26 5.33331H11.3333C10.9651 5.33331 10.6667 5.63179 10.6667 5.99998V17.5714C10.6667 17.6694 10.5644 17.7342 10.4741 17.6962C9.91823 17.4625 9.30754 17.3333 8.66667 17.3333C6.08934 17.3333 4 19.4226 4 22C4 24.5773 6.08934 26.6666 8.66667 26.6666C11.244 26.6666 13.3333 24.5773 13.3333 22V8.66665C13.3333 8.29846 13.6318 7.99998 14 7.99998L23.3333 7.99998C23.7015 7.99998 24 8.29846 24 8.66665V14.9048C24 15.0027 23.8978 15.0675 23.8075 15.0296C23.2516 14.7958 22.6409 14.6666 22 14.6666C19.4227 14.6666 17.3333 16.756 17.3333 19.3333C17.3333 21.9106 19.4227 24 22 24C24.5773 24 26.6667 21.9106 26.6667 19.3333V5.99998ZM22 21.3333C23.1046 21.3333 24 20.4379 24 19.3333C24 18.2287 23.1046 17.3333 22 17.3333C20.8954 17.3333 20 18.2287 20 19.3333C20 20.4379 20.8954 21.3333 22 21.3333ZM8.66667 24C9.77124 24 10.6667 23.1045 10.6667 22C10.6667 20.8954 9.77124 20 8.66667 20C7.5621 20 6.66667 20.8954 6.66667 22C6.66667 23.1045 7.5621 24 8.66667 24Z" fill="currentColor"/>`;
var Icon$54 = `<path d="M17.5091 24.6594C17.5091 25.2066 16.8864 25.5208 16.4463 25.1956L9.44847 20.0252C9.42553 20.0083 9.39776 19.9991 9.36923 19.9991H4.66667C4.29848 19.9991 4 19.7006 4 19.3325V12.6658C4 12.2976 4.29848 11.9991 4.66667 11.9991H9.37115C9.39967 11.9991 9.42745 11.99 9.45039 11.973L16.4463 6.8036C16.8863 6.47842 17.5091 6.79259 17.5091 7.33977L17.5091 24.6594Z" fill="currentColor"/> <path d="M28.8621 13.6422C29.1225 13.3818 29.1225 12.9597 28.8621 12.6994L27.9193 11.7566C27.659 11.4962 27.2368 11.4962 26.9765 11.7566L24.7134 14.0197C24.6613 14.0717 24.5769 14.0717 24.5248 14.0197L22.262 11.7568C22.0016 11.4964 21.5795 11.4964 21.3191 11.7568L20.3763 12.6996C20.116 12.9599 20.116 13.382 20.3763 13.6424L22.6392 15.9053C22.6913 15.9573 22.6913 16.0418 22.6392 16.0938L20.3768 18.3562C20.1165 18.6166 20.1165 19.0387 20.3768 19.299L21.3196 20.2419C21.58 20.5022 22.0021 20.5022 22.2624 20.2418L24.5248 17.9795C24.5769 17.9274 24.6613 17.9274 24.7134 17.9795L26.976 20.2421C27.2363 20.5024 27.6585 20.5024 27.9188 20.2421L28.8616 19.2992C29.122 19.0389 29.122 18.6168 28.8616 18.3564L26.599 16.0938C26.547 16.0418 26.547 15.9573 26.599 15.9053L28.8621 13.6422Z" fill="currentColor"/>`;
var Icon$56 = `<path d="M26.6009 16.0725C26.6009 16.424 26.4302 17.1125 25.9409 18.0213C25.4676 18.8976 24.7542 19.8715 23.8182 20.7783C21.9489 22.5905 19.2662 24.0667 15.9342 24.0667C12.6009 24.0667 9.91958 22.5915 8.04891 20.78C7.11424 19.8736 6.40091 18.9 5.92758 18.0236C5.43824 17.1149 5.26758 16.4257 5.26758 16.0725C5.26758 15.7193 5.43824 15.0293 5.92891 14.1193C6.40224 13.2416 7.11558 12.2665 8.05158 11.3587C9.92224 9.54398 12.6049 8.06665 15.9342 8.06665C19.2636 8.06665 21.9449 9.54505 23.8169 11.3604C24.7529 12.2687 25.4662 13.2441 25.9396 14.1216C26.4302 15.0317 26.6009 15.7209 26.6009 16.0725Z" stroke="currentColor" stroke-width="3"/> <path d="M15.9336 20.0667C18.1427 20.0667 19.9336 18.2758 19.9336 16.0667C19.9336 13.8575 18.1427 12.0667 15.9336 12.0667C13.7245 12.0667 11.9336 13.8575 11.9336 16.0667C11.9336 18.2758 13.7245 20.0667 15.9336 20.0667Z" fill="currentColor"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M27.2323 25.0624L6.93878 4.76886C6.78118 4.61126 6.70762 4.57052 6.61919 4.54372C6.53077 4.51692 6.44033 4.51691 6.3519 4.54372C6.26347 4.57052 6.18991 4.61126 6.03231 4.76886L4.77032 6.03085C4.61272 6.18845 4.57198 6.26201 4.54518 6.35044C4.51838 6.43887 4.51838 6.5293 4.54518 6.61773C4.57198 6.70616 4.61272 6.77972 4.77032 6.93732L25.0639 27.2308C25.2215 27.3884 25.295 27.4292 25.3834 27.456C25.4719 27.4828 25.5623 27.4828 25.6507 27.456C25.7392 27.4292 25.8127 27.3885 25.9703 27.2309L27.2323 25.9689C27.3899 25.8113 27.4307 25.7377 27.4575 25.6493C27.4843 25.5608 27.4843 25.4704 27.4575 25.382C27.4307 25.2935 27.3899 25.22 27.2323 25.0624Z" fill="currentColor"/>`;
var Icon$59 = `<path d="M8.66667 6.66667C8.29848 6.66667 8 6.96514 8 7.33333V24.6667C8 25.0349 8.29848 25.3333 8.66667 25.3333H12.6667C13.0349 25.3333 13.3333 25.0349 13.3333 24.6667V7.33333C13.3333 6.96514 13.0349 6.66667 12.6667 6.66667H8.66667Z" fill="currentColor"/> <path d="M19.3333 6.66667C18.9651 6.66667 18.6667 6.96514 18.6667 7.33333V24.6667C18.6667 25.0349 18.9651 25.3333 19.3333 25.3333H23.3333C23.7015 25.3333 24 25.0349 24 24.6667V7.33333C24 6.96514 23.7015 6.66667 23.3333 6.66667H19.3333Z" fill="currentColor"/>`;
var Icon$60 = `<path d="M5.33334 26V19.4667C5.33334 19.393 5.39304 19.3333 5.46668 19.3333H7.86668C7.94031 19.3333 8.00001 19.393 8.00001 19.4667V23.3333C8.00001 23.7015 8.29849 24 8.66668 24H23.3333C23.7015 24 24 23.7015 24 23.3333V8.66666C24 8.29847 23.7015 7.99999 23.3333 7.99999H19.4667C19.393 7.99999 19.3333 7.9403 19.3333 7.86666V5.46666C19.3333 5.39302 19.393 5.33333 19.4667 5.33333H26C26.3682 5.33333 26.6667 5.63181 26.6667 5.99999V26C26.6667 26.3682 26.3682 26.6667 26 26.6667H6.00001C5.63182 26.6667 5.33334 26.3682 5.33334 26Z" fill="currentColor"/> <path d="M14.0098 8.42359H10.806C10.6872 8.42359 10.6277 8.56721 10.7117 8.6512L16.5491 14.4886C16.8094 14.7489 16.8094 15.171 16.5491 15.4314L15.3234 16.657C15.0631 16.9174 14.641 16.9174 14.3806 16.657L8.63739 10.9138C8.55339 10.8298 8.40978 10.8893 8.40978 11.0081V14.0236C8.40978 14.3918 8.1113 14.6903 7.74311 14.6903H6.00978C5.64159 14.6903 5.34311 14.3918 5.34311 14.0236L5.34311 6.02359C5.34311 5.6554 5.64159 5.35692 6.00978 5.35692L14.0098 5.35692C14.378 5.35692 14.6764 5.6554 14.6764 6.02359V7.75692C14.6764 8.12511 14.378 8.42359 14.0098 8.42359Z" fill="currentColor"/>`;
var Icon$61 = `<path d="M16 15.3333C15.6318 15.3333 15.3333 15.6318 15.3333 16V20C15.3333 20.3682 15.6318 20.6667 16 20.6667H21.3333C21.7015 20.6667 22 20.3682 22 20V16C22 15.6318 21.7015 15.3333 21.3333 15.3333H16Z" fill="currentColor"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M5.33333 7.33334C5.33333 6.96515 5.63181 6.66667 5.99999 6.66667H26C26.3682 6.66667 26.6667 6.96515 26.6667 7.33334V24.6667C26.6667 25.0349 26.3682 25.3333 26 25.3333H5.99999C5.63181 25.3333 5.33333 25.0349 5.33333 24.6667V7.33334ZM7.99999 10C7.99999 9.63182 8.29847 9.33334 8.66666 9.33334H23.3333C23.7015 9.33334 24 9.63182 24 10V22C24 22.3682 23.7015 22.6667 23.3333 22.6667H8.66666C8.29847 22.6667 7.99999 22.3682 7.99999 22V10Z" fill="currentColor"/>`;
var Icon$62 = `<path d="M10.6667 6.6548C10.6667 6.10764 11.2894 5.79346 11.7295 6.11862L24.377 15.4634C24.7377 15.7298 24.7377 16.2692 24.3771 16.5357L11.7295 25.8813C11.2895 26.2065 10.6667 25.8923 10.6667 25.3451L10.6667 6.6548Z" fill="currentColor"/>`;
var Icon$63 = `<path d="M13.9213 5.53573C14.3146 5.45804 14.6666 5.76987 14.6666 6.17079V7.57215C14.6666 7.89777 14.4305 8.17277 14.114 8.24925C12.5981 8.61559 11.2506 9.41368 10.2091 10.506C9.98474 10.7414 9.62903 10.8079 9.34742 10.6453L8.14112 9.94885C7.79394 9.7484 7.69985 9.28777 7.96359 8.98585C9.48505 7.24409 11.5636 6.00143 13.9213 5.53573Z" fill="currentColor"/> <path d="M5.88974 12.5908C6.01805 12.2101 6.46491 12.0603 6.81279 12.2611L8.01201 12.9535C8.29379 13.1162 8.41396 13.4577 8.32238 13.7699C8.11252 14.4854 7.99998 15.2424 7.99998 16.0257C7.99998 16.809 8.11252 17.566 8.32238 18.2814C8.41396 18.5936 8.29378 18.9352 8.01201 19.0979L6.82742 19.7818C6.48051 19.9821 6.03488 19.8337 5.90521 19.4547C5.5345 18.3712 5.33331 17.2091 5.33331 16C5.33331 14.8078 5.5289 13.6613 5.88974 12.5908Z" fill="currentColor"/> <path d="M8.17106 22.0852C7.82291 22.2862 7.72949 22.7486 7.99532 23.0502C9.51387 24.773 11.5799 26.0017 13.9213 26.4642C14.3146 26.5419 14.6666 26.2301 14.6666 25.8291V24.4792C14.6666 24.1536 14.4305 23.8786 14.114 23.8021C12.5981 23.4358 11.2506 22.6377 10.2091 21.5453C9.98474 21.31 9.62903 21.2435 9.34742 21.4061L8.17106 22.0852Z" fill="currentColor"/> <path d="M17.3333 25.8291C17.3333 26.2301 17.6857 26.5418 18.079 26.4641C22.9748 25.4969 26.6666 21.1796 26.6666 16C26.6666 10.8204 22.9748 6.50302 18.079 5.5358C17.6857 5.4581 17.3333 5.76987 17.3333 6.17079V7.57215C17.3333 7.89777 17.5697 8.17282 17.8862 8.24932C21.3942 9.09721 24 12.2572 24 16.0257C24 19.7942 21.3942 22.9542 17.8862 23.802C17.5697 23.8785 17.3333 24.1536 17.3333 24.4792V25.8291Z" fill="currentColor"/> <path d="M14.3961 10.4163C13.9561 10.0911 13.3333 10.4053 13.3333 10.9525L13.3333 21.0474C13.3333 21.5946 13.9561 21.9087 14.3962 21.5836L21.2273 16.5359C21.5879 16.2694 21.5879 15.73 21.2273 15.4635L14.3961 10.4163Z" fill="currentColor"/>`;
var Icon$74 = `<path d="M15.6038 12.2147C16.0439 12.5399 16.6667 12.2257 16.6667 11.6786V10.1789C16.6667 10.1001 16.7351 10.0384 16.8134 10.0479C20.1116 10.4494 22.6667 13.2593 22.6667 16.6659C22.6667 20.3481 19.6817 23.3332 15.9995 23.3332C12.542 23.3332 9.69927 20.7014 9.36509 17.332C9.32875 16.9655 9.03371 16.6662 8.66548 16.6662L6.66655 16.6666C6.29841 16.6666 5.99769 16.966 6.02187 17.3334C6.36494 22.5454 10.7012 26.6667 16 26.6667C21.5228 26.6667 26 22.1895 26 16.6667C26 11.4103 21.9444 7.10112 16.7916 6.69757C16.7216 6.69209 16.6667 6.63396 16.6667 6.56372V4.98824C16.6667 4.44106 16.0439 4.12689 15.6038 4.45206L11.0765 7.79738C10.7159 8.06387 10.7159 8.60326 11.0766 8.86973L15.6038 12.2147Z" fill="currentColor"/>`;
var Icon$77 = `<path d="M16.6667 10.3452C16.6667 10.8924 16.0439 11.2066 15.6038 10.8814L11.0766 7.5364C10.7159 7.26993 10.7159 6.73054 11.0766 6.46405L15.6038 3.11873C16.0439 2.79356 16.6667 3.10773 16.6667 3.6549V5.22682C16.6667 5.29746 16.7223 5.35579 16.7927 5.36066C22.6821 5.76757 27.3333 10.674 27.3333 16.6667C27.3333 22.9259 22.2592 28 16 28C9.96483 28 5.03145 23.2827 4.68601 17.3341C4.66466 16.9665 4.96518 16.6673 5.33339 16.6673H7.3334C7.70157 16.6673 7.99714 16.9668 8.02743 17.3337C8.36638 21.4399 11.8064 24.6667 16 24.6667C20.4183 24.6667 24 21.085 24 16.6667C24 12.5225 20.8483 9.11428 16.8113 8.70739C16.7337 8.69957 16.6667 8.76096 16.6667 8.83893V10.3452Z" fill="currentColor"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0879 19.679C17.4553 19.9195 17.8928 20.0398 18.4004 20.0398C18.9099 20.0398 19.3474 19.9205 19.7129 19.6818C20.0803 19.4413 20.3635 19.0938 20.5623 18.6392C20.7612 18.1847 20.8606 17.6373 20.8606 16.9972C20.8625 16.3608 20.764 15.8192 20.5652 15.3722C20.3663 14.9252 20.0822 14.5853 19.7129 14.3523C19.3455 14.1175 18.908 14 18.4004 14C17.8928 14 17.4553 14.1175 17.0879 14.3523C16.7224 14.5853 16.4402 14.9252 16.2413 15.3722C16.0443 15.8173 15.9449 16.3589 15.943 16.9972C15.9411 17.6354 16.0396 18.1818 16.2385 18.6364C16.4373 19.089 16.7205 19.4366 17.0879 19.679ZM19.1362 18.4262C18.9487 18.7349 18.7034 18.8892 18.4004 18.8892C18.1996 18.8892 18.0226 18.8211 17.8691 18.6847C17.7157 18.5464 17.5964 18.3372 17.5112 18.0568C17.4279 17.7765 17.3871 17.4233 17.389 16.9972C17.3909 16.3684 17.4847 15.9025 17.6703 15.5995C17.8559 15.2945 18.0993 15.1421 18.4004 15.1421C18.603 15.1421 18.7801 15.2093 18.9316 15.3438C19.0832 15.4782 19.2015 15.6828 19.2868 15.9574C19.372 16.2301 19.4146 16.5767 19.4146 16.9972C19.4165 17.6392 19.3237 18.1156 19.1362 18.4262Z" fill="currentColor"/> <path d="M13.7746 19.8978C13.8482 19.8978 13.9079 19.8381 13.9079 19.7644V14.2129C13.9079 14.1393 13.8482 14.0796 13.7746 14.0796H12.642C12.6171 14.0796 12.5927 14.0865 12.5716 14.0997L11.2322 14.9325C11.1931 14.9568 11.1693 14.9996 11.1693 15.0457V15.9497C11.1693 16.0539 11.2833 16.1178 11.3722 16.0635L12.464 15.396C12.4682 15.3934 12.473 15.3921 12.4779 15.3921C12.4926 15.3921 12.5045 15.404 12.5045 15.4187V19.7644C12.5045 19.8381 12.5642 19.8978 12.6378 19.8978H13.7746Z" fill="currentColor"/>`;
var Icon$81 = `<path d="M15.3333 10.3452C15.3333 10.8924 15.9561 11.2066 16.3962 10.8814L20.9234 7.5364C21.2841 7.26993 21.2841 6.73054 20.9235 6.46405L16.3962 3.11873C15.9561 2.79356 15.3333 3.10773 15.3333 3.6549V5.22682C15.3333 5.29746 15.2778 5.35579 15.2073 5.36066C9.31791 5.76757 4.66667 10.674 4.66667 16.6667C4.66667 22.9259 9.74078 28 16 28C22.0352 28 26.9686 23.2827 27.314 17.3341C27.3354 16.9665 27.0348 16.6673 26.6666 16.6673H24.6666C24.2984 16.6673 24.0029 16.9668 23.9726 17.3337C23.6336 21.4399 20.1937 24.6667 16 24.6667C11.5817 24.6667 8 21.085 8 16.6667C8 12.5225 11.1517 9.11428 15.1887 8.70739C15.2663 8.69957 15.3333 8.76096 15.3333 8.83893V10.3452Z" fill="currentColor"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0879 19.679C17.4553 19.9195 17.8928 20.0398 18.4004 20.0398C18.9099 20.0398 19.3474 19.9205 19.7129 19.6818C20.0803 19.4413 20.3635 19.0938 20.5623 18.6392C20.7612 18.1847 20.8606 17.6373 20.8606 16.9972C20.8625 16.3608 20.764 15.8192 20.5652 15.3722C20.3663 14.9252 20.0822 14.5853 19.7129 14.3523C19.3455 14.1175 18.908 14 18.4004 14C17.8928 14 17.4553 14.1175 17.0879 14.3523C16.7224 14.5853 16.4402 14.9252 16.2413 15.3722C16.0443 15.8173 15.9449 16.3589 15.943 16.9972C15.9411 17.6354 16.0396 18.1818 16.2385 18.6364C16.4373 19.089 16.7205 19.4366 17.0879 19.679ZM19.1362 18.4262C18.9487 18.7349 18.7034 18.8892 18.4004 18.8892C18.1996 18.8892 18.0225 18.8211 17.8691 18.6847C17.7157 18.5464 17.5964 18.3372 17.5112 18.0568C17.4278 17.7765 17.3871 17.4233 17.389 16.9972C17.3909 16.3684 17.4847 15.9025 17.6703 15.5995C17.8559 15.2945 18.0992 15.1421 18.4004 15.1421C18.603 15.1421 18.7801 15.2093 18.9316 15.3438C19.0831 15.4782 19.2015 15.6828 19.2867 15.9574C19.372 16.2301 19.4146 16.5767 19.4146 16.9972C19.4165 17.6392 19.3237 18.1156 19.1362 18.4262Z" fill="currentColor"/> <path d="M13.7746 19.8978C13.8482 19.8978 13.9079 19.8381 13.9079 19.7644V14.2129C13.9079 14.1393 13.8482 14.0796 13.7746 14.0796H12.642C12.6171 14.0796 12.5927 14.0865 12.5716 14.0997L11.2322 14.9325C11.1931 14.9568 11.1693 14.9996 11.1693 15.0457V15.9497C11.1693 16.0539 11.2833 16.1178 11.3722 16.0635L12.464 15.396C12.4682 15.3934 12.473 15.3921 12.4779 15.3921C12.4926 15.3921 12.5045 15.404 12.5045 15.4187V19.7644C12.5045 19.8381 12.5642 19.8978 12.6378 19.8978H13.7746Z" fill="currentColor"/>`;
var Icon$88 = `<path fill-rule="evenodd" clip-rule="evenodd" d="M13.5722 5.33333C13.2429 5.33333 12.9629 5.57382 12.9132 5.89938L12.4063 9.21916C12.4 9.26058 12.3746 9.29655 12.3378 9.31672C12.2387 9.37118 12.1409 9.42779 12.0444 9.48648C12.0086 9.5083 11.9646 9.51242 11.9255 9.49718L8.79572 8.27692C8.48896 8.15732 8.14083 8.27958 7.9762 8.56472L5.5491 12.7686C5.38444 13.0538 5.45271 13.4165 5.70981 13.6223L8.33308 15.7225C8.3658 15.7487 8.38422 15.7887 8.38331 15.8306C8.38209 15.8867 8.38148 15.9429 8.38148 15.9993C8.38148 16.0558 8.3821 16.1121 8.38332 16.1684C8.38423 16.2102 8.36582 16.2503 8.33313 16.2765L5.7103 18.3778C5.45334 18.5836 5.38515 18.9462 5.54978 19.2314L7.97688 23.4352C8.14155 23.7205 8.48981 23.8427 8.79661 23.723L11.926 22.5016C11.9651 22.4864 12.009 22.4905 12.0449 22.5123C12.1412 22.5709 12.2388 22.6274 12.3378 22.6818C12.3745 22.7019 12.4 22.7379 12.4063 22.7793L12.9132 26.0993C12.9629 26.4249 13.2429 26.6654 13.5722 26.6654H18.4264C18.7556 26.6654 19.0356 26.425 19.0854 26.0995L19.5933 22.7801C19.5997 22.7386 19.6252 22.7027 19.6619 22.6825C19.7614 22.6279 19.8596 22.5711 19.9564 22.5121C19.9923 22.4903 20.0362 22.4862 20.0754 22.5015L23.2035 23.7223C23.5103 23.842 23.8585 23.7198 24.0232 23.4346L26.4503 19.2307C26.6149 18.9456 26.5467 18.583 26.2898 18.3771L23.6679 16.2766C23.6352 16.2504 23.6168 16.2104 23.6177 16.1685C23.619 16.1122 23.6196 16.0558 23.6196 15.9993C23.6196 15.9429 23.619 15.8866 23.6177 15.8305C23.6168 15.7886 23.6353 15.7486 23.668 15.7224L26.2903 13.623C26.5474 13.4172 26.6156 13.0544 26.451 12.7692L24.0239 8.56537C23.8592 8.28023 23.5111 8.15797 23.2043 8.27757L20.0758 9.49734C20.0367 9.51258 19.9927 9.50846 19.9569 9.48664C19.8599 9.42762 19.7616 9.37071 19.6618 9.31596C19.6251 9.2958 19.5997 9.25984 19.5933 9.21843L19.0854 5.89915C19.0356 5.57369 18.7556 5.33333 18.4264 5.33333H13.5722ZM16.0001 20.2854C18.3672 20.2854 20.2862 18.3664 20.2862 15.9993C20.2862 13.6322 18.3672 11.7132 16.0001 11.7132C13.6329 11.7132 11.714 13.6322 11.714 15.9993C11.714 18.3664 13.6329 20.2854 16.0001 20.2854Z" fill="currentColor"/>`;
var Icon$104 = `<path d="M17.5091 24.6595C17.5091 25.2066 16.8864 25.5208 16.4463 25.1956L9.44847 20.0252C9.42553 20.0083 9.39776 19.9992 9.36923 19.9992H4.66667C4.29848 19.9992 4 19.7007 4 19.3325V12.6658C4 12.2976 4.29848 11.9992 4.66667 11.9992H9.37115C9.39967 11.9992 9.42745 11.99 9.45039 11.9731L16.4463 6.80363C16.8863 6.47845 17.5091 6.79262 17.5091 7.3398L17.5091 24.6595Z" fill="currentColor"/> <path d="M27.5091 9.33336C27.8773 9.33336 28.1758 9.63184 28.1758 10V22C28.1758 22.3682 27.8773 22.6667 27.5091 22.6667H26.1758C25.8076 22.6667 25.5091 22.3682 25.5091 22V10C25.5091 9.63184 25.8076 9.33336 26.1758 9.33336L27.5091 9.33336Z" fill="currentColor"/> <path d="M22.1758 12C22.544 12 22.8424 12.2985 22.8424 12.6667V19.3334C22.8424 19.7016 22.544 20 22.1758 20H20.8424C20.4743 20 20.1758 19.7016 20.1758 19.3334V12.6667C20.1758 12.2985 20.4743 12 20.8424 12H22.1758Z" fill="currentColor"/>`;
var Icon$105 = `<path d="M17.5091 24.6594C17.5091 25.2066 16.8864 25.5207 16.4463 25.1956L9.44847 20.0252C9.42553 20.0083 9.39776 19.9991 9.36923 19.9991H4.66667C4.29848 19.9991 4 19.7006 4 19.3324V12.6658C4 12.2976 4.29848 11.9991 4.66667 11.9991H9.37115C9.39967 11.9991 9.42745 11.99 9.45039 11.973L16.4463 6.80358C16.8863 6.4784 17.5091 6.79258 17.5091 7.33975L17.5091 24.6594Z" fill="currentColor"/> <path d="M22.8424 12.6667C22.8424 12.2985 22.544 12 22.1758 12H20.8424C20.4743 12 20.1758 12.2985 20.1758 12.6667V19.3333C20.1758 19.7015 20.4743 20 20.8424 20H22.1758C22.544 20 22.8424 19.7015 22.8424 19.3333V12.6667Z" fill="currentColor"/>`;

});
parcelRegister("57dmi", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3b97f7f3112bb636$export$71511d61b312f219; });

var $f6lS4 = parcelRequire("f6lS4");

var $3Z9LC = parcelRequire("3Z9LC");
function $3b97f7f3112bb636$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $3Z9LC._)(receiver, privateMap, "get");
    return (0, $f6lS4._)(receiver, descriptor);
}

});
parcelRegister("f6lS4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $afe861b3a062123d$export$71511d61b312f219; });
function $afe861b3a062123d$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}

});

parcelRegister("3Z9LC", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2e6ea51c060eeb24$export$71511d61b312f219; });
function $2e6ea51c060eeb24$export$71511d61b312f219(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}

});


parcelRegister("fhH8k", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b209e6eea9204612$export$71511d61b312f219; });

var $5x0Jz = parcelRequire("5x0Jz");
function $b209e6eea9204612$export$71511d61b312f219(obj, privateMap, value) {
    (0, $5x0Jz._)(obj, privateMap);
    privateMap.set(obj, value);
}

});
parcelRegister("5x0Jz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $40709a9855c854d8$export$71511d61b312f219; });
function $40709a9855c854d8$export$71511d61b312f219(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}

});


parcelRegister("4vwVC", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $34839991d0fc8409$export$71511d61b312f219; });

var $bV4No = parcelRequire("bV4No");

var $3Z9LC = parcelRequire("3Z9LC");
function $34839991d0fc8409$export$71511d61b312f219(receiver, privateMap, value) {
    var descriptor = (0, $3Z9LC._)(receiver, privateMap, "set");
    (0, $bV4No._)(receiver, descriptor, value);
    return value;
}

});
parcelRegister("bV4No", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8ad8bce721c6a61f$export$71511d61b312f219; });
function $8ad8bce721c6a61f$export$71511d61b312f219(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}

});


parcelRegister("2u9SC", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1cf60c113ba878c6$export$71511d61b312f219; });
function $1cf60c113ba878c6$export$71511d61b312f219(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}

});

parcelRegister("9P4tJ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $726c59d30fce19e3$export$71511d61b312f219; });

var $5x0Jz = parcelRequire("5x0Jz");
function $726c59d30fce19e3$export$71511d61b312f219(obj, privateSet) {
    (0, $5x0Jz._)(obj, privateSet);
    privateSet.add(obj);
}

});

parcelRegister("97zcJ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6a40135bc8ae48ef$export$71511d61b312f219; });
function $6a40135bc8ae48ef$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("6KfMo", function(module, exports) {

$parcel$export(module.exports, "mediaContext", function () { return $4e93476ed0b4c55c$export$68678f806ed4f45e; });
$parcel$export(module.exports, "useMediaContext", function () { return $4e93476ed0b4c55c$export$2d636d13f24b27df; });
$parcel$export(module.exports, "useMediaState", function () { return $4e93476ed0b4c55c$export$f7bd70748244625e; });

var $8B3mG = parcelRequire("8B3mG");
const $4e93476ed0b4c55c$export$68678f806ed4f45e = (0, $8B3mG.createContext)();
function $4e93476ed0b4c55c$export$2d636d13f24b27df() {
    return (0, $8B3mG.useContext)($4e93476ed0b4c55c$export$68678f806ed4f45e);
}
function $4e93476ed0b4c55c$export$f7bd70748244625e() {
    return $4e93476ed0b4c55c$export$2d636d13f24b27df().$state;
}

});

parcelRegister("8kkZn", function(module, exports) {

$parcel$export(module.exports, "IS_IOS", function () { return $610078f4d89267f3$export$9135b5fce2a2854d; });
$parcel$export(module.exports, "IS_IPHONE", function () { return $610078f4d89267f3$export$70fe86f90dd668ff; });
$parcel$export(module.exports, "IS_CHROME", function () { return $610078f4d89267f3$export$265e05392e08df49; });
$parcel$export(module.exports, "IS_SAFARI", function () { return $610078f4d89267f3$export$af54264dae9065e6; });
$parcel$export(module.exports, "canOrientScreen", function () { return $610078f4d89267f3$export$bc94c66487cfb7eb; });
$parcel$export(module.exports, "canPlayAudioType", function () { return $610078f4d89267f3$export$6493e1bb2c5e48a9; });
$parcel$export(module.exports, "canPlayVideoType", function () { return $610078f4d89267f3$export$7d6dc70798a573c8; });
$parcel$export(module.exports, "canPlayHLSNatively", function () { return $610078f4d89267f3$export$bab8b045b59573c5; });
$parcel$export(module.exports, "canUsePictureInPicture", function () { return $610078f4d89267f3$export$2fda5ec2157b0df2; });
$parcel$export(module.exports, "canUseVideoPresentation", function () { return $610078f4d89267f3$export$bcc3daaed7f2f9c7; });
$parcel$export(module.exports, "canChangeVolume", function () { return $610078f4d89267f3$export$aed1065f8008fb82; });
$parcel$export(module.exports, "isHLSSupported", function () { return $610078f4d89267f3$export$aa9a42d7273bb011; });
$parcel$export(module.exports, "isDASHSupported", function () { return $610078f4d89267f3$export$266d9a48d415712f; });
$parcel$export(module.exports, "isAudioSrc", function () { return $610078f4d89267f3$export$d5fd12d5c7d61ad6; });
$parcel$export(module.exports, "isVideoSrc", function () { return $610078f4d89267f3$export$1e37a46f5c693b02; });
$parcel$export(module.exports, "isHLSSrc", function () { return $610078f4d89267f3$export$c52ef9b4d47b437c; });
$parcel$export(module.exports, "isDASHSrc", function () { return $610078f4d89267f3$export$9a6af7702b4930f2; });
$parcel$export(module.exports, "canGoogleCastSrc", function () { return $610078f4d89267f3$export$e80401721ae63441; });
$parcel$export(module.exports, "isMediaStream", function () { return $610078f4d89267f3$export$65b9d31b380607e2; });

var $8B3mG = parcelRequire("8B3mG");
const $610078f4d89267f3$var$UA = navigator?.userAgent.toLowerCase() || "";
const $610078f4d89267f3$export$9135b5fce2a2854d = /iphone|ipad|ipod|ios|crios|fxios/i.test($610078f4d89267f3$var$UA);
const $610078f4d89267f3$export$70fe86f90dd668ff = /(iphone|ipod)/gi.test(navigator?.platform || "");
const $610078f4d89267f3$export$265e05392e08df49 = !!window.chrome;
const $610078f4d89267f3$export$af54264dae9065e6 = !!window.safari || $610078f4d89267f3$export$9135b5fce2a2854d;
function $610078f4d89267f3$export$bc94c66487cfb7eb() {
    return $610078f4d89267f3$export$875962dde729bb55() && (0, $8B3mG.isFunction)(screen.orientation.unlock);
}
function $610078f4d89267f3$export$875962dde729bb55() {
    return !(0, $8B3mG.isUndefined)(window.screen.orientation) && !(0, $8B3mG.isUndefined)(window.screen.orientation.lock);
}
function $610078f4d89267f3$export$6493e1bb2c5e48a9(audio, type) {
    if (!audio) audio = document.createElement("audio");
    return audio.canPlayType(type).length > 0;
}
function $610078f4d89267f3$export$7d6dc70798a573c8(video, type) {
    if (!video) video = document.createElement("video");
    return video.canPlayType(type).length > 0;
}
function $610078f4d89267f3$export$bab8b045b59573c5(video) {
    if (!video) video = document.createElement("video");
    return video.canPlayType("application/vnd.apple.mpegurl").length > 0;
}
function $610078f4d89267f3$export$2fda5ec2157b0df2(video) {
    return !!document.pictureInPictureEnabled && !video?.disablePictureInPicture;
}
function $610078f4d89267f3$export$bcc3daaed7f2f9c7(video) {
    return (0, $8B3mG.isFunction)(video?.webkitSupportsPresentationMode) && (0, $8B3mG.isFunction)(video?.webkitSetPresentationMode);
}
async function $610078f4d89267f3$export$aed1065f8008fb82() {
    const video = document.createElement("video");
    video.volume = 0.5;
    await (0, $8B3mG.waitTimeout)(0);
    return video.volume === 0.5;
}
function $610078f4d89267f3$var$getMediaSource() {
    return window?.ManagedMediaSource ?? window?.MediaSource ?? window?.WebKitMediaSource;
}
function $610078f4d89267f3$var$getSourceBuffer() {
    return window?.SourceBuffer ?? window?.WebKitSourceBuffer;
}
function $610078f4d89267f3$export$aa9a42d7273bb011() {
    const MediaSource = $610078f4d89267f3$var$getMediaSource();
    if ((0, $8B3mG.isUndefined)(MediaSource)) return false;
    const isTypeSupported = MediaSource && (0, $8B3mG.isFunction)(MediaSource.isTypeSupported) && MediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');
    const SourceBuffer = $610078f4d89267f3$var$getSourceBuffer();
    const isSourceBufferValid = (0, $8B3mG.isUndefined)(SourceBuffer) || !(0, $8B3mG.isUndefined)(SourceBuffer.prototype) && (0, $8B3mG.isFunction)(SourceBuffer.prototype.appendBuffer) && (0, $8B3mG.isFunction)(SourceBuffer.prototype.remove);
    return !!isTypeSupported && !!isSourceBufferValid;
}
function $610078f4d89267f3$export$266d9a48d415712f() {
    return $610078f4d89267f3$export$aa9a42d7273bb011();
}
const $610078f4d89267f3$export$6e358387921d60a6 = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx|flac)($|\?)/i;
const $610078f4d89267f3$export$a6fa74468fd4c16a = /* @__PURE__ */ new Set([
    "audio/mpeg",
    "audio/ogg",
    "audio/3gp",
    "audio/mp3",
    "audio/webm",
    "audio/flac",
    "audio/m4a",
    "audio/m4b",
    "audio/mp4a"
]);
const $610078f4d89267f3$export$2c10378b315a7748 = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i;
const $610078f4d89267f3$export$e2efa1215faa66b1 = /* @__PURE__ */ new Set([
    "video/mp4",
    "video/webm",
    "video/3gp",
    "video/ogg",
    "video/avi",
    "video/mpeg"
]);
const $610078f4d89267f3$export$8ded90fecf3013d3 = /\.(m3u8)($|\?)/i;
const $610078f4d89267f3$export$fad20c5f0cd5b39 = /\.(mpd)($|\?)/i;
const $610078f4d89267f3$export$a0caf98d8fd369bf = /* @__PURE__ */ new Set([
    // Apple sanctioned
    "application/vnd.apple.mpegurl",
    // Apple sanctioned for backwards compatibility
    "audio/mpegurl",
    // Very common
    "audio/x-mpegurl",
    // Very common
    "application/x-mpegurl",
    // Included for completeness
    "video/x-mpegurl",
    "video/mpegurl",
    "application/mpegurl"
]);
const $610078f4d89267f3$export$22c95f05b9c0fd2b = /* @__PURE__ */ new Set([
    "application/dash+xml"
]);
function $610078f4d89267f3$export$d5fd12d5c7d61ad6({ src: src, type: type }) {
    return (0, $8B3mG.isString)(src) ? $610078f4d89267f3$export$6e358387921d60a6.test(src) || $610078f4d89267f3$export$a6fa74468fd4c16a.has(type) || src.startsWith("blob:") && type === "audio/object" : type === "audio/object";
}
function $610078f4d89267f3$export$1e37a46f5c693b02(src) {
    return (0, $8B3mG.isString)(src.src) ? $610078f4d89267f3$export$2c10378b315a7748.test(src.src) || $610078f4d89267f3$export$e2efa1215faa66b1.has(src.type) || src.src.startsWith("blob:") && src.type === "video/object" || $610078f4d89267f3$export$c52ef9b4d47b437c(src) && $610078f4d89267f3$export$bab8b045b59573c5() : src.type === "video/object";
}
function $610078f4d89267f3$export$c52ef9b4d47b437c({ src: src, type: type }) {
    return (0, $8B3mG.isString)(src) && $610078f4d89267f3$export$8ded90fecf3013d3.test(src) || $610078f4d89267f3$export$a0caf98d8fd369bf.has(type);
}
function $610078f4d89267f3$export$9a6af7702b4930f2({ src: src, type: type }) {
    return (0, $8B3mG.isString)(src) && $610078f4d89267f3$export$fad20c5f0cd5b39.test(src) || $610078f4d89267f3$export$22c95f05b9c0fd2b.has(type);
}
function $610078f4d89267f3$export$e80401721ae63441(src) {
    return (0, $8B3mG.isString)(src.src) && ($610078f4d89267f3$export$d5fd12d5c7d61ad6(src) || $610078f4d89267f3$export$1e37a46f5c693b02(src) || $610078f4d89267f3$export$c52ef9b4d47b437c(src));
}
function $610078f4d89267f3$export$65b9d31b380607e2(src) {
    return typeof window.MediaStream !== "undefined" && src instanceof window.MediaStream;
}

});

parcelRegister("6ELNS", function(module, exports) {

$parcel$export(module.exports, "TimeRange", function () { return $4d8b8f4bc71464b3$export$74e1c7e2f1829413; });
$parcel$export(module.exports, "getTimeRangesStart", function () { return $4d8b8f4bc71464b3$export$27f007db8589a520; });
$parcel$export(module.exports, "getTimeRangesEnd", function () { return $4d8b8f4bc71464b3$export$6137fddc810714c0; });
$parcel$export(module.exports, "updateTimeIntervals", function () { return $4d8b8f4bc71464b3$export$6200ffd8e4e49744; });

var $57dmi = parcelRequire("57dmi");

var $fhH8k = parcelRequire("fhH8k");

var $4vwVC = parcelRequire("4vwVC");

var $8B3mG = parcelRequire("8B3mG");
var $4d8b8f4bc71464b3$var$_ranges = /*#__PURE__*/ new WeakMap();
class $4d8b8f4bc71464b3$export$74e1c7e2f1829413 {
    get length() {
        return (0, $57dmi._)(this, $4d8b8f4bc71464b3$var$_ranges).length;
    }
    start(index) {
        return (0, $57dmi._)(this, $4d8b8f4bc71464b3$var$_ranges)[index][0] ?? Infinity;
    }
    end(index) {
        return (0, $57dmi._)(this, $4d8b8f4bc71464b3$var$_ranges)[index][1] ?? Infinity;
    }
    constructor(start, end){
        (0, $fhH8k._)(this, $4d8b8f4bc71464b3$var$_ranges, {
            writable: true,
            value: void 0
        });
        if ((0, $8B3mG.isArray)(start)) (0, $4vwVC._)(this, $4d8b8f4bc71464b3$var$_ranges, start);
        else if (!(0, $8B3mG.isUndefined)(start) && !(0, $8B3mG.isUndefined)(end)) (0, $4vwVC._)(this, $4d8b8f4bc71464b3$var$_ranges, [
            [
                start,
                end
            ]
        ]);
        else (0, $4vwVC._)(this, $4d8b8f4bc71464b3$var$_ranges, []);
    }
}
function $4d8b8f4bc71464b3$export$27f007db8589a520(range) {
    if (!range.length) return null;
    let min = range.start(0);
    for(let i = 1; i < range.length; i++){
        const value = range.start(i);
        if (value < min) min = value;
    }
    return min;
}
function $4d8b8f4bc71464b3$export$6137fddc810714c0(range) {
    if (!range.length) return null;
    let max = range.end(0);
    for(let i = 1; i < range.length; i++){
        const value = range.end(i);
        if (value > max) max = value;
    }
    return max;
}
function $4d8b8f4bc71464b3$export$e4232aae89611010(intervals) {
    if (intervals.length <= 1) return intervals;
    intervals.sort((a, b)=>a[0] - b[0]);
    let normalized = [], current = intervals[0];
    for(let i = 1; i < intervals.length; i++){
        const next = intervals[i];
        if (current[1] >= next[0] - 1) current = [
            current[0],
            Math.max(current[1], next[1])
        ];
        else {
            normalized.push(current);
            current = next;
        }
    }
    normalized.push(current);
    return normalized;
}
function $4d8b8f4bc71464b3$export$6200ffd8e4e49744(intervals, interval, value) {
    let start = interval[0], end = interval[1];
    if (value < start) return [
        value,
        -1
    ];
    else if (value === start) return interval;
    else if (start === -1) {
        interval[0] = value;
        return interval;
    } else if (value > start) {
        interval[1] = value;
        if (end === -1) intervals.push(interval);
    }
    $4d8b8f4bc71464b3$export$e4232aae89611010(intervals);
    return interval;
}

});

parcelRegister("ihjXw", function(module, exports) {

$parcel$export(module.exports, "TextTrackSymbol", function () { return $d4e94bfb933a8508$export$6aa2179173ac85c; });
$parcel$export(module.exports, "TextTrack", function () { return $d4e94bfb933a8508$export$e3721fda89ae9763; });
$parcel$export(module.exports, "isTrackCaptionKind", function () { return $d4e94bfb933a8508$export$373044e11fc7ec7f; });

var $57dmi = parcelRequire("57dmi");

var $fhH8k = parcelRequire("fhH8k");

var $4vwVC = parcelRequire("4vwVC");

var $2u9SC = parcelRequire("2u9SC");

var $9P4tJ = parcelRequire("9P4tJ");

var $97zcJ = parcelRequire("97zcJ");

var $8B3mG = parcelRequire("8B3mG");

var $dLb9W = parcelRequire("dLb9W");

var $l6thX = parcelRequire("l6thX");
const $d4e94bfb933a8508$var$CROSS_ORIGIN = Symbol(0), $d4e94bfb933a8508$var$READY_STATE = Symbol(0), $d4e94bfb933a8508$var$UPDATE_ACTIVE_CUES = Symbol(0), $d4e94bfb933a8508$var$CAN_LOAD = Symbol(0), $d4e94bfb933a8508$var$ON_MODE_CHANGE = Symbol(0), $d4e94bfb933a8508$var$NATIVE = Symbol(0), $d4e94bfb933a8508$var$NATIVE_HLS = Symbol(0);
const $d4e94bfb933a8508$export$6aa2179173ac85c = {
    crossOrigin: $d4e94bfb933a8508$var$CROSS_ORIGIN,
    readyState: $d4e94bfb933a8508$var$READY_STATE,
    updateActiveCues: $d4e94bfb933a8508$var$UPDATE_ACTIVE_CUES,
    canLoad: $d4e94bfb933a8508$var$CAN_LOAD,
    onModeChange: $d4e94bfb933a8508$var$ON_MODE_CHANGE,
    native: $d4e94bfb933a8508$var$NATIVE,
    nativeHLS: $d4e94bfb933a8508$var$NATIVE_HLS
};
var $d4e94bfb933a8508$var$_canLoad = /*#__PURE__*/ new WeakMap(), $d4e94bfb933a8508$var$_currentTime = /*#__PURE__*/ new WeakMap(), $d4e94bfb933a8508$var$_mode = /*#__PURE__*/ new WeakMap(), $d4e94bfb933a8508$var$_metadata = /*#__PURE__*/ new WeakMap(), $d4e94bfb933a8508$var$_regions = /*#__PURE__*/ new WeakMap(), $d4e94bfb933a8508$var$_cues = /*#__PURE__*/ new WeakMap(), $d4e94bfb933a8508$var$_activeCues = /*#__PURE__*/ new WeakMap(), $d4e94bfb933a8508$var$_parseContent = /*#__PURE__*/ new WeakSet(), $d4e94bfb933a8508$var$_load = /*#__PURE__*/ new WeakSet(), $d4e94bfb933a8508$var$_ready = /*#__PURE__*/ new WeakSet(), $d4e94bfb933a8508$var$_error = /*#__PURE__*/ new WeakSet(), $d4e94bfb933a8508$var$_parseJSON = /*#__PURE__*/ new WeakSet(), $d4e94bfb933a8508$var$_activeCuesChanged = /*#__PURE__*/ new WeakSet();
let $d4e94bfb933a8508$var$_TextTrackSymbol_readyState = $d4e94bfb933a8508$export$6aa2179173ac85c.readyState, $d4e94bfb933a8508$var$_TextTrackSymbol_crossOrigin = $d4e94bfb933a8508$export$6aa2179173ac85c.crossOrigin, $d4e94bfb933a8508$var$_TextTrackSymbol_onModeChange = $d4e94bfb933a8508$export$6aa2179173ac85c.onModeChange, $d4e94bfb933a8508$var$_TextTrackSymbol_native = $d4e94bfb933a8508$export$6aa2179173ac85c.native, $d4e94bfb933a8508$var$_TextTrackSymbol_updateActiveCues = $d4e94bfb933a8508$export$6aa2179173ac85c.updateActiveCues, $d4e94bfb933a8508$var$_TextTrackSymbol_canLoad = $d4e94bfb933a8508$export$6aa2179173ac85c.canLoad;
class $d4e94bfb933a8508$export$e3721fda89ae9763 extends (0, $8B3mG.EventsTarget) {
    static createId(track) {
        return `vds-${track.type}-${track.kind}-${track.src ?? track.label ?? "?"}`;
    }
    get metadata() {
        return (0, $57dmi._)(this, $d4e94bfb933a8508$var$_metadata);
    }
    get regions() {
        return (0, $57dmi._)(this, $d4e94bfb933a8508$var$_regions);
    }
    get cues() {
        return (0, $57dmi._)(this, $d4e94bfb933a8508$var$_cues);
    }
    get activeCues() {
        return (0, $57dmi._)(this, $d4e94bfb933a8508$var$_activeCues);
    }
    /**
   * - 0: Not Loading
   * - 1: Loading
   * - 2: Ready
   * - 3: Error
   */ get readyState() {
        return this[$d4e94bfb933a8508$export$6aa2179173ac85c.readyState];
    }
    get mode() {
        return (0, $57dmi._)(this, $d4e94bfb933a8508$var$_mode);
    }
    set mode(mode) {
        this.setMode(mode);
    }
    addCue(cue, trigger) {
        let i = 0, length = (0, $57dmi._)(this, $d4e94bfb933a8508$var$_cues).length;
        for(i = 0; i < length; i++)if (cue.endTime <= (0, $57dmi._)(this, $d4e94bfb933a8508$var$_cues)[i].startTime) break;
        if (i === length) (0, $57dmi._)(this, $d4e94bfb933a8508$var$_cues).push(cue);
        else (0, $57dmi._)(this, $d4e94bfb933a8508$var$_cues).splice(i, 0, cue);
        if (!(cue instanceof TextTrackCue)) this[$d4e94bfb933a8508$export$6aa2179173ac85c.native]?.track.addCue(cue);
        this.dispatchEvent(new (0, $8B3mG.DOMEvent)("add-cue", {
            detail: cue,
            trigger: trigger
        }));
        if ((0, $l6thX.isCueActive)(cue, (0, $57dmi._)(this, $d4e94bfb933a8508$var$_currentTime))) this[$d4e94bfb933a8508$export$6aa2179173ac85c.updateActiveCues]((0, $57dmi._)(this, $d4e94bfb933a8508$var$_currentTime), trigger);
    }
    removeCue(cue, trigger) {
        const index = (0, $57dmi._)(this, $d4e94bfb933a8508$var$_cues).indexOf(cue);
        if (index >= 0) {
            const isActive = (0, $57dmi._)(this, $d4e94bfb933a8508$var$_activeCues).includes(cue);
            (0, $57dmi._)(this, $d4e94bfb933a8508$var$_cues).splice(index, 1);
            this[$d4e94bfb933a8508$export$6aa2179173ac85c.native]?.track.removeCue(cue);
            this.dispatchEvent(new (0, $8B3mG.DOMEvent)("remove-cue", {
                detail: cue,
                trigger: trigger
            }));
            if (isActive) this[$d4e94bfb933a8508$export$6aa2179173ac85c.updateActiveCues]((0, $57dmi._)(this, $d4e94bfb933a8508$var$_currentTime), trigger);
        }
    }
    setMode(mode, trigger) {
        if ((0, $57dmi._)(this, $d4e94bfb933a8508$var$_mode) === mode) return;
        (0, $4vwVC._)(this, $d4e94bfb933a8508$var$_mode, mode);
        if (mode === "disabled") {
            (0, $4vwVC._)(this, $d4e94bfb933a8508$var$_activeCues, []);
            (0, $2u9SC._)(this, $d4e94bfb933a8508$var$_activeCuesChanged, $d4e94bfb933a8508$var$activeCuesChanged).call(this);
        } else if (this.readyState === 2) this[$d4e94bfb933a8508$export$6aa2179173ac85c.updateActiveCues]((0, $57dmi._)(this, $d4e94bfb933a8508$var$_currentTime), trigger);
        else (0, $2u9SC._)(this, $d4e94bfb933a8508$var$_load, $d4e94bfb933a8508$var$load).call(this);
        this.dispatchEvent(new (0, $8B3mG.DOMEvent)("mode-change", {
            detail: this,
            trigger: trigger
        }));
        this[$d4e94bfb933a8508$export$6aa2179173ac85c.onModeChange]?.();
    }
    /** @internal */ [$d4e94bfb933a8508$var$_TextTrackSymbol_updateActiveCues](currentTime, trigger) {
        (0, $4vwVC._)(this, $d4e94bfb933a8508$var$_currentTime, currentTime);
        if (this.mode === "disabled" || !(0, $57dmi._)(this, $d4e94bfb933a8508$var$_cues).length) return;
        const activeCues = [];
        for(let i = 0, length = (0, $57dmi._)(this, $d4e94bfb933a8508$var$_cues).length; i < length; i++){
            const cue = (0, $57dmi._)(this, $d4e94bfb933a8508$var$_cues)[i];
            if ((0, $l6thX.isCueActive)(cue, currentTime)) activeCues.push(cue);
        }
        let changed = activeCues.length !== (0, $57dmi._)(this, $d4e94bfb933a8508$var$_activeCues).length;
        if (!changed) {
            for(let i = 0; i < activeCues.length; i++)if (!(0, $57dmi._)(this, $d4e94bfb933a8508$var$_activeCues).includes(activeCues[i])) {
                changed = true;
                break;
            }
        }
        (0, $4vwVC._)(this, $d4e94bfb933a8508$var$_activeCues, activeCues);
        if (changed) (0, $2u9SC._)(this, $d4e94bfb933a8508$var$_activeCuesChanged, $d4e94bfb933a8508$var$activeCuesChanged).call(this, trigger);
    }
    /** @internal */ [$d4e94bfb933a8508$var$_TextTrackSymbol_canLoad]() {
        (0, $4vwVC._)(this, $d4e94bfb933a8508$var$_canLoad, true);
        if ((0, $57dmi._)(this, $d4e94bfb933a8508$var$_mode) !== "disabled") (0, $2u9SC._)(this, $d4e94bfb933a8508$var$_load, $d4e94bfb933a8508$var$load).call(this);
    }
    constructor(init){
        super();
        (0, $9P4tJ._)(this, $d4e94bfb933a8508$var$_parseContent);
        (0, $9P4tJ._)(this, $d4e94bfb933a8508$var$_load);
        (0, $9P4tJ._)(this, $d4e94bfb933a8508$var$_ready);
        (0, $9P4tJ._)(this, $d4e94bfb933a8508$var$_error);
        (0, $9P4tJ._)(this, $d4e94bfb933a8508$var$_parseJSON);
        (0, $9P4tJ._)(this, $d4e94bfb933a8508$var$_activeCuesChanged);
        (0, $97zcJ._)(this, "src", void 0);
        (0, $97zcJ._)(this, "content", void 0);
        (0, $97zcJ._)(this, "type", void 0);
        (0, $97zcJ._)(this, "encoding", void 0);
        (0, $97zcJ._)(this, "id", "");
        (0, $97zcJ._)(this, "label", "");
        (0, $97zcJ._)(this, "language", "");
        (0, $97zcJ._)(this, "kind", void 0);
        (0, $97zcJ._)(this, "default", false);
        (0, $fhH8k._)(this, $d4e94bfb933a8508$var$_canLoad, {
            writable: true,
            value: false
        });
        (0, $fhH8k._)(this, $d4e94bfb933a8508$var$_currentTime, {
            writable: true,
            value: 0
        });
        (0, $fhH8k._)(this, $d4e94bfb933a8508$var$_mode, {
            writable: true,
            value: "disabled"
        });
        (0, $fhH8k._)(this, $d4e94bfb933a8508$var$_metadata, {
            writable: true,
            value: {}
        });
        (0, $fhH8k._)(this, $d4e94bfb933a8508$var$_regions, {
            writable: true,
            value: []
        });
        (0, $fhH8k._)(this, $d4e94bfb933a8508$var$_cues, {
            writable: true,
            value: []
        });
        (0, $fhH8k._)(this, $d4e94bfb933a8508$var$_activeCues, {
            writable: true,
            value: []
        });
        /** @internal */ (0, $97zcJ._)(this, $d4e94bfb933a8508$var$_TextTrackSymbol_readyState, 0);
        /** @internal */ (0, $97zcJ._)(this, $d4e94bfb933a8508$var$_TextTrackSymbol_crossOrigin, void 0);
        /** @internal */ (0, $97zcJ._)(this, $d4e94bfb933a8508$var$_TextTrackSymbol_onModeChange, null);
        /** @internal */ (0, $97zcJ._)(this, $d4e94bfb933a8508$var$_TextTrackSymbol_native, null);
        for (const prop of Object.keys(init))this[prop] = init[prop];
        if (!this.type) this.type = "vtt";
        if (init.content) (0, $2u9SC._)(this, $d4e94bfb933a8508$var$_parseContent, $d4e94bfb933a8508$var$parseContent).call(this, init);
        else if (!init.src) this[$d4e94bfb933a8508$export$6aa2179173ac85c.readyState] = 2;
    }
}

function $d4e94bfb933a8508$var$parseContent(init) {
    (parcelRequire("8fTk5")).then(({ parseText: parseText, VTTCue: VTTCue, VTTRegion: VTTRegion })=>{
        if (!(0, $8B3mG.isString)(init.content) || init.type === "json") {
            (0, $2u9SC._)(this, $d4e94bfb933a8508$var$_parseJSON, $d4e94bfb933a8508$var$parseJSON).call(this, init.content, VTTCue, VTTRegion);
            if (this.readyState !== 3) (0, $2u9SC._)(this, $d4e94bfb933a8508$var$_ready, $d4e94bfb933a8508$var$ready).call(this);
        } else parseText(init.content, {
            type: init.type
        }).then(({ cues: cues, regions: regions })=>{
            (0, $4vwVC._)(this, $d4e94bfb933a8508$var$_cues, cues);
            (0, $4vwVC._)(this, $d4e94bfb933a8508$var$_regions, regions);
            (0, $2u9SC._)(this, $d4e94bfb933a8508$var$_ready, $d4e94bfb933a8508$var$ready).call(this);
        });
    });
}

async function $d4e94bfb933a8508$var$load() {
    if (!(0, $57dmi._)(this, $d4e94bfb933a8508$var$_canLoad) || this[$d4e94bfb933a8508$export$6aa2179173ac85c.readyState] > 0) return;
    this[$d4e94bfb933a8508$export$6aa2179173ac85c.readyState] = 1;
    this.dispatchEvent(new (0, $8B3mG.DOMEvent)("load-start"));
    if (!this.src) {
        (0, $2u9SC._)(this, $d4e94bfb933a8508$var$_ready, $d4e94bfb933a8508$var$ready).call(this);
        return;
    }
    try {
        const { parseResponse: parseResponse, VTTCue: VTTCue, VTTRegion: VTTRegion } = await (parcelRequire("8fTk5")), crossOrigin = this[$d4e94bfb933a8508$export$6aa2179173ac85c.crossOrigin]?.();
        const response = fetch(this.src, {
            headers: this.type === "json" ? {
                "Content-Type": "application/json"
            } : void 0,
            credentials: (0, $dLb9W.getRequestCredentials)(crossOrigin)
        });
        if (this.type === "json") (0, $2u9SC._)(this, $d4e94bfb933a8508$var$_parseJSON, $d4e94bfb933a8508$var$parseJSON).call(this, await (await response).text(), VTTCue, VTTRegion);
        else {
            const { errors: errors, metadata: metadata, regions: regions, cues: cues } = await parseResponse(response, {
                type: this.type,
                encoding: this.encoding
            });
            if (errors[0]?.code === 0) throw errors[0];
            else {
                (0, $4vwVC._)(this, $d4e94bfb933a8508$var$_metadata, metadata);
                (0, $4vwVC._)(this, $d4e94bfb933a8508$var$_regions, regions);
                (0, $4vwVC._)(this, $d4e94bfb933a8508$var$_cues, cues);
            }
        }
        (0, $2u9SC._)(this, $d4e94bfb933a8508$var$_ready, $d4e94bfb933a8508$var$ready).call(this);
    } catch (error1) {
        (0, $2u9SC._)(this, $d4e94bfb933a8508$var$_error, $d4e94bfb933a8508$var$error).call(this, error1);
    }
}
function $d4e94bfb933a8508$var$ready() {
    this[$d4e94bfb933a8508$export$6aa2179173ac85c.readyState] = 2;
    if (!this.src || this.type !== "vtt") {
        const native = this[$d4e94bfb933a8508$export$6aa2179173ac85c.native];
        if (native && !native.managed) for (const cue of (0, $57dmi._)(this, $d4e94bfb933a8508$var$_cues))native.track.addCue(cue);
    }
    const loadEvent = new (0, $8B3mG.DOMEvent)("load");
    this[$d4e94bfb933a8508$export$6aa2179173ac85c.updateActiveCues]((0, $57dmi._)(this, $d4e94bfb933a8508$var$_currentTime), loadEvent);
    this.dispatchEvent(loadEvent);
}
function $d4e94bfb933a8508$var$error(error) {
    this[$d4e94bfb933a8508$export$6aa2179173ac85c.readyState] = 3;
    this.dispatchEvent(new (0, $8B3mG.DOMEvent)("error", {
        detail: error
    }));
}
function $d4e94bfb933a8508$var$parseJSON(json, VTTCue, VTTRegion) {
    try {
        const { regions: regions, cues: cues } = $d4e94bfb933a8508$export$1cadbcc1f8b28e2b(json, VTTCue, VTTRegion);
        (0, $4vwVC._)(this, $d4e94bfb933a8508$var$_regions, regions);
        (0, $4vwVC._)(this, $d4e94bfb933a8508$var$_cues, cues);
    } catch (error1) {
        (0, $2u9SC._)(this, $d4e94bfb933a8508$var$_error, $d4e94bfb933a8508$var$error).call(this, error1);
    }
}
function $d4e94bfb933a8508$var$activeCuesChanged(trigger) {
    this.dispatchEvent(new (0, $8B3mG.DOMEvent)("cue-change", {
        trigger: trigger
    }));
}
const $d4e94bfb933a8508$var$captionRE = /captions|subtitles/;
function $d4e94bfb933a8508$export$373044e11fc7ec7f(track) {
    return $d4e94bfb933a8508$var$captionRE.test(track.kind);
}
function $d4e94bfb933a8508$export$1cadbcc1f8b28e2b(json, Cue, Region) {
    const content = (0, $8B3mG.isString)(json) ? JSON.parse(json) : json;
    let regions = [], cues = [];
    if (content.regions && Region) regions = content.regions.map((region)=>Object.assign(new Region(), region));
    if (content.cues || (0, $8B3mG.isArray)(content)) cues = ((0, $8B3mG.isArray)(content) ? content : content.cues).filter((content2)=>(0, $8B3mG.isNumber)(content2.startTime) && (0, $8B3mG.isNumber)(content2.endTime)).map((cue)=>Object.assign(new Cue(0, 0, ""), cue));
    return {
        regions: regions,
        cues: cues
    };
}

});
parcelRegister("dLb9W", function(module, exports) {

$parcel$export(module.exports, "appendParamsToURL", function () { return $a048522d6d94a02e$export$e37eab07b9334e17; });
$parcel$export(module.exports, "preconnect", function () { return $a048522d6d94a02e$export$a0816fa17a9e79be; });
$parcel$export(module.exports, "loadScript", function () { return $a048522d6d94a02e$export$2cb99e4be0dc4646; });
$parcel$export(module.exports, "getRequestCredentials", function () { return $a048522d6d94a02e$export$2d4bf2d3ceade8bb; });
$parcel$export(module.exports, "getDownloadFile", function () { return $a048522d6d94a02e$export$72b4db5ea0370ce6; });

var $8B3mG = parcelRequire("8B3mG");

var $8kkZn = parcelRequire("8kkZn");
function $a048522d6d94a02e$export$e37eab07b9334e17(baseUrl, params) {
    const searchParams = new URLSearchParams();
    for (const key of Object.keys(params))searchParams.set(key, params[key] + "");
    return baseUrl + "?" + searchParams.toString();
}
function $a048522d6d94a02e$export$a0816fa17a9e79be(url, rel = "preconnect") {
    const exists = document.querySelector(`link[href="${url}"]`);
    if (!(0, $8B3mG.isNull)(exists)) return true;
    const link = document.createElement("link");
    link.rel = rel;
    link.href = url;
    link.crossOrigin = "true";
    document.head.append(link);
    return true;
}
const $a048522d6d94a02e$var$pendingRequests = {};
function $a048522d6d94a02e$export$2cb99e4be0dc4646(src) {
    if ($a048522d6d94a02e$var$pendingRequests[src]) return $a048522d6d94a02e$var$pendingRequests[src].promise;
    const promise = (0, $8B3mG.deferredPromise)(), exists = document.querySelector(`script[src="${src}"]`);
    if (!(0, $8B3mG.isNull)(exists)) {
        promise.resolve();
        return promise.promise;
    }
    const script = document.createElement("script");
    script.src = src;
    script.onload = ()=>{
        promise.resolve();
        delete $a048522d6d94a02e$var$pendingRequests[src];
    };
    script.onerror = ()=>{
        promise.reject();
        delete $a048522d6d94a02e$var$pendingRequests[src];
    };
    setTimeout(()=>document.head.append(script), 0);
    return promise.promise;
}
function $a048522d6d94a02e$export$2d4bf2d3ceade8bb(crossOrigin) {
    return crossOrigin === "use-credentials" ? "include" : (0, $8B3mG.isString)(crossOrigin) ? "same-origin" : void 0;
}
function $a048522d6d94a02e$export$72b4db5ea0370ce6({ title: title, src: src, download: download }) {
    const url = (0, $8B3mG.isBoolean)(download) || download === "" ? src.src : (0, $8B3mG.isString)(download) ? download : download?.url;
    if (!$a048522d6d94a02e$var$isValidFileDownload({
        url: url,
        src: src,
        download: download
    })) return null;
    return {
        url: url,
        name: !(0, $8B3mG.isBoolean)(download) && !(0, $8B3mG.isString)(download) && download?.filename || title.toLowerCase() || "media"
    };
}
function $a048522d6d94a02e$var$isValidFileDownload({ url: url, src: src, download: download }) {
    return (0, $8B3mG.isString)(url) && (download && download !== true || (0, $8kkZn.isAudioSrc)(src) || (0, $8kkZn.isVideoSrc)(src));
}

});

parcelRegister("l6thX", function(module, exports) {

$parcel$export(module.exports, "isCueActive", function () { return $f5d0e099d3f64675$export$9ebc9bcf0fed5e3; });
$parcel$export(module.exports, "watchActiveTextTrack", function () { return $f5d0e099d3f64675$export$2cfa71e966fc592; });
$parcel$export(module.exports, "watchCueTextChange", function () { return $f5d0e099d3f64675$export$435259c9b1c46bdf; });

var $8B3mG = parcelRequire("8B3mG");
function $f5d0e099d3f64675$export$bd2e0b7629535218(cues, time) {
    for(let i = 0, len = cues.length; i < len; i++){
        if ($f5d0e099d3f64675$export$9ebc9bcf0fed5e3(cues[i], time)) return cues[i];
    }
    return null;
}
function $f5d0e099d3f64675$export$9ebc9bcf0fed5e3(cue, time) {
    return time >= cue.startTime && time < cue.endTime;
}
function $f5d0e099d3f64675$export$2cfa71e966fc592(tracks, kind, onChange) {
    let currentTrack = null, scope = (0, $8B3mG.getScope)();
    function onModeChange() {
        const kinds = (0, $8B3mG.isString)(kind) ? [
            kind
        ] : kind, track = tracks.toArray().find((track2)=>kinds.includes(track2.kind) && track2.mode === "showing");
        if (track === currentTrack) return;
        if (!track) {
            onChange(null);
            currentTrack = null;
            return;
        }
        if (track.readyState == 2) onChange(track);
        else {
            onChange(null);
            (0, $8B3mG.scoped)(()=>{
                const off = (0, $8B3mG.listenEvent)(track, "load", ()=>{
                    onChange(track);
                    off();
                }, {
                    once: true
                });
            }, scope);
        }
        currentTrack = track;
    }
    onModeChange();
    return (0, $8B3mG.listenEvent)(tracks, "mode-change", onModeChange);
}
function $f5d0e099d3f64675$export$435259c9b1c46bdf(tracks, kind, callback) {
    $f5d0e099d3f64675$export$2cfa71e966fc592(tracks, kind, (track)=>{
        if (!track) {
            callback("");
            return;
        }
        const onCueChange = ()=>{
            const activeCue = track?.activeCues[0];
            callback(activeCue?.text || "");
        };
        onCueChange();
        (0, $8B3mG.listenEvent)(track, "cue-change", onCueChange);
    });
}

});

parcelRegister("8fTk5", function(module, exports) {


module.exports = (parcelRequire("9ONCo"))((parcelRequire("3pG7n")).resolve("2uU34")).then(()=>parcelRequire("9UDwb"));

});
parcelRegister("9ONCo", function(module, exports) {
"use strict";

var $7SasQ = parcelRequire("7SasQ");
module.exports = $7SasQ(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("7SasQ", function(module, exports) {
"use strict";
var $5bb5b182060e90db$var$cachedBundles = {};
var $5bb5b182060e90db$var$cachedPreloads = {};
var $5bb5b182060e90db$var$cachedPrefetches = {};
function $5bb5b182060e90db$var$getCache(type) {
    switch(type){
        case "preload":
            return $5bb5b182060e90db$var$cachedPreloads;
        case "prefetch":
            return $5bb5b182060e90db$var$cachedPrefetches;
        default:
            return $5bb5b182060e90db$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $5bb5b182060e90db$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




parcelRegister("5UOkG", function(module, exports) {

$parcel$export(module.exports, "ListSymbol", function () { return $44e939bdd870665c$export$aae4ab06c68e8d8a; });
const $44e939bdd870665c$var$ADD = Symbol(0), $44e939bdd870665c$var$REMOVE = Symbol(0), $44e939bdd870665c$var$RESET = Symbol(0), $44e939bdd870665c$var$SELECT = Symbol(0), $44e939bdd870665c$var$READONLY = Symbol(0), $44e939bdd870665c$var$SET_READONLY = Symbol(0), $44e939bdd870665c$var$ON_RESET = Symbol(0), $44e939bdd870665c$var$ON_REMOVE = Symbol(0), $44e939bdd870665c$var$ON_USER_SELECT = Symbol(0);
const $44e939bdd870665c$export$aae4ab06c68e8d8a = {
    add: $44e939bdd870665c$var$ADD,
    remove: $44e939bdd870665c$var$REMOVE,
    reset: $44e939bdd870665c$var$RESET,
    select: $44e939bdd870665c$var$SELECT,
    readonly: $44e939bdd870665c$var$READONLY,
    setReadonly: $44e939bdd870665c$var$SET_READONLY,
    onReset: $44e939bdd870665c$var$ON_RESET,
    onRemove: $44e939bdd870665c$var$ON_REMOVE,
    onUserSelect: $44e939bdd870665c$var$ON_USER_SELECT
};

});

parcelRegister("eRuH7", function(module, exports) {

$parcel$export(module.exports, "QualitySymbol", function () { return $ad1dd33b7a7c3eb5$export$219d140079ddefaf; });
const $ad1dd33b7a7c3eb5$var$SET_AUTO = Symbol(0), $ad1dd33b7a7c3eb5$var$ENABLE_AUTO = Symbol(0);
const $ad1dd33b7a7c3eb5$export$219d140079ddefaf = {
    setAuto: $ad1dd33b7a7c3eb5$var$SET_AUTO,
    enableAuto: $ad1dd33b7a7c3eb5$var$ENABLE_AUTO
};

});

parcelRegister("9KZm0", function(module, exports) {

$parcel$export(module.exports, "coerceToError", function () { return $71a80091f8fad073$export$3a72f6a95046315b; });
$parcel$export(module.exports, "assert", function () { return $71a80091f8fad073$export$a7a9523472993e97; });
function $71a80091f8fad073$export$3a72f6a95046315b(error) {
    return error instanceof Error ? error : Error(typeof error === "string" ? error : JSON.stringify(error));
}
function $71a80091f8fad073$export$a7a9523472993e97(condition, message) {
    if (!condition) throw Error("Assertion failed.");
}

});

parcelRegister("ciZW6", function(module, exports) {

$parcel$export(module.exports, "isEventInside", function () { return $8f5735b49d1c0917$export$f64fb92b700a9fde; });
$parcel$export(module.exports, "setAttributeIfEmpty", function () { return $8f5735b49d1c0917$export$e927fe74c649eb20; });
$parcel$export(module.exports, "setARIALabel", function () { return $8f5735b49d1c0917$export$ce1d0481f995d9e; });
$parcel$export(module.exports, "isElementVisible", function () { return $8f5735b49d1c0917$export$e989c0fffaa6b27a; });
$parcel$export(module.exports, "observeVisibility", function () { return $8f5735b49d1c0917$export$7c347855cb535aff; });
$parcel$export(module.exports, "isElementParent", function () { return $8f5735b49d1c0917$export$2afbdb0b1441313e; });
$parcel$export(module.exports, "onPress", function () { return $8f5735b49d1c0917$export$b0155bf0bd6d2703; });
$parcel$export(module.exports, "isTouchPinchEvent", function () { return $8f5735b49d1c0917$export$269c0bf4c0098b41; });
$parcel$export(module.exports, "requestScopedAnimationFrame", function () { return $8f5735b49d1c0917$export$8daeb947826d57bc; });
$parcel$export(module.exports, "cloneTemplate", function () { return $8f5735b49d1c0917$export$ab8f051e2ff626fb; });
$parcel$export(module.exports, "createTemplate", function () { return $8f5735b49d1c0917$export$7b7ae612b60e1630; });
$parcel$export(module.exports, "cloneTemplateContent", function () { return $8f5735b49d1c0917$export$f0463f0c94e8c9b8; });
$parcel$export(module.exports, "autoPlacement", function () { return $8f5735b49d1c0917$export$91fb6ecbd551914; });
$parcel$export(module.exports, "hasAnimation", function () { return $8f5735b49d1c0917$export$2097d829fb8a3331; });
$parcel$export(module.exports, "createSlot", function () { return $8f5735b49d1c0917$export$e88b45bda5c13eb9; });
$parcel$export(module.exports, "useTransitionActive", function () { return $8f5735b49d1c0917$export$d254d8848be3d5f1; });
$parcel$export(module.exports, "useResizeObserver", function () { return $8f5735b49d1c0917$export$683480f191c0e3ea; });
$parcel$export(module.exports, "useActive", function () { return $8f5735b49d1c0917$export$d338b88b3b422a2d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $8f5735b49d1c0917$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "watchColorScheme", function () { return $8f5735b49d1c0917$export$11abda33abdd5bac; });

var $9IM2D = parcelRequire("9IM2D");

var $8B3mG = parcelRequire("8B3mG");
function $8f5735b49d1c0917$export$f64fb92b700a9fde(el, event) {
    const target = event.composedPath()[0];
    return (0, $8B3mG.isDOMNode)(target) && el.contains(target);
}
const $8f5735b49d1c0917$var$rafJobs = /* @__PURE__ */ new Set();
{
    let processJobs = function() {
        for (const job of $8f5735b49d1c0917$var$rafJobs)try {
            job();
        } catch (e) {}
        window.requestAnimationFrame(processJobs);
    };
    processJobs();
}function $8f5735b49d1c0917$var$scheduleRafJob(job) {
    $8f5735b49d1c0917$var$rafJobs.add(job);
    return ()=>$8f5735b49d1c0917$var$rafJobs.delete(job);
}
function $8f5735b49d1c0917$export$e927fe74c649eb20(target, name, value) {
    if (!target.hasAttribute(name)) target.setAttribute(name, value);
}
function $8f5735b49d1c0917$export$ce1d0481f995d9e(target, $label) {
    if (target.hasAttribute("aria-label") || target.hasAttribute("data-no-label")) return;
    if (!(0, $8B3mG.isFunction)($label)) {
        (0, $8B3mG.setAttribute)(target, "aria-label", $label);
        return;
    }
    function updateAriaDescription() {
        (0, $8B3mG.setAttribute)(target, "aria-label", $label());
    }
    (0, $8B3mG.effect)(updateAriaDescription);
}
function $8f5735b49d1c0917$export$e989c0fffaa6b27a(el) {
    const style = getComputedStyle(el);
    return style.display !== "none" && parseInt(style.opacity) > 0;
}
function $8f5735b49d1c0917$var$checkVisibility(el) {
    return !!el && ("checkVisibility" in el ? el.checkVisibility({
        checkOpacity: true,
        checkVisibilityCSS: true
    }) : $8f5735b49d1c0917$export$e989c0fffaa6b27a(el));
}
function $8f5735b49d1c0917$export$7c347855cb535aff(el, callback) {
    return $8f5735b49d1c0917$var$scheduleRafJob(()=>callback($8f5735b49d1c0917$var$checkVisibility(el)));
}
function $8f5735b49d1c0917$export$2afbdb0b1441313e(owner, node, test) {
    while(node){
        if (node === owner) return true;
        else if (test?.(node)) break;
        else node = node.parentElement;
    }
    return false;
}
function $8f5735b49d1c0917$export$b0155bf0bd6d2703(target, handler) {
    return new (0, $8B3mG.EventsController)(target).add("pointerup", (event)=>{
        if (event.button === 0 && !event.defaultPrevented) handler(event);
    }).add("keydown", (event)=>{
        if ((0, $8B3mG.isKeyboardClick)(event)) handler(event);
    });
}
function $8f5735b49d1c0917$export$269c0bf4c0098b41(event) {
    return (0, $8B3mG.isTouchEvent)(event) && (event.touches.length > 1 || event.changedTouches.length > 1);
}
function $8f5735b49d1c0917$export$8daeb947826d57bc(callback) {
    let scope = (0, $8B3mG.getScope)(), id = window.requestAnimationFrame(()=>{
        (0, $8B3mG.scoped)(callback, scope);
        id = -1;
    });
    return ()=>void window.cancelAnimationFrame(id);
}
function $8f5735b49d1c0917$export$ab8f051e2ff626fb(template, length, onCreate) {
    let current, prev = template, parent = template.parentElement, content = template.content.firstElementChild, elements = [];
    if (!content && template.firstElementChild) {
        template.innerHTML = template.firstElementChild.outerHTML;
        template.firstElementChild.remove();
        content = template.content.firstElementChild;
    }
    for(let i = 0; i < length; i++){
        current = document.importNode(content, true);
        onCreate?.(current, i);
        parent.insertBefore(current, prev.nextSibling);
        elements.push(current);
        prev = current;
    }
    (0, $8B3mG.onDispose)(()=>{
        for(let i = 0; i < elements.length; i++)elements[i].remove();
    });
    return elements;
}
function $8f5735b49d1c0917$export$7b7ae612b60e1630(content) {
    const template = document.createElement("template");
    template.innerHTML = content;
    return template.content;
}
function $8f5735b49d1c0917$export$f0463f0c94e8c9b8(content) {
    const fragment = content.cloneNode(true);
    return fragment.firstElementChild;
}
function $8f5735b49d1c0917$export$91fb6ecbd551914(el, trigger, placement, { offsetVarName: offsetVarName, xOffset: xOffset, yOffset: yOffset, ...options }) {
    if (!el) return;
    const floatingPlacement = placement.replace(" ", "-").replace("-center", "");
    (0, $8B3mG.setStyle)(el, "visibility", !trigger ? "hidden" : null);
    if (!trigger) return;
    let isTop = placement.includes("top");
    const negateX = (x)=>placement.includes("left") ? `calc(-1 * ${x})` : x, negateY = (y)=>isTop ? `calc(-1 * ${y})` : y;
    return (0, $9IM2D.autoUpdate)(trigger, el, ()=>{
        (0, $9IM2D.computePosition)(trigger, el, {
            placement: floatingPlacement,
            middleware: [
                ...options.middleware ?? [],
                (0, $9IM2D.flip)({
                    fallbackAxisSideDirection: "start",
                    crossAxis: false
                }),
                (0, $9IM2D.shift)()
            ],
            ...options
        }).then(({ x: x, y: y, middlewareData: middlewareData })=>{
            const hasFlipped = !!middlewareData.flip?.index;
            isTop = placement.includes(hasFlipped ? "bottom" : "top");
            el.setAttribute("data-placement", hasFlipped ? placement.startsWith("top") ? placement.replace("top", "bottom") : placement.replace("bottom", "top") : placement);
            Object.assign(el.style, {
                top: `calc(${y + "px"} + ${negateY(yOffset ? yOffset + "px" : `var(--${offsetVarName}-y-offset, 0px)`)})`,
                left: `calc(${x + "px"} + ${negateX(xOffset ? xOffset + "px" : `var(--${offsetVarName}-x-offset, 0px)`)})`
            });
        });
    });
}
function $8f5735b49d1c0917$export$2097d829fb8a3331(el) {
    const styles = getComputedStyle(el);
    return styles.animationName !== "none";
}
function $8f5735b49d1c0917$export$e88b45bda5c13eb9(name) {
    const slot = document.createElement("slot");
    slot.name = name;
    return slot;
}
function $8f5735b49d1c0917$export$d254d8848be3d5f1($el) {
    const $active = (0, $8B3mG.signal)(false);
    (0, $8B3mG.effect)(()=>{
        const el = $el();
        if (!el) return;
        new (0, $8B3mG.EventsController)(el).add("transitionstart", ()=>$active.set(true)).add("transitionend", ()=>$active.set(false));
    });
    return $active;
}
function $8f5735b49d1c0917$export$683480f191c0e3ea($el, onResize) {
    function onElementChange() {
        const el = $el();
        if (!el) return;
        onResize();
        const observer = new ResizeObserver((0, $8B3mG.animationFrameThrottle)(onResize));
        observer.observe(el);
        return ()=>observer.disconnect();
    }
    (0, $8B3mG.effect)(onElementChange);
}
function $8f5735b49d1c0917$export$d338b88b3b422a2d($el) {
    const $isMouseEnter = $8f5735b49d1c0917$var$useMouseEnter($el), $isFocusedIn = $8f5735b49d1c0917$var$useFocusIn($el);
    let prevMouseEnter = false;
    return (0, $8B3mG.computed)(()=>{
        const isMouseEnter = $isMouseEnter();
        if (prevMouseEnter && !isMouseEnter) return false;
        prevMouseEnter = isMouseEnter;
        return isMouseEnter || $isFocusedIn();
    });
}
function $8f5735b49d1c0917$var$useMouseEnter($el) {
    const $isMouseEnter = (0, $8B3mG.signal)(false);
    (0, $8B3mG.effect)(()=>{
        const el = $el();
        if (!el) {
            $isMouseEnter.set(false);
            return;
        }
        new (0, $8B3mG.EventsController)(el).add("mouseenter", ()=>$isMouseEnter.set(true)).add("mouseleave", ()=>$isMouseEnter.set(false));
    });
    return $isMouseEnter;
}
function $8f5735b49d1c0917$var$useFocusIn($el) {
    const $isFocusIn = (0, $8B3mG.signal)(false);
    (0, $8B3mG.effect)(()=>{
        const el = $el();
        if (!el) {
            $isFocusIn.set(false);
            return;
        }
        new (0, $8B3mG.EventsController)(el).add("focusin", ()=>$isFocusIn.set(true)).add("focusout", ()=>$isFocusIn.set(false));
    });
    return $isFocusIn;
}
function $8f5735b49d1c0917$export$1b3bfaa9684536aa(el) {
    return el instanceof HTMLElement;
}
function $8f5735b49d1c0917$var$useColorSchemePreference() {
    const colorScheme = (0, $8B3mG.signal)("dark");
    const media = window.matchMedia("(prefers-color-scheme: light)");
    function onChange() {
        colorScheme.set(media.matches ? "light" : "dark");
    }
    onChange();
    (0, $8B3mG.listenEvent)(media, "change", onChange);
    return colorScheme;
}
function $8f5735b49d1c0917$export$11abda33abdd5bac(el, colorScheme) {
    (0, $8B3mG.effect)(()=>{
        const scheme = colorScheme();
        if (scheme === "system") {
            const preference = $8f5735b49d1c0917$var$useColorSchemePreference();
            (0, $8B3mG.effect)(()=>updateColorScheme(preference()));
            return;
        }
        updateColorScheme(scheme);
    });
    function updateColorScheme(scheme) {
        (0, $8B3mG.toggleClass)(el, "light", scheme === "light");
        (0, $8B3mG.toggleClass)(el, "dark", scheme === "dark");
    }
}

});
parcelRegister("9IM2D", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", function () { return $3afe2efc53080d12$export$deee3a793edee05f; });
$parcel$export(module.exports, "shift", function () { return $3afe2efc53080d12$export$fba63a578e423eb; });
$parcel$export(module.exports, "flip", function () { return $3afe2efc53080d12$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "computePosition", function () { return $3afe2efc53080d12$export$48a53dcb22e581d0; });

var $g234E = parcelRequire("g234E");
var $eq5N1 = parcelRequire("eq5N1");

var $eq5N1 = parcelRequire("eq5N1");

var $1FU2M = parcelRequire("1FU2M");
function $3afe2efc53080d12$var$getCssDimensions(element) {
    const css = (0, $1FU2M.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $1FU2M.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $eq5N1.round)(width) !== offsetWidth || (0, $eq5N1.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $3afe2efc53080d12$var$unwrapElement(element) {
    return !(0, $1FU2M.isElement)(element) ? element.contextElement : element;
}
function $3afe2efc53080d12$var$getScale(element) {
    const domElement = $3afe2efc53080d12$var$unwrapElement(element);
    if (!(0, $1FU2M.isHTMLElement)(domElement)) return (0, $eq5N1.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $3afe2efc53080d12$var$getCssDimensions(domElement);
    let x = ($ ? (0, $eq5N1.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $eq5N1.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $3afe2efc53080d12$var$noOffsets = /*#__PURE__*/ (0, $eq5N1.createCoords)(0);
function $3afe2efc53080d12$var$getVisualOffsets(element) {
    const win = (0, $1FU2M.getWindow)(element);
    if (!(0, $1FU2M.isWebKit)() || !win.visualViewport) return $3afe2efc53080d12$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $3afe2efc53080d12$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $1FU2M.getWindow)(element)) return false;
    return isFixed;
}
function $3afe2efc53080d12$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $3afe2efc53080d12$var$unwrapElement(element);
    let scale = (0, $eq5N1.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $1FU2M.isElement)(offsetParent)) scale = $3afe2efc53080d12$var$getScale(offsetParent);
        } else scale = $3afe2efc53080d12$var$getScale(element);
    }
    const visualOffsets = $3afe2efc53080d12$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $3afe2efc53080d12$var$getVisualOffsets(domElement) : (0, $eq5N1.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $1FU2M.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $1FU2M.isElement)(offsetParent) ? (0, $1FU2M.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $1FU2M.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $3afe2efc53080d12$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $1FU2M.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $1FU2M.getWindow)(currentIFrame);
            currentIFrame = (0, $1FU2M.getFrameElement)(currentWin);
        }
    }
    return (0, $eq5N1.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $3afe2efc53080d12$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $1FU2M.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $1FU2M.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $eq5N1.createCoords)(1);
    const offsets = (0, $eq5N1.createCoords)(0);
    const isOffsetParentAnElement = (0, $1FU2M.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1FU2M.getNodeName)(offsetParent) !== "body" || (0, $1FU2M.isOverflowElement)(documentElement)) scroll = (0, $1FU2M.getNodeScroll)(offsetParent);
        if ((0, $1FU2M.isHTMLElement)(offsetParent)) {
            const offsetRect = $3afe2efc53080d12$var$getBoundingClientRect(offsetParent);
            scale = $3afe2efc53080d12$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $3afe2efc53080d12$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $3afe2efc53080d12$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $3afe2efc53080d12$var$getBoundingClientRect((0, $1FU2M.getDocumentElement)(element)).left + (0, $1FU2M.getNodeScroll)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $3afe2efc53080d12$var$getDocumentRect(element) {
    const html = (0, $1FU2M.getDocumentElement)(element);
    const scroll = (0, $1FU2M.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $eq5N1.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $eq5N1.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $3afe2efc53080d12$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $1FU2M.getComputedStyle)(body).direction === "rtl") x += (0, $eq5N1.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $3afe2efc53080d12$var$getViewportRect(element, strategy) {
    const win = (0, $1FU2M.getWindow)(element);
    const html = (0, $1FU2M.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $1FU2M.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $3afe2efc53080d12$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $3afe2efc53080d12$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $1FU2M.isHTMLElement)(element) ? $3afe2efc53080d12$var$getScale(element) : (0, $eq5N1.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $3afe2efc53080d12$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $3afe2efc53080d12$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $3afe2efc53080d12$var$getDocumentRect((0, $1FU2M.getDocumentElement)(element));
    else if ((0, $1FU2M.isElement)(clippingAncestor)) rect = $3afe2efc53080d12$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $3afe2efc53080d12$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $eq5N1.rectToClientRect)(rect);
}
function $3afe2efc53080d12$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $1FU2M.getParentNode)(element);
    if (parentNode === stopNode || !(0, $1FU2M.isElement)(parentNode) || (0, $1FU2M.isLastTraversableNode)(parentNode)) return false;
    return (0, $1FU2M.getComputedStyle)(parentNode).position === "fixed" || $3afe2efc53080d12$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $3afe2efc53080d12$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $1FU2M.getOverflowAncestors)(element, [], false).filter((el)=>(0, $1FU2M.isElement)(el) && (0, $1FU2M.getNodeName)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $1FU2M.getComputedStyle)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $1FU2M.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $1FU2M.isElement)(currentNode) && !(0, $1FU2M.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $1FU2M.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $1FU2M.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $1FU2M.isOverflowElement)(currentNode) && !currentNodeIsContaining && $3afe2efc53080d12$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $1FU2M.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $3afe2efc53080d12$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? (0, $1FU2M.isTopLayer)(element) ? [] : $3afe2efc53080d12$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $3afe2efc53080d12$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $eq5N1.max)(rect.top, accRect.top);
        accRect.right = (0, $eq5N1.min)(rect.right, accRect.right);
        accRect.bottom = (0, $eq5N1.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $eq5N1.max)(rect.left, accRect.left);
        return accRect;
    }, $3afe2efc53080d12$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $3afe2efc53080d12$var$getDimensions(element) {
    const { width: width, height: height } = $3afe2efc53080d12$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $3afe2efc53080d12$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $1FU2M.isHTMLElement)(offsetParent);
    const documentElement = (0, $1FU2M.getDocumentElement)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $3afe2efc53080d12$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $eq5N1.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1FU2M.getNodeName)(offsetParent) !== "body" || (0, $1FU2M.isOverflowElement)(documentElement)) scroll = (0, $1FU2M.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $3afe2efc53080d12$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $3afe2efc53080d12$var$getWindowScrollBarX(documentElement);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x;
    const y = rect.top + scroll.scrollTop - offsets.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $3afe2efc53080d12$var$isStaticPositioned(element) {
    return (0, $1FU2M.getComputedStyle)(element).position === "static";
}
function $3afe2efc53080d12$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $1FU2M.isHTMLElement)(element) || (0, $1FU2M.getComputedStyle)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $3afe2efc53080d12$var$getOffsetParent(element, polyfill) {
    const win = (0, $1FU2M.getWindow)(element);
    if ((0, $1FU2M.isTopLayer)(element)) return win;
    if (!(0, $1FU2M.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $1FU2M.getParentNode)(element);
        while(svgOffsetParent && !(0, $1FU2M.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $1FU2M.isElement)(svgOffsetParent) && !$3afe2efc53080d12$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $1FU2M.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $3afe2efc53080d12$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $1FU2M.isTableElement)(offsetParent) && $3afe2efc53080d12$var$isStaticPositioned(offsetParent))offsetParent = $3afe2efc53080d12$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $1FU2M.isLastTraversableNode)(offsetParent) && $3afe2efc53080d12$var$isStaticPositioned(offsetParent) && !(0, $1FU2M.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $1FU2M.getContainingBlock)(element) || win;
}
const $3afe2efc53080d12$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $3afe2efc53080d12$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $3afe2efc53080d12$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $3afe2efc53080d12$var$isRTL(element) {
    return (0, $1FU2M.getComputedStyle)(element).direction === "rtl";
}
const $3afe2efc53080d12$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $3afe2efc53080d12$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $1FU2M.getDocumentElement,
    getClippingRect: $3afe2efc53080d12$var$getClippingRect,
    getOffsetParent: $3afe2efc53080d12$var$getOffsetParent,
    getElementRects: $3afe2efc53080d12$var$getElementRects,
    getClientRects: $3afe2efc53080d12$var$getClientRects,
    getDimensions: $3afe2efc53080d12$var$getDimensions,
    getScale: $3afe2efc53080d12$var$getScale,
    isElement: $1FU2M.isElement,
    isRTL: $3afe2efc53080d12$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $3afe2efc53080d12$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $1FU2M.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $eq5N1.floor)(top);
        const insetRight = (0, $eq5N1.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $eq5N1.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $eq5N1.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $eq5N1.max)(0, (0, $eq5N1.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $3afe2efc53080d12$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $3afe2efc53080d12$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $1FU2M.getOverflowAncestors)(referenceEl) : [],
        ...(0, $1FU2M.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $3afe2efc53080d12$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $3afe2efc53080d12$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $3afe2efc53080d12$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $3afe2efc53080d12$export$37b6bde19b108ecc = (0, $g234E.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $3afe2efc53080d12$export$cc800923e997bb8 = (0, $g234E.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $3afe2efc53080d12$export$91fb6ecbd551914 = (0, $g234E.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $3afe2efc53080d12$export$fba63a578e423eb = (0, $g234E.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $3afe2efc53080d12$export$8a83211c878a3f1f = (0, $g234E.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $3afe2efc53080d12$export$346677f925de839c = (0, $g234E.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $3afe2efc53080d12$export$fe8985bb6374093c = (0, $g234E.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $3afe2efc53080d12$export$f2120bbfa5450bd2 = (0, $g234E.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $3afe2efc53080d12$export$18c8ad048e32c7d5 = (0, $g234E.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $3afe2efc53080d12$export$7bf07e38f3dc4b69 = (0, $g234E.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $3afe2efc53080d12$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $3afe2efc53080d12$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $g234E.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("g234E", function(module, exports) {

$parcel$export(module.exports, "computePosition", function () { return $e344f2f1bf1d720d$export$48a53dcb22e581d0; });
$parcel$export(module.exports, "detectOverflow", function () { return $e344f2f1bf1d720d$export$37b6bde19b108ecc; });
$parcel$export(module.exports, "arrow", function () { return $e344f2f1bf1d720d$export$f2120bbfa5450bd2; });
$parcel$export(module.exports, "autoPlacement", function () { return $e344f2f1bf1d720d$export$91fb6ecbd551914; });
$parcel$export(module.exports, "flip", function () { return $e344f2f1bf1d720d$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "hide", function () { return $e344f2f1bf1d720d$export$fe8985bb6374093c; });
$parcel$export(module.exports, "inline", function () { return $e344f2f1bf1d720d$export$18c8ad048e32c7d5; });
$parcel$export(module.exports, "offset", function () { return $e344f2f1bf1d720d$export$cc800923e997bb8; });
$parcel$export(module.exports, "shift", function () { return $e344f2f1bf1d720d$export$fba63a578e423eb; });
$parcel$export(module.exports, "limitShift", function () { return $e344f2f1bf1d720d$export$7bf07e38f3dc4b69; });
$parcel$export(module.exports, "size", function () { return $e344f2f1bf1d720d$export$346677f925de839c; });
$parcel$export(module.exports, "rectToClientRect", function () { return (parcelRequire("eq5N1")).rectToClientRect; });

var $eq5N1 = parcelRequire("eq5N1");
function $e344f2f1bf1d720d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $eq5N1.getSideAxis)(placement);
    const alignmentAxis = (0, $eq5N1.getAlignmentAxis)(placement);
    const alignLength = (0, $eq5N1.getAxisLength)(alignmentAxis);
    const side = (0, $eq5N1.getSide)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $eq5N1.getAlignment)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $e344f2f1bf1d720d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $e344f2f1bf1d720d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $e344f2f1bf1d720d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $e344f2f1bf1d720d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $eq5N1.evaluate)(options, state);
    const paddingObject = (0, $eq5N1.getPaddingObject)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $eq5N1.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $eq5N1.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $e344f2f1bf1d720d$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $eq5N1.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $eq5N1.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $eq5N1.getAlignmentAxis)(placement);
            const length = (0, $eq5N1.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $eq5N1.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $eq5N1.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $eq5N1.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $eq5N1.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $e344f2f1bf1d720d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $eq5N1.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $eq5N1.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $eq5N1.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $eq5N1.getAlignment)(placement) === alignment || (autoAlignment ? (0, $eq5N1.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $e344f2f1bf1d720d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $eq5N1.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $eq5N1.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $eq5N1.placements) ? $e344f2f1bf1d720d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $e344f2f1bf1d720d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $eq5N1.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $eq5N1.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $eq5N1.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $eq5N1.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $e344f2f1bf1d720d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $eq5N1.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $eq5N1.getSide)(placement);
            const initialSideAxis = (0, $eq5N1.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $eq5N1.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $eq5N1.getOppositePlacement)(initialPlacement)
            ] : (0, $eq5N1.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $eq5N1.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $e344f2f1bf1d720d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $eq5N1.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $eq5N1.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === "y";
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $e344f2f1bf1d720d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $e344f2f1bf1d720d$var$isAnySideFullyClipped(overflow) {
    return (0, $eq5N1.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $e344f2f1bf1d720d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $eq5N1.evaluate)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $e344f2f1bf1d720d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $e344f2f1bf1d720d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $e344f2f1bf1d720d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $e344f2f1bf1d720d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $e344f2f1bf1d720d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $e344f2f1bf1d720d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $e344f2f1bf1d720d$var$getBoundingRect(rects) {
    const minX = (0, $eq5N1.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $eq5N1.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $eq5N1.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $eq5N1.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $e344f2f1bf1d720d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $eq5N1.rectToClientRect)($e344f2f1bf1d720d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $e344f2f1bf1d720d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $eq5N1.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $e344f2f1bf1d720d$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $eq5N1.rectToClientRect)($e344f2f1bf1d720d$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $eq5N1.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $eq5N1.getSideAxis)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $eq5N1.getSide)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $eq5N1.getSide)(placement) === "left";
                    const maxRight = (0, $eq5N1.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $eq5N1.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $e344f2f1bf1d720d$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $eq5N1.getSide)(placement);
    const alignment = (0, $eq5N1.getAlignment)(placement);
    const isVertical = (0, $eq5N1.getSideAxis)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $eq5N1.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $e344f2f1bf1d720d$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $e344f2f1bf1d720d$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $e344f2f1bf1d720d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $eq5N1.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $e344f2f1bf1d720d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $eq5N1.getSideAxis)((0, $eq5N1.getSide)(placement));
            const mainAxis = (0, $eq5N1.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $eq5N1.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $eq5N1.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $e344f2f1bf1d720d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $eq5N1.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $eq5N1.getSideAxis)(placement);
            const mainAxis = (0, $eq5N1.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $eq5N1.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $eq5N1.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $e344f2f1bf1d720d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $eq5N1.evaluate)(options, state);
            const overflow = await $e344f2f1bf1d720d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $eq5N1.getSide)(placement);
            const alignment = (0, $eq5N1.getAlignment)(placement);
            const isYAxis = (0, $eq5N1.getSideAxis)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $eq5N1.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $eq5N1.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) availableWidth = alignment || noShift ? (0, $eq5N1.min)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            else availableHeight = alignment || noShift ? (0, $eq5N1.min)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $eq5N1.max)(overflow.left, 0);
                const xMax = (0, $eq5N1.max)(overflow.right, 0);
                const yMin = (0, $eq5N1.max)(overflow.top, 0);
                const yMax = (0, $eq5N1.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $eq5N1.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $eq5N1.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("eq5N1", function(module, exports) {

$parcel$export(module.exports, "sides", function () { return $21114258c1c15453$export$832b6fa47fa053d2; });
$parcel$export(module.exports, "placements", function () { return $21114258c1c15453$export$803cd8101b6c182b; });
$parcel$export(module.exports, "min", function () { return $21114258c1c15453$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $21114258c1c15453$export$8960430cfd85939f; });
$parcel$export(module.exports, "round", function () { return $21114258c1c15453$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "floor", function () { return $21114258c1c15453$export$a3fe094919f356fd; });
$parcel$export(module.exports, "createCoords", function () { return $21114258c1c15453$export$a397704b5e280835; });
$parcel$export(module.exports, "clamp", function () { return $21114258c1c15453$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "evaluate", function () { return $21114258c1c15453$export$fef61f332f2c0afc; });
$parcel$export(module.exports, "getSide", function () { return $21114258c1c15453$export$3c915306cb7fc97a; });
$parcel$export(module.exports, "getAlignment", function () { return $21114258c1c15453$export$f0989780f32bfcda; });
$parcel$export(module.exports, "getOppositeAxis", function () { return $21114258c1c15453$export$8a000a963141ac32; });
$parcel$export(module.exports, "getAxisLength", function () { return $21114258c1c15453$export$320bd9d53520c68a; });
$parcel$export(module.exports, "getSideAxis", function () { return $21114258c1c15453$export$f28e8f882010718a; });
$parcel$export(module.exports, "getAlignmentAxis", function () { return $21114258c1c15453$export$2b57e0052a6d6d4c; });
$parcel$export(module.exports, "getAlignmentSides", function () { return $21114258c1c15453$export$be42861551f17911; });
$parcel$export(module.exports, "getOppositePlacement", function () { return $21114258c1c15453$export$9c5e28bad23365fa; });
$parcel$export(module.exports, "getExpandedPlacements", function () { return $21114258c1c15453$export$496432a3699e50b1; });
$parcel$export(module.exports, "getOppositeAlignmentPlacement", function () { return $21114258c1c15453$export$2b182c584985588b; });
$parcel$export(module.exports, "getOppositeAxisPlacements", function () { return $21114258c1c15453$export$a9b6fb18fd92c3ec; });
$parcel$export(module.exports, "getPaddingObject", function () { return $21114258c1c15453$export$598c291c29bc2e71; });
$parcel$export(module.exports, "rectToClientRect", function () { return $21114258c1c15453$export$ee05aea0aeecbad4; });
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $21114258c1c15453$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $21114258c1c15453$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $21114258c1c15453$export$803cd8101b6c182b = /*#__PURE__*/ $21114258c1c15453$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $21114258c1c15453$export$27b07d8a310ed8b5[0], side + "-" + $21114258c1c15453$export$27b07d8a310ed8b5[1]), []);
const $21114258c1c15453$export$96ec731ed4dcb222 = Math.min;
const $21114258c1c15453$export$8960430cfd85939f = Math.max;
const $21114258c1c15453$export$2077e0241d6afd3c = Math.round;
const $21114258c1c15453$export$a3fe094919f356fd = Math.floor;
const $21114258c1c15453$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $21114258c1c15453$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $21114258c1c15453$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $21114258c1c15453$export$7d15b64cf5a3a4c4(start, value, end) {
    return $21114258c1c15453$export$8960430cfd85939f(start, $21114258c1c15453$export$96ec731ed4dcb222(value, end));
}
function $21114258c1c15453$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $21114258c1c15453$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $21114258c1c15453$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $21114258c1c15453$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $21114258c1c15453$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $21114258c1c15453$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($21114258c1c15453$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $21114258c1c15453$export$2b57e0052a6d6d4c(placement) {
    return $21114258c1c15453$export$8a000a963141ac32($21114258c1c15453$export$f28e8f882010718a(placement));
}
function $21114258c1c15453$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $21114258c1c15453$export$f0989780f32bfcda(placement);
    const alignmentAxis = $21114258c1c15453$export$2b57e0052a6d6d4c(placement);
    const length = $21114258c1c15453$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $21114258c1c15453$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $21114258c1c15453$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $21114258c1c15453$export$496432a3699e50b1(placement) {
    const oppositePlacement = $21114258c1c15453$export$9c5e28bad23365fa(placement);
    return [
        $21114258c1c15453$export$2b182c584985588b(placement),
        oppositePlacement,
        $21114258c1c15453$export$2b182c584985588b(oppositePlacement)
    ];
}
function $21114258c1c15453$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$21114258c1c15453$var$oppositeAlignmentMap[alignment]);
}
function $21114258c1c15453$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $21114258c1c15453$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $21114258c1c15453$export$f0989780f32bfcda(placement);
    let list = $21114258c1c15453$var$getSideList($21114258c1c15453$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($21114258c1c15453$export$2b182c584985588b));
    }
    return list;
}
function $21114258c1c15453$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$21114258c1c15453$var$oppositeSideMap[side]);
}
function $21114258c1c15453$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $21114258c1c15453$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $21114258c1c15453$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $21114258c1c15453$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("1FU2M", function(module, exports) {

$parcel$export(module.exports, "getNodeName", function () { return $fb1a3b073692e8b4$export$651544f548703224; });
$parcel$export(module.exports, "getWindow", function () { return $fb1a3b073692e8b4$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "getDocumentElement", function () { return $fb1a3b073692e8b4$export$e495491855dc5418; });
$parcel$export(module.exports, "isElement", function () { return $fb1a3b073692e8b4$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $fb1a3b073692e8b4$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isOverflowElement", function () { return $fb1a3b073692e8b4$export$989e911fa9af580a; });
$parcel$export(module.exports, "getComputedStyle", function () { return $fb1a3b073692e8b4$export$3735103072e4a80; });
$parcel$export(module.exports, "isTableElement", function () { return $fb1a3b073692e8b4$export$71535ffaa902797f; });
$parcel$export(module.exports, "isTopLayer", function () { return $fb1a3b073692e8b4$export$89e651af02346cd4; });
$parcel$export(module.exports, "isContainingBlock", function () { return $fb1a3b073692e8b4$export$d6c4e8150c35fed1; });
$parcel$export(module.exports, "isWebKit", function () { return $fb1a3b073692e8b4$export$78551043582a6a98; });
$parcel$export(module.exports, "getContainingBlock", function () { return $fb1a3b073692e8b4$export$940d8225183e1404; });
$parcel$export(module.exports, "getParentNode", function () { return $fb1a3b073692e8b4$export$4e12058fc4d51d56; });
$parcel$export(module.exports, "isLastTraversableNode", function () { return $fb1a3b073692e8b4$export$d1162fb0b6d4cd51; });
$parcel$export(module.exports, "getNodeScroll", function () { return $fb1a3b073692e8b4$export$dc8fc79fa2800137; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return $fb1a3b073692e8b4$export$3b57c1601291186b; });
$parcel$export(module.exports, "getFrameElement", function () { return $fb1a3b073692e8b4$export$7bf1f8740e3e34af; });
function $fb1a3b073692e8b4$export$651544f548703224(node) {
    if ($fb1a3b073692e8b4$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $fb1a3b073692e8b4$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $fb1a3b073692e8b4$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($fb1a3b073692e8b4$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $fb1a3b073692e8b4$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $fb1a3b073692e8b4$export$38b2d434cce3ea22(value).Node;
}
function $fb1a3b073692e8b4$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $fb1a3b073692e8b4$export$38b2d434cce3ea22(value).Element;
}
function $fb1a3b073692e8b4$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $fb1a3b073692e8b4$export$38b2d434cce3ea22(value).HTMLElement;
}
function $fb1a3b073692e8b4$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $fb1a3b073692e8b4$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $fb1a3b073692e8b4$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $fb1a3b073692e8b4$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $fb1a3b073692e8b4$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($fb1a3b073692e8b4$export$651544f548703224(element));
}
function $fb1a3b073692e8b4$export$89e651af02346cd4(element) {
    return [
        ":popover-open",
        ":modal"
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $fb1a3b073692e8b4$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $fb1a3b073692e8b4$export$78551043582a6a98();
    const css = $fb1a3b073692e8b4$export$45a5e7f76e0caa8d(elementOrCss) ? $fb1a3b073692e8b4$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $fb1a3b073692e8b4$export$940d8225183e1404(element) {
    let currentNode = $fb1a3b073692e8b4$export$4e12058fc4d51d56(element);
    while($fb1a3b073692e8b4$export$1b3bfaa9684536aa(currentNode) && !$fb1a3b073692e8b4$export$d1162fb0b6d4cd51(currentNode)){
        if ($fb1a3b073692e8b4$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($fb1a3b073692e8b4$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $fb1a3b073692e8b4$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $fb1a3b073692e8b4$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $fb1a3b073692e8b4$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($fb1a3b073692e8b4$export$651544f548703224(node));
}
function $fb1a3b073692e8b4$export$3735103072e4a80(element) {
    return $fb1a3b073692e8b4$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $fb1a3b073692e8b4$export$dc8fc79fa2800137(element) {
    if ($fb1a3b073692e8b4$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $fb1a3b073692e8b4$export$4e12058fc4d51d56(node) {
    if ($fb1a3b073692e8b4$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $fb1a3b073692e8b4$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $fb1a3b073692e8b4$export$e495491855dc5418(node);
    return $fb1a3b073692e8b4$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $fb1a3b073692e8b4$export$7cd01a57c8ca906c(node) {
    const parentNode = $fb1a3b073692e8b4$export$4e12058fc4d51d56(node);
    if ($fb1a3b073692e8b4$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($fb1a3b073692e8b4$export$1b3bfaa9684536aa(parentNode) && $fb1a3b073692e8b4$export$989e911fa9af580a(parentNode)) return parentNode;
    return $fb1a3b073692e8b4$export$7cd01a57c8ca906c(parentNode);
}
function $fb1a3b073692e8b4$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $fb1a3b073692e8b4$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $fb1a3b073692e8b4$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $fb1a3b073692e8b4$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $fb1a3b073692e8b4$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $fb1a3b073692e8b4$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $fb1a3b073692e8b4$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $fb1a3b073692e8b4$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});



parcelRegister("hzYuC", function(module, exports) {

$parcel$export(module.exports, "round", function () { return $ccc4a12fc3bd1500$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "getNumberOfDecimalPlaces", function () { return $ccc4a12fc3bd1500$export$9f536c494121a25b; });
$parcel$export(module.exports, "clampNumber", function () { return $ccc4a12fc3bd1500$export$d8bb65601c55995; });
function $ccc4a12fc3bd1500$export$2077e0241d6afd3c(num, decimalPlaces = 2) {
    return Number(num.toFixed(decimalPlaces));
}
function $ccc4a12fc3bd1500$export$9f536c494121a25b(num) {
    return String(num).split(".")[1]?.length ?? 0;
}
function $ccc4a12fc3bd1500$export$d8bb65601c55995(min, value, max) {
    return Math.max(min, Math.min(max, value));
}

});

parcelRegister("jWjYZ", function(module, exports) {

$parcel$export(module.exports, "$keyboard", function () { return $e842ef3e599403f6$export$1324784a40a5abc6; });
$parcel$export(module.exports, "FocusVisibleController", function () { return $e842ef3e599403f6$export$f607b183509e84c9; });

var $57dmi = parcelRequire("57dmi");

var $fhH8k = parcelRequire("fhH8k");

var $2u9SC = parcelRequire("2u9SC");

var $9P4tJ = parcelRequire("9P4tJ");

var $8B3mG = parcelRequire("8B3mG");
let $e842ef3e599403f6$export$1324784a40a5abc6 = (0, $8B3mG.signal)(false);
(0, $8B3mG.listenEvent)(document, "pointerdown", ()=>{
    $e842ef3e599403f6$export$1324784a40a5abc6.set(false);
});
(0, $8B3mG.listenEvent)(document, "keydown", (e)=>{
    if (e.metaKey || e.altKey || e.ctrlKey) return;
    $e842ef3e599403f6$export$1324784a40a5abc6.set(true);
});
var $e842ef3e599403f6$var$_focused = /*#__PURE__*/ new WeakMap(), $e842ef3e599403f6$var$_onFocus = /*#__PURE__*/ new WeakSet(), $e842ef3e599403f6$var$_onBlur = /*#__PURE__*/ new WeakSet(), $e842ef3e599403f6$var$_onPointerEnter = /*#__PURE__*/ new WeakSet(), $e842ef3e599403f6$var$_onPointerLeave = /*#__PURE__*/ new WeakSet();
class $e842ef3e599403f6$export$f607b183509e84c9 extends (0, $8B3mG.ViewController) {
    onConnect(el) {
        (0, $8B3mG.effect)(()=>{
            const events = new (0, $8B3mG.EventsController)(el);
            if (!$e842ef3e599403f6$export$1324784a40a5abc6()) {
                (0, $57dmi._)(this, $e842ef3e599403f6$var$_focused).set(false);
                $e842ef3e599403f6$var$updateFocusAttr(el, false);
                events.add("pointerenter", (0, $2u9SC._)(this, $e842ef3e599403f6$var$_onPointerEnter, $e842ef3e599403f6$var$onPointerEnter).bind(this)).add("pointerleave", (0, $2u9SC._)(this, $e842ef3e599403f6$var$_onPointerLeave, $e842ef3e599403f6$var$onPointerLeave).bind(this));
                return;
            }
            const active = document.activeElement === el;
            (0, $57dmi._)(this, $e842ef3e599403f6$var$_focused).set(active);
            $e842ef3e599403f6$var$updateFocusAttr(el, active);
            events.add("focus", (0, $2u9SC._)(this, $e842ef3e599403f6$var$_onFocus, $e842ef3e599403f6$var$onFocus).bind(this)).add("blur", (0, $2u9SC._)(this, $e842ef3e599403f6$var$_onBlur, $e842ef3e599403f6$var$onBlur).bind(this));
        });
    }
    focused() {
        return (0, $57dmi._)(this, $e842ef3e599403f6$var$_focused).call(this);
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $e842ef3e599403f6$var$_onFocus);
        (0, $9P4tJ._)(this, $e842ef3e599403f6$var$_onBlur);
        (0, $9P4tJ._)(this, $e842ef3e599403f6$var$_onPointerEnter);
        (0, $9P4tJ._)(this, $e842ef3e599403f6$var$_onPointerLeave);
        (0, $fhH8k._)(this, $e842ef3e599403f6$var$_focused, {
            writable: true,
            value: (0, $8B3mG.signal)(false)
        });
    }
}
function $e842ef3e599403f6$var$onFocus() {
    (0, $57dmi._)(this, $e842ef3e599403f6$var$_focused).set(true);
    $e842ef3e599403f6$var$updateFocusAttr(this.el, true);
}
function $e842ef3e599403f6$var$onBlur() {
    (0, $57dmi._)(this, $e842ef3e599403f6$var$_focused).set(false);
    $e842ef3e599403f6$var$updateFocusAttr(this.el, false);
}
function $e842ef3e599403f6$var$onPointerEnter() {
    $e842ef3e599403f6$var$updateHoverAttr(this.el, true);
}
function $e842ef3e599403f6$var$onPointerLeave() {
    $e842ef3e599403f6$var$updateHoverAttr(this.el, false);
}
function $e842ef3e599403f6$var$updateFocusAttr(el, isFocused) {
    (0, $8B3mG.setAttribute)(el, "data-focus", isFocused);
    (0, $8B3mG.setAttribute)(el, "data-hocus", isFocused);
}
function $e842ef3e599403f6$var$updateHoverAttr(el, isHovering) {
    (0, $8B3mG.setAttribute)(el, "data-hocus", isHovering);
    (0, $8B3mG.setAttribute)(el, "data-hover", isHovering);
}

});

parcelRegister("8UZgv", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("9ONCo"))((parcelRequire("3pG7n")).resolve("9ZwVl")),
    (parcelRequire("9ONCo"))((parcelRequire("3pG7n")).resolve("1rtjd"))
]).then(()=>parcelRequire("jqQNI"));

});

parcelRegister("13daR", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("9ONCo"))((parcelRequire("3pG7n")).resolve("9ZwVl")),
    (parcelRequire("9ONCo"))((parcelRequire("3pG7n")).resolve("71knP"))
]).then(()=>parcelRequire("3rOgD"));

});

parcelRegister("8v5fF", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("9ONCo"))((parcelRequire("3pG7n")).resolve("9ZwVl")),
    (parcelRequire("9ONCo"))((parcelRequire("3pG7n")).resolve("71knP")),
    (parcelRequire("9ONCo"))((parcelRequire("3pG7n")).resolve("jxjEY"))
]).then(()=>parcelRequire("afSVV"));

});

parcelRegister("kXdqo", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("9ONCo"))((parcelRequire("3pG7n")).resolve("9ZwVl")),
    (parcelRequire("9ONCo"))((parcelRequire("3pG7n")).resolve("71knP")),
    (parcelRequire("9ONCo"))((parcelRequire("3pG7n")).resolve("5ppjt"))
]).then(()=>parcelRequire("fHPZO"));

});

parcelRegister("h1Egj", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("9ONCo"))((parcelRequire("3pG7n")).resolve("4n99l")),
    (parcelRequire("9ONCo"))((parcelRequire("3pG7n")).resolve("fYjTM"))
]).then(()=>parcelRequire("fWm0o"));

});

parcelRegister("buafn", function(module, exports) {


module.exports = (parcelRequire("9ONCo"))((parcelRequire("3pG7n")).resolve("4n99l")).then(()=>parcelRequire("h7gDk"));

});

parcelRegister("kQ396", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("9ONCo"))((parcelRequire("3pG7n")).resolve("7FDt4")),
    (parcelRequire("9ONCo"))((parcelRequire("3pG7n")).resolve("32sUK"))
]).then(()=>parcelRequire("aeDBj"));

});

parcelRegister("7ipNj", function(module, exports) {


module.exports = (parcelRequire("9ONCo"))((parcelRequire("3pG7n")).resolve("7FDt4")).then(()=>parcelRequire("5J19P"));

});

parcelRegister("dnjPE", function(module, exports) {


module.exports = (parcelRequire("9ONCo"))((parcelRequire("3pG7n")).resolve("I2Gtd")).then(()=>parcelRequire("lBC45"));

});

parcelRegister("6Ro0y", function(module, exports) {


module.exports = (parcelRequire("9ONCo"))((parcelRequire("3pG7n")).resolve("bZP5r")).then(()=>parcelRequire("acV4b"));

});

parcelRegister("4cwBt", function(module, exports) {

var $8B3mG = parcelRequire("8B3mG");

var $3xjxV = parcelRequire("3xjxV");

var $29GZd = parcelRequire("29GZd");




parcelRequire("gX4mh");

parcelRequire("8hn4v");
parcelRequire("ezUKc");
parcelRequire("fCAPZ");


parcelRequire("3Oa6Y");



parcelRequire("kLho8");
(0, $8B3mG.defineCustomElement)((0, $3xjxV.MediaAudioLayoutElement));
(0, $8B3mG.defineCustomElement)((0, $29GZd.MediaVideoLayoutElement));

});
parcelRegister("3xjxV", function(module, exports) {

$parcel$export(module.exports, "MediaAudioLayoutElement", function () { return $29339da2fb06c92e$export$6c3ae714ac91fc53; });

var $57dmi = parcelRequire("57dmi");

var $fhH8k = parcelRequire("fhH8k");

var $4vwVC = parcelRequire("4vwVC");

var $2u9SC = parcelRequire("2u9SC");

var $9P4tJ = parcelRequire("9P4tJ");

var $97zcJ = parcelRequire("97zcJ");

var $7w04t = parcelRequire("7w04t");

var $kiZDu = parcelRequire("kiZDu");

var $8B3mG = parcelRequire("8B3mG");

var $4E82O = parcelRequire("4E82O");

var $6KfMo = parcelRequire("6KfMo");

var $ciZW6 = parcelRequire("ciZW6");

var $e5L6E = parcelRequire("e5L6E");

var $1dN1L = parcelRequire("1dN1L");

var $gX4mh = parcelRequire("gX4mh");

var $3Oa6Y = parcelRequire("3Oa6Y");


parcelRequire("8hn4v");



parcelRequire("ezUKc");
parcelRequire("fCAPZ");
var $29339da2fb06c92e$var$_DefaultAudioLayout;
let $29339da2fb06c92e$var$DefaultAudioLayout$1 = ($29339da2fb06c92e$var$_DefaultAudioLayout = class DefaultAudioLayout extends (0, $4E82O.DefaultLayout) {
}, (0, $97zcJ._)($29339da2fb06c92e$var$_DefaultAudioLayout, "props", {
    ...(0, $7w04t._)((0, $kiZDu._)($29339da2fb06c92e$var$_DefaultAudioLayout), "props", $29339da2fb06c92e$var$_DefaultAudioLayout),
    when: ({ viewType: viewType })=>viewType === "audio",
    smallWhen: ({ width: width })=>width < 576
}), $29339da2fb06c92e$var$_DefaultAudioLayout);
function $29339da2fb06c92e$var$DefaultAudioLayout() {
    return [
        (0, $4E82O.DefaultAnnouncer)(),
        (0, $4E82O.DefaultCaptions)(),
        (0, $gX4mh.html)`
      <media-controls class="vds-controls">
        <media-controls-group class="vds-controls-group">
          ${[
            (0, $4E82O.DefaultSeekButton)({
                backward: true,
                tooltip: "top start"
            }),
            (0, $4E82O.DefaultPlayButton)({
                tooltip: "top"
            }),
            (0, $4E82O.DefaultSeekButton)({
                tooltip: "top"
            }),
            $29339da2fb06c92e$var$DefaultAudioTitle(),
            (0, $4E82O.DefaultTimeSlider)(),
            (0, $4E82O.DefaultTimeInvert)(),
            (0, $4E82O.DefaultVolumePopup)({
                orientation: "vertical",
                tooltip: "top"
            }),
            (0, $4E82O.DefaultCaptionButton)({
                tooltip: "top"
            }),
            (0, $4E82O.DefaultDownloadButton)(),
            (0, $4E82O.DefaultAirPlayButton)({
                tooltip: "top"
            }),
            $29339da2fb06c92e$var$DefaultAudioMenus()
        ]}
        </media-controls-group>
      </media-controls>
    `
    ];
}
function $29339da2fb06c92e$var$DefaultAudioTitle() {
    return (0, $e5L6E.$signal)(()=>{
        let $ref = (0, $8B3mG.signal)(void 0), $isTextOverflowing = (0, $8B3mG.signal)(false), media = (0, $6KfMo.useMediaContext)(), { title: title, started: started, currentTime: currentTime, ended: ended } = (0, $6KfMo.useMediaState)(), { translations: translations } = (0, $4E82O.useDefaultLayoutContext)(), $isTransitionActive = (0, $ciZW6.useTransitionActive)($ref), $isContinued = ()=>started() || currentTime() > 0;
        const $title = ()=>{
            const word = ended() ? "Replay" : $isContinued() ? "Continue" : "Play";
            return `${(0, $4E82O.i18n)(translations, word)}: ${title()}`;
        };
        (0, $8B3mG.effect)(()=>{
            if ($isTransitionActive() && document.activeElement === document.body) media.player.el?.focus({
                preventScroll: true
            });
        });
        function onResize() {
            const el = $ref(), isOverflowing = !!el && !$isTransitionActive() && el.clientWidth < el.children[0].clientWidth;
            el && (0, $8B3mG.toggleClass)(el, "vds-marquee", isOverflowing);
            $isTextOverflowing.set(isOverflowing);
        }
        function Title() {
            return (0, $gX4mh.html)`
        <span class="vds-title-text">
          ${(0, $e5L6E.$signal)($title)}${(0, $e5L6E.$signal)(()=>$isContinued() ? (0, $4E82O.DefaultChapterTitle)() : null)}
        </span>
      `;
        }
        (0, $ciZW6.useResizeObserver)($ref, onResize);
        return title() ? (0, $gX4mh.html)`
          <span class="vds-title" title=${(0, $e5L6E.$signal)($title)} ${(0, $3Oa6Y.ref)($ref.set)}>
            ${[
            Title(),
            (0, $e5L6E.$signal)(()=>$isTextOverflowing() && !$isTransitionActive() ? Title() : null)
        ]}
          </span>
        ` : (0, $4E82O.DefaultControlsSpacer)();
    });
}
function $29339da2fb06c92e$var$DefaultAudioMenus() {
    const placement = "top end";
    return [
        (0, $4E82O.DefaultChaptersMenu)({
            tooltip: "top",
            placement: placement,
            portal: true
        }),
        (0, $4E82O.DefaultSettingsMenu)({
            tooltip: "top end",
            placement: placement,
            portal: true
        })
    ];
}
var $29339da2fb06c92e$var$_Host, $29339da2fb06c92e$var$_media = /*#__PURE__*/ new WeakMap(), $29339da2fb06c92e$var$_scrubbing = /*#__PURE__*/ new WeakMap(), $29339da2fb06c92e$var$_render = /*#__PURE__*/ new WeakSet(), $29339da2fb06c92e$var$_setupMenuContainer = /*#__PURE__*/ new WeakSet(), $29339da2fb06c92e$var$_setupWatchScrubbing = /*#__PURE__*/ new WeakSet(), $29339da2fb06c92e$var$_watchScrubbing = /*#__PURE__*/ new WeakSet(), $29339da2fb06c92e$var$_onStartScrubbing = /*#__PURE__*/ new WeakSet(), $29339da2fb06c92e$var$_onStopScrubbing = /*#__PURE__*/ new WeakSet();
class $29339da2fb06c92e$export$6c3ae714ac91fc53 extends ($29339da2fb06c92e$var$_Host = (0, $8B3mG.Host)((0, $1dN1L.LitElement), $29339da2fb06c92e$var$DefaultAudioLayout$1)) {
    onSetup() {
        this.forwardKeepAlive = false;
        (0, $4vwVC._)(this, $29339da2fb06c92e$var$_media, (0, $6KfMo.useMediaContext)());
        this.classList.add("vds-audio-layout");
        (0, $2u9SC._)(this, $29339da2fb06c92e$var$_setupWatchScrubbing, $29339da2fb06c92e$var$setupWatchScrubbing).call(this);
    }
    onConnect() {
        (0, $4E82O.setLayoutName)("audio", ()=>this.isMatch);
        (0, $2u9SC._)(this, $29339da2fb06c92e$var$_setupMenuContainer, $29339da2fb06c92e$var$setupMenuContainer).call(this);
    }
    render() {
        return (0, $e5L6E.$signal)((0, $2u9SC._)(this, $29339da2fb06c92e$var$_render, $29339da2fb06c92e$var$render).bind(this));
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $29339da2fb06c92e$var$_render);
        (0, $9P4tJ._)(this, $29339da2fb06c92e$var$_setupMenuContainer);
        (0, $9P4tJ._)(this, $29339da2fb06c92e$var$_setupWatchScrubbing);
        (0, $9P4tJ._)(this, $29339da2fb06c92e$var$_watchScrubbing);
        (0, $9P4tJ._)(this, $29339da2fb06c92e$var$_onStartScrubbing);
        (0, $9P4tJ._)(this, $29339da2fb06c92e$var$_onStopScrubbing);
        (0, $fhH8k._)(this, $29339da2fb06c92e$var$_media, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $29339da2fb06c92e$var$_scrubbing, {
            writable: true,
            value: (0, $8B3mG.signal)(false)
        });
    }
}
(0, $97zcJ._)($29339da2fb06c92e$export$6c3ae714ac91fc53, "tagName", "media-audio-layout");
(0, $97zcJ._)($29339da2fb06c92e$export$6c3ae714ac91fc53, "attrs", {
    smallWhen: {
        converter (value) {
            return value !== "never" && !!value;
        }
    }
});
function $29339da2fb06c92e$var$render() {
    return this.isMatch ? $29339da2fb06c92e$var$DefaultAudioLayout() : null;
}
function $29339da2fb06c92e$var$setupMenuContainer() {
    const { menuPortal: menuPortal } = (0, $4E82O.useDefaultLayoutContext)();
    (0, $8B3mG.effect)(()=>{
        if (!this.isMatch) return;
        const container = (0, $4E82O.createMenuContainer)(this, this.menuContainer, "vds-audio-layout", ()=>this.isSmallLayout), roots = container ? [
            this,
            container
        ] : [
            this
        ];
        const iconsManager = this.$props.customIcons() ? new (0, $e5L6E.SlotManager)(roots) : new (0, $4E82O.DefaultLayoutIconsLoader)(roots);
        iconsManager.connect();
        menuPortal.set(container);
        return ()=>{
            container.remove();
            menuPortal.set(null);
        };
    });
}
function $29339da2fb06c92e$var$setupWatchScrubbing() {
    const { pointer: pointer } = (0, $57dmi._)(this, $29339da2fb06c92e$var$_media).$state;
    (0, $8B3mG.effect)(()=>{
        if (pointer() !== "coarse") return;
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $29339da2fb06c92e$var$_watchScrubbing, $29339da2fb06c92e$var$watchScrubbing).bind(this));
    });
}
function $29339da2fb06c92e$var$watchScrubbing() {
    if (!(0, $57dmi._)(this, $29339da2fb06c92e$var$_scrubbing).call(this)) {
        (0, $8B3mG.listenEvent)(this, "pointerdown", (0, $2u9SC._)(this, $29339da2fb06c92e$var$_onStartScrubbing, $29339da2fb06c92e$var$onStartScrubbing).bind(this), {
            capture: true
        });
        return;
    }
    (0, $8B3mG.listenEvent)(this, "pointerdown", (e)=>e.stopPropagation());
    (0, $8B3mG.listenEvent)(window, "pointerdown", (0, $2u9SC._)(this, $29339da2fb06c92e$var$_onStopScrubbing, $29339da2fb06c92e$var$onStopScrubbing).bind(this));
}
function $29339da2fb06c92e$var$onStartScrubbing(event) {
    const { target: target } = event, hasTimeSlider = !!((0, $ciZW6.isHTMLElement)(target) && target.closest(".vds-time-slider"));
    if (!hasTimeSlider) return;
    event.stopImmediatePropagation();
    this.setAttribute("data-scrubbing", "");
    (0, $57dmi._)(this, $29339da2fb06c92e$var$_scrubbing).set(true);
}
function $29339da2fb06c92e$var$onStopScrubbing() {
    (0, $57dmi._)(this, $29339da2fb06c92e$var$_scrubbing).set(false);
    this.removeAttribute("data-scrubbing");
}

});
parcelRegister("7w04t", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $578b93ac1a1fa15c$export$71511d61b312f219; });

var $5y3kZ = parcelRequire("5y3kZ");
function $578b93ac1a1fa15c$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $578b93ac1a1fa15c$export$71511d61b312f219 = Reflect.get;
    else $578b93ac1a1fa15c$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $5y3kZ._)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $578b93ac1a1fa15c$export$71511d61b312f219(target, property, receiver || target);
}

});
parcelRegister("5y3kZ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $40a2b77ed0cedd24$export$71511d61b312f219; });

var $kiZDu = parcelRequire("kiZDu");
function $40a2b77ed0cedd24$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $kiZDu._)(object);
        if (object === null) break;
    }
    return object;
}

});
parcelRegister("kiZDu", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ec854cae4bb6e30c$export$71511d61b312f219; });
function $ec854cae4bb6e30c$export$71511d61b312f219(o) {
    $ec854cae4bb6e30c$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ec854cae4bb6e30c$export$71511d61b312f219(o);
}

});



parcelRegister("4E82O", function(module, exports) {

$parcel$export(module.exports, "useDefaultLayoutContext", function () { return $362123485be3cdce$export$46f4c66a779bac51; });
$parcel$export(module.exports, "DefaultLayout", function () { return $362123485be3cdce$export$a6a66093eadb740; });
$parcel$export(module.exports, "setLayoutName", function () { return $362123485be3cdce$export$b6c742106577527b; });
$parcel$export(module.exports, "i18n", function () { return $362123485be3cdce$export$a7357cdd1f0b0168; });
$parcel$export(module.exports, "DefaultAnnouncer", function () { return $362123485be3cdce$export$dc68e6bd156a8574; });
$parcel$export(module.exports, "DefaultAirPlayButton", function () { return $362123485be3cdce$export$c85b19f225334737; });
$parcel$export(module.exports, "DefaultGoogleCastButton", function () { return $362123485be3cdce$export$5c01f6baabf8bf00; });
$parcel$export(module.exports, "DefaultPlayButton", function () { return $362123485be3cdce$export$8254a25b426f2e13; });
$parcel$export(module.exports, "DefaultCaptionButton", function () { return $362123485be3cdce$export$bb5ec99a1f51be8e; });
$parcel$export(module.exports, "DefaultPIPButton", function () { return $362123485be3cdce$export$e93929dfe72914a1; });
$parcel$export(module.exports, "DefaultFullscreenButton", function () { return $362123485be3cdce$export$465a642cc36d7208; });
$parcel$export(module.exports, "DefaultSeekButton", function () { return $362123485be3cdce$export$bc210ee100eac242; });
$parcel$export(module.exports, "DefaultDownloadButton", function () { return $362123485be3cdce$export$40a62cc9435cd002; });
$parcel$export(module.exports, "DefaultCaptions", function () { return $362123485be3cdce$export$f0914ef976c7fb99; });
$parcel$export(module.exports, "DefaultControlsSpacer", function () { return $362123485be3cdce$export$bea531b661a1b080; });
$parcel$export(module.exports, "createMenuContainer", function () { return $362123485be3cdce$export$47eeb6d3738d41bc; });
$parcel$export(module.exports, "DefaultChaptersMenu", function () { return $362123485be3cdce$export$a16bca1414b426a6; });
$parcel$export(module.exports, "DefaultSettingsMenu", function () { return $362123485be3cdce$export$275cf529611de599; });
$parcel$export(module.exports, "DefaultVolumePopup", function () { return $362123485be3cdce$export$12ffac1a5abb1f72; });
$parcel$export(module.exports, "DefaultTimeSlider", function () { return $362123485be3cdce$export$f5a82b0f6b290195; });
$parcel$export(module.exports, "DefaultTimeInvert", function () { return $362123485be3cdce$export$5a9920dbdd1268df; });
$parcel$export(module.exports, "DefaultTimeInfo", function () { return $362123485be3cdce$export$724e13efab671e72; });
$parcel$export(module.exports, "DefaultTitle", function () { return $362123485be3cdce$export$772e6bb8c71f8823; });
$parcel$export(module.exports, "DefaultChapterTitle", function () { return $362123485be3cdce$export$2c1c19d12926b7c0; });
$parcel$export(module.exports, "DefaultLayoutIconsLoader", function () { return $362123485be3cdce$export$eb8cb61fa2f12073; });

var $57dmi = parcelRequire("57dmi");

var $fhH8k = parcelRequire("fhH8k");

var $4vwVC = parcelRequire("4vwVC");

var $2u9SC = parcelRequire("2u9SC");

var $9P4tJ = parcelRequire("9P4tJ");

var $97zcJ = parcelRequire("97zcJ");

var $8B3mG = parcelRequire("8B3mG");

var $6KfMo = parcelRequire("6KfMo");

var $ciZW6 = parcelRequire("ciZW6");

var $gX4mh = parcelRequire("gX4mh");

var $e5L6E = parcelRequire("e5L6E");

var $l6thX = parcelRequire("l6thX");

var $jrniq = parcelRequire("jrniq");

var $8hn4v = parcelRequire("8hn4v");

var $3Oa6Y = parcelRequire("3Oa6Y");

var $dLb9W = parcelRequire("dLb9W");
const $362123485be3cdce$var$defaultLayoutContext = (0, $8B3mG.createContext)();
function $362123485be3cdce$export$46f4c66a779bac51() {
    return (0, $8B3mG.useContext)($362123485be3cdce$var$defaultLayoutContext);
}
const $362123485be3cdce$var$defaultLayoutProps = {
    colorScheme: "system",
    download: null,
    customIcons: false,
    disableTimeSlider: false,
    menuContainer: null,
    menuGroup: "bottom",
    noAudioGain: false,
    noGestures: false,
    noKeyboardAnimations: false,
    noModal: false,
    noScrubGesture: false,
    playbackRates: {
        min: 0,
        max: 2,
        step: 0.25
    },
    audioGains: {
        min: 0,
        max: 300,
        step: 25
    },
    seekStep: 10,
    sliderChaptersMinWidth: 325,
    hideQualityBitrate: false,
    smallWhen: false,
    thumbnails: null,
    translations: null,
    when: false
};
var $362123485be3cdce$var$_media = /*#__PURE__*/ new WeakMap(), $362123485be3cdce$var$_when = /*#__PURE__*/ new WeakMap(), $362123485be3cdce$var$_smallWhen = /*#__PURE__*/ new WeakMap(), $362123485be3cdce$var$_matches = /*#__PURE__*/ new WeakSet();
class $362123485be3cdce$export$a6a66093eadb740 extends (0, $8B3mG.Component) {
    get isMatch() {
        return (0, $57dmi._)(this, $362123485be3cdce$var$_when).call(this);
    }
    get isSmallLayout() {
        return (0, $57dmi._)(this, $362123485be3cdce$var$_smallWhen).call(this);
    }
    onSetup() {
        (0, $4vwVC._)(this, $362123485be3cdce$var$_media, (0, $6KfMo.useMediaContext)());
        this.setAttributes({
            "data-match": (0, $57dmi._)(this, $362123485be3cdce$var$_when),
            "data-sm": ()=>(0, $57dmi._)(this, $362123485be3cdce$var$_smallWhen).call(this) ? "" : null,
            "data-lg": ()=>!(0, $57dmi._)(this, $362123485be3cdce$var$_smallWhen).call(this) ? "" : null,
            "data-size": ()=>(0, $57dmi._)(this, $362123485be3cdce$var$_smallWhen).call(this) ? "sm" : "lg",
            "data-no-scrub-gesture": this.$props.noScrubGesture
        });
        (0, $8B3mG.provideContext)($362123485be3cdce$var$defaultLayoutContext, {
            ...this.$props,
            when: (0, $57dmi._)(this, $362123485be3cdce$var$_when),
            smallWhen: (0, $57dmi._)(this, $362123485be3cdce$var$_smallWhen),
            userPrefersAnnouncements: (0, $8B3mG.signal)(true),
            userPrefersKeyboardAnimations: (0, $8B3mG.signal)(true),
            menuPortal: (0, $8B3mG.signal)(null)
        });
    }
    onAttach(el) {
        (0, $ciZW6.watchColorScheme)(el, this.$props.colorScheme);
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $362123485be3cdce$var$_matches);
        (0, $fhH8k._)(this, $362123485be3cdce$var$_media, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $362123485be3cdce$var$_when, {
            writable: true,
            value: (0, $8B3mG.computed)(()=>{
                const when = this.$props.when();
                return (0, $2u9SC._)(this, $362123485be3cdce$var$_matches, $362123485be3cdce$var$matches).call(this, when);
            })
        });
        (0, $fhH8k._)(this, $362123485be3cdce$var$_smallWhen, {
            writable: true,
            value: (0, $8B3mG.computed)(()=>{
                const when = this.$props.smallWhen();
                return (0, $2u9SC._)(this, $362123485be3cdce$var$_matches, $362123485be3cdce$var$matches).call(this, when);
            })
        });
    }
}
(0, $97zcJ._)($362123485be3cdce$export$a6a66093eadb740, "props", $362123485be3cdce$var$defaultLayoutProps);
function $362123485be3cdce$var$matches(query) {
    return query !== "never" && ((0, $8B3mG.isBoolean)(query) ? query : (0, $8B3mG.computed)(()=>query((0, $57dmi._)(this, $362123485be3cdce$var$_media).player.state))());
}
const $362123485be3cdce$var$defaultlayout__proto = $362123485be3cdce$export$a6a66093eadb740.prototype;
(0, $8B3mG.prop)($362123485be3cdce$var$defaultlayout__proto, "isMatch");
(0, $8B3mG.prop)($362123485be3cdce$var$defaultlayout__proto, "isSmallLayout");
function $362123485be3cdce$export$b6c742106577527b(name, isMatch) {
    (0, $8B3mG.effect)(()=>{
        const { player: player } = (0, $6KfMo.useMediaContext)(), el = player.el;
        el && (0, $8B3mG.setAttribute)(el, "data-layout", isMatch() && name);
        return ()=>el?.removeAttribute("data-layout");
    });
}
function $362123485be3cdce$export$a7357cdd1f0b0168(translations, word) {
    return translations()?.[word] ?? word;
}
function $362123485be3cdce$export$dc68e6bd156a8574() {
    return (0, $e5L6E.$signal)(()=>{
        const { translations: translations, userPrefersAnnouncements: userPrefersAnnouncements } = $362123485be3cdce$export$46f4c66a779bac51();
        if (!userPrefersAnnouncements()) return null;
        return (0, $gX4mh.html)`<media-announcer .translations=${(0, $e5L6E.$signal)(translations)}></media-announcer>`;
    });
}
function $362123485be3cdce$var$IconSlot(name, classes = "") {
    return (0, $gX4mh.html)`<slot
    name=${`${name}-icon`}
    data-class=${`vds-icon vds-${name}-icon${classes ? ` ${classes}` : ""}`}
  ></slot>`;
}
function $362123485be3cdce$var$IconSlots(names) {
    return names.map((name)=>$362123485be3cdce$var$IconSlot(name));
}
function $362123485be3cdce$var$$i18n(translations, word) {
    return (0, $e5L6E.$signal)(()=>$362123485be3cdce$export$a7357cdd1f0b0168(translations, word));
}
function $362123485be3cdce$export$c85b19f225334737({ tooltip: tooltip }) {
    const { translations: translations } = $362123485be3cdce$export$46f4c66a779bac51(), { remotePlaybackState: remotePlaybackState } = (0, $6KfMo.useMediaState)(), $label = (0, $e5L6E.$signal)(()=>{
        const airPlayText = $362123485be3cdce$export$a7357cdd1f0b0168(translations, "AirPlay"), stateText = (0, $8B3mG.uppercaseFirstChar)(remotePlaybackState());
        return `${airPlayText} ${stateText}`;
    }), $airPlayText = $362123485be3cdce$var$$i18n(translations, "AirPlay");
    return (0, $gX4mh.html)`
    <media-tooltip class="vds-airplay-tooltip vds-tooltip">
      <media-tooltip-trigger>
        <media-airplay-button class="vds-airplay-button vds-button" aria-label=${$label}>
          ${$362123485be3cdce$var$IconSlot("airplay")}
        </media-airplay-button>
      </media-tooltip-trigger>
      <media-tooltip-content class="vds-tooltip-content" placement=${tooltip}>
        <span class="vds-airplay-tooltip-text">${$airPlayText}</span>
      </media-tooltip-content>
    </media-tooltip>
  `;
}
function $362123485be3cdce$export$5c01f6baabf8bf00({ tooltip: tooltip }) {
    const { translations: translations } = $362123485be3cdce$export$46f4c66a779bac51(), { remotePlaybackState: remotePlaybackState } = (0, $6KfMo.useMediaState)(), $label = (0, $e5L6E.$signal)(()=>{
        const googleCastText = $362123485be3cdce$export$a7357cdd1f0b0168(translations, "Google Cast"), stateText = (0, $8B3mG.uppercaseFirstChar)(remotePlaybackState());
        return `${googleCastText} ${stateText}`;
    }), $googleCastText = $362123485be3cdce$var$$i18n(translations, "Google Cast");
    return (0, $gX4mh.html)`
    <media-tooltip class="vds-google-cast-tooltip vds-tooltip">
      <media-tooltip-trigger>
        <media-google-cast-button class="vds-google-cast-button vds-button" aria-label=${$label}>
          ${$362123485be3cdce$var$IconSlot("google-cast")}
        </media-google-cast-button>
      </media-tooltip-trigger>
      <media-tooltip-content class="vds-tooltip-content" placement=${tooltip}>
        <span class="vds-google-cast-tooltip-text">${$googleCastText}</span>
      </media-tooltip-content>
    </media-tooltip>
  `;
}
function $362123485be3cdce$export$8254a25b426f2e13({ tooltip: tooltip }) {
    const { translations: translations } = $362123485be3cdce$export$46f4c66a779bac51(), $playText = $362123485be3cdce$var$$i18n(translations, "Play"), $pauseText = $362123485be3cdce$var$$i18n(translations, "Pause");
    return (0, $gX4mh.html)`
    <media-tooltip class="vds-play-tooltip vds-tooltip">
      <media-tooltip-trigger>
        <media-play-button
          class="vds-play-button vds-button"
          aria-label=${$362123485be3cdce$var$$i18n(translations, "Play")}
        >
          ${$362123485be3cdce$var$IconSlots([
        "play",
        "pause",
        "replay"
    ])}
        </media-play-button>
      </media-tooltip-trigger>
      <media-tooltip-content class="vds-tooltip-content" placement=${tooltip}>
        <span class="vds-play-tooltip-text">${$playText}</span>
        <span class="vds-pause-tooltip-text">${$pauseText}</span>
      </media-tooltip-content>
    </media-tooltip>
  `;
}
function $362123485be3cdce$var$DefaultMuteButton({ tooltip: tooltip, ref: ref$1 = (0, $8B3mG.noop) }) {
    const { translations: translations } = $362123485be3cdce$export$46f4c66a779bac51(), $muteText = $362123485be3cdce$var$$i18n(translations, "Mute"), $unmuteText = $362123485be3cdce$var$$i18n(translations, "Unmute");
    return (0, $gX4mh.html)`
    <media-tooltip class="vds-mute-tooltip vds-tooltip">
      <media-tooltip-trigger>
        <media-mute-button
          class="vds-mute-button vds-button"
          aria-label=${$362123485be3cdce$var$$i18n(translations, "Mute")}
          ${(0, $3Oa6Y.ref)(ref$1)}
        >
          ${$362123485be3cdce$var$IconSlots([
        "mute",
        "volume-low",
        "volume-high"
    ])}
        </media-mute-button>
      </media-tooltip-trigger>
      <media-tooltip-content class="vds-tooltip-content" placement=${tooltip}>
        <span class="vds-mute-tooltip-text">${$unmuteText}</span>
        <span class="vds-unmute-tooltip-text">${$muteText}</span>
      </media-tooltip-content>
    </media-tooltip>
  `;
}
function $362123485be3cdce$export$bb5ec99a1f51be8e({ tooltip: tooltip }) {
    const { translations: translations } = $362123485be3cdce$export$46f4c66a779bac51(), $ccOnText = $362123485be3cdce$var$$i18n(translations, "Closed-Captions On"), $ccOffText = $362123485be3cdce$var$$i18n(translations, "Closed-Captions Off");
    return (0, $gX4mh.html)`
    <media-tooltip class="vds-caption-tooltip vds-tooltip">
      <media-tooltip-trigger>
        <media-caption-button
          class="vds-caption-button vds-button"
          aria-label=${$362123485be3cdce$var$$i18n(translations, "Captions")}
        >
          ${$362123485be3cdce$var$IconSlots([
        "cc-on",
        "cc-off"
    ])}
        </media-caption-button>
      </media-tooltip-trigger>
      <media-tooltip-content class="vds-tooltip-content" placement=${tooltip}>
        <span class="vds-cc-on-tooltip-text">${$ccOffText}</span>
        <span class="vds-cc-off-tooltip-text">${$ccOnText}</span>
      </media-tooltip-content>
    </media-tooltip>
  `;
}
function $362123485be3cdce$export$e93929dfe72914a1() {
    const { translations: translations } = $362123485be3cdce$export$46f4c66a779bac51(), $enterText = $362123485be3cdce$var$$i18n(translations, "Enter PiP"), $exitText = $362123485be3cdce$var$$i18n(translations, "Exit PiP");
    return (0, $gX4mh.html)`
    <media-tooltip class="vds-pip-tooltip vds-tooltip">
      <media-tooltip-trigger>
        <media-pip-button
          class="vds-pip-button vds-button"
          aria-label=${$362123485be3cdce$var$$i18n(translations, "PiP")}
        >
          ${$362123485be3cdce$var$IconSlots([
        "pip-enter",
        "pip-exit"
    ])}
        </media-pip-button>
      </media-tooltip-trigger>
      <media-tooltip-content class="vds-tooltip-content">
        <span class="vds-pip-enter-tooltip-text">${$enterText}</span>
        <span class="vds-pip-exit-tooltip-text">${$exitText}</span>
      </media-tooltip-content>
    </media-tooltip>
  `;
}
function $362123485be3cdce$export$465a642cc36d7208({ tooltip: tooltip }) {
    const { translations: translations } = $362123485be3cdce$export$46f4c66a779bac51(), $enterText = $362123485be3cdce$var$$i18n(translations, "Enter Fullscreen"), $exitText = $362123485be3cdce$var$$i18n(translations, "Exit Fullscreen");
    return (0, $gX4mh.html)`
    <media-tooltip class="vds-fullscreen-tooltip vds-tooltip">
      <media-tooltip-trigger>
        <media-fullscreen-button
          class="vds-fullscreen-button vds-button"
          aria-label=${$362123485be3cdce$var$$i18n(translations, "Fullscreen")}
        >
          ${$362123485be3cdce$var$IconSlots([
        "fs-enter",
        "fs-exit"
    ])}
        </media-fullscreen-button>
      </media-tooltip-trigger>
      <media-tooltip-content class="vds-tooltip-content" placement=${tooltip}>
        <span class="vds-fs-enter-tooltip-text">${$enterText}</span>
        <span class="vds-fs-exit-tooltip-text">${$exitText}</span>
      </media-tooltip-content>
    </media-tooltip>
  `;
}
function $362123485be3cdce$export$bc210ee100eac242({ backward: backward, tooltip: tooltip }) {
    const { translations: translations, seekStep: seekStep } = $362123485be3cdce$export$46f4c66a779bac51(), seekText = !backward ? "Seek Forward" : "Seek Backward", $label = $362123485be3cdce$var$$i18n(translations, seekText), $seconds = ()=>(backward ? -1 : 1) * seekStep();
    return (0, $gX4mh.html)`
    <media-tooltip class="vds-seek-tooltip vds-tooltip">
      <media-tooltip-trigger>
        <media-seek-button
          class="vds-seek-button vds-button"
          seconds=${(0, $e5L6E.$signal)($seconds)}
          aria-label=${$label}
        >
          ${!backward ? $362123485be3cdce$var$IconSlot("seek-forward") : $362123485be3cdce$var$IconSlot("seek-backward")}
        </media-seek-button>
      </media-tooltip-trigger>
      <media-tooltip-content class="vds-tooltip-content" placement=${tooltip}>
        ${$362123485be3cdce$var$$i18n(translations, seekText)}
      </media-tooltip-content>
    </media-tooltip>
  `;
}
function $362123485be3cdce$var$DefaultLiveButton() {
    const { translations: translations } = $362123485be3cdce$export$46f4c66a779bac51(), { live: live } = (0, $6KfMo.useMediaState)(), $label = $362123485be3cdce$var$$i18n(translations, "Skip To Live"), $liveText = $362123485be3cdce$var$$i18n(translations, "LIVE");
    return live() ? (0, $gX4mh.html)`
        <media-live-button class="vds-live-button" aria-label=${$label}>
          <span class="vds-live-button-text">${$liveText}</span>
        </media-live-button>
      ` : null;
}
function $362123485be3cdce$export$40a62cc9435cd002() {
    return (0, $e5L6E.$signal)(()=>{
        const { download: download, translations: translations } = $362123485be3cdce$export$46f4c66a779bac51(), $download = download();
        if ((0, $8B3mG.isNil)($download)) return null;
        const { source: source, title: title } = (0, $6KfMo.useMediaState)(), $src = source(), file = (0, $dLb9W.getDownloadFile)({
            title: title(),
            src: $src,
            download: $download
        });
        return file ? (0, $gX4mh.html)`
          <media-tooltip class="vds-download-tooltip vds-tooltip">
            <media-tooltip-trigger>
              <a
                role="button"
                class="vds-download-button vds-button"
                aria-label=${$362123485be3cdce$var$$i18n(translations, "Download")}
                href=${file.url + `?download=${file.name}`}
                download=${file.name}
                target="_blank"
              >
                <slot name="download-icon" data-class="vds-icon" />
              </a>
            </media-tooltip-trigger>
            <media-tooltip-content class="vds-tooltip-content" placement="top">
              ${$362123485be3cdce$var$$i18n(translations, "Download")}
            </media-tooltip-content>
          </media-tooltip>
        ` : null;
    });
}
function $362123485be3cdce$export$f0914ef976c7fb99() {
    const { translations: translations } = $362123485be3cdce$export$46f4c66a779bac51();
    return (0, $gX4mh.html)`
    <media-captions
      class="vds-captions"
      .exampleText=${$362123485be3cdce$var$$i18n(translations, "Captions look like this")}
    ></media-captions>
  `;
}
function $362123485be3cdce$export$bea531b661a1b080() {
    return (0, $gX4mh.html)`<div class="vds-controls-spacer"></div>`;
}
function $362123485be3cdce$var$MenuPortal(container, template) {
    return (0, $gX4mh.html)`
    <media-menu-portal .container=${(0, $e5L6E.$signal)(container)} disabled="fullscreen">
      ${template}
    </media-menu-portal>
  `;
}
function $362123485be3cdce$export$47eeb6d3738d41bc(layoutEl, rootSelector, className, isSmallLayout) {
    let root = (0, $8B3mG.isString)(rootSelector) ? document.querySelector(rootSelector) : rootSelector;
    if (!root) root = layoutEl?.closest("dialog");
    if (!root) root = document.body;
    const container = document.createElement("div");
    container.style.display = "contents";
    container.classList.add(className);
    root.append(container);
    (0, $8B3mG.effect)(()=>{
        if (!container) return;
        const { viewType: viewType } = (0, $6KfMo.useMediaState)(), isSmall = isSmallLayout();
        (0, $8B3mG.setAttribute)(container, "data-view-type", viewType());
        (0, $8B3mG.setAttribute)(container, "data-sm", isSmall);
        (0, $8B3mG.setAttribute)(container, "data-lg", !isSmall);
        (0, $8B3mG.setAttribute)(container, "data-size", isSmall ? "sm" : "lg");
    });
    const { colorScheme: colorScheme } = $362123485be3cdce$export$46f4c66a779bac51();
    (0, $ciZW6.watchColorScheme)(container, colorScheme);
    return container;
}
function $362123485be3cdce$export$a16bca1414b426a6({ placement: placement, tooltip: tooltip, portal: portal }) {
    const { textTracks: textTracks } = (0, $6KfMo.useMediaContext)(), { viewType: viewType, clipStartTime: clipStartTime, clipEndTime: clipEndTime } = (0, $6KfMo.useMediaState)(), { translations: translations, thumbnails: thumbnails, menuPortal: menuPortal, noModal: noModal, menuGroup: menuGroup, smallWhen: smWhen } = $362123485be3cdce$export$46f4c66a779bac51(), $disabled = (0, $8B3mG.computed)(()=>{
        const $startTime = clipStartTime(), $endTime = clipEndTime() || Infinity, $track = (0, $8B3mG.signal)(null);
        (0, $l6thX.watchActiveTextTrack)(textTracks, "chapters", $track.set);
        const cues = $track()?.cues.filter((cue)=>cue.startTime <= $endTime && cue.endTime >= $startTime);
        return !cues?.length;
    });
    if ($disabled()) return null;
    const $placement = (0, $8B3mG.computed)(()=>noModal() ? (0, $8B3mG.unwrap)(placement) : !smWhen() ? (0, $8B3mG.unwrap)(placement) : null), $offset = (0, $8B3mG.computed)(()=>!smWhen() && menuGroup() === "bottom" && viewType() === "video" ? 26 : 0), $isOpen = (0, $8B3mG.signal)(false);
    function onOpen() {
        $isOpen.set(true);
    }
    function onClose() {
        $isOpen.set(false);
    }
    const items = (0, $gX4mh.html)`
    <media-menu-items
      class="vds-chapters-menu-items vds-menu-items"
      placement=${(0, $e5L6E.$signal)($placement)}
      offset=${(0, $e5L6E.$signal)($offset)}
    >
      ${(0, $e5L6E.$signal)(()=>{
        if (!$isOpen()) return null;
        return (0, $gX4mh.html)`
          <media-chapters-radio-group
            class="vds-chapters-radio-group vds-radio-group"
            .thumbnails=${(0, $e5L6E.$signal)(thumbnails)}
          >
            <template>
              <media-radio class="vds-chapter-radio vds-radio">
                <media-thumbnail class="vds-thumbnail"></media-thumbnail>
                <div class="vds-chapter-radio-content">
                  <span class="vds-chapter-radio-label" data-part="label"></span>
                  <span class="vds-chapter-radio-start-time" data-part="start-time"></span>
                  <span class="vds-chapter-radio-duration" data-part="duration"></span>
                </div>
              </media-radio>
            </template>
          </media-chapters-radio-group>
        `;
    })}
    </media-menu-items>
  `;
    return (0, $gX4mh.html)`
    <media-menu class="vds-chapters-menu vds-menu" @open=${onOpen} @close=${onClose}>
      <media-tooltip class="vds-tooltip">
        <media-tooltip-trigger>
          <media-menu-button
            class="vds-menu-button vds-button"
            aria-label=${$362123485be3cdce$var$$i18n(translations, "Chapters")}
          >
            ${$362123485be3cdce$var$IconSlot("menu-chapters")}
          </media-menu-button>
        </media-tooltip-trigger>
        <media-tooltip-content
          class="vds-tooltip-content"
          placement=${(0, $8B3mG.isFunction)(tooltip) ? (0, $e5L6E.$signal)(tooltip) : tooltip}
        >
          ${$362123485be3cdce$var$$i18n(translations, "Chapters")}
        </media-tooltip-content>
      </media-tooltip>
      ${portal ? $362123485be3cdce$var$MenuPortal(menuPortal, items) : items}
    </media-menu>
  `;
}
function $362123485be3cdce$var$hexToRgb(hex) {
    const { style: style } = new Option();
    style.color = hex;
    return style.color.match(/\((.*?)\)/)[1].replace(/,/g, " ");
}
const $362123485be3cdce$var$FONT_COLOR_OPTION = {
    type: "color"
};
const $362123485be3cdce$var$FONT_FAMILY_OPTION = {
    type: "radio",
    values: {
        "Monospaced Serif": "mono-serif",
        "Proportional Serif": "pro-serif",
        "Monospaced Sans-Serif": "mono-sans",
        "Proportional Sans-Serif": "pro-sans",
        Casual: "casual",
        Cursive: "cursive",
        "Small Capitals": "capitals"
    }
};
const $362123485be3cdce$var$FONT_SIZE_OPTION = {
    type: "slider",
    min: 0,
    max: 400,
    step: 25,
    upIcon: null,
    downIcon: null
};
const $362123485be3cdce$var$FONT_OPACITY_OPTION = {
    type: "slider",
    min: 0,
    max: 100,
    step: 5,
    upIcon: null,
    downIcon: null
};
const $362123485be3cdce$var$FONT_TEXT_SHADOW_OPTION = {
    type: "radio",
    values: [
        "None",
        "Drop Shadow",
        "Raised",
        "Depressed",
        "Outline"
    ]
};
const $362123485be3cdce$var$FONT_DEFAULTS = {
    fontFamily: "pro-sans",
    fontSize: "100%",
    textColor: "#ffffff",
    textOpacity: "100%",
    textShadow: "none",
    textBg: "#000000",
    textBgOpacity: "100%",
    displayBg: "#000000",
    displayBgOpacity: "0%"
};
const $362123485be3cdce$var$FONT_SIGNALS = Object.keys($362123485be3cdce$var$FONT_DEFAULTS).reduce((prev, type)=>({
        ...prev,
        [type]: (0, $8B3mG.signal)($362123485be3cdce$var$FONT_DEFAULTS[type])
    }), {});
for (const type of Object.keys($362123485be3cdce$var$FONT_SIGNALS)){
    const value = localStorage.getItem(`vds-player:${(0, $8B3mG.camelToKebabCase)(type)}`);
    if ((0, $8B3mG.isString)(value)) $362123485be3cdce$var$FONT_SIGNALS[type].set(value);
}
function $362123485be3cdce$var$onFontReset() {
    for (const type of Object.keys($362123485be3cdce$var$FONT_SIGNALS)){
        const defaultValue = $362123485be3cdce$var$FONT_DEFAULTS[type];
        $362123485be3cdce$var$FONT_SIGNALS[type].set(defaultValue);
    }
}
let $362123485be3cdce$var$isWatchingVars = false, $362123485be3cdce$var$players = /* @__PURE__ */ new Set();
function $362123485be3cdce$var$updateFontCssVars() {
    const { player: player } = (0, $6KfMo.useMediaContext)();
    $362123485be3cdce$var$players.add(player);
    (0, $8B3mG.onDispose)(()=>$362123485be3cdce$var$players.delete(player));
    if (!$362123485be3cdce$var$isWatchingVars) {
        (0, $8B3mG.scoped)(()=>{
            for (const type of (0, $8B3mG.keysOf)($362123485be3cdce$var$FONT_SIGNALS)){
                const $value = $362123485be3cdce$var$FONT_SIGNALS[type], defaultValue = $362123485be3cdce$var$FONT_DEFAULTS[type], varName = `--media-user-${(0, $8B3mG.camelToKebabCase)(type)}`, storageKey = `vds-player:${(0, $8B3mG.camelToKebabCase)(type)}`;
                (0, $8B3mG.effect)(()=>{
                    const value = $value(), isDefaultVarValue = value === defaultValue, varValue = !isDefaultVarValue ? $362123485be3cdce$var$getCssVarValue(player, type, value) : null;
                    for (const player2 of $362123485be3cdce$var$players)player2.el?.style.setProperty(varName, varValue);
                    if (isDefaultVarValue) localStorage.removeItem(storageKey);
                    else localStorage.setItem(storageKey, value);
                });
            }
        }, null);
        $362123485be3cdce$var$isWatchingVars = true;
    }
}
function $362123485be3cdce$var$getCssVarValue(player, type, value) {
    switch(type){
        case "fontFamily":
            const fontVariant = value === "capitals" ? "small-caps" : "";
            player.el?.style.setProperty("--media-user-font-variant", fontVariant);
            return $362123485be3cdce$var$getFontFamilyCSSVarValue(value);
        case "fontSize":
        case "textOpacity":
        case "textBgOpacity":
        case "displayBgOpacity":
            return $362123485be3cdce$var$percentToRatio(value);
        case "textColor":
            return `rgb(${$362123485be3cdce$var$hexToRgb(value)} / var(--media-user-text-opacity, 1))`;
        case "textShadow":
            return $362123485be3cdce$var$getTextShadowCssVarValue(value);
        case "textBg":
            return `rgb(${$362123485be3cdce$var$hexToRgb(value)} / var(--media-user-text-bg-opacity, 1))`;
        case "displayBg":
            return `rgb(${$362123485be3cdce$var$hexToRgb(value)} / var(--media-user-display-bg-opacity, 1))`;
    }
}
function $362123485be3cdce$var$percentToRatio(value) {
    return (parseInt(value) / 100).toString();
}
function $362123485be3cdce$var$getFontFamilyCSSVarValue(value) {
    switch(value){
        case "mono-serif":
            return '"Courier New", Courier, "Nimbus Mono L", "Cutive Mono", monospace';
        case "mono-sans":
            return '"Deja Vu Sans Mono", "Lucida Console", Monaco, Consolas, "PT Mono", monospace';
        case "pro-sans":
            return 'Roboto, "Arial Unicode Ms", Arial, Helvetica, Verdana, "PT Sans Caption", sans-serif';
        case "casual":
            return '"Comic Sans MS", Impact, Handlee, fantasy';
        case "cursive":
            return '"Monotype Corsiva", "URW Chancery L", "Apple Chancery", "Dancing Script", cursive';
        case "capitals":
            return '"Arial Unicode Ms", Arial, Helvetica, Verdana, "Marcellus SC", sans-serif + font-variant=small-caps';
        default:
            return '"Times New Roman", Times, Georgia, Cambria, "PT Serif Caption", serif';
    }
}
function $362123485be3cdce$var$getTextShadowCssVarValue(value) {
    switch(value){
        case "drop shadow":
            return "rgb(34, 34, 34) 1.86389px 1.86389px 2.79583px, rgb(34, 34, 34) 1.86389px 1.86389px 3.72778px, rgb(34, 34, 34) 1.86389px 1.86389px 4.65972px";
        case "raised":
            return "rgb(34, 34, 34) 1px 1px, rgb(34, 34, 34) 2px 2px";
        case "depressed":
            return "rgb(204, 204, 204) 1px 1px, rgb(34, 34, 34) -1px -1px";
        case "outline":
            return "rgb(34, 34, 34) 0px 0px 1.86389px, rgb(34, 34, 34) 0px 0px 1.86389px, rgb(34, 34, 34) 0px 0px 1.86389px, rgb(34, 34, 34) 0px 0px 1.86389px, rgb(34, 34, 34) 0px 0px 1.86389px";
        default:
            return "";
    }
}
let $362123485be3cdce$var$sectionId = 0;
function $362123485be3cdce$var$DefaultMenuSection({ label: label = "", value: value = "", children: children }) {
    if (!label) return (0, $gX4mh.html)`
      <div class="vds-menu-section">
        <div class="vds-menu-section-body">${children}</div>
      </div>
    `;
    const id = `vds-menu-section-${++$362123485be3cdce$var$sectionId}`;
    return (0, $gX4mh.html)`
    <section class="vds-menu-section" role="group" aria-labelledby=${id}>
      <div class="vds-menu-section-title">
        <header id=${id}>${label}</header>
        ${value ? (0, $gX4mh.html)`<div class="vds-menu-section-value">${value}</div>` : null}
      </div>
      <div class="vds-menu-section-body">${children}</div>
    </section>
  `;
}
function $362123485be3cdce$var$DefaultMenuItem({ label: label, children: children }) {
    return (0, $gX4mh.html)`
    <div class="vds-menu-item">
      <div class="vds-menu-item-label">${label}</div>
      ${children}
    </div>
  `;
}
function $362123485be3cdce$var$DefaultMenuButton({ label: label, icon: icon, hint: hint }) {
    return (0, $gX4mh.html)`
    <media-menu-button class="vds-menu-item">
      ${$362123485be3cdce$var$IconSlot("menu-arrow-left", "vds-menu-close-icon")}
      ${icon ? $362123485be3cdce$var$IconSlot(icon, "vds-menu-item-icon") : null}
      <span class="vds-menu-item-label">${(0, $e5L6E.$signal)(label)}</span>
      <span class="vds-menu-item-hint" data-part="hint">${hint ? (0, $e5L6E.$signal)(hint) : null} </span>
      ${$362123485be3cdce$var$IconSlot("menu-arrow-right", "vds-menu-open-icon")}
    </media-menu-button>
  `;
}
function $362123485be3cdce$var$DefaultRadioGroup({ value: value = null, options: options, hideLabel: hideLabel = false, children: children = null, onChange: onChange = null }) {
    function renderRadio(option) {
        const { value: value2, label: content } = option;
        return (0, $gX4mh.html)`
      <media-radio class="vds-radio" value=${value2}>
        ${$362123485be3cdce$var$IconSlot("menu-radio-check")}
        ${!hideLabel ? (0, $gX4mh.html)`
              <span class="vds-radio-label" data-part="label">
                ${(0, $8B3mG.isString)(content) ? content : (0, $e5L6E.$signal)(content)}
              </span>
            ` : null}
        ${(0, $8B3mG.isFunction)(children) ? children(option) : children}
      </media-radio>
    `;
    }
    return (0, $gX4mh.html)`
    <media-radio-group
      class="vds-radio-group"
      value=${(0, $8B3mG.isString)(value) ? value : value ? (0, $e5L6E.$signal)(value) : ""}
      @change=${onChange}
    >
      ${(0, $8B3mG.isArray)(options) ? options.map(renderRadio) : (0, $e5L6E.$signal)(()=>options().map(renderRadio))}
    </media-radio-group>
  `;
}
function $362123485be3cdce$var$createRadioOptions(entries) {
    return (0, $8B3mG.isArray)(entries) ? entries.map((entry)=>({
            label: entry,
            value: entry.toLowerCase()
        })) : Object.keys(entries).map((label)=>({
            label: label,
            value: entries[label]
        }));
}
function $362123485be3cdce$var$DefaultSliderParts() {
    return (0, $gX4mh.html)`
    <div class="vds-slider-track"></div>
    <div class="vds-slider-track-fill vds-slider-track"></div>
    <div class="vds-slider-thumb"></div>
  `;
}
function $362123485be3cdce$var$DefaultSliderSteps() {
    return (0, $gX4mh.html)`
    <media-slider-steps class="vds-slider-steps">
      <template>
        <div class="vds-slider-step"></div>
      </template>
    </media-slider-steps>
  `;
}
function $362123485be3cdce$var$DefaultMenuSliderItem({ label: label = null, value: value = null, upIcon: upIcon = "", downIcon: downIcon = "", children: children, isMin: isMin, isMax: isMax }) {
    const hasTitle = label || value, content = [
        downIcon ? $362123485be3cdce$var$IconSlot(downIcon, "down") : null,
        children,
        upIcon ? $362123485be3cdce$var$IconSlot(upIcon, "up") : null
    ];
    return (0, $gX4mh.html)`
    <div
      class=${`vds-menu-item vds-menu-slider-item${hasTitle ? " group" : ""}`}
      data-min=${(0, $e5L6E.$signal)(()=>isMin() ? "" : null)}
      data-max=${(0, $e5L6E.$signal)(()=>isMax() ? "" : null)}
    >
      ${hasTitle ? (0, $gX4mh.html)`
            <div class="vds-menu-slider-title">
              ${[
        label ? (0, $gX4mh.html)`<div>${label}</div>` : null,
        value ? (0, $gX4mh.html)`<div>${value}</div>` : null
    ]}
            </div>
            <div class="vds-menu-slider-body">${content}</div>
          ` : content}
    </div>
  `;
}
const $362123485be3cdce$var$FONT_SIZE_OPTION_WITH_ICONS = {
    ...$362123485be3cdce$var$FONT_SIZE_OPTION,
    upIcon: "menu-opacity-up",
    downIcon: "menu-opacity-down"
};
const $362123485be3cdce$var$FONT_OPACITY_OPTION_WITH_ICONS = {
    ...$362123485be3cdce$var$FONT_OPACITY_OPTION,
    upIcon: "menu-opacity-up",
    downIcon: "menu-opacity-down"
};
function $362123485be3cdce$var$DefaultFontMenu() {
    return (0, $e5L6E.$signal)(()=>{
        const { hasCaptions: hasCaptions } = (0, $6KfMo.useMediaState)(), { translations: translations } = $362123485be3cdce$export$46f4c66a779bac51();
        if (!hasCaptions()) return null;
        return (0, $gX4mh.html)`
      <media-menu class="vds-font-menu vds-menu">
        ${$362123485be3cdce$var$DefaultMenuButton({
            label: ()=>$362123485be3cdce$export$a7357cdd1f0b0168(translations, "Caption Styles")
        })}
        <media-menu-items class="vds-menu-items">
          ${[
            $362123485be3cdce$var$DefaultMenuSection({
                label: $362123485be3cdce$var$$i18n(translations, "Font"),
                children: [
                    $362123485be3cdce$var$DefaultFontFamilyMenu(),
                    $362123485be3cdce$var$DefaultFontSizeSlider()
                ]
            }),
            $362123485be3cdce$var$DefaultMenuSection({
                label: $362123485be3cdce$var$$i18n(translations, "Text"),
                children: [
                    $362123485be3cdce$var$DefaultTextColorInput(),
                    $362123485be3cdce$var$DefaultTextShadowMenu(),
                    $362123485be3cdce$var$DefaultTextOpacitySlider()
                ]
            }),
            $362123485be3cdce$var$DefaultMenuSection({
                label: $362123485be3cdce$var$$i18n(translations, "Text Background"),
                children: [
                    $362123485be3cdce$var$DefaultTextBgInput(),
                    $362123485be3cdce$var$DefaultTextBgOpacitySlider()
                ]
            }),
            $362123485be3cdce$var$DefaultMenuSection({
                label: $362123485be3cdce$var$$i18n(translations, "Display Background"),
                children: [
                    $362123485be3cdce$var$DefaultDisplayBgInput(),
                    $362123485be3cdce$var$DefaultDisplayOpacitySlider()
                ]
            }),
            $362123485be3cdce$var$DefaultMenuSection({
                children: [
                    $362123485be3cdce$var$DefaultResetMenuItem()
                ]
            })
        ]}
        </media-menu-items>
      </media-menu>
    `;
    });
}
function $362123485be3cdce$var$DefaultFontFamilyMenu() {
    return $362123485be3cdce$var$DefaultFontSetting({
        label: "Family",
        option: $362123485be3cdce$var$FONT_FAMILY_OPTION,
        type: "fontFamily"
    });
}
function $362123485be3cdce$var$DefaultFontSizeSlider() {
    return $362123485be3cdce$var$DefaultFontSetting({
        label: "Size",
        option: $362123485be3cdce$var$FONT_SIZE_OPTION_WITH_ICONS,
        type: "fontSize"
    });
}
function $362123485be3cdce$var$DefaultTextColorInput() {
    return $362123485be3cdce$var$DefaultFontSetting({
        label: "Color",
        option: $362123485be3cdce$var$FONT_COLOR_OPTION,
        type: "textColor"
    });
}
function $362123485be3cdce$var$DefaultTextOpacitySlider() {
    return $362123485be3cdce$var$DefaultFontSetting({
        label: "Opacity",
        option: $362123485be3cdce$var$FONT_OPACITY_OPTION_WITH_ICONS,
        type: "textOpacity"
    });
}
function $362123485be3cdce$var$DefaultTextShadowMenu() {
    return $362123485be3cdce$var$DefaultFontSetting({
        label: "Shadow",
        option: $362123485be3cdce$var$FONT_TEXT_SHADOW_OPTION,
        type: "textShadow"
    });
}
function $362123485be3cdce$var$DefaultTextBgInput() {
    return $362123485be3cdce$var$DefaultFontSetting({
        label: "Color",
        option: $362123485be3cdce$var$FONT_COLOR_OPTION,
        type: "textBg"
    });
}
function $362123485be3cdce$var$DefaultTextBgOpacitySlider() {
    return $362123485be3cdce$var$DefaultFontSetting({
        label: "Opacity",
        option: $362123485be3cdce$var$FONT_OPACITY_OPTION_WITH_ICONS,
        type: "textBgOpacity"
    });
}
function $362123485be3cdce$var$DefaultDisplayBgInput() {
    return $362123485be3cdce$var$DefaultFontSetting({
        label: "Color",
        option: $362123485be3cdce$var$FONT_COLOR_OPTION,
        type: "displayBg"
    });
}
function $362123485be3cdce$var$DefaultDisplayOpacitySlider() {
    return $362123485be3cdce$var$DefaultFontSetting({
        label: "Opacity",
        option: $362123485be3cdce$var$FONT_OPACITY_OPTION_WITH_ICONS,
        type: "displayBgOpacity"
    });
}
function $362123485be3cdce$var$DefaultResetMenuItem() {
    const { translations: translations } = $362123485be3cdce$export$46f4c66a779bac51(), $label = ()=>$362123485be3cdce$export$a7357cdd1f0b0168(translations, "Reset");
    return (0, $gX4mh.html)`
    <button class="vds-menu-item" role="menuitem" @click=${$362123485be3cdce$var$onFontReset}>
      <span class="vds-menu-item-label">${(0, $e5L6E.$signal)($label)}</span>
    </button>
  `;
}
function $362123485be3cdce$var$DefaultFontSetting({ label: label, option: option, type: type }) {
    const { player: player } = (0, $6KfMo.useMediaContext)(), { translations: translations } = $362123485be3cdce$export$46f4c66a779bac51(), $currentValue = $362123485be3cdce$var$FONT_SIGNALS[type], $label = ()=>$362123485be3cdce$export$a7357cdd1f0b0168(translations, label);
    function notify() {
        (0, $8B3mG.tick)();
        player.dispatchEvent(new Event("vds-font-change"));
    }
    if (option.type === "color") {
        let onColorChange2 = function(event) {
            $currentValue.set(event.target.value);
            notify();
        };
        return $362123485be3cdce$var$DefaultMenuItem({
            label: (0, $e5L6E.$signal)($label),
            children: (0, $gX4mh.html)`
        <input
          class="vds-color-picker"
          type="color"
          .value=${(0, $e5L6E.$signal)($currentValue)}
          @input=${onColorChange2}
        />
      `
        });
    }
    if (option.type === "slider") {
        let onSliderValueChange2 = function(event) {
            $currentValue.set(event.detail + "%");
            notify();
        };
        const { min: min, max: max, step: step, upIcon: upIcon, downIcon: downIcon } = option;
        return $362123485be3cdce$var$DefaultMenuSliderItem({
            label: (0, $e5L6E.$signal)($label),
            value: (0, $e5L6E.$signal)($currentValue),
            upIcon: upIcon,
            downIcon: downIcon,
            isMin: ()=>$currentValue() === min + "%",
            isMax: ()=>$currentValue() === max + "%",
            children: (0, $gX4mh.html)`
        <media-slider
          class="vds-slider"
          min=${min}
          max=${max}
          step=${step}
          key-step=${step}
          .value=${(0, $e5L6E.$signal)(()=>parseInt($currentValue()))}
          aria-label=${(0, $e5L6E.$signal)($label)}
          @value-change=${onSliderValueChange2}
          @drag-value-change=${onSliderValueChange2}
        >
          ${$362123485be3cdce$var$DefaultSliderParts()}${$362123485be3cdce$var$DefaultSliderSteps()}
        </media-slider>
      `
        });
    }
    const radioOptions = $362123485be3cdce$var$createRadioOptions(option.values), $hint = ()=>{
        const value = $currentValue(), label2 = radioOptions.find((radio)=>radio.value === value)?.label || "";
        return $362123485be3cdce$export$a7357cdd1f0b0168(translations, (0, $8B3mG.isString)(label2) ? label2 : label2());
    };
    return (0, $gX4mh.html)`
    <media-menu class=${`vds-${(0, $8B3mG.camelToKebabCase)(type)}-menu vds-menu`}>
      ${$362123485be3cdce$var$DefaultMenuButton({
        label: $label,
        hint: $hint
    })}
      <media-menu-items class="vds-menu-items">
        ${$362123485be3cdce$var$DefaultRadioGroup({
        value: $currentValue,
        options: radioOptions,
        onChange ({ detail: value }) {
            $currentValue.set(value);
            notify();
        }
    })}
      </media-menu-items>
    </media-menu>
  `;
}
function $362123485be3cdce$var$DefaultMenuCheckbox({ label: label, checked: checked, defaultChecked: defaultChecked = false, storageKey: storageKey, onChange: onChange }) {
    const { translations: translations } = $362123485be3cdce$export$46f4c66a779bac51(), savedValue = storageKey ? localStorage.getItem(storageKey) : null, $checked = (0, $8B3mG.signal)(!!(savedValue ?? defaultChecked)), $active = (0, $8B3mG.signal)(false), $ariaChecked = (0, $e5L6E.$signal)((0, $jrniq.$ariaBool)($checked)), $label = $362123485be3cdce$var$$i18n(translations, label);
    if (storageKey) onChange((0, $8B3mG.peek)($checked));
    if (checked) (0, $8B3mG.effect)(()=>void $checked.set(checked()));
    function onPress(event) {
        if (event?.button === 1) return;
        $checked.set((checked2)=>!checked2);
        if (storageKey) localStorage.setItem(storageKey, $checked() ? "1" : "");
        onChange($checked(), event);
        $active.set(false);
    }
    function onKeyDown(event) {
        if ((0, $8B3mG.isKeyboardClick)(event)) onPress();
    }
    function onActive(event) {
        if (event.button !== 0) return;
        $active.set(true);
    }
    return (0, $gX4mh.html)`
    <div
      class="vds-menu-checkbox"
      role="menuitemcheckbox"
      tabindex="0"
      aria-label=${$label}
      aria-checked=${$ariaChecked}
      data-active=${(0, $e5L6E.$signal)(()=>$active() ? "" : null)}
      @pointerup=${onPress}
      @pointerdown=${onActive}
      @keydown=${onKeyDown}
    ></div>
  `;
}
function $362123485be3cdce$var$DefaultAccessibilityMenu() {
    return (0, $e5L6E.$signal)(()=>{
        const { translations: translations } = $362123485be3cdce$export$46f4c66a779bac51();
        return (0, $gX4mh.html)`
      <media-menu class="vds-accessibility-menu vds-menu">
        ${$362123485be3cdce$var$DefaultMenuButton({
            label: ()=>$362123485be3cdce$export$a7357cdd1f0b0168(translations, "Accessibility"),
            icon: "menu-accessibility"
        })}
        <media-menu-items class="vds-menu-items">
          ${[
            $362123485be3cdce$var$DefaultMenuSection({
                children: [
                    $362123485be3cdce$var$DefaultAnnouncementsMenuCheckbox(),
                    $362123485be3cdce$var$DefaultKeyboardAnimationsMenuCheckbox()
                ]
            }),
            $362123485be3cdce$var$DefaultMenuSection({
                children: [
                    $362123485be3cdce$var$DefaultFontMenu()
                ]
            })
        ]}
        </media-menu-items>
      </media-menu>
    `;
    });
}
function $362123485be3cdce$var$DefaultAnnouncementsMenuCheckbox() {
    const { userPrefersAnnouncements: userPrefersAnnouncements, translations: translations } = $362123485be3cdce$export$46f4c66a779bac51(), label = "Announcements";
    return $362123485be3cdce$var$DefaultMenuItem({
        label: $362123485be3cdce$var$$i18n(translations, label),
        children: $362123485be3cdce$var$DefaultMenuCheckbox({
            label: label,
            storageKey: "vds-player::announcements",
            onChange (checked) {
                userPrefersAnnouncements.set(checked);
            }
        })
    });
}
function $362123485be3cdce$var$DefaultKeyboardAnimationsMenuCheckbox() {
    return (0, $e5L6E.$signal)(()=>{
        const { translations: translations, userPrefersKeyboardAnimations: userPrefersKeyboardAnimations, noKeyboardAnimations: noKeyboardAnimations } = $362123485be3cdce$export$46f4c66a779bac51(), { viewType: viewType } = (0, $6KfMo.useMediaState)(), $disabled = (0, $8B3mG.computed)(()=>viewType() !== "video" || noKeyboardAnimations());
        if ($disabled()) return null;
        const label = "Keyboard Animations";
        return $362123485be3cdce$var$DefaultMenuItem({
            label: $362123485be3cdce$var$$i18n(translations, label),
            children: $362123485be3cdce$var$DefaultMenuCheckbox({
                label: label,
                defaultChecked: true,
                storageKey: "vds-player::keyboard-animations",
                onChange (checked) {
                    userPrefersKeyboardAnimations.set(checked);
                }
            })
        });
    });
}
function $362123485be3cdce$var$DefaultAudioMenu() {
    return (0, $e5L6E.$signal)(()=>{
        const { noAudioGain: noAudioGain, translations: translations } = $362123485be3cdce$export$46f4c66a779bac51(), { audioTracks: audioTracks, canSetAudioGain: canSetAudioGain } = (0, $6KfMo.useMediaState)(), $disabled = (0, $8B3mG.computed)(()=>{
            const hasGainSlider = canSetAudioGain() && !noAudioGain();
            return !hasGainSlider && audioTracks().length <= 1;
        });
        if ($disabled()) return null;
        return (0, $gX4mh.html)`
      <media-menu class="vds-audio-menu vds-menu">
        ${$362123485be3cdce$var$DefaultMenuButton({
            label: ()=>$362123485be3cdce$export$a7357cdd1f0b0168(translations, "Audio"),
            icon: "menu-audio"
        })}
        <media-menu-items class="vds-menu-items">
          ${[
            $362123485be3cdce$var$DefaultAudioTracksMenu(),
            $362123485be3cdce$var$DefaultAudioBoostSection()
        ]}
        </media-menu-items>
      </media-menu>
    `;
    });
}
function $362123485be3cdce$var$DefaultAudioTracksMenu() {
    return (0, $e5L6E.$signal)(()=>{
        const { translations: translations } = $362123485be3cdce$export$46f4c66a779bac51(), { audioTracks: audioTracks } = (0, $6KfMo.useMediaState)(), $defaultText = $362123485be3cdce$var$$i18n(translations, "Default"), $disabled = (0, $8B3mG.computed)(()=>audioTracks().length <= 1);
        if ($disabled()) return null;
        return $362123485be3cdce$var$DefaultMenuSection({
            children: (0, $gX4mh.html)`
        <media-menu class="vds-audio-tracks-menu vds-menu">
          ${$362123485be3cdce$var$DefaultMenuButton({
                label: ()=>$362123485be3cdce$export$a7357cdd1f0b0168(translations, "Track")
            })}
          <media-menu-items class="vds-menu-items">
            <media-audio-radio-group
              class="vds-audio-track-radio-group vds-radio-group"
              empty-label=${$defaultText}
            >
              <template>
                <media-radio class="vds-audio-track-radio vds-radio">
                  <slot name="menu-radio-check-icon" data-class="vds-icon"></slot>
                  <span class="vds-radio-label" data-part="label"></span>
                </media-radio>
              </template>
            </media-audio-radio-group>
          </media-menu-items>
        </media-menu>
      `
        });
    });
}
function $362123485be3cdce$var$DefaultAudioBoostSection() {
    return (0, $e5L6E.$signal)(()=>{
        const { noAudioGain: noAudioGain, translations: translations } = $362123485be3cdce$export$46f4c66a779bac51(), { canSetAudioGain: canSetAudioGain } = (0, $6KfMo.useMediaState)(), $disabled = (0, $8B3mG.computed)(()=>!canSetAudioGain() || noAudioGain());
        if ($disabled()) return null;
        const { audioGain: audioGain } = (0, $6KfMo.useMediaState)();
        return $362123485be3cdce$var$DefaultMenuSection({
            label: $362123485be3cdce$var$$i18n(translations, "Boost"),
            value: (0, $e5L6E.$signal)(()=>Math.round(((audioGain() ?? 1) - 1) * 100) + "%"),
            children: [
                $362123485be3cdce$var$DefaultMenuSliderItem({
                    upIcon: "menu-audio-boost-up",
                    downIcon: "menu-audio-boost-down",
                    children: $362123485be3cdce$var$DefaultAudioGainSlider(),
                    isMin: ()=>((audioGain() ?? 1) - 1) * 100 <= $362123485be3cdce$var$getGainMin(),
                    isMax: ()=>((audioGain() ?? 1) - 1) * 100 === $362123485be3cdce$var$getGainMax()
                })
            ]
        });
    });
}
function $362123485be3cdce$var$DefaultAudioGainSlider() {
    const { translations: translations } = $362123485be3cdce$export$46f4c66a779bac51(), $label = $362123485be3cdce$var$$i18n(translations, "Boost"), $min = $362123485be3cdce$var$getGainMin, $max = $362123485be3cdce$var$getGainMax, $step = $362123485be3cdce$var$getGainStep;
    return (0, $gX4mh.html)`
    <media-audio-gain-slider
      class="vds-audio-gain-slider vds-slider"
      aria-label=${$label}
      min=${(0, $e5L6E.$signal)($min)}
      max=${(0, $e5L6E.$signal)($max)}
      step=${(0, $e5L6E.$signal)($step)}
      key-step=${(0, $e5L6E.$signal)($step)}
    >
      ${$362123485be3cdce$var$DefaultSliderParts()}${$362123485be3cdce$var$DefaultSliderSteps()}
    </media-audio-gain-slider>
  `;
}
function $362123485be3cdce$var$getGainMin() {
    const { audioGains: audioGains } = $362123485be3cdce$export$46f4c66a779bac51(), gains = audioGains();
    return (0, $8B3mG.isArray)(gains) ? gains[0] ?? 0 : gains.min;
}
function $362123485be3cdce$var$getGainMax() {
    const { audioGains: audioGains } = $362123485be3cdce$export$46f4c66a779bac51(), gains = audioGains();
    return (0, $8B3mG.isArray)(gains) ? gains[gains.length - 1] ?? 300 : gains.max;
}
function $362123485be3cdce$var$getGainStep() {
    const { audioGains: audioGains } = $362123485be3cdce$export$46f4c66a779bac51(), gains = audioGains();
    return (0, $8B3mG.isArray)(gains) ? gains[1] - gains[0] || 25 : gains.step;
}
function $362123485be3cdce$var$DefaultCaptionsMenu() {
    return (0, $e5L6E.$signal)(()=>{
        const { translations: translations } = $362123485be3cdce$export$46f4c66a779bac51(), { hasCaptions: hasCaptions } = (0, $6KfMo.useMediaState)(), $offText = $362123485be3cdce$var$$i18n(translations, "Off");
        if (!hasCaptions()) return null;
        return (0, $gX4mh.html)`
      <media-menu class="vds-captions-menu vds-menu">
        ${$362123485be3cdce$var$DefaultMenuButton({
            label: ()=>$362123485be3cdce$export$a7357cdd1f0b0168(translations, "Captions"),
            icon: "menu-captions"
        })}
        <media-menu-items class="vds-menu-items">
          <media-captions-radio-group
            class="vds-captions-radio-group vds-radio-group"
            off-label=${$offText}
          >
            <template>
              <media-radio class="vds-caption-radio vds-radio">
                <slot name="menu-radio-check-icon" data-class="vds-icon"></slot>
                <span class="vds-radio-label" data-part="label"></span>
              </media-radio>
            </template>
          </media-captions-radio-group>
        </media-menu-items>
      </media-menu>
    `;
    });
}
function $362123485be3cdce$var$DefaultPlaybackMenu() {
    return (0, $e5L6E.$signal)(()=>{
        const { translations: translations } = $362123485be3cdce$export$46f4c66a779bac51();
        return (0, $gX4mh.html)`
      <media-menu class="vds-playback-menu vds-menu">
        ${$362123485be3cdce$var$DefaultMenuButton({
            label: ()=>$362123485be3cdce$export$a7357cdd1f0b0168(translations, "Playback"),
            icon: "menu-playback"
        })}
        <media-menu-items class="vds-menu-items">
          ${[
            $362123485be3cdce$var$DefaultMenuSection({
                children: $362123485be3cdce$var$DefaultLoopCheckbox()
            }),
            $362123485be3cdce$var$DefaultSpeedMenuSection(),
            $362123485be3cdce$var$DefaultQualityMenuSection()
        ]}
        </media-menu-items>
      </media-menu>
    `;
    });
}
function $362123485be3cdce$var$DefaultLoopCheckbox() {
    const { remote: remote } = (0, $6KfMo.useMediaContext)(), { translations: translations } = $362123485be3cdce$export$46f4c66a779bac51(), label = "Loop";
    return $362123485be3cdce$var$DefaultMenuItem({
        label: $362123485be3cdce$var$$i18n(translations, label),
        children: $362123485be3cdce$var$DefaultMenuCheckbox({
            label: label,
            storageKey: "vds-player::user-loop",
            onChange (checked, trigger) {
                remote.userPrefersLoopChange(checked, trigger);
            }
        })
    });
}
function $362123485be3cdce$var$DefaultSpeedMenuSection() {
    return (0, $e5L6E.$signal)(()=>{
        const { translations: translations } = $362123485be3cdce$export$46f4c66a779bac51(), { canSetPlaybackRate: canSetPlaybackRate, playbackRate: playbackRate } = (0, $6KfMo.useMediaState)();
        if (!canSetPlaybackRate()) return null;
        return $362123485be3cdce$var$DefaultMenuSection({
            label: $362123485be3cdce$var$$i18n(translations, "Speed"),
            value: (0, $e5L6E.$signal)(()=>playbackRate() === 1 ? $362123485be3cdce$export$a7357cdd1f0b0168(translations, "Normal") : playbackRate() + "x"),
            children: [
                $362123485be3cdce$var$DefaultMenuSliderItem({
                    upIcon: "menu-speed-up",
                    downIcon: "menu-speed-down",
                    children: $362123485be3cdce$var$DefaultSpeedSlider(),
                    isMin: ()=>playbackRate() === $362123485be3cdce$var$getSpeedMin(),
                    isMax: ()=>playbackRate() === $362123485be3cdce$var$getSpeedMax()
                })
            ]
        });
    });
}
function $362123485be3cdce$var$getSpeedMin() {
    const { playbackRates: playbackRates } = $362123485be3cdce$export$46f4c66a779bac51(), rates = playbackRates();
    return (0, $8B3mG.isArray)(rates) ? rates[0] ?? 0 : rates.min;
}
function $362123485be3cdce$var$getSpeedMax() {
    const { playbackRates: playbackRates } = $362123485be3cdce$export$46f4c66a779bac51(), rates = playbackRates();
    return (0, $8B3mG.isArray)(rates) ? rates[rates.length - 1] ?? 2 : rates.max;
}
function $362123485be3cdce$var$getSpeedStep() {
    const { playbackRates: playbackRates } = $362123485be3cdce$export$46f4c66a779bac51(), rates = playbackRates();
    return (0, $8B3mG.isArray)(rates) ? rates[1] - rates[0] || 0.25 : rates.step;
}
function $362123485be3cdce$var$DefaultSpeedSlider() {
    const { translations: translations } = $362123485be3cdce$export$46f4c66a779bac51(), $label = $362123485be3cdce$var$$i18n(translations, "Speed"), $min = $362123485be3cdce$var$getSpeedMin, $max = $362123485be3cdce$var$getSpeedMax, $step = $362123485be3cdce$var$getSpeedStep;
    return (0, $gX4mh.html)`
    <media-speed-slider
      class="vds-speed-slider vds-slider"
      aria-label=${$label}
      min=${(0, $e5L6E.$signal)($min)}
      max=${(0, $e5L6E.$signal)($max)}
      step=${(0, $e5L6E.$signal)($step)}
      key-step=${(0, $e5L6E.$signal)($step)}
    >
      ${$362123485be3cdce$var$DefaultSliderParts()}${$362123485be3cdce$var$DefaultSliderSteps()}
    </media-speed-slider>
  `;
}
function $362123485be3cdce$var$DefaultAutoQualityCheckbox() {
    const { remote: remote, qualities: qualities } = (0, $6KfMo.useMediaContext)(), { autoQuality: autoQuality, canSetQuality: canSetQuality, qualities: $qualities } = (0, $6KfMo.useMediaState)(), { translations: translations } = $362123485be3cdce$export$46f4c66a779bac51(), label = "Auto", $disabled = (0, $8B3mG.computed)(()=>!canSetQuality() || $qualities().length <= 1);
    if ($disabled()) return null;
    return $362123485be3cdce$var$DefaultMenuItem({
        label: $362123485be3cdce$var$$i18n(translations, label),
        children: $362123485be3cdce$var$DefaultMenuCheckbox({
            label: label,
            checked: autoQuality,
            onChange (checked, trigger) {
                if (checked) remote.requestAutoQuality(trigger);
                else remote.changeQuality(qualities.selectedIndex, trigger);
            }
        })
    });
}
function $362123485be3cdce$var$DefaultQualityMenuSection() {
    return (0, $e5L6E.$signal)(()=>{
        const { hideQualityBitrate: hideQualityBitrate, translations: translations } = $362123485be3cdce$export$46f4c66a779bac51(), { canSetQuality: canSetQuality, qualities: qualities, quality: quality } = (0, $6KfMo.useMediaState)(), $disabled = (0, $8B3mG.computed)(()=>!canSetQuality() || qualities().length <= 1), $sortedQualities = (0, $8B3mG.computed)(()=>(0, $jrniq.sortVideoQualities)(qualities()));
        if ($disabled()) return null;
        return $362123485be3cdce$var$DefaultMenuSection({
            label: $362123485be3cdce$var$$i18n(translations, "Quality"),
            value: (0, $e5L6E.$signal)(()=>{
                const height = quality()?.height, bitrate = !hideQualityBitrate() ? quality()?.bitrate : null, bitrateText = bitrate && bitrate > 0 ? `${(bitrate / 1e6).toFixed(2)} Mbps` : null, autoText = $362123485be3cdce$export$a7357cdd1f0b0168(translations, "Auto");
                return height ? `${height}p${bitrateText ? ` (${bitrateText})` : ""}` : autoText;
            }),
            children: [
                $362123485be3cdce$var$DefaultMenuSliderItem({
                    upIcon: "menu-quality-up",
                    downIcon: "menu-quality-down",
                    children: $362123485be3cdce$var$DefaultQualitySlider(),
                    isMin: ()=>$sortedQualities()[0] === quality(),
                    isMax: ()=>$sortedQualities().at(-1) === quality()
                }),
                $362123485be3cdce$var$DefaultAutoQualityCheckbox()
            ]
        });
    });
}
function $362123485be3cdce$var$DefaultQualitySlider() {
    const { translations: translations } = $362123485be3cdce$export$46f4c66a779bac51(), $label = $362123485be3cdce$var$$i18n(translations, "Quality");
    return (0, $gX4mh.html)`
    <media-quality-slider class="vds-quality-slider vds-slider" aria-label=${$label}>
      ${$362123485be3cdce$var$DefaultSliderParts()}${$362123485be3cdce$var$DefaultSliderSteps()}
    </media-quality-slider>
  `;
}
function $362123485be3cdce$export$275cf529611de599({ placement: placement, portal: portal, tooltip: tooltip }) {
    return (0, $e5L6E.$signal)(()=>{
        const { viewType: viewType } = (0, $6KfMo.useMediaState)(), { translations: translations, menuPortal: menuPortal, noModal: noModal, menuGroup: menuGroup, smallWhen: smWhen } = $362123485be3cdce$export$46f4c66a779bac51(), $placement = (0, $8B3mG.computed)(()=>noModal() ? (0, $8B3mG.unwrap)(placement) : !smWhen() ? (0, $8B3mG.unwrap)(placement) : null), $offset = (0, $8B3mG.computed)(()=>!smWhen() && menuGroup() === "bottom" && viewType() === "video" ? 26 : 0), $isOpen = (0, $8B3mG.signal)(false);
        $362123485be3cdce$var$updateFontCssVars();
        function onOpen() {
            $isOpen.set(true);
        }
        function onClose() {
            $isOpen.set(false);
        }
        const items = (0, $gX4mh.html)`
      <media-menu-items
        class="vds-settings-menu-items vds-menu-items"
        placement=${(0, $e5L6E.$signal)($placement)}
        offset=${(0, $e5L6E.$signal)($offset)}
      >
        ${(0, $e5L6E.$signal)(()=>{
            if (!$isOpen()) return null;
            return [
                $362123485be3cdce$var$DefaultPlaybackMenu(),
                $362123485be3cdce$var$DefaultAccessibilityMenu(),
                $362123485be3cdce$var$DefaultAudioMenu(),
                $362123485be3cdce$var$DefaultCaptionsMenu()
            ];
        })}
      </media-menu-items>
    `;
        return (0, $gX4mh.html)`
      <media-menu class="vds-settings-menu vds-menu" @open=${onOpen} @close=${onClose}>
        <media-tooltip class="vds-tooltip">
          <media-tooltip-trigger>
            <media-menu-button
              class="vds-menu-button vds-button"
              aria-label=${$362123485be3cdce$var$$i18n(translations, "Settings")}
            >
              ${$362123485be3cdce$var$IconSlot("menu-settings", "vds-rotate-icon")}
            </media-menu-button>
          </media-tooltip-trigger>
          <media-tooltip-content
            class="vds-tooltip-content"
            placement=${(0, $8B3mG.isFunction)(tooltip) ? (0, $e5L6E.$signal)(tooltip) : tooltip}
          >
            ${$362123485be3cdce$var$$i18n(translations, "Settings")}
          </media-tooltip-content>
        </media-tooltip>
        ${portal ? $362123485be3cdce$var$MenuPortal(menuPortal, items) : items}
      </media-menu>
    `;
    });
}
function $362123485be3cdce$export$12ffac1a5abb1f72({ orientation: orientation, tooltip: tooltip }) {
    return (0, $e5L6E.$signal)(()=>{
        const { pointer: pointer, muted: muted, canSetVolume: canSetVolume } = (0, $6KfMo.useMediaState)();
        if (pointer() === "coarse" && !muted()) return null;
        if (!canSetVolume()) return $362123485be3cdce$var$DefaultMuteButton({
            tooltip: tooltip
        });
        const $rootRef = (0, $8B3mG.signal)(void 0), $isRootActive = (0, $ciZW6.useActive)($rootRef);
        return (0, $gX4mh.html)`
      <div class="vds-volume" ?data-active=${(0, $e5L6E.$signal)($isRootActive)} ${(0, $3Oa6Y.ref)($rootRef.set)}>
        ${$362123485be3cdce$var$DefaultMuteButton({
            tooltip: tooltip
        })}
        <div class="vds-volume-popup">${$362123485be3cdce$var$DefaultVolumeSlider({
            orientation: orientation
        })}</div>
      </div>
    `;
    });
}
function $362123485be3cdce$var$DefaultVolumeSlider({ orientation: orientation } = {}) {
    const { translations: translations } = $362123485be3cdce$export$46f4c66a779bac51(), $label = $362123485be3cdce$var$$i18n(translations, "Volume");
    return (0, $gX4mh.html)`
    <media-volume-slider
      class="vds-volume-slider vds-slider"
      aria-label=${$label}
      orientation=${(0, $8hn4v.ifDefined)(orientation)}
    >
      <div class="vds-slider-track"></div>
      <div class="vds-slider-track-fill vds-slider-track"></div>
      <media-slider-preview class="vds-slider-preview" no-clamp>
        <media-slider-value class="vds-slider-value"></media-slider-value>
      </media-slider-preview>
      <div class="vds-slider-thumb"></div>
    </media-volume-slider>
  `;
}
function $362123485be3cdce$export$f5a82b0f6b290195() {
    const $ref = (0, $8B3mG.signal)(void 0), $width = (0, $8B3mG.signal)(0), { thumbnails: thumbnails, translations: translations, sliderChaptersMinWidth: sliderChaptersMinWidth, disableTimeSlider: disableTimeSlider, seekStep: seekStep, noScrubGesture: noScrubGesture } = $362123485be3cdce$export$46f4c66a779bac51(), $label = $362123485be3cdce$var$$i18n(translations, "Seek"), $isDisabled = (0, $e5L6E.$signal)(disableTimeSlider), $isChaptersDisabled = (0, $e5L6E.$signal)(()=>$width() < sliderChaptersMinWidth()), $thumbnails = (0, $e5L6E.$signal)(thumbnails);
    (0, $ciZW6.useResizeObserver)($ref, ()=>{
        const el = $ref();
        el && $width.set(el.clientWidth);
    });
    return (0, $gX4mh.html)`
    <media-time-slider
      class="vds-time-slider vds-slider"
      aria-label=${$label}
      key-step=${(0, $e5L6E.$signal)(seekStep)}
      ?disabled=${$isDisabled}
      ?no-swipe-gesture=${(0, $e5L6E.$signal)(noScrubGesture)}
      ${(0, $3Oa6Y.ref)($ref.set)}
    >
      <media-slider-chapters class="vds-slider-chapters" ?disabled=${$isChaptersDisabled}>
        <template>
          <div class="vds-slider-chapter">
            <div class="vds-slider-track"></div>
            <div class="vds-slider-track-fill vds-slider-track"></div>
            <div class="vds-slider-progress vds-slider-track"></div>
          </div>
        </template>
      </media-slider-chapters>
      <div class="vds-slider-thumb"></div>
      <media-slider-preview class="vds-slider-preview">
        <media-slider-thumbnail
          class="vds-slider-thumbnail vds-thumbnail"
          .src=${$thumbnails}
        ></media-slider-thumbnail>
        <div class="vds-slider-chapter-title" data-part="chapter-title"></div>
        <media-slider-value class="vds-slider-value"></media-slider-value>
      </media-slider-preview>
    </media-time-slider>
  `;
}
function $362123485be3cdce$var$DefaultTimeGroup() {
    return (0, $gX4mh.html)`
    <div class="vds-time-group">
      ${(0, $e5L6E.$signal)(()=>{
        const { duration: duration } = (0, $6KfMo.useMediaState)();
        if (!duration()) return null;
        return [
            (0, $gX4mh.html)`<media-time class="vds-time" type="current"></media-time>`,
            (0, $gX4mh.html)`<div class="vds-time-divider">/</div>`,
            (0, $gX4mh.html)`<media-time class="vds-time" type="duration"></media-time>`
        ];
    })}
    </div>
  `;
}
function $362123485be3cdce$export$5a9920dbdd1268df() {
    return (0, $e5L6E.$signal)(()=>{
        const { live: live, duration: duration } = (0, $6KfMo.useMediaState)();
        return live() ? $362123485be3cdce$var$DefaultLiveButton() : duration() ? (0, $gX4mh.html)`<media-time class="vds-time" type="current" toggle remainder></media-time>` : null;
    });
}
function $362123485be3cdce$export$724e13efab671e72() {
    return (0, $e5L6E.$signal)(()=>{
        const { live: live } = (0, $6KfMo.useMediaState)();
        return live() ? $362123485be3cdce$var$DefaultLiveButton() : $362123485be3cdce$var$DefaultTimeGroup();
    });
}
function $362123485be3cdce$export$772e6bb8c71f8823() {
    return (0, $e5L6E.$signal)(()=>{
        const { textTracks: textTracks } = (0, $6KfMo.useMediaContext)(), { title: title, started: started } = (0, $6KfMo.useMediaState)(), $hasChapters = (0, $8B3mG.signal)(null);
        (0, $l6thX.watchActiveTextTrack)(textTracks, "chapters", $hasChapters.set);
        return $hasChapters() && (started() || !title()) ? $362123485be3cdce$export$2c1c19d12926b7c0() : (0, $gX4mh.html)`<media-title class="vds-chapter-title"></media-title>`;
    });
}
function $362123485be3cdce$export$2c1c19d12926b7c0() {
    return (0, $gX4mh.html)`<media-chapter-title class="vds-chapter-title"></media-chapter-title>`;
}

class $362123485be3cdce$export$eb8cb61fa2f12073 extends (0, $e5L6E.LayoutIconsLoader) {
    async loadIcons() {
        const paths = (await (parcelRequire("6rDv2"))).icons, icons = {};
        for (const iconName of Object.keys(paths))icons[iconName] = (0, $e5L6E.Icon)({
            name: iconName,
            paths: paths[iconName]
        });
        return icons;
    }
}

});
parcelRegister("gX4mh", function(module, exports) {

$parcel$export(module.exports, "html", function () { return $c57589859a654fc0$export$c0bb0b647f701bb5; });
$parcel$export(module.exports, "noChange", function () { return $c57589859a654fc0$export$9c068ae9cc5db4e8; });
$parcel$export(module.exports, "nothing", function () { return $c57589859a654fc0$export$45b790e32b2810ee; });
$parcel$export(module.exports, "_$LH", function () { return $c57589859a654fc0$export$8613d1ca9052b22e; });
$parcel$export(module.exports, "render", function () { return $c57589859a654fc0$export$b3890eb0ae9dca99; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var $c57589859a654fc0$var$t;
const $c57589859a654fc0$var$i = window, $c57589859a654fc0$var$s = $c57589859a654fc0$var$i.trustedTypes, $c57589859a654fc0$var$e = $c57589859a654fc0$var$s ? $c57589859a654fc0$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $c57589859a654fc0$var$o = "$lit$", $c57589859a654fc0$var$n = `lit$${(Math.random() + "").slice(9)}$`, $c57589859a654fc0$var$l = "?" + $c57589859a654fc0$var$n, $c57589859a654fc0$var$h = `<${$c57589859a654fc0$var$l}>`, $c57589859a654fc0$var$r = document, $c57589859a654fc0$var$u = ()=>$c57589859a654fc0$var$r.createComment(""), $c57589859a654fc0$var$d = (t)=>null === t || "object" != typeof t && "function" != typeof t, $c57589859a654fc0$var$c = Array.isArray, $c57589859a654fc0$var$v = (t)=>$c57589859a654fc0$var$c(t) || "function" == typeof (null == t ? void 0 : t[Symbol.iterator]), $c57589859a654fc0$var$a = "[ 	\n\f\r]", $c57589859a654fc0$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $c57589859a654fc0$var$_ = /-->/g, $c57589859a654fc0$var$m = />/g, $c57589859a654fc0$var$p = RegExp(`>|${$c57589859a654fc0$var$a}(?:([^\\s"'>=/]+)(${$c57589859a654fc0$var$a}*=${$c57589859a654fc0$var$a}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $c57589859a654fc0$var$g = /'/g, $c57589859a654fc0$var$$ = /"/g, $c57589859a654fc0$var$y = /^(?:script|style|textarea|title)$/i, $c57589859a654fc0$var$w = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $c57589859a654fc0$export$c0bb0b647f701bb5 = $c57589859a654fc0$var$w(1), $c57589859a654fc0$export$7ed1367e7fa1ad68 = $c57589859a654fc0$var$w(2), $c57589859a654fc0$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $c57589859a654fc0$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $c57589859a654fc0$var$E = new WeakMap, $c57589859a654fc0$var$C = $c57589859a654fc0$var$r.createTreeWalker($c57589859a654fc0$var$r, 129, null, !1);
function $c57589859a654fc0$var$P(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $c57589859a654fc0$var$e ? $c57589859a654fc0$var$e.createHTML(i) : i;
}
const $c57589859a654fc0$var$V = (t, i)=>{
    const s = t.length - 1, e = [];
    let l, r = 2 === i ? "<svg>" : "", u = $c57589859a654fc0$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let d, c, v = -1, a = 0;
        for(; a < s.length && (u.lastIndex = a, c = u.exec(s), null !== c);)a = u.lastIndex, u === $c57589859a654fc0$var$f ? "!--" === c[1] ? u = $c57589859a654fc0$var$_ : void 0 !== c[1] ? u = $c57589859a654fc0$var$m : void 0 !== c[2] ? ($c57589859a654fc0$var$y.test(c[2]) && (l = RegExp("</" + c[2], "g")), u = $c57589859a654fc0$var$p) : void 0 !== c[3] && (u = $c57589859a654fc0$var$p) : u === $c57589859a654fc0$var$p ? ">" === c[0] ? (u = null != l ? l : $c57589859a654fc0$var$f, v = -1) : void 0 === c[1] ? v = -2 : (v = u.lastIndex - c[2].length, d = c[1], u = void 0 === c[3] ? $c57589859a654fc0$var$p : '"' === c[3] ? $c57589859a654fc0$var$$ : $c57589859a654fc0$var$g) : u === $c57589859a654fc0$var$$ || u === $c57589859a654fc0$var$g ? u = $c57589859a654fc0$var$p : u === $c57589859a654fc0$var$_ || u === $c57589859a654fc0$var$m ? u = $c57589859a654fc0$var$f : (u = $c57589859a654fc0$var$p, l = void 0);
        const w = u === $c57589859a654fc0$var$p && t[i + 1].startsWith("/>") ? " " : "";
        r += u === $c57589859a654fc0$var$f ? s + $c57589859a654fc0$var$h : v >= 0 ? (e.push(d), s.slice(0, v) + $c57589859a654fc0$var$o + s.slice(v) + $c57589859a654fc0$var$n + w) : s + $c57589859a654fc0$var$n + (-2 === v ? (e.push(void 0), i) : w);
    }
    return [
        $c57589859a654fc0$var$P(t, r + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        e
    ];
};
class $c57589859a654fc0$var$N {
    static createElement(t, i) {
        const s = $c57589859a654fc0$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
    constructor({ strings: t, _$litType$: i }, e){
        let h;
        this.parts = [];
        let r = 0, d = 0;
        const c = t.length - 1, v = this.parts, [a, f] = $c57589859a654fc0$var$V(t, i);
        if (this.el = $c57589859a654fc0$var$N.createElement(a, e), $c57589859a654fc0$var$C.currentNode = this.el.content, 2 === i) {
            const t = this.el.content, i = t.firstChild;
            i.remove(), t.append(...i.childNodes);
        }
        for(; null !== (h = $c57589859a654fc0$var$C.nextNode()) && v.length < c;){
            if (1 === h.nodeType) {
                if (h.hasAttributes()) {
                    const t = [];
                    for (const i of h.getAttributeNames())if (i.endsWith($c57589859a654fc0$var$o) || i.startsWith($c57589859a654fc0$var$n)) {
                        const s = f[d++];
                        if (t.push(i), void 0 !== s) {
                            const t = h.getAttribute(s.toLowerCase() + $c57589859a654fc0$var$o).split($c57589859a654fc0$var$n), i = /([.?@])?(.*)/.exec(s);
                            v.push({
                                type: 1,
                                index: r,
                                name: i[2],
                                strings: t,
                                ctor: "." === i[1] ? $c57589859a654fc0$var$H : "?" === i[1] ? $c57589859a654fc0$var$L : "@" === i[1] ? $c57589859a654fc0$var$z : $c57589859a654fc0$var$k
                            });
                        } else v.push({
                            type: 6,
                            index: r
                        });
                    }
                    for (const i of t)h.removeAttribute(i);
                }
                if ($c57589859a654fc0$var$y.test(h.tagName)) {
                    const t = h.textContent.split($c57589859a654fc0$var$n), i = t.length - 1;
                    if (i > 0) {
                        h.textContent = $c57589859a654fc0$var$s ? $c57589859a654fc0$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)h.append(t[s], $c57589859a654fc0$var$u()), $c57589859a654fc0$var$C.nextNode(), v.push({
                            type: 2,
                            index: ++r
                        });
                        h.append(t[i], $c57589859a654fc0$var$u());
                    }
                }
            } else if (8 === h.nodeType) {
                if (h.data === $c57589859a654fc0$var$l) v.push({
                    type: 2,
                    index: r
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = h.data.indexOf($c57589859a654fc0$var$n, t + 1));)v.push({
                        type: 7,
                        index: r
                    }), t += $c57589859a654fc0$var$n.length - 1;
                }
            }
            r++;
        }
    }
}
function $c57589859a654fc0$var$S(t, i, s = t, e) {
    var o, n, l, h;
    if (i === $c57589859a654fc0$export$9c068ae9cc5db4e8) return i;
    let r = void 0 !== e ? null === (o = s._$Co) || void 0 === o ? void 0 : o[e] : s._$Cl;
    const u = $c57589859a654fc0$var$d(i) ? void 0 : i._$litDirective$;
    return (null == r ? void 0 : r.constructor) !== u && (null === (n = null == r ? void 0 : r._$AO) || void 0 === n || n.call(r, !1), void 0 === u ? r = void 0 : (r = new u(t), r._$AT(t, s, e)), void 0 !== e ? (null !== (l = (h = s)._$Co) && void 0 !== l ? l : h._$Co = [])[e] = r : s._$Cl = r), void 0 !== r && (i = $c57589859a654fc0$var$S(t, r._$AS(t, i.values), r, e)), i;
}
class $c57589859a654fc0$var$M {
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        var i;
        const { el: { content: s }, parts: e } = this._$AD, o = (null !== (i = null == t ? void 0 : t.creationScope) && void 0 !== i ? i : $c57589859a654fc0$var$r).importNode(s, !0);
        $c57589859a654fc0$var$C.currentNode = o;
        let n = $c57589859a654fc0$var$C.nextNode(), l = 0, h = 0, u = e[0];
        for(; void 0 !== u;){
            if (l === u.index) {
                let i;
                2 === u.type ? i = new $c57589859a654fc0$var$R(n, n.nextSibling, this, t) : 1 === u.type ? i = new u.ctor(n, u.name, u.strings, this, t) : 6 === u.type && (i = new $c57589859a654fc0$var$Z(n, this, t)), this._$AV.push(i), u = e[++h];
            }
            l !== (null == u ? void 0 : u.index) && (n = $c57589859a654fc0$var$C.nextNode(), l++);
        }
        return $c57589859a654fc0$var$C.currentNode = $c57589859a654fc0$var$r, o;
    }
    v(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
}
class $c57589859a654fc0$var$R {
    get _$AU() {
        var t, i;
        return null !== (i = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== i ? i : this._$Cp;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === (null == t ? void 0 : t.nodeType) && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $c57589859a654fc0$var$S(this, t, i), $c57589859a654fc0$var$d(t) ? t === $c57589859a654fc0$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $c57589859a654fc0$export$45b790e32b2810ee && this._$AR(), this._$AH = $c57589859a654fc0$export$45b790e32b2810ee) : t !== this._$AH && t !== $c57589859a654fc0$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.g(t) : void 0 !== t.nodeType ? this.$(t) : $c57589859a654fc0$var$v(t) ? this.T(t) : this._(t);
    }
    k(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    $(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.k(t));
    }
    _(t) {
        this._$AH !== $c57589859a654fc0$export$45b790e32b2810ee && $c57589859a654fc0$var$d(this._$AH) ? this._$AA.nextSibling.data = t : this.$($c57589859a654fc0$var$r.createTextNode(t)), this._$AH = t;
    }
    g(t) {
        var i;
        const { values: s, _$litType$: e } = t, o = "number" == typeof e ? this._$AC(t) : (void 0 === e.el && (e.el = $c57589859a654fc0$var$N.createElement($c57589859a654fc0$var$P(e.h, e.h[0]), this.options)), e);
        if ((null === (i = this._$AH) || void 0 === i ? void 0 : i._$AD) === o) this._$AH.v(s);
        else {
            const t = new $c57589859a654fc0$var$M(o, this), i = t.u(this.options);
            t.v(s), this.$(i), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $c57589859a654fc0$var$E.get(t.strings);
        return void 0 === i && $c57589859a654fc0$var$E.set(t.strings, i = new $c57589859a654fc0$var$N(t)), i;
    }
    T(t) {
        $c57589859a654fc0$var$c(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const o of t)e === i.length ? i.push(s = new $c57589859a654fc0$var$R(this.k($c57589859a654fc0$var$u()), this.k($c57589859a654fc0$var$u()), this, this.options)) : s = i[e], s._$AI(o), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        var s;
        for(null === (s = this._$AP) || void 0 === s || s.call(this, !1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        var i;
        void 0 === this._$AM && (this._$Cp = t, null === (i = this._$AP) || void 0 === i || i.call(this, t));
    }
    constructor(t, i, s, e){
        var o;
        this.type = 2, this._$AH = $c57589859a654fc0$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cp = null === (o = null == e ? void 0 : e.isConnected) || void 0 === o || o;
    }
}
class $c57589859a654fc0$var$k {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t, i = this, s, e) {
        const o = this.strings;
        let n = !1;
        if (void 0 === o) t = $c57589859a654fc0$var$S(this, t, i, 0), n = !$c57589859a654fc0$var$d(t) || t !== this._$AH && t !== $c57589859a654fc0$export$9c068ae9cc5db4e8, n && (this._$AH = t);
        else {
            const e = t;
            let l, h;
            for(t = o[0], l = 0; l < o.length - 1; l++)h = $c57589859a654fc0$var$S(this, e[s + l], i, l), h === $c57589859a654fc0$export$9c068ae9cc5db4e8 && (h = this._$AH[l]), n || (n = !$c57589859a654fc0$var$d(h) || h !== this._$AH[l]), h === $c57589859a654fc0$export$45b790e32b2810ee ? t = $c57589859a654fc0$export$45b790e32b2810ee : t !== $c57589859a654fc0$export$45b790e32b2810ee && (t += (null != h ? h : "") + o[l + 1]), this._$AH[l] = h;
        }
        n && !e && this.j(t);
    }
    j(t) {
        t === $c57589859a654fc0$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
    constructor(t, i, s, e, o){
        this.type = 1, this._$AH = $c57589859a654fc0$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = o, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $c57589859a654fc0$export$45b790e32b2810ee;
    }
}
class $c57589859a654fc0$var$H extends $c57589859a654fc0$var$k {
    j(t) {
        this.element[this.name] = t === $c57589859a654fc0$export$45b790e32b2810ee ? void 0 : t;
    }
    constructor(){
        super(...arguments), this.type = 3;
    }
}
const $c57589859a654fc0$var$I = $c57589859a654fc0$var$s ? $c57589859a654fc0$var$s.emptyScript : "";
class $c57589859a654fc0$var$L extends $c57589859a654fc0$var$k {
    j(t) {
        t && t !== $c57589859a654fc0$export$45b790e32b2810ee ? this.element.setAttribute(this.name, $c57589859a654fc0$var$I) : this.element.removeAttribute(this.name);
    }
    constructor(){
        super(...arguments), this.type = 4;
    }
}
class $c57589859a654fc0$var$z extends $c57589859a654fc0$var$k {
    _$AI(t, i = this) {
        var s;
        if ((t = null !== (s = $c57589859a654fc0$var$S(this, t, i, 0)) && void 0 !== s ? s : $c57589859a654fc0$export$45b790e32b2810ee) === $c57589859a654fc0$export$9c068ae9cc5db4e8) return;
        const e = this._$AH, o = t === $c57589859a654fc0$export$45b790e32b2810ee && e !== $c57589859a654fc0$export$45b790e32b2810ee || t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive, n = t !== $c57589859a654fc0$export$45b790e32b2810ee && (e === $c57589859a654fc0$export$45b790e32b2810ee || o);
        o && this.element.removeEventListener(this.name, this, e), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        var i, s;
        "function" == typeof this._$AH ? this._$AH.call(null !== (s = null === (i = this.options) || void 0 === i ? void 0 : i.host) && void 0 !== s ? s : this.element, t) : this._$AH.handleEvent(t);
    }
    constructor(t, i, s, e, o){
        super(t, i, s, e, o), this.type = 5;
    }
}
class $c57589859a654fc0$var$Z {
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $c57589859a654fc0$var$S(this, t);
    }
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
}
const $c57589859a654fc0$export$8613d1ca9052b22e = {
    O: $c57589859a654fc0$var$o,
    P: $c57589859a654fc0$var$n,
    A: $c57589859a654fc0$var$l,
    C: 1,
    M: $c57589859a654fc0$var$V,
    L: $c57589859a654fc0$var$M,
    R: $c57589859a654fc0$var$v,
    D: $c57589859a654fc0$var$S,
    I: $c57589859a654fc0$var$R,
    V: $c57589859a654fc0$var$k,
    H: $c57589859a654fc0$var$L,
    N: $c57589859a654fc0$var$z,
    U: $c57589859a654fc0$var$H,
    F: $c57589859a654fc0$var$Z
}, $c57589859a654fc0$var$B = $c57589859a654fc0$var$i.litHtmlPolyfillSupport;
null == $c57589859a654fc0$var$B || $c57589859a654fc0$var$B($c57589859a654fc0$var$N, $c57589859a654fc0$var$R), (null !== ($c57589859a654fc0$var$t = $c57589859a654fc0$var$i.litHtmlVersions) && void 0 !== $c57589859a654fc0$var$t ? $c57589859a654fc0$var$t : $c57589859a654fc0$var$i.litHtmlVersions = []).push("2.8.0");
const $c57589859a654fc0$export$b3890eb0ae9dca99 = (t, i, s)=>{
    var e, o;
    const n = null !== (e = null == s ? void 0 : s.renderBefore) && void 0 !== e ? e : i;
    let l = n._$litPart$;
    if (void 0 === l) {
        const t = null !== (o = null == s ? void 0 : s.renderBefore) && void 0 !== o ? o : null;
        n._$litPart$ = l = new $c57589859a654fc0$var$R(i.insertBefore($c57589859a654fc0$var$u(), t), t, void 0, null != s ? s : {});
    }
    return l._$AI(t), l;
};

});

parcelRegister("e5L6E", function(module, exports) {

$parcel$export(module.exports, "$signal", function () { return $a42612a3a5a983c5$export$a49fad4e4764beed; });
$parcel$export(module.exports, "SlotManager", function () { return $a42612a3a5a983c5$export$737dfade0e2c8111; });
$parcel$export(module.exports, "Icon", function () { return $a42612a3a5a983c5$export$f04a61298a47a40f; });
$parcel$export(module.exports, "LayoutIconsLoader", function () { return $a42612a3a5a983c5$export$e0d226989ffa3b1d; });

var $57dmi = parcelRequire("57dmi");

var $fhH8k = parcelRequire("fhH8k");

var $4vwVC = parcelRequire("4vwVC");

var $2u9SC = parcelRequire("2u9SC");

var $9P4tJ = parcelRequire("9P4tJ");

var $97zcJ = parcelRequire("97zcJ");

var $8B3mG = parcelRequire("8B3mG");

var $gX4mh = parcelRequire("gX4mh");

var $8hn4v = parcelRequire("8hn4v");

var $ezUKc = parcelRequire("ezUKc");

var $fCAPZ = parcelRequire("fCAPZ");
var $2MTbH = parcelRequire("2MTbH");

var $6KfMo = parcelRequire("6KfMo");
var $a42612a3a5a983c5$var$_signal = /*#__PURE__*/ new WeakMap(), $a42612a3a5a983c5$var$_isAttr = /*#__PURE__*/ new WeakMap(), $a42612a3a5a983c5$var$_stop = /*#__PURE__*/ new WeakMap(), $a42612a3a5a983c5$var$_watch = /*#__PURE__*/ new WeakSet(), $a42612a3a5a983c5$var$_resolveValue = /*#__PURE__*/ new WeakSet(), $a42612a3a5a983c5$var$_setValue = /*#__PURE__*/ new WeakSet(), $a42612a3a5a983c5$var$_onValueChange = /*#__PURE__*/ new WeakSet();
class $a42612a3a5a983c5$var$SignalDirective extends (0, $fCAPZ.AsyncDirective) {
    render(signal) {
        if (signal !== (0, $57dmi._)(this, $a42612a3a5a983c5$var$_signal)) {
            this.disconnected();
            (0, $4vwVC._)(this, $a42612a3a5a983c5$var$_signal, signal);
            if (this.isConnected) (0, $2u9SC._)(this, $a42612a3a5a983c5$var$_watch, $a42612a3a5a983c5$var$watch).call(this);
        }
        return (0, $57dmi._)(this, $a42612a3a5a983c5$var$_signal) ? (0, $2u9SC._)(this, $a42612a3a5a983c5$var$_resolveValue, $a42612a3a5a983c5$var$resolveValue).call(this, (0, $8B3mG.peek)((0, $57dmi._)(this, $a42612a3a5a983c5$var$_signal))) : (0, $gX4mh.nothing);
    }
    reconnected() {
        (0, $2u9SC._)(this, $a42612a3a5a983c5$var$_watch, $a42612a3a5a983c5$var$watch).call(this);
    }
    disconnected() {
        var _this, _this1, _ref;
        (_this = (0, $57dmi._)(_ref = _this1 = this, $a42612a3a5a983c5$var$_stop)) === null || _this === void 0 ? void 0 : _this.call(_this1);
        (0, $4vwVC._)(this, $a42612a3a5a983c5$var$_stop, null);
    }
    constructor(part){
        super(part);
        (0, $9P4tJ._)(this, $a42612a3a5a983c5$var$_watch);
        (0, $9P4tJ._)(this, $a42612a3a5a983c5$var$_resolveValue);
        (0, $9P4tJ._)(this, $a42612a3a5a983c5$var$_setValue);
        (0, $9P4tJ._)(this, $a42612a3a5a983c5$var$_onValueChange);
        (0, $fhH8k._)(this, $a42612a3a5a983c5$var$_signal, {
            writable: true,
            value: null
        });
        (0, $fhH8k._)(this, $a42612a3a5a983c5$var$_isAttr, {
            writable: true,
            value: false
        });
        (0, $fhH8k._)(this, $a42612a3a5a983c5$var$_stop, {
            writable: true,
            value: null
        });
        (0, $4vwVC._)(this, $a42612a3a5a983c5$var$_isAttr, part.type === (0, $2MTbH.PartType).ATTRIBUTE || part.type === (0, $2MTbH.PartType).BOOLEAN_ATTRIBUTE);
    }
}
function $a42612a3a5a983c5$var$watch() {
    if (!(0, $57dmi._)(this, $a42612a3a5a983c5$var$_signal)) return;
    (0, $4vwVC._)(this, $a42612a3a5a983c5$var$_stop, (0, $8B3mG.effect)((0, $2u9SC._)(this, $a42612a3a5a983c5$var$_onValueChange, $a42612a3a5a983c5$var$onValueChange).bind(this)));
}
function $a42612a3a5a983c5$var$resolveValue(value) {
    return (0, $57dmi._)(this, $a42612a3a5a983c5$var$_isAttr) ? (0, $8hn4v.ifDefined)(value) : value;
}
function $a42612a3a5a983c5$var$setValue(value) {
    this.setValue((0, $2u9SC._)(this, $a42612a3a5a983c5$var$_resolveValue, $a42612a3a5a983c5$var$resolveValue).call(this, value));
}
function $a42612a3a5a983c5$var$onValueChange() {
    var _this, _this1, _ref;
    (0, $2u9SC._)(this, $a42612a3a5a983c5$var$_setValue, $a42612a3a5a983c5$var$setValue).call(this, (_this = (0, $57dmi._)(_ref = _this1 = this, $a42612a3a5a983c5$var$_signal)) === null || _this === void 0 ? void 0 : _this.call(_this1));
}
function $a42612a3a5a983c5$export$a49fad4e4764beed(compute) {
    return (0, $2MTbH.directive)($a42612a3a5a983c5$var$SignalDirective)((0, $8B3mG.computed)(compute));
}
var $a42612a3a5a983c5$var$_roots = /*#__PURE__*/ new WeakMap(), $a42612a3a5a983c5$var$_callback = /*#__PURE__*/ new WeakMap(), $a42612a3a5a983c5$var$_onMutation = /*#__PURE__*/ new WeakMap(), $a42612a3a5a983c5$var$_update = /*#__PURE__*/ new WeakSet();
class $a42612a3a5a983c5$var$SlotObserver {
    connect() {
        (0, $2u9SC._)(this, $a42612a3a5a983c5$var$_update, $a42612a3a5a983c5$var$update).call(this);
        const observer = new MutationObserver((0, $57dmi._)(this, $a42612a3a5a983c5$var$_onMutation));
        for (const root of (0, $57dmi._)(this, $a42612a3a5a983c5$var$_roots))observer.observe(root, {
            childList: true,
            subtree: true
        });
        (0, $8B3mG.onDispose)(()=>observer.disconnect());
        (0, $8B3mG.onDispose)(this.disconnect.bind(this));
    }
    disconnect() {
        this.elements.clear();
    }
    assign(template, slot) {
        if ((0, $8B3mG.isDOMNode)(template)) {
            slot.textContent = "";
            slot.append(template);
        } else {
            (0, $gX4mh.render)(null, slot);
            (0, $gX4mh.render)(template, slot);
        }
        if (!slot.style.display) slot.style.display = "contents";
        const el = slot.firstElementChild;
        if (!el) return;
        const classList = slot.getAttribute("data-class");
        if (classList) el.classList.add(...classList.split(" "));
    }
    constructor(roots, callback){
        (0, $9P4tJ._)(this, $a42612a3a5a983c5$var$_update);
        (0, $fhH8k._)(this, $a42612a3a5a983c5$var$_roots, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $a42612a3a5a983c5$var$_callback, {
            writable: true,
            value: void 0
        });
        (0, $97zcJ._)(this, "elements", /* @__PURE__ */ new Set());
        (0, $fhH8k._)(this, $a42612a3a5a983c5$var$_onMutation, {
            writable: true,
            value: (0, $8B3mG.animationFrameThrottle)((0, $2u9SC._)(this, $a42612a3a5a983c5$var$_update, $a42612a3a5a983c5$var$update).bind(this))
        });
        (0, $4vwVC._)(this, $a42612a3a5a983c5$var$_roots, roots);
        (0, $4vwVC._)(this, $a42612a3a5a983c5$var$_callback, callback);
    }
}
function $a42612a3a5a983c5$var$update(entries) {
    if (entries && !entries.some((e)=>e.addedNodes.length)) return;
    let changed = false, slots = (0, $57dmi._)(this, $a42612a3a5a983c5$var$_roots).flatMap((root)=>[
            ...root.querySelectorAll("slot")
        ]);
    for (const slot of slots){
        if (!slot.hasAttribute("name") || this.elements.has(slot)) continue;
        this.elements.add(slot);
        changed = true;
    }
    if (changed) (0, $57dmi._)(this, $a42612a3a5a983c5$var$_callback).call(this, this.elements);
}
let $a42612a3a5a983c5$var$id = 0, $a42612a3a5a983c5$var$slotIdAttr = "data-slot-id";
var $a42612a3a5a983c5$var$_roots1 = /*#__PURE__*/ new WeakMap(), $a42612a3a5a983c5$var$_onMutation1 = /*#__PURE__*/ new WeakMap(), $a42612a3a5a983c5$var$_update1 = /*#__PURE__*/ new WeakSet();
class $a42612a3a5a983c5$export$737dfade0e2c8111 {
    connect() {
        this.slots.connect();
        (0, $2u9SC._)(this, $a42612a3a5a983c5$var$_update1, $a42612a3a5a983c5$var$update1).call(this);
        const mutations = new MutationObserver((0, $57dmi._)(this, $a42612a3a5a983c5$var$_onMutation1));
        for (const root of (0, $57dmi._)(this, $a42612a3a5a983c5$var$_roots1))mutations.observe(root, {
            childList: true
        });
        (0, $8B3mG.onDispose)(()=>mutations.disconnect());
    }
    constructor(roots){
        (0, $9P4tJ._)(this, $a42612a3a5a983c5$var$_update1);
        (0, $fhH8k._)(this, $a42612a3a5a983c5$var$_roots1, {
            writable: true,
            value: void 0
        });
        (0, $97zcJ._)(this, "slots", void 0);
        (0, $fhH8k._)(this, $a42612a3a5a983c5$var$_onMutation1, {
            writable: true,
            value: (0, $8B3mG.animationFrameThrottle)((0, $2u9SC._)(this, $a42612a3a5a983c5$var$_update1, $a42612a3a5a983c5$var$update1).bind(this))
        });
        (0, $4vwVC._)(this, $a42612a3a5a983c5$var$_roots1, roots);
        this.slots = new $a42612a3a5a983c5$var$SlotObserver(roots, (0, $2u9SC._)(this, $a42612a3a5a983c5$var$_update1, $a42612a3a5a983c5$var$update1).bind(this));
    }
}
function $a42612a3a5a983c5$var$update1() {
    for (const root of (0, $57dmi._)(this, $a42612a3a5a983c5$var$_roots1))for (const node of root.children){
        if (node.nodeType !== 1) continue;
        const name = node.getAttribute("slot");
        if (!name) continue;
        node.style.display = "none";
        let slotId = node.getAttribute($a42612a3a5a983c5$var$slotIdAttr);
        if (!slotId) node.setAttribute($a42612a3a5a983c5$var$slotIdAttr, slotId = ++$a42612a3a5a983c5$var$id + "");
        for (const slot of this.slots.elements){
            if (slot.getAttribute("name") !== name || slot.getAttribute($a42612a3a5a983c5$var$slotIdAttr) === slotId) continue;
            const clone = document.importNode(node, true);
            if (name.includes("-icon")) clone.classList.add("vds-icon");
            clone.style.display = "";
            clone.removeAttribute("slot");
            this.slots.assign(clone, slot);
            slot.setAttribute($a42612a3a5a983c5$var$slotIdAttr, slotId);
        }
    }
}
function $a42612a3a5a983c5$export$f04a61298a47a40f({ name: name, class: _class, state: state, paths: paths, viewBox: viewBox = "0 0 32 32" }) {
    return (0, $gX4mh.html)`<svg
    class="${"vds-icon" + (_class ? ` ${_class}` : "")}"
    viewBox="${viewBox}"
    fill="none"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    data-icon=${(0, $8hn4v.ifDefined)(name ?? state)}
  >
    ${!(0, $8B3mG.isString)(paths) ? $a42612a3a5a983c5$export$a49fad4e4764beed(paths) : (0, $ezUKc.unsafeSVG)(paths)}
  </svg>`;
}
var $a42612a3a5a983c5$var$_icons = /*#__PURE__*/ new WeakMap(), $a42612a3a5a983c5$var$_loaded = /*#__PURE__*/ new WeakMap(), $a42612a3a5a983c5$var$_iterate = /*#__PURE__*/ new WeakSet(), $a42612a3a5a983c5$var$_insertIcons = /*#__PURE__*/ new WeakSet();
class $a42612a3a5a983c5$var$IconsLoader {
    connect() {
        this.slots.connect();
    }
    load() {
        this.loadIcons().then((icons)=>{
            (0, $4vwVC._)(this, $a42612a3a5a983c5$var$_icons, icons);
            (0, $4vwVC._)(this, $a42612a3a5a983c5$var$_loaded, true);
            (0, $2u9SC._)(this, $a42612a3a5a983c5$var$_insertIcons, $a42612a3a5a983c5$var$insertIcons).call(this);
        });
    }
    constructor(roots){
        (0, $9P4tJ._)(this, $a42612a3a5a983c5$var$_iterate);
        (0, $9P4tJ._)(this, $a42612a3a5a983c5$var$_insertIcons);
        (0, $fhH8k._)(this, $a42612a3a5a983c5$var$_icons, {
            writable: true,
            value: {}
        });
        (0, $fhH8k._)(this, $a42612a3a5a983c5$var$_loaded, {
            writable: true,
            value: false
        });
        (0, $97zcJ._)(this, "slots", void 0);
        this.slots = new $a42612a3a5a983c5$var$SlotObserver(roots, (0, $2u9SC._)(this, $a42612a3a5a983c5$var$_insertIcons, $a42612a3a5a983c5$var$insertIcons).bind(this));
    }
}
function* $a42612a3a5a983c5$var$iterate() {
    for (const iconName of Object.keys((0, $57dmi._)(this, $a42612a3a5a983c5$var$_icons))){
        const slotName = `${iconName}-icon`;
        for (const slot of this.slots.elements){
            if (slot.name !== slotName) continue;
            yield {
                icon: (0, $57dmi._)(this, $a42612a3a5a983c5$var$_icons)[iconName],
                slot: slot
            };
        }
    }
}
function $a42612a3a5a983c5$var$insertIcons() {
    if (!(0, $57dmi._)(this, $a42612a3a5a983c5$var$_loaded)) return;
    for (const { icon: icon, slot: slot } of (0, $2u9SC._)(this, $a42612a3a5a983c5$var$_iterate, $a42612a3a5a983c5$var$iterate).call(this))this.slots.assign(icon, slot);
}
class $a42612a3a5a983c5$export$e0d226989ffa3b1d extends $a42612a3a5a983c5$var$IconsLoader {
    connect() {
        super.connect();
        const { player: player } = (0, $6KfMo.useMediaContext)();
        if (!player.el) return;
        let dispose, observer = new IntersectionObserver((entries)=>{
            if (!entries[0]?.isIntersecting) return;
            dispose?.();
            dispose = void 0;
            this.load();
        });
        observer.observe(player.el);
        dispose = (0, $8B3mG.onDispose)(()=>observer.disconnect());
    }
}

});
parcelRegister("8hn4v", function(module, exports) {

$parcel$export(module.exports, "ifDefined", function () { return $6071cece8ccaa26b$export$f68dd208b5df064d; });

var $gX4mh = parcelRequire("gX4mh");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $6071cece8ccaa26b$export$f68dd208b5df064d = (l)=>null != l ? l : (0, $gX4mh.nothing);

});

parcelRegister("ezUKc", function(module, exports) {

$parcel$export(module.exports, "unsafeSVG", function () { return $a9d059c27464c341$export$1cb98903879b8bf5; });

var $2MTbH = parcelRequire("2MTbH");

var $bEYzr = parcelRequire("bEYzr");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $a9d059c27464c341$var$t extends (0, $bEYzr.UnsafeHTMLDirective) {
}
$a9d059c27464c341$var$t.directiveName = "unsafeSVG", $a9d059c27464c341$var$t.resultType = 2;
const $a9d059c27464c341$export$1cb98903879b8bf5 = (0, $2MTbH.directive)($a9d059c27464c341$var$t);

});
parcelRegister("2MTbH", function(module, exports) {

$parcel$export(module.exports, "PartType", function () { return $207adf943ee0e042$export$9ba3b3f20a85bfa; });
$parcel$export(module.exports, "directive", function () { return $207adf943ee0e042$export$99b43ad1ed32e735; });
$parcel$export(module.exports, "Directive", function () { return $207adf943ee0e042$export$befdefbdce210f91; });
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $207adf943ee0e042$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $207adf943ee0e042$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $207adf943ee0e042$export$befdefbdce210f91 {
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
    constructor(t){}
}

});

parcelRegister("bEYzr", function(module, exports) {

$parcel$export(module.exports, "UnsafeHTMLDirective", function () { return $87d26a3718441b7d$export$3bebd1f0e3943985; });
$parcel$export(module.exports, "unsafeHTML", function () { return $87d26a3718441b7d$export$b6e69390c23686fb; });

var $gX4mh = parcelRequire("gX4mh");

var $2MTbH = parcelRequire("2MTbH");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $87d26a3718441b7d$export$3bebd1f0e3943985 extends (0, $2MTbH.Directive) {
    render(r) {
        if (r === (0, $gX4mh.nothing) || null == r) return this.ft = void 0, this.et = r;
        if (r === (0, $gX4mh.noChange)) return r;
        if ("string" != typeof r) throw Error(this.constructor.directiveName + "() called with a non-string value");
        if (r === this.et) return this.ft;
        this.et = r;
        const s = [
            r
        ];
        return s.raw = s, this.ft = {
            _$litType$: this.constructor.resultType,
            strings: s,
            values: []
        };
    }
    constructor(i){
        if (super(i), this.et = (0, $gX4mh.nothing), i.type !== (0, $2MTbH.PartType).CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
    }
}
$87d26a3718441b7d$export$3bebd1f0e3943985.directiveName = "unsafeHTML", $87d26a3718441b7d$export$3bebd1f0e3943985.resultType = 1;
const $87d26a3718441b7d$export$b6e69390c23686fb = (0, $2MTbH.directive)($87d26a3718441b7d$export$3bebd1f0e3943985);

});


parcelRegister("fCAPZ", function(module, exports) {

$parcel$export(module.exports, "AsyncDirective", function () { return $b5f6faca2f4ead5a$export$7d025501802325e; });
$parcel$export(module.exports, "PartType", function () { return (parcelRequire("2MTbH")).PartType; });
$parcel$export(module.exports, "directive", function () { return (parcelRequire("2MTbH")).directive; });

var $1wFfK = parcelRequire("1wFfK");

var $2MTbH = parcelRequire("2MTbH");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $b5f6faca2f4ead5a$var$s = (i, t)=>{
    var e, o;
    const r = i._$AN;
    if (void 0 === r) return !1;
    for (const i of r)null === (o = (e = i)._$AO) || void 0 === o || o.call(e, t, !1), $b5f6faca2f4ead5a$var$s(i, t);
    return !0;
}, $b5f6faca2f4ead5a$var$o = (i)=>{
    let t, e;
    do {
        if (void 0 === (t = i._$AM)) break;
        e = t._$AN, e.delete(i), i = t;
    }while (0 === (null == e ? void 0 : e.size));
}, $b5f6faca2f4ead5a$var$r = (i)=>{
    for(let t; t = i._$AM; i = t){
        let e = t._$AN;
        if (void 0 === e) t._$AN = e = new Set;
        else if (e.has(i)) break;
        e.add(i), $b5f6faca2f4ead5a$var$l(t);
    }
};
function $b5f6faca2f4ead5a$var$n(i) {
    void 0 !== this._$AN ? ($b5f6faca2f4ead5a$var$o(this), this._$AM = i, $b5f6faca2f4ead5a$var$r(this)) : this._$AM = i;
}
function $b5f6faca2f4ead5a$var$h(i, t = !1, e = 0) {
    const r = this._$AH, n = this._$AN;
    if (void 0 !== n && 0 !== n.size) {
        if (t) {
            if (Array.isArray(r)) for(let i = e; i < r.length; i++)$b5f6faca2f4ead5a$var$s(r[i], !1), $b5f6faca2f4ead5a$var$o(r[i]);
            else null != r && ($b5f6faca2f4ead5a$var$s(r, !1), $b5f6faca2f4ead5a$var$o(r));
        } else $b5f6faca2f4ead5a$var$s(this, i);
    }
}
const $b5f6faca2f4ead5a$var$l = (i)=>{
    var t, s, o, r;
    i.type == (0, $2MTbH.PartType).CHILD && (null !== (t = (o = i)._$AP) && void 0 !== t || (o._$AP = $b5f6faca2f4ead5a$var$h), null !== (s = (r = i)._$AQ) && void 0 !== s || (r._$AQ = $b5f6faca2f4ead5a$var$n));
};
class $b5f6faca2f4ead5a$export$7d025501802325e extends (0, $2MTbH.Directive) {
    _$AT(i, t, e) {
        super._$AT(i, t, e), $b5f6faca2f4ead5a$var$r(this), this.isConnected = i._$AU;
    }
    _$AO(i, t = !0) {
        var e, r;
        i !== this.isConnected && (this.isConnected = i, i ? null === (e = this.reconnected) || void 0 === e || e.call(this) : null === (r = this.disconnected) || void 0 === r || r.call(this)), t && ($b5f6faca2f4ead5a$var$s(this, i), $b5f6faca2f4ead5a$var$o(this));
    }
    setValue(t) {
        if ((0, $1wFfK.isSingleExpression)(this._$Ct)) this._$Ct._$AI(t, this);
        else {
            const i = [
                ...this._$Ct._$AH
            ];
            i[this._$Ci] = t, this._$Ct._$AI(i, this, 0);
        }
    }
    disconnected() {}
    reconnected() {}
    constructor(){
        super(...arguments), this._$AN = void 0;
    }
}

});
parcelRegister("1wFfK", function(module, exports) {

$parcel$export(module.exports, "isSingleExpression", function () { return $11c8c79a2dc0cd8f$export$7f431ad0fff82fd9; });
$parcel$export(module.exports, "setCommittedValue", function () { return $11c8c79a2dc0cd8f$export$ea70d9dd5965b1c8; });

var $gX4mh = parcelRequire("gX4mh");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $11c8c79a2dc0cd8f$var$l } = (0, $gX4mh._$LH), $11c8c79a2dc0cd8f$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $11c8c79a2dc0cd8f$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2
}, $11c8c79a2dc0cd8f$export$6b6d145ec2a44ca9 = (o, l)=>void 0 === l ? void 0 !== (null == o ? void 0 : o._$litType$) : (null == o ? void 0 : o._$litType$) === l, $11c8c79a2dc0cd8f$export$6a0e8de894d2fcca = (o)=>{
    var l;
    return null != (null === (l = null == o ? void 0 : o._$litType$) || void 0 === l ? void 0 : l.h);
}, $11c8c79a2dc0cd8f$export$2f448fec17d50a3e = (o)=>void 0 !== (null == o ? void 0 : o._$litDirective$), $11c8c79a2dc0cd8f$export$f28e31de6a6eaf32 = (o)=>null == o ? void 0 : o._$litDirective$, $11c8c79a2dc0cd8f$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $11c8c79a2dc0cd8f$var$r = ()=>document.createComment(""), $11c8c79a2dc0cd8f$export$291b2338ad9b0b30 = (o, i, n)=>{
    var t;
    const v = o._$AA.parentNode, d = void 0 === i ? o._$AB : i._$AA;
    if (void 0 === n) {
        const i = v.insertBefore($11c8c79a2dc0cd8f$var$r(), d), t = v.insertBefore($11c8c79a2dc0cd8f$var$r(), d);
        n = new $11c8c79a2dc0cd8f$var$l(i, t, o, o.options);
    } else {
        const l = n._$AB.nextSibling, i = n._$AM, u = i !== o;
        if (u) {
            let l;
            null === (t = n._$AQ) || void 0 === t || t.call(n, o), n._$AM = o, void 0 !== n._$AP && (l = o._$AU) !== i._$AU && n._$AP(l);
        }
        if (l !== d || u) {
            let o = n._$AA;
            for(; o !== l;){
                const l = o.nextSibling;
                v.insertBefore(o, d), o = l;
            }
        }
    }
    return n;
}, $11c8c79a2dc0cd8f$export$cb8bf9562088e9f4 = (o, l, i = o)=>(o._$AI(l, i), o), $11c8c79a2dc0cd8f$var$s = {}, $11c8c79a2dc0cd8f$export$ea70d9dd5965b1c8 = (o, l = $11c8c79a2dc0cd8f$var$s)=>o._$AH = l, $11c8c79a2dc0cd8f$export$59e9bce518cde500 = (o)=>o._$AH, $11c8c79a2dc0cd8f$export$3133b3144bbba267 = (o)=>{
    var l;
    null === (l = o._$AP) || void 0 === l || l.call(o, !1, !0);
    let i = o._$AA;
    const n = o._$AB.nextSibling;
    for(; i !== n;){
        const o = i.nextSibling;
        i.remove(), i = o;
    }
}, $11c8c79a2dc0cd8f$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};

});



parcelRegister("jrniq", function(module, exports) {

$parcel$export(module.exports, "sortVideoQualities", function () { return $e2729c0df2024731$export$ba8b1fa603dcea98; });
$parcel$export(module.exports, "$ariaBool", function () { return $e2729c0df2024731$export$f928df85ef28554; });
function $e2729c0df2024731$export$ba8b1fa603dcea98(qualities, desc) {
    return [
        ...qualities
    ].sort(desc ? $e2729c0df2024731$var$compareVideoQualityDesc : $e2729c0df2024731$var$compareVideoQualityAsc);
}
function $e2729c0df2024731$var$compareVideoQualityAsc(a, b) {
    return a.height === b.height ? (a.bitrate ?? 0) - (b.bitrate ?? 0) : a.height - b.height;
}
function $e2729c0df2024731$var$compareVideoQualityDesc(a, b) {
    return b.height === a.height ? (b.bitrate ?? 0) - (a.bitrate ?? 0) : b.height - a.height;
}
function $e2729c0df2024731$var$ariaBool(value) {
    return value ? "true" : "false";
}
function $e2729c0df2024731$export$f928df85ef28554(signal) {
    return ()=>$e2729c0df2024731$var$ariaBool(signal());
}

});

parcelRegister("3Oa6Y", function(module, exports) {

$parcel$export(module.exports, "ref", function () { return $2c5de28aa94dc18f$export$eff4d24c3ff7876e; });

var $gX4mh = parcelRequire("gX4mh");

var $fCAPZ = parcelRequire("fCAPZ");

var $2MTbH = parcelRequire("2MTbH");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $2c5de28aa94dc18f$export$7d1e3a5e95ceca43 = ()=>new $2c5de28aa94dc18f$var$o;
class $2c5de28aa94dc18f$var$o {
}
const $2c5de28aa94dc18f$var$h = new WeakMap, $2c5de28aa94dc18f$export$eff4d24c3ff7876e = (0, $2MTbH.directive)(class extends (0, $fCAPZ.AsyncDirective) {
    render(t) {
        return 0, $gX4mh.nothing;
    }
    update(t, [s]) {
        var e;
        const o = s !== this.G;
        return o && void 0 !== this.G && this.ot(void 0), (o || this.rt !== this.lt) && (this.G = s, this.dt = null === (e = t.options) || void 0 === e ? void 0 : e.host, this.ot(this.lt = t.element)), $gX4mh.nothing;
    }
    ot(i) {
        var t;
        if ("function" == typeof this.G) {
            const s = null !== (t = this.dt) && void 0 !== t ? t : globalThis;
            let e = $2c5de28aa94dc18f$var$h.get(s);
            void 0 === e && (e = new WeakMap, $2c5de28aa94dc18f$var$h.set(s, e)), void 0 !== e.get(this.G) && this.G.call(this.dt, void 0), e.set(this.G, i), void 0 !== i && this.G.call(this.dt, i);
        } else this.G.value = i;
    }
    get rt() {
        var i, t, s;
        return "function" == typeof this.G ? null === (t = $2c5de28aa94dc18f$var$h.get(null !== (i = this.dt) && void 0 !== i ? i : globalThis)) || void 0 === t ? void 0 : t.get(this.G) : null === (s = this.G) || void 0 === s ? void 0 : s.value;
    }
    disconnected() {
        this.rt === this.lt && this.ot(void 0);
    }
    reconnected() {
        this.ot(this.lt);
    }
});

});

parcelRegister("6rDv2", function(module, exports) {


module.exports = (parcelRequire("9ONCo"))((parcelRequire("3pG7n")).resolve("62pQ9")).then(()=>parcelRequire("joTAL"));

});


parcelRegister("1dN1L", function(module, exports) {

$parcel$export(module.exports, "LitElement", function () { return $0e3d092d62a16890$export$3f2f9f5909897157; });

var $97zcJ = parcelRequire("97zcJ");

var $gX4mh = parcelRequire("gX4mh");
class $0e3d092d62a16890$export$3f2f9f5909897157 extends HTMLElement {
    connectedCallback() {
        this.rootPart = (0, $gX4mh.render)(this.render(), this, {
            renderBefore: this.firstChild
        });
        this.rootPart.setConnected(true);
    }
    disconnectedCallback() {
        this.rootPart?.setConnected(false);
        this.rootPart = null;
        (0, $gX4mh.render)(null, this);
    }
    constructor(...args){
        super(...args);
        (0, $97zcJ._)(this, "rootPart", null);
    }
}

});


parcelRegister("29GZd", function(module, exports) {

$parcel$export(module.exports, "MediaVideoLayoutElement", function () { return $191dc43c2b1399da$export$a7e922ae7d2f2da3; });

var $57dmi = parcelRequire("57dmi");

var $fhH8k = parcelRequire("fhH8k");

var $4vwVC = parcelRequire("4vwVC");

var $2u9SC = parcelRequire("2u9SC");

var $9P4tJ = parcelRequire("9P4tJ");

var $97zcJ = parcelRequire("97zcJ");

var $7w04t = parcelRequire("7w04t");

var $kiZDu = parcelRequire("kiZDu");

var $8B3mG = parcelRequire("8B3mG");

var $4E82O = parcelRequire("4E82O");

var $6KfMo = parcelRequire("6KfMo");

var $e5L6E = parcelRequire("e5L6E");

var $1dN1L = parcelRequire("1dN1L");

var $gX4mh = parcelRequire("gX4mh");

var $kLho8 = parcelRequire("kLho8");

var $ciZW6 = parcelRequire("ciZW6");


parcelRequire("8hn4v");
parcelRequire("3Oa6Y");


parcelRequire("ezUKc");
parcelRequire("fCAPZ");

class $191dc43c2b1399da$var$DefaultVideoLayout extends (0, $4E82O.DefaultLayout) {
}
(0, $97zcJ._)($191dc43c2b1399da$var$DefaultVideoLayout, "props", {
    ...(0, $7w04t._)((0, $kiZDu._)($191dc43c2b1399da$var$DefaultVideoLayout), "props", $191dc43c2b1399da$var$DefaultVideoLayout),
    when: ({ viewType: viewType })=>viewType === "video",
    smallWhen: ({ width: width, height: height })=>width < 576 || height < 380
});
function $191dc43c2b1399da$var$DefaultKeyboardDisplay() {
    return (0, $e5L6E.$signal)(()=>{
        const media = (0, $6KfMo.useMediaContext)(), { noKeyboardAnimations: noKeyboardAnimations, userPrefersKeyboardAnimations: userPrefersKeyboardAnimations } = (0, $4E82O.useDefaultLayoutContext)(), $disabled = (0, $8B3mG.computed)(()=>noKeyboardAnimations() || !userPrefersKeyboardAnimations());
        if ($disabled()) return null;
        const visible = (0, $8B3mG.signal)(false), { lastKeyboardAction: lastKeyboardAction } = media.$state;
        (0, $8B3mG.effect)(()=>{
            visible.set(!!lastKeyboardAction());
            const id = setTimeout(()=>visible.set(false), 500);
            return ()=>{
                visible.set(false);
                window.clearTimeout(id);
            };
        });
        const $actionDataAttr = (0, $8B3mG.computed)(()=>{
            const action = lastKeyboardAction()?.action;
            return action && visible() ? (0, $8B3mG.camelToKebabCase)(action) : null;
        });
        const $classList = (0, $8B3mG.computed)(()=>`vds-kb-action${!visible() ? " hidden" : ""}`), $text = (0, $8B3mG.computed)($191dc43c2b1399da$var$getText), $iconSlot = (0, $8B3mG.computed)(()=>{
            const name = $191dc43c2b1399da$var$getIconName();
            return name ? (0, $ciZW6.createSlot)(name) : null;
        });
        function Icon() {
            const $slot = $iconSlot();
            if (!$slot) return null;
            return (0, $gX4mh.html)`
        <div class="vds-kb-bezel">
          <div class="vds-kb-icon">${$slot}</div>
        </div>
      `;
        }
        return (0, $gX4mh.html)`
      <div class=${(0, $e5L6E.$signal)($classList)} data-action=${(0, $e5L6E.$signal)($actionDataAttr)}>
        <div class="vds-kb-text-wrapper">
          <div class="vds-kb-text">${(0, $e5L6E.$signal)($text)}</div>
        </div>
        ${(0, $e5L6E.$signal)(()=>(0, $kLho8.keyed)(lastKeyboardAction(), Icon()))}
      </div>
    `;
    });
}
function $191dc43c2b1399da$var$getText() {
    const { $state: $state } = (0, $6KfMo.useMediaContext)(), action = $state.lastKeyboardAction()?.action, audioGain = $state.audioGain() ?? 1;
    switch(action){
        case "toggleMuted":
            return $state.muted() ? "0%" : $191dc43c2b1399da$var$getVolumeText($state.volume(), audioGain);
        case "volumeUp":
        case "volumeDown":
            return $191dc43c2b1399da$var$getVolumeText($state.volume(), audioGain);
        default:
            return "";
    }
}
function $191dc43c2b1399da$var$getVolumeText(volume, gain) {
    return `${Math.round(volume * gain * 100)}%`;
}
function $191dc43c2b1399da$var$getIconName() {
    const { $state: $state } = (0, $6KfMo.useMediaContext)(), action = $state.lastKeyboardAction()?.action;
    switch(action){
        case "togglePaused":
            return !$state.paused() ? "kb-play-icon" : "kb-pause-icon";
        case "toggleMuted":
            return $state.muted() || $state.volume() === 0 ? "kb-mute-icon" : $state.volume() >= 0.5 ? "kb-volume-up-icon" : "kb-volume-down-icon";
        case "toggleFullscreen":
            return `kb-fs-${$state.fullscreen() ? "enter" : "exit"}-icon`;
        case "togglePictureInPicture":
            return `kb-pip-${$state.pictureInPicture() ? "enter" : "exit"}-icon`;
        case "toggleCaptions":
            return $state.hasCaptions() ? `kb-cc-${$state.textTrack() ? "on" : "off"}-icon` : null;
        case "volumeUp":
            return "kb-volume-up-icon";
        case "volumeDown":
            return "kb-volume-down-icon";
        case "seekForward":
            return "kb-seek-forward-icon";
        case "seekBackward":
            return "kb-seek-backward-icon";
        default:
            return null;
    }
}
function $191dc43c2b1399da$var$DefaultVideoLayoutLarge() {
    return [
        (0, $4E82O.DefaultAnnouncer)(),
        $191dc43c2b1399da$var$DefaultVideoGestures(),
        $191dc43c2b1399da$var$DefaultBufferingIndicator(),
        $191dc43c2b1399da$var$DefaultKeyboardDisplay(),
        (0, $4E82O.DefaultCaptions)(),
        (0, $gX4mh.html)`<div class="vds-scrim"></div>`,
        (0, $gX4mh.html)`
      <media-controls class="vds-controls">
        ${[
            $191dc43c2b1399da$var$DefaultControlsGroupTop(),
            (0, $4E82O.DefaultControlsSpacer)(),
            (0, $gX4mh.html)`<media-controls-group class="vds-controls-group"></media-controls-group>`,
            (0, $4E82O.DefaultControlsSpacer)(),
            (0, $gX4mh.html)`
            <media-controls-group class="vds-controls-group">
              ${(0, $4E82O.DefaultTimeSlider)()}
            </media-controls-group>
          `,
            (0, $gX4mh.html)`
            <media-controls-group class="vds-controls-group">
              ${[
                (0, $4E82O.DefaultPlayButton)({
                    tooltip: "top start"
                }),
                (0, $4E82O.DefaultVolumePopup)({
                    orientation: "horizontal",
                    tooltip: "top"
                }),
                (0, $4E82O.DefaultTimeInfo)(),
                (0, $4E82O.DefaultTitle)(),
                (0, $4E82O.DefaultCaptionButton)({
                    tooltip: "top"
                }),
                $191dc43c2b1399da$var$DefaultBottomMenuGroup(),
                (0, $4E82O.DefaultAirPlayButton)({
                    tooltip: "top"
                }),
                (0, $4E82O.DefaultGoogleCastButton)({
                    tooltip: "top"
                }),
                (0, $4E82O.DefaultDownloadButton)(),
                (0, $4E82O.DefaultPIPButton)(),
                (0, $4E82O.DefaultFullscreenButton)({
                    tooltip: "top end"
                })
            ]}
            </media-controls-group>
          `
        ]}
      </media-controls>
    `
    ];
}
function $191dc43c2b1399da$var$DefaultBottomMenuGroup() {
    return (0, $e5L6E.$signal)(()=>{
        const { menuGroup: menuGroup } = (0, $4E82O.useDefaultLayoutContext)();
        return menuGroup() === "bottom" ? $191dc43c2b1399da$var$DefaultVideoMenus() : null;
    });
}
function $191dc43c2b1399da$var$DefaultControlsGroupTop() {
    return (0, $gX4mh.html)`
    <media-controls-group class="vds-controls-group">
      ${(0, $e5L6E.$signal)(()=>{
        const { menuGroup: menuGroup } = (0, $4E82O.useDefaultLayoutContext)();
        return menuGroup() === "top" ? [
            (0, $4E82O.DefaultControlsSpacer)(),
            $191dc43c2b1399da$var$DefaultVideoMenus()
        ] : null;
    })}
    </media-controls-group>
  `;
}
function $191dc43c2b1399da$var$DefaultVideoLayoutSmall() {
    return [
        (0, $4E82O.DefaultAnnouncer)(),
        $191dc43c2b1399da$var$DefaultVideoGestures(),
        $191dc43c2b1399da$var$DefaultBufferingIndicator(),
        (0, $4E82O.DefaultCaptions)(),
        $191dc43c2b1399da$var$DefaultKeyboardDisplay(),
        (0, $gX4mh.html)`<div class="vds-scrim"></div>`,
        (0, $gX4mh.html)`
      <media-controls class="vds-controls">
        <media-controls-group class="vds-controls-group">
          ${[
            (0, $4E82O.DefaultAirPlayButton)({
                tooltip: "top start"
            }),
            (0, $4E82O.DefaultGoogleCastButton)({
                tooltip: "bottom start"
            }),
            (0, $4E82O.DefaultControlsSpacer)(),
            (0, $4E82O.DefaultCaptionButton)({
                tooltip: "bottom"
            }),
            (0, $4E82O.DefaultDownloadButton)(),
            $191dc43c2b1399da$var$DefaultVideoMenus(),
            (0, $4E82O.DefaultVolumePopup)({
                orientation: "vertical",
                tooltip: "bottom end"
            })
        ]}
        </media-controls-group>

        ${(0, $4E82O.DefaultControlsSpacer)()}

        <media-controls-group class="vds-controls-group" style="pointer-events: none;">
          ${[
            (0, $4E82O.DefaultControlsSpacer)(),
            (0, $4E82O.DefaultPlayButton)({
                tooltip: "top"
            }),
            (0, $4E82O.DefaultControlsSpacer)()
        ]}
        </media-controls-group>

        ${(0, $4E82O.DefaultControlsSpacer)()}

        <media-controls-group class="vds-controls-group">
          ${[
            (0, $4E82O.DefaultTimeInfo)(),
            (0, $4E82O.DefaultTitle)(),
            (0, $4E82O.DefaultFullscreenButton)({
                tooltip: "top end"
            })
        ]}
        </media-controls-group>

        <media-controls-group class="vds-controls-group">
          ${(0, $4E82O.DefaultTimeSlider)()}
        </media-controls-group>
      </media-controls>
    `,
        $191dc43c2b1399da$var$StartDuration()
    ];
}
function $191dc43c2b1399da$var$DefaultVideoLoadLayout() {
    return (0, $gX4mh.html)`
    <div class="vds-load-container">
      ${[
        $191dc43c2b1399da$var$DefaultBufferingIndicator(),
        (0, $4E82O.DefaultPlayButton)({
            tooltip: "top"
        })
    ]}
    </div>
  `;
}
function $191dc43c2b1399da$var$StartDuration() {
    return (0, $e5L6E.$signal)(()=>{
        const { duration: duration } = (0, $6KfMo.useMediaState)();
        if (duration() === 0) return null;
        return (0, $gX4mh.html)`
      <div class="vds-start-duration">
        <media-time class="vds-time" type="duration"></media-time>
      </div>
    `;
    });
}
function $191dc43c2b1399da$var$DefaultBufferingIndicator() {
    return (0, $gX4mh.html)`
    <div class="vds-buffering-indicator">
      <media-spinner class="vds-buffering-spinner"></media-spinner>
    </div>
  `;
}
function $191dc43c2b1399da$var$DefaultVideoMenus() {
    const { menuGroup: menuGroup, smallWhen: smWhen } = (0, $4E82O.useDefaultLayoutContext)(), $side = ()=>menuGroup() === "top" || smWhen() ? "bottom" : "top", $tooltip = (0, $8B3mG.computed)(()=>`${$side()} ${menuGroup() === "top" ? "end" : "center"}`), $placement = (0, $8B3mG.computed)(()=>`${$side()} end`);
    return [
        (0, $4E82O.DefaultChaptersMenu)({
            tooltip: $tooltip,
            placement: $placement,
            portal: true
        }),
        (0, $4E82O.DefaultSettingsMenu)({
            tooltip: $tooltip,
            placement: $placement,
            portal: true
        })
    ];
}
function $191dc43c2b1399da$var$DefaultVideoGestures() {
    return (0, $e5L6E.$signal)(()=>{
        const { noGestures: noGestures } = (0, $4E82O.useDefaultLayoutContext)();
        if (noGestures()) return null;
        return (0, $gX4mh.html)`
      <div class="vds-gestures">
        <media-gesture class="vds-gesture" event="pointerup" action="toggle:paused"></media-gesture>
        <media-gesture
          class="vds-gesture"
          event="pointerup"
          action="toggle:controls"
        ></media-gesture>
        <media-gesture
          class="vds-gesture"
          event="dblpointerup"
          action="toggle:fullscreen"
        ></media-gesture>
        <media-gesture class="vds-gesture" event="dblpointerup" action="seek:-10"></media-gesture>
        <media-gesture class="vds-gesture" event="dblpointerup" action="seek:10"></media-gesture>
      </div>
    `;
    });
}
var $191dc43c2b1399da$var$_Host, $191dc43c2b1399da$var$_media = /*#__PURE__*/ new WeakMap(), $191dc43c2b1399da$var$_setupMenuContainer = /*#__PURE__*/ new WeakSet(), $191dc43c2b1399da$var$_render = /*#__PURE__*/ new WeakSet();
class $191dc43c2b1399da$export$a7e922ae7d2f2da3 extends ($191dc43c2b1399da$var$_Host = (0, $8B3mG.Host)((0, $1dN1L.LitElement), $191dc43c2b1399da$var$DefaultVideoLayout)) {
    onSetup() {
        this.forwardKeepAlive = false;
        (0, $4vwVC._)(this, $191dc43c2b1399da$var$_media, (0, $6KfMo.useMediaContext)());
        this.classList.add("vds-video-layout");
    }
    onConnect() {
        (0, $4E82O.setLayoutName)("video", ()=>this.isMatch);
        (0, $2u9SC._)(this, $191dc43c2b1399da$var$_setupMenuContainer, $191dc43c2b1399da$var$setupMenuContainer).call(this);
    }
    render() {
        return (0, $e5L6E.$signal)((0, $2u9SC._)(this, $191dc43c2b1399da$var$_render, $191dc43c2b1399da$var$render).bind(this));
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $191dc43c2b1399da$var$_setupMenuContainer);
        (0, $9P4tJ._)(this, $191dc43c2b1399da$var$_render);
        (0, $fhH8k._)(this, $191dc43c2b1399da$var$_media, {
            writable: true,
            value: void 0
        });
    }
}
(0, $97zcJ._)($191dc43c2b1399da$export$a7e922ae7d2f2da3, "tagName", "media-video-layout");
(0, $97zcJ._)($191dc43c2b1399da$export$a7e922ae7d2f2da3, "attrs", {
    smallWhen: {
        converter (value) {
            return value !== "never" && !!value;
        }
    }
});
function $191dc43c2b1399da$var$setupMenuContainer() {
    const { menuPortal: menuPortal } = (0, $4E82O.useDefaultLayoutContext)();
    (0, $8B3mG.effect)(()=>{
        if (!this.isMatch) return;
        const container = (0, $4E82O.createMenuContainer)(this, this.menuContainer, "vds-video-layout", ()=>this.isSmallLayout), roots = container ? [
            this,
            container
        ] : [
            this
        ];
        const iconsManager = this.$props.customIcons() ? new (0, $e5L6E.SlotManager)(roots) : new (0, $4E82O.DefaultLayoutIconsLoader)(roots);
        iconsManager.connect();
        menuPortal.set(container);
        return ()=>{
            container.remove();
            menuPortal.set(null);
        };
    });
}
function $191dc43c2b1399da$var$render() {
    const { load: load } = (0, $57dmi._)(this, $191dc43c2b1399da$var$_media).$props, { canLoad: canLoad, streamType: streamType, nativeControls: nativeControls } = (0, $57dmi._)(this, $191dc43c2b1399da$var$_media).$state;
    return !nativeControls() && this.isMatch ? load() === "play" && !canLoad() ? $191dc43c2b1399da$var$DefaultVideoLoadLayout() : streamType() === "unknown" ? $191dc43c2b1399da$var$DefaultBufferingIndicator() : this.isSmallLayout ? $191dc43c2b1399da$var$DefaultVideoLayoutSmall() : $191dc43c2b1399da$var$DefaultVideoLayoutLarge() : null;
}

});
parcelRegister("kLho8", function(module, exports) {

$parcel$export(module.exports, "keyed", function () { return $f1d5af5fe9510f0d$export$8dbf9c790527241e; });

var $gX4mh = parcelRequire("gX4mh");

var $2MTbH = parcelRequire("2MTbH");

var $1wFfK = parcelRequire("1wFfK");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $f1d5af5fe9510f0d$export$8dbf9c790527241e = (0, $2MTbH.directive)(class extends (0, $2MTbH.Directive) {
    render(r, t) {
        return this.key = r, t;
    }
    update(r, [t, e]) {
        return t !== this.key && ((0, $1wFfK.setCommittedValue)(r), this.key = t), e;
    }
    constructor(){
        super(...arguments), this.key = (0, $gX4mh.nothing);
    }
});

});



parcelRegister("begiE", function(module, exports) {

var $8B3mG = parcelRequire("8B3mG");

var $a0hcA = parcelRequire("a0hcA");

var $itCve = parcelRequire("itCve");

var $juFXD = parcelRequire("juFXD");













parcelRequire("gX4mh");


(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaLayoutElement));
(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaControlsElement));
(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaControlsGroupElement));
(0, $8B3mG.defineCustomElement)((0, $juFXD.MediaPosterElement));
(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaAnnouncerElement));
(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaTooltipElement));
(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaTooltipTriggerElement));
(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaTooltipContentElement));
(0, $8B3mG.defineCustomElement)((0, $itCve.MediaPlayButtonElement));
(0, $8B3mG.defineCustomElement)((0, $itCve.MediaMuteButtonElement));
(0, $8B3mG.defineCustomElement)((0, $itCve.MediaCaptionButtonElement));
(0, $8B3mG.defineCustomElement)((0, $itCve.MediaFullscreenButtonElement));
(0, $8B3mG.defineCustomElement)((0, $itCve.MediaPIPButtonElement));
(0, $8B3mG.defineCustomElement)((0, $itCve.MediaSeekButtonElement));
(0, $8B3mG.defineCustomElement)((0, $itCve.MediaAirPlayButtonElement));
(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaGoogleCastButtonElement));
(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaToggleButtonElement));
(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaSliderElement));
(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaAudioGainSliderElement));
(0, $8B3mG.defineCustomElement)((0, $itCve.MediaVolumeSliderElement));
(0, $8B3mG.defineCustomElement)((0, $itCve.MediaTimeSliderElement));
(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaSpeedSliderElement));
(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaQualitySliderElement));
(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaSliderChaptersElement));
(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaSliderStepsElement));
(0, $8B3mG.defineCustomElement)((0, $itCve.MediaSliderPreviewElement));
(0, $8B3mG.defineCustomElement)((0, $itCve.MediaSliderValueElement));
(0, $8B3mG.defineCustomElement)((0, $itCve.MediaSliderThumbnailElement));
(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaSliderVideoElement));
(0, $8B3mG.defineCustomElement)((0, $itCve.MediaMenuElement));
(0, $8B3mG.defineCustomElement)((0, $itCve.MediaMenuButtonElement));
(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaMenuPortalElement));
(0, $8B3mG.defineCustomElement)((0, $itCve.MediaMenuItemsElement));
(0, $8B3mG.defineCustomElement)((0, $itCve.MediaMenuItemElement));
(0, $8B3mG.defineCustomElement)((0, $itCve.MediaAudioRadioGroupElement));
(0, $8B3mG.defineCustomElement)((0, $itCve.MediaCaptionsRadioGroupElement));
(0, $8B3mG.defineCustomElement)((0, $itCve.MediaSpeedRadioGroupElement));
(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaAudioGainRadioGroupElement));
(0, $8B3mG.defineCustomElement)((0, $itCve.MediaQualityRadioGroupElement));
(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaChaptersRadioGroupElement));
(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaRadioGroupElement));
(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaRadioElement));
(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaGestureElement));
(0, $8B3mG.defineCustomElement)((0, $itCve.MediaThumbnailElement));
(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaCaptionsElement));
(0, $8B3mG.defineCustomElement)((0, $itCve.MediaLiveButtonElement));
(0, $8B3mG.defineCustomElement)((0, $itCve.MediaTimeElement));
(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaTitleElement));
(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaChapterTitleElement));
(0, $8B3mG.defineCustomElement)((0, $a0hcA.MediaSpinnerElement));

});
parcelRegister("a0hcA", function(module, exports) {

$parcel$export(module.exports, "MediaCaptionsElement", function () { return $74873f712a093416$export$504d0e74d1c95fef; });
$parcel$export(module.exports, "MediaGestureElement", function () { return $74873f712a093416$export$c706d884ba0859b9; });
$parcel$export(module.exports, "MediaAnnouncerElement", function () { return $74873f712a093416$export$fdca8c8c2cea4356; });
$parcel$export(module.exports, "MediaControlsElement", function () { return $74873f712a093416$export$d0a3519caf288ef1; });
$parcel$export(module.exports, "MediaControlsGroupElement", function () { return $74873f712a093416$export$261b7ab30f70a1e; });
$parcel$export(module.exports, "MediaTitleElement", function () { return $74873f712a093416$export$a282b0b3e87cb693; });
$parcel$export(module.exports, "MediaChapterTitleElement", function () { return $74873f712a093416$export$2c4f40bef87cd3d; });
$parcel$export(module.exports, "MediaSpinnerElement", function () { return $74873f712a093416$export$fa8280453beb4c7e; });
$parcel$export(module.exports, "MediaLayoutElement", function () { return $74873f712a093416$export$18fdfc23a3efc900; });
$parcel$export(module.exports, "MediaGoogleCastButtonElement", function () { return $74873f712a093416$export$2421b0d66f1c3793; });
$parcel$export(module.exports, "MediaToggleButtonElement", function () { return $74873f712a093416$export$63fd5d5d2460e68b; });
$parcel$export(module.exports, "MediaTooltipElement", function () { return $74873f712a093416$export$c2c0ae4671d6c749; });
$parcel$export(module.exports, "MediaTooltipTriggerElement", function () { return $74873f712a093416$export$17af34a510418183; });
$parcel$export(module.exports, "MediaTooltipContentElement", function () { return $74873f712a093416$export$45a8291cfb2c223f; });
$parcel$export(module.exports, "MediaMenuPortalElement", function () { return $74873f712a093416$export$fe1e6b36160a0c78; });
$parcel$export(module.exports, "MediaChaptersRadioGroupElement", function () { return $74873f712a093416$export$30201d38e80b656d; });
$parcel$export(module.exports, "MediaAudioGainRadioGroupElement", function () { return $74873f712a093416$export$2cff8b00e97ca952; });
$parcel$export(module.exports, "MediaRadioElement", function () { return $74873f712a093416$export$4eb6699d52324e3a; });
$parcel$export(module.exports, "MediaRadioGroupElement", function () { return $74873f712a093416$export$8f2cedc6240c50b1; });
$parcel$export(module.exports, "MediaSliderElement", function () { return $74873f712a093416$export$3590061e1a06950d; });
$parcel$export(module.exports, "MediaSliderVideoElement", function () { return $74873f712a093416$export$13efc38e5883eac6; });
$parcel$export(module.exports, "MediaAudioGainSliderElement", function () { return $74873f712a093416$export$baf5ea9b3a958d46; });
$parcel$export(module.exports, "MediaSpeedSliderElement", function () { return $74873f712a093416$export$59a66cbb9762628a; });
$parcel$export(module.exports, "MediaQualitySliderElement", function () { return $74873f712a093416$export$8fb96d4aa2b0d83c; });
$parcel$export(module.exports, "MediaSliderChaptersElement", function () { return $74873f712a093416$export$7163c0c94dc0e8a; });
$parcel$export(module.exports, "MediaSliderStepsElement", function () { return $74873f712a093416$export$42383907fed3a5cb; });

var $57dmi = parcelRequire("57dmi");

var $fhH8k = parcelRequire("fhH8k");

var $4vwVC = parcelRequire("4vwVC");

var $2u9SC = parcelRequire("2u9SC");

var $9P4tJ = parcelRequire("9P4tJ");

var $97zcJ = parcelRequire("97zcJ");

var $8B3mG = parcelRequire("8B3mG");

var $f206l = parcelRequire("f206l");

var $6KfMo = parcelRequire("6KfMo");

var $l6thX = parcelRequire("l6thX");

var $gX4mh = parcelRequire("gX4mh");

var $ciZW6 = parcelRequire("ciZW6");

var $1dN1L = parcelRequire("1dN1L");

var $g6paF = parcelRequire("g6paF");

var $itCve = parcelRequire("itCve");
var $74873f712a093416$var$_Host;
class $74873f712a093416$export$504d0e74d1c95fef extends ($74873f712a093416$var$_Host = (0, $8B3mG.Host)(HTMLElement, (0, $f206l.Captions))) {
}
(0, $97zcJ._)($74873f712a093416$export$504d0e74d1c95fef, "tagName", "media-captions");
var $74873f712a093416$var$_Host1;
class $74873f712a093416$export$c706d884ba0859b9 extends ($74873f712a093416$var$_Host1 = (0, $8B3mG.Host)(HTMLElement, (0, $f206l.Gesture))) {
}
(0, $97zcJ._)($74873f712a093416$export$c706d884ba0859b9, "tagName", "media-gesture");
var $74873f712a093416$var$_Host2;
class $74873f712a093416$export$fdca8c8c2cea4356 extends ($74873f712a093416$var$_Host2 = (0, $8B3mG.Host)(HTMLElement, (0, $f206l.MediaAnnouncer))) {
}
(0, $97zcJ._)($74873f712a093416$export$fdca8c8c2cea4356, "tagName", "media-announcer");
var $74873f712a093416$var$_Host3;
class $74873f712a093416$export$d0a3519caf288ef1 extends ($74873f712a093416$var$_Host3 = (0, $8B3mG.Host)(HTMLElement, (0, $f206l.Controls))) {
}
(0, $97zcJ._)($74873f712a093416$export$d0a3519caf288ef1, "tagName", "media-controls");
var $74873f712a093416$var$_Host4;
class $74873f712a093416$export$261b7ab30f70a1e extends ($74873f712a093416$var$_Host4 = (0, $8B3mG.Host)(HTMLElement, (0, $f206l.ControlsGroup))) {
}
(0, $97zcJ._)($74873f712a093416$export$261b7ab30f70a1e, "tagName", "media-controls-group");
class $74873f712a093416$var$Title extends (0, $8B3mG.Component) {
}
var $74873f712a093416$var$_Host5, $74873f712a093416$var$_media = /*#__PURE__*/ new WeakMap(), $74873f712a093416$var$_watchTitle = /*#__PURE__*/ new WeakSet();
class $74873f712a093416$export$a282b0b3e87cb693 extends ($74873f712a093416$var$_Host5 = (0, $8B3mG.Host)(HTMLElement, $74873f712a093416$var$Title)) {
    onSetup() {
        (0, $4vwVC._)(this, $74873f712a093416$var$_media, (0, $6KfMo.useMediaContext)());
    }
    onConnect() {
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $74873f712a093416$var$_watchTitle, $74873f712a093416$var$watchTitle).bind(this));
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $74873f712a093416$var$_watchTitle);
        (0, $fhH8k._)(this, $74873f712a093416$var$_media, {
            writable: true,
            value: void 0
        });
    }
}
(0, $97zcJ._)($74873f712a093416$export$a282b0b3e87cb693, "tagName", "media-title");
function $74873f712a093416$var$watchTitle() {
    const { title: title } = (0, $57dmi._)(this, $74873f712a093416$var$_media).$state;
    this.textContent = title();
}
class $74873f712a093416$var$ChapterTitle extends (0, $8B3mG.Component) {
}
(0, $97zcJ._)($74873f712a093416$var$ChapterTitle, "props", {
    defaultText: ""
});
var $74873f712a093416$var$_Host6, $74873f712a093416$var$_media1 = /*#__PURE__*/ new WeakMap(), $74873f712a093416$var$_chapterTitle = /*#__PURE__*/ new WeakMap(), $74873f712a093416$var$_watchChapterTitle = /*#__PURE__*/ new WeakSet();
class $74873f712a093416$export$2c4f40bef87cd3d extends ($74873f712a093416$var$_Host6 = (0, $8B3mG.Host)(HTMLElement, $74873f712a093416$var$ChapterTitle)) {
    onSetup() {
        (0, $4vwVC._)(this, $74873f712a093416$var$_media1, (0, $6KfMo.useMediaContext)());
        (0, $4vwVC._)(this, $74873f712a093416$var$_chapterTitle, (0, $8B3mG.signal)(""));
    }
    onConnect() {
        const tracks = (0, $57dmi._)(this, $74873f712a093416$var$_media1).textTracks;
        (0, $l6thX.watchCueTextChange)(tracks, "chapters", (0, $57dmi._)(this, $74873f712a093416$var$_chapterTitle).set);
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $74873f712a093416$var$_watchChapterTitle, $74873f712a093416$var$watchChapterTitle).bind(this));
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $74873f712a093416$var$_watchChapterTitle);
        (0, $fhH8k._)(this, $74873f712a093416$var$_media1, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $74873f712a093416$var$_chapterTitle, {
            writable: true,
            value: void 0
        });
    }
}
(0, $97zcJ._)($74873f712a093416$export$2c4f40bef87cd3d, "tagName", "media-chapter-title");
function $74873f712a093416$var$watchChapterTitle() {
    const { defaultText: defaultText } = this.$props;
    this.textContent = (0, $57dmi._)(this, $74873f712a093416$var$_chapterTitle).call(this) || defaultText();
}
var $74873f712a093416$var$_update = /*#__PURE__*/ new WeakSet();
class $74873f712a093416$var$Spinner extends (0, $8B3mG.Component) {
    onConnect(el) {
        (0, $ciZW6.requestScopedAnimationFrame)(()=>{
            if (!this.connectScope) return;
            const root = el.querySelector("svg"), track = root.firstElementChild, trackFill = track.nextElementSibling;
            (0, $8B3mG.effect)((0, $2u9SC._)(this, $74873f712a093416$var$_update, $74873f712a093416$var$update).bind(this, root, track, trackFill));
        });
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $74873f712a093416$var$_update);
    }
}
(0, $97zcJ._)($74873f712a093416$var$Spinner, "props", {
    size: 96,
    trackWidth: 8,
    fillPercent: 50
});
function $74873f712a093416$var$update(root, track, trackFill) {
    const { size: size, trackWidth: trackWidth, fillPercent: fillPercent } = this.$props;
    (0, $8B3mG.setAttribute)(root, "width", size());
    (0, $8B3mG.setAttribute)(root, "height", size());
    (0, $8B3mG.setAttribute)(track, "stroke-width", trackWidth());
    (0, $8B3mG.setAttribute)(trackFill, "stroke-width", trackWidth());
    (0, $8B3mG.setAttribute)(trackFill, "stroke-dashoffset", 100 - fillPercent());
}
var $74873f712a093416$var$_Host7;
class $74873f712a093416$export$fa8280453beb4c7e extends ($74873f712a093416$var$_Host7 = (0, $8B3mG.Host)((0, $1dN1L.LitElement), $74873f712a093416$var$Spinner)) {
    render() {
        return (0, $gX4mh.html)`
      <svg fill="none" viewBox="0 0 120 120" aria-hidden="true" data-part="root">
        <circle cx="60" cy="60" r="54" stroke="currentColor" data-part="track"></circle>
        <circle
          cx="60"
          cy="60"
          r="54"
          stroke="currentColor"
          pathLength="100"
          stroke-dasharray="100"
          data-part="track-fill"
        ></circle>
      </svg>
    `;
    }
}
(0, $97zcJ._)($74873f712a093416$export$fa8280453beb4c7e, "tagName", "media-spinner");
class $74873f712a093416$var$MediaLayout extends (0, $8B3mG.Component) {
}
(0, $97zcJ._)($74873f712a093416$var$MediaLayout, "props", {
    when: false
});
var $74873f712a093416$var$_Host8, $74873f712a093416$var$_media2 = /*#__PURE__*/ new WeakMap(), $74873f712a093416$var$_watchWhen = /*#__PURE__*/ new WeakSet();
class $74873f712a093416$export$18fdfc23a3efc900 extends ($74873f712a093416$var$_Host8 = (0, $8B3mG.Host)(HTMLElement, $74873f712a093416$var$MediaLayout)) {
    onSetup() {
        (0, $4vwVC._)(this, $74873f712a093416$var$_media2, (0, $6KfMo.useMediaContext)());
    }
    onConnect() {
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $74873f712a093416$var$_watchWhen, $74873f712a093416$var$watchWhen).bind(this));
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $74873f712a093416$var$_watchWhen);
        (0, $fhH8k._)(this, $74873f712a093416$var$_media2, {
            writable: true,
            value: void 0
        });
    }
}
(0, $97zcJ._)($74873f712a093416$export$18fdfc23a3efc900, "tagName", "media-layout");
function $74873f712a093416$var$watchWhen() {
    const root = this.firstElementChild, isTemplate = root?.localName === "template", when = this.$props.when(), matches = (0, $8B3mG.isBoolean)(when) ? when : (0, $8B3mG.computed)(()=>when((0, $57dmi._)(this, $74873f712a093416$var$_media2).player.state))();
    if (!matches) {
        if (isTemplate) {
            this.textContent = "";
            this.appendChild(root);
        } else if ((0, $ciZW6.isHTMLElement)(root)) root.style.display = "none";
        return;
    }
    if (isTemplate) this.append(root.content.cloneNode(true));
    else if ((0, $ciZW6.isHTMLElement)(root)) root.style.display = "";
}
var $74873f712a093416$var$_Host9;
class $74873f712a093416$export$2421b0d66f1c3793 extends ($74873f712a093416$var$_Host9 = (0, $8B3mG.Host)(HTMLElement, (0, $f206l.GoogleCastButton))) {
}
(0, $97zcJ._)($74873f712a093416$export$2421b0d66f1c3793, "tagName", "media-google-cast-button");
var $74873f712a093416$var$_Host10;
class $74873f712a093416$export$63fd5d5d2460e68b extends ($74873f712a093416$var$_Host10 = (0, $8B3mG.Host)(HTMLElement, (0, $f206l.ToggleButton))) {
}
(0, $97zcJ._)($74873f712a093416$export$63fd5d5d2460e68b, "tagName", "media-toggle-button");
var $74873f712a093416$var$_Host11;
class $74873f712a093416$export$c2c0ae4671d6c749 extends ($74873f712a093416$var$_Host11 = (0, $8B3mG.Host)(HTMLElement, (0, $f206l.Tooltip))) {
}
(0, $97zcJ._)($74873f712a093416$export$c2c0ae4671d6c749, "tagName", "media-tooltip");
var $74873f712a093416$var$_Host12;
class $74873f712a093416$export$17af34a510418183 extends ($74873f712a093416$var$_Host12 = (0, $8B3mG.Host)(HTMLElement, (0, $f206l.TooltipTrigger))) {
    onConnect() {
        this.style.display = "contents";
    }
}
(0, $97zcJ._)($74873f712a093416$export$17af34a510418183, "tagName", "media-tooltip-trigger");
var $74873f712a093416$var$_Host13;
class $74873f712a093416$export$45a8291cfb2c223f extends ($74873f712a093416$var$_Host13 = (0, $8B3mG.Host)(HTMLElement, (0, $f206l.TooltipContent))) {
}
(0, $97zcJ._)($74873f712a093416$export$45a8291cfb2c223f, "tagName", "media-tooltip-content");
var $74873f712a093416$var$_Host14;
class $74873f712a093416$export$fe1e6b36160a0c78 extends ($74873f712a093416$var$_Host14 = (0, $8B3mG.Host)(HTMLElement, (0, $g6paF.MenuPortal))) {
}
(0, $97zcJ._)($74873f712a093416$export$fe1e6b36160a0c78, "tagName", "media-menu-portal");
(0, $97zcJ._)($74873f712a093416$export$fe1e6b36160a0c78, "attrs", {
    disabled: {
        converter (value) {
            if ((0, $8B3mG.isString)(value)) return value;
            return value !== null;
        }
    }
});
var $74873f712a093416$var$_Host15;
class $74873f712a093416$export$30201d38e80b656d extends ($74873f712a093416$var$_Host15 = (0, $8B3mG.Host)(HTMLElement, (0, $f206l.ChaptersRadioGroup))) {
    onConnect() {
        (0, $itCve.renderMenuItemsTemplate)(this, (el, option)=>{
            const { cue: cue, startTime: startTime, duration: duration } = option, thumbnailEl = el.querySelector(".vds-thumbnail,media-thumbnail"), startEl = el.querySelector('[data-part="start-time"]'), durationEl = el.querySelector('[data-part="duration"]');
            if (startEl) startEl.textContent = startTime;
            if (durationEl) durationEl.textContent = duration;
            if (thumbnailEl) {
                thumbnailEl.setAttribute("time", cue.startTime + "");
                (0, $8B3mG.effect)(()=>{
                    const thumbnails = this.$props.thumbnails();
                    if ("src" in thumbnailEl) thumbnailEl.src = thumbnails;
                    else if ((0, $8B3mG.isString)(thumbnails)) thumbnailEl.setAttribute("src", thumbnails);
                });
            }
        });
    }
}
(0, $97zcJ._)($74873f712a093416$export$30201d38e80b656d, "tagName", "media-chapters-radio-group");
var $74873f712a093416$var$_Host16;
class $74873f712a093416$export$2cff8b00e97ca952 extends ($74873f712a093416$var$_Host16 = (0, $8B3mG.Host)(HTMLElement, (0, $f206l.AudioGainRadioGroup))) {
    onConnect() {
        (0, $itCve.renderMenuItemsTemplate)(this);
    }
}
(0, $97zcJ._)($74873f712a093416$export$2cff8b00e97ca952, "tagName", "media-audio-gain-radio-group");
var $74873f712a093416$var$_Host17;
class $74873f712a093416$export$4eb6699d52324e3a extends ($74873f712a093416$var$_Host17 = (0, $8B3mG.Host)(HTMLElement, (0, $f206l.Radio))) {
}
(0, $97zcJ._)($74873f712a093416$export$4eb6699d52324e3a, "tagName", "media-radio");
var $74873f712a093416$var$_Host18;
class $74873f712a093416$export$8f2cedc6240c50b1 extends ($74873f712a093416$var$_Host18 = (0, $8B3mG.Host)(HTMLElement, (0, $f206l.RadioGroup))) {
}
(0, $97zcJ._)($74873f712a093416$export$8f2cedc6240c50b1, "tagName", "media-radio-group");
var $74873f712a093416$var$_Host19;
class $74873f712a093416$export$3590061e1a06950d extends ($74873f712a093416$var$_Host19 = (0, $8B3mG.Host)(HTMLElement, (0, $g6paF.Slider))) {
}
(0, $97zcJ._)($74873f712a093416$export$3590061e1a06950d, "tagName", "media-slider");
const $74873f712a093416$var$videoTemplate = /* @__PURE__ */ (0, $ciZW6.createTemplate)(`<video muted playsinline preload="none" style="max-width: unset;"></video>`);
var $74873f712a093416$var$_Host20, $74873f712a093416$var$_media3 = /*#__PURE__*/ new WeakMap(), $74873f712a093416$var$_video = /*#__PURE__*/ new WeakMap(), $74873f712a093416$var$_createVideo = /*#__PURE__*/ new WeakSet();
class $74873f712a093416$export$13efc38e5883eac6 extends ($74873f712a093416$var$_Host20 = (0, $8B3mG.Host)(HTMLElement, (0, $f206l.SliderVideo))) {
    onSetup() {
        (0, $4vwVC._)(this, $74873f712a093416$var$_media3, (0, $6KfMo.useMediaContext)());
        this.$state.video.set((0, $57dmi._)(this, $74873f712a093416$var$_video));
    }
    onConnect() {
        const { canLoad: canLoad } = (0, $57dmi._)(this, $74873f712a093416$var$_media3).$state, { src: src, crossOrigin: crossOrigin } = this.$state;
        if ((0, $57dmi._)(this, $74873f712a093416$var$_video).parentNode !== this) this.prepend((0, $57dmi._)(this, $74873f712a093416$var$_video));
        (0, $8B3mG.effect)(()=>{
            (0, $8B3mG.setAttribute)((0, $57dmi._)(this, $74873f712a093416$var$_video), "crossorigin", crossOrigin());
            (0, $8B3mG.setAttribute)((0, $57dmi._)(this, $74873f712a093416$var$_video), "preload", canLoad() ? "auto" : "none");
            (0, $8B3mG.setAttribute)((0, $57dmi._)(this, $74873f712a093416$var$_video), "src", src());
        });
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $74873f712a093416$var$_createVideo);
        (0, $fhH8k._)(this, $74873f712a093416$var$_media3, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $74873f712a093416$var$_video, {
            writable: true,
            value: (0, $2u9SC._)(this, $74873f712a093416$var$_createVideo, $74873f712a093416$var$createVideo).call(this)
        });
    }
}
(0, $97zcJ._)($74873f712a093416$export$13efc38e5883eac6, "tagName", "media-slider-video");
function $74873f712a093416$var$createVideo() {
    return (0, $ciZW6.cloneTemplateContent)($74873f712a093416$var$videoTemplate);
}
var $74873f712a093416$var$_Host21;
class $74873f712a093416$export$baf5ea9b3a958d46 extends ($74873f712a093416$var$_Host21 = (0, $8B3mG.Host)(HTMLElement, (0, $f206l.AudioGainSlider))) {
}
(0, $97zcJ._)($74873f712a093416$export$baf5ea9b3a958d46, "tagName", "media-audio-gain-slider");
var $74873f712a093416$var$_Host22;
class $74873f712a093416$export$59a66cbb9762628a extends ($74873f712a093416$var$_Host22 = (0, $8B3mG.Host)(HTMLElement, (0, $f206l.SpeedSlider))) {
}
(0, $97zcJ._)($74873f712a093416$export$59a66cbb9762628a, "tagName", "media-speed-slider");
var $74873f712a093416$var$_Host23;
class $74873f712a093416$export$8fb96d4aa2b0d83c extends ($74873f712a093416$var$_Host23 = (0, $8B3mG.Host)(HTMLElement, (0, $f206l.QualitySlider))) {
}
(0, $97zcJ._)($74873f712a093416$export$8fb96d4aa2b0d83c, "tagName", "media-quality-slider");
var $74873f712a093416$var$_Host24, $74873f712a093416$var$_template = /*#__PURE__*/ new WeakMap(), $74873f712a093416$var$_renderTemplate = /*#__PURE__*/ new WeakSet();
class $74873f712a093416$export$7163c0c94dc0e8a extends ($74873f712a093416$var$_Host24 = (0, $8B3mG.Host)(HTMLElement, (0, $f206l.SliderChapters))) {
    onConnect() {
        (0, $ciZW6.requestScopedAnimationFrame)(()=>{
            if (!this.connectScope) return;
            const template = this.querySelector("template");
            if (template) {
                (0, $4vwVC._)(this, $74873f712a093416$var$_template, template);
                (0, $8B3mG.effect)((0, $2u9SC._)(this, $74873f712a093416$var$_renderTemplate, $74873f712a093416$var$renderTemplate).bind(this));
            }
        });
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $74873f712a093416$var$_renderTemplate);
        (0, $fhH8k._)(this, $74873f712a093416$var$_template, {
            writable: true,
            value: null
        });
    }
}
(0, $97zcJ._)($74873f712a093416$export$7163c0c94dc0e8a, "tagName", "media-slider-chapters");
function $74873f712a093416$var$renderTemplate() {
    if (!(0, $57dmi._)(this, $74873f712a093416$var$_template)) return;
    const elements = (0, $ciZW6.cloneTemplate)((0, $57dmi._)(this, $74873f712a093416$var$_template), this.cues.length || 1);
    this.setRefs(elements);
}
class $74873f712a093416$var$SliderSteps extends (0, $8B3mG.Component) {
}
var $74873f712a093416$var$_Host25, $74873f712a093416$var$_template1 = /*#__PURE__*/ new WeakMap(), $74873f712a093416$var$_render = /*#__PURE__*/ new WeakSet();
class $74873f712a093416$export$42383907fed3a5cb extends ($74873f712a093416$var$_Host25 = (0, $8B3mG.Host)(HTMLElement, $74873f712a093416$var$SliderSteps)) {
    onConnect(el) {
        (0, $ciZW6.requestScopedAnimationFrame)(()=>{
            if (!this.connectScope) return;
            (0, $4vwVC._)(this, $74873f712a093416$var$_template1, el.querySelector("template"));
            if ((0, $57dmi._)(this, $74873f712a093416$var$_template1)) (0, $8B3mG.effect)((0, $2u9SC._)(this, $74873f712a093416$var$_render, $74873f712a093416$var$render).bind(this));
        });
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $74873f712a093416$var$_render);
        (0, $fhH8k._)(this, $74873f712a093416$var$_template1, {
            writable: true,
            value: null
        });
    }
}
(0, $97zcJ._)($74873f712a093416$export$42383907fed3a5cb, "tagName", "media-slider-steps");
function $74873f712a093416$var$render() {
    if (!(0, $57dmi._)(this, $74873f712a093416$var$_template1)) return;
    const { min: min, max: max, step: step } = (0, $8B3mG.useState)((0, $g6paF.sliderState)), steps = (max() - min()) / step();
    (0, $ciZW6.cloneTemplate)((0, $57dmi._)(this, $74873f712a093416$var$_template1), Math.floor(steps) + 1);
}

});
parcelRegister("f206l", function(module, exports) {

$parcel$export(module.exports, "MediaAnnouncer", function () { return $af171f1136c0783f$export$8733dfb24ec1b7d5; });
$parcel$export(module.exports, "Controls", function () { return $af171f1136c0783f$export$c7c44baae9d9f25f; });
$parcel$export(module.exports, "ControlsGroup", function () { return $af171f1136c0783f$export$ceef51eaa926795d; });
$parcel$export(module.exports, "Tooltip", function () { return $af171f1136c0783f$export$28c660c63b792dea; });
$parcel$export(module.exports, "TooltipTrigger", function () { return $af171f1136c0783f$export$8c610744efcf8a1d; });
$parcel$export(module.exports, "TooltipContent", function () { return $af171f1136c0783f$export$e9003e2be37ec060; });
$parcel$export(module.exports, "ToggleButton", function () { return $af171f1136c0783f$export$d2b052e7b4be1756; });
$parcel$export(module.exports, "GoogleCastButton", function () { return $af171f1136c0783f$export$c020cba823374aca; });
$parcel$export(module.exports, "SliderVideo", function () { return $af171f1136c0783f$export$f58f86c46ea10b75; });
$parcel$export(module.exports, "AudioGainSlider", function () { return $af171f1136c0783f$export$66d79f1b7bd7369d; });
$parcel$export(module.exports, "SpeedSlider", function () { return $af171f1136c0783f$export$21434f2cfaa53e32; });
$parcel$export(module.exports, "QualitySlider", function () { return $af171f1136c0783f$export$1267b1becd779d24; });
$parcel$export(module.exports, "SliderChapters", function () { return $af171f1136c0783f$export$11d0536309d27326; });
$parcel$export(module.exports, "RadioGroup", function () { return $af171f1136c0783f$export$a98f0dcb43a68a25; });
$parcel$export(module.exports, "Radio", function () { return $af171f1136c0783f$export$d7b12c4107be0d61; });
$parcel$export(module.exports, "ChaptersRadioGroup", function () { return $af171f1136c0783f$export$20dc6dce1c83395a; });
$parcel$export(module.exports, "AudioGainRadioGroup", function () { return $af171f1136c0783f$export$f749e84e3a859fa5; });
$parcel$export(module.exports, "Gesture", function () { return $af171f1136c0783f$export$61ce360501d38a6f; });
$parcel$export(module.exports, "Captions", function () { return $af171f1136c0783f$export$700b041b251b6ffe; });

var $57dmi = parcelRequire("57dmi");

var $fhH8k = parcelRequire("fhH8k");

var $4vwVC = parcelRequire("4vwVC");

var $5pK9s = parcelRequire("5pK9s");

var $2u9SC = parcelRequire("2u9SC");

var $9P4tJ = parcelRequire("9P4tJ");

var $97zcJ = parcelRequire("97zcJ");

var $8B3mG = parcelRequire("8B3mG");

var $6KfMo = parcelRequire("6KfMo");

var $ciZW6 = parcelRequire("ciZW6");

var $g6paF = parcelRequire("g6paF");

var $jWjYZ = parcelRequire("jWjYZ");

var $jrniq = parcelRequire("jrniq");

var $hzYuC = parcelRequire("hzYuC");

var $l6thX = parcelRequire("l6thX");

var $ihjXw = parcelRequire("ihjXw");
var $af171f1136c0783f$var$_media = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_initializing = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_watchPaused = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchFullscreen = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchPiP = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchCaptions = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchVolume = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_startedSeekingAt = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_seekTimer = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_watchSeeking = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_translate = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchLabel = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_setLabel = /*#__PURE__*/ new WeakSet();
class $af171f1136c0783f$export$8733dfb24ec1b7d5 extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_media, (0, $6KfMo.useMediaContext)());
    }
    onAttach(el) {
        el.style.display = "contents";
    }
    onConnect(el) {
        el.setAttribute("data-media-announcer", "");
        (0, $ciZW6.setAttributeIfEmpty)(el, "role", "status");
        (0, $ciZW6.setAttributeIfEmpty)(el, "aria-live", "polite");
        const { busy: busy } = this.$state;
        this.setAttributes({
            "aria-busy": ()=>busy() ? "true" : null
        });
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_initializing, true);
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchPaused, $af171f1136c0783f$var$watchPaused).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchVolume, $af171f1136c0783f$var$watchVolume).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchCaptions, $af171f1136c0783f$var$watchCaptions).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchFullscreen, $af171f1136c0783f$var$watchFullscreen).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchPiP, $af171f1136c0783f$var$watchPiP).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchSeeking, $af171f1136c0783f$var$watchSeeking).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchLabel, $af171f1136c0783f$var$watchLabel).bind(this));
        (0, $8B3mG.tick)();
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_initializing, false);
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchPaused);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchFullscreen);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchPiP);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchCaptions);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchVolume);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchSeeking);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_translate);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchLabel);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_setLabel);
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_media, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_initializing, {
            writable: true,
            value: false
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_startedSeekingAt, {
            writable: true,
            value: -1
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_seekTimer, {
            writable: true,
            value: -1
        });
    }
}
(0, $97zcJ._)($af171f1136c0783f$export$8733dfb24ec1b7d5, "props", {
    translations: null
});
(0, $97zcJ._)($af171f1136c0783f$export$8733dfb24ec1b7d5, "state", new (0, $8B3mG.State)({
    label: null,
    busy: false
}));
function $af171f1136c0783f$var$watchPaused() {
    const { paused: paused } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media).$state;
    (0, $2u9SC._)(this, $af171f1136c0783f$var$_setLabel, $af171f1136c0783f$var$setLabel).call(this, !paused() ? "Play" : "Pause");
}
function $af171f1136c0783f$var$watchFullscreen() {
    const { fullscreen: fullscreen } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media).$state;
    (0, $2u9SC._)(this, $af171f1136c0783f$var$_setLabel, $af171f1136c0783f$var$setLabel).call(this, fullscreen() ? "Enter Fullscreen" : "Exit Fullscreen");
}
function $af171f1136c0783f$var$watchPiP() {
    const { pictureInPicture: pictureInPicture } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media).$state;
    (0, $2u9SC._)(this, $af171f1136c0783f$var$_setLabel, $af171f1136c0783f$var$setLabel).call(this, pictureInPicture() ? "Enter PiP" : "Exit PiP");
}
function $af171f1136c0783f$var$watchCaptions() {
    const { textTrack: textTrack } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media).$state;
    (0, $2u9SC._)(this, $af171f1136c0783f$var$_setLabel, $af171f1136c0783f$var$setLabel).call(this, textTrack() ? "Closed-Captions On" : "Closed-Captions Off");
}
function $af171f1136c0783f$var$watchVolume() {
    const { muted: muted, volume: volume, audioGain: audioGain } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media).$state;
    (0, $2u9SC._)(this, $af171f1136c0783f$var$_setLabel, $af171f1136c0783f$var$setLabel).call(this, muted() || volume() === 0 ? "Mute" : `${Math.round(volume() * (audioGain() ?? 1) * 100)}% ${(0, $2u9SC._)(this, $af171f1136c0783f$var$_translate, $af171f1136c0783f$var$translate).call(this, "Volume")}`);
}
function $af171f1136c0783f$var$watchSeeking() {
    const { seeking: seeking, currentTime: currentTime } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media).$state, isSeeking = seeking();
    if ((0, $57dmi._)(this, $af171f1136c0783f$var$_startedSeekingAt) > 0) {
        window.clearTimeout((0, $57dmi._)(this, $af171f1136c0783f$var$_seekTimer));
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_seekTimer, window.setTimeout(()=>{
            if (!this.scope) return;
            const newTime = (0, $8B3mG.peek)(currentTime), seconds = Math.abs(newTime - (0, $57dmi._)(this, $af171f1136c0783f$var$_startedSeekingAt));
            if (seconds >= 1) {
                const isForward = newTime >= (0, $57dmi._)(this, $af171f1136c0783f$var$_startedSeekingAt), spokenTime = (0, $g6paF.formatSpokenTime)(seconds);
                (0, $2u9SC._)(this, $af171f1136c0783f$var$_setLabel, $af171f1136c0783f$var$setLabel).call(this, `${(0, $2u9SC._)(this, $af171f1136c0783f$var$_translate, $af171f1136c0783f$var$translate).call(this, isForward ? "Seek Forward" : "Seek Backward")} ${spokenTime}`);
            }
            (0, $4vwVC._)(this, $af171f1136c0783f$var$_startedSeekingAt, -1);
            (0, $4vwVC._)(this, $af171f1136c0783f$var$_seekTimer, -1);
        }, 300));
    } else if (isSeeking) (0, $4vwVC._)(this, $af171f1136c0783f$var$_startedSeekingAt, (0, $8B3mG.peek)(currentTime));
}
function $af171f1136c0783f$var$translate(word) {
    const { translations: translations } = this.$props;
    return translations?.()?.[word || ""] ?? word;
}
function $af171f1136c0783f$var$watchLabel() {
    const { label: label, busy: busy } = this.$state, $label = (0, $2u9SC._)(this, $af171f1136c0783f$var$_translate, $af171f1136c0783f$var$translate).call(this, label());
    if ((0, $57dmi._)(this, $af171f1136c0783f$var$_initializing)) return;
    busy.set(true);
    const id = window.setTimeout(()=>void busy.set(false), 150);
    this.el && (0, $8B3mG.setAttribute)(this.el, "aria-label", $label);
    if ((0, $8B3mG.isString)($label)) this.dispatch("change", {
        detail: $label
    });
    return ()=>window.clearTimeout(id);
}
function $af171f1136c0783f$var$setLabel(word) {
    const { label: label } = this.$state;
    label.set(word);
}
var $af171f1136c0783f$var$_media1 = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_hideControls = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchProps = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_isShowing = /*#__PURE__*/ new WeakSet();
class $af171f1136c0783f$export$c7c44baae9d9f25f extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_media1, (0, $6KfMo.useMediaContext)());
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchProps, $af171f1136c0783f$var$watchProps).bind(this));
    }
    onAttach(el) {
        const { pictureInPicture: pictureInPicture, fullscreen: fullscreen } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media1).$state;
        (0, $8B3mG.setStyle)(el, "pointer-events", "none");
        (0, $ciZW6.setAttributeIfEmpty)(el, "role", "group");
        this.setAttributes({
            "data-visible": (0, $2u9SC._)(this, $af171f1136c0783f$var$_isShowing, $af171f1136c0783f$var$isShowing).bind(this),
            "data-fullscreen": fullscreen,
            "data-pip": pictureInPicture
        });
        (0, $8B3mG.effect)(()=>{
            this.dispatch("change", {
                detail: (0, $2u9SC._)(this, $af171f1136c0783f$var$_isShowing, $af171f1136c0783f$var$isShowing).call(this)
            });
        });
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_hideControls, $af171f1136c0783f$var$hideControls).bind(this));
        (0, $8B3mG.effect)(()=>{
            const isFullscreen = fullscreen();
            for (const side of [
                "top",
                "right",
                "bottom",
                "left"
            ])(0, $8B3mG.setStyle)(el, `padding-${side}`, isFullscreen && `env(safe-area-inset-${side})`);
        });
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_hideControls);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchProps);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_isShowing);
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_media1, {
            writable: true,
            value: void 0
        });
    }
}
(0, $97zcJ._)($af171f1136c0783f$export$c7c44baae9d9f25f, "props", {
    hideDelay: 2e3,
    hideOnMouseLeave: false
});
function $af171f1136c0783f$var$hideControls() {
    if (!this.el) return;
    const { nativeControls: nativeControls } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media1).$state, isHidden = nativeControls();
    (0, $8B3mG.setAttribute)(this.el, "aria-hidden", isHidden ? "true" : null);
    (0, $8B3mG.setStyle)(this.el, "display", isHidden ? "none" : null);
}
function $af171f1136c0783f$var$watchProps() {
    const { controls: controls } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media1).player, { hideDelay: hideDelay, hideOnMouseLeave: hideOnMouseLeave } = this.$props;
    controls.defaultDelay = hideDelay() === 2e3 ? (0, $57dmi._)(this, $af171f1136c0783f$var$_media1).$props.controlsDelay() : hideDelay();
    controls.hideOnMouseLeave = hideOnMouseLeave();
}
function $af171f1136c0783f$var$isShowing() {
    const { controlsVisible: controlsVisible } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media1).$state;
    return controlsVisible();
}
class $af171f1136c0783f$export$ceef51eaa926795d extends (0, $8B3mG.Component) {
    onAttach(el) {
        if (!el.style.pointerEvents) (0, $8B3mG.setStyle)(el, "pointer-events", "auto");
    }
}
const $af171f1136c0783f$var$tooltipContext = (0, $8B3mG.createContext)();
let $af171f1136c0783f$var$id = 0;
var $af171f1136c0783f$var$_id = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_trigger = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_content = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_showing = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_attachTrigger = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_detachTrigger = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_attachContent = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_detachContent = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_onShowingChange = /*#__PURE__*/ new WeakSet();
class $af171f1136c0783f$export$28c660c63b792dea extends (0, $8B3mG.Component) {
    onAttach(el) {
        el.style.setProperty("display", "contents");
    }
    onSetup() {
        (0, $8B3mG.provideContext)($af171f1136c0783f$var$tooltipContext, {
            trigger: (0, $57dmi._)(this, $af171f1136c0783f$var$_trigger),
            content: (0, $57dmi._)(this, $af171f1136c0783f$var$_content),
            showing: (0, $57dmi._)(this, $af171f1136c0783f$var$_showing),
            attachTrigger: (0, $2u9SC._)(this, $af171f1136c0783f$var$_attachTrigger, $af171f1136c0783f$var$attachTrigger).bind(this),
            detachTrigger: (0, $2u9SC._)(this, $af171f1136c0783f$var$_detachTrigger, $af171f1136c0783f$var$detachTrigger).bind(this),
            attachContent: (0, $2u9SC._)(this, $af171f1136c0783f$var$_attachContent, $af171f1136c0783f$var$attachContent).bind(this),
            detachContent: (0, $2u9SC._)(this, $af171f1136c0783f$var$_detachContent, $af171f1136c0783f$var$detachContent).bind(this)
        });
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_attachTrigger);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_detachTrigger);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_attachContent);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_detachContent);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onShowingChange);
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_id, {
            writable: true,
            value: `media-tooltip-${++$af171f1136c0783f$var$id}`
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_trigger, {
            writable: true,
            value: (0, $8B3mG.signal)(null)
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_content, {
            writable: true,
            value: (0, $8B3mG.signal)(null)
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_showing, {
            writable: true,
            value: (0, $8B3mG.signal)(false)
        });
        new (0, $jWjYZ.FocusVisibleController)();
        const { showDelay: showDelay } = this.$props;
        new (0, $g6paF.Popper)({
            trigger: (0, $57dmi._)(this, $af171f1136c0783f$var$_trigger),
            content: (0, $57dmi._)(this, $af171f1136c0783f$var$_content),
            showDelay: showDelay,
            listen (trigger, show, hide) {
                (0, $8B3mG.effect)(()=>{
                    if ((0, $jWjYZ.$keyboard)()) (0, $8B3mG.listenEvent)(trigger, "focus", show);
                    (0, $8B3mG.listenEvent)(trigger, "blur", hide);
                });
                new (0, $8B3mG.EventsController)(trigger).add("touchstart", (e)=>e.preventDefault(), {
                    passive: false
                }).add("mouseenter", show).add("mouseleave", hide);
            },
            onChange: (0, $2u9SC._)(this, $af171f1136c0783f$var$_onShowingChange, $af171f1136c0783f$var$onShowingChange).bind(this)
        });
    }
}
(0, $97zcJ._)($af171f1136c0783f$export$28c660c63b792dea, "props", {
    showDelay: 700
});
function $af171f1136c0783f$var$attachTrigger(el) {
    (0, $57dmi._)(this, $af171f1136c0783f$var$_trigger).set(el);
    let tooltipName = el.getAttribute("data-media-tooltip");
    if (tooltipName) this.el?.setAttribute(`data-media-${tooltipName}-tooltip`, "");
    (0, $8B3mG.setAttribute)(el, "data-describedby", (0, $57dmi._)(this, $af171f1136c0783f$var$_id));
}
function $af171f1136c0783f$var$detachTrigger(el) {
    el.removeAttribute("data-describedby");
    el.removeAttribute("aria-describedby");
    (0, $57dmi._)(this, $af171f1136c0783f$var$_trigger).set(null);
}
function $af171f1136c0783f$var$attachContent(el) {
    el.setAttribute("id", (0, $57dmi._)(this, $af171f1136c0783f$var$_id));
    el.style.display = "none";
    (0, $ciZW6.setAttributeIfEmpty)(el, "role", "tooltip");
    (0, $57dmi._)(this, $af171f1136c0783f$var$_content).set(el);
}
function $af171f1136c0783f$var$detachContent(el) {
    el.removeAttribute("id");
    el.removeAttribute("role");
    (0, $57dmi._)(this, $af171f1136c0783f$var$_content).set(null);
}
function $af171f1136c0783f$var$onShowingChange(isShowing) {
    const trigger = (0, $57dmi._)(this, $af171f1136c0783f$var$_trigger).call(this), content = (0, $57dmi._)(this, $af171f1136c0783f$var$_content).call(this);
    if (trigger) (0, $8B3mG.setAttribute)(trigger, "aria-describedby", isShowing ? (0, $57dmi._)(this, $af171f1136c0783f$var$_id) : null);
    for (const el of [
        this.el,
        trigger,
        content
    ])el && (0, $8B3mG.setAttribute)(el, "data-visible", isShowing);
    (0, $57dmi._)(this, $af171f1136c0783f$var$_showing).set(isShowing);
}
var $af171f1136c0783f$var$_attach = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_getButton = /*#__PURE__*/ new WeakSet();
class $af171f1136c0783f$export$8c610744efcf8a1d extends (0, $8B3mG.Component) {
    onConnect(el) {
        (0, $8B3mG.onDispose)((0, $ciZW6.requestScopedAnimationFrame)(()=>{
            if (!this.connectScope) return;
            (0, $2u9SC._)(this, $af171f1136c0783f$var$_attach, $af171f1136c0783f$var$attach).call(this);
            const tooltip = (0, $8B3mG.useContext)($af171f1136c0783f$var$tooltipContext);
            (0, $8B3mG.onDispose)(()=>{
                const button = (0, $2u9SC._)(this, $af171f1136c0783f$var$_getButton, $af171f1136c0783f$var$getButton).call(this);
                button && tooltip.detachTrigger(button);
            });
        }));
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_attach);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_getButton);
        new (0, $jWjYZ.FocusVisibleController)();
    }
}
function $af171f1136c0783f$var$attach() {
    const button = (0, $2u9SC._)(this, $af171f1136c0783f$var$_getButton, $af171f1136c0783f$var$getButton).call(this), tooltip = (0, $8B3mG.useContext)($af171f1136c0783f$var$tooltipContext);
    button && tooltip.attachTrigger(button);
}
function $af171f1136c0783f$var$getButton() {
    const candidate = this.el.firstElementChild;
    return candidate?.localName === "button" || candidate?.getAttribute("role") === "button" ? candidate : this.el;
}
var $af171f1136c0783f$var$_attach1 = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchPlacement = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_getTrigger = /*#__PURE__*/ new WeakSet();
class $af171f1136c0783f$export$e9003e2be37ec060 extends (0, $8B3mG.Component) {
    onAttach(el) {
        (0, $2u9SC._)(this, $af171f1136c0783f$var$_attach1, $af171f1136c0783f$var$attach1).call(this, el);
        Object.assign(el.style, {
            position: "absolute",
            top: 0,
            left: 0,
            width: "max-content"
        });
    }
    onConnect(el) {
        (0, $2u9SC._)(this, $af171f1136c0783f$var$_attach1, $af171f1136c0783f$var$attach1).call(this, el);
        const tooltip = (0, $8B3mG.useContext)($af171f1136c0783f$var$tooltipContext);
        (0, $8B3mG.onDispose)(()=>tooltip.detachContent(el));
        (0, $8B3mG.onDispose)((0, $ciZW6.requestScopedAnimationFrame)(()=>{
            if (!this.connectScope) return;
            (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchPlacement, $af171f1136c0783f$var$watchPlacement).bind(this));
        }));
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_attach1);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchPlacement);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_getTrigger);
        new (0, $jWjYZ.FocusVisibleController)();
        const { placement: placement } = this.$props;
        this.setAttributes({
            "data-placement": placement
        });
    }
}
(0, $97zcJ._)($af171f1136c0783f$export$e9003e2be37ec060, "props", {
    placement: "top center",
    offset: 0,
    alignOffset: 0
});
function $af171f1136c0783f$var$attach1(el) {
    const tooltip = (0, $8B3mG.useContext)($af171f1136c0783f$var$tooltipContext);
    tooltip.attachContent(el);
}
function $af171f1136c0783f$var$watchPlacement() {
    const { showing: showing } = (0, $8B3mG.useContext)($af171f1136c0783f$var$tooltipContext);
    if (!showing()) return;
    const { placement: placement, offset: mainOffset, alignOffset: alignOffset } = this.$props;
    return (0, $ciZW6.autoPlacement)(this.el, (0, $2u9SC._)(this, $af171f1136c0783f$var$_getTrigger, $af171f1136c0783f$var$getTrigger).call(this), placement(), {
        offsetVarName: "media-tooltip",
        xOffset: alignOffset(),
        yOffset: mainOffset()
    });
}
function $af171f1136c0783f$var$getTrigger() {
    return (0, $8B3mG.useContext)($af171f1136c0783f$var$tooltipContext).trigger();
}
var $af171f1136c0783f$var$_pressed = /*#__PURE__*/ new WeakMap();
class $af171f1136c0783f$export$d2b052e7b4be1756 extends (0, $8B3mG.Component) {
    /**
   * Whether the toggle is currently in a `pressed` state.
   */ get pressed() {
        return (0, $57dmi._)(this, $af171f1136c0783f$var$_pressed).call(this);
    }
    constructor(){
        super();
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_pressed, {
            writable: true,
            value: (0, $8B3mG.signal)(false)
        });
        new (0, $g6paF.ToggleButtonController)({
            isPresssed: (0, $57dmi._)(this, $af171f1136c0783f$var$_pressed)
        });
    }
}
(0, $97zcJ._)($af171f1136c0783f$export$d2b052e7b4be1756, "props", {
    disabled: false,
    defaultPressed: false
});
const $af171f1136c0783f$var$togglebutton__proto = $af171f1136c0783f$export$d2b052e7b4be1756.prototype;
(0, $8B3mG.prop)($af171f1136c0783f$var$togglebutton__proto, "pressed");
var $af171f1136c0783f$var$_media2 = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_onPress = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_isPressed = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_getState = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_getDefaultLabel = /*#__PURE__*/ new WeakSet();
class $af171f1136c0783f$export$c020cba823374aca extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_media2, (0, $6KfMo.useMediaContext)());
        const { canGoogleCast: canGoogleCast, isGoogleCastConnected: isGoogleCastConnected } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media2).$state;
        this.setAttributes({
            "data-active": isGoogleCastConnected,
            "data-supported": canGoogleCast,
            "data-state": (0, $2u9SC._)(this, $af171f1136c0783f$var$_getState, $af171f1136c0783f$var$getState).bind(this),
            "aria-hidden": (0, $jrniq.$ariaBool)(()=>!canGoogleCast())
        });
    }
    onAttach(el) {
        el.setAttribute("data-media-tooltip", "google-cast");
        (0, $ciZW6.setARIALabel)(el, (0, $2u9SC._)(this, $af171f1136c0783f$var$_getDefaultLabel, $af171f1136c0783f$var$getDefaultLabel).bind(this));
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onPress);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_isPressed);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_getState);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_getDefaultLabel);
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_media2, {
            writable: true,
            value: void 0
        });
        new (0, $g6paF.ToggleButtonController)({
            isPresssed: (0, $2u9SC._)(this, $af171f1136c0783f$var$_isPressed, $af171f1136c0783f$var$isPressed).bind(this),
            onPress: (0, $2u9SC._)(this, $af171f1136c0783f$var$_onPress, $af171f1136c0783f$var$onPress1).bind(this)
        });
    }
}
(0, $97zcJ._)($af171f1136c0783f$export$c020cba823374aca, "props", (0, $g6paF.ToggleButtonController).props);
function $af171f1136c0783f$var$onPress1(event) {
    const remote = (0, $57dmi._)(this, $af171f1136c0783f$var$_media2).remote;
    remote.requestGoogleCast(event);
}
function $af171f1136c0783f$var$isPressed() {
    const { remotePlaybackType: remotePlaybackType, remotePlaybackState: remotePlaybackState } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media2).$state;
    return remotePlaybackType() === "google-cast" && remotePlaybackState() !== "disconnected";
}
function $af171f1136c0783f$var$getState() {
    const { remotePlaybackType: remotePlaybackType, remotePlaybackState: remotePlaybackState } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media2).$state;
    return remotePlaybackType() === "google-cast" && remotePlaybackState();
}
function $af171f1136c0783f$var$getDefaultLabel() {
    const { remotePlaybackState: remotePlaybackState } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media2).$state;
    return `Google Cast ${remotePlaybackState()}`;
}
var $af171f1136c0783f$var$_media3 = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_slider = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_watchVideo = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchSrc = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchCrossOrigin = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_isLoading = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_hasError = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchHidden = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_onSrcChange = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_onCanPlay = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_onError = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_onUpdateTime = /*#__PURE__*/ new WeakSet();
class $af171f1136c0783f$export$f58f86c46ea10b75 extends (0, $8B3mG.Component) {
    get video() {
        return this.$state.video();
    }
    onSetup() {
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_media3, (0, $6KfMo.useMediaContext)());
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_slider, (0, $8B3mG.useState)((0, $g6paF.Slider).state));
        (0, $2u9SC._)(this, $af171f1136c0783f$var$_watchCrossOrigin, $af171f1136c0783f$var$watchCrossOrigin).call(this);
        this.setAttributes({
            "data-loading": (0, $2u9SC._)(this, $af171f1136c0783f$var$_isLoading, $af171f1136c0783f$var$isLoading).bind(this),
            "data-hidden": this.$state.hidden,
            "data-error": (0, $2u9SC._)(this, $af171f1136c0783f$var$_hasError, $af171f1136c0783f$var$hasError).bind(this),
            "aria-hidden": (0, $jrniq.$ariaBool)(this.$state.hidden)
        });
    }
    onAttach(el) {
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchVideo, $af171f1136c0783f$var$watchVideo).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchSrc, $af171f1136c0783f$var$watchSrc).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchCrossOrigin, $af171f1136c0783f$var$watchCrossOrigin).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchHidden, $af171f1136c0783f$var$watchHidden).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_onSrcChange, $af171f1136c0783f$var$onSrcChange).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_onUpdateTime, $af171f1136c0783f$var$onUpdateTime).bind(this));
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchVideo);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchSrc);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchCrossOrigin);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_isLoading);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_hasError);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchHidden);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onSrcChange);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onCanPlay);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onError);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onUpdateTime);
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_media3, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_slider, {
            writable: true,
            value: void 0
        });
    }
}
(0, $97zcJ._)($af171f1136c0783f$export$f58f86c46ea10b75, "props", {
    src: null,
    crossOrigin: null
});
(0, $97zcJ._)($af171f1136c0783f$export$f58f86c46ea10b75, "state", new (0, $8B3mG.State)({
    video: null,
    src: null,
    crossOrigin: null,
    canPlay: false,
    error: null,
    hidden: false
}));
function $af171f1136c0783f$var$watchVideo() {
    const video = this.$state.video();
    if (!video) return;
    if (video.readyState >= 2) (0, $2u9SC._)(this, $af171f1136c0783f$var$_onCanPlay, $af171f1136c0783f$var$onCanPlay).call(this);
    new (0, $8B3mG.EventsController)(video).add("canplay", (0, $2u9SC._)(this, $af171f1136c0783f$var$_onCanPlay, $af171f1136c0783f$var$onCanPlay).bind(this)).add("error", (0, $2u9SC._)(this, $af171f1136c0783f$var$_onError, $af171f1136c0783f$var$onError).bind(this));
}
function $af171f1136c0783f$var$watchSrc() {
    const { src: src } = this.$state, { canLoad: canLoad } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media3).$state;
    src.set(canLoad() ? this.$props.src() : null);
}
function $af171f1136c0783f$var$watchCrossOrigin() {
    const { crossOrigin: crossOriginProp } = this.$props, { crossOrigin: crossOriginState } = this.$state, { crossOrigin: mediaCrossOrigin } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media3).$state, crossOrigin = crossOriginProp() !== null ? crossOriginProp() : mediaCrossOrigin();
    crossOriginState.set(crossOrigin === true ? "anonymous" : crossOrigin);
}
function $af171f1136c0783f$var$isLoading() {
    const { canPlay: canPlay, hidden: hidden } = this.$state;
    return !canPlay() && !hidden();
}
function $af171f1136c0783f$var$hasError() {
    const { error: error } = this.$state;
    return !(0, $8B3mG.isNull)(error);
}
function $af171f1136c0783f$var$watchHidden() {
    const { src: src, hidden: hidden } = this.$state, { canLoad: canLoad, duration: duration } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media3).$state;
    hidden.set(canLoad() && (!src() || (0, $2u9SC._)(this, $af171f1136c0783f$var$_hasError, $af171f1136c0783f$var$hasError).call(this) || !Number.isFinite(duration())));
}
function $af171f1136c0783f$var$onSrcChange() {
    const { src: src, canPlay: canPlay, error: error } = this.$state;
    src();
    canPlay.set(false);
    error.set(null);
}
function $af171f1136c0783f$var$onCanPlay(event) {
    const { canPlay: canPlay, error: error } = this.$state;
    canPlay.set(true);
    error.set(null);
    this.dispatch("can-play", {
        trigger: event
    });
}
function $af171f1136c0783f$var$onError(event) {
    const { canPlay: canPlay, error: error } = this.$state;
    canPlay.set(false);
    error.set(event);
    this.dispatch("error", {
        trigger: event
    });
}
function $af171f1136c0783f$var$onUpdateTime() {
    const { video: video, canPlay: canPlay } = this.$state, { duration: duration } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media3).$state, { pointerRate: pointerRate } = (0, $57dmi._)(this, $af171f1136c0783f$var$_slider), media = video(), canUpdate = canPlay() && media && Number.isFinite(duration()) && Number.isFinite(pointerRate());
    if (canUpdate) media.currentTime = pointerRate() * duration();
}
const $af171f1136c0783f$var$slidervideo__proto = $af171f1136c0783f$export$f58f86c46ea10b75.prototype;
(0, $8B3mG.prop)($af171f1136c0783f$var$slidervideo__proto, "video");
var $af171f1136c0783f$var$_media4 = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_getARIAValueNow = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_getARIAValueText = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchMinMax = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchAudioGain = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_isDisabled = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_onAudioGainChange = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_onValueChange = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_onDragValueChange = /*#__PURE__*/ new WeakSet();
class $af171f1136c0783f$export$66d79f1b7bd7369d extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_media4, (0, $6KfMo.useMediaContext)());
        (0, $8B3mG.provideContext)((0, $g6paF.sliderValueFormatContext), {
            default: "percent",
            percent: (_, decimalPlaces)=>{
                return (0, $hzYuC.round)(this.$state.value(), decimalPlaces) + "%";
            }
        });
        new (0, $g6paF.SliderController)({
            getStep: this.$props.step,
            getKeyStep: this.$props.keyStep,
            roundValue: Math.round,
            isDisabled: (0, $2u9SC._)(this, $af171f1136c0783f$var$_isDisabled, $af171f1136c0783f$var$isDisabled).bind(this),
            aria: {
                valueNow: (0, $2u9SC._)(this, $af171f1136c0783f$var$_getARIAValueNow, $af171f1136c0783f$var$getARIAValueNow).bind(this),
                valueText: (0, $2u9SC._)(this, $af171f1136c0783f$var$_getARIAValueText, $af171f1136c0783f$var$getARIAValueText).bind(this)
            },
            onDragValueChange: (0, $2u9SC._)(this, $af171f1136c0783f$var$_onDragValueChange, $af171f1136c0783f$var$onDragValueChange).bind(this),
            onValueChange: (0, $2u9SC._)(this, $af171f1136c0783f$var$_onValueChange, $af171f1136c0783f$var$onValueChange).bind(this)
        }).attach(this);
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchMinMax, $af171f1136c0783f$var$watchMinMax).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchAudioGain, $af171f1136c0783f$var$watchAudioGain).bind(this));
    }
    onAttach(el) {
        el.setAttribute("data-media-audio-gain-slider", "");
        (0, $ciZW6.setAttributeIfEmpty)(el, "aria-label", "Audio Boost");
        const { canSetAudioGain: canSetAudioGain } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media4).$state;
        this.setAttributes({
            "data-supported": canSetAudioGain,
            "aria-hidden": (0, $jrniq.$ariaBool)(()=>!canSetAudioGain())
        });
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_getARIAValueNow);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_getARIAValueText);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchMinMax);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchAudioGain);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_isDisabled);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onAudioGainChange);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onValueChange);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onDragValueChange);
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_media4, {
            writable: true,
            value: void 0
        });
    }
}
(0, $97zcJ._)($af171f1136c0783f$export$66d79f1b7bd7369d, "props", {
    ...(0, $g6paF.SliderController).props,
    step: 25,
    keyStep: 25,
    shiftKeyMultiplier: 2,
    min: 0,
    max: 300
});
(0, $97zcJ._)($af171f1136c0783f$export$66d79f1b7bd7369d, "state", (0, $g6paF.sliderState));
function $af171f1136c0783f$var$getARIAValueNow() {
    const { value: value } = this.$state;
    return Math.round(value());
}
function $af171f1136c0783f$var$getARIAValueText() {
    const { value: value } = this.$state;
    return value() + "%";
}
function $af171f1136c0783f$var$watchMinMax() {
    const { min: min, max: max } = this.$props;
    this.$state.min.set(min());
    this.$state.max.set(max());
}
function $af171f1136c0783f$var$watchAudioGain() {
    const { audioGain: audioGain } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media4).$state, value = ((audioGain() ?? 1) - 1) * 100;
    this.$state.value.set(value);
    this.dispatch("value-change", {
        detail: value
    });
}
function $af171f1136c0783f$var$isDisabled() {
    const { disabled: disabled } = this.$props, { canSetAudioGain: canSetAudioGain } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media4).$state;
    return disabled() || !canSetAudioGain();
}
function $af171f1136c0783f$var$onAudioGainChange(event) {
    if (!event.trigger) return;
    const gain = (0, $hzYuC.round)(1 + event.detail / 100, 2);
    (0, $57dmi._)(this, $af171f1136c0783f$var$_media4).remote.changeAudioGain(gain, event);
}
function $af171f1136c0783f$var$onValueChange(event) {
    (0, $2u9SC._)(this, $af171f1136c0783f$var$_onAudioGainChange, $af171f1136c0783f$var$onAudioGainChange).call(this, event);
}
function $af171f1136c0783f$var$onDragValueChange(event) {
    (0, $2u9SC._)(this, $af171f1136c0783f$var$_onAudioGainChange, $af171f1136c0783f$var$onAudioGainChange).call(this, event);
}
var $af171f1136c0783f$var$_media5 = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_getARIAValueNow1 = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_getARIAValueText1 = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchMinMax1 = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchPlaybackRate = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_roundValue = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_isDisabled1 = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_throttledSpeedChange = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_onPlaybackRateChange = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_onValueChange1 = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_onDragValueChange1 = /*#__PURE__*/ new WeakSet();
class $af171f1136c0783f$export$21434f2cfaa53e32 extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_media5, (0, $6KfMo.useMediaContext)());
        new (0, $g6paF.SliderController)({
            getStep: this.$props.step,
            getKeyStep: this.$props.keyStep,
            roundValue: (0, $2u9SC._)(this, $af171f1136c0783f$var$_roundValue, $af171f1136c0783f$var$roundValue),
            isDisabled: (0, $2u9SC._)(this, $af171f1136c0783f$var$_isDisabled1, $af171f1136c0783f$var$isDisabled1).bind(this),
            aria: {
                valueNow: (0, $2u9SC._)(this, $af171f1136c0783f$var$_getARIAValueNow1, $af171f1136c0783f$var$getARIAValueNow1).bind(this),
                valueText: (0, $2u9SC._)(this, $af171f1136c0783f$var$_getARIAValueText1, $af171f1136c0783f$var$getARIAValueText1).bind(this)
            },
            onDragValueChange: (0, $2u9SC._)(this, $af171f1136c0783f$var$_onDragValueChange1, $af171f1136c0783f$var$onDragValueChange1).bind(this),
            onValueChange: (0, $2u9SC._)(this, $af171f1136c0783f$var$_onValueChange1, $af171f1136c0783f$var$onValueChange1).bind(this)
        }).attach(this);
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchMinMax1, $af171f1136c0783f$var$watchMinMax1).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchPlaybackRate, $af171f1136c0783f$var$watchPlaybackRate).bind(this));
    }
    onAttach(el) {
        el.setAttribute("data-media-speed-slider", "");
        (0, $ciZW6.setAttributeIfEmpty)(el, "aria-label", "Speed");
        const { canSetPlaybackRate: canSetPlaybackRate } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media5).$state;
        this.setAttributes({
            "data-supported": canSetPlaybackRate,
            "aria-hidden": (0, $jrniq.$ariaBool)(()=>!canSetPlaybackRate())
        });
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_getARIAValueNow1);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_getARIAValueText1);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchMinMax1);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchPlaybackRate);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_roundValue);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_isDisabled1);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onPlaybackRateChange);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onValueChange1);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onDragValueChange1);
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_media5, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_throttledSpeedChange, {
            writable: true,
            value: (0, $8B3mG.functionThrottle)((0, $2u9SC._)(this, $af171f1136c0783f$var$_onPlaybackRateChange, $af171f1136c0783f$var$onPlaybackRateChange).bind(this), 25)
        });
    }
}
(0, $97zcJ._)($af171f1136c0783f$export$21434f2cfaa53e32, "props", {
    ...(0, $g6paF.SliderController).props,
    step: 0.25,
    keyStep: 0.25,
    shiftKeyMultiplier: 2,
    min: 0,
    max: 2
});
(0, $97zcJ._)($af171f1136c0783f$export$21434f2cfaa53e32, "state", (0, $g6paF.sliderState));
function $af171f1136c0783f$var$getARIAValueNow1() {
    const { value: value } = this.$state;
    return value();
}
function $af171f1136c0783f$var$getARIAValueText1() {
    const { value: value } = this.$state;
    return value() + "x";
}
function $af171f1136c0783f$var$watchMinMax1() {
    const { min: min, max: max } = this.$props;
    this.$state.min.set(min());
    this.$state.max.set(max());
}
function $af171f1136c0783f$var$watchPlaybackRate() {
    const { playbackRate: playbackRate } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media5).$state;
    const newValue = playbackRate();
    this.$state.value.set(newValue);
    this.dispatch("value-change", {
        detail: newValue
    });
}
function $af171f1136c0783f$var$roundValue(value) {
    return (0, $hzYuC.round)(value, 2);
}
function $af171f1136c0783f$var$isDisabled1() {
    const { disabled: disabled } = this.$props, { canSetPlaybackRate: canSetPlaybackRate } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media5).$state;
    return disabled() || !canSetPlaybackRate();
}
function $af171f1136c0783f$var$onPlaybackRateChange(event) {
    if (!event.trigger) return;
    const rate = event.detail;
    (0, $57dmi._)(this, $af171f1136c0783f$var$_media5).remote.changePlaybackRate(rate, event);
}
function $af171f1136c0783f$var$onValueChange1(event) {
    (0, $57dmi._)(this, $af171f1136c0783f$var$_throttledSpeedChange).call(this, event);
}
function $af171f1136c0783f$var$onDragValueChange1(event) {
    (0, $57dmi._)(this, $af171f1136c0783f$var$_throttledSpeedChange).call(this, event);
}
var $af171f1136c0783f$var$_media6 = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_sortedQualities = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_getARIAValueNow2 = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_getARIAValueText2 = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchMax = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchQuality = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_isDisabled2 = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_throttledQualityChange = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_onQualityChange = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_onValueChange2 = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_onDragValueChange2 = /*#__PURE__*/ new WeakSet();
class $af171f1136c0783f$export$1267b1becd779d24 extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_media6, (0, $6KfMo.useMediaContext)());
        new (0, $g6paF.SliderController)({
            getStep: this.$props.step,
            getKeyStep: this.$props.keyStep,
            roundValue: Math.round,
            isDisabled: (0, $2u9SC._)(this, $af171f1136c0783f$var$_isDisabled2, $af171f1136c0783f$var$isDisabled2).bind(this),
            aria: {
                valueNow: (0, $2u9SC._)(this, $af171f1136c0783f$var$_getARIAValueNow2, $af171f1136c0783f$var$getARIAValueNow2).bind(this),
                valueText: (0, $2u9SC._)(this, $af171f1136c0783f$var$_getARIAValueText2, $af171f1136c0783f$var$getARIAValueText2).bind(this)
            },
            onDragValueChange: (0, $2u9SC._)(this, $af171f1136c0783f$var$_onDragValueChange2, $af171f1136c0783f$var$onDragValueChange2).bind(this),
            onValueChange: (0, $2u9SC._)(this, $af171f1136c0783f$var$_onValueChange2, $af171f1136c0783f$var$onValueChange2).bind(this)
        }).attach(this);
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchMax, $af171f1136c0783f$var$watchMax).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchQuality, $af171f1136c0783f$var$watchQuality).bind(this));
    }
    onAttach(el) {
        el.setAttribute("data-media-quality-slider", "");
        (0, $ciZW6.setAttributeIfEmpty)(el, "aria-label", "Video Quality");
        const { qualities: qualities, canSetQuality: canSetQuality } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media6).$state, $supported = (0, $8B3mG.computed)(()=>canSetQuality() && qualities().length > 0);
        this.setAttributes({
            "data-supported": $supported,
            "aria-hidden": (0, $jrniq.$ariaBool)(()=>!$supported())
        });
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_getARIAValueNow2);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_getARIAValueText2);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchMax);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchQuality);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_isDisabled2);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onQualityChange);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onValueChange2);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onDragValueChange2);
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_media6, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_sortedQualities, {
            writable: true,
            value: (0, $8B3mG.computed)(()=>{
                const { qualities: qualities } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media6).$state;
                return (0, $jrniq.sortVideoQualities)(qualities());
            })
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_throttledQualityChange, {
            writable: true,
            value: (0, $8B3mG.functionThrottle)((0, $2u9SC._)(this, $af171f1136c0783f$var$_onQualityChange, $af171f1136c0783f$var$onQualityChange).bind(this), 25)
        });
    }
}
(0, $97zcJ._)($af171f1136c0783f$export$1267b1becd779d24, "props", {
    ...(0, $g6paF.SliderController).props,
    step: 1,
    keyStep: 1,
    shiftKeyMultiplier: 1
});
(0, $97zcJ._)($af171f1136c0783f$export$1267b1becd779d24, "state", (0, $g6paF.sliderState));
function $af171f1136c0783f$var$getARIAValueNow2() {
    const { value: value } = this.$state;
    return value();
}
function $af171f1136c0783f$var$getARIAValueText2() {
    const { quality: quality } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media6).$state;
    if (!quality()) return "";
    const { height: height, bitrate: bitrate } = quality(), bitrateText = bitrate && bitrate > 0 ? `${(bitrate / 1e6).toFixed(2)} Mbps` : null;
    return height ? `${height}p${bitrateText ? ` (${bitrateText})` : ""}` : "Auto";
}
function $af171f1136c0783f$var$watchMax() {
    const $qualities = (0, $57dmi._)(this, $af171f1136c0783f$var$_sortedQualities).call(this);
    this.$state.max.set(Math.max(0, $qualities.length - 1));
}
function $af171f1136c0783f$var$watchQuality() {
    let { quality: quality } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media6).$state, $qualities = (0, $57dmi._)(this, $af171f1136c0783f$var$_sortedQualities).call(this), value = Math.max(0, $qualities.indexOf(quality()));
    this.$state.value.set(value);
    this.dispatch("value-change", {
        detail: value
    });
}
function $af171f1136c0783f$var$isDisabled2() {
    const { disabled: disabled } = this.$props, { canSetQuality: canSetQuality, qualities: qualities } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media6).$state;
    return disabled() || qualities().length <= 1 || !canSetQuality();
}
function $af171f1136c0783f$var$onQualityChange(event) {
    if (!event.trigger) return;
    const { qualities: qualities } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media6), quality = (0, $8B3mG.peek)((0, $57dmi._)(this, $af171f1136c0783f$var$_sortedQualities))[event.detail];
    (0, $57dmi._)(this, $af171f1136c0783f$var$_media6).remote.changeQuality(qualities.indexOf(quality), event);
}
function $af171f1136c0783f$var$onValueChange2(event) {
    (0, $57dmi._)(this, $af171f1136c0783f$var$_throttledQualityChange).call(this, event);
}
function $af171f1136c0783f$var$onDragValueChange2(event) {
    (0, $57dmi._)(this, $af171f1136c0783f$var$_throttledQualityChange).call(this, event);
}
var $af171f1136c0783f$var$_media7 = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_sliderState = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_updateScope = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_titleRef = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_refs = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_$track = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_$cues = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_activeIndex = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_activePointerIndex = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_bufferedIndex = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_setTrack = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_reset = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watch = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchUpdates = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchContainerWidths = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchFillPercent = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchPointerPercent = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_updateFillPercents = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_updateFillPercent = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_findActiveChapterIndex = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchBufferedPercent = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_updateBufferedPercent = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_bufferedPercent = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_calcMediaBufferedPercent = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_getEndTime = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_calcPercent = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_fillGaps = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchSource = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_onTrackChange = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchMediaDuration = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_onCuesChange = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_onChapterTitleChange = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_findParentSlider = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_findChapterTitleRef = /*#__PURE__*/ new WeakSet();
class $af171f1136c0783f$export$11d0536309d27326 extends (0, $8B3mG.Component) {
    get cues() {
        return (0, $57dmi._)(this, $af171f1136c0783f$var$_$cues).call(this);
    }
    get activeCue() {
        return (0, $57dmi._)(this, $af171f1136c0783f$var$_$cues).call(this)[(0, $57dmi._)(this, $af171f1136c0783f$var$_activeIndex).call(this)] || null;
    }
    get activePointerCue() {
        return (0, $57dmi._)(this, $af171f1136c0783f$var$_$cues).call(this)[(0, $57dmi._)(this, $af171f1136c0783f$var$_activePointerIndex).call(this)] || null;
    }
    onSetup() {
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_media7, (0, $6KfMo.useMediaContext)());
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_sliderState, (0, $8B3mG.useState)((0, $g6paF.TimeSlider).state));
    }
    onAttach(el) {
        (0, $l6thX.watchActiveTextTrack)((0, $57dmi._)(this, $af171f1136c0783f$var$_media7).textTracks, "chapters", (0, $2u9SC._)(this, $af171f1136c0783f$var$_setTrack, $af171f1136c0783f$var$setTrack).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchSource, $af171f1136c0783f$var$watchSource).bind(this));
    }
    onConnect() {
        (0, $8B3mG.onDispose)(()=>(0, $2u9SC._)(this, $af171f1136c0783f$var$_reset, $af171f1136c0783f$var$reset).bind(this));
    }
    onDestroy() {
        (0, $2u9SC._)(this, $af171f1136c0783f$var$_setTrack, $af171f1136c0783f$var$setTrack).call(this, null);
    }
    setRefs(refs) {
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_refs, refs);
        (0, $57dmi._)(this, $af171f1136c0783f$var$_updateScope)?.dispose();
        if ((0, $57dmi._)(this, $af171f1136c0783f$var$_refs).length === 1) {
            const el = (0, $57dmi._)(this, $af171f1136c0783f$var$_refs)[0];
            el.style.width = "100%";
            el.style.setProperty("--chapter-fill", "var(--slider-fill)");
            el.style.setProperty("--chapter-progress", "var(--slider-progress)");
        } else if ((0, $57dmi._)(this, $af171f1136c0783f$var$_refs).length > 0) (0, $8B3mG.scoped)(()=>(0, $2u9SC._)(this, $af171f1136c0783f$var$_watch, $af171f1136c0783f$var$watch).call(this), (0, $4vwVC._)(this, $af171f1136c0783f$var$_updateScope, (0, $8B3mG.createScope)()));
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_setTrack);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_reset);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watch);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchUpdates);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchContainerWidths);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchFillPercent);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchPointerPercent);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_updateFillPercents);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_updateFillPercent);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_findActiveChapterIndex);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchBufferedPercent);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_calcMediaBufferedPercent);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_getEndTime);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_calcPercent);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_fillGaps);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchSource);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onTrackChange);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchMediaDuration);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onChapterTitleChange);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_findParentSlider);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_findChapterTitleRef);
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_media7, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_sliderState, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_updateScope, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_titleRef, {
            writable: true,
            value: null
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_refs, {
            writable: true,
            value: []
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_$track, {
            writable: true,
            value: (0, $8B3mG.signal)(null)
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_$cues, {
            writable: true,
            value: (0, $8B3mG.signal)([])
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_activeIndex, {
            writable: true,
            value: (0, $8B3mG.signal)(-1)
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_activePointerIndex, {
            writable: true,
            value: (0, $8B3mG.signal)(-1)
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_bufferedIndex, {
            writable: true,
            value: 0
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_updateBufferedPercent, {
            writable: true,
            value: (0, $8B3mG.animationFrameThrottle)((bufferedPercent)=>{
                let percent, cues = (0, $57dmi._)(this, $af171f1136c0783f$var$_$cues).call(this), { clipStartTime: clipStartTime } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media7).$state, startTime = clipStartTime(), endTime = (0, $2u9SC._)(this, $af171f1136c0783f$var$_getEndTime, $af171f1136c0783f$var$getEndTime).call(this, cues);
                for(let i = (0, $57dmi._)(this, $af171f1136c0783f$var$_bufferedIndex); i < (0, $57dmi._)(this, $af171f1136c0783f$var$_refs).length; i++){
                    percent = (0, $2u9SC._)(this, $af171f1136c0783f$var$_calcPercent, $af171f1136c0783f$var$calcPercent).call(this, cues[i], bufferedPercent, startTime, endTime);
                    (0, $57dmi._)(this, $af171f1136c0783f$var$_refs)[i]?.style.setProperty("--chapter-progress", percent + "%");
                    if (percent < 100) {
                        (0, $4vwVC._)(this, $af171f1136c0783f$var$_bufferedIndex, i);
                        break;
                    }
                }
            })
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_bufferedPercent, {
            writable: true,
            value: (0, $8B3mG.computed)((0, $2u9SC._)(this, $af171f1136c0783f$var$_calcMediaBufferedPercent, $af171f1136c0783f$var$calcMediaBufferedPercent).bind(this))
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_onCuesChange, {
            writable: true,
            value: (0, $8B3mG.functionDebounce)(()=>{
                const track = (0, $8B3mG.peek)((0, $57dmi._)(this, $af171f1136c0783f$var$_$track));
                if (!this.scope || !track || !track.cues.length) return;
                (0, $57dmi._)(this, $af171f1136c0783f$var$_$cues).set((0, $2u9SC._)(this, $af171f1136c0783f$var$_fillGaps, $af171f1136c0783f$var$fillGaps).call(this, track.cues));
                (0, $57dmi._)(this, $af171f1136c0783f$var$_activeIndex).set(0);
                (0, $4vwVC._)(this, $af171f1136c0783f$var$_bufferedIndex, 0);
            }, 150, true)
        });
    }
}
(0, $97zcJ._)($af171f1136c0783f$export$11d0536309d27326, "props", {
    disabled: false
});
function $af171f1136c0783f$var$setTrack(track) {
    if ((0, $8B3mG.peek)((0, $57dmi._)(this, $af171f1136c0783f$var$_$track)) === track) return;
    (0, $2u9SC._)(this, $af171f1136c0783f$var$_reset, $af171f1136c0783f$var$reset).call(this);
    (0, $57dmi._)(this, $af171f1136c0783f$var$_$track).set(track);
}
function $af171f1136c0783f$var$reset() {
    (0, $4vwVC._)(this, $af171f1136c0783f$var$_refs, []);
    (0, $57dmi._)(this, $af171f1136c0783f$var$_$cues).set([]);
    (0, $57dmi._)(this, $af171f1136c0783f$var$_activeIndex).set(-1);
    (0, $57dmi._)(this, $af171f1136c0783f$var$_activePointerIndex).set(-1);
    (0, $4vwVC._)(this, $af171f1136c0783f$var$_bufferedIndex, 0);
    (0, $57dmi._)(this, $af171f1136c0783f$var$_updateScope)?.dispose();
}
function $af171f1136c0783f$var$watch() {
    if (!(0, $57dmi._)(this, $af171f1136c0783f$var$_refs).length) return;
    (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchUpdates, $af171f1136c0783f$var$watchUpdates).bind(this));
}
function $af171f1136c0783f$var$watchUpdates() {
    const { hidden: hidden } = (0, $57dmi._)(this, $af171f1136c0783f$var$_sliderState);
    if (hidden()) return;
    (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchContainerWidths, $af171f1136c0783f$var$watchContainerWidths).bind(this));
    (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchFillPercent, $af171f1136c0783f$var$watchFillPercent).bind(this));
    (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchPointerPercent, $af171f1136c0783f$var$watchPointerPercent).bind(this));
    (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchBufferedPercent, $af171f1136c0783f$var$watchBufferedPercent).bind(this));
}
function $af171f1136c0783f$var$watchContainerWidths() {
    const cues = (0, $57dmi._)(this, $af171f1136c0783f$var$_$cues).call(this);
    if (!cues.length) return;
    let cue, { clipStartTime: clipStartTime, clipEndTime: clipEndTime } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media7).$state, startTime = clipStartTime(), endTime = clipEndTime() || cues[cues.length - 1].endTime, duration = endTime - startTime, remainingWidth = 100;
    for(let i = 0; i < cues.length; i++){
        cue = cues[i];
        if ((0, $57dmi._)(this, $af171f1136c0783f$var$_refs)[i]) {
            const width = i === cues.length - 1 ? remainingWidth : (0, $hzYuC.round)((cue.endTime - Math.max(startTime, cue.startTime)) / duration * 100, 3);
            (0, $57dmi._)(this, $af171f1136c0783f$var$_refs)[i].style.width = width + "%";
            remainingWidth -= width;
        }
    }
}
function $af171f1136c0783f$var$watchFillPercent() {
    let { liveEdge: liveEdge, clipStartTime: clipStartTime, duration: duration } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media7).$state, { fillPercent: fillPercent, value: value } = (0, $57dmi._)(this, $af171f1136c0783f$var$_sliderState), cues = (0, $57dmi._)(this, $af171f1136c0783f$var$_$cues).call(this), isLiveEdge = liveEdge(), prevActiveIndex = (0, $8B3mG.peek)((0, $57dmi._)(this, $af171f1136c0783f$var$_activeIndex)), currentChapter = cues[prevActiveIndex];
    let currentActiveIndex = isLiveEdge ? (0, $57dmi._)(this, $af171f1136c0783f$var$_$cues).length - 1 : (0, $2u9SC._)(this, $af171f1136c0783f$var$_findActiveChapterIndex, $af171f1136c0783f$var$findActiveChapterIndex).call(this, currentChapter ? currentChapter.startTime / duration() * 100 <= (0, $8B3mG.peek)(value) ? prevActiveIndex : 0 : 0, fillPercent());
    if (isLiveEdge || !currentChapter) (0, $2u9SC._)(this, $af171f1136c0783f$var$_updateFillPercents, $af171f1136c0783f$var$updateFillPercents).call(this, 0, cues.length, 100);
    else if (currentActiveIndex > prevActiveIndex) (0, $2u9SC._)(this, $af171f1136c0783f$var$_updateFillPercents, $af171f1136c0783f$var$updateFillPercents).call(this, prevActiveIndex, currentActiveIndex, 100);
    else if (currentActiveIndex < prevActiveIndex) (0, $2u9SC._)(this, $af171f1136c0783f$var$_updateFillPercents, $af171f1136c0783f$var$updateFillPercents).call(this, currentActiveIndex + 1, prevActiveIndex + 1, 0);
    const percent = isLiveEdge ? 100 : (0, $2u9SC._)(this, $af171f1136c0783f$var$_calcPercent, $af171f1136c0783f$var$calcPercent).call(this, cues[currentActiveIndex], fillPercent(), clipStartTime(), (0, $2u9SC._)(this, $af171f1136c0783f$var$_getEndTime, $af171f1136c0783f$var$getEndTime).call(this, cues));
    (0, $2u9SC._)(this, $af171f1136c0783f$var$_updateFillPercent, $af171f1136c0783f$var$updateFillPercent).call(this, (0, $57dmi._)(this, $af171f1136c0783f$var$_refs)[currentActiveIndex], percent);
    (0, $57dmi._)(this, $af171f1136c0783f$var$_activeIndex).set(currentActiveIndex);
}
function $af171f1136c0783f$var$watchPointerPercent() {
    let { pointing: pointing, pointerPercent: pointerPercent } = (0, $57dmi._)(this, $af171f1136c0783f$var$_sliderState);
    if (!pointing()) {
        (0, $57dmi._)(this, $af171f1136c0783f$var$_activePointerIndex).set(-1);
        return;
    }
    const activeIndex = (0, $2u9SC._)(this, $af171f1136c0783f$var$_findActiveChapterIndex, $af171f1136c0783f$var$findActiveChapterIndex).call(this, 0, pointerPercent());
    (0, $57dmi._)(this, $af171f1136c0783f$var$_activePointerIndex).set(activeIndex);
}
function $af171f1136c0783f$var$updateFillPercents(start, end, percent) {
    for(let i = start; i < end; i++)(0, $2u9SC._)(this, $af171f1136c0783f$var$_updateFillPercent, $af171f1136c0783f$var$updateFillPercent).call(this, (0, $57dmi._)(this, $af171f1136c0783f$var$_refs)[i], percent);
}
function $af171f1136c0783f$var$updateFillPercent(ref, percent) {
    if (!ref) return;
    ref.style.setProperty("--chapter-fill", percent + "%");
    (0, $8B3mG.setAttribute)(ref, "data-active", percent > 0 && percent < 100);
    (0, $8B3mG.setAttribute)(ref, "data-ended", percent === 100);
}
function $af171f1136c0783f$var$findActiveChapterIndex(startIndex, percent) {
    let chapterPercent = 0, cues = (0, $57dmi._)(this, $af171f1136c0783f$var$_$cues).call(this);
    if (percent === 0) return 0;
    else if (percent === 100) return cues.length - 1;
    let { clipStartTime: clipStartTime } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media7).$state, startTime = clipStartTime(), endTime = (0, $2u9SC._)(this, $af171f1136c0783f$var$_getEndTime, $af171f1136c0783f$var$getEndTime).call(this, cues);
    for(let i = startIndex; i < cues.length; i++){
        chapterPercent = (0, $2u9SC._)(this, $af171f1136c0783f$var$_calcPercent, $af171f1136c0783f$var$calcPercent).call(this, cues[i], percent, startTime, endTime);
        if (chapterPercent >= 0 && chapterPercent < 100) return i;
    }
    return 0;
}
function $af171f1136c0783f$var$watchBufferedPercent() {
    (0, $57dmi._)(this, $af171f1136c0783f$var$_updateBufferedPercent).call(this, (0, $57dmi._)(this, $af171f1136c0783f$var$_bufferedPercent).call(this));
}
function $af171f1136c0783f$var$calcMediaBufferedPercent() {
    const { bufferedEnd: bufferedEnd, duration: duration } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media7).$state;
    return (0, $hzYuC.round)(Math.min(bufferedEnd() / Math.max(duration(), 1), 1), 3) * 100;
}
function $af171f1136c0783f$var$getEndTime(cues) {
    const { clipEndTime: clipEndTime } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media7).$state, endTime = clipEndTime();
    return endTime > 0 ? endTime : cues[cues.length - 1]?.endTime || 0;
}
function $af171f1136c0783f$var$calcPercent(cue, percent, startTime, endTime) {
    const cues = (0, $57dmi._)(this, $af171f1136c0783f$var$_$cues).call(this);
    if (cues.length === 0) return 0;
    const duration = endTime - startTime, cueStartTime = Math.max(0, cue.startTime - startTime), cueEndTime = Math.min(endTime, cue.endTime) - startTime;
    const startRatio = cueStartTime / duration, startPercent = startRatio * 100, endPercent = Math.min(1, startRatio + (cueEndTime - cueStartTime) / duration) * 100;
    return Math.max(0, (0, $hzYuC.round)(percent >= endPercent ? 100 : (percent - startPercent) / (endPercent - startPercent) * 100, 3));
}
function $af171f1136c0783f$var$fillGaps(cues) {
    let chapters = [], { clipStartTime: clipStartTime, clipEndTime: clipEndTime, duration: duration } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media7).$state, startTime = clipStartTime(), endTime = clipEndTime() || Infinity;
    cues = cues.filter((cue)=>cue.startTime <= endTime && cue.endTime >= startTime);
    const firstCue = cues[0];
    if (firstCue && firstCue.startTime > startTime) chapters.push(new window.VTTCue(startTime, firstCue.startTime, ""));
    for(let i = 0; i < cues.length - 1; i++){
        const currentCue = cues[i], nextCue = cues[i + 1];
        chapters.push(currentCue);
        if (nextCue) {
            const timeDiff = nextCue.startTime - currentCue.endTime;
            if (timeDiff > 0) chapters.push(new window.VTTCue(currentCue.endTime, currentCue.endTime + timeDiff, ""));
        }
    }
    const lastCue = cues[cues.length - 1];
    if (lastCue) {
        chapters.push(lastCue);
        const endTime2 = duration();
        if (endTime2 >= 0 && endTime2 - lastCue.endTime > 1) chapters.push(new window.VTTCue(lastCue.endTime, duration(), ""));
    }
    return chapters;
}
function $af171f1136c0783f$var$watchSource() {
    const { source: source } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media7).$state;
    source();
    (0, $2u9SC._)(this, $af171f1136c0783f$var$_onTrackChange, $af171f1136c0783f$var$onTrackChange).call(this);
}
function $af171f1136c0783f$var$onTrackChange() {
    if (!this.scope) return;
    const { disabled: disabled } = this.$props;
    if (disabled()) {
        (0, $57dmi._)(this, $af171f1136c0783f$var$_$cues).set([]);
        (0, $57dmi._)(this, $af171f1136c0783f$var$_activeIndex).set(0);
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_bufferedIndex, 0);
        return;
    }
    const track = (0, $57dmi._)(this, $af171f1136c0783f$var$_$track).call(this);
    if (track) {
        const onCuesChange = (0, $57dmi._)(this, $af171f1136c0783f$var$_onCuesChange).bind(this);
        onCuesChange();
        new (0, $8B3mG.EventsController)(track).add("add-cue", onCuesChange).add("remove-cue", onCuesChange);
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchMediaDuration, $af171f1136c0783f$var$watchMediaDuration).bind(this));
    }
    (0, $4vwVC._)(this, $af171f1136c0783f$var$_titleRef, (0, $2u9SC._)(this, $af171f1136c0783f$var$_findChapterTitleRef, $af171f1136c0783f$var$findChapterTitleRef).call(this));
    if ((0, $57dmi._)(this, $af171f1136c0783f$var$_titleRef)) (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_onChapterTitleChange, $af171f1136c0783f$var$onChapterTitleChange).bind(this));
    return ()=>{
        if ((0, $57dmi._)(this, $af171f1136c0783f$var$_titleRef)) {
            (0, $57dmi._)(this, $af171f1136c0783f$var$_titleRef).textContent = "";
            (0, $4vwVC._)(this, $af171f1136c0783f$var$_titleRef, null);
        }
    };
}
function $af171f1136c0783f$var$watchMediaDuration() {
    (0, $57dmi._)(this, $af171f1136c0783f$var$_media7).$state.duration();
    (0, $57dmi._)(this, $af171f1136c0783f$var$_onCuesChange).call(this);
}
function $af171f1136c0783f$var$onChapterTitleChange() {
    const cue = this.activePointerCue || this.activeCue;
    if ((0, $57dmi._)(this, $af171f1136c0783f$var$_titleRef)) (0, $57dmi._)(this, $af171f1136c0783f$var$_titleRef).textContent = cue?.text || "";
}
function $af171f1136c0783f$var$findParentSlider() {
    let node = this.el;
    while(node && node.getAttribute("role") !== "slider")node = node.parentElement;
    return node;
}
function $af171f1136c0783f$var$findChapterTitleRef() {
    const slider = (0, $2u9SC._)(this, $af171f1136c0783f$var$_findParentSlider, $af171f1136c0783f$var$findParentSlider).call(this);
    return slider ? slider.querySelector('[data-part="chapter-title"]') : null;
}
const $af171f1136c0783f$var$sliderchapters__proto = $af171f1136c0783f$export$11d0536309d27326.prototype;
(0, $8B3mG.prop)($af171f1136c0783f$var$sliderchapters__proto, "cues");
(0, $8B3mG.prop)($af171f1136c0783f$var$sliderchapters__proto, "activeCue");
(0, $8B3mG.prop)($af171f1136c0783f$var$sliderchapters__proto, "activePointerCue");
(0, $8B3mG.method)($af171f1136c0783f$var$sliderchapters__proto, "setRefs");
var $af171f1136c0783f$var$_controller = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_watchValue = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_onValueChange3 = /*#__PURE__*/ new WeakSet();
class $af171f1136c0783f$export$a98f0dcb43a68a25 extends (0, $8B3mG.Component) {
    /**
   * A list of radio values that belong this group.
   */ get values() {
        return (0, $57dmi._)(this, $af171f1136c0783f$var$_controller).values;
    }
    /**
   * The radio value that is checked in this group.
   */ get value() {
        return (0, $57dmi._)(this, $af171f1136c0783f$var$_controller).value;
    }
    set value(newValue) {
        (0, $57dmi._)(this, $af171f1136c0783f$var$_controller).value = newValue;
    }
    onSetup() {
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchValue, $af171f1136c0783f$var$watchValue).bind(this));
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchValue);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onValueChange3);
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_controller, {
            writable: true,
            value: void 0
        });
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_controller, new (0, $g6paF.RadioGroupController)());
        (0, $57dmi._)(this, $af171f1136c0783f$var$_controller).onValueChange = (0, $2u9SC._)(this, $af171f1136c0783f$var$_onValueChange3, $af171f1136c0783f$var$onValueChange3).bind(this);
    }
}
(0, $97zcJ._)($af171f1136c0783f$export$a98f0dcb43a68a25, "props", {
    value: ""
});
function $af171f1136c0783f$var$watchValue() {
    (0, $57dmi._)(this, $af171f1136c0783f$var$_controller).value = this.$props.value();
}
function $af171f1136c0783f$var$onValueChange3(value, trigger) {
    const event = this.createEvent("change", {
        detail: value,
        trigger: trigger
    });
    this.dispatch(event);
}
const $af171f1136c0783f$var$radiogroup__proto = $af171f1136c0783f$export$a98f0dcb43a68a25.prototype;
(0, $8B3mG.prop)($af171f1136c0783f$var$radiogroup__proto, "values");
(0, $8B3mG.prop)($af171f1136c0783f$var$radiogroup__proto, "value");
var $af171f1136c0783f$var$_checked = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_controller1 = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_onDisconnect = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_addToGroup = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchValue1 = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_onPress1 = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_check = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_onChange = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_onSelect = /*#__PURE__*/ new WeakSet();
class $af171f1136c0783f$export$d7b12c4107be0d61 extends (0, $8B3mG.Component) {
    /**
   * Whether this radio is currently checked.
   */ get checked() {
        return (0, $57dmi._)(this, $af171f1136c0783f$var$_checked).call(this);
    }
    onSetup() {
        this.setAttributes({
            value: this.$props.value,
            "data-checked": (0, $57dmi._)(this, $af171f1136c0783f$var$_checked),
            "aria-checked": (0, $jrniq.$ariaBool)((0, $57dmi._)(this, $af171f1136c0783f$var$_checked))
        });
    }
    onAttach(el) {
        const isMenuItem = (0, $8B3mG.hasProvidedContext)((0, $g6paF.menuContext));
        (0, $ciZW6.setAttributeIfEmpty)(el, "tabindex", isMenuItem ? "-1" : "0");
        (0, $ciZW6.setAttributeIfEmpty)(el, "role", isMenuItem ? "menuitemradio" : "radio");
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchValue1, $af171f1136c0783f$var$watchValue1).bind(this));
    }
    onConnect(el) {
        (0, $2u9SC._)(this, $af171f1136c0783f$var$_addToGroup, $af171f1136c0783f$var$addToGroup).call(this);
        (0, $ciZW6.onPress)(el, (0, $2u9SC._)(this, $af171f1136c0783f$var$_onPress1, $af171f1136c0783f$var$onPress2).bind(this));
        (0, $8B3mG.onDispose)((0, $2u9SC._)(this, $af171f1136c0783f$var$_onDisconnect, $af171f1136c0783f$var$onDisconnect).bind(this));
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onDisconnect);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_addToGroup);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchValue1);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onPress1);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_check);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onChange);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onSelect);
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_checked, {
            writable: true,
            value: (0, $8B3mG.signal)(false)
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_controller1, {
            writable: true,
            value: {
                value: this.$props.value,
                check: (0, $2u9SC._)(this, $af171f1136c0783f$var$_check, $af171f1136c0783f$var$check).bind(this),
                onCheck: null
            }
        });
        new (0, $jWjYZ.FocusVisibleController)();
    }
}
(0, $97zcJ._)($af171f1136c0783f$export$d7b12c4107be0d61, "props", {
    value: ""
});
function $af171f1136c0783f$var$onDisconnect() {
    (0, $8B3mG.scoped)(()=>{
        const group = (0, $8B3mG.useContext)((0, $g6paF.radioControllerContext));
        group.remove((0, $57dmi._)(this, $af171f1136c0783f$var$_controller1));
    }, this.connectScope);
}
function $af171f1136c0783f$var$addToGroup() {
    const group = (0, $8B3mG.useContext)((0, $g6paF.radioControllerContext));
    group.add((0, $57dmi._)(this, $af171f1136c0783f$var$_controller1));
}
function $af171f1136c0783f$var$watchValue1() {
    const { value: value } = this.$props, newValue = value();
    if ((0, $8B3mG.peek)((0, $57dmi._)(this, $af171f1136c0783f$var$_checked))) (0, $57dmi._)(this, $af171f1136c0783f$var$_controller1).onCheck?.(newValue);
}
function $af171f1136c0783f$var$onPress2(event) {
    if ((0, $8B3mG.peek)((0, $57dmi._)(this, $af171f1136c0783f$var$_checked))) return;
    (0, $2u9SC._)(this, $af171f1136c0783f$var$_onChange, $af171f1136c0783f$var$onChange).call(this, true, event);
    (0, $2u9SC._)(this, $af171f1136c0783f$var$_onSelect, $af171f1136c0783f$var$onSelect).call(this, event);
    (0, $57dmi._)(this, $af171f1136c0783f$var$_controller1).onCheck?.((0, $8B3mG.peek)(this.$props.value), event);
}
function $af171f1136c0783f$var$check(value, trigger) {
    if ((0, $8B3mG.peek)((0, $57dmi._)(this, $af171f1136c0783f$var$_checked)) === value) return;
    (0, $2u9SC._)(this, $af171f1136c0783f$var$_onChange, $af171f1136c0783f$var$onChange).call(this, value, trigger);
}
function $af171f1136c0783f$var$onChange(value, trigger) {
    (0, $57dmi._)(this, $af171f1136c0783f$var$_checked).set(value);
    this.dispatch("change", {
        detail: value,
        trigger: trigger
    });
}
function $af171f1136c0783f$var$onSelect(trigger) {
    this.dispatch("select", {
        trigger: trigger
    });
}
const $af171f1136c0783f$var$radio__proto = $af171f1136c0783f$export$d7b12c4107be0d61.prototype;
(0, $8B3mG.prop)($af171f1136c0783f$var$radio__proto, "checked");
var $af171f1136c0783f$var$__defProp = Object.defineProperty;
var $af171f1136c0783f$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $af171f1136c0783f$var$__decorateClass = (decorators, target, key, kind)=>{
    var result = $af171f1136c0783f$var$__getOwnPropDesc(target, key);
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = decorator(target, key, result) || result;
    if (result) $af171f1136c0783f$var$__defProp(target, key, result);
    return result;
};
var $af171f1136c0783f$var$_media8 = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_menu = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_controller2 = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_track = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_cues = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_onOpen = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchTrack = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_onCuesChange1 = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchCurrentTime = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchControllerDisabled = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_onValueChange4 = /*#__PURE__*/ new WeakSet();
class $af171f1136c0783f$export$20dc6dce1c83395a extends (0, $8B3mG.Component) {
    get value() {
        return (0, $57dmi._)(this, $af171f1136c0783f$var$_controller2).value;
    }
    get disabled() {
        return !(0, $57dmi._)(this, $af171f1136c0783f$var$_cues).call(this)?.length;
    }
    onSetup() {
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_media8, (0, $6KfMo.useMediaContext)());
        if ((0, $8B3mG.hasProvidedContext)((0, $g6paF.menuContext))) (0, $4vwVC._)(this, $af171f1136c0783f$var$_menu, (0, $8B3mG.useContext)((0, $g6paF.menuContext)));
        const { thumbnails: thumbnails } = this.$props;
        this.setAttributes({
            "data-thumbnails": ()=>!!thumbnails()
        });
    }
    onAttach(el) {
        (0, $57dmi._)(this, $af171f1136c0783f$var$_menu)?.attachObserver({
            onOpen: (0, $2u9SC._)(this, $af171f1136c0783f$var$_onOpen, $af171f1136c0783f$var$onOpen).bind(this)
        });
    }
    getOptions() {
        const { clipStartTime: clipStartTime, clipEndTime: clipEndTime } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media8).$state, startTime = clipStartTime(), endTime = clipEndTime() || Infinity;
        return (0, $57dmi._)(this, $af171f1136c0783f$var$_cues).call(this).map((cue, i)=>({
                cue: cue,
                value: i.toString(),
                label: cue.text,
                startTime: (0, $g6paF.formatTime)(Math.max(0, cue.startTime - startTime)),
                duration: (0, $g6paF.formatSpokenTime)(Math.min(endTime, cue.endTime) - Math.max(startTime, cue.startTime))
            }));
    }
    onConnect(el) {
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchCurrentTime, $af171f1136c0783f$var$watchCurrentTime).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchControllerDisabled, $af171f1136c0783f$var$watchControllerDisabled).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchTrack, $af171f1136c0783f$var$watchTrack).bind(this));
        (0, $l6thX.watchActiveTextTrack)((0, $57dmi._)(this, $af171f1136c0783f$var$_media8).textTracks, "chapters", (0, $57dmi._)(this, $af171f1136c0783f$var$_track).set);
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onOpen);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchTrack);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onCuesChange1);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchCurrentTime);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchControllerDisabled);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onValueChange4);
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_media8, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_menu, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_controller2, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_track, {
            writable: true,
            value: (0, $8B3mG.signal)(null)
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_cues, {
            writable: true,
            value: (0, $8B3mG.signal)([])
        });
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_controller2, new (0, $g6paF.RadioGroupController)());
        (0, $57dmi._)(this, $af171f1136c0783f$var$_controller2).onValueChange = (0, $2u9SC._)(this, $af171f1136c0783f$var$_onValueChange4, $af171f1136c0783f$var$onValueChange4).bind(this);
    }
}
(0, $97zcJ._)($af171f1136c0783f$export$20dc6dce1c83395a, "props", {
    thumbnails: null
});
function $af171f1136c0783f$var$onOpen() {
    (0, $8B3mG.peek)(()=>(0, $2u9SC._)(this, $af171f1136c0783f$var$_watchCurrentTime, $af171f1136c0783f$var$watchCurrentTime).call(this));
}
function $af171f1136c0783f$var$watchTrack() {
    const track = (0, $57dmi._)(this, $af171f1136c0783f$var$_track).call(this);
    if (!track) return;
    const onCuesChange1 = (0, $2u9SC._)(this, $af171f1136c0783f$var$_onCuesChange1, $af171f1136c0783f$var$onCuesChange).bind(this, track);
    onCuesChange1();
    new (0, $8B3mG.EventsController)(track).add("add-cue", onCuesChange1).add("remove-cue", onCuesChange1);
    return ()=>{
        (0, $57dmi._)(this, $af171f1136c0783f$var$_cues).set([]);
    };
}
function $af171f1136c0783f$var$onCuesChange(track) {
    const { clipStartTime: clipStartTime, clipEndTime: clipEndTime } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media8).$state, startTime = clipStartTime(), endTime = clipEndTime() || Infinity;
    (0, $57dmi._)(this, $af171f1136c0783f$var$_cues).set([
        ...track.cues
    ].filter((cue)=>cue.startTime <= endTime && cue.endTime >= startTime));
}
function $af171f1136c0783f$var$watchCurrentTime() {
    if (!(0, $57dmi._)(this, $af171f1136c0783f$var$_menu)?.expanded()) return;
    const track = (0, $57dmi._)(this, $af171f1136c0783f$var$_track).call(this);
    if (!track) {
        (0, $57dmi._)(this, $af171f1136c0783f$var$_controller2).value = "-1";
        return;
    }
    const { realCurrentTime: realCurrentTime, clipStartTime: clipStartTime, clipEndTime: clipEndTime } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media8).$state, startTime = clipStartTime(), endTime = clipEndTime() || Infinity, time = realCurrentTime(), activeCueIndex = (0, $57dmi._)(this, $af171f1136c0783f$var$_cues).call(this).findIndex((cue)=>(0, $l6thX.isCueActive)(cue, time));
    (0, $57dmi._)(this, $af171f1136c0783f$var$_controller2).value = activeCueIndex.toString();
    if (activeCueIndex >= 0) (0, $ciZW6.requestScopedAnimationFrame)(()=>{
        if (!this.connectScope) return;
        const cue = (0, $57dmi._)(this, $af171f1136c0783f$var$_cues).call(this)[activeCueIndex], radio = this.el.querySelector(`[aria-checked='true']`), cueStartTime = Math.max(startTime, cue.startTime), duration = Math.min(endTime, cue.endTime) - cueStartTime, playedPercent = Math.max(0, time - cueStartTime) / duration * 100;
        radio && (0, $8B3mG.setStyle)(radio, "--progress", (0, $hzYuC.round)(playedPercent, 3) + "%");
    });
}
function $af171f1136c0783f$var$watchControllerDisabled() {
    (0, $57dmi._)(this, $af171f1136c0783f$var$_menu)?.disable(this.disabled);
}
function $af171f1136c0783f$var$onValueChange4(value, trigger) {
    if (this.disabled || !trigger) return;
    const index = +value, cues = (0, $57dmi._)(this, $af171f1136c0783f$var$_cues).call(this), { clipStartTime: clipStartTime } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media8).$state;
    if ((0, $8B3mG.isNumber)(index) && cues?.[index]) {
        (0, $57dmi._)(this, $af171f1136c0783f$var$_controller2).value = index.toString();
        (0, $57dmi._)(this, $af171f1136c0783f$var$_media8).remote.seek(cues[index].startTime - clipStartTime(), trigger);
        this.dispatch("change", {
            detail: cues[index],
            trigger: trigger
        });
    }
}
$af171f1136c0783f$var$__decorateClass([
    (0, $8B3mG.prop)
], $af171f1136c0783f$export$20dc6dce1c83395a.prototype, "value");
$af171f1136c0783f$var$__decorateClass([
    (0, $8B3mG.prop)
], $af171f1136c0783f$export$20dc6dce1c83395a.prototype, "disabled");
$af171f1136c0783f$var$__decorateClass([
    (0, $8B3mG.method)
], $af171f1136c0783f$export$20dc6dce1c83395a.prototype, "getOptions");
const $af171f1136c0783f$export$ddfd7bbf9881da34 = [
    1,
    1.25,
    1.5,
    1.75,
    2,
    2.5,
    3,
    4
];
var $af171f1136c0783f$var$_media9 = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_menu1 = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_controller3 = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_watchValue2 = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchHintText = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchControllerDisabled1 = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_getValue = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_onValueChange5 = /*#__PURE__*/ new WeakSet();
class $af171f1136c0783f$export$f749e84e3a859fa5 extends (0, $8B3mG.Component) {
    get value() {
        return (0, $57dmi._)(this, $af171f1136c0783f$var$_controller3).value;
    }
    get disabled() {
        const { gains: gains } = this.$props, { canSetAudioGain: canSetAudioGain } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media9).$state;
        return !canSetAudioGain() || gains().length === 0;
    }
    onSetup() {
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_media9, (0, $6KfMo.useMediaContext)());
        if ((0, $8B3mG.hasProvidedContext)((0, $g6paF.menuContext))) (0, $4vwVC._)(this, $af171f1136c0783f$var$_menu1, (0, $8B3mG.useContext)((0, $g6paF.menuContext)));
    }
    onConnect(el) {
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchValue2, $af171f1136c0783f$var$watchValue2).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchHintText, $af171f1136c0783f$var$watchHintText).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchControllerDisabled1, $af171f1136c0783f$var$watchControllerDisabled1).bind(this));
    }
    getOptions() {
        const { gains: gains, normalLabel: normalLabel } = this.$props;
        return gains().map((gain)=>({
                label: gain === 1 || gain === null ? normalLabel : String(gain * 100) + "%",
                value: gain.toString()
            }));
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchValue2);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchHintText);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchControllerDisabled1);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_getValue);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onValueChange5);
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_media9, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_menu1, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_controller3, {
            writable: true,
            value: void 0
        });
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_controller3, new (0, $g6paF.RadioGroupController)());
        (0, $57dmi._)(this, $af171f1136c0783f$var$_controller3).onValueChange = (0, $2u9SC._)(this, $af171f1136c0783f$var$_onValueChange5, $af171f1136c0783f$var$onValueChange5).bind(this);
    }
}
(0, $97zcJ._)($af171f1136c0783f$export$f749e84e3a859fa5, "props", {
    normalLabel: "Disabled",
    gains: $af171f1136c0783f$export$ddfd7bbf9881da34
});
function $af171f1136c0783f$var$watchValue2() {
    (0, $57dmi._)(this, $af171f1136c0783f$var$_controller3).value = (0, $2u9SC._)(this, $af171f1136c0783f$var$_getValue, $af171f1136c0783f$var$getValue).call(this);
}
function $af171f1136c0783f$var$watchHintText() {
    const { normalLabel: normalLabel } = this.$props, { audioGain: audioGain } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media9).$state, gain = audioGain();
    (0, $57dmi._)(this, $af171f1136c0783f$var$_menu1)?.hint.set(gain === 1 || gain == null ? normalLabel() : String(gain * 100) + "%");
}
function $af171f1136c0783f$var$watchControllerDisabled1() {
    (0, $57dmi._)(this, $af171f1136c0783f$var$_menu1)?.disable(this.disabled);
}
function $af171f1136c0783f$var$getValue() {
    const { audioGain: audioGain } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media9).$state;
    return audioGain()?.toString() ?? "1";
}
function $af171f1136c0783f$var$onValueChange5(value, trigger) {
    if (this.disabled) return;
    const gain = +value;
    (0, $57dmi._)(this, $af171f1136c0783f$var$_media9).remote.changeAudioGain(gain, trigger);
    this.dispatch("change", {
        detail: gain,
        trigger: trigger
    });
}
const $af171f1136c0783f$var$audiogainradiogroup__proto = $af171f1136c0783f$export$f749e84e3a859fa5.prototype;
(0, $8B3mG.prop)($af171f1136c0783f$var$audiogainradiogroup__proto, "value");
(0, $8B3mG.prop)($af171f1136c0783f$var$audiogainradiogroup__proto, "disabled");
(0, $8B3mG.method)($af171f1136c0783f$var$audiogainradiogroup__proto, "getOptions");
var $af171f1136c0783f$var$_media10 = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_provider = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_attachListener = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_presses = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_pressTimerId = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_acceptEvent = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_handleEvent = /*#__PURE__*/ new WeakSet(), /** Validate event occurred in gesture bounds. */ $af171f1136c0783f$var$_inBounds = /*#__PURE__*/ new WeakSet(), /** Validate gesture has the highest z-index in this triggered group. */ $af171f1136c0783f$var$_isTopLayer = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_performAction = /*#__PURE__*/ new WeakSet();
class $af171f1136c0783f$export$61ce360501d38a6f extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_media10, (0, $6KfMo.useMediaContext)());
        const { event: event, action: action } = this.$props;
        this.setAttributes({
            event: event,
            action: action
        });
    }
    onAttach(el) {
        el.setAttribute("data-media-gesture", "");
        el.style.setProperty("pointer-events", "none");
    }
    onConnect(el) {
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_provider, (0, $57dmi._)(this, $af171f1136c0783f$var$_media10).player.el?.querySelector("[data-media-provider]"));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_attachListener, $af171f1136c0783f$var$attachListener).bind(this));
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_attachListener);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_acceptEvent);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_handleEvent);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_inBounds);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_isTopLayer);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_performAction);
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_media10, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_provider, {
            writable: true,
            value: null
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_presses, {
            writable: true,
            value: 0
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_pressTimerId, {
            writable: true,
            value: -1
        });
    }
}
(0, $97zcJ._)($af171f1136c0783f$export$61ce360501d38a6f, "props", {
    disabled: false,
    event: void 0,
    action: void 0
});
function $af171f1136c0783f$var$attachListener() {
    let eventType = this.$props.event(), disabled = this.$props.disabled();
    if (!(0, $57dmi._)(this, $af171f1136c0783f$var$_provider) || !eventType || disabled) return;
    if (/^dbl/.test(eventType)) eventType = eventType.split(/^dbl/)[1];
    if (eventType === "pointerup" || eventType === "pointerdown") {
        const pointer = (0, $57dmi._)(this, $af171f1136c0783f$var$_media10).$state.pointer();
        if (pointer === "coarse") eventType = eventType === "pointerup" ? "touchend" : "touchstart";
    }
    (0, $8B3mG.listenEvent)((0, $57dmi._)(this, $af171f1136c0783f$var$_provider), eventType, (0, $2u9SC._)(this, $af171f1136c0783f$var$_acceptEvent, $af171f1136c0783f$var$acceptEvent).bind(this), {
        passive: false
    });
}
function $af171f1136c0783f$var$acceptEvent(event) {
    if (this.$props.disabled() || (0, $8B3mG.isPointerEvent)(event) && (event.button !== 0 || (0, $57dmi._)(this, $af171f1136c0783f$var$_media10).activeMenu) || (0, $8B3mG.isTouchEvent)(event) && (0, $57dmi._)(this, $af171f1136c0783f$var$_media10).activeMenu || (0, $ciZW6.isTouchPinchEvent)(event) || !(0, $2u9SC._)(this, $af171f1136c0783f$var$_inBounds, $af171f1136c0783f$var$inBounds).call(this, event)) return;
    event.MEDIA_GESTURE = true;
    event.preventDefault();
    const eventType = (0, $8B3mG.peek)(this.$props.event), isDblEvent = eventType?.startsWith("dbl");
    if (!isDblEvent) {
        if ((0, $57dmi._)(this, $af171f1136c0783f$var$_presses) === 0) setTimeout(()=>{
            if ((0, $57dmi._)(this, $af171f1136c0783f$var$_presses) === 1) (0, $2u9SC._)(this, $af171f1136c0783f$var$_handleEvent, $af171f1136c0783f$var$handleEvent).call(this, event);
        }, 250);
    } else if ((0, $57dmi._)(this, $af171f1136c0783f$var$_presses) === 1) {
        queueMicrotask(()=>(0, $2u9SC._)(this, $af171f1136c0783f$var$_handleEvent, $af171f1136c0783f$var$handleEvent).call(this, event));
        clearTimeout((0, $57dmi._)(this, $af171f1136c0783f$var$_pressTimerId));
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_presses, 0);
        return;
    }
    if ((0, $57dmi._)(this, $af171f1136c0783f$var$_presses) === 0) (0, $4vwVC._)(this, $af171f1136c0783f$var$_pressTimerId, window.setTimeout(()=>{
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_presses, 0);
    }, 275));
    (0, $5pK9s._)(this, $af171f1136c0783f$var$_presses).value++;
}
function $af171f1136c0783f$var$handleEvent(event) {
    this.el.setAttribute("data-triggered", "");
    requestAnimationFrame(()=>{
        if ((0, $2u9SC._)(this, $af171f1136c0783f$var$_isTopLayer, $af171f1136c0783f$var$isTopLayer).call(this)) (0, $2u9SC._)(this, $af171f1136c0783f$var$_performAction, $af171f1136c0783f$var$performAction).call(this, (0, $8B3mG.peek)(this.$props.action), event);
        requestAnimationFrame(()=>{
            this.el.removeAttribute("data-triggered");
        });
    });
}
function $af171f1136c0783f$var$inBounds(event) {
    if (!this.el) return false;
    if ((0, $8B3mG.isPointerEvent)(event) || (0, $8B3mG.isMouseEvent)(event) || (0, $8B3mG.isTouchEvent)(event)) {
        const touch = (0, $8B3mG.isTouchEvent)(event) ? event.changedTouches[0] ?? event.touches[0] : void 0;
        const clientX = touch?.clientX ?? event.clientX;
        const clientY = touch?.clientY ?? event.clientY;
        const rect = this.el.getBoundingClientRect();
        const inBounds = clientY >= rect.top && clientY <= rect.bottom && clientX >= rect.left && clientX <= rect.right;
        return event.type.includes("leave") ? !inBounds : inBounds;
    }
    return true;
}
function $af171f1136c0783f$var$isTopLayer() {
    const gestures = (0, $57dmi._)(this, $af171f1136c0783f$var$_media10).player.el.querySelectorAll("[data-media-gesture][data-triggered]");
    return Array.from(gestures).sort((a, b)=>+getComputedStyle(b).zIndex - +getComputedStyle(a).zIndex)[0] === this.el;
}
function $af171f1136c0783f$var$performAction(action, trigger) {
    if (!action) return;
    const willTriggerEvent = new (0, $8B3mG.DOMEvent)("will-trigger", {
        detail: action,
        cancelable: true,
        trigger: trigger
    });
    this.dispatchEvent(willTriggerEvent);
    if (willTriggerEvent.defaultPrevented) return;
    const [method, value] = action.replace(/:([a-z])/, "-$1").split(":");
    if (action.includes(":fullscreen")) (0, $57dmi._)(this, $af171f1136c0783f$var$_media10).remote.toggleFullscreen("prefer-media", trigger);
    else if (action.includes("seek:")) (0, $57dmi._)(this, $af171f1136c0783f$var$_media10).remote.seek((0, $8B3mG.peek)((0, $57dmi._)(this, $af171f1136c0783f$var$_media10).$state.currentTime) + (+value || 0), trigger);
    else (0, $57dmi._)(this, $af171f1136c0783f$var$_media10).remote[(0, $8B3mG.kebabToCamelCase)(method)](trigger);
    this.dispatch("trigger", {
        detail: action,
        trigger: trigger
    });
}
var $af171f1136c0783f$var$_track1 = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_renderer = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_events = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_changeTrack = /*#__PURE__*/ new WeakSet();
class $af171f1136c0783f$var$CaptionsTextRenderer {
    attach() {}
    canRender() {
        return true;
    }
    detach() {
        (0, $57dmi._)(this, $af171f1136c0783f$var$_events)?.abort();
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_events, void 0);
        (0, $57dmi._)(this, $af171f1136c0783f$var$_renderer).reset();
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_track1, null);
    }
    changeTrack(track) {
        if (!track || (0, $57dmi._)(this, $af171f1136c0783f$var$_track1) === track) return;
        (0, $57dmi._)(this, $af171f1136c0783f$var$_events)?.abort();
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_events, new (0, $8B3mG.EventsController)(track));
        if (track.readyState < 2) {
            (0, $57dmi._)(this, $af171f1136c0783f$var$_renderer).reset();
            (0, $57dmi._)(this, $af171f1136c0783f$var$_events).add("load", ()=>(0, $2u9SC._)(this, $af171f1136c0783f$var$_changeTrack, $af171f1136c0783f$var$changeTrack).call(this, track), {
                once: true
            });
        } else (0, $2u9SC._)(this, $af171f1136c0783f$var$_changeTrack, $af171f1136c0783f$var$changeTrack).call(this, track);
        (0, $57dmi._)(this, $af171f1136c0783f$var$_events).add("add-cue", (event)=>{
            (0, $57dmi._)(this, $af171f1136c0783f$var$_renderer).addCue(event.detail);
        }).add("remove-cue", (event)=>{
            (0, $57dmi._)(this, $af171f1136c0783f$var$_renderer).removeCue(event.detail);
        });
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_track1, track);
    }
    constructor(renderer){
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_changeTrack);
        (0, $97zcJ._)(this, "priority", 10);
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_track1, {
            writable: true,
            value: null
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_renderer, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_events, {
            writable: true,
            value: void 0
        });
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_renderer, renderer);
    }
}
function $af171f1136c0783f$var$changeTrack(track) {
    (0, $57dmi._)(this, $af171f1136c0783f$var$_renderer).changeTrack({
        cues: [
            ...track.cues
        ],
        regions: [
            ...track.regions
        ]
    });
}
var $af171f1136c0783f$var$_media11 = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_isHidden = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchViewType = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_setupAudioView = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_onTrackChange1 = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_onCueChange = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_onUpdateTimedNodes = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_setupVideoView = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchTextDirection = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_watchMediaTime = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_listenToFontStyleChanges = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_onFontStyleChange = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_showExample = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_hideExampleTimer = /*#__PURE__*/ new WeakMap(), $af171f1136c0783f$var$_hideExample = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_removeExample = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_createCueDisplayElement = /*#__PURE__*/ new WeakSet(), $af171f1136c0783f$var$_createCueElement = /*#__PURE__*/ new WeakSet();

class $af171f1136c0783f$export$700b041b251b6ffe extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $4vwVC._)(this, $af171f1136c0783f$var$_media11, (0, $6KfMo.useMediaContext)());
        this.setAttributes({
            "aria-hidden": (0, $jrniq.$ariaBool)((0, $2u9SC._)(this, $af171f1136c0783f$var$_isHidden, $af171f1136c0783f$var$isHidden).bind(this))
        });
    }
    onAttach(el) {
        el.style.setProperty("pointer-events", "none");
    }
    onConnect(el) {
        if (!$af171f1136c0783f$export$700b041b251b6ffe.lib()) (parcelRequire("8fTk5")).then((lib)=>$af171f1136c0783f$export$700b041b251b6ffe.lib.set(lib));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchViewType, $af171f1136c0783f$var$watchViewType).bind(this));
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_isHidden);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchViewType);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_setupAudioView);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onTrackChange1);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onCueChange);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onUpdateTimedNodes);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_setupVideoView);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchTextDirection);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_watchMediaTime);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_listenToFontStyleChanges);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_onFontStyleChange);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_showExample);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_hideExample);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_removeExample);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_createCueDisplayElement);
        (0, $9P4tJ._)(this, $af171f1136c0783f$var$_createCueElement);
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_media11, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $af171f1136c0783f$var$_hideExampleTimer, {
            writable: true,
            value: -1
        });
    }
}
(0, $97zcJ._)($af171f1136c0783f$export$700b041b251b6ffe, "props", {
    textDir: "ltr",
    exampleText: "Captions look like this."
});
(0, $97zcJ._)($af171f1136c0783f$export$700b041b251b6ffe, "lib", (0, $8B3mG.signal)(null));
function $af171f1136c0783f$var$isHidden() {
    const { textTrack: textTrack, remotePlaybackState: remotePlaybackState, iOSControls: iOSControls } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media11).$state, track = textTrack();
    return iOSControls() || remotePlaybackState() === "connected" || !track || !(0, $ihjXw.isTrackCaptionKind)(track);
}
function $af171f1136c0783f$var$watchViewType() {
    if (!$af171f1136c0783f$export$700b041b251b6ffe.lib()) return;
    const { viewType: viewType } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media11).$state;
    if (viewType() === "audio") return (0, $2u9SC._)(this, $af171f1136c0783f$var$_setupAudioView, $af171f1136c0783f$var$setupAudioView).call(this);
    else return (0, $2u9SC._)(this, $af171f1136c0783f$var$_setupVideoView, $af171f1136c0783f$var$setupVideoView).call(this);
}
function $af171f1136c0783f$var$setupAudioView() {
    (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_onTrackChange1, $af171f1136c0783f$var$onTrackChange1).bind(this));
    (0, $2u9SC._)(this, $af171f1136c0783f$var$_listenToFontStyleChanges, $af171f1136c0783f$var$listenToFontStyleChanges).call(this, null);
    return ()=>{
        this.el.textContent = "";
    };
}
function $af171f1136c0783f$var$onTrackChange1() {
    if ((0, $2u9SC._)(this, $af171f1136c0783f$var$_isHidden, $af171f1136c0783f$var$isHidden).call(this)) return;
    (0, $2u9SC._)(this, $af171f1136c0783f$var$_onCueChange, $af171f1136c0783f$var$onCueChange).call(this);
    const { textTrack: textTrack } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media11).$state;
    (0, $8B3mG.listenEvent)(textTrack(), "cue-change", (0, $2u9SC._)(this, $af171f1136c0783f$var$_onCueChange, $af171f1136c0783f$var$onCueChange).bind(this));
    (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_onUpdateTimedNodes, $af171f1136c0783f$var$onUpdateTimedNodes).bind(this));
}
function $af171f1136c0783f$var$onCueChange() {
    this.el.textContent = "";
    if ((0, $57dmi._)(this, $af171f1136c0783f$var$_hideExampleTimer) >= 0) (0, $2u9SC._)(this, $af171f1136c0783f$var$_removeExample, $af171f1136c0783f$var$removeExample).call(this);
    const { realCurrentTime: realCurrentTime, textTrack: textTrack } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media11).$state, { renderVTTCueString: renderVTTCueString } = $af171f1136c0783f$export$700b041b251b6ffe.lib(), time = (0, $8B3mG.peek)(realCurrentTime), activeCues = (0, $8B3mG.peek)(textTrack).activeCues;
    for (const cue of activeCues){
        const displayEl = (0, $2u9SC._)(this, $af171f1136c0783f$var$_createCueDisplayElement, $af171f1136c0783f$var$createCueDisplayElement).call(this), cueEl = (0, $2u9SC._)(this, $af171f1136c0783f$var$_createCueElement, $af171f1136c0783f$var$createCueElement).call(this);
        cueEl.innerHTML = renderVTTCueString(cue, time);
        displayEl.append(cueEl);
        this.el.append(cueEl);
    }
}
function $af171f1136c0783f$var$onUpdateTimedNodes() {
    const { realCurrentTime: realCurrentTime } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media11).$state, { updateTimedVTTCueNodes: updateTimedVTTCueNodes } = $af171f1136c0783f$export$700b041b251b6ffe.lib();
    updateTimedVTTCueNodes(this.el, realCurrentTime());
}
function $af171f1136c0783f$var$setupVideoView() {
    const { CaptionsRenderer: CaptionsRenderer } = $af171f1136c0783f$export$700b041b251b6ffe.lib(), renderer = new CaptionsRenderer(this.el), textRenderer = new $af171f1136c0783f$var$CaptionsTextRenderer(renderer);
    (0, $57dmi._)(this, $af171f1136c0783f$var$_media11).textRenderers.add(textRenderer);
    (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchTextDirection, $af171f1136c0783f$var$watchTextDirection).bind(this, renderer));
    (0, $8B3mG.effect)((0, $2u9SC._)(this, $af171f1136c0783f$var$_watchMediaTime, $af171f1136c0783f$var$watchMediaTime).bind(this, renderer));
    (0, $2u9SC._)(this, $af171f1136c0783f$var$_listenToFontStyleChanges, $af171f1136c0783f$var$listenToFontStyleChanges).call(this, renderer);
    return ()=>{
        this.el.textContent = "";
        (0, $57dmi._)(this, $af171f1136c0783f$var$_media11).textRenderers.remove(textRenderer);
        renderer.destroy();
    };
}
function $af171f1136c0783f$var$watchTextDirection(renderer) {
    renderer.dir = this.$props.textDir();
}
function $af171f1136c0783f$var$watchMediaTime(renderer) {
    if ((0, $2u9SC._)(this, $af171f1136c0783f$var$_isHidden, $af171f1136c0783f$var$isHidden).call(this)) return;
    const { realCurrentTime: realCurrentTime, textTrack: textTrack } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media11).$state;
    renderer.currentTime = realCurrentTime();
    if ((0, $57dmi._)(this, $af171f1136c0783f$var$_hideExampleTimer) >= 0 && textTrack()?.activeCues[0]) (0, $2u9SC._)(this, $af171f1136c0783f$var$_removeExample, $af171f1136c0783f$var$removeExample).call(this);
}
function $af171f1136c0783f$var$listenToFontStyleChanges(renderer) {
    const player = (0, $57dmi._)(this, $af171f1136c0783f$var$_media11).player;
    if (!player) return;
    const onChange = (0, $2u9SC._)(this, $af171f1136c0783f$var$_onFontStyleChange, $af171f1136c0783f$var$onFontStyleChange).bind(this, renderer);
    (0, $8B3mG.listenEvent)(player, "vds-font-change", onChange);
}
function $af171f1136c0783f$var$onFontStyleChange(renderer) {
    if ((0, $57dmi._)(this, $af171f1136c0783f$var$_hideExampleTimer) >= 0) {
        (0, $2u9SC._)(this, $af171f1136c0783f$var$_hideExample, $af171f1136c0783f$var$hideExample).call(this);
        return;
    }
    const { textTrack: textTrack } = (0, $57dmi._)(this, $af171f1136c0783f$var$_media11).$state;
    if (!textTrack()?.activeCues[0]) (0, $2u9SC._)(this, $af171f1136c0783f$var$_showExample, $af171f1136c0783f$var$showExample).call(this);
    else renderer?.update(true);
}
function $af171f1136c0783f$var$showExample() {
    const display = (0, $2u9SC._)(this, $af171f1136c0783f$var$_createCueDisplayElement, $af171f1136c0783f$var$createCueDisplayElement).call(this);
    (0, $8B3mG.setAttribute)(display, "data-example", "");
    const cue = (0, $2u9SC._)(this, $af171f1136c0783f$var$_createCueElement, $af171f1136c0783f$var$createCueElement).call(this);
    (0, $8B3mG.setAttribute)(cue, "data-example", "");
    cue.textContent = this.$props.exampleText();
    display?.append(cue);
    this.el?.append(display);
    this.el?.setAttribute("data-example", "");
    (0, $2u9SC._)(this, $af171f1136c0783f$var$_hideExample, $af171f1136c0783f$var$hideExample).call(this);
}
function $af171f1136c0783f$var$hideExample() {
    window.clearTimeout((0, $57dmi._)(this, $af171f1136c0783f$var$_hideExampleTimer));
    (0, $4vwVC._)(this, $af171f1136c0783f$var$_hideExampleTimer, window.setTimeout((0, $2u9SC._)(this, $af171f1136c0783f$var$_removeExample, $af171f1136c0783f$var$removeExample).bind(this), 2500));
}
function $af171f1136c0783f$var$removeExample() {
    this.el?.removeAttribute("data-example");
    if (this.el?.querySelector("[data-example]")) this.el.textContent = "";
    (0, $4vwVC._)(this, $af171f1136c0783f$var$_hideExampleTimer, -1);
}
function $af171f1136c0783f$var$createCueDisplayElement() {
    const el = document.createElement("div");
    (0, $8B3mG.setAttribute)(el, "data-part", "cue-display");
    return el;
}
function $af171f1136c0783f$var$createCueElement() {
    const el = document.createElement("div");
    (0, $8B3mG.setAttribute)(el, "data-part", "cue");
    return el;
}

});
parcelRegister("5pK9s", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3f131648d7c15f3d$export$71511d61b312f219; });

var $5veKv = parcelRequire("5veKv");

var $3Z9LC = parcelRequire("3Z9LC");
function $3f131648d7c15f3d$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $3Z9LC._)(receiver, privateMap, "update");
    return (0, $5veKv._)(receiver, descriptor);
}

});
parcelRegister("5veKv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $401b49d7df529bb0$export$71511d61b312f219; });
function $401b49d7df529bb0$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.set) {
        if (!descriptor.get) throw new TypeError("attempted to read set only private field");
        if (!("__destrWrapper" in descriptor)) descriptor.__destrWrapper = {
            set value (v){
                descriptor.set.call(receiver, v);
            },
            get value () {
                return descriptor.get.call(receiver);
            }
        };
        return descriptor.__destrWrapper;
    } else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        return descriptor;
    }
}

});


parcelRegister("g6paF", function(module, exports) {

$parcel$export(module.exports, "formatTime", function () { return $bb90bb562fcb86a3$export$3203edd9e5edd663; });
$parcel$export(module.exports, "formatSpokenTime", function () { return $bb90bb562fcb86a3$export$378179385e8b7aa2; });
$parcel$export(module.exports, "Popper", function () { return $bb90bb562fcb86a3$export$badac9ada3a0bdf9; });
$parcel$export(module.exports, "ToggleButtonController", function () { return $bb90bb562fcb86a3$export$2fdb964152b42c79; });
$parcel$export(module.exports, "AirPlayButton", function () { return $bb90bb562fcb86a3$export$55ff439f381ad7b5; });
$parcel$export(module.exports, "PlayButton", function () { return $bb90bb562fcb86a3$export$fbed5f62d839a0cd; });
$parcel$export(module.exports, "CaptionButton", function () { return $bb90bb562fcb86a3$export$3e4982ba83f4a5c6; });
$parcel$export(module.exports, "FullscreenButton", function () { return $bb90bb562fcb86a3$export$305be705ce696d42; });
$parcel$export(module.exports, "MuteButton", function () { return $bb90bb562fcb86a3$export$7ee6365f549a934a; });
$parcel$export(module.exports, "PIPButton", function () { return $bb90bb562fcb86a3$export$b826ad0d3c504704; });
$parcel$export(module.exports, "SeekButton", function () { return $bb90bb562fcb86a3$export$d947da0a2595cd47; });
$parcel$export(module.exports, "LiveButton", function () { return $bb90bb562fcb86a3$export$a35d1ec6b27677d2; });
$parcel$export(module.exports, "sliderState", function () { return $bb90bb562fcb86a3$export$467e17e18ed84bff; });
$parcel$export(module.exports, "sliderValueFormatContext", function () { return $bb90bb562fcb86a3$export$55d0aa125ccf93d2; });
$parcel$export(module.exports, "SliderController", function () { return $bb90bb562fcb86a3$export$b4f48791b51b8570; });
$parcel$export(module.exports, "Slider", function () { return $bb90bb562fcb86a3$export$472062a354075cee; });
$parcel$export(module.exports, "Thumbnail", function () { return $bb90bb562fcb86a3$export$1cd1efc78cb52ca5; });
$parcel$export(module.exports, "SliderValue", function () { return $bb90bb562fcb86a3$export$848e329471fb286b; });
$parcel$export(module.exports, "SliderPreview", function () { return $bb90bb562fcb86a3$export$1d818f3e85fd500a; });
$parcel$export(module.exports, "VolumeSlider", function () { return $bb90bb562fcb86a3$export$87e3e233220841f8; });
$parcel$export(module.exports, "TimeSlider", function () { return $bb90bb562fcb86a3$export$e296a477a1bc715a; });
$parcel$export(module.exports, "menuContext", function () { return $bb90bb562fcb86a3$export$eb1e9ed85beee4a5; });
$parcel$export(module.exports, "Menu", function () { return $bb90bb562fcb86a3$export$d9b273488cd8ce6f; });
$parcel$export(module.exports, "MenuButton", function () { return $bb90bb562fcb86a3$export$266a769812832828; });
$parcel$export(module.exports, "MenuItem", function () { return $bb90bb562fcb86a3$export$2ce376c2cc3355c8; });
$parcel$export(module.exports, "MenuPortal", function () { return $bb90bb562fcb86a3$export$793392f970497feb; });
$parcel$export(module.exports, "MenuItems", function () { return $bb90bb562fcb86a3$export$15a41fea157b048a; });
$parcel$export(module.exports, "radioControllerContext", function () { return $bb90bb562fcb86a3$export$29450a5971d94a40; });
$parcel$export(module.exports, "RadioGroupController", function () { return $bb90bb562fcb86a3$export$b6c81938ab9ab49c; });
$parcel$export(module.exports, "AudioRadioGroup", function () { return $bb90bb562fcb86a3$export$ff8295f298e1a1e; });
$parcel$export(module.exports, "CaptionsRadioGroup", function () { return $bb90bb562fcb86a3$export$47dbee46003f5b8d; });
$parcel$export(module.exports, "SpeedRadioGroup", function () { return $bb90bb562fcb86a3$export$a35c36feac690f18; });
$parcel$export(module.exports, "QualityRadioGroup", function () { return $bb90bb562fcb86a3$export$d91da3a1ef0bdb9e; });
$parcel$export(module.exports, "Time", function () { return $bb90bb562fcb86a3$export$680ea196effce5f; });

var $57dmi = parcelRequire("57dmi");

var $fhH8k = parcelRequire("fhH8k");

var $4vwVC = parcelRequire("4vwVC");

var $2u9SC = parcelRequire("2u9SC");

var $9P4tJ = parcelRequire("9P4tJ");

var $97zcJ = parcelRequire("97zcJ");

var $8B3mG = parcelRequire("8B3mG");

var $6KfMo = parcelRequire("6KfMo");

var $jrniq = parcelRequire("jrniq");

var $ciZW6 = parcelRequire("ciZW6");

var $ihjXw = parcelRequire("ihjXw");

var $jWjYZ = parcelRequire("jWjYZ");

var $9KZm0 = parcelRequire("9KZm0");

var $dLb9W = parcelRequire("dLb9W");

var $hzYuC = parcelRequire("hzYuC");

var $l6thX = parcelRequire("l6thX");
var $bb90bb562fcb86a3$var$_shortcut = /*#__PURE__*/ new WeakMap();
class $bb90bb562fcb86a3$export$f114b940d45184e extends (0, $8B3mG.ViewController) {
    onAttach(el) {
        const { $props: $props, ariaKeys: ariaKeys } = (0, $6KfMo.useMediaContext)(), keys = el.getAttribute("aria-keyshortcuts");
        if (keys) {
            ariaKeys[(0, $57dmi._)(this, $bb90bb562fcb86a3$var$_shortcut)] = keys;
            (0, $8B3mG.onDispose)(()=>{
                delete ariaKeys[(0, $57dmi._)(this, $bb90bb562fcb86a3$var$_shortcut)];
            });
            return;
        }
        const shortcuts = $props.keyShortcuts()[(0, $57dmi._)(this, $bb90bb562fcb86a3$var$_shortcut)];
        if (shortcuts) {
            const keys2 = (0, $8B3mG.isArray)(shortcuts) ? shortcuts.join(" ") : (0, $8B3mG.isString)(shortcuts) ? shortcuts : shortcuts?.keys;
            el.setAttribute("aria-keyshortcuts", (0, $8B3mG.isArray)(keys2) ? keys2.join(" ") : keys2);
        }
    }
    constructor(shortcut){
        super();
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_shortcut, {
            writable: true,
            value: void 0
        });
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_shortcut, shortcut);
    }
}
function $bb90bb562fcb86a3$var$padNumberWithZeroes(num, expectedLength) {
    const str = String(num);
    const actualLength = str.length;
    const shouldPad = actualLength < expectedLength;
    if (shouldPad) {
        const padLength = expectedLength - actualLength;
        const padding = `0`.repeat(padLength);
        return `${padding}${num}`;
    }
    return str;
}
function $bb90bb562fcb86a3$var$parseTime(duration) {
    const hours = Math.trunc(duration / 3600);
    const minutes = Math.trunc(duration % 3600 / 60);
    const seconds = Math.trunc(duration % 60);
    const fraction = Number((duration - Math.trunc(duration)).toPrecision(3));
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        fraction: fraction
    };
}
function $bb90bb562fcb86a3$export$3203edd9e5edd663(duration, { padHrs: padHrs = null, padMins: padMins = null, showHrs: showHrs = false, showMs: showMs = false } = {}) {
    const { hours: hours, minutes: minutes, seconds: seconds, fraction: fraction } = $bb90bb562fcb86a3$var$parseTime(duration), paddedHours = padHrs ? $bb90bb562fcb86a3$var$padNumberWithZeroes(hours, 2) : hours, paddedMinutes = padMins || (0, $8B3mG.isNull)(padMins) && duration >= 3600 ? $bb90bb562fcb86a3$var$padNumberWithZeroes(minutes, 2) : minutes, paddedSeconds = $bb90bb562fcb86a3$var$padNumberWithZeroes(seconds, 2), paddedMs = showMs && fraction > 0 ? `.${String(fraction).replace(/^0?\./, "")}` : "", time = `${paddedMinutes}:${paddedSeconds}${paddedMs}`;
    return hours > 0 || showHrs ? `${paddedHours}:${time}` : time;
}
function $bb90bb562fcb86a3$export$378179385e8b7aa2(duration) {
    const spokenParts = [];
    const { hours: hours, minutes: minutes, seconds: seconds } = $bb90bb562fcb86a3$var$parseTime(duration);
    if (hours > 0) spokenParts.push(`${hours} hour`);
    if (minutes > 0) spokenParts.push(`${minutes} min`);
    if (seconds > 0 || spokenParts.length === 0) spokenParts.push(`${seconds} sec`);
    return spokenParts.join(" ");
}
var $bb90bb562fcb86a3$var$_delegate = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_watchTrigger = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_showTimerId = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_hideRafId = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_stopAnimationEndListener = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_cancelShowing = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$export$badac9ada3a0bdf9 extends (0, $8B3mG.ViewController) {
    onDestroy() {
        var _this, _this1, _ref;
        (_this = (0, $57dmi._)(_ref = _this1 = this, $bb90bb562fcb86a3$var$_stopAnimationEndListener)) === null || _this === void 0 ? void 0 : _this.call(_this1);
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_stopAnimationEndListener, null);
    }
    show(trigger) {
        var _this, _this1, _ref;
        (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_cancelShowing, $bb90bb562fcb86a3$var$cancelShowing).call(this);
        window.cancelAnimationFrame((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_hideRafId));
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_hideRafId, -1);
        (_this = (0, $57dmi._)(_ref = _this1 = this, $bb90bb562fcb86a3$var$_stopAnimationEndListener)) === null || _this === void 0 ? void 0 : _this.call(_this1);
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_stopAnimationEndListener, null);
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_showTimerId, window.setTimeout(()=>{
            (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_showTimerId, -1);
            const content = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate).content();
            if (content) content.style.removeProperty("display");
            (0, $8B3mG.peek)(()=>(0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate).onChange(true, trigger));
        }, (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate).showDelay?.() ?? 0));
    }
    hide(trigger) {
        var _this, _this1, _ref;
        (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_cancelShowing, $bb90bb562fcb86a3$var$cancelShowing).call(this);
        (0, $8B3mG.peek)(()=>(0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate).onChange(false, trigger));
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_hideRafId, requestAnimationFrame(()=>{
            (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_cancelShowing, $bb90bb562fcb86a3$var$cancelShowing).call(this);
            (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_hideRafId, -1);
            const content = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate).content();
            if (content) {
                const onHide = ()=>{
                    content.style.display = "none";
                    (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_stopAnimationEndListener, null);
                };
                const isAnimated = (0, $ciZW6.hasAnimation)(content);
                if (isAnimated) {
                    (_this = (0, $57dmi._)(_ref = _this1 = this, $bb90bb562fcb86a3$var$_stopAnimationEndListener)) === null || _this === void 0 ? void 0 : _this.call(_this1);
                    const stop = (0, $8B3mG.listenEvent)(content, "animationend", onHide, {
                        once: true
                    });
                    (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_stopAnimationEndListener, stop);
                } else onHide();
            }
        }));
    }
    constructor(delegate){
        super();
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchTrigger);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_cancelShowing);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_delegate, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_showTimerId, {
            writable: true,
            value: -1
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_hideRafId, {
            writable: true,
            value: -1
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_stopAnimationEndListener, {
            writable: true,
            value: null
        });
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_delegate, delegate);
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchTrigger, $bb90bb562fcb86a3$var$watchTrigger).bind(this));
    }
}
function $bb90bb562fcb86a3$var$watchTrigger() {
    const trigger = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate).trigger();
    if (!trigger) {
        this.hide();
        return;
    }
    const show = this.show.bind(this), hide = this.hide.bind(this);
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate).listen(trigger, show, hide);
}
function $bb90bb562fcb86a3$var$cancelShowing() {
    window.clearTimeout((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_showTimerId));
    (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_showTimerId, -1);
}
var $bb90bb562fcb86a3$var$_delegate1 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_isARIAPressed = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onPressed = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onMaybePress = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onInteraction = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$export$2fdb964152b42c79 extends (0, $8B3mG.ViewController) {
    onSetup() {
        const { disabled: disabled } = this.$props;
        this.setAttributes({
            "data-pressed": (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate1).isPresssed,
            "aria-pressed": (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isARIAPressed, $bb90bb562fcb86a3$var$isARIAPressed).bind(this),
            "aria-disabled": ()=>disabled() ? "true" : null
        });
    }
    onAttach(el) {
        (0, $ciZW6.setAttributeIfEmpty)(el, "tabindex", "0");
        (0, $ciZW6.setAttributeIfEmpty)(el, "role", "button");
        (0, $ciZW6.setAttributeIfEmpty)(el, "type", "button");
    }
    onConnect(el) {
        const events = (0, $ciZW6.onPress)(el, (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onMaybePress, $bb90bb562fcb86a3$var$onMaybePress).bind(this));
        for (const type of [
            "click",
            "touchstart"
        ])events.add(type, (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onInteraction, $bb90bb562fcb86a3$var$onInteraction).bind(this), {
            passive: true
        });
    }
    constructor(delegate){
        super();
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_isARIAPressed);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onPressed);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onMaybePress);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onInteraction);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_delegate1, {
            writable: true,
            value: void 0
        });
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_delegate1, delegate);
        new (0, $jWjYZ.FocusVisibleController)();
        if (delegate.keyShortcut) new $bb90bb562fcb86a3$export$f114b940d45184e(delegate.keyShortcut);
    }
}
(0, $97zcJ._)($bb90bb562fcb86a3$export$2fdb964152b42c79, "props", {
    disabled: false
});
function $bb90bb562fcb86a3$var$isARIAPressed() {
    return (0, $8B3mG.ariaBool)((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate1).isPresssed());
}
function $bb90bb562fcb86a3$var$onPressed(event) {
    if ((0, $8B3mG.isWriteSignal)((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate1).isPresssed)) (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate1).isPresssed.set((p)=>!p);
}
function $bb90bb562fcb86a3$var$onMaybePress(event) {
    const disabled = this.$props.disabled() || this.el.hasAttribute("data-disabled");
    if (disabled) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
    }
    event.preventDefault();
    ((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate1).onPress ?? (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onPressed, $bb90bb562fcb86a3$var$onPressed)).call(this, event);
}
function $bb90bb562fcb86a3$var$onInteraction(event) {
    if (this.$props.disabled()) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }
}
var $bb90bb562fcb86a3$var$_media = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_onPress = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_isPressed = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_getState = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_getDefaultLabel = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$export$55ff439f381ad7b5 extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_media, (0, $6KfMo.useMediaContext)());
        const { canAirPlay: canAirPlay, isAirPlayConnected: isAirPlayConnected } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media).$state;
        this.setAttributes({
            "data-active": isAirPlayConnected,
            "data-supported": canAirPlay,
            "data-state": (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getState, $bb90bb562fcb86a3$var$getState).bind(this),
            "aria-hidden": (0, $jrniq.$ariaBool)(()=>!canAirPlay())
        });
    }
    onAttach(el) {
        el.setAttribute("data-media-tooltip", "airplay");
        (0, $ciZW6.setARIALabel)(el, (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getDefaultLabel, $bb90bb562fcb86a3$var$getDefaultLabel).bind(this));
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onPress);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_isPressed);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getState);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getDefaultLabel);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_media, {
            writable: true,
            value: void 0
        });
        new $bb90bb562fcb86a3$export$2fdb964152b42c79({
            isPresssed: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isPressed, $bb90bb562fcb86a3$var$isPressed).bind(this),
            onPress: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onPress, $bb90bb562fcb86a3$var$onPress1).bind(this)
        });
    }
}
(0, $97zcJ._)($bb90bb562fcb86a3$export$55ff439f381ad7b5, "props", $bb90bb562fcb86a3$export$2fdb964152b42c79.props);
function $bb90bb562fcb86a3$var$onPress1(event) {
    const remote = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media).remote;
    remote.requestAirPlay(event);
}
function $bb90bb562fcb86a3$var$isPressed() {
    const { remotePlaybackType: remotePlaybackType, remotePlaybackState: remotePlaybackState } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media).$state;
    return remotePlaybackType() === "airplay" && remotePlaybackState() !== "disconnected";
}
function $bb90bb562fcb86a3$var$getState() {
    const { remotePlaybackType: remotePlaybackType, remotePlaybackState: remotePlaybackState } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media).$state;
    return remotePlaybackType() === "airplay" && remotePlaybackState();
}
function $bb90bb562fcb86a3$var$getDefaultLabel() {
    const { remotePlaybackState: remotePlaybackState } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media).$state;
    return `AirPlay ${remotePlaybackState()}`;
}
var $bb90bb562fcb86a3$var$_media1 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_onPress1 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_isPressed1 = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$export$fbed5f62d839a0cd extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_media1, (0, $6KfMo.useMediaContext)());
        const { paused: paused, ended: ended } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media1).$state;
        this.setAttributes({
            "data-paused": paused,
            "data-ended": ended
        });
    }
    onAttach(el) {
        el.setAttribute("data-media-tooltip", "play");
        (0, $ciZW6.setARIALabel)(el, "Play");
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onPress1);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_isPressed1);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_media1, {
            writable: true,
            value: void 0
        });
        new $bb90bb562fcb86a3$export$2fdb964152b42c79({
            isPresssed: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isPressed1, $bb90bb562fcb86a3$var$isPressed1).bind(this),
            keyShortcut: "togglePaused",
            onPress: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onPress1, $bb90bb562fcb86a3$var$onPress2).bind(this)
        });
    }
}
(0, $97zcJ._)($bb90bb562fcb86a3$export$fbed5f62d839a0cd, "props", $bb90bb562fcb86a3$export$2fdb964152b42c79.props);
function $bb90bb562fcb86a3$var$onPress2(event) {
    const remote = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media1).remote;
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isPressed1, $bb90bb562fcb86a3$var$isPressed1).call(this) ? remote.pause(event) : remote.play(event);
}
function $bb90bb562fcb86a3$var$isPressed1() {
    const { paused: paused } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media1).$state;
    return !paused();
}
var $bb90bb562fcb86a3$var$_media2 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_onPress2 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_isPressed2 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_isHidden = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$export$3e4982ba83f4a5c6 extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_media2, (0, $6KfMo.useMediaContext)());
        this.setAttributes({
            "data-active": (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isPressed2, $bb90bb562fcb86a3$var$isPressed2).bind(this),
            "data-supported": ()=>!(0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isHidden, $bb90bb562fcb86a3$var$isHidden).call(this),
            "aria-hidden": (0, $jrniq.$ariaBool)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isHidden, $bb90bb562fcb86a3$var$isHidden).bind(this))
        });
    }
    onAttach(el) {
        el.setAttribute("data-media-tooltip", "caption");
        (0, $ciZW6.setARIALabel)(el, "Captions");
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onPress2);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_isPressed2);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_isHidden);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_media2, {
            writable: true,
            value: void 0
        });
        new $bb90bb562fcb86a3$export$2fdb964152b42c79({
            isPresssed: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isPressed2, $bb90bb562fcb86a3$var$isPressed2).bind(this),
            keyShortcut: "toggleCaptions",
            onPress: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onPress2, $bb90bb562fcb86a3$var$onPress3).bind(this)
        });
    }
}
(0, $97zcJ._)($bb90bb562fcb86a3$export$3e4982ba83f4a5c6, "props", $bb90bb562fcb86a3$export$2fdb964152b42c79.props);
function $bb90bb562fcb86a3$var$onPress3(event) {
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media2).remote.toggleCaptions(event);
}
function $bb90bb562fcb86a3$var$isPressed2() {
    const { textTrack: textTrack } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media2).$state, track = textTrack();
    return !!track && (0, $ihjXw.isTrackCaptionKind)(track);
}
function $bb90bb562fcb86a3$var$isHidden() {
    const { hasCaptions: hasCaptions } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media2).$state;
    return !hasCaptions();
}
var $bb90bb562fcb86a3$var$_media3 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_onPress3 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_isPressed3 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_isSupported = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$export$305be705ce696d42 extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_media3, (0, $6KfMo.useMediaContext)());
        const { fullscreen: fullscreen } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media3).$state, isSupported1 = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isSupported, $bb90bb562fcb86a3$var$isSupported).bind(this);
        this.setAttributes({
            "data-active": fullscreen,
            "data-supported": isSupported1,
            "aria-hidden": (0, $jrniq.$ariaBool)(()=>!isSupported1())
        });
    }
    onAttach(el) {
        el.setAttribute("data-media-tooltip", "fullscreen");
        (0, $ciZW6.setARIALabel)(el, "Fullscreen");
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onPress3);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_isPressed3);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_isSupported);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_media3, {
            writable: true,
            value: void 0
        });
        new $bb90bb562fcb86a3$export$2fdb964152b42c79({
            isPresssed: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isPressed3, $bb90bb562fcb86a3$var$isPressed3).bind(this),
            keyShortcut: "toggleFullscreen",
            onPress: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onPress3, $bb90bb562fcb86a3$var$onPress4).bind(this)
        });
    }
}
(0, $97zcJ._)($bb90bb562fcb86a3$export$305be705ce696d42, "props", {
    ...$bb90bb562fcb86a3$export$2fdb964152b42c79.props,
    target: "prefer-media"
});
function $bb90bb562fcb86a3$var$onPress4(event) {
    const remote = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media3).remote, target = this.$props.target();
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isPressed3, $bb90bb562fcb86a3$var$isPressed3).call(this) ? remote.exitFullscreen(target, event) : remote.enterFullscreen(target, event);
}
function $bb90bb562fcb86a3$var$isPressed3() {
    const { fullscreen: fullscreen } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media3).$state;
    return fullscreen();
}
function $bb90bb562fcb86a3$var$isSupported() {
    const { canFullscreen: canFullscreen } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media3).$state;
    return canFullscreen();
}
var $bb90bb562fcb86a3$var$_media4 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_onPress4 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_isPressed4 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_getState1 = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$export$7ee6365f549a934a extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_media4, (0, $6KfMo.useMediaContext)());
        this.setAttributes({
            "data-muted": (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isPressed4, $bb90bb562fcb86a3$var$isPressed4).bind(this),
            "data-state": (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getState1, $bb90bb562fcb86a3$var$getState1).bind(this)
        });
    }
    onAttach(el) {
        el.setAttribute("data-media-mute-button", "");
        el.setAttribute("data-media-tooltip", "mute");
        (0, $ciZW6.setARIALabel)(el, "Mute");
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onPress4);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_isPressed4);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getState1);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_media4, {
            writable: true,
            value: void 0
        });
        new $bb90bb562fcb86a3$export$2fdb964152b42c79({
            isPresssed: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isPressed4, $bb90bb562fcb86a3$var$isPressed4).bind(this),
            keyShortcut: "toggleMuted",
            onPress: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onPress4, $bb90bb562fcb86a3$var$onPress5).bind(this)
        });
    }
}
(0, $97zcJ._)($bb90bb562fcb86a3$export$7ee6365f549a934a, "props", $bb90bb562fcb86a3$export$2fdb964152b42c79.props);
function $bb90bb562fcb86a3$var$onPress5(event) {
    const remote = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media4).remote;
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isPressed4, $bb90bb562fcb86a3$var$isPressed4).call(this) ? remote.unmute(event) : remote.mute(event);
}
function $bb90bb562fcb86a3$var$isPressed4() {
    const { muted: muted, volume: volume } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media4).$state;
    return muted() || volume() === 0;
}
function $bb90bb562fcb86a3$var$getState1() {
    const { muted: muted, volume: volume } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media4).$state, $volume = volume();
    if (muted() || $volume === 0) return "muted";
    else if ($volume >= 0.5) return "high";
    else if ($volume < 0.5) return "low";
}
var $bb90bb562fcb86a3$var$_media5 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_onPress5 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_isPressed5 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_isSupported1 = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$export$b826ad0d3c504704 extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_media5, (0, $6KfMo.useMediaContext)());
        const { pictureInPicture: pictureInPicture } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media5).$state, isSupported = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isSupported1, $bb90bb562fcb86a3$var$isSupported1).bind(this);
        this.setAttributes({
            "data-active": pictureInPicture,
            "data-supported": isSupported,
            "aria-hidden": (0, $jrniq.$ariaBool)(()=>!isSupported())
        });
    }
    onAttach(el) {
        el.setAttribute("data-media-tooltip", "pip");
        (0, $ciZW6.setARIALabel)(el, "PiP");
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onPress5);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_isPressed5);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_isSupported1);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_media5, {
            writable: true,
            value: void 0
        });
        new $bb90bb562fcb86a3$export$2fdb964152b42c79({
            isPresssed: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isPressed5, $bb90bb562fcb86a3$var$isPressed5).bind(this),
            keyShortcut: "togglePictureInPicture",
            onPress: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onPress5, $bb90bb562fcb86a3$var$onPress6).bind(this)
        });
    }
}
(0, $97zcJ._)($bb90bb562fcb86a3$export$b826ad0d3c504704, "props", $bb90bb562fcb86a3$export$2fdb964152b42c79.props);
function $bb90bb562fcb86a3$var$onPress6(event) {
    const remote = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media5).remote;
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isPressed5, $bb90bb562fcb86a3$var$isPressed5).call(this) ? remote.exitPictureInPicture(event) : remote.enterPictureInPicture(event);
}
function $bb90bb562fcb86a3$var$isPressed5() {
    const { pictureInPicture: pictureInPicture } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media5).$state;
    return pictureInPicture();
}
function $bb90bb562fcb86a3$var$isSupported1() {
    const { canPictureInPicture: canPictureInPicture } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media5).$state;
    return canPictureInPicture();
}
var $bb90bb562fcb86a3$var$_media6 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_isSupported2 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_getDefaultLabel1 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onPress6 = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$export$d947da0a2595cd47 extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_media6, (0, $6KfMo.useMediaContext)());
        const { seeking: seeking } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media6).$state, { seconds: seconds } = this.$props, isSupported = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isSupported2, $bb90bb562fcb86a3$var$isSupported2).bind(this);
        this.setAttributes({
            seconds: seconds,
            "data-seeking": seeking,
            "data-supported": isSupported,
            "aria-hidden": (0, $jrniq.$ariaBool)(()=>!isSupported())
        });
    }
    onAttach(el) {
        (0, $ciZW6.setAttributeIfEmpty)(el, "tabindex", "0");
        (0, $ciZW6.setAttributeIfEmpty)(el, "role", "button");
        (0, $ciZW6.setAttributeIfEmpty)(el, "type", "button");
        el.setAttribute("data-media-tooltip", "seek");
        (0, $ciZW6.setARIALabel)(el, (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getDefaultLabel1, $bb90bb562fcb86a3$var$getDefaultLabel1).bind(this));
    }
    onConnect(el) {
        (0, $ciZW6.onPress)(el, (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onPress6, $bb90bb562fcb86a3$var$onPress7).bind(this));
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_isSupported2);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getDefaultLabel1);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onPress6);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_media6, {
            writable: true,
            value: void 0
        });
        new (0, $jWjYZ.FocusVisibleController)();
    }
}
(0, $97zcJ._)($bb90bb562fcb86a3$export$d947da0a2595cd47, "props", {
    disabled: false,
    seconds: 30
});
function $bb90bb562fcb86a3$var$isSupported2() {
    const { canSeek: canSeek } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media6).$state;
    return canSeek();
}
function $bb90bb562fcb86a3$var$getDefaultLabel1() {
    const { seconds: seconds } = this.$props;
    return `Seek ${seconds() > 0 ? "forward" : "backward"} ${seconds()} seconds`;
}
function $bb90bb562fcb86a3$var$onPress7(event) {
    const { seconds: seconds, disabled: disabled } = this.$props;
    if (disabled()) return;
    const { currentTime: currentTime } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media6).$state, seekTo = currentTime() + seconds();
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media6).remote.seek(seekTo, event);
}
var $bb90bb562fcb86a3$var$_media7 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_onPress7 = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$export$a35d1ec6b27677d2 extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_media7, (0, $6KfMo.useMediaContext)());
        const { disabled: disabled } = this.$props, { live: live, liveEdge: liveEdge } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media7).$state, isHidden = ()=>!live();
        this.setAttributes({
            "data-edge": liveEdge,
            "data-hidden": isHidden,
            "aria-disabled": (0, $jrniq.$ariaBool)(()=>disabled() || liveEdge()),
            "aria-hidden": (0, $jrniq.$ariaBool)(isHidden)
        });
    }
    onAttach(el) {
        (0, $ciZW6.setAttributeIfEmpty)(el, "tabindex", "0");
        (0, $ciZW6.setAttributeIfEmpty)(el, "role", "button");
        (0, $ciZW6.setAttributeIfEmpty)(el, "type", "button");
        el.setAttribute("data-media-tooltip", "live");
    }
    onConnect(el) {
        (0, $ciZW6.onPress)(el, (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onPress7, $bb90bb562fcb86a3$var$onPress8).bind(this));
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onPress7);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_media7, {
            writable: true,
            value: void 0
        });
        new (0, $jWjYZ.FocusVisibleController)();
    }
}
(0, $97zcJ._)($bb90bb562fcb86a3$export$a35d1ec6b27677d2, "props", {
    disabled: false
});
function $bb90bb562fcb86a3$var$onPress8(event) {
    const { disabled: disabled } = this.$props, { liveEdge: liveEdge } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media7).$state;
    if (disabled() || liveEdge()) return;
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media7).remote.seekToLiveEdge(event);
}
const $bb90bb562fcb86a3$export$467e17e18ed84bff = new (0, $8B3mG.State)({
    min: 0,
    max: 100,
    value: 0,
    step: 1,
    pointerValue: 0,
    focused: false,
    dragging: false,
    pointing: false,
    hidden: false,
    get active () {
        return this.dragging || this.focused || this.pointing;
    },
    get fillRate () {
        return $bb90bb562fcb86a3$var$calcRate(this.min, this.max, this.value);
    },
    get fillPercent () {
        return this.fillRate * 100;
    },
    get pointerRate () {
        return $bb90bb562fcb86a3$var$calcRate(this.min, this.max, this.pointerValue);
    },
    get pointerPercent () {
        return this.pointerRate * 100;
    }
});
function $bb90bb562fcb86a3$var$calcRate(min, max, value) {
    const range = max - min, offset = value - min;
    return range > 0 ? offset / range : 0;
}
var $bb90bb562fcb86a3$var$_init = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_observer = /*#__PURE__*/ new WeakMap(), /**
   * Disconnect any active intersection observers.
   */ $bb90bb562fcb86a3$var$_onDisconnect = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$var$IntersectionObserverController extends (0, $8B3mG.ViewController) {
    onConnect(el) {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_observer, new IntersectionObserver((entries)=>{
            (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_init).callback?.(entries, (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_observer));
        }, (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_init)));
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_observer).observe(el);
        (0, $8B3mG.onDispose)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onDisconnect, $bb90bb562fcb86a3$var$onDisconnect).bind(this));
    }
    constructor(init){
        super();
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onDisconnect);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_init, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_observer, {
            writable: true,
            value: void 0
        });
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_init, init);
    }
}
function $bb90bb562fcb86a3$var$onDisconnect() {
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_observer)?.disconnect();
    (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_observer, void 0);
}
const $bb90bb562fcb86a3$export$622028cc33f7ef5 = (0, $8B3mG.createContext)();
const $bb90bb562fcb86a3$var$sliderObserverContext = (0, $8B3mG.createContext)();
function $bb90bb562fcb86a3$var$getClampedValue(min, max, value, step) {
    return (0, $hzYuC.clampNumber)(min, (0, $hzYuC.round)(value, (0, $hzYuC.getNumberOfDecimalPlaces)(step)), max);
}
function $bb90bb562fcb86a3$var$getValueFromRate(min, max, rate, step) {
    const boundRate = (0, $hzYuC.clampNumber)(0, rate, 1), range = max - min, fill = range * boundRate, stepRatio = fill / step, steps = step * Math.round(stepRatio);
    return min + steps;
}
const $bb90bb562fcb86a3$var$SliderKeyDirection = {
    Left: -1,
    ArrowLeft: -1,
    Up: 1,
    ArrowUp: 1,
    Right: 1,
    ArrowRight: 1,
    Down: -1,
    ArrowDown: -1
};
var $bb90bb562fcb86a3$var$_delegate2 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_media8 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_observer1 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_watchSwipeGesture = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_provider = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_touch = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_touchStartValue = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_onTouchStart = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onTouchMove = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_attachEventListeners = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_attachPointerListeners = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onFocus = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_updateValue = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_updatePointerValue = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_getPointerValue = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onPointerEnter = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onPointerMove = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onPointerLeave = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onPointerDown = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onStartDragging = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onStopDragging = /*#__PURE__*/ new WeakSet(), // -------------------------------------------------------------------------------------------
// Keyboard Events
// -------------------------------------------------------------------------------------------
$bb90bb562fcb86a3$var$_lastDownKey = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_repeatedKeys = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_onKeyDown = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onKeyUp = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_calcJumpValue = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_calcNewKeyValue = /*#__PURE__*/ new WeakSet(), // -------------------------------------------------------------------------------------------
// Document (Pointer Events)
// -------------------------------------------------------------------------------------------
$bb90bb562fcb86a3$var$_onDocumentPointerUp = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onDocumentTouchMove = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onDocumentPointerMove = /*#__PURE__*/ new WeakMap();
class $bb90bb562fcb86a3$var$SliderEventsController extends (0, $8B3mG.ViewController) {
    onSetup() {
        if ((0, $8B3mG.hasProvidedContext)($bb90bb562fcb86a3$var$sliderObserverContext)) (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_observer1, (0, $8B3mG.useContext)($bb90bb562fcb86a3$var$sliderObserverContext));
    }
    onConnect(el) {
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_attachEventListeners, $bb90bb562fcb86a3$var$attachEventListeners).bind(this, el));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_attachPointerListeners, $bb90bb562fcb86a3$var$attachPointerListeners).bind(this, el));
        if ((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate2).swipeGesture) (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchSwipeGesture, $bb90bb562fcb86a3$var$watchSwipeGesture).bind(this));
    }
    constructor(delegate, media){
        super();
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchSwipeGesture);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onTouchStart);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onTouchMove);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_attachEventListeners);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_attachPointerListeners);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onFocus);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_updateValue);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_updatePointerValue);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getPointerValue);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onPointerEnter);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onPointerMove);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onPointerLeave);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onPointerDown);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onStartDragging);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onStopDragging);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onKeyDown);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onKeyUp);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_calcJumpValue);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_calcNewKeyValue);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onDocumentPointerUp);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onDocumentTouchMove);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_delegate2, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_media8, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_observer1, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_provider, {
            writable: true,
            value: null
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_touch, {
            writable: true,
            value: null
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_touchStartValue, {
            writable: true,
            value: null
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_lastDownKey, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_repeatedKeys, {
            writable: true,
            value: false
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_onDocumentPointerMove, {
            writable: true,
            value: (0, $8B3mG.functionThrottle)((event)=>{
                (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_updatePointerValue, $bb90bb562fcb86a3$var$updatePointerValue).call(this, (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getPointerValue, $bb90bb562fcb86a3$var$getPointerValue).call(this, event), event);
            }, 20, {
                leading: true
            })
        });
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_delegate2, delegate);
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_media8, media);
    }
}
function $bb90bb562fcb86a3$var$watchSwipeGesture() {
    const { pointer: pointer } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media8).$state;
    if (pointer() !== "coarse" || !(0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate2).swipeGesture()) {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_provider, null);
        return;
    }
    (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_provider, (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media8).player.el?.querySelector("media-provider,[data-media-provider]"));
    if (!(0, $57dmi._)(this, $bb90bb562fcb86a3$var$_provider)) return;
    new (0, $8B3mG.EventsController)((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_provider)).add("touchstart", (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onTouchStart, $bb90bb562fcb86a3$var$onTouchStart).bind(this), {
        passive: true
    }).add("touchmove", (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onTouchMove, $bb90bb562fcb86a3$var$onTouchMove).bind(this), {
        passive: false
    });
}
function $bb90bb562fcb86a3$var$onTouchStart(event) {
    (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_touch, event.touches[0]);
}
function $bb90bb562fcb86a3$var$onTouchMove(event) {
    if ((0, $8B3mG.isNull)((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_touch)) || (0, $ciZW6.isTouchPinchEvent)(event)) return;
    const touch = event.touches[0], xDiff = touch.clientX - (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_touch).clientX, yDiff = touch.clientY - (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_touch).clientY, isDragging = this.$state.dragging();
    if (!isDragging && Math.abs(yDiff) > 5) return;
    if (isDragging) return;
    event.preventDefault();
    if (Math.abs(xDiff) > 20) {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_touch, touch);
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_touchStartValue, this.$state.value());
        (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onStartDragging, $bb90bb562fcb86a3$var$onStartDragging).call(this, (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_touchStartValue), event);
    }
}
function $bb90bb562fcb86a3$var$attachEventListeners(el) {
    const { hidden: hidden } = this.$props;
    new (0, $8B3mG.EventsController)(el).add("focus", (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onFocus, $bb90bb562fcb86a3$var$onFocus).bind(this)).add("keyup", (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onKeyUp, $bb90bb562fcb86a3$var$onKeyUp).bind(this)).add("keydown", (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onKeyDown, $bb90bb562fcb86a3$var$onKeyDown).bind(this));
    if (hidden() || (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate2).isDisabled()) return;
    new (0, $8B3mG.EventsController)(el).add("pointerenter", (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onPointerEnter, $bb90bb562fcb86a3$var$onPointerEnter).bind(this)).add("pointermove", (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onPointerMove, $bb90bb562fcb86a3$var$onPointerMove).bind(this)).add("pointerleave", (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onPointerLeave, $bb90bb562fcb86a3$var$onPointerLeave).bind(this)).add("pointerdown", (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onPointerDown, $bb90bb562fcb86a3$var$onPointerDown).bind(this));
}
function $bb90bb562fcb86a3$var$attachPointerListeners(el) {
    if ((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate2).isDisabled() || !this.$state.dragging()) return;
    new (0, $8B3mG.EventsController)(document).add("pointerup", (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onDocumentPointerUp, $bb90bb562fcb86a3$var$onDocumentPointerUp).bind(this), {
        capture: true
    }).add("pointermove", (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_onDocumentPointerMove).bind(this)).add("touchmove", (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onDocumentTouchMove, $bb90bb562fcb86a3$var$onDocumentTouchMove).bind(this), {
        passive: false
    });
}
function $bb90bb562fcb86a3$var$onFocus() {
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_updatePointerValue, $bb90bb562fcb86a3$var$updatePointerValue).call(this, this.$state.value());
}
function $bb90bb562fcb86a3$var$updateValue(newValue, trigger) {
    const { value: value, min: min, max: max, dragging: dragging } = this.$state;
    const clampedValue = Math.max(min(), Math.min(newValue, max()));
    value.set(clampedValue);
    const event = this.createEvent("value-change", {
        detail: clampedValue,
        trigger: trigger
    });
    this.dispatch(event);
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate2).onValueChange?.(event);
    if (dragging()) {
        const event2 = this.createEvent("drag-value-change", {
            detail: clampedValue,
            trigger: trigger
        });
        this.dispatch(event2);
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate2).onDragValueChange?.(event2);
    }
}
function $bb90bb562fcb86a3$var$updatePointerValue(value, trigger) {
    const { pointerValue: pointerValue, dragging: dragging } = this.$state;
    pointerValue.set(value);
    this.dispatch("pointer-value-change", {
        detail: value,
        trigger: trigger
    });
    if (dragging()) (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_updateValue, $bb90bb562fcb86a3$var$updateValue).call(this, value, trigger);
}
function $bb90bb562fcb86a3$var$getPointerValue(event) {
    let thumbPositionRate, rect = this.el.getBoundingClientRect(), { min: min, max: max } = this.$state;
    if (this.$props.orientation() === "vertical") {
        const { bottom: trackBottom, height: trackHeight } = rect;
        thumbPositionRate = (trackBottom - event.clientY) / trackHeight;
    } else if ((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_touch) && (0, $8B3mG.isNumber)((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_touchStartValue))) {
        const { width: width } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_provider).getBoundingClientRect(), rate = (event.clientX - (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_touch).clientX) / width, range = max() - min(), diff = range * Math.abs(rate);
        thumbPositionRate = (rate < 0 ? (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_touchStartValue) - diff : (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_touchStartValue) + diff) / range;
    } else {
        const { left: trackLeft, width: trackWidth } = rect;
        thumbPositionRate = (event.clientX - trackLeft) / trackWidth;
    }
    return Math.max(min(), Math.min(max(), (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate2).roundValue($bb90bb562fcb86a3$var$getValueFromRate(min(), max(), thumbPositionRate, (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate2).getStep()))));
}
function $bb90bb562fcb86a3$var$onPointerEnter(event) {
    this.$state.pointing.set(true);
}
function $bb90bb562fcb86a3$var$onPointerMove(event) {
    const { dragging: dragging } = this.$state;
    if (dragging()) return;
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_updatePointerValue, $bb90bb562fcb86a3$var$updatePointerValue).call(this, (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getPointerValue, $bb90bb562fcb86a3$var$getPointerValue).call(this, event), event);
}
function $bb90bb562fcb86a3$var$onPointerLeave(event) {
    this.$state.pointing.set(false);
}
function $bb90bb562fcb86a3$var$onPointerDown(event) {
    if (event.button !== 0) return;
    const value = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getPointerValue, $bb90bb562fcb86a3$var$getPointerValue).call(this, event);
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onStartDragging, $bb90bb562fcb86a3$var$onStartDragging).call(this, value, event);
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_updatePointerValue, $bb90bb562fcb86a3$var$updatePointerValue).call(this, value, event);
}
function $bb90bb562fcb86a3$var$onStartDragging(value, trigger) {
    const { dragging: dragging } = this.$state;
    if (dragging()) return;
    dragging.set(true);
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media8).remote.pauseControls(trigger);
    const event = this.createEvent("drag-start", {
        detail: value,
        trigger: trigger
    });
    this.dispatch(event);
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate2).onDragStart?.(event);
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_observer1)?.onDragStart?.();
}
function $bb90bb562fcb86a3$var$onStopDragging(value, trigger) {
    const { dragging: dragging } = this.$state;
    if (!dragging()) return;
    dragging.set(false);
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media8).remote.resumeControls(trigger);
    const event = this.createEvent("drag-end", {
        detail: value,
        trigger: trigger
    });
    this.dispatch(event);
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate2).onDragEnd?.(event);
    (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_touch, null);
    (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_touchStartValue, null);
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_observer1)?.onDragEnd?.();
}
function $bb90bb562fcb86a3$var$onKeyDown(event) {
    const isValidKey = Object.keys($bb90bb562fcb86a3$var$SliderKeyDirection).includes(event.key);
    if (!isValidKey) return;
    const { key: key } = event, jumpValue = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_calcJumpValue, $bb90bb562fcb86a3$var$calcJumpValue).call(this, event);
    if (!(0, $8B3mG.isNull)(jumpValue)) {
        (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_updatePointerValue, $bb90bb562fcb86a3$var$updatePointerValue).call(this, jumpValue, event);
        (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_updateValue, $bb90bb562fcb86a3$var$updateValue).call(this, jumpValue, event);
        return;
    }
    const newValue = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_calcNewKeyValue, $bb90bb562fcb86a3$var$calcNewKeyValue).call(this, event);
    if (!(0, $57dmi._)(this, $bb90bb562fcb86a3$var$_repeatedKeys)) {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_repeatedKeys, key === (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_lastDownKey));
        if (!this.$state.dragging() && (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_repeatedKeys)) (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onStartDragging, $bb90bb562fcb86a3$var$onStartDragging).call(this, newValue, event);
    }
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_updatePointerValue, $bb90bb562fcb86a3$var$updatePointerValue).call(this, newValue, event);
    (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_lastDownKey, key);
}
function $bb90bb562fcb86a3$var$onKeyUp(event) {
    const isValidKey = Object.keys($bb90bb562fcb86a3$var$SliderKeyDirection).includes(event.key);
    if (!isValidKey || !(0, $8B3mG.isNull)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_calcJumpValue, $bb90bb562fcb86a3$var$calcJumpValue).call(this, event))) return;
    const newValue = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_repeatedKeys) ? this.$state.pointerValue() : (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_calcNewKeyValue, $bb90bb562fcb86a3$var$calcNewKeyValue).call(this, event);
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_updateValue, $bb90bb562fcb86a3$var$updateValue).call(this, newValue, event);
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onStopDragging, $bb90bb562fcb86a3$var$onStopDragging).call(this, newValue, event);
    (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_lastDownKey, "");
    (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_repeatedKeys, false);
}
function $bb90bb562fcb86a3$var$calcJumpValue(event) {
    let key = event.key, { min: min, max: max } = this.$state;
    if (key === "Home" || key === "PageUp") return min();
    else if (key === "End" || key === "PageDown") return max();
    else if (!event.metaKey && /^[0-9]$/.test(key)) return (max() - min()) / 10 * Number(key);
    return null;
}
function $bb90bb562fcb86a3$var$calcNewKeyValue(event) {
    const { key: key, shiftKey: shiftKey } = event;
    event.preventDefault();
    event.stopPropagation();
    const { shiftKeyMultiplier: shiftKeyMultiplier } = this.$props;
    const { min: min, max: max, value: value, pointerValue: pointerValue } = this.$state, step = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate2).getStep(), keyStep = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate2).getKeyStep();
    const modifiedStep = !shiftKey ? keyStep : keyStep * shiftKeyMultiplier(), direction = Number($bb90bb562fcb86a3$var$SliderKeyDirection[key]), diff = modifiedStep * direction, currentValue = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_repeatedKeys) ? pointerValue() : (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate2).getValue?.() ?? value(), steps = (currentValue + diff) / step;
    return Math.max(min(), Math.min(max(), Number((step * steps).toFixed(3))));
}
function $bb90bb562fcb86a3$var$onDocumentPointerUp(event) {
    if (event.button !== 0) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const value = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getPointerValue, $bb90bb562fcb86a3$var$getPointerValue).call(this, event);
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_updatePointerValue, $bb90bb562fcb86a3$var$updatePointerValue).call(this, value, event);
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onStopDragging, $bb90bb562fcb86a3$var$onStopDragging).call(this, value, event);
}
function $bb90bb562fcb86a3$var$onDocumentTouchMove(event) {
    event.preventDefault();
}
const $bb90bb562fcb86a3$export$55d0aa125ccf93d2 = (0, $8B3mG.createContext)(()=>({}));
var $bb90bb562fcb86a3$var$_media9 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_delegate3 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_isVisible = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_isIntersecting = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_onIntersectionChange = /*#__PURE__*/ new WeakSet(), // -------------------------------------------------------------------------------------------
// Watch
// -------------------------------------------------------------------------------------------
$bb90bb562fcb86a3$var$_watchHidden = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchValue = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchStep = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchDisabled = /*#__PURE__*/ new WeakSet(), // -------------------------------------------------------------------------------------------
// ARIA
// -------------------------------------------------------------------------------------------
$bb90bb562fcb86a3$var$_getARIADisabled = /*#__PURE__*/ new WeakSet(), // -------------------------------------------------------------------------------------------
// Attributes
// -------------------------------------------------------------------------------------------
$bb90bb562fcb86a3$var$_setupAttrs = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchCSSVars = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_updateSliderVars = /*#__PURE__*/ new WeakMap();
class $bb90bb562fcb86a3$export$b4f48791b51b8570 extends (0, $8B3mG.ViewController) {
    onSetup() {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_media9, (0, $6KfMo.useMediaContext)());
        const focus = new (0, $jWjYZ.FocusVisibleController)();
        focus.attach(this);
        this.$state.focused = focus.focused.bind(focus);
        if (!(0, $8B3mG.hasProvidedContext)($bb90bb562fcb86a3$export$55d0aa125ccf93d2)) (0, $8B3mG.provideContext)($bb90bb562fcb86a3$export$55d0aa125ccf93d2, {
            default: "value"
        });
        (0, $8B3mG.provideContext)($bb90bb562fcb86a3$export$622028cc33f7ef5, {
            orientation: this.$props.orientation,
            disabled: (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate3).isDisabled,
            preview: (0, $8B3mG.signal)(null)
        });
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchValue, $bb90bb562fcb86a3$var$watchValue).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchStep, $bb90bb562fcb86a3$var$watchStep).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchDisabled, $bb90bb562fcb86a3$var$watchDisabled).bind(this));
        (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_setupAttrs, $bb90bb562fcb86a3$var$setupAttrs).call(this);
        new $bb90bb562fcb86a3$var$SliderEventsController((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate3), (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media9)).attach(this);
        new $bb90bb562fcb86a3$var$IntersectionObserverController({
            callback: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onIntersectionChange, $bb90bb562fcb86a3$var$onIntersectionChange).bind(this)
        }).attach(this);
    }
    onAttach(el) {
        (0, $ciZW6.setAttributeIfEmpty)(el, "role", "slider");
        (0, $ciZW6.setAttributeIfEmpty)(el, "tabindex", "0");
        (0, $ciZW6.setAttributeIfEmpty)(el, "autocomplete", "off");
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchCSSVars, $bb90bb562fcb86a3$var$watchCSSVars).bind(this));
    }
    onConnect(el) {
        (0, $8B3mG.onDispose)((0, $ciZW6.observeVisibility)(el, (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_isVisible).set));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchHidden, $bb90bb562fcb86a3$var$watchHidden).bind(this));
    }
    constructor(delegate){
        super();
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onIntersectionChange);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchHidden);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchValue);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchStep);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchDisabled);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getARIADisabled);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_setupAttrs);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchCSSVars);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_media9, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_delegate3, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_isVisible, {
            writable: true,
            value: (0, $8B3mG.signal)(true)
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_isIntersecting, {
            writable: true,
            value: (0, $8B3mG.signal)(true)
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_updateSliderVars, {
            writable: true,
            value: (0, $8B3mG.animationFrameThrottle)((fillPercent, pointerPercent)=>{
                this.el?.style.setProperty("--slider-fill", fillPercent + "%");
                this.el?.style.setProperty("--slider-pointer", pointerPercent + "%");
            })
        });
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_delegate3, delegate);
    }
}
(0, $97zcJ._)($bb90bb562fcb86a3$export$b4f48791b51b8570, "props", {
    hidden: false,
    disabled: false,
    step: 1,
    keyStep: 1,
    orientation: "horizontal",
    shiftKeyMultiplier: 5
});
function $bb90bb562fcb86a3$var$onIntersectionChange(entries) {
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_isIntersecting).set(entries[0].isIntersecting);
}
function $bb90bb562fcb86a3$var$watchHidden() {
    const { hidden: hidden } = this.$props;
    this.$state.hidden.set(hidden() || !(0, $57dmi._)(this, $bb90bb562fcb86a3$var$_isVisible).call(this) || !(0, $57dmi._)(this, $bb90bb562fcb86a3$var$_isIntersecting).bind(this));
}
function $bb90bb562fcb86a3$var$watchValue() {
    const { dragging: dragging, value: value, min: min, max: max } = this.$state;
    if ((0, $8B3mG.peek)(dragging)) return;
    value.set($bb90bb562fcb86a3$var$getClampedValue(min(), max(), value(), (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate3).getStep()));
}
function $bb90bb562fcb86a3$var$watchStep() {
    this.$state.step.set((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate3).getStep());
}
function $bb90bb562fcb86a3$var$watchDisabled() {
    if (!(0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate3).isDisabled()) return;
    const { dragging: dragging, pointing: pointing } = this.$state;
    dragging.set(false);
    pointing.set(false);
}
function $bb90bb562fcb86a3$var$getARIADisabled() {
    return (0, $8B3mG.ariaBool)((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate3).isDisabled());
}
function $bb90bb562fcb86a3$var$setupAttrs() {
    const { orientation: orientation } = this.$props, { dragging: dragging, active: active, pointing: pointing } = this.$state;
    this.setAttributes({
        "data-dragging": dragging,
        "data-pointing": pointing,
        "data-active": active,
        "aria-disabled": (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getARIADisabled, $bb90bb562fcb86a3$var$getARIADisabled).bind(this),
        "aria-valuemin": (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate3).aria.valueMin ?? this.$state.min,
        "aria-valuemax": (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate3).aria.valueMax ?? this.$state.max,
        "aria-valuenow": (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate3).aria.valueNow,
        "aria-valuetext": (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate3).aria.valueText,
        "aria-orientation": orientation
    });
}
function $bb90bb562fcb86a3$var$watchCSSVars() {
    const { fillPercent: fillPercent, pointerPercent: pointerPercent } = this.$state;
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_updateSliderVars).call(this, (0, $hzYuC.round)(fillPercent(), 3), (0, $hzYuC.round)(pointerPercent(), 3));
}
var // -------------------------------------------------------------------------------------------
// Props
// -------------------------------------------------------------------------------------------
$bb90bb562fcb86a3$var$_getARIAValueNow = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_getARIAValueText = /*#__PURE__*/ new WeakSet(), // -------------------------------------------------------------------------------------------
// Watch
// -------------------------------------------------------------------------------------------
$bb90bb562fcb86a3$var$_watchValue1 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchMinMax = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$export$472062a354075cee extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchValue1, $bb90bb562fcb86a3$var$watchValue1).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchMinMax, $bb90bb562fcb86a3$var$watchMinMax).bind(this));
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getARIAValueNow);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getARIAValueText);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchValue1);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchMinMax);
        new $bb90bb562fcb86a3$export$b4f48791b51b8570({
            getStep: this.$props.step,
            getKeyStep: this.$props.keyStep,
            roundValue: Math.round,
            isDisabled: this.$props.disabled,
            aria: {
                valueNow: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getARIAValueNow, $bb90bb562fcb86a3$var$getARIAValueNow).bind(this),
                valueText: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getARIAValueText, $bb90bb562fcb86a3$var$getARIAValueText).bind(this)
            }
        });
    }
}
(0, $97zcJ._)($bb90bb562fcb86a3$export$472062a354075cee, "props", {
    ...$bb90bb562fcb86a3$export$b4f48791b51b8570.props,
    min: 0,
    max: 100,
    value: 0
});
(0, $97zcJ._)($bb90bb562fcb86a3$export$472062a354075cee, "state", $bb90bb562fcb86a3$export$467e17e18ed84bff);
function $bb90bb562fcb86a3$var$getARIAValueNow() {
    const { value: value } = this.$state;
    return Math.round(value());
}
function $bb90bb562fcb86a3$var$getARIAValueText() {
    const { value: value, max: max } = this.$state;
    return (0, $hzYuC.round)(value() / max() * 100, 2) + "%";
}
function $bb90bb562fcb86a3$var$watchValue1() {
    const { value: value } = this.$props;
    this.$state.value.set(value());
}
function $bb90bb562fcb86a3$var$watchMinMax() {
    const { min: min, max: max } = this.$props;
    this.$state.min.set(min());
    this.$state.max.set(max());
}
const $bb90bb562fcb86a3$var$cache = /* @__PURE__ */ new Map(), $bb90bb562fcb86a3$var$pending = /* @__PURE__ */ new Map();
var $bb90bb562fcb86a3$var$_media10 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_src = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_crossOrigin = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_onLoadCues = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_processImages = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_processStoryboard = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_processVTTCues = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_resolveBaseUrl = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_resolveURL = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_resolveData = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onError = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$export$9547fa6d0873ee33 {
    static create(src, crossOrigin) {
        const media = (0, $6KfMo.useMediaContext)();
        return new $bb90bb562fcb86a3$export$9547fa6d0873ee33(src, crossOrigin, media);
    }
    constructor(src, crossOrigin, media){
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onLoadCues);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_processImages);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_processStoryboard);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_processVTTCues);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_resolveBaseUrl);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_resolveURL);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_resolveData);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onError);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_media10, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_src, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_crossOrigin, {
            writable: true,
            value: void 0
        });
        (0, $97zcJ._)(this, "$images", (0, $8B3mG.signal)([]));
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_src, src);
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_crossOrigin, crossOrigin);
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_media10, media);
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onLoadCues, $bb90bb562fcb86a3$var$onLoadCues).bind(this));
    }
}

function $bb90bb562fcb86a3$var$onLoadCues() {
    const { canLoad: canLoad } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media10).$state;
    if (!canLoad()) return;
    const src = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_src).call(this);
    if (!src) return;
    if ((0, $8B3mG.isString)(src) && $bb90bb562fcb86a3$var$cache.has(src)) {
        const cues = $bb90bb562fcb86a3$var$cache.get(src);
        $bb90bb562fcb86a3$var$cache.delete(src);
        $bb90bb562fcb86a3$var$cache.set(src, cues);
        if ($bb90bb562fcb86a3$var$cache.size > 99) {
            const firstKey = $bb90bb562fcb86a3$var$cache.keys().next().value;
            $bb90bb562fcb86a3$var$cache.delete(firstKey);
        }
        this.$images.set($bb90bb562fcb86a3$var$cache.get(src));
    } else if ((0, $8B3mG.isString)(src)) {
        const crossOrigin = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_crossOrigin).call(this), currentKey = src + "::" + crossOrigin;
        if (!$bb90bb562fcb86a3$var$pending.has(currentKey)) {
            const promise = new Promise(async (resolve, reject)=>{
                try {
                    const response = await fetch(src, {
                        credentials: (0, $dLb9W.getRequestCredentials)(crossOrigin)
                    }), isJSON = response.headers.get("content-type") === "application/json";
                    if (isJSON) {
                        const json = await response.json();
                        if ((0, $8B3mG.isArray)(json)) {
                            if (json[0] && "text" in json[0]) resolve((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_processVTTCues, $bb90bb562fcb86a3$var$processVTTCues).call(this, json));
                            else {
                                for(let i = 0; i < json.length; i++){
                                    const image = json[i];
                                    (0, $9KZm0.assert)((0, $8B3mG.isObject)(image), false);
                                    (0, $9KZm0.assert)("url" in image && (0, $8B3mG.isString)(image.url), false);
                                    (0, $9KZm0.assert)("startTime" in image && (0, $8B3mG.isNumber)(image.startTime), false);
                                }
                                resolve(json);
                            }
                        } else resolve((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_processStoryboard, $bb90bb562fcb86a3$var$processStoryboard).call(this, json));
                        return;
                    }
                    (parcelRequire("8fTk5")).then(async ({ parseResponse: parseResponse })=>{
                        try {
                            const { cues: cues } = await parseResponse(response);
                            resolve((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_processVTTCues, $bb90bb562fcb86a3$var$processVTTCues).call(this, cues));
                        } catch (e) {
                            reject(e);
                        }
                    });
                } catch (e) {
                    reject(e);
                }
            }).then((images)=>{
                $bb90bb562fcb86a3$var$cache.set(currentKey, images);
                return images;
            }).catch((error)=>{
                (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onError, $bb90bb562fcb86a3$var$onError).call(this, src, error);
            }).finally(()=>{
                if ((0, $8B3mG.isString)(currentKey)) $bb90bb562fcb86a3$var$pending.delete(currentKey);
            });
            $bb90bb562fcb86a3$var$pending.set(currentKey, promise);
        }
        $bb90bb562fcb86a3$var$pending.get(currentKey)?.then((images)=>{
            this.$images.set(images || []);
        });
    } else if ((0, $8B3mG.isArray)(src)) try {
        this.$images.set((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_processImages, $bb90bb562fcb86a3$var$processImages).call(this, src));
    } catch (error) {
        (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onError, $bb90bb562fcb86a3$var$onError).call(this, src, error);
    }
    else try {
        this.$images.set((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_processStoryboard, $bb90bb562fcb86a3$var$processStoryboard).call(this, src));
    } catch (error) {
        (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onError, $bb90bb562fcb86a3$var$onError).call(this, src, error);
    }
    return ()=>{
        this.$images.set([]);
    };
}
function $bb90bb562fcb86a3$var$processImages(images) {
    const baseURL = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_resolveBaseUrl, $bb90bb562fcb86a3$var$resolveBaseUrl).call(this);
    return images.map((img, i)=>{
        (0, $9KZm0.assert)(img.url && (0, $8B3mG.isString)(img.url));
        (0, $9KZm0.assert)("startTime" in img && (0, $8B3mG.isNumber)(img.startTime));
        return {
            ...img,
            url: (0, $8B3mG.isString)(img.url) ? (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_resolveURL, $bb90bb562fcb86a3$var$resolveURL).call(this, img.url, baseURL) : img.url
        };
    });
}
function $bb90bb562fcb86a3$var$processStoryboard(board) {
    (0, $9KZm0.assert)((0, $8B3mG.isString)(board.url));
    (0, $9KZm0.assert)((0, $8B3mG.isArray)(board.tiles) && board.tiles?.length);
    const url = new URL(board.url), images = [];
    const tileWidth = "tile_width" in board ? board.tile_width : board.tileWidth, tileHeight = "tile_height" in board ? board.tile_height : board.tileHeight;
    for (const tile of board.tiles)images.push({
        url: url,
        startTime: "start" in tile ? tile.start : tile.startTime,
        width: tileWidth,
        height: tileHeight,
        coords: {
            x: tile.x,
            y: tile.y
        }
    });
    return images;
}
function $bb90bb562fcb86a3$var$processVTTCues(cues) {
    for(let i = 0; i < cues.length; i++){
        const cue = cues[i];
        (0, $9KZm0.assert)("startTime" in cue && (0, $8B3mG.isNumber)(cue.startTime));
        (0, $9KZm0.assert)("text" in cue && (0, $8B3mG.isString)(cue.text));
    }
    const images = [], baseURL = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_resolveBaseUrl, $bb90bb562fcb86a3$var$resolveBaseUrl).call(this);
    for (const cue of cues){
        const [url, hash] = cue.text.split("#"), data = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_resolveData, $bb90bb562fcb86a3$var$resolveData).call(this, hash);
        images.push({
            url: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_resolveURL, $bb90bb562fcb86a3$var$resolveURL).call(this, url, baseURL),
            startTime: cue.startTime,
            endTime: cue.endTime,
            width: data?.w,
            height: data?.h,
            coords: data && (0, $8B3mG.isNumber)(data.x) && (0, $8B3mG.isNumber)(data.y) ? {
                x: data.x,
                y: data.y
            } : void 0
        });
    }
    return images;
}
function $bb90bb562fcb86a3$var$resolveBaseUrl() {
    let baseURL = (0, $8B3mG.peek)((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_src));
    if (!(0, $8B3mG.isString)(baseURL) || !/^https?:/.test(baseURL)) return location.href;
    return baseURL;
}
function $bb90bb562fcb86a3$var$resolveURL(src, baseURL) {
    return /^https?:/.test(src) ? new URL(src) : new URL(src, baseURL);
}
function $bb90bb562fcb86a3$var$resolveData(hash) {
    if (!hash) return {};
    const [hashProps, values] = hash.split("="), hashValues = values?.split(","), data = {};
    if (!hashProps || !hashValues) return null;
    for(let i = 0; i < hashProps.length; i++){
        const value = +hashValues[i];
        if (!isNaN(value)) data[hashProps[i]] = value;
    }
    return data;
}
function $bb90bb562fcb86a3$var$onError(src, error) {
    return;
}
var $bb90bb562fcb86a3$var$_loader = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_styleResets = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_watchImg = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchCrossOrigin = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onLoadStart = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onLoaded = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onError1 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_isLoading = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_hasError = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchHidden1 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onFindActiveThumbnail = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_resize = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_style = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_resetStyles = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$export$1cd1efc78cb52ca5 extends (0, $8B3mG.Component) {
    onSetup() {
        this.media = (0, $6KfMo.useMediaContext)();
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_loader, $bb90bb562fcb86a3$export$9547fa6d0873ee33.create(this.$props.src, this.$state.crossOrigin));
        (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchCrossOrigin, $bb90bb562fcb86a3$var$watchCrossOrigin).call(this);
        this.setAttributes({
            "data-loading": (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isLoading, $bb90bb562fcb86a3$var$isLoading).bind(this),
            "data-error": (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_hasError, $bb90bb562fcb86a3$var$hasError).bind(this),
            "data-hidden": this.$state.hidden,
            "aria-hidden": (0, $jrniq.$ariaBool)(this.$state.hidden)
        });
    }
    onConnect(el) {
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchImg, $bb90bb562fcb86a3$var$watchImg).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchHidden1, $bb90bb562fcb86a3$var$watchHidden1).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchCrossOrigin, $bb90bb562fcb86a3$var$watchCrossOrigin).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onLoadStart, $bb90bb562fcb86a3$var$onLoadStart).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onFindActiveThumbnail, $bb90bb562fcb86a3$var$onFindActiveThumbnail).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_resize, $bb90bb562fcb86a3$var$resize).bind(this));
    }
    getTime() {
        return this.$props.time();
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchImg);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchCrossOrigin);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onLoadStart);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onLoaded);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onError1);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_isLoading);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_hasError);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchHidden1);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onFindActiveThumbnail);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_resize);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_style);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_resetStyles);
        (0, $97zcJ._)(this, "media", void 0);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_loader, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_styleResets, {
            writable: true,
            value: []
        });
    }
}
(0, $97zcJ._)($bb90bb562fcb86a3$export$1cd1efc78cb52ca5, "props", {
    src: null,
    time: 0,
    crossOrigin: null
});
(0, $97zcJ._)($bb90bb562fcb86a3$export$1cd1efc78cb52ca5, "state", new (0, $8B3mG.State)({
    src: "",
    img: null,
    thumbnails: [],
    activeThumbnail: null,
    crossOrigin: null,
    loading: false,
    error: null,
    hidden: false
}));
function $bb90bb562fcb86a3$var$watchImg() {
    const img = this.$state.img();
    if (!img) return;
    new (0, $8B3mG.EventsController)(img).add("load", (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onLoaded, $bb90bb562fcb86a3$var$onLoaded).bind(this)).add("error", (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onError1, $bb90bb562fcb86a3$var$onError1).bind(this));
}
function $bb90bb562fcb86a3$var$watchCrossOrigin() {
    const { crossOrigin: crossOriginProp } = this.$props, { crossOrigin: crossOriginState } = this.$state, { crossOrigin: mediaCrossOrigin } = this.media.$state, crossOrigin = crossOriginProp() !== null ? crossOriginProp() : mediaCrossOrigin();
    crossOriginState.set(crossOrigin === true ? "anonymous" : crossOrigin);
}
function $bb90bb562fcb86a3$var$onLoadStart() {
    const { src: src, loading: loading, error: error } = this.$state;
    if (src()) {
        loading.set(true);
        error.set(null);
    }
    return ()=>{
        (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_resetStyles, $bb90bb562fcb86a3$var$resetStyles).call(this);
        loading.set(false);
        error.set(null);
    };
}
function $bb90bb562fcb86a3$var$onLoaded() {
    const { loading: loading, error: error } = this.$state;
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_resize, $bb90bb562fcb86a3$var$resize).call(this);
    loading.set(false);
    error.set(null);
}
function $bb90bb562fcb86a3$var$onError1(event) {
    const { loading: loading, error: error } = this.$state;
    loading.set(false);
    error.set(event);
}
function $bb90bb562fcb86a3$var$isLoading() {
    const { loading: loading, hidden: hidden } = this.$state;
    return !hidden() && loading();
}
function $bb90bb562fcb86a3$var$hasError() {
    const { error: error } = this.$state;
    return !(0, $8B3mG.isNull)(error());
}
function $bb90bb562fcb86a3$var$watchHidden1() {
    const { hidden: hidden } = this.$state, { duration: duration } = this.media.$state, images = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_loader).$images();
    hidden.set((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_hasError, $bb90bb562fcb86a3$var$hasError).call(this) || !Number.isFinite(duration()) || images.length === 0);
}
function $bb90bb562fcb86a3$var$onFindActiveThumbnail() {
    let images = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_loader).$images();
    if (!images.length) return;
    let time = this.getTime(), { src: src, activeThumbnail: activeThumbnail } = this.$state, activeIndex = -1, activeImage = null;
    for(let i = images.length - 1; i >= 0; i--){
        const image = images[i];
        if (time >= image.startTime && (!image.endTime || time < image.endTime)) {
            activeIndex = i;
            break;
        }
    }
    if (images[activeIndex]) activeImage = images[activeIndex];
    activeThumbnail.set(activeImage);
    src.set(activeImage?.url.href || "");
}
function $bb90bb562fcb86a3$var$resize() {
    if (!this.scope || this.$state.hidden()) return;
    const rootEl = this.el, imgEl = this.$state.img(), thumbnail = this.$state.activeThumbnail();
    if (!imgEl || !thumbnail || !rootEl) return;
    let width = thumbnail.width ?? imgEl.naturalWidth, height = thumbnail?.height ?? imgEl.naturalHeight, { maxWidth: maxWidth, maxHeight: maxHeight, minWidth: minWidth, minHeight: minHeight, width: elWidth, height: elHeight } = getComputedStyle(this.el);
    if (minWidth === "100%") minWidth = parseFloat(elWidth) + "";
    if (minHeight === "100%") minHeight = parseFloat(elHeight) + "";
    let minRatio = Math.max(parseInt(minWidth) / width, parseInt(minHeight) / height), maxRatio = Math.min(Math.max(parseInt(minWidth), parseInt(maxWidth)) / width, Math.max(parseInt(minHeight), parseInt(maxHeight)) / height), scale = !isNaN(maxRatio) && maxRatio < 1 ? maxRatio : minRatio > 1 ? minRatio : 1;
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_style, $bb90bb562fcb86a3$var$style).call(this, rootEl, "--thumbnail-width", `${width * scale}px`);
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_style, $bb90bb562fcb86a3$var$style).call(this, rootEl, "--thumbnail-height", `${height * scale}px`);
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_style, $bb90bb562fcb86a3$var$style).call(this, imgEl, "width", `${imgEl.naturalWidth * scale}px`);
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_style, $bb90bb562fcb86a3$var$style).call(this, imgEl, "height", `${imgEl.naturalHeight * scale}px`);
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_style, $bb90bb562fcb86a3$var$style).call(this, imgEl, "transform", thumbnail.coords ? `translate(-${thumbnail.coords.x * scale}px, -${thumbnail.coords.y * scale}px)` : "");
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_style, $bb90bb562fcb86a3$var$style).call(this, imgEl, "max-width", "none");
}
function $bb90bb562fcb86a3$var$style(el, name, value) {
    el.style.setProperty(name, value);
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_styleResets).push(()=>el.style.removeProperty(name));
}
function $bb90bb562fcb86a3$var$resetStyles() {
    for (const reset of (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_styleResets))reset();
    (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_styleResets, []);
}
var $bb90bb562fcb86a3$var$_format = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_text = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_slider = /*#__PURE__*/ new WeakMap();
class $bb90bb562fcb86a3$export$848e329471fb286b extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_slider, (0, $8B3mG.useState)($bb90bb562fcb86a3$export$472062a354075cee.state));
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_format, (0, $8B3mG.useContext)($bb90bb562fcb86a3$export$55d0aa125ccf93d2));
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_text, (0, $8B3mG.computed)(this.getValueText.bind(this)));
    }
    /**
   * Returns the current value formatted as text based on prop settings.
   */ getValueText() {
        const { type: type, format: $format, decimalPlaces: decimalPlaces, padHours: padHours, padMinutes: padMinutes, showHours: showHours, showMs: showMs } = this.$props, { value: sliderValue, pointerValue: pointerValue, min: min, max: max } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_slider), format = $format?.() ?? (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_format).default;
        const value = type() === "current" ? sliderValue() : pointerValue();
        if (format === "percent") {
            const range = max() - min();
            const percent = value / range * 100;
            return ((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_format).percent ?? (0, $hzYuC.round))(percent, decimalPlaces()) + "%";
        } else if (format === "time") return ((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_format).time ?? $bb90bb562fcb86a3$export$3203edd9e5edd663)(value, {
            padHrs: padHours(),
            padMins: padMinutes(),
            showHrs: showHours(),
            showMs: showMs()
        });
        else return ((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_format).value?.(value) ?? value.toFixed(2)) + "";
    }
    constructor(...args){
        super(...args);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_format, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_text, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_slider, {
            writable: true,
            value: void 0
        });
    }
}
(0, $97zcJ._)($bb90bb562fcb86a3$export$848e329471fb286b, "props", {
    type: "pointer",
    format: null,
    showHours: false,
    showMs: false,
    padHours: null,
    padMinutes: null,
    decimalPlaces: 2
});
const $bb90bb562fcb86a3$var$slidervalue__proto = $bb90bb562fcb86a3$export$848e329471fb286b.prototype;
(0, $8B3mG.method)($bb90bb562fcb86a3$var$slidervalue__proto, "getValueText");
var $bb90bb562fcb86a3$var$_slider1 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_updatePlacement = /*#__PURE__*/ new WeakMap();
class $bb90bb562fcb86a3$export$1d818f3e85fd500a extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_slider1, (0, $8B3mG.useContext)($bb90bb562fcb86a3$export$622028cc33f7ef5));
        const { active: active } = (0, $8B3mG.useState)($bb90bb562fcb86a3$export$472062a354075cee.state);
        this.setAttributes({
            "data-visible": active
        });
    }
    onAttach(el) {
        Object.assign(el.style, {
            position: "absolute",
            top: 0,
            left: 0,
            width: "max-content"
        });
    }
    onConnect(el) {
        const { preview: preview } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_slider1);
        preview.set(el);
        (0, $8B3mG.onDispose)(()=>preview.set(null));
        (0, $8B3mG.effect)((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_updatePlacement).bind(this));
        const resize = new ResizeObserver((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_updatePlacement).bind(this));
        resize.observe(el);
        (0, $8B3mG.onDispose)(()=>resize.disconnect());
    }
    constructor(...args){
        super(...args);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_slider1, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_updatePlacement, {
            writable: true,
            value: (0, $8B3mG.animationFrameThrottle)(()=>{
                const { disabled: disabled, orientation: orientation } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_slider1);
                if (disabled()) return;
                const el = this.el, { offset: offset, noClamp: noClamp } = this.$props;
                if (!el) return;
                $bb90bb562fcb86a3$export$e78a6edc9fd3c15d(el, {
                    clamp: !noClamp(),
                    offset: offset(),
                    orientation: orientation()
                });
            })
        });
    }
}
(0, $97zcJ._)($bb90bb562fcb86a3$export$1d818f3e85fd500a, "props", {
    offset: 0,
    noClamp: false
});
function $bb90bb562fcb86a3$export$e78a6edc9fd3c15d(el, { clamp: clamp, offset: offset, orientation: orientation }) {
    const computedStyle = getComputedStyle(el), width = parseFloat(computedStyle.width), height = parseFloat(computedStyle.height), styles = {
        top: null,
        right: null,
        bottom: null,
        left: null
    };
    styles[orientation === "horizontal" ? "bottom" : "left"] = `calc(100% + var(--media-slider-preview-offset, ${offset}px))`;
    if (orientation === "horizontal") {
        const widthHalf = width / 2;
        if (!clamp) styles.left = `calc(var(--slider-pointer) - ${widthHalf}px)`;
        else {
            const leftClamp = `max(0px, calc(var(--slider-pointer) - ${widthHalf}px))`, rightClamp = `calc(100% - ${width}px)`;
            styles.left = `min(${leftClamp}, ${rightClamp})`;
        }
    } else {
        const heightHalf = height / 2;
        if (!clamp) styles.bottom = `calc(var(--slider-pointer) - ${heightHalf}px)`;
        else {
            const topClamp = `max(${heightHalf}px, calc(var(--slider-pointer) - ${heightHalf}px))`, bottomClamp = `calc(100% - ${height}px)`;
            styles.bottom = `min(${topClamp}, ${bottomClamp})`;
        }
    }
    Object.assign(el.style, styles);
}
var $bb90bb562fcb86a3$var$_media11 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_getARIAValueNow1 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_getARIAValueText1 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_getARIAValueMax = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_isDisabled = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchVolume = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_throttleVolumeChange = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_onVolumeChange = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onValueChange = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onDragValueChange = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$export$87e3e233220841f8 extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_media11, (0, $6KfMo.useMediaContext)());
        const { audioGain: audioGain } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media11).$state;
        (0, $8B3mG.provideContext)($bb90bb562fcb86a3$export$55d0aa125ccf93d2, {
            default: "percent",
            value (value) {
                return (value * (audioGain() ?? 1)).toFixed(2);
            },
            percent (value) {
                return Math.round(value * (audioGain() ?? 1));
            }
        });
        new $bb90bb562fcb86a3$export$b4f48791b51b8570({
            getStep: this.$props.step,
            getKeyStep: this.$props.keyStep,
            roundValue: Math.round,
            isDisabled: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isDisabled, $bb90bb562fcb86a3$var$isDisabled).bind(this),
            aria: {
                valueMax: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getARIAValueMax, $bb90bb562fcb86a3$var$getARIAValueMax).bind(this),
                valueNow: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getARIAValueNow1, $bb90bb562fcb86a3$var$getARIAValueNow1).bind(this),
                valueText: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getARIAValueText1, $bb90bb562fcb86a3$var$getARIAValueText1).bind(this)
            },
            onDragValueChange: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onDragValueChange, $bb90bb562fcb86a3$var$onDragValueChange).bind(this),
            onValueChange: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onValueChange, $bb90bb562fcb86a3$var$onValueChange).bind(this)
        }).attach(this);
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchVolume, $bb90bb562fcb86a3$var$watchVolume).bind(this));
    }
    onAttach(el) {
        el.setAttribute("data-media-volume-slider", "");
        (0, $ciZW6.setAttributeIfEmpty)(el, "aria-label", "Volume");
        const { canSetVolume: canSetVolume } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media11).$state;
        this.setAttributes({
            "data-supported": canSetVolume,
            "aria-hidden": (0, $jrniq.$ariaBool)(()=>!canSetVolume())
        });
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getARIAValueNow1);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getARIAValueText1);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getARIAValueMax);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_isDisabled);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchVolume);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onVolumeChange);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onValueChange);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onDragValueChange);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_media11, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_throttleVolumeChange, {
            writable: true,
            value: (0, $8B3mG.functionThrottle)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onVolumeChange, $bb90bb562fcb86a3$var$onVolumeChange).bind(this), 25)
        });
    }
}
(0, $97zcJ._)($bb90bb562fcb86a3$export$87e3e233220841f8, "props", {
    ...$bb90bb562fcb86a3$export$b4f48791b51b8570.props,
    keyStep: 5,
    shiftKeyMultiplier: 2
});
(0, $97zcJ._)($bb90bb562fcb86a3$export$87e3e233220841f8, "state", $bb90bb562fcb86a3$export$467e17e18ed84bff);
function $bb90bb562fcb86a3$var$getARIAValueNow1() {
    const { value: value } = this.$state, { audioGain: audioGain } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media11).$state;
    return Math.round(value() * (audioGain() ?? 1));
}
function $bb90bb562fcb86a3$var$getARIAValueText1() {
    const { value: value, max: max } = this.$state, { audioGain: audioGain } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media11).$state;
    return (0, $hzYuC.round)(value() / max() * (audioGain() ?? 1) * 100, 2) + "%";
}
function $bb90bb562fcb86a3$var$getARIAValueMax() {
    const { audioGain: audioGain } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media11).$state;
    return this.$state.max() * (audioGain() ?? 1);
}
function $bb90bb562fcb86a3$var$isDisabled() {
    const { disabled: disabled } = this.$props, { canSetVolume: canSetVolume } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media11).$state;
    return disabled() || !canSetVolume();
}
function $bb90bb562fcb86a3$var$watchVolume() {
    const { muted: muted, volume: volume } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media11).$state;
    const newValue = muted() ? 0 : volume() * 100;
    this.$state.value.set(newValue);
    this.dispatch("value-change", {
        detail: newValue
    });
}
function $bb90bb562fcb86a3$var$onVolumeChange(event) {
    if (!event.trigger) return;
    const mediaVolume = (0, $hzYuC.round)(event.detail / 100, 3);
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media11).remote.changeVolume(mediaVolume, event);
}
function $bb90bb562fcb86a3$var$onValueChange(event) {
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_throttleVolumeChange).call(this, event);
}
function $bb90bb562fcb86a3$var$onDragValueChange(event) {
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_throttleVolumeChange).call(this, event);
}
var $bb90bb562fcb86a3$var$_media12 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_dispatchSeeking = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_chapter = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_calcBufferedPercent = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_hasChapters = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchSeekingThrottle = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchCurrentTime = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchPreviewing = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_seeking = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_seek = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_playingBeforeDragStart = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_onDragStart = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onDragValueChange1 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onDragEnd = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onValueChange1 = /*#__PURE__*/ new WeakSet(), // -------------------------------------------------------------------------------------------
// Props
// -------------------------------------------------------------------------------------------
$bb90bb562fcb86a3$var$_getValue = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_getStep = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_getKeyStep = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_roundValue = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_isDisabled1 = /*#__PURE__*/ new WeakSet(), // -------------------------------------------------------------------------------------------
// ARIA
// -------------------------------------------------------------------------------------------
$bb90bb562fcb86a3$var$_getARIAValueNow2 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_getARIAValueText2 = /*#__PURE__*/ new WeakSet(), // -------------------------------------------------------------------------------------------
// Format
// -------------------------------------------------------------------------------------------
$bb90bb562fcb86a3$var$_percentToTime = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_timeToPercent = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_formatValue = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_formatTime = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$export$e296a477a1bc715a extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_media12, (0, $6KfMo.useMediaContext)());
        (0, $8B3mG.provideContext)($bb90bb562fcb86a3$export$55d0aa125ccf93d2, {
            default: "time",
            value: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_formatValue, $bb90bb562fcb86a3$var$formatValue).bind(this),
            time: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_formatTime, $bb90bb562fcb86a3$var$formatTime1).bind(this)
        });
        this.setAttributes({
            "data-chapters": (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_hasChapters, $bb90bb562fcb86a3$var$hasChapters).bind(this)
        });
        this.setStyles({
            "--slider-progress": (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_calcBufferedPercent, $bb90bb562fcb86a3$var$calcBufferedPercent).bind(this)
        });
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchCurrentTime, $bb90bb562fcb86a3$var$watchCurrentTime).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchSeekingThrottle, $bb90bb562fcb86a3$var$watchSeekingThrottle).bind(this));
    }
    onAttach(el) {
        el.setAttribute("data-media-time-slider", "");
        (0, $ciZW6.setAttributeIfEmpty)(el, "aria-label", "Seek");
    }
    onConnect(el) {
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchPreviewing, $bb90bb562fcb86a3$var$watchPreviewing).bind(this));
        (0, $l6thX.watchActiveTextTrack)((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media12).textTracks, "chapters", (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_chapter).set);
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_calcBufferedPercent);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_hasChapters);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchSeekingThrottle);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchCurrentTime);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchPreviewing);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_seeking);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_seek);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onDragStart);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onDragValueChange1);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onDragEnd);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onValueChange1);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getValue);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getStep);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getKeyStep);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_roundValue);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_isDisabled1);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getARIAValueNow2);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getARIAValueText2);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_percentToTime);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_timeToPercent);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_formatValue);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_formatTime);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_media12, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_dispatchSeeking, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_chapter, {
            writable: true,
            value: (0, $8B3mG.signal)(null)
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_playingBeforeDragStart, {
            writable: true,
            value: false
        });
        const { noSwipeGesture: noSwipeGesture } = this.$props;
        new $bb90bb562fcb86a3$export$b4f48791b51b8570({
            swipeGesture: ()=>!noSwipeGesture(),
            getValue: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getValue, $bb90bb562fcb86a3$var$getValue).bind(this),
            getStep: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getStep, $bb90bb562fcb86a3$var$getStep).bind(this),
            getKeyStep: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getKeyStep, $bb90bb562fcb86a3$var$getKeyStep).bind(this),
            roundValue: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_roundValue, $bb90bb562fcb86a3$var$roundValue),
            isDisabled: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isDisabled1, $bb90bb562fcb86a3$var$isDisabled1).bind(this),
            aria: {
                valueNow: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getARIAValueNow2, $bb90bb562fcb86a3$var$getARIAValueNow2).bind(this),
                valueText: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getARIAValueText2, $bb90bb562fcb86a3$var$getARIAValueText2).bind(this)
            },
            onDragStart: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onDragStart, $bb90bb562fcb86a3$var$onDragStart).bind(this),
            onDragValueChange: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onDragValueChange1, $bb90bb562fcb86a3$var$onDragValueChange1).bind(this),
            onDragEnd: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onDragEnd, $bb90bb562fcb86a3$var$onDragEnd).bind(this),
            onValueChange: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onValueChange1, $bb90bb562fcb86a3$var$onValueChange1).bind(this)
        });
    }
}
(0, $97zcJ._)($bb90bb562fcb86a3$export$e296a477a1bc715a, "props", {
    ...$bb90bb562fcb86a3$export$b4f48791b51b8570.props,
    step: 0.1,
    keyStep: 5,
    shiftKeyMultiplier: 2,
    pauseWhileDragging: false,
    noSwipeGesture: false,
    seekingRequestThrottle: 100
});
(0, $97zcJ._)($bb90bb562fcb86a3$export$e296a477a1bc715a, "state", $bb90bb562fcb86a3$export$467e17e18ed84bff);
function $bb90bb562fcb86a3$var$calcBufferedPercent() {
    const { bufferedEnd: bufferedEnd, duration: duration } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media12).$state;
    return (0, $hzYuC.round)(Math.min(bufferedEnd() / Math.max(duration(), 1), 1) * 100, 3) + "%";
}
function $bb90bb562fcb86a3$var$hasChapters() {
    const { duration: duration } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media12).$state;
    return (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_chapter).call(this)?.cues.length && Number.isFinite(duration()) && duration() > 0;
}
function $bb90bb562fcb86a3$var$watchSeekingThrottle() {
    (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_dispatchSeeking, (0, $8B3mG.functionThrottle)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_seeking, $bb90bb562fcb86a3$var$seeking).bind(this), this.$props.seekingRequestThrottle()));
}
function $bb90bb562fcb86a3$var$watchCurrentTime() {
    if (this.$state.hidden()) return;
    const { value: value, dragging: dragging } = this.$state, newValue = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getValue, $bb90bb562fcb86a3$var$getValue).call(this);
    if (!(0, $8B3mG.peek)(dragging)) {
        value.set(newValue);
        this.dispatch("value-change", {
            detail: newValue
        });
    }
}
function $bb90bb562fcb86a3$var$watchPreviewing() {
    const player = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media12).player.el, { preview: preview } = (0, $8B3mG.useContext)($bb90bb562fcb86a3$export$622028cc33f7ef5);
    player && preview() && (0, $8B3mG.setAttribute)(player, "data-preview", this.$state.active());
}
function $bb90bb562fcb86a3$var$seeking(time, event) {
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media12).remote.seeking(time, event);
}
function $bb90bb562fcb86a3$var$seek(time, percent, event) {
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_dispatchSeeking).cancel();
    const { live: live } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media12).$state;
    if (live() && percent >= 99) {
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media12).remote.seekToLiveEdge(event);
        return;
    }
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media12).remote.seek(time, event);
}
function $bb90bb562fcb86a3$var$onDragStart(event) {
    const { pauseWhileDragging: pauseWhileDragging } = this.$props;
    if (pauseWhileDragging()) {
        const { paused: paused } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media12).$state;
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_playingBeforeDragStart, !paused());
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media12).remote.pause(event);
    }
}
function $bb90bb562fcb86a3$var$onDragValueChange1(event) {
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_dispatchSeeking).call(this, (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_percentToTime, $bb90bb562fcb86a3$var$percentToTime).call(this, event.detail), event);
}
function $bb90bb562fcb86a3$var$onDragEnd(event) {
    const { seeking: seeking1 } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media12).$state;
    if (!(0, $8B3mG.peek)(seeking1)) (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_seeking, $bb90bb562fcb86a3$var$seeking).call(this, (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_percentToTime, $bb90bb562fcb86a3$var$percentToTime).call(this, event.detail), event);
    const percent = event.detail;
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_seek, $bb90bb562fcb86a3$var$seek).call(this, (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_percentToTime, $bb90bb562fcb86a3$var$percentToTime).call(this, percent), percent, event);
    const { pauseWhileDragging: pauseWhileDragging } = this.$props;
    if (pauseWhileDragging() && (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_playingBeforeDragStart)) {
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media12).remote.play(event);
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_playingBeforeDragStart, false);
    }
}
function $bb90bb562fcb86a3$var$onValueChange1(event) {
    const { dragging: dragging } = this.$state;
    if (dragging() || !event.trigger) return;
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onDragEnd, $bb90bb562fcb86a3$var$onDragEnd).call(this, event);
}
function $bb90bb562fcb86a3$var$getValue() {
    const { currentTime: currentTime } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media12).$state;
    return (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_timeToPercent, $bb90bb562fcb86a3$var$timeToPercent).call(this, currentTime());
}
function $bb90bb562fcb86a3$var$getStep() {
    const value = this.$props.step() / (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media12).$state.duration() * 100;
    return Number.isFinite(value) ? value : 1;
}
function $bb90bb562fcb86a3$var$getKeyStep() {
    const value = this.$props.keyStep() / (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media12).$state.duration() * 100;
    return Number.isFinite(value) ? value : 1;
}
function $bb90bb562fcb86a3$var$roundValue(value) {
    return (0, $hzYuC.round)(value, 3);
}
function $bb90bb562fcb86a3$var$isDisabled1() {
    const { disabled: disabled } = this.$props, { canSeek: canSeek } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media12).$state;
    return disabled() || !canSeek();
}
function $bb90bb562fcb86a3$var$getARIAValueNow2() {
    const { value: value } = this.$state;
    return Math.round(value());
}
function $bb90bb562fcb86a3$var$getARIAValueText2() {
    const time = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_percentToTime, $bb90bb562fcb86a3$var$percentToTime).call(this, this.$state.value()), { duration: duration } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media12).$state;
    return Number.isFinite(time) ? `${$bb90bb562fcb86a3$export$378179385e8b7aa2(time)} out of ${$bb90bb562fcb86a3$export$378179385e8b7aa2(duration())}` : "live";
}
function $bb90bb562fcb86a3$var$percentToTime(percent) {
    const { duration: duration } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media12).$state;
    return (0, $hzYuC.round)(percent / 100 * duration(), 5);
}
function $bb90bb562fcb86a3$var$timeToPercent(time) {
    const { liveEdge: liveEdge, duration: duration } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media12).$state, rate = Math.max(0, Math.min(1, liveEdge() ? 1 : Math.min(time, duration()) / duration()));
    return Number.isNaN(rate) ? 0 : Number.isFinite(rate) ? rate * 100 : 100;
}
function $bb90bb562fcb86a3$var$formatValue(percent) {
    const time = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_percentToTime, $bb90bb562fcb86a3$var$percentToTime).call(this, percent), { live: live, duration: duration } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media12).$state;
    return Number.isFinite(time) ? (live() ? time - duration() : time).toFixed(0) : "LIVE";
}
function $bb90bb562fcb86a3$var$formatTime1(percent, options) {
    const time = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_percentToTime, $bb90bb562fcb86a3$var$percentToTime).call(this, percent), { live: live, duration: duration } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media12).$state, value = live() ? time - duration() : time;
    return Number.isFinite(time) ? `${value < 0 ? "-" : ""}${$bb90bb562fcb86a3$export$3203edd9e5edd663(Math.abs(value), options)}` : "LIVE";
}
const $bb90bb562fcb86a3$export$eb1e9ed85beee4a5 = (0, $8B3mG.createContext)();
function $bb90bb562fcb86a3$var$scrollIntoView(el, options) {
    const scrolls = (0, $8B3mG.r)(el, options);
    for (const { el: el2, top: top, left: left } of scrolls)el2.scroll({
        top: top,
        left: left,
        behavior: options.behavior
    });
}
function $bb90bb562fcb86a3$var$scrollIntoCenter(el, options = {}) {
    $bb90bb562fcb86a3$var$scrollIntoView(el, {
        scrollMode: "if-needed",
        block: "center",
        inline: "center",
        ...options
    });
}
const $bb90bb562fcb86a3$var$FOCUSABLE_ELEMENTS_SELECTOR = /* @__PURE__ */ [
    "a[href]",
    "[tabindex]",
    "input",
    "select",
    "button"
].map((selector)=>`${selector}:not([aria-hidden='true'])`).join(",");
const $bb90bb562fcb86a3$var$VALID_KEYS = /* @__PURE__ */ new Set([
    "Escape",
    "Tab",
    "ArrowUp",
    "ArrowDown",
    "Home",
    "PageUp",
    "End",
    "PageDown",
    "Enter",
    " "
]);
var $bb90bb562fcb86a3$var$_index = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_el = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_elements = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_delegate4 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_focusAt = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_findActiveIndex = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onFocus1 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_validateKeyEvent = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onKeyUp1 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onKeyDown1 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_nextIndex = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_getFocusableElements = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$var$MenuFocusController {
    get items() {
        return (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_elements);
    }
    attachMenu(el) {
        (0, $8B3mG.listenEvent)(el, "focus", (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onFocus1, $bb90bb562fcb86a3$var$onFocus1).bind(this));
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_el, el);
        (0, $8B3mG.onDispose)(()=>{
            (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_el, null);
        });
    }
    listen() {
        if (!(0, $57dmi._)(this, $bb90bb562fcb86a3$var$_el)) return;
        this.update();
        new (0, $8B3mG.EventsController)((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_el)).add("keyup", (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onKeyUp1, $bb90bb562fcb86a3$var$onKeyUp1).bind(this)).add("keydown", (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onKeyDown1, $bb90bb562fcb86a3$var$onKeyDown1).bind(this));
        (0, $8B3mG.onDispose)(()=>{
            (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_index, -1);
            (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_elements, []);
        });
    }
    update() {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_index, 0);
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_elements, (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getFocusableElements, $bb90bb562fcb86a3$var$getFocusableElements).call(this));
    }
    scroll(index = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_findActiveIndex, $bb90bb562fcb86a3$var$findActiveIndex).call(this)) {
        const element = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_elements)[index];
        if (element) requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                $bb90bb562fcb86a3$var$scrollIntoCenter(element, {
                    behavior: "smooth",
                    boundary: (el)=>{
                        return !el.hasAttribute("data-root");
                    }
                });
            });
        });
    }
    focusActive(scroll = true) {
        const index = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_findActiveIndex, $bb90bb562fcb86a3$var$findActiveIndex).call(this);
        (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_focusAt, $bb90bb562fcb86a3$var$focusAt).call(this, index >= 0 ? index : 0, scroll);
    }
    constructor(delegate){
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_focusAt);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_findActiveIndex);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onFocus1);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_validateKeyEvent);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onKeyUp1);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onKeyDown1);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_nextIndex);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getFocusableElements);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_index, {
            writable: true,
            value: -1
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_el, {
            writable: true,
            value: null
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_elements, {
            writable: true,
            value: []
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_delegate4, {
            writable: true,
            value: void 0
        });
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_delegate4, delegate);
    }
}
function $bb90bb562fcb86a3$var$focusAt(index, scroll = true) {
    (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_index, index);
    if ((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_elements)[index]) {
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_elements)[index].focus({
            preventScroll: true
        });
        if (scroll) this.scroll(index);
    } else (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_el)?.focus({
        preventScroll: true
    });
}
function $bb90bb562fcb86a3$var$findActiveIndex() {
    return (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_elements).findIndex((el)=>document.activeElement === el || el.getAttribute("role") === "menuitemradio" && el.getAttribute("aria-checked") === "true");
}
function $bb90bb562fcb86a3$var$onFocus1() {
    if ((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_index) >= 0) return;
    this.update();
    this.focusActive();
}
function $bb90bb562fcb86a3$var$validateKeyEvent(event) {
    const el = event.target;
    if ((0, $8B3mG.wasEnterKeyPressed)(event) && el instanceof Element) {
        const role = el.getAttribute("role");
        return !/a|input|select|button/.test(el.localName) && !role;
    }
    return $bb90bb562fcb86a3$var$VALID_KEYS.has(event.key);
}
function $bb90bb562fcb86a3$var$onKeyUp1(event) {
    if (!(0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_validateKeyEvent, $bb90bb562fcb86a3$var$validateKeyEvent).call(this, event)) return;
    event.stopPropagation();
    event.preventDefault();
}
function $bb90bb562fcb86a3$var$onKeyDown1(event) {
    if (!(0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_validateKeyEvent, $bb90bb562fcb86a3$var$validateKeyEvent).call(this, event)) return;
    event.stopPropagation();
    event.preventDefault();
    switch(event.key){
        case "Escape":
            (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_delegate4).closeMenu(event);
            break;
        case "Tab":
            (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_focusAt, $bb90bb562fcb86a3$var$focusAt).call(this, (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_nextIndex, $bb90bb562fcb86a3$var$nextIndex).call(this, event.shiftKey ? -1 : 1));
            break;
        case "ArrowUp":
            (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_focusAt, $bb90bb562fcb86a3$var$focusAt).call(this, (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_nextIndex, $bb90bb562fcb86a3$var$nextIndex).call(this, -1));
            break;
        case "ArrowDown":
            (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_focusAt, $bb90bb562fcb86a3$var$focusAt).call(this, (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_nextIndex, $bb90bb562fcb86a3$var$nextIndex).call(this, 1));
            break;
        case "Home":
        case "PageUp":
            (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_focusAt, $bb90bb562fcb86a3$var$focusAt).call(this, 0);
            break;
        case "End":
        case "PageDown":
            (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_focusAt, $bb90bb562fcb86a3$var$focusAt).call(this, (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_elements).length - 1);
            break;
    }
}
function $bb90bb562fcb86a3$var$nextIndex(delta) {
    let index = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_index);
    do index = (index + delta + (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_elements).length) % (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_elements).length;
    while ((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_elements)[index]?.offsetParent === null);
    return index;
}
function $bb90bb562fcb86a3$var$getFocusableElements() {
    if (!(0, $57dmi._)(this, $bb90bb562fcb86a3$var$_el)) return [];
    const focusableElements = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_el).querySelectorAll($bb90bb562fcb86a3$var$FOCUSABLE_ELEMENTS_SELECTOR), elements = [];
    const is = (node)=>{
        return node.getAttribute("role") === "menu";
    };
    for (const el of focusableElements)if ((0, $ciZW6.isHTMLElement)(el) && el.offsetParent !== null && // does not have display: none
    (0, $ciZW6.isElementParent)((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_el), el, is)) elements.push(el);
    return elements;
}
var $bb90bb562fcb86a3$var$__defProp = Object.defineProperty;
var $bb90bb562fcb86a3$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $bb90bb562fcb86a3$var$__decorateClass = (decorators, target, key, kind)=>{
    var result = $bb90bb562fcb86a3$var$__getOwnPropDesc(target, key);
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = decorator(target, key, result) || result;
    if (result) $bb90bb562fcb86a3$var$__defProp(target, key, result);
    return result;
};
let $bb90bb562fcb86a3$var$idCount = 0;
var $bb90bb562fcb86a3$var$_media13 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_menuId = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_menuButtonId = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_expanded = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_disabled = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_trigger = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_content = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_parentMenu = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_submenus = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_menuObserver = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_popper = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_focus = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_isSliderActive = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_isTriggerDisabled = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_transitionCallbacks = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_observeSliders = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchExpanded = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_attachMenuButton = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_attachMenuItems = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_attachObserver = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_updateMenuItemsHidden = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_disableMenuButton = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_wasKeyboardExpand = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_onExpandedChange = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_updateFocus = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_isExpanded = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_isDisabled2 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_disable = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onPointerUp = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onWindowPointerUp = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_getCloseTarget = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_toggleMediaControls = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_addSubmenu = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_removeSubmenuBind = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_removeSubmenu = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_isSubmenuOpen = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_onSubmenuOpenBind = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_onSubmenuOpen = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onSubmenuCloseBind = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_onSubmenuClose = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onResize = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_isTransitionActive = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_onResizeTransition = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$export$d9b273488cd8ce6f extends (0, $8B3mG.Component) {
    get triggerElement() {
        return (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_trigger).call(this);
    }
    get contentElement() {
        return (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_content).call(this);
    }
    get isSubmenu() {
        return !!(0, $57dmi._)(this, $bb90bb562fcb86a3$var$_parentMenu);
    }
    onSetup() {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_media13, (0, $6KfMo.useMediaContext)());
        const currentIdCount = ++$bb90bb562fcb86a3$var$idCount;
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_menuId, `media-menu-${currentIdCount}`);
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_menuButtonId, `media-menu-button-${currentIdCount}`);
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_focus, new $bb90bb562fcb86a3$var$MenuFocusController({
            closeMenu: this.close.bind(this)
        }));
        if ((0, $8B3mG.hasProvidedContext)($bb90bb562fcb86a3$export$eb1e9ed85beee4a5)) (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_parentMenu, (0, $8B3mG.useContext)($bb90bb562fcb86a3$export$eb1e9ed85beee4a5));
        (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_observeSliders, $bb90bb562fcb86a3$var$observeSliders).call(this);
        this.setAttributes({
            "data-open": (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_expanded),
            "data-root": !this.isSubmenu,
            "data-submenu": this.isSubmenu,
            "data-disabled": (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isDisabled2, $bb90bb562fcb86a3$var$isDisabled2).bind(this)
        });
        (0, $8B3mG.provideContext)($bb90bb562fcb86a3$export$eb1e9ed85beee4a5, {
            button: (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_trigger),
            content: (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_content),
            expanded: (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_expanded),
            hint: (0, $8B3mG.signal)(""),
            submenu: !!(0, $57dmi._)(this, $bb90bb562fcb86a3$var$_parentMenu),
            disable: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_disable, $bb90bb562fcb86a3$var$disable).bind(this),
            attachMenuButton: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_attachMenuButton, $bb90bb562fcb86a3$var$attachMenuButton).bind(this),
            attachMenuItems: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_attachMenuItems, $bb90bb562fcb86a3$var$attachMenuItems).bind(this),
            attachObserver: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_attachObserver, $bb90bb562fcb86a3$var$attachObserver).bind(this),
            disableMenuButton: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_disableMenuButton, $bb90bb562fcb86a3$var$disableMenuButton).bind(this),
            addSubmenu: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_addSubmenu, $bb90bb562fcb86a3$var$addSubmenu).bind(this),
            onTransitionEvent: (callback)=>{
                (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_transitionCallbacks).add(callback);
                (0, $8B3mG.onDispose)(()=>{
                    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_transitionCallbacks).delete(callback);
                });
            }
        });
    }
    onAttach(el) {
        el.style.setProperty("display", "contents");
    }
    onConnect(el) {
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchExpanded, $bb90bb562fcb86a3$var$watchExpanded).bind(this));
        if (this.isSubmenu) (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_parentMenu)?.addSubmenu(this);
    }
    onDestroy() {
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_trigger).set(null);
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_content).set(null);
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_menuObserver, null);
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_transitionCallbacks).clear();
    }
    open(trigger) {
        if ((0, $8B3mG.peek)((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_expanded))) return;
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_popper).show(trigger);
        (0, $8B3mG.tick)();
    }
    close(trigger) {
        if (!(0, $8B3mG.peek)((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_expanded))) return;
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_popper).hide(trigger);
        (0, $8B3mG.tick)();
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_observeSliders);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchExpanded);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_attachMenuButton);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_attachMenuItems);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_attachObserver);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_updateMenuItemsHidden);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_disableMenuButton);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onExpandedChange);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_updateFocus);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_isExpanded);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_isDisabled2);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_disable);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onPointerUp);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onWindowPointerUp);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getCloseTarget);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_toggleMediaControls);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_addSubmenu);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_removeSubmenu);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onSubmenuOpen);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onSubmenuClose);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onResizeTransition);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_media13, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_menuId, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_menuButtonId, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_expanded, {
            writable: true,
            value: (0, $8B3mG.signal)(false)
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_disabled, {
            writable: true,
            value: (0, $8B3mG.signal)(false)
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_trigger, {
            writable: true,
            value: (0, $8B3mG.signal)(null)
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_content, {
            writable: true,
            value: (0, $8B3mG.signal)(null)
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_parentMenu, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_submenus, {
            writable: true,
            value: /* @__PURE__ */ new Set()
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_menuObserver, {
            writable: true,
            value: null
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_popper, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_focus, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_isSliderActive, {
            writable: true,
            value: false
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_isTriggerDisabled, {
            writable: true,
            value: (0, $8B3mG.signal)(false)
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_transitionCallbacks, {
            writable: true,
            value: /* @__PURE__ */ new Set()
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_wasKeyboardExpand, {
            writable: true,
            value: false
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_removeSubmenuBind, {
            writable: true,
            value: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_removeSubmenu, $bb90bb562fcb86a3$var$removeSubmenu).bind(this)
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_isSubmenuOpen, {
            writable: true,
            value: false
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_onSubmenuOpenBind, {
            writable: true,
            value: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onSubmenuOpen, $bb90bb562fcb86a3$var$onSubmenuOpen).bind(this)
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_onSubmenuCloseBind, {
            writable: true,
            value: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onSubmenuClose, $bb90bb562fcb86a3$var$onSubmenuClose).bind(this)
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_onResize, {
            writable: true,
            value: (0, $8B3mG.animationFrameThrottle)(()=>{
                const content = (0, $8B3mG.peek)((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_content));
                if (!content || false) return;
                let height = 0, styles = getComputedStyle(content), children = [
                    ...content.children
                ];
                for (const prop2 of [
                    "paddingTop",
                    "paddingBottom",
                    "borderTopWidth",
                    "borderBottomWidth"
                ])height += parseFloat(styles[prop2]) || 0;
                for (const child of children){
                    if ((0, $ciZW6.isHTMLElement)(child) && child.style.display === "contents") children.push(...child.children);
                    else if (child.nodeType === 3) height += parseFloat(getComputedStyle(child).fontSize);
                    else if ((0, $ciZW6.isHTMLElement)(child)) {
                        if (!(0, $ciZW6.isElementVisible)(child)) continue;
                        const style = getComputedStyle(child);
                        height += child.offsetHeight + (parseFloat(style.marginTop) || 0) + (parseFloat(style.marginBottom) || 0);
                    }
                }
                (0, $8B3mG.setStyle)(content, "--menu-height", height + "px");
            })
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_isTransitionActive, {
            writable: true,
            value: false
        });
        const { showDelay: showDelay } = this.$props;
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_popper, new $bb90bb562fcb86a3$export$badac9ada3a0bdf9({
            trigger: (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_trigger),
            content: (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_content),
            showDelay: showDelay,
            listen: (trigger, show, hide)=>{
                (0, $ciZW6.onPress)(trigger, (event)=>{
                    if ((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_expanded).call(this)) hide(event);
                    else show(event);
                });
                const closeTarget = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getCloseTarget, $bb90bb562fcb86a3$var$getCloseTarget).call(this);
                if (closeTarget) (0, $ciZW6.onPress)(closeTarget, (event)=>{
                    event.stopPropagation();
                    hide(event);
                });
            },
            onChange: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onExpandedChange, $bb90bb562fcb86a3$var$onExpandedChange).bind(this)
        }));
    }
}
(0, $97zcJ._)($bb90bb562fcb86a3$export$d9b273488cd8ce6f, "props", {
    showDelay: 0
});
function $bb90bb562fcb86a3$var$observeSliders() {
    let sliderActiveTimer = -1, parentSliderObserver = (0, $8B3mG.hasProvidedContext)($bb90bb562fcb86a3$var$sliderObserverContext) ? (0, $8B3mG.useContext)($bb90bb562fcb86a3$var$sliderObserverContext) : null;
    (0, $8B3mG.provideContext)($bb90bb562fcb86a3$var$sliderObserverContext, {
        onDragStart: ()=>{
            parentSliderObserver?.onDragStart?.();
            window.clearTimeout(sliderActiveTimer);
            sliderActiveTimer = -1;
            (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_isSliderActive, true);
        },
        onDragEnd: ()=>{
            parentSliderObserver?.onDragEnd?.();
            sliderActiveTimer = window.setTimeout(()=>{
                (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_isSliderActive, false);
                sliderActiveTimer = -1;
            }, 300);
        }
    });
}
function $bb90bb562fcb86a3$var$watchExpanded() {
    const expanded = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isExpanded, $bb90bb562fcb86a3$var$isExpanded).call(this);
    if (!this.isSubmenu) (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_onResize).call(this);
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_updateMenuItemsHidden, $bb90bb562fcb86a3$var$updateMenuItemsHidden).call(this, expanded);
    if (!expanded) return;
    (0, $8B3mG.effect)(()=>{
        const { height: height } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media13).$state, content = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_content).call(this);
        content && (0, $8B3mG.setStyle)(content, "--player-height", height() + "px");
    });
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_focus).listen();
    this.listen("pointerup", (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onPointerUp, $bb90bb562fcb86a3$var$onPointerUp).bind(this));
    (0, $8B3mG.listenEvent)(window, "pointerup", (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onWindowPointerUp, $bb90bb562fcb86a3$var$onWindowPointerUp).bind(this));
}
function $bb90bb562fcb86a3$var$attachMenuButton(button) {
    const el = button.el, isMenuItem = this.isSubmenu, isARIADisabled = (0, $jrniq.$ariaBool)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isDisabled2, $bb90bb562fcb86a3$var$isDisabled2).bind(this));
    (0, $ciZW6.setAttributeIfEmpty)(el, "tabindex", isMenuItem ? "-1" : "0");
    (0, $ciZW6.setAttributeIfEmpty)(el, "role", isMenuItem ? "menuitem" : "button");
    (0, $8B3mG.setAttribute)(el, "id", (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_menuButtonId));
    (0, $8B3mG.setAttribute)(el, "aria-haspopup", "menu");
    (0, $8B3mG.setAttribute)(el, "aria-expanded", "false");
    (0, $8B3mG.setAttribute)(el, "data-root", !this.isSubmenu);
    (0, $8B3mG.setAttribute)(el, "data-submenu", this.isSubmenu);
    const watchAttrs = ()=>{
        (0, $8B3mG.setAttribute)(el, "data-open", (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_expanded).call(this));
        (0, $8B3mG.setAttribute)(el, "aria-disabled", isARIADisabled());
    };
    (0, $8B3mG.effect)(watchAttrs);
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_trigger).set(el);
    (0, $8B3mG.onDispose)(()=>{
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_trigger).set(null);
    });
}
function $bb90bb562fcb86a3$var$attachMenuItems(items) {
    const el = items.el;
    el.style.setProperty("display", "none");
    (0, $8B3mG.setAttribute)(el, "id", (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_menuId));
    (0, $ciZW6.setAttributeIfEmpty)(el, "role", "menu");
    (0, $ciZW6.setAttributeIfEmpty)(el, "tabindex", "-1");
    (0, $8B3mG.setAttribute)(el, "data-root", !this.isSubmenu);
    (0, $8B3mG.setAttribute)(el, "data-submenu", this.isSubmenu);
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_content).set(el);
    (0, $8B3mG.onDispose)(()=>(0, $57dmi._)(this, $bb90bb562fcb86a3$var$_content).set(null));
    const watchAttrs = ()=>(0, $8B3mG.setAttribute)(el, "data-open", (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_expanded).call(this));
    (0, $8B3mG.effect)(watchAttrs);
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_focus).attachMenu(el);
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_updateMenuItemsHidden, $bb90bb562fcb86a3$var$updateMenuItemsHidden).call(this, false);
    const onTransition = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onResizeTransition, $bb90bb562fcb86a3$var$onResizeTransition).bind(this);
    if (!this.isSubmenu) {
        items.listen("transitionstart", onTransition);
        items.listen("transitionend", onTransition);
        items.listen("animationend", (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_onResize));
        items.listen("vds-menu-resize", (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_onResize));
    } else (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_parentMenu)?.onTransitionEvent(onTransition);
}
function $bb90bb562fcb86a3$var$attachObserver(observer) {
    (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_menuObserver, observer);
}
function $bb90bb562fcb86a3$var$updateMenuItemsHidden(expanded) {
    const content = (0, $8B3mG.peek)((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_content));
    if (content) (0, $8B3mG.setAttribute)(content, "aria-hidden", (0, $8B3mG.ariaBool)(!expanded));
}
function $bb90bb562fcb86a3$var$disableMenuButton(disabled) {
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_isTriggerDisabled).set(disabled);
}
function $bb90bb562fcb86a3$var$onExpandedChange(isExpanded, event) {
    (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_wasKeyboardExpand, (0, $8B3mG.isKeyboardEvent)(event));
    event?.stopPropagation();
    if ((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_expanded).call(this) === isExpanded) return;
    if ((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isDisabled2, $bb90bb562fcb86a3$var$isDisabled2).call(this)) {
        if (isExpanded) (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_popper).hide(event);
        return;
    }
    this.el?.dispatchEvent(new Event("vds-menu-resize", {
        bubbles: true,
        composed: true
    }));
    const trigger = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_trigger).call(this), content = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_content).call(this);
    if (trigger) {
        (0, $8B3mG.setAttribute)(trigger, "aria-controls", isExpanded && (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_menuId));
        (0, $8B3mG.setAttribute)(trigger, "aria-expanded", (0, $8B3mG.ariaBool)(isExpanded));
    }
    if (content) (0, $8B3mG.setAttribute)(content, "aria-labelledby", isExpanded && (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_menuButtonId));
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_expanded).set(isExpanded);
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_toggleMediaControls, $bb90bb562fcb86a3$var$toggleMediaControls).call(this, event);
    (0, $8B3mG.tick)();
    if ((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_wasKeyboardExpand)) {
        if (isExpanded) content?.focus();
        else trigger?.focus();
        for (const el of [
            this.el,
            content
        ])el && el.setAttribute("data-keyboard", "");
    } else for (const el of [
        this.el,
        content
    ])el && el.removeAttribute("data-keyboard");
    this.dispatch(isExpanded ? "open" : "close", {
        trigger: event
    });
    if (isExpanded) {
        if (!this.isSubmenu && (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media13).activeMenu !== this) {
            (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media13).activeMenu?.close(event);
            (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media13).activeMenu = this;
        }
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_menuObserver)?.onOpen?.(event);
    } else {
        if (this.isSubmenu) for (const el of (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_submenus))el.close(event);
        else (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media13).activeMenu = null;
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_menuObserver)?.onClose?.(event);
    }
    if (isExpanded) requestAnimationFrame((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_updateFocus, $bb90bb562fcb86a3$var$updateFocus).bind(this));
}
function $bb90bb562fcb86a3$var$updateFocus() {
    if ((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_isTransitionActive) || (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_isSubmenuOpen)) return;
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_focus).update();
    requestAnimationFrame(()=>{
        if ((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_wasKeyboardExpand)) (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_focus).focusActive();
        else (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_focus).scroll();
    });
}
function $bb90bb562fcb86a3$var$isExpanded() {
    return !(0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_isDisabled2, $bb90bb562fcb86a3$var$isDisabled2).call(this) && (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_expanded).call(this);
}
function $bb90bb562fcb86a3$var$isDisabled2() {
    return (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_disabled).call(this) || (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_isTriggerDisabled).call(this);
}
function $bb90bb562fcb86a3$var$disable(disabled) {
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_disabled).set(disabled);
}
function $bb90bb562fcb86a3$var$onPointerUp(event) {
    const content = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_content).call(this);
    if ((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_isSliderActive) || content && (0, $ciZW6.isEventInside)(content, event)) return;
    event.stopPropagation();
}
function $bb90bb562fcb86a3$var$onWindowPointerUp(event) {
    const content = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_content).call(this);
    if ((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_isSliderActive) || content && (0, $ciZW6.isEventInside)(content, event)) return;
    this.close(event);
}
function $bb90bb562fcb86a3$var$getCloseTarget() {
    const target = this.el?.querySelector('[data-part="close-target"]');
    return this.el && target && (0, $ciZW6.isElementParent)(this.el, target, (node)=>node.getAttribute("role") === "menu") ? target : null;
}
function $bb90bb562fcb86a3$var$toggleMediaControls(trigger) {
    if (this.isSubmenu) return;
    if ((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_expanded).call(this)) (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media13).remote.pauseControls(trigger);
    else (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media13).remote.resumeControls(trigger);
}
function $bb90bb562fcb86a3$var$addSubmenu(menu) {
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_submenus).add(menu);
    new (0, $8B3mG.EventsController)(menu).add("open", (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_onSubmenuOpenBind)).add("close", (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_onSubmenuCloseBind));
    (0, $8B3mG.onDispose)((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_removeSubmenuBind));
}
function $bb90bb562fcb86a3$var$removeSubmenu(menu) {
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_submenus).delete(menu);
}
function $bb90bb562fcb86a3$var$onSubmenuOpen(event) {
    (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_isSubmenuOpen, true);
    const content = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_content).call(this);
    if (this.isSubmenu) this.triggerElement?.setAttribute("aria-hidden", "true");
    for (const target of (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_submenus)){
        if (target !== event.target) for (const el of [
            target.el,
            target.triggerElement
        ])el?.setAttribute("aria-hidden", "true");
    }
    if (content) {
        const el = event.target.el;
        for (const child of content.children){
            if (child.contains(el)) child.setAttribute("data-open", "");
            else if (child !== el) child.setAttribute("data-hidden", "");
        }
    }
}
function $bb90bb562fcb86a3$var$onSubmenuClose(event) {
    (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_isSubmenuOpen, false);
    const content = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_content).call(this);
    if (this.isSubmenu) this.triggerElement?.setAttribute("aria-hidden", "false");
    for (const target of (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_submenus))for (const el of [
        target.el,
        target.triggerElement
    ])el?.setAttribute("aria-hidden", "false");
    if (content) for (const child of content.children){
        child.removeAttribute("data-open");
        child.removeAttribute("data-hidden");
    }
}
function $bb90bb562fcb86a3$var$onResizeTransition(event) {
    const content = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_content).call(this);
    if (content && event.propertyName === "height") {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_isTransitionActive, event.type === "transitionstart");
        (0, $8B3mG.setAttribute)(content, "data-transition", (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_isTransitionActive) ? "height" : null);
        if ((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_expanded).call(this)) (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_updateFocus, $bb90bb562fcb86a3$var$updateFocus).call(this);
    }
    for (const callback of (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_transitionCallbacks))callback(event);
}
$bb90bb562fcb86a3$var$__decorateClass([
    (0, $8B3mG.prop)
], $bb90bb562fcb86a3$export$d9b273488cd8ce6f.prototype, "triggerElement");
$bb90bb562fcb86a3$var$__decorateClass([
    (0, $8B3mG.prop)
], $bb90bb562fcb86a3$export$d9b273488cd8ce6f.prototype, "contentElement");
$bb90bb562fcb86a3$var$__decorateClass([
    (0, $8B3mG.prop)
], $bb90bb562fcb86a3$export$d9b273488cd8ce6f.prototype, "isSubmenu");
$bb90bb562fcb86a3$var$__decorateClass([
    (0, $8B3mG.method)
], $bb90bb562fcb86a3$export$d9b273488cd8ce6f.prototype, "open");
$bb90bb562fcb86a3$var$__decorateClass([
    (0, $8B3mG.method)
], $bb90bb562fcb86a3$export$d9b273488cd8ce6f.prototype, "close");
var $bb90bb562fcb86a3$var$_menu = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_hintEl = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_watchDisabled1 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchHintEl = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onMutation = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$export$266a769812832828 extends (0, $8B3mG.Component) {
    get expanded() {
        return (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_menu)?.expanded() ?? false;
    }
    onSetup() {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_menu, (0, $8B3mG.useContext)($bb90bb562fcb86a3$export$eb1e9ed85beee4a5));
    }
    onAttach(el) {
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_menu).attachMenuButton(this);
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchDisabled1, $bb90bb562fcb86a3$var$watchDisabled1).bind(this));
        (0, $ciZW6.setAttributeIfEmpty)(el, "type", "button");
    }
    onConnect(el) {
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchHintEl, $bb90bb562fcb86a3$var$watchHintEl).bind(this));
        (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onMutation, $bb90bb562fcb86a3$var$onMutation).call(this);
        const mutations = new MutationObserver((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onMutation, $bb90bb562fcb86a3$var$onMutation).bind(this));
        mutations.observe(el, {
            attributeFilter: [
                "data-part"
            ],
            childList: true,
            subtree: true
        });
        (0, $8B3mG.onDispose)(()=>mutations.disconnect());
        (0, $ciZW6.onPress)(el, (trigger)=>{
            this.dispatch("select", {
                trigger: trigger
            });
        });
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchDisabled1);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchHintEl);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onMutation);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_menu, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_hintEl, {
            writable: true,
            value: (0, $8B3mG.signal)(null)
        });
        new (0, $jWjYZ.FocusVisibleController)();
    }
}
(0, $97zcJ._)($bb90bb562fcb86a3$export$266a769812832828, "props", {
    disabled: false
});
function $bb90bb562fcb86a3$var$watchDisabled1() {
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_menu).disableMenuButton(this.$props.disabled());
}
function $bb90bb562fcb86a3$var$watchHintEl() {
    const el = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_hintEl).call(this);
    if (!el) return;
    (0, $8B3mG.effect)(()=>{
        const text = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_menu).hint();
        if (text) el.textContent = text;
    });
}
function $bb90bb562fcb86a3$var$onMutation() {
    const hintEl = this.el?.querySelector('[data-part="hint"]');
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_hintEl).set(hintEl ?? null);
}
const $bb90bb562fcb86a3$var$menubutton__proto = $bb90bb562fcb86a3$export$266a769812832828.prototype;
(0, $8B3mG.prop)($bb90bb562fcb86a3$var$menubutton__proto, "expanded");
class $bb90bb562fcb86a3$export$2ce376c2cc3355c8 extends $bb90bb562fcb86a3$export$266a769812832828 {
}
var $bb90bb562fcb86a3$var$_target = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_media14 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_attachElement = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchDisabled2 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_portal = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_getContainer = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$export$793392f970497feb extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_media14, (0, $6KfMo.useMediaContext)());
        (0, $8B3mG.provideContext)($bb90bb562fcb86a3$export$660eba09ec4aa015, {
            attach: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_attachElement, $bb90bb562fcb86a3$var$attachElement).bind(this)
        });
    }
    onAttach(el) {
        el.style.setProperty("display", "contents");
    }
    // Need this so connect scope is defined.
    onConnect(el) {}
    onDestroy() {
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_target)?.remove();
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_target, null);
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_attachElement);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchDisabled2);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_portal);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getContainer);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_target, {
            writable: true,
            value: null
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_media14, {
            writable: true,
            value: void 0
        });
    }
}
(0, $97zcJ._)($bb90bb562fcb86a3$export$793392f970497feb, "props", {
    container: null,
    disabled: false
});
function $bb90bb562fcb86a3$var$attachElement(el) {
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_portal, $bb90bb562fcb86a3$var$portal).call(this, false);
    (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_target, el);
    (0, $ciZW6.requestScopedAnimationFrame)(()=>{
        (0, $ciZW6.requestScopedAnimationFrame)(()=>{
            if (!this.connectScope) return;
            (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchDisabled2, $bb90bb562fcb86a3$var$watchDisabled2).bind(this));
        });
    });
}
function $bb90bb562fcb86a3$var$watchDisabled2() {
    const { fullscreen: fullscreen } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media14).$state, { disabled: disabled } = this.$props;
    (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_portal, $bb90bb562fcb86a3$var$portal).call(this, disabled() === "fullscreen" ? !fullscreen() : !disabled());
}
function $bb90bb562fcb86a3$var$portal(shouldPortal) {
    if (!(0, $57dmi._)(this, $bb90bb562fcb86a3$var$_target)) return;
    let container = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getContainer, $bb90bb562fcb86a3$var$getContainer).call(this, this.$props.container());
    if (!container) return;
    const isPortalled = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_target).parentElement === container;
    (0, $8B3mG.setAttribute)((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_target), "data-portal", shouldPortal);
    if (shouldPortal) {
        if (!isPortalled) {
            (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_target).remove();
            container.append((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_target));
        }
    } else if (isPortalled && (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_target).parentElement === container) {
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_target).remove();
        this.el?.append((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_target));
    }
}
function $bb90bb562fcb86a3$var$getContainer(selector) {
    if ((0, $ciZW6.isHTMLElement)(selector)) return selector;
    return selector ? document.querySelector(selector) : document.body;
}
const $bb90bb562fcb86a3$export$660eba09ec4aa015 = (0, $8B3mG.createContext)();
var $bb90bb562fcb86a3$var$_menu1 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_watchPlacement = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_hide = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_getButton = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$export$15a41fea157b048a extends (0, $8B3mG.Component) {
    onAttach(el) {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_menu1, (0, $8B3mG.useContext)($bb90bb562fcb86a3$export$eb1e9ed85beee4a5));
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_menu1).attachMenuItems(this);
        if ((0, $8B3mG.hasProvidedContext)($bb90bb562fcb86a3$export$660eba09ec4aa015)) {
            const portal = (0, $8B3mG.useContext)($bb90bb562fcb86a3$export$660eba09ec4aa015);
            if (portal) {
                (0, $8B3mG.provideContext)($bb90bb562fcb86a3$export$660eba09ec4aa015, null);
                portal.attach(el);
                (0, $8B3mG.onDispose)(()=>portal.attach(null));
            }
        }
    }
    onConnect(el) {
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchPlacement, $bb90bb562fcb86a3$var$watchPlacement).bind(this));
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchPlacement);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_hide);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getButton);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_menu1, {
            writable: true,
            value: void 0
        });
        new (0, $jWjYZ.FocusVisibleController)();
        const { placement: placement } = this.$props;
        this.setAttributes({
            "data-placement": placement
        });
    }
}
(0, $97zcJ._)($bb90bb562fcb86a3$export$15a41fea157b048a, "props", {
    placement: null,
    offset: 0,
    alignOffset: 0
});
function $bb90bb562fcb86a3$var$watchPlacement() {
    const { expanded: expanded } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_menu1);
    if (!this.el || !expanded()) return;
    const placement = this.$props.placement();
    if (!placement) return;
    Object.assign(this.el.style, {
        position: "absolute",
        top: 0,
        left: 0,
        width: "max-content"
    });
    const { offset: mainOffset, alignOffset: alignOffset } = this.$props;
    (0, $8B3mG.onDispose)((0, $ciZW6.autoPlacement)(this.el, (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getButton, $bb90bb562fcb86a3$var$getButton).call(this), placement, {
        offsetVarName: "media-menu",
        xOffset: alignOffset(),
        yOffset: mainOffset()
    }));
    (0, $8B3mG.onDispose)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_hide, $bb90bb562fcb86a3$var$hide).bind(this));
}
function $bb90bb562fcb86a3$var$hide() {
    if (!this.el) return;
    this.el.removeAttribute("style");
    this.el.style.display = "none";
}
function $bb90bb562fcb86a3$var$getButton() {
    return (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_menu1).button();
}
const $bb90bb562fcb86a3$export$29450a5971d94a40 = (0, $8B3mG.createContext)();
var $bb90bb562fcb86a3$var$_group = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_value = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_controller = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_addRadio = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_removeRadio = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onChangeBind = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_onChange = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_findRadio = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$export$b6c81938ab9ab49c extends (0, $8B3mG.ViewController) {
    get values() {
        return Array.from((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_group)).map((radio)=>radio.value());
    }
    get value() {
        return (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_value).call(this);
    }
    set value(value) {
        (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onChange, $bb90bb562fcb86a3$var$onChange).call(this, value);
    }
    onSetup() {
        (0, $8B3mG.provideContext)($bb90bb562fcb86a3$export$29450a5971d94a40, {
            add: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_addRadio, $bb90bb562fcb86a3$var$addRadio).bind(this),
            remove: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_removeRadio, $bb90bb562fcb86a3$var$removeRadio).bind(this)
        });
    }
    onAttach(el) {
        const isMenuItem = (0, $8B3mG.hasProvidedContext)($bb90bb562fcb86a3$export$eb1e9ed85beee4a5);
        if (!isMenuItem) (0, $ciZW6.setAttributeIfEmpty)(el, "role", "radiogroup");
        this.setAttributes({
            value: (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_value)
        });
    }
    onDestroy() {
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_group).clear();
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_addRadio);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_removeRadio);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onChange);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_findRadio);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_group, {
            writable: true,
            value: /* @__PURE__ */ new Set()
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_value, {
            writable: true,
            value: (0, $8B3mG.signal)("")
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_controller, {
            writable: true,
            value: null
        });
        (0, $97zcJ._)(this, "onValueChange", void 0);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_onChangeBind, {
            writable: true,
            value: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onChange, $bb90bb562fcb86a3$var$onChange).bind(this)
        });
    }
}
function $bb90bb562fcb86a3$var$addRadio(radio) {
    if ((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_group).has(radio)) return;
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_group).add(radio);
    radio.onCheck = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_onChangeBind);
    radio.check(radio.value() === (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_value).call(this));
}
function $bb90bb562fcb86a3$var$removeRadio(radio) {
    radio.onCheck = null;
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_group).delete(radio);
}
function $bb90bb562fcb86a3$var$onChange(newValue, trigger) {
    const currentValue = (0, $8B3mG.peek)((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_value));
    if (!newValue || newValue === currentValue) return;
    const currentRadio = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_findRadio, $bb90bb562fcb86a3$var$findRadio).call(this, currentValue), newRadio = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_findRadio, $bb90bb562fcb86a3$var$findRadio).call(this, newValue);
    currentRadio?.check(false, trigger);
    newRadio?.check(true, trigger);
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_value).set(newValue);
    this.onValueChange?.(newValue, trigger);
}
function $bb90bb562fcb86a3$var$findRadio(newValue) {
    for (const radio of (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_group)){
        if (newValue === (0, $8B3mG.peek)(radio.value)) return radio;
    }
    return null;
}
var $bb90bb562fcb86a3$var$_menu2 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_media15 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_controller1 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_watchValue2 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchHintText = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchControllerDisabled = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_getValue1 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onValueChange2 = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$export$ff8295f298e1a1e extends (0, $8B3mG.Component) {
    get value() {
        return (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_controller1).value;
    }
    get disabled() {
        const { audioTracks: audioTracks } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media15).$state;
        return audioTracks().length <= 1;
    }
    onSetup() {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_media15, (0, $6KfMo.useMediaContext)());
        if ((0, $8B3mG.hasProvidedContext)($bb90bb562fcb86a3$export$eb1e9ed85beee4a5)) (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_menu2, (0, $8B3mG.useContext)($bb90bb562fcb86a3$export$eb1e9ed85beee4a5));
    }
    onConnect(el) {
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchValue2, $bb90bb562fcb86a3$var$watchValue2).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchControllerDisabled, $bb90bb562fcb86a3$var$watchControllerDisabled).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchHintText, $bb90bb562fcb86a3$var$watchHintText).bind(this));
    }
    getOptions() {
        const { audioTracks: audioTracks } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media15).$state;
        return audioTracks().map((track)=>({
                track: track,
                label: track.label,
                value: track.label.toLowerCase()
            }));
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchValue2);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchHintText);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchControllerDisabled);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getValue1);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onValueChange2);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_menu2, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_media15, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_controller1, {
            writable: true,
            value: void 0
        });
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_controller1, new $bb90bb562fcb86a3$export$b6c81938ab9ab49c());
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_controller1).onValueChange = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onValueChange2, $bb90bb562fcb86a3$var$onValueChange2).bind(this);
    }
}
(0, $97zcJ._)($bb90bb562fcb86a3$export$ff8295f298e1a1e, "props", {
    emptyLabel: "Default"
});
function $bb90bb562fcb86a3$var$watchValue2() {
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_controller1).value = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getValue1, $bb90bb562fcb86a3$var$getValue1).call(this);
}
function $bb90bb562fcb86a3$var$watchHintText() {
    const { emptyLabel: emptyLabel } = this.$props, { audioTrack: audioTrack } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media15).$state, track = audioTrack();
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_menu2)?.hint.set(track?.label ?? emptyLabel());
}
function $bb90bb562fcb86a3$var$watchControllerDisabled() {
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_menu2)?.disable(this.disabled);
}
function $bb90bb562fcb86a3$var$getValue1() {
    const { audioTrack: audioTrack } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media15).$state;
    const track = audioTrack();
    return track ? track.label.toLowerCase() : "";
}
function $bb90bb562fcb86a3$var$onValueChange2(value, trigger) {
    if (this.disabled) return;
    const index = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media15).audioTracks.toArray().findIndex((track)=>track.label.toLowerCase() === value);
    if (index >= 0) {
        const track = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media15).audioTracks[index];
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media15).remote.changeAudioTrack(index, trigger);
        this.dispatch("change", {
            detail: track,
            trigger: trigger
        });
    }
}
const $bb90bb562fcb86a3$var$audioradiogroup__proto = $bb90bb562fcb86a3$export$ff8295f298e1a1e.prototype;
(0, $8B3mG.prop)($bb90bb562fcb86a3$var$audioradiogroup__proto, "value");
(0, $8B3mG.prop)($bb90bb562fcb86a3$var$audioradiogroup__proto, "disabled");
(0, $8B3mG.method)($bb90bb562fcb86a3$var$audioradiogroup__proto, "getOptions");
var $bb90bb562fcb86a3$var$_media16 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_menu3 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_controller2 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_watchValue3 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchHintText1 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchControllerDisabled1 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_getValue2 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onValueChange3 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_getTrackValue = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$export$47dbee46003f5b8d extends (0, $8B3mG.Component) {
    get value() {
        return (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_controller2).value;
    }
    get disabled() {
        const { hasCaptions: hasCaptions } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media16).$state;
        return !hasCaptions();
    }
    onSetup() {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_media16, (0, $6KfMo.useMediaContext)());
        if ((0, $8B3mG.hasProvidedContext)($bb90bb562fcb86a3$export$eb1e9ed85beee4a5)) (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_menu3, (0, $8B3mG.useContext)($bb90bb562fcb86a3$export$eb1e9ed85beee4a5));
    }
    onConnect(el) {
        super.onConnect?.(el);
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchValue3, $bb90bb562fcb86a3$var$watchValue3).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchControllerDisabled1, $bb90bb562fcb86a3$var$watchControllerDisabled1).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchHintText1, $bb90bb562fcb86a3$var$watchHintText1).bind(this));
    }
    getOptions() {
        const { offLabel: offLabel } = this.$props, { textTracks: textTracks } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media16).$state;
        return [
            {
                value: "off",
                label: offLabel
            },
            ...textTracks().filter((0, $ihjXw.isTrackCaptionKind)).map((track)=>({
                    track: track,
                    label: track.label,
                    value: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getTrackValue, $bb90bb562fcb86a3$var$getTrackValue).call(this, track)
                }))
        ];
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchValue3);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchHintText1);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchControllerDisabled1);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getValue2);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onValueChange3);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getTrackValue);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_media16, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_menu3, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_controller2, {
            writable: true,
            value: void 0
        });
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_controller2, new $bb90bb562fcb86a3$export$b6c81938ab9ab49c());
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_controller2).onValueChange = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onValueChange3, $bb90bb562fcb86a3$var$onValueChange3).bind(this);
    }
}
(0, $97zcJ._)($bb90bb562fcb86a3$export$47dbee46003f5b8d, "props", {
    offLabel: "Off"
});
function $bb90bb562fcb86a3$var$watchValue3() {
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_controller2).value = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getValue2, $bb90bb562fcb86a3$var$getValue2).call(this);
}
function $bb90bb562fcb86a3$var$watchHintText1() {
    const { offLabel: offLabel } = this.$props, { textTrack: textTrack } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media16).$state, track = textTrack();
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_menu3)?.hint.set(track && (0, $ihjXw.isTrackCaptionKind)(track) && track.mode === "showing" ? track.label : offLabel());
}
function $bb90bb562fcb86a3$var$watchControllerDisabled1() {
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_menu3)?.disable(this.disabled);
}
function $bb90bb562fcb86a3$var$getValue2() {
    const { textTrack: textTrack } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media16).$state, track = textTrack();
    return track && (0, $ihjXw.isTrackCaptionKind)(track) && track.mode === "showing" ? (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getTrackValue, $bb90bb562fcb86a3$var$getTrackValue).call(this, track) : "off";
}
function $bb90bb562fcb86a3$var$onValueChange3(value, trigger) {
    if (this.disabled) return;
    if (value === "off") {
        const track = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media16).textTracks.selected;
        if (track) {
            const index2 = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media16).textTracks.indexOf(track);
            (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media16).remote.changeTextTrackMode(index2, "disabled", trigger);
            this.dispatch("change", {
                detail: null,
                trigger: trigger
            });
        }
        return;
    }
    const index = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media16).textTracks.toArray().findIndex((track)=>(0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getTrackValue, $bb90bb562fcb86a3$var$getTrackValue).call(this, track) === value);
    if (index >= 0) {
        const track = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media16).textTracks[index];
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media16).remote.changeTextTrackMode(index, "showing", trigger);
        this.dispatch("change", {
            detail: track,
            trigger: trigger
        });
    }
}
function $bb90bb562fcb86a3$var$getTrackValue(track) {
    return track.id + ":" + track.kind + "-" + track.label.toLowerCase();
}
const $bb90bb562fcb86a3$var$captionsradiogroup__proto = $bb90bb562fcb86a3$export$47dbee46003f5b8d.prototype;
(0, $8B3mG.prop)($bb90bb562fcb86a3$var$captionsradiogroup__proto, "value");
(0, $8B3mG.prop)($bb90bb562fcb86a3$var$captionsradiogroup__proto, "disabled");
(0, $8B3mG.method)($bb90bb562fcb86a3$var$captionsradiogroup__proto, "getOptions");
const $bb90bb562fcb86a3$export$3aeb36203c91d73a = [
    0.25,
    0.5,
    0.75,
    1,
    1.25,
    1.5,
    1.75,
    2
];
var $bb90bb562fcb86a3$var$_media17 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_menu4 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_controller3 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_watchValue4 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchHintText2 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchControllerDisabled2 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_getValue3 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onValueChange4 = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$export$a35c36feac690f18 extends (0, $8B3mG.Component) {
    get value() {
        return (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_controller3).value;
    }
    get disabled() {
        const { rates: rates } = this.$props, { canSetPlaybackRate: canSetPlaybackRate } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media17).$state;
        return !canSetPlaybackRate() || rates().length === 0;
    }
    onSetup() {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_media17, (0, $6KfMo.useMediaContext)());
        if ((0, $8B3mG.hasProvidedContext)($bb90bb562fcb86a3$export$eb1e9ed85beee4a5)) (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_menu4, (0, $8B3mG.useContext)($bb90bb562fcb86a3$export$eb1e9ed85beee4a5));
    }
    onConnect(el) {
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchValue4, $bb90bb562fcb86a3$var$watchValue4).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchHintText2, $bb90bb562fcb86a3$var$watchHintText2).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchControllerDisabled2, $bb90bb562fcb86a3$var$watchControllerDisabled2).bind(this));
    }
    getOptions() {
        const { rates: rates, normalLabel: normalLabel } = this.$props;
        return rates().map((rate)=>({
                label: rate === 1 ? normalLabel : rate + "\xd7",
                value: rate.toString()
            }));
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchValue4);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchHintText2);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchControllerDisabled2);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getValue3);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onValueChange4);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_media17, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_menu4, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_controller3, {
            writable: true,
            value: void 0
        });
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_controller3, new $bb90bb562fcb86a3$export$b6c81938ab9ab49c());
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_controller3).onValueChange = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onValueChange4, $bb90bb562fcb86a3$var$onValueChange4).bind(this);
    }
}
(0, $97zcJ._)($bb90bb562fcb86a3$export$a35c36feac690f18, "props", {
    normalLabel: "Normal",
    rates: $bb90bb562fcb86a3$export$3aeb36203c91d73a
});
function $bb90bb562fcb86a3$var$watchValue4() {
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_controller3).value = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getValue3, $bb90bb562fcb86a3$var$getValue3).call(this);
}
function $bb90bb562fcb86a3$var$watchHintText2() {
    const { normalLabel: normalLabel } = this.$props, { playbackRate: playbackRate } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media17).$state, rate = playbackRate();
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_menu4)?.hint.set(rate === 1 ? normalLabel() : rate + "\xd7");
}
function $bb90bb562fcb86a3$var$watchControllerDisabled2() {
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_menu4)?.disable(this.disabled);
}
function $bb90bb562fcb86a3$var$getValue3() {
    const { playbackRate: playbackRate } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media17).$state;
    return playbackRate().toString();
}
function $bb90bb562fcb86a3$var$onValueChange4(value, trigger) {
    if (this.disabled) return;
    const rate = +value;
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media17).remote.changePlaybackRate(rate, trigger);
    this.dispatch("change", {
        detail: rate,
        trigger: trigger
    });
}
const $bb90bb562fcb86a3$var$speedradiogroup__proto = $bb90bb562fcb86a3$export$a35c36feac690f18.prototype;
(0, $8B3mG.prop)($bb90bb562fcb86a3$var$speedradiogroup__proto, "value");
(0, $8B3mG.prop)($bb90bb562fcb86a3$var$speedradiogroup__proto, "disabled");
(0, $8B3mG.method)($bb90bb562fcb86a3$var$speedradiogroup__proto, "getOptions");
var $bb90bb562fcb86a3$var$_media18 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_menu5 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_controller4 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_sortedQualities = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_watchValue5 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchHintText3 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchControllerDisabled3 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onValueChange5 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_getValue4 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_getQualityId = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$export$d91da3a1ef0bdb9e extends (0, $8B3mG.Component) {
    get value() {
        return (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_controller4).value;
    }
    get disabled() {
        const { canSetQuality: canSetQuality, qualities: qualities } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media18).$state;
        return !canSetQuality() || qualities().length <= 1;
    }
    onSetup() {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_media18, (0, $6KfMo.useMediaContext)());
        if ((0, $8B3mG.hasProvidedContext)($bb90bb562fcb86a3$export$eb1e9ed85beee4a5)) (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_menu5, (0, $8B3mG.useContext)($bb90bb562fcb86a3$export$eb1e9ed85beee4a5));
    }
    onConnect(el) {
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchValue5, $bb90bb562fcb86a3$var$watchValue5).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchControllerDisabled3, $bb90bb562fcb86a3$var$watchControllerDisabled3).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchHintText3, $bb90bb562fcb86a3$var$watchHintText3).bind(this));
    }
    getOptions() {
        const { autoLabel: autoLabel, hideBitrate: hideBitrate } = this.$props;
        return [
            {
                value: "auto",
                label: autoLabel
            },
            ...(0, $57dmi._)(this, $bb90bb562fcb86a3$var$_sortedQualities).call(this).map((quality)=>{
                const bitrate = quality.bitrate && quality.bitrate >= 0 ? `${(0, $hzYuC.round)(quality.bitrate / 1e6, 2)} Mbps` : null;
                return {
                    quality: quality,
                    label: quality.height + "p",
                    value: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getQualityId, $bb90bb562fcb86a3$var$getQualityId).call(this, quality),
                    bitrate: ()=>!hideBitrate() ? bitrate : null
                };
            })
        ];
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchValue5);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchHintText3);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchControllerDisabled3);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onValueChange5);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getValue4);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getQualityId);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_media18, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_menu5, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_controller4, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_sortedQualities, {
            writable: true,
            value: (0, $8B3mG.computed)(()=>{
                const { sort: sort } = this.$props, { qualities: qualities } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media18).$state;
                return (0, $jrniq.sortVideoQualities)(qualities(), sort() === "descending");
            })
        });
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_controller4, new $bb90bb562fcb86a3$export$b6c81938ab9ab49c());
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_controller4).onValueChange = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onValueChange5, $bb90bb562fcb86a3$var$onValueChange5).bind(this);
    }
}
(0, $97zcJ._)($bb90bb562fcb86a3$export$d91da3a1ef0bdb9e, "props", {
    autoLabel: "Auto",
    hideBitrate: false,
    sort: "descending"
});
function $bb90bb562fcb86a3$var$watchValue5() {
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_controller4).value = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getValue4, $bb90bb562fcb86a3$var$getValue4).call(this);
}
function $bb90bb562fcb86a3$var$watchHintText3() {
    const { autoLabel: autoLabel } = this.$props, { autoQuality: autoQuality, quality: quality } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media18).$state, qualityText = quality() ? quality().height + "p" : "";
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_menu5)?.hint.set(!autoQuality() ? qualityText : autoLabel() + (qualityText ? ` (${qualityText})` : ""));
}
function $bb90bb562fcb86a3$var$watchControllerDisabled3() {
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_menu5)?.disable(this.disabled);
}
function $bb90bb562fcb86a3$var$onValueChange5(value, trigger) {
    if (this.disabled) return;
    if (value === "auto") {
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media18).remote.changeQuality(-1, trigger);
        this.dispatch("change", {
            detail: "auto",
            trigger: trigger
        });
        return;
    }
    const { qualities: qualities } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media18).$state, index = (0, $8B3mG.peek)(qualities).findIndex((quality)=>(0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getQualityId, $bb90bb562fcb86a3$var$getQualityId).call(this, quality) === value);
    if (index >= 0) {
        const quality = (0, $8B3mG.peek)(qualities)[index];
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media18).remote.changeQuality(index, trigger);
        this.dispatch("change", {
            detail: quality,
            trigger: trigger
        });
    }
}
function $bb90bb562fcb86a3$var$getValue4() {
    const { quality: quality, autoQuality: autoQuality } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media18).$state;
    if (autoQuality()) return "auto";
    const currentQuality = quality();
    return currentQuality ? (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getQualityId, $bb90bb562fcb86a3$var$getQualityId).call(this, currentQuality) : "auto";
}
function $bb90bb562fcb86a3$var$getQualityId(quality) {
    return quality.height + "_" + quality.bitrate;
}
const $bb90bb562fcb86a3$var$qualityradiogroup__proto = $bb90bb562fcb86a3$export$d91da3a1ef0bdb9e.prototype;
(0, $8B3mG.prop)($bb90bb562fcb86a3$var$qualityradiogroup__proto, "value");
(0, $8B3mG.prop)($bb90bb562fcb86a3$var$qualityradiogroup__proto, "disabled");
(0, $8B3mG.method)($bb90bb562fcb86a3$var$qualityradiogroup__proto, "getOptions");
var $bb90bb562fcb86a3$var$_media19 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_invert = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_isVisible1 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_isIntersecting1 = /*#__PURE__*/ new WeakMap(), $bb90bb562fcb86a3$var$_onIntersectionChange1 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchHidden2 = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchToggle = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchTime = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_watchRole = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_getSeconds = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_shouldInvert = /*#__PURE__*/ new WeakSet(), $bb90bb562fcb86a3$var$_onToggle = /*#__PURE__*/ new WeakSet();
class $bb90bb562fcb86a3$export$680ea196effce5f extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $4vwVC._)(this, $bb90bb562fcb86a3$var$_media19, (0, $6KfMo.useMediaContext)());
        (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchTime, $bb90bb562fcb86a3$var$watchTime).call(this);
        const { type: type } = this.$props;
        this.setAttributes({
            "data-type": type,
            "data-remainder": (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_shouldInvert, $bb90bb562fcb86a3$var$shouldInvert).bind(this)
        });
        new $bb90bb562fcb86a3$var$IntersectionObserverController({
            callback: (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onIntersectionChange1, $bb90bb562fcb86a3$var$onIntersectionChange1).bind(this)
        }).attach(this);
    }
    onAttach(el) {
        if (!el.hasAttribute("role")) (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchRole, $bb90bb562fcb86a3$var$watchRole).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchTime, $bb90bb562fcb86a3$var$watchTime).bind(this));
    }
    onConnect(el) {
        (0, $8B3mG.onDispose)((0, $ciZW6.observeVisibility)(el, (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_isVisible1).set));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchHidden2, $bb90bb562fcb86a3$var$watchHidden2).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_watchToggle, $bb90bb562fcb86a3$var$watchToggle).bind(this));
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onIntersectionChange1);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchHidden2);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchToggle);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchTime);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_watchRole);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_getSeconds);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_shouldInvert);
        (0, $9P4tJ._)(this, $bb90bb562fcb86a3$var$_onToggle);
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_media19, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_invert, {
            writable: true,
            value: (0, $8B3mG.signal)(null)
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_isVisible1, {
            writable: true,
            value: (0, $8B3mG.signal)(true)
        });
        (0, $fhH8k._)(this, $bb90bb562fcb86a3$var$_isIntersecting1, {
            writable: true,
            value: (0, $8B3mG.signal)(true)
        });
    }
}
(0, $97zcJ._)($bb90bb562fcb86a3$export$680ea196effce5f, "props", {
    type: "current",
    showHours: false,
    padHours: null,
    padMinutes: null,
    remainder: false,
    toggle: false,
    hidden: false
});
(0, $97zcJ._)($bb90bb562fcb86a3$export$680ea196effce5f, "state", new (0, $8B3mG.State)({
    timeText: "",
    hidden: false
}));
function $bb90bb562fcb86a3$var$onIntersectionChange1(entries) {
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_isIntersecting1).set(entries[0].isIntersecting);
}
function $bb90bb562fcb86a3$var$watchHidden2() {
    const { hidden: hidden } = this.$props;
    this.$state.hidden.set(hidden() || !(0, $57dmi._)(this, $bb90bb562fcb86a3$var$_isVisible1).call(this) || !(0, $57dmi._)(this, $bb90bb562fcb86a3$var$_isIntersecting1).call(this));
}
function $bb90bb562fcb86a3$var$watchToggle() {
    if (!this.$props.toggle()) {
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_invert).set(null);
        return;
    }
    if (this.el) (0, $ciZW6.onPress)(this.el, (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_onToggle, $bb90bb562fcb86a3$var$onToggle).bind(this));
}
function $bb90bb562fcb86a3$var$watchTime() {
    const { hidden: hidden, timeText: timeText } = this.$state, { duration: duration } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media19).$state;
    if (hidden()) return;
    const { type: type, padHours: padHours, padMinutes: padMinutes, showHours: showHours } = this.$props, seconds = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_getSeconds, $bb90bb562fcb86a3$var$getSeconds).call(this, type()), $duration = duration(), shouldInvert1 = (0, $2u9SC._)(this, $bb90bb562fcb86a3$var$_shouldInvert, $bb90bb562fcb86a3$var$shouldInvert).call(this);
    if (!Number.isFinite(seconds + $duration)) {
        timeText.set("LIVE");
        return;
    }
    const time = shouldInvert1 ? Math.max(0, $duration - seconds) : seconds, formattedTime = $bb90bb562fcb86a3$export$3203edd9e5edd663(time, {
        padHrs: padHours(),
        padMins: padMinutes(),
        showHrs: showHours()
    });
    timeText.set((shouldInvert1 ? "-" : "") + formattedTime);
}
function $bb90bb562fcb86a3$var$watchRole() {
    if (!this.el) return;
    const { toggle: toggle } = this.$props;
    (0, $8B3mG.setAttribute)(this.el, "role", toggle() ? "timer" : null);
    (0, $8B3mG.setAttribute)(this.el, "tabindex", toggle() ? 0 : null);
}
function $bb90bb562fcb86a3$var$getSeconds(type) {
    const { bufferedEnd: bufferedEnd, duration: duration, currentTime: currentTime } = (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_media19).$state;
    switch(type){
        case "buffered":
            return bufferedEnd();
        case "duration":
            return duration();
        default:
            return currentTime();
    }
}
function $bb90bb562fcb86a3$var$shouldInvert() {
    return this.$props.remainder() && (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_invert).call(this) !== false;
}
function $bb90bb562fcb86a3$var$onToggle(event) {
    event.preventDefault();
    if ((0, $57dmi._)(this, $bb90bb562fcb86a3$var$_invert).call(this) === null) {
        (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_invert).set(!this.$props.remainder());
        return;
    }
    (0, $57dmi._)(this, $bb90bb562fcb86a3$var$_invert).set((v)=>!v);
}

});


parcelRegister("itCve", function(module, exports) {

$parcel$export(module.exports, "MediaThumbnailElement", function () { return $d738cd3fbf7c09c7$export$b6dbc3aade9d3908; });
$parcel$export(module.exports, "MediaTimeElement", function () { return $d738cd3fbf7c09c7$export$84bb446c8ff8058f; });
$parcel$export(module.exports, "MediaAirPlayButtonElement", function () { return $d738cd3fbf7c09c7$export$61d38296db29f3a8; });
$parcel$export(module.exports, "MediaCaptionButtonElement", function () { return $d738cd3fbf7c09c7$export$3cf150422f3e89bd; });
$parcel$export(module.exports, "MediaFullscreenButtonElement", function () { return $d738cd3fbf7c09c7$export$2963038141f68f8b; });
$parcel$export(module.exports, "MediaLiveButtonElement", function () { return $d738cd3fbf7c09c7$export$3a75f6f34ae6aef1; });
$parcel$export(module.exports, "MediaMuteButtonElement", function () { return $d738cd3fbf7c09c7$export$259a77807e473246; });
$parcel$export(module.exports, "MediaPIPButtonElement", function () { return $d738cd3fbf7c09c7$export$97ecd5d9148f064c; });
$parcel$export(module.exports, "MediaPlayButtonElement", function () { return $d738cd3fbf7c09c7$export$1970834309f67fec; });
$parcel$export(module.exports, "MediaSeekButtonElement", function () { return $d738cd3fbf7c09c7$export$f3e668187ff10e4; });
$parcel$export(module.exports, "renderMenuItemsTemplate", function () { return $d738cd3fbf7c09c7$export$3d4754607f42da89; });
$parcel$export(module.exports, "MediaAudioRadioGroupElement", function () { return $d738cd3fbf7c09c7$export$5585416b47137530; });
$parcel$export(module.exports, "MediaCaptionsRadioGroupElement", function () { return $d738cd3fbf7c09c7$export$dd4a911d266c3dc5; });
$parcel$export(module.exports, "MediaMenuElement", function () { return $d738cd3fbf7c09c7$export$84682bd3a2f19c19; });
$parcel$export(module.exports, "MediaMenuButtonElement", function () { return $d738cd3fbf7c09c7$export$84c3802386d473a2; });
$parcel$export(module.exports, "MediaMenuItemElement", function () { return $d738cd3fbf7c09c7$export$b5b1db1c396a37b7; });
$parcel$export(module.exports, "MediaMenuItemsElement", function () { return $d738cd3fbf7c09c7$export$4471944ea03b89c9; });
$parcel$export(module.exports, "MediaSpeedRadioGroupElement", function () { return $d738cd3fbf7c09c7$export$ab30e5be1481f45c; });
$parcel$export(module.exports, "MediaQualityRadioGroupElement", function () { return $d738cd3fbf7c09c7$export$fb4687c81ce40181; });
$parcel$export(module.exports, "MediaSliderThumbnailElement", function () { return $d738cd3fbf7c09c7$export$c13ec3177c166afc; });
$parcel$export(module.exports, "MediaSliderValueElement", function () { return $d738cd3fbf7c09c7$export$5bd744dcbbe4d2d9; });
$parcel$export(module.exports, "MediaTimeSliderElement", function () { return $d738cd3fbf7c09c7$export$d889d8168135b8a9; });
$parcel$export(module.exports, "MediaSliderPreviewElement", function () { return $d738cd3fbf7c09c7$export$8800d14ce45bc251; });
$parcel$export(module.exports, "MediaVolumeSliderElement", function () { return $d738cd3fbf7c09c7$export$951914e9cacacde0; });

var $57dmi = parcelRequire("57dmi");

var $fhH8k = parcelRequire("fhH8k");

var $4vwVC = parcelRequire("4vwVC");

var $2u9SC = parcelRequire("2u9SC");

var $9P4tJ = parcelRequire("9P4tJ");

var $97zcJ = parcelRequire("97zcJ");

var $8B3mG = parcelRequire("8B3mG");

var $g6paF = parcelRequire("g6paF");

var $ciZW6 = parcelRequire("ciZW6");

var $6KfMo = parcelRequire("6KfMo");
const $d738cd3fbf7c09c7$var$imgTemplate = /* @__PURE__ */ (0, $ciZW6.createTemplate)('<img loading="eager" decoding="async" aria-hidden="true">');
var $d738cd3fbf7c09c7$var$_Host, $d738cd3fbf7c09c7$var$_media = /*#__PURE__*/ new WeakMap(), $d738cd3fbf7c09c7$var$_img = /*#__PURE__*/ new WeakMap(), $d738cd3fbf7c09c7$var$_createImg = /*#__PURE__*/ new WeakSet();
class $d738cd3fbf7c09c7$export$b6dbc3aade9d3908 extends ($d738cd3fbf7c09c7$var$_Host = (0, $8B3mG.Host)(HTMLElement, (0, $g6paF.Thumbnail))) {
    onSetup() {
        (0, $4vwVC._)(this, $d738cd3fbf7c09c7$var$_media, (0, $6KfMo.useMediaContext)());
        this.$state.img.set((0, $57dmi._)(this, $d738cd3fbf7c09c7$var$_img));
    }
    onConnect() {
        const { src: src, crossOrigin: crossOrigin } = this.$state;
        if ((0, $57dmi._)(this, $d738cd3fbf7c09c7$var$_img).parentNode !== this) this.prepend((0, $57dmi._)(this, $d738cd3fbf7c09c7$var$_img));
        (0, $8B3mG.effect)(()=>{
            (0, $8B3mG.setAttribute)((0, $57dmi._)(this, $d738cd3fbf7c09c7$var$_img), "src", src());
            (0, $8B3mG.setAttribute)((0, $57dmi._)(this, $d738cd3fbf7c09c7$var$_img), "crossorigin", crossOrigin());
        });
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $d738cd3fbf7c09c7$var$_createImg);
        (0, $fhH8k._)(this, $d738cd3fbf7c09c7$var$_media, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $d738cd3fbf7c09c7$var$_img, {
            writable: true,
            value: (0, $2u9SC._)(this, $d738cd3fbf7c09c7$var$_createImg, $d738cd3fbf7c09c7$var$createImg).call(this)
        });
    }
}
(0, $97zcJ._)($d738cd3fbf7c09c7$export$b6dbc3aade9d3908, "tagName", "media-thumbnail");
(0, $97zcJ._)($d738cd3fbf7c09c7$export$b6dbc3aade9d3908, "attrs", {
    crossOrigin: "crossorigin"
});
function $d738cd3fbf7c09c7$var$createImg() {
    return (0, $ciZW6.cloneTemplateContent)($d738cd3fbf7c09c7$var$imgTemplate);
}
var $d738cd3fbf7c09c7$var$_Host1;
class $d738cd3fbf7c09c7$export$84bb446c8ff8058f extends ($d738cd3fbf7c09c7$var$_Host1 = (0, $8B3mG.Host)(HTMLElement, (0, $g6paF.Time))) {
    onConnect() {
        (0, $8B3mG.effect)(()=>{
            this.textContent = this.$state.timeText();
        });
    }
}
(0, $97zcJ._)($d738cd3fbf7c09c7$export$84bb446c8ff8058f, "tagName", "media-time");
var $d738cd3fbf7c09c7$var$_Host2;
class $d738cd3fbf7c09c7$export$61d38296db29f3a8 extends ($d738cd3fbf7c09c7$var$_Host2 = (0, $8B3mG.Host)(HTMLElement, (0, $g6paF.AirPlayButton))) {
}
(0, $97zcJ._)($d738cd3fbf7c09c7$export$61d38296db29f3a8, "tagName", "media-airplay-button");
var $d738cd3fbf7c09c7$var$_Host3;
class $d738cd3fbf7c09c7$export$3cf150422f3e89bd extends ($d738cd3fbf7c09c7$var$_Host3 = (0, $8B3mG.Host)(HTMLElement, (0, $g6paF.CaptionButton))) {
}
(0, $97zcJ._)($d738cd3fbf7c09c7$export$3cf150422f3e89bd, "tagName", "media-caption-button");
var $d738cd3fbf7c09c7$var$_Host4;
class $d738cd3fbf7c09c7$export$2963038141f68f8b extends ($d738cd3fbf7c09c7$var$_Host4 = (0, $8B3mG.Host)(HTMLElement, (0, $g6paF.FullscreenButton))) {
}
(0, $97zcJ._)($d738cd3fbf7c09c7$export$2963038141f68f8b, "tagName", "media-fullscreen-button");
var $d738cd3fbf7c09c7$var$_Host5;
class $d738cd3fbf7c09c7$export$3a75f6f34ae6aef1 extends ($d738cd3fbf7c09c7$var$_Host5 = (0, $8B3mG.Host)(HTMLElement, (0, $g6paF.LiveButton))) {
}
(0, $97zcJ._)($d738cd3fbf7c09c7$export$3a75f6f34ae6aef1, "tagName", "media-live-button");
var $d738cd3fbf7c09c7$var$_Host6;
class $d738cd3fbf7c09c7$export$259a77807e473246 extends ($d738cd3fbf7c09c7$var$_Host6 = (0, $8B3mG.Host)(HTMLElement, (0, $g6paF.MuteButton))) {
}
(0, $97zcJ._)($d738cd3fbf7c09c7$export$259a77807e473246, "tagName", "media-mute-button");
var $d738cd3fbf7c09c7$var$_Host7;
class $d738cd3fbf7c09c7$export$97ecd5d9148f064c extends ($d738cd3fbf7c09c7$var$_Host7 = (0, $8B3mG.Host)(HTMLElement, (0, $g6paF.PIPButton))) {
}
(0, $97zcJ._)($d738cd3fbf7c09c7$export$97ecd5d9148f064c, "tagName", "media-pip-button");
var $d738cd3fbf7c09c7$var$_Host8;
class $d738cd3fbf7c09c7$export$1970834309f67fec extends ($d738cd3fbf7c09c7$var$_Host8 = (0, $8B3mG.Host)(HTMLElement, (0, $g6paF.PlayButton))) {
}
(0, $97zcJ._)($d738cd3fbf7c09c7$export$1970834309f67fec, "tagName", "media-play-button");
var $d738cd3fbf7c09c7$var$_Host9;
class $d738cd3fbf7c09c7$export$f3e668187ff10e4 extends ($d738cd3fbf7c09c7$var$_Host9 = (0, $8B3mG.Host)(HTMLElement, (0, $g6paF.SeekButton))) {
}
(0, $97zcJ._)($d738cd3fbf7c09c7$export$f3e668187ff10e4, "tagName", "media-seek-button");
function $d738cd3fbf7c09c7$export$3d4754607f42da89(el, onCreate) {
    (0, $ciZW6.requestScopedAnimationFrame)(()=>{
        if (!el.connectScope) return;
        const template = el.querySelector("template");
        if (!template) return;
        (0, $8B3mG.effect)(()=>{
            const options = el.getOptions();
            (0, $ciZW6.cloneTemplate)(template, options.length, (radio, i)=>{
                const { label: label, value: value } = options[i], labelEl = radio.querySelector(`[data-part="label"]`);
                radio.setAttribute("value", value);
                if (labelEl) {
                    if ((0, $8B3mG.isString)(label)) labelEl.textContent = label;
                    else (0, $8B3mG.effect)(()=>{
                        labelEl.textContent = label();
                    });
                }
                onCreate?.(radio, options[i], i);
            });
        });
    });
}
var $d738cd3fbf7c09c7$var$_Host10;
class $d738cd3fbf7c09c7$export$5585416b47137530 extends ($d738cd3fbf7c09c7$var$_Host10 = (0, $8B3mG.Host)(HTMLElement, (0, $g6paF.AudioRadioGroup))) {
    onConnect() {
        $d738cd3fbf7c09c7$export$3d4754607f42da89(this);
    }
}
(0, $97zcJ._)($d738cd3fbf7c09c7$export$5585416b47137530, "tagName", "media-audio-radio-group");
var $d738cd3fbf7c09c7$var$_Host11;
class $d738cd3fbf7c09c7$export$dd4a911d266c3dc5 extends ($d738cd3fbf7c09c7$var$_Host11 = (0, $8B3mG.Host)(HTMLElement, (0, $g6paF.CaptionsRadioGroup))) {
    onConnect() {
        $d738cd3fbf7c09c7$export$3d4754607f42da89(this);
    }
}
(0, $97zcJ._)($d738cd3fbf7c09c7$export$dd4a911d266c3dc5, "tagName", "media-captions-radio-group");
var $d738cd3fbf7c09c7$var$_Host12;
class $d738cd3fbf7c09c7$export$84682bd3a2f19c19 extends ($d738cd3fbf7c09c7$var$_Host12 = (0, $8B3mG.Host)(HTMLElement, (0, $g6paF.Menu))) {
}
(0, $97zcJ._)($d738cd3fbf7c09c7$export$84682bd3a2f19c19, "tagName", "media-menu");
var $d738cd3fbf7c09c7$var$_Host13;
class $d738cd3fbf7c09c7$export$84c3802386d473a2 extends ($d738cd3fbf7c09c7$var$_Host13 = (0, $8B3mG.Host)(HTMLElement, (0, $g6paF.MenuButton))) {
}
(0, $97zcJ._)($d738cd3fbf7c09c7$export$84c3802386d473a2, "tagName", "media-menu-button");
var $d738cd3fbf7c09c7$var$_Host14;
class $d738cd3fbf7c09c7$export$b5b1db1c396a37b7 extends ($d738cd3fbf7c09c7$var$_Host14 = (0, $8B3mG.Host)(HTMLElement, (0, $g6paF.MenuItem))) {
}
(0, $97zcJ._)($d738cd3fbf7c09c7$export$b5b1db1c396a37b7, "tagName", "media-menu-item");
var $d738cd3fbf7c09c7$var$_Host15;
class $d738cd3fbf7c09c7$export$4471944ea03b89c9 extends ($d738cd3fbf7c09c7$var$_Host15 = (0, $8B3mG.Host)(HTMLElement, (0, $g6paF.MenuItems))) {
}
(0, $97zcJ._)($d738cd3fbf7c09c7$export$4471944ea03b89c9, "tagName", "media-menu-items");
var $d738cd3fbf7c09c7$var$_Host16;
class $d738cd3fbf7c09c7$export$ab30e5be1481f45c extends ($d738cd3fbf7c09c7$var$_Host16 = (0, $8B3mG.Host)(HTMLElement, (0, $g6paF.SpeedRadioGroup))) {
    onConnect() {
        $d738cd3fbf7c09c7$export$3d4754607f42da89(this);
    }
}
(0, $97zcJ._)($d738cd3fbf7c09c7$export$ab30e5be1481f45c, "tagName", "media-speed-radio-group");
var $d738cd3fbf7c09c7$var$_Host17;
class $d738cd3fbf7c09c7$export$fb4687c81ce40181 extends ($d738cd3fbf7c09c7$var$_Host17 = (0, $8B3mG.Host)(HTMLElement, (0, $g6paF.QualityRadioGroup))) {
    onConnect() {
        $d738cd3fbf7c09c7$export$3d4754607f42da89(this, (el, option)=>{
            const bitrate = option.bitrate, bitrateEl = el.querySelector('[data-part="bitrate"]');
            if (bitrate && bitrateEl) (0, $8B3mG.effect)(()=>{
                bitrateEl.textContent = bitrate() || "";
            });
        });
    }
}
(0, $97zcJ._)($d738cd3fbf7c09c7$export$fb4687c81ce40181, "tagName", "media-quality-radio-group");
var $d738cd3fbf7c09c7$var$_media1 = /*#__PURE__*/ new WeakMap(), $d738cd3fbf7c09c7$var$_slider = /*#__PURE__*/ new WeakMap(), $d738cd3fbf7c09c7$var$_watchTime = /*#__PURE__*/ new WeakSet();
class $d738cd3fbf7c09c7$export$c13ec3177c166afc extends $d738cd3fbf7c09c7$export$b6dbc3aade9d3908 {
    onSetup() {
        super.onSetup();
        (0, $4vwVC._)(this, $d738cd3fbf7c09c7$var$_media1, (0, $6KfMo.useMediaContext)());
        (0, $4vwVC._)(this, $d738cd3fbf7c09c7$var$_slider, (0, $8B3mG.useState)((0, $g6paF.Slider).state));
    }
    onConnect() {
        super.onConnect();
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $d738cd3fbf7c09c7$var$_watchTime, $d738cd3fbf7c09c7$var$watchTime).bind(this));
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $d738cd3fbf7c09c7$var$_watchTime);
        (0, $fhH8k._)(this, $d738cd3fbf7c09c7$var$_media1, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $d738cd3fbf7c09c7$var$_slider, {
            writable: true,
            value: void 0
        });
    }
}
(0, $97zcJ._)($d738cd3fbf7c09c7$export$c13ec3177c166afc, "tagName", "media-slider-thumbnail");
function $d738cd3fbf7c09c7$var$watchTime() {
    const { duration: duration, clipStartTime: clipStartTime } = (0, $57dmi._)(this, $d738cd3fbf7c09c7$var$_media1).$state;
    this.time = clipStartTime() + (0, $57dmi._)(this, $d738cd3fbf7c09c7$var$_slider).pointerRate() * duration();
}
var $d738cd3fbf7c09c7$var$_Host18;
class $d738cd3fbf7c09c7$export$5bd744dcbbe4d2d9 extends ($d738cd3fbf7c09c7$var$_Host18 = (0, $8B3mG.Host)(HTMLElement, (0, $g6paF.SliderValue))) {
    onConnect() {
        (0, $8B3mG.effect)(()=>{
            this.textContent = this.getValueText();
        });
    }
}
(0, $97zcJ._)($d738cd3fbf7c09c7$export$5bd744dcbbe4d2d9, "tagName", "media-slider-value");
(0, $97zcJ._)($d738cd3fbf7c09c7$export$5bd744dcbbe4d2d9, "attrs", {
    padMinutes: {
        converter: (0, $8B3mG.BOOLEAN)
    }
});
var $d738cd3fbf7c09c7$var$_Host19;
class $d738cd3fbf7c09c7$export$d889d8168135b8a9 extends ($d738cd3fbf7c09c7$var$_Host19 = (0, $8B3mG.Host)(HTMLElement, (0, $g6paF.TimeSlider))) {
}
(0, $97zcJ._)($d738cd3fbf7c09c7$export$d889d8168135b8a9, "tagName", "media-time-slider");
var $d738cd3fbf7c09c7$var$_Host20;
class $d738cd3fbf7c09c7$export$8800d14ce45bc251 extends ($d738cd3fbf7c09c7$var$_Host20 = (0, $8B3mG.Host)(HTMLElement, (0, $g6paF.SliderPreview))) {
}
(0, $97zcJ._)($d738cd3fbf7c09c7$export$8800d14ce45bc251, "tagName", "media-slider-preview");
var $d738cd3fbf7c09c7$var$_Host21;
class $d738cd3fbf7c09c7$export$951914e9cacacde0 extends ($d738cd3fbf7c09c7$var$_Host21 = (0, $8B3mG.Host)(HTMLElement, (0, $g6paF.VolumeSlider))) {
}
(0, $97zcJ._)($d738cd3fbf7c09c7$export$951914e9cacacde0, "tagName", "media-volume-slider");

});


parcelRegister("juFXD", function(module, exports) {

$parcel$export(module.exports, "MediaPosterElement", function () { return $e3115e36d0513838$export$2f4bc6e037f8422b; });

var $57dmi = parcelRequire("57dmi");

var $fhH8k = parcelRequire("fhH8k");

var $97zcJ = parcelRequire("97zcJ");

var $8B3mG = parcelRequire("8B3mG");

var $6amPG = parcelRequire("6amPG");



var $e3115e36d0513838$var$_Host, $e3115e36d0513838$var$_img = /*#__PURE__*/ new WeakMap();
class $e3115e36d0513838$export$2f4bc6e037f8422b extends ($e3115e36d0513838$var$_Host = (0, $8B3mG.Host)(HTMLElement, (0, $6amPG.Poster))) {
    onSetup() {
        this.$state.img.set((0, $57dmi._)(this, $e3115e36d0513838$var$_img));
    }
    onConnect() {
        const { src: src, alt: alt, crossOrigin: crossOrigin } = this.$state;
        (0, $8B3mG.effect)(()=>{
            const { loading: loading, hidden: hidden } = this.$state;
            (0, $57dmi._)(this, $e3115e36d0513838$var$_img).style.display = loading() || hidden() ? "none" : "";
        });
        (0, $8B3mG.effect)(()=>{
            (0, $8B3mG.setAttribute)((0, $57dmi._)(this, $e3115e36d0513838$var$_img), "alt", alt());
            (0, $8B3mG.setAttribute)((0, $57dmi._)(this, $e3115e36d0513838$var$_img), "crossorigin", crossOrigin());
            (0, $8B3mG.setAttribute)((0, $57dmi._)(this, $e3115e36d0513838$var$_img), "src", src());
        });
        if ((0, $57dmi._)(this, $e3115e36d0513838$var$_img).parentNode !== this) this.prepend((0, $57dmi._)(this, $e3115e36d0513838$var$_img));
    }
    constructor(...args){
        super(...args);
        (0, $fhH8k._)(this, $e3115e36d0513838$var$_img, {
            writable: true,
            value: document.createElement("img")
        });
    }
}
(0, $97zcJ._)($e3115e36d0513838$export$2f4bc6e037f8422b, "tagName", "media-poster");
(0, $97zcJ._)($e3115e36d0513838$export$2f4bc6e037f8422b, "attrs", {
    crossOrigin: "crossorigin"
});

});
parcelRegister("6amPG", function(module, exports) {

$parcel$export(module.exports, "Poster", function () { return $47d5634f6aaaf141$export$df7511532b4bb4a0; });

var $57dmi = parcelRequire("57dmi");

var $fhH8k = parcelRequire("fhH8k");

var $4vwVC = parcelRequire("4vwVC");

var $2u9SC = parcelRequire("2u9SC");

var $9P4tJ = parcelRequire("9P4tJ");

var $97zcJ = parcelRequire("97zcJ");

var $8B3mG = parcelRequire("8B3mG");

var $6KfMo = parcelRequire("6KfMo");

var $dLb9W = parcelRequire("dLb9W");
var $47d5634f6aaaf141$var$_media = /*#__PURE__*/ new WeakMap(), $47d5634f6aaaf141$var$_hasError = /*#__PURE__*/ new WeakSet(), $47d5634f6aaaf141$var$_onPreconnect = /*#__PURE__*/ new WeakSet(), $47d5634f6aaaf141$var$_watchHidden = /*#__PURE__*/ new WeakSet(), $47d5634f6aaaf141$var$_isLoading = /*#__PURE__*/ new WeakSet(), $47d5634f6aaaf141$var$_watchImg = /*#__PURE__*/ new WeakSet(), $47d5634f6aaaf141$var$_prevSrc = /*#__PURE__*/ new WeakMap(), $47d5634f6aaaf141$var$_watchSrc = /*#__PURE__*/ new WeakSet(), $47d5634f6aaaf141$var$_watchAlt = /*#__PURE__*/ new WeakSet(), $47d5634f6aaaf141$var$_watchCrossOrigin = /*#__PURE__*/ new WeakSet(), $47d5634f6aaaf141$var$_onLoadStart = /*#__PURE__*/ new WeakSet(), $47d5634f6aaaf141$var$_onLoad = /*#__PURE__*/ new WeakSet(), $47d5634f6aaaf141$var$_onError = /*#__PURE__*/ new WeakSet();
class $47d5634f6aaaf141$export$df7511532b4bb4a0 extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $4vwVC._)(this, $47d5634f6aaaf141$var$_media, (0, $6KfMo.useMediaContext)());
        (0, $2u9SC._)(this, $47d5634f6aaaf141$var$_watchSrc, $47d5634f6aaaf141$var$watchSrc).call(this);
        (0, $2u9SC._)(this, $47d5634f6aaaf141$var$_watchAlt, $47d5634f6aaaf141$var$watchAlt).call(this);
        (0, $2u9SC._)(this, $47d5634f6aaaf141$var$_watchCrossOrigin, $47d5634f6aaaf141$var$watchCrossOrigin).call(this);
        (0, $2u9SC._)(this, $47d5634f6aaaf141$var$_watchHidden, $47d5634f6aaaf141$var$watchHidden).call(this);
    }
    onAttach(el) {
        el.style.setProperty("pointer-events", "none");
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $47d5634f6aaaf141$var$_watchImg, $47d5634f6aaaf141$var$watchImg).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $47d5634f6aaaf141$var$_watchSrc, $47d5634f6aaaf141$var$watchSrc).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $47d5634f6aaaf141$var$_watchAlt, $47d5634f6aaaf141$var$watchAlt).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $47d5634f6aaaf141$var$_watchCrossOrigin, $47d5634f6aaaf141$var$watchCrossOrigin).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $47d5634f6aaaf141$var$_watchHidden, $47d5634f6aaaf141$var$watchHidden).bind(this));
        const { started: started } = (0, $57dmi._)(this, $47d5634f6aaaf141$var$_media).$state;
        this.setAttributes({
            "data-visible": ()=>!started() && !this.$state.hidden(),
            "data-loading": (0, $2u9SC._)(this, $47d5634f6aaaf141$var$_isLoading, $47d5634f6aaaf141$var$isLoading).bind(this),
            "data-error": (0, $2u9SC._)(this, $47d5634f6aaaf141$var$_hasError, $47d5634f6aaaf141$var$hasError).bind(this),
            "data-hidden": this.$state.hidden
        });
    }
    onConnect(el) {
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $47d5634f6aaaf141$var$_onPreconnect, $47d5634f6aaaf141$var$onPreconnect).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $47d5634f6aaaf141$var$_onLoadStart, $47d5634f6aaaf141$var$onLoadStart).bind(this));
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $47d5634f6aaaf141$var$_hasError);
        (0, $9P4tJ._)(this, $47d5634f6aaaf141$var$_onPreconnect);
        (0, $9P4tJ._)(this, $47d5634f6aaaf141$var$_watchHidden);
        (0, $9P4tJ._)(this, $47d5634f6aaaf141$var$_isLoading);
        (0, $9P4tJ._)(this, $47d5634f6aaaf141$var$_watchImg);
        (0, $9P4tJ._)(this, $47d5634f6aaaf141$var$_watchSrc);
        (0, $9P4tJ._)(this, $47d5634f6aaaf141$var$_watchAlt);
        (0, $9P4tJ._)(this, $47d5634f6aaaf141$var$_watchCrossOrigin);
        (0, $9P4tJ._)(this, $47d5634f6aaaf141$var$_onLoadStart);
        (0, $9P4tJ._)(this, $47d5634f6aaaf141$var$_onLoad);
        (0, $9P4tJ._)(this, $47d5634f6aaaf141$var$_onError);
        (0, $fhH8k._)(this, $47d5634f6aaaf141$var$_media, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $47d5634f6aaaf141$var$_prevSrc, {
            writable: true,
            value: ""
        });
    }
}
(0, $97zcJ._)($47d5634f6aaaf141$export$df7511532b4bb4a0, "props", {
    src: null,
    alt: null,
    crossOrigin: null
});
(0, $97zcJ._)($47d5634f6aaaf141$export$df7511532b4bb4a0, "state", new (0, $8B3mG.State)({
    img: null,
    src: null,
    alt: null,
    crossOrigin: null,
    loading: true,
    error: null,
    hidden: false
}));
function $47d5634f6aaaf141$var$hasError() {
    const { error: error } = this.$state;
    return !(0, $8B3mG.isNull)(error());
}
function $47d5634f6aaaf141$var$onPreconnect() {
    const { canLoadPoster: canLoadPoster, poster: poster } = (0, $57dmi._)(this, $47d5634f6aaaf141$var$_media).$state;
    if (!canLoadPoster() && poster()) (0, $dLb9W.preconnect)(poster(), "preconnect");
}
function $47d5634f6aaaf141$var$watchHidden() {
    const { src: src } = this.$props, { poster: poster, nativeControls: nativeControls } = (0, $57dmi._)(this, $47d5634f6aaaf141$var$_media).$state;
    this.el && (0, $8B3mG.setAttribute)(this.el, "display", nativeControls() ? "none" : null);
    this.$state.hidden.set((0, $2u9SC._)(this, $47d5634f6aaaf141$var$_hasError, $47d5634f6aaaf141$var$hasError).call(this) || !(src() || poster()) || nativeControls());
}
function $47d5634f6aaaf141$var$isLoading() {
    const { loading: loading, hidden: hidden } = this.$state;
    return !hidden() && loading();
}
function $47d5634f6aaaf141$var$watchImg() {
    const img = this.$state.img();
    if (!img) return;
    new (0, $8B3mG.EventsController)(img).add("load", (0, $2u9SC._)(this, $47d5634f6aaaf141$var$_onLoad, $47d5634f6aaaf141$var$onLoad).bind(this)).add("error", (0, $2u9SC._)(this, $47d5634f6aaaf141$var$_onError, $47d5634f6aaaf141$var$onError).bind(this));
    if (img.complete) (0, $2u9SC._)(this, $47d5634f6aaaf141$var$_onLoad, $47d5634f6aaaf141$var$onLoad).call(this);
}
function $47d5634f6aaaf141$var$watchSrc() {
    const { poster: defaultPoster } = (0, $57dmi._)(this, $47d5634f6aaaf141$var$_media).$props, { canLoadPoster: canLoadPoster, providedPoster: providedPoster, inferredPoster: inferredPoster } = (0, $57dmi._)(this, $47d5634f6aaaf141$var$_media).$state;
    const src = this.$props.src() || "", poster = src || defaultPoster() || inferredPoster();
    if ((0, $57dmi._)(this, $47d5634f6aaaf141$var$_prevSrc) === providedPoster()) providedPoster.set(src);
    this.$state.src.set(canLoadPoster() && poster.length ? poster : null);
    (0, $4vwVC._)(this, $47d5634f6aaaf141$var$_prevSrc, src);
}
function $47d5634f6aaaf141$var$watchAlt() {
    const { src: src } = this.$props, { alt: alt } = this.$state, { poster: poster } = (0, $57dmi._)(this, $47d5634f6aaaf141$var$_media).$state;
    alt.set(src() || poster() ? this.$props.alt() : null);
}
function $47d5634f6aaaf141$var$watchCrossOrigin() {
    const { crossOrigin: crossOriginProp } = this.$props, { crossOrigin: crossOriginState } = this.$state, { crossOrigin: mediaCrossOrigin, poster: src } = (0, $57dmi._)(this, $47d5634f6aaaf141$var$_media).$state, crossOrigin = crossOriginProp() !== null ? crossOriginProp() : mediaCrossOrigin();
    crossOriginState.set(/ytimg\.com|vimeo/.test(src() || "") ? null : crossOrigin === true ? "anonymous" : crossOrigin);
}
function $47d5634f6aaaf141$var$onLoadStart() {
    const { loading: loading, error: error } = this.$state, { canLoadPoster: canLoadPoster, poster: poster } = (0, $57dmi._)(this, $47d5634f6aaaf141$var$_media).$state;
    loading.set(canLoadPoster() && !!poster());
    error.set(null);
}
function $47d5634f6aaaf141$var$onLoad() {
    const { loading: loading, error: error } = this.$state;
    loading.set(false);
    error.set(null);
}
function $47d5634f6aaaf141$var$onError(event) {
    const { loading: loading, error: error } = this.$state;
    loading.set(false);
    error.set(event);
}

});



parcelRegister("1Kv2u", function(module, exports) {

$parcel$export(module.exports, "_config", function () { return _config; });
$parcel$export(module.exports, "_isString", function () { return _isString; });
$parcel$export(module.exports, "_isUndefined", function () { return _isUndefined; });
$parcel$export(module.exports, "_numExp", function () { return _numExp; });
$parcel$export(module.exports, "_numWithUnitExp", function () { return _numWithUnitExp; });
$parcel$export(module.exports, "_relExp", function () { return _relExp; });
$parcel$export(module.exports, "gsap", function () { return gsap; });
$parcel$export(module.exports, "_missingPlugin", function () { return _missingPlugin; });
$parcel$export(module.exports, "_plugins", function () { return _plugins; });
$parcel$export(module.exports, "GSCache", function () { return GSCache; });
$parcel$export(module.exports, "_getCache", function () { return _getCache; });
$parcel$export(module.exports, "_getProperty", function () { return _getProperty; });
$parcel$export(module.exports, "_forEachName", function () { return _forEachName; });
$parcel$export(module.exports, "_round", function () { return _round; });
$parcel$export(module.exports, "_parseRelative", function () { return _parseRelative; });
$parcel$export(module.exports, "_ticker", function () { return _ticker; });
$parcel$export(module.exports, "getUnit", function () { return getUnit; });
$parcel$export(module.exports, "_replaceRandom", function () { return _replaceRandom; });
$parcel$export(module.exports, "_getSetter", function () { return _getSetter; });
$parcel$export(module.exports, "PropTween", function () { return PropTween; });
$parcel$export(module.exports, "_colorExp", function () { return _colorExp; });
$parcel$export(module.exports, "_colorStringFilter", function () { return _colorStringFilter; });
$parcel$export(module.exports, "_renderComplexString", function () { return _renderComplexString; });
$parcel$export(module.exports, "_checkPlugin", function () { return _checkPlugin; });
$parcel$export(module.exports, "_sortPropTweensByPriority", function () { return _sortPropTweensByPriority; });
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.12.2
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || _reverting && time < 0 && (animation._initted || animation._startAt));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime /= cycleDuration);
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
        s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (_windowExists() && config) {
        // edge case: some build tools may pass in a null/undefined value
        config = !config.name && config["default"] || config; //UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else config && _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        elapsed > _lagThreshold && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _raf = _win.requestAnimationFrame;
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? _win.cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof Timeline) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return p ? Math.pow(2, 10 * (p - 1)) : 0;
});
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this._tDur, tTime), true);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (this._initted || this._startAt) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (animation._ts || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.vars.immediateRender ? -Infinity : this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        return this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://greensock.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    _propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && time && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && (child._initted || child._startAt)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, onUpdateParams = vars.onUpdateParams, callbackScope = vars.callbackScope, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate,
                onUpdateParams: onUpdateParams,
                callbackScope: callbackScope,
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return 1;
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://greensock.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative) {
            //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock) {
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values.
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (time && !prevTime && !suppressEvents && !iteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : !time && isYoyo ? -_tinyNum : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time)) return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            return this.parent ? _interrupt(this) : this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c);
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) {
            var tweens = this.getTweens();
            this.data.forEach(function(t) {
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            }); // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t.globalTime(0),
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            this.data.forEach(function(e) {
                return !(e instanceof Tween) && e.revert && e.revert(revert);
            });
            this._r.forEach(function(f) {
                return f(revert, _this4);
            });
            this.isReverted = true;
        } else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    };
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context);
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _merge2;
        var tween = gsap.to(target, _merge((_merge2 = {}, _merge2[property] = "+=0.1", _merge2.paused = true, _merge2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.12.2";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

});

parcelRegister("2I9O3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $1f974c243a910361$var$formatDate;
function $1f974c243a910361$var$_slicedToArray(arr, i) {
    return $1f974c243a910361$var$_arrayWithHoles(arr) || $1f974c243a910361$var$_iterableToArrayLimit(arr, i) || $1f974c243a910361$var$_unsupportedIterableToArray(arr, i) || $1f974c243a910361$var$_nonIterableRest();
}
function $1f974c243a910361$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1f974c243a910361$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1f974c243a910361$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1f974c243a910361$var$_arrayLikeToArray(o, minLen);
}
function $1f974c243a910361$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1f974c243a910361$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $1f974c243a910361$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $1f974c243a910361$var$pad = function pad(n) {
    return n < 10 ? "0".concat(n) : "".concat(n);
};
function $1f974c243a910361$var$formatDate() {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var outputType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "utc";
    var inputType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "local";
    if (typeof args === "string") return args;
    if (Array.isArray(args) && args.length === 3) {
        var _args = $1f974c243a910361$var$_slicedToArray(args, 3), year = _args[0], month = _args[1], date = _args[2];
        return "".concat(year).concat($1f974c243a910361$var$pad(month)).concat($1f974c243a910361$var$pad(date));
    }
    var outDate = new Date();
    if (Array.isArray(args) && args.length > 0 && args[0]) {
        var _args2 = $1f974c243a910361$var$_slicedToArray(args, 6), _year = _args2[0], _month = _args2[1], _date = _args2[2], _args2$ = _args2[3], hours = _args2$ === void 0 ? 0 : _args2$, _args2$2 = _args2[4], minutes = _args2$2 === void 0 ? 0 : _args2$2, _args2$3 = _args2[5], seconds = _args2$3 === void 0 ? 0 : _args2$3;
        if (inputType === "local") outDate = new Date(_year, _month - 1, _date, hours, minutes, seconds);
        else outDate = new Date(Date.UTC(_year, _month - 1, _date, hours, minutes, seconds));
    } else if (!Array.isArray(args)) // it's a unix time stamp (ms)
    outDate = new Date(args);
    if (outputType === "local") return [
        outDate.getFullYear(),
        $1f974c243a910361$var$pad(outDate.getMonth() + 1),
        $1f974c243a910361$var$pad(outDate.getDate()),
        "T",
        $1f974c243a910361$var$pad(outDate.getHours()),
        $1f974c243a910361$var$pad(outDate.getMinutes()),
        $1f974c243a910361$var$pad(outDate.getSeconds())
    ].join("");
    return [
        outDate.getUTCFullYear(),
        $1f974c243a910361$var$pad(outDate.getUTCMonth() + 1),
        $1f974c243a910361$var$pad(outDate.getUTCDate()),
        "T",
        $1f974c243a910361$var$pad(outDate.getUTCHours()),
        $1f974c243a910361$var$pad(outDate.getUTCMinutes()),
        $1f974c243a910361$var$pad(outDate.getUTCSeconds()),
        "Z"
    ].join("");
}

});

parcelRegister("bbsCP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $8246ed2d4b64ded4$var$setGeolocation;
function $8246ed2d4b64ded4$var$setGeolocation(_ref) {
    var lat = _ref.lat, lon = _ref.lon;
    return "".concat(lat, ";").concat(lon);
}

});

parcelRegister("8Biyp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $64302bda24d9b903$var$setContact;

var $64302bda24d9b903$var$_encodeParamValue = $64302bda24d9b903$var$_interopRequireDefault((parcelRequire("14CXE")));
function $64302bda24d9b903$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $64302bda24d9b903$var$setContact(_ref) {
    var name = _ref.name, email = _ref.email, rsvp = _ref.rsvp, dir = _ref.dir, partstat = _ref.partstat, role = _ref.role, cutype = _ref.cutype, xNumGuests = _ref.xNumGuests;
    var formattedParts = [];
    if (rsvp !== undefined) formattedParts.push(rsvp ? "RSVP=TRUE" : "RSVP=FALSE");
    if (cutype) formattedParts.push("CUTYPE=".concat((0, $64302bda24d9b903$var$_encodeParamValue["default"])(cutype)));
    if (xNumGuests !== undefined) formattedParts.push("X-NUM-GUESTS=".concat(xNumGuests));
    if (role) formattedParts.push("ROLE=".concat((0, $64302bda24d9b903$var$_encodeParamValue["default"])(role)));
    if (partstat) formattedParts.push("PARTSTAT=".concat((0, $64302bda24d9b903$var$_encodeParamValue["default"])(partstat)));
    if (dir) formattedParts.push("DIR=".concat((0, $64302bda24d9b903$var$_encodeParamValue["default"])(dir)));
    formattedParts.push("CN=".concat((0, $64302bda24d9b903$var$_encodeParamValue["default"])(name || "Unnamed attendee")));
    var formattedAttendee = formattedParts.join(";").concat(email ? ":mailto:".concat(email) : "");
    return formattedAttendee;
}

});
parcelRegister("14CXE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $0c8463058eb78ecc$var$encodeParamValue;
function $0c8463058eb78ecc$var$encodeParamValue(value) {
    return '"'.concat(value.replaceAll('"', '\\"'), '"');
}

});


parcelRegister("kZ5O6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $f46e0252824866ff$var$setOrganizer;

var $f46e0252824866ff$var$_encodeParamValue = $f46e0252824866ff$var$_interopRequireDefault((parcelRequire("14CXE")));
function $f46e0252824866ff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $f46e0252824866ff$var$setOrganizer(_ref) {
    var name = _ref.name, email = _ref.email, dir = _ref.dir, sentBy = _ref.sentBy;
    var formattedOrganizer = "";
    formattedOrganizer += dir ? "DIR=".concat((0, $f46e0252824866ff$var$_encodeParamValue["default"])(dir), ";") : "";
    formattedOrganizer += sentBy ? "SENT-BY=".concat((0, $f46e0252824866ff$var$_encodeParamValue["default"])("MAILTO:".concat(sentBy)), ";") : "";
    formattedOrganizer += "CN=";
    formattedOrganizer += (0, $f46e0252824866ff$var$_encodeParamValue["default"])(name || "Organizer");
    formattedOrganizer += email ? ":MAILTO:".concat(email) : "";
    return formattedOrganizer;
}

});

parcelRegister("1S8JO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $15d19cc0d5c792e3$var$setAlarm;

var $15d19cc0d5c792e3$var$_formatDate = $15d19cc0d5c792e3$var$_interopRequireDefault((parcelRequire("2I9O3")));

var $15d19cc0d5c792e3$var$_foldLine = $15d19cc0d5c792e3$var$_interopRequireDefault((parcelRequire("1Py5t")));

var $15d19cc0d5c792e3$var$_encodeNewLines = $15d19cc0d5c792e3$var$_interopRequireDefault((parcelRequire("gREEX")));
function $15d19cc0d5c792e3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $15d19cc0d5c792e3$var$setDuration(_ref) {
    var weeks = _ref.weeks, days = _ref.days, hours = _ref.hours, minutes = _ref.minutes, seconds = _ref.seconds;
    var formattedString = "P";
    formattedString += weeks ? "".concat(weeks, "W") : "";
    formattedString += days ? "".concat(days, "D") : "";
    formattedString += "T";
    formattedString += hours ? "".concat(hours, "H") : "";
    formattedString += minutes ? "".concat(minutes, "M") : "";
    formattedString += seconds ? "".concat(seconds, "S") : "";
    return formattedString;
}
function $15d19cc0d5c792e3$var$setTrigger(trigger) {
    var formattedString = "";
    if (Array.isArray(trigger) || typeof trigger === "number" || typeof trigger === "string") formattedString = "TRIGGER;VALUE=DATE-TIME:".concat((0, $15d19cc0d5c792e3$var$_encodeNewLines["default"])((0, $15d19cc0d5c792e3$var$_formatDate["default"])(trigger)), "\r\n");
    else {
        var alert = trigger.before ? "-" : "";
        formattedString = "TRIGGER:".concat((0, $15d19cc0d5c792e3$var$_encodeNewLines["default"])(alert + $15d19cc0d5c792e3$var$setDuration(trigger)), "\r\n");
    }
    return formattedString;
}
function $15d19cc0d5c792e3$var$setAction(action) {
    return action.toUpperCase();
}
function $15d19cc0d5c792e3$var$setAlarm() {
    var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = attributes.action, repeat = attributes.repeat, description = attributes.description, duration = attributes.duration, attach = attributes.attach, attachType = attributes.attachType, trigger = attributes.trigger, summary = attributes.summary;
    var formattedString = "BEGIN:VALARM\r\n";
    formattedString += (0, $15d19cc0d5c792e3$var$_foldLine["default"])("ACTION:".concat((0, $15d19cc0d5c792e3$var$_encodeNewLines["default"])($15d19cc0d5c792e3$var$setAction(action)))) + "\r\n";
    formattedString += repeat ? (0, $15d19cc0d5c792e3$var$_foldLine["default"])("REPEAT:".concat(repeat)) + "\r\n" : "";
    formattedString += description ? (0, $15d19cc0d5c792e3$var$_foldLine["default"])("DESCRIPTION:".concat((0, $15d19cc0d5c792e3$var$_encodeNewLines["default"])(description))) + "\r\n" : "";
    formattedString += duration ? (0, $15d19cc0d5c792e3$var$_foldLine["default"])("DURATION:".concat($15d19cc0d5c792e3$var$setDuration(duration))) + "\r\n" : "";
    var attachInfo = attachType ? attachType : "FMTTYPE=audio/basic";
    formattedString += attach ? (0, $15d19cc0d5c792e3$var$_foldLine["default"])((0, $15d19cc0d5c792e3$var$_encodeNewLines["default"])("ATTACH;".concat(attachInfo, ":").concat(attach))) + "\r\n" : "";
    formattedString += trigger ? $15d19cc0d5c792e3$var$setTrigger(trigger) : "";
    formattedString += summary ? (0, $15d19cc0d5c792e3$var$_foldLine["default"])("SUMMARY:".concat((0, $15d19cc0d5c792e3$var$_encodeNewLines["default"])(summary))) + "\r\n" : "";
    formattedString += "END:VALARM\r\n";
    return formattedString;
} // Example:  A duration of 15 days, 5 hours, and 20 seconds would be:
 // P15DT5H0M20S
 // A duration of 7 weeks would be:
 // P7W

});
parcelRegister("1Py5t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $1554fedf2aad40fb$var$foldLine;

var $ehfNt = parcelRequire("ehfNt");
function $1554fedf2aad40fb$var$foldLine(line) {
    var parts = [];
    var length = 75;
    while((0, $ehfNt.runes)(line).length > length){
        parts.push((0, $ehfNt.substring)(line, 0, length));
        line = (0, $ehfNt.substring)(line, length);
        length = 74;
    }
    parts.push(line);
    return parts.join("\r\n	");
}

});
parcelRegister("ehfNt", function(module, exports) {

var $ffNCS = parcelRequire("ffNCS");
"use strict";
typeof $ffNCS;

module.exports = (parcelRequire("c5eJp"));

});
parcelRegister("ffNCS", function(module, exports) {
// shim for using process in browser
var $b1aec0739a00d502$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $b1aec0739a00d502$var$cachedSetTimeout;
var $b1aec0739a00d502$var$cachedClearTimeout;
function $b1aec0739a00d502$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $b1aec0739a00d502$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $b1aec0739a00d502$var$cachedSetTimeout = setTimeout;
        else $b1aec0739a00d502$var$cachedSetTimeout = $b1aec0739a00d502$var$defaultSetTimout;
    } catch (e) {
        $b1aec0739a00d502$var$cachedSetTimeout = $b1aec0739a00d502$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $b1aec0739a00d502$var$cachedClearTimeout = clearTimeout;
        else $b1aec0739a00d502$var$cachedClearTimeout = $b1aec0739a00d502$var$defaultClearTimeout;
    } catch (e) {
        $b1aec0739a00d502$var$cachedClearTimeout = $b1aec0739a00d502$var$defaultClearTimeout;
    }
})();
function $b1aec0739a00d502$var$runTimeout(fun) {
    if ($b1aec0739a00d502$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($b1aec0739a00d502$var$cachedSetTimeout === $b1aec0739a00d502$var$defaultSetTimout || !$b1aec0739a00d502$var$cachedSetTimeout) && setTimeout) {
        $b1aec0739a00d502$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $b1aec0739a00d502$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $b1aec0739a00d502$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $b1aec0739a00d502$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $b1aec0739a00d502$var$runClearTimeout(marker) {
    if ($b1aec0739a00d502$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($b1aec0739a00d502$var$cachedClearTimeout === $b1aec0739a00d502$var$defaultClearTimeout || !$b1aec0739a00d502$var$cachedClearTimeout) && clearTimeout) {
        $b1aec0739a00d502$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $b1aec0739a00d502$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $b1aec0739a00d502$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $b1aec0739a00d502$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $b1aec0739a00d502$var$queue = [];
var $b1aec0739a00d502$var$draining = false;
var $b1aec0739a00d502$var$currentQueue;
var $b1aec0739a00d502$var$queueIndex = -1;
function $b1aec0739a00d502$var$cleanUpNextTick() {
    if (!$b1aec0739a00d502$var$draining || !$b1aec0739a00d502$var$currentQueue) return;
    $b1aec0739a00d502$var$draining = false;
    if ($b1aec0739a00d502$var$currentQueue.length) $b1aec0739a00d502$var$queue = $b1aec0739a00d502$var$currentQueue.concat($b1aec0739a00d502$var$queue);
    else $b1aec0739a00d502$var$queueIndex = -1;
    if ($b1aec0739a00d502$var$queue.length) $b1aec0739a00d502$var$drainQueue();
}
function $b1aec0739a00d502$var$drainQueue() {
    if ($b1aec0739a00d502$var$draining) return;
    var timeout = $b1aec0739a00d502$var$runTimeout($b1aec0739a00d502$var$cleanUpNextTick);
    $b1aec0739a00d502$var$draining = true;
    var len = $b1aec0739a00d502$var$queue.length;
    while(len){
        $b1aec0739a00d502$var$currentQueue = $b1aec0739a00d502$var$queue;
        $b1aec0739a00d502$var$queue = [];
        while(++$b1aec0739a00d502$var$queueIndex < len)if ($b1aec0739a00d502$var$currentQueue) $b1aec0739a00d502$var$currentQueue[$b1aec0739a00d502$var$queueIndex].run();
        $b1aec0739a00d502$var$queueIndex = -1;
        len = $b1aec0739a00d502$var$queue.length;
    }
    $b1aec0739a00d502$var$currentQueue = null;
    $b1aec0739a00d502$var$draining = false;
    $b1aec0739a00d502$var$runClearTimeout(timeout);
}
$b1aec0739a00d502$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $b1aec0739a00d502$var$queue.push(new $b1aec0739a00d502$var$Item(fun, args));
    if ($b1aec0739a00d502$var$queue.length === 1 && !$b1aec0739a00d502$var$draining) $b1aec0739a00d502$var$runTimeout($b1aec0739a00d502$var$drainQueue);
};
// v8 likes predictible objects
function $b1aec0739a00d502$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$b1aec0739a00d502$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$b1aec0739a00d502$var$process.title = "browser";
$b1aec0739a00d502$var$process.browser = true;
$b1aec0739a00d502$var$process.env = {};
$b1aec0739a00d502$var$process.argv = [];
$b1aec0739a00d502$var$process.version = ""; // empty string to avoid regexp issues
$b1aec0739a00d502$var$process.versions = {};
function $b1aec0739a00d502$var$noop() {}
$b1aec0739a00d502$var$process.on = $b1aec0739a00d502$var$noop;
$b1aec0739a00d502$var$process.addListener = $b1aec0739a00d502$var$noop;
$b1aec0739a00d502$var$process.once = $b1aec0739a00d502$var$noop;
$b1aec0739a00d502$var$process.off = $b1aec0739a00d502$var$noop;
$b1aec0739a00d502$var$process.removeListener = $b1aec0739a00d502$var$noop;
$b1aec0739a00d502$var$process.removeAllListeners = $b1aec0739a00d502$var$noop;
$b1aec0739a00d502$var$process.emit = $b1aec0739a00d502$var$noop;
$b1aec0739a00d502$var$process.prependListener = $b1aec0739a00d502$var$noop;
$b1aec0739a00d502$var$process.prependOnceListener = $b1aec0739a00d502$var$noop;
$b1aec0739a00d502$var$process.listeners = function(name) {
    return [];
};
$b1aec0739a00d502$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$b1aec0739a00d502$var$process.cwd = function() {
    return "/";
};
$b1aec0739a00d502$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$b1aec0739a00d502$var$process.umask = function() {
    return 0;
};

});

parcelRegister("c5eJp", function(module, exports) {
"use strict";
var $84d831d87baabb3d$var$e;
!function(e) {
    e[e.HIGH_SURROGATE_START = 55296] = "HIGH_SURROGATE_START", e[e.HIGH_SURROGATE_END = 56319] = "HIGH_SURROGATE_END", e[e.LOW_SURROGATE_START = 56320] = "LOW_SURROGATE_START", e[e.REGIONAL_INDICATOR_START = 127462] = "REGIONAL_INDICATOR_START", e[e.REGIONAL_INDICATOR_END = 127487] = "REGIONAL_INDICATOR_END", e[e.FITZPATRICK_MODIFIER_START = 127995] = "FITZPATRICK_MODIFIER_START", e[e.FITZPATRICK_MODIFIER_END = 127999] = "FITZPATRICK_MODIFIER_END", e[e.VARIATION_MODIFIER_START = 65024] = "VARIATION_MODIFIER_START", e[e.VARIATION_MODIFIER_END = 65039] = "VARIATION_MODIFIER_END", e[e.DIACRITICAL_MARKS_START = 8400] = "DIACRITICAL_MARKS_START", e[e.DIACRITICAL_MARKS_END = 8447] = "DIACRITICAL_MARKS_END", e[e.SUBDIVISION_INDICATOR_START = 127988] = "SUBDIVISION_INDICATOR_START", e[e.TAGS_START = 917504] = "TAGS_START", e[e.TAGS_END = 917631] = "TAGS_END", e[e.ZWJ = 8205] = "ZWJ";
}($84d831d87baabb3d$var$e || ($84d831d87baabb3d$var$e = {}));
const $84d831d87baabb3d$var$n = Object.freeze([
    0x0308,
    0x0937,
    0x093F,
    0x0BA8,
    0x0BBF,
    0x0BCD,
    0x0E31,
    0x0E33,
    0x0E40,
    0x0E49,
    0x1100,
    0x1161,
    0x11A8
]);
var $84d831d87baabb3d$var$t;
function $84d831d87baabb3d$var$runes(e) {
    if ("string" != typeof e) throw new TypeError("string cannot be undefined or null");
    const n = [];
    let t = 0, r = 0;
    for(; t < e.length;)r += $84d831d87baabb3d$var$nextUnits(t + r, e), $84d831d87baabb3d$var$isGrapheme(e[t + r]) && r++, $84d831d87baabb3d$var$isVariationSelector(e[t + r]) && r++, $84d831d87baabb3d$var$isDiacriticalMark(e[t + r]) && r++, $84d831d87baabb3d$var$isZeroWidthJoiner(e[t + r]) ? r++ : (n.push(e.substring(t, t + r)), t += r, r = 0);
    return n;
}
function $84d831d87baabb3d$var$nextUnits(e, n) {
    const t = n[e];
    if (!function isFirstOfSurrogatePair(e) {
        return e && $84d831d87baabb3d$var$betweenInclusive(e[0].charCodeAt(0), 55296, 56319);
    }(t) || e === n.length - 1) return 1;
    const r = t + n[e + 1];
    let i = n.substring(e + 2, e + 5);
    return $84d831d87baabb3d$var$isRegionalIndicator(r) && $84d831d87baabb3d$var$isRegionalIndicator(i) ? 4 : function isSubdivisionFlag(e) {
        return $84d831d87baabb3d$var$betweenInclusive($84d831d87baabb3d$var$codePointFromSurrogatePair(e), 127988, 127988);
    }(r) && function isSupplementarySpecialpurposePlane(e) {
        const n = e.codePointAt(0);
        return "string" == typeof e && "number" == typeof n && $84d831d87baabb3d$var$betweenInclusive(n, 917504, 917631);
    }(i) ? n.slice(e).indexOf(String.fromCodePoint(917631)) + 2 : function isFitzpatrickModifier(e) {
        return $84d831d87baabb3d$var$betweenInclusive($84d831d87baabb3d$var$codePointFromSurrogatePair(e), 127995, 127999);
    }(i) ? 4 : 2;
}
function $84d831d87baabb3d$var$isRegionalIndicator(e) {
    return $84d831d87baabb3d$var$betweenInclusive($84d831d87baabb3d$var$codePointFromSurrogatePair(e), 127462, 127487);
}
function $84d831d87baabb3d$var$isVariationSelector(e) {
    return "string" == typeof e && $84d831d87baabb3d$var$betweenInclusive(e.charCodeAt(0), 65024, 65039);
}
function $84d831d87baabb3d$var$isDiacriticalMark(e) {
    return "string" == typeof e && $84d831d87baabb3d$var$betweenInclusive(e.charCodeAt(0), 8400, 8447);
}
function $84d831d87baabb3d$var$isGrapheme(e) {
    return "string" == typeof e && $84d831d87baabb3d$var$n.includes(e.charCodeAt(0));
}
function $84d831d87baabb3d$var$isZeroWidthJoiner(e) {
    return "string" == typeof e && 8205 === e.charCodeAt(0);
}
function $84d831d87baabb3d$var$codePointFromSurrogatePair(e) {
    return (e.charCodeAt(0) - 55296 << 10) + (e.charCodeAt(1) - 56320) + 0x10000;
}
function $84d831d87baabb3d$var$betweenInclusive(e, n, t) {
    return e >= n && e <= t;
}
function $84d831d87baabb3d$var$substring(e, n, t) {
    const r = $84d831d87baabb3d$var$runes(e);
    if (void 0 === n) return e;
    if (n >= r.length) return "";
    const i = r.length - n;
    let o = n + (void 0 === t ? i : t);
    return o > n + i && (o = void 0), r.slice(n, o).join("");
}
!function(e) {
    e[e.unit_1 = 1] = "unit_1", e[e.unit_2 = 2] = "unit_2", e[e.unit_4 = 4] = "unit_4";
}($84d831d87baabb3d$var$t || ($84d831d87baabb3d$var$t = {})), Object.defineProperty($84d831d87baabb3d$var$runes, "runes", {
    value: $84d831d87baabb3d$var$runes
}), Object.defineProperty($84d831d87baabb3d$var$runes, "default", {
    value: $84d831d87baabb3d$var$runes
}), Object.defineProperty($84d831d87baabb3d$var$runes, "__esModule", {
    value: !0
}), Object.defineProperty($84d831d87baabb3d$var$runes, "substr", {
    value: $84d831d87baabb3d$var$substring
}), Object.defineProperty($84d831d87baabb3d$var$runes, "substring", {
    value: $84d831d87baabb3d$var$substring
}), Object.defineProperty($84d831d87baabb3d$var$runes, "EnumRunesCode", {
    value: $84d831d87baabb3d$var$e
}), Object.defineProperty($84d831d87baabb3d$var$runes, "EnumCodeUnits", {
    value: $84d831d87baabb3d$var$t
}), Object.defineProperty($84d831d87baabb3d$var$runes, "GRAPHEMES", {
    value: $84d831d87baabb3d$var$n
}), module.exports = $84d831d87baabb3d$var$runes; //# sourceMappingURL=index.cjs.production.min.cjs.map

});



parcelRegister("gREEX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $c47122c0fb6d7975$var$encodeNewLines;
function $c47122c0fb6d7975$var$encodeNewLines(text) {
    return text.replace(/\r?\n/gm, "\\n");
}

});


parcelRegister("jhxZp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $e099f86e4a1b24a0$var$setDescription;

var $e099f86e4a1b24a0$var$_formatText = $e099f86e4a1b24a0$var$_interopRequireDefault((parcelRequire("bLLlV")));
function $e099f86e4a1b24a0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e099f86e4a1b24a0$var$setDescription(description) {
    return (0, $e099f86e4a1b24a0$var$_formatText["default"])(description);
}

});
parcelRegister("bLLlV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $8918d0bd0b258a8c$var$formatText;
function $8918d0bd0b258a8c$var$formatText(text) {
    return text.replace(/\\/gm, "\\\\").replace(/\r?\n/gm, "\\n").replace(/;/gm, "\\;").replace(/,/gm, "\\,");
}

});


parcelRegister("h2gqO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $c66f5e87e07b7bd9$var$setSummary;

var $c66f5e87e07b7bd9$var$_formatText = $c66f5e87e07b7bd9$var$_interopRequireDefault((parcelRequire("bLLlV")));
function $c66f5e87e07b7bd9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $c66f5e87e07b7bd9$var$setSummary(summary) {
    return (0, $c66f5e87e07b7bd9$var$_formatText["default"])(summary);
}

});

parcelRegister("eyhlm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $a981b1ba9200d4ed$var$formatDuration;
function $a981b1ba9200d4ed$var$formatDuration() {
    var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var weeks = attributes.weeks, days = attributes.days, hours = attributes.hours, minutes = attributes.minutes, seconds = attributes.seconds;
    var formattedDuration = "P";
    formattedDuration += weeks ? "".concat(weeks, "W") : "";
    formattedDuration += days ? "".concat(days, "D") : "";
    formattedDuration += "T";
    formattedDuration += hours ? "".concat(hours, "H") : "";
    formattedDuration += minutes ? "".concat(minutes, "M") : "";
    formattedDuration += seconds ? "".concat(seconds, "S") : "";
    return formattedDuration;
}

});

parcelRegister("gQ8Nk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $c4285315f95df379$var$setLocation;

var $c4285315f95df379$var$_formatText = $c4285315f95df379$var$_interopRequireDefault((parcelRequire("bLLlV")));
function $c4285315f95df379$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $c4285315f95df379$var$setLocation(location) {
    return (0, $c4285315f95df379$var$_formatText["default"])(location);
}

});

parcelRegister("DV6aU", function(module, exports) {

$parcel$export(module.exports, "printValue", function () { return $077fef39a0580000$export$5790025c6e6c2ba6; });
$parcel$export(module.exports, "ValidationError", function () { return $077fef39a0580000$export$2191b9da168c6cf0; });
$parcel$export(module.exports, "defaultLocale", function () { return $077fef39a0580000$export$d7f512c98c859244; });
$parcel$export(module.exports, "isSchema", function () { return $077fef39a0580000$export$213e2a3e7c4f326e; });
$parcel$export(module.exports, "ref", function () { return $077fef39a0580000$export$eff4d24c3ff7876e; });
$parcel$export(module.exports, "getIn", function () { return $077fef39a0580000$export$c52e5867d5879e24; });
$parcel$export(module.exports, "reach", function () { return $077fef39a0580000$export$cfedb76369cc7782; });
$parcel$export(module.exports, "Schema", function () { return $077fef39a0580000$export$19342e026b58ebb7; });
$parcel$export(module.exports, "mixed", function () { return $077fef39a0580000$export$9b30b6294c1449a8; });
$parcel$export(module.exports, "MixedSchema", function () { return $077fef39a0580000$export$1e88358c94ddec71; });
$parcel$export(module.exports, "bool", function () { return $077fef39a0580000$export$87b259aa03e3d267; });
$parcel$export(module.exports, "BooleanSchema", function () { return $077fef39a0580000$export$c7980688f11e1f49; });
$parcel$export(module.exports, "string", function () { return $077fef39a0580000$export$22b082955e083ec3; });
$parcel$export(module.exports, "StringSchema", function () { return $077fef39a0580000$export$49bf8b2ede5138eb; });
$parcel$export(module.exports, "number", function () { return $077fef39a0580000$export$98e628dec113755e; });
$parcel$export(module.exports, "NumberSchema", function () { return $077fef39a0580000$export$f192ec5e9228ab19; });
$parcel$export(module.exports, "date", function () { return $077fef39a0580000$export$324d90190a8b822a; });
$parcel$export(module.exports, "DateSchema", function () { return $077fef39a0580000$export$18ec3cc5a157503f; });
$parcel$export(module.exports, "object", function () { return $077fef39a0580000$export$be5493f9613cbbe; });
$parcel$export(module.exports, "ObjectSchema", function () { return $077fef39a0580000$export$18b4fc70ec7eccf8; });
$parcel$export(module.exports, "array", function () { return $077fef39a0580000$export$2f23118c22fb2630; });
$parcel$export(module.exports, "ArraySchema", function () { return $077fef39a0580000$export$4347112b8447a7d; });
$parcel$export(module.exports, "tuple", function () { return $077fef39a0580000$export$65e3907585753458; });
$parcel$export(module.exports, "TupleSchema", function () { return $077fef39a0580000$export$411c3b3687e8ecc8; });
$parcel$export(module.exports, "lazy", function () { return $077fef39a0580000$export$488013bae63b21da; });
$parcel$export(module.exports, "setLocale", function () { return $077fef39a0580000$export$c8aadf3621e41efb; });
$parcel$export(module.exports, "addMethod", function () { return $077fef39a0580000$export$20be359f745f973c; });
$parcel$export(module.exports, "boolean", function () { return $077fef39a0580000$export$87b259aa03e3d267; });

var $9xXug = parcelRequire("9xXug");

var $dbdUT = parcelRequire("dbdUT");

var $eTC75 = parcelRequire("eTC75");
const $077fef39a0580000$var$toString = Object.prototype.toString;
const $077fef39a0580000$var$errorToString = Error.prototype.toString;
const $077fef39a0580000$var$regExpToString = RegExp.prototype.toString;
const $077fef39a0580000$var$symbolToString = typeof Symbol !== "undefined" ? Symbol.prototype.toString : ()=>"";
const $077fef39a0580000$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $077fef39a0580000$var$printNumber(val) {
    if (val != +val) return "NaN";
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? "-0" : "" + val;
}
function $077fef39a0580000$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return "" + val;
    const typeOf = typeof val;
    if (typeOf === "number") return $077fef39a0580000$var$printNumber(val);
    if (typeOf === "string") return quoteStrings ? `"${val}"` : val;
    if (typeOf === "function") return "[Function " + (val.name || "anonymous") + "]";
    if (typeOf === "symbol") return $077fef39a0580000$var$symbolToString.call(val).replace($077fef39a0580000$var$SYMBOL_REGEXP, "Symbol($1)");
    const tag = $077fef39a0580000$var$toString.call(val).slice(8, -1);
    if (tag === "Date") return isNaN(val.getTime()) ? "" + val : val.toISOString(val);
    if (tag === "Error" || val instanceof Error) return "[" + $077fef39a0580000$var$errorToString.call(val) + "]";
    if (tag === "RegExp") return $077fef39a0580000$var$regExpToString.call(val);
    return null;
}
function $077fef39a0580000$export$5790025c6e6c2ba6(value, quoteStrings) {
    let result = $077fef39a0580000$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $077fef39a0580000$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}
function $077fef39a0580000$var$toArray(value) {
    return value == null ? [] : [].concat(value);
}
let $077fef39a0580000$var$_Symbol$toStringTag, $077fef39a0580000$var$_Symbol$hasInstance, $077fef39a0580000$var$_Symbol$toStringTag2;
let $077fef39a0580000$var$strReg = /\$\{\s*(\w+)\s*\}/g;
$077fef39a0580000$var$_Symbol$toStringTag = Symbol.toStringTag;
class $077fef39a0580000$var$ValidationErrorNoStack {
    constructor(errorOrErrors, value, field, type){
        this.name = void 0;
        this.message = void 0;
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = void 0;
        this.inner = void 0;
        this[$077fef39a0580000$var$_Symbol$toStringTag] = "Error";
        this.name = "ValidationError";
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        $077fef39a0580000$var$toArray(errorOrErrors).forEach((err)=>{
            if ($077fef39a0580000$export$2191b9da168c6cf0.isError(err)) {
                this.errors.push(...err.errors);
                const innerErrors = err.inner.length ? err.inner : [
                    err
                ];
                this.inner.push(...innerErrors);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    }
}
$077fef39a0580000$var$_Symbol$hasInstance = Symbol.hasInstance;
$077fef39a0580000$var$_Symbol$toStringTag2 = Symbol.toStringTag;
class $077fef39a0580000$export$2191b9da168c6cf0 extends Error {
    static formatError(message, params) {
        const path = params.label || params.path || "this";
        if (path !== params.path) params = Object.assign({}, params, {
            path: path
        });
        if (typeof message === "string") return message.replace($077fef39a0580000$var$strReg, (_, key)=>$077fef39a0580000$export$5790025c6e6c2ba6(params[key]));
        if (typeof message === "function") return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === "ValidationError";
    }
    static [$077fef39a0580000$var$_Symbol$hasInstance](inst) {
        return $077fef39a0580000$var$ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
    }
    constructor(errorOrErrors, value, field, type, disableStack){
        const errorNoStack = new $077fef39a0580000$var$ValidationErrorNoStack(errorOrErrors, value, field, type);
        if (disableStack) return errorNoStack;
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = [];
        this.inner = [];
        this[$077fef39a0580000$var$_Symbol$toStringTag2] = "Error";
        this.name = errorNoStack.name;
        this.message = errorNoStack.message;
        this.type = errorNoStack.type;
        this.value = errorNoStack.value;
        this.path = errorNoStack.path;
        this.errors = errorNoStack.errors;
        this.inner = errorNoStack.inner;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $077fef39a0580000$export$2191b9da168c6cf0);
    }
}
let $077fef39a0580000$var$mixed = {
    default: "${path} is invalid",
    required: "${path} is a required field",
    defined: "${path} must be defined",
    notNull: "${path} cannot be null",
    oneOf: "${path} must be one of the following values: ${values}",
    notOneOf: "${path} must not be one of the following values: ${values}",
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${$077fef39a0580000$export$5790025c6e6c2ba6(originalValue, true)}\`).` : ".";
        return type !== "mixed" ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${$077fef39a0580000$export$5790025c6e6c2ba6(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${$077fef39a0580000$export$5790025c6e6c2ba6(value, true)}\`` + castMsg;
    }
};
let $077fef39a0580000$var$string = {
    length: "${path} must be exactly ${length} characters",
    min: "${path} must be at least ${min} characters",
    max: "${path} must be at most ${max} characters",
    matches: '${path} must match the following: "${regex}"',
    email: "${path} must be a valid email",
    url: "${path} must be a valid URL",
    uuid: "${path} must be a valid UUID",
    datetime: "${path} must be a valid ISO date-time",
    datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
    datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
    trim: "${path} must be a trimmed string",
    lowercase: "${path} must be a lowercase string",
    uppercase: "${path} must be a upper case string"
};
let $077fef39a0580000$var$number = {
    min: "${path} must be greater than or equal to ${min}",
    max: "${path} must be less than or equal to ${max}",
    lessThan: "${path} must be less than ${less}",
    moreThan: "${path} must be greater than ${more}",
    positive: "${path} must be a positive number",
    negative: "${path} must be a negative number",
    integer: "${path} must be an integer"
};
let $077fef39a0580000$var$date = {
    min: "${path} field must be later than ${min}",
    max: "${path} field must be at earlier than ${max}"
};
let $077fef39a0580000$var$boolean = {
    isValue: "${path} field must be ${value}"
};
let $077fef39a0580000$var$object = {
    noUnknown: "${path} field has unspecified keys: ${unknown}"
};
let $077fef39a0580000$var$array = {
    min: "${path} field must have at least ${min} items",
    max: "${path} field must have less than or equal to ${max} items",
    length: "${path} must have ${length} items"
};
let $077fef39a0580000$var$tuple = {
    notType: (params)=>{
        const { path: path, value: value, spec: spec } = params;
        const typeLen = spec.types.length;
        if (Array.isArray(value)) {
            if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${$077fef39a0580000$export$5790025c6e6c2ba6(value, true)}\``;
            if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${$077fef39a0580000$export$5790025c6e6c2ba6(value, true)}\``;
        }
        return $077fef39a0580000$export$2191b9da168c6cf0.formatError($077fef39a0580000$var$mixed.notType, params);
    }
};
var $077fef39a0580000$export$d7f512c98c859244 = Object.assign(Object.create(null), {
    mixed: $077fef39a0580000$var$mixed,
    string: $077fef39a0580000$var$string,
    number: $077fef39a0580000$var$number,
    date: $077fef39a0580000$var$date,
    object: $077fef39a0580000$var$object,
    array: $077fef39a0580000$var$array,
    boolean: $077fef39a0580000$var$boolean,
    tuple: $077fef39a0580000$var$tuple
});
const $077fef39a0580000$export$213e2a3e7c4f326e = (obj)=>obj && obj.__isYupSchema__;
class $077fef39a0580000$var$Condition {
    static fromOptions(refs, config) {
        if (!config.then && !config.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
        let { is: is, then: then, otherwise: otherwise } = config;
        let check = typeof is === "function" ? is : (...values)=>values.every((value)=>value === is);
        return new $077fef39a0580000$var$Condition(refs, (values, schema)=>{
            var _branch;
            let branch = check(...values) ? then : otherwise;
            return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
        });
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>// TODO: ? operator here?
            ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn(values, base, options);
        if (schema === undefined || // @ts-ignore this can be base
        schema === base) return base;
        if (!$077fef39a0580000$export$213e2a3e7c4f326e(schema)) throw new TypeError("conditions must return a schema object");
        return schema.resolve(options);
    }
    constructor(refs, builder){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        this.fn = builder;
    }
}
const $077fef39a0580000$var$prefixes = {
    context: "$",
    value: "."
};
function $077fef39a0580000$export$eff4d24c3ff7876e(key, options) {
    return new $077fef39a0580000$var$Reference(key, options);
}
class $077fef39a0580000$var$Reference {
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: "ref",
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== "string") throw new TypeError("ref must be a string, got: " + key);
        this.key = key.trim();
        if (key === "") throw new TypeError("ref must be a non-empty string");
        this.isContext = this.key[0] === $077fef39a0580000$var$prefixes.context;
        this.isValue = this.key[0] === $077fef39a0580000$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $077fef39a0580000$var$prefixes.context : this.isValue ? $077fef39a0580000$var$prefixes.value : "";
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $9xXug.getter)(this.path, true);
        this.map = options.map;
    }
}
// @ts-ignore
$077fef39a0580000$var$Reference.prototype.__isYupRef = true;
const $077fef39a0580000$var$isAbsent = (value)=>value == null;
function $077fef39a0580000$var$createValidation(config) {
    function validate({ value: value, path: path = "", options: options, originalValue: originalValue, schema: schema }, panic, next) {
        const { name: name, test: test, params: params, message: message, skipAbsent: skipAbsent } = config;
        let { parent: parent, context: context, abortEarly: abortEarly = schema.spec.abortEarly, disableStackTrace: disableStackTrace = schema.spec.disableStackTrace } = options;
        function resolve(item) {
            return $077fef39a0580000$var$Reference.isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = Object.assign({
                value: value,
                originalValue: originalValue,
                label: schema.spec.label,
                path: overrides.path || path,
                spec: schema.spec,
                disableStackTrace: overrides.disableStackTrace || disableStackTrace
            }, params, overrides.params);
            for (const key of Object.keys(nextParams))nextParams[key] = resolve(nextParams[key]);
            const error = new $077fef39a0580000$export$2191b9da168c6cf0($077fef39a0580000$export$2191b9da168c6cf0.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
            error.params = nextParams;
            return error;
        }
        const invalid = abortEarly ? panic : next;
        let ctx = {
            path: path,
            parent: parent,
            type: name,
            from: options.from,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue,
            schema: schema
        };
        const handleResult = (validOrError)=>{
            if ($077fef39a0580000$export$2191b9da168c6cf0.isError(validOrError)) invalid(validOrError);
            else if (!validOrError) invalid(createError());
            else next(null);
        };
        const handleError = (err)=>{
            if ($077fef39a0580000$export$2191b9da168c6cf0.isError(err)) invalid(err);
            else panic(err);
        };
        const shouldSkip = skipAbsent && $077fef39a0580000$var$isAbsent(value);
        if (shouldSkip) return handleResult(true);
        let result;
        try {
            var _result;
            result = test.call(ctx, value, ctx);
            if (typeof ((_result = result) == null ? void 0 : _result.then) === "function") {
                if (options.sync) throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
                return Promise.resolve(result).then(handleResult, handleError);
            }
        } catch (err) {
            handleError(err);
            return;
        }
        handleResult(result);
    }
    validate.OPTIONS = config;
    return validate;
}
function $077fef39a0580000$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug;
    // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $9xXug.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        let isTuple = schema.type === "tuple";
        let idx = isArray ? parseInt(part, 10) : 0;
        if (schema.innerType || isTuple) {
            if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = isTuple ? schema.spec.types[idx] : schema.innerType;
        }
        // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? "[" + _part + "]" : "." + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
function $077fef39a0580000$export$cfedb76369cc7782(obj, path, value, context) {
    return $077fef39a0580000$export$c52e5867d5879e24(obj, path, value, context).schema;
}
class $077fef39a0580000$var$ReferenceSet extends Set {
    describe() {
        const description = [];
        for (const item of this.values())description.push($077fef39a0580000$var$Reference.isRef(item) ? item.describe() : item);
        return description;
    }
    resolveAll(resolve) {
        let result = [];
        for (const item of this.values())result.push(resolve(item));
        return result;
    }
    clone() {
        return new $077fef39a0580000$var$ReferenceSet(this.values());
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.forEach((value)=>next.add(value));
        removeItems.forEach((value)=>next.delete(value));
        return next;
    }
}
// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function $077fef39a0580000$var$clone(src, seen = new Map()) {
    if ($077fef39a0580000$export$213e2a3e7c4f326e(src) || !src || typeof src !== "object") return src;
    if (seen.has(src)) return seen.get(src);
    let copy;
    if (src instanceof Date) {
        // Date
        copy = new Date(src.getTime());
        seen.set(src, copy);
    } else if (src instanceof RegExp) {
        // RegExp
        copy = new RegExp(src);
        seen.set(src, copy);
    } else if (Array.isArray(src)) {
        // Array
        copy = new Array(src.length);
        seen.set(src, copy);
        for(let i = 0; i < src.length; i++)copy[i] = $077fef39a0580000$var$clone(src[i], seen);
    } else if (src instanceof Map) {
        // Map
        copy = new Map();
        seen.set(src, copy);
        for (const [k, v] of src.entries())copy.set(k, $077fef39a0580000$var$clone(v, seen));
    } else if (src instanceof Set) {
        // Set
        copy = new Set();
        seen.set(src, copy);
        for (const v of src)copy.add($077fef39a0580000$var$clone(v, seen));
    } else if (src instanceof Object) {
        // Object
        copy = {};
        seen.set(src, copy);
        for (const [k, v] of Object.entries(src))copy[k] = $077fef39a0580000$var$clone(v, seen);
    } else throw Error(`Unable to clone ${src}`);
    return copy;
}
// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class $077fef39a0580000$export$19342e026b58ebb7 {
    // TODO: remove
    get _type() {
        return this.type;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        }
        // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this));
        // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeCheck = this._typeCheck;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.internalTests = Object.assign({}, this.internalTests);
        next.exclusiveTests = Object.assign({}, this.exclusiveTests);
        // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = $077fef39a0580000$var$clone(Object.assign({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = Object.assign({}, base.spec, combined.spec);
        combined.spec = mergedSpec;
        combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);
        // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
        // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests;
        // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (v == null) {
            if (this.spec.nullable && v === null) return true;
            if (this.spec.optional && v === undefined) return true;
            return false;
        }
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((prevSchema, condition)=>condition.resolve(prevSchema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    resolveOptions(options) {
        var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
        return Object.assign({}, options, {
            from: options.from || [],
            strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
            abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
            recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
            disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
        });
    }
    /**
   * Run the configured transform pipeline over an input value.
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve(Object.assign({
            value: value
        }, options));
        let allowOptionality = options.assert === "ignore-optionality";
        let result = resolvedSchema._cast(value, options);
        if (options.assert !== false && !resolvedSchema.isType(result)) {
            if (allowOptionality && $077fef39a0580000$var$isAbsent(result)) return result;
            let formattedValue = $077fef39a0580000$export$5790025c6e6c2ba6(value);
            let formattedResult = $077fef39a0580000$export$5790025c6e6c2ba6(result);
            throw new TypeError(`The value of ${options.path || "field"} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ""));
        }
        return result;
    }
    _cast(rawValue, options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn)=>fn.call(this, prevValue, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault(options);
        return value;
    }
    _validate(_value, options = {}, panic, next) {
        let { path: path, originalValue: originalValue = _value, strict: strict = this.spec.strict } = options;
        let value = _value;
        if (!strict) value = this._cast(value, Object.assign({
            assert: false
        }, options));
        let initialTests = [];
        for (let test of Object.values(this.internalTests))if (test) initialTests.push(test);
        this.runTests({
            path: path,
            value: value,
            originalValue: originalValue,
            options: options,
            tests: initialTests
        }, panic, (initialErrors)=>{
            // even if we aren't ending early we can't proceed further if the types aren't correct
            if (initialErrors.length) return next(initialErrors, value);
            this.runTests({
                path: path,
                value: value,
                originalValue: originalValue,
                options: options,
                tests: this.tests
            }, panic, next);
        });
    }
    /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */ runTests(runOptions, panic, next) {
        let fired = false;
        let { tests: tests, value: value, originalValue: originalValue, path: path, options: options } = runOptions;
        let panicOnce = (arg)=>{
            if (fired) return;
            fired = true;
            panic(arg, value);
        };
        let nextOnce = (arg)=>{
            if (fired) return;
            fired = true;
            next(arg, value);
        };
        let count = tests.length;
        let nestedErrors = [];
        if (!count) return nextOnce([]);
        let args = {
            value: value,
            originalValue: originalValue,
            path: path,
            options: options,
            schema: this
        };
        for(let i = 0; i < tests.length; i++){
            const test = tests[i];
            test(args, panicOnce, function finishTestRun(err) {
                if (err) Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
                if (--count <= 0) nextOnce(nestedErrors);
            });
        }
    }
    asNestedTest({ key: key, index: index, parent: parent, parentPath: parentPath, originalParent: originalParent, options: options }) {
        const k = key != null ? key : index;
        if (k == null) throw TypeError("Must include `key` or `index` for nested validations");
        const isIndex = typeof k === "number";
        let value = parent[k];
        const testOptions = Object.assign({}, options, {
            // Nested validations fields are always strict:
            //    1. parent isn't strict so the casting will also have cast inner values
            //    2. parent is strict in which case the nested values weren't cast either
            strict: true,
            parent: parent,
            value: value,
            originalValue: originalParent[k],
            // FIXME: tests depend on `index` being passed around deeply,
            //   we should not let the options.key/index bleed through
            key: undefined,
            // index: undefined,
            [isIndex ? "index" : "key"]: k,
            path: isIndex || k.includes(".") ? `${parentPath || ""}[${isIndex ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : "") + key
        });
        return (_, panic, next)=>this.resolve(testOptions)._validate(value, testOptions, panic, next);
    }
    validate(value, options) {
        var _options$disableStack2;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
        return new Promise((resolve, reject)=>schema._validate(value, options, (error, parsed)=>{
                if ($077fef39a0580000$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
                reject(error);
            }, (errors, validated)=>{
                if (errors.length) reject(new $077fef39a0580000$export$2191b9da168c6cf0(errors, validated, undefined, undefined, disableStackTrace));
                else resolve(validated);
            }));
    }
    validateSync(value, options) {
        var _options$disableStack3;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let result;
        let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
        schema._validate(value, Object.assign({}, options, {
            sync: true
        }), (error, parsed)=>{
            if ($077fef39a0580000$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
            throw error;
        }, (errors, validated)=>{
            if (errors.length) throw new $077fef39a0580000$export$2191b9da168c6cf0(errors, value, undefined, undefined, disableStackTrace);
            result = validated;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ($077fef39a0580000$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ($077fef39a0580000$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        }
    }
    _getDefault(options) {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === "function" ? defaultValue.call(this, options) : $077fef39a0580000$var$clone(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault(options);
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        return this.clone({
            strict: isStrict
        });
    }
    nullability(nullable, message) {
        const next = this.clone({
            nullable: nullable
        });
        next.internalTests.nullable = $077fef39a0580000$var$createValidation({
            message: message,
            name: "nullable",
            test (value) {
                return value === null ? this.schema.spec.nullable : true;
            }
        });
        return next;
    }
    optionality(optional, message) {
        const next = this.clone({
            optional: optional
        });
        next.internalTests.optionality = $077fef39a0580000$var$createValidation({
            message: message,
            name: "optionality",
            test (value) {
                return value === undefined ? this.schema.spec.optional : true;
            }
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    defined(message = $077fef39a0580000$var$mixed.defined) {
        return this.optionality(false, message);
    }
    nullable() {
        return this.nullability(true);
    }
    nonNullable(message = $077fef39a0580000$var$mixed.notNull) {
        return this.nullability(false, message);
    }
    required(message = $077fef39a0580000$var$mixed.required) {
        return this.clone().withMutation((next)=>next.nonNullable(message).defined(message));
    }
    notRequired() {
        return this.clone().withMutation((next)=>next.nullable().optional());
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === "function") opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = $077fef39a0580000$var$mixed.default;
        if (typeof opts.test !== "function") throw new TypeError("`test` is a required parameters");
        let next = this.clone();
        let validate = $077fef39a0580000$var$createValidation(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== "string") {
            options = keys;
            keys = ".";
        }
        let next = this.clone();
        let deps = $077fef39a0580000$var$toArray(keys).map((key)=>new $077fef39a0580000$var$Reference(key));
        deps.forEach((dep)=>{
            // @ts-ignore readonly array
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(typeof options === "function" ? new $077fef39a0580000$var$Condition(deps, options) : $077fef39a0580000$var$Condition.fromOptions(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next.internalTests.typeError = $077fef39a0580000$var$createValidation({
            message: message,
            name: "typeError",
            skipAbsent: true,
            test (value) {
                if (!this.schema._typeCheck(value)) return this.createError({
                    params: {
                        type: this.schema.type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = $077fef39a0580000$var$mixed.oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next.internalTests.whiteList = $077fef39a0580000$var$createValidation({
            message: message,
            name: "oneOf",
            skipAbsent: true,
            test (value) {
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: Array.from(valids).join(", "),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = $077fef39a0580000$var$mixed.notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next.internalTests.blacklist = $077fef39a0580000$var$createValidation({
            message: message,
            name: "notOneOf",
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: Array.from(invalids).join(", "),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */ describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const { label: label, meta: meta, optional: optional, nullable: nullable } = next.spec;
        const description = {
            meta: meta,
            label: label,
            optional: optional,
            nullable: nullable,
            default: next.getDefault(options),
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
    constructor(options){
        this.type = void 0;
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this.internalTests = {};
        this._whitelist = new $077fef39a0580000$var$ReferenceSet();
        this._blacklist = new $077fef39a0580000$var$ReferenceSet();
        this.exclusiveTests = Object.create(null);
        this._typeCheck = void 0;
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError($077fef39a0580000$var$mixed.notType);
        });
        this.type = options.type;
        this._typeCheck = options.check;
        this.spec = Object.assign({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            disableStackTrace: false,
            nullable: false,
            optional: true,
            coerce: true
        }, options == null ? void 0 : options.spec);
        this.withMutation((s)=>{
            s.nonNullable();
        });
    }
}
// @ts-expect-error
$077fef39a0580000$export$19342e026b58ebb7.prototype.__isYupSchema__ = true;
for (const method of [
    "validate",
    "validateSync"
])$077fef39a0580000$export$19342e026b58ebb7.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = $077fef39a0580000$export$c52e5867d5879e24(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], Object.assign({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    "equals",
    "is"
])$077fef39a0580000$export$19342e026b58ebb7.prototype[alias] = $077fef39a0580000$export$19342e026b58ebb7.prototype.oneOf;
for (const alias of [
    "not",
    "nope"
])$077fef39a0580000$export$19342e026b58ebb7.prototype[alias] = $077fef39a0580000$export$19342e026b58ebb7.prototype.notOneOf;
const $077fef39a0580000$var$returnsTrue = ()=>true;
function $077fef39a0580000$export$9b30b6294c1449a8(spec) {
    return new $077fef39a0580000$export$1e88358c94ddec71(spec);
}
class $077fef39a0580000$export$1e88358c94ddec71 extends $077fef39a0580000$export$19342e026b58ebb7 {
    constructor(spec){
        super(typeof spec === "function" ? {
            type: "mixed",
            check: spec
        } : Object.assign({
            type: "mixed",
            check: $077fef39a0580000$var$returnsTrue
        }, spec));
    }
}
$077fef39a0580000$export$9b30b6294c1449a8.prototype = $077fef39a0580000$export$1e88358c94ddec71.prototype;
function $077fef39a0580000$export$87b259aa03e3d267() {
    return new $077fef39a0580000$export$c7980688f11e1f49();
}
class $077fef39a0580000$export$c7980688f11e1f49 extends $077fef39a0580000$export$19342e026b58ebb7 {
    isTrue(message = $077fef39a0580000$var$boolean.isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "true"
            },
            test (value) {
                return $077fef39a0580000$var$isAbsent(value) || value === true;
            }
        });
    }
    isFalse(message = $077fef39a0580000$var$boolean.isValue) {
        return this.test({
            message: message,
            name: "is-value",
            exclusive: true,
            params: {
                value: "false"
            },
            test (value) {
                return $077fef39a0580000$var$isAbsent(value) || value === false;
            }
        });
    }
    default(def) {
        return super.default(def);
    }
    defined(msg) {
        return super.defined(msg);
    }
    optional() {
        return super.optional();
    }
    required(msg) {
        return super.required(msg);
    }
    notRequired() {
        return super.notRequired();
    }
    nullable() {
        return super.nullable();
    }
    nonNullable(msg) {
        return super.nonNullable(msg);
    }
    strip(v) {
        return super.strip(v);
    }
    constructor(){
        super({
            type: "boolean",
            check (v) {
                if (v instanceof Boolean) v = v.valueOf();
                return typeof v === "boolean";
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (ctx.spec.coerce && !ctx.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
}
$077fef39a0580000$export$87b259aa03e3d267.prototype = $077fef39a0580000$export$c7980688f11e1f49.prototype;
/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ // prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const $077fef39a0580000$var$isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $077fef39a0580000$var$parseIsoDate(date) {
    const struct = $077fef39a0580000$var$parseDateStruct(date);
    if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;
    // timestamps without timezone identifiers should be considered local time
    if (struct.z === undefined && struct.plusMinus === undefined) return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
    let totalMinutesOffset = 0;
    if (struct.z !== "Z" && struct.plusMinus !== undefined) {
        totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
        if (struct.plusMinus === "+") totalMinutesOffset = 0 - totalMinutesOffset;
    }
    return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function $077fef39a0580000$var$parseDateStruct(date) {
    var _regexResult$7$length, _regexResult$;
    const regexResult = $077fef39a0580000$var$isoReg.exec(date);
    if (!regexResult) return null;
    // use of toNumber() avoids NaN timestamps caused by “undefined”
    // values being passed to Date constructor
    return {
        year: $077fef39a0580000$var$toNumber(regexResult[1]),
        month: $077fef39a0580000$var$toNumber(regexResult[2], 1) - 1,
        day: $077fef39a0580000$var$toNumber(regexResult[3], 1),
        hour: $077fef39a0580000$var$toNumber(regexResult[4]),
        minute: $077fef39a0580000$var$toNumber(regexResult[5]),
        second: $077fef39a0580000$var$toNumber(regexResult[6]),
        millisecond: regexResult[7] ? // allow arbitrary sub-second precision beyond milliseconds
        $077fef39a0580000$var$toNumber(regexResult[7].substring(0, 3)) : 0,
        precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
        z: regexResult[8] || undefined,
        plusMinus: regexResult[9] || undefined,
        hourOffset: $077fef39a0580000$var$toNumber(regexResult[10]),
        minuteOffset: $077fef39a0580000$var$toNumber(regexResult[11])
    };
}
function $077fef39a0580000$var$toNumber(str, defaultValue = 0) {
    return Number(str) || defaultValue;
}
// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let $077fef39a0580000$var$rEmail = // eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let $077fef39a0580000$var$rUrl = // eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
// eslint-disable-next-line
let $077fef39a0580000$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $077fef39a0580000$var$yearMonthDay = "^\\d{4}-\\d{2}-\\d{2}";
let $077fef39a0580000$var$hourMinuteSecond = "\\d{2}:\\d{2}:\\d{2}";
let $077fef39a0580000$var$zOrOffset = "(([+-]\\d{2}(:?\\d{2})?)|Z)";
let $077fef39a0580000$var$rIsoDateTime = new RegExp(`${$077fef39a0580000$var$yearMonthDay}T${$077fef39a0580000$var$hourMinuteSecond}(\\.\\d+)?${$077fef39a0580000$var$zOrOffset}$`);
let $077fef39a0580000$var$isTrimmed = (value)=>$077fef39a0580000$var$isAbsent(value) || value === value.trim();
let $077fef39a0580000$var$objStringTag = ({}).toString();
function $077fef39a0580000$export$22b082955e083ec3() {
    return new $077fef39a0580000$export$49bf8b2ede5138eb();
}
class $077fef39a0580000$export$49bf8b2ede5138eb extends $077fef39a0580000$export$19342e026b58ebb7 {
    required(message) {
        return super.required(message).withMutation((schema)=>schema.test({
                message: message || $077fef39a0580000$var$mixed.required,
                name: "required",
                skipAbsent: true,
                test: (value)=>!!value.length
            }));
    }
    notRequired() {
        return super.notRequired().withMutation((schema)=>{
            schema.tests = schema.tests.filter((t)=>t.OPTIONS.name !== "required");
            return schema;
        });
    }
    length(length, message = $077fef39a0580000$var$string.length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message = $077fef39a0580000$var$string.min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = $077fef39a0580000$var$string.max) {
        return this.test({
            name: "max",
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === "object") ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || "matches",
            message: message || $077fef39a0580000$var$string.matches,
            params: {
                regex: regex
            },
            skipAbsent: true,
            test: (value)=>value === "" && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = $077fef39a0580000$var$string.email) {
        return this.matches($077fef39a0580000$var$rEmail, {
            name: "email",
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = $077fef39a0580000$var$string.url) {
        return this.matches($077fef39a0580000$var$rUrl, {
            name: "url",
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = $077fef39a0580000$var$string.uuid) {
        return this.matches($077fef39a0580000$var$rUUID, {
            name: "uuid",
            message: message,
            excludeEmptyString: false
        });
    }
    datetime(options) {
        let message = "";
        let allowOffset;
        let precision;
        if (options) {
            if (typeof options === "object") ({ message: message = "", allowOffset: allowOffset = false, precision: precision } = options);
            else message = options;
        }
        return this.matches($077fef39a0580000$var$rIsoDateTime, {
            name: "datetime",
            message: message || $077fef39a0580000$var$string.datetime,
            excludeEmptyString: true
        }).test({
            name: "datetime_offset",
            message: message || $077fef39a0580000$var$string.datetime_offset,
            params: {
                allowOffset: allowOffset
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || allowOffset) return true;
                const struct = $077fef39a0580000$var$parseDateStruct(value);
                if (!struct) return false;
                return !!struct.z;
            }
        }).test({
            name: "datetime_precision",
            message: message || $077fef39a0580000$var$string.datetime_precision,
            params: {
                precision: precision
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || precision == undefined) return true;
                const struct = $077fef39a0580000$var$parseDateStruct(value);
                if (!struct) return false;
                return struct.precision === precision;
            }
        });
    }
    //-- transforms --
    ensure() {
        return this.default("").transform((val)=>val === null ? "" : val);
    }
    trim(message = $077fef39a0580000$var$string.trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: "trim",
            test: $077fef39a0580000$var$isTrimmed
        });
    }
    lowercase(message = $077fef39a0580000$var$string.lowercase) {
        return this.transform((value)=>!$077fef39a0580000$var$isAbsent(value) ? value.toLowerCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$077fef39a0580000$var$isAbsent(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = $077fef39a0580000$var$string.uppercase) {
        return this.transform((value)=>!$077fef39a0580000$var$isAbsent(value) ? value.toUpperCase() : value).test({
            message: message,
            name: "string_case",
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$077fef39a0580000$var$isAbsent(value) || value === value.toUpperCase()
        });
    }
    constructor(){
        super({
            type: "string",
            check (value) {
                if (value instanceof String) value = value.valueOf();
                return typeof value === "string";
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce || ctx.isType(value)) return value;
                // don't ever convert arrays
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                // no one wants plain objects converted to [Object object]
                if (strValue === $077fef39a0580000$var$objStringTag) return value;
                return strValue;
            });
        });
    }
}
$077fef39a0580000$export$22b082955e083ec3.prototype = $077fef39a0580000$export$49bf8b2ede5138eb.prototype;
//
// String Interfaces
//
let $077fef39a0580000$var$isNaN$1 = (value)=>value != +value;
function $077fef39a0580000$export$98e628dec113755e() {
    return new $077fef39a0580000$export$f192ec5e9228ab19();
}
class $077fef39a0580000$export$f192ec5e9228ab19 extends $077fef39a0580000$export$19342e026b58ebb7 {
    min(min, message = $077fef39a0580000$var$number.min) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(min);
            }
        });
    }
    max(max, message = $077fef39a0580000$var$number.max) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = $077fef39a0580000$var$number.lessThan) {
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                less: less
            },
            skipAbsent: true,
            test (value) {
                return value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = $077fef39a0580000$var$number.moreThan) {
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                more: more
            },
            skipAbsent: true,
            test (value) {
                return value > this.resolve(more);
            }
        });
    }
    positive(msg = $077fef39a0580000$var$number.positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = $077fef39a0580000$var$number.negative) {
        return this.lessThan(0, msg);
    }
    integer(message = $077fef39a0580000$var$number.integer) {
        return this.test({
            name: "integer",
            message: message,
            skipAbsent: true,
            test: (val)=>Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!$077fef39a0580000$var$isAbsent(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            "ceil",
            "floor",
            "round",
            "trunc"
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || "round";
        // this exists for symemtry with the new Math.trunc
        if (method === "trunc") return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + avail.join(", "));
        return this.transform((value)=>!$077fef39a0580000$var$isAbsent(value) ? Math[method](value) : value);
    }
    constructor(){
        super({
            type: "number",
            check (value) {
                if (value instanceof Number) value = value.valueOf();
                return typeof value === "number" && !$077fef39a0580000$var$isNaN$1(value);
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce) return value;
                let parsed = value;
                if (typeof parsed === "string") {
                    parsed = parsed.replace(/\s/g, "");
                    if (parsed === "") return NaN;
                    // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                // null -> NaN isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (ctx.isType(parsed) || parsed === null) return parsed;
                return parseFloat(parsed);
            });
        });
    }
}
$077fef39a0580000$export$98e628dec113755e.prototype = $077fef39a0580000$export$f192ec5e9228ab19.prototype;
//
// Number Interfaces
//
let $077fef39a0580000$var$invalidDate = new Date("");
let $077fef39a0580000$var$isDate = (obj)=>Object.prototype.toString.call(obj) === "[object Date]";
function $077fef39a0580000$export$324d90190a8b822a() {
    return new $077fef39a0580000$export$18ec3cc5a157503f();
}
class $077fef39a0580000$export$18ec3cc5a157503f extends $077fef39a0580000$export$19342e026b58ebb7 {
    prepareParam(ref, name) {
        let param;
        if (!$077fef39a0580000$var$Reference.isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = $077fef39a0580000$var$date.min) {
        let limit = this.prepareParam(min, "min");
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(limit);
            }
        });
    }
    max(max, message = $077fef39a0580000$var$date.max) {
        let limit = this.prepareParam(max, "max");
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(limit);
            }
        });
    }
    constructor(){
        super({
            type: "date",
            check (v) {
                return $077fef39a0580000$var$isDate(v) && !isNaN(v.getTime());
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (!ctx.spec.coerce || ctx.isType(value) || value === null) return value;
                value = $077fef39a0580000$var$parseIsoDate(value);
                // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $077fef39a0580000$export$18ec3cc5a157503f.INVALID_DATE;
            });
        });
    }
}
$077fef39a0580000$export$18ec3cc5a157503f.INVALID_DATE = $077fef39a0580000$var$invalidDate;
$077fef39a0580000$export$324d90190a8b822a.prototype = $077fef39a0580000$export$18ec3cc5a157503f.prototype;
$077fef39a0580000$export$324d90190a8b822a.INVALID_DATE = $077fef39a0580000$var$invalidDate;
// @ts-expect-error
function $077fef39a0580000$var$sortFields(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $9xXug.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for (const key of Object.keys(fields)){
        let value = fields[key];
        nodes.add(key);
        if ($077fef39a0580000$var$Reference.isRef(value) && value.isSibling) addNode(value.path, key);
        else if ($077fef39a0580000$export$213e2a3e7c4f326e(value) && "deps" in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($eTC75))).array(Array.from(nodes), edges).reverse();
}
function $077fef39a0580000$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if ((_err$path = err.path) != null && _err$path.includes(key)) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $077fef39a0580000$var$sortByKeyOrder(keys) {
    return (a, b)=>{
        return $077fef39a0580000$var$findIndex(keys, a) - $077fef39a0580000$var$findIndex(keys, b);
    };
}
const $077fef39a0580000$var$parseJson = (value, _, ctx)=>{
    if (typeof value !== "string") return value;
    let parsed = value;
    try {
        parsed = JSON.parse(value);
    } catch (err) {
    /* */ }
    return ctx.isType(parsed) ? parsed : value;
};
// @ts-ignore
function $077fef39a0580000$var$deepPartial(schema) {
    if ("fields" in schema) {
        const partial = {};
        for (const [key, fieldSchema] of Object.entries(schema.fields))partial[key] = $077fef39a0580000$var$deepPartial(fieldSchema);
        return schema.setFields(partial);
    }
    if (schema.type === "array") {
        const nextArray = schema.optional();
        if (nextArray.innerType) nextArray.innerType = $077fef39a0580000$var$deepPartial(nextArray.innerType);
        return nextArray;
    }
    if (schema.type === "tuple") return schema.optional().clone({
        types: schema.spec.types.map($077fef39a0580000$var$deepPartial)
    });
    if ("optional" in schema) return schema.optional();
    return schema;
}
const $077fef39a0580000$var$deepHas = (obj, p)=>{
    const path = [
        ...(0, $9xXug.normalizePath)(p)
    ];
    if (path.length === 1) return path[0] in obj;
    let last = path.pop();
    let parent = (0, $9xXug.getter)((0, $9xXug.join)(path), true)(obj);
    return !!(parent && last in parent);
};
let $077fef39a0580000$var$isObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]";
function $077fef39a0580000$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $077fef39a0580000$var$defaultSort = $077fef39a0580000$var$sortByKeyOrder([]);
function $077fef39a0580000$export$be5493f9613cbbe(spec) {
    return new $077fef39a0580000$export$18b4fc70ec7eccf8(spec);
}
class $077fef39a0580000$export$18b4fc70ec7eccf8 extends $077fef39a0580000$export$19342e026b58ebb7 {
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options);
        //should ignore nulls here
        if (value === undefined) return this.getDefault(options);
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = [].concat(this._nodes, Object.keys(value).filter((v)=>!this._nodes.includes(v)));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = Object.assign({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = prop in value;
            if (field) {
                let fieldValue;
                let inputValue = value[prop];
                // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : "") + prop;
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = field instanceof $077fef39a0580000$export$19342e026b58ebb7 ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec != null && fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
                field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, options = {}, panic, next) {
        let { from: from = [], originalValue: originalValue = _value, recursive: recursive = this.spec.recursive } = options;
        options.from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ];
        // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        options.__validating = true;
        options.originalValue = originalValue;
        super._validate(_value, options, panic, (objectErrors, value)=>{
            if (!recursive || !$077fef39a0580000$var$isObject(value)) {
                next(objectErrors, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = [];
            for (let key of this._nodes){
                let field = this.fields[key];
                if (!field || $077fef39a0580000$var$Reference.isRef(field)) continue;
                tests.push(field.asNestedTest({
                    options: options,
                    key: key,
                    parent: value,
                    parentPath: options.path,
                    originalParent: originalValue
                }));
            }
            this.runTests({
                tests: tests,
                value: value,
                originalValue: originalValue,
                options: options
            }, panic, (fieldErrors)=>{
                next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
            });
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = Object.assign({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            nextFields[field] = target === undefined ? schemaOrRef : target;
        }
        return next.withMutation((s)=>// XXX: excludes here is wrong
            s.setFields(nextFields, [
                ...this._excludedEdges,
                ...schema._excludedEdges
            ]));
    }
    _getDefault(options) {
        if ("default" in this.spec) return super._getDefault(options);
        // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        let dft = {};
        this._nodes.forEach((key)=>{
            var _innerOptions;
            const field = this.fields[key];
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            dft[key] = field && "getDefault" in field ? field.getDefault(innerOptions) : undefined;
        });
        return dft;
    }
    setFields(shape, excludedEdges) {
        let next = this.clone();
        next.fields = shape;
        next._nodes = $077fef39a0580000$var$sortFields(shape, excludedEdges);
        next._sortErrors = $077fef39a0580000$var$sortByKeyOrder(Object.keys(shape));
        // XXX: this carries over edges which may not be what you want
        if (excludedEdges) next._excludedEdges = excludedEdges;
        return next;
    }
    shape(additions, excludes = []) {
        return this.clone().withMutation((next)=>{
            let edges = next._excludedEdges;
            if (excludes.length) {
                if (!Array.isArray(excludes[0])) excludes = [
                    excludes
                ];
                edges = [
                    ...next._excludedEdges,
                    ...excludes
                ];
            }
            // XXX: excludes here is wrong
            return next.setFields(Object.assign(next.fields, additions), edges);
        });
    }
    partial() {
        const partial = {};
        for (const [key, schema] of Object.entries(this.fields))partial[key] = "optional" in schema && schema.optional instanceof Function ? schema.optional() : schema;
        return this.setFields(partial);
    }
    deepPartial() {
        const next = $077fef39a0580000$var$deepPartial(this);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.setFields(picked, this._excludedEdges.filter(([a, b])=>keys.includes(a) && keys.includes(b)));
    }
    omit(keys) {
        const remaining = [];
        for (const key of Object.keys(this.fields)){
            if (keys.includes(key)) continue;
            remaining.push(key);
        }
        return this.pick(remaining);
    }
    from(from, to, alias) {
        let fromGetter = (0, $9xXug.getter)(from, true);
        return this.transform((obj)=>{
            if (!obj) return obj;
            let newObj = obj;
            if ($077fef39a0580000$var$deepHas(obj, from)) {
                newObj = Object.assign({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($077fef39a0580000$var$parseJson);
    }
    noUnknown(noAllow = true, message = $077fef39a0580000$var$object.noUnknown) {
        if (typeof noAllow !== "boolean") {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: "noUnknown",
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $077fef39a0580000$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(", ")
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = $077fef39a0580000$var$object.noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>{
            if (!obj) return obj;
            const result = {};
            for (const key of Object.keys(obj))result[fn(key)] = obj[key];
            return result;
        });
    }
    camelCase() {
        return this.transformKeys((0, $dbdUT.camelCase));
    }
    snakeCase() {
        return this.transformKeys((0, $dbdUT.snakeCase));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, $dbdUT.snakeCase)(key).toUpperCase());
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.fields = {};
        for (const [key, value] of Object.entries(next.fields)){
            var _innerOptions2;
            let innerOptions = options;
            if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            base.fields[key] = value.describe(innerOptions);
        }
        return base;
    }
    constructor(spec){
        super({
            type: "object",
            check (value) {
                return $077fef39a0580000$var$isObject(value) || typeof value === "function";
            }
        });
        this.fields = Object.create(null);
        this._sortErrors = $077fef39a0580000$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            if (spec) this.shape(spec);
        });
    }
}
$077fef39a0580000$export$be5493f9613cbbe.prototype = $077fef39a0580000$export$18b4fc70ec7eccf8.prototype;
function $077fef39a0580000$export$2f23118c22fb2630(type) {
    return new $077fef39a0580000$export$4347112b8447a7d(type);
}
class $077fef39a0580000$export$4347112b8447a7d extends $077fef39a0580000$export$19342e026b58ebb7 {
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts);
        // should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
                path: `${_opts.path || ""}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        var _options$recursive;
        // let sync = options.sync;
        // let path = options.path;
        let innerType = this.innerType;
        // let endEarly = options.abortEarly ?? this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, panic, (arrayErrors, value)=>{
            var _options$originalValu2;
            if (!recursive || !innerType || !this._typeCheck(value)) {
                next(arrayErrors, value);
                return;
            }
            // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let index = 0; index < value.length; index++){
                var _options$originalValu;
                tests[index] = innerType.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(arrayErrors), value));
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        return next;
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($077fef39a0580000$var$parseJson);
    }
    concat(schema) {
        let next = super.concat(schema);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        if (schema.innerType) // @ts-expect-error readonly
        next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat and will break
        next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!$077fef39a0580000$export$213e2a3e7c4f326e(schema)) throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + $077fef39a0580000$export$5790025c6e6c2ba6(schema));
        // @ts-expect-error readonly
        next.innerType = schema;
        next.spec = Object.assign({}, next.spec, {
            types: schema
        });
        return next;
    }
    length(length, message = $077fef39a0580000$var$array.length) {
        return this.test({
            message: message,
            name: "length",
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || $077fef39a0580000$var$array.min;
        return this.test({
            message: message,
            name: "min",
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            // FIXME(ts): Array<typeof T>
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || $077fef39a0580000$var$array.max;
        return this.test({
            message: message,
            name: "max",
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        if (next.innerType) {
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[0]
            });
            base.innerType = next.innerType.describe(innerOptions);
        }
        return base;
    }
    constructor(type){
        super({
            type: "array",
            spec: {
                types: type
            },
            check (v) {
                return Array.isArray(v);
            }
        });
        // `undefined` specifically means uninitialized, as opposed to "no subtype"
        this.innerType = void 0;
        this.innerType = type;
    }
}
$077fef39a0580000$export$2f23118c22fb2630.prototype = $077fef39a0580000$export$4347112b8447a7d.prototype;
// @ts-ignore
function $077fef39a0580000$export$65e3907585753458(schemas) {
    return new $077fef39a0580000$export$411c3b3687e8ecc8(schemas);
}
class $077fef39a0580000$export$411c3b3687e8ecc8 extends $077fef39a0580000$export$19342e026b58ebb7 {
    _cast(inputValue, options) {
        const { types: types } = this.spec;
        const value = super._cast(inputValue, options);
        if (!this._typeCheck(value)) return value;
        let isChanged = false;
        const castArray = types.map((type, idx)=>{
            const castElement = type.cast(value[idx], Object.assign({}, options, {
                path: `${options.path || ""}[${idx}]`
            }));
            if (castElement !== value[idx]) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        let itemTypes = this.spec.types;
        super._validate(_value, options, panic, (tupleErrors, value)=>{
            var _options$originalValu2;
            // intentionally not respecting recursive
            if (!this._typeCheck(value)) {
                next(tupleErrors, value);
                return;
            }
            let tests = [];
            for (let [index, itemSchema] of itemTypes.entries()){
                var _options$originalValu;
                tests[index] = itemSchema.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(tupleErrors), value));
        });
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.innerType = next.spec.types.map((schema, index)=>{
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[index]
            });
            return schema.describe(innerOptions);
        });
        return base;
    }
    constructor(schemas){
        super({
            type: "tuple",
            spec: {
                types: schemas
            },
            check (v) {
                const types = this.spec.types;
                return Array.isArray(v) && v.length === types.length;
            }
        });
        this.withMutation(()=>{
            this.typeError($077fef39a0580000$var$tuple.notType);
        });
    }
}
$077fef39a0580000$export$65e3907585753458.prototype = $077fef39a0580000$export$411c3b3687e8ecc8.prototype;
function $077fef39a0580000$export$488013bae63b21da(builder) {
    return new $077fef39a0580000$var$Lazy(builder);
}
class $077fef39a0580000$var$Lazy {
    clone(spec) {
        const next = new $077fef39a0580000$var$Lazy(this.builder);
        next.spec = Object.assign({}, this.spec, spec);
        return next;
    }
    optionality(optional) {
        const next = this.clone({
            optional: optional
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    asNestedTest(config) {
        let { key: key, index: index, parent: parent, options: options } = config;
        let value = parent[index != null ? index : key];
        return this._resolve(value, Object.assign({}, options, {
            value: value,
            parent: parent
        })).asNestedTest(config);
    }
    validate(value, options) {
        return this._resolve(value, options).validate(value, options);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
    describe(options) {
        return options ? this.resolve(options).describe(options) : {
            type: "lazy",
            meta: this.spec.meta,
            label: undefined
        };
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    constructor(builder){
        this.type = "lazy";
        this.__isYupSchema__ = true;
        this.spec = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!$077fef39a0580000$export$213e2a3e7c4f326e(schema)) throw new TypeError("lazy() functions must return a valid schema");
            if (this.spec.optional) schema = schema.optional();
            return schema.resolve(options);
        };
        this.builder = builder;
        this.spec = {
            meta: undefined,
            optional: false
        };
    }
}
function $077fef39a0580000$export$c8aadf3621e41efb(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            $077fef39a0580000$export$d7f512c98c859244[type][method] = custom[type][method];
        });
    });
}
function $077fef39a0580000$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !$077fef39a0580000$export$213e2a3e7c4f326e(schemaType.prototype)) throw new TypeError("You must provide a yup schema constructor function");
    if (typeof name !== "string") throw new TypeError("A Method name must be provided");
    if (typeof fn !== "function") throw new TypeError("Method function must be provided");
    schemaType.prototype[name] = fn;
}

});
parcelRegister("9xXug", function(module, exports) {
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ "use strict";
function $6f35570ba1ff42db$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$6f35570ba1ff42db$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$6f35570ba1ff42db$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$6f35570ba1ff42db$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $6f35570ba1ff42db$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $6f35570ba1ff42db$var$DIGIT_REGEX = /^\d+$/, $6f35570ba1ff42db$var$LEAD_DIGIT_REGEX = /^\d/, $6f35570ba1ff42db$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $6f35570ba1ff42db$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $6f35570ba1ff42db$var$MAX_CACHE_SIZE = 512;
var $6f35570ba1ff42db$var$pathCache = new $6f35570ba1ff42db$var$Cache($6f35570ba1ff42db$var$MAX_CACHE_SIZE), $6f35570ba1ff42db$var$setCache = new $6f35570ba1ff42db$var$Cache($6f35570ba1ff42db$var$MAX_CACHE_SIZE), $6f35570ba1ff42db$var$getCache = new $6f35570ba1ff42db$var$Cache($6f35570ba1ff42db$var$MAX_CACHE_SIZE);
var $6f35570ba1ff42db$var$config;
module.exports = {
    Cache: $6f35570ba1ff42db$var$Cache,
    split: $6f35570ba1ff42db$var$split,
    normalizePath: $6f35570ba1ff42db$var$normalizePath,
    setter: function(path) {
        var parts = $6f35570ba1ff42db$var$normalizePath(path);
        return $6f35570ba1ff42db$var$setCache.get(path) || $6f35570ba1ff42db$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === "__proto__" || part === "constructor" || part === "prototype") return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $6f35570ba1ff42db$var$normalizePath(path);
        return $6f35570ba1ff42db$var$getCache.get(path) || $6f35570ba1ff42db$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($6f35570ba1ff42db$var$isQuoted(part) || $6f35570ba1ff42db$var$DIGIT_REGEX.test(part) ? "[" + part + "]" : (path ? "." : "") + part);
        }, "");
    },
    forEach: function(path, cb, thisArg) {
        $6f35570ba1ff42db$var$forEach(Array.isArray(path) ? path : $6f35570ba1ff42db$var$split(path), cb, thisArg);
    }
};
function $6f35570ba1ff42db$var$normalizePath(path) {
    return $6f35570ba1ff42db$var$pathCache.get(path) || $6f35570ba1ff42db$var$pathCache.set(path, $6f35570ba1ff42db$var$split(path).map(function(part) {
        return part.replace($6f35570ba1ff42db$var$CLEAN_QUOTES_REGEX, "$2");
    }));
}
function $6f35570ba1ff42db$var$split(path) {
    return path.match($6f35570ba1ff42db$var$SPLIT_REGEX) || [
        ""
    ];
}
function $6f35570ba1ff42db$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($6f35570ba1ff42db$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $6f35570ba1ff42db$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $6f35570ba1ff42db$var$isQuoted(str) {
    return typeof str === "string" && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $6f35570ba1ff42db$var$hasLeadingNumber(part) {
    return part.match($6f35570ba1ff42db$var$LEAD_DIGIT_REGEX) && !part.match($6f35570ba1ff42db$var$DIGIT_REGEX);
}
function $6f35570ba1ff42db$var$hasSpecialChars(part) {
    return $6f35570ba1ff42db$var$SPEC_CHAR_REGEX.test(part);
}
function $6f35570ba1ff42db$var$shouldBeQuoted(part) {
    return !$6f35570ba1ff42db$var$isQuoted(part) && ($6f35570ba1ff42db$var$hasLeadingNumber(part) || $6f35570ba1ff42db$var$hasSpecialChars(part));
}

});

parcelRegister("dbdUT", function(module, exports) {
const $998718fd6080a7ca$var$reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const $998718fd6080a7ca$var$words = (str)=>str.match($998718fd6080a7ca$var$reWords) || [];
const $998718fd6080a7ca$var$upperFirst = (str)=>str[0].toUpperCase() + str.slice(1);
const $998718fd6080a7ca$var$join = (str, d)=>$998718fd6080a7ca$var$words(str).join(d).toLowerCase();
const $998718fd6080a7ca$var$camelCase = (str)=>$998718fd6080a7ca$var$words(str).reduce((acc, next)=>`${acc}${!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()}`, "");
const $998718fd6080a7ca$var$pascalCase = (str)=>$998718fd6080a7ca$var$upperFirst($998718fd6080a7ca$var$camelCase(str));
const $998718fd6080a7ca$var$snakeCase = (str)=>$998718fd6080a7ca$var$join(str, "_");
const $998718fd6080a7ca$var$kebabCase = (str)=>$998718fd6080a7ca$var$join(str, "-");
const $998718fd6080a7ca$var$sentenceCase = (str)=>$998718fd6080a7ca$var$upperFirst($998718fd6080a7ca$var$join(str, " "));
const $998718fd6080a7ca$var$titleCase = (str)=>$998718fd6080a7ca$var$words(str).map($998718fd6080a7ca$var$upperFirst).join(" ");
module.exports = {
    words: $998718fd6080a7ca$var$words,
    upperFirst: $998718fd6080a7ca$var$upperFirst,
    camelCase: $998718fd6080a7ca$var$camelCase,
    pascalCase: $998718fd6080a7ca$var$pascalCase,
    snakeCase: $998718fd6080a7ca$var$snakeCase,
    kebabCase: $998718fd6080a7ca$var$kebabCase,
    sentenceCase: $998718fd6080a7ca$var$sentenceCase,
    titleCase: $998718fd6080a7ca$var$titleCase
};

});

parcelRegister("eTC75", function(module, exports) {
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ module.exports = function(edges) {
    return $ad83c44445957d3e$var$toposort($ad83c44445957d3e$var$uniqueNodes(edges), edges);
};
module.exports.array = $ad83c44445957d3e$var$toposort;
function $ad83c44445957d3e$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $ad83c44445957d3e$var$makeOutgoingEdges(edges), nodesHash = $ad83c44445957d3e$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error("Cyclic dependency" + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $ad83c44445957d3e$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $ad83c44445957d3e$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $ad83c44445957d3e$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}

});


parcelRegister("e6DOx", function(module, exports) {


module.exports = (parcelRequire("9ONCo"))((parcelRequire("3pG7n")).resolve("8hCtD")).then(()=>parcelRequire("cxjRc"));

});

parcelRegister("6nnFN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a474112a30cbc45$export$2e2bcd8739ae039; });

var $fshLi = parcelRequire("fshLi");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $fshLi.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $4a474112a30cbc45$export$2e2bcd8739ae039 = cloneBuffer;

});
parcelRegister("fshLi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4073fa938112c27$export$2e2bcd8739ae039; });

var $lJj8p = parcelRequire("lJj8p");
/** Detect free variable `self`. */ var $b4073fa938112c27$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $b4073fa938112c27$var$root = (0, $lJj8p.default) || $b4073fa938112c27$var$freeSelf || Function("return this")();
var $b4073fa938112c27$export$2e2bcd8739ae039 = $b4073fa938112c27$var$root;

});
parcelRegister("lJj8p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd1ca4af10c4c49e$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $fd1ca4af10c4c49e$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $fd1ca4af10c4c49e$export$2e2bcd8739ae039 = $fd1ca4af10c4c49e$var$freeGlobal;

});



parcelRegister("42CIw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f1561bc208c6eda$export$2e2bcd8739ae039; });

var $fshLi = parcelRequire("fshLi");

var $5kAuJ = parcelRequire("5kAuJ");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $fshLi.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $5kAuJ.default);
var $2f1561bc208c6eda$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("5kAuJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e1b2111dee3642e$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $3e1b2111dee3642e$var$stubFalse() {
    return false;
}
var $3e1b2111dee3642e$export$2e2bcd8739ae039 = $3e1b2111dee3642e$var$stubFalse;

});


parcelRegister("fe9Eu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b15fa6837f1676a2$export$2e2bcd8739ae039; });

var $lJj8p = parcelRequire("lJj8p");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $lJj8p.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
var $b15fa6837f1676a2$export$2e2bcd8739ae039 = nodeUtil;

});

parcelRegister("6d3lL", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */ function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
}
/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */ function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
}
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__["delete"](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) object[key] = value;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
    var result;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            if (isHostObject(value)) return object ? value : {};
            result = initCloneObject(isFunc ? {} : value);
            if (!isDeep) return copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, baseClone, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (!isArr) var props = isFull ? getAllKeys(value) : keys(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
    });
    return result;
}
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */ function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var result = new buffer.constructor(buffer.length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */ function cloneMap(map, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
    return arrayReduce(array, addMapEntry, new map.constructor);
}
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */ function cloneSet(set, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
    return arrayReduce(array, addSetEntry, new set.constructor);
}
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        assignValue(object, key, newValue === undefined ? source[key] : newValue);
    }
    return object;
}
/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, cloneFunc, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return cloneMap(object, isDeep, cloneFunc);
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return cloneSet(object, isDeep, cloneFunc);
        case symbolTag:
            return cloneSymbol(object);
    }
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, true, true);
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : "";
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = cloneDeep;

});

parcelRegister("lj5HN", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEqual;

});

var $4ee8dbb07ae14fbf$exports = {};


(parcelRequire("3pG7n")).register((parcelRequire("9LRG6")).getBundleURL("gPLkr"), JSON.parse('["gPLkr","main.js","2uU34","prod.d6497366.js","faRaP","srt-parser.5ad31d99.js","fzZsA","ssa-parser.ba00731f.js","iCL6X","errors.dfd9c97a.js","1rtjd","vidstack-audio.c1bad67d.js","9ZwVl","vidstack-audio.c4117e15.js","71knP","vidstack-video.8ed21188.js","jxjEY","vidstack-hls.fb0db2e1.js","5ppjt","vidstack-dash.3084d30b.js","fYjTM","vidstack-vimeo.675da638.js","4n99l","vidstack-krOAtKMi.8fb537f3.js","32sUK","vidstack-youtube.2b7308c5.js","7FDt4","vidstack-Zc3I7oOd.f51afb8c.js","I2Gtd","vidstack-kV1-bfkY.5f8a73dd.js","jtrFD","vidstack-google-cast.5e4f2f02.js","bZP5r","vidstack-DJTshtlu.57399f2e.js","62pQ9","vidstack-H72EDyqs.e296e1b7.js","8hCtD","plyr-layout.8546df2a.js","jM1Fq","vidstack-DXxIKXmd.9c451987.js","lob87","main.css"]'));


window.app = (()=>{
    /**
     * Global utils functions
     * to move on from jQuery
     */ class appUtils {
        /**
         * Launch a function when dom is ready
         * @param {function} fn - Function to run
         */ static domReady(fn) {
            if (document.readyState != "loading") fn();
            else document.addEventListener("DOMContentLoaded", fn);
        }
        /**
         * Iterate over a NodeList
         * @param {NodeList} elements - NodeList
         * @param {function} fn - Function
         */ static nodesEach(elements, fn) {
            Array.prototype.forEach.call(elements, (el, i)=>{
                fn(el, i);
            });
        }
        /**
         * Create element
         * @param {string} html - String containing html
         */ static createElement(html) {
            const template = document.createElement("template");
            template.innerHTML = html.trim();
            return template.content.children;
        }
        /**
         * Add class to all element from a NodeList
         * @param {NodeList} elements - NodeList
         * @param {string} className - Class to add
         */ static nodesAddClass(elements, className) {
            Array.prototype.forEach.call(elements, (el, i)=>{
                el.classList.add(className);
            });
        }
        /**
         * Remove class to all element from a NodeList
         * @param {NodeList} elements - NodeList
         * @param {string} className - Class to remove
         */ static nodesRemoveClass(elements, className) {
            Array.prototype.forEach.call(elements, (el, i)=>{
                el.classList.remove(className);
            });
        }
        /**
         * Attach event to elems in NodeList
         * @param {string} event - Event name
         * @param {NodeList} elements - NodeList
         * @param {function} fn - function to execute
         */ static nodesEventListener(event, elements, fn) {
            Array.prototype.forEach.call(elements, (el, i)=>{
                el.addEventListener(event, fn.bind(this, el, i));
            });
        }
        /**
         * Debounce a function
         * @param {function} fn - Function to execute
         * @param {number} delay - Timeout delay
         */ static debounce(fn, delay = 250) {
            let timer = false;
            return ()=>{
                clearTimeout(timer);
                timer = setTimeout(()=>{
                    fn();
                }, delay);
            };
        }
        /**
         * Throttle a function
         * @param {function} fn - Function to execute
         * @param {number} delay - Timeout delay
         */ static throttle(fn, delay = 250) {
            let throttle = false;
            return ()=>{
                if (!throttle) {
                    fn();
                    throttle = true;
                    setTimeout(()=>{
                        throttle = false;
                    }, delay);
                }
            };
        }
        /**
         * Get a cookie
         * @param {string} cname - Cookie name
         */ static getCookie(cname) {
            let name = cname + "=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(";");
            for(let i = 0; i < ca.length; i++){
                let c = ca[i];
                while(c.charAt(0) == " ")c = c.substring(1);
                if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
            }
            return "";
        }
        /**
         * Set a cookie
         * @param {string} cname - Cookie name
         * @param {string} cvalue - Cookie value
         * @param {int} exminutes - Number of minutes
         */ static setCookie(cname, cvalue, exminutes) {
            const d = new Date();
            d.setTime(d.getTime() + exminutes * 60000);
            let expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }
    }
    const app = (element)=>new appUtils(element);
    // Return static functions
    app.domReady = appUtils.domReady;
    app.nodesEach = appUtils.nodesEach;
    app.nodesAddClass = appUtils.nodesAddClass;
    app.nodesRemoveClass = appUtils.nodesRemoveClass;
    app.nodesEventListener = appUtils.nodesEventListener;
    app.throttle = appUtils.throttle;
    app.debounce = appUtils.debounce;
    app.createElement = appUtils.createElement;
    app.getCookie = appUtils.getCookie;
    app.setCookie = appUtils.setCookie;
    return app;
})();


var $390f14e99fea332e$exports = {};




/*!
  * Bootstrap collapse.js v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    $390f14e99fea332e$exports = factory((parcelRequire("3MRB0")), (parcelRequire("eFdKX")), (parcelRequire("8Bd7h")), (parcelRequire("jpXV4")));
})($390f14e99fea332e$exports, function(BaseComponent, EventHandler, SelectorEngine, index_js) {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap collapse.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ const NAME = "collapse";
    const DATA_KEY = "bs.collapse";
    const EVENT_KEY = `.${DATA_KEY}`;
    const DATA_API_KEY = ".data-api";
    const EVENT_SHOW = `show${EVENT_KEY}`;
    const EVENT_SHOWN = `shown${EVENT_KEY}`;
    const EVENT_HIDE = `hide${EVENT_KEY}`;
    const EVENT_HIDDEN = `hidden${EVENT_KEY}`;
    const EVENT_CLICK_DATA_API = `click${EVENT_KEY}${DATA_API_KEY}`;
    const CLASS_NAME_SHOW = "show";
    const CLASS_NAME_COLLAPSE = "collapse";
    const CLASS_NAME_COLLAPSING = "collapsing";
    const CLASS_NAME_COLLAPSED = "collapsed";
    const CLASS_NAME_DEEPER_CHILDREN = `:scope .${CLASS_NAME_COLLAPSE} .${CLASS_NAME_COLLAPSE}`;
    const CLASS_NAME_HORIZONTAL = "collapse-horizontal";
    const WIDTH = "width";
    const HEIGHT = "height";
    const SELECTOR_ACTIVES = ".collapse.show, .collapse.collapsing";
    const SELECTOR_DATA_TOGGLE = '[data-bs-toggle="collapse"]';
    const Default = {
        parent: null,
        toggle: true
    };
    const DefaultType = {
        parent: "(null|element)",
        toggle: "boolean"
    };
    /**
   * Class definition
   */ class Collapse extends BaseComponent {
        // Getters
        static get Default() {
            return Default;
        }
        static get DefaultType() {
            return DefaultType;
        }
        static get NAME() {
            return NAME;
        }
        // Public
        toggle() {
            if (this._isShown()) this.hide();
            else this.show();
        }
        show() {
            if (this._isTransitioning || this._isShown()) return;
            let activeChildren = [];
            // find active children
            if (this._config.parent) activeChildren = this._getFirstLevelChildren(SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>Collapse.getOrCreateInstance(element, {
                    toggle: false
                }));
            if (activeChildren.length && activeChildren[0]._isTransitioning) return;
            const startEvent = EventHandler.trigger(this._element, EVENT_SHOW);
            if (startEvent.defaultPrevented) return;
            for (const activeInstance of activeChildren)activeInstance.hide();
            const dimension = this._getDimension();
            this._element.classList.remove(CLASS_NAME_COLLAPSE);
            this._element.classList.add(CLASS_NAME_COLLAPSING);
            this._element.style[dimension] = 0;
            this._addAriaAndCollapsedClass(this._triggerArray, true);
            this._isTransitioning = true;
            const complete = ()=>{
                this._isTransitioning = false;
                this._element.classList.remove(CLASS_NAME_COLLAPSING);
                this._element.classList.add(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW);
                this._element.style[dimension] = "";
                EventHandler.trigger(this._element, EVENT_SHOWN);
            };
            const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
            const scrollSize = `scroll${capitalizedDimension}`;
            this._queueCallback(complete, this._element, true);
            this._element.style[dimension] = `${this._element[scrollSize]}px`;
        }
        hide() {
            if (this._isTransitioning || !this._isShown()) return;
            const startEvent = EventHandler.trigger(this._element, EVENT_HIDE);
            if (startEvent.defaultPrevented) return;
            const dimension = this._getDimension();
            this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
            index_js.reflow(this._element);
            this._element.classList.add(CLASS_NAME_COLLAPSING);
            this._element.classList.remove(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW);
            for (const trigger of this._triggerArray){
                const element = SelectorEngine.getElementFromSelector(trigger);
                if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                    trigger
                ], false);
            }
            this._isTransitioning = true;
            const complete = ()=>{
                this._isTransitioning = false;
                this._element.classList.remove(CLASS_NAME_COLLAPSING);
                this._element.classList.add(CLASS_NAME_COLLAPSE);
                EventHandler.trigger(this._element, EVENT_HIDDEN);
            };
            this._element.style[dimension] = "";
            this._queueCallback(complete, this._element, true);
        }
        _isShown(element = this._element) {
            return element.classList.contains(CLASS_NAME_SHOW);
        }
        // Private
        _configAfterMerge(config) {
            config.toggle = Boolean(config.toggle); // Coerce string values
            config.parent = index_js.getElement(config.parent);
            return config;
        }
        _getDimension() {
            return this._element.classList.contains(CLASS_NAME_HORIZONTAL) ? WIDTH : HEIGHT;
        }
        _initializeChildren() {
            if (!this._config.parent) return;
            const children = this._getFirstLevelChildren(SELECTOR_DATA_TOGGLE);
            for (const element of children){
                const selected = SelectorEngine.getElementFromSelector(element);
                if (selected) this._addAriaAndCollapsedClass([
                    element
                ], this._isShown(selected));
            }
        }
        _getFirstLevelChildren(selector) {
            const children = SelectorEngine.find(CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
            // remove children if greater depth
            return SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
        }
        _addAriaAndCollapsedClass(triggerArray, isOpen) {
            if (!triggerArray.length) return;
            for (const element of triggerArray){
                element.classList.toggle(CLASS_NAME_COLLAPSED, !isOpen);
                element.setAttribute("aria-expanded", isOpen);
            }
        }
        // Static
        static jQueryInterface(config) {
            const _config = {};
            if (typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
            return this.each(function() {
                const data = Collapse.getOrCreateInstance(this, _config);
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                    data[config]();
                }
            });
        }
        constructor(element, config){
            super(element, config);
            this._isTransitioning = false;
            this._triggerArray = [];
            const toggleList = SelectorEngine.find(SELECTOR_DATA_TOGGLE);
            for (const elem of toggleList){
                const selector = SelectorEngine.getSelectorFromElement(elem);
                const filterElement = SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
                if (selector !== null && filterElement.length) this._triggerArray.push(elem);
            }
            this._initializeChildren();
            if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
            if (this._config.toggle) this.toggle();
        }
    }
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function(event) {
        // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
        if (event.target.tagName === "A" || event.delegateTarget && event.delegateTarget.tagName === "A") event.preventDefault();
        for (const element of SelectorEngine.getMultipleElementsFromSelector(this))Collapse.getOrCreateInstance(element, {
            toggle: false
        }).toggle();
    });
    /**
   * jQuery
   */ index_js.defineJQueryPlugin(Collapse);
    return Collapse;
});



var $8B3mG = parcelRequire("8B3mG");

var $57dmi = parcelRequire("57dmi");

var $fhH8k = parcelRequire("fhH8k");

var $4vwVC = parcelRequire("4vwVC");

var $2u9SC = parcelRequire("2u9SC");

var $9P4tJ = parcelRequire("9P4tJ");

var $97zcJ = parcelRequire("97zcJ");

var $8B3mG = parcelRequire("8B3mG");

var $57dmi = parcelRequire("57dmi");

var $fhH8k = parcelRequire("fhH8k");

var $4vwVC = parcelRequire("4vwVC");

var $2u9SC = parcelRequire("2u9SC");

var $9P4tJ = parcelRequire("9P4tJ");

var $97zcJ = parcelRequire("97zcJ");

var $8B3mG = parcelRequire("8B3mG");

var $6KfMo = parcelRequire("6KfMo");

var $8kkZn = parcelRequire("8kkZn");

var $6ELNS = parcelRequire("6ELNS");

var $ihjXw = parcelRequire("ihjXw");

var $5UOkG = parcelRequire("5UOkG");

var $eRuH7 = parcelRequire("eRuH7");

var $9KZm0 = parcelRequire("9KZm0");

var $dLb9W = parcelRequire("dLb9W");

var $ciZW6 = parcelRequire("ciZW6");

var $hzYuC = parcelRequire("hzYuC");

var $jWjYZ = parcelRequire("jWjYZ");
let $9f21272e0549cf92$var$_ListSymbol_readonly = (0, $5UOkG.ListSymbol).readonly, $9f21272e0549cf92$var$_Symbol_iterator = Symbol.iterator, $9f21272e0549cf92$var$_ListSymbol_add = (0, $5UOkG.ListSymbol).add, $9f21272e0549cf92$var$_ListSymbol_remove = (0, $5UOkG.ListSymbol).remove, $9f21272e0549cf92$var$_ListSymbol_reset = (0, $5UOkG.ListSymbol).reset, $9f21272e0549cf92$var$_ListSymbol_setReadonly = (0, $5UOkG.ListSymbol).setReadonly;
class $9f21272e0549cf92$export$54c2e3dc7acea9f5 extends (0, $8B3mG.EventsTarget) {
    get length() {
        return this.items.length;
    }
    get readonly() {
        return this[(0, $5UOkG.ListSymbol).readonly];
    }
    /**
   * Returns the index of the first occurrence of the given item, or -1 if it is not present.
   */ indexOf(item) {
        return this.items.indexOf(item);
    }
    /**
   * Returns an item matching the given `id`, or `null` if not present.
   */ getById(id) {
        if (id === "") return null;
        return this.items.find((item)=>item.id === id) ?? null;
    }
    /**
   * Transform list to an array.
   */ toArray() {
        return [
            ...this.items
        ];
    }
    [$9f21272e0549cf92$var$_Symbol_iterator]() {
        return this.items.values();
    }
    /** @internal */ [$9f21272e0549cf92$var$_ListSymbol_add](item, trigger) {
        const index = this.items.length;
        if (!("" + index in this)) Object.defineProperty(this, index, {
            get () {
                return this.items[index];
            }
        });
        if (this.items.includes(item)) return;
        this.items.push(item);
        this.dispatchEvent(new (0, $8B3mG.DOMEvent)("add", {
            detail: item,
            trigger: trigger
        }));
    }
    /** @internal */ [$9f21272e0549cf92$var$_ListSymbol_remove](item, trigger) {
        const index = this.items.indexOf(item);
        if (index >= 0) {
            this[(0, $5UOkG.ListSymbol).onRemove]?.(item, trigger);
            this.items.splice(index, 1);
            this.dispatchEvent(new (0, $8B3mG.DOMEvent)("remove", {
                detail: item,
                trigger: trigger
            }));
        }
    }
    /** @internal */ [$9f21272e0549cf92$var$_ListSymbol_reset](trigger) {
        for (const item of [
            ...this.items
        ])this[(0, $5UOkG.ListSymbol).remove](item, trigger);
        this.items = [];
        this[(0, $5UOkG.ListSymbol).setReadonly](false, trigger);
        this[(0, $5UOkG.ListSymbol).onReset]?.();
    }
    /** @internal */ [$9f21272e0549cf92$var$_ListSymbol_setReadonly](readonly, trigger) {
        if (this[(0, $5UOkG.ListSymbol).readonly] === readonly) return;
        this[(0, $5UOkG.ListSymbol).readonly] = readonly;
        this.dispatchEvent(new (0, $8B3mG.DOMEvent)("readonly-change", {
            detail: readonly,
            trigger: trigger
        }));
    }
    constructor(...args){
        super(...args);
        (0, $97zcJ._)(this, "items", []);
        /** @internal */ (0, $97zcJ._)(this, $9f21272e0549cf92$var$_ListSymbol_readonly, false);
    }
}
const $9f21272e0549cf92$var$CAN_FULLSCREEN = (0, $8B3mG.fscreen).fullscreenEnabled;
var /**
   * Tracks whether we're the active fullscreen event listener. Fullscreen events can only be
   * listened to globally on the document so we need to know if they relate to the current host
   * element or not.
   */ $9f21272e0549cf92$var$_listening = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_active = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_onDisconnect = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onChange = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onError = /*#__PURE__*/ new WeakSet();
class $9f21272e0549cf92$export$9822702783955312 extends (0, $8B3mG.ViewController) {
    get active() {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_active);
    }
    get supported() {
        return $9f21272e0549cf92$var$CAN_FULLSCREEN;
    }
    onConnect() {
        new (0, $8B3mG.EventsController)((0, $8B3mG.fscreen)).add("fullscreenchange", (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onChange, $9f21272e0549cf92$var$onChange).bind(this)).add("fullscreenerror", (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onError, $9f21272e0549cf92$var$onError).bind(this));
        (0, $8B3mG.onDispose)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_onDisconnect, $9f21272e0549cf92$var$onDisconnect).bind(this));
    }
    async enter() {
        try {
            (0, $4vwVC._)(this, $9f21272e0549cf92$var$_listening, true);
            if (!this.el || $9f21272e0549cf92$var$isFullscreen(this.el)) return;
            $9f21272e0549cf92$var$assertFullscreenAPI();
            return (0, $8B3mG.fscreen).requestFullscreen(this.el);
        } catch (error) {
            (0, $4vwVC._)(this, $9f21272e0549cf92$var$_listening, false);
            throw error;
        }
    }
    async exit() {
        if (!this.el || !$9f21272e0549cf92$var$isFullscreen(this.el)) return;
        $9f21272e0549cf92$var$assertFullscreenAPI();
        return (0, $8B3mG.fscreen).exitFullscreen();
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onDisconnect);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onChange);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onError);
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_listening, {
            writable: true,
            value: false
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_active, {
            writable: true,
            value: false
        });
    }
}
async function $9f21272e0549cf92$var$onDisconnect() {
    if ($9f21272e0549cf92$var$CAN_FULLSCREEN) await this.exit();
}
function $9f21272e0549cf92$var$onChange(event) {
    const active = $9f21272e0549cf92$var$isFullscreen(this.el);
    if (active === (0, $57dmi._)(this, $9f21272e0549cf92$var$_active)) return;
    if (!active) (0, $4vwVC._)(this, $9f21272e0549cf92$var$_listening, false);
    (0, $4vwVC._)(this, $9f21272e0549cf92$var$_active, active);
    this.dispatch("fullscreen-change", {
        detail: active,
        trigger: event
    });
}
function $9f21272e0549cf92$var$onError(event) {
    if (!(0, $57dmi._)(this, $9f21272e0549cf92$var$_listening)) return;
    this.dispatch("fullscreen-error", {
        detail: null,
        trigger: event
    });
    (0, $4vwVC._)(this, $9f21272e0549cf92$var$_listening, false);
}
function $9f21272e0549cf92$export$e041d5707970e318() {
    return $9f21272e0549cf92$var$CAN_FULLSCREEN;
}
function $9f21272e0549cf92$var$isFullscreen(host) {
    if ((0, $8B3mG.fscreen).fullscreenElement === host) return true;
    try {
        return host.matches(// @ts-expect-error - `fullscreenPseudoClass` is missing from `@types/fscreen`.
        (0, $8B3mG.fscreen).fullscreenPseudoClass);
    } catch (error) {
        return false;
    }
}
function $9f21272e0549cf92$var$assertFullscreenAPI() {
    if ($9f21272e0549cf92$var$CAN_FULLSCREEN) return;
    throw Error("[vidstack] no fullscreen API");
}
var $9f21272e0549cf92$var$_type = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_locked = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_currentLock = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_onDisconnect1 = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onOrientationChange = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_assertScreenOrientationAPI = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_getScreenOrientation = /*#__PURE__*/ new WeakSet();
class $9f21272e0549cf92$export$e048a67118113df5 extends (0, $8B3mG.ViewController) {
    /**
   * The current screen orientation type.
   *
   * @signal
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ScreenOrientation}
   * @see https://w3c.github.io/screen-orientation/#screen-orientation-types-and-locks
   */ get type() {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_type).call(this);
    }
    /**
   * Whether the screen orientation is currently locked.
   *
   * @signal
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ScreenOrientation}
   * @see https://w3c.github.io/screen-orientation/#screen-orientation-types-and-locks
   */ get locked() {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_locked).call(this);
    }
    /**
   * Whether the viewport is in a portrait orientation.
   *
   * @signal
   */ get portrait() {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_type).call(this).startsWith("portrait");
    }
    /**
   * Whether the viewport is in a landscape orientation.
   *
   * @signal
   */ get landscape() {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_type).call(this).startsWith("landscape");
    }
    /**
   * Whether the native Screen Orientation API is available.
   */ get supported() {
        return $9f21272e0549cf92$export$e048a67118113df5.supported;
    }
    onConnect() {
        if (this.supported) (0, $8B3mG.listenEvent)(screen.orientation, "change", (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onOrientationChange, $9f21272e0549cf92$var$onOrientationChange).bind(this));
        else {
            const query = window.matchMedia("(orientation: landscape)");
            query.onchange = (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onOrientationChange, $9f21272e0549cf92$var$onOrientationChange).bind(this);
            (0, $8B3mG.onDispose)(()=>query.onchange = null);
        }
        (0, $8B3mG.onDispose)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_onDisconnect1, $9f21272e0549cf92$var$onDisconnect1).bind(this));
    }
    /**
   * Locks the orientation of the screen to the desired orientation type using the
   * Screen Orientation API.
   *
   * @param lockType - The screen lock orientation type.
   * @throws Error - If screen orientation API is unavailable.
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Screen/orientation}
   * @see {@link https://w3c.github.io/screen-orientation}
   */ async lock(lockType) {
        if ((0, $8B3mG.peek)((0, $57dmi._)(this, $9f21272e0549cf92$var$_locked)) || (0, $57dmi._)(this, $9f21272e0549cf92$var$_currentLock) === lockType) return;
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_assertScreenOrientationAPI, $9f21272e0549cf92$var$assertScreenOrientationAPI).call(this);
        await screen.orientation.lock(lockType);
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_locked).set(true);
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_currentLock, lockType);
    }
    /**
   * Unlocks the orientation of the screen to it's default state using the Screen Orientation
   * API. This method will throw an error if the API is unavailable.
   *
   * @throws Error - If screen orientation API is unavailable.
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Screen/orientation}
   * @see {@link https://w3c.github.io/screen-orientation}
   */ async unlock() {
        if (!(0, $8B3mG.peek)((0, $57dmi._)(this, $9f21272e0549cf92$var$_locked))) return;
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_assertScreenOrientationAPI, $9f21272e0549cf92$var$assertScreenOrientationAPI).call(this);
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_currentLock, void 0);
        await screen.orientation.unlock();
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_locked).set(false);
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onDisconnect1);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onOrientationChange);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_assertScreenOrientationAPI);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_getScreenOrientation);
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_type, {
            writable: true,
            value: (0, $8B3mG.signal)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_getScreenOrientation, $9f21272e0549cf92$var$getScreenOrientation).call(this))
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_locked, {
            writable: true,
            value: (0, $8B3mG.signal)(false)
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_currentLock, {
            writable: true,
            value: void 0
        });
    }
}
/**
   * Whether the native Screen Orientation API is available.
   */ (0, $97zcJ._)($9f21272e0549cf92$export$e048a67118113df5, "supported", (0, $8kkZn.canOrientScreen)());
async function $9f21272e0549cf92$var$onDisconnect1() {
    if (this.supported && (0, $57dmi._)(this, $9f21272e0549cf92$var$_locked).call(this)) await this.unlock();
}
function $9f21272e0549cf92$var$onOrientationChange(event) {
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_type).set((0, $2u9SC._)(this, $9f21272e0549cf92$var$_getScreenOrientation, $9f21272e0549cf92$var$getScreenOrientation).call(this));
    this.dispatch("orientation-change", {
        detail: {
            orientation: (0, $8B3mG.peek)((0, $57dmi._)(this, $9f21272e0549cf92$var$_type)),
            lock: (0, $57dmi._)(this, $9f21272e0549cf92$var$_currentLock)
        },
        trigger: event
    });
}
function $9f21272e0549cf92$var$assertScreenOrientationAPI() {
    if (this.supported) return;
    throw Error("[vidstack] no orientation API");
}
function $9f21272e0549cf92$var$getScreenOrientation() {
    if (this.supported) return window.screen.orientation.type;
    return window.innerWidth >= window.innerHeight ? "landscape-primary" : "portrait-primary";
}
function $9f21272e0549cf92$export$47b7db197eee1042(src) {
    return !(0, $8B3mG.isString)(src) && "width" in src && "height" in src && (0, $8B3mG.isNumber)(src.width) && (0, $8B3mG.isNumber)(src.height);
}
const $9f21272e0549cf92$export$8cef61637918b288 = new (0, $8B3mG.State)({
    artist: "",
    artwork: null,
    audioTrack: null,
    audioTracks: [],
    autoPlay: false,
    autoPlayError: null,
    audioGain: null,
    buffered: new (0, $6ELNS.TimeRange)(),
    canLoad: false,
    canLoadPoster: false,
    canFullscreen: false,
    canOrientScreen: (0, $8kkZn.canOrientScreen)(),
    canPictureInPicture: false,
    canPlay: false,
    clipStartTime: 0,
    clipEndTime: 0,
    controls: false,
    get iOSControls () {
        return (0, $8kkZn.IS_IPHONE) && this.mediaType === "video" && (!this.playsInline || !(0, $8B3mG.fscreen).fullscreenEnabled && this.fullscreen);
    },
    get nativeControls () {
        return this.controls || this.iOSControls;
    },
    controlsVisible: false,
    get controlsHidden () {
        return !this.controlsVisible;
    },
    crossOrigin: null,
    ended: false,
    error: null,
    fullscreen: false,
    get loop () {
        return this.providedLoop || this.userPrefersLoop;
    },
    logLevel: "silent",
    mediaType: "unknown",
    muted: false,
    paused: true,
    played: new (0, $6ELNS.TimeRange)(),
    playing: false,
    playsInline: false,
    pictureInPicture: false,
    preload: "metadata",
    playbackRate: 1,
    qualities: [],
    quality: null,
    autoQuality: false,
    canSetQuality: true,
    canSetPlaybackRate: true,
    canSetVolume: false,
    canSetAudioGain: false,
    seekable: new (0, $6ELNS.TimeRange)(),
    seeking: false,
    source: {
        src: "",
        type: ""
    },
    sources: [],
    started: false,
    textTracks: [],
    textTrack: null,
    get hasCaptions () {
        return this.textTracks.filter((0, $ihjXw.isTrackCaptionKind)).length > 0;
    },
    volume: 1,
    waiting: false,
    realCurrentTime: 0,
    get currentTime () {
        return this.ended ? this.duration : this.clipStartTime > 0 ? Math.max(0, Math.min(this.realCurrentTime - this.clipStartTime, this.duration)) : this.realCurrentTime;
    },
    providedDuration: -1,
    intrinsicDuration: 0,
    get realDuration () {
        return this.providedDuration > 0 ? this.providedDuration : this.intrinsicDuration;
    },
    get duration () {
        return this.clipEndTime > 0 ? this.clipEndTime - this.clipStartTime : Math.max(0, this.realDuration - this.clipStartTime);
    },
    get title () {
        return this.providedTitle || this.inferredTitle;
    },
    get poster () {
        return this.providedPoster || this.inferredPoster;
    },
    get viewType () {
        return this.providedViewType !== "unknown" ? this.providedViewType : this.inferredViewType;
    },
    get streamType () {
        return this.providedStreamType !== "unknown" ? this.providedStreamType : this.inferredStreamType;
    },
    get currentSrc () {
        return this.source;
    },
    get bufferedStart () {
        const start = (0, $6ELNS.getTimeRangesStart)(this.buffered) ?? 0;
        return Math.max(0, start - this.clipStartTime);
    },
    get bufferedEnd () {
        const end = (0, $6ELNS.getTimeRangesEnd)(this.buffered) ?? 0;
        return Math.min(this.duration, Math.max(0, end - this.clipStartTime));
    },
    get seekableStart () {
        const start = (0, $6ELNS.getTimeRangesStart)(this.seekable) ?? 0;
        return Math.max(0, Math.abs(start - this.clipStartTime));
    },
    get seekableEnd () {
        const end = this.canPlay ? (0, $6ELNS.getTimeRangesEnd)(this.seekable) ?? Infinity : 0;
        return this.clipEndTime > 0 ? Math.max(this.clipEndTime, Math.max(0, end - this.clipStartTime)) : end;
    },
    get seekableWindow () {
        return Math.max(0, this.seekableEnd - this.seekableStart);
    },
    // ~~ remote playback ~~
    canAirPlay: false,
    canGoogleCast: false,
    remotePlaybackState: "disconnected",
    remotePlaybackType: "none",
    remotePlaybackLoader: null,
    remotePlaybackInfo: null,
    get isAirPlayConnected () {
        return this.remotePlaybackType === "airplay" && this.remotePlaybackState === "connected";
    },
    get isGoogleCastConnected () {
        return this.remotePlaybackType === "google-cast" && this.remotePlaybackState === "connected";
    },
    // ~~ responsive design ~~
    pointer: "fine",
    orientation: "landscape",
    width: 0,
    height: 0,
    mediaWidth: 0,
    mediaHeight: 0,
    lastKeyboardAction: null,
    // ~~ user props ~~
    userBehindLiveEdge: false,
    // ~~ live props ~~
    liveEdgeTolerance: 10,
    minLiveDVRWindow: 60,
    get canSeek () {
        return /unknown|on-demand|:dvr/.test(this.streamType) && Number.isFinite(this.seekableWindow) && (!this.live || /:dvr/.test(this.streamType) && this.seekableWindow >= this.minLiveDVRWindow);
    },
    get live () {
        return this.streamType.includes("live") || !Number.isFinite(this.realDuration);
    },
    get liveEdgeStart () {
        return this.live && Number.isFinite(this.seekableEnd) ? Math.max(0, (this.liveSyncPosition ?? this.seekableEnd) - this.liveEdgeTolerance) : 0;
    },
    get liveEdge () {
        return this.live && (!this.canSeek || !this.userBehindLiveEdge && this.currentTime >= this.liveEdgeStart);
    },
    get liveEdgeWindow () {
        return this.live && Number.isFinite(this.seekableEnd) ? this.seekableEnd - this.liveEdgeStart : 0;
    },
    // ~~ internal props ~~
    autoPlaying: false,
    providedTitle: "",
    inferredTitle: "",
    providedLoop: false,
    userPrefersLoop: false,
    providedPoster: "",
    inferredPoster: "",
    inferredViewType: "unknown",
    providedViewType: "unknown",
    providedStreamType: "unknown",
    inferredStreamType: "unknown",
    liveSyncPosition: null,
    savedState: null
});
const $9f21272e0549cf92$var$RESET_ON_SRC_QUALITY_CHANGE = /* @__PURE__ */ new Set([
    "autoPlayError",
    "autoPlaying",
    "buffered",
    "canPlay",
    "error",
    "paused",
    "played",
    "playing",
    "seekable",
    "seeking",
    "waiting"
]);
const $9f21272e0549cf92$var$RESET_ON_SRC_CHANGE = /* @__PURE__ */ new Set([
    ...$9f21272e0549cf92$var$RESET_ON_SRC_QUALITY_CHANGE,
    "ended",
    "inferredPoster",
    "inferredStreamType",
    "inferredTitle",
    "intrinsicDuration",
    "liveSyncPosition",
    "realCurrentTime",
    "savedState",
    "started",
    "userBehindLiveEdge"
]);
function $9f21272e0549cf92$export$274a38118ae9ffaf($media, isSourceQualityChange = false) {
    const filter = isSourceQualityChange ? $9f21272e0549cf92$var$RESET_ON_SRC_QUALITY_CHANGE : $9f21272e0549cf92$var$RESET_ON_SRC_CHANGE;
    $9f21272e0549cf92$export$8cef61637918b288.reset($media, (prop)=>filter.has(prop));
    (0, $8B3mG.tick)();
}
var $9f21272e0549cf92$var$_target = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_player = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_prevTrackIndex = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_logger = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_dispatchRequest = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_noPlayerWarning = /*#__PURE__*/ new WeakSet();
class $9f21272e0549cf92$export$a1bb2a710f7468 {
    /**
   * Set the target from which to dispatch media requests events from. The events should bubble
   * up from this target to the player element.
   *
   * @example
   * ```ts
   * const button = document.querySelector('button');
   * remote.setTarget(button);
   * ```
   */ setTarget(target) {
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_target, target);
    }
    /**
   * Returns the current player element. This method will attempt to find the player by
   * searching up from either the given `target` or default target set via `remote.setTarget`.
   *
   * @example
   * ```ts
   * const player = remote.getPlayer();
   * ```
   */ getPlayer(target) {
        if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_player)) return (0, $57dmi._)(this, $9f21272e0549cf92$var$_player);
        (target ?? (0, $57dmi._)(this, $9f21272e0549cf92$var$_target))?.dispatchEvent(new (0, $8B3mG.DOMEvent)("find-media-player", {
            detail: (player)=>void (0, $4vwVC._)(this, $9f21272e0549cf92$var$_player, player),
            bubbles: true,
            composed: true
        }));
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_player);
    }
    /**
   * Set the current player element so the remote can support toggle methods such as
   * `togglePaused` as they rely on the current media state.
   */ setPlayer(player) {
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_player, player);
    }
    /**
   * Dispatch a request to start the media loading process. This will only work if the media
   * player has been initialized with a custom loading strategy `load="custom">`.
   *
   * @docs {@link https://www.vidstack.io/docs/player/core-concepts/loading#load-strategies}
   */ startLoading(trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-start-loading", trigger);
    }
    /**
   * Dispatch a request to start the poster loading process. This will only work if the media
   * player has been initialized with a custom poster loading strategy `posterLoad="custom">`.
   *
   * @docs {@link https://www.vidstack.io/docs/player/core-concepts/loading#load-strategies}
   */ startLoadingPoster(trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-poster-start-loading", trigger);
    }
    /**
   * Dispatch a request to connect to AirPlay.
   *
   * @see {@link https://www.apple.com/au/airplay}
   */ requestAirPlay(trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-airplay-request", trigger);
    }
    /**
   * Dispatch a request to connect to Google Cast.
   *
   * @see {@link https://developers.google.com/cast/docs/overview}
   */ requestGoogleCast(trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-google-cast-request", trigger);
    }
    /**
   * Dispatch a request to begin/resume media playback.
   */ play(trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-play-request", trigger);
    }
    /**
   * Dispatch a request to pause media playback.
   */ pause(trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-pause-request", trigger);
    }
    /**
   * Dispatch a request to set the media volume to mute (0).
   */ mute(trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-mute-request", trigger);
    }
    /**
   * Dispatch a request to unmute the media volume and set it back to it's previous state.
   */ unmute(trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-unmute-request", trigger);
    }
    /**
   * Dispatch a request to enter fullscreen.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/fullscreen#remote-control}
   */ enterFullscreen(target, trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-enter-fullscreen-request", trigger, target);
    }
    /**
   * Dispatch a request to exit fullscreen.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/fullscreen#remote-control}
   */ exitFullscreen(target, trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-exit-fullscreen-request", trigger, target);
    }
    /**
   * Dispatch a request to lock the screen orientation.
   *
   * @docs {@link https://www.vidstack.io/docs/player/screen-orientation#remote-control}
   */ lockScreenOrientation(lockType, trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-orientation-lock-request", trigger, lockType);
    }
    /**
   * Dispatch a request to unlock the screen orientation.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/screen-orientation#remote-control}
   */ unlockScreenOrientation(trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-orientation-unlock-request", trigger);
    }
    /**
   * Dispatch a request to enter picture-in-picture mode.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/picture-in-picture#remote-control}
   */ enterPictureInPicture(trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-enter-pip-request", trigger);
    }
    /**
   * Dispatch a request to exit picture-in-picture mode.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/picture-in-picture#remote-control}
   */ exitPictureInPicture(trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-exit-pip-request", trigger);
    }
    /**
   * Notify the media player that a seeking process is happening and to seek to the given `time`.
   */ seeking(time, trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-seeking-request", trigger, time);
    }
    /**
   * Notify the media player that a seeking operation has completed and to seek to the given `time`.
   * This is generally called after a series of `remote.seeking()` calls.
   */ seek(time, trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-seek-request", trigger, time);
    }
    seekToLiveEdge(trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-live-edge-request", trigger);
    }
    /**
   * Dispatch a request to update the length of the media in seconds.
   *
   * @example
   * ```ts
   * remote.changeDuration(100); // 100 seconds
   * ```
   */ changeDuration(duration, trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-duration-change-request", trigger, duration);
    }
    /**
   * Dispatch a request to update the clip start time. This is the time at which media playback
   * should start at.
   *
   * @example
   * ```ts
   * remote.changeClipStart(100); // start at 100 seconds
   * ```
   */ changeClipStart(startTime, trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-clip-start-change-request", trigger, startTime);
    }
    /**
   * Dispatch a request to update the clip end time. This is the time at which media playback
   * should end at.
   *
   * @example
   * ```ts
   * remote.changeClipEnd(100); // end at 100 seconds
   * ```
   */ changeClipEnd(endTime, trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-clip-end-change-request", trigger, endTime);
    }
    /**
   * Dispatch a request to update the media volume to the given `volume` level which is a value
   * between 0 and 1.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/audio-gain#remote-control}
   * @example
   * ```ts
   * remote.changeVolume(0); // 0%
   * remote.changeVolume(0.05); // 5%
   * remote.changeVolume(0.5); // 50%
   * remote.changeVolume(0.75); // 70%
   * remote.changeVolume(1); // 100%
   * ```
   */ changeVolume(volume, trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-volume-change-request", trigger, Math.max(0, Math.min(1, volume)));
    }
    /**
   * Dispatch a request to change the current audio track.
   *
   * @example
   * ```ts
   * remote.changeAudioTrack(1); // track at index 1
   * ```
   */ changeAudioTrack(index, trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-audio-track-change-request", trigger, index);
    }
    /**
   * Dispatch a request to change the video quality. The special value `-1` represents auto quality
   * selection.
   *
   * @example
   * ```ts
   * remote.changeQuality(-1); // auto
   * remote.changeQuality(1); // quality at index 1
   * ```
   */ changeQuality(index, trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-quality-change-request", trigger, index);
    }
    /**
   * Request auto quality selection.
   */ requestAutoQuality(trigger) {
        this.changeQuality(-1, trigger);
    }
    /**
   * Dispatch a request to change the mode of the text track at the given index.
   *
   * @example
   * ```ts
   * remote.changeTextTrackMode(1, 'showing'); // track at index 1
   * ```
   */ changeTextTrackMode(index, mode, trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-text-track-change-request", trigger, {
            index: index,
            mode: mode
        });
    }
    /**
   * Dispatch a request to change the media playback rate.
   *
   * @example
   * ```ts
   * remote.changePlaybackRate(0.5); // Half the normal speed
   * remote.changePlaybackRate(1); // Normal speed
   * remote.changePlaybackRate(1.5); // 50% faster than normal
   * remote.changePlaybackRate(2); // Double the normal speed
   * ```
   */ changePlaybackRate(rate, trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-rate-change-request", trigger, rate);
    }
    /**
   * Dispatch a request to change the media audio gain.
   *
   * @example
   * ```ts
   * remote.changeAudioGain(1); // Disable audio gain
   * remote.changeAudioGain(1.5); // 50% louder
   * remote.changeAudioGain(2); // 100% louder
   * ```
   */ changeAudioGain(gain, trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-audio-gain-change-request", trigger, gain);
    }
    /**
   * Dispatch a request to resume idle tracking on controls.
   */ resumeControls(trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-resume-controls-request", trigger);
    }
    /**
   * Dispatch a request to pause controls idle tracking. Pausing tracking will result in the
   * controls being visible until `remote.resumeControls()` is called. This method
   * is generally used when building custom controls and you'd like to prevent the UI from
   * disappearing.
   *
   * @example
   * ```ts
   * // Prevent controls hiding while menu is being interacted with.
   * function onSettingsOpen() {
   *   remote.pauseControls();
   * }
   *
   * function onSettingsClose() {
   *   remote.resumeControls();
   * }
   * ```
   */ pauseControls(trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-pause-controls-request", trigger);
    }
    /**
   * Dispatch a request to toggle the media playback state.
   */ togglePaused(trigger) {
        const player = this.getPlayer(trigger?.target);
        if (!player) return;
        if (player.state.paused) this.play(trigger);
        else this.pause(trigger);
    }
    /**
   * Dispatch a request to toggle the controls visibility.
   */ toggleControls(trigger) {
        const player = this.getPlayer(trigger?.target);
        if (!player) return;
        if (!player.controls.showing) player.controls.show(0, trigger);
        else player.controls.hide(0, trigger);
    }
    /**
   * Dispatch a request to toggle the media muted state.
   */ toggleMuted(trigger) {
        const player = this.getPlayer(trigger?.target);
        if (!player) return;
        if (player.state.muted) this.unmute(trigger);
        else this.mute(trigger);
    }
    /**
   * Dispatch a request to toggle the media fullscreen state.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/fullscreen#remote-control}
   */ toggleFullscreen(target, trigger) {
        const player = this.getPlayer(trigger?.target);
        if (!player) return;
        if (player.state.fullscreen) this.exitFullscreen(target, trigger);
        else this.enterFullscreen(target, trigger);
    }
    /**
   * Dispatch a request to toggle the media picture-in-picture mode.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/picture-in-picture#remote-control}
   */ togglePictureInPicture(trigger) {
        const player = this.getPlayer(trigger?.target);
        if (!player) return;
        if (player.state.pictureInPicture) this.exitPictureInPicture(trigger);
        else this.enterPictureInPicture(trigger);
    }
    /**
   * Show captions.
   */ showCaptions(trigger) {
        const player = this.getPlayer(trigger?.target);
        if (!player) return;
        let tracks = player.state.textTracks, index = (0, $57dmi._)(this, $9f21272e0549cf92$var$_prevTrackIndex);
        if (!tracks[index] || !(0, $ihjXw.isTrackCaptionKind)(tracks[index])) index = -1;
        if (index === -1) index = tracks.findIndex((track)=>(0, $ihjXw.isTrackCaptionKind)(track) && track.default);
        if (index === -1) index = tracks.findIndex((track)=>(0, $ihjXw.isTrackCaptionKind)(track));
        if (index >= 0) this.changeTextTrackMode(index, "showing", trigger);
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_prevTrackIndex, -1);
    }
    /**
   * Turn captions off.
   */ disableCaptions(trigger) {
        const player = this.getPlayer(trigger?.target);
        if (!player) return;
        const tracks = player.state.textTracks, track = player.state.textTrack;
        if (track) {
            const index = tracks.indexOf(track);
            this.changeTextTrackMode(index, "disabled", trigger);
            (0, $4vwVC._)(this, $9f21272e0549cf92$var$_prevTrackIndex, index);
        }
    }
    /**
   * Dispatch a request to toggle the current captions mode.
   */ toggleCaptions(trigger) {
        const player = this.getPlayer(trigger?.target);
        if (!player) return;
        if (player.state.textTrack) this.disableCaptions();
        else this.showCaptions();
    }
    userPrefersLoopChange(prefersLoop, trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_dispatchRequest, $9f21272e0549cf92$var$dispatchRequest).call(this, "media-user-loop-change-request", trigger, prefersLoop);
    }
    constructor(logger){
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_dispatchRequest);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_noPlayerWarning);
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_target, {
            writable: true,
            value: null
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_player, {
            writable: true,
            value: null
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_prevTrackIndex, {
            writable: true,
            value: -1
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_logger, {
            writable: true,
            value: void 0
        });
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_logger, logger);
    }
}
function $9f21272e0549cf92$var$dispatchRequest(type, trigger, detail) {
    const request = new (0, $8B3mG.DOMEvent)(type, {
        bubbles: true,
        composed: true,
        cancelable: true,
        detail: detail,
        trigger: trigger
    });
    let target = trigger?.target || null;
    if (target && target instanceof (0, $8B3mG.Component)) target = target.el;
    const shouldUsePlayer = !target || target === document || target === window || target === document.body || (0, $57dmi._)(this, $9f21272e0549cf92$var$_player)?.el && target instanceof Node && !(0, $57dmi._)(this, $9f21272e0549cf92$var$_player).el.contains(target);
    target = shouldUsePlayer ? (0, $57dmi._)(this, $9f21272e0549cf92$var$_target) ?? this.getPlayer()?.el : target ?? (0, $57dmi._)(this, $9f21272e0549cf92$var$_target);
    if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_player)) {
        if (type === "media-play-request" && !(0, $57dmi._)(this, $9f21272e0549cf92$var$_player).state.canLoad) target?.dispatchEvent(request);
        else (0, $57dmi._)(this, $9f21272e0549cf92$var$_player).canPlayQueue.enqueue(type, ()=>target?.dispatchEvent(request));
    } else target?.dispatchEvent(request);
}
function $9f21272e0549cf92$var$noPlayerWarning(method) {}
var $9f21272e0549cf92$var$_data = /*#__PURE__*/ new WeakMap();
class $9f21272e0549cf92$export$87c11e4c5bbdf503 {
    async getVolume() {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_data).volume;
    }
    async setVolume(volume) {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_data).volume = volume;
        this.save();
    }
    async getMuted() {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_data).muted;
    }
    async setMuted(muted) {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_data).muted = muted;
        this.save();
    }
    async getTime() {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_data).time;
    }
    async setTime(time, ended) {
        const shouldClear = time < 0;
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_data).time = !shouldClear ? time : null;
        if (shouldClear || ended) this.saveTime();
        else this.saveTimeThrottled();
    }
    async getLang() {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_data).lang;
    }
    async setLang(lang) {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_data).lang = lang;
        this.save();
    }
    async getCaptions() {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_data).captions;
    }
    async setCaptions(enabled) {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_data).captions = enabled;
        this.save();
    }
    async getPlaybackRate() {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_data).rate;
    }
    async setPlaybackRate(rate) {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_data).rate = rate;
        this.save();
    }
    async getAudioGain() {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_data).audioGain;
    }
    async setAudioGain(gain) {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_data).audioGain = gain;
        this.save();
    }
    async getVideoQuality() {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_data).quality;
    }
    async setVideoQuality(quality) {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_data).quality = quality;
        this.save();
    }
    onChange(src, mediaId, playerId = "vds-player") {
        const savedData = playerId ? localStorage.getItem(playerId) : null, savedTime = mediaId ? localStorage.getItem(mediaId) : null;
        this.playerId = playerId;
        this.mediaId = mediaId;
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_data, {
            volume: null,
            muted: null,
            audioGain: null,
            lang: null,
            captions: null,
            rate: null,
            quality: null,
            ...savedData ? JSON.parse(savedData) : {},
            time: savedTime ? +savedTime : null
        });
    }
    save() {
        if (!this.playerId) return;
        const data = JSON.stringify({
            ...(0, $57dmi._)(this, $9f21272e0549cf92$var$_data),
            time: void 0
        });
        localStorage.setItem(this.playerId, data);
    }
    saveTime() {
        if (!this.mediaId) return;
        const data = ((0, $57dmi._)(this, $9f21272e0549cf92$var$_data).time ?? 0).toString();
        localStorage.setItem(this.mediaId, data);
    }
    constructor(){
        (0, $97zcJ._)(this, "playerId", "vds-player");
        (0, $97zcJ._)(this, "mediaId", null);
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_data, {
            writable: true,
            value: {
                volume: null,
                muted: null,
                audioGain: null,
                time: null,
                lang: null,
                captions: null,
                rate: null,
                quality: null
            }
        });
        (0, $97zcJ._)(this, "saveTimeThrottled", (0, $8B3mG.functionThrottle)(this.saveTime.bind(this), 1e3));
    }
}
var $9f21272e0549cf92$var$_display = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_video = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_track = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_tracks = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_attachTrack = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_createTrackElement = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_copyCues = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onChange1 = /*#__PURE__*/ new WeakSet();
class $9f21272e0549cf92$var$NativeTextRenderer {
    canRender(_, video) {
        return !!video;
    }
    attach(video) {
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_video, video);
        if (video) video.textTracks.onchange = (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onChange1, $9f21272e0549cf92$var$onChange1).bind(this);
    }
    addTrack(track) {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_tracks).add(track);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_attachTrack, $9f21272e0549cf92$var$attachTrack).call(this, track);
    }
    removeTrack(track) {
        track[(0, $ihjXw.TextTrackSymbol).native]?.remove?.();
        track[(0, $ihjXw.TextTrackSymbol).native] = null;
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_tracks).delete(track);
    }
    changeTrack(track) {
        const current = track?.[(0, $ihjXw.TextTrackSymbol).native];
        if (current && current.track.mode !== "showing") current.track.mode = "showing";
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_track, track);
    }
    setDisplay(display) {
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_display, display);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onChange1, $9f21272e0549cf92$var$onChange1).call(this);
    }
    detach() {
        if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_video)) (0, $57dmi._)(this, $9f21272e0549cf92$var$_video).textTracks.onchange = null;
        for (const track of (0, $57dmi._)(this, $9f21272e0549cf92$var$_tracks))this.removeTrack(track);
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_tracks).clear();
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_video, null);
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_track, null);
    }
    constructor(){
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_attachTrack);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_createTrackElement);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_copyCues);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onChange1);
        (0, $97zcJ._)(this, "priority", 0);
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_display, {
            writable: true,
            value: true
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_video, {
            writable: true,
            value: null
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_track, {
            writable: true,
            value: null
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_tracks, {
            writable: true,
            value: /* @__PURE__ */ new Set()
        });
    }
}
function $9f21272e0549cf92$var$attachTrack(track) {
    if (!(0, $57dmi._)(this, $9f21272e0549cf92$var$_video)) return;
    const el = track[(0, $ihjXw.TextTrackSymbol).native] ??= (0, $2u9SC._)(this, $9f21272e0549cf92$var$_createTrackElement, $9f21272e0549cf92$var$createTrackElement).call(this, track);
    if ((0, $ciZW6.isHTMLElement)(el)) {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_video).append(el);
        el.track.mode = el.default ? "showing" : "disabled";
    }
}
function $9f21272e0549cf92$var$createTrackElement(track) {
    const el = document.createElement("track"), isDefault = track.default || track.mode === "showing", isSupported = track.src && track.type === "vtt";
    el.id = track.id;
    el.src = isSupported ? track.src : "";
    el.label = track.label;
    el.kind = track.kind;
    el.default = isDefault;
    track.language && (el.srclang = track.language);
    if (isDefault && !isSupported) (0, $2u9SC._)(this, $9f21272e0549cf92$var$_copyCues, $9f21272e0549cf92$var$copyCues).call(this, track, el.track);
    return el;
}
function $9f21272e0549cf92$var$copyCues(track, native) {
    if (track.src && track.type === "vtt" || native.cues?.length) return;
    for (const cue of track.cues)native.addCue(cue);
}
function $9f21272e0549cf92$var$onChange1(event) {
    for (const track of (0, $57dmi._)(this, $9f21272e0549cf92$var$_tracks)){
        const native = track[(0, $ihjXw.TextTrackSymbol).native];
        if (!native) continue;
        if (!(0, $57dmi._)(this, $9f21272e0549cf92$var$_display)) {
            native.track.mode = native.managed ? "hidden" : "disabled";
            continue;
        }
        const isShowing = native.track.mode === "showing";
        if (isShowing) (0, $2u9SC._)(this, $9f21272e0549cf92$var$_copyCues, $9f21272e0549cf92$var$copyCues).call(this, track, native.track);
        track.setMode(isShowing ? "showing" : "disabled", event);
    }
}
var $9f21272e0549cf92$var$_video1 = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_textTracks = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_renderers = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_media = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_nativeDisplay = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_nativeRenderer = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_customRenderer = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_watchControls = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_addNativeTrack = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_removeNativeTrack = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onAddTrack = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onRemoveTrack = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_update = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_detach = /*#__PURE__*/ new WeakSet();
class $9f21272e0549cf92$export$474cc74c966eef64 {
    add(renderer) {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_renderers).push(renderer);
        (0, $8B3mG.untrack)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_update, $9f21272e0549cf92$var$update).bind(this));
    }
    remove(renderer) {
        renderer.detach();
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_renderers).splice((0, $57dmi._)(this, $9f21272e0549cf92$var$_renderers).indexOf(renderer), 1);
        (0, $8B3mG.untrack)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_update, $9f21272e0549cf92$var$update).bind(this));
    }
    /** @internal */ attachVideo(video) {
        requestAnimationFrame(()=>{
            (0, $4vwVC._)(this, $9f21272e0549cf92$var$_video1, video);
            if (video) {
                (0, $4vwVC._)(this, $9f21272e0549cf92$var$_nativeRenderer, new $9f21272e0549cf92$var$NativeTextRenderer());
                (0, $57dmi._)(this, $9f21272e0549cf92$var$_nativeRenderer).attach(video);
                for (const track of (0, $57dmi._)(this, $9f21272e0549cf92$var$_textTracks))(0, $2u9SC._)(this, $9f21272e0549cf92$var$_addNativeTrack, $9f21272e0549cf92$var$addNativeTrack).call(this, track);
            }
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_update, $9f21272e0549cf92$var$update).call(this);
        });
    }
    constructor(media){
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchControls);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_addNativeTrack);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_removeNativeTrack);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onAddTrack);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onRemoveTrack);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_update);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_detach);
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_video1, {
            writable: true,
            value: null
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_textTracks, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_renderers, {
            writable: true,
            value: []
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_media, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_nativeDisplay, {
            writable: true,
            value: false
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_nativeRenderer, {
            writable: true,
            value: null
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_customRenderer, {
            writable: true,
            value: null
        });
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_media, media);
        const textTracks = media.textTracks;
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_textTracks, textTracks);
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchControls, $9f21272e0549cf92$var$watchControls).bind(this));
        (0, $8B3mG.onDispose)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_detach, $9f21272e0549cf92$var$detach).bind(this));
        new (0, $8B3mG.EventsController)(textTracks).add("add", (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onAddTrack, $9f21272e0549cf92$var$onAddTrack).bind(this)).add("remove", (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onRemoveTrack, $9f21272e0549cf92$var$onRemoveTrack).bind(this)).add("mode-change", (0, $2u9SC._)(this, $9f21272e0549cf92$var$_update, $9f21272e0549cf92$var$update).bind(this));
    }
}
function $9f21272e0549cf92$var$watchControls() {
    const { nativeControls: nativeControls } = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media).$state;
    (0, $4vwVC._)(this, $9f21272e0549cf92$var$_nativeDisplay, nativeControls());
    (0, $2u9SC._)(this, $9f21272e0549cf92$var$_update, $9f21272e0549cf92$var$update).call(this);
}
function $9f21272e0549cf92$var$addNativeTrack(track) {
    if (!(0, $ihjXw.isTrackCaptionKind)(track)) return;
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_nativeRenderer)?.addTrack(track);
}
function $9f21272e0549cf92$var$removeNativeTrack(track) {
    if (!(0, $ihjXw.isTrackCaptionKind)(track)) return;
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_nativeRenderer)?.removeTrack(track);
}
function $9f21272e0549cf92$var$onAddTrack(event) {
    (0, $2u9SC._)(this, $9f21272e0549cf92$var$_addNativeTrack, $9f21272e0549cf92$var$addNativeTrack).call(this, event.detail);
}
function $9f21272e0549cf92$var$onRemoveTrack(event) {
    (0, $2u9SC._)(this, $9f21272e0549cf92$var$_removeNativeTrack, $9f21272e0549cf92$var$removeNativeTrack).call(this, event.detail);
}
function $9f21272e0549cf92$var$update() {
    const currentTrack = (0, $57dmi._)(this, $9f21272e0549cf92$var$_textTracks).selected;
    if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_video1) && ((0, $57dmi._)(this, $9f21272e0549cf92$var$_nativeDisplay) || currentTrack?.[(0, $ihjXw.TextTrackSymbol).nativeHLS])) {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_customRenderer)?.changeTrack(null);
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_nativeRenderer)?.setDisplay(true);
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_nativeRenderer)?.changeTrack(currentTrack);
        return;
    }
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_nativeRenderer)?.setDisplay(false);
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_nativeRenderer)?.changeTrack(null);
    if (!currentTrack) {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_customRenderer)?.changeTrack(null);
        return;
    }
    const customRenderer = (0, $57dmi._)(this, $9f21272e0549cf92$var$_renderers).sort((a, b)=>a.priority - b.priority).find((renderer)=>renderer.canRender(currentTrack, (0, $57dmi._)(this, $9f21272e0549cf92$var$_video1)));
    if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_customRenderer) !== customRenderer) {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_customRenderer)?.detach();
        customRenderer?.attach((0, $57dmi._)(this, $9f21272e0549cf92$var$_video1));
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_customRenderer, customRenderer ?? null);
    }
    customRenderer?.changeTrack(currentTrack);
}
function $9f21272e0549cf92$var$detach() {
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_nativeRenderer)?.detach();
    (0, $4vwVC._)(this, $9f21272e0549cf92$var$_nativeRenderer, null);
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_customRenderer)?.detach();
    (0, $4vwVC._)(this, $9f21272e0549cf92$var$_customRenderer, null);
}
var $9f21272e0549cf92$var$_canLoad = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_defaults = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_storage = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_preferredLang = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_selectTracks = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_pendingRemoval = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_onTrackModeChangeBind = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_onTrackModeChange = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_saveCaptionsTrack = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_saveLang = /*#__PURE__*/ new WeakSet();
let $9f21272e0549cf92$var$_TextTrackSymbol_crossOrigin = (0, $ihjXw.TextTrackSymbol).crossOrigin, $9f21272e0549cf92$var$_TextTrackSymbol_canLoad = (0, $ihjXw.TextTrackSymbol).canLoad;
class $9f21272e0549cf92$export$cfd404c5b64818f extends $9f21272e0549cf92$export$54c2e3dc7acea9f5 {
    get selected() {
        const track = this.items.find((t)=>t.mode === "showing" && (0, $ihjXw.isTrackCaptionKind)(t));
        return track ?? null;
    }
    get selectedIndex() {
        const selected = this.selected;
        return selected ? this.indexOf(selected) : -1;
    }
    get preferredLang() {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_preferredLang);
    }
    set preferredLang(lang) {
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_preferredLang, lang);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_saveLang, $9f21272e0549cf92$var$saveLang).call(this, lang);
    }
    add(init, trigger) {
        const isTrack = init instanceof (0, $ihjXw.TextTrack), track = isTrack ? init : new (0, $ihjXw.TextTrack)(init), kind = init.kind === "captions" || init.kind === "subtitles" ? "captions" : init.kind;
        if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_defaults)[kind] && init.default) delete init.default;
        track.addEventListener("mode-change", (0, $57dmi._)(this, $9f21272e0549cf92$var$_onTrackModeChangeBind));
        this[(0, $5UOkG.ListSymbol).add](track, trigger);
        track[(0, $ihjXw.TextTrackSymbol).crossOrigin] = this[(0, $ihjXw.TextTrackSymbol).crossOrigin];
        if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_canLoad)) track[(0, $ihjXw.TextTrackSymbol).canLoad]();
        if (init.default) (0, $57dmi._)(this, $9f21272e0549cf92$var$_defaults)[kind] = track;
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_selectTracks).call(this);
        return this;
    }
    remove(track, trigger) {
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_pendingRemoval, track);
        if (!this.items.includes(track)) return;
        if (track === (0, $57dmi._)(this, $9f21272e0549cf92$var$_defaults)[track.kind]) delete (0, $57dmi._)(this, $9f21272e0549cf92$var$_defaults)[track.kind];
        track.mode = "disabled";
        track[(0, $ihjXw.TextTrackSymbol).onModeChange] = null;
        track.removeEventListener("mode-change", (0, $57dmi._)(this, $9f21272e0549cf92$var$_onTrackModeChangeBind));
        this[(0, $5UOkG.ListSymbol).remove](track, trigger);
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_pendingRemoval, null);
        return this;
    }
    clear(trigger) {
        for (const track of [
            ...this.items
        ])this.remove(track, trigger);
        return this;
    }
    getByKind(kind) {
        const kinds = Array.isArray(kind) ? kind : [
            kind
        ];
        return this.items.filter((track)=>kinds.includes(track.kind));
    }
    /** @internal */ [$9f21272e0549cf92$var$_TextTrackSymbol_canLoad]() {
        if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_canLoad)) return;
        for (const track of this.items)track[(0, $ihjXw.TextTrackSymbol).canLoad]();
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_canLoad, true);
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_selectTracks).call(this);
    }
    setStorage(storage) {
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_storage, storage);
    }
    constructor(){
        super();
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onTrackModeChange);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_saveCaptionsTrack);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_saveLang);
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_canLoad, {
            writable: true,
            value: false
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_defaults, {
            writable: true,
            value: {}
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_storage, {
            writable: true,
            value: null
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_preferredLang, {
            writable: true,
            value: null
        });
        /** @internal */ (0, $97zcJ._)(this, $9f21272e0549cf92$var$_TextTrackSymbol_crossOrigin, void 0);
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_selectTracks, {
            writable: true,
            value: (0, $8B3mG.functionDebounce)(async ()=>{
                if (!(0, $57dmi._)(this, $9f21272e0549cf92$var$_canLoad)) return;
                if (!(0, $57dmi._)(this, $9f21272e0549cf92$var$_preferredLang) && (0, $57dmi._)(this, $9f21272e0549cf92$var$_storage)) (0, $4vwVC._)(this, $9f21272e0549cf92$var$_preferredLang, await (0, $57dmi._)(this, $9f21272e0549cf92$var$_storage).getLang());
                const showCaptions = await (0, $57dmi._)(this, $9f21272e0549cf92$var$_storage)?.getCaptions(), kinds = [
                    [
                        "captions",
                        "subtitles"
                    ],
                    "chapters",
                    "descriptions",
                    "metadata"
                ];
                for (const kind of kinds){
                    const tracks = this.getByKind(kind);
                    if (tracks.find((t)=>t.mode === "showing")) continue;
                    const preferredTrack = (0, $57dmi._)(this, $9f21272e0549cf92$var$_preferredLang) ? tracks.find((track2)=>track2.language === (0, $57dmi._)(this, $9f21272e0549cf92$var$_preferredLang)) : null;
                    const defaultTrack = (0, $8B3mG.isArray)(kind) ? (0, $57dmi._)(this, $9f21272e0549cf92$var$_defaults)[kind.find((kind2)=>(0, $57dmi._)(this, $9f21272e0549cf92$var$_defaults)[kind2]) || ""] : (0, $57dmi._)(this, $9f21272e0549cf92$var$_defaults)[kind];
                    const track = preferredTrack ?? defaultTrack, isCaptionsKind = track && (0, $ihjXw.isTrackCaptionKind)(track);
                    if (track && (!isCaptionsKind || showCaptions !== false)) {
                        track.mode = "showing";
                        if (isCaptionsKind) (0, $2u9SC._)(this, $9f21272e0549cf92$var$_saveCaptionsTrack, $9f21272e0549cf92$var$saveCaptionsTrack).call(this, track);
                    }
                }
            }, 300)
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_pendingRemoval, {
            writable: true,
            value: null
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_onTrackModeChangeBind, {
            writable: true,
            value: (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onTrackModeChange, $9f21272e0549cf92$var$onTrackModeChange).bind(this)
        });
    }
}
function $9f21272e0549cf92$var$onTrackModeChange(event) {
    const track = event.detail;
    if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_storage) && (0, $ihjXw.isTrackCaptionKind)(track) && track !== (0, $57dmi._)(this, $9f21272e0549cf92$var$_pendingRemoval)) (0, $2u9SC._)(this, $9f21272e0549cf92$var$_saveCaptionsTrack, $9f21272e0549cf92$var$saveCaptionsTrack).call(this, track);
    if (track.mode === "showing") {
        const kinds = (0, $ihjXw.isTrackCaptionKind)(track) ? [
            "captions",
            "subtitles"
        ] : [
            track.kind
        ];
        for (const t of this.items)if (t.mode === "showing" && t != track && kinds.includes(t.kind)) t.mode = "disabled";
    }
    this.dispatchEvent(new (0, $8B3mG.DOMEvent)("mode-change", {
        detail: event.detail,
        trigger: event
    }));
}
function $9f21272e0549cf92$var$saveCaptionsTrack(track) {
    if (track.mode !== "disabled") (0, $2u9SC._)(this, $9f21272e0549cf92$var$_saveLang, $9f21272e0549cf92$var$saveLang).call(this, track.language);
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_storage)?.setCaptions?.(track.mode === "showing");
}
function $9f21272e0549cf92$var$saveLang(lang) {
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_storage)?.setLang?.((0, $4vwVC._)(this, $9f21272e0549cf92$var$_preferredLang, lang));
}
const $9f21272e0549cf92$var$SELECTED = Symbol(0);
class $9f21272e0549cf92$var$SelectList extends $9f21272e0549cf92$export$54c2e3dc7acea9f5 {
    get selected() {
        return this.items.find((item)=>item.selected) ?? null;
    }
    get selectedIndex() {
        return this.items.findIndex((item)=>item.selected);
    }
    /** @internal */ [(0, $5UOkG.ListSymbol).onRemove](item, trigger) {
        this[(0, $5UOkG.ListSymbol).select](item, false, trigger);
    }
    /** @internal */ [(0, $5UOkG.ListSymbol).add](item, trigger) {
        item[$9f21272e0549cf92$var$SELECTED] = false;
        Object.defineProperty(item, "selected", {
            get () {
                return this[$9f21272e0549cf92$var$SELECTED];
            },
            set: (selected)=>{
                if (this.readonly) return;
                this[(0, $5UOkG.ListSymbol).onUserSelect]?.();
                this[(0, $5UOkG.ListSymbol).select](item, selected);
            }
        });
        super[(0, $5UOkG.ListSymbol).add](item, trigger);
    }
    /** @internal */ [(0, $5UOkG.ListSymbol).select](item, selected, trigger) {
        if (selected === item?.[$9f21272e0549cf92$var$SELECTED]) return;
        const prev = this.selected;
        if (item) item[$9f21272e0549cf92$var$SELECTED] = selected;
        const changed = !selected ? prev === item : prev !== item;
        if (changed) {
            if (prev) prev[$9f21272e0549cf92$var$SELECTED] = false;
            this.dispatchEvent(new (0, $8B3mG.DOMEvent)("change", {
                detail: {
                    prev: prev,
                    current: this.selected
                },
                trigger: trigger
            }));
        }
    }
}
class $9f21272e0549cf92$export$9e769fc3da26d171 extends $9f21272e0549cf92$var$SelectList {
}
var $9f21272e0549cf92$var$_auto = /*#__PURE__*/ new WeakMap();
let $9f21272e0549cf92$var$_QualitySymbol_enableAuto = (0, $eRuH7.QualitySymbol).enableAuto, $9f21272e0549cf92$var$_ListSymbol_onUserSelect = (0, $5UOkG.ListSymbol).onUserSelect, $9f21272e0549cf92$var$_ListSymbol_onReset = (0, $5UOkG.ListSymbol).onReset, $9f21272e0549cf92$var$_QualitySymbol_setAuto = (0, $eRuH7.QualitySymbol).setAuto;
class $9f21272e0549cf92$export$626acecd0d09262e extends $9f21272e0549cf92$var$SelectList {
    /**
   * Whether automatic quality selection is enabled.
   */ get auto() {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_auto) || this.readonly;
    }
    /** @internal */ [$9f21272e0549cf92$var$_ListSymbol_onUserSelect]() {
        this[(0, $eRuH7.QualitySymbol).setAuto](false);
    }
    /** @internal */ [$9f21272e0549cf92$var$_ListSymbol_onReset](trigger) {
        this[(0, $eRuH7.QualitySymbol).enableAuto] = void 0;
        this[(0, $eRuH7.QualitySymbol).setAuto](false, trigger);
    }
    /**
   * Request automatic quality selection (if supported). This will be a no-op if the list is
   * `readonly` as that already implies auto-selection.
   */ autoSelect(trigger) {
        if (this.readonly || (0, $57dmi._)(this, $9f21272e0549cf92$var$_auto) || !this[(0, $eRuH7.QualitySymbol).enableAuto]) return;
        this[(0, $eRuH7.QualitySymbol).enableAuto]?.(trigger);
        this[(0, $eRuH7.QualitySymbol).setAuto](true, trigger);
    }
    getBySrc(src) {
        return this.items.find((quality)=>quality.src === src);
    }
    /** @internal */ [$9f21272e0549cf92$var$_QualitySymbol_setAuto](auto, trigger) {
        if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_auto) === auto) return;
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_auto, auto);
        this.dispatchEvent(new (0, $8B3mG.DOMEvent)("auto-change", {
            detail: auto,
            trigger: trigger
        }));
    }
    constructor(...args){
        super(...args);
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_auto, {
            writable: true,
            value: false
        });
        /**
   * Configures quality switching:
   *
   * - `current`: Trigger an immediate quality level switch. This will abort the current fragment
   * request if any, flush the whole buffer, and fetch fragment matching with current position
   * and requested quality level.
   *
   * - `next`: Trigger a quality level switch for next fragment. This could eventually flush
   * already buffered next fragment.
   *
   * - `load`: Set quality level for next loaded fragment.
   *
   * @see {@link https://www.vidstack.io/docs/player/api/video-quality#switch}
   * @see {@link https://github.com/video-dev/hls.js/blob/master/docs/API.md#quality-switch-control-api}
   */ (0, $97zcJ._)(this, "switch", "current");
        /** @internal */ (0, $97zcJ._)(this, $9f21272e0549cf92$var$_QualitySymbol_enableAuto, void 0);
    }
}
function $9f21272e0549cf92$export$14bc6bca65202172(provider) {
    return provider?.$$PROVIDER_TYPE === "AUDIO";
}
function $9f21272e0549cf92$export$2a582c4c52c3da86(provider) {
    return provider?.$$PROVIDER_TYPE === "VIDEO";
}
function $9f21272e0549cf92$export$4fda8f708fe57912(provider) {
    return provider?.$$PROVIDER_TYPE === "HLS";
}
function $9f21272e0549cf92$export$d118b5fec5772756(provider) {
    return provider?.$$PROVIDER_TYPE === "DASH";
}
function $9f21272e0549cf92$export$50055b56b187cf1c(provider) {
    return provider?.$$PROVIDER_TYPE === "YOUTUBE";
}
function $9f21272e0549cf92$export$6797891cdedcb81e(provider) {
    return provider?.$$PROVIDER_TYPE === "VIMEO";
}
function $9f21272e0549cf92$export$93a9f25f1ae4ee28(provider) {
    return provider?.$$PROVIDER_TYPE === "GOOGLE_CAST";
}
function $9f21272e0549cf92$export$b83b0880d88b7dec(element) {
    return element instanceof HTMLAudioElement;
}
function $9f21272e0549cf92$export$334f44aecfa32a9e(element) {
    return element instanceof HTMLVideoElement;
}
function $9f21272e0549cf92$export$a38297c47057a993(element) {
    return $9f21272e0549cf92$export$b83b0880d88b7dec(element) || $9f21272e0549cf92$export$334f44aecfa32a9e(element);
}
function $9f21272e0549cf92$export$5180e63bc53de6dd(element) {
    return element instanceof HTMLIFrameElement;
}
class $9f21272e0549cf92$var$MediaPlayerController extends (0, $8B3mG.ViewController) {
}
const $9f21272e0549cf92$export$3ae2801a8b246f99 = {
    togglePaused: "k Space",
    toggleMuted: "m",
    toggleFullscreen: "f",
    togglePictureInPicture: "i",
    toggleCaptions: "c",
    seekBackward: "j J ArrowLeft",
    seekForward: "l L ArrowRight",
    volumeUp: "ArrowUp",
    volumeDown: "ArrowDown",
    speedUp: ">",
    slowDown: "<"
};
const $9f21272e0549cf92$var$MODIFIER_KEYS = /* @__PURE__ */ new Set([
    "Shift",
    "Alt",
    "Meta",
    "Ctrl"
]), $9f21272e0549cf92$var$BUTTON_SELECTORS = 'button, [role="button"]', $9f21272e0549cf92$var$IGNORE_SELECTORS = 'input, textarea, select, [contenteditable], [role^="menuitem"], [role="timer"]';
var $9f21272e0549cf92$var$_media1 = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_onTargetChange = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onKeyUp = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onKeyDown = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onPreventVideoKeys = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_getMatchingMethod = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_seekTotal = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_calcSeekAmount = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_timeSlider = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_forwardTimeKeyboardEvent = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_seeking = /*#__PURE__*/ new WeakSet();
class $9f21272e0549cf92$var$MediaKeyboardController extends $9f21272e0549cf92$var$MediaPlayerController {
    onConnect() {
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_onTargetChange, $9f21272e0549cf92$var$onTargetChange).bind(this));
    }
    constructor(media){
        super();
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onTargetChange);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onKeyUp);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onKeyDown);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onPreventVideoKeys);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_getMatchingMethod);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_calcSeekAmount);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_forwardTimeKeyboardEvent);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_seeking);
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_media1, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_seekTotal, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_timeSlider, {
            writable: true,
            value: null
        });
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_media1, media);
    }
}
function $9f21272e0549cf92$var$onTargetChange() {
    const { keyDisabled: keyDisabled, keyTarget: keyTarget } = this.$props;
    if (keyDisabled()) return;
    const target = keyTarget() === "player" ? this.el : document, $active = (0, $8B3mG.signal)(false);
    if (target === this.el) new (0, $8B3mG.EventsController)(this.el).add("focusin", ()=>$active.set(true)).add("focusout", (event)=>{
        if (!this.el.contains(event.target)) $active.set(false);
    });
    else {
        if (!(0, $8B3mG.peek)($active)) $active.set(document.querySelector("[data-media-player]") === this.el);
        (0, $8B3mG.listenEvent)(document, "focusin", (event)=>{
            const activePlayer = event.composedPath().find((el)=>el instanceof Element && el.localName === "media-player");
            if (activePlayer !== void 0) $active.set(this.el === activePlayer);
        });
    }
    (0, $8B3mG.effect)(()=>{
        if (!$active()) return;
        new (0, $8B3mG.EventsController)(target).add("keyup", (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onKeyUp, $9f21272e0549cf92$var$onKeyUp).bind(this)).add("keydown", (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onKeyDown, $9f21272e0549cf92$var$onKeyDown).bind(this)).add("keydown", (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onPreventVideoKeys, $9f21272e0549cf92$var$onPreventVideoKeys).bind(this), {
            capture: true
        });
    });
}
function $9f21272e0549cf92$var$onKeyUp(event) {
    const focusedEl = document.activeElement;
    if (!event.key || !this.$state.canSeek() || focusedEl?.matches($9f21272e0549cf92$var$IGNORE_SELECTORS)) return;
    let { method: method, value: value } = (0, $2u9SC._)(this, $9f21272e0549cf92$var$_getMatchingMethod, $9f21272e0549cf92$var$getMatchingMethod).call(this, event);
    if (!(0, $8B3mG.isString)(value) && !(0, $8B3mG.isArray)(value)) {
        value?.onKeyUp?.({
            event: event,
            player: (0, $57dmi._)(this, $9f21272e0549cf92$var$_media1).player,
            remote: (0, $57dmi._)(this, $9f21272e0549cf92$var$_media1).remote
        });
        value?.callback?.(event, (0, $57dmi._)(this, $9f21272e0549cf92$var$_media1).remote);
        return;
    }
    if (method?.startsWith("seek")) {
        event.preventDefault();
        event.stopPropagation();
        if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_timeSlider)) {
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_forwardTimeKeyboardEvent, $9f21272e0549cf92$var$forwardTimeKeyboardEvent).call(this, event, method === "seekForward");
            (0, $4vwVC._)(this, $9f21272e0549cf92$var$_timeSlider, null);
        } else {
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_media1).remote.seek((0, $57dmi._)(this, $9f21272e0549cf92$var$_seekTotal), event);
            (0, $4vwVC._)(this, $9f21272e0549cf92$var$_seekTotal, void 0);
        }
    }
    if (method?.startsWith("volume")) {
        const volumeSlider = this.el.querySelector("[data-media-volume-slider]");
        volumeSlider?.dispatchEvent(new KeyboardEvent("keyup", {
            key: method === "volumeUp" ? "Up" : "Down",
            shiftKey: event.shiftKey,
            trigger: event
        }));
    }
}
function $9f21272e0549cf92$var$onKeyDown(event) {
    if (!event.key || $9f21272e0549cf92$var$MODIFIER_KEYS.has(event.key)) return;
    const focusedEl = document.activeElement;
    if (focusedEl?.matches($9f21272e0549cf92$var$IGNORE_SELECTORS) || (0, $8B3mG.isKeyboardClick)(event) && focusedEl?.matches($9f21272e0549cf92$var$BUTTON_SELECTORS)) return;
    let { method: method, value: value } = (0, $2u9SC._)(this, $9f21272e0549cf92$var$_getMatchingMethod, $9f21272e0549cf92$var$getMatchingMethod).call(this, event), isNumberPress = !event.metaKey && /^[0-9]$/.test(event.key);
    if (!(0, $8B3mG.isString)(value) && !(0, $8B3mG.isArray)(value) && !isNumberPress) {
        value?.onKeyDown?.({
            event: event,
            player: (0, $57dmi._)(this, $9f21272e0549cf92$var$_media1).player,
            remote: (0, $57dmi._)(this, $9f21272e0549cf92$var$_media1).remote
        });
        value?.callback?.(event, (0, $57dmi._)(this, $9f21272e0549cf92$var$_media1).remote);
        return;
    }
    if (!method && isNumberPress) {
        event.preventDefault();
        event.stopPropagation();
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_media1).remote.seek(this.$state.duration() / 10 * Number(event.key), event);
        return;
    }
    if (!method) return;
    event.preventDefault();
    event.stopPropagation();
    switch(method){
        case "seekForward":
        case "seekBackward":
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_seeking, $9f21272e0549cf92$var$seeking).call(this, event, method, method === "seekForward");
            break;
        case "volumeUp":
        case "volumeDown":
            const volumeSlider = this.el.querySelector("[data-media-volume-slider]");
            if (volumeSlider) volumeSlider.dispatchEvent(new KeyboardEvent("keydown", {
                key: method === "volumeUp" ? "Up" : "Down",
                shiftKey: event.shiftKey,
                trigger: event
            }));
            else {
                const value2 = event.shiftKey ? 0.1 : 0.05;
                (0, $57dmi._)(this, $9f21272e0549cf92$var$_media1).remote.changeVolume(this.$state.volume() + (method === "volumeUp" ? +value2 : -value2), event);
            }
            break;
        case "toggleFullscreen":
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_media1).remote.toggleFullscreen("prefer-media", event);
            break;
        case "speedUp":
        case "slowDown":
            const playbackRate = this.$state.playbackRate();
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_media1).remote.changePlaybackRate(Math.max(0.25, Math.min(2, playbackRate + (method === "speedUp" ? 0.25 : -0.25))), event);
            break;
        default:
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_media1).remote[method]?.(event);
    }
    this.$state.lastKeyboardAction.set({
        action: method,
        event: event
    });
}
function $9f21272e0549cf92$var$onPreventVideoKeys(event) {
    if ($9f21272e0549cf92$export$a38297c47057a993(event.target) && (0, $2u9SC._)(this, $9f21272e0549cf92$var$_getMatchingMethod, $9f21272e0549cf92$var$getMatchingMethod).call(this, event).method) event.preventDefault();
}
function $9f21272e0549cf92$var$getMatchingMethod(event) {
    const keyShortcuts = {
        ...this.$props.keyShortcuts(),
        ...(0, $57dmi._)(this, $9f21272e0549cf92$var$_media1).ariaKeys
    };
    const method = Object.keys(keyShortcuts).find((method2)=>{
        const value = keyShortcuts[method2], keys = (0, $8B3mG.isArray)(value) ? value.join(" ") : (0, $8B3mG.isString)(value) ? value : value?.keys;
        const combinations = ((0, $8B3mG.isArray)(keys) ? keys : keys?.split(" "))?.map((key)=>$9f21272e0549cf92$var$replaceSymbolKeys(key).replace(/Control/g, "Ctrl").split("+"));
        return combinations?.some((combo)=>{
            const modifierKeys = new Set(combo.filter((key)=>$9f21272e0549cf92$var$MODIFIER_KEYS.has(key)));
            for (const modKey of $9f21272e0549cf92$var$MODIFIER_KEYS){
                const modKeyProp = modKey.toLowerCase() + "Key";
                if (!modifierKeys.has(modKey) && event[modKeyProp]) return false;
            }
            return combo.every((key)=>{
                return $9f21272e0549cf92$var$MODIFIER_KEYS.has(key) ? event[key.toLowerCase() + "Key"] : event.key === key.replace("Space", " ");
            });
        });
    });
    return {
        method: method,
        value: method ? keyShortcuts[method] : null
    };
}
function $9f21272e0549cf92$var$calcSeekAmount(event, type) {
    const seekBy = event.shiftKey ? 10 : 5;
    return (0, $4vwVC._)(this, $9f21272e0549cf92$var$_seekTotal, Math.max(0, Math.min(((0, $57dmi._)(this, $9f21272e0549cf92$var$_seekTotal) ?? this.$state.currentTime()) + (type === "seekForward" ? +seekBy : -seekBy), this.$state.duration())));
}
function $9f21272e0549cf92$var$forwardTimeKeyboardEvent(event, forward) {
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_timeSlider)?.dispatchEvent(new KeyboardEvent(event.type, {
        key: !forward ? "Left" : "Right",
        shiftKey: event.shiftKey,
        trigger: event
    }));
}
function $9f21272e0549cf92$var$seeking(event, type, forward) {
    if (!this.$state.canSeek()) return;
    if (!(0, $57dmi._)(this, $9f21272e0549cf92$var$_timeSlider)) (0, $4vwVC._)(this, $9f21272e0549cf92$var$_timeSlider, this.el.querySelector("[data-media-time-slider]"));
    if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_timeSlider)) (0, $2u9SC._)(this, $9f21272e0549cf92$var$_forwardTimeKeyboardEvent, $9f21272e0549cf92$var$forwardTimeKeyboardEvent).call(this, event, forward);
    else (0, $57dmi._)(this, $9f21272e0549cf92$var$_media1).remote.seeking((0, $2u9SC._)(this, $9f21272e0549cf92$var$_calcSeekAmount, $9f21272e0549cf92$var$calcSeekAmount).call(this, event, type), event);
}
const $9f21272e0549cf92$var$SYMBOL_KEY_MAP = [
    "!",
    "@",
    "#",
    "$",
    "%",
    "^",
    "&",
    "*",
    "(",
    ")"
];
function $9f21272e0549cf92$var$replaceSymbolKeys(key) {
    return key.replace(/Shift\+(\d)/g, (_, num)=>$9f21272e0549cf92$var$SYMBOL_KEY_MAP[num - 1]);
}
var $9f21272e0549cf92$var$_idleTimer = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_pausedTracking = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_hideOnMouseLeave = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_isMouseOutside = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_focusedItem = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_canIdle = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_init = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchMouse = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchPaused = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onPlay = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onPause = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onEnd = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onMouseEnter = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onMouseLeave = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_clearIdleTimer = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onStopIdle = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_changeVisibility = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onChange2 = /*#__PURE__*/ new WeakSet();
class $9f21272e0549cf92$export$71b0351bcb535b62 extends $9f21272e0549cf92$var$MediaPlayerController {
    /**
   * Whether controls can hide after a delay in user interaction. If this is false, controls will
   * not hide and be user controlled.
   */ get canIdle() {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_canIdle).call(this);
    }
    set canIdle(canIdle) {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_canIdle).set(canIdle);
    }
    /**
   * Whether controls visibility should be toggled when the mouse enters and leaves the player
   * container.
   *
   * @defaultValue false
   */ get hideOnMouseLeave() {
        const { hideControlsOnMouseLeave: hideControlsOnMouseLeave } = this.$props;
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_hideOnMouseLeave).call(this) || hideControlsOnMouseLeave();
    }
    set hideOnMouseLeave(hide) {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_hideOnMouseLeave).set(hide);
    }
    /**
   * Whether media controls are currently visible.
   */ get showing() {
        return this.$state.controlsVisible();
    }
    /**
   * Show controls.
   */ show(delay = 0, trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_clearIdleTimer, $9f21272e0549cf92$var$clearIdleTimer).call(this);
        if (!(0, $57dmi._)(this, $9f21272e0549cf92$var$_pausedTracking)) (0, $2u9SC._)(this, $9f21272e0549cf92$var$_changeVisibility, $9f21272e0549cf92$var$changeVisibility).call(this, true, delay, trigger);
    }
    /**
   * Hide controls.
   */ hide(delay = this.defaultDelay, trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_clearIdleTimer, $9f21272e0549cf92$var$clearIdleTimer).call(this);
        if (!(0, $57dmi._)(this, $9f21272e0549cf92$var$_pausedTracking)) (0, $2u9SC._)(this, $9f21272e0549cf92$var$_changeVisibility, $9f21272e0549cf92$var$changeVisibility).call(this, false, delay, trigger);
    }
    /**
   * Whether all idle tracking on controls should be paused until resumed again.
   */ pause(trigger) {
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_pausedTracking, true);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_clearIdleTimer, $9f21272e0549cf92$var$clearIdleTimer).call(this);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_changeVisibility, $9f21272e0549cf92$var$changeVisibility).call(this, true, 0, trigger);
    }
    resume(trigger) {
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_pausedTracking, false);
        if (this.$state.paused()) return;
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_changeVisibility, $9f21272e0549cf92$var$changeVisibility).call(this, false, this.defaultDelay, trigger);
    }
    onConnect() {
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_init, $9f21272e0549cf92$var$init).bind(this));
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_init);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchMouse);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchPaused);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onPlay);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onPause);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onEnd);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onMouseEnter);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onMouseLeave);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_clearIdleTimer);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onStopIdle);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_changeVisibility);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onChange2);
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_idleTimer, {
            writable: true,
            value: -2
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_pausedTracking, {
            writable: true,
            value: false
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_hideOnMouseLeave, {
            writable: true,
            value: (0, $8B3mG.signal)(false)
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_isMouseOutside, {
            writable: true,
            value: (0, $8B3mG.signal)(false)
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_focusedItem, {
            writable: true,
            value: null
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_canIdle, {
            writable: true,
            value: (0, $8B3mG.signal)(true)
        });
        /**
   * The default amount of delay in milliseconds while media playback is progressing without user
   * activity to indicate an idle state (i.e., hide controls).
   *
   * @defaultValue 2000
   */ (0, $97zcJ._)(this, "defaultDelay", 2e3);
    }
}
function $9f21272e0549cf92$var$init() {
    const { viewType: viewType } = this.$state;
    if (!this.el || !(0, $57dmi._)(this, $9f21272e0549cf92$var$_canIdle).call(this)) return;
    if (viewType() === "audio") {
        this.show();
        return;
    }
    (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchMouse, $9f21272e0549cf92$var$watchMouse).bind(this));
    (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchPaused, $9f21272e0549cf92$var$watchPaused).bind(this));
    const onPlay1 = (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onPlay, $9f21272e0549cf92$var$onPlay).bind(this), onPause1 = (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onPause, $9f21272e0549cf92$var$onPause).bind(this), onEnd1 = (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onEnd, $9f21272e0549cf92$var$onEnd).bind(this);
    new (0, $8B3mG.EventsController)(this.el).add("can-play", (event)=>this.show(0, event)).add("play", onPlay1).add("pause", onPause1).add("end", onEnd1).add("auto-play-fail", onPause1);
}
function $9f21272e0549cf92$var$watchMouse() {
    if (!this.el) return;
    const { started: started, pointer: pointer, paused: paused } = this.$state;
    if (!started() || pointer() !== "fine") return;
    const events = new (0, $8B3mG.EventsController)(this.el), shouldHideOnMouseLeave = this.hideOnMouseLeave;
    if (!shouldHideOnMouseLeave || !(0, $57dmi._)(this, $9f21272e0549cf92$var$_isMouseOutside).call(this)) (0, $8B3mG.effect)(()=>{
        if (!paused()) events.add("pointermove", (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onStopIdle, $9f21272e0549cf92$var$onStopIdle).bind(this));
    });
    if (shouldHideOnMouseLeave) events.add("mouseenter", (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onMouseEnter, $9f21272e0549cf92$var$onMouseEnter).bind(this)).add("mouseleave", (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onMouseLeave, $9f21272e0549cf92$var$onMouseLeave).bind(this));
}
function $9f21272e0549cf92$var$watchPaused() {
    const { paused: paused, started: started, autoPlayError: autoPlayError } = this.$state;
    if (paused() || autoPlayError() && !started()) return;
    const onStopIdle1 = (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onStopIdle, $9f21272e0549cf92$var$onStopIdle).bind(this);
    (0, $8B3mG.effect)(()=>{
        if (!this.el) return;
        const pointer = this.$state.pointer(), isTouch = pointer === "coarse", events = new (0, $8B3mG.EventsController)(this.el), eventTypes = [
            isTouch ? "touchend" : "pointerup",
            "keydown"
        ];
        for (const eventType of eventTypes)events.add(eventType, onStopIdle1, {
            passive: false
        });
    });
}
function $9f21272e0549cf92$var$onPlay(event) {
    if (event.triggers.hasType("ended")) return;
    this.show(0, event);
    this.hide(void 0, event);
}
function $9f21272e0549cf92$var$onPause(event) {
    this.show(0, event);
}
function $9f21272e0549cf92$var$onEnd(event) {
    const { loop: loop } = this.$state;
    if (loop()) this.hide(0, event);
}
function $9f21272e0549cf92$var$onMouseEnter(event) {
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_isMouseOutside).set(false);
    this.show(0, event);
    this.hide(void 0, event);
}
function $9f21272e0549cf92$var$onMouseLeave(event) {
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_isMouseOutside).set(true);
    this.hide(0, event);
}
function $9f21272e0549cf92$var$clearIdleTimer() {
    window.clearTimeout((0, $57dmi._)(this, $9f21272e0549cf92$var$_idleTimer));
    (0, $4vwVC._)(this, $9f21272e0549cf92$var$_idleTimer, -1);
}
function $9f21272e0549cf92$var$onStopIdle(event) {
    if (// @ts-expect-error
    event.MEDIA_GESTURE || (0, $57dmi._)(this, $9f21272e0549cf92$var$_pausedTracking) || (0, $ciZW6.isTouchPinchEvent)(event)) return;
    if ((0, $8B3mG.isKeyboardEvent)(event)) {
        if (event.key === "Escape") {
            this.el?.focus();
            (0, $4vwVC._)(this, $9f21272e0549cf92$var$_focusedItem, null);
        } else if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_focusedItem)) {
            event.preventDefault();
            requestAnimationFrame(()=>{
                (0, $57dmi._)(this, $9f21272e0549cf92$var$_focusedItem)?.focus();
                (0, $4vwVC._)(this, $9f21272e0549cf92$var$_focusedItem, null);
            });
        }
    }
    this.show(0, event);
    this.hide(this.defaultDelay, event);
}
function $9f21272e0549cf92$var$changeVisibility(visible, delay, trigger) {
    if (delay === 0) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onChange2, $9f21272e0549cf92$var$onChange2).call(this, visible, trigger);
        return;
    }
    (0, $4vwVC._)(this, $9f21272e0549cf92$var$_idleTimer, window.setTimeout(()=>{
        if (!this.scope) return;
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onChange2, $9f21272e0549cf92$var$onChange2).call(this, visible && !(0, $57dmi._)(this, $9f21272e0549cf92$var$_pausedTracking), trigger);
    }, delay));
}
function $9f21272e0549cf92$var$onChange2(visible, trigger) {
    if (this.$state.controlsVisible() === visible) return;
    this.$state.controlsVisible.set(visible);
    if (!visible && document.activeElement && this.el?.contains(document.activeElement)) {
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_focusedItem, document.activeElement);
        requestAnimationFrame(()=>{
            this.el?.focus({
                preventScroll: true
            });
        });
    }
    this.dispatch("controls-change", {
        detail: visible,
        trigger: trigger
    });
}

class $9f21272e0549cf92$export$3b6ee65e53e21943 {
    canPlay(src) {
        if (!(0, $8kkZn.isAudioSrc)(src)) return false;
        return !(0, $8B3mG.isString)(src.src) || src.type === "?" || (0, $8kkZn.canPlayAudioType)(this.target, src.type);
    }
    mediaType() {
        return "audio";
    }
    async load(ctx) {
        return new (await (parcelRequire("8UZgv"))).AudioProvider(this.target, ctx);
    }
    constructor(){
        (0, $97zcJ._)(this, "name", "audio");
        (0, $97zcJ._)(this, "target", void 0);
    }
}

class $9f21272e0549cf92$export$f5ae8460d3ff5e74 {
    canPlay(src) {
        if (!(0, $8kkZn.isVideoSrc)(src)) return false;
        return !(0, $8B3mG.isString)(src.src) || src.type === "?" || (0, $8kkZn.canPlayVideoType)(this.target, src.type);
    }
    mediaType() {
        return "video";
    }
    async load(ctx) {
        return new (await (parcelRequire("13daR"))).VideoProvider(this.target, ctx);
    }
    constructor(){
        (0, $97zcJ._)(this, "name", "video");
        (0, $97zcJ._)(this, "target", void 0);
    }
}

class $9f21272e0549cf92$export$86f4eeacf5114a41 extends $9f21272e0549cf92$export$f5ae8460d3ff5e74 {
    canPlay(src) {
        return $9f21272e0549cf92$export$86f4eeacf5114a41.supported && (0, $8kkZn.isHLSSrc)(src);
    }
    async load(context) {
        return new (await (parcelRequire("8v5fF"))).HLSProvider(this.target, context);
    }
    constructor(...args){
        super(...args);
        (0, $97zcJ._)(this, "name", "hls");
    }
}
(0, $97zcJ._)($9f21272e0549cf92$export$86f4eeacf5114a41, "supported", (0, $8kkZn.isHLSSupported)());

class $9f21272e0549cf92$export$9b47f20788fea2cb extends $9f21272e0549cf92$export$f5ae8460d3ff5e74 {
    canPlay(src) {
        return $9f21272e0549cf92$export$9b47f20788fea2cb.supported && (0, $8kkZn.isDASHSrc)(src);
    }
    async load(context) {
        return new (await (parcelRequire("kXdqo"))).DASHProvider(this.target, context);
    }
    constructor(...args){
        super(...args);
        (0, $97zcJ._)(this, "name", "dash");
    }
}
(0, $97zcJ._)($9f21272e0549cf92$export$9b47f20788fea2cb, "supported", (0, $8kkZn.isDASHSupported)());


class $9f21272e0549cf92$export$6812dd811fbf981 {
    preconnect() {
        const connections = [
            "https://i.vimeocdn.com",
            "https://f.vimeocdn.com",
            "https://fresnel.vimeocdn.com"
        ];
        for (const url of connections)(0, $dLb9W.preconnect)(url);
    }
    canPlay(src) {
        return (0, $8B3mG.isString)(src.src) && src.type === "video/vimeo";
    }
    mediaType() {
        return "video";
    }
    async load(ctx) {
        return new (await (parcelRequire("h1Egj"))).VimeoProvider(this.target, ctx);
    }
    async loadPoster(src, ctx, abort) {
        const { resolveVimeoVideoId: resolveVimeoVideoId, getVimeoVideoInfo: getVimeoVideoInfo } = await (parcelRequire("buafn"));
        if (!(0, $8B3mG.isString)(src.src)) return null;
        const { videoId: videoId, hash: hash } = resolveVimeoVideoId(src.src);
        if (videoId) return getVimeoVideoInfo(videoId, abort, hash).then((info)=>info ? info.poster : null);
        return null;
    }
    constructor(){
        (0, $97zcJ._)(this, "name", "vimeo");
        (0, $97zcJ._)(this, "target", void 0);
    }
}


class $9f21272e0549cf92$export$142512714515b064 {
    preconnect() {
        const connections = [
            // Botguard script.
            "https://www.google.com",
            // Posters.
            "https://i.ytimg.com",
            // Ads.
            "https://googleads.g.doubleclick.net",
            "https://static.doubleclick.net"
        ];
        for (const url of connections)(0, $dLb9W.preconnect)(url);
    }
    canPlay(src) {
        return (0, $8B3mG.isString)(src.src) && src.type === "video/youtube";
    }
    mediaType() {
        return "video";
    }
    async load(ctx) {
        return new (await (parcelRequire("kQ396"))).YouTubeProvider(this.target, ctx);
    }
    async loadPoster(src, ctx, abort) {
        const { findYouTubePoster: findYouTubePoster, resolveYouTubeVideoId: resolveYouTubeVideoId } = await (parcelRequire("7ipNj"));
        const videoId = (0, $8B3mG.isString)(src.src) && resolveYouTubeVideoId(src.src);
        if (videoId) return findYouTubePoster(videoId, abort);
        return null;
    }
    constructor(){
        (0, $97zcJ._)(this, "name", "youtube");
        (0, $97zcJ._)(this, "target", void 0);
    }
}
const $9f21272e0549cf92$var$MEDIA_ATTRIBUTES = Symbol(0);
const $9f21272e0549cf92$var$mediaAttributes = [
    "autoPlay",
    "canAirPlay",
    "canFullscreen",
    "canGoogleCast",
    "canLoad",
    "canLoadPoster",
    "canPictureInPicture",
    "canPlay",
    "canSeek",
    "ended",
    "fullscreen",
    "isAirPlayConnected",
    "isGoogleCastConnected",
    "live",
    "liveEdge",
    "loop",
    "mediaType",
    "muted",
    "paused",
    "pictureInPicture",
    "playing",
    "playsInline",
    "remotePlaybackState",
    "remotePlaybackType",
    "seeking",
    "started",
    "streamType",
    "viewType",
    "waiting"
];
const $9f21272e0549cf92$var$mediaPlayerProps = {
    artist: "",
    artwork: null,
    autoplay: false,
    autoPlay: false,
    clipStartTime: 0,
    clipEndTime: 0,
    controls: false,
    currentTime: 0,
    crossorigin: null,
    crossOrigin: null,
    duration: -1,
    fullscreenOrientation: "landscape",
    googleCast: {},
    load: "visible",
    posterLoad: "visible",
    logLevel: "silent",
    loop: false,
    muted: false,
    paused: true,
    playsinline: false,
    playsInline: false,
    playbackRate: 1,
    poster: "",
    preload: "metadata",
    preferNativeHLS: false,
    src: "",
    title: "",
    controlsDelay: 2e3,
    hideControlsOnMouseLeave: false,
    viewType: "unknown",
    streamType: "unknown",
    volume: 1,
    liveEdgeTolerance: 10,
    minLiveDVRWindow: 60,
    keyDisabled: false,
    keyTarget: "player",
    keyShortcuts: $9f21272e0549cf92$export$3ae2801a8b246f99,
    storage: null
};
var $9f21272e0549cf92$var$_type1 = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_callback = /*#__PURE__*/ new WeakMap();
class $9f21272e0549cf92$var$MediaLoadController extends $9f21272e0549cf92$var$MediaPlayerController {
    async onAttach(el) {
        const load = this.$props[(0, $57dmi._)(this, $9f21272e0549cf92$var$_type1)]();
        if (load === "eager") requestAnimationFrame((0, $57dmi._)(this, $9f21272e0549cf92$var$_callback));
        else if (load === "idle") (0, $8B3mG.waitIdlePeriod)((0, $57dmi._)(this, $9f21272e0549cf92$var$_callback));
        else if (load === "visible") {
            let dispose, observer = new IntersectionObserver((entries)=>{
                if (!this.scope) return;
                if (entries[0].isIntersecting) {
                    dispose?.();
                    dispose = void 0;
                    (0, $57dmi._)(this, $9f21272e0549cf92$var$_callback).call(this);
                }
            });
            observer.observe(el);
            dispose = (0, $8B3mG.onDispose)(()=>observer.disconnect());
        }
    }
    constructor(type, callback){
        super();
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_type1, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_callback, {
            writable: true,
            value: void 0
        });
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_type1, type);
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_callback, callback);
    }
}
var $9f21272e0549cf92$var$_handle = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_media2 = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_attemptAutoplay = /*#__PURE__*/ new WeakSet();
class $9f21272e0549cf92$var$MediaPlayerDelegate {
    notify(type, ...init) {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_handle).call(this, new (0, $8B3mG.DOMEvent)(type, {
            detail: init?.[0],
            trigger: init?.[1]
        }));
    }
    async ready(info, trigger) {
        return (0, $8B3mG.untrack)(async ()=>{
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_media2);
            const { autoPlay: autoPlay, canPlay: canPlay, started: started, duration: duration, seekable: seekable, buffered: buffered, remotePlaybackInfo: remotePlaybackInfo, playsInline: playsInline, savedState: savedState, source: source } = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media2).$state;
            if (canPlay()) return;
            const detail = {
                duration: info?.duration ?? duration(),
                seekable: info?.seekable ?? seekable(),
                buffered: info?.buffered ?? buffered(),
                provider: (0, $57dmi._)(this, $9f21272e0549cf92$var$_media2).$provider()
            };
            this.notify("can-play", detail, trigger);
            (0, $8B3mG.tick)();
            let provider = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media2).$provider(), { storage: storage, qualities: qualities } = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media2), { muted: muted, volume: volume, clipStartTime: clipStartTime, playbackRate: playbackRate } = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media2).$props;
            await storage?.onLoad?.(source());
            const savedPlaybackTime = savedState()?.currentTime, savedPlayingState = savedState()?.paused, storageTime = await storage?.getTime(), startTime = savedPlaybackTime ?? storageTime ?? clipStartTime(), shouldAutoPlay = savedPlayingState || savedPlayingState !== false && !started() && autoPlay();
            if (provider) {
                provider.setVolume(await storage?.getVolume() ?? volume());
                provider.setMuted(muted() || !!await storage?.getMuted());
                const audioGain = await storage?.getAudioGain() ?? 1;
                if (audioGain > 1) provider.audioGain?.setGain?.(audioGain);
                provider.setPlaybackRate?.(await storage?.getPlaybackRate() ?? playbackRate());
                provider.setPlaysInline?.(playsInline());
                if (startTime > 0) provider.setCurrentTime(startTime);
            }
            const prefQuality = await storage?.getVideoQuality();
            if (prefQuality && qualities.length) {
                let currentQuality = null, currentScore = Infinity;
                for (const quality of qualities){
                    const score = Math.abs(prefQuality.width - quality.width) + Math.abs(prefQuality.height - quality.height) + (prefQuality.bitrate ? Math.abs(prefQuality.bitrate - (quality.bitrate ?? 0)) : 0);
                    if (score < currentScore) {
                        currentQuality = quality;
                        currentScore = score;
                    }
                }
                if (currentQuality) currentQuality.selected = true;
            }
            if (canPlay() && shouldAutoPlay) await (0, $2u9SC._)(this, $9f21272e0549cf92$var$_attemptAutoplay, $9f21272e0549cf92$var$attemptAutoplay).call(this, trigger);
            else if (storageTime && storageTime > 0) this.notify("started", void 0, trigger);
            remotePlaybackInfo.set(null);
        });
    }
    constructor(handle, media){
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_attemptAutoplay);
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_handle, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_media2, {
            writable: true,
            value: void 0
        });
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_handle, handle);
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_media2, media);
    }
}
async function $9f21272e0549cf92$var$attemptAutoplay(trigger) {
    const { player: player, $state: { autoPlaying: autoPlaying, muted: muted } } = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media2);
    autoPlaying.set(true);
    const attemptEvent = new (0, $8B3mG.DOMEvent)("auto-play-attempt", {
        trigger: trigger
    });
    try {
        await player.play(attemptEvent);
    } catch (error) {}
}
var $9f21272e0549cf92$var$_queue = /*#__PURE__*/ new WeakMap();
class $9f21272e0549cf92$var$Queue {
    /**
   * Queue the given `item` under the given `key` to be processed at a later time by calling
   * `serve(key)`.
   */ enqueue(key, item) {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_queue).set(key, item);
    }
    /**
   * Process item in queue for the given `key`.
   */ serve(key) {
        const value = this.peek(key);
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_queue).delete(key);
        return value;
    }
    /**
   * Peek at item in queue for the given `key`.
   */ peek(key) {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_queue).get(key);
    }
    /**
   * Removes queued item under the given `key`.
   */ delete(key) {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_queue).delete(key);
    }
    /**
   * Clear all items in the queue.
   */ clear() {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_queue).clear();
    }
    constructor(){
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_queue, {
            writable: true,
            value: /* @__PURE__ */ new Map()
        });
    }
}
var $9f21272e0549cf92$var$_serving = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_pending = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_queue1 = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_flush = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_release = /*#__PURE__*/ new WeakSet();
class $9f21272e0549cf92$var$RequestQueue {
    /**
   * The number of callbacks that are currently in queue.
   */ get size() {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_queue1).size;
    }
    /**
   * Whether items in the queue are being served immediately, otherwise they're queued to
   * be processed later.
   */ get isServing() {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_serving);
    }
    /**
   * Waits for the queue to be flushed (ie: start serving).
   */ async waitForFlush() {
        if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_serving)) return;
        await (0, $57dmi._)(this, $9f21272e0549cf92$var$_pending).promise;
    }
    /**
   * Queue the given `callback` to be invoked at a later time by either calling the `serve()` or
   * `start()` methods. If the queue has started serving (i.e., `start()` was already called),
   * then the callback will be invoked immediately.
   *
   * @param key - Uniquely identifies this callback so duplicates are ignored.
   * @param callback - The function to call when this item in the queue is being served.
   */ enqueue(key, callback) {
        if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_serving)) {
            callback();
            return;
        }
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_queue1).delete(key);
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_queue1).set(key, callback);
    }
    /**
   * Invokes the callback with the given `key` in the queue (if it exists).
   */ serve(key) {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_queue1).get(key)?.();
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_queue1).delete(key);
    }
    /**
   * Flush all queued items and start serving future requests immediately until `stop()` is called.
   */ start() {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_flush, $9f21272e0549cf92$var$flush).call(this);
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_serving, true);
        if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_queue1).size > 0) (0, $2u9SC._)(this, $9f21272e0549cf92$var$_flush, $9f21272e0549cf92$var$flush).call(this);
    }
    /**
   * Stop serving requests, they'll be queued until you begin processing again by calling `start()`.
   */ stop() {
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_serving, false);
    }
    /**
   * Stop serving requests, empty the request queue, and release any promises waiting for the
   * queue to flush.
   */ reset() {
        this.stop();
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_queue1).clear();
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_release, $9f21272e0549cf92$var$release).call(this);
    }
    constructor(){
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_flush);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_release);
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_serving, {
            writable: true,
            value: false
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_pending, {
            writable: true,
            value: (0, $8B3mG.deferredPromise)()
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_queue1, {
            writable: true,
            value: /* @__PURE__ */ new Map()
        });
    }
}
function $9f21272e0549cf92$var$flush() {
    for (const key of (0, $57dmi._)(this, $9f21272e0549cf92$var$_queue1).keys())this.serve(key);
    (0, $2u9SC._)(this, $9f21272e0549cf92$var$_release, $9f21272e0549cf92$var$release).call(this);
}
function $9f21272e0549cf92$var$release() {
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_pending).resolve();
    (0, $4vwVC._)(this, $9f21272e0549cf92$var$_pending, (0, $8B3mG.deferredPromise)());
}
var $9f21272e0549cf92$var$_stateMgr = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_request = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_media3 = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_fullscreen = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_orientation = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_$provider = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_providerQueue = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_attachLoadPlayListener = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchProvider = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_handleRequest = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_handleLoadPlayStrategy = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_wasPIPActive = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_getFullscreenAdapter = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_throwIfPIPNotSupported = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchControlsDelayChange = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchAudioGainSupport = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchAirPlaySupport = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchGoogleCastSupport = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchFullscreenSupport = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchPiPSupport = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_googleCastLoader = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_onFullscreenChange = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onFullscreenError = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onPictureInPictureError = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_logError = /*#__PURE__*/ new WeakSet();

class $9f21272e0549cf92$var$MediaRequestManager extends $9f21272e0549cf92$var$MediaPlayerController {
    onAttach() {
        this.listen("fullscreen-change", (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onFullscreenChange, $9f21272e0549cf92$var$onFullscreenChange).bind(this));
    }
    onConnect(el) {
        const names = Object.getOwnPropertyNames(Object.getPrototypeOf(this)), events = new (0, $8B3mG.EventsController)(el), handleRequest1 = (0, $2u9SC._)(this, $9f21272e0549cf92$var$_handleRequest, $9f21272e0549cf92$var$handleRequest).bind(this);
        for (const name of names)if (name.startsWith("media-")) events.add(name, handleRequest1);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_attachLoadPlayListener, $9f21272e0549cf92$var$attachLoadPlayListener).call(this);
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchProvider, $9f21272e0549cf92$var$watchProvider).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchControlsDelayChange, $9f21272e0549cf92$var$watchControlsDelayChange).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchAudioGainSupport, $9f21272e0549cf92$var$watchAudioGainSupport).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchAirPlaySupport, $9f21272e0549cf92$var$watchAirPlaySupport).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchGoogleCastSupport, $9f21272e0549cf92$var$watchGoogleCastSupport).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchFullscreenSupport, $9f21272e0549cf92$var$watchFullscreenSupport).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchPiPSupport, $9f21272e0549cf92$var$watchPiPSupport).bind(this));
    }
    onDestroy() {
        try {
            const destroyEvent = this.createEvent("destroy"), { pictureInPicture: pictureInPicture, fullscreen: fullscreen } = this.$state;
            if (fullscreen()) this.exitFullscreen("prefer-media", destroyEvent);
            if (pictureInPicture()) this.exitPictureInPicture(destroyEvent);
        } catch (e) {}
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_providerQueue).reset();
    }
    async play(trigger) {
        const { canPlay: canPlay, paused: paused, autoPlaying: autoPlaying } = this.$state;
        if ((0, $2u9SC._)(this, $9f21272e0549cf92$var$_handleLoadPlayStrategy, $9f21272e0549cf92$var$handleLoadPlayStrategy).call(this, trigger)) return;
        if (!(0, $8B3mG.peek)(paused)) return;
        if (trigger) (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue("media-play-request", trigger);
        const isAutoPlaying = (0, $8B3mG.peek)(autoPlaying);
        try {
            const provider = (0, $8B3mG.peek)((0, $57dmi._)(this, $9f21272e0549cf92$var$_$provider));
            $9f21272e0549cf92$var$throwIfNotReadyForPlayback(provider, (0, $8B3mG.peek)(canPlay));
            return await provider.play();
        } catch (error) {
            const errorEvent = this.createEvent("play-fail", {
                detail: (0, $9KZm0.coerceToError)(error),
                trigger: trigger
            });
            errorEvent.autoPlay = isAutoPlaying;
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_stateMgr).handle(errorEvent);
            throw error;
        }
    }
    async pause(trigger) {
        const { canPlay: canPlay, paused: paused } = this.$state;
        if ((0, $8B3mG.peek)(paused)) return;
        if (trigger) (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue("media-pause-request", trigger);
        try {
            const provider = (0, $8B3mG.peek)((0, $57dmi._)(this, $9f21272e0549cf92$var$_$provider));
            $9f21272e0549cf92$var$throwIfNotReadyForPlayback(provider, (0, $8B3mG.peek)(canPlay));
            return await provider.pause();
        } catch (error) {
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.delete("media-pause-request");
            throw error;
        }
    }
    setAudioGain(gain, trigger) {
        const { audioGain: audioGain, canSetAudioGain: canSetAudioGain } = this.$state;
        if (audioGain() === gain) return;
        const provider = (0, $57dmi._)(this, $9f21272e0549cf92$var$_$provider).call(this);
        if (!provider?.audioGain || !canSetAudioGain()) throw Error("[vidstack] audio gain api not available");
        if (trigger) (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue("media-audio-gain-change-request", trigger);
        provider.audioGain.setGain(gain);
    }
    seekToLiveEdge(trigger) {
        const { canPlay: canPlay, live: live, liveEdge: liveEdge, canSeek: canSeek, liveSyncPosition: liveSyncPosition, seekableEnd: seekableEnd, userBehindLiveEdge: userBehindLiveEdge } = this.$state;
        userBehindLiveEdge.set(false);
        if ((0, $8B3mG.peek)(()=>!live() || liveEdge() || !canSeek())) return;
        const provider = (0, $8B3mG.peek)((0, $57dmi._)(this, $9f21272e0549cf92$var$_$provider));
        $9f21272e0549cf92$var$throwIfNotReadyForPlayback(provider, (0, $8B3mG.peek)(canPlay));
        if (trigger) (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue("media-seek-request", trigger);
        const end = seekableEnd() - 2;
        provider.setCurrentTime(Math.min(end, liveSyncPosition() ?? end));
    }
    async enterFullscreen(target = "prefer-media", trigger) {
        const adapter = (0, $2u9SC._)(this, $9f21272e0549cf92$var$_getFullscreenAdapter, $9f21272e0549cf92$var$getFullscreenAdapter).call(this, target);
        $9f21272e0549cf92$var$throwIfFullscreenNotSupported(target, adapter);
        if (adapter.active) return;
        if ((0, $8B3mG.peek)(this.$state.pictureInPicture)) {
            (0, $4vwVC._)(this, $9f21272e0549cf92$var$_wasPIPActive, true);
            await this.exitPictureInPicture(trigger);
        }
        if (trigger) (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue("media-enter-fullscreen-request", trigger);
        return adapter.enter();
    }
    async exitFullscreen(target = "prefer-media", trigger) {
        const adapter = (0, $2u9SC._)(this, $9f21272e0549cf92$var$_getFullscreenAdapter, $9f21272e0549cf92$var$getFullscreenAdapter).call(this, target);
        $9f21272e0549cf92$var$throwIfFullscreenNotSupported(target, adapter);
        if (!adapter.active) return;
        if (trigger) (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue("media-exit-fullscreen-request", trigger);
        try {
            const result = await adapter.exit();
            if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_wasPIPActive) && (0, $8B3mG.peek)(this.$state.canPictureInPicture)) await this.enterPictureInPicture();
            return result;
        } finally{
            (0, $4vwVC._)(this, $9f21272e0549cf92$var$_wasPIPActive, false);
        }
    }
    async enterPictureInPicture(trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_throwIfPIPNotSupported, $9f21272e0549cf92$var$throwIfPIPNotSupported).call(this);
        if (this.$state.pictureInPicture()) return;
        if (trigger) (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue("media-enter-pip-request", trigger);
        return await (0, $57dmi._)(this, $9f21272e0549cf92$var$_$provider).call(this).pictureInPicture.enter();
    }
    async exitPictureInPicture(trigger) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_throwIfPIPNotSupported, $9f21272e0549cf92$var$throwIfPIPNotSupported).call(this);
        if (!this.$state.pictureInPicture()) return;
        if (trigger) (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue("media-exit-pip-request", trigger);
        return await (0, $57dmi._)(this, $9f21272e0549cf92$var$_$provider).call(this).pictureInPicture.exit();
    }
    async ["media-airplay-request"](event) {
        try {
            await this.requestAirPlay(event);
        } catch (error) {}
    }
    async requestAirPlay(trigger) {
        try {
            const adapter = (0, $57dmi._)(this, $9f21272e0549cf92$var$_$provider).call(this)?.airPlay;
            if (!adapter?.supported) throw Error("No AirPlay adapter.");
            if (trigger) (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue("media-airplay-request", trigger);
            return await adapter.prompt();
        } catch (error) {
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.delete("media-airplay-request");
            throw error;
        }
    }
    async ["media-google-cast-request"](event) {
        try {
            await this.requestGoogleCast(event);
        } catch (error) {}
    }
    async requestGoogleCast(trigger) {
        try {
            const { canGoogleCast: canGoogleCast } = this.$state;
            if (!(0, $8B3mG.peek)(canGoogleCast)) {
                const error = Error("Cast not available.");
                error.code = "CAST_NOT_AVAILABLE";
                throw error;
            }
            (0, $dLb9W.preconnect)("https://www.gstatic.com");
            if (!(0, $57dmi._)(this, $9f21272e0549cf92$var$_googleCastLoader)) {
                const $module = await (parcelRequire("dnjPE"));
                (0, $4vwVC._)(this, $9f21272e0549cf92$var$_googleCastLoader, new $module.GoogleCastLoader());
            }
            await (0, $57dmi._)(this, $9f21272e0549cf92$var$_googleCastLoader).prompt((0, $57dmi._)(this, $9f21272e0549cf92$var$_media3));
            if (trigger) (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue("media-google-cast-request", trigger);
            const isConnecting = (0, $8B3mG.peek)(this.$state.remotePlaybackState) !== "disconnected";
            if (isConnecting) this.$state.savedState.set({
                paused: (0, $8B3mG.peek)(this.$state.paused),
                currentTime: (0, $8B3mG.peek)(this.$state.currentTime)
            });
            this.$state.remotePlaybackLoader.set(isConnecting ? (0, $57dmi._)(this, $9f21272e0549cf92$var$_googleCastLoader) : null);
        } catch (error) {
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.delete("media-google-cast-request");
            throw error;
        }
    }
    ["media-clip-start-change-request"](event) {
        const { clipStartTime: clipStartTime } = this.$state;
        clipStartTime.set(event.detail);
    }
    ["media-clip-end-change-request"](event) {
        const { clipEndTime: clipEndTime } = this.$state;
        clipEndTime.set(event.detail);
        this.dispatch("duration-change", {
            detail: event.detail,
            trigger: event
        });
    }
    ["media-duration-change-request"](event) {
        const { providedDuration: providedDuration, clipEndTime: clipEndTime } = this.$state;
        providedDuration.set(event.detail);
        if (clipEndTime() <= 0) this.dispatch("duration-change", {
            detail: event.detail,
            trigger: event
        });
    }
    ["media-audio-track-change-request"](event) {
        const { logger: logger, audioTracks: audioTracks } = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media3);
        if (audioTracks.readonly) return;
        const index = event.detail, track = audioTracks[index];
        if (track) {
            const key = event.type;
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue(key, event);
            track.selected = true;
        }
    }
    async ["media-enter-fullscreen-request"](event) {
        try {
            await this.enterFullscreen(event.detail, event);
        } catch (error) {
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onFullscreenError, $9f21272e0549cf92$var$onFullscreenError).call(this, error, event);
        }
    }
    async ["media-exit-fullscreen-request"](event) {
        try {
            await this.exitFullscreen(event.detail, event);
        } catch (error) {
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onFullscreenError, $9f21272e0549cf92$var$onFullscreenError).call(this, error, event);
        }
    }
    async ["media-orientation-lock-request"](event) {
        const key = event.type;
        try {
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue(key, event);
            await (0, $57dmi._)(this, $9f21272e0549cf92$var$_orientation).lock(event.detail);
        } catch (error) {
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.delete(key);
        }
    }
    async ["media-orientation-unlock-request"](event) {
        const key = event.type;
        try {
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue(key, event);
            await (0, $57dmi._)(this, $9f21272e0549cf92$var$_orientation).unlock();
        } catch (error) {
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.delete(key);
        }
    }
    async ["media-enter-pip-request"](event) {
        try {
            await this.enterPictureInPicture(event);
        } catch (error) {
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onPictureInPictureError, $9f21272e0549cf92$var$onPictureInPictureError).call(this, error, event);
        }
    }
    async ["media-exit-pip-request"](event) {
        try {
            await this.exitPictureInPicture(event);
        } catch (error) {
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onPictureInPictureError, $9f21272e0549cf92$var$onPictureInPictureError).call(this, error, event);
        }
    }
    ["media-live-edge-request"](event) {
        const { live: live, liveEdge: liveEdge, canSeek: canSeek } = this.$state;
        if (!live() || liveEdge() || !canSeek()) return;
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue("media-seek-request", event);
        try {
            this.seekToLiveEdge();
        } catch (error) {
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.delete("media-seek-request");
        }
    }
    async ["media-loop-request"](event) {
        try {
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).looping = true;
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).replaying = true;
            await this.play(event);
        } catch (error) {
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).looping = false;
        }
    }
    ["media-user-loop-change-request"](event) {
        this.$state.userPrefersLoop.set(event.detail);
    }
    async ["media-pause-request"](event) {
        if (this.$state.paused()) return;
        try {
            await this.pause(event);
        } catch (error) {}
    }
    async ["media-play-request"](event) {
        if (!this.$state.paused()) return;
        try {
            await this.play(event);
        } catch (e) {}
    }
    ["media-rate-change-request"](event) {
        const { playbackRate: playbackRate, canSetPlaybackRate: canSetPlaybackRate } = this.$state;
        if (playbackRate() === event.detail || !canSetPlaybackRate()) return;
        const provider = (0, $57dmi._)(this, $9f21272e0549cf92$var$_$provider).call(this);
        if (!provider?.setPlaybackRate) return;
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue("media-rate-change-request", event);
        provider.setPlaybackRate(event.detail);
    }
    ["media-audio-gain-change-request"](event) {
        try {
            this.setAudioGain(event.detail, event);
        } catch (e) {}
    }
    ["media-quality-change-request"](event) {
        const { qualities: qualities, storage: storage, logger: logger } = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media3);
        if (qualities.readonly) return;
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue("media-quality-change-request", event);
        const index = event.detail;
        if (index < 0) {
            qualities.autoSelect(event);
            if (event.isOriginTrusted) storage?.setVideoQuality?.(null);
        } else {
            const quality = qualities[index];
            if (quality) {
                quality.selected = true;
                if (event.isOriginTrusted) storage?.setVideoQuality?.({
                    id: quality.id,
                    width: quality.width,
                    height: quality.height,
                    bitrate: quality.bitrate
                });
            }
        }
    }
    ["media-pause-controls-request"](event) {
        const key = event.type;
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue(key, event);
        this.controls.pause(event);
    }
    ["media-resume-controls-request"](event) {
        const key = event.type;
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue(key, event);
        this.controls.resume(event);
    }
    ["media-seek-request"](event) {
        const { seekableStart: seekableStart, seekableEnd: seekableEnd, ended: ended, canSeek: canSeek, live: live, userBehindLiveEdge: userBehindLiveEdge, clipStartTime: clipStartTime } = this.$state, seekTime = event.detail;
        if (ended()) (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).replaying = true;
        const key = event.type;
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).seeking = false;
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.delete(key);
        const clippedTime = seekTime + clipStartTime(), isStart = Math.floor(seekTime) === Math.floor(seekableStart()), isEnd = Math.floor(clippedTime) === Math.floor(seekableEnd()), boundTime = isStart ? seekableStart() : isEnd ? seekableEnd() : Math.min(Math.max(seekableStart() + 0.1, clippedTime), seekableEnd() - 0.1);
        if (!Number.isFinite(boundTime) || !canSeek()) return;
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue(key, event);
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_$provider).call(this).setCurrentTime(boundTime);
        if (live() && event.isOriginTrusted && Math.abs(seekableEnd() - boundTime) >= 2) userBehindLiveEdge.set(true);
    }
    ["media-seeking-request"](event) {
        const key = event.type;
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue(key, event);
        this.$state.seeking.set(true);
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).seeking = true;
    }
    ["media-start-loading"](event) {
        if (this.$state.canLoad()) return;
        const key = event.type;
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue(key, event);
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_stateMgr).handle(this.createEvent("can-load"));
    }
    ["media-poster-start-loading"](event) {
        if (this.$state.canLoadPoster()) return;
        const key = event.type;
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue(key, event);
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_stateMgr).handle(this.createEvent("can-load-poster"));
    }
    ["media-text-track-change-request"](event) {
        const { index: index, mode: mode } = event.detail, track = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media3).textTracks[index];
        if (track) {
            const key = event.type;
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue(key, event);
            track.setMode(mode, event);
        }
    }
    ["media-mute-request"](event) {
        if (this.$state.muted()) return;
        const key = event.type;
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue(key, event);
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_$provider).call(this).setMuted(true);
    }
    ["media-unmute-request"](event) {
        const { muted: muted, volume: volume } = this.$state;
        if (!muted()) return;
        const key = event.type;
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue(key, event);
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_media3).$provider().setMuted(false);
        if (volume() === 0) {
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue(key, event);
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_$provider).call(this).setVolume(0.25);
        }
    }
    ["media-volume-change-request"](event) {
        const { muted: muted, volume: volume } = this.$state;
        const newVolume = event.detail;
        if (volume() === newVolume) return;
        const key = event.type;
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue(key, event);
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_$provider).call(this).setVolume(newVolume);
        if (newVolume > 0 && muted()) {
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_request).queue.enqueue(key, event);
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_$provider).call(this).setMuted(false);
        }
    }
    constructor(stateMgr, request, media){
        super();
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_attachLoadPlayListener);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchProvider);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_handleRequest);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_handleLoadPlayStrategy);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_getFullscreenAdapter);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_throwIfPIPNotSupported);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchControlsDelayChange);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchAudioGainSupport);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchAirPlaySupport);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchGoogleCastSupport);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchFullscreenSupport);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchPiPSupport);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onFullscreenChange);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onFullscreenError);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onPictureInPictureError);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_logError);
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_stateMgr, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_request, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_media3, {
            writable: true,
            value: void 0
        });
        (0, $97zcJ._)(this, "controls", void 0);
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_fullscreen, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_orientation, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_$provider, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_providerQueue, {
            writable: true,
            value: new $9f21272e0549cf92$var$RequestQueue()
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_wasPIPActive, {
            writable: true,
            value: false
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_googleCastLoader, {
            writable: true,
            value: void 0
        });
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_stateMgr, stateMgr);
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_request, request);
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_media3, media);
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_$provider, media.$provider);
        this.controls = new $9f21272e0549cf92$export$71b0351bcb535b62();
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_fullscreen, new $9f21272e0549cf92$export$9822702783955312());
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_orientation, new $9f21272e0549cf92$export$e048a67118113df5());
    }
}
function $9f21272e0549cf92$var$attachLoadPlayListener() {
    const { load: load } = this.$props, { canLoad: canLoad } = this.$state;
    if (load() !== "play" || canLoad()) return;
    const off = this.listen("media-play-request", (event)=>{
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_handleLoadPlayStrategy, $9f21272e0549cf92$var$handleLoadPlayStrategy).call(this, event);
        off();
    });
}
function $9f21272e0549cf92$var$watchProvider() {
    const provider = (0, $57dmi._)(this, $9f21272e0549cf92$var$_$provider).call(this), canPlay = this.$state.canPlay();
    if (provider && canPlay) (0, $57dmi._)(this, $9f21272e0549cf92$var$_providerQueue).start();
    return ()=>{
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_providerQueue).stop();
    };
}
function $9f21272e0549cf92$var$handleRequest(event) {
    event.stopPropagation();
    if (event.defaultPrevented) return;
    if (!this[event.type]) return;
    if ((0, $8B3mG.peek)((0, $57dmi._)(this, $9f21272e0549cf92$var$_$provider))) this[event.type](event);
    else (0, $57dmi._)(this, $9f21272e0549cf92$var$_providerQueue).enqueue(event.type, ()=>{
        if ((0, $8B3mG.peek)((0, $57dmi._)(this, $9f21272e0549cf92$var$_$provider))) this[event.type](event);
    });
}
function $9f21272e0549cf92$var$handleLoadPlayStrategy(trigger) {
    const { load: load } = this.$props, { canLoad: canLoad } = this.$state;
    if (load() === "play" && !canLoad()) {
        const event = this.createEvent("media-start-loading", {
            trigger: trigger
        });
        this.dispatchEvent(event);
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_providerQueue).enqueue("media-play-request", async ()=>{
            try {
                await this.play(event);
            } catch (error) {}
        });
        return true;
    }
    return false;
}
function $9f21272e0549cf92$var$getFullscreenAdapter(target) {
    const provider = (0, $8B3mG.peek)((0, $57dmi._)(this, $9f21272e0549cf92$var$_$provider));
    return target === "prefer-media" && (0, $57dmi._)(this, $9f21272e0549cf92$var$_fullscreen).supported || target === "media" ? (0, $57dmi._)(this, $9f21272e0549cf92$var$_fullscreen) : provider?.fullscreen;
}
function $9f21272e0549cf92$var$throwIfPIPNotSupported() {
    if (this.$state.canPictureInPicture()) return;
    throw Error("[vidstack] no pip support");
}
function $9f21272e0549cf92$var$watchControlsDelayChange() {
    this.controls.defaultDelay = this.$props.controlsDelay();
}
function $9f21272e0549cf92$var$watchAudioGainSupport() {
    const { canSetAudioGain: canSetAudioGain } = this.$state, supported = !!(0, $57dmi._)(this, $9f21272e0549cf92$var$_$provider).call(this)?.audioGain?.supported;
    canSetAudioGain.set(supported);
}
function $9f21272e0549cf92$var$watchAirPlaySupport() {
    const { canAirPlay: canAirPlay } = this.$state, supported = !!(0, $57dmi._)(this, $9f21272e0549cf92$var$_$provider).call(this)?.airPlay?.supported;
    canAirPlay.set(supported);
}
function $9f21272e0549cf92$var$watchGoogleCastSupport() {
    const { canGoogleCast: canGoogleCast, source: source } = this.$state, supported = (0, $8kkZn.IS_CHROME) && !(0, $8kkZn.IS_IOS) && (0, $8kkZn.canGoogleCastSrc)(source());
    canGoogleCast.set(supported);
}
function $9f21272e0549cf92$var$watchFullscreenSupport() {
    const { canFullscreen: canFullscreen } = this.$state, supported = (0, $57dmi._)(this, $9f21272e0549cf92$var$_fullscreen).supported || !!(0, $57dmi._)(this, $9f21272e0549cf92$var$_$provider).call(this)?.fullscreen?.supported;
    canFullscreen.set(supported);
}
function $9f21272e0549cf92$var$watchPiPSupport() {
    const { canPictureInPicture: canPictureInPicture } = this.$state, supported = !!(0, $57dmi._)(this, $9f21272e0549cf92$var$_$provider).call(this)?.pictureInPicture?.supported;
    canPictureInPicture.set(supported);
}
async function $9f21272e0549cf92$var$onFullscreenChange(event) {
    const lockType = (0, $8B3mG.peek)(this.$props.fullscreenOrientation), isFullscreen = event.detail;
    if ((0, $8B3mG.isUndefined)(lockType) || lockType === "none" || !(0, $57dmi._)(this, $9f21272e0549cf92$var$_orientation).supported) return;
    if (isFullscreen) {
        if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_orientation).locked) return;
        this.dispatch("media-orientation-lock-request", {
            detail: lockType,
            trigger: event
        });
    } else if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_orientation).locked) this.dispatch("media-orientation-unlock-request", {
        trigger: event
    });
}
function $9f21272e0549cf92$var$onFullscreenError(error, request) {
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_stateMgr).handle(this.createEvent("fullscreen-error", {
        detail: (0, $9KZm0.coerceToError)(error)
    }));
}
function $9f21272e0549cf92$var$onPictureInPictureError(error, request) {
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_stateMgr).handle(this.createEvent("picture-in-picture-error", {
        detail: (0, $9KZm0.coerceToError)(error)
    }));
}
function $9f21272e0549cf92$var$logError(title, error, request) {
    return;
}
function $9f21272e0549cf92$var$throwIfNotReadyForPlayback(provider, canPlay) {
    if (provider && canPlay) return;
    throw Error("[vidstack] media not ready");
}
function $9f21272e0549cf92$var$throwIfFullscreenNotSupported(target, fullscreen) {
    if (fullscreen?.supported) return;
    throw Error("[vidstack] no fullscreen support");
}
class $9f21272e0549cf92$var$MediaRequestContext {
    constructor(){
        (0, $97zcJ._)(this, "seeking", false);
        (0, $97zcJ._)(this, "looping", false);
        (0, $97zcJ._)(this, "replaying", false);
        (0, $97zcJ._)(this, "queue", new $9f21272e0549cf92$var$Queue());
    }
}
const $9f21272e0549cf92$var$TRACKED_EVENT = /* @__PURE__ */ new Set([
    "auto-play",
    "auto-play-fail",
    "can-load",
    "sources-change",
    "source-change",
    "load-start",
    "abort",
    "error",
    "loaded-metadata",
    "loaded-data",
    "can-play",
    "play",
    "play-fail",
    "pause",
    "playing",
    "seeking",
    "seeked",
    "waiting"
]);
var $9f21272e0549cf92$var$_request1 = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_media4 = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_trackedEvents = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_clipEnded = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_playedIntervals = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_playedInterval = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_firingWaiting = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_waitingTrigger = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_isPlayingOnDisconnect = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_resumePlaybackOnConnect = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_pausePlaybackOnDisconnect = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_resetTracking = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_satisfyRequest = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_addTextTrackListeners = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_addQualityListeners = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_addAudioTrackListeners = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onTextTracksChange = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onTextTrackModeChange = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onAudioTracksChange = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onAudioTrackChange = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onQualitiesChange = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onQualityChange = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onAutoQualityChange = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_stopQualityResizeEffect = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_watchQualityResize = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_stopWatchingQualityResize = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onCanSetQualityChange = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchCanSetVolume = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onSourceQualitiesChange = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_resetMediaState = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onCanPlayDetail = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_resetPlaybackIfNeeded = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_updatePlayed = /*#__PURE__*/ new WeakSet(), // Called to update time again incase duration precision has changed.
$9f21272e0549cf92$var$_onEndPrecisionChange = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_saveTime = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_fireWaiting = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_onEnded = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_stopWaiting = /*#__PURE__*/ new WeakSet();
class $9f21272e0549cf92$var$MediaStateManager extends $9f21272e0549cf92$var$MediaPlayerController {
    onAttach(el) {
        el.setAttribute("aria-busy", "true");
        new (0, $8B3mG.EventsController)(this).add("fullscreen-change", this["fullscreen-change"].bind(this)).add("fullscreen-error", this["fullscreen-error"].bind(this)).add("orientation-change", this["orientation-change"].bind(this));
    }
    onConnect(el) {
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchCanSetVolume, $9f21272e0549cf92$var$watchCanSetVolume).bind(this));
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_addTextTrackListeners, $9f21272e0549cf92$var$addTextTrackListeners).call(this);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_addQualityListeners, $9f21272e0549cf92$var$addQualityListeners).call(this);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_addAudioTrackListeners, $9f21272e0549cf92$var$addAudioTrackListeners).call(this);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_resumePlaybackOnConnect, $9f21272e0549cf92$var$resumePlaybackOnConnect).call(this);
        (0, $8B3mG.onDispose)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_pausePlaybackOnDisconnect, $9f21272e0549cf92$var$pausePlaybackOnDisconnect).bind(this));
    }
    onDestroy() {
        const { audioTracks: audioTracks, qualities: qualities, textTracks: textTracks } = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media4);
        audioTracks[(0, $5UOkG.ListSymbol).reset]();
        qualities[(0, $5UOkG.ListSymbol).reset]();
        textTracks[(0, $5UOkG.ListSymbol).reset]();
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_stopWatchingQualityResize, $9f21272e0549cf92$var$stopWatchingQualityResize).call(this);
    }
    handle(event) {
        if (!this.scope) return;
        const type = event.type;
        (0, $8B3mG.untrack)(()=>this[event.type]?.(event));
        if ($9f21272e0549cf92$var$TRACKED_EVENT.has(type)) (0, $57dmi._)(this, $9f21272e0549cf92$var$_trackedEvents).set(type, event);
        this.dispatch(event);
    }
    ["provider-change"](event) {
        const prevProvider = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media4).$provider(), newProvider = event.detail;
        if (prevProvider?.type === newProvider?.type) return;
        prevProvider?.destroy?.();
        prevProvider?.scope?.dispose();
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_media4).$provider.set(event.detail);
        if (prevProvider && event.detail === null) (0, $2u9SC._)(this, $9f21272e0549cf92$var$_resetMediaState, $9f21272e0549cf92$var$resetMediaState).call(this, event);
    }
    ["provider-loader-change"](event) {}
    ["auto-play"](event) {
        this.$state.autoPlayError.set(null);
    }
    ["auto-play-fail"](event) {
        this.$state.autoPlayError.set(event.detail);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_resetTracking, $9f21272e0549cf92$var$resetTracking).call(this);
    }
    ["can-load"](event) {
        this.$state.canLoad.set(true);
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_trackedEvents).set("can-load", event);
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_media4).textTracks[(0, $ihjXw.TextTrackSymbol).canLoad]();
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_satisfyRequest, $9f21272e0549cf92$var$satisfyRequest).call(this, "media-start-loading", event);
    }
    ["can-load-poster"](event) {
        this.$state.canLoadPoster.set(true);
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_trackedEvents).set("can-load-poster", event);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_satisfyRequest, $9f21272e0549cf92$var$satisfyRequest).call(this, "media-poster-start-loading", event);
    }
    ["media-type-change"](event) {
        const sourceChangeEvent = (0, $57dmi._)(this, $9f21272e0549cf92$var$_trackedEvents).get("source-change");
        if (sourceChangeEvent) event.triggers.add(sourceChangeEvent);
        const viewType = this.$state.viewType();
        this.$state.mediaType.set(event.detail);
        const providedViewType = this.$state.providedViewType(), currentViewType = providedViewType === "unknown" ? event.detail : providedViewType;
        if (viewType !== currentViewType) setTimeout(()=>{
            requestAnimationFrame(()=>{
                if (!this.scope) return;
                this.$state.inferredViewType.set(event.detail);
                this.dispatch("view-type-change", {
                    detail: currentViewType,
                    trigger: event
                });
            });
        }, 0);
    }
    ["stream-type-change"](event) {
        const sourceChangeEvent = (0, $57dmi._)(this, $9f21272e0549cf92$var$_trackedEvents).get("source-change");
        if (sourceChangeEvent) event.triggers.add(sourceChangeEvent);
        const { streamType: streamType, inferredStreamType: inferredStreamType } = this.$state;
        inferredStreamType.set(event.detail);
        event.detail = streamType();
    }
    ["rate-change"](event) {
        const { storage: storage } = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media4), { canPlay: canPlay } = this.$state;
        this.$state.playbackRate.set(event.detail);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_satisfyRequest, $9f21272e0549cf92$var$satisfyRequest).call(this, "media-rate-change-request", event);
        if (canPlay()) storage?.setPlaybackRate?.(event.detail);
    }
    ["remote-playback-change"](event) {
        const { remotePlaybackState: remotePlaybackState, remotePlaybackType: remotePlaybackType } = this.$state, { type: type, state: state } = event.detail, isConnected = state === "connected";
        remotePlaybackType.set(type);
        remotePlaybackState.set(state);
        const key = type === "airplay" ? "media-airplay-request" : "media-google-cast-request";
        if (isConnected) (0, $2u9SC._)(this, $9f21272e0549cf92$var$_satisfyRequest, $9f21272e0549cf92$var$satisfyRequest).call(this, key, event);
        else {
            const requestEvent = (0, $57dmi._)(this, $9f21272e0549cf92$var$_request1).queue.peek(key);
            if (requestEvent) {
                event.request = requestEvent;
                event.triggers.add(requestEvent);
            }
        }
    }
    ["sources-change"](event) {
        const prevSources = this.$state.sources(), newSources = event.detail;
        this.$state.sources.set(newSources);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onSourceQualitiesChange, $9f21272e0549cf92$var$onSourceQualitiesChange).call(this, prevSources, newSources, event);
    }
    ["source-change"](event) {
        event.isQualityChange = event.originEvent?.type === "quality-change";
        const source = event.detail;
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_resetMediaState, $9f21272e0549cf92$var$resetMediaState).call(this, event, event.isQualityChange);
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_trackedEvents).set(event.type, event);
        this.$state.source.set(source);
        this.el?.setAttribute("aria-busy", "true");
    }
    ["abort"](event) {
        const sourceChangeEvent = (0, $57dmi._)(this, $9f21272e0549cf92$var$_trackedEvents).get("source-change");
        if (sourceChangeEvent) event.triggers.add(sourceChangeEvent);
        const canLoadEvent = (0, $57dmi._)(this, $9f21272e0549cf92$var$_trackedEvents).get("can-load");
        if (canLoadEvent && !event.triggers.hasType("can-load")) event.triggers.add(canLoadEvent);
    }
    ["load-start"](event) {
        const sourceChangeEvent = (0, $57dmi._)(this, $9f21272e0549cf92$var$_trackedEvents).get("source-change");
        if (sourceChangeEvent) event.triggers.add(sourceChangeEvent);
    }
    ["error"](event) {
        this.$state.error.set(event.detail);
        const abortEvent = (0, $57dmi._)(this, $9f21272e0549cf92$var$_trackedEvents).get("abort");
        if (abortEvent) event.triggers.add(abortEvent);
    }
    ["loaded-metadata"](event) {
        const loadStartEvent = (0, $57dmi._)(this, $9f21272e0549cf92$var$_trackedEvents).get("load-start");
        if (loadStartEvent) event.triggers.add(loadStartEvent);
    }
    ["loaded-data"](event) {
        const loadStartEvent = (0, $57dmi._)(this, $9f21272e0549cf92$var$_trackedEvents).get("load-start");
        if (loadStartEvent) event.triggers.add(loadStartEvent);
    }
    ["can-play"](event) {
        const loadedMetadata = (0, $57dmi._)(this, $9f21272e0549cf92$var$_trackedEvents).get("loaded-metadata");
        if (loadedMetadata) event.triggers.add(loadedMetadata);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onCanPlayDetail, $9f21272e0549cf92$var$onCanPlayDetail).call(this, event.detail);
        this.el?.setAttribute("aria-busy", "false");
    }
    ["can-play-through"](event) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onCanPlayDetail, $9f21272e0549cf92$var$onCanPlayDetail).call(this, event.detail);
        const canPlay = (0, $57dmi._)(this, $9f21272e0549cf92$var$_trackedEvents).get("can-play");
        if (canPlay) event.triggers.add(canPlay);
    }
    ["duration-change"](event) {
        const { live: live, intrinsicDuration: intrinsicDuration, providedDuration: providedDuration, clipEndTime: clipEndTime, ended: ended } = this.$state, time = event.detail;
        if (!live()) {
            const duration = !Number.isNaN(time) ? time : 0;
            intrinsicDuration.set(duration);
            if (ended()) (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onEndPrecisionChange, $9f21272e0549cf92$var$onEndPrecisionChange).call(this, event);
        }
        if (providedDuration() > 0 || clipEndTime() > 0) event.stopImmediatePropagation();
    }
    ["progress"](event) {
        const { buffered: buffered, bufferedEnd: bufferedEnd, seekable: seekable, seekableEnd: seekableEnd, live: live, intrinsicDuration: intrinsicDuration } = this.$state, { buffered: newBuffered, seekable: newSeekable } = event.detail, newBufferedEnd = (0, $6ELNS.getTimeRangesEnd)(newBuffered) ?? Infinity, hasBufferedLengthChanged = newBuffered.length !== buffered().length, hasBufferedEndChanged = newBufferedEnd > bufferedEnd(), newSeekableEnd = (0, $6ELNS.getTimeRangesEnd)(newSeekable) ?? Infinity, hasSeekableLengthChanged = newSeekable.length !== seekable().length, hasSeekableEndChanged = newSeekableEnd > seekableEnd();
        if (hasBufferedLengthChanged || hasBufferedEndChanged) buffered.set(newBuffered);
        if (hasSeekableLengthChanged || hasSeekableEndChanged) seekable.set(newSeekable);
        if (live()) {
            intrinsicDuration.set(newSeekableEnd);
            this.dispatch("duration-change", {
                detail: newSeekableEnd,
                trigger: event
            });
        }
    }
    ["play"](event) {
        const { paused: paused, autoPlayError: autoPlayError, ended: ended, autoPlaying: autoPlaying, playsInline: playsInline, pointer: pointer, muted: muted, viewType: viewType, live: live, userBehindLiveEdge: userBehindLiveEdge } = this.$state;
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_resetPlaybackIfNeeded, $9f21272e0549cf92$var$resetPlaybackIfNeeded).call(this);
        if (!paused()) {
            event.stopImmediatePropagation();
            return;
        }
        event.autoPlay = autoPlaying();
        const waitingEvent = (0, $57dmi._)(this, $9f21272e0549cf92$var$_trackedEvents).get("waiting");
        if (waitingEvent) event.triggers.add(waitingEvent);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_satisfyRequest, $9f21272e0549cf92$var$satisfyRequest).call(this, "media-play-request", event);
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_trackedEvents).set("play", event);
        paused.set(false);
        autoPlayError.set(null);
        if (event.autoPlay) {
            this.handle(this.createEvent("auto-play", {
                detail: {
                    muted: muted()
                },
                trigger: event
            }));
            autoPlaying.set(false);
        }
        if (ended() || (0, $57dmi._)(this, $9f21272e0549cf92$var$_request1).replaying) {
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_request1).replaying = false;
            ended.set(false);
            this.handle(this.createEvent("replay", {
                trigger: event
            }));
        }
        if (!playsInline() && viewType() === "video" && pointer() === "coarse") (0, $57dmi._)(this, $9f21272e0549cf92$var$_media4).remote.enterFullscreen("prefer-media", event);
        if (live() && !userBehindLiveEdge()) (0, $57dmi._)(this, $9f21272e0549cf92$var$_media4).remote.seekToLiveEdge(event);
    }
    ["play-fail"](event) {
        const { muted: muted, autoPlaying: autoPlaying } = this.$state;
        const playEvent = (0, $57dmi._)(this, $9f21272e0549cf92$var$_trackedEvents).get("play");
        if (playEvent) event.triggers.add(playEvent);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_satisfyRequest, $9f21272e0549cf92$var$satisfyRequest).call(this, "media-play-request", event);
        const { paused: paused, playing: playing } = this.$state;
        paused.set(true);
        playing.set(false);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_resetTracking, $9f21272e0549cf92$var$resetTracking).call(this);
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_trackedEvents).set("play-fail", event);
        if (event.autoPlay) {
            this.handle(this.createEvent("auto-play-fail", {
                detail: {
                    muted: muted(),
                    error: event.detail
                },
                trigger: event
            }));
            autoPlaying.set(false);
        }
    }
    ["playing"](event) {
        const playEvent = (0, $57dmi._)(this, $9f21272e0549cf92$var$_trackedEvents).get("play"), seekedEvent = (0, $57dmi._)(this, $9f21272e0549cf92$var$_trackedEvents).get("seeked");
        if (playEvent) event.triggers.add(playEvent);
        else if (seekedEvent) event.triggers.add(seekedEvent);
        setTimeout(()=>(0, $2u9SC._)(this, $9f21272e0549cf92$var$_resetTracking, $9f21272e0549cf92$var$resetTracking).call(this), 0);
        const { paused: paused, playing: playing, live: live, liveSyncPosition: liveSyncPosition, seekableEnd: seekableEnd, started: started, currentTime: currentTime, seeking: seeking, ended: ended } = this.$state;
        paused.set(false);
        playing.set(true);
        seeking.set(false);
        ended.set(false);
        if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_request1).looping) {
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_request1).looping = false;
            return;
        }
        if (live() && !started() && currentTime() === 0) {
            const end = liveSyncPosition() ?? seekableEnd() - 2;
            if (Number.isFinite(end)) (0, $57dmi._)(this, $9f21272e0549cf92$var$_media4).$provider().setCurrentTime(end);
        }
        this["started"](event);
    }
    ["started"](event) {
        const { started: started } = this.$state;
        if (!started()) {
            started.set(true);
            this.handle(this.createEvent("started", {
                trigger: event
            }));
        }
    }
    ["pause"](event) {
        if (!this.el?.isConnected) (0, $4vwVC._)(this, $9f21272e0549cf92$var$_isPlayingOnDisconnect, true);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_satisfyRequest, $9f21272e0549cf92$var$satisfyRequest).call(this, "media-pause-request", event);
        const seekedEvent = (0, $57dmi._)(this, $9f21272e0549cf92$var$_trackedEvents).get("seeked");
        if (seekedEvent) event.triggers.add(seekedEvent);
        const { paused: paused, playing: playing } = this.$state;
        paused.set(true);
        playing.set(false);
        if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_clipEnded)) setTimeout(()=>{
            this.handle(this.createEvent("end", {
                trigger: event
            }));
            (0, $4vwVC._)(this, $9f21272e0549cf92$var$_clipEnded, false);
        }, 0);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_resetTracking, $9f21272e0549cf92$var$resetTracking).call(this);
    }
    ["time-change"](event) {
        if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_request1).looping) {
            event.stopImmediatePropagation();
            return;
        }
        let { waiting: waiting, played: played, clipEndTime: clipEndTime, realCurrentTime: realCurrentTime, currentTime: currentTime } = this.$state, newTime = event.detail, endTime = clipEndTime();
        realCurrentTime.set(newTime);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_updatePlayed, $9f21272e0549cf92$var$updatePlayed).call(this);
        waiting.set(false);
        for (const track of (0, $57dmi._)(this, $9f21272e0549cf92$var$_media4).textTracks)track[(0, $ihjXw.TextTrackSymbol).updateActiveCues](newTime, event);
        if (endTime > 0 && newTime >= endTime) {
            (0, $4vwVC._)(this, $9f21272e0549cf92$var$_clipEnded, true);
            this.dispatch("media-pause-request", {
                trigger: event
            });
        }
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_saveTime, $9f21272e0549cf92$var$saveTime).call(this);
        this.dispatch("time-update", {
            detail: {
                currentTime: currentTime(),
                played: played()
            },
            trigger: event
        });
    }
    ["audio-gain-change"](event) {
        const { storage: storage } = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media4), { canPlay: canPlay, audioGain: audioGain } = this.$state;
        audioGain.set(event.detail);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_satisfyRequest, $9f21272e0549cf92$var$satisfyRequest).call(this, "media-audio-gain-change-request", event);
        if (canPlay()) storage?.setAudioGain?.(audioGain());
    }
    ["volume-change"](event) {
        const { storage: storage } = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media4), { volume: volume, muted: muted, canPlay: canPlay } = this.$state, detail = event.detail;
        volume.set(detail.volume);
        muted.set(detail.muted || detail.volume === 0);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_satisfyRequest, $9f21272e0549cf92$var$satisfyRequest).call(this, "media-volume-change-request", event);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_satisfyRequest, $9f21272e0549cf92$var$satisfyRequest).call(this, detail.muted ? "media-mute-request" : "media-unmute-request", event);
        if (canPlay()) {
            storage?.setVolume?.(volume());
            storage?.setMuted?.(muted());
        }
    }
    ["seeked"](event) {
        const { seeking: seeking, currentTime: currentTime, realCurrentTime: realCurrentTime, paused: paused, seekableEnd: seekableEnd, ended: ended } = this.$state;
        if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_request1).seeking) {
            seeking.set(true);
            event.stopImmediatePropagation();
        } else if (seeking()) {
            const waitingEvent = (0, $57dmi._)(this, $9f21272e0549cf92$var$_trackedEvents).get("waiting");
            if (waitingEvent) event.triggers.add(waitingEvent);
            const seekingEvent = (0, $57dmi._)(this, $9f21272e0549cf92$var$_trackedEvents).get("seeking");
            if (seekingEvent && !event.triggers.has(seekingEvent)) event.triggers.add(seekingEvent);
            if (paused()) (0, $2u9SC._)(this, $9f21272e0549cf92$var$_stopWaiting, $9f21272e0549cf92$var$stopWaiting).call(this);
            seeking.set(false);
            realCurrentTime.set(event.detail);
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_satisfyRequest, $9f21272e0549cf92$var$satisfyRequest).call(this, "media-seek-request", event);
            const origin = event?.originEvent;
            if (origin?.isTrusted && !(origin instanceof MessageEvent) && !/seek/.test(origin.type)) this["started"](event);
        }
        if (Math.floor(currentTime()) !== Math.floor(seekableEnd())) ended.set(false);
        else this.end(event);
    }
    ["waiting"](event) {
        if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_firingWaiting) || (0, $57dmi._)(this, $9f21272e0549cf92$var$_request1).seeking) return;
        event.stopImmediatePropagation();
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_waitingTrigger, event);
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_fireWaiting).call(this);
    }
    ["end"](event) {
        const { loop: loop, ended: ended } = this.$state;
        if (!loop() && ended()) return;
        if (loop()) {
            setTimeout(()=>{
                requestAnimationFrame(()=>{
                    (0, $2u9SC._)(this, $9f21272e0549cf92$var$_resetPlaybackIfNeeded, $9f21272e0549cf92$var$resetPlaybackIfNeeded).call(this, event);
                    this.dispatch("media-loop-request", {
                        trigger: event
                    });
                });
            }, 10);
            return;
        }
        setTimeout(()=>(0, $2u9SC._)(this, $9f21272e0549cf92$var$_onEnded, $9f21272e0549cf92$var$onEnded).call(this, event), 0);
    }
    ["fullscreen-change"](event) {
        const isFullscreen = event.detail;
        this.$state.fullscreen.set(isFullscreen);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_satisfyRequest, $9f21272e0549cf92$var$satisfyRequest).call(this, isFullscreen ? "media-enter-fullscreen-request" : "media-exit-fullscreen-request", event);
    }
    ["fullscreen-error"](event) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_satisfyRequest, $9f21272e0549cf92$var$satisfyRequest).call(this, "media-enter-fullscreen-request", event);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_satisfyRequest, $9f21272e0549cf92$var$satisfyRequest).call(this, "media-exit-fullscreen-request", event);
    }
    ["orientation-change"](event) {
        const isLocked = event.detail.lock;
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_satisfyRequest, $9f21272e0549cf92$var$satisfyRequest).call(this, isLocked ? "media-orientation-lock-request" : "media-orientation-unlock-request", event);
    }
    ["picture-in-picture-change"](event) {
        const isPiP = event.detail;
        this.$state.pictureInPicture.set(isPiP);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_satisfyRequest, $9f21272e0549cf92$var$satisfyRequest).call(this, isPiP ? "media-enter-pip-request" : "media-exit-pip-request", event);
    }
    ["picture-in-picture-error"](event) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_satisfyRequest, $9f21272e0549cf92$var$satisfyRequest).call(this, "media-enter-pip-request", event);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_satisfyRequest, $9f21272e0549cf92$var$satisfyRequest).call(this, "media-exit-pip-request", event);
    }
    ["title-change"](event) {
        if (!event.trigger) return;
        event.stopImmediatePropagation();
        this.$state.inferredTitle.set(event.detail);
    }
    ["poster-change"](event) {
        if (!event.trigger) return;
        event.stopImmediatePropagation();
        this.$state.inferredPoster.set(event.detail);
    }
    constructor(request, media){
        super();
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_resumePlaybackOnConnect);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_pausePlaybackOnDisconnect);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_resetTracking);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_satisfyRequest);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_addTextTrackListeners);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_addQualityListeners);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_addAudioTrackListeners);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onTextTracksChange);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onTextTrackModeChange);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onAudioTracksChange);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onAudioTrackChange);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onQualitiesChange);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onQualityChange);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onAutoQualityChange);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchQualityResize);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_stopWatchingQualityResize);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onCanSetQualityChange);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchCanSetVolume);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onSourceQualitiesChange);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_resetMediaState);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onCanPlayDetail);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_resetPlaybackIfNeeded);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_updatePlayed);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onEndPrecisionChange);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_saveTime);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onEnded);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_stopWaiting);
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_request1, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_media4, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_trackedEvents, {
            writable: true,
            value: /* @__PURE__ */ new Map()
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_clipEnded, {
            writable: true,
            value: false
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_playedIntervals, {
            writable: true,
            value: []
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_playedInterval, {
            writable: true,
            value: [
                -1,
                -1
            ]
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_firingWaiting, {
            writable: true,
            value: false
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_waitingTrigger, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_isPlayingOnDisconnect, {
            writable: true,
            value: false
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_stopQualityResizeEffect, {
            writable: true,
            value: null
        });
        (0, $97zcJ._)(this, "seeking", (0, $8B3mG.functionThrottle)((event)=>{
            const { seeking: seeking, realCurrentTime: realCurrentTime, paused: paused } = this.$state;
            seeking.set(true);
            realCurrentTime.set(event.detail);
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_satisfyRequest, $9f21272e0549cf92$var$satisfyRequest).call(this, "media-seeking-request", event);
            if (paused()) {
                (0, $4vwVC._)(this, $9f21272e0549cf92$var$_waitingTrigger, event);
                (0, $57dmi._)(this, $9f21272e0549cf92$var$_fireWaiting).call(this);
            }
            (0, $4vwVC._)(this, $9f21272e0549cf92$var$_playedInterval, [
                -1,
                -1
            ]);
        }, 150, {
            leading: true
        }));
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_fireWaiting, {
            writable: true,
            value: (0, $8B3mG.functionDebounce)(()=>{
                if (!(0, $57dmi._)(this, $9f21272e0549cf92$var$_waitingTrigger)) return;
                (0, $4vwVC._)(this, $9f21272e0549cf92$var$_firingWaiting, true);
                const { waiting: waiting, playing: playing } = this.$state;
                waiting.set(true);
                playing.set(false);
                const event = this.createEvent("waiting", {
                    trigger: (0, $57dmi._)(this, $9f21272e0549cf92$var$_waitingTrigger)
                });
                (0, $57dmi._)(this, $9f21272e0549cf92$var$_trackedEvents).set("waiting", event);
                this.dispatch(event);
                (0, $4vwVC._)(this, $9f21272e0549cf92$var$_waitingTrigger, void 0);
                (0, $4vwVC._)(this, $9f21272e0549cf92$var$_firingWaiting, false);
            }, 300)
        });
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_request1, request);
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_media4, media);
    }
}
function $9f21272e0549cf92$var$resumePlaybackOnConnect() {
    if (!(0, $57dmi._)(this, $9f21272e0549cf92$var$_isPlayingOnDisconnect)) return;
    requestAnimationFrame(()=>{
        if (!this.scope) return;
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_media4).remote.play(new (0, $8B3mG.DOMEvent)("dom-connect"));
    });
    (0, $4vwVC._)(this, $9f21272e0549cf92$var$_isPlayingOnDisconnect, false);
}
function $9f21272e0549cf92$var$pausePlaybackOnDisconnect() {
    if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_isPlayingOnDisconnect)) return;
    (0, $4vwVC._)(this, $9f21272e0549cf92$var$_isPlayingOnDisconnect, !this.$state.paused());
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_media4).$provider()?.pause();
}
function $9f21272e0549cf92$var$resetTracking() {
    (0, $2u9SC._)(this, $9f21272e0549cf92$var$_stopWaiting, $9f21272e0549cf92$var$stopWaiting).call(this);
    (0, $4vwVC._)(this, $9f21272e0549cf92$var$_clipEnded, false);
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_request1).replaying = false;
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_request1).looping = false;
    (0, $4vwVC._)(this, $9f21272e0549cf92$var$_firingWaiting, false);
    (0, $4vwVC._)(this, $9f21272e0549cf92$var$_waitingTrigger, void 0);
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_trackedEvents).clear();
}
function $9f21272e0549cf92$var$satisfyRequest(request, event) {
    const requestEvent = (0, $57dmi._)(this, $9f21272e0549cf92$var$_request1).queue.serve(request);
    if (!requestEvent) return;
    event.request = requestEvent;
    event.triggers.add(requestEvent);
}
function $9f21272e0549cf92$var$addTextTrackListeners() {
    (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onTextTracksChange, $9f21272e0549cf92$var$onTextTracksChange).call(this);
    (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onTextTrackModeChange, $9f21272e0549cf92$var$onTextTrackModeChange).call(this);
    const textTracks = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media4).textTracks;
    new (0, $8B3mG.EventsController)(textTracks).add("add", (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onTextTracksChange, $9f21272e0549cf92$var$onTextTracksChange).bind(this)).add("remove", (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onTextTracksChange, $9f21272e0549cf92$var$onTextTracksChange).bind(this)).add("mode-change", (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onTextTrackModeChange, $9f21272e0549cf92$var$onTextTrackModeChange).bind(this));
}
function $9f21272e0549cf92$var$addQualityListeners() {
    const qualities = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media4).qualities;
    new (0, $8B3mG.EventsController)(qualities).add("add", (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onQualitiesChange, $9f21272e0549cf92$var$onQualitiesChange).bind(this)).add("remove", (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onQualitiesChange, $9f21272e0549cf92$var$onQualitiesChange).bind(this)).add("change", (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onQualityChange, $9f21272e0549cf92$var$onQualityChange).bind(this)).add("auto-change", (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onAutoQualityChange, $9f21272e0549cf92$var$onAutoQualityChange).bind(this)).add("readonly-change", (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onCanSetQualityChange, $9f21272e0549cf92$var$onCanSetQualityChange).bind(this));
}
function $9f21272e0549cf92$var$addAudioTrackListeners() {
    const audioTracks = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media4).audioTracks;
    new (0, $8B3mG.EventsController)(audioTracks).add("add", (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onAudioTracksChange, $9f21272e0549cf92$var$onAudioTracksChange).bind(this)).add("remove", (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onAudioTracksChange, $9f21272e0549cf92$var$onAudioTracksChange).bind(this)).add("change", (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onAudioTrackChange, $9f21272e0549cf92$var$onAudioTrackChange).bind(this));
}
function $9f21272e0549cf92$var$onTextTracksChange(event) {
    const { textTracks: textTracks } = this.$state;
    textTracks.set((0, $57dmi._)(this, $9f21272e0549cf92$var$_media4).textTracks.toArray());
    this.dispatch("text-tracks-change", {
        detail: textTracks(),
        trigger: event
    });
}
function $9f21272e0549cf92$var$onTextTrackModeChange(event) {
    if (event) (0, $2u9SC._)(this, $9f21272e0549cf92$var$_satisfyRequest, $9f21272e0549cf92$var$satisfyRequest).call(this, "media-text-track-change-request", event);
    const current = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media4).textTracks.selected, { textTrack: textTrack } = this.$state;
    if (textTrack() !== current) {
        textTrack.set(current);
        this.dispatch("text-track-change", {
            detail: current,
            trigger: event
        });
    }
}
function $9f21272e0549cf92$var$onAudioTracksChange(event) {
    const { audioTracks: audioTracks } = this.$state;
    audioTracks.set((0, $57dmi._)(this, $9f21272e0549cf92$var$_media4).audioTracks.toArray());
    this.dispatch("audio-tracks-change", {
        detail: audioTracks(),
        trigger: event
    });
}
function $9f21272e0549cf92$var$onAudioTrackChange(event) {
    const { audioTrack: audioTrack } = this.$state;
    audioTrack.set((0, $57dmi._)(this, $9f21272e0549cf92$var$_media4).audioTracks.selected);
    if (event) (0, $2u9SC._)(this, $9f21272e0549cf92$var$_satisfyRequest, $9f21272e0549cf92$var$satisfyRequest).call(this, "media-audio-track-change-request", event);
    this.dispatch("audio-track-change", {
        detail: audioTrack(),
        trigger: event
    });
}
function $9f21272e0549cf92$var$onQualitiesChange(event) {
    const { qualities: qualities } = this.$state;
    qualities.set((0, $57dmi._)(this, $9f21272e0549cf92$var$_media4).qualities.toArray());
    this.dispatch("qualities-change", {
        detail: qualities(),
        trigger: event
    });
}
function $9f21272e0549cf92$var$onQualityChange(event) {
    const { quality: quality } = this.$state;
    quality.set((0, $57dmi._)(this, $9f21272e0549cf92$var$_media4).qualities.selected);
    if (event) (0, $2u9SC._)(this, $9f21272e0549cf92$var$_satisfyRequest, $9f21272e0549cf92$var$satisfyRequest).call(this, "media-quality-change-request", event);
    this.dispatch("quality-change", {
        detail: quality(),
        trigger: event
    });
}
function $9f21272e0549cf92$var$onAutoQualityChange() {
    const { qualities: qualities } = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media4), isAuto = qualities.auto;
    this.$state.autoQuality.set(isAuto);
    if (!isAuto) (0, $2u9SC._)(this, $9f21272e0549cf92$var$_stopWatchingQualityResize, $9f21272e0549cf92$var$stopWatchingQualityResize).call(this);
}
function $9f21272e0549cf92$var$watchQualityResize() {
    (0, $2u9SC._)(this, $9f21272e0549cf92$var$_stopWatchingQualityResize, $9f21272e0549cf92$var$stopWatchingQualityResize).call(this);
    (0, $4vwVC._)(this, $9f21272e0549cf92$var$_stopQualityResizeEffect, (0, $8B3mG.effect)(()=>{
        const { qualities: qualities } = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media4), { mediaWidth: mediaWidth, mediaHeight: mediaHeight } = this.$state, w = mediaWidth(), h = mediaHeight();
        if (w === 0 || h === 0) return;
        let selectedQuality = null, minScore = Infinity;
        for (const quality of qualities){
            const score = Math.abs(quality.width - w) + Math.abs(quality.height - h);
            if (score < minScore) {
                minScore = score;
                selectedQuality = quality;
            }
        }
        if (selectedQuality) qualities[(0, $5UOkG.ListSymbol).select](selectedQuality, true, new (0, $8B3mG.DOMEvent)("resize", {
            detail: {
                width: w,
                height: h
            }
        }));
    }));
}
function $9f21272e0549cf92$var$stopWatchingQualityResize() {
    var _this, _this1, _ref;
    (_this = (0, $57dmi._)(_ref = _this1 = this, $9f21272e0549cf92$var$_stopQualityResizeEffect)) === null || _this === void 0 ? void 0 : _this.call(_this1);
    (0, $4vwVC._)(this, $9f21272e0549cf92$var$_stopQualityResizeEffect, null);
}
function $9f21272e0549cf92$var$onCanSetQualityChange() {
    this.$state.canSetQuality.set(!(0, $57dmi._)(this, $9f21272e0549cf92$var$_media4).qualities.readonly);
}
function $9f21272e0549cf92$var$watchCanSetVolume() {
    const { canSetVolume: canSetVolume, isGoogleCastConnected: isGoogleCastConnected } = this.$state;
    if (isGoogleCastConnected()) {
        canSetVolume.set(false);
        return;
    }
    (0, $8kkZn.canChangeVolume)().then(canSetVolume.set);
}
function $9f21272e0549cf92$var$onSourceQualitiesChange(prevSources, newSources, trigger) {
    let { qualities: qualities } = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media4), added = false, removed = false;
    for (const prevSrc of prevSources){
        if (!$9f21272e0549cf92$export$47b7db197eee1042(prevSrc)) continue;
        const exists = newSources.some((s)=>s.src === prevSrc.src);
        if (!exists) {
            const quality = qualities.getBySrc(prevSrc.src);
            if (quality) {
                qualities[(0, $5UOkG.ListSymbol).remove](quality, trigger);
                removed = true;
            }
        }
    }
    if (removed && !qualities.length) {
        this.$state.savedState.set(null);
        qualities[(0, $5UOkG.ListSymbol).reset](trigger);
    }
    for (const src of newSources){
        if (!$9f21272e0549cf92$export$47b7db197eee1042(src) || qualities.getBySrc(src.src)) continue;
        const quality = {
            id: src.id ?? src.height + "p",
            bitrate: null,
            codec: null,
            ...src,
            selected: false
        };
        qualities[(0, $5UOkG.ListSymbol).add](quality, trigger);
        added = true;
    }
    if (added && !qualities[(0, $eRuH7.QualitySymbol).enableAuto]) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchQualityResize, $9f21272e0549cf92$var$watchQualityResize).call(this);
        qualities[(0, $eRuH7.QualitySymbol).enableAuto] = (0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchQualityResize, $9f21272e0549cf92$var$watchQualityResize).bind(this);
        qualities[(0, $eRuH7.QualitySymbol).setAuto](true, trigger);
    }
}
function $9f21272e0549cf92$var$resetMediaState(event, isSourceQualityChange = false) {
    const { audioTracks: audioTracks, qualities: qualities } = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media4);
    if (!isSourceQualityChange) {
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_playedIntervals, []);
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_playedInterval, [
            -1,
            -1
        ]);
        audioTracks[(0, $5UOkG.ListSymbol).reset](event);
        qualities[(0, $5UOkG.ListSymbol).reset](event);
        $9f21272e0549cf92$export$274a38118ae9ffaf(this.$state, isSourceQualityChange);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_resetTracking, $9f21272e0549cf92$var$resetTracking).call(this);
        return;
    }
    $9f21272e0549cf92$export$274a38118ae9ffaf(this.$state, isSourceQualityChange);
    (0, $2u9SC._)(this, $9f21272e0549cf92$var$_resetTracking, $9f21272e0549cf92$var$resetTracking).call(this);
}
function $9f21272e0549cf92$var$onCanPlayDetail(detail) {
    const { seekable: seekable, buffered: buffered, intrinsicDuration: intrinsicDuration, canPlay: canPlay } = this.$state;
    canPlay.set(true);
    buffered.set(detail.buffered);
    seekable.set(detail.seekable);
    const seekableEnd = (0, $6ELNS.getTimeRangesEnd)(detail.seekable) ?? Infinity;
    intrinsicDuration.set(seekableEnd);
}
function $9f21272e0549cf92$var$resetPlaybackIfNeeded(trigger) {
    const provider = (0, $8B3mG.peek)((0, $57dmi._)(this, $9f21272e0549cf92$var$_media4).$provider);
    if (!provider) return;
    const { ended: ended, seekableStart: seekableStart, clipStartTime: clipStartTime, clipEndTime: clipEndTime, currentTime: currentTime, realCurrentTime: realCurrentTime, duration: duration } = this.$state;
    const shouldReset = ended() || realCurrentTime() < clipStartTime() || clipEndTime() > 0 && realCurrentTime() >= clipEndTime() || Math.abs(currentTime() - duration()) < 0.1;
    if (shouldReset) this.dispatch("media-seek-request", {
        detail: seekableStart(),
        trigger: trigger
    });
    return shouldReset;
}
function $9f21272e0549cf92$var$updatePlayed() {
    const { currentTime: currentTime, played: played, paused: paused } = this.$state;
    if (paused()) return;
    (0, $4vwVC._)(this, $9f21272e0549cf92$var$_playedInterval, (0, $6ELNS.updateTimeIntervals)((0, $57dmi._)(this, $9f21272e0549cf92$var$_playedIntervals), (0, $57dmi._)(this, $9f21272e0549cf92$var$_playedInterval), currentTime()));
    played.set(new (0, $6ELNS.TimeRange)((0, $57dmi._)(this, $9f21272e0549cf92$var$_playedIntervals)));
}
function $9f21272e0549cf92$var$onEndPrecisionChange(trigger) {
    const { clipStartTime: clipStartTime, clipEndTime: clipEndTime, duration: duration } = this.$state, isClipped = clipStartTime() > 0 || clipEndTime() > 0;
    if (isClipped) return;
    this.handle(this.createEvent("time-change", {
        detail: duration(),
        trigger: trigger
    }));
}
function $9f21272e0549cf92$var$saveTime() {
    const { storage: storage } = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media4), { canPlay: canPlay, realCurrentTime: realCurrentTime } = this.$state;
    if (canPlay()) storage?.setTime?.(realCurrentTime());
}
function $9f21272e0549cf92$var$onEnded(event) {
    const { storage: storage } = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media4), { paused: paused, seeking: seeking, ended: ended, duration: duration } = this.$state;
    (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onEndPrecisionChange, $9f21272e0549cf92$var$onEndPrecisionChange).call(this, event);
    if (!paused()) this.dispatch("pause", {
        trigger: event
    });
    if (seeking()) this.dispatch("seeked", {
        detail: duration(),
        trigger: event
    });
    ended.set(true);
    (0, $2u9SC._)(this, $9f21272e0549cf92$var$_resetTracking, $9f21272e0549cf92$var$resetTracking).call(this);
    storage?.setTime?.(duration(), true);
    this.dispatch("ended", {
        trigger: event
    });
}
function $9f21272e0549cf92$var$stopWaiting() {
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_fireWaiting).cancel();
    this.$state.waiting.set(false);
}
var $9f21272e0549cf92$var$_init1 = /*#__PURE__*/ new WeakSet(), // Sync "provided" props with internal state. Provided props are used to differentiate from
// provider inferred values.
$9f21272e0549cf92$var$_watchProvidedTypes = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchLogLevel = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchMetadata = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchTitle = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchAutoplay = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchLoop = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchControls1 = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchPoster = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchCrossOrigin = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchDuration = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchPlaysInline = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchClipStartTime = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchClipEndTime = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchLive = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchLiveTolerance = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchLiveEdge = /*#__PURE__*/ new WeakSet();
class $9f21272e0549cf92$var$MediaStateSync extends $9f21272e0549cf92$var$MediaPlayerController {
    onSetup() {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_init1, $9f21272e0549cf92$var$init1).call(this);
        const effects = [
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchMetadata, $9f21272e0549cf92$var$watchMetadata),
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchAutoplay, $9f21272e0549cf92$var$watchAutoplay),
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchClipStartTime, $9f21272e0549cf92$var$watchClipStartTime),
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchClipEndTime, $9f21272e0549cf92$var$watchClipEndTime),
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchControls1, $9f21272e0549cf92$var$watchControls1),
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchCrossOrigin, $9f21272e0549cf92$var$watchCrossOrigin),
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchDuration, $9f21272e0549cf92$var$watchDuration),
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchLive, $9f21272e0549cf92$var$watchLive),
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchLiveEdge, $9f21272e0549cf92$var$watchLiveEdge),
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchLiveTolerance, $9f21272e0549cf92$var$watchLiveTolerance),
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchLoop, $9f21272e0549cf92$var$watchLoop),
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchPlaysInline, $9f21272e0549cf92$var$watchPlaysInline),
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchPoster, $9f21272e0549cf92$var$watchPoster),
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchProvidedTypes, $9f21272e0549cf92$var$watchProvidedTypes),
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchTitle, $9f21272e0549cf92$var$watchTitle)
        ];
        for (const callback of effects)(0, $8B3mG.effect)(callback.bind(this));
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_init1);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchProvidedTypes);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchLogLevel);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchMetadata);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchTitle);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchAutoplay);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchLoop);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchControls1);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchPoster);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchCrossOrigin);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchDuration);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchPlaysInline);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchClipStartTime);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchClipEndTime);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchLive);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchLiveTolerance);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchLiveEdge);
    }
}
function $9f21272e0549cf92$var$init1() {
    const providedProps = {
        duration: "providedDuration",
        loop: "providedLoop",
        poster: "providedPoster",
        streamType: "providedStreamType",
        title: "providedTitle",
        viewType: "providedViewType"
    };
    const skip = /* @__PURE__ */ new Set([
        "currentTime",
        "paused",
        "playbackRate",
        "volume"
    ]);
    for (const prop of Object.keys(this.$props)){
        if (skip.has(prop)) continue;
        this.$state[providedProps[prop] ?? prop]?.set(this.$props[prop]());
    }
    this.$state.muted.set(this.$props.muted() || this.$props.volume() === 0);
}
function $9f21272e0549cf92$var$watchProvidedTypes() {
    const { viewType: viewType, streamType: streamType, title: title, poster: poster, loop: loop } = this.$props, $state = this.$state;
    $state.providedPoster.set(poster());
    $state.providedStreamType.set(streamType());
    $state.providedViewType.set(viewType());
    $state.providedTitle.set(title());
    $state.providedLoop.set(loop());
}
function $9f21272e0549cf92$var$watchLogLevel() {
    return;
}
function $9f21272e0549cf92$var$watchMetadata() {
    const { artist: artist, artwork: artwork } = this.$props;
    this.$state.artist.set(artist());
    this.$state.artwork.set(artwork());
}
function $9f21272e0549cf92$var$watchTitle() {
    const { title: title } = this.$state;
    this.dispatch("title-change", {
        detail: title()
    });
}
function $9f21272e0549cf92$var$watchAutoplay() {
    const autoPlay = this.$props.autoPlay() || this.$props.autoplay();
    this.$state.autoPlay.set(autoPlay);
    this.dispatch("auto-play-change", {
        detail: autoPlay
    });
}
function $9f21272e0549cf92$var$watchLoop() {
    const loop = this.$state.loop();
    this.dispatch("loop-change", {
        detail: loop
    });
}
function $9f21272e0549cf92$var$watchControls1() {
    const controls = this.$props.controls();
    this.$state.controls.set(controls);
}
function $9f21272e0549cf92$var$watchPoster() {
    const { poster: poster } = this.$state;
    this.dispatch("poster-change", {
        detail: poster()
    });
}
function $9f21272e0549cf92$var$watchCrossOrigin() {
    const crossOrigin = this.$props.crossOrigin() ?? this.$props.crossorigin(), value = crossOrigin === true ? "" : crossOrigin;
    this.$state.crossOrigin.set(value);
}
function $9f21272e0549cf92$var$watchDuration() {
    const { duration: duration } = this.$props;
    this.dispatch("media-duration-change-request", {
        detail: duration()
    });
}
function $9f21272e0549cf92$var$watchPlaysInline() {
    const inline = this.$props.playsInline() || this.$props.playsinline();
    this.$state.playsInline.set(inline);
    this.dispatch("plays-inline-change", {
        detail: inline
    });
}
function $9f21272e0549cf92$var$watchClipStartTime() {
    const { clipStartTime: clipStartTime } = this.$props;
    this.dispatch("media-clip-start-change-request", {
        detail: clipStartTime()
    });
}
function $9f21272e0549cf92$var$watchClipEndTime() {
    const { clipEndTime: clipEndTime } = this.$props;
    this.dispatch("media-clip-end-change-request", {
        detail: clipEndTime()
    });
}
function $9f21272e0549cf92$var$watchLive() {
    this.dispatch("live-change", {
        detail: this.$state.live()
    });
}
function $9f21272e0549cf92$var$watchLiveTolerance() {
    this.$state.liveEdgeTolerance.set(this.$props.liveEdgeTolerance());
    this.$state.minLiveDVRWindow.set(this.$props.minLiveDVRWindow());
}
function $9f21272e0549cf92$var$watchLiveEdge() {
    this.dispatch("live-edge-change", {
        detail: this.$state.liveEdge()
    });
}
const $9f21272e0549cf92$var$actions = [
    "play",
    "pause",
    "seekforward",
    "seekbackward",
    "seekto"
];
var $9f21272e0549cf92$var$_onDisconnect2 = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onMetadataChange = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onPlaybackStateChange = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_handleAction = /*#__PURE__*/ new WeakSet();
class $9f21272e0549cf92$var$NavigatorMediaSession extends $9f21272e0549cf92$var$MediaPlayerController {
    onConnect() {
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_onMetadataChange, $9f21272e0549cf92$var$onMetadataChange).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_onPlaybackStateChange, $9f21272e0549cf92$var$onPlaybackStateChange).bind(this));
        const handleAction1 = (0, $2u9SC._)(this, $9f21272e0549cf92$var$_handleAction, $9f21272e0549cf92$var$handleAction).bind(this);
        for (const action of $9f21272e0549cf92$var$actions)navigator.mediaSession.setActionHandler(action, handleAction1);
        (0, $8B3mG.onDispose)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_onDisconnect2, $9f21272e0549cf92$var$onDisconnect2).bind(this));
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onDisconnect2);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onMetadataChange);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onPlaybackStateChange);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_handleAction);
    }
}
function $9f21272e0549cf92$var$onDisconnect2() {
    for (const action of $9f21272e0549cf92$var$actions)navigator.mediaSession.setActionHandler(action, null);
}
function $9f21272e0549cf92$var$onMetadataChange() {
    const { title: title, artist: artist, artwork: artwork, poster: poster } = this.$state;
    navigator.mediaSession.metadata = new MediaMetadata({
        title: title(),
        artist: artist(),
        artwork: artwork() ?? [
            {
                src: poster()
            }
        ]
    });
}
function $9f21272e0549cf92$var$onPlaybackStateChange() {
    const { canPlay: canPlay, paused: paused } = this.$state;
    navigator.mediaSession.playbackState = !canPlay() ? "none" : paused() ? "paused" : "playing";
}
function $9f21272e0549cf92$var$handleAction(details) {
    const trigger = new (0, $8B3mG.DOMEvent)(`media-session-action`, {
        detail: details
    });
    switch(details.action){
        case "play":
            this.dispatch("media-play-request", {
                trigger: trigger
            });
            break;
        case "pause":
            this.dispatch("media-pause-request", {
                trigger: trigger
            });
            break;
        case "seekto":
        case "seekforward":
        case "seekbackward":
            this.dispatch("media-seek-request", {
                detail: (0, $8B3mG.isNumber)(details.seekTime) ? details.seekTime : this.$state.currentTime() + (details.seekOffset ?? (details.action === "seekforward" ? 10 : -10)),
                trigger: trigger
            });
            break;
    }
}
var $9f21272e0549cf92$var$_media5 = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_stateMgr1 = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_requestMgr = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_provider = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_props = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_skipTitleUpdate = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_watchTitle1 = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchOrientation = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchCanPlay = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_setupMediaAttributes = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onFindPlayer = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onResize = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onPointerChange = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchPaused1 = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_queuePausedUpdate = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchMuted = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_queueMutedUpdate = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchCurrentTime = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_queueCurrentTimeUpdate = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchVolume = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_queueVolumeUpdate = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchPlaybackRate = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_queuePlaybackRateUpdate = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchPlaysInline1 = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_queuePlaysInlineUpdate = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_watchStorage = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_computeMediaId = /*#__PURE__*/ new WeakSet();
class $9f21272e0549cf92$export$5884da26c35dd546 extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_setupMediaAttributes, $9f21272e0549cf92$var$setupMediaAttributes).call(this);
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchCanPlay, $9f21272e0549cf92$var$watchCanPlay).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchMuted, $9f21272e0549cf92$var$watchMuted).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchPaused1, $9f21272e0549cf92$var$watchPaused1).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchVolume, $9f21272e0549cf92$var$watchVolume).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchCurrentTime, $9f21272e0549cf92$var$watchCurrentTime).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchPlaysInline1, $9f21272e0549cf92$var$watchPlaysInline1).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchPlaybackRate, $9f21272e0549cf92$var$watchPlaybackRate).bind(this));
    }
    onAttach(el) {
        el.setAttribute("data-media-player", "");
        (0, $ciZW6.setAttributeIfEmpty)(el, "tabindex", "0");
        (0, $ciZW6.setAttributeIfEmpty)(el, "role", "region");
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchStorage, $9f21272e0549cf92$var$watchStorage).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchTitle1, $9f21272e0549cf92$var$watchTitle1).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_watchOrientation, $9f21272e0549cf92$var$watchOrientation).bind(this));
        (0, $8B3mG.listenEvent)(el, "find-media-player", (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onFindPlayer, $9f21272e0549cf92$var$onFindPlayer).bind(this));
    }
    onConnect(el) {
        if (0, $8kkZn.IS_IPHONE) (0, $8B3mG.setAttribute)(el, "data-iphone", "");
        const pointerQuery = window.matchMedia("(pointer: coarse)");
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onPointerChange, $9f21272e0549cf92$var$onPointerChange).call(this, pointerQuery);
        pointerQuery.onchange = (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onPointerChange, $9f21272e0549cf92$var$onPointerChange).bind(this);
        const resize = new ResizeObserver((0, $8B3mG.animationFrameThrottle)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_onResize, $9f21272e0549cf92$var$onResize).bind(this)));
        resize.observe(el);
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_onResize, $9f21272e0549cf92$var$onResize).bind(this));
        this.dispatch("media-player-connect", {
            detail: this,
            bubbles: true,
            composed: true
        });
        (0, $8B3mG.onDispose)(()=>{
            resize.disconnect();
            pointerQuery.onchange = null;
        });
    }
    onDestroy() {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_media5).player = null;
        this.canPlayQueue.reset();
    }
    /**
   * The current media provider.
   */ get provider() {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_provider);
    }
    /**
   * Media controls settings.
   */ get controls() {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_requestMgr).controls;
    }
    set controls(controls) {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_props).controls.set(controls);
    }
    /**
   * The title of the current media.
   */ get title() {
        return (0, $8B3mG.peek)(this.$state.title);
    }
    set title(newTitle) {
        if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_skipTitleUpdate)) {
            (0, $4vwVC._)(this, $9f21272e0549cf92$var$_skipTitleUpdate, false);
            return;
        }
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_props).title.set(newTitle);
    }
    /**
   * A list of all `VideoQuality` objects representing the set of available video renditions.
   *
   * @see {@link https://vidstack.io/docs/player/api/video-quality}
   */ get qualities() {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_media5).qualities;
    }
    /**
   * A list of all `AudioTrack` objects representing the set of available audio tracks.
   *
   * @see {@link https://vidstack.io/docs/player/api/audio-tracks}
   */ get audioTracks() {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_media5).audioTracks;
    }
    /**
   * A list of all `TextTrack` objects representing the set of available text tracks.
   *
   * @see {@link https://vidstack.io/docs/player/api/text-tracks}
   */ get textTracks() {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_media5).textTracks;
    }
    /**
   * Contains text renderers which are responsible for loading, parsing, and rendering text
   * tracks.
   */ get textRenderers() {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_media5).textRenderers;
    }
    get duration() {
        return this.$state.duration();
    }
    set duration(duration) {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_props).duration.set(duration);
    }
    get paused() {
        return (0, $8B3mG.peek)(this.$state.paused);
    }
    set paused(paused) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_queuePausedUpdate, $9f21272e0549cf92$var$queuePausedUpdate).call(this, paused);
    }
    get muted() {
        return (0, $8B3mG.peek)(this.$state.muted);
    }
    set muted(muted) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_queueMutedUpdate, $9f21272e0549cf92$var$queueMutedUpdate).call(this, muted);
    }
    get currentTime() {
        return (0, $8B3mG.peek)(this.$state.currentTime);
    }
    set currentTime(time) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_queueCurrentTimeUpdate, $9f21272e0549cf92$var$queueCurrentTimeUpdate).call(this, time);
    }
    get volume() {
        return (0, $8B3mG.peek)(this.$state.volume);
    }
    set volume(volume) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_queueVolumeUpdate, $9f21272e0549cf92$var$queueVolumeUpdate).call(this, volume);
    }
    get playbackRate() {
        return (0, $8B3mG.peek)(this.$state.playbackRate);
    }
    set playbackRate(rate) {
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_queuePlaybackRateUpdate, $9f21272e0549cf92$var$queuePlaybackRateUpdate).call(this, rate);
    }
    /**
   * Begins/resumes playback of the media. If this method is called programmatically before the
   * user has interacted with the player, the promise may be rejected subject to the browser's
   * autoplay policies. This method will throw if called before media is ready for playback.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/play}
   */ async play(trigger) {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_requestMgr).play(trigger);
    }
    /**
   * Pauses playback of the media. This method will throw if called before media is ready for
   * playback.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/pause}
   */ async pause(trigger) {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_requestMgr).pause(trigger);
    }
    /**
   * Attempts to display the player in fullscreen. The promise will resolve if successful, and
   * reject if not. This method will throw if any fullscreen API is _not_ currently available.
   *
   * @see {@link https://vidstack.io/docs/player/api/fullscreen}
   */ async enterFullscreen(target, trigger) {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_requestMgr).enterFullscreen(target, trigger);
    }
    /**
   * Attempts to display the player inline by exiting fullscreen. This method will throw if any
   * fullscreen API is _not_ currently available.
   *
   * @see {@link https://vidstack.io/docs/player/api/fullscreen}
   */ async exitFullscreen(target, trigger) {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_requestMgr).exitFullscreen(target, trigger);
    }
    /**
   * Attempts to display the player in picture-in-picture mode. This method will throw if PIP is
   * not supported. This method will also return a `PictureInPictureWindow` if the current
   * provider supports it.
   *
   * @see {@link https://vidstack.io/docs/player/api/picture-in-picture}
   */ enterPictureInPicture(trigger) {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_requestMgr).enterPictureInPicture(trigger);
    }
    /**
   * Attempts to display the player in inline by exiting picture-in-picture mode. This method
   * will throw if not supported.
   *
   * @see {@link https://vidstack.io/docs/player/api/picture-in-picture}
   */ exitPictureInPicture(trigger) {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_requestMgr).exitPictureInPicture(trigger);
    }
    /**
   * Sets the current time to the live edge (i.e., `duration`). This is a no-op for non-live
   * streams and will throw if called before media is ready for playback.
   *
   * @see {@link https://vidstack.io/docs/player/api/live}
   */ seekToLiveEdge(trigger) {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_requestMgr).seekToLiveEdge(trigger);
    }
    /**
   * Called when media can begin loading. Calling this method will trigger the initial provider
   * loading process. Calling it more than once has no effect.
   *
   * @see {@link https://vidstack.io/docs/player/core-concepts/loading#load-strategies}
   */ startLoading(trigger) {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_media5).notify("can-load", void 0, trigger);
    }
    /**
   * Called when the poster image can begin loading. Calling it more than once has no effect.
   *
   * @see {@link https://vidstack.io/docs/player/core-concepts/loading#load-strategies}
   */ startLoadingPoster(trigger) {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_media5).notify("can-load-poster", void 0, trigger);
    }
    /**
   * Request Apple AirPlay picker to open.
   */ requestAirPlay(trigger) {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_requestMgr).requestAirPlay(trigger);
    }
    /**
   * Request Google Cast device picker to open. The Google Cast framework will be loaded if it
   * hasn't yet.
   */ requestGoogleCast(trigger) {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_requestMgr).requestGoogleCast(trigger);
    }
    /**
   * Set the audio gain, amplifying volume and enabling a maximum volume above 100%.
   *
   * @see {@link https://vidstack.io/docs/player/api/audio-gain}
   */ setAudioGain(gain, trigger) {
        return (0, $57dmi._)(this, $9f21272e0549cf92$var$_requestMgr).setAudioGain(gain, trigger);
    }
    destroy() {
        super.destroy();
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_media5).remote.setPlayer(null);
        this.dispatch("destroy");
    }
    constructor(){
        super();
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_provider, {
            get: $9f21272e0549cf92$var$get_provider,
            set: void 0
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_props, {
            get: $9f21272e0549cf92$var$get_props,
            set: void 0
        });
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchTitle1);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchOrientation);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchCanPlay);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_setupMediaAttributes);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onFindPlayer);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onResize);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onPointerChange);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchPaused1);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_queuePausedUpdate);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchMuted);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_queueMutedUpdate);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchCurrentTime);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_queueCurrentTimeUpdate);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchVolume);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_queueVolumeUpdate);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchPlaybackRate);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_queuePlaybackRateUpdate);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchPlaysInline1);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_queuePlaysInlineUpdate);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_watchStorage);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_computeMediaId);
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_media5, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_stateMgr1, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_requestMgr, {
            writable: true,
            value: void 0
        });
        (0, $97zcJ._)(this, "canPlayQueue", new $9f21272e0549cf92$var$RequestQueue());
        (0, $97zcJ._)(this, "remoteControl", void 0);
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_skipTitleUpdate, {
            writable: true,
            value: false
        });
        /**
   * Controls the screen orientation of the current browser window and dispatches orientation
   * change events on the player.
   */ (0, $97zcJ._)(this, "orientation", void 0);
        new $9f21272e0549cf92$var$MediaStateSync();
        const context = {
            player: this,
            qualities: new $9f21272e0549cf92$export$626acecd0d09262e(),
            audioTracks: new $9f21272e0549cf92$export$9e769fc3da26d171(),
            storage: null,
            $provider: (0, $8B3mG.signal)(null),
            $providerSetup: (0, $8B3mG.signal)(false),
            $props: this.$props,
            $state: this.$state
        };
        context.remote = this.remoteControl = new $9f21272e0549cf92$export$a1bb2a710f7468(void 0);
        context.remote.setPlayer(this);
        context.textTracks = new $9f21272e0549cf92$export$cfd404c5b64818f();
        context.textTracks[(0, $ihjXw.TextTrackSymbol).crossOrigin] = this.$state.crossOrigin;
        context.textRenderers = new $9f21272e0549cf92$export$474cc74c966eef64(context);
        context.ariaKeys = {};
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_media5, context);
        (0, $8B3mG.provideContext)((0, $6KfMo.mediaContext), context);
        this.orientation = new $9f21272e0549cf92$export$e048a67118113df5();
        new (0, $jWjYZ.FocusVisibleController)();
        new $9f21272e0549cf92$var$MediaKeyboardController(context);
        const request = new $9f21272e0549cf92$var$MediaRequestContext();
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_stateMgr1, new $9f21272e0549cf92$var$MediaStateManager(request, context));
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_requestMgr, new $9f21272e0549cf92$var$MediaRequestManager((0, $57dmi._)(this, $9f21272e0549cf92$var$_stateMgr1), request, context));
        context.delegate = new $9f21272e0549cf92$var$MediaPlayerDelegate((0, $57dmi._)(this, $9f21272e0549cf92$var$_stateMgr1).handle.bind((0, $57dmi._)(this, $9f21272e0549cf92$var$_stateMgr1)), context);
        context.notify = context.delegate.notify.bind(context.delegate);
        if (typeof navigator !== "undefined" && "mediaSession" in navigator) new $9f21272e0549cf92$var$NavigatorMediaSession();
        new $9f21272e0549cf92$var$MediaLoadController("load", this.startLoading.bind(this));
        new $9f21272e0549cf92$var$MediaLoadController("posterLoad", this.startLoadingPoster.bind(this));
    }
}
(0, $97zcJ._)($9f21272e0549cf92$export$5884da26c35dd546, "props", $9f21272e0549cf92$var$mediaPlayerProps);
(0, $97zcJ._)($9f21272e0549cf92$export$5884da26c35dd546, "state", $9f21272e0549cf92$export$8cef61637918b288);
function $9f21272e0549cf92$var$get_provider() {
    return (0, $57dmi._)(this, $9f21272e0549cf92$var$_media5).$provider();
}
function $9f21272e0549cf92$var$get_props() {
    return this.$props;
}
function $9f21272e0549cf92$var$watchTitle1() {
    const el = this.$el, { title: title, live: live, viewType: viewType, providedTitle: providedTitle } = this.$state, isLive = live(), type = (0, $8B3mG.uppercaseFirstChar)(viewType()), typeText = type !== "Unknown" ? `${isLive ? "Live " : ""}${type}` : isLive ? "Live" : "Media", currentTitle = title();
    (0, $8B3mG.setAttribute)(this.el, "aria-label", `${typeText} Player` + (currentTitle ? ` - ${currentTitle}` : ""));
    if (el?.hasAttribute("title")) {
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_skipTitleUpdate, true);
        el?.removeAttribute("title");
    }
}
function $9f21272e0549cf92$var$watchOrientation() {
    const orientation = this.orientation.landscape ? "landscape" : "portrait";
    this.$state.orientation.set(orientation);
    (0, $8B3mG.setAttribute)(this.el, "data-orientation", orientation);
    (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onResize, $9f21272e0549cf92$var$onResize).call(this);
}
function $9f21272e0549cf92$var$watchCanPlay() {
    if (this.$state.canPlay() && (0, $57dmi._)(this, $9f21272e0549cf92$var$_provider)) this.canPlayQueue.start();
    else this.canPlayQueue.stop();
}
function $9f21272e0549cf92$var$setupMediaAttributes() {
    if ($9f21272e0549cf92$export$5884da26c35dd546[$9f21272e0549cf92$var$MEDIA_ATTRIBUTES]) {
        this.setAttributes($9f21272e0549cf92$export$5884da26c35dd546[$9f21272e0549cf92$var$MEDIA_ATTRIBUTES]);
        return;
    }
    const $attrs = {
        "data-load": function() {
            return this.$props.load();
        },
        "data-captions": function() {
            const track = this.$state.textTrack();
            return !!track && (0, $ihjXw.isTrackCaptionKind)(track);
        },
        "data-ios-controls": function() {
            return this.$state.iOSControls();
        },
        "data-controls": function() {
            return this.controls.showing;
        },
        "data-buffering": function() {
            const { canLoad: canLoad, canPlay: canPlay, waiting: waiting } = this.$state;
            return canLoad() && (!canPlay() || waiting());
        },
        "data-error": function() {
            const { error: error } = this.$state;
            return !!error();
        },
        "data-autoplay-error": function() {
            const { autoPlayError: autoPlayError } = this.$state;
            return !!autoPlayError();
        }
    };
    const alias = {
        autoPlay: "autoplay",
        canAirPlay: "can-airplay",
        canPictureInPicture: "can-pip",
        pictureInPicture: "pip",
        playsInline: "playsinline",
        remotePlaybackState: "remote-state",
        remotePlaybackType: "remote-type",
        isAirPlayConnected: "airplay",
        isGoogleCastConnected: "google-cast"
    };
    for (const prop2 of $9f21272e0549cf92$var$mediaAttributes){
        const attrName = "data-" + (alias[prop2] ?? (0, $8B3mG.camelToKebabCase)(prop2));
        $attrs[attrName] = function() {
            return this.$state[prop2]();
        };
    }
    delete $attrs.title;
    $9f21272e0549cf92$export$5884da26c35dd546[$9f21272e0549cf92$var$MEDIA_ATTRIBUTES] = $attrs;
    this.setAttributes($attrs);
}
function $9f21272e0549cf92$var$onFindPlayer(event) {
    event.detail(this);
}
function $9f21272e0549cf92$var$onResize() {
    if (!this.el) return;
    const width = this.el.clientWidth, height = this.el.clientHeight;
    this.$state.width.set(width);
    this.$state.height.set(height);
    (0, $8B3mG.setStyle)(this.el, "--player-width", width + "px");
    (0, $8B3mG.setStyle)(this.el, "--player-height", height + "px");
}
function $9f21272e0549cf92$var$onPointerChange(queryList) {
    const pointer = queryList.matches ? "coarse" : "fine";
    (0, $8B3mG.setAttribute)(this.el, "data-pointer", pointer);
    this.$state.pointer.set(pointer);
    (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onResize, $9f21272e0549cf92$var$onResize).call(this);
}
function $9f21272e0549cf92$var$watchPaused1() {
    (0, $2u9SC._)(this, $9f21272e0549cf92$var$_queuePausedUpdate, $9f21272e0549cf92$var$queuePausedUpdate).call(this, this.$props.paused());
}
function $9f21272e0549cf92$var$queuePausedUpdate(paused) {
    if (paused) this.canPlayQueue.enqueue("paused", ()=>(0, $57dmi._)(this, $9f21272e0549cf92$var$_requestMgr).pause());
    else this.canPlayQueue.enqueue("paused", ()=>(0, $57dmi._)(this, $9f21272e0549cf92$var$_requestMgr).play());
}
function $9f21272e0549cf92$var$watchMuted() {
    (0, $2u9SC._)(this, $9f21272e0549cf92$var$_queueMutedUpdate, $9f21272e0549cf92$var$queueMutedUpdate).call(this, this.$props.muted());
}
function $9f21272e0549cf92$var$queueMutedUpdate(muted) {
    this.canPlayQueue.enqueue("muted", ()=>{
        if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_provider)) (0, $57dmi._)(this, $9f21272e0549cf92$var$_provider).setMuted(muted);
    });
}
function $9f21272e0549cf92$var$watchCurrentTime() {
    (0, $2u9SC._)(this, $9f21272e0549cf92$var$_queueCurrentTimeUpdate, $9f21272e0549cf92$var$queueCurrentTimeUpdate).call(this, this.$props.currentTime());
}
function $9f21272e0549cf92$var$queueCurrentTimeUpdate(time) {
    this.canPlayQueue.enqueue("currentTime", ()=>{
        const { currentTime: currentTime, clipStartTime: clipStartTime, seekableStart: seekableStart, seekableEnd: seekableEnd } = this.$state;
        if (time === (0, $8B3mG.peek)(currentTime)) return;
        (0, $8B3mG.peek)(()=>{
            if (!(0, $57dmi._)(this, $9f21272e0549cf92$var$_provider)) return;
            const clippedTime = time + clipStartTime(), isStart = Math.floor(time) === Math.floor(seekableStart()), isEnd = Math.floor(clippedTime) === Math.floor(seekableEnd()), boundTime = isStart ? seekableStart() : isEnd ? seekableEnd() : Math.min(Math.max(seekableStart() + 0.1, clippedTime), seekableEnd() - 0.1);
            if (Number.isFinite(boundTime)) (0, $57dmi._)(this, $9f21272e0549cf92$var$_provider).setCurrentTime(boundTime);
        });
    });
}
function $9f21272e0549cf92$var$watchVolume() {
    (0, $2u9SC._)(this, $9f21272e0549cf92$var$_queueVolumeUpdate, $9f21272e0549cf92$var$queueVolumeUpdate).call(this, this.$props.volume());
}
function $9f21272e0549cf92$var$queueVolumeUpdate(volume) {
    const clampedVolume = (0, $hzYuC.clampNumber)(0, volume, 1);
    this.canPlayQueue.enqueue("volume", ()=>{
        if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_provider)) (0, $57dmi._)(this, $9f21272e0549cf92$var$_provider).setVolume(clampedVolume);
    });
}
function $9f21272e0549cf92$var$watchPlaybackRate() {
    (0, $2u9SC._)(this, $9f21272e0549cf92$var$_queuePlaybackRateUpdate, $9f21272e0549cf92$var$queuePlaybackRateUpdate).call(this, this.$props.playbackRate());
}
function $9f21272e0549cf92$var$queuePlaybackRateUpdate(rate) {
    this.canPlayQueue.enqueue("rate", ()=>{
        if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_provider)) (0, $57dmi._)(this, $9f21272e0549cf92$var$_provider).setPlaybackRate?.(rate);
    });
}
function $9f21272e0549cf92$var$watchPlaysInline1() {
    (0, $2u9SC._)(this, $9f21272e0549cf92$var$_queuePlaysInlineUpdate, $9f21272e0549cf92$var$queuePlaysInlineUpdate).call(this, this.$props.playsInline());
}
function $9f21272e0549cf92$var$queuePlaysInlineUpdate(inline) {
    this.canPlayQueue.enqueue("playsinline", ()=>{
        if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_provider)) (0, $57dmi._)(this, $9f21272e0549cf92$var$_provider).setPlaysInline?.(inline);
    });
}
function $9f21272e0549cf92$var$watchStorage() {
    let storageValue = this.$props.storage(), storage = (0, $8B3mG.isString)(storageValue) ? new $9f21272e0549cf92$export$87c11e4c5bbdf503() : storageValue;
    if (storage?.onChange) {
        const { source: source } = this.$state, playerId = (0, $8B3mG.isString)(storageValue) ? storageValue : this.el?.id, mediaId = (0, $8B3mG.computed)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_computeMediaId, $9f21272e0549cf92$var$computeMediaId).bind(this));
        (0, $8B3mG.effect)(()=>storage.onChange(source(), mediaId(), playerId || void 0));
    }
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_media5).storage = storage;
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_media5).textTracks.setStorage(storage);
    (0, $8B3mG.onDispose)(()=>{
        storage?.onDestroy?.();
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_media5).storage = null;
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_media5).textTracks.setStorage(null);
    });
}
function $9f21272e0549cf92$var$computeMediaId() {
    const { clipStartTime: clipStartTime, clipEndTime: clipEndTime } = this.$props, { source: source } = this.$state, src = source();
    return src.src ? `${src.src}:${clipStartTime()}:${clipEndTime()}` : null;
}
const $9f21272e0549cf92$var$mediaplayer__proto = $9f21272e0549cf92$export$5884da26c35dd546.prototype;
(0, $8B3mG.prop)($9f21272e0549cf92$var$mediaplayer__proto, "canPlayQueue");
(0, $8B3mG.prop)($9f21272e0549cf92$var$mediaplayer__proto, "remoteControl");
(0, $8B3mG.prop)($9f21272e0549cf92$var$mediaplayer__proto, "provider");
(0, $8B3mG.prop)($9f21272e0549cf92$var$mediaplayer__proto, "controls");
(0, $8B3mG.prop)($9f21272e0549cf92$var$mediaplayer__proto, "orientation");
(0, $8B3mG.prop)($9f21272e0549cf92$var$mediaplayer__proto, "title");
(0, $8B3mG.prop)($9f21272e0549cf92$var$mediaplayer__proto, "qualities");
(0, $8B3mG.prop)($9f21272e0549cf92$var$mediaplayer__proto, "audioTracks");
(0, $8B3mG.prop)($9f21272e0549cf92$var$mediaplayer__proto, "textTracks");
(0, $8B3mG.prop)($9f21272e0549cf92$var$mediaplayer__proto, "textRenderers");
(0, $8B3mG.prop)($9f21272e0549cf92$var$mediaplayer__proto, "duration");
(0, $8B3mG.prop)($9f21272e0549cf92$var$mediaplayer__proto, "paused");
(0, $8B3mG.prop)($9f21272e0549cf92$var$mediaplayer__proto, "muted");
(0, $8B3mG.prop)($9f21272e0549cf92$var$mediaplayer__proto, "currentTime");
(0, $8B3mG.prop)($9f21272e0549cf92$var$mediaplayer__proto, "volume");
(0, $8B3mG.prop)($9f21272e0549cf92$var$mediaplayer__proto, "playbackRate");
(0, $8B3mG.method)($9f21272e0549cf92$var$mediaplayer__proto, "play");
(0, $8B3mG.method)($9f21272e0549cf92$var$mediaplayer__proto, "pause");
(0, $8B3mG.method)($9f21272e0549cf92$var$mediaplayer__proto, "enterFullscreen");
(0, $8B3mG.method)($9f21272e0549cf92$var$mediaplayer__proto, "exitFullscreen");
(0, $8B3mG.method)($9f21272e0549cf92$var$mediaplayer__proto, "enterPictureInPicture");
(0, $8B3mG.method)($9f21272e0549cf92$var$mediaplayer__proto, "exitPictureInPicture");
(0, $8B3mG.method)($9f21272e0549cf92$var$mediaplayer__proto, "seekToLiveEdge");
(0, $8B3mG.method)($9f21272e0549cf92$var$mediaplayer__proto, "startLoading");
(0, $8B3mG.method)($9f21272e0549cf92$var$mediaplayer__proto, "startLoadingPoster");
(0, $8B3mG.method)($9f21272e0549cf92$var$mediaplayer__proto, "requestAirPlay");
(0, $8B3mG.method)($9f21272e0549cf92$var$mediaplayer__proto, "requestGoogleCast");
(0, $8B3mG.method)($9f21272e0549cf92$var$mediaplayer__proto, "setAudioGain");
function $9f21272e0549cf92$var$resolveStreamTypeFromDASHManifest(manifestSrc, requestInit) {
    return fetch(manifestSrc, requestInit).then((res)=>res.text()).then((manifest)=>{
        return /type="static"/.test(manifest) ? "on-demand" : "live";
    });
}
function $9f21272e0549cf92$var$resolveStreamTypeFromHLSManifest(manifestSrc, requestInit) {
    return fetch(manifestSrc, requestInit).then((res)=>res.text()).then((manifest)=>{
        const renditionURI = $9f21272e0549cf92$var$resolveHLSRenditionURI(manifest);
        if (renditionURI) return $9f21272e0549cf92$var$resolveStreamTypeFromHLSManifest(/^https?:/.test(renditionURI) ? renditionURI : new URL(renditionURI, manifestSrc).href, requestInit);
        const streamType = /EXT-X-PLAYLIST-TYPE:\s*VOD/.test(manifest) ? "on-demand" : "live";
        if (streamType === "live" && $9f21272e0549cf92$var$resolveTargetDuration(manifest) >= 10 && (/#EXT-X-DVR-ENABLED:\s*true/.test(manifest) || manifest.includes("#EXT-X-DISCONTINUITY"))) return "live:dvr";
        return streamType;
    });
}
function $9f21272e0549cf92$var$resolveHLSRenditionURI(manifest) {
    const matches = manifest.match(/#EXT-X-STREAM-INF:[^\n]+(\n[^\n]+)*/g);
    return matches ? matches[0].split("\n")[1].trim() : null;
}
function $9f21272e0549cf92$var$resolveTargetDuration(manifest) {
    const lines = manifest.split("\n");
    for (const line of lines)if (line.startsWith("#EXT-X-TARGETDURATION")) {
        const duration = parseFloat(line.split(":")[1]);
        if (!isNaN(duration)) return duration;
    }
    return -1;
}
const $9f21272e0549cf92$var$sourceTypes = /* @__PURE__ */ new Map();
var $9f21272e0549cf92$var$_initialize = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_loaders = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_domSources = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_media6 = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_loader = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_onSourcesChange = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onSourceChange = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_findNewSource = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_notifySourceChange = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_notifyLoaderChange = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onSetup = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onLoadSource = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onLoadPoster = /*#__PURE__*/ new WeakSet();
class $9f21272e0549cf92$var$SourceSelection {
    connect() {
        const loader = (0, $57dmi._)(this, $9f21272e0549cf92$var$_loader).call(this);
        if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_initialize)) {
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_notifySourceChange, $9f21272e0549cf92$var$notifySourceChange).call(this, (0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).$state.source(), loader);
            (0, $2u9SC._)(this, $9f21272e0549cf92$var$_notifyLoaderChange, $9f21272e0549cf92$var$notifyLoaderChange).call(this, loader);
            (0, $4vwVC._)(this, $9f21272e0549cf92$var$_initialize, false);
        }
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_onSourcesChange, $9f21272e0549cf92$var$onSourcesChange).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_onSourceChange, $9f21272e0549cf92$var$onSourceChange).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_onSetup, $9f21272e0549cf92$var$onSetup).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_onLoadSource, $9f21272e0549cf92$var$onLoadSource).bind(this));
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_onLoadPoster, $9f21272e0549cf92$var$onLoadPoster).bind(this));
    }
    constructor(domSources, media, loader, customLoaders = []){
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onSourcesChange);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onSourceChange);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_findNewSource);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_notifySourceChange);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_notifyLoaderChange);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onSetup);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onLoadSource);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onLoadPoster);
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_initialize, {
            writable: true,
            value: false
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_loaders, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_domSources, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_media6, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_loader, {
            writable: true,
            value: void 0
        });
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_domSources, domSources);
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_media6, media);
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_loader, loader);
        const DASH_LOADER = new $9f21272e0549cf92$export$9b47f20788fea2cb(), HLS_LOADER = new $9f21272e0549cf92$export$86f4eeacf5114a41(), VIDEO_LOADER = new $9f21272e0549cf92$export$f5ae8460d3ff5e74(), AUDIO_LOADER = new $9f21272e0549cf92$export$3b6ee65e53e21943(), YOUTUBE_LOADER = new $9f21272e0549cf92$export$142512714515b064(), VIMEO_LOADER = new $9f21272e0549cf92$export$6812dd811fbf981(), EMBED_LOADERS = [
            YOUTUBE_LOADER,
            VIMEO_LOADER
        ];
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_loaders, (0, $8B3mG.computed)(()=>{
            const remoteLoader = media.$state.remotePlaybackLoader();
            const loaders = media.$props.preferNativeHLS() ? [
                VIDEO_LOADER,
                AUDIO_LOADER,
                DASH_LOADER,
                HLS_LOADER,
                ...EMBED_LOADERS,
                ...customLoaders
            ] : [
                HLS_LOADER,
                VIDEO_LOADER,
                AUDIO_LOADER,
                DASH_LOADER,
                ...EMBED_LOADERS,
                ...customLoaders
            ];
            return remoteLoader ? [
                remoteLoader,
                ...loaders
            ] : loaders;
        }));
        const { $state: $state } = media;
        $state.sources.set($9f21272e0549cf92$var$normalizeSrc(media.$props.src()));
        for (const src of $state.sources()){
            const loader2 = (0, $57dmi._)(this, $9f21272e0549cf92$var$_loaders).call(this).find((loader3)=>loader3.canPlay(src));
            if (!loader2) continue;
            const mediaType = loader2.mediaType(src);
            media.$state.source.set(src);
            media.$state.mediaType.set(mediaType);
            media.$state.inferredViewType.set(mediaType);
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_loader).set(loader2);
            (0, $4vwVC._)(this, $9f21272e0549cf92$var$_initialize, true);
            break;
        }
    }
}
function $9f21272e0549cf92$var$onSourcesChange() {
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).notify("sources-change", [
        ...$9f21272e0549cf92$var$normalizeSrc((0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).$props.src()),
        ...(0, $57dmi._)(this, $9f21272e0549cf92$var$_domSources).call(this)
    ]);
}
function $9f21272e0549cf92$var$onSourceChange() {
    const { $state: $state } = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media6);
    const sources = $state.sources(), currentSource = (0, $8B3mG.peek)($state.source), newSource = (0, $2u9SC._)(this, $9f21272e0549cf92$var$_findNewSource, $9f21272e0549cf92$var$findNewSource).call(this, currentSource, sources), noMatch = sources[0]?.src && !newSource.src && !newSource.type;
    if (noMatch) {
        const { crossOrigin: crossOrigin } = $state, credentials = (0, $dLb9W.getRequestCredentials)(crossOrigin()), abort = new AbortController();
        Promise.all(sources.map((source)=>(0, $8B3mG.isString)(source.src) && source.type === "?" ? fetch(source.src, {
                method: "HEAD",
                credentials: credentials,
                signal: abort.signal
            }).then((res)=>{
                source.type = res.headers.get("content-type") || "??";
                $9f21272e0549cf92$var$sourceTypes.set(source.src, source.type);
                return source;
            }).catch(()=>source) : source)).then((sources2)=>{
            if (abort.signal.aborted) return;
            const newSource2 = (0, $2u9SC._)(this, $9f21272e0549cf92$var$_findNewSource, $9f21272e0549cf92$var$findNewSource).call(this, (0, $8B3mG.peek)($state.source), sources2);
            (0, $8B3mG.tick)();
            if (!newSource2.src) (0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).notify("error", {
                message: "Failed to load resource.",
                code: 4
            });
        });
        return ()=>abort.abort();
    }
    (0, $8B3mG.tick)();
}
function $9f21272e0549cf92$var$findNewSource(currentSource, sources) {
    let newSource = {
        src: "",
        type: ""
    }, newLoader = null, triggerEvent = new (0, $8B3mG.DOMEvent)("sources-change", {
        detail: {
            sources: sources
        }
    }), loaders = (0, $57dmi._)(this, $9f21272e0549cf92$var$_loaders).call(this), { started: started, paused: paused, currentTime: currentTime, quality: quality, savedState: savedState } = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).$state;
    for (const src of sources){
        const loader = loaders.find((loader2)=>loader2.canPlay(src));
        if (loader) {
            newSource = src;
            newLoader = loader;
            break;
        }
    }
    if ($9f21272e0549cf92$export$47b7db197eee1042(newSource)) {
        const currentQuality = quality(), sourceQuality = sources.find((s)=>s.src === currentQuality?.src);
        if ((0, $8B3mG.peek)(started)) savedState.set({
            paused: (0, $8B3mG.peek)(paused),
            currentTime: (0, $8B3mG.peek)(currentTime)
        });
        else savedState.set(null);
        if (sourceQuality) {
            newSource = sourceQuality;
            triggerEvent = new (0, $8B3mG.DOMEvent)("quality-change", {
                detail: {
                    quality: currentQuality
                }
            });
        }
    }
    if (!$9f21272e0549cf92$var$isSameSrc(currentSource, newSource)) (0, $2u9SC._)(this, $9f21272e0549cf92$var$_notifySourceChange, $9f21272e0549cf92$var$notifySourceChange).call(this, newSource, newLoader, triggerEvent);
    if (newLoader !== (0, $8B3mG.peek)((0, $57dmi._)(this, $9f21272e0549cf92$var$_loader))) (0, $2u9SC._)(this, $9f21272e0549cf92$var$_notifyLoaderChange, $9f21272e0549cf92$var$notifyLoaderChange).call(this, newLoader, triggerEvent);
    return newSource;
}
function $9f21272e0549cf92$var$notifySourceChange(src, loader, trigger) {
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).notify("source-change", src, trigger);
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).notify("media-type-change", loader?.mediaType(src) || "unknown", trigger);
}
function $9f21272e0549cf92$var$notifyLoaderChange(loader, trigger) {
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).$providerSetup.set(false);
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).notify("provider-change", null, trigger);
    loader && (0, $8B3mG.peek)(()=>loader.preconnect?.((0, $57dmi._)(this, $9f21272e0549cf92$var$_media6)));
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_loader).set(loader);
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).notify("provider-loader-change", loader, trigger);
}
function $9f21272e0549cf92$var$onSetup() {
    const provider = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).$provider();
    if (!provider || (0, $8B3mG.peek)((0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).$providerSetup)) return;
    if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).$state.canLoad()) {
        (0, $8B3mG.scoped)(()=>provider.setup(), provider.scope);
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).$providerSetup.set(true);
        return;
    }
    (0, $8B3mG.peek)(()=>provider.preconnect?.());
}
function $9f21272e0549cf92$var$onLoadSource() {
    if (!(0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).$providerSetup()) return;
    const provider = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).$provider(), source = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).$state.source(), crossOrigin = (0, $8B3mG.peek)((0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).$state.crossOrigin), preferNativeHLS = (0, $8B3mG.peek)((0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).$props.preferNativeHLS);
    if ($9f21272e0549cf92$var$isSameSrc(provider?.currentSrc, source)) return;
    if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).$state.canLoad()) {
        const abort = new AbortController();
        if ((0, $8kkZn.isHLSSrc)(source)) {
            if (preferNativeHLS || !(0, $8kkZn.isHLSSupported)()) $9f21272e0549cf92$var$resolveStreamTypeFromHLSManifest(source.src, {
                credentials: (0, $dLb9W.getRequestCredentials)(crossOrigin),
                signal: abort.signal
            }).then((streamType)=>{
                (0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).notify("stream-type-change", streamType);
            }).catch((0, $8B3mG.noop));
        } else if ((0, $8kkZn.isDASHSrc)(source)) $9f21272e0549cf92$var$resolveStreamTypeFromDASHManifest(source.src, {
            credentials: (0, $dLb9W.getRequestCredentials)(crossOrigin),
            signal: abort.signal
        }).then((streamType)=>{
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).notify("stream-type-change", streamType);
        }).catch((0, $8B3mG.noop));
        else (0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).notify("stream-type-change", "on-demand");
        (0, $8B3mG.peek)(()=>{
            const preload = (0, $8B3mG.peek)((0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).$state.preload);
            return provider?.loadSource(source, preload).catch((error)=>{});
        });
        return ()=>abort.abort();
    }
    try {
        (0, $8B3mG.isString)(source.src) && (0, $dLb9W.preconnect)(new URL(source.src).origin);
    } catch (error) {}
}
function $9f21272e0549cf92$var$onLoadPoster() {
    const loader = (0, $57dmi._)(this, $9f21272e0549cf92$var$_loader).call(this), { providedPoster: providedPoster, source: source, canLoadPoster: canLoadPoster } = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).$state;
    if (!loader || !loader.loadPoster || !source() || !canLoadPoster() || providedPoster()) return;
    const abort = new AbortController(), trigger = new (0, $8B3mG.DOMEvent)("source-change", {
        detail: source
    });
    loader.loadPoster(source(), (0, $57dmi._)(this, $9f21272e0549cf92$var$_media6), abort).then((url)=>{
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).notify("poster-change", url || "", trigger);
    }).catch(()=>{
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_media6).notify("poster-change", "", trigger);
    });
    return ()=>{
        abort.abort();
    };
}
function $9f21272e0549cf92$var$normalizeSrc(src) {
    return ((0, $8B3mG.isArray)(src) ? src : [
        src
    ]).map((src2)=>{
        if ((0, $8B3mG.isString)(src2)) return {
            src: src2,
            type: $9f21272e0549cf92$var$inferType(src2)
        };
        else return {
            ...src2,
            type: $9f21272e0549cf92$var$inferType(src2.src, src2.type)
        };
    });
}
function $9f21272e0549cf92$var$inferType(src, type) {
    if ((0, $8B3mG.isString)(type) && type.length) return type;
    else if ((0, $8B3mG.isString)(src) && $9f21272e0549cf92$var$sourceTypes.has(src)) return $9f21272e0549cf92$var$sourceTypes.get(src);
    else if (!type && (0, $8kkZn.isHLSSrc)({
        src: src,
        type: ""
    })) return "application/x-mpegurl";
    else if (!type && (0, $8kkZn.isDASHSrc)({
        src: src,
        type: ""
    })) return "application/dash+xml";
    else if (!(0, $8B3mG.isString)(src) || src.startsWith("blob:")) return "video/object";
    else if (src.includes("youtube") || src.includes("youtu.be")) return "video/youtube";
    else if (src.includes("vimeo") && !src.includes("progressive_redirect") && !src.includes(".m3u8")) return "video/vimeo";
    return "?";
}
function $9f21272e0549cf92$var$isSameSrc(a, b) {
    return a?.src === b?.src && a?.type === b?.type;
}
var $9f21272e0549cf92$var$_domTracks = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_media7 = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_prevTracks = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_onTracksChange = /*#__PURE__*/ new WeakSet();
class $9f21272e0549cf92$var$Tracks {
    constructor(domTracks, media){
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onTracksChange);
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_domTracks, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_media7, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_prevTracks, {
            writable: true,
            value: []
        });
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_domTracks, domTracks);
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_media7, media);
        (0, $8B3mG.effect)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_onTracksChange, $9f21272e0549cf92$var$onTracksChange).bind(this));
    }
}
function $9f21272e0549cf92$var$onTracksChange() {
    const newTracks = (0, $57dmi._)(this, $9f21272e0549cf92$var$_domTracks).call(this);
    for (const oldTrack of (0, $57dmi._)(this, $9f21272e0549cf92$var$_prevTracks))if (!newTracks.some((t)=>t.id === oldTrack.id)) {
        const track = oldTrack.id && (0, $57dmi._)(this, $9f21272e0549cf92$var$_media7).textTracks.getById(oldTrack.id);
        if (track) (0, $57dmi._)(this, $9f21272e0549cf92$var$_media7).textTracks.remove(track);
    }
    for (const newTrack of newTracks){
        const id = newTrack.id || (0, $ihjXw.TextTrack).createId(newTrack);
        if (!(0, $57dmi._)(this, $9f21272e0549cf92$var$_media7).textTracks.getById(id)) {
            newTrack.id = id;
            (0, $57dmi._)(this, $9f21272e0549cf92$var$_media7).textTracks.add(newTrack);
        }
    }
    (0, $4vwVC._)(this, $9f21272e0549cf92$var$_prevTracks, newTracks);
}
var $9f21272e0549cf92$var$_media8 = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_sources = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_domSources1 = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_domTracks1 = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_loader1 = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_loadRafId = /*#__PURE__*/ new WeakMap(), $9f21272e0549cf92$var$_runLoader = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_destroyProvider = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onResize1 = /*#__PURE__*/ new WeakSet(), $9f21272e0549cf92$var$_onMutation = /*#__PURE__*/ new WeakSet();
class $9f21272e0549cf92$export$57164260bc1f1218 extends (0, $8B3mG.Component) {
    onSetup() {
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_media8, (0, $6KfMo.useMediaContext)());
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_sources, new $9f21272e0549cf92$var$SourceSelection((0, $57dmi._)(this, $9f21272e0549cf92$var$_domSources1), (0, $57dmi._)(this, $9f21272e0549cf92$var$_media8), this.$state.loader, this.$props.loaders()));
    }
    onAttach(el) {
        el.setAttribute("data-media-provider", "");
    }
    onConnect(el) {
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_sources).connect();
        new $9f21272e0549cf92$var$Tracks((0, $57dmi._)(this, $9f21272e0549cf92$var$_domTracks1), (0, $57dmi._)(this, $9f21272e0549cf92$var$_media8));
        const resize = new ResizeObserver((0, $8B3mG.animationFrameThrottle)((0, $2u9SC._)(this, $9f21272e0549cf92$var$_onResize1, $9f21272e0549cf92$var$onResize1).bind(this)));
        resize.observe(el);
        const mutations = new MutationObserver((0, $2u9SC._)(this, $9f21272e0549cf92$var$_onMutation, $9f21272e0549cf92$var$onMutation).bind(this));
        mutations.observe(el, {
            attributes: true,
            childList: true
        });
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onResize1, $9f21272e0549cf92$var$onResize1).call(this);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_onMutation, $9f21272e0549cf92$var$onMutation).call(this);
        (0, $8B3mG.onDispose)(()=>{
            resize.disconnect();
            mutations.disconnect();
        });
    }
    load(target) {
        target?.setAttribute("aria-hidden", "true");
        window.cancelAnimationFrame((0, $57dmi._)(this, $9f21272e0549cf92$var$_loadRafId));
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_loadRafId, requestAnimationFrame(()=>(0, $2u9SC._)(this, $9f21272e0549cf92$var$_runLoader, $9f21272e0549cf92$var$runLoader).call(this, target)));
        (0, $8B3mG.onDispose)(()=>{
            window.cancelAnimationFrame((0, $57dmi._)(this, $9f21272e0549cf92$var$_loadRafId));
        });
    }
    onDestroy() {
        (0, $4vwVC._)(this, $9f21272e0549cf92$var$_loader1, null);
        (0, $2u9SC._)(this, $9f21272e0549cf92$var$_destroyProvider, $9f21272e0549cf92$var$destroyProvider).call(this);
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_runLoader);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_destroyProvider);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onResize1);
        (0, $9P4tJ._)(this, $9f21272e0549cf92$var$_onMutation);
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_media8, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_sources, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_domSources1, {
            writable: true,
            value: (0, $8B3mG.signal)([])
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_domTracks1, {
            writable: true,
            value: (0, $8B3mG.signal)([])
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_loader1, {
            writable: true,
            value: null
        });
        (0, $fhH8k._)(this, $9f21272e0549cf92$var$_loadRafId, {
            writable: true,
            value: -1
        });
    }
}
(0, $97zcJ._)($9f21272e0549cf92$export$57164260bc1f1218, "props", {
    loaders: []
});
(0, $97zcJ._)($9f21272e0549cf92$export$57164260bc1f1218, "state", new (0, $8B3mG.State)({
    loader: null
}));
function $9f21272e0549cf92$var$runLoader(target) {
    if (!this.scope) return;
    const loader = this.$state.loader(), { $provider: $provider } = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media8);
    if ((0, $57dmi._)(this, $9f21272e0549cf92$var$_loader1) === loader && loader?.target === target && (0, $8B3mG.peek)($provider)) return;
    (0, $2u9SC._)(this, $9f21272e0549cf92$var$_destroyProvider, $9f21272e0549cf92$var$destroyProvider).call(this);
    (0, $4vwVC._)(this, $9f21272e0549cf92$var$_loader1, loader);
    if (loader) loader.target = target || null;
    if (!loader || !target) return;
    loader.load((0, $57dmi._)(this, $9f21272e0549cf92$var$_media8)).then((provider)=>{
        if (!this.scope) return;
        if ((0, $8B3mG.peek)(this.$state.loader) !== loader) return;
        (0, $57dmi._)(this, $9f21272e0549cf92$var$_media8).notify("provider-change", provider);
    });
}
function $9f21272e0549cf92$var$destroyProvider() {
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_media8)?.notify("provider-change", null);
}
function $9f21272e0549cf92$var$onResize1() {
    if (!this.el) return;
    const { player: player, $state: $state } = (0, $57dmi._)(this, $9f21272e0549cf92$var$_media8), width = this.el.offsetWidth, height = this.el.offsetHeight;
    if (!player) return;
    $state.mediaWidth.set(width);
    $state.mediaHeight.set(height);
    if (player.el) {
        (0, $8B3mG.setStyle)(player.el, "--media-width", width + "px");
        (0, $8B3mG.setStyle)(player.el, "--media-height", height + "px");
    }
}
function $9f21272e0549cf92$var$onMutation() {
    const sources = [], tracks = [], children = this.el.children;
    for (const el of children){
        if (el.hasAttribute("data-vds")) continue;
        if (el instanceof HTMLSourceElement) {
            const src = {
                id: el.id,
                src: el.src,
                type: el.type
            };
            for (const prop of [
                "id",
                "src",
                "width",
                "height",
                "bitrate",
                "codec"
            ]){
                const value = el.getAttribute(`data-${prop}`);
                if ((0, $8B3mG.isString)(value)) src[prop] = /id|src|codec/.test(prop) ? value : Number(value);
            }
            sources.push(src);
        } else if (el instanceof HTMLTrackElement) {
            const track = {
                src: el.src,
                kind: el.track.kind,
                language: el.srclang,
                label: el.label,
                default: el.default,
                type: el.getAttribute("data-type")
            };
            tracks.push({
                id: el.id || (0, $ihjXw.TextTrack).createId(track),
                ...track
            });
        }
    }
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_domSources1).set(sources);
    (0, $57dmi._)(this, $9f21272e0549cf92$var$_domTracks1).set(tracks);
    (0, $8B3mG.tick)();
}
const $9f21272e0549cf92$var$mediaprovider__proto = $9f21272e0549cf92$export$57164260bc1f1218.prototype;
(0, $8B3mG.method)($9f21272e0549cf92$var$mediaprovider__proto, "load");



var $6KfMo = parcelRequire("6KfMo");
var $8502c5b0a560f535$var$_Host, $8502c5b0a560f535$var$_media = /*#__PURE__*/ new WeakMap(), $8502c5b0a560f535$var$_target = /*#__PURE__*/ new WeakMap(), $8502c5b0a560f535$var$_blocker = /*#__PURE__*/ new WeakMap(), $8502c5b0a560f535$var$_createAudio = /*#__PURE__*/ new WeakSet(), $8502c5b0a560f535$var$_createVideo = /*#__PURE__*/ new WeakSet(), $8502c5b0a560f535$var$_createIFrame = /*#__PURE__*/ new WeakSet(), $8502c5b0a560f535$var$_createGoogleCastContainer = /*#__PURE__*/ new WeakSet();
class $8502c5b0a560f535$export$9869c89149fd8504 extends ($8502c5b0a560f535$var$_Host = (0, $8B3mG.Host)(HTMLElement, (0, $9f21272e0549cf92$export$57164260bc1f1218))) {
    onSetup() {
        (0, $4vwVC._)(this, $8502c5b0a560f535$var$_media, (0, $6KfMo.useMediaContext)());
        this.setAttribute("keep-alive", "");
    }
    onDestroy() {
        (0, $57dmi._)(this, $8502c5b0a560f535$var$_blocker)?.remove();
        (0, $4vwVC._)(this, $8502c5b0a560f535$var$_blocker, null);
        (0, $57dmi._)(this, $8502c5b0a560f535$var$_target)?.remove();
        (0, $4vwVC._)(this, $8502c5b0a560f535$var$_target, null);
    }
    onConnect() {
        (0, $8B3mG.effect)(()=>{
            const loader = this.$state.loader(), isYouTubeEmbed = loader?.name === "youtube", isVimeoEmbed = loader?.name === "vimeo", isEmbed = isYouTubeEmbed || isVimeoEmbed, isGoogleCast = loader?.name === "google-cast";
            const target = loader ? isGoogleCast ? (0, $2u9SC._)(this, $8502c5b0a560f535$var$_createGoogleCastContainer, $8502c5b0a560f535$var$createGoogleCastContainer).call(this) : isEmbed ? (0, $2u9SC._)(this, $8502c5b0a560f535$var$_createIFrame, $8502c5b0a560f535$var$createIFrame).call(this) : loader.mediaType() === "audio" ? (0, $2u9SC._)(this, $8502c5b0a560f535$var$_createAudio, $8502c5b0a560f535$var$createAudio).call(this) : (0, $2u9SC._)(this, $8502c5b0a560f535$var$_createVideo, $8502c5b0a560f535$var$createVideo).call(this) : null;
            if ((0, $57dmi._)(this, $8502c5b0a560f535$var$_target) !== target) {
                const parent = (0, $57dmi._)(this, $8502c5b0a560f535$var$_target)?.parentElement ?? this;
                (0, $57dmi._)(this, $8502c5b0a560f535$var$_target)?.remove();
                (0, $4vwVC._)(this, $8502c5b0a560f535$var$_target, target);
                if (target) parent.prepend(target);
                if (isEmbed && target) (0, $8B3mG.effect)(()=>{
                    const { nativeControls: nativeControls, viewType: viewType } = (0, $57dmi._)(this, $8502c5b0a560f535$var$_media).$state, showNativeControls = nativeControls(), isAudioView = viewType() === "audio", showBlocker = !showNativeControls && !isAudioView;
                    if (showBlocker) {
                        (0, $4vwVC._)(this, $8502c5b0a560f535$var$_blocker, this.querySelector(".vds-blocker"));
                        if (!(0, $57dmi._)(this, $8502c5b0a560f535$var$_blocker)) {
                            (0, $4vwVC._)(this, $8502c5b0a560f535$var$_blocker, document.createElement("div"));
                            (0, $57dmi._)(this, $8502c5b0a560f535$var$_blocker).classList.add("vds-blocker");
                            target.after((0, $57dmi._)(this, $8502c5b0a560f535$var$_blocker));
                        }
                    } else {
                        (0, $57dmi._)(this, $8502c5b0a560f535$var$_blocker)?.remove();
                        (0, $4vwVC._)(this, $8502c5b0a560f535$var$_blocker, null);
                    }
                    (0, $8B3mG.setAttribute)(target, "data-no-controls", !showNativeControls);
                });
            }
            if (isYouTubeEmbed) target?.classList.add("vds-youtube");
            else if (isVimeoEmbed) target?.classList.add("vds-vimeo");
            if (!isEmbed) {
                (0, $57dmi._)(this, $8502c5b0a560f535$var$_blocker)?.remove();
                (0, $4vwVC._)(this, $8502c5b0a560f535$var$_blocker, null);
            }
            this.load(target);
        });
    }
    constructor(...args){
        super(...args);
        (0, $9P4tJ._)(this, $8502c5b0a560f535$var$_createAudio);
        (0, $9P4tJ._)(this, $8502c5b0a560f535$var$_createVideo);
        (0, $9P4tJ._)(this, $8502c5b0a560f535$var$_createIFrame);
        (0, $9P4tJ._)(this, $8502c5b0a560f535$var$_createGoogleCastContainer);
        (0, $fhH8k._)(this, $8502c5b0a560f535$var$_media, {
            writable: true,
            value: void 0
        });
        (0, $fhH8k._)(this, $8502c5b0a560f535$var$_target, {
            writable: true,
            value: null
        });
        (0, $fhH8k._)(this, $8502c5b0a560f535$var$_blocker, {
            writable: true,
            value: null
        });
    }
}
(0, $97zcJ._)($8502c5b0a560f535$export$9869c89149fd8504, "tagName", "media-provider");
function $8502c5b0a560f535$var$createAudio() {
    const audio = (0, $57dmi._)(this, $8502c5b0a560f535$var$_target) instanceof HTMLAudioElement ? (0, $57dmi._)(this, $8502c5b0a560f535$var$_target) : document.createElement("audio");
    const { controls: controls, crossOrigin: crossOrigin } = (0, $57dmi._)(this, $8502c5b0a560f535$var$_media).$state;
    (0, $8B3mG.effect)(()=>{
        (0, $8B3mG.setAttribute)(audio, "controls", controls());
        (0, $8B3mG.setAttribute)(audio, "crossorigin", crossOrigin());
    });
    return audio;
}
function $8502c5b0a560f535$var$createVideo() {
    const video = (0, $57dmi._)(this, $8502c5b0a560f535$var$_target) instanceof HTMLVideoElement ? (0, $57dmi._)(this, $8502c5b0a560f535$var$_target) : document.createElement("video");
    const { crossOrigin: crossOrigin, poster: poster, nativeControls: nativeControls } = (0, $57dmi._)(this, $8502c5b0a560f535$var$_media).$state, $controls = (0, $8B3mG.computed)(()=>nativeControls() ? "true" : null), $poster = (0, $8B3mG.computed)(()=>poster() && nativeControls() ? poster() : null);
    (0, $8B3mG.effect)(()=>{
        (0, $8B3mG.setAttribute)(video, "controls", $controls());
        (0, $8B3mG.setAttribute)(video, "crossorigin", crossOrigin());
        (0, $8B3mG.setAttribute)(video, "poster", $poster());
    });
    return video;
}
function $8502c5b0a560f535$var$createIFrame() {
    const iframe = (0, $57dmi._)(this, $8502c5b0a560f535$var$_target) instanceof HTMLIFrameElement ? (0, $57dmi._)(this, $8502c5b0a560f535$var$_target) : document.createElement("iframe"), { nativeControls: nativeControls } = (0, $57dmi._)(this, $8502c5b0a560f535$var$_media).$state;
    (0, $8B3mG.effect)(()=>(0, $8B3mG.setAttribute)(iframe, "tabindex", !nativeControls() ? -1 : null));
    return iframe;
}

function $8502c5b0a560f535$var$createGoogleCastContainer() {
    if ((0, $57dmi._)(this, $8502c5b0a560f535$var$_target)?.classList.contains("vds-google-cast")) return (0, $57dmi._)(this, $8502c5b0a560f535$var$_target);
    const container = document.createElement("div");
    container.classList.add("vds-google-cast");
    (parcelRequire("6Ro0y")).then(({ insertContent: insertContent })=>{
        insertContent(container, (0, $57dmi._)(this, $8502c5b0a560f535$var$_media).$state);
    });
    return container;
}
var $8502c5b0a560f535$var$_Host1;
class $8502c5b0a560f535$export$88a20905a1e223a4 extends ($8502c5b0a560f535$var$_Host1 = (0, $8B3mG.Host)(HTMLElement, (0, $9f21272e0549cf92$export$5884da26c35dd546))) {
}
(0, $97zcJ._)($8502c5b0a560f535$export$88a20905a1e223a4, "tagName", "media-player");
(0, $97zcJ._)($8502c5b0a560f535$export$88a20905a1e223a4, "attrs", {
    autoPlay: "autoplay",
    crossOrigin: "crossorigin",
    playsInline: "playsinline",
    preferNativeHLS: "prefer-native-hls",
    minLiveDVRWindow: "min-live-dvr-window"
});
















(0, $8B3mG.defineCustomElement)((0, $8502c5b0a560f535$export$88a20905a1e223a4));
(0, $8B3mG.defineCustomElement)((0, $8502c5b0a560f535$export$9869c89149fd8504));


parcelRequire("4cwBt");
parcelRequire("begiE");
/**
 * Swiper 11.1.9
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2024 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: July 31, 2024
 */ /**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $46341108e5b8fdcb$var$isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function $46341108e5b8fdcb$var$extend(target, src) {
    if (target === void 0) target = {};
    if (src === void 0) src = {};
    Object.keys(src).forEach((key)=>{
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if ($46341108e5b8fdcb$var$isObject(src[key]) && $46341108e5b8fdcb$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $46341108e5b8fdcb$var$extend(target[key], src[key]);
    });
}
const $46341108e5b8fdcb$var$ssrDocument = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ""
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function $46341108e5b8fdcb$export$39b482c5e57630a8() {
    const doc = typeof document !== "undefined" ? document : {};
    $46341108e5b8fdcb$var$extend(doc, $46341108e5b8fdcb$var$ssrDocument);
    return doc;
}
const $46341108e5b8fdcb$var$ssrWindow = {
    document: $46341108e5b8fdcb$var$ssrDocument,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return "";
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    }
};
function $46341108e5b8fdcb$export$407448d2b89b1813() {
    const win = typeof window !== "undefined" ? window : {};
    $46341108e5b8fdcb$var$extend(win, $46341108e5b8fdcb$var$ssrWindow);
    return win;
}



function $2c77a2a8fab70b7a$export$23f2a1d2818174ef(classes) {
    if (classes === void 0) classes = "";
    return classes.trim().split(" ").filter((c)=>!!c.trim());
}
function $2c77a2a8fab70b7a$export$d141bba7fdc215a3(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $2c77a2a8fab70b7a$export$7ccc53e8f1e7dfc5(callback, delay) {
    if (delay === void 0) delay = 0;
    return setTimeout(callback, delay);
}
function $2c77a2a8fab70b7a$export$4368d992c4eafac0() {
    return Date.now();
}
function $2c77a2a8fab70b7a$var$getComputedStyle(el) {
    const window1 = (0, $46341108e5b8fdcb$export$407448d2b89b1813)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $2c77a2a8fab70b7a$export$35e795649ee09318(el, axis) {
    if (axis === void 0) axis = "x";
    const window1 = (0, $46341108e5b8fdcb$export$407448d2b89b1813)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $2c77a2a8fab70b7a$var$getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(",").length > 6) curTransform = curTransform.split(", ").map((a)=>a.replace(",", ".")).join(", ");
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $2c77a2a8fab70b7a$export$882b5998b3b9117c(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function $2c77a2a8fab70b7a$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $2c77a2a8fab70b7a$export$efccba1c4a2ef57b() {
    const to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    const noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    for(let i = 1; i < arguments.length; i += 1){
        const nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
        if (nextSource !== undefined && nextSource !== null && !$2c77a2a8fab70b7a$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($2c77a2a8fab70b7a$export$882b5998b3b9117c(to[nextKey]) && $2c77a2a8fab70b7a$export$882b5998b3b9117c(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $2c77a2a8fab70b7a$export$efccba1c4a2ef57b(to[nextKey], nextSource[nextKey]);
                    } else if (!$2c77a2a8fab70b7a$export$882b5998b3b9117c(to[nextKey]) && $2c77a2a8fab70b7a$export$882b5998b3b9117c(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $2c77a2a8fab70b7a$export$efccba1c4a2ef57b(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $2c77a2a8fab70b7a$export$2408f22a0fab9ae5(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $2c77a2a8fab70b7a$export$625550452a3fa3ec(_ref) {
    let { swiper: swiper, targetPosition: targetPosition, side: side } = _ref;
    const window1 = (0, $46341108e5b8fdcb$export$407448d2b89b1813)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? "next" : "prev";
    const isOutOfBound = (current, target)=>{
        return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.scrollSnapType = "";
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = "";
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $2c77a2a8fab70b7a$export$39b482c5e57630a8(slideEl) {
    return slideEl.querySelector(".swiper-slide-transform") || slideEl.shadowRoot && slideEl.shadowRoot.querySelector(".swiper-slide-transform") || slideEl;
}
function $2c77a2a8fab70b7a$export$f1e1789686576879(element, selector) {
    if (selector === void 0) selector = "";
    const children = [
        ...element.children
    ];
    if (element instanceof HTMLSlotElement) children.push(...element.assignedElements());
    if (!selector) return children;
    return children.filter((el)=>el.matches(selector));
}
function $2c77a2a8fab70b7a$export$90a7f3efeed30595(el, parent) {
    const isChild = parent.contains(el);
    if (!isChild && parent instanceof HTMLSlotElement) {
        const children = [
            ...parent.assignedElements()
        ];
        return children.includes(el);
    }
    return isChild;
}
function $2c77a2a8fab70b7a$export$3b14a55fb2447963(text) {
    try {
        console.warn(text);
        return;
    } catch (err) {
    // err
    }
}
function $2c77a2a8fab70b7a$export$db3b6bfb95261072(tag, classes) {
    if (classes === void 0) classes = [];
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : $2c77a2a8fab70b7a$export$23f2a1d2818174ef(classes));
    return el;
}
function $2c77a2a8fab70b7a$export$8b22cf2602fb60ce(el) {
    const window1 = (0, $46341108e5b8fdcb$export$407448d2b89b1813)();
    const document1 = (0, $46341108e5b8fdcb$export$39b482c5e57630a8)();
    const box = el.getBoundingClientRect();
    const body = document1.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    const scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $2c77a2a8fab70b7a$export$43caf9889c228507(el, selector) {
    const prevEls = [];
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $2c77a2a8fab70b7a$export$9e5f44173e64f162(el, selector) {
    const nextEls = [];
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $2c77a2a8fab70b7a$export$ffb5f4729a158638(el, prop) {
    const window1 = (0, $46341108e5b8fdcb$export$407448d2b89b1813)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $2c77a2a8fab70b7a$export$dda1d9f60106f0e9(el) {
    let child = el;
    let i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $2c77a2a8fab70b7a$export$407448d2b89b1813(el, selector) {
    const parents = []; // eslint-disable-line
    let parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $2c77a2a8fab70b7a$export$342063e11d6c3cad(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener("transitionend", fireCallBack);
    }
    if (callback) el.addEventListener("transitionend", fireCallBack);
}
function $2c77a2a8fab70b7a$export$2d1720544b23b823(el, size, includeMargins) {
    const window1 = (0, $46341108e5b8fdcb$export$407448d2b89b1813)();
    if (includeMargins) return el[size === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-right" : "margin-top")) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-left" : "margin-bottom"));
    return el.offsetWidth;
}
function $2c77a2a8fab70b7a$export$953cecd6e717a553(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter((e)=>!!e);
}
function $2c77a2a8fab70b7a$export$ae1af26003f05816(swiper) {
    return (v)=>{
        if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) return v + 0.001;
        return v;
    };
}


let $731acbcb25ce319f$var$support;
function $731acbcb25ce319f$var$calcSupport() {
    const window1 = (0, $46341108e5b8fdcb$export$407448d2b89b1813)();
    const document1 = (0, $46341108e5b8fdcb$export$39b482c5e57630a8)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && "scrollBehavior" in document1.documentElement.style,
        touch: !!("ontouchstart" in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function $731acbcb25ce319f$var$getSupport() {
    if (!$731acbcb25ce319f$var$support) $731acbcb25ce319f$var$support = $731acbcb25ce319f$var$calcSupport();
    return $731acbcb25ce319f$var$support;
}
let $731acbcb25ce319f$var$deviceCached;
function $731acbcb25ce319f$var$calcDevice(_temp) {
    let { userAgent: userAgent } = _temp === void 0 ? {} : _temp;
    const support = $731acbcb25ce319f$var$getSupport();
    const window1 = (0, $46341108e5b8fdcb$export$407448d2b89b1813)();
    const platform = window1.navigator.platform;
    const ua = userAgent || window1.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window1.screen.width;
    const screenHeight = window1.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === "Win32";
    let macos = platform === "MacIntel";
    // iPadOs 13 fix
    const iPadScreens = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            "13_0_0"
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = "android";
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    }
    // Export object
    return device;
}
function $731acbcb25ce319f$var$getDevice(overrides) {
    if (overrides === void 0) overrides = {};
    if (!$731acbcb25ce319f$var$deviceCached) $731acbcb25ce319f$var$deviceCached = $731acbcb25ce319f$var$calcDevice(overrides);
    return $731acbcb25ce319f$var$deviceCached;
}
let $731acbcb25ce319f$var$browser;
function $731acbcb25ce319f$var$calcBrowser() {
    const window1 = (0, $46341108e5b8fdcb$export$407448d2b89b1813)();
    const device = $731acbcb25ce319f$var$getDevice();
    let needPerspectiveFix = false;
    function isSafari() {
        const ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    if (isSafari()) {
        const ua = String(window1.navigator.userAgent);
        if (ua.includes("Version/")) {
            const [major, minor] = ua.split("Version/")[1].split(" ")[0].split(".").map((num)=>Number(num));
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent);
    const isSafariBrowser = isSafari();
    const need3dFix = isSafariBrowser || isWebView && device.ios;
    return {
        isSafari: needPerspectiveFix || isSafariBrowser,
        needPerspectiveFix: needPerspectiveFix,
        need3dFix: need3dFix,
        isWebView: isWebView
    };
}
function $731acbcb25ce319f$var$getBrowser() {
    if (!$731acbcb25ce319f$var$browser) $731acbcb25ce319f$var$browser = $731acbcb25ce319f$var$calcBrowser();
    return $731acbcb25ce319f$var$browser;
}
function $731acbcb25ce319f$var$Resize(_ref) {
    let { swiper: swiper, on: on, emit: emit } = _ref;
    const window1 = (0, $46341108e5b8fdcb$export$407448d2b89b1813)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("beforeResize");
        emit("resize");
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window1.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach((_ref2)=>{
                    let { contentBoxSize: contentBoxSize, contentRect: contentRect, target: target } = _ref2;
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("orientationchange");
    };
    on("init", ()=>{
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== "undefined") {
            createObserver();
            return;
        }
        window1.addEventListener("resize", resizeHandler);
        window1.addEventListener("orientationchange", orientationChangeHandler);
    });
    on("destroy", ()=>{
        removeObserver();
        window1.removeEventListener("resize", resizeHandler);
        window1.removeEventListener("orientationchange", orientationChangeHandler);
    });
}
function $731acbcb25ce319f$var$Observer(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const observers = [];
    const window1 = (0, $46341108e5b8fdcb$export$407448d2b89b1813)();
    const attach = function(target, options) {
        if (options === void 0) options = {};
        const ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit("observerUpdate", mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit("observerUpdate", mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: swiper.isElement || (typeof options.childList === "undefined" ? true : options).childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, $2c77a2a8fab70b7a$export$407448d2b89b1813)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on("init", init);
    on("destroy", destroy);
}
/* eslint-disable no-underscore-dangle */ var $731acbcb25ce319f$var$eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        events.split(" ").forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        function onceHandler() {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach((event)=>{
            if (typeof handler === "undefined") self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit () {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $731acbcb25ce319f$var$updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $2c77a2a8fab70b7a$export$ffb5f4729a158638)(el, "padding-left") || 0, 10) - parseInt((0, $2c77a2a8fab70b7a$export$ffb5f4729a158638)(el, "padding-right") || 0, 10);
    height = height - parseInt((0, $2c77a2a8fab70b7a$export$ffb5f4729a158638)(el, "padding-top") || 0, 10) - parseInt((0, $2c77a2a8fab70b7a$export$ffb5f4729a158638)(el, "padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $731acbcb25ce319f$var$updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { wrapperEl: wrapperEl, slidesEl: slidesEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, $2c77a2a8fab70b7a$export$f1e1789686576879)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === "undefined") return;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = "";
        else slideEl.style.marginRight = "";
        slideEl.style.marginBottom = "";
        slideEl.style.marginTop = "";
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $2c77a2a8fab70b7a$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-before", "");
        (0, $2c77a2a8fab70b7a$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-after", "");
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        let slide;
        if (slides[i]) slide = slides[i];
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
        if (slides[i] && (0, $2c77a2a8fab70b7a$export$ffb5f4729a158638)(slide, "display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            if (shouldResetSlideSize) slides[i].style[swiper.getDirectionLabel("width")] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = "none";
            if (currentWebKitTransform) slide.style.webkitTransform = "none";
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $2c77a2a8fab70b7a$export$2d1720544b23b823)(slide, "width", true) : (0, $2c77a2a8fab70b7a$export$2d1720544b23b823)(slide, "height", true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, "width");
                const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
                const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
                const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
                const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
                const boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box") slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[swiper.getDirectionLabel("width")] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? "marginLeft" : swiper.getDirectionLabel("marginRight");
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const offsetSize = (params.slidesOffsetBefore || 0) + (params.slidesOffsetAfter || 0);
        if (allSlidesSize + offsetSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize - offsetSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $2c77a2a8fab70b7a$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
        (0, $2c77a2a8fab70b7a$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit("slidesLengthChange");
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit("slidesGridLengthChange");
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit("slidesUpdated");
    if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function $731acbcb25ce319f$var$updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === "number") swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== "undefined") {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function $731acbcb25ce319f$var$updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    // eslint-disable-next-line
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
const $731acbcb25ce319f$var$toggleSlideClasses$1 = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $731acbcb25ce319f$var$updateSlidesProgress(translate) {
    if (translate === void 0) translate = this && this.translate || 0;
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
        }
        $731acbcb25ce319f$var$toggleSlideClasses$1(slide, isVisible, params.slideVisibleClass);
        $731acbcb25ce319f$var$toggleSlideClasses$1(slide, isFullyVisible, params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function $731acbcb25ce319f$var$updateProgress(translate) {
    const swiper = this;
    if (typeof translate === "undefined") {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd, progressLoop: progressLoop } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit("reachBeginning toEdge");
    if (isEnd && !wasEnd) swiper.emit("reachEnd toEdge");
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit("fromEdge");
    swiper.emit("progress", progress);
}
const $731acbcb25ce319f$var$toggleSlideClasses = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $731acbcb25ce319f$var$updateSlidesClasses() {
    const swiper = this;
    const { slides: slides, params: params, slidesEl: slidesEl, activeIndex: activeIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector)=>{
        return (0, $2c77a2a8fab70b7a$export$f1e1789686576879)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
        if (params.loop) {
            let slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else if (gridEnabled) {
        activeSlide = slides.filter((slideEl)=>slideEl.column === activeIndex)[0];
        nextSlide = slides.filter((slideEl)=>slideEl.column === activeIndex + 1)[0];
        prevSlide = slides.filter((slideEl)=>slideEl.column === activeIndex - 1)[0];
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0, $2c77a2a8fab70b7a$export$9e5f44173e64f162)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            // Prev Slide
            prevSlide = (0, $2c77a2a8fab70b7a$export$43caf9889c228507)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            params.loop;
        }
    }
    slides.forEach((slideEl)=>{
        $731acbcb25ce319f$var$toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
        $731acbcb25ce319f$var$toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
        $731acbcb25ce319f$var$toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}
const $731acbcb25ce319f$var$processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            else // init later
            requestAnimationFrame(()=>{
                if (slideEl.shadowRoot) {
                    lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                    if (lazyEl) lazyEl.remove();
                }
            });
        }
        if (lazyEl) lazyEl.remove();
    }
};
const $731acbcb25ce319f$var$unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute("loading");
};
const $731acbcb25ce319f$var$preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>{
            return activeColumn + slidesPerView + i;
        }));
        swiper.slides.forEach((slideEl, i)=>{
            if (preloadColumns.includes(slideEl.column)) $731acbcb25ce319f$var$unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $731acbcb25ce319f$var$unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) $731acbcb25ce319f$var$unlazy(swiper, i);
    }
};
function $731acbcb25ce319f$var$getActiveIndexByTranslate(swiper) {
    const { slidesGrid: slidesGrid, params: params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
    }
    return activeIndex;
}
function $731acbcb25ce319f$var$updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        let realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === "undefined") activeIndex = $731acbcb25ce319f$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (gridEnabled) {
        const firstSlideInColumn = swiper.slides.filter((slideEl)=>slideEl.column === activeIndex)[0];
        let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute("data-swiper-slide-index"), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        const slideIndex = swiper.slides[activeIndex].getAttribute("data-swiper-slide-index");
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $731acbcb25ce319f$var$preload(swiper);
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit("realIndexChange");
        swiper.emit("slideChange");
    }
}
function $731acbcb25ce319f$var$updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) [
        ...path.slice(path.indexOf(el) + 1, path.length)
    ].forEach((pathEl)=>{
        if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) slide = pathEl;
    });
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute("data-swiper-slide-index"), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var $731acbcb25ce319f$var$update = {
    updateSize: $731acbcb25ce319f$var$updateSize,
    updateSlides: $731acbcb25ce319f$var$updateSlides,
    updateAutoHeight: $731acbcb25ce319f$var$updateAutoHeight,
    updateSlidesOffset: $731acbcb25ce319f$var$updateSlidesOffset,
    updateSlidesProgress: $731acbcb25ce319f$var$updateSlidesProgress,
    updateProgress: $731acbcb25ce319f$var$updateProgress,
    updateSlidesClasses: $731acbcb25ce319f$var$updateSlidesClasses,
    updateActiveIndex: $731acbcb25ce319f$var$updateActiveIndex,
    updateClickedSlide: $731acbcb25ce319f$var$updateClickedSlide
};
function $731acbcb25ce319f$var$getSwiperTranslate(axis) {
    if (axis === void 0) axis = this.isHorizontal() ? "x" : "y";
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, wrapperEl: wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $2c77a2a8fab70b7a$export$35e795649ee09318)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $731acbcb25ce319f$var$setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit("setTranslate", swiper.translate, byController);
}
function $731acbcb25ce319f$var$minTranslate() {
    return -this.snapGrid[0];
}
function $731acbcb25ce319f$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $731acbcb25ce319f$var$translateTo(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) translate = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (translateBounds === void 0) translateBounds = true;
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $2c77a2a8fab70b7a$export$625550452a3fa3ec)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: -newTranslate,
                behavior: "smooth"
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionEnd");
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                swiper.animating = false;
                if (runCallbacks) swiper.emit("transitionEnd");
            };
            swiper.wrapperEl.addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $731acbcb25ce319f$var$translate = {
    getTranslate: $731acbcb25ce319f$var$getSwiperTranslate,
    setTranslate: $731acbcb25ce319f$var$setTranslate,
    minTranslate: $731acbcb25ce319f$var$minTranslate,
    maxTranslate: $731acbcb25ce319f$var$maxTranslate,
    translateTo: $731acbcb25ce319f$var$translateTo
};
function $731acbcb25ce319f$var$setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : "";
    }
    swiper.emit("setTransition", duration, byController);
}
function $731acbcb25ce319f$var$transitionEmit(_ref) {
    let { swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step } = _ref;
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === "next") swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function $731acbcb25ce319f$var$transitionStart(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $731acbcb25ce319f$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "Start"
    });
}
function $731acbcb25ce319f$var$transitionEnd(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $731acbcb25ce319f$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "End"
    });
}
var $731acbcb25ce319f$var$transition = {
    setTransition: $731acbcb25ce319f$var$setTransition,
    transitionStart: $731acbcb25ce319f$var$transitionStart,
    transitionEnd: $731acbcb25ce319f$var$transitionEnd
};
function $731acbcb25ce319f$var$slideTo(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) return false;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit("beforeSlideChangeStart");
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset";
    // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") swiper.setTranslate(translate);
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = "none";
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
                });
            } else wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = "";
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $2c77a2a8fab70b7a$export$625550452a3fa3ec)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: t,
                behavior: "smooth"
            });
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $731acbcb25ce319f$var$slideToLoop(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else {
            let targetSlideIndex;
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                targetSlideIndex = swiper.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex)[0].column;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            const { centeredSlides: centeredSlides } = swiper.params;
            let slidesPerView = swiper.params.slidesPerView;
            if (slidesPerView === "auto") slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
                if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            let needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (centeredSlides) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (internal && centeredSlides && swiper.params.slidesPerView !== "auto" && !gridEnabled) needLoopFix = false;
            if (needLoopFix) {
                const direction = centeredSlides ? targetSlideIndex < swiper.activeIndex ? "prev" : "next" : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? "next" : "prev";
                swiper.loopFix({
                    direction: direction,
                    slideTo: true,
                    activeSlideIndex: direction === "next" ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === "next" ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                newIndex = swiper.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === slideIndex)[0].column;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(()=>{
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
/* eslint no-unused-vars: "off" */ function $731acbcb25ce319f$var$slideNext(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { enabled: enabled, params: params, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "next"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(()=>{
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $731acbcb25ce319f$var$slidePrev(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "prev"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== "undefined") prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(()=>{
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $731acbcb25ce319f$var$slideReset(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $731acbcb25ce319f$var$slideToClosest(speed, runCallbacks, internal, threshold) {
    if (runCallbacks === void 0) runCallbacks = true;
    if (threshold === void 0) threshold = 0.5;
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === "undefined") speed = swiper.params.speed;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $731acbcb25ce319f$var$slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { params: params, slidesEl: slidesEl } = swiper;
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = swiper.getSlideIndex((0, $2c77a2a8fab70b7a$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
                (0, $2c77a2a8fab70b7a$export$7ccc53e8f1e7dfc5)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $2c77a2a8fab70b7a$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, $2c77a2a8fab70b7a$export$7ccc53e8f1e7dfc5)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var $731acbcb25ce319f$var$slide = {
    slideTo: $731acbcb25ce319f$var$slideTo,
    slideToLoop: $731acbcb25ce319f$var$slideToLoop,
    slideNext: $731acbcb25ce319f$var$slideNext,
    slidePrev: $731acbcb25ce319f$var$slidePrev,
    slideReset: $731acbcb25ce319f$var$slideReset,
    slideToClosest: $731acbcb25ce319f$var$slideToClosest,
    slideToClickedSlide: $731acbcb25ce319f$var$slideToClickedSlide
};
function $731acbcb25ce319f$var$loopCreate(slideRealIndex) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const initSlides = ()=>{
        const slides = (0, $2c77a2a8fab70b7a$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach((el, index)=>{
            el.setAttribute("data-swiper-slide-index", index);
        });
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides)=>{
        for(let i = 0; i < amountOfSlides; i += 1){
            const slideEl = swiper.isElement ? (0, $2c77a2a8fab70b7a$export$db3b6bfb95261072)("swiper-slide", [
                params.slideBlankClass
            ]) : (0, $2c77a2a8fab70b7a$export$db3b6bfb95261072)("div", [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $2c77a2a8fab70b7a$export$3b14a55fb2447963)("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $2c77a2a8fab70b7a$export$3b14a55fb2447963)("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
        initSlides();
    } else initSlides();
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: params.centeredSlides ? undefined : "next"
    });
}
function $731acbcb25ce319f$var$loopFix(_temp) {
    let { slideRealIndex: slideRealIndex, slideTo: slideTo = true, direction: direction, setTranslate: setTranslate, activeSlideIndex: activeSlideIndex, byController: byController, byMousewheel: byMousewheel } = _temp === void 0 ? {} : _temp;
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit("beforeLoopFix");
    const { slides: slides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, slidesEl: slidesEl, params: params } = swiper;
    const { centeredSlides: centeredSlides } = params;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!params.centeredSlides && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit("loopFix");
        return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === "auto") slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
        if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    let loopedSlides = slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides) (0, $2c77a2a8fab70b7a$export$3b14a55fb2447963)("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters");
    else if (gridEnabled && params.grid.fill === "row") (0, $2c77a2a8fab70b7a$export$3b14a55fb2447963)("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    let activeIndex = swiper.activeIndex;
    if (typeof activeSlideIndex === "undefined") activeSlideIndex = swiper.getSlideIndex(slides.filter((el)=>el.classList.contains(params.slideActiveClass))[0]);
    else activeIndex = activeSlideIndex;
    const isNext = direction === "next" || !direction;
    const isPrev = direction === "prev" || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (centeredSlides && typeof setTranslate === "undefined" ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                const colIndexToPrepend = cols - index - 1;
                for(let i = slides.length - 1; i >= 0; i -= 1)if (slides[i].column === colIndexToPrepend) prependSlidesIndexes.push(i);
            // slides.forEach((slide, slideIndex) => {
            //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
            // });
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) slides.forEach((slide, slideIndex)=>{
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === "auto") swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach((slide, slideIndex)=>{
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (setTranslate) {
                const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else {
                const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        const loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix({
                ...loopParams,
                slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            });
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix({
            ...loopParams,
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
    }
    swiper.emit("loopFix");
}
function $731acbcb25ce319f$var$loopDestroy() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const index = typeof slideEl.swiperSlideIndex === "undefined" ? slideEl.getAttribute("data-swiper-slide-index") * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute("data-swiper-slide-index");
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var $731acbcb25ce319f$var$loop = {
    loopCreate: $731acbcb25ce319f$var$loopCreate,
    loopFix: $731acbcb25ce319f$var$loopFix,
    loopDestroy: $731acbcb25ce319f$var$loopDestroy
};
function $731acbcb25ce319f$var$setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = "move";
    el.style.cursor = moving ? "grabbing" : "grab";
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function $731acbcb25ce319f$var$unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var $731acbcb25ce319f$var$grabCursor = {
    setGrabCursor: $731acbcb25ce319f$var$setGrabCursor,
    unsetGrabCursor: $731acbcb25ce319f$var$unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $731acbcb25ce319f$var$closestElement(selector, base) {
    if (base === void 0) base = this;
    function __closestFrom(el) {
        if (!el || el === (0, $46341108e5b8fdcb$export$39b482c5e57630a8)() || el === (0, $46341108e5b8fdcb$export$407448d2b89b1813)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $731acbcb25ce319f$var$preventEdgeSwipe(swiper, event, startX) {
    const window1 = (0, $46341108e5b8fdcb$export$407448d2b89b1813)();
    const { params: params } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === "prevent") {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function $731acbcb25ce319f$var$onTouchStart(event) {
    const swiper = this;
    const document1 = (0, $46341108e5b8fdcb$export$39b482c5e57630a8)();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    const data = swiper.touchEventsData;
    if (e.type === "pointerdown") {
        if (data.pointerId !== null && data.pointerId !== e.pointerId) return;
        data.pointerId = e.pointerId;
    } else if (e.type === "touchstart" && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === "touchstart") {
        // don't proceed touch event
        $731acbcb25ce319f$var$preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === "mouse") return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let targetEl = e.target;
    if (params.touchEventsTarget === "wrapper") {
        if (!(0, $2c77a2a8fab70b7a$export$90a7f3efeed30595)(targetEl, swiper.wrapperEl)) return;
    }
    if ("which" in e && e.which === 3) return;
    if ("button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
    // eslint-disable-next-line
    const eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $731acbcb25ce319f$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!$731acbcb25ce319f$var$preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $2c77a2a8fab70b7a$export$4368d992c4eafac0)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === "SELECT") data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl) document1.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit("touchStart", e);
}
function $731acbcb25ce319f$var$onTouchMove(event) {
    const document1 = (0, $46341108e5b8fdcb$export$39b482c5e57630a8)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (e.type === "pointermove") {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const id = e.pointerId;
        if (id !== data.pointerId) return;
    }
    let targetTouch;
    if (e.type === "touchmove") {
        targetTouch = [
            ...e.changedTouches
        ].filter((t)=>t.identifier === data.touchId)[0];
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit("touchMoveOpposite", e);
        return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $2c77a2a8fab70b7a$export$4368d992c4eafac0)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit("touchMove", e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit("touchMoveOpposite", e);
    if (typeof data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || e.type === "touchmove" && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    swiper.touchesDirection = touchesDiff > 0 ? "prev" : "next";
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === "next" && swiper.allowSlideNext || swiper.touchesDirection === "prev" && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent("transitionend", {
                bubbles: true,
                cancelable: true,
                detail: {
                    bySwiperTouchMove: true
                }
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit("sliderFirstMove", e);
    }
    let loopFixed;
    new Date().getTime();
    if (data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== "auto" && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) swiper.loopFix({
            direction: "prev",
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== "auto" && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) swiper.loopFix({
            direction: "next",
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function $731acbcb25ce319f$var$onTouchEnd(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let targetTouch;
    const isTouchEvent = e.type === "touchend" || e.type === "touchcancel";
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        if (e.pointerId !== data.pointerId) return;
        targetTouch = e;
    } else {
        targetTouch = [
            ...e.changedTouches
        ].filter((t)=>t.identifier === data.touchId)[0];
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if ([
        "pointercancel",
        "pointerout",
        "pointerleave",
        "contextmenu"
    ].includes(e.type)) {
        const proceed = [
            "pointercancel",
            "contextmenu"
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === "mouse") return;
    if (data.allowTouchCallbacks) swiper.emit("touchEnd", e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, $2c77a2a8fab70b7a$export$4368d992c4eafac0)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit("doubleTap doubleClick", e);
    }
    data.lastClickTime = (0, $2c77a2a8fab70b7a$export$4368d992c4eafac0)();
    (0, $2c77a2a8fab70b7a$export$7ccc53e8f1e7dfc5)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === "next") swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === "prev") swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function $731acbcb25ce319f$var$onResize() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $731acbcb25ce319f$var$onClick(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $731acbcb25ce319f$var$onScroll() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit("setTranslate", swiper.translate, false);
}
function $731acbcb25ce319f$var$onLoad(e) {
    const swiper = this;
    $731acbcb25ce319f$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== "auto" && !swiper.params.autoHeight) return;
    swiper.update();
}
function $731acbcb25ce319f$var$onDocumentTouchStart() {
    const swiper = this;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = "auto";
}
const $731acbcb25ce319f$var$events = (swiper, method)=>{
    const document1 = (0, $46341108e5b8fdcb$export$39b482c5e57630a8)();
    const { params: params, el: el, wrapperEl: wrapperEl, device: device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    const swiperMethod = method;
    if (!el || typeof el === "string") return;
    // Touch Events
    document1[domMethod]("touchstart", swiper.onDocumentTouchStart, {
        passive: false,
        capture: capture
    });
    el[domMethod]("touchstart", swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]("pointerdown", swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]("touchmove", swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]("pointermove", swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]("touchend", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerup", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointercancel", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("touchcancel", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerout", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerleave", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("contextmenu", swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]("click", swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]("scroll", swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", $731acbcb25ce319f$var$onResize, true);
    else swiper[swiperMethod]("observerUpdate", $731acbcb25ce319f$var$onResize, true);
    // Images loader
    el[domMethod]("load", swiper.onLoad, {
        capture: true
    });
};
function $731acbcb25ce319f$var$attachEvents() {
    const swiper = this;
    const { params: params } = swiper;
    swiper.onTouchStart = $731acbcb25ce319f$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $731acbcb25ce319f$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $731acbcb25ce319f$var$onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = $731acbcb25ce319f$var$onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = $731acbcb25ce319f$var$onScroll.bind(swiper);
    swiper.onClick = $731acbcb25ce319f$var$onClick.bind(swiper);
    swiper.onLoad = $731acbcb25ce319f$var$onLoad.bind(swiper);
    $731acbcb25ce319f$var$events(swiper, "on");
}
function $731acbcb25ce319f$var$detachEvents() {
    const swiper = this;
    $731acbcb25ce319f$var$events(swiper, "off");
}
var $731acbcb25ce319f$var$events$1 = {
    attachEvents: $731acbcb25ce319f$var$attachEvents,
    detachEvents: $731acbcb25ce319f$var$detachEvents
};
const $731acbcb25ce319f$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $731acbcb25ce319f$var$setBreakpoint() {
    const swiper = this;
    const { realIndex: realIndex, initialized: initialized, params: params, el: el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    // Get breakpoint for window width and update parameters
    const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $731acbcb25ce319f$var$isGridEnabled(swiper, params);
    const isMultiRow = $731acbcb25ce319f$var$isGridEnabled(swiper, breakpointParams);
    const wasGrabCursor = swiper.params.grabCursor;
    const isGrabCursor = breakpointParams.grabCursor;
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) swiper.unsetGrabCursor();
    else if (!wasGrabCursor && isGrabCursor) swiper.setGrabCursor();
    // Toggle navigation, pagination, scrollbar
    [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach((prop)=>{
        if (typeof breakpointParams[prop] === "undefined") return;
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $2c77a2a8fab70b7a$export$efccba1c4a2ef57b)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit("breakpoint", breakpointParams);
}
function $731acbcb25ce319f$var$getBreakpoint(breakpoints, base, containerEl) {
    if (base === void 0) base = "window";
    if (!breakpoints || base === "container" && !containerEl) return undefined;
    let breakpoint = false;
    const window1 = (0, $46341108e5b8fdcb$export$407448d2b89b1813)();
    const currentHeight = base === "window" ? window1.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === "string" && point.indexOf("@") === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === "window") {
            if (window1.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || "max";
}
var $731acbcb25ce319f$var$breakpoints = {
    setBreakpoint: $731acbcb25ce319f$var$setBreakpoint,
    getBreakpoint: $731acbcb25ce319f$var$getBreakpoint
};
function $731acbcb25ce319f$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === "object") Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === "string") resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $731acbcb25ce319f$var$addClasses() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, el: el, device: device } = swiper;
    // prettier-ignore
    const suffixes = $731acbcb25ce319f$var$prepareClasses([
        "initialized",
        params.direction,
        {
            "free-mode": swiper.params.freeMode && params.freeMode.enabled
        },
        {
            "autoheight": params.autoHeight
        },
        {
            "rtl": rtl
        },
        {
            "grid": params.grid && params.grid.rows > 1
        },
        {
            "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
        },
        {
            "android": device.android
        },
        {
            "ios": device.ios
        },
        {
            "css-mode": params.cssMode
        },
        {
            "centered": params.cssMode && params.centeredSlides
        },
        {
            "watch-progress": params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function $731acbcb25ce319f$var$removeClasses() {
    const swiper = this;
    const { el: el, classNames: classNames } = swiper;
    if (!el || typeof el === "string") return;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var $731acbcb25ce319f$var$classes = {
    addClasses: $731acbcb25ce319f$var$addClasses,
    removeClasses: $731acbcb25ce319f$var$removeClasses
};
function $731acbcb25ce319f$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
}
var $731acbcb25ce319f$var$checkOverflow$1 = {
    checkOverflow: $731acbcb25ce319f$var$checkOverflow
};
var $731acbcb25ce319f$export$4368d992c4eafac0 = {
    init: true,
    direction: "horizontal",
    oneWayMovement: false,
    swiperElementNodeName: "SWIPER-CONTAINER",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: "swiper",
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-blank",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideFullyVisibleClass: "swiper-slide-fully-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function $731acbcb25ce319f$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj) {
        if (obj === void 0) obj = {};
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== "object" || moduleParams === null) {
            (0, $2c77a2a8fab70b7a$export$efccba1c4a2ef57b)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === "navigation" && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            "pagination",
            "scrollbar"
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && "enabled" in moduleParams)) {
            (0, $2c77a2a8fab70b7a$export$efccba1c4a2ef57b)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $2c77a2a8fab70b7a$export$efccba1c4a2ef57b)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ const $731acbcb25ce319f$var$prototypes = {
    eventsEmitter: $731acbcb25ce319f$var$eventsEmitter,
    update: $731acbcb25ce319f$var$update,
    translate: $731acbcb25ce319f$var$translate,
    transition: $731acbcb25ce319f$var$transition,
    slide: $731acbcb25ce319f$var$slide,
    loop: $731acbcb25ce319f$var$loop,
    grabCursor: $731acbcb25ce319f$var$grabCursor,
    events: $731acbcb25ce319f$var$events$1,
    breakpoints: $731acbcb25ce319f$var$breakpoints,
    checkOverflow: $731acbcb25ce319f$var$checkOverflow$1,
    classes: $731acbcb25ce319f$var$classes
};
const $731acbcb25ce319f$var$extendedDefaults = {};
class $731acbcb25ce319f$export$25ce5a424b770e84 {
    getDirectionLabel(property) {
        if (this.isHorizontal()) return property;
        // prettier-ignore
        return ({
            "width": "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            "marginRight": "marginBottom"
        })[property];
    }
    getSlideIndex(slideEl) {
        const { slidesEl: slidesEl, params: params } = this;
        const slides = (0, $2c77a2a8fab70b7a$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, $2c77a2a8fab70b7a$export$dda1d9f60106f0e9)(slides[0]);
        return (0, $2c77a2a8fab70b7a$export$dda1d9f60106f0e9)(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === index)[0]);
    }
    recalcSlides() {
        const swiper = this;
        const { slidesEl: slidesEl, params: params } = swiper;
        swiper.slides = (0, $2c77a2a8fab70b7a$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit("enable");
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit("disable");
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(" ").filter((className)=>{
            return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit("_containerClasses", cls.join(" "));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return "";
        return slideEl.className.split(" ").filter((className)=>{
            return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(" ");
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.forEach((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit("_slideClass", slideEl, classNames);
        });
        swiper.emit("_slideClasses", updates);
    }
    slidesPerViewDynamic(view, exact) {
        if (view === void 0) view = "current";
        if (exact === void 0) exact = false;
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (typeof params.slidesPerView === "number") return params.slidesPerView;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += Math.ceil(slides[i].swiperSlideSize);
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === "current") for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) $731acbcb25ce319f$var$processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                translated = swiper.slideTo(slides.length - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit("update");
    }
    changeDirection(newDirection, needUpdate) {
        if (needUpdate === void 0) needUpdate = true;
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
        if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === "vertical") slideEl.style.width = "";
            else slideEl.style.height = "";
        });
        swiper.emit("changeDirection");
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
        swiper.rtl = direction === "rtl";
        swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "rtl";
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "ltr";
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // Find el
        let el = element || swiper.params.el;
        if (typeof el === "string") el = document.querySelector(el);
        if (!el) return false;
        el.swiper = swiper;
        if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, $2c77a2a8fab70b7a$export$f1e1789686576879)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, $2c77a2a8fab70b7a$export$db3b6bfb95261072)("div", swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, $2c77a2a8fab70b7a$export$f1e1789686576879)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            el: el,
            wrapperEl: wrapperEl,
            slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
            hostEl: swiper.isElement ? el.parentNode.host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === "rtl" || (0, $2c77a2a8fab70b7a$export$ffb5f4729a158638)(el, "direction") === "rtl",
            rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || (0, $2c77a2a8fab70b7a$export$ffb5f4729a158638)(el, "direction") === "rtl"),
            wrongRTL: (0, $2c77a2a8fab70b7a$export$ffb5f4729a158638)(wrapperEl, "display") === "-webkit-box"
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit("beforeInit");
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate();
        // Attach events
        swiper.attachEvents();
        const lazyElements = [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ];
        if (swiper.isElement) lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        lazyElements.forEach((imageEl)=>{
            if (imageEl.complete) $731acbcb25ce319f$var$processLazyPreloader(swiper, imageEl);
            else imageEl.addEventListener("load", (e)=>{
                $731acbcb25ce319f$var$processLazyPreloader(swiper, e.target);
            });
        });
        $731acbcb25ce319f$var$preload(swiper);
        // Init Flag
        swiper.initialized = true;
        $731acbcb25ce319f$var$preload(swiper);
        // Emit
        swiper.emit("init");
        swiper.emit("afterInit");
        return swiper;
    }
    destroy(deleteInstance, cleanStyles) {
        if (deleteInstance === void 0) deleteInstance = true;
        if (cleanStyles === void 0) cleanStyles = true;
        const swiper = this;
        const { params: params, el: el, wrapperEl: wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === "undefined" || swiper.destroyed) return null;
        swiper.emit("beforeDestroy");
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            if (el && typeof el !== "string") el.removeAttribute("style");
            if (wrapperEl) wrapperEl.removeAttribute("style");
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute("style");
                slideEl.removeAttribute("data-swiper-slide-index");
            });
        }
        swiper.emit("destroy");
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            if (swiper.el && typeof swiper.el !== "string") swiper.el.swiper = null;
            (0, $2c77a2a8fab70b7a$export$d141bba7fdc215a3)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $2c77a2a8fab70b7a$export$efccba1c4a2ef57b)($731acbcb25ce319f$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $731acbcb25ce319f$var$extendedDefaults;
    }
    static get defaults() {
        return $731acbcb25ce319f$export$4368d992c4eafac0;
    }
    static installModule(mod) {
        if (!$731acbcb25ce319f$export$25ce5a424b770e84.prototype.__modules__) $731acbcb25ce319f$export$25ce5a424b770e84.prototype.__modules__ = [];
        const modules = $731acbcb25ce319f$export$25ce5a424b770e84.prototype.__modules__;
        if (typeof mod === "function" && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$731acbcb25ce319f$export$25ce5a424b770e84.installModule(m));
            return $731acbcb25ce319f$export$25ce5a424b770e84;
        }
        $731acbcb25ce319f$export$25ce5a424b770e84.installModule(module);
        return $731acbcb25ce319f$export$25ce5a424b770e84;
    }
    constructor(){
        let el;
        let params;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $2c77a2a8fab70b7a$export$efccba1c4a2ef57b)({}, params);
        if (el && !params.el) params.el = el;
        const document1 = (0, $46341108e5b8fdcb$export$39b482c5e57630a8)();
        if (params.el && typeof params.el === "string" && document1.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document1.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, $2c77a2a8fab70b7a$export$efccba1c4a2ef57b)({}, params, {
                    el: containerEl
                });
                swipers.push(new $731acbcb25ce319f$export$25ce5a424b770e84(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $731acbcb25ce319f$var$getSupport();
        swiper.device = $731acbcb25ce319f$var$getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = $731acbcb25ce319f$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params: params,
                swiper: swiper,
                extendParams: $731acbcb25ce319f$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, $2c77a2a8fab70b7a$export$efccba1c4a2ef57b)({}, $731acbcb25ce319f$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $2c77a2a8fab70b7a$export$efccba1c4a2ef57b)({}, swiperParams, $731acbcb25ce319f$var$extendedDefaults, params);
        swiper.originalParams = (0, $2c77a2a8fab70b7a$export$efccba1c4a2ef57b)({}, swiper.params);
        swiper.passedParams = (0, $2c77a2a8fab70b7a$export$efccba1c4a2ef57b)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === "horizontal";
            },
            isVertical () {
                return swiper.params.direction === "vertical";
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit("_swiper");
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
}
Object.keys($731acbcb25ce319f$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($731acbcb25ce319f$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $731acbcb25ce319f$export$25ce5a424b770e84.prototype[protoMethod] = $731acbcb25ce319f$var$prototypes[prototypeGroup][protoMethod];
    });
});
$731acbcb25ce319f$export$25ce5a424b770e84.use([
    $731acbcb25ce319f$var$Resize,
    $731acbcb25ce319f$var$Observer
]);






function $f2cc14553f8cdad3$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    const document = (0, $46341108e5b8fdcb$export$39b482c5e57630a8)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    const tempDOM = document.createElement("div");
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        let slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === "string") {
                tempDOM.innerHTML = slideEl;
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, $2c77a2a8fab70b7a$export$db3b6bfb95261072)("swiper-slide");
        else slideEl = (0, $2c77a2a8fab70b7a$export$db3b6bfb95261072)("div", swiper.params.slideClass);
        slideEl.setAttribute("data-swiper-slide-index", index);
        if (!params.renderSlide) slideEl.innerHTML = slide;
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force, beforeInit) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides, loop: isLoop, initialSlide: initialSlide } = swiper.params;
        if (beforeInit && !isLoop && initialSlide > 0) return;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = swiper.activeIndex || 0;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = "right";
        else offsetProp = swiper.isHorizontal() ? "left" : "top";
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerView : slidesPerGroup) + addSlidesBefore;
        }
        let from = activeIndex - slidesBefore;
        let to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit("virtualUpdate");
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach((slideEl)=>{
                slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
            });
            swiper.updateProgress();
            emit("virtualUpdate");
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit("virtualUpdate");
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        const getSlideIndex = (index)=>{
            let slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach((slideEl)=>{
            slideEl.remove();
        });
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                const slideIndex = getSlideIndex(i);
                swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach((slideEl)=>{
                    slideEl.remove();
                });
            }
        }
        const loopFrom = isLoop ? -slides.length : 0;
        const loopTo = isLoop ? slides.length * 2 : slides.length;
        for(let i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) {
            const slideIndex = getSlideIndex(i);
            if (typeof previousTo === "undefined" || force) appendIndexes.push(slideIndex);
            else {
                if (i > previousTo) appendIndexes.push(slideIndex);
                if (i < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(let i = prependIndexes.length - 1; i >= 0; i -= 1){
            const index = prependIndexes[i];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort((a, b)=>b - a);
            prependIndexes.forEach((index)=>{
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $2c77a2a8fab70b7a$export$f1e1789686576879)(swiper.slidesEl, ".swiper-slide, swiper-slide").forEach((slideEl)=>{
            slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === "object" && "length" in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const cachedEl = cache[cachedIndex];
                const cachedElIndex = cachedEl.getAttribute("data-swiper-slide-index");
                if (cachedElIndex) cachedEl.setAttribute("data-swiper-slide-index", parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === "undefined" || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute("data-swiper-slide-index", key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute("data-swiper-slide-index", key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on("beforeInit", ()=>{
        if (!swiper.params.virtual.enabled) return;
        let domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === "undefined") {
            const slides = [
                ...swiper.slidesEl.children
            ].filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`));
            if (slides && slides.length) {
                swiper.virtual.slides = [
                    ...slides
                ];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex)=>{
                    slideEl.setAttribute("data-swiper-slide-index", slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update(false, true);
    });
    on("setTranslate", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on("init update resize", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $2c77a2a8fab70b7a$export$2408f22a0fab9ae5)(swiper.wrapperEl, "--swiper-virtual-size", `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}




/* eslint-disable consistent-return */ function $a6127bd355944b0b$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const document = (0, $46341108e5b8fdcb$export$39b482c5e57630a8)();
    const window = (0, $46341108e5b8fdcb$export$407448d2b89b1813)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === "input" || document.activeElement.nodeName.toLowerCase() === "textarea")) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $2c77a2a8fab70b7a$export$407448d2b89b1813)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0, $2c77a2a8fab70b7a$export$407448d2b89b1813)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const el = swiper.el;
            const swiperWidth = el.clientWidth;
            const swiperHeight = el.clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = (0, $2c77a2a8fab70b7a$export$8b22cf2602fb60ce)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit("keyPress", kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener("keydown", handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener("keydown", handle);
        swiper.keyboard.enabled = false;
    }
    on("init", ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}




/* eslint-disable consistent-return */ function $56b2435cf97bcd52$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const window = (0, $46341108e5b8fdcb$export$407448d2b89b1813)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: "swiper-no-mousewheel"
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $2c77a2a8fab70b7a$export$4368d992c4eafac0)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ("detail" in e) sY = e.detail;
        if ("wheelDelta" in e) sY = -e.wheelDelta / 120;
        if ("wheelDeltaY" in e) sY = -e.wheelDeltaY / 120;
        if ("wheelDeltaX" in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ("deltaY" in e) pY = e.deltaY;
        if ("deltaX" in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $2c77a2a8fab70b7a$export$4368d992c4eafac0)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $2c77a2a8fab70b7a$export$4368d992c4eafac0)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit("scroll", newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit("scroll", newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        const targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $2c77a2a8fab70b7a$export$4368d992c4eafac0)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $2c77a2a8fab70b7a$export$4368d992c4eafac0)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent.direction < 0 ? "next" : "prev",
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $2c77a2a8fab70b7a$export$7ccc53e8f1e7dfc5)(()=>{
                            if (swiper.destroyed || !swiper.params) return;
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $2c77a2a8fab70b7a$export$7ccc53e8f1e7dfc5)(()=>{
                        if (swiper.destroyed || !swiper.params) return;
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit("scroll", e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]("mouseenter", handleMouseEnter);
        targetEl[method]("mouseleave", handleMouseLeave);
        targetEl[method]("wheel", handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener("wheel", handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events("addEventListener");
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events("removeEventListener");
        swiper.mousewheel.enabled = false;
        return true;
    }
    on("init", ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



function $313bd21f79f515b0$export$db3b6bfb95261072(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = (0, $2c77a2a8fab70b7a$export$f1e1789686576879)(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
                element = (0, $2c77a2a8fab70b7a$export$db3b6bfb95261072)("div", checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}



function $b68a48a0cb5e2e58$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled"
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null
    };
    function getEl(el) {
        let res;
        if (el && typeof el === "string" && swiper.isElement) {
            res = swiper.el.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === "string") res = [
                ...document.querySelectorAll(el)
            ];
            if (swiper.params.uniqueNavElements && typeof el === "string" && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
            else if (res && res.length === 1) res = res[0];
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    }
    function toggleEl(el, disabled) {
        const params = swiper.params.navigation;
        el = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (subEl) {
                subEl.classList[disabled ? "add" : "remove"](...params.disabledClass.split(" "));
                if (subEl.tagName === "BUTTON") subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit("navigationPrev");
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit("navigationNext");
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $313bd21f79f515b0$export$db3b6bfb95261072)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
        });
        if (!(params.nextEl || params.prevEl)) return;
        let nextEl = getEl(params.nextEl);
        let prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        nextEl = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(prevEl);
        const initButton = (el, dir)=>{
            if (el) el.addEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            if (!swiper.enabled && el) el.classList.add(...params.lockClass.split(" "));
        };
        nextEl.forEach((el)=>initButton(el, "next"));
        prevEl.forEach((el)=>initButton(el, "prev"));
    }
    function destroy() {
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(prevEl);
        const destroyButton = (el, dir)=>{
            el.removeEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            el.classList.remove(...swiper.params.navigation.disabledClass.split(" "));
        };
        nextEl.forEach((el)=>destroyButton(el, "next"));
        prevEl.forEach((el)=>destroyButton(el, "prev"));
    }
    on("init", ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on("toEdge fromEdge lock unlock", ()=>{
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        [
            ...nextEl,
            ...prevEl
        ].filter((el)=>!!el).forEach((el)=>el.classList.add(swiper.params.navigation.lockClass));
    });
    on("click", (_s, e)=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(prevEl);
        const targetEl = e.target;
        let targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
        if (swiper.isElement && !targetIsButton) {
            const path = e.path || e.composedPath && e.composedPath();
            if (path) targetIsButton = path.find((pathEl)=>nextEl.includes(pathEl) || prevEl.includes(pathEl));
        }
        if (swiper.params.navigation.hideOnClick && !targetIsButton) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit("navigationShow");
            else emit("navigationHide");
            [
                ...nextEl,
                ...prevEl
            ].filter((el)=>!!el).forEach((el)=>el.classList.toggle(swiper.params.navigation.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(" "));
        init();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(" "));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}


function $718b5e1f3d97595b$export$db3b6bfb95261072(classes) {
    if (classes === void 0) classes = "";
    return `.${classes.trim().replace(/([\.:!+\/])/g, "\\$1") // eslint-disable-line
    .replace(/ /g, ".")}`;
}




function $ad4c197f78da2876$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const pfx = "swiper-pagination";
    extendParams({
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: "bullets",
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        if (!bulletEl) return;
        bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
        if (bulletEl) {
            bulletEl.classList.add(`${bulletActiveClass}-${position}`);
            bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
            if (bulletEl) bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
    }
    function onBulletClick(e) {
        const bulletEl = e.target.closest((0, $718b5e1f3d97595b$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        const index = (0, $2c77a2a8fab70b7a$export$dda1d9f60106f0e9)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        el = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== "undefined") {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, $2c77a2a8fab70b7a$export$2d1720544b23b823)(bullets[0], swiper.isHorizontal() ? "width" : "height", true);
                el.forEach((subEl)=>{
                    subEl.style[swiper.isHorizontal() ? "width" : "height"] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach((bulletEl)=>{
                const classesToRemove = [
                    ...[
                        "",
                        "-next",
                        "-next-next",
                        "-prev",
                        "-prev-prev",
                        "-main"
                    ].map((suffix)=>`${params.bulletActiveClass}${suffix}`)
                ].map((s)=>typeof s === "string" && s.includes(" ") ? s.split(" ") : s).flat();
                bulletEl.classList.remove(...classesToRemove);
            });
            if (el.length > 1) bullets.forEach((bullet)=>{
                const bulletIndex = (0, $2c77a2a8fab70b7a$export$dda1d9f60106f0e9)(bullet);
                if (bulletIndex === current) bullet.classList.add(...params.bulletActiveClass.split(" "));
                else if (swiper.isElement) bullet.setAttribute("part", "bullet");
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) bullet.classList.add(...`${params.bulletActiveClass}-main`.split(" "));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, "prev");
                    if (bulletIndex === lastIndex) setSideBullets(bullet, "next");
                }
            });
            else {
                const bullet = bullets[current];
                if (bullet) bullet.classList.add(...params.bulletActiveClass.split(" "));
                if (swiper.isElement) bullets.forEach((bulletEl, bulletIndex)=>{
                    bulletEl.setAttribute("part", bulletIndex === current ? "bullet-active" : "bullet");
                });
                if (params.dynamicBullets) {
                    const firstDisplayedBullet = bullets[firstIndex];
                    const lastDisplayedBullet = bullets[lastIndex];
                    for(let i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(" "));
                    setSideBullets(firstDisplayedBullet, "prev");
                    setSideBullets(lastDisplayedBullet, "next");
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? "right" : "left";
                bullets.forEach((bullet)=>{
                    bullet.style[swiper.isHorizontal() ? offsetProp : "top"] = `${bulletsOffset}px`;
                });
            }
        }
        el.forEach((subEl, subElIndex)=>{
            if (params.type === "fraction") {
                subEl.querySelectorAll((0, $718b5e1f3d97595b$export$db3b6bfb95261072)(params.currentClass)).forEach((fractionEl)=>{
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, $718b5e1f3d97595b$export$db3b6bfb95261072)(params.totalClass)).forEach((totalEl)=>{
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === "progressbar") {
                let progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
                else progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === "horizontal") scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $718b5e1f3d97595b$export$db3b6bfb95261072)(params.progressbarFillClass)).forEach((progressEl)=>{
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === "custom" && params.renderCustom) {
                subEl.innerHTML = params.renderCustom(swiper, current + 1, total);
                if (subElIndex === 0) emit("paginationRender", subEl);
            } else {
                if (subElIndex === 0) emit("paginationRender", subEl);
                emit("paginationUpdate", subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
        });
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
        let el = swiper.pagination.el;
        el = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(el);
        let paginationHTML = "";
        if (params.type === "bullets") {
            let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ""} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
        if (params.type === "fraction") {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + " / " + `<span class="${params.totalClass}"></span>`;
        }
        if (params.type === "progressbar") {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
        swiper.pagination.bullets = [];
        el.forEach((subEl)=>{
            if (params.type !== "custom") subEl.innerHTML = paginationHTML || "";
            if (params.type === "bullets") swiper.pagination.bullets.push(...subEl.querySelectorAll((0, $718b5e1f3d97595b$export$db3b6bfb95261072)(params.bulletClass)));
        });
        if (params.type !== "custom") emit("paginationRender", el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $313bd21f79f515b0$export$db3b6bfb95261072)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: "swiper-pagination"
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === "string") el = [
            ...document.querySelectorAll(params.el)
        ];
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && Array.isArray(el) && el.length > 1) {
            el = [
                ...swiper.el.querySelectorAll(params.el)
            ];
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.filter((subEl)=>{
                if ((0, $2c77a2a8fab70b7a$export$407448d2b89b1813)(subEl, ".swiper")[0] !== swiper.el) return false;
                return true;
            })[0];
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        el = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (params.type === "bullets" && params.clickable) subEl.classList.add(...(params.clickableClass || "").split(" "));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === "bullets" && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === "progressbar" && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener("click", onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        if (el) {
            el = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>{
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    subEl.classList.remove(...(params.clickableClass || "").split(" "));
                    subEl.removeEventListener("click", onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl)=>subEl.classList.remove(...params.bulletActiveClass.split(" ")));
    }
    on("changeDirection", ()=>{
        if (!swiper.pagination || !swiper.pagination.el) return;
        const params = swiper.params.pagination;
        let { el: el } = swiper.pagination;
        el = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on("init", ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on("activeIndexChange", ()=>{
        if (typeof swiper.snapIndex === "undefined") update();
    });
    on("snapIndexChange", ()=>{
        update();
    });
    on("snapGridLengthChange", ()=>{
        render();
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList[swiper.enabled ? "remove" : "add"](swiper.params.pagination.lockClass));
        }
    });
    on("lock unlock", ()=>{
        update();
    });
    on("click", (_s, e)=>{
        const targetEl = e.target;
        const el = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(swiper.pagination.el);
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit("paginationShow");
            else emit("paginationHide");
            el.forEach((subEl)=>subEl.classList.toggle(swiper.params.pagination.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
        }
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}






function $327f39dd84528b01$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const document = (0, $46341108e5b8fdcb$export$39b482c5e57630a8)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
            scrollbarDisabledClass: "swiper-scrollbar-disabled",
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        const params = swiper.params.scrollbar;
        const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        } else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        dragEl.style.width = "";
        dragEl.style.height = "";
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === "auto") dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = `${dragSize}px`;
        else dragEl.style.height = `${dragSize}px`;
        if (divider >= 1) el.style.display = "none";
        else el.style.display = "";
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? "add" : "remove"](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { el: el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $2c77a2a8fab70b7a$export$8b22cf2602fb60ce)(el)[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = "100ms";
        dragEl.style.transitionDuration = "100ms";
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = "0ms";
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style["scroll-snap-type"] = "none";
        emit("scrollbarDragStart", e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault && e.cancelable) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = "0ms";
        el.style.transitionDuration = "0ms";
        dragEl.style.transitionDuration = "0ms";
        emit("scrollbarDragMove", e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style["scroll-snap-type"] = "";
            wrapperEl.style.transitionDuration = "";
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $2c77a2a8fab70b7a$export$7ccc53e8f1e7dfc5)(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
        emit("scrollbarDragEnd", e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, params: params } = swiper;
        const el = scrollbar.el;
        if (!el) return;
        const target = el;
        const activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === "on" ? "addEventListener" : "removeEventListener";
        target[eventMethod]("pointerdown", onDragStart, activeListener);
        document[eventMethod]("pointermove", onDragMove, activeListener);
        document[eventMethod]("pointerup", onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("on");
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("off");
    }
    function init() {
        const { scrollbar: scrollbar, el: swiperEl } = swiper;
        swiper.params.scrollbar = (0, $313bd21f79f515b0$export$db3b6bfb95261072)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: "swiper-scrollbar"
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === "string") {
            el = document.querySelectorAll(params.el);
            if (!el.length) return;
        } else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let dragEl;
        if (el) {
            dragEl = el.querySelector((0, $718b5e1f3d97595b$export$db3b6bfb95261072)(swiper.params.scrollbar.dragClass));
            if (!dragEl) {
                dragEl = (0, $2c77a2a8fab70b7a$export$db3b6bfb95261072)("div", swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: el,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) el.classList[swiper.enabled ? "remove" : "add"](...(0, $2c77a2a8fab70b7a$export$23f2a1d2818174ef)(swiper.params.scrollbar.lockClass));
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const el = swiper.scrollbar.el;
        if (el) el.classList.remove(...(0, $2c77a2a8fab70b7a$export$23f2a1d2818174ef)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass));
        disableDraggable();
    }
    on("changeDirection", ()=>{
        if (!swiper.scrollbar || !swiper.scrollbar.el) return;
        const params = swiper.params.scrollbar;
        let { el: el } = swiper.scrollbar;
        el = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on("init", ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on("update resize observerUpdate lock unlock changeDirection", ()=>{
        updateSize();
    });
    on("setTranslate", ()=>{
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        setTransition(duration);
    });
    on("enable disable", ()=>{
        const { el: el } = swiper.scrollbar;
        if (el) el.classList[swiper.enabled ? "remove" : "add"](...(0, $2c77a2a8fab70b7a$export$23f2a1d2818174ef)(swiper.params.scrollbar.lockClass));
    });
    on("destroy", ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.el.classList.remove(...(0, $2c77a2a8fab70b7a$export$23f2a1d2818174ef)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(...(0, $2c77a2a8fab70b7a$export$23f2a1d2818174ef)(swiper.params.scrollbar.scrollbarDisabledClass));
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.el.classList.add(...(0, $2c77a2a8fab70b7a$export$23f2a1d2818174ef)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(...(0, $2c77a2a8fab70b7a$export$23f2a1d2818174ef)(swiper.params.scrollbar.scrollbarDisabledClass));
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $19c129ca6e0d16ae$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const elementsSelector = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]";
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const rtlFactor = rtl ? -1 : 1;
        const p = el.getAttribute("data-swiper-parallax") || "0";
        let x = el.getAttribute("data-swiper-parallax-x");
        let y = el.getAttribute("data-swiper-parallax-y");
        const scale = el.getAttribute("data-swiper-parallax-scale");
        const opacity = el.getAttribute("data-swiper-parallax-opacity");
        const rotate = el.getAttribute("data-swiper-parallax-rotate");
        if (x || y) {
            x = x || "0";
            y = y || "0";
        } else if (swiper.isHorizontal()) {
            x = p;
            y = "0";
        } else {
            y = p;
            x = "0";
        }
        if (x.indexOf("%") >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf("%") >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== "undefined" && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        let transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== "undefined" && scale !== null) {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== "undefined" && rotate !== null) {
            const currentRotate = rotate * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    const setTranslate = ()=>{
        const { el: el, slides: slides, progress: progress, snapGrid: snapGrid, isElement: isElement } = swiper;
        const elements = (0, $2c77a2a8fab70b7a$export$f1e1789686576879)(el, elementsSelector);
        if (swiper.isElement) elements.push(...(0, $2c77a2a8fab70b7a$export$f1e1789686576879)(swiper.hostEl, elementsSelector));
        elements.forEach((subEl)=>{
            setTransform(subEl, progress);
        });
        slides.forEach((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== "auto") slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach((subEl)=>{
                setTransform(subEl, slideProgress);
            });
        });
    };
    const setTransition = function(duration) {
        if (duration === void 0) duration = swiper.params.speed;
        const { el: el, hostEl: hostEl } = swiper;
        const elements = [
            ...el.querySelectorAll(elementsSelector)
        ];
        if (swiper.isElement) elements.push(...hostEl.querySelectorAll(elementsSelector));
        elements.forEach((parallaxEl)=>{
            let parallaxDuration = parseInt(parallaxEl.getAttribute("data-swiper-parallax-duration"), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on("beforeInit", ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on("init", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTransition", (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}




function $5f03686888588985$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const window = (0, $46341108e5b8fdcb$export$407448d2b89b1813)();
    extendParams({
        zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let fakeGestureTouched;
    let fakeGestureMoved;
    const evCache = [];
    const gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, "scale", {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit("zoomChange", value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        const x1 = evCache[0].pageX;
        const y1 = evCache[0].pageY;
        const x2 = evCache[1].pageX;
        const y2 = evCache[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    }
    function getMaxRatio() {
        const params = swiper.params.zoom;
        const maxRatio = gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
        if (params.limitToOriginalSize && gesture.imageEl && gesture.imageEl.naturalWidth) {
            const imageMaxRatio = gesture.imageEl.naturalWidth / gesture.imageEl.offsetWidth;
            return Math.min(imageMaxRatio, maxRatio);
        }
        return maxRatio;
    }
    function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        const box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        const slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter((slideEl)=>slideEl.contains(e.target)).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        const selector = `.${swiper.params.zoom.containerClass}`;
        if (e.target.matches(selector)) return true;
        if ([
            ...swiper.hostEl.querySelectorAll(selector)
        ].filter((containerEl)=>containerEl.contains(e.target)).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === "mouse") evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $2c77a2a8fab70b7a$export$407448d2b89b1813)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = getMaxRatio();
        }
        if (gesture.imageEl) {
            const [originX, originY] = getScaleOrigin();
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = "0ms";
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === "mouse" && e.type === "pointerout") return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    let allowTouchMoveTimeout;
    function allowTouchMove() {
        swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function preventTouchMove() {
        clearTimeout(allowTouchMoveTimeout);
        swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
        allowTouchMoveTimeout = setTimeout(()=>{
            allowTouchMove();
        });
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        const event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            image.startX = (0, $2c77a2a8fab70b7a$export$35e795649ee09318)(gesture.imageWrapEl, "x") || 0;
            image.startY = (0, $2c77a2a8fab70b7a$export$35e795649ee09318)(gesture.imageWrapEl, "y") || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = "0ms";
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        preventTouchMove();
        image.isMoved = true;
        const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        const { originX: originX, originY: originY } = gesture;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
            gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $2c77a2a8fab70b7a$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $2c77a2a8fab70b7a$export$407448d2b89b1813)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.touchAction = "none";
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === "undefined" && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        const forceZoomRatio = typeof e === "number" ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
        }
        const maxRatio = getMaxRatio();
        zoom.scale = forceZoomRatio || maxRatio;
        currentScale = forceZoomRatio || maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $2c77a2a8fab70b7a$export$8b22cf2602fb60ce)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $2c77a2a8fab70b7a$export$8b22cf2602fb60ce)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $2c77a2a8fab70b7a$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $2c77a2a8fab70b7a$export$407448d2b89b1813)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "";
            swiper.wrapperEl.style.touchAction = "";
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
    }
    // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.addEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach((eventName)=>{
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.removeEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach((eventName)=>{
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    }
    on("init", ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on("destroy", ()=>{
        disable();
    });
    on("touchStart", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on("touchEnd", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on("doubleTap", (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on("transitionEnd", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on("slideChange", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}



/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ function $1324801bfbd1bfd3$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: "slide" // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === "slide") {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === "container") {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $2c77a2a8fab70b7a$export$7ccc53e8f1e7dfc5)(()=>{
                    c.updateAutoHeight();
                });
                (0, $2c77a2a8fab70b7a$export$342063e11d6c3cad)(c.wrapperEl, ()=>{
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on("beforeInit", ()=>{
        if (typeof window !== "undefined" && // eslint-disable-line
        (typeof swiper.params.controller.control === "string" || swiper.params.controller.control instanceof HTMLElement)) {
            const controlElements = typeof swiper.params.controller.control === "string" ? [
                ...document.querySelectorAll(swiper.params.controller.control)
            ] : [
                swiper.params.controller.control
            ];
            controlElements.forEach((controlElement)=>{
                if (!swiper.controller.control) swiper.controller.control = [];
                if (controlElement && controlElement.swiper) swiper.controller.control.push(controlElement.swiper);
                else if (controlElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onControllerSwiper = (e)=>{
                        swiper.controller.control.push(e.detail[0]);
                        swiper.update();
                        controlElement.removeEventListener(eventName, onControllerSwiper);
                    };
                    controlElement.addEventListener(eventName, onControllerSwiper);
                }
            });
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on("update", ()=>{
        removeSpline();
    });
    on("resize", ()=>{
        removeSpline();
    });
    on("observerUpdate", ()=>{
        removeSpline();
    });
    on("setTranslate", (_s, translate, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on("setTransition", (_s, duration, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}





function $8e4e6395a236882f$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group",
            id: null,
            scrollOnFocus: true
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    let preventFocusHandler;
    let focusTargetSlideEl;
    let visibilityChangedTimestamp = new Date().getTime();
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        notification.innerHTML = "";
        notification.innerHTML = message;
    }
    function getRandomNumber(size) {
        if (size === void 0) size = 16;
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return "x".repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        el = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("tabIndex", "0");
        });
    }
    function makeElNotFocusable(el) {
        el = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("tabIndex", "-1");
        });
    }
    function addElRole(el, role) {
        el = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("role", role);
        });
    }
    function addElRoleDescription(el, description) {
        el = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-roledescription", description);
        });
    }
    function addElControls(el, controls) {
        el = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-controls", controls);
        });
    }
    function addElLabel(el, label) {
        el = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-label", label);
        });
    }
    function addElId(el, id) {
        el = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("id", id);
        });
    }
    function addElLive(el, live) {
        el = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-live", live);
        });
    }
    function disableEl(el) {
        el = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-disabled", true);
        });
    }
    function enableEl(el) {
        el = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-disabled", false);
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, $718b5e1f3d97595b$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
            const prevEls = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(swiper.navigation.prevEl);
            const nextEls = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(swiper.navigation.nextEl);
            if (nextEls.includes(targetEl)) {
                if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
                if (swiper.isEnd) notify(params.lastSlideMessage);
                else notify(params.nextSlideMessage);
            }
            if (prevEls.includes(targetEl)) {
                if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
                if (swiper.isBeginning) notify(params.firstSlideMessage);
                else notify(params.prevSlideMessage);
            }
        }
        if (swiper.pagination && targetEl.matches((0, $718b5e1f3d97595b$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach((bulletEl)=>{
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, "button");
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, $2c77a2a8fab70b7a$export$dda1d9f60106f0e9)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, $718b5e1f3d97595b$export$db3b6bfb95261072)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute("aria-current", "true");
            else bulletEl.removeAttribute("aria-current");
        });
    }
    const initNavEl = (el, wrapperId, message)=>{
        makeElFocusable(el);
        if (el.tagName !== "BUTTON") {
            addElRole(el, "button");
            el.addEventListener("keydown", onEnterOrSpaceKey);
        }
        addElLabel(el, message);
        addElControls(el, wrapperId);
    };
    const handlePointerDown = (e)=>{
        if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) preventFocusHandler = true;
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        preventFocusHandler = false;
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const onVisibilityChange = (e)=>{
        visibilityChangedTimestamp = new Date().getTime();
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked || !swiper.params.a11y.scrollOnFocus) return;
        if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        focusTargetSlideEl = slideEl;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        requestAnimationFrame(()=>{
            if (preventFocusHandler) return;
            if (swiper.params.loop) swiper.slideToLoop(parseInt(slideEl.getAttribute("data-swiper-slide-index")), 0);
            else swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
            preventFocusHandler = false;
        });
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        const slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach((slideEl, index)=>{
            const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.el.append(liveRegion);
        // Container
        const containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        // Wrapper
        const wrapperEl = swiper.wrapperEl;
        const wrapperId = params.id || wrapperEl.getAttribute("id") || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? "off" : "polite";
        addElId(wrapperEl, wrapperId);
        addElLive(wrapperEl, live);
        // Slide
        initSlides();
        // Navigation
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>initNavEl(el, wrapperId, params.nextSlideMessage));
        if (prevEl) prevEl.forEach((el)=>initNavEl(el, wrapperId, params.prevSlideMessage));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.addEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        // Tab focus
        const document = (0, $46341108e5b8fdcb$export$39b482c5e57630a8)();
        document.addEventListener("visibilitychange", onVisibilityChange);
        swiper.el.addEventListener("focus", handleFocus, true);
        swiper.el.addEventListener("focus", handleFocus, true);
        swiper.el.addEventListener("pointerdown", handlePointerDown, true);
        swiper.el.addEventListener("pointerup", handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>el.removeEventListener("keydown", onEnterOrSpaceKey));
        if (prevEl) prevEl.forEach((el)=>el.removeEventListener("keydown", onEnterOrSpaceKey));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $2c77a2a8fab70b7a$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.removeEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        const document = (0, $46341108e5b8fdcb$export$39b482c5e57630a8)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
        // Tab focus
        if (swiper.el && typeof swiper.el !== "string") {
            swiper.el.removeEventListener("focus", handleFocus, true);
            swiper.el.removeEventListener("pointerdown", handlePointerDown, true);
            swiper.el.removeEventListener("pointerup", handlePointerUp, true);
        }
    }
    on("beforeInit", ()=>{
        liveRegion = (0, $2c77a2a8fab70b7a$export$db3b6bfb95261072)("span", swiper.params.a11y.notificationClass);
        liveRegion.setAttribute("aria-live", "assertive");
        liveRegion.setAttribute("aria-atomic", "true");
    });
    on("afterInit", ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on("slidesLengthChange snapGridLengthChange slidesGridLengthChange", ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on("fromEdge toEdge afterInit lock unlock", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on("paginationUpdate", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on("destroy", ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



function $cce3ea058f3e8e83$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        history: {
            enabled: false,
            root: "",
            replaceState: false,
            key: "slides",
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $46341108e5b8fdcb$export$407448d2b89b1813)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split("/").filter((part)=>part !== "");
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $46341108e5b8fdcb$export$407448d2b89b1813)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${index}"]`) : swiper.slides[index];
        let value = slugify(slide.getAttribute("data-history"));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === "/") root = root.slice(0, root.length - 1);
            value = `${root}/${key ? `${key}/` : ""}${value}`;
        } else if (!location.pathname.includes(key)) value = `${key ? `${key}/` : ""}${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides[i];
            const slideHistory = slugify(slide.getAttribute("data-history"));
            if (slideHistory === value) {
                const index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $46341108e5b8fdcb$export$407448d2b89b1813)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $46341108e5b8fdcb$export$407448d2b89b1813)();
        if (!swiper.params.history.replaceState) window.removeEventListener("popstate", setHistoryPopState);
    };
    on("init", ()=>{
        if (swiper.params.history.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}




function $51dbae5b05e5195b$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, emit: emit, on: on } = _ref;
    let initialized = false;
    const document = (0, $46341108e5b8fdcb$export$39b482c5e57630a8)();
    const window = (0, $46341108e5b8fdcb$export$407448d2b89b1813)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex (_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    const slideWithHash = swiper.slides.filter((slideEl)=>slideEl.getAttribute("data-hash") === hash)[0];
                    if (!slideWithHash) return 0;
                    const index = parseInt(slideWithHash.getAttribute("data-swiper-slide-index"), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, $2c77a2a8fab70b7a$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
            }
        }
    });
    const onHashChange = ()=>{
        emit("hashChange");
        const newHash = document.location.hash.replace("#", "");
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") : "";
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === "undefined" || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") || activeSlideEl.getAttribute("data-history") : "";
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${activeSlideHash}` || "");
            emit("hashSet");
        } else {
            document.location.hash = activeSlideHash || "";
            emit("hashSet");
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace("#", "");
        if (hash) {
            const speed = 0;
            const index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener("hashchange", onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) window.removeEventListener("hashchange", onHashChange);
    };
    on("init", ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHash();
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}



/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ function $35eff46a1051e8a5$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit, params: params } = _ref;
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    let timeout;
    let raf;
    let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayTimeLeft;
    let autoplayStartTime = new Date().getTime();
    let wasPaused;
    let isTouched;
    let pausedByTouch;
    let touchStartTimeout;
    let slideChanged;
    let pausedByInteraction;
    let pausedByPointerEnter;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener("transitionend", onTransitionEnd);
        if (pausedByPointerEnter || e.detail && e.detail.bySwiperTouchMove) return;
        resume();
    }
    const calcTimeLeft = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit("autoplayTimeLeft", timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(()=>{
            calcTimeLeft();
        });
    };
    const getSlideDelay = ()=>{
        let activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.filter((slideEl)=>slideEl.classList.contains("swiper-slide-active"))[0];
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        const currentSlideDelay = parseInt(activeSlideEl.getAttribute("data-swiper-autoplay"), 10);
        return currentSlideDelay;
    };
    const run = (delayForce)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = typeof delayForce === "undefined" ? swiper.params.autoplay.delay : delayForce;
        autoplayDelayTotal = swiper.params.autoplay.delay;
        autoplayDelayCurrent = swiper.params.autoplay.delay;
        const currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === "undefined") {
            delay = currentSlideDelay;
            autoplayDelayTotal = currentSlideDelay;
            autoplayDelayCurrent = currentSlideDelay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = ()=>{
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit("autoplay");
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit("autoplay");
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(()=>{
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                proceed();
            }, delay);
        } else requestAnimationFrame(()=>{
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    const start = ()=>{
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit("autoplayStart");
    };
    const stop = ()=>{
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit("autoplayStop");
    };
    const pause = (internal, reset)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        const proceed = ()=>{
            emit("autoplayPause");
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener("transitionend", onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            if (slideChanged) autoplayTimeLeft = swiper.params.autoplay.delay;
            slideChanged = false;
            proceed();
            return;
        }
        const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    const resume = ()=>{
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit("autoplayResume");
    };
    const onVisibilityChange = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        const document = (0, $46341108e5b8fdcb$export$39b482c5e57630a8)();
        if (document.visibilityState === "hidden") {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === "visible") resume();
    };
    const onPointerEnter = (e)=>{
        if (e.pointerType !== "mouse") return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    const onPointerLeave = (e)=>{
        if (e.pointerType !== "mouse") return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) resume();
    };
    const attachMouseEvents = ()=>{
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener("pointerenter", onPointerEnter);
            swiper.el.addEventListener("pointerleave", onPointerLeave);
        }
    };
    const detachMouseEvents = ()=>{
        if (swiper.el && typeof swiper.el !== "string") {
            swiper.el.removeEventListener("pointerenter", onPointerEnter);
            swiper.el.removeEventListener("pointerleave", onPointerLeave);
        }
    };
    const attachDocumentEvents = ()=>{
        const document = (0, $46341108e5b8fdcb$export$39b482c5e57630a8)();
        document.addEventListener("visibilitychange", onVisibilityChange);
    };
    const detachDocumentEvents = ()=>{
        const document = (0, $46341108e5b8fdcb$export$39b482c5e57630a8)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
    };
    on("init", ()=>{
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on("destroy", ()=>{
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on("_freeModeStaticRelease", ()=>{
        if (pausedByTouch || pausedByInteraction) resume();
    });
    on("_freeModeNoMomentumRelease", ()=>{
        if (!swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on("beforeTransitionStart", (_s, speed, internal)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on("sliderFirstMove", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(()=>{
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on("touchEnd", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on("slideChange", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        slideChanged = true;
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
}




function $eb0143a756c09e8a$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs"
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, $2c77a2a8fab70b7a$export$882b5998b3b9117c)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on("tap", onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach((slideEl)=>slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)(0, $2c77a2a8fab70b7a$export$f1e1789686576879)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl)=>{
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(let i = 0; i < thumbsToActivate; i += 1)if (thumbsSwiper.slides[swiper.realIndex + i]) thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
        }
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            const currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") === `${swiper.realIndex}`)[0];
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
            }
            if (useOffset) newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on("beforeInit", ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === "string" || thumbs.swiper instanceof HTMLElement) {
            const document = (0, $46341108e5b8fdcb$export$39b482c5e57630a8)();
            const getThumbsElementAndInit = ()=>{
                const thumbsElement = typeof thumbs.swiper === "string" ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onThumbsSwiper = (e)=>{
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener(eventName, onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener(eventName, onThumbsSwiper);
                }
                return thumbsElement;
            };
            const watchForThumbsToAppear = ()=>{
                if (swiper.destroyed) return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on("slideChange update resize observerUpdate", ()=>{
        update();
    });
    on("setTransition", (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on("beforeDestroy", ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $bfcd8e91e69621c3$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, emit: emit, once: once } = _ref;
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        const { touchEventsData: data, touches: touches } = swiper;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? "startX" : "startY"],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
            time: (0, $2c77a2a8fab70b7a$export$4368d992c4eafac0)()
        });
    }
    function onTouchEnd(_ref2) {
        let { currentPos: currentPos } = _ref2;
        if (swiper.params.cssMode) return;
        const { params: params, wrapperEl: wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper;
        // Time diff
        const touchEndTime = (0, $2c77a2a8fab70b7a$export$4368d992c4eafac0)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $2c77a2a8fab70b7a$export$4368d992c4eafac0)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next") newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once("transitionEnd", ()=>{
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $2c77a2a8fab70b7a$export$342063e11d6c3cad)(wrapperEl, ()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit("momentumBounce");
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        (0, $2c77a2a8fab70b7a$export$342063e11d6c3cad)(wrapperEl, ()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit("_freeModeNoMomentumRelease");
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $2c77a2a8fab70b7a$export$342063e11d6c3cad)(wrapperEl, ()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit("_freeModeNoMomentumRelease");
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            emit("_freeModeStaticRelease");
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}


function $3b74883d898b0a86$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        grid: {
            rows: 1,
            fill: "column"
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    let wasMultiRow;
    const getSpaceBetween = ()=>{
        let spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
        else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    const initSlides = (slides)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== "auto" && fill === "row") slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    const unsetSlides = ()=>{
        if (swiper.slides) swiper.slides.forEach((slide)=>{
            if (slide.swiperSlideGridSet) {
                slide.style.height = "";
                slide.style[swiper.getDirectionLabel("margin-top")] = "";
            }
        });
    };
    const updateSlide = (i, slide, slides)=>{
        const { slidesPerGroup: slidesPerGroup } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === "row" && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === "column") {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style.height = `calc((100% - ${(rows - 1) * spaceBetween}px) / ${rows})`;
        slide.style[swiper.getDirectionLabel("margin-top")] = row !== 0 ? spaceBetween && `${spaceBetween}px` : "";
        slide.swiperSlideGridSet = true;
    };
    const updateWrapperSize = (slideSize, snapGrid)=>{
        const { centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) swiper.wrapperEl.style[swiper.getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
        if (centeredSlides) {
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            snapGrid.push(...newSlidesGrid);
        }
    };
    const onInit = ()=>{
        wasMultiRow = swiper.params.grid && swiper.params.grid.rows > 1;
    };
    const onUpdate = ()=>{
        const { params: params, el: el } = swiper;
        const isMultiRow = params.grid && params.grid.rows > 1;
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add(`${params.containerModifierClass}grid`);
            if (params.grid.fill === "column") el.classList.add(`${params.containerModifierClass}grid-column`);
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on("init", onInit);
    on("update", onUpdate);
    swiper.grid = {
        initSlides: initSlides,
        unsetSlides: unsetSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}


function $88f0014356ef8162$var$appendSlide(slides) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    const appendElement = (slideEl)=>{
        if (typeof slideEl === "string") {
            const tempDOM = document.createElement("div");
            tempDOM.innerHTML = slideEl;
            slidesEl.append(tempDOM.children[0]);
            tempDOM.innerHTML = "";
        } else slidesEl.append(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function $88f0014356ef8162$var$prependSlide(slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl)=>{
        if (typeof slideEl === "string") {
            const tempDOM = document.createElement("div");
            tempDOM.innerHTML = slideEl;
            slidesEl.prepend(tempDOM.children[0]);
            tempDOM.innerHTML = "";
        } else slidesEl.prepend(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function $88f0014356ef8162$var$addSlide(index, slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) slidesEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)slidesEl.append(slidesBuffer[i]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $88f0014356ef8162$var$removeSlide(slidesIndexes) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $88f0014356ef8162$var$removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function $88f0014356ef8162$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper } = _ref;
    Object.assign(swiper, {
        appendSlide: $88f0014356ef8162$var$appendSlide.bind(swiper),
        prependSlide: $88f0014356ef8162$var$prependSlide.bind(swiper),
        addSlide: $88f0014356ef8162$var$addSlide.bind(swiper),
        removeSlide: $88f0014356ef8162$var$removeSlide.bind(swiper),
        removeAllSlides: $88f0014356ef8162$var$removeAllSlides.bind(swiper)
    });
}


function $7e3a3c09fb41275d$export$f1e1789686576879(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on("beforeInit", ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on("setTranslate", ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on("transitionEnd", ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach((slideEl)=>{
                slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>shadowEl.remove());
            });
            // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on("virtualUpdate", ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}



function $b61f78517acd4639$export$f1e1789686576879(effectParams, slideEl) {
    const transformEl = (0, $2c77a2a8fab70b7a$export$39b482c5e57630a8)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = "hidden";
        transformEl.style["-webkit-backface-visibility"] = "hidden";
    }
    return transformEl;
}



function $53358a0ca889c907$export$f1e1789686576879(_ref) {
    let { swiper: swiper, duration: duration, transformElements: transformElements, allSlides: allSlides } = _ref;
    const { activeIndex: activeIndex } = swiper;
    const getSlide = (el)=>{
        if (!el.parentElement) {
            // assume shadow root
            const slide = swiper.slides.filter((slideEl)=>slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode)[0];
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter((transformEl)=>{
            const el = transformEl.classList.contains("swiper-slide-transform") ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach((el)=>{
            (0, $2c77a2a8fab70b7a$export$342063e11d6c3cad)(el, ()=>{
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new window.CustomEvent("transitionend", {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}



function $e8d552d7d2d634bc$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = swiper.slides[i];
            const offset = slideEl.swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            const targetEl = (0, $b61f78517acd4639$export$f1e1789686576879)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $2c77a2a8fab70b7a$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
        });
        (0, $53358a0ca889c907$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $7e3a3c09fb41275d$export$f1e1789686576879)({
        effect: "fade",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $86377c4757f299de$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = (slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        let shadowAfter = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) {
            shadowBefore = (0, $2c77a2a8fab70b7a$export$db3b6bfb95261072)("div", `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? "left" : "top"}`.split(" "));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $2c77a2a8fab70b7a$export$db3b6bfb95261072)("div", `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? "right" : "bottom"}`.split(" "));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { el: el, wrapperEl: wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const r = (0, $2c77a2a8fab70b7a$export$ae1af26003f05816)(swiper);
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $2c77a2a8fab70b7a$export$db3b6bfb95261072)("div", "swiper-cube-shadow");
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            } else {
                cubeShadowEl = el.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $2c77a2a8fab70b7a$export$db3b6bfb95261072)("div", "swiper-cube-shadow");
                    el.append(cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${r(isHorizontal ? 0 : -slideAngle)}deg) rotateY(${r(isHorizontal ? slideAngle : 0)}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style["-webkit-transform-origin"] = `50% 50% -${swiperSize / 2}px`;
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
            }
        }
        const zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${r(swiper.isHorizontal() ? 0 : wrapperRotate)}deg) rotateY(${r(swiper.isHorizontal() ? -wrapperRotate : 0)}deg)`;
        wrapperEl.style.setProperty("--swiper-cube-translate-z", `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { el: el, slides: slides } = swiper;
        slides.forEach((slideEl)=>{
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((subEl)=>{
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            const shadowEl = el.querySelector(".swiper-cube-shadow");
            if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0, $7e3a3c09fb41275d$export$f1e1789686576879)({
        effect: "cube",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}



function $8549315888a1bac6$export$db3b6bfb95261072(suffix, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ""}${suffix ? ` swiper-slide-shadow-${suffix}` : ""}`;
    const shadowContainer = (0, $2c77a2a8fab70b7a$export$39b482c5e57630a8)(slideEl);
    let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(" ").join(".")}`);
    if (!shadowEl) {
        shadowEl = (0, $2c77a2a8fab70b7a$export$db3b6bfb95261072)("div", shadowClass.split(" "));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}






function $eb95f4a36d72e34a$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    const createSlideShadows = (slideEl, progress)=>{
        let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) shadowBefore = (0, $8549315888a1bac6$export$db3b6bfb95261072)("flip", slideEl, swiper.isHorizontal() ? "left" : "top");
        if (!shadowAfter) shadowAfter = (0, $8549315888a1bac6$export$db3b6bfb95261072)("flip", slideEl, swiper.isHorizontal() ? "right" : "bottom");
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        swiper.params.flipEffect;
        swiper.slides.forEach((slideEl)=>{
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        const rotateFix = (0, $2c77a2a8fab70b7a$export$ae1af26003f05816)(swiper);
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            const offset = slideEl.swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateFix(rotateX)}deg) rotateY(${rotateFix(rotateY)}deg)`;
            const targetEl = (0, $b61f78517acd4639$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $2c77a2a8fab70b7a$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $53358a0ca889c907$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $7e3a3c09fb41275d$export$f1e1789686576879)({
        effect: "flip",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






function $cf3b34a03363ed82$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        const r = (0, $2c77a2a8fab70b7a$export$ae1af26003f05816)(swiper);
        // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === "function" ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === "string" && stretch.indexOf("%") !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${r(rotateX)}deg) rotateY(${r(rotateY)}deg) scale(${scale})`;
            const targetEl = (0, $b61f78517acd4639$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
                let shadowAfterEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
                if (!shadowBeforeEl) shadowBeforeEl = (0, $8549315888a1bac6$export$db3b6bfb95261072)("coverflow", slideEl, isHorizontal ? "left" : "top");
                if (!shadowAfterEl) shadowAfterEl = (0, $8549315888a1bac6$export$db3b6bfb95261072)("coverflow", slideEl, isHorizontal ? "right" : "bottom");
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $2c77a2a8fab70b7a$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0, $7e3a3c09fb41275d$export$f1e1789686576879)({
        effect: "coverflow",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}







function $d057ba983564c53e$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === "string") return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, wrapperEl: wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        const rotateFix = (0, $2c77a2a8fab70b7a$export$ae1af26003f05816)(swiper);
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            const offset = slideEl.swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach((value, index)=>{
                let val = data.rotate[index] * Math.abs(progress * multiplier);
                r[index] = val;
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(", ");
            const rotateString = `rotateX(${rotateFix(r[0])}deg) rotateY(${rotateFix(r[1])}deg) rotateZ(${rotateFix(r[2])}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if (custom && data.shadow || !custom) {
                let shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl && data.shadow) shadowEl = (0, $8549315888a1bac6$export$db3b6bfb95261072)("creative", slideEl);
                if (shadowEl) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const targetEl = (0, $b61f78517acd4639$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $2c77a2a8fab70b7a$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $53358a0ca889c907$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $7e3a3c09fb41275d$export$f1e1789686576879)({
        effect: "creative",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}







function $085dbd3118ef206c$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex, rtlTranslate: rtl } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? "-" : "+"} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px ${rtl ? "-" : "+"} (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            /* eslint-disable */ const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl) shadowEl = (0, $8549315888a1bac6$export$db3b6bfb95261072)("cards", slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const targetEl = (0, $b61f78517acd4639$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $2c77a2a8fab70b7a$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $53358a0ca889c907$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $7e3a3c09fb41275d$export$f1e1789686576879)({
        effect: "cards",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




class $43e69f558dbbb285$export$2e2bcd8739ae039 {
    init() {
        this.slider = new (0, $731acbcb25ce319f$export$25ce5a424b770e84)(this._swiper, {
            slidesPerView: 1,
            loop: true,
            spaceBetween: 24,
            modules: [
                (0, $ad4c197f78da2876$export$2e2bcd8739ae039)
            ],
            pagination: {
                el: this._pagination,
                type: "bullets",
                clickable: true
            },
            breakpoints: {
                768: {
                    slidesPerView: parseInt(this._wrapper.getAttribute("data-perview"))
                }
            }
        });
    }
    constructor(element){
        this._wrapper = element;
        this._swiper = this._wrapper.querySelector(".swiper");
        this._pagination = this._wrapper.querySelector(".swiper-pagination");
        this.init();
    }
}



var $1Kv2u = parcelRequire("1Kv2u");
/*!
 * CSSPlugin 3.12.2
 * https://greensock.com
 *
 * Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $1Kv2u = parcelRequire("1Kv2u");
var $f70736198bffeea0$var$_win, $f70736198bffeea0$var$_doc, $f70736198bffeea0$var$_docElement, $f70736198bffeea0$var$_pluginInitted, $f70736198bffeea0$var$_tempDiv, $f70736198bffeea0$var$_tempDivStyler, $f70736198bffeea0$var$_recentSetterPlugin, $f70736198bffeea0$var$_reverting, $f70736198bffeea0$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $f70736198bffeea0$var$_transformProps = {}, $f70736198bffeea0$var$_RAD2DEG = 180 / Math.PI, $f70736198bffeea0$var$_DEG2RAD = Math.PI / 180, $f70736198bffeea0$var$_atan2 = Math.atan2, $f70736198bffeea0$var$_bigNum = 1e8, $f70736198bffeea0$var$_capsExp = /([A-Z])/g, $f70736198bffeea0$var$_horizontalExp = /(left|right|width|margin|padding|x)/i, $f70736198bffeea0$var$_complexExp = /[\s,\(]\S/, $f70736198bffeea0$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $f70736198bffeea0$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $f70736198bffeea0$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $f70736198bffeea0$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$f70736198bffeea0$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $f70736198bffeea0$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $f70736198bffeea0$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $f70736198bffeea0$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $f70736198bffeea0$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $f70736198bffeea0$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $f70736198bffeea0$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $f70736198bffeea0$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $f70736198bffeea0$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $f70736198bffeea0$var$_transformProp = "transform", $f70736198bffeea0$var$_transformOriginProp = $f70736198bffeea0$var$_transformProp + "Origin", $f70736198bffeea0$var$_saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style;
    if (property in $f70736198bffeea0$var$_transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = $f70736198bffeea0$var$_propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = $f70736198bffeea0$var$_get(target, a);
            }) : this.tfm[property] = target._gsap.x ? target._gsap[property] : $f70736198bffeea0$var$_get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
        } else return $f70736198bffeea0$var$_propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf($f70736198bffeea0$var$_transformProp) >= 0) return;
        if (target._gsap.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push($f70736198bffeea0$var$_transformOriginProp, isNotCSS, "");
        }
        property = $f70736198bffeea0$var$_transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, $f70736198bffeea0$var$_removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, $f70736198bffeea0$var$_revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3)// stored like this: property, isNotCSS, value
    props[i + 1] ? target[props[i]] = props[i + 2] : props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace($f70736198bffeea0$var$_capsExp, "-$1").toLowerCase());
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = $f70736198bffeea0$var$_reverting();
        if ((!i || !i.isStart) && !style[$f70736198bffeea0$var$_transformProp]) {
            $f70736198bffeea0$var$_removeIndependentTransforms(style);
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, $f70736198bffeea0$var$_getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: $f70736198bffeea0$var$_revertStyle,
        save: $f70736198bffeea0$var$_saveStyle
    };
    target._gsap || (0, $1Kv2u.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && properties.split(",").forEach(function(p) {
        return saver.save(p);
    });
    return saver;
}, $f70736198bffeea0$var$_supports3D, $f70736198bffeea0$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $f70736198bffeea0$var$_doc.createElementNS ? $f70736198bffeea0$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $f70736198bffeea0$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e.style ? e : $f70736198bffeea0$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://greensock.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $f70736198bffeea0$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($f70736198bffeea0$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $f70736198bffeea0$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $f70736198bffeea0$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $f70736198bffeea0$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $f70736198bffeea0$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($f70736198bffeea0$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $f70736198bffeea0$var$_prefixes[i] : "") + property;
}, $f70736198bffeea0$var$_initCore = function _initCore() {
    if ($f70736198bffeea0$var$_windowExists() && window.document) {
        $f70736198bffeea0$var$_win = window;
        $f70736198bffeea0$var$_doc = $f70736198bffeea0$var$_win.document;
        $f70736198bffeea0$var$_docElement = $f70736198bffeea0$var$_doc.documentElement;
        $f70736198bffeea0$var$_tempDiv = $f70736198bffeea0$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $f70736198bffeea0$var$_tempDivStyler = $f70736198bffeea0$export$a232bb0480ae674a("div");
        $f70736198bffeea0$var$_transformProp = $f70736198bffeea0$export$8cbef5dd49a09c8b($f70736198bffeea0$var$_transformProp);
        $f70736198bffeea0$var$_transformOriginProp = $f70736198bffeea0$var$_transformProp + "Origin";
        $f70736198bffeea0$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $f70736198bffeea0$var$_supports3D = !!$f70736198bffeea0$export$8cbef5dd49a09c8b("perspective");
        $f70736198bffeea0$var$_reverting = (0, $1Kv2u.gsap).core.reverting;
        $f70736198bffeea0$var$_pluginInitted = 1;
    }
}, $f70736198bffeea0$var$_getBBoxHack = function _getBBoxHack(swapIfPossible) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var svg = $f70736198bffeea0$export$a232bb0480ae674a("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), oldParent = this.parentNode, oldSibling = this.nextSibling, oldCSS = this.style.cssText, bbox;
    $f70736198bffeea0$var$_docElement.appendChild(svg);
    svg.appendChild(this);
    this.style.display = "block";
    if (swapIfPossible) try {
        bbox = this.getBBox();
        this._gsapBBox = this.getBBox; //store the original
        this.getBBox = _getBBoxHack;
    } catch (e) {}
    else if (this._gsapBBox) bbox = this._gsapBBox();
    if (oldParent) {
        if (oldSibling) oldParent.insertBefore(this, oldSibling);
        else oldParent.appendChild(this);
    }
    $f70736198bffeea0$var$_docElement.removeChild(svg);
    this.style.cssText = oldCSS;
    return bbox;
}, $f70736198bffeea0$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $f70736198bffeea0$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $f70736198bffeea0$var$_getBBoxHack.call(target, true);
    }
    bounds && (bounds.width || bounds.height) || target.getBBox === $f70736198bffeea0$var$_getBBoxHack || (bounds = $f70736198bffeea0$var$_getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$f70736198bffeea0$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$f70736198bffeea0$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $f70736198bffeea0$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $f70736198bffeea0$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$f70736198bffeea0$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style;
        if (property in $f70736198bffeea0$var$_transformProps && property !== $f70736198bffeea0$var$_transformOriginProp) property = $f70736198bffeea0$var$_transformProp;
        if (style.removeProperty) {
            if (property.substr(0, 2) === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(property.replace($f70736198bffeea0$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $f70736198bffeea0$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $1Kv2u.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $f70736198bffeea0$var$_renderNonTweeningValueOnlyAtEnd : $f70736198bffeea0$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $f70736198bffeea0$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, $f70736198bffeea0$var$_nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$f70736198bffeea0$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $f70736198bffeea0$var$_tempDiv.style, horizontal = $f70736198bffeea0$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $f70736198bffeea0$var$_nonConvertibleUnits[unit] || $f70736198bffeea0$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $f70736198bffeea0$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($f70736198bffeea0$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $1Kv2u._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $f70736198bffeea0$var$_doc || !parent.appendChild) parent = $f70736198bffeea0$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $1Kv2u._ticker).time && !cache.uncache) return (0, $1Kv2u._round)(curValue / cache.width * amount);
    else {
        (toPercent || curUnit === "%") && !$f70736198bffeea0$var$_nonStandardLayouts[$f70736198bffeea0$var$_getComputedProperty(parent, "display")] && (style.position = $f70736198bffeea0$var$_getComputedProperty(target, "position"));
        parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
        parent.appendChild($f70736198bffeea0$var$_tempDiv);
        px = $f70736198bffeea0$var$_tempDiv[measureProperty];
        parent.removeChild($f70736198bffeea0$var$_tempDiv);
        style.position = "absolute";
        if (horizontal && toPercent) {
            cache = (0, $1Kv2u._getCache)(parent);
            cache.time = (0, $1Kv2u._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $1Kv2u._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $f70736198bffeea0$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $f70736198bffeea0$var$_pluginInitted || $f70736198bffeea0$var$_initCore();
    if (property in $f70736198bffeea0$var$_propertyAliases && property !== "transform") {
        property = $f70736198bffeea0$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($f70736198bffeea0$var$_transformProps[property] && property !== "transform") {
        value = $f70736198bffeea0$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : $f70736198bffeea0$var$_firstTwoOnly($f70736198bffeea0$var$_getComputedProperty(target, $f70736198bffeea0$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $f70736198bffeea0$var$_specialProps[property] && $f70736198bffeea0$var$_specialProps[property](target, property, unit) || $f70736198bffeea0$var$_getComputedProperty(target, property) || (0, $1Kv2u._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $f70736198bffeea0$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $f70736198bffeea0$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://greensock.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $f70736198bffeea0$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $f70736198bffeea0$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $f70736198bffeea0$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://greensock.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $1Kv2u.PropTween)(this._pt, target.style, prop, 0, 1, (0, $1Kv2u._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end === "auto") {
        target.style[prop] = end;
        end = $f70736198bffeea0$var$_getComputedProperty(target, prop) || end;
        target.style[prop] = start;
    }
    a = [
        start,
        end
    ];
    (0, $1Kv2u._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $1Kv2u._numWithUnitExp)) || [];
    endValues = end.match((0, $1Kv2u._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, $1Kv2u._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, $1Kv2u._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $1Kv2u._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $1Kv2u._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $f70736198bffeea0$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $f70736198bffeea0$var$_renderNonTweeningValueOnlyAtEnd : $f70736198bffeea0$var$_renderNonTweeningValue;
    (0, $1Kv2u._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $f70736198bffeea0$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $f70736198bffeea0$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $f70736198bffeea0$var$_keywordToPercent[x] || x;
    split[1] = $f70736198bffeea0$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $f70736198bffeea0$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($f70736198bffeea0$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $f70736198bffeea0$var$_transformOriginProp : $f70736198bffeea0$var$_transformProp;
                }
                $f70736198bffeea0$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $f70736198bffeea0$var$_removeProperty(target, $f70736198bffeea0$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                $f70736198bffeea0$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                $f70736198bffeea0$var$_removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$f70736198bffeea0$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $1Kv2u.PropTween)(plugin._pt, target, property, 0, 0, $f70736198bffeea0$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $f70736198bffeea0$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $f70736198bffeea0$var$_rotationalProperties = {}, $f70736198bffeea0$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $f70736198bffeea0$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $f70736198bffeea0$var$_getComputedProperty(target, $f70736198bffeea0$var$_transformProp);
    return $f70736198bffeea0$var$_isNullTransform(matrixString) ? $f70736198bffeea0$var$_identity2DMatrix : matrixString.substr(7).match((0, $1Kv2u._numExp)).map((0, $1Kv2u._round));
}, $f70736198bffeea0$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $1Kv2u._getCache)(target), style = target.style, matrix = $f70736198bffeea0$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $f70736198bffeea0$var$_identity2DMatrix : matrix;
    } else if (matrix === $f70736198bffeea0$var$_identity2DMatrix && !target.offsetParent && target !== $f70736198bffeea0$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            $f70736198bffeea0$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $f70736198bffeea0$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $f70736198bffeea0$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $f70736198bffeea0$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $f70736198bffeea0$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $f70736198bffeea0$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $f70736198bffeea0$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin);
    } else if (matrix !== $f70736198bffeea0$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y;
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$f70736198bffeea0$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $f70736198bffeea0$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $f70736198bffeea0$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $f70736198bffeea0$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $f70736198bffeea0$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $f70736198bffeea0$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $1Kv2u.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = $f70736198bffeea0$var$_getComputedProperty(target, $f70736198bffeea0$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $f70736198bffeea0$var$_isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[$f70736198bffeea0$var$_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[$f70736198bffeea0$var$_transformProp] !== "none" ? cs[$f70736198bffeea0$var$_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = $f70736198bffeea0$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        $f70736198bffeea0$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $f70736198bffeea0$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $f70736198bffeea0$var$_atan2(b, a) * $f70736198bffeea0$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $f70736198bffeea0$var$_atan2(c, d) * $f70736198bffeea0$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * $f70736198bffeea0$var$_DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $f70736198bffeea0$var$_atan2(a32, a33);
            rotationX = angle * $f70736198bffeea0$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $f70736198bffeea0$var$_atan2(-c, a33);
            rotationY = angle * $f70736198bffeea0$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $f70736198bffeea0$var$_atan2(b, a);
            rotation = angle * $f70736198bffeea0$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $1Kv2u._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $1Kv2u._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $f70736198bffeea0$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $f70736198bffeea0$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$f70736198bffeea0$var$_isNullTransform($f70736198bffeea0$var$_getComputedProperty(target, $f70736198bffeea0$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $1Kv2u._round)(scaleX);
    cache.scaleY = (0, $1Kv2u._round)(scaleY);
    cache.rotation = (0, $1Kv2u._round)(rotation) + deg;
    cache.rotationX = (0, $1Kv2u._round)(rotationX) + deg;
    cache.rotationY = (0, $1Kv2u._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || 0) style[$f70736198bffeea0$var$_transformOriginProp] = $f70736198bffeea0$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $1Kv2u._config).force3D;
    cache.renderTransform = cache.svg ? $f70736198bffeea0$var$_renderSVGTransforms : $f70736198bffeea0$var$_supports3D ? $f70736198bffeea0$var$_renderCSSTransforms : $f70736198bffeea0$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $f70736198bffeea0$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$f70736198bffeea0$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $1Kv2u.getUnit)(start);
    return (0, $1Kv2u._round)(parseFloat(start) + parseFloat($f70736198bffeea0$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $f70736198bffeea0$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $f70736198bffeea0$var$_renderCSSTransforms(ratio, cache);
}, $f70736198bffeea0$var$_zeroDeg = "0deg", $f70736198bffeea0$var$_zeroPx = "0px", $f70736198bffeea0$var$_endParenthesis = ") ", $f70736198bffeea0$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $f70736198bffeea0$var$_zeroDeg || rotationY !== $f70736198bffeea0$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $f70736198bffeea0$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $f70736198bffeea0$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $f70736198bffeea0$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $f70736198bffeea0$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $f70736198bffeea0$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $f70736198bffeea0$var$_zeroPx) transforms += "perspective(" + transformPerspective + $f70736198bffeea0$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $f70736198bffeea0$var$_zeroPx || y !== $f70736198bffeea0$var$_zeroPx || z !== $f70736198bffeea0$var$_zeroPx) transforms += z !== $f70736198bffeea0$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $f70736198bffeea0$var$_endParenthesis;
    if (rotation !== $f70736198bffeea0$var$_zeroDeg) transforms += "rotate(" + rotation + $f70736198bffeea0$var$_endParenthesis;
    if (rotationY !== $f70736198bffeea0$var$_zeroDeg) transforms += "rotateY(" + rotationY + $f70736198bffeea0$var$_endParenthesis;
    if (rotationX !== $f70736198bffeea0$var$_zeroDeg) transforms += "rotateX(" + rotationX + $f70736198bffeea0$var$_endParenthesis;
    if (skewX !== $f70736198bffeea0$var$_zeroDeg || skewY !== $f70736198bffeea0$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $f70736198bffeea0$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $f70736198bffeea0$var$_endParenthesis;
    target.style[$f70736198bffeea0$var$_transformProp] = transforms || "translate(0, 0)";
}, $f70736198bffeea0$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $f70736198bffeea0$var$_DEG2RAD;
        skewX *= $f70736198bffeea0$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $f70736198bffeea0$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $1Kv2u._round)(a11);
        a21 = (0, $1Kv2u._round)(a21);
        a12 = (0, $1Kv2u._round)(a12);
        a22 = (0, $1Kv2u._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $f70736198bffeea0$var$_convertToUnit(target, "x", x, "px");
        ty = $f70736198bffeea0$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $1Kv2u._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $1Kv2u._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $1Kv2u._round)(tx + xPercent / 100 * temp.width);
        ty = (0, $1Kv2u._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$f70736198bffeea0$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, $f70736198bffeea0$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, $1Kv2u._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $f70736198bffeea0$var$_RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $f70736198bffeea0$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $f70736198bffeea0$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $1Kv2u.PropTween)(plugin._pt, target, property, startNum, change, $f70736198bffeea0$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $f70736198bffeea0$var$_assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, $f70736198bffeea0$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = $f70736198bffeea0$var$_assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[$f70736198bffeea0$var$_transformProp] = transforms;
        endCache = $f70736198bffeea0$var$_parseTransform(target, 1);
        $f70736198bffeea0$var$_removeProperty(target, $f70736198bffeea0$var$_transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[$f70736198bffeea0$var$_transformProp];
        style[$f70736198bffeea0$var$_transformProp] = transforms;
        endCache = $f70736198bffeea0$var$_parseTransform(target, 1);
        style[$f70736198bffeea0$var$_transformProp] = startValue;
    }
    for(p in $f70736198bffeea0$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $1Kv2u.getUnit)(startValue);
            endUnit = (0, $1Kv2u.getUnit)(endValue);
            startNum = startUnit !== endUnit ? $f70736198bffeea0$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $1Kv2u.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, $f70736198bffeea0$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $f70736198bffeea0$var$_assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $1Kv2u._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $f70736198bffeea0$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $f70736198bffeea0$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $f70736198bffeea0$export$855822f522f18eef = {
    name: "css",
    register: $f70736198bffeea0$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps;
        $f70736198bffeea0$var$_pluginInitted || $f70736198bffeea0$var$_initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || $f70736198bffeea0$var$_getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $1Kv2u._plugins)[p] && (0, $1Kv2u._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $f70736198bffeea0$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $1Kv2u._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, $1Kv2u._colorExp).lastIndex = 0;
                if (!(0, $1Kv2u._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, $1Kv2u.getUnit)(startValue);
                    endUnit = (0, $1Kv2u.getUnit)(endValue);
                }
                endUnit ? startUnit !== endUnit && (startValue = $f70736198bffeea0$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, $1Kv2u._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, $1Kv2u._replaceRandom)(startValue));
                    (0, $1Kv2u.getUnit)(startValue + "") || (startValue += (0, $1Kv2u._config).units[p] || (0, $1Kv2u.getUnit)($f70736198bffeea0$var$_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $f70736198bffeea0$var$_get(target, p)); // can't work with relative values
                } else startValue = $f70736198bffeea0$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $f70736198bffeea0$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $f70736198bffeea0$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        $f70736198bffeea0$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $f70736198bffeea0$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $f70736198bffeea0$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $f70736198bffeea0$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $1Kv2u.PropTween)(this._pt, style, $f70736198bffeea0$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $1Kv2u.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, $1Kv2u._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, $f70736198bffeea0$var$_renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push($f70736198bffeea0$var$_transformOriginProp, 0, style[$f70736198bffeea0$var$_transformOriginProp]);
                        endValue = $f70736198bffeea0$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $f70736198bffeea0$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $f70736198bffeea0$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $f70736198bffeea0$var$_addNonTweeningPT(this, style, p, $f70736198bffeea0$var$_firstTwoOnly(startValue), $f70736198bffeea0$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $f70736198bffeea0$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $f70736198bffeea0$var$_rotationalProperties) {
                        $f70736198bffeea0$var$_addRotationalPropTween(this, cache, p, startNum, relative ? (0, $1Kv2u._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $f70736198bffeea0$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $f70736198bffeea0$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $f70736198bffeea0$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$f70736198bffeea0$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $1Kv2u.getUnit)(endValue) || (p in (0, $1Kv2u._config).units ? (0, $1Kv2u._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $f70736198bffeea0$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $1Kv2u.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, $1Kv2u._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $f70736198bffeea0$var$_renderRoundedCSSProp : $f70736198bffeea0$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $f70736198bffeea0$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, $1Kv2u._missingPlugin)(p, endValue);
                        continue;
                    }
                } else $f70736198bffeea0$var$_tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, $1Kv2u._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$f70736198bffeea0$var$_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: $f70736198bffeea0$var$_get,
    aliases: $f70736198bffeea0$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $f70736198bffeea0$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $f70736198bffeea0$var$_transformProps && property !== $f70736198bffeea0$var$_transformOriginProp && (target._gsap.x || $f70736198bffeea0$var$_get(target, "x")) ? plugin && $f70736198bffeea0$var$_recentSetterPlugin === plugin ? property === "scale" ? $f70736198bffeea0$var$_setterScale : $f70736198bffeea0$var$_setterTransform : ($f70736198bffeea0$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $f70736198bffeea0$var$_setterScaleWithRender : $f70736198bffeea0$var$_setterTransformWithRender) : target.style && !(0, $1Kv2u._isUndefined)(target.style[property]) ? $f70736198bffeea0$var$_setterCSSStyle : ~property.indexOf("-") ? $f70736198bffeea0$var$_setterCSSProp : (0, $1Kv2u._getSetter)(target, property);
    },
    core: {
        _removeProperty: $f70736198bffeea0$var$_removeProperty,
        _getMatrix: $f70736198bffeea0$var$_getMatrix
    }
};
(0, $1Kv2u.gsap).utils.checkPrefix = $f70736198bffeea0$export$8cbef5dd49a09c8b;
(0, $1Kv2u.gsap).core.getStyleSaver = $f70736198bffeea0$var$_getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $1Kv2u._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        $f70736198bffeea0$var$_transformProps[name] = 1;
    });
    (0, $1Kv2u._forEachName)(rotation, function(name) {
        (0, $1Kv2u._config).units[name] = "deg";
        $f70736198bffeea0$var$_rotationalProperties[name] = 1;
    });
    $f70736198bffeea0$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $1Kv2u._forEachName)(aliases, function(name) {
        var split = name.split(":");
        $f70736198bffeea0$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $1Kv2u._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $1Kv2u._config).units[name] = "px";
});
(0, $1Kv2u.gsap).registerPlugin($f70736198bffeea0$export$855822f522f18eef);


var $35069e6098950ce3$export$99ee26438460406a = (0, $1Kv2u.gsap).registerPlugin((0, $f70736198bffeea0$export$855822f522f18eef)) || (0, $1Kv2u.gsap), // to protect from tree shaking
$35069e6098950ce3$export$7b23975ad686bf91 = $35069e6098950ce3$export$99ee26438460406a.core.Tween;


/*!
 * ScrollTrigger 3.12.2
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ function $62ae116bd3942e88$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $62ae116bd3942e88$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $62ae116bd3942e88$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $62ae116bd3942e88$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/*!
 * Observer 3.12.2
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $62ae116bd3942e88$var$gsap, $62ae116bd3942e88$var$_coreInitted, $62ae116bd3942e88$var$_clamp, $62ae116bd3942e88$var$_win, $62ae116bd3942e88$var$_doc, $62ae116bd3942e88$var$_docEl, $62ae116bd3942e88$var$_body, $62ae116bd3942e88$var$_isTouch, $62ae116bd3942e88$var$_pointerType, $62ae116bd3942e88$var$ScrollTrigger, $62ae116bd3942e88$var$_root, $62ae116bd3942e88$var$_normalizer, $62ae116bd3942e88$var$_eventTypes, $62ae116bd3942e88$var$_context, $62ae116bd3942e88$var$_getGSAP = function _getGSAP() {
    return $62ae116bd3942e88$var$gsap || typeof window !== "undefined" && ($62ae116bd3942e88$var$gsap = window.gsap) && $62ae116bd3942e88$var$gsap.registerPlugin && $62ae116bd3942e88$var$gsap;
}, $62ae116bd3942e88$var$_startup = 1, $62ae116bd3942e88$var$_observers = [], $62ae116bd3942e88$export$3cd1cee43d19b683 = [], $62ae116bd3942e88$export$d8e56d510a804d0a = [], $62ae116bd3942e88$var$_getTime = Date.now, $62ae116bd3942e88$var$_bridge = function _bridge(name, value) {
    return value;
}, $62ae116bd3942e88$var$_integrate = function _integrate() {
    var core = $62ae116bd3942e88$var$ScrollTrigger.core, data = core.bridge || {}, scrollers = core._scrollers, proxies = core._proxies;
    scrollers.push.apply(scrollers, $62ae116bd3942e88$export$3cd1cee43d19b683);
    proxies.push.apply(proxies, $62ae116bd3942e88$export$d8e56d510a804d0a);
    $62ae116bd3942e88$export$3cd1cee43d19b683 = scrollers;
    $62ae116bd3942e88$export$d8e56d510a804d0a = proxies;
    $62ae116bd3942e88$var$_bridge = function _bridge(name, value) {
        return data[name](value);
    };
}, $62ae116bd3942e88$export$6078f1ef08b38af9 = function _getProxyProp(element, property) {
    return ~$62ae116bd3942e88$export$d8e56d510a804d0a.indexOf(element) && $62ae116bd3942e88$export$d8e56d510a804d0a[$62ae116bd3942e88$export$d8e56d510a804d0a.indexOf(element) + 1][property];
}, $62ae116bd3942e88$export$4330f3a92e5d2e94 = function _isViewport(el) {
    return !!~$62ae116bd3942e88$var$_root.indexOf(el);
}, $62ae116bd3942e88$var$_addListener = function _addListener(element, type, func, nonPassive, capture) {
    return element.addEventListener(type, func, {
        passive: !nonPassive,
        capture: !!capture
    });
}, $62ae116bd3942e88$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $62ae116bd3942e88$var$_scrollLeft = "scrollLeft", $62ae116bd3942e88$var$_scrollTop = "scrollTop", $62ae116bd3942e88$var$_onScroll = function _onScroll() {
    return $62ae116bd3942e88$var$_normalizer && $62ae116bd3942e88$var$_normalizer.isPressed || $62ae116bd3942e88$export$3cd1cee43d19b683.cache++;
}, $62ae116bd3942e88$var$_scrollCacheFunc = function _scrollCacheFunc(f, doNotCache) {
    var cachingFunc = function cachingFunc(value) {
        // since reading the scrollTop/scrollLeft/pageOffsetY/pageOffsetX can trigger a layout, this function allows us to cache the value so it only gets read fresh after a "scroll" event fires (or while we're refreshing because that can lengthen the page and alter the scroll position). when "soft" is true, that means don't actually set the scroll, but cache the new value instead (useful in ScrollSmoother)
        if (value || value === 0) {
            $62ae116bd3942e88$var$_startup && ($62ae116bd3942e88$var$_win.history.scrollRestoration = "manual"); // otherwise the new position will get overwritten by the browser onload.
            var isNormalizing = $62ae116bd3942e88$var$_normalizer && $62ae116bd3942e88$var$_normalizer.isPressed;
            value = cachingFunc.v = Math.round(value) || ($62ae116bd3942e88$var$_normalizer && $62ae116bd3942e88$var$_normalizer.iOS ? 1 : 0); //TODO: iOS Bug: if you allow it to go to 0, Safari can start to report super strange (wildly inaccurate) touch positions!
            f(value);
            cachingFunc.cacheID = $62ae116bd3942e88$export$3cd1cee43d19b683.cache;
            isNormalizing && $62ae116bd3942e88$var$_bridge("ss", value); // set scroll (notify ScrollTrigger so it can dispatch a "scrollStart" event if necessary
        } else if (doNotCache || $62ae116bd3942e88$export$3cd1cee43d19b683.cache !== cachingFunc.cacheID || $62ae116bd3942e88$var$_bridge("ref")) {
            cachingFunc.cacheID = $62ae116bd3942e88$export$3cd1cee43d19b683.cache;
            cachingFunc.v = f();
        }
        return cachingFunc.v + cachingFunc.offset;
    };
    cachingFunc.offset = 0;
    return f && cachingFunc;
}, $62ae116bd3942e88$export$b2cabb342cb0ebe1 = {
    s: $62ae116bd3942e88$var$_scrollLeft,
    p: "left",
    p2: "Left",
    os: "right",
    os2: "Right",
    d: "width",
    d2: "Width",
    a: "x",
    sc: $62ae116bd3942e88$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $62ae116bd3942e88$var$_win.scrollTo(value, $62ae116bd3942e88$export$8e40fc98ff518e9d.sc()) : $62ae116bd3942e88$var$_win.pageXOffset || $62ae116bd3942e88$var$_doc[$62ae116bd3942e88$var$_scrollLeft] || $62ae116bd3942e88$var$_docEl[$62ae116bd3942e88$var$_scrollLeft] || $62ae116bd3942e88$var$_body[$62ae116bd3942e88$var$_scrollLeft] || 0;
    })
}, $62ae116bd3942e88$export$8e40fc98ff518e9d = {
    s: $62ae116bd3942e88$var$_scrollTop,
    p: "top",
    p2: "Top",
    os: "bottom",
    os2: "Bottom",
    d: "height",
    d2: "Height",
    a: "y",
    op: $62ae116bd3942e88$export$b2cabb342cb0ebe1,
    sc: $62ae116bd3942e88$var$_scrollCacheFunc(function(value) {
        return arguments.length ? $62ae116bd3942e88$var$_win.scrollTo($62ae116bd3942e88$export$b2cabb342cb0ebe1.sc(), value) : $62ae116bd3942e88$var$_win.pageYOffset || $62ae116bd3942e88$var$_doc[$62ae116bd3942e88$var$_scrollTop] || $62ae116bd3942e88$var$_docEl[$62ae116bd3942e88$var$_scrollTop] || $62ae116bd3942e88$var$_body[$62ae116bd3942e88$var$_scrollTop] || 0;
    })
}, $62ae116bd3942e88$export$937374fea3f88711 = function _getTarget(t, self) {
    return (self && self._ctx && self._ctx.selector || $62ae116bd3942e88$var$gsap.utils.toArray)(t)[0] || (typeof t === "string" && $62ae116bd3942e88$var$gsap.config().nullTargetWarn !== false ? console.warn("Element not found:", t) : null);
}, $62ae116bd3942e88$export$8665aac53dad5647 = function _getScrollFunc(element, _ref) {
    var s = _ref.s, sc = _ref.sc;
    // we store the scroller functions in an alternating sequenced Array like [element, verticalScrollFunc, horizontalScrollFunc, ...] so that we can minimize memory, maximize performance, and we also record the last position as a ".rec" property in order to revert to that after refreshing to ensure things don't shift around.
    $62ae116bd3942e88$export$4330f3a92e5d2e94(element) && (element = $62ae116bd3942e88$var$_doc.scrollingElement || $62ae116bd3942e88$var$_docEl);
    var i = $62ae116bd3942e88$export$3cd1cee43d19b683.indexOf(element), offset = sc === $62ae116bd3942e88$export$8e40fc98ff518e9d.sc ? 1 : 2;
    !~i && (i = $62ae116bd3942e88$export$3cd1cee43d19b683.push(element) - 1);
    $62ae116bd3942e88$export$3cd1cee43d19b683[i + offset] || $62ae116bd3942e88$var$_addListener(element, "scroll", $62ae116bd3942e88$var$_onScroll); // clear the cache when a scroll occurs
    var prev = $62ae116bd3942e88$export$3cd1cee43d19b683[i + offset], func = prev || ($62ae116bd3942e88$export$3cd1cee43d19b683[i + offset] = $62ae116bd3942e88$var$_scrollCacheFunc($62ae116bd3942e88$export$6078f1ef08b38af9(element, s), true) || ($62ae116bd3942e88$export$4330f3a92e5d2e94(element) ? sc : $62ae116bd3942e88$var$_scrollCacheFunc(function(value) {
        return arguments.length ? element[s] = value : element[s];
    })));
    func.target = element;
    prev || (func.smooth = $62ae116bd3942e88$var$gsap.getProperty(element, "scrollBehavior") === "smooth"); // only set it the first time (don't reset every time a scrollFunc is requested because perhaps it happens during a refresh() when it's disabled in ScrollTrigger.
    return func;
}, $62ae116bd3942e88$export$5de019f4480f0f8d = function _getVelocityProp(value, minTimeRefresh, useDelta) {
    var v1 = value, v2 = value, t1 = $62ae116bd3942e88$var$_getTime(), t2 = t1, min = minTimeRefresh || 50, dropToZeroTime = Math.max(500, min * 3), update = function update(value, force) {
        var t = $62ae116bd3942e88$var$_getTime();
        if (force || t - t1 > min) {
            v2 = v1;
            v1 = value;
            t2 = t1;
            t1 = t;
        } else if (useDelta) v1 += value;
        else // not totally necessary, but makes it a bit more accurate by adjusting the v1 value according to the new slope. This way we're not just ignoring the incoming data. Removing for now because it doesn't seem to make much practical difference and it's probably not worth the kb.
        v1 = v2 + (value - v2) / (t - t2) * (t1 - t2);
    }, reset = function reset() {
        v2 = v1 = useDelta ? 0 : v1;
        t2 = t1 = 0;
    }, getVelocity = function getVelocity(latestValue) {
        var tOld = t2, vOld = v2, t = $62ae116bd3942e88$var$_getTime();
        (latestValue || latestValue === 0) && latestValue !== v1 && update(latestValue);
        return t1 === t2 || t - t2 > dropToZeroTime ? 0 : (v1 + (useDelta ? vOld : -vOld)) / ((useDelta ? t : t1) - tOld) * 1000;
    };
    return {
        update: update,
        reset: reset,
        getVelocity: getVelocity
    };
}, $62ae116bd3942e88$var$_getEvent = function _getEvent(e, preventDefault) {
    preventDefault && !e._gsapAllow && e.preventDefault();
    return e.changedTouches ? e.changedTouches[0] : e;
}, $62ae116bd3942e88$var$_getAbsoluteMax = function _getAbsoluteMax(a) {
    var max = Math.max.apply(Math, a), min = Math.min.apply(Math, a);
    return Math.abs(max) >= Math.abs(min) ? max : min;
}, $62ae116bd3942e88$var$_setScrollTrigger = function _setScrollTrigger() {
    $62ae116bd3942e88$var$ScrollTrigger = $62ae116bd3942e88$var$gsap.core.globals().ScrollTrigger;
    $62ae116bd3942e88$var$ScrollTrigger && $62ae116bd3942e88$var$ScrollTrigger.core && $62ae116bd3942e88$var$_integrate();
}, $62ae116bd3942e88$var$_initCore = function _initCore(core) {
    $62ae116bd3942e88$var$gsap = core || $62ae116bd3942e88$var$_getGSAP();
    if ($62ae116bd3942e88$var$gsap && typeof document !== "undefined" && document.body) {
        $62ae116bd3942e88$var$_win = window;
        $62ae116bd3942e88$var$_doc = document;
        $62ae116bd3942e88$var$_docEl = $62ae116bd3942e88$var$_doc.documentElement;
        $62ae116bd3942e88$var$_body = $62ae116bd3942e88$var$_doc.body;
        $62ae116bd3942e88$var$_root = [
            $62ae116bd3942e88$var$_win,
            $62ae116bd3942e88$var$_doc,
            $62ae116bd3942e88$var$_docEl,
            $62ae116bd3942e88$var$_body
        ];
        $62ae116bd3942e88$var$_clamp = $62ae116bd3942e88$var$gsap.utils.clamp;
        $62ae116bd3942e88$var$_context = $62ae116bd3942e88$var$gsap.core.context || function() {};
        $62ae116bd3942e88$var$_pointerType = "onpointerenter" in $62ae116bd3942e88$var$_body ? "pointer" : "mouse"; // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
        $62ae116bd3942e88$var$_isTouch = $62ae116bd3942e88$export$c1cbdee04e18ea8b.isTouch = $62ae116bd3942e88$var$_win.matchMedia && $62ae116bd3942e88$var$_win.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in $62ae116bd3942e88$var$_win || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0;
        $62ae116bd3942e88$var$_eventTypes = $62ae116bd3942e88$export$c1cbdee04e18ea8b.eventTypes = ("ontouchstart" in $62ae116bd3942e88$var$_docEl ? "touchstart,touchmove,touchcancel,touchend" : !("onpointerdown" in $62ae116bd3942e88$var$_docEl) ? "mousedown,mousemove,mouseup,mouseup" : "pointerdown,pointermove,pointercancel,pointerup").split(",");
        setTimeout(function() {
            return $62ae116bd3942e88$var$_startup = 0;
        }, 500);
        $62ae116bd3942e88$var$_setScrollTrigger();
        $62ae116bd3942e88$var$_coreInitted = 1;
    }
    return $62ae116bd3942e88$var$_coreInitted;
};
$62ae116bd3942e88$export$b2cabb342cb0ebe1.op = $62ae116bd3942e88$export$8e40fc98ff518e9d;
$62ae116bd3942e88$export$3cd1cee43d19b683.cache = 0;
var $62ae116bd3942e88$export$c1cbdee04e18ea8b = /*#__PURE__*/ function() {
    function Observer(vars) {
        this.init(vars);
    }
    var _proto = Observer.prototype;
    _proto.init = function init(vars) {
        $62ae116bd3942e88$var$_coreInitted || $62ae116bd3942e88$var$_initCore($62ae116bd3942e88$var$gsap) || console.warn("Please gsap.registerPlugin(Observer)");
        $62ae116bd3942e88$var$ScrollTrigger || $62ae116bd3942e88$var$_setScrollTrigger();
        var tolerance = vars.tolerance, dragMinimum = vars.dragMinimum, type = vars.type, target = vars.target, lineHeight = vars.lineHeight, debounce = vars.debounce, preventDefault = vars.preventDefault, onStop = vars.onStop, onStopDelay = vars.onStopDelay, ignore = vars.ignore, wheelSpeed = vars.wheelSpeed, event = vars.event, onDragStart = vars.onDragStart, onDragEnd = vars.onDragEnd, onDrag = vars.onDrag, onPress = vars.onPress, onRelease = vars.onRelease, onRight = vars.onRight, onLeft = vars.onLeft, onUp = vars.onUp, onDown = vars.onDown, onChangeX = vars.onChangeX, onChangeY = vars.onChangeY, onChange = vars.onChange, onToggleX = vars.onToggleX, onToggleY = vars.onToggleY, onHover = vars.onHover, onHoverEnd = vars.onHoverEnd, onMove = vars.onMove, ignoreCheck = vars.ignoreCheck, isNormalizer = vars.isNormalizer, onGestureStart = vars.onGestureStart, onGestureEnd = vars.onGestureEnd, onWheel = vars.onWheel, onEnable = vars.onEnable, onDisable = vars.onDisable, onClick = vars.onClick, scrollSpeed = vars.scrollSpeed, capture = vars.capture, allowClicks = vars.allowClicks, lockAxis = vars.lockAxis, onLockAxis = vars.onLockAxis;
        this.target = target = $62ae116bd3942e88$export$937374fea3f88711(target) || $62ae116bd3942e88$var$_docEl;
        this.vars = vars;
        ignore && (ignore = $62ae116bd3942e88$var$gsap.utils.toArray(ignore));
        tolerance = tolerance || 1e-9;
        dragMinimum = dragMinimum || 0;
        wheelSpeed = wheelSpeed || 1;
        scrollSpeed = scrollSpeed || 1;
        type = type || "wheel,touch,pointer";
        debounce = debounce !== false;
        lineHeight || (lineHeight = parseFloat($62ae116bd3942e88$var$_win.getComputedStyle($62ae116bd3942e88$var$_body).lineHeight) || 22); // note: browser may report "normal", so default to 22.
        var id, onStopDelayedCall, dragged, moved, wheeled, locked, axis, self = this, prevDeltaX = 0, prevDeltaY = 0, scrollFuncX = $62ae116bd3942e88$export$8665aac53dad5647(target, $62ae116bd3942e88$export$b2cabb342cb0ebe1), scrollFuncY = $62ae116bd3942e88$export$8665aac53dad5647(target, $62ae116bd3942e88$export$8e40fc98ff518e9d), scrollX = scrollFuncX(), scrollY = scrollFuncY(), limitToTouch = ~type.indexOf("touch") && !~type.indexOf("pointer") && $62ae116bd3942e88$var$_eventTypes[0] === "pointerdown", // for devices that accommodate mouse events and touch events, we need to distinguish.
        isViewport = $62ae116bd3942e88$export$4330f3a92e5d2e94(target), ownerDoc = target.ownerDocument || $62ae116bd3942e88$var$_doc, deltaX = [
            0,
            0,
            0
        ], // wheel, scroll, pointer/touch
        deltaY = [
            0,
            0,
            0
        ], onClickTime = 0, clickCapture = function clickCapture() {
            return onClickTime = $62ae116bd3942e88$var$_getTime();
        }, _ignoreCheck = function _ignoreCheck(e, isPointerOrTouch) {
            return (self.event = e) && ignore && ~ignore.indexOf(e.target) || isPointerOrTouch && limitToTouch && e.pointerType !== "touch" || ignoreCheck && ignoreCheck(e, isPointerOrTouch);
        }, onStopFunc = function onStopFunc() {
            self._vx.reset();
            self._vy.reset();
            onStopDelayedCall.pause();
            onStop && onStop(self);
        }, update = function update() {
            var dx = self.deltaX = $62ae116bd3942e88$var$_getAbsoluteMax(deltaX), dy = self.deltaY = $62ae116bd3942e88$var$_getAbsoluteMax(deltaY), changedX = Math.abs(dx) >= tolerance, changedY = Math.abs(dy) >= tolerance;
            onChange && (changedX || changedY) && onChange(self, dx, dy, deltaX, deltaY); // in ScrollTrigger.normalizeScroll(), we need to know if it was touch/pointer so we need access to the deltaX/deltaY Arrays before we clear them out.
            if (changedX) {
                onRight && self.deltaX > 0 && onRight(self);
                onLeft && self.deltaX < 0 && onLeft(self);
                onChangeX && onChangeX(self);
                onToggleX && self.deltaX < 0 !== prevDeltaX < 0 && onToggleX(self);
                prevDeltaX = self.deltaX;
                deltaX[0] = deltaX[1] = deltaX[2] = 0;
            }
            if (changedY) {
                onDown && self.deltaY > 0 && onDown(self);
                onUp && self.deltaY < 0 && onUp(self);
                onChangeY && onChangeY(self);
                onToggleY && self.deltaY < 0 !== prevDeltaY < 0 && onToggleY(self);
                prevDeltaY = self.deltaY;
                deltaY[0] = deltaY[1] = deltaY[2] = 0;
            }
            if (moved || dragged) {
                onMove && onMove(self);
                if (dragged) {
                    onDrag(self);
                    dragged = false;
                }
                moved = false;
            }
            locked && (locked = false, true) && onLockAxis && onLockAxis(self);
            if (wheeled) {
                onWheel(self);
                wheeled = false;
            }
            id = 0;
        }, onDelta = function onDelta(x, y, index) {
            deltaX[index] += x;
            deltaY[index] += y;
            self._vx.update(x);
            self._vy.update(y);
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, onTouchOrPointerDelta = function onTouchOrPointerDelta(x, y) {
            if (lockAxis && !axis) {
                self.axis = axis = Math.abs(x) > Math.abs(y) ? "x" : "y";
                locked = true;
            }
            if (axis !== "y") {
                deltaX[2] += x;
                self._vx.update(x, true); // update the velocity as frequently as possible instead of in the debounced function so that very quick touch-scrolls (flicks) feel natural. If it's the mouse/touch/pointer, force it so that we get snappy/accurate momentum scroll.
            }
            if (axis !== "x") {
                deltaY[2] += y;
                self._vy.update(y, true);
            }
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, _onDrag = function _onDrag(e) {
            if (_ignoreCheck(e, 1)) return;
            e = $62ae116bd3942e88$var$_getEvent(e, preventDefault);
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y, isDragging = self.isDragging;
            self.x = x;
            self.y = y;
            if (isDragging || Math.abs(self.startX - x) >= dragMinimum || Math.abs(self.startY - y) >= dragMinimum) {
                onDrag && (dragged = true);
                isDragging || (self.isDragging = true);
                onTouchOrPointerDelta(dx, dy);
                isDragging || onDragStart && onDragStart(self);
            }
        }, _onPress = self.onPress = function(e) {
            if (_ignoreCheck(e, 1) || e && e.button) return;
            self.axis = axis = null;
            onStopDelayedCall.pause();
            self.isPressed = true;
            e = $62ae116bd3942e88$var$_getEvent(e); // note: may need to preventDefault(?) Won't side-scroll on iOS Safari if we do, though.
            prevDeltaX = prevDeltaY = 0;
            self.startX = self.x = e.clientX;
            self.startY = self.y = e.clientY;
            self._vx.reset(); // otherwise the t2 may be stale if the user touches and flicks super fast and releases in less than 2 requestAnimationFrame ticks, causing velocity to be 0.
            self._vy.reset();
            $62ae116bd3942e88$var$_addListener(isNormalizer ? target : ownerDoc, $62ae116bd3942e88$var$_eventTypes[1], _onDrag, preventDefault, true);
            self.deltaX = self.deltaY = 0;
            onPress && onPress(self);
        }, _onRelease = self.onRelease = function(e) {
            if (_ignoreCheck(e, 1)) return;
            $62ae116bd3942e88$var$_removeListener(isNormalizer ? target : ownerDoc, $62ae116bd3942e88$var$_eventTypes[1], _onDrag, true);
            var isTrackingDrag = !isNaN(self.y - self.startY), wasDragging = self.isDragging && (Math.abs(self.x - self.startX) > 3 || Math.abs(self.y - self.startY) > 3), // some touch devices need some wiggle room in terms of sensing clicks - the finger may move a few pixels.
            eventData = $62ae116bd3942e88$var$_getEvent(e);
            if (!wasDragging && isTrackingDrag) {
                self._vx.reset();
                self._vy.reset();
                if (preventDefault && allowClicks) $62ae116bd3942e88$var$gsap.delayedCall(0.08, function() {
                    // some browsers (like Firefox) won't trust script-generated clicks, so if the user tries to click on a video to play it, for example, it simply won't work. Since a regular "click" event will most likely be generated anyway (one that has its isTrusted flag set to true), we must slightly delay our script-generated click so that the "real"/trusted one is prioritized. Remember, when there are duplicate events in quick succession, we suppress all but the first one. Some browsers don't even trigger the "real" one at all, so our synthetic one is a safety valve that ensures that no matter what, a click event does get dispatched.
                    if ($62ae116bd3942e88$var$_getTime() - onClickTime > 300 && !e.defaultPrevented) {
                        if (e.target.click) //some browsers (like mobile Safari) don't properly trigger the click event
                        e.target.click();
                        else if (ownerDoc.createEvent) {
                            var syntheticEvent = ownerDoc.createEvent("MouseEvents");
                            syntheticEvent.initMouseEvent("click", true, true, $62ae116bd3942e88$var$_win, 1, eventData.screenX, eventData.screenY, eventData.clientX, eventData.clientY, false, false, false, false, 0, null);
                            e.target.dispatchEvent(syntheticEvent);
                        }
                    }
                });
            }
            self.isDragging = self.isGesturing = self.isPressed = false;
            onStop && !isNormalizer && onStopDelayedCall.restart(true);
            onDragEnd && wasDragging && onDragEnd(self);
            onRelease && onRelease(self, wasDragging);
        }, _onGestureStart = function _onGestureStart(e) {
            return e.touches && e.touches.length > 1 && (self.isGesturing = true) && onGestureStart(e, self.isDragging);
        }, _onGestureEnd = function _onGestureEnd() {
            return self.isGesturing = false, onGestureEnd(self);
        }, onScroll = function onScroll(e) {
            if (_ignoreCheck(e)) return;
            var x = scrollFuncX(), y = scrollFuncY();
            onDelta((x - scrollX) * scrollSpeed, (y - scrollY) * scrollSpeed, 1);
            scrollX = x;
            scrollY = y;
            onStop && onStopDelayedCall.restart(true);
        }, _onWheel = function _onWheel(e) {
            if (_ignoreCheck(e)) return;
            e = $62ae116bd3942e88$var$_getEvent(e, preventDefault);
            onWheel && (wheeled = true);
            var multiplier = (e.deltaMode === 1 ? lineHeight : e.deltaMode === 2 ? $62ae116bd3942e88$var$_win.innerHeight : 1) * wheelSpeed;
            onDelta(e.deltaX * multiplier, e.deltaY * multiplier, 0);
            onStop && !isNormalizer && onStopDelayedCall.restart(true);
        }, _onMove = function _onMove(e) {
            if (_ignoreCheck(e)) return;
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y;
            self.x = x;
            self.y = y;
            moved = true;
            (dx || dy) && onTouchOrPointerDelta(dx, dy);
        }, _onHover = function _onHover(e) {
            self.event = e;
            onHover(self);
        }, _onHoverEnd = function _onHoverEnd(e) {
            self.event = e;
            onHoverEnd(self);
        }, _onClick = function _onClick(e) {
            return _ignoreCheck(e) || $62ae116bd3942e88$var$_getEvent(e, preventDefault) && onClick(self);
        };
        onStopDelayedCall = self._dc = $62ae116bd3942e88$var$gsap.delayedCall(onStopDelay || 0.25, onStopFunc).pause();
        self.deltaX = self.deltaY = 0;
        self._vx = $62ae116bd3942e88$export$5de019f4480f0f8d(0, 50, true);
        self._vy = $62ae116bd3942e88$export$5de019f4480f0f8d(0, 50, true);
        self.scrollX = scrollFuncX;
        self.scrollY = scrollFuncY;
        self.isDragging = self.isGesturing = self.isPressed = false;
        $62ae116bd3942e88$var$_context(this);
        self.enable = function(e) {
            if (!self.isEnabled) {
                $62ae116bd3942e88$var$_addListener(isViewport ? ownerDoc : target, "scroll", $62ae116bd3942e88$var$_onScroll);
                type.indexOf("scroll") >= 0 && $62ae116bd3942e88$var$_addListener(isViewport ? ownerDoc : target, "scroll", onScroll, preventDefault, capture);
                type.indexOf("wheel") >= 0 && $62ae116bd3942e88$var$_addListener(target, "wheel", _onWheel, preventDefault, capture);
                if (type.indexOf("touch") >= 0 && $62ae116bd3942e88$var$_isTouch || type.indexOf("pointer") >= 0) {
                    $62ae116bd3942e88$var$_addListener(target, $62ae116bd3942e88$var$_eventTypes[0], _onPress, preventDefault, capture);
                    $62ae116bd3942e88$var$_addListener(ownerDoc, $62ae116bd3942e88$var$_eventTypes[2], _onRelease);
                    $62ae116bd3942e88$var$_addListener(ownerDoc, $62ae116bd3942e88$var$_eventTypes[3], _onRelease);
                    allowClicks && $62ae116bd3942e88$var$_addListener(target, "click", clickCapture, false, true);
                    onClick && $62ae116bd3942e88$var$_addListener(target, "click", _onClick);
                    onGestureStart && $62ae116bd3942e88$var$_addListener(ownerDoc, "gesturestart", _onGestureStart);
                    onGestureEnd && $62ae116bd3942e88$var$_addListener(ownerDoc, "gestureend", _onGestureEnd);
                    onHover && $62ae116bd3942e88$var$_addListener(target, $62ae116bd3942e88$var$_pointerType + "enter", _onHover);
                    onHoverEnd && $62ae116bd3942e88$var$_addListener(target, $62ae116bd3942e88$var$_pointerType + "leave", _onHoverEnd);
                    onMove && $62ae116bd3942e88$var$_addListener(target, $62ae116bd3942e88$var$_pointerType + "move", _onMove);
                }
                self.isEnabled = true;
                e && e.type && _onPress(e);
                onEnable && onEnable(self);
            }
            return self;
        };
        self.disable = function() {
            if (self.isEnabled) {
                // only remove the _onScroll listener if there aren't any others that rely on the functionality.
                $62ae116bd3942e88$var$_observers.filter(function(o) {
                    return o !== self && $62ae116bd3942e88$export$4330f3a92e5d2e94(o.target);
                }).length || $62ae116bd3942e88$var$_removeListener(isViewport ? ownerDoc : target, "scroll", $62ae116bd3942e88$var$_onScroll);
                if (self.isPressed) {
                    self._vx.reset();
                    self._vy.reset();
                    $62ae116bd3942e88$var$_removeListener(isNormalizer ? target : ownerDoc, $62ae116bd3942e88$var$_eventTypes[1], _onDrag, true);
                }
                $62ae116bd3942e88$var$_removeListener(isViewport ? ownerDoc : target, "scroll", onScroll, capture);
                $62ae116bd3942e88$var$_removeListener(target, "wheel", _onWheel, capture);
                $62ae116bd3942e88$var$_removeListener(target, $62ae116bd3942e88$var$_eventTypes[0], _onPress, capture);
                $62ae116bd3942e88$var$_removeListener(ownerDoc, $62ae116bd3942e88$var$_eventTypes[2], _onRelease);
                $62ae116bd3942e88$var$_removeListener(ownerDoc, $62ae116bd3942e88$var$_eventTypes[3], _onRelease);
                $62ae116bd3942e88$var$_removeListener(target, "click", clickCapture, true);
                $62ae116bd3942e88$var$_removeListener(target, "click", _onClick);
                $62ae116bd3942e88$var$_removeListener(ownerDoc, "gesturestart", _onGestureStart);
                $62ae116bd3942e88$var$_removeListener(ownerDoc, "gestureend", _onGestureEnd);
                $62ae116bd3942e88$var$_removeListener(target, $62ae116bd3942e88$var$_pointerType + "enter", _onHover);
                $62ae116bd3942e88$var$_removeListener(target, $62ae116bd3942e88$var$_pointerType + "leave", _onHoverEnd);
                $62ae116bd3942e88$var$_removeListener(target, $62ae116bd3942e88$var$_pointerType + "move", _onMove);
                self.isEnabled = self.isPressed = self.isDragging = false;
                onDisable && onDisable(self);
            }
        };
        self.kill = self.revert = function() {
            self.disable();
            var i = $62ae116bd3942e88$var$_observers.indexOf(self);
            i >= 0 && $62ae116bd3942e88$var$_observers.splice(i, 1);
            $62ae116bd3942e88$var$_normalizer === self && ($62ae116bd3942e88$var$_normalizer = 0);
        };
        $62ae116bd3942e88$var$_observers.push(self);
        isNormalizer && $62ae116bd3942e88$export$4330f3a92e5d2e94(target) && ($62ae116bd3942e88$var$_normalizer = self);
        self.enable(event);
    };
    $62ae116bd3942e88$var$_createClass(Observer, [
        {
            key: "velocityX",
            get: function get() {
                return this._vx.getVelocity();
            }
        },
        {
            key: "velocityY",
            get: function get() {
                return this._vy.getVelocity();
            }
        }
    ]);
    return Observer;
}();
$62ae116bd3942e88$export$c1cbdee04e18ea8b.version = "3.12.2";
$62ae116bd3942e88$export$c1cbdee04e18ea8b.create = function(vars) {
    return new $62ae116bd3942e88$export$c1cbdee04e18ea8b(vars);
};
$62ae116bd3942e88$export$c1cbdee04e18ea8b.register = $62ae116bd3942e88$var$_initCore;
$62ae116bd3942e88$export$c1cbdee04e18ea8b.getAll = function() {
    return $62ae116bd3942e88$var$_observers.slice();
};
$62ae116bd3942e88$export$c1cbdee04e18ea8b.getById = function(id) {
    return $62ae116bd3942e88$var$_observers.filter(function(o) {
        return o.vars.id === id;
    })[0];
};
$62ae116bd3942e88$var$_getGSAP() && $62ae116bd3942e88$var$gsap.registerPlugin($62ae116bd3942e88$export$c1cbdee04e18ea8b);


var $1db01b369728d7c8$var$gsap, $1db01b369728d7c8$var$_coreInitted, $1db01b369728d7c8$var$_win, $1db01b369728d7c8$var$_doc, $1db01b369728d7c8$var$_docEl, $1db01b369728d7c8$var$_body, $1db01b369728d7c8$var$_root, $1db01b369728d7c8$var$_resizeDelay, $1db01b369728d7c8$var$_toArray, $1db01b369728d7c8$var$_clamp, $1db01b369728d7c8$var$_time2, $1db01b369728d7c8$var$_syncInterval, $1db01b369728d7c8$var$_refreshing, $1db01b369728d7c8$var$_pointerIsDown, $1db01b369728d7c8$var$_transformProp, $1db01b369728d7c8$var$_i, $1db01b369728d7c8$var$_prevWidth, $1db01b369728d7c8$var$_prevHeight, $1db01b369728d7c8$var$_autoRefresh, $1db01b369728d7c8$var$_sort, $1db01b369728d7c8$var$_suppressOverwrites, $1db01b369728d7c8$var$_ignoreResize, $1db01b369728d7c8$var$_normalizer, $1db01b369728d7c8$var$_ignoreMobileResize, $1db01b369728d7c8$var$_baseScreenHeight, $1db01b369728d7c8$var$_baseScreenWidth, $1db01b369728d7c8$var$_fixIOSBug, $1db01b369728d7c8$var$_context, $1db01b369728d7c8$var$_scrollRestoration, $1db01b369728d7c8$var$_div100vh, $1db01b369728d7c8$var$_100vh, $1db01b369728d7c8$var$_limitCallbacks, // if true, we'll only trigger callbacks if the active state toggles, so if you scroll immediately past both the start and end positions of a ScrollTrigger (thus inactive to inactive), neither its onEnter nor onLeave will be called. This is useful during startup.
$1db01b369728d7c8$var$_startup = 1, $1db01b369728d7c8$var$_getTime = Date.now, $1db01b369728d7c8$var$_time1 = $1db01b369728d7c8$var$_getTime(), $1db01b369728d7c8$var$_lastScrollTime = 0, $1db01b369728d7c8$var$_enabled = 0, $1db01b369728d7c8$var$_parseClamp = function _parseClamp(value, type, self) {
    var clamp = $1db01b369728d7c8$var$_isString(value) && (value.substr(0, 6) === "clamp(" || value.indexOf("max") > -1);
    self["_" + type + "Clamp"] = clamp;
    return clamp ? value.substr(6, value.length - 7) : value;
}, $1db01b369728d7c8$var$_keepClamp = function _keepClamp(value, clamp) {
    return clamp && (!$1db01b369728d7c8$var$_isString(value) || value.substr(0, 6) !== "clamp(") ? "clamp(" + value + ")" : value;
}, $1db01b369728d7c8$var$_rafBugFix = function _rafBugFix() {
    return $1db01b369728d7c8$var$_enabled && requestAnimationFrame(_rafBugFix);
}, // in some browsers (like Firefox), screen repaints weren't consistent unless we had SOMETHING queued up in requestAnimationFrame()! So this just creates a super simple loop to keep it alive and smooth out repaints.
$1db01b369728d7c8$var$_pointerDownHandler = function _pointerDownHandler() {
    return $1db01b369728d7c8$var$_pointerIsDown = 1;
}, $1db01b369728d7c8$var$_pointerUpHandler = function _pointerUpHandler() {
    return $1db01b369728d7c8$var$_pointerIsDown = 0;
}, $1db01b369728d7c8$var$_passThrough = function _passThrough(v) {
    return v;
}, $1db01b369728d7c8$var$_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, $1db01b369728d7c8$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $1db01b369728d7c8$var$_getGSAP = function _getGSAP() {
    return $1db01b369728d7c8$var$gsap || $1db01b369728d7c8$var$_windowExists() && ($1db01b369728d7c8$var$gsap = window.gsap) && $1db01b369728d7c8$var$gsap.registerPlugin && $1db01b369728d7c8$var$gsap;
}, $1db01b369728d7c8$var$_isViewport = function _isViewport(e) {
    return !!~$1db01b369728d7c8$var$_root.indexOf(e);
}, $1db01b369728d7c8$var$_getViewportDimension = function _getViewportDimension(dimensionProperty) {
    return (dimensionProperty === "Height" ? $1db01b369728d7c8$var$_100vh : $1db01b369728d7c8$var$_win["inner" + dimensionProperty]) || $1db01b369728d7c8$var$_docEl["client" + dimensionProperty] || $1db01b369728d7c8$var$_body["client" + dimensionProperty];
}, $1db01b369728d7c8$var$_getBoundsFunc = function _getBoundsFunc(element) {
    return (0, $62ae116bd3942e88$export$6078f1ef08b38af9)(element, "getBoundingClientRect") || ($1db01b369728d7c8$var$_isViewport(element) ? function() {
        $1db01b369728d7c8$var$_winOffsets.width = $1db01b369728d7c8$var$_win.innerWidth;
        $1db01b369728d7c8$var$_winOffsets.height = $1db01b369728d7c8$var$_100vh;
        return $1db01b369728d7c8$var$_winOffsets;
    } : function() {
        return $1db01b369728d7c8$var$_getBounds(element);
    });
}, $1db01b369728d7c8$var$_getSizeFunc = function _getSizeFunc(scroller, isViewport, _ref) {
    var d = _ref.d, d2 = _ref.d2, a = _ref.a;
    return (a = (0, $62ae116bd3942e88$export$6078f1ef08b38af9)(scroller, "getBoundingClientRect")) ? function() {
        return a()[d];
    } : function() {
        return (isViewport ? $1db01b369728d7c8$var$_getViewportDimension(d2) : scroller["client" + d2]) || 0;
    };
}, $1db01b369728d7c8$var$_getOffsetsFunc = function _getOffsetsFunc(element, isViewport) {
    return !isViewport || ~(0, $62ae116bd3942e88$export$d8e56d510a804d0a).indexOf(element) ? $1db01b369728d7c8$var$_getBoundsFunc(element) : function() {
        return $1db01b369728d7c8$var$_winOffsets;
    };
}, $1db01b369728d7c8$var$_maxScroll = function _maxScroll(element, _ref2) {
    var s = _ref2.s, d2 = _ref2.d2, d = _ref2.d, a = _ref2.a;
    return Math.max(0, (s = "scroll" + d2, a = (0, $62ae116bd3942e88$export$6078f1ef08b38af9)(element, s)) ? a() - $1db01b369728d7c8$var$_getBoundsFunc(element)()[d] : $1db01b369728d7c8$var$_isViewport(element) ? ($1db01b369728d7c8$var$_docEl[s] || $1db01b369728d7c8$var$_body[s]) - $1db01b369728d7c8$var$_getViewportDimension(d2) : element[s] - element["offset" + d2]);
}, $1db01b369728d7c8$var$_iterateAutoRefresh = function _iterateAutoRefresh(func, events) {
    for(var i = 0; i < $1db01b369728d7c8$var$_autoRefresh.length; i += 3)(!events || ~events.indexOf($1db01b369728d7c8$var$_autoRefresh[i + 1])) && func($1db01b369728d7c8$var$_autoRefresh[i], $1db01b369728d7c8$var$_autoRefresh[i + 1], $1db01b369728d7c8$var$_autoRefresh[i + 2]);
}, $1db01b369728d7c8$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $1db01b369728d7c8$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $1db01b369728d7c8$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $1db01b369728d7c8$var$_isObject = function _isObject(value) {
    return typeof value === "object";
}, $1db01b369728d7c8$var$_endAnimation = function _endAnimation(animation, reversed, pause) {
    return animation && animation.progress(reversed ? 0 : 1) && pause && animation.pause();
}, $1db01b369728d7c8$var$_callback = function _callback(self, func) {
    if (self.enabled) {
        var result = func(self);
        result && result.totalTime && (self.callbackAnimation = result);
    }
}, $1db01b369728d7c8$var$_abs = Math.abs, $1db01b369728d7c8$var$_left = "left", $1db01b369728d7c8$var$_top = "top", $1db01b369728d7c8$var$_right = "right", $1db01b369728d7c8$var$_bottom = "bottom", $1db01b369728d7c8$var$_width = "width", $1db01b369728d7c8$var$_height = "height", $1db01b369728d7c8$var$_Right = "Right", $1db01b369728d7c8$var$_Left = "Left", $1db01b369728d7c8$var$_Top = "Top", $1db01b369728d7c8$var$_Bottom = "Bottom", $1db01b369728d7c8$var$_padding = "padding", $1db01b369728d7c8$var$_margin = "margin", $1db01b369728d7c8$var$_Width = "Width", $1db01b369728d7c8$var$_Height = "Height", $1db01b369728d7c8$var$_px = "px", $1db01b369728d7c8$var$_getComputedStyle = function _getComputedStyle(element) {
    return $1db01b369728d7c8$var$_win.getComputedStyle(element);
}, $1db01b369728d7c8$var$_makePositionable = function _makePositionable(element) {
    // if the element already has position: absolute or fixed, leave that, otherwise make it position: relative
    var position = $1db01b369728d7c8$var$_getComputedStyle(element).position;
    element.style.position = position === "absolute" || position === "fixed" ? position : "relative";
}, $1db01b369728d7c8$var$_setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, $1db01b369728d7c8$var$_getBounds = function _getBounds(element, withoutTransforms) {
    var tween = withoutTransforms && $1db01b369728d7c8$var$_getComputedStyle(element)[$1db01b369728d7c8$var$_transformProp] !== "matrix(1, 0, 0, 1, 0, 0)" && $1db01b369728d7c8$var$gsap.to(element, {
        x: 0,
        y: 0,
        xPercent: 0,
        yPercent: 0,
        rotation: 0,
        rotationX: 0,
        rotationY: 0,
        scale: 1,
        skewX: 0,
        skewY: 0
    }).progress(1), bounds = element.getBoundingClientRect();
    tween && tween.progress(0).kill();
    return bounds;
}, $1db01b369728d7c8$var$_getSize = function _getSize(element, _ref3) {
    var d2 = _ref3.d2;
    return element["offset" + d2] || element["client" + d2] || 0;
}, $1db01b369728d7c8$var$_getLabelRatioArray = function _getLabelRatioArray(timeline) {
    var a = [], labels = timeline.labels, duration = timeline.duration(), p;
    for(p in labels)a.push(labels[p] / duration);
    return a;
}, $1db01b369728d7c8$var$_getClosestLabel = function _getClosestLabel(animation) {
    return function(value) {
        return $1db01b369728d7c8$var$gsap.utils.snap($1db01b369728d7c8$var$_getLabelRatioArray(animation), value);
    };
}, $1db01b369728d7c8$var$_snapDirectional = function _snapDirectional(snapIncrementOrArray) {
    var snap = $1db01b369728d7c8$var$gsap.utils.snap(snapIncrementOrArray), a = Array.isArray(snapIncrementOrArray) && snapIncrementOrArray.slice(0).sort(function(a, b) {
        return a - b;
    });
    return a ? function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var i;
        if (!direction) return snap(value);
        if (direction > 0) {
            value -= threshold; // to avoid rounding errors. If we're too strict, it might snap forward, then immediately again, and again.
            for(i = 0; i < a.length; i++){
                if (a[i] >= value) return a[i];
            }
            return a[i - 1];
        } else {
            i = a.length;
            value += threshold;
            while(i--){
                if (a[i] <= value) return a[i];
            }
        }
        return a[0];
    } : function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var snapped = snap(value);
        return !direction || Math.abs(snapped - value) < threshold || snapped - value < 0 === direction < 0 ? snapped : snap(direction < 0 ? value - snapIncrementOrArray : value + snapIncrementOrArray);
    };
}, $1db01b369728d7c8$var$_getLabelAtDirection = function _getLabelAtDirection(timeline) {
    return function(value, st) {
        return $1db01b369728d7c8$var$_snapDirectional($1db01b369728d7c8$var$_getLabelRatioArray(timeline))(value, st.direction);
    };
}, $1db01b369728d7c8$var$_multiListener = function _multiListener(func, element, types, callback) {
    return types.split(",").forEach(function(type) {
        return func(element, type, callback);
    });
}, $1db01b369728d7c8$var$_addListener = function _addListener(element, type, func, nonPassive, capture) {
    return element.addEventListener(type, func, {
        passive: !nonPassive,
        capture: !!capture
    });
}, $1db01b369728d7c8$var$_removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, $1db01b369728d7c8$var$_wheelListener = function _wheelListener(func, el, scrollFunc) {
    scrollFunc = scrollFunc && scrollFunc.wheelHandler;
    if (scrollFunc) {
        func(el, "wheel", scrollFunc);
        func(el, "touchmove", scrollFunc);
    }
}, $1db01b369728d7c8$var$_markerDefaults = {
    startColor: "green",
    endColor: "red",
    indent: 0,
    fontSize: "16px",
    fontWeight: "normal"
}, $1db01b369728d7c8$var$_defaults = {
    toggleActions: "play",
    anticipatePin: 0
}, $1db01b369728d7c8$var$_keywords = {
    top: 0,
    left: 0,
    center: 0.5,
    bottom: 1,
    right: 1
}, $1db01b369728d7c8$var$_offsetToPx = function _offsetToPx(value, size) {
    if ($1db01b369728d7c8$var$_isString(value)) {
        var eqIndex = value.indexOf("="), relative = ~eqIndex ? +(value.charAt(eqIndex - 1) + 1) * parseFloat(value.substr(eqIndex + 1)) : 0;
        if (~eqIndex) {
            value.indexOf("%") > eqIndex && (relative *= size / 100);
            value = value.substr(0, eqIndex - 1);
        }
        value = relative + (value in $1db01b369728d7c8$var$_keywords ? $1db01b369728d7c8$var$_keywords[value] * size : ~value.indexOf("%") ? parseFloat(value) * size / 100 : parseFloat(value) || 0);
    }
    return value;
}, $1db01b369728d7c8$var$_createMarker = function _createMarker(type, name, container, direction, _ref4, offset, matchWidthEl, containerAnimation) {
    var startColor = _ref4.startColor, endColor = _ref4.endColor, fontSize = _ref4.fontSize, indent = _ref4.indent, fontWeight = _ref4.fontWeight;
    var e = $1db01b369728d7c8$var$_doc.createElement("div"), useFixedPosition = $1db01b369728d7c8$var$_isViewport(container) || (0, $62ae116bd3942e88$export$6078f1ef08b38af9)(container, "pinType") === "fixed", isScroller = type.indexOf("scroller") !== -1, parent = useFixedPosition ? $1db01b369728d7c8$var$_body : container, isStart = type.indexOf("start") !== -1, color = isStart ? startColor : endColor, css = "border-color:" + color + ";font-size:" + fontSize + ";color:" + color + ";font-weight:" + fontWeight + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
    css += "position:" + ((isScroller || containerAnimation) && useFixedPosition ? "fixed;" : "absolute;");
    (isScroller || containerAnimation || !useFixedPosition) && (css += (direction === (0, $62ae116bd3942e88$export$8e40fc98ff518e9d) ? $1db01b369728d7c8$var$_right : $1db01b369728d7c8$var$_bottom) + ":" + (offset + parseFloat(indent)) + "px;");
    matchWidthEl && (css += "box-sizing:border-box;text-align:left;width:" + matchWidthEl.offsetWidth + "px;");
    e._isStart = isStart;
    e.setAttribute("class", "gsap-marker-" + type + (name ? " marker-" + name : ""));
    e.style.cssText = css;
    e.innerText = name || name === 0 ? type + "-" + name : type;
    parent.children[0] ? parent.insertBefore(e, parent.children[0]) : parent.appendChild(e);
    e._offset = e["offset" + direction.op.d2];
    $1db01b369728d7c8$var$_positionMarker(e, 0, direction, isStart);
    return e;
}, $1db01b369728d7c8$var$_positionMarker = function _positionMarker(marker, start, direction, flipped) {
    var vars = {
        display: "block"
    }, side = direction[flipped ? "os2" : "p2"], oppositeSide = direction[flipped ? "p2" : "os2"];
    marker._isFlipped = flipped;
    vars[direction.a + "Percent"] = flipped ? -100 : 0;
    vars[direction.a] = flipped ? "1px" : 0;
    vars["border" + side + $1db01b369728d7c8$var$_Width] = 1;
    vars["border" + oppositeSide + $1db01b369728d7c8$var$_Width] = 0;
    vars[direction.p] = start + "px";
    $1db01b369728d7c8$var$gsap.set(marker, vars);
}, $1db01b369728d7c8$var$_triggers = [], $1db01b369728d7c8$var$_ids = {}, $1db01b369728d7c8$var$_rafID, $1db01b369728d7c8$var$_sync = function _sync() {
    return $1db01b369728d7c8$var$_getTime() - $1db01b369728d7c8$var$_lastScrollTime > 34 && ($1db01b369728d7c8$var$_rafID || ($1db01b369728d7c8$var$_rafID = requestAnimationFrame($1db01b369728d7c8$var$_updateAll)));
}, $1db01b369728d7c8$var$_onScroll = function _onScroll() {
    // previously, we tried to optimize performance by batching/deferring to the next requestAnimationFrame(), but discovered that Safari has a few bugs that make this unworkable (especially on iOS). See https://codepen.io/GreenSock/pen/16c435b12ef09c38125204818e7b45fc?editors=0010 and https://codepen.io/GreenSock/pen/JjOxYpQ/3dd65ccec5a60f1d862c355d84d14562?editors=0010 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503?editors=0010
    if (!$1db01b369728d7c8$var$_normalizer || !$1db01b369728d7c8$var$_normalizer.isPressed || $1db01b369728d7c8$var$_normalizer.startX > $1db01b369728d7c8$var$_body.clientWidth) {
        // if the user is dragging the scrollbar, allow it.
        (0, $62ae116bd3942e88$export$3cd1cee43d19b683).cache++;
        if ($1db01b369728d7c8$var$_normalizer) $1db01b369728d7c8$var$_rafID || ($1db01b369728d7c8$var$_rafID = requestAnimationFrame($1db01b369728d7c8$var$_updateAll));
        else $1db01b369728d7c8$var$_updateAll(); // Safari in particular (on desktop) NEEDS the immediate update rather than waiting for a requestAnimationFrame() whereas iOS seems to benefit from waiting for the requestAnimationFrame() tick, at least when normalizing. See https://codepen.io/GreenSock/pen/qBYozqO?editors=0110
        $1db01b369728d7c8$var$_lastScrollTime || $1db01b369728d7c8$var$_dispatch("scrollStart");
        $1db01b369728d7c8$var$_lastScrollTime = $1db01b369728d7c8$var$_getTime();
    }
}, $1db01b369728d7c8$var$_setBaseDimensions = function _setBaseDimensions() {
    $1db01b369728d7c8$var$_baseScreenWidth = $1db01b369728d7c8$var$_win.innerWidth;
    $1db01b369728d7c8$var$_baseScreenHeight = $1db01b369728d7c8$var$_win.innerHeight;
}, $1db01b369728d7c8$var$_onResize = function _onResize() {
    (0, $62ae116bd3942e88$export$3cd1cee43d19b683).cache++;
    !$1db01b369728d7c8$var$_refreshing && !$1db01b369728d7c8$var$_ignoreResize && !$1db01b369728d7c8$var$_doc.fullscreenElement && !$1db01b369728d7c8$var$_doc.webkitFullscreenElement && (!$1db01b369728d7c8$var$_ignoreMobileResize || $1db01b369728d7c8$var$_baseScreenWidth !== $1db01b369728d7c8$var$_win.innerWidth || Math.abs($1db01b369728d7c8$var$_win.innerHeight - $1db01b369728d7c8$var$_baseScreenHeight) > $1db01b369728d7c8$var$_win.innerHeight * 0.25) && $1db01b369728d7c8$var$_resizeDelay.restart(true);
}, // ignore resizes triggered by refresh()
$1db01b369728d7c8$var$_listeners = {}, $1db01b369728d7c8$var$_emptyArray = [], $1db01b369728d7c8$var$_softRefresh = function _softRefresh() {
    return $1db01b369728d7c8$var$_removeListener($1db01b369728d7c8$export$875bcbe48555930, "scrollEnd", _softRefresh) || $1db01b369728d7c8$var$_refreshAll(true);
}, $1db01b369728d7c8$var$_dispatch = function _dispatch(type) {
    return $1db01b369728d7c8$var$_listeners[type] && $1db01b369728d7c8$var$_listeners[type].map(function(f) {
        return f();
    }) || $1db01b369728d7c8$var$_emptyArray;
}, $1db01b369728d7c8$var$_savedStyles = [], // when ScrollTrigger.saveStyles() is called, the inline styles are recorded in this Array in a sequential format like [element, cssText, gsCache, media]. This keeps it very memory-efficient and fast to iterate through.
$1db01b369728d7c8$var$_revertRecorded = function _revertRecorded(media) {
    for(var i = 0; i < $1db01b369728d7c8$var$_savedStyles.length; i += 5)if (!media || $1db01b369728d7c8$var$_savedStyles[i + 4] && $1db01b369728d7c8$var$_savedStyles[i + 4].query === media) {
        $1db01b369728d7c8$var$_savedStyles[i].style.cssText = $1db01b369728d7c8$var$_savedStyles[i + 1];
        $1db01b369728d7c8$var$_savedStyles[i].getBBox && $1db01b369728d7c8$var$_savedStyles[i].setAttribute("transform", $1db01b369728d7c8$var$_savedStyles[i + 2] || "");
        $1db01b369728d7c8$var$_savedStyles[i + 3].uncache = 1;
    }
}, $1db01b369728d7c8$var$_revertAll = function _revertAll(kill, media) {
    var trigger;
    for($1db01b369728d7c8$var$_i = 0; $1db01b369728d7c8$var$_i < $1db01b369728d7c8$var$_triggers.length; $1db01b369728d7c8$var$_i++){
        trigger = $1db01b369728d7c8$var$_triggers[$1db01b369728d7c8$var$_i];
        if (trigger && (!media || trigger._ctx === media)) {
            if (kill) trigger.kill(1);
            else trigger.revert(true, true);
        }
    }
    media && $1db01b369728d7c8$var$_revertRecorded(media);
    media || $1db01b369728d7c8$var$_dispatch("revert");
}, $1db01b369728d7c8$var$_clearScrollMemory = function _clearScrollMemory(scrollRestoration, force) {
    // zero-out all the recorded scroll positions. Don't use _triggers because if, for example, .matchMedia() is used to create some ScrollTriggers and then the user resizes and it removes ALL ScrollTriggers, and then go back to a size where there are ScrollTriggers, it would have kept the position(s) saved from the initial state.
    (0, $62ae116bd3942e88$export$3cd1cee43d19b683).cache++;
    (force || !$1db01b369728d7c8$var$_refreshingAll) && (0, $62ae116bd3942e88$export$3cd1cee43d19b683).forEach(function(obj) {
        return $1db01b369728d7c8$var$_isFunction(obj) && obj.cacheID++ && (obj.rec = 0);
    });
    $1db01b369728d7c8$var$_isString(scrollRestoration) && ($1db01b369728d7c8$var$_win.history.scrollRestoration = $1db01b369728d7c8$var$_scrollRestoration = scrollRestoration);
}, $1db01b369728d7c8$var$_refreshingAll, $1db01b369728d7c8$var$_refreshID = 0, $1db01b369728d7c8$var$_queueRefreshID, $1db01b369728d7c8$var$_queueRefreshAll = function _queueRefreshAll() {
    // we don't want to call _refreshAll() every time we create a new ScrollTrigger (for performance reasons) - it's better to batch them. Some frameworks dynamically load content and we can't rely on the window's "load" or "DOMContentLoaded" events to trigger it.
    if ($1db01b369728d7c8$var$_queueRefreshID !== $1db01b369728d7c8$var$_refreshID) {
        var id = $1db01b369728d7c8$var$_queueRefreshID = $1db01b369728d7c8$var$_refreshID;
        requestAnimationFrame(function() {
            return id === $1db01b369728d7c8$var$_refreshID && $1db01b369728d7c8$var$_refreshAll(true);
        });
    }
}, $1db01b369728d7c8$var$_refresh100vh = function _refresh100vh() {
    $1db01b369728d7c8$var$_body.appendChild($1db01b369728d7c8$var$_div100vh);
    $1db01b369728d7c8$var$_100vh = $1db01b369728d7c8$var$_div100vh.offsetHeight || $1db01b369728d7c8$var$_win.innerHeight;
    $1db01b369728d7c8$var$_body.removeChild($1db01b369728d7c8$var$_div100vh);
}, $1db01b369728d7c8$var$_refreshAll = function _refreshAll(force, skipRevert) {
    if ($1db01b369728d7c8$var$_lastScrollTime && !force) {
        $1db01b369728d7c8$var$_addListener($1db01b369728d7c8$export$875bcbe48555930, "scrollEnd", $1db01b369728d7c8$var$_softRefresh);
        return;
    }
    $1db01b369728d7c8$var$_refresh100vh();
    $1db01b369728d7c8$var$_refreshingAll = $1db01b369728d7c8$export$875bcbe48555930.isRefreshing = true;
    (0, $62ae116bd3942e88$export$3cd1cee43d19b683).forEach(function(obj) {
        return $1db01b369728d7c8$var$_isFunction(obj) && ++obj.cacheID && (obj.rec = obj());
    }); // force the clearing of the cache because some browsers take a little while to dispatch the "scroll" event and the user may have changed the scroll position and then called ScrollTrigger.refresh() right away
    var refreshInits = $1db01b369728d7c8$var$_dispatch("refreshInit");
    $1db01b369728d7c8$var$_sort && $1db01b369728d7c8$export$875bcbe48555930.sort();
    skipRevert || $1db01b369728d7c8$var$_revertAll();
    (0, $62ae116bd3942e88$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($1db01b369728d7c8$var$_isFunction(obj)) {
            obj.smooth && (obj.target.style.scrollBehavior = "auto"); // smooth scrolling interferes
            obj(0);
        }
    });
    $1db01b369728d7c8$var$_triggers.slice(0).forEach(function(t) {
        return t.refresh();
    }); // don't loop with _i because during a refresh() someone could call ScrollTrigger.update() which would iterate through _i resulting in a skip.
    $1db01b369728d7c8$var$_triggers.forEach(function(t, i) {
        // nested pins (pinnedContainer) with pinSpacing may expand the container, so we must accommodate that here.
        if (t._subPinOffset && t.pin) {
            var prop = t.vars.horizontal ? "offsetWidth" : "offsetHeight", original = t.pin[prop];
            t.revert(true, 1);
            t.adjustPinSpacing(t.pin[prop] - original);
            t.refresh();
        }
    });
    $1db01b369728d7c8$var$_triggers.forEach(function(t) {
        // the scroller's max scroll position may change after all the ScrollTriggers refreshed (like pinning could push it down), so we need to loop back and correct any with end: "max". Same for anything with a clamped end
        var max = $1db01b369728d7c8$var$_maxScroll(t.scroller, t._dir);
        (t.vars.end === "max" || t._endClamp && t.end > max) && t.setPositions(t.start, Math.max(t.start + 1, max), true);
    });
    refreshInits.forEach(function(result) {
        return result && result.render && result.render(-1);
    }); // if the onRefreshInit() returns an animation (typically a gsap.set()), revert it. This makes it easy to put things in a certain spot before refreshing for measurement purposes, and then put things back.
    (0, $62ae116bd3942e88$export$3cd1cee43d19b683).forEach(function(obj) {
        if ($1db01b369728d7c8$var$_isFunction(obj)) {
            obj.smooth && requestAnimationFrame(function() {
                return obj.target.style.scrollBehavior = "smooth";
            });
            obj.rec && obj(obj.rec);
        }
    });
    $1db01b369728d7c8$var$_clearScrollMemory($1db01b369728d7c8$var$_scrollRestoration, 1);
    $1db01b369728d7c8$var$_resizeDelay.pause();
    $1db01b369728d7c8$var$_refreshID++;
    $1db01b369728d7c8$var$_refreshingAll = 2;
    $1db01b369728d7c8$var$_updateAll(2);
    $1db01b369728d7c8$var$_triggers.forEach(function(t) {
        return $1db01b369728d7c8$var$_isFunction(t.vars.onRefresh) && t.vars.onRefresh(t);
    });
    $1db01b369728d7c8$var$_refreshingAll = $1db01b369728d7c8$export$875bcbe48555930.isRefreshing = false;
    $1db01b369728d7c8$var$_dispatch("refresh");
}, $1db01b369728d7c8$var$_lastScroll = 0, $1db01b369728d7c8$var$_direction = 1, $1db01b369728d7c8$var$_primary, $1db01b369728d7c8$var$_updateAll = function _updateAll(force) {
    if (!$1db01b369728d7c8$var$_refreshingAll || force === 2) {
        $1db01b369728d7c8$export$875bcbe48555930.isUpdating = true;
        $1db01b369728d7c8$var$_primary && $1db01b369728d7c8$var$_primary.update(0); // ScrollSmoother uses refreshPriority -9999 to become the primary that gets updated before all others because it affects the scroll position.
        var l = $1db01b369728d7c8$var$_triggers.length, time = $1db01b369728d7c8$var$_getTime(), recordVelocity = time - $1db01b369728d7c8$var$_time1 >= 50, scroll = l && $1db01b369728d7c8$var$_triggers[0].scroll();
        $1db01b369728d7c8$var$_direction = $1db01b369728d7c8$var$_lastScroll > scroll ? -1 : 1;
        $1db01b369728d7c8$var$_refreshingAll || ($1db01b369728d7c8$var$_lastScroll = scroll);
        if (recordVelocity) {
            if ($1db01b369728d7c8$var$_lastScrollTime && !$1db01b369728d7c8$var$_pointerIsDown && time - $1db01b369728d7c8$var$_lastScrollTime > 200) {
                $1db01b369728d7c8$var$_lastScrollTime = 0;
                $1db01b369728d7c8$var$_dispatch("scrollEnd");
            }
            $1db01b369728d7c8$var$_time2 = $1db01b369728d7c8$var$_time1;
            $1db01b369728d7c8$var$_time1 = time;
        }
        if ($1db01b369728d7c8$var$_direction < 0) {
            $1db01b369728d7c8$var$_i = l;
            while($1db01b369728d7c8$var$_i-- > 0)$1db01b369728d7c8$var$_triggers[$1db01b369728d7c8$var$_i] && $1db01b369728d7c8$var$_triggers[$1db01b369728d7c8$var$_i].update(0, recordVelocity);
            $1db01b369728d7c8$var$_direction = 1;
        } else for($1db01b369728d7c8$var$_i = 0; $1db01b369728d7c8$var$_i < l; $1db01b369728d7c8$var$_i++)$1db01b369728d7c8$var$_triggers[$1db01b369728d7c8$var$_i] && $1db01b369728d7c8$var$_triggers[$1db01b369728d7c8$var$_i].update(0, recordVelocity);
        $1db01b369728d7c8$export$875bcbe48555930.isUpdating = false;
    }
    $1db01b369728d7c8$var$_rafID = 0;
}, $1db01b369728d7c8$var$_propNamesToCopy = [
    $1db01b369728d7c8$var$_left,
    $1db01b369728d7c8$var$_top,
    $1db01b369728d7c8$var$_bottom,
    $1db01b369728d7c8$var$_right,
    $1db01b369728d7c8$var$_margin + $1db01b369728d7c8$var$_Bottom,
    $1db01b369728d7c8$var$_margin + $1db01b369728d7c8$var$_Right,
    $1db01b369728d7c8$var$_margin + $1db01b369728d7c8$var$_Top,
    $1db01b369728d7c8$var$_margin + $1db01b369728d7c8$var$_Left,
    "display",
    "flexShrink",
    "float",
    "zIndex",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRowStart",
    "gridRowEnd",
    "gridArea",
    "justifySelf",
    "alignSelf",
    "placeSelf",
    "order"
], $1db01b369728d7c8$var$_stateProps = $1db01b369728d7c8$var$_propNamesToCopy.concat([
    $1db01b369728d7c8$var$_width,
    $1db01b369728d7c8$var$_height,
    "boxSizing",
    "max" + $1db01b369728d7c8$var$_Width,
    "max" + $1db01b369728d7c8$var$_Height,
    "position",
    $1db01b369728d7c8$var$_margin,
    $1db01b369728d7c8$var$_padding,
    $1db01b369728d7c8$var$_padding + $1db01b369728d7c8$var$_Top,
    $1db01b369728d7c8$var$_padding + $1db01b369728d7c8$var$_Right,
    $1db01b369728d7c8$var$_padding + $1db01b369728d7c8$var$_Bottom,
    $1db01b369728d7c8$var$_padding + $1db01b369728d7c8$var$_Left
]), $1db01b369728d7c8$var$_swapPinOut = function _swapPinOut(pin, spacer, state) {
    $1db01b369728d7c8$var$_setState(state);
    var cache = pin._gsap;
    if (cache.spacerIsNative) $1db01b369728d7c8$var$_setState(cache.spacerState);
    else if (pin._gsap.swappedIn) {
        var parent = spacer.parentNode;
        if (parent) {
            parent.insertBefore(pin, spacer);
            parent.removeChild(spacer);
        }
    }
    pin._gsap.swappedIn = false;
}, $1db01b369728d7c8$var$_swapPinIn = function _swapPinIn(pin, spacer, cs, spacerState) {
    if (!pin._gsap.swappedIn) {
        var i = $1db01b369728d7c8$var$_propNamesToCopy.length, spacerStyle = spacer.style, pinStyle = pin.style, p;
        while(i--){
            p = $1db01b369728d7c8$var$_propNamesToCopy[i];
            spacerStyle[p] = cs[p];
        }
        spacerStyle.position = cs.position === "absolute" ? "absolute" : "relative";
        cs.display === "inline" && (spacerStyle.display = "inline-block");
        pinStyle[$1db01b369728d7c8$var$_bottom] = pinStyle[$1db01b369728d7c8$var$_right] = "auto";
        spacerStyle.flexBasis = cs.flexBasis || "auto";
        spacerStyle.overflow = "visible";
        spacerStyle.boxSizing = "border-box";
        spacerStyle[$1db01b369728d7c8$var$_width] = $1db01b369728d7c8$var$_getSize(pin, (0, $62ae116bd3942e88$export$b2cabb342cb0ebe1)) + $1db01b369728d7c8$var$_px;
        spacerStyle[$1db01b369728d7c8$var$_height] = $1db01b369728d7c8$var$_getSize(pin, (0, $62ae116bd3942e88$export$8e40fc98ff518e9d)) + $1db01b369728d7c8$var$_px;
        spacerStyle[$1db01b369728d7c8$var$_padding] = pinStyle[$1db01b369728d7c8$var$_margin] = pinStyle[$1db01b369728d7c8$var$_top] = pinStyle[$1db01b369728d7c8$var$_left] = "0";
        $1db01b369728d7c8$var$_setState(spacerState);
        pinStyle[$1db01b369728d7c8$var$_width] = pinStyle["max" + $1db01b369728d7c8$var$_Width] = cs[$1db01b369728d7c8$var$_width];
        pinStyle[$1db01b369728d7c8$var$_height] = pinStyle["max" + $1db01b369728d7c8$var$_Height] = cs[$1db01b369728d7c8$var$_height];
        pinStyle[$1db01b369728d7c8$var$_padding] = cs[$1db01b369728d7c8$var$_padding];
        if (pin.parentNode !== spacer) {
            pin.parentNode.insertBefore(spacer, pin);
            spacer.appendChild(pin);
        }
        pin._gsap.swappedIn = true;
    }
}, $1db01b369728d7c8$var$_capsExp = /([A-Z])/g, $1db01b369728d7c8$var$_setState = function _setState(state) {
    if (state) {
        var style = state.t.style, l = state.length, i = 0, p, value;
        (state.t._gsap || $1db01b369728d7c8$var$gsap.core.getCache(state.t)).uncache = 1; // otherwise transforms may be off
        for(; i < l; i += 2){
            value = state[i + 1];
            p = state[i];
            if (value) style[p] = value;
            else if (style[p]) style.removeProperty(p.replace($1db01b369728d7c8$var$_capsExp, "-$1").toLowerCase());
        }
    }
}, $1db01b369728d7c8$var$_getState = function _getState(element) {
    // returns an Array with alternating values like [property, value, property, value] and a "t" property pointing to the target (element). Makes it fast and cheap.
    var l = $1db01b369728d7c8$var$_stateProps.length, style = element.style, state = [], i = 0;
    for(; i < l; i++)state.push($1db01b369728d7c8$var$_stateProps[i], style[$1db01b369728d7c8$var$_stateProps[i]]);
    state.t = element;
    return state;
}, $1db01b369728d7c8$var$_copyState = function _copyState(state, override, omitOffsets) {
    var result = [], l = state.length, i = omitOffsets ? 8 : 0, // skip top, left, right, bottom if omitOffsets is true
    p;
    for(; i < l; i += 2){
        p = state[i];
        result.push(p, p in override ? override[p] : state[i + 1]);
    }
    result.t = state.t;
    return result;
}, $1db01b369728d7c8$var$_winOffsets = {
    left: 0,
    top: 0
}, // // potential future feature (?) Allow users to calculate where a trigger hits (scroll position) like getScrollPosition("#id", "top bottom")
// _getScrollPosition = (trigger, position, {scroller, containerAnimation, horizontal}) => {
// 	scroller = _getTarget(scroller || _win);
// 	let direction = horizontal ? _horizontal : _vertical,
// 		isViewport = _isViewport(scroller);
// 	_getSizeFunc(scroller, isViewport, direction);
// 	return _parsePosition(position, _getTarget(trigger), _getSizeFunc(scroller, isViewport, direction)(), direction, _getScrollFunc(scroller, direction)(), 0, 0, 0, _getOffsetsFunc(scroller, isViewport)(), isViewport ? 0 : parseFloat(_getComputedStyle(scroller)["border" + direction.p2 + _Width]) || 0, 0, containerAnimation ? containerAnimation.duration() : _maxScroll(scroller), containerAnimation);
// },
$1db01b369728d7c8$var$_parsePosition = function _parsePosition(value, trigger, scrollerSize, direction, scroll, marker, markerScroller, self, scrollerBounds, borderWidth, useFixedPosition, scrollerMax, containerAnimation, clampZeroProp) {
    $1db01b369728d7c8$var$_isFunction(value) && (value = value(self));
    if ($1db01b369728d7c8$var$_isString(value) && value.substr(0, 3) === "max") value = scrollerMax + (value.charAt(4) === "=" ? $1db01b369728d7c8$var$_offsetToPx("0" + value.substr(3), scrollerSize) : 0);
    var time = containerAnimation ? containerAnimation.time() : 0, p1, p2, element;
    containerAnimation && containerAnimation.seek(0);
    isNaN(value) || (value = +value); // convert a string number like "45" to an actual number
    if (!$1db01b369728d7c8$var$_isNumber(value)) {
        $1db01b369728d7c8$var$_isFunction(trigger) && (trigger = trigger(self));
        var offsets = (value || "0").split(" "), bounds, localOffset, globalOffset, display;
        element = (0, $62ae116bd3942e88$export$937374fea3f88711)(trigger, self) || $1db01b369728d7c8$var$_body;
        bounds = $1db01b369728d7c8$var$_getBounds(element) || {};
        if ((!bounds || !bounds.left && !bounds.top) && $1db01b369728d7c8$var$_getComputedStyle(element).display === "none") {
            // if display is "none", it won't report getBoundingClientRect() properly
            display = element.style.display;
            element.style.display = "block";
            bounds = $1db01b369728d7c8$var$_getBounds(element);
            display ? element.style.display = display : element.style.removeProperty("display");
        }
        localOffset = $1db01b369728d7c8$var$_offsetToPx(offsets[0], bounds[direction.d]);
        globalOffset = $1db01b369728d7c8$var$_offsetToPx(offsets[1] || "0", scrollerSize);
        value = bounds[direction.p] - scrollerBounds[direction.p] - borderWidth + localOffset + scroll - globalOffset;
        markerScroller && $1db01b369728d7c8$var$_positionMarker(markerScroller, globalOffset, direction, scrollerSize - globalOffset < 20 || markerScroller._isStart && globalOffset > 20);
        scrollerSize -= scrollerSize - globalOffset; // adjust for the marker
    } else {
        containerAnimation && (value = $1db01b369728d7c8$var$gsap.utils.mapRange(containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, 0, scrollerMax, value));
        markerScroller && $1db01b369728d7c8$var$_positionMarker(markerScroller, scrollerSize, direction, true);
    }
    if (clampZeroProp) {
        self[clampZeroProp] = value || -0.001;
        value < 0 && (value = 0);
    }
    if (marker) {
        var position = value + scrollerSize, isStart = marker._isStart;
        p1 = "scroll" + direction.d2;
        $1db01b369728d7c8$var$_positionMarker(marker, position, direction, isStart && position > 20 || !isStart && (useFixedPosition ? Math.max($1db01b369728d7c8$var$_body[p1], $1db01b369728d7c8$var$_docEl[p1]) : marker.parentNode[p1]) <= position + 1);
        if (useFixedPosition) {
            scrollerBounds = $1db01b369728d7c8$var$_getBounds(markerScroller);
            useFixedPosition && (marker.style[direction.op.p] = scrollerBounds[direction.op.p] - direction.op.m - marker._offset + $1db01b369728d7c8$var$_px);
        }
    }
    if (containerAnimation && element) {
        p1 = $1db01b369728d7c8$var$_getBounds(element);
        containerAnimation.seek(scrollerMax);
        p2 = $1db01b369728d7c8$var$_getBounds(element);
        containerAnimation._caScrollDist = p1[direction.p] - p2[direction.p];
        value = value / containerAnimation._caScrollDist * scrollerMax;
    }
    containerAnimation && containerAnimation.seek(time);
    return containerAnimation ? value : Math.round(value);
}, $1db01b369728d7c8$var$_prefixExp = /(webkit|moz|length|cssText|inset)/i, $1db01b369728d7c8$var$_reparent = function _reparent(element, parent, top, left) {
    if (element.parentNode !== parent) {
        var style = element.style, p, cs;
        if (parent === $1db01b369728d7c8$var$_body) {
            element._stOrig = style.cssText; // record original inline styles so we can revert them later
            cs = $1db01b369728d7c8$var$_getComputedStyle(element);
            for(p in cs)// must copy all relevant styles to ensure that nothing changes visually when we reparent to the <body>. Skip the vendor prefixed ones.
            if (!+p && !$1db01b369728d7c8$var$_prefixExp.test(p) && cs[p] && typeof style[p] === "string" && p !== "0") style[p] = cs[p];
            style.top = top;
            style.left = left;
        } else style.cssText = element._stOrig;
        $1db01b369728d7c8$var$gsap.core.getCache(element).uncache = 1;
        parent.appendChild(element);
    }
}, $1db01b369728d7c8$var$_interruptionTracker = function _interruptionTracker(getValueFunc, initialValue, onInterrupt) {
    var last1 = initialValue, last2 = last1;
    return function(value) {
        var current = Math.round(getValueFunc()); // round because in some [very uncommon] Windows environments, scroll can get reported with decimals even though it was set without.
        if (current !== last1 && current !== last2 && Math.abs(current - last1) > 3 && Math.abs(current - last2) > 3) {
            // if the user scrolls, kill the tween. iOS Safari intermittently misreports the scroll position, it may be the most recently-set one or the one before that! When Safari is zoomed (CMD-+), it often misreports as 1 pixel off too! So if we set the scroll position to 125, for example, it'll actually report it as 124.
            value = current;
            onInterrupt && onInterrupt();
        }
        last2 = last1;
        last1 = value;
        return value;
    };
}, $1db01b369728d7c8$var$_shiftMarker = function _shiftMarker(marker, direction, value) {
    var vars = {};
    vars[direction.p] = "+=" + value;
    $1db01b369728d7c8$var$gsap.set(marker, vars);
}, // _mergeAnimations = animations => {
// 	let tl = gsap.timeline({smoothChildTiming: true}).startTime(Math.min(...animations.map(a => a.globalTime(0))));
// 	animations.forEach(a => {let time = a.totalTime(); tl.add(a); a.totalTime(time); });
// 	tl.smoothChildTiming = false;
// 	return tl;
// },
// returns a function that can be used to tween the scroll position in the direction provided, and when doing so it'll add a .tween property to the FUNCTION itself, and remove it when the tween completes or gets killed. This gives us a way to have multiple ScrollTriggers use a central function for any given scroller and see if there's a scroll tween running (which would affect if/how things get updated)
$1db01b369728d7c8$var$_getTweenCreator = function _getTweenCreator(scroller, direction) {
    var getScroll = (0, $62ae116bd3942e88$export$8665aac53dad5647)(scroller, direction), prop = "_scroll" + direction.p2, // add a tweenable property to the scroller that's a getter/setter function, like _scrollTop or _scrollLeft. This way, if someone does gsap.killTweensOf(scroller) it'll kill the scroll tween.
    getTween = function getTween(scrollTo, vars, initialValue, change1, change2) {
        var tween = getTween.tween, onComplete = vars.onComplete, modifiers = {};
        initialValue = initialValue || getScroll();
        var checkForInterruption = $1db01b369728d7c8$var$_interruptionTracker(getScroll, initialValue, function() {
            tween.kill();
            getTween.tween = 0;
        });
        change2 = change1 && change2 || 0; // if change1 is 0, we set that to the difference and ignore change2. Otherwise, there would be a compound effect.
        change1 = change1 || scrollTo - initialValue;
        tween && tween.kill();
        vars[prop] = scrollTo;
        vars.modifiers = modifiers;
        modifiers[prop] = function() {
            return checkForInterruption(initialValue + change1 * tween.ratio + change2 * tween.ratio * tween.ratio);
        };
        vars.onUpdate = function() {
            (0, $62ae116bd3942e88$export$3cd1cee43d19b683).cache++;
            $1db01b369728d7c8$var$_updateAll();
        };
        vars.onComplete = function() {
            getTween.tween = 0;
            onComplete && onComplete.call(tween);
        };
        tween = getTween.tween = $1db01b369728d7c8$var$gsap.to(scroller, vars);
        return tween;
    };
    scroller[prop] = getScroll;
    getScroll.wheelHandler = function() {
        return getTween.tween && getTween.tween.kill() && (getTween.tween = 0);
    };
    $1db01b369728d7c8$var$_addListener(scroller, "wheel", getScroll.wheelHandler); // Windows machines handle mousewheel scrolling in chunks (like "3 lines per scroll") meaning the typical strategy for cancelling the scroll isn't as sensitive. It's much more likely to match one of the previous 2 scroll event positions. So we kill any snapping as soon as there's a wheel event.
    $1db01b369728d7c8$export$875bcbe48555930.isTouch && $1db01b369728d7c8$var$_addListener(scroller, "touchmove", getScroll.wheelHandler);
    return getTween;
};
var $1db01b369728d7c8$export$875bcbe48555930 = /*#__PURE__*/ function() {
    function ScrollTrigger(vars, animation) {
        $1db01b369728d7c8$var$_coreInitted || ScrollTrigger.register($1db01b369728d7c8$var$gsap) || console.warn("Please gsap.registerPlugin(ScrollTrigger)");
        $1db01b369728d7c8$var$_context(this);
        this.init(vars, animation);
    }
    var _proto = ScrollTrigger.prototype;
    _proto.init = function init(vars, animation) {
        this.progress = this.start = 0;
        this.vars && this.kill(true, true); // in case it's being initted again
        if (!$1db01b369728d7c8$var$_enabled) {
            this.update = this.refresh = this.kill = $1db01b369728d7c8$var$_passThrough;
            return;
        }
        vars = $1db01b369728d7c8$var$_setDefaults($1db01b369728d7c8$var$_isString(vars) || $1db01b369728d7c8$var$_isNumber(vars) || vars.nodeType ? {
            trigger: vars
        } : vars, $1db01b369728d7c8$var$_defaults);
        var _vars = vars, onUpdate = _vars.onUpdate, toggleClass = _vars.toggleClass, id = _vars.id, onToggle = _vars.onToggle, onRefresh = _vars.onRefresh, scrub = _vars.scrub, trigger = _vars.trigger, pin = _vars.pin, pinSpacing = _vars.pinSpacing, invalidateOnRefresh = _vars.invalidateOnRefresh, anticipatePin = _vars.anticipatePin, onScrubComplete = _vars.onScrubComplete, onSnapComplete = _vars.onSnapComplete, once = _vars.once, snap = _vars.snap, pinReparent = _vars.pinReparent, pinSpacer = _vars.pinSpacer, containerAnimation = _vars.containerAnimation, fastScrollEnd = _vars.fastScrollEnd, preventOverlaps = _vars.preventOverlaps, direction = vars.horizontal || vars.containerAnimation && vars.horizontal !== false ? (0, $62ae116bd3942e88$export$b2cabb342cb0ebe1) : (0, $62ae116bd3942e88$export$8e40fc98ff518e9d), isToggle = !scrub && scrub !== 0, scroller = (0, $62ae116bd3942e88$export$937374fea3f88711)(vars.scroller || $1db01b369728d7c8$var$_win), scrollerCache = $1db01b369728d7c8$var$gsap.core.getCache(scroller), isViewport = $1db01b369728d7c8$var$_isViewport(scroller), useFixedPosition = ("pinType" in vars ? vars.pinType : (0, $62ae116bd3942e88$export$6078f1ef08b38af9)(scroller, "pinType") || isViewport && "fixed") === "fixed", callbacks = [
            vars.onEnter,
            vars.onLeave,
            vars.onEnterBack,
            vars.onLeaveBack
        ], toggleActions = isToggle && vars.toggleActions.split(" "), markers = "markers" in vars ? vars.markers : $1db01b369728d7c8$var$_defaults.markers, borderWidth = isViewport ? 0 : parseFloat($1db01b369728d7c8$var$_getComputedStyle(scroller)["border" + direction.p2 + $1db01b369728d7c8$var$_Width]) || 0, self = this, onRefreshInit = vars.onRefreshInit && function() {
            return vars.onRefreshInit(self);
        }, getScrollerSize = $1db01b369728d7c8$var$_getSizeFunc(scroller, isViewport, direction), getScrollerOffsets = $1db01b369728d7c8$var$_getOffsetsFunc(scroller, isViewport), lastSnap = 0, lastRefresh = 0, prevProgress = 0, scrollFunc = (0, $62ae116bd3942e88$export$8665aac53dad5647)(scroller, direction), tweenTo, pinCache, snapFunc, scroll1, scroll2, start, end, markerStart, markerEnd, markerStartTrigger, markerEndTrigger, markerVars, executingOnRefresh, change, pinOriginalState, pinActiveState, pinState, spacer, offset, pinGetter, pinSetter, pinStart, pinChange, spacingStart, spacerState, markerStartSetter, pinMoves, markerEndSetter, cs, snap1, snap2, scrubTween, scrubSmooth, snapDurClamp, snapDelayedCall, prevScroll, prevAnimProgress, caMarkerSetter, customRevertReturn; // for the sake of efficiency, _startClamp/_endClamp serve like a truthy value indicating that clamping was enabled on the start/end, and ALSO store the actual pre-clamped numeric value. We tap into that in ScrollSmoother for speed effects. So for example, if start="clamp(top bottom)" results in a start of -100 naturally, it would get clamped to 0 but -100 would be stored in _startClamp.
        self._startClamp = self._endClamp = false;
        self._dir = direction;
        anticipatePin *= 45;
        self.scroller = scroller;
        self.scroll = containerAnimation ? containerAnimation.time.bind(containerAnimation) : scrollFunc;
        scroll1 = scrollFunc();
        self.vars = vars;
        animation = animation || vars.animation;
        if ("refreshPriority" in vars) {
            $1db01b369728d7c8$var$_sort = 1;
            vars.refreshPriority === -9999 && ($1db01b369728d7c8$var$_primary = self); // used by ScrollSmoother
        }
        scrollerCache.tweenScroll = scrollerCache.tweenScroll || {
            top: $1db01b369728d7c8$var$_getTweenCreator(scroller, (0, $62ae116bd3942e88$export$8e40fc98ff518e9d)),
            left: $1db01b369728d7c8$var$_getTweenCreator(scroller, (0, $62ae116bd3942e88$export$b2cabb342cb0ebe1))
        };
        self.tweenTo = tweenTo = scrollerCache.tweenScroll[direction.p];
        self.scrubDuration = function(value) {
            scrubSmooth = $1db01b369728d7c8$var$_isNumber(value) && value;
            if (!scrubSmooth) {
                scrubTween && scrubTween.progress(1).kill();
                scrubTween = 0;
            } else scrubTween ? scrubTween.duration(value) : scrubTween = $1db01b369728d7c8$var$gsap.to(animation, {
                ease: "expo",
                totalProgress: "+=0",
                duration: scrubSmooth,
                paused: true,
                onComplete: function onComplete() {
                    return onScrubComplete && onScrubComplete(self);
                }
            });
        };
        if (animation) {
            animation.vars.lazy = false;
            animation._initted && !self.isReverted || animation.vars.immediateRender !== false && vars.immediateRender !== false && animation.duration() && animation.render(0, true, true); // special case: if this ScrollTrigger gets re-initted, a from() tween with a stagger could get initted initially and then reverted on the re-init which means it'll need to get rendered again here to properly display things. Otherwise, See https://greensock.com/forums/topic/36777-scrollsmoother-splittext-nextjs/ and https://codepen.io/GreenSock/pen/eYPyPpd?editors=0010
            self.animation = animation.pause();
            animation.scrollTrigger = self;
            self.scrubDuration(scrub);
            snap1 = 0;
            id || (id = animation.vars.id);
        }
        if (snap) {
            // TODO: potential idea: use legitimate CSS scroll snapping by pushing invisible elements into the DOM that serve as snap positions, and toggle the document.scrollingElement.style.scrollSnapType onToggle. See https://codepen.io/GreenSock/pen/JjLrgWM for a quick proof of concept.
            if (!$1db01b369728d7c8$var$_isObject(snap) || snap.push) snap = {
                snapTo: snap
            };
            "scrollBehavior" in $1db01b369728d7c8$var$_body.style && $1db01b369728d7c8$var$gsap.set(isViewport ? [
                $1db01b369728d7c8$var$_body,
                $1db01b369728d7c8$var$_docEl
            ] : scroller, {
                scrollBehavior: "auto"
            }); // smooth scrolling doesn't work with snap.
            (0, $62ae116bd3942e88$export$3cd1cee43d19b683).forEach(function(o) {
                return $1db01b369728d7c8$var$_isFunction(o) && o.target === (isViewport ? $1db01b369728d7c8$var$_doc.scrollingElement || $1db01b369728d7c8$var$_docEl : scroller) && (o.smooth = false);
            }); // note: set smooth to false on both the vertical and horizontal scroll getters/setters
            snapFunc = $1db01b369728d7c8$var$_isFunction(snap.snapTo) ? snap.snapTo : snap.snapTo === "labels" ? $1db01b369728d7c8$var$_getClosestLabel(animation) : snap.snapTo === "labelsDirectional" ? $1db01b369728d7c8$var$_getLabelAtDirection(animation) : snap.directional !== false ? function(value, st) {
                return $1db01b369728d7c8$var$_snapDirectional(snap.snapTo)(value, $1db01b369728d7c8$var$_getTime() - lastRefresh < 500 ? 0 : st.direction);
            } : $1db01b369728d7c8$var$gsap.utils.snap(snap.snapTo);
            snapDurClamp = snap.duration || {
                min: 0.1,
                max: 2
            };
            snapDurClamp = $1db01b369728d7c8$var$_isObject(snapDurClamp) ? $1db01b369728d7c8$var$_clamp(snapDurClamp.min, snapDurClamp.max) : $1db01b369728d7c8$var$_clamp(snapDurClamp, snapDurClamp);
            snapDelayedCall = $1db01b369728d7c8$var$gsap.delayedCall(snap.delay || scrubSmooth / 2 || 0.1, function() {
                var scroll = scrollFunc(), refreshedRecently = $1db01b369728d7c8$var$_getTime() - lastRefresh < 500, tween = tweenTo.tween;
                if ((refreshedRecently || Math.abs(self.getVelocity()) < 10) && !tween && !$1db01b369728d7c8$var$_pointerIsDown && lastSnap !== scroll) {
                    var progress = (scroll - start) / change, totalProgress = animation && !isToggle ? animation.totalProgress() : progress, velocity = refreshedRecently ? 0 : (totalProgress - snap2) / ($1db01b369728d7c8$var$_getTime() - $1db01b369728d7c8$var$_time2) * 1000 || 0, change1 = $1db01b369728d7c8$var$gsap.utils.clamp(-progress, 1 - progress, $1db01b369728d7c8$var$_abs(velocity / 2) * velocity / 0.185), naturalEnd = progress + (snap.inertia === false ? 0 : change1), endValue = $1db01b369728d7c8$var$_clamp(0, 1, snapFunc(naturalEnd, self)), endScroll = Math.round(start + endValue * change), _snap = snap, onStart = _snap.onStart, _onInterrupt = _snap.onInterrupt, _onComplete = _snap.onComplete;
                    if (scroll <= end && scroll >= start && endScroll !== scroll) {
                        if (tween && !tween._initted && tween.data <= $1db01b369728d7c8$var$_abs(endScroll - scroll)) // there's an overlapping snap! So we must figure out which one is closer and let that tween live.
                        return;
                        if (snap.inertia === false) change1 = endValue - progress;
                        tweenTo(endScroll, {
                            duration: snapDurClamp($1db01b369728d7c8$var$_abs(Math.max($1db01b369728d7c8$var$_abs(naturalEnd - totalProgress), $1db01b369728d7c8$var$_abs(endValue - totalProgress)) * 0.185 / velocity / 0.05 || 0)),
                            ease: snap.ease || "power3",
                            data: $1db01b369728d7c8$var$_abs(endScroll - scroll),
                            // record the distance so that if another snap tween occurs (conflict) we can prioritize the closest snap.
                            onInterrupt: function onInterrupt() {
                                return snapDelayedCall.restart(true) && _onInterrupt && _onInterrupt(self);
                            },
                            onComplete: function onComplete() {
                                self.update();
                                lastSnap = scrollFunc();
                                snap1 = snap2 = animation && !isToggle ? animation.totalProgress() : self.progress;
                                onSnapComplete && onSnapComplete(self);
                                _onComplete && _onComplete(self);
                            }
                        }, scroll, change1 * change, endScroll - scroll - change1 * change);
                        onStart && onStart(self, tweenTo.tween);
                    }
                } else if (self.isActive && lastSnap !== scroll) snapDelayedCall.restart(true);
            }).pause();
        }
        id && ($1db01b369728d7c8$var$_ids[id] = self);
        trigger = self.trigger = (0, $62ae116bd3942e88$export$937374fea3f88711)(trigger || pin !== true && pin); // if a trigger has some kind of scroll-related effect applied that could contaminate the "y" or "x" position (like a ScrollSmoother effect), we needed a way to temporarily revert it, so we use the stRevert property of the gsCache. It can return another function that we'll call at the end so it can return to its normal state.
        customRevertReturn = trigger && trigger._gsap && trigger._gsap.stRevert;
        customRevertReturn && (customRevertReturn = customRevertReturn(self));
        pin = pin === true ? trigger : (0, $62ae116bd3942e88$export$937374fea3f88711)(pin);
        $1db01b369728d7c8$var$_isString(toggleClass) && (toggleClass = {
            targets: trigger,
            className: toggleClass
        });
        if (pin) {
            pinSpacing === false || pinSpacing === $1db01b369728d7c8$var$_margin || (pinSpacing = !pinSpacing && pin.parentNode && pin.parentNode.style && $1db01b369728d7c8$var$_getComputedStyle(pin.parentNode).display === "flex" ? false : $1db01b369728d7c8$var$_padding); // if the parent is display: flex, don't apply pinSpacing by default. We should check that pin.parentNode is an element (not shadow dom window)
            self.pin = pin;
            pinCache = $1db01b369728d7c8$var$gsap.core.getCache(pin);
            if (!pinCache.spacer) {
                // record the spacer and pinOriginalState on the cache in case someone tries pinning the same element with MULTIPLE ScrollTriggers - we don't want to have multiple spacers or record the "original" pin state after it has already been affected by another ScrollTrigger.
                if (pinSpacer) {
                    pinSpacer = (0, $62ae116bd3942e88$export$937374fea3f88711)(pinSpacer);
                    pinSpacer && !pinSpacer.nodeType && (pinSpacer = pinSpacer.current || pinSpacer.nativeElement); // for React & Angular
                    pinCache.spacerIsNative = !!pinSpacer;
                    pinSpacer && (pinCache.spacerState = $1db01b369728d7c8$var$_getState(pinSpacer));
                }
                pinCache.spacer = spacer = pinSpacer || $1db01b369728d7c8$var$_doc.createElement("div");
                spacer.classList.add("pin-spacer");
                id && spacer.classList.add("pin-spacer-" + id);
                pinCache.pinState = pinOriginalState = $1db01b369728d7c8$var$_getState(pin);
            } else pinOriginalState = pinCache.pinState;
            vars.force3D !== false && $1db01b369728d7c8$var$gsap.set(pin, {
                force3D: true
            });
            self.spacer = spacer = pinCache.spacer;
            cs = $1db01b369728d7c8$var$_getComputedStyle(pin);
            spacingStart = cs[pinSpacing + direction.os2];
            pinGetter = $1db01b369728d7c8$var$gsap.getProperty(pin);
            pinSetter = $1db01b369728d7c8$var$gsap.quickSetter(pin, direction.a, $1db01b369728d7c8$var$_px); // pin.firstChild && !_maxScroll(pin, direction) && (pin.style.overflow = "hidden"); // protects from collapsing margins, but can have unintended consequences as demonstrated here: https://codepen.io/GreenSock/pen/1e42c7a73bfa409d2cf1e184e7a4248d so it was removed in favor of just telling people to set up their CSS to avoid the collapsing margins (overflow: hidden | auto is just one option. Another is border-top: 1px solid transparent).
            $1db01b369728d7c8$var$_swapPinIn(pin, spacer, cs);
            pinState = $1db01b369728d7c8$var$_getState(pin);
        }
        if (markers) {
            markerVars = $1db01b369728d7c8$var$_isObject(markers) ? $1db01b369728d7c8$var$_setDefaults(markers, $1db01b369728d7c8$var$_markerDefaults) : $1db01b369728d7c8$var$_markerDefaults;
            markerStartTrigger = $1db01b369728d7c8$var$_createMarker("scroller-start", id, scroller, direction, markerVars, 0);
            markerEndTrigger = $1db01b369728d7c8$var$_createMarker("scroller-end", id, scroller, direction, markerVars, 0, markerStartTrigger);
            offset = markerStartTrigger["offset" + direction.op.d2];
            var content = (0, $62ae116bd3942e88$export$937374fea3f88711)((0, $62ae116bd3942e88$export$6078f1ef08b38af9)(scroller, "content") || scroller);
            markerStart = this.markerStart = $1db01b369728d7c8$var$_createMarker("start", id, content, direction, markerVars, offset, 0, containerAnimation);
            markerEnd = this.markerEnd = $1db01b369728d7c8$var$_createMarker("end", id, content, direction, markerVars, offset, 0, containerAnimation);
            containerAnimation && (caMarkerSetter = $1db01b369728d7c8$var$gsap.quickSetter([
                markerStart,
                markerEnd
            ], direction.a, $1db01b369728d7c8$var$_px));
            if (!useFixedPosition && !((0, $62ae116bd3942e88$export$d8e56d510a804d0a).length && (0, $62ae116bd3942e88$export$6078f1ef08b38af9)(scroller, "fixedMarkers") === true)) {
                $1db01b369728d7c8$var$_makePositionable(isViewport ? $1db01b369728d7c8$var$_body : scroller);
                $1db01b369728d7c8$var$gsap.set([
                    markerStartTrigger,
                    markerEndTrigger
                ], {
                    force3D: true
                });
                markerStartSetter = $1db01b369728d7c8$var$gsap.quickSetter(markerStartTrigger, direction.a, $1db01b369728d7c8$var$_px);
                markerEndSetter = $1db01b369728d7c8$var$gsap.quickSetter(markerEndTrigger, direction.a, $1db01b369728d7c8$var$_px);
            }
        }
        if (containerAnimation) {
            var oldOnUpdate = containerAnimation.vars.onUpdate, oldParams = containerAnimation.vars.onUpdateParams;
            containerAnimation.eventCallback("onUpdate", function() {
                self.update(0, 0, 1);
                oldOnUpdate && oldOnUpdate.apply(containerAnimation, oldParams || []);
            });
        }
        self.previous = function() {
            return $1db01b369728d7c8$var$_triggers[$1db01b369728d7c8$var$_triggers.indexOf(self) - 1];
        };
        self.next = function() {
            return $1db01b369728d7c8$var$_triggers[$1db01b369728d7c8$var$_triggers.indexOf(self) + 1];
        };
        self.revert = function(revert, temp) {
            if (!temp) return self.kill(true);
             // for compatibility with gsap.context() and gsap.matchMedia() which call revert()
            var r = revert !== false || !self.enabled, prevRefreshing = $1db01b369728d7c8$var$_refreshing;
            if (r !== self.isReverted) {
                if (r) {
                    prevScroll = Math.max(scrollFunc(), self.scroll.rec || 0); // record the scroll so we can revert later (repositioning/pinning things can affect scroll position). In the static refresh() method, we first record all the scroll positions as a reference.
                    prevProgress = self.progress;
                    prevAnimProgress = animation && animation.progress();
                }
                markerStart && [
                    markerStart,
                    markerEnd,
                    markerStartTrigger,
                    markerEndTrigger
                ].forEach(function(m) {
                    return m.style.display = r ? "none" : "block";
                });
                if (r) {
                    $1db01b369728d7c8$var$_refreshing = self;
                    self.update(r); // make sure the pin is back in its original position so that all the measurements are correct. do this BEFORE swapping the pin out
                }
                if (pin && (!pinReparent || !self.isActive)) {
                    if (r) $1db01b369728d7c8$var$_swapPinOut(pin, spacer, pinOriginalState);
                    else $1db01b369728d7c8$var$_swapPinIn(pin, spacer, $1db01b369728d7c8$var$_getComputedStyle(pin), spacerState);
                }
                r || self.update(r); // when we're restoring, the update should run AFTER swapping the pin into its pin-spacer.
                $1db01b369728d7c8$var$_refreshing = prevRefreshing; // restore. We set it to true during the update() so that things fire properly in there.
                self.isReverted = r;
            }
        };
        self.refresh = function(soft, force, position, pinOffset) {
            // position is typically only defined if it's coming from setPositions() - it's a way to skip the normal parsing. pinOffset is also only from setPositions() and is mostly related to fancy stuff we need to do in ScrollSmoother with effects
            if (($1db01b369728d7c8$var$_refreshing || !self.enabled) && !force) return;
            if (pin && soft && $1db01b369728d7c8$var$_lastScrollTime) {
                $1db01b369728d7c8$var$_addListener(ScrollTrigger, "scrollEnd", $1db01b369728d7c8$var$_softRefresh);
                return;
            }
            !$1db01b369728d7c8$var$_refreshingAll && onRefreshInit && onRefreshInit(self);
            $1db01b369728d7c8$var$_refreshing = self;
            if (tweenTo.tween && !position) {
                // we skip this if a position is passed in because typically that's from .setPositions() and it's best to allow in-progress snapping to continue.
                tweenTo.tween.kill();
                tweenTo.tween = 0;
            }
            scrubTween && scrubTween.pause();
            invalidateOnRefresh && animation && animation.revert({
                kill: false
            }).invalidate();
            self.isReverted || self.revert(true, true);
            self._subPinOffset = false; // we'll set this to true in the sub-pins if we find any
            var size = getScrollerSize(), scrollerBounds = getScrollerOffsets(), max = containerAnimation ? containerAnimation.duration() : $1db01b369728d7c8$var$_maxScroll(scroller, direction), isFirstRefresh = change <= 0.01, offset = 0, otherPinOffset = pinOffset || 0, parsedEnd = $1db01b369728d7c8$var$_isObject(position) ? position.end : vars.end, parsedEndTrigger = vars.endTrigger || trigger, parsedStart = $1db01b369728d7c8$var$_isObject(position) ? position.start : vars.start || (vars.start === 0 || !trigger ? 0 : pin ? "0 0" : "0 100%"), pinnedContainer = self.pinnedContainer = vars.pinnedContainer && (0, $62ae116bd3942e88$export$937374fea3f88711)(vars.pinnedContainer, self), triggerIndex = trigger && Math.max(0, $1db01b369728d7c8$var$_triggers.indexOf(self)) || 0, i = triggerIndex, cs, bounds, scroll, isVertical, override, curTrigger, curPin, oppositeScroll, initted, revertedPins, forcedOverflow, markerStartOffset, markerEndOffset;
            if (markers && $1db01b369728d7c8$var$_isObject(position)) {
                // if we alter the start/end positions with .setPositions(), it generally feeds in absolute NUMBERS which don't convey information about where to line up the markers, so to keep it intuitive, we record how far the trigger positions shift after applying the new numbers and then offset by that much in the opposite direction. We do the same to the associated trigger markers too of course.
                markerStartOffset = $1db01b369728d7c8$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset = $1db01b369728d7c8$var$gsap.getProperty(markerEndTrigger, direction.p);
            }
            while(i--){
                // user might try to pin the same element more than once, so we must find any prior triggers with the same pin, revert them, and determine how long they're pinning so that we can offset things appropriately. Make sure we revert from last to first so that things "rewind" properly.
                curTrigger = $1db01b369728d7c8$var$_triggers[i];
                curTrigger.end || curTrigger.refresh(0, 1) || ($1db01b369728d7c8$var$_refreshing = self); // if it's a timeline-based trigger that hasn't been fully initialized yet because it's waiting for 1 tick, just force the refresh() here, otherwise if it contains a pin that's supposed to affect other ScrollTriggers further down the page, they won't be adjusted properly.
                curPin = curTrigger.pin;
                if (curPin && (curPin === trigger || curPin === pin || curPin === pinnedContainer) && !curTrigger.isReverted) {
                    revertedPins || (revertedPins = []);
                    revertedPins.unshift(curTrigger); // we'll revert from first to last to make sure things reach their end state properly
                    curTrigger.revert(true, true);
                }
                if (curTrigger !== $1db01b369728d7c8$var$_triggers[i]) {
                    // in case it got removed.
                    triggerIndex--;
                    i--;
                }
            }
            $1db01b369728d7c8$var$_isFunction(parsedStart) && (parsedStart = parsedStart(self));
            parsedStart = $1db01b369728d7c8$var$_parseClamp(parsedStart, "start", self);
            start = $1db01b369728d7c8$var$_parsePosition(parsedStart, trigger, size, direction, scrollFunc(), markerStart, markerStartTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._startClamp && "_startClamp") || (pin ? -0.001 : 0);
            $1db01b369728d7c8$var$_isFunction(parsedEnd) && (parsedEnd = parsedEnd(self));
            if ($1db01b369728d7c8$var$_isString(parsedEnd) && !parsedEnd.indexOf("+=")) {
                if (~parsedEnd.indexOf(" ")) parsedEnd = ($1db01b369728d7c8$var$_isString(parsedStart) ? parsedStart.split(" ")[0] : "") + parsedEnd;
                else {
                    offset = $1db01b369728d7c8$var$_offsetToPx(parsedEnd.substr(2), size);
                    parsedEnd = $1db01b369728d7c8$var$_isString(parsedStart) ? parsedStart : (containerAnimation ? $1db01b369728d7c8$var$gsap.utils.mapRange(0, containerAnimation.duration(), containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, start) : start) + offset; // _parsePosition won't factor in the offset if the start is a number, so do it here.
                    parsedEndTrigger = trigger;
                }
            }
            parsedEnd = $1db01b369728d7c8$var$_parseClamp(parsedEnd, "end", self);
            end = Math.max(start, $1db01b369728d7c8$var$_parsePosition(parsedEnd || (parsedEndTrigger ? "100% 0" : max), parsedEndTrigger, size, direction, scrollFunc() + offset, markerEnd, markerEndTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._endClamp && "_endClamp")) || -0.001;
            offset = 0;
            i = triggerIndex;
            while(i--){
                curTrigger = $1db01b369728d7c8$var$_triggers[i];
                curPin = curTrigger.pin;
                if (curPin && curTrigger.start - curTrigger._pinPush <= start && !containerAnimation && curTrigger.end > 0) {
                    cs = curTrigger.end - (self._startClamp ? Math.max(0, curTrigger.start) : curTrigger.start);
                    if ((curPin === trigger && curTrigger.start - curTrigger._pinPush < start || curPin === pinnedContainer) && isNaN(parsedStart)) // numeric start values shouldn't be offset at all - treat them as absolute
                    offset += cs * (1 - curTrigger.progress);
                    curPin === pin && (otherPinOffset += cs);
                }
            }
            start += offset;
            end += offset;
            self._startClamp && (self._startClamp += offset);
            if (self._endClamp && !$1db01b369728d7c8$var$_refreshingAll) {
                self._endClamp = end || -0.001;
                end = Math.min(end, $1db01b369728d7c8$var$_maxScroll(scroller, direction));
            }
            change = end - start || (start -= 0.01) && 0.001;
            if (isFirstRefresh) // on the very first refresh(), the prevProgress couldn't have been accurate yet because the start/end were never calculated, so we set it here. Before 3.11.5, it could lead to an inaccurate scroll position restoration with snapping.
            prevProgress = $1db01b369728d7c8$var$gsap.utils.clamp(0, 1, $1db01b369728d7c8$var$gsap.utils.normalize(start, end, prevScroll));
            self._pinPush = otherPinOffset;
            if (markerStart && offset) {
                // offset the markers if necessary
                cs = {};
                cs[direction.a] = "+=" + offset;
                pinnedContainer && (cs[direction.p] = "-=" + scrollFunc());
                $1db01b369728d7c8$var$gsap.set([
                    markerStart,
                    markerEnd
                ], cs);
            }
            if (pin) {
                cs = $1db01b369728d7c8$var$_getComputedStyle(pin);
                isVertical = direction === (0, $62ae116bd3942e88$export$8e40fc98ff518e9d);
                scroll = scrollFunc(); // recalculate because the triggers can affect the scroll
                pinStart = parseFloat(pinGetter(direction.a)) + otherPinOffset;
                if (!max && end > 1) {
                    // makes sure the scroller has a scrollbar, otherwise if something has width: 100%, for example, it would be too big (exclude the scrollbar). See https://greensock.com/forums/topic/25182-scrolltrigger-width-of-page-increase-where-markers-are-set-to-false/
                    forcedOverflow = (isViewport ? $1db01b369728d7c8$var$_doc.scrollingElement || $1db01b369728d7c8$var$_docEl : scroller).style;
                    forcedOverflow = {
                        style: forcedOverflow,
                        value: forcedOverflow["overflow" + direction.a.toUpperCase()]
                    };
                    if (isViewport && $1db01b369728d7c8$var$_getComputedStyle($1db01b369728d7c8$var$_body)["overflow" + direction.a.toUpperCase()] !== "scroll") // avoid an extra scrollbar if BOTH <html> and <body> have overflow set to "scroll"
                    forcedOverflow.style["overflow" + direction.a.toUpperCase()] = "scroll";
                }
                $1db01b369728d7c8$var$_swapPinIn(pin, spacer, cs);
                pinState = $1db01b369728d7c8$var$_getState(pin); // transforms will interfere with the top/left/right/bottom placement, so remove them temporarily. getBoundingClientRect() factors in transforms.
                bounds = $1db01b369728d7c8$var$_getBounds(pin, true);
                oppositeScroll = useFixedPosition && (0, $62ae116bd3942e88$export$8665aac53dad5647)(scroller, isVertical ? (0, $62ae116bd3942e88$export$b2cabb342cb0ebe1) : (0, $62ae116bd3942e88$export$8e40fc98ff518e9d))();
                if (pinSpacing) {
                    spacerState = [
                        pinSpacing + direction.os2,
                        change + otherPinOffset + $1db01b369728d7c8$var$_px
                    ];
                    spacerState.t = spacer;
                    i = pinSpacing === $1db01b369728d7c8$var$_padding ? $1db01b369728d7c8$var$_getSize(pin, direction) + change + otherPinOffset : 0;
                    i && spacerState.push(direction.d, i + $1db01b369728d7c8$var$_px); // for box-sizing: border-box (must include padding).
                    $1db01b369728d7c8$var$_setState(spacerState);
                    if (pinnedContainer) // in ScrollTrigger.refresh(), we need to re-evaluate the pinContainer's size because this pinSpacing may stretch it out, but we can't just add the exact distance because depending on layout, it may not push things down or it may only do so partially.
                    $1db01b369728d7c8$var$_triggers.forEach(function(t) {
                        if (t.pin === pinnedContainer && t.vars.pinSpacing !== false) t._subPinOffset = true;
                    });
                    useFixedPosition && scrollFunc(prevScroll);
                }
                if (useFixedPosition) {
                    override = {
                        top: bounds.top + (isVertical ? scroll - start : oppositeScroll) + $1db01b369728d7c8$var$_px,
                        left: bounds.left + (isVertical ? oppositeScroll : scroll - start) + $1db01b369728d7c8$var$_px,
                        boxSizing: "border-box",
                        position: "fixed"
                    };
                    override[$1db01b369728d7c8$var$_width] = override["max" + $1db01b369728d7c8$var$_Width] = Math.ceil(bounds.width) + $1db01b369728d7c8$var$_px;
                    override[$1db01b369728d7c8$var$_height] = override["max" + $1db01b369728d7c8$var$_Height] = Math.ceil(bounds.height) + $1db01b369728d7c8$var$_px;
                    override[$1db01b369728d7c8$var$_margin] = override[$1db01b369728d7c8$var$_margin + $1db01b369728d7c8$var$_Top] = override[$1db01b369728d7c8$var$_margin + $1db01b369728d7c8$var$_Right] = override[$1db01b369728d7c8$var$_margin + $1db01b369728d7c8$var$_Bottom] = override[$1db01b369728d7c8$var$_margin + $1db01b369728d7c8$var$_Left] = "0";
                    override[$1db01b369728d7c8$var$_padding] = cs[$1db01b369728d7c8$var$_padding];
                    override[$1db01b369728d7c8$var$_padding + $1db01b369728d7c8$var$_Top] = cs[$1db01b369728d7c8$var$_padding + $1db01b369728d7c8$var$_Top];
                    override[$1db01b369728d7c8$var$_padding + $1db01b369728d7c8$var$_Right] = cs[$1db01b369728d7c8$var$_padding + $1db01b369728d7c8$var$_Right];
                    override[$1db01b369728d7c8$var$_padding + $1db01b369728d7c8$var$_Bottom] = cs[$1db01b369728d7c8$var$_padding + $1db01b369728d7c8$var$_Bottom];
                    override[$1db01b369728d7c8$var$_padding + $1db01b369728d7c8$var$_Left] = cs[$1db01b369728d7c8$var$_padding + $1db01b369728d7c8$var$_Left];
                    pinActiveState = $1db01b369728d7c8$var$_copyState(pinOriginalState, override, pinReparent);
                    $1db01b369728d7c8$var$_refreshingAll && scrollFunc(0);
                }
                if (animation) {
                    // the animation might be affecting the transform, so we must jump to the end, check the value, and compensate accordingly. Otherwise, when it becomes unpinned, the pinSetter() will get set to a value that doesn't include whatever the animation did.
                    initted = animation._initted; // if not, we must invalidate() after this step, otherwise it could lock in starting values prematurely.
                    $1db01b369728d7c8$var$_suppressOverwrites(1);
                    animation.render(animation.duration(), true, true);
                    pinChange = pinGetter(direction.a) - pinStart + change + otherPinOffset;
                    pinMoves = Math.abs(change - pinChange) > 1;
                    useFixedPosition && pinMoves && pinActiveState.splice(pinActiveState.length - 2, 2); // transform is the last property/value set in the state Array. Since the animation is controlling that, we should omit it.
                    animation.render(0, true, true);
                    initted || animation.invalidate(true);
                    animation.parent || animation.totalTime(animation.totalTime()); // if, for example, a toggleAction called play() and then refresh() happens and when we render(1) above, it would cause the animation to complete and get removed from its parent, so this makes sure it gets put back in.
                    $1db01b369728d7c8$var$_suppressOverwrites(0);
                } else pinChange = change;
                forcedOverflow && (forcedOverflow.value ? forcedOverflow.style["overflow" + direction.a.toUpperCase()] = forcedOverflow.value : forcedOverflow.style.removeProperty("overflow-" + direction.a));
            } else if (trigger && scrollFunc() && !containerAnimation) {
                // it may be INSIDE a pinned element, so walk up the tree and look for any elements with _pinOffset to compensate because anything with pinSpacing that's already scrolled would throw off the measurements in getBoundingClientRect()
                bounds = trigger.parentNode;
                while(bounds && bounds !== $1db01b369728d7c8$var$_body){
                    if (bounds._pinOffset) {
                        start -= bounds._pinOffset;
                        end -= bounds._pinOffset;
                    }
                    bounds = bounds.parentNode;
                }
            }
            revertedPins && revertedPins.forEach(function(t) {
                return t.revert(false, true);
            });
            self.start = start;
            self.end = end;
            scroll1 = scroll2 = $1db01b369728d7c8$var$_refreshingAll ? prevScroll : scrollFunc(); // reset velocity
            if (!containerAnimation && !$1db01b369728d7c8$var$_refreshingAll) {
                scroll1 < prevScroll && scrollFunc(prevScroll);
                self.scroll.rec = 0;
            }
            self.revert(false, true);
            lastRefresh = $1db01b369728d7c8$var$_getTime();
            if (snapDelayedCall) {
                lastSnap = -1; // just so snapping gets re-enabled, clear out any recorded last value
                // self.isActive && scrollFunc(start + change * prevProgress); // previously this line was here to ensure that when snapping kicks in, it's from the previous progress but in some cases that's not desirable, like an all-page ScrollTrigger when new content gets added to the page, that'd totally change the progress.
                snapDelayedCall.restart(true);
            }
            $1db01b369728d7c8$var$_refreshing = 0;
            animation && isToggle && (animation._initted || prevAnimProgress) && animation.progress() !== prevAnimProgress && animation.progress(prevAnimProgress || 0, true).render(animation.time(), true, true); // must force a re-render because if saveStyles() was used on the target(s), the styles could have been wiped out during the refresh().
            if (isFirstRefresh || prevProgress !== self.progress || containerAnimation) {
                // ensures that the direction is set properly (when refreshing, progress is set back to 0 initially, then back again to wherever it needs to be) and that callbacks are triggered.
                animation && !isToggle && animation.totalProgress(containerAnimation && start < -0.001 && !prevProgress ? $1db01b369728d7c8$var$gsap.utils.normalize(start, end, 0) : prevProgress, true); // to avoid issues where animation callbacks like onStart aren't triggered.
                self.progress = isFirstRefresh || (scroll1 - start) / change === prevProgress ? 0 : prevProgress;
            }
            pin && pinSpacing && (spacer._pinOffset = Math.round(self.progress * pinChange));
            scrubTween && scrubTween.invalidate();
            if (!isNaN(markerStartOffset)) {
                // numbers were passed in for the position which are absolute, so instead of just putting the markers at the very bottom of the viewport, we figure out how far they shifted down (it's safe to assume they were originally positioned in closer relation to the trigger element with values like "top", "center", a percentage or whatever, so we offset that much in the opposite direction to basically revert them to the relative position thy were at previously.
                markerStartOffset -= $1db01b369728d7c8$var$gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset -= $1db01b369728d7c8$var$gsap.getProperty(markerEndTrigger, direction.p);
                $1db01b369728d7c8$var$_shiftMarker(markerStartTrigger, direction, markerStartOffset);
                $1db01b369728d7c8$var$_shiftMarker(markerStart, direction, markerStartOffset - (pinOffset || 0));
                $1db01b369728d7c8$var$_shiftMarker(markerEndTrigger, direction, markerEndOffset);
                $1db01b369728d7c8$var$_shiftMarker(markerEnd, direction, markerEndOffset - (pinOffset || 0));
            }
            isFirstRefresh && !$1db01b369728d7c8$var$_refreshingAll && self.update(); // edge case - when you reload a page when it's already scrolled down, some browsers fire a "scroll" event before DOMContentLoaded, triggering an updateAll(). If we don't update the self.progress as part of refresh(), then when it happens next, it may record prevProgress as 0 when it really shouldn't, potentially causing a callback in an animation to fire again.
            if (onRefresh && !$1db01b369728d7c8$var$_refreshingAll && !executingOnRefresh) {
                // when refreshing all, we do extra work to correct pinnedContainer sizes and ensure things don't exceed the maxScroll, so we should do all the refreshes at the end after all that work so that the start/end values are corrected.
                executingOnRefresh = true;
                onRefresh(self);
                executingOnRefresh = false;
            }
        };
        self.getVelocity = function() {
            return (scrollFunc() - scroll2) / ($1db01b369728d7c8$var$_getTime() - $1db01b369728d7c8$var$_time2) * 1000 || 0;
        };
        self.endAnimation = function() {
            $1db01b369728d7c8$var$_endAnimation(self.callbackAnimation);
            if (animation) scrubTween ? scrubTween.progress(1) : !animation.paused() ? $1db01b369728d7c8$var$_endAnimation(animation, animation.reversed()) : isToggle || $1db01b369728d7c8$var$_endAnimation(animation, self.direction < 0, 1);
        };
        self.labelToScroll = function(label) {
            return animation && animation.labels && (start || self.refresh() || start) + animation.labels[label] / animation.duration() * change || 0;
        };
        self.getTrailing = function(name) {
            var i = $1db01b369728d7c8$var$_triggers.indexOf(self), a = self.direction > 0 ? $1db01b369728d7c8$var$_triggers.slice(0, i).reverse() : $1db01b369728d7c8$var$_triggers.slice(i + 1);
            return ($1db01b369728d7c8$var$_isString(name) ? a.filter(function(t) {
                return t.vars.preventOverlaps === name;
            }) : a).filter(function(t) {
                return self.direction > 0 ? t.end <= start : t.start >= end;
            });
        };
        self.update = function(reset, recordVelocity, forceFake) {
            if (containerAnimation && !forceFake && !reset) return;
            var scroll = $1db01b369728d7c8$var$_refreshingAll === true ? prevScroll : self.scroll(), p = reset ? 0 : (scroll - start) / change, clipped = p < 0 ? 0 : p > 1 ? 1 : p || 0, prevProgress = self.progress, isActive, wasActive, toggleState, action, stateChanged, toggled, isAtMax, isTakingAction;
            if (recordVelocity) {
                scroll2 = scroll1;
                scroll1 = containerAnimation ? scrollFunc() : scroll;
                if (snap) {
                    snap2 = snap1;
                    snap1 = animation && !isToggle ? animation.totalProgress() : clipped;
                }
            } // anticipate the pinning a few ticks ahead of time based on velocity to avoid a visual glitch due to the fact that most browsers do scrolling on a separate thread (not synced with requestAnimationFrame).
            anticipatePin && !clipped && pin && !$1db01b369728d7c8$var$_refreshing && !$1db01b369728d7c8$var$_startup && $1db01b369728d7c8$var$_lastScrollTime && start < scroll + (scroll - scroll2) / ($1db01b369728d7c8$var$_getTime() - $1db01b369728d7c8$var$_time2) * anticipatePin && (clipped = 0.0001);
            if (clipped !== prevProgress && self.enabled) {
                isActive = self.isActive = !!clipped && clipped < 1;
                wasActive = !!prevProgress && prevProgress < 1;
                toggled = isActive !== wasActive;
                stateChanged = toggled || !!clipped !== !!prevProgress; // could go from start all the way to end, thus it didn't toggle but it did change state in a sense (may need to fire a callback)
                self.direction = clipped > prevProgress ? 1 : -1;
                self.progress = clipped;
                if (stateChanged && !$1db01b369728d7c8$var$_refreshing) {
                    toggleState = clipped && !prevProgress ? 0 : clipped === 1 ? 1 : prevProgress === 1 ? 2 : 3; // 0 = enter, 1 = leave, 2 = enterBack, 3 = leaveBack (we prioritize the FIRST encounter, thus if you scroll really fast past the onEnter and onLeave in one tick, it'd prioritize onEnter.
                    if (isToggle) {
                        action = !toggled && toggleActions[toggleState + 1] !== "none" && toggleActions[toggleState + 1] || toggleActions[toggleState]; // if it didn't toggle, that means it shot right past and since we prioritize the "enter" action, we should switch to the "leave" in this case (but only if one is defined)
                        isTakingAction = animation && (action === "complete" || action === "reset" || action in animation);
                    }
                }
                preventOverlaps && (toggled || isTakingAction) && (isTakingAction || scrub || !animation) && ($1db01b369728d7c8$var$_isFunction(preventOverlaps) ? preventOverlaps(self) : self.getTrailing(preventOverlaps).forEach(function(t) {
                    return t.endAnimation();
                }));
                if (!isToggle) {
                    if (scrubTween && !$1db01b369728d7c8$var$_refreshing && !$1db01b369728d7c8$var$_startup) {
                        scrubTween._dp._time - scrubTween._start !== scrubTween._time && scrubTween.render(scrubTween._dp._time - scrubTween._start); // if there's a scrub on both the container animation and this one (or a ScrollSmoother), the update order would cause this one not to have rendered yet, so it wouldn't make any progress before we .restart() it heading toward the new progress so it'd appear stuck thus we force a render here.
                        if (scrubTween.resetTo) scrubTween.resetTo("totalProgress", clipped, animation._tTime / animation._tDur);
                        else {
                            // legacy support (courtesy), before 3.10.0
                            scrubTween.vars.totalProgress = clipped;
                            scrubTween.invalidate().restart();
                        }
                    } else if (animation) animation.totalProgress(clipped, !!($1db01b369728d7c8$var$_refreshing && (lastRefresh || reset)));
                }
                if (pin) {
                    reset && pinSpacing && (spacer.style[pinSpacing + direction.os2] = spacingStart);
                    if (!useFixedPosition) pinSetter($1db01b369728d7c8$var$_round(pinStart + pinChange * clipped));
                    else if (stateChanged) {
                        isAtMax = !reset && clipped > prevProgress && end + 1 > scroll && scroll + 1 >= $1db01b369728d7c8$var$_maxScroll(scroller, direction); // if it's at the VERY end of the page, don't switch away from position: fixed because it's pointless and it could cause a brief flash when the user scrolls back up (when it gets pinned again)
                        if (pinReparent) {
                            if (!reset && (isActive || isAtMax)) {
                                var bounds = $1db01b369728d7c8$var$_getBounds(pin, true), _offset = scroll - start;
                                $1db01b369728d7c8$var$_reparent(pin, $1db01b369728d7c8$var$_body, bounds.top + (direction === (0, $62ae116bd3942e88$export$8e40fc98ff518e9d) ? _offset : 0) + $1db01b369728d7c8$var$_px, bounds.left + (direction === (0, $62ae116bd3942e88$export$8e40fc98ff518e9d) ? 0 : _offset) + $1db01b369728d7c8$var$_px);
                            } else $1db01b369728d7c8$var$_reparent(pin, spacer);
                        }
                        $1db01b369728d7c8$var$_setState(isActive || isAtMax ? pinActiveState : pinState);
                        pinMoves && clipped < 1 && isActive || pinSetter(pinStart + (clipped === 1 && !isAtMax ? pinChange : 0));
                    }
                }
                snap && !tweenTo.tween && !$1db01b369728d7c8$var$_refreshing && !$1db01b369728d7c8$var$_startup && snapDelayedCall.restart(true);
                toggleClass && (toggled || once && clipped && (clipped < 1 || !$1db01b369728d7c8$var$_limitCallbacks)) && $1db01b369728d7c8$var$_toArray(toggleClass.targets).forEach(function(el) {
                    return el.classList[isActive || once ? "add" : "remove"](toggleClass.className);
                }); // classes could affect positioning, so do it even if reset or refreshing is true.
                onUpdate && !isToggle && !reset && onUpdate(self);
                if (stateChanged && !$1db01b369728d7c8$var$_refreshing) {
                    if (isToggle) {
                        if (isTakingAction) {
                            if (action === "complete") animation.pause().totalProgress(1);
                            else if (action === "reset") animation.restart(true).pause();
                            else if (action === "restart") animation.restart(true);
                            else animation[action]();
                        }
                        onUpdate && onUpdate(self);
                    }
                    if (toggled || !$1db01b369728d7c8$var$_limitCallbacks) {
                        // on startup, the page could be scrolled and we don't want to fire callbacks that didn't toggle. For example onEnter shouldn't fire if the ScrollTrigger isn't actually entered.
                        onToggle && toggled && $1db01b369728d7c8$var$_callback(self, onToggle);
                        callbacks[toggleState] && $1db01b369728d7c8$var$_callback(self, callbacks[toggleState]);
                        once && (clipped === 1 ? self.kill(false, 1) : callbacks[toggleState] = 0); // a callback shouldn't be called again if once is true.
                        if (!toggled) {
                            // it's possible to go completely past, like from before the start to after the end (or vice-versa) in which case BOTH callbacks should be fired in that order
                            toggleState = clipped === 1 ? 1 : 3;
                            callbacks[toggleState] && $1db01b369728d7c8$var$_callback(self, callbacks[toggleState]);
                        }
                    }
                    if (fastScrollEnd && !isActive && Math.abs(self.getVelocity()) > ($1db01b369728d7c8$var$_isNumber(fastScrollEnd) ? fastScrollEnd : 2500)) {
                        $1db01b369728d7c8$var$_endAnimation(self.callbackAnimation);
                        scrubTween ? scrubTween.progress(1) : $1db01b369728d7c8$var$_endAnimation(animation, action === "reverse" ? 1 : !clipped, 1);
                    }
                } else if (isToggle && onUpdate && !$1db01b369728d7c8$var$_refreshing) onUpdate(self);
            } // update absolutely-positioned markers (only if the scroller isn't the viewport)
            if (markerEndSetter) {
                var n = containerAnimation ? scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0) : scroll;
                markerStartSetter(n + (markerStartTrigger._isFlipped ? 1 : 0));
                markerEndSetter(n);
            }
            caMarkerSetter && caMarkerSetter(-scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0));
        };
        self.enable = function(reset, refresh) {
            if (!self.enabled) {
                self.enabled = true;
                $1db01b369728d7c8$var$_addListener(scroller, "resize", $1db01b369728d7c8$var$_onResize);
                isViewport || $1db01b369728d7c8$var$_addListener(scroller, "scroll", $1db01b369728d7c8$var$_onScroll);
                onRefreshInit && $1db01b369728d7c8$var$_addListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (reset !== false) {
                    self.progress = prevProgress = 0;
                    scroll1 = scroll2 = lastSnap = scrollFunc();
                }
                refresh !== false && self.refresh();
            }
        };
        self.getTween = function(snap) {
            return snap && tweenTo ? tweenTo.tween : scrubTween;
        };
        self.setPositions = function(newStart, newEnd, keepClamp, pinOffset) {
            // doesn't persist after refresh()! Intended to be a way to override values that were set during refresh(), like you could set it in onRefresh()
            if (containerAnimation) {
                // convert ratios into scroll positions. Remember, start/end values on ScrollTriggers that have a containerAnimation refer to the time (in seconds), NOT scroll positions.
                var st = containerAnimation.scrollTrigger, duration = containerAnimation.duration(), _change = st.end - st.start;
                newStart = st.start + _change * newStart / duration;
                newEnd = st.start + _change * newEnd / duration;
            }
            self.refresh(false, false, {
                start: $1db01b369728d7c8$var$_keepClamp(newStart, keepClamp && !!self._startClamp),
                end: $1db01b369728d7c8$var$_keepClamp(newEnd, keepClamp && !!self._endClamp)
            }, pinOffset);
            self.update();
        };
        self.adjustPinSpacing = function(amount) {
            if (spacerState && amount) {
                var i = spacerState.indexOf(direction.d) + 1;
                spacerState[i] = parseFloat(spacerState[i]) + amount + $1db01b369728d7c8$var$_px;
                spacerState[1] = parseFloat(spacerState[1]) + amount + $1db01b369728d7c8$var$_px;
                $1db01b369728d7c8$var$_setState(spacerState);
            }
        };
        self.disable = function(reset, allowAnimation) {
            if (self.enabled) {
                reset !== false && self.revert(true, true);
                self.enabled = self.isActive = false;
                allowAnimation || scrubTween && scrubTween.pause();
                prevScroll = 0;
                pinCache && (pinCache.uncache = 1);
                onRefreshInit && $1db01b369728d7c8$var$_removeListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (snapDelayedCall) {
                    snapDelayedCall.pause();
                    tweenTo.tween && tweenTo.tween.kill() && (tweenTo.tween = 0);
                }
                if (!isViewport) {
                    var i = $1db01b369728d7c8$var$_triggers.length;
                    while(i--){
                        if ($1db01b369728d7c8$var$_triggers[i].scroller === scroller && $1db01b369728d7c8$var$_triggers[i] !== self) return; //don't remove the listeners if there are still other triggers referencing it.
                    }
                    $1db01b369728d7c8$var$_removeListener(scroller, "resize", $1db01b369728d7c8$var$_onResize);
                    isViewport || $1db01b369728d7c8$var$_removeListener(scroller, "scroll", $1db01b369728d7c8$var$_onScroll);
                }
            }
        };
        self.kill = function(revert, allowAnimation) {
            self.disable(revert, allowAnimation);
            scrubTween && !allowAnimation && scrubTween.kill();
            id && delete $1db01b369728d7c8$var$_ids[id];
            var i = $1db01b369728d7c8$var$_triggers.indexOf(self);
            i >= 0 && $1db01b369728d7c8$var$_triggers.splice(i, 1);
            i === $1db01b369728d7c8$var$_i && $1db01b369728d7c8$var$_direction > 0 && $1db01b369728d7c8$var$_i--; // if we're in the middle of a refresh() or update(), splicing would cause skips in the index, so adjust...
            // if no other ScrollTrigger instances of the same scroller are found, wipe out any recorded scroll position. Otherwise, in a single page application, for example, it could maintain scroll position when it really shouldn't.
            i = 0;
            $1db01b369728d7c8$var$_triggers.forEach(function(t) {
                return t.scroller === self.scroller && (i = 1);
            });
            i || $1db01b369728d7c8$var$_refreshingAll || (self.scroll.rec = 0);
            if (animation) {
                animation.scrollTrigger = null;
                revert && animation.revert({
                    kill: false
                });
                allowAnimation || animation.kill();
            }
            markerStart && [
                markerStart,
                markerEnd,
                markerStartTrigger,
                markerEndTrigger
            ].forEach(function(m) {
                return m.parentNode && m.parentNode.removeChild(m);
            });
            $1db01b369728d7c8$var$_primary === self && ($1db01b369728d7c8$var$_primary = 0);
            if (pin) {
                pinCache && (pinCache.uncache = 1);
                i = 0;
                $1db01b369728d7c8$var$_triggers.forEach(function(t) {
                    return t.pin === pin && i++;
                });
                i || (pinCache.spacer = 0); // if there aren't any more ScrollTriggers with the same pin, remove the spacer, otherwise it could be contaminated with old/stale values if the user re-creates a ScrollTrigger for the same element.
            }
            vars.onKill && vars.onKill(self);
        };
        $1db01b369728d7c8$var$_triggers.push(self);
        self.enable(false, false);
        customRevertReturn && customRevertReturn(self);
        if (animation && animation.add && !change) {
            // if the animation is a timeline, it may not have been populated yet, so it wouldn't render at the proper place on the first refresh(), thus we should schedule one for the next tick. If "change" is defined, we know it must be re-enabling, thus we can refresh() right away.
            var updateFunc = self.update; // some browsers may fire a scroll event BEFORE a tick elapses and/or the DOMContentLoaded fires. So there's a chance update() will be called BEFORE a refresh() has happened on a Timeline-attached ScrollTrigger which means the start/end won't be calculated yet. We don't want to add conditional logic inside the update() method (like check to see if end is defined and if not, force a refresh()) because that's a function that gets hit a LOT (performance). So we swap out the real update() method for this one that'll re-attach it the first time it gets called and of course forces a refresh().
            self.update = function() {
                self.update = updateFunc;
                start || end || self.refresh();
            };
            $1db01b369728d7c8$var$gsap.delayedCall(0.01, self.update);
            change = 0.01;
            start = end = 0;
        } else self.refresh();
        pin && $1db01b369728d7c8$var$_queueRefreshAll(); // pinning could affect the positions of other things, so make sure we queue a full refresh()
    };
    ScrollTrigger.register = function register(core) {
        if (!$1db01b369728d7c8$var$_coreInitted) {
            $1db01b369728d7c8$var$gsap = core || $1db01b369728d7c8$var$_getGSAP();
            $1db01b369728d7c8$var$_windowExists() && window.document && ScrollTrigger.enable();
            $1db01b369728d7c8$var$_coreInitted = $1db01b369728d7c8$var$_enabled;
        }
        return $1db01b369728d7c8$var$_coreInitted;
    };
    ScrollTrigger.defaults = function defaults(config) {
        if (config) for(var p in config)$1db01b369728d7c8$var$_defaults[p] = config[p];
        return $1db01b369728d7c8$var$_defaults;
    };
    ScrollTrigger.disable = function disable(reset, kill) {
        $1db01b369728d7c8$var$_enabled = 0;
        $1db01b369728d7c8$var$_triggers.forEach(function(trigger) {
            return trigger[kill ? "kill" : "disable"](reset);
        });
        $1db01b369728d7c8$var$_removeListener($1db01b369728d7c8$var$_win, "wheel", $1db01b369728d7c8$var$_onScroll);
        $1db01b369728d7c8$var$_removeListener($1db01b369728d7c8$var$_doc, "scroll", $1db01b369728d7c8$var$_onScroll);
        clearInterval($1db01b369728d7c8$var$_syncInterval);
        $1db01b369728d7c8$var$_removeListener($1db01b369728d7c8$var$_doc, "touchcancel", $1db01b369728d7c8$var$_passThrough);
        $1db01b369728d7c8$var$_removeListener($1db01b369728d7c8$var$_body, "touchstart", $1db01b369728d7c8$var$_passThrough);
        $1db01b369728d7c8$var$_multiListener($1db01b369728d7c8$var$_removeListener, $1db01b369728d7c8$var$_doc, "pointerdown,touchstart,mousedown", $1db01b369728d7c8$var$_pointerDownHandler);
        $1db01b369728d7c8$var$_multiListener($1db01b369728d7c8$var$_removeListener, $1db01b369728d7c8$var$_doc, "pointerup,touchend,mouseup", $1db01b369728d7c8$var$_pointerUpHandler);
        $1db01b369728d7c8$var$_resizeDelay.kill();
        $1db01b369728d7c8$var$_iterateAutoRefresh($1db01b369728d7c8$var$_removeListener);
        for(var i = 0; i < (0, $62ae116bd3942e88$export$3cd1cee43d19b683).length; i += 3){
            $1db01b369728d7c8$var$_wheelListener($1db01b369728d7c8$var$_removeListener, (0, $62ae116bd3942e88$export$3cd1cee43d19b683)[i], (0, $62ae116bd3942e88$export$3cd1cee43d19b683)[i + 1]);
            $1db01b369728d7c8$var$_wheelListener($1db01b369728d7c8$var$_removeListener, (0, $62ae116bd3942e88$export$3cd1cee43d19b683)[i], (0, $62ae116bd3942e88$export$3cd1cee43d19b683)[i + 2]);
        }
    };
    ScrollTrigger.enable = function enable() {
        $1db01b369728d7c8$var$_win = window;
        $1db01b369728d7c8$var$_doc = document;
        $1db01b369728d7c8$var$_docEl = $1db01b369728d7c8$var$_doc.documentElement;
        $1db01b369728d7c8$var$_body = $1db01b369728d7c8$var$_doc.body;
        if ($1db01b369728d7c8$var$gsap) {
            $1db01b369728d7c8$var$_toArray = $1db01b369728d7c8$var$gsap.utils.toArray;
            $1db01b369728d7c8$var$_clamp = $1db01b369728d7c8$var$gsap.utils.clamp;
            $1db01b369728d7c8$var$_context = $1db01b369728d7c8$var$gsap.core.context || $1db01b369728d7c8$var$_passThrough;
            $1db01b369728d7c8$var$_suppressOverwrites = $1db01b369728d7c8$var$gsap.core.suppressOverwrites || $1db01b369728d7c8$var$_passThrough;
            $1db01b369728d7c8$var$_scrollRestoration = $1db01b369728d7c8$var$_win.history.scrollRestoration || "auto";
            $1db01b369728d7c8$var$_lastScroll = $1db01b369728d7c8$var$_win.pageYOffset;
            $1db01b369728d7c8$var$gsap.core.globals("ScrollTrigger", ScrollTrigger); // must register the global manually because in Internet Explorer, functions (classes) don't have a "name" property.
            if ($1db01b369728d7c8$var$_body) {
                $1db01b369728d7c8$var$_enabled = 1;
                $1db01b369728d7c8$var$_div100vh = document.createElement("div"); // to solve mobile browser address bar show/hide resizing, we shouldn't rely on window.innerHeight. Instead, use a <div> with its height set to 100vh and measure that since that's what the scrolling is based on anyway and it's not affected by address bar showing/hiding.
                $1db01b369728d7c8$var$_div100vh.style.height = "100vh";
                $1db01b369728d7c8$var$_div100vh.style.position = "absolute";
                $1db01b369728d7c8$var$_refresh100vh();
                $1db01b369728d7c8$var$_rafBugFix();
                (0, $62ae116bd3942e88$export$c1cbdee04e18ea8b).register($1db01b369728d7c8$var$gsap); // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
                ScrollTrigger.isTouch = (0, $62ae116bd3942e88$export$c1cbdee04e18ea8b).isTouch;
                $1db01b369728d7c8$var$_fixIOSBug = (0, $62ae116bd3942e88$export$c1cbdee04e18ea8b).isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent); // since 2017, iOS has had a bug that causes event.clientX/Y to be inaccurate when a scroll occurs, thus we must alternate ignoring every other touchmove event to work around it. See https://bugs.webkit.org/show_bug.cgi?id=181954 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503
                $1db01b369728d7c8$var$_addListener($1db01b369728d7c8$var$_win, "wheel", $1db01b369728d7c8$var$_onScroll); // mostly for 3rd party smooth scrolling libraries.
                $1db01b369728d7c8$var$_root = [
                    $1db01b369728d7c8$var$_win,
                    $1db01b369728d7c8$var$_doc,
                    $1db01b369728d7c8$var$_docEl,
                    $1db01b369728d7c8$var$_body
                ];
                if ($1db01b369728d7c8$var$gsap.matchMedia) {
                    ScrollTrigger.matchMedia = function(vars) {
                        var mm = $1db01b369728d7c8$var$gsap.matchMedia(), p;
                        for(p in vars)mm.add(p, vars[p]);
                        return mm;
                    };
                    $1db01b369728d7c8$var$gsap.addEventListener("matchMediaInit", function() {
                        return $1db01b369728d7c8$var$_revertAll();
                    });
                    $1db01b369728d7c8$var$gsap.addEventListener("matchMediaRevert", function() {
                        return $1db01b369728d7c8$var$_revertRecorded();
                    });
                    $1db01b369728d7c8$var$gsap.addEventListener("matchMedia", function() {
                        $1db01b369728d7c8$var$_refreshAll(0, 1);
                        $1db01b369728d7c8$var$_dispatch("matchMedia");
                    });
                    $1db01b369728d7c8$var$gsap.matchMedia("(orientation: portrait)", function() {
                        // when orientation changes, we should take new base measurements for the ignoreMobileResize feature.
                        $1db01b369728d7c8$var$_setBaseDimensions();
                        return $1db01b369728d7c8$var$_setBaseDimensions;
                    });
                } else console.warn("Requires GSAP 3.11.0 or later");
                $1db01b369728d7c8$var$_setBaseDimensions();
                $1db01b369728d7c8$var$_addListener($1db01b369728d7c8$var$_doc, "scroll", $1db01b369728d7c8$var$_onScroll); // some browsers (like Chrome), the window stops dispatching scroll events on the window if you scroll really fast, but it's consistent on the document!
                var bodyStyle = $1db01b369728d7c8$var$_body.style, border = bodyStyle.borderTopStyle, AnimationProto = $1db01b369728d7c8$var$gsap.core.Animation.prototype, bounds, i;
                AnimationProto.revert || Object.defineProperty(AnimationProto, "revert", {
                    value: function value() {
                        return this.time(-0.01, true);
                    }
                }); // only for backwards compatibility (Animation.revert() was added after 3.10.4)
                bodyStyle.borderTopStyle = "solid"; // works around an issue where a margin of a child element could throw off the bounds of the _body, making it seem like there's a margin when there actually isn't. The border ensures that the bounds are accurate.
                bounds = $1db01b369728d7c8$var$_getBounds($1db01b369728d7c8$var$_body);
                (0, $62ae116bd3942e88$export$8e40fc98ff518e9d).m = Math.round(bounds.top + (0, $62ae116bd3942e88$export$8e40fc98ff518e9d).sc()) || 0; // accommodate the offset of the <body> caused by margins and/or padding
                (0, $62ae116bd3942e88$export$b2cabb342cb0ebe1).m = Math.round(bounds.left + (0, $62ae116bd3942e88$export$b2cabb342cb0ebe1).sc()) || 0;
                border ? bodyStyle.borderTopStyle = border : bodyStyle.removeProperty("border-top-style"); // TODO: (?) maybe move to leveraging the velocity mechanism in Observer and skip intervals.
                $1db01b369728d7c8$var$_syncInterval = setInterval($1db01b369728d7c8$var$_sync, 250);
                $1db01b369728d7c8$var$gsap.delayedCall(0.5, function() {
                    return $1db01b369728d7c8$var$_startup = 0;
                });
                $1db01b369728d7c8$var$_addListener($1db01b369728d7c8$var$_doc, "touchcancel", $1db01b369728d7c8$var$_passThrough); // some older Android devices intermittently stop dispatching "touchmove" events if we don't listen for "touchcancel" on the document.
                $1db01b369728d7c8$var$_addListener($1db01b369728d7c8$var$_body, "touchstart", $1db01b369728d7c8$var$_passThrough); //works around Safari bug: https://greensock.com/forums/topic/21450-draggable-in-iframe-on-mobile-is-buggy/
                $1db01b369728d7c8$var$_multiListener($1db01b369728d7c8$var$_addListener, $1db01b369728d7c8$var$_doc, "pointerdown,touchstart,mousedown", $1db01b369728d7c8$var$_pointerDownHandler);
                $1db01b369728d7c8$var$_multiListener($1db01b369728d7c8$var$_addListener, $1db01b369728d7c8$var$_doc, "pointerup,touchend,mouseup", $1db01b369728d7c8$var$_pointerUpHandler);
                $1db01b369728d7c8$var$_transformProp = $1db01b369728d7c8$var$gsap.utils.checkPrefix("transform");
                $1db01b369728d7c8$var$_stateProps.push($1db01b369728d7c8$var$_transformProp);
                $1db01b369728d7c8$var$_coreInitted = $1db01b369728d7c8$var$_getTime();
                $1db01b369728d7c8$var$_resizeDelay = $1db01b369728d7c8$var$gsap.delayedCall(0.2, $1db01b369728d7c8$var$_refreshAll).pause();
                $1db01b369728d7c8$var$_autoRefresh = [
                    $1db01b369728d7c8$var$_doc,
                    "visibilitychange",
                    function() {
                        var w = $1db01b369728d7c8$var$_win.innerWidth, h = $1db01b369728d7c8$var$_win.innerHeight;
                        if ($1db01b369728d7c8$var$_doc.hidden) {
                            $1db01b369728d7c8$var$_prevWidth = w;
                            $1db01b369728d7c8$var$_prevHeight = h;
                        } else if ($1db01b369728d7c8$var$_prevWidth !== w || $1db01b369728d7c8$var$_prevHeight !== h) $1db01b369728d7c8$var$_onResize();
                    },
                    $1db01b369728d7c8$var$_doc,
                    "DOMContentLoaded",
                    $1db01b369728d7c8$var$_refreshAll,
                    $1db01b369728d7c8$var$_win,
                    "load",
                    $1db01b369728d7c8$var$_refreshAll,
                    $1db01b369728d7c8$var$_win,
                    "resize",
                    $1db01b369728d7c8$var$_onResize
                ];
                $1db01b369728d7c8$var$_iterateAutoRefresh($1db01b369728d7c8$var$_addListener);
                $1db01b369728d7c8$var$_triggers.forEach(function(trigger) {
                    return trigger.enable(0, 1);
                });
                for(i = 0; i < (0, $62ae116bd3942e88$export$3cd1cee43d19b683).length; i += 3){
                    $1db01b369728d7c8$var$_wheelListener($1db01b369728d7c8$var$_removeListener, (0, $62ae116bd3942e88$export$3cd1cee43d19b683)[i], (0, $62ae116bd3942e88$export$3cd1cee43d19b683)[i + 1]);
                    $1db01b369728d7c8$var$_wheelListener($1db01b369728d7c8$var$_removeListener, (0, $62ae116bd3942e88$export$3cd1cee43d19b683)[i], (0, $62ae116bd3942e88$export$3cd1cee43d19b683)[i + 2]);
                }
            }
        }
    };
    ScrollTrigger.config = function config(vars) {
        "limitCallbacks" in vars && ($1db01b369728d7c8$var$_limitCallbacks = !!vars.limitCallbacks);
        var ms = vars.syncInterval;
        ms && clearInterval($1db01b369728d7c8$var$_syncInterval) || ($1db01b369728d7c8$var$_syncInterval = ms) && setInterval($1db01b369728d7c8$var$_sync, ms);
        "ignoreMobileResize" in vars && ($1db01b369728d7c8$var$_ignoreMobileResize = ScrollTrigger.isTouch === 1 && vars.ignoreMobileResize);
        if ("autoRefreshEvents" in vars) {
            $1db01b369728d7c8$var$_iterateAutoRefresh($1db01b369728d7c8$var$_removeListener) || $1db01b369728d7c8$var$_iterateAutoRefresh($1db01b369728d7c8$var$_addListener, vars.autoRefreshEvents || "none");
            $1db01b369728d7c8$var$_ignoreResize = (vars.autoRefreshEvents + "").indexOf("resize") === -1;
        }
    };
    ScrollTrigger.scrollerProxy = function scrollerProxy(target, vars) {
        var t = (0, $62ae116bd3942e88$export$937374fea3f88711)(target), i = (0, $62ae116bd3942e88$export$3cd1cee43d19b683).indexOf(t), isViewport = $1db01b369728d7c8$var$_isViewport(t);
        if (~i) (0, $62ae116bd3942e88$export$3cd1cee43d19b683).splice(i, isViewport ? 6 : 2);
        if (vars) isViewport ? (0, $62ae116bd3942e88$export$d8e56d510a804d0a).unshift($1db01b369728d7c8$var$_win, vars, $1db01b369728d7c8$var$_body, vars, $1db01b369728d7c8$var$_docEl, vars) : (0, $62ae116bd3942e88$export$d8e56d510a804d0a).unshift(t, vars);
    };
    ScrollTrigger.clearMatchMedia = function clearMatchMedia(query) {
        $1db01b369728d7c8$var$_triggers.forEach(function(t) {
            return t._ctx && t._ctx.query === query && t._ctx.kill(true, true);
        });
    };
    ScrollTrigger.isInViewport = function isInViewport(element, ratio, horizontal) {
        var bounds = ($1db01b369728d7c8$var$_isString(element) ? (0, $62ae116bd3942e88$export$937374fea3f88711)(element) : element).getBoundingClientRect(), offset = bounds[horizontal ? $1db01b369728d7c8$var$_width : $1db01b369728d7c8$var$_height] * ratio || 0;
        return horizontal ? bounds.right - offset > 0 && bounds.left + offset < $1db01b369728d7c8$var$_win.innerWidth : bounds.bottom - offset > 0 && bounds.top + offset < $1db01b369728d7c8$var$_win.innerHeight;
    };
    ScrollTrigger.positionInViewport = function positionInViewport(element, referencePoint, horizontal) {
        $1db01b369728d7c8$var$_isString(element) && (element = (0, $62ae116bd3942e88$export$937374fea3f88711)(element));
        var bounds = element.getBoundingClientRect(), size = bounds[horizontal ? $1db01b369728d7c8$var$_width : $1db01b369728d7c8$var$_height], offset = referencePoint == null ? size / 2 : referencePoint in $1db01b369728d7c8$var$_keywords ? $1db01b369728d7c8$var$_keywords[referencePoint] * size : ~referencePoint.indexOf("%") ? parseFloat(referencePoint) * size / 100 : parseFloat(referencePoint) || 0;
        return horizontal ? (bounds.left + offset) / $1db01b369728d7c8$var$_win.innerWidth : (bounds.top + offset) / $1db01b369728d7c8$var$_win.innerHeight;
    };
    ScrollTrigger.killAll = function killAll(allowListeners) {
        $1db01b369728d7c8$var$_triggers.slice(0).forEach(function(t) {
            return t.vars.id !== "ScrollSmoother" && t.kill();
        });
        if (allowListeners !== true) {
            var listeners = $1db01b369728d7c8$var$_listeners.killAll || [];
            $1db01b369728d7c8$var$_listeners = {};
            listeners.forEach(function(f) {
                return f();
            });
        }
    };
    return ScrollTrigger;
}();
$1db01b369728d7c8$export$875bcbe48555930.version = "3.12.2";
$1db01b369728d7c8$export$875bcbe48555930.saveStyles = function(targets) {
    return targets ? $1db01b369728d7c8$var$_toArray(targets).forEach(function(target) {
        // saved styles are recorded in a consecutive alternating Array, like [element, cssText, transform attribute, cache, matchMedia, ...]
        if (target && target.style) {
            var i = $1db01b369728d7c8$var$_savedStyles.indexOf(target);
            i >= 0 && $1db01b369728d7c8$var$_savedStyles.splice(i, 5);
            $1db01b369728d7c8$var$_savedStyles.push(target, target.style.cssText, target.getBBox && target.getAttribute("transform"), $1db01b369728d7c8$var$gsap.core.getCache(target), $1db01b369728d7c8$var$_context());
        }
    }) : $1db01b369728d7c8$var$_savedStyles;
};
$1db01b369728d7c8$export$875bcbe48555930.revert = function(soft, media) {
    return $1db01b369728d7c8$var$_revertAll(!soft, media);
};
$1db01b369728d7c8$export$875bcbe48555930.create = function(vars, animation) {
    return new $1db01b369728d7c8$export$875bcbe48555930(vars, animation);
};
$1db01b369728d7c8$export$875bcbe48555930.refresh = function(safe) {
    return safe ? $1db01b369728d7c8$var$_onResize() : ($1db01b369728d7c8$var$_coreInitted || $1db01b369728d7c8$export$875bcbe48555930.register()) && $1db01b369728d7c8$var$_refreshAll(true);
};
$1db01b369728d7c8$export$875bcbe48555930.update = function(force) {
    return ++(0, $62ae116bd3942e88$export$3cd1cee43d19b683).cache && $1db01b369728d7c8$var$_updateAll(force === true ? 2 : 0);
};
$1db01b369728d7c8$export$875bcbe48555930.clearScrollMemory = $1db01b369728d7c8$var$_clearScrollMemory;
$1db01b369728d7c8$export$875bcbe48555930.maxScroll = function(element, horizontal) {
    return $1db01b369728d7c8$var$_maxScroll(element, horizontal ? (0, $62ae116bd3942e88$export$b2cabb342cb0ebe1) : (0, $62ae116bd3942e88$export$8e40fc98ff518e9d));
};
$1db01b369728d7c8$export$875bcbe48555930.getScrollFunc = function(element, horizontal) {
    return (0, $62ae116bd3942e88$export$8665aac53dad5647)((0, $62ae116bd3942e88$export$937374fea3f88711)(element), horizontal ? (0, $62ae116bd3942e88$export$b2cabb342cb0ebe1) : (0, $62ae116bd3942e88$export$8e40fc98ff518e9d));
};
$1db01b369728d7c8$export$875bcbe48555930.getById = function(id) {
    return $1db01b369728d7c8$var$_ids[id];
};
$1db01b369728d7c8$export$875bcbe48555930.getAll = function() {
    return $1db01b369728d7c8$var$_triggers.filter(function(t) {
        return t.vars.id !== "ScrollSmoother";
    });
}; // it's common for people to ScrollTrigger.getAll(t => t.kill()) on page routes, for example, and we don't want it to ruin smooth scrolling by killing the main ScrollSmoother one.
$1db01b369728d7c8$export$875bcbe48555930.isScrolling = function() {
    return !!$1db01b369728d7c8$var$_lastScrollTime;
};
$1db01b369728d7c8$export$875bcbe48555930.snapDirectional = $1db01b369728d7c8$var$_snapDirectional;
$1db01b369728d7c8$export$875bcbe48555930.addEventListener = function(type, callback) {
    var a = $1db01b369728d7c8$var$_listeners[type] || ($1db01b369728d7c8$var$_listeners[type] = []);
    ~a.indexOf(callback) || a.push(callback);
};
$1db01b369728d7c8$export$875bcbe48555930.removeEventListener = function(type, callback) {
    var a = $1db01b369728d7c8$var$_listeners[type], i = a && a.indexOf(callback);
    i >= 0 && a.splice(i, 1);
};
$1db01b369728d7c8$export$875bcbe48555930.batch = function(targets, vars) {
    var result = [], varsCopy = {}, interval = vars.interval || 0.016, batchMax = vars.batchMax || 1e9, proxyCallback = function proxyCallback(type, callback) {
        var elements = [], triggers = [], delay = $1db01b369728d7c8$var$gsap.delayedCall(interval, function() {
            callback(elements, triggers);
            elements = [];
            triggers = [];
        }).pause();
        return function(self) {
            elements.length || delay.restart(true);
            elements.push(self.trigger);
            triggers.push(self);
            batchMax <= elements.length && delay.progress(1);
        };
    }, p;
    for(p in vars)varsCopy[p] = p.substr(0, 2) === "on" && $1db01b369728d7c8$var$_isFunction(vars[p]) && p !== "onRefreshInit" ? proxyCallback(p, vars[p]) : vars[p];
    if ($1db01b369728d7c8$var$_isFunction(batchMax)) {
        batchMax = batchMax();
        $1db01b369728d7c8$var$_addListener($1db01b369728d7c8$export$875bcbe48555930, "refresh", function() {
            return batchMax = vars.batchMax();
        });
    }
    $1db01b369728d7c8$var$_toArray(targets).forEach(function(target) {
        var config = {};
        for(p in varsCopy)config[p] = varsCopy[p];
        config.trigger = target;
        result.push($1db01b369728d7c8$export$875bcbe48555930.create(config));
    });
    return result;
}; // to reduce file size. clamps the scroll and also returns a duration multiplier so that if the scroll gets chopped shorter, the duration gets curtailed as well (otherwise if you're very close to the top of the page, for example, and swipe up really fast, it'll suddenly slow down and take a long time to reach the top).
var $1db01b369728d7c8$var$_clampScrollAndGetDurationMultiplier = function _clampScrollAndGetDurationMultiplier(scrollFunc, current, end, max) {
    current > max ? scrollFunc(max) : current < 0 && scrollFunc(0);
    return end > max ? (max - current) / (end - current) : end < 0 ? current / (current - end) : 1;
}, $1db01b369728d7c8$var$_allowNativePanning = function _allowNativePanning(target, direction) {
    if (direction === true) target.style.removeProperty("touch-action");
    else target.style.touchAction = direction === true ? "auto" : direction ? "pan-" + direction + ((0, $62ae116bd3942e88$export$c1cbdee04e18ea8b).isTouch ? " pinch-zoom" : "") : "none"; // note: Firefox doesn't support it pinch-zoom properly, at least in addition to a pan-x or pan-y.
    target === $1db01b369728d7c8$var$_docEl && _allowNativePanning($1db01b369728d7c8$var$_body, direction);
}, $1db01b369728d7c8$var$_overflow = {
    auto: 1,
    scroll: 1
}, $1db01b369728d7c8$var$_nestedScroll = function _nestedScroll(_ref5) {
    var event = _ref5.event, target = _ref5.target, axis = _ref5.axis;
    var node = (event.changedTouches ? event.changedTouches[0] : event).target, cache = node._gsap || $1db01b369728d7c8$var$gsap.core.getCache(node), time = $1db01b369728d7c8$var$_getTime(), cs;
    if (!cache._isScrollT || time - cache._isScrollT > 2000) {
        // cache for 2 seconds to improve performance.
        while(node && node !== $1db01b369728d7c8$var$_body && (node.scrollHeight <= node.clientHeight && node.scrollWidth <= node.clientWidth || !($1db01b369728d7c8$var$_overflow[(cs = $1db01b369728d7c8$var$_getComputedStyle(node)).overflowY] || $1db01b369728d7c8$var$_overflow[cs.overflowX])))node = node.parentNode;
        cache._isScroll = node && node !== target && !$1db01b369728d7c8$var$_isViewport(node) && ($1db01b369728d7c8$var$_overflow[(cs = $1db01b369728d7c8$var$_getComputedStyle(node)).overflowY] || $1db01b369728d7c8$var$_overflow[cs.overflowX]);
        cache._isScrollT = time;
    }
    if (cache._isScroll || axis === "x") {
        event.stopPropagation();
        event._gsapAllow = true;
    }
}, // capture events on scrollable elements INSIDE the <body> and allow those by calling stopPropagation() when we find a scrollable ancestor
$1db01b369728d7c8$var$_inputObserver = function _inputObserver(target, type, inputs, nested) {
    return (0, $62ae116bd3942e88$export$c1cbdee04e18ea8b).create({
        target: target,
        capture: true,
        debounce: false,
        lockAxis: true,
        type: type,
        onWheel: nested = nested && $1db01b369728d7c8$var$_nestedScroll,
        onPress: nested,
        onDrag: nested,
        onScroll: nested,
        onEnable: function onEnable() {
            return inputs && $1db01b369728d7c8$var$_addListener($1db01b369728d7c8$var$_doc, (0, $62ae116bd3942e88$export$c1cbdee04e18ea8b).eventTypes[0], $1db01b369728d7c8$var$_captureInputs, false, true);
        },
        onDisable: function onDisable() {
            return $1db01b369728d7c8$var$_removeListener($1db01b369728d7c8$var$_doc, (0, $62ae116bd3942e88$export$c1cbdee04e18ea8b).eventTypes[0], $1db01b369728d7c8$var$_captureInputs, true);
        }
    });
}, $1db01b369728d7c8$var$_inputExp = /(input|label|select|textarea)/i, $1db01b369728d7c8$var$_inputIsFocused, $1db01b369728d7c8$var$_captureInputs = function _captureInputs(e) {
    var isInput = $1db01b369728d7c8$var$_inputExp.test(e.target.tagName);
    if (isInput || $1db01b369728d7c8$var$_inputIsFocused) {
        e._gsapAllow = true;
        $1db01b369728d7c8$var$_inputIsFocused = isInput;
    }
}, $1db01b369728d7c8$var$_getScrollNormalizer = function _getScrollNormalizer(vars) {
    $1db01b369728d7c8$var$_isObject(vars) || (vars = {});
    vars.preventDefault = vars.isNormalizer = vars.allowClicks = true;
    vars.type || (vars.type = "wheel,touch");
    vars.debounce = !!vars.debounce;
    vars.id = vars.id || "normalizer";
    var _vars2 = vars, normalizeScrollX = _vars2.normalizeScrollX, momentum = _vars2.momentum, allowNestedScroll = _vars2.allowNestedScroll, onRelease = _vars2.onRelease, self, maxY, target = (0, $62ae116bd3942e88$export$937374fea3f88711)(vars.target) || $1db01b369728d7c8$var$_docEl, smoother = $1db01b369728d7c8$var$gsap.core.globals().ScrollSmoother, smootherInstance = smoother && smoother.get(), content = $1db01b369728d7c8$var$_fixIOSBug && (vars.content && (0, $62ae116bd3942e88$export$937374fea3f88711)(vars.content) || smootherInstance && vars.content !== false && !smootherInstance.smooth() && smootherInstance.content()), scrollFuncY = (0, $62ae116bd3942e88$export$8665aac53dad5647)(target, (0, $62ae116bd3942e88$export$8e40fc98ff518e9d)), scrollFuncX = (0, $62ae116bd3942e88$export$8665aac53dad5647)(target, (0, $62ae116bd3942e88$export$b2cabb342cb0ebe1)), scale = 1, initialScale = ((0, $62ae116bd3942e88$export$c1cbdee04e18ea8b).isTouch && $1db01b369728d7c8$var$_win.visualViewport ? $1db01b369728d7c8$var$_win.visualViewport.scale * $1db01b369728d7c8$var$_win.visualViewport.width : $1db01b369728d7c8$var$_win.outerWidth) / $1db01b369728d7c8$var$_win.innerWidth, wheelRefresh = 0, resolveMomentumDuration = $1db01b369728d7c8$var$_isFunction(momentum) ? function() {
        return momentum(self);
    } : function() {
        return momentum || 2.8;
    }, lastRefreshID, skipTouchMove, inputObserver = $1db01b369728d7c8$var$_inputObserver(target, vars.type, true, allowNestedScroll), resumeTouchMove = function resumeTouchMove() {
        return skipTouchMove = false;
    }, scrollClampX = $1db01b369728d7c8$var$_passThrough, scrollClampY = $1db01b369728d7c8$var$_passThrough, updateClamps = function updateClamps() {
        maxY = $1db01b369728d7c8$var$_maxScroll(target, (0, $62ae116bd3942e88$export$8e40fc98ff518e9d));
        scrollClampY = $1db01b369728d7c8$var$_clamp($1db01b369728d7c8$var$_fixIOSBug ? 1 : 0, maxY);
        normalizeScrollX && (scrollClampX = $1db01b369728d7c8$var$_clamp(0, $1db01b369728d7c8$var$_maxScroll(target, (0, $62ae116bd3942e88$export$b2cabb342cb0ebe1))));
        lastRefreshID = $1db01b369728d7c8$var$_refreshID;
    }, removeContentOffset = function removeContentOffset() {
        content._gsap.y = $1db01b369728d7c8$var$_round(parseFloat(content._gsap.y) + scrollFuncY.offset) + "px";
        content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(content._gsap.y) + ", 0, 1)";
        scrollFuncY.offset = scrollFuncY.cacheID = 0;
    }, ignoreDrag = function ignoreDrag() {
        if (skipTouchMove) {
            requestAnimationFrame(resumeTouchMove);
            var offset = $1db01b369728d7c8$var$_round(self.deltaY / 2), scroll = scrollClampY(scrollFuncY.v - offset);
            if (content && scroll !== scrollFuncY.v + scrollFuncY.offset) {
                scrollFuncY.offset = scroll - scrollFuncY.v;
                var y = $1db01b369728d7c8$var$_round((parseFloat(content && content._gsap.y) || 0) - scrollFuncY.offset);
                content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + y + ", 0, 1)";
                content._gsap.y = y + "px";
                scrollFuncY.cacheID = (0, $62ae116bd3942e88$export$3cd1cee43d19b683).cache;
                $1db01b369728d7c8$var$_updateAll();
            }
            return true;
        }
        scrollFuncY.offset && removeContentOffset();
        skipTouchMove = true;
    }, tween, startScrollX, startScrollY, onStopDelayedCall, onResize = function onResize() {
        // if the window resizes, like on an iPhone which Apple FORCES the address bar to show/hide even if we event.preventDefault(), it may be scrolling too far now that the address bar is showing, so we must dynamically adjust the momentum tween.
        updateClamps();
        if (tween.isActive() && tween.vars.scrollY > maxY) scrollFuncY() > maxY ? tween.progress(1) && scrollFuncY(maxY) : tween.resetTo("scrollY", maxY);
    };
    content && $1db01b369728d7c8$var$gsap.set(content, {
        y: "+=0"
    }); // to ensure there's a cache (element._gsap)
    vars.ignoreCheck = function(e) {
        return $1db01b369728d7c8$var$_fixIOSBug && e.type === "touchmove" && ignoreDrag(e) || scale > 1.05 && e.type !== "touchstart" || self.isGesturing || e.touches && e.touches.length > 1;
    };
    vars.onPress = function() {
        skipTouchMove = false;
        var prevScale = scale;
        scale = $1db01b369728d7c8$var$_round(($1db01b369728d7c8$var$_win.visualViewport && $1db01b369728d7c8$var$_win.visualViewport.scale || 1) / initialScale);
        tween.pause();
        prevScale !== scale && $1db01b369728d7c8$var$_allowNativePanning(target, scale > 1.01 ? true : normalizeScrollX ? false : "x");
        startScrollX = scrollFuncX();
        startScrollY = scrollFuncY();
        updateClamps();
        lastRefreshID = $1db01b369728d7c8$var$_refreshID;
    };
    vars.onRelease = vars.onGestureStart = function(self, wasDragging) {
        scrollFuncY.offset && removeContentOffset();
        if (!wasDragging) onStopDelayedCall.restart(true);
        else {
            (0, $62ae116bd3942e88$export$3cd1cee43d19b683).cache++; // make sure we're pulling the non-cached value
            // alternate algorithm: durX = Math.min(6, Math.abs(self.velocityX / 800)),	dur = Math.max(durX, Math.min(6, Math.abs(self.velocityY / 800))); dur = dur * (0.4 + (1 - _power4In(dur / 6)) * 0.6)) * (momentumSpeed || 1)
            var dur = resolveMomentumDuration(), currentScroll, endScroll;
            if (normalizeScrollX) {
                currentScroll = scrollFuncX();
                endScroll = currentScroll + dur * 0.05 * -self.velocityX / 0.227; // the constant .227 is from power4(0.05). velocity is inverted because scrolling goes in the opposite direction.
                dur *= $1db01b369728d7c8$var$_clampScrollAndGetDurationMultiplier(scrollFuncX, currentScroll, endScroll, $1db01b369728d7c8$var$_maxScroll(target, (0, $62ae116bd3942e88$export$b2cabb342cb0ebe1)));
                tween.vars.scrollX = scrollClampX(endScroll);
            }
            currentScroll = scrollFuncY();
            endScroll = currentScroll + dur * 0.05 * -self.velocityY / 0.227; // the constant .227 is from power4(0.05)
            dur *= $1db01b369728d7c8$var$_clampScrollAndGetDurationMultiplier(scrollFuncY, currentScroll, endScroll, $1db01b369728d7c8$var$_maxScroll(target, (0, $62ae116bd3942e88$export$8e40fc98ff518e9d)));
            tween.vars.scrollY = scrollClampY(endScroll);
            tween.invalidate().duration(dur).play(0.01);
            if ($1db01b369728d7c8$var$_fixIOSBug && tween.vars.scrollY >= maxY || currentScroll >= maxY - 1) // iOS bug: it'll show the address bar but NOT fire the window "resize" event until the animation is done but we must protect against overshoot so we leverage an onUpdate to do so.
            $1db01b369728d7c8$var$gsap.to({}, {
                onUpdate: onResize,
                duration: dur
            });
        }
        onRelease && onRelease(self);
    };
    vars.onWheel = function() {
        tween._ts && tween.pause();
        if ($1db01b369728d7c8$var$_getTime() - wheelRefresh > 1000) {
            // after 1 second, refresh the clamps otherwise that'll only happen when ScrollTrigger.refresh() is called or for touch-scrolling.
            lastRefreshID = 0;
            wheelRefresh = $1db01b369728d7c8$var$_getTime();
        }
    };
    vars.onChange = function(self, dx, dy, xArray, yArray) {
        $1db01b369728d7c8$var$_refreshID !== lastRefreshID && updateClamps();
        dx && normalizeScrollX && scrollFuncX(scrollClampX(xArray[2] === dx ? startScrollX + (self.startX - self.x) : scrollFuncX() + dx - xArray[1])); // for more precision, we track pointer/touch movement from the start, otherwise it'll drift.
        if (dy) {
            scrollFuncY.offset && removeContentOffset();
            var isTouch = yArray[2] === dy, y = isTouch ? startScrollY + self.startY - self.y : scrollFuncY() + dy - yArray[1], yClamped = scrollClampY(y);
            isTouch && y !== yClamped && (startScrollY += yClamped - y);
            scrollFuncY(yClamped);
        }
        (dy || dx) && $1db01b369728d7c8$var$_updateAll();
    };
    vars.onEnable = function() {
        $1db01b369728d7c8$var$_allowNativePanning(target, normalizeScrollX ? false : "x");
        $1db01b369728d7c8$export$875bcbe48555930.addEventListener("refresh", onResize);
        $1db01b369728d7c8$var$_addListener($1db01b369728d7c8$var$_win, "resize", onResize);
        if (scrollFuncY.smooth) {
            scrollFuncY.target.style.scrollBehavior = "auto";
            scrollFuncY.smooth = scrollFuncX.smooth = false;
        }
        inputObserver.enable();
    };
    vars.onDisable = function() {
        $1db01b369728d7c8$var$_allowNativePanning(target, true);
        $1db01b369728d7c8$var$_removeListener($1db01b369728d7c8$var$_win, "resize", onResize);
        $1db01b369728d7c8$export$875bcbe48555930.removeEventListener("refresh", onResize);
        inputObserver.kill();
    };
    vars.lockAxis = vars.lockAxis !== false;
    self = new (0, $62ae116bd3942e88$export$c1cbdee04e18ea8b)(vars);
    self.iOS = $1db01b369728d7c8$var$_fixIOSBug; // used in the Observer getCachedScroll() function to work around an iOS bug that wreaks havoc with TouchEvent.clientY if we allow scroll to go all the way back to 0.
    $1db01b369728d7c8$var$_fixIOSBug && !scrollFuncY() && scrollFuncY(1); // iOS bug causes event.clientY values to freak out (wildly inaccurate) if the scroll position is exactly 0.
    $1db01b369728d7c8$var$_fixIOSBug && $1db01b369728d7c8$var$gsap.ticker.add($1db01b369728d7c8$var$_passThrough); // prevent the ticker from sleeping
    onStopDelayedCall = self._dc;
    tween = $1db01b369728d7c8$var$gsap.to(self, {
        ease: "power4",
        paused: true,
        scrollX: normalizeScrollX ? "+=0.1" : "+=0",
        scrollY: "+=0.1",
        modifiers: {
            scrollY: $1db01b369728d7c8$var$_interruptionTracker(scrollFuncY, scrollFuncY(), function() {
                return tween.pause();
            })
        },
        onUpdate: $1db01b369728d7c8$var$_updateAll,
        onComplete: onStopDelayedCall.vars.onComplete
    }); // we need the modifier to sense if the scroll position is altered outside of the momentum tween (like with a scrollTo tween) so we can pause() it to prevent conflicts.
    return self;
};
$1db01b369728d7c8$export$875bcbe48555930.sort = function(func) {
    return $1db01b369728d7c8$var$_triggers.sort(func || function(a, b) {
        return (a.vars.refreshPriority || 0) * -1000000 + a.start - (b.start + (b.vars.refreshPriority || 0) * -1000000);
    });
};
$1db01b369728d7c8$export$875bcbe48555930.observe = function(vars) {
    return new (0, $62ae116bd3942e88$export$c1cbdee04e18ea8b)(vars);
};
$1db01b369728d7c8$export$875bcbe48555930.normalizeScroll = function(vars) {
    if (typeof vars === "undefined") return $1db01b369728d7c8$var$_normalizer;
    if (vars === true && $1db01b369728d7c8$var$_normalizer) return $1db01b369728d7c8$var$_normalizer.enable();
    if (vars === false) return $1db01b369728d7c8$var$_normalizer && $1db01b369728d7c8$var$_normalizer.kill();
    var normalizer = vars instanceof (0, $62ae116bd3942e88$export$c1cbdee04e18ea8b) ? vars : $1db01b369728d7c8$var$_getScrollNormalizer(vars);
    $1db01b369728d7c8$var$_normalizer && $1db01b369728d7c8$var$_normalizer.target === normalizer.target && $1db01b369728d7c8$var$_normalizer.kill();
    $1db01b369728d7c8$var$_isViewport(normalizer.target) && ($1db01b369728d7c8$var$_normalizer = normalizer);
    return normalizer;
};
$1db01b369728d7c8$export$875bcbe48555930.core = {
    // smaller file size way to leverage in ScrollSmoother and Observer
    _getVelocityProp: (0, $62ae116bd3942e88$export$5de019f4480f0f8d),
    _inputObserver: $1db01b369728d7c8$var$_inputObserver,
    _scrollers: (0, $62ae116bd3942e88$export$3cd1cee43d19b683),
    _proxies: (0, $62ae116bd3942e88$export$d8e56d510a804d0a),
    bridge: {
        // when normalizeScroll sets the scroll position (ss = setScroll)
        ss: function ss() {
            $1db01b369728d7c8$var$_lastScrollTime || $1db01b369728d7c8$var$_dispatch("scrollStart");
            $1db01b369728d7c8$var$_lastScrollTime = $1db01b369728d7c8$var$_getTime();
        },
        // a way to get the _refreshing value in Observer
        ref: function ref() {
            return $1db01b369728d7c8$var$_refreshing;
        }
    }
};
$1db01b369728d7c8$var$_getGSAP() && $1db01b369728d7c8$var$gsap.registerPlugin($1db01b369728d7c8$export$875bcbe48555930);


(0, $35069e6098950ce3$export$99ee26438460406a).registerPlugin((0, $1db01b369728d7c8$export$875bcbe48555930));
class $299a04d279521f55$export$2e2bcd8739ae039 {
    init() {
        [
            ...this._blocks
        ].forEach((el, n)=>{
            let isLastIteration = n === this._blocks.length - 1;
            (0, $1db01b369728d7c8$export$875bcbe48555930).create({
                trigger: el,
                start: isLastIteration ? "top bottom-=10" : "top top+=" + this.getHeaderHeight(),
                endTrigger: el,
                end: "bottom top",
                markers: false,
                onEnter: ()=>{
                    app.nodesRemoveClass(this._btns, "is-active");
                    this._btns[n].classList.add("is-active");
                },
                onEnterBack: ()=>{
                    app.nodesRemoveClass(this._btns, "is-active");
                    this._btns[n].classList.add("is-active");
                },
                onLeaveBack: ()=>{
                    if (isLastIteration) {
                        app.nodesRemoveClass(this._btns, "is-active");
                        this._btns[n - 1].classList.add("is-active");
                    }
                }
            });
        });
    }
    getHeaderHeight() {
        return this._header.getBoundingClientRect().height + 15;
    }
    constructor(element){
        this._wrapper = element;
        this._header = document.querySelector(".js-header");
        this._blocks = this._wrapper.querySelectorAll(".js-flexibles-anchors-blocks");
        this._btns = this._wrapper.querySelectorAll(".js-flexibles-anchors-btn");
        this.init();
    }
}




class $bd0ced7f3757fcf6$export$2e2bcd8739ae039 {
    init() {
        this.slider = new (0, $731acbcb25ce319f$export$25ce5a424b770e84)(this._swiper, {
            slidesPerView: 1,
            loop: true,
            spaceBetween: 24,
            modules: [
                (0, $ad4c197f78da2876$export$2e2bcd8739ae039)
            ],
            pagination: {
                el: this._pagination,
                type: "bullets",
                clickable: true
            },
            breakpoints: {
                576: {
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 3
                },
                1200: {
                    slidesPerView: 4
                }
            }
        });
    }
    constructor(element){
        this._wrapper = element;
        this._swiper = this._wrapper.querySelector(".swiper");
        this._pagination = this._wrapper.querySelector(".swiper-pagination");
        this.init();
    }
}




class $7eaf8133ffc569dd$export$2e2bcd8739ae039 {
    init() {
        this.slider = new (0, $731acbcb25ce319f$export$25ce5a424b770e84)(this._swiper, {
            slidesPerView: 1,
            loop: true,
            spaceBetween: 24,
            modules: [
                (0, $ad4c197f78da2876$export$2e2bcd8739ae039)
            ],
            pagination: {
                el: this._pagination,
                type: "bullets",
                clickable: true
            },
            breakpoints: {
                576: {
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 3
                },
                1200: {
                    slidesPerView: 4
                }
            }
        });
    }
    constructor(element){
        this._wrapper = element;
        this._swiper = this._wrapper.querySelector(".swiper");
        this._pagination = this._wrapper.querySelector(".swiper-pagination");
        this.init();
    }
}




class $a74bd482019d7be3$export$2e2bcd8739ae039 {
    init() {
        this.slider = new (0, $731acbcb25ce319f$export$25ce5a424b770e84)(this._swiper, {
            slidesPerView: 1,
            loop: true,
            spaceBetween: 24,
            modules: [
                (0, $ad4c197f78da2876$export$2e2bcd8739ae039)
            ],
            pagination: {
                el: this._pagination,
                type: "bullets",
                clickable: true
            },
            breakpoints: {
                576: {
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 3
                },
                1200: {
                    slidesPerView: 4
                }
            }
        });
    }
    constructor(element){
        this._wrapper = element;
        this._swiper = this._wrapper.querySelector(".swiper");
        this._pagination = this._wrapper.querySelector(".swiper-pagination");
        this.init();
    }
}


var $1acdf244acbb2b83$exports = {};
"use strict";
Object.defineProperty($1acdf244acbb2b83$exports, "__esModule", {
    value: true
});
$1acdf244acbb2b83$exports.convertTimestampToArray = $1acdf244acbb2b83$var$convertTimestampToArray;
$1acdf244acbb2b83$exports.createEvent = $1acdf244acbb2b83$var$createEvent;
$1acdf244acbb2b83$exports.createEvents = $1acdf244acbb2b83$var$createEvents;
var $3c55986a95d9bd6b$exports = {};
"use strict";
Object.defineProperty($3c55986a95d9bd6b$exports, "__esModule", {
    value: true
});
Object.defineProperty($3c55986a95d9bd6b$exports, "buildEvent", {
    enumerable: true,
    get: function get() {
        return $27cd4b429ceb4e70$exports.buildEvent;
    }
});
Object.defineProperty($3c55986a95d9bd6b$exports, "buildHeader", {
    enumerable: true,
    get: function get() {
        return $27cd4b429ceb4e70$exports.buildHeader;
    }
});
Object.defineProperty($3c55986a95d9bd6b$exports, "formatEvent", {
    enumerable: true,
    get: function get() {
        return $e96de0cc9a88de76$exports.formatEvent;
    }
});
Object.defineProperty($3c55986a95d9bd6b$exports, "formatFooter", {
    enumerable: true,
    get: function get() {
        return $e96de0cc9a88de76$exports.formatFooter;
    }
});
Object.defineProperty($3c55986a95d9bd6b$exports, "formatHeader", {
    enumerable: true,
    get: function get() {
        return $e96de0cc9a88de76$exports.formatHeader;
    }
});
Object.defineProperty($3c55986a95d9bd6b$exports, "validateHeader", {
    enumerable: true,
    get: function get() {
        return $9d81b2aa01f9dc3a$exports.validateHeader;
    }
});
Object.defineProperty($3c55986a95d9bd6b$exports, "validateHeaderAndEvent", {
    enumerable: true,
    get: function get() {
        return $9d81b2aa01f9dc3a$exports.validateHeaderAndEvent;
    }
});
var $27cd4b429ceb4e70$exports = {};
"use strict";
Object.defineProperty($27cd4b429ceb4e70$exports, "__esModule", {
    value: true
});
$27cd4b429ceb4e70$exports.buildEvent = $27cd4b429ceb4e70$var$buildEvent;
$27cd4b429ceb4e70$exports.buildHeader = $27cd4b429ceb4e70$var$buildHeader;
var $83a30e5ae55a75c8$exports = {};
"use strict";
Object.defineProperty($83a30e5ae55a75c8$exports, "__esModule", {
    value: true
});
$83a30e5ae55a75c8$exports.headerDefaults = $83a30e5ae55a75c8$exports.eventDefaults = void 0;
let $6c70dfc9b2dbec4f$export$2b646eea95309f00 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";


let $233927059d274c10$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $233927059d274c10$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = "";
        while(true){
            let bytes = getRandom(step);
            let j = step | 0;
            while(j--){
                id += alphabet[bytes[j] & mask] || "";
                if (id.length === size) return id;
            }
        }
    };
};
let $233927059d274c10$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$233927059d274c10$export$a5cee9e955a615e5(alphabet, size, $233927059d274c10$export$4385e60b38654f68);
let $233927059d274c10$export$ac4959f4f1338dfc = (size = 21)=>crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte)=>{
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += "-";
        else id += "_";
        return id;
    }, "");


var $83a30e5ae55a75c8$var$headerDefaults = $83a30e5ae55a75c8$exports.headerDefaults = function headerDefaults() {
    return {
        productId: "adamgibbons/ics",
        method: "PUBLISH"
    };
};
var $83a30e5ae55a75c8$var$eventDefaults = $83a30e5ae55a75c8$exports.eventDefaults = function eventDefaults() {
    return {
        title: "Untitled event",
        uid: (0, $233927059d274c10$export$ac4959f4f1338dfc)(),
        timestamp: Date.now()
    };
};


function $27cd4b429ceb4e70$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $27cd4b429ceb4e70$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $27cd4b429ceb4e70$var$_typeof(obj);
}
function $27cd4b429ceb4e70$var$_defineProperty(obj, key, value) {
    key = $27cd4b429ceb4e70$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $27cd4b429ceb4e70$var$_toPropertyKey(arg) {
    var key = $27cd4b429ceb4e70$var$_toPrimitive(arg, "string");
    return $27cd4b429ceb4e70$var$_typeof(key) === "symbol" ? key : String(key);
}
function $27cd4b429ceb4e70$var$_toPrimitive(input, hint) {
    if ($27cd4b429ceb4e70$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($27cd4b429ceb4e70$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $27cd4b429ceb4e70$var$removeUndefined(input) {
    return Object.entries(input).reduce(function(clean, entry) {
        return typeof entry[1] !== "undefined" ? Object.assign(clean, $27cd4b429ceb4e70$var$_defineProperty({}, entry[0], entry[1])) : clean;
    }, {});
}
function $27cd4b429ceb4e70$var$buildHeader() {
    var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // fill in default values where necessary
    var output = Object.assign({}, (0, $83a30e5ae55a75c8$exports.headerDefaults)(), attributes);
    return $27cd4b429ceb4e70$var$removeUndefined(output);
}
function $27cd4b429ceb4e70$var$buildEvent() {
    var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // fill in default values where necessary
    var output = Object.assign({}, (0, $83a30e5ae55a75c8$exports.eventDefaults)(), attributes);
    return $27cd4b429ceb4e70$var$removeUndefined(output);
}


var $e96de0cc9a88de76$exports = {};
"use strict";
Object.defineProperty($e96de0cc9a88de76$exports, "__esModule", {
    value: true
});
$e96de0cc9a88de76$exports.formatEvent = $e96de0cc9a88de76$var$formatEvent;
$e96de0cc9a88de76$exports.formatFooter = $e96de0cc9a88de76$var$formatFooter;
$e96de0cc9a88de76$exports.formatHeader = $e96de0cc9a88de76$var$formatHeader;
var $f3ce2b19837eb4bd$exports = {};
"use strict";
Object.defineProperty($f3ce2b19837eb4bd$exports, "__esModule", {
    value: true
});
Object.defineProperty($f3ce2b19837eb4bd$exports, "encodeParamValue", {
    enumerable: true,
    get: function get() {
        return $f3ce2b19837eb4bd$var$_encodeParamValue["default"];
    }
});
Object.defineProperty($f3ce2b19837eb4bd$exports, "foldLine", {
    enumerable: true,
    get: function get() {
        return $f3ce2b19837eb4bd$var$_foldLine["default"];
    }
});
Object.defineProperty($f3ce2b19837eb4bd$exports, "formatDate", {
    enumerable: true,
    get: function get() {
        return $f3ce2b19837eb4bd$var$_formatDate["default"];
    }
});
Object.defineProperty($f3ce2b19837eb4bd$exports, "formatDuration", {
    enumerable: true,
    get: function get() {
        return $f3ce2b19837eb4bd$var$_formatDuration["default"];
    }
});
Object.defineProperty($f3ce2b19837eb4bd$exports, "setAlarm", {
    enumerable: true,
    get: function get() {
        return $f3ce2b19837eb4bd$var$_setAlarm["default"];
    }
});
Object.defineProperty($f3ce2b19837eb4bd$exports, "setContact", {
    enumerable: true,
    get: function get() {
        return $f3ce2b19837eb4bd$var$_setContact["default"];
    }
});
Object.defineProperty($f3ce2b19837eb4bd$exports, "setDescription", {
    enumerable: true,
    get: function get() {
        return $f3ce2b19837eb4bd$var$_setDescription["default"];
    }
});
Object.defineProperty($f3ce2b19837eb4bd$exports, "setGeolocation", {
    enumerable: true,
    get: function get() {
        return $f3ce2b19837eb4bd$var$_setGeolocation["default"];
    }
});
Object.defineProperty($f3ce2b19837eb4bd$exports, "setLocation", {
    enumerable: true,
    get: function get() {
        return $f3ce2b19837eb4bd$var$_setLocation["default"];
    }
});
Object.defineProperty($f3ce2b19837eb4bd$exports, "setOrganizer", {
    enumerable: true,
    get: function get() {
        return $f3ce2b19837eb4bd$var$_setOrganizer["default"];
    }
});
Object.defineProperty($f3ce2b19837eb4bd$exports, "setSummary", {
    enumerable: true,
    get: function get() {
        return $f3ce2b19837eb4bd$var$_setSummary["default"];
    }
});

var $f3ce2b19837eb4bd$var$_formatDate = $f3ce2b19837eb4bd$var$_interopRequireDefault((parcelRequire("2I9O3")));

var $f3ce2b19837eb4bd$var$_setGeolocation = $f3ce2b19837eb4bd$var$_interopRequireDefault((parcelRequire("bbsCP")));

var $f3ce2b19837eb4bd$var$_setContact = $f3ce2b19837eb4bd$var$_interopRequireDefault((parcelRequire("8Biyp")));

var $f3ce2b19837eb4bd$var$_setOrganizer = $f3ce2b19837eb4bd$var$_interopRequireDefault((parcelRequire("kZ5O6")));

var $f3ce2b19837eb4bd$var$_setAlarm = $f3ce2b19837eb4bd$var$_interopRequireDefault((parcelRequire("1S8JO")));

var $f3ce2b19837eb4bd$var$_setDescription = $f3ce2b19837eb4bd$var$_interopRequireDefault((parcelRequire("jhxZp")));

var $f3ce2b19837eb4bd$var$_setSummary = $f3ce2b19837eb4bd$var$_interopRequireDefault((parcelRequire("h2gqO")));

var $f3ce2b19837eb4bd$var$_formatDuration = $f3ce2b19837eb4bd$var$_interopRequireDefault((parcelRequire("eyhlm")));

var $f3ce2b19837eb4bd$var$_foldLine = $f3ce2b19837eb4bd$var$_interopRequireDefault((parcelRequire("1Py5t")));

var $f3ce2b19837eb4bd$var$_setLocation = $f3ce2b19837eb4bd$var$_interopRequireDefault((parcelRequire("gQ8Nk")));

var $f3ce2b19837eb4bd$var$_encodeParamValue = $f3ce2b19837eb4bd$var$_interopRequireDefault((parcelRequire("14CXE")));
function $f3ce2b19837eb4bd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}



var $e96de0cc9a88de76$var$_encodeNewLines = $e96de0cc9a88de76$var$_interopRequireDefault((parcelRequire("gREEX")));
function $e96de0cc9a88de76$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e96de0cc9a88de76$var$formatHeader() {
    var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var productId = attributes.productId, method = attributes.method, calName = attributes.calName;
    var icsFormat = "";
    icsFormat += "BEGIN:VCALENDAR\r\n";
    icsFormat += "VERSION:2.0\r\n";
    icsFormat += "CALSCALE:GREGORIAN\r\n";
    icsFormat += (0, $f3ce2b19837eb4bd$exports.foldLine)("PRODID:".concat((0, $e96de0cc9a88de76$var$_encodeNewLines["default"])(productId))) + "\r\n";
    icsFormat += (0, $f3ce2b19837eb4bd$exports.foldLine)("METHOD:".concat((0, $e96de0cc9a88de76$var$_encodeNewLines["default"])(method))) + "\r\n";
    icsFormat += calName ? (0, $f3ce2b19837eb4bd$exports.foldLine)("X-WR-CALNAME:".concat((0, $e96de0cc9a88de76$var$_encodeNewLines["default"])(calName))) + "\r\n" : "";
    icsFormat += "X-PUBLISHED-TTL:PT1H\r\n";
    return icsFormat;
}
function $e96de0cc9a88de76$var$formatFooter() {
    return "END:VCALENDAR\r\n";
}
function $e96de0cc9a88de76$var$formatEvent() {
    var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var title = attributes.title, uid = attributes.uid, sequence = attributes.sequence, timestamp = attributes.timestamp, start = attributes.start, startType = attributes.startType, startInputType = attributes.startInputType, startOutputType = attributes.startOutputType, duration = attributes.duration, end = attributes.end, endInputType = attributes.endInputType, endOutputType = attributes.endOutputType, description = attributes.description, url = attributes.url, geo = attributes.geo, location = attributes.location, status = attributes.status, categories = attributes.categories, organizer = attributes.organizer, attendees = attributes.attendees, alarms = attributes.alarms, recurrenceRule = attributes.recurrenceRule, exclusionDates = attributes.exclusionDates, busyStatus = attributes.busyStatus, transp = attributes.transp, classification = attributes.classification, created = attributes.created, lastModified = attributes.lastModified, htmlContent = attributes.htmlContent;
    var icsFormat = "";
    icsFormat += "BEGIN:VEVENT\r\n";
    icsFormat += (0, $f3ce2b19837eb4bd$exports.foldLine)("UID:".concat((0, $e96de0cc9a88de76$var$_encodeNewLines["default"])(uid))) + "\r\n";
    icsFormat += title ? (0, $f3ce2b19837eb4bd$exports.foldLine)("SUMMARY:".concat((0, $e96de0cc9a88de76$var$_encodeNewLines["default"])((0, $f3ce2b19837eb4bd$exports.setSummary)(title)))) + "\r\n" : "";
    icsFormat += (0, $f3ce2b19837eb4bd$exports.foldLine)("DTSTAMP:".concat((0, $e96de0cc9a88de76$var$_encodeNewLines["default"])((0, $f3ce2b19837eb4bd$exports.formatDate)(timestamp)))) + "\r\n";
    // All day events like anniversaries must be specified as VALUE type DATE
    icsFormat += (0, $f3ce2b19837eb4bd$exports.foldLine)("DTSTART".concat(start && start.length == 3 ? ";VALUE=DATE" : "", ":").concat((0, $e96de0cc9a88de76$var$_encodeNewLines["default"])((0, $f3ce2b19837eb4bd$exports.formatDate)(start, startOutputType || startType, startInputType)))) + "\r\n";
    // End is not required for all day events on single days (like anniversaries)
    if (!end || end.length !== 3 || start.length !== end.length || start.some(function(val, i) {
        return val !== end[i];
    })) {
        if (end) icsFormat += (0, $f3ce2b19837eb4bd$exports.foldLine)("DTEND".concat(end.length === 3 ? ";VALUE=DATE" : "", ":").concat((0, $e96de0cc9a88de76$var$_encodeNewLines["default"])((0, $f3ce2b19837eb4bd$exports.formatDate)(end, endOutputType || startOutputType || startType, endInputType || startInputType)))) + "\r\n";
    }
    icsFormat += typeof sequence !== "undefined" ? "SEQUENCE:".concat(sequence, "\r\n") : "";
    icsFormat += description ? (0, $f3ce2b19837eb4bd$exports.foldLine)("DESCRIPTION:".concat((0, $e96de0cc9a88de76$var$_encodeNewLines["default"])((0, $f3ce2b19837eb4bd$exports.setDescription)(description)))) + "\r\n" : "";
    icsFormat += url ? (0, $f3ce2b19837eb4bd$exports.foldLine)("URL:".concat((0, $e96de0cc9a88de76$var$_encodeNewLines["default"])(url))) + "\r\n" : "";
    icsFormat += geo ? (0, $f3ce2b19837eb4bd$exports.foldLine)("GEO:".concat((0, $f3ce2b19837eb4bd$exports.setGeolocation)(geo))) + "\r\n" : "";
    icsFormat += location ? (0, $f3ce2b19837eb4bd$exports.foldLine)("LOCATION:".concat((0, $e96de0cc9a88de76$var$_encodeNewLines["default"])((0, $f3ce2b19837eb4bd$exports.setLocation)(location)))) + "\r\n" : "";
    icsFormat += status ? (0, $f3ce2b19837eb4bd$exports.foldLine)("STATUS:".concat((0, $e96de0cc9a88de76$var$_encodeNewLines["default"])(status))) + "\r\n" : "";
    icsFormat += categories ? (0, $f3ce2b19837eb4bd$exports.foldLine)("CATEGORIES:".concat((0, $e96de0cc9a88de76$var$_encodeNewLines["default"])(categories.join(",")))) + "\r\n" : "";
    icsFormat += organizer ? (0, $f3ce2b19837eb4bd$exports.foldLine)("ORGANIZER;".concat((0, $f3ce2b19837eb4bd$exports.setOrganizer)(organizer))) + "\r\n" : "";
    icsFormat += busyStatus ? (0, $f3ce2b19837eb4bd$exports.foldLine)("X-MICROSOFT-CDO-BUSYSTATUS:".concat((0, $e96de0cc9a88de76$var$_encodeNewLines["default"])(busyStatus))) + "\r\n" : "";
    icsFormat += transp ? (0, $f3ce2b19837eb4bd$exports.foldLine)("TRANSP:".concat((0, $e96de0cc9a88de76$var$_encodeNewLines["default"])(transp))) + "\r\n" : "";
    icsFormat += classification ? (0, $f3ce2b19837eb4bd$exports.foldLine)("CLASS:".concat((0, $e96de0cc9a88de76$var$_encodeNewLines["default"])(classification))) + "\r\n" : "";
    icsFormat += created ? "CREATED:" + (0, $e96de0cc9a88de76$var$_encodeNewLines["default"])((0, $f3ce2b19837eb4bd$exports.formatDate)(created)) + "\r\n" : "";
    icsFormat += lastModified ? "LAST-MODIFIED:" + (0, $e96de0cc9a88de76$var$_encodeNewLines["default"])((0, $f3ce2b19837eb4bd$exports.formatDate)(lastModified)) + "\r\n" : "";
    icsFormat += htmlContent ? (0, $f3ce2b19837eb4bd$exports.foldLine)("X-ALT-DESC;FMTTYPE=text/html:".concat((0, $e96de0cc9a88de76$var$_encodeNewLines["default"])(htmlContent))) + "\r\n" : "";
    if (attendees) attendees.forEach(function(attendee) {
        icsFormat += (0, $f3ce2b19837eb4bd$exports.foldLine)("ATTENDEE;".concat((0, $e96de0cc9a88de76$var$_encodeNewLines["default"])((0, $f3ce2b19837eb4bd$exports.setContact)(attendee)))) + "\r\n";
    });
    icsFormat += recurrenceRule ? (0, $f3ce2b19837eb4bd$exports.foldLine)("RRULE:".concat((0, $e96de0cc9a88de76$var$_encodeNewLines["default"])(recurrenceRule))) + "\r\n" : "";
    icsFormat += exclusionDates ? (0, $f3ce2b19837eb4bd$exports.foldLine)("EXDATE:".concat((0, $e96de0cc9a88de76$var$_encodeNewLines["default"])(exclusionDates.map(function(a) {
        return (0, $f3ce2b19837eb4bd$exports.formatDate)(a);
    }).join(",")))) + "\r\n" : "";
    icsFormat += duration ? (0, $f3ce2b19837eb4bd$exports.foldLine)("DURATION:".concat((0, $f3ce2b19837eb4bd$exports.formatDuration)(duration))) + "\r\n" : "";
    if (alarms) alarms.forEach(function(alarm) {
        icsFormat += (0, $f3ce2b19837eb4bd$exports.setAlarm)(alarm);
    });
    icsFormat += "END:VEVENT\r\n";
    return icsFormat;
}


var $9d81b2aa01f9dc3a$exports = {};
"use strict";
Object.defineProperty($9d81b2aa01f9dc3a$exports, "__esModule", {
    value: true
});
var $72fea8a754fd5d24$exports = {};
"use strict";
Object.defineProperty($72fea8a754fd5d24$exports, "__esModule", {
    value: true
});
$72fea8a754fd5d24$exports.validateHeader = $72fea8a754fd5d24$var$validateHeader;
$72fea8a754fd5d24$exports.validateHeaderAndEvent = $72fea8a754fd5d24$var$validateHeaderAndEvent;

var $72fea8a754fd5d24$var$yup = $72fea8a754fd5d24$var$_interopRequireWildcard((parcelRequire("DV6aU")));
function $72fea8a754fd5d24$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($72fea8a754fd5d24$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $72fea8a754fd5d24$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $72fea8a754fd5d24$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $72fea8a754fd5d24$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $72fea8a754fd5d24$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $72fea8a754fd5d24$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $72fea8a754fd5d24$var$_typeof(obj);
}
function $72fea8a754fd5d24$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $72fea8a754fd5d24$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $72fea8a754fd5d24$var$ownKeys(Object(source), !0).forEach(function(key) {
            $72fea8a754fd5d24$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $72fea8a754fd5d24$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $72fea8a754fd5d24$var$_defineProperty(obj, key, value) {
    key = $72fea8a754fd5d24$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $72fea8a754fd5d24$var$_toPropertyKey(arg) {
    var key = $72fea8a754fd5d24$var$_toPrimitive(arg, "string");
    return $72fea8a754fd5d24$var$_typeof(key) === "symbol" ? key : String(key);
}
function $72fea8a754fd5d24$var$_toPrimitive(input, hint) {
    if ($72fea8a754fd5d24$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($72fea8a754fd5d24$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
// yup url validation blocks localhost, so use a more flexible regex instead
// taken from https://github.com/jquense/yup/issues/224#issuecomment-417172609
// This does mean that the url validation error is
// "url must match the following: ...." as opposed to "url must be a valid URL"
var $72fea8a754fd5d24$var$urlRegex = /^(?:([a-z0-9+.-]+):\/\/)(?:\S+(?::\S*)?@)?(?:(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/;
var $72fea8a754fd5d24$var$dateTimeSchema = function dateTimeSchema(_ref) {
    var required = _ref.required;
    return $72fea8a754fd5d24$var$yup.lazy(function(value) {
        if (typeof value === "number") return $72fea8a754fd5d24$var$yup.number().integer().min(0);
        if (typeof value === "string") return $72fea8a754fd5d24$var$yup.string().required();
        if (!required && typeof value === "undefined") return $72fea8a754fd5d24$var$yup.mixed().oneOf([
            undefined
        ]);
        return $72fea8a754fd5d24$var$yup.array().required().min(3).max(7).of($72fea8a754fd5d24$var$yup.lazy(function(item, options) {
            var itemIndex = options.parent.indexOf(options.value);
            return [
                $72fea8a754fd5d24$var$yup.number().integer(),
                $72fea8a754fd5d24$var$yup.number().integer().min(1).max(12),
                $72fea8a754fd5d24$var$yup.number().integer().min(1).max(31),
                $72fea8a754fd5d24$var$yup.number().integer().min(0).max(23),
                $72fea8a754fd5d24$var$yup.number().integer().min(0).max(60),
                $72fea8a754fd5d24$var$yup.number().integer().min(0).max(60)
            ][itemIndex];
        }));
    });
};
var $72fea8a754fd5d24$var$durationSchema = $72fea8a754fd5d24$var$yup.object().shape({
    before: $72fea8a754fd5d24$var$yup["boolean"](),
    //option to set before alaram
    weeks: $72fea8a754fd5d24$var$yup.number(),
    days: $72fea8a754fd5d24$var$yup.number(),
    hours: $72fea8a754fd5d24$var$yup.number(),
    minutes: $72fea8a754fd5d24$var$yup.number(),
    seconds: $72fea8a754fd5d24$var$yup.number()
}).noUnknown();
var $72fea8a754fd5d24$var$contactSchema = $72fea8a754fd5d24$var$yup.object().shape({
    name: $72fea8a754fd5d24$var$yup.string(),
    email: $72fea8a754fd5d24$var$yup.string().email(),
    rsvp: $72fea8a754fd5d24$var$yup["boolean"](),
    dir: $72fea8a754fd5d24$var$yup.string().matches($72fea8a754fd5d24$var$urlRegex),
    partstat: $72fea8a754fd5d24$var$yup.string(),
    role: $72fea8a754fd5d24$var$yup.string(),
    cutype: $72fea8a754fd5d24$var$yup.string(),
    xNumGuests: $72fea8a754fd5d24$var$yup.number()
}).noUnknown();
var $72fea8a754fd5d24$var$organizerSchema = $72fea8a754fd5d24$var$yup.object().shape({
    name: $72fea8a754fd5d24$var$yup.string(),
    email: $72fea8a754fd5d24$var$yup.string().email(),
    dir: $72fea8a754fd5d24$var$yup.string(),
    sentBy: $72fea8a754fd5d24$var$yup.string()
}).noUnknown();
var $72fea8a754fd5d24$var$alarmSchema = $72fea8a754fd5d24$var$yup.object().shape({
    action: $72fea8a754fd5d24$var$yup.string().matches(/^(audio|display|email)$/).required(),
    trigger: $72fea8a754fd5d24$var$yup.mixed().required(),
    description: $72fea8a754fd5d24$var$yup.string(),
    duration: $72fea8a754fd5d24$var$durationSchema,
    repeat: $72fea8a754fd5d24$var$yup.number(),
    attach: $72fea8a754fd5d24$var$yup.string(),
    attachType: $72fea8a754fd5d24$var$yup.string(),
    summary: $72fea8a754fd5d24$var$yup.string(),
    attendee: $72fea8a754fd5d24$var$contactSchema,
    "x-prop": $72fea8a754fd5d24$var$yup.mixed(),
    "iana-prop": $72fea8a754fd5d24$var$yup.mixed()
}).noUnknown();
var $72fea8a754fd5d24$var$headerShape = {
    productId: $72fea8a754fd5d24$var$yup.string(),
    method: $72fea8a754fd5d24$var$yup.string(),
    calName: $72fea8a754fd5d24$var$yup.string()
};
var $72fea8a754fd5d24$var$headerSchema = $72fea8a754fd5d24$var$yup.object().shape($72fea8a754fd5d24$var$headerShape).noUnknown();
var $72fea8a754fd5d24$var$eventShape = {
    summary: $72fea8a754fd5d24$var$yup.string(),
    timestamp: $72fea8a754fd5d24$var$dateTimeSchema({
        required: false
    }),
    title: $72fea8a754fd5d24$var$yup.string(),
    uid: $72fea8a754fd5d24$var$yup.string(),
    sequence: $72fea8a754fd5d24$var$yup.number().integer().max(2147483647),
    start: $72fea8a754fd5d24$var$dateTimeSchema({
        required: true
    }),
    duration: $72fea8a754fd5d24$var$durationSchema,
    startType: $72fea8a754fd5d24$var$yup.string().matches(/^(utc|local)$/),
    startInputType: $72fea8a754fd5d24$var$yup.string().matches(/^(utc|local)$/),
    startOutputType: $72fea8a754fd5d24$var$yup.string().matches(/^(utc|local)$/),
    end: $72fea8a754fd5d24$var$dateTimeSchema({
        required: false
    }),
    endInputType: $72fea8a754fd5d24$var$yup.string().matches(/^(utc|local)$/),
    endOutputType: $72fea8a754fd5d24$var$yup.string().matches(/^(utc|local)$/),
    description: $72fea8a754fd5d24$var$yup.string(),
    url: $72fea8a754fd5d24$var$yup.string().matches($72fea8a754fd5d24$var$urlRegex),
    geo: $72fea8a754fd5d24$var$yup.object().shape({
        lat: $72fea8a754fd5d24$var$yup.number(),
        lon: $72fea8a754fd5d24$var$yup.number()
    }),
    location: $72fea8a754fd5d24$var$yup.string(),
    status: $72fea8a754fd5d24$var$yup.string().matches(/^(TENTATIVE|CANCELLED|CONFIRMED)$/i),
    categories: $72fea8a754fd5d24$var$yup.array().of($72fea8a754fd5d24$var$yup.string()),
    organizer: $72fea8a754fd5d24$var$organizerSchema,
    attendees: $72fea8a754fd5d24$var$yup.array().of($72fea8a754fd5d24$var$contactSchema),
    alarms: $72fea8a754fd5d24$var$yup.array().of($72fea8a754fd5d24$var$alarmSchema),
    recurrenceRule: $72fea8a754fd5d24$var$yup.string(),
    busyStatus: $72fea8a754fd5d24$var$yup.string().matches(/^(TENTATIVE|FREE|BUSY|OOF)$/i),
    transp: $72fea8a754fd5d24$var$yup.string().matches(/^(TRANSPARENT|OPAQUE)$/i),
    classification: $72fea8a754fd5d24$var$yup.string(),
    created: $72fea8a754fd5d24$var$dateTimeSchema({
        required: false
    }),
    lastModified: $72fea8a754fd5d24$var$dateTimeSchema({
        required: false
    }),
    exclusionDates: $72fea8a754fd5d24$var$yup.array().of($72fea8a754fd5d24$var$dateTimeSchema({
        required: true
    })),
    htmlContent: $72fea8a754fd5d24$var$yup.string()
};
var $72fea8a754fd5d24$var$headerAndEventSchema = $72fea8a754fd5d24$var$yup.object().shape($72fea8a754fd5d24$var$_objectSpread($72fea8a754fd5d24$var$_objectSpread({}, $72fea8a754fd5d24$var$headerShape), $72fea8a754fd5d24$var$eventShape)).test("xor", "object should have end or duration (but not both)", function(val) {
    var hasEnd = !!val.end;
    var hasDuration = !!val.duration;
    return hasEnd && !hasDuration || !hasEnd && hasDuration || !hasEnd && !hasDuration;
}).noUnknown();
function $72fea8a754fd5d24$var$validateHeader(candidate) {
    try {
        var value = $72fea8a754fd5d24$var$headerSchema.validateSync(candidate, {
            abortEarly: false,
            strict: true
        });
        return {
            error: null,
            value: value
        };
    } catch (error) {
        return {
            error: Object.assign({}, error),
            value: undefined
        };
    }
}
function $72fea8a754fd5d24$var$validateHeaderAndEvent(candidate) {
    try {
        var value = $72fea8a754fd5d24$var$headerAndEventSchema.validateSync(candidate, {
            abortEarly: false,
            strict: true
        });
        return {
            error: null,
            value: value
        };
    } catch (error) {
        return {
            error: Object.assign({}, error),
            value: undefined
        };
    }
}


Object.keys($72fea8a754fd5d24$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $9d81b2aa01f9dc3a$exports && $9d81b2aa01f9dc3a$exports[key] === $72fea8a754fd5d24$exports[key]) return;
    Object.defineProperty($9d81b2aa01f9dc3a$exports, key, {
        enumerable: true,
        get: function get() {
            return $72fea8a754fd5d24$exports[key];
        }
    });
});




function $1acdf244acbb2b83$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1acdf244acbb2b83$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1acdf244acbb2b83$var$_typeof(obj);
}
function $1acdf244acbb2b83$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1acdf244acbb2b83$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1acdf244acbb2b83$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1acdf244acbb2b83$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1acdf244acbb2b83$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1acdf244acbb2b83$var$_defineProperty(obj, key, value) {
    key = $1acdf244acbb2b83$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1acdf244acbb2b83$var$_toPropertyKey(arg) {
    var key = $1acdf244acbb2b83$var$_toPrimitive(arg, "string");
    return $1acdf244acbb2b83$var$_typeof(key) === "symbol" ? key : String(key);
}
function $1acdf244acbb2b83$var$_toPrimitive(input, hint) {
    if ($1acdf244acbb2b83$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($1acdf244acbb2b83$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $1acdf244acbb2b83$var$buildHeaderAndValidate(header) {
    return (0, $3c55986a95d9bd6b$exports.validateHeader)((0, $3c55986a95d9bd6b$exports.buildHeader)(header));
}
function $1acdf244acbb2b83$var$buildHeaderAndEventAndValidate(event) {
    return (0, $3c55986a95d9bd6b$exports.validateHeaderAndEvent)($1acdf244acbb2b83$var$_objectSpread($1acdf244acbb2b83$var$_objectSpread({}, (0, $3c55986a95d9bd6b$exports.buildHeader)(event)), (0, $3c55986a95d9bd6b$exports.buildEvent)(event)));
}
function $1acdf244acbb2b83$var$convertTimestampToArray(timestamp) {
    var inputType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "local";
    var dateArray = [];
    var d = new Date(timestamp);
    dateArray.push(inputType === "local" ? d.getFullYear() : d.getUTCFullYear());
    dateArray.push((inputType === "local" ? d.getMonth() : d.getUTCMonth()) + 1);
    dateArray.push(inputType === "local" ? d.getDate() : d.getUTCDate());
    dateArray.push(inputType === "local" ? d.getHours() : d.getUTCHours());
    dateArray.push(inputType === "local" ? d.getMinutes() : d.getUTCMinutes());
    return dateArray;
}
function $1acdf244acbb2b83$var$createEvent(attributes, cb) {
    return $1acdf244acbb2b83$var$createEvents([
        attributes
    ], cb);
}
function $1acdf244acbb2b83$var$createEvents(events, headerAttributesOrCb, cb) {
    var resolvedHeaderAttributes = $1acdf244acbb2b83$var$_typeof(headerAttributesOrCb) === "object" ? headerAttributesOrCb : {};
    var resolvedCb = arguments.length === 3 ? cb : typeof headerAttributesOrCb === "function" ? headerAttributesOrCb : null;
    var run = function run() {
        if (!events) return {
            error: new Error("one argument is required"),
            value: null
        };
        var _ref = events.length === 0 ? $1acdf244acbb2b83$var$buildHeaderAndValidate(resolvedHeaderAttributes) : $1acdf244acbb2b83$var$buildHeaderAndEventAndValidate($1acdf244acbb2b83$var$_objectSpread($1acdf244acbb2b83$var$_objectSpread({}, events[0]), resolvedHeaderAttributes)), headerError = _ref.error, headerValue = _ref.value;
        if (headerError) return {
            error: headerError,
            value: null
        };
        var value = "";
        value += (0, $3c55986a95d9bd6b$exports.formatHeader)(headerValue);
        for(var i = 0; i < events.length; i++){
            var _buildHeaderAndEventA = $1acdf244acbb2b83$var$buildHeaderAndEventAndValidate(events[i]), eventError = _buildHeaderAndEventA.error, eventValue = _buildHeaderAndEventA.value;
            if (eventError) return {
                error: eventError,
                value: null
            };
            value += (0, $3c55986a95d9bd6b$exports.formatEvent)(eventValue);
        }
        value += (0, $3c55986a95d9bd6b$exports.formatFooter)();
        return {
            error: null,
            value: value
        };
    };
    var returnValue;
    try {
        returnValue = run();
    } catch (e) {
        returnValue = {
            error: e,
            value: null
        };
    }
    if (!resolvedCb) return returnValue;
    return resolvedCb(returnValue.error, returnValue.value);
}


class $de5b88a996a03fad$export$2e2bcd8739ae039 {
    bindEvents() {
        this.item.addEventListener("click", (e)=>{
            e.preventDefault();
            this.handleDownload();
        });
    }
    async handleDownload() {
        let event = {
            productId: "opcommerce/id",
            uid: this.slug + "@opcommerce",
            startOutputType: "local",
            start: this.start,
            end: this.end,
            title: this.title,
            // description:this.description,
            location: this.location
        };
        const filename = this.slug + ".ics";
        const file = await new Promise((resolve, reject)=>{
            (0, $1acdf244acbb2b83$exports.createEvent)(event, (error, value)=>{
                if (error) reject(error);
                resolve(new File([
                    value
                ], filename, {
                    type: "text/calendar"
                }));
            });
        });
        const url = URL.createObjectURL(file);
        // trying to assign the file URL to a window could cause cross-site
        // issues so this is a workaround using HTML5
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = filename;
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
        URL.revokeObjectURL(url);
    }
    constructor(element){
        this.item = element;
        this.start = parseInt(this.item.dataset.startDate) * 1000;
        this.end = parseInt(this.item.dataset.endDate) * 1000;
        this.slug = this.item.dataset.slug;
        this.title = this.item.dataset.title;
        // this.description = this.item.dataset.description;
        this.location = this.item.dataset.location;
        this.bindEvents();
        this.item.isInit = true;
    }
}


class $5ba741c30eea73e0$export$2e2bcd8739ae039 {
    init() {
        this._track.style.whiteSpace = "nowrap";
        this._wrapper.style.display = "flex";
        this._wrapper.style.alignItems = "center";
        this._wrapper.style.gap = "1em";
        this._text.style.display = "inline";
    }
    buildMarquee() {
        let times = Math.ceil(this._wrapper.offsetWidth / this._text.offsetWidth);
        for(let i = 0; i <= times; i++){
            let clone = this._text.cloneNode(true);
            this._track.appendChild(clone);
            this.clones.push(clone);
        }
        this._clonedTrack = this._track.cloneNode(true);
        this._wrapper.appendChild(this._clonedTrack);
        this._track.classList.add("marquee");
        this._clonedTrack.classList.add("marquee");
    }
    bindEvents() {
        window.addEventListener("resize", app.debounce(()=>{
            this.kill();
            this.buildMarquee();
        }));
    }
    kill() {
        this._track.classList.remove("marquee");
        this.clones.forEach((el)=>{
            el.remove();
        });
        this._clonedTrack.remove();
    }
    constructor(element){
        this._wrapper = element;
        this._track = this._wrapper.querySelector(".js-marquee-track");
        this._text = this._wrapper.querySelector(".js-marquee-text");
        this.clones = [];
        this._clonedTrack = false;
        this.init();
        this.buildMarquee();
        this.bindEvents();
    }
}



class $43abcced49545ed4$export$2e2bcd8739ae039 {
    bindEvents() {
        app.nodesEventListener("click", this._btns, (el, n, e)=>{
            if (el.classList.contains("is-active")) this.reset();
            else {
                let targetIndex = el.getAttribute("data-target");
                let _targetContent = this._wrapper.querySelector('.js-sectors-list-content[data-index="' + targetIndex + '"]');
                let _otherContents = this._wrapper.querySelectorAll('.js-sectors-list-content:not([data-index="' + targetIndex + '"])');
                let _targetBtns = this._wrapper.querySelectorAll('.js-sectors-list-btn[data-target="' + targetIndex + '"]');
                let _otherBtns = this._wrapper.querySelectorAll('.js-sectors-list-btn:not([data-target="' + targetIndex + '"])');
                app.nodesAddClass(_targetBtns, "is-active");
                app.nodesRemoveClass(_otherBtns, "is-active");
                this.filterContents(_targetContent, _otherContents);
            }
        });
    }
    checkUrlParams() {
        let params = new URLSearchParams(document.location.search);
        if (params.get("target")) {
            let targetIndex = params.get("target");
            let _targetContent = this._wrapper.querySelector('.js-sectors-list-content[data-index="' + targetIndex + '"]');
            let _otherContents = this._wrapper.querySelectorAll('.js-sectors-list-content:not([data-index="' + targetIndex + '"])');
            let _targetBtns = this._wrapper.querySelectorAll('.js-sectors-list-btn[data-target="' + targetIndex + '"]');
            let _otherBtns = this._wrapper.querySelectorAll('.js-sectors-list-btn:not([data-target="' + targetIndex + '"])');
            if (_targetContent) {
                app.nodesAddClass(_targetBtns, "is-active");
                app.nodesRemoveClass(_otherBtns, "is-active");
                this.filterContents(_targetContent, _otherContents);
            }
        }
    }
    filterContents(_targetContent, _otherContents) {
        (0, $35069e6098950ce3$export$99ee26438460406a).to(_otherContents, {
            y: "-50px",
            alpha: 0,
            onComplete: ()=>{
                app.nodesAddClass(_otherContents, "d-none");
                _targetContent.classList.remove("d-none");
                _targetContent.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
                (0, $35069e6098950ce3$export$99ee26438460406a).to(_targetContent, {
                    y: "0px",
                    alpha: 1
                });
            }
        });
    }
    reset() {
        app.nodesRemoveClass(this._btns, "is-active");
        app.nodesRemoveClass(this._contents, "d-none");
        (0, $35069e6098950ce3$export$99ee26438460406a).to(this._contents, {
            y: "0px",
            alpha: 1
        });
    }
    constructor(element){
        this._wrapper = element;
        this._btns = this._wrapper.querySelectorAll(".js-sectors-list-btn");
        this._contents = this._wrapper.querySelectorAll(".js-sectors-list-content");
        this.bindEvents();
        this.checkUrlParams();
    }
}




class $6185d5206e00a777$export$2e2bcd8739ae039 {
    init() {
        this.slider = new (0, $731acbcb25ce319f$export$25ce5a424b770e84)(this._swiper, {
            slidesPerView: 1,
            loop: true,
            rewind: false,
            spaceBetween: 24,
            modules: [
                (0, $b68a48a0cb5e2e58$export$2e2bcd8739ae039)
            ],
            navigation: {
                nextEl: this._right,
                prevEl: this._left
            },
            breakpoints: {
                576: {
                    slidesPerView: 2
                },
                768: {
                    slidesPerView: 3
                },
                1200: {
                    slidesPerView: 4
                },
                1440: {
                    slidesPerView: 6
                },
                1520: {
                    slidesPerView: 6
                }
            }
        });
        this.slider.on("activeIndexChange", ()=>{
            this._count.innerText = this.slider.realIndex + 1;
        });
    }
    setSliderWrapperWidth() {
        let offsetLeft = this._container.offsetLeft;
        if (this.isMD()) this._sliderWrapper.setAttribute("style", "");
        else this._sliderWrapper.style.width = "calc(100% - " + offsetLeft + "px)";
    }
    bindEvents() {
        window.addEventListener("resize", app.debounce(this.setSliderWrapperWidth.bind(this)));
    }
    isMD() {
        return window.matchMedia("(max-width:768px)").matches;
    }
    constructor(element){
        this._wrapper = element;
        this._swiper = this._wrapper.querySelector(".swiper");
        this._left = this._wrapper.querySelector(".js-slider-video-left");
        this._right = this._wrapper.querySelector(".js-slider-video-right");
        this._count = this._wrapper.querySelector(".js-slider-video-count");
        this._container = this._wrapper.querySelector(".js-slider-video-container");
        this._sliderWrapper = this._wrapper.querySelector(".js-slider-video-slider-wrapper");
        this.init();
        this.bindEvents();
        this.setSliderWrapperWidth();
    }
}




class $e641f985927f5a57$export$2e2bcd8739ae039 {
    init() {
        this.slider = new (0, $731acbcb25ce319f$export$25ce5a424b770e84)(this._swiper, {
            slidesPerView: 1,
            loop: true,
            spaceBetween: 24,
            modules: [
                (0, $ad4c197f78da2876$export$2e2bcd8739ae039)
            ],
            pagination: {
                el: this._pagination,
                type: "bullets",
                clickable: true
            },
            breakpoints: {
                992: {
                    slidesPerView: 2
                },
                1200: {
                    slidesPerView: 3
                }
            }
        });
    }
    constructor(element){
        this._wrapper = element;
        this._swiper = this._wrapper.querySelector(".swiper");
        this._pagination = this._wrapper.querySelector(".swiper-pagination");
        this.init();
    }
}


var $0b508cf32695ce57$exports = {};
/*!
 * matter-js 0.20.0 by @liabru
 * http://brm.io/matter-js/
 * License MIT
 * 
 * The MIT License (MIT)
 * 
 * Copyright (c) Liam Brummitt and contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ (function webpackUniversalModuleDefinition(root, factory) {
    $0b508cf32695ce57$exports = factory();
})($0b508cf32695ce57$exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            /******/ Object.defineProperty(exports, "__esModule", {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != "string") for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 20);
    /******/ }([
        /* 0 */ /***/ function(module1, exports) {
            /**
* The `Matter.Common` module contains utility functions that are common to all modules.
*
* @class Common
*/ var Common = {};
            module1.exports = Common;
            (function() {
                Common._baseDelta = 1000 / 60;
                Common._nextId = 0;
                Common._seed = 0;
                Common._nowStartTime = +new Date();
                Common._warnedOnce = {};
                Common._decomp = null;
                /**
     * Extends the object in the first argument using the object in the second argument.
     * @method extend
     * @param {} obj
     * @param {boolean} deep
     * @return {} obj extended
     */ Common.extend = function(obj, deep) {
                    var argsStart, args, deepClone;
                    if (typeof deep === "boolean") {
                        argsStart = 2;
                        deepClone = deep;
                    } else {
                        argsStart = 1;
                        deepClone = true;
                    }
                    for(var i = argsStart; i < arguments.length; i++){
                        var source = arguments[i];
                        if (source) {
                            for(var prop in source)if (deepClone && source[prop] && source[prop].constructor === Object) {
                                if (!obj[prop] || obj[prop].constructor === Object) {
                                    obj[prop] = obj[prop] || {};
                                    Common.extend(obj[prop], deepClone, source[prop]);
                                } else obj[prop] = source[prop];
                            } else obj[prop] = source[prop];
                        }
                    }
                    return obj;
                };
                /**
     * Creates a new clone of the object, if deep is true references will also be cloned.
     * @method clone
     * @param {} obj
     * @param {bool} deep
     * @return {} obj cloned
     */ Common.clone = function(obj, deep) {
                    return Common.extend({}, deep, obj);
                };
                /**
     * Returns the list of keys for the given object.
     * @method keys
     * @param {} obj
     * @return {string[]} keys
     */ Common.keys = function(obj) {
                    if (Object.keys) return Object.keys(obj);
                    // avoid hasOwnProperty for performance
                    var keys = [];
                    for(var key in obj)keys.push(key);
                    return keys;
                };
                /**
     * Returns the list of values for the given object.
     * @method values
     * @param {} obj
     * @return {array} Array of the objects property values
     */ Common.values = function(obj) {
                    var values = [];
                    if (Object.keys) {
                        var keys = Object.keys(obj);
                        for(var i = 0; i < keys.length; i++)values.push(obj[keys[i]]);
                        return values;
                    }
                    // avoid hasOwnProperty for performance
                    for(var key in obj)values.push(obj[key]);
                    return values;
                };
                /**
     * Gets a value from `base` relative to the `path` string.
     * @method get
     * @param {} obj The base object
     * @param {string} path The path relative to `base`, e.g. 'Foo.Bar.baz'
     * @param {number} [begin] Path slice begin
     * @param {number} [end] Path slice end
     * @return {} The object at the given path
     */ Common.get = function(obj, path, begin, end) {
                    path = path.split(".").slice(begin, end);
                    for(var i = 0; i < path.length; i += 1)obj = obj[path[i]];
                    return obj;
                };
                /**
     * Sets a value on `base` relative to the given `path` string.
     * @method set
     * @param {} obj The base object
     * @param {string} path The path relative to `base`, e.g. 'Foo.Bar.baz'
     * @param {} val The value to set
     * @param {number} [begin] Path slice begin
     * @param {number} [end] Path slice end
     * @return {} Pass through `val` for chaining
     */ Common.set = function(obj, path, val, begin, end) {
                    var parts = path.split(".").slice(begin, end);
                    Common.get(obj, path, 0, -1)[parts[parts.length - 1]] = val;
                    return val;
                };
                /**
     * Shuffles the given array in-place.
     * The function uses a seeded random generator.
     * @method shuffle
     * @param {array} array
     * @return {array} array shuffled randomly
     */ Common.shuffle = function(array) {
                    for(var i = array.length - 1; i > 0; i--){
                        var j = Math.floor(Common.random() * (i + 1));
                        var temp = array[i];
                        array[i] = array[j];
                        array[j] = temp;
                    }
                    return array;
                };
                /**
     * Randomly chooses a value from a list with equal probability.
     * The function uses a seeded random generator.
     * @method choose
     * @param {array} choices
     * @return {object} A random choice object from the array
     */ Common.choose = function(choices) {
                    return choices[Math.floor(Common.random() * choices.length)];
                };
                /**
     * Returns true if the object is a HTMLElement, otherwise false.
     * @method isElement
     * @param {object} obj
     * @return {boolean} True if the object is a HTMLElement, otherwise false
     */ Common.isElement = function(obj) {
                    if (typeof HTMLElement !== "undefined") return obj instanceof HTMLElement;
                    return !!(obj && obj.nodeType && obj.nodeName);
                };
                /**
     * Returns true if the object is an array.
     * @method isArray
     * @param {object} obj
     * @return {boolean} True if the object is an array, otherwise false
     */ Common.isArray = function(obj) {
                    return Object.prototype.toString.call(obj) === "[object Array]";
                };
                /**
     * Returns true if the object is a function.
     * @method isFunction
     * @param {object} obj
     * @return {boolean} True if the object is a function, otherwise false
     */ Common.isFunction = function(obj) {
                    return typeof obj === "function";
                };
                /**
     * Returns true if the object is a plain object.
     * @method isPlainObject
     * @param {object} obj
     * @return {boolean} True if the object is a plain object, otherwise false
     */ Common.isPlainObject = function(obj) {
                    return typeof obj === "object" && obj.constructor === Object;
                };
                /**
     * Returns true if the object is a string.
     * @method isString
     * @param {object} obj
     * @return {boolean} True if the object is a string, otherwise false
     */ Common.isString = function(obj) {
                    return toString.call(obj) === "[object String]";
                };
                /**
     * Returns the given value clamped between a minimum and maximum value.
     * @method clamp
     * @param {number} value
     * @param {number} min
     * @param {number} max
     * @return {number} The value clamped between min and max inclusive
     */ Common.clamp = function(value, min, max) {
                    if (value < min) return min;
                    if (value > max) return max;
                    return value;
                };
                /**
     * Returns the sign of the given value.
     * @method sign
     * @param {number} value
     * @return {number} -1 if negative, +1 if 0 or positive
     */ Common.sign = function(value) {
                    return value < 0 ? -1 : 1;
                };
                /**
     * Returns the current timestamp since the time origin (e.g. from page load).
     * The result is in milliseconds and will use high-resolution timing if available.
     * @method now
     * @return {number} the current timestamp in milliseconds
     */ Common.now = function() {
                    if (typeof window !== "undefined" && window.performance) {
                        if (window.performance.now) return window.performance.now();
                        else if (window.performance.webkitNow) return window.performance.webkitNow();
                    }
                    if (Date.now) return Date.now();
                    return new Date() - Common._nowStartTime;
                };
                /**
     * Returns a random value between a minimum and a maximum value inclusive.
     * The function uses a seeded random generator.
     * @method random
     * @param {number} min
     * @param {number} max
     * @return {number} A random number between min and max inclusive
     */ Common.random = function(min, max) {
                    min = typeof min !== "undefined" ? min : 0;
                    max = typeof max !== "undefined" ? max : 1;
                    return min + _seededRandom() * (max - min);
                };
                var _seededRandom = function() {
                    // https://en.wikipedia.org/wiki/Linear_congruential_generator
                    Common._seed = (Common._seed * 9301 + 49297) % 233280;
                    return Common._seed / 233280;
                };
                /**
     * Converts a CSS hex colour string into an integer.
     * @method colorToNumber
     * @param {string} colorString
     * @return {number} An integer representing the CSS hex string
     */ Common.colorToNumber = function(colorString) {
                    colorString = colorString.replace("#", "");
                    if (colorString.length == 3) colorString = colorString.charAt(0) + colorString.charAt(0) + colorString.charAt(1) + colorString.charAt(1) + colorString.charAt(2) + colorString.charAt(2);
                    return parseInt(colorString, 16);
                };
                /**
     * The console logging level to use, where each level includes all levels above and excludes the levels below.
     * The default level is 'debug' which shows all console messages.  
     *
     * Possible level values are:
     * - 0 = None
     * - 1 = Debug
     * - 2 = Info
     * - 3 = Warn
     * - 4 = Error
     * @static
     * @property logLevel
     * @type {Number}
     * @default 1
     */ Common.logLevel = 1;
                /**
     * Shows a `console.log` message only if the current `Common.logLevel` allows it.
     * The message will be prefixed with 'matter-js' to make it easily identifiable.
     * @method log
     * @param ...objs {} The objects to log.
     */ Common.log = function() {
                    if (console && Common.logLevel > 0 && Common.logLevel <= 3) console.log.apply(console, [
                        "matter-js:"
                    ].concat(Array.prototype.slice.call(arguments)));
                };
                /**
     * Shows a `console.info` message only if the current `Common.logLevel` allows it.
     * The message will be prefixed with 'matter-js' to make it easily identifiable.
     * @method info
     * @param ...objs {} The objects to log.
     */ Common.info = function() {
                    if (console && Common.logLevel > 0 && Common.logLevel <= 2) console.info.apply(console, [
                        "matter-js:"
                    ].concat(Array.prototype.slice.call(arguments)));
                };
                /**
     * Shows a `console.warn` message only if the current `Common.logLevel` allows it.
     * The message will be prefixed with 'matter-js' to make it easily identifiable.
     * @method warn
     * @param ...objs {} The objects to log.
     */ Common.warn = function() {
                    if (console && Common.logLevel > 0 && Common.logLevel <= 3) console.warn.apply(console, [
                        "matter-js:"
                    ].concat(Array.prototype.slice.call(arguments)));
                };
                /**
     * Uses `Common.warn` to log the given message one time only.
     * @method warnOnce
     * @param ...objs {} The objects to log.
     */ Common.warnOnce = function() {
                    var message = Array.prototype.slice.call(arguments).join(" ");
                    if (!Common._warnedOnce[message]) {
                        Common.warn(message);
                        Common._warnedOnce[message] = true;
                    }
                };
                /**
     * Shows a deprecated console warning when the function on the given object is called.
     * The target function will be replaced with a new function that first shows the warning
     * and then calls the original function.
     * @method deprecated
     * @param {object} obj The object or module
     * @param {string} name The property name of the function on obj
     * @param {string} warning The one-time message to show if the function is called
     */ Common.deprecated = function(obj, prop, warning) {
                    obj[prop] = Common.chain(function() {
                        Common.warnOnce("\uD83D\uDD05 deprecated \uD83D\uDD05", warning);
                    }, obj[prop]);
                };
                /**
     * Returns the next unique sequential ID.
     * @method nextId
     * @return {Number} Unique sequential ID
     */ Common.nextId = function() {
                    return Common._nextId++;
                };
                /**
     * A cross browser compatible indexOf implementation.
     * @method indexOf
     * @param {array} haystack
     * @param {object} needle
     * @return {number} The position of needle in haystack, otherwise -1.
     */ Common.indexOf = function(haystack, needle) {
                    if (haystack.indexOf) return haystack.indexOf(needle);
                    for(var i = 0; i < haystack.length; i++){
                        if (haystack[i] === needle) return i;
                    }
                    return -1;
                };
                /**
     * A cross browser compatible array map implementation.
     * @method map
     * @param {array} list
     * @param {function} func
     * @return {array} Values from list transformed by func.
     */ Common.map = function(list, func) {
                    if (list.map) return list.map(func);
                    var mapped = [];
                    for(var i = 0; i < list.length; i += 1)mapped.push(func(list[i]));
                    return mapped;
                };
                /**
     * Takes a directed graph and returns the partially ordered set of vertices in topological order.
     * Circular dependencies are allowed.
     * @method topologicalSort
     * @param {object} graph
     * @return {array} Partially ordered set of vertices in topological order.
     */ Common.topologicalSort = function(graph) {
                    // https://github.com/mgechev/javascript-algorithms
                    // Copyright (c) Minko Gechev (MIT license)
                    // Modifications: tidy formatting and naming
                    var result = [], visited = [], temp = [];
                    for(var node in graph)if (!visited[node] && !temp[node]) Common._topologicalSort(node, visited, temp, graph, result);
                    return result;
                };
                Common._topologicalSort = function(node, visited, temp, graph, result) {
                    var neighbors = graph[node] || [];
                    temp[node] = true;
                    for(var i = 0; i < neighbors.length; i += 1){
                        var neighbor = neighbors[i];
                        if (temp[neighbor]) continue;
                        if (!visited[neighbor]) Common._topologicalSort(neighbor, visited, temp, graph, result);
                    }
                    temp[node] = false;
                    visited[node] = true;
                    result.push(node);
                };
                /**
     * Takes _n_ functions as arguments and returns a new function that calls them in order.
     * The arguments applied when calling the new function will also be applied to every function passed.
     * The value of `this` refers to the last value returned in the chain that was not `undefined`.
     * Therefore if a passed function does not return a value, the previously returned value is maintained.
     * After all passed functions have been called the new function returns the last returned value (if any).
     * If any of the passed functions are a chain, then the chain will be flattened.
     * @method chain
     * @param ...funcs {function} The functions to chain.
     * @return {function} A new function that calls the passed functions in order.
     */ Common.chain = function() {
                    var funcs = [];
                    for(var i = 0; i < arguments.length; i += 1){
                        var func = arguments[i];
                        if (func._chained) // flatten already chained functions
                        funcs.push.apply(funcs, func._chained);
                        else funcs.push(func);
                    }
                    var chain = function() {
                        // https://github.com/GoogleChrome/devtools-docs/issues/53#issuecomment-51941358
                        var lastResult, args = new Array(arguments.length);
                        for(var i = 0, l = arguments.length; i < l; i++)args[i] = arguments[i];
                        for(i = 0; i < funcs.length; i += 1){
                            var result = funcs[i].apply(lastResult, args);
                            if (typeof result !== "undefined") lastResult = result;
                        }
                        return lastResult;
                    };
                    chain._chained = funcs;
                    return chain;
                };
                /**
     * Chains a function to excute before the original function on the given `path` relative to `base`.
     * See also docs for `Common.chain`.
     * @method chainPathBefore
     * @param {} base The base object
     * @param {string} path The path relative to `base`
     * @param {function} func The function to chain before the original
     * @return {function} The chained function that replaced the original
     */ Common.chainPathBefore = function(base, path, func) {
                    return Common.set(base, path, Common.chain(func, Common.get(base, path)));
                };
                /**
     * Chains a function to excute after the original function on the given `path` relative to `base`.
     * See also docs for `Common.chain`.
     * @method chainPathAfter
     * @param {} base The base object
     * @param {string} path The path relative to `base`
     * @param {function} func The function to chain after the original
     * @return {function} The chained function that replaced the original
     */ Common.chainPathAfter = function(base, path, func) {
                    return Common.set(base, path, Common.chain(Common.get(base, path), func));
                };
                /**
     * Provide the [poly-decomp](https://github.com/schteppe/poly-decomp.js) library module to enable
     * concave vertex decomposition support when using `Bodies.fromVertices` e.g. `Common.setDecomp(require('poly-decomp'))`.
     * @method setDecomp
     * @param {} decomp The [poly-decomp](https://github.com/schteppe/poly-decomp.js) library module.
     */ Common.setDecomp = function(decomp) {
                    Common._decomp = decomp;
                };
                /**
     * Returns the [poly-decomp](https://github.com/schteppe/poly-decomp.js) library module provided through `Common.setDecomp`,
     * otherwise returns the global `decomp` if set.
     * @method getDecomp
     * @return {} The [poly-decomp](https://github.com/schteppe/poly-decomp.js) library module if provided.
     */ Common.getDecomp = function() {
                    // get user provided decomp if set
                    var decomp = Common._decomp;
                    try {
                        // otherwise from window global
                        if (!decomp && typeof window !== "undefined") decomp = window.decomp;
                        // otherwise from node global
                        if (!decomp && typeof $parcel$global !== "undefined") decomp = $parcel$global.decomp;
                    } catch (e) {
                        // decomp not available
                        decomp = null;
                    }
                    return decomp;
                };
            })();
        /***/ },
        /* 1 */ /***/ function(module1, exports) {
            /**
* The `Matter.Bounds` module contains methods for creating and manipulating axis-aligned bounding boxes (AABB).
*
* @class Bounds
*/ var Bounds = {};
            module1.exports = Bounds;
            (function() {
                /**
     * Creates a new axis-aligned bounding box (AABB) for the given vertices.
     * @method create
     * @param {vertices} vertices
     * @return {bounds} A new bounds object
     */ Bounds.create = function(vertices) {
                    var bounds = {
                        min: {
                            x: 0,
                            y: 0
                        },
                        max: {
                            x: 0,
                            y: 0
                        }
                    };
                    if (vertices) Bounds.update(bounds, vertices);
                    return bounds;
                };
                /**
     * Updates bounds using the given vertices and extends the bounds given a velocity.
     * @method update
     * @param {bounds} bounds
     * @param {vertices} vertices
     * @param {vector} velocity
     */ Bounds.update = function(bounds, vertices, velocity) {
                    bounds.min.x = Infinity;
                    bounds.max.x = -Infinity;
                    bounds.min.y = Infinity;
                    bounds.max.y = -Infinity;
                    for(var i = 0; i < vertices.length; i++){
                        var vertex = vertices[i];
                        if (vertex.x > bounds.max.x) bounds.max.x = vertex.x;
                        if (vertex.x < bounds.min.x) bounds.min.x = vertex.x;
                        if (vertex.y > bounds.max.y) bounds.max.y = vertex.y;
                        if (vertex.y < bounds.min.y) bounds.min.y = vertex.y;
                    }
                    if (velocity) {
                        if (velocity.x > 0) bounds.max.x += velocity.x;
                        else bounds.min.x += velocity.x;
                        if (velocity.y > 0) bounds.max.y += velocity.y;
                        else bounds.min.y += velocity.y;
                    }
                };
                /**
     * Returns true if the bounds contains the given point.
     * @method contains
     * @param {bounds} bounds
     * @param {vector} point
     * @return {boolean} True if the bounds contain the point, otherwise false
     */ Bounds.contains = function(bounds, point) {
                    return point.x >= bounds.min.x && point.x <= bounds.max.x && point.y >= bounds.min.y && point.y <= bounds.max.y;
                };
                /**
     * Returns true if the two bounds intersect.
     * @method overlaps
     * @param {bounds} boundsA
     * @param {bounds} boundsB
     * @return {boolean} True if the bounds overlap, otherwise false
     */ Bounds.overlaps = function(boundsA, boundsB) {
                    return boundsA.min.x <= boundsB.max.x && boundsA.max.x >= boundsB.min.x && boundsA.max.y >= boundsB.min.y && boundsA.min.y <= boundsB.max.y;
                };
                /**
     * Translates the bounds by the given vector.
     * @method translate
     * @param {bounds} bounds
     * @param {vector} vector
     */ Bounds.translate = function(bounds, vector) {
                    bounds.min.x += vector.x;
                    bounds.max.x += vector.x;
                    bounds.min.y += vector.y;
                    bounds.max.y += vector.y;
                };
                /**
     * Shifts the bounds to the given position.
     * @method shift
     * @param {bounds} bounds
     * @param {vector} position
     */ Bounds.shift = function(bounds, position) {
                    var deltaX = bounds.max.x - bounds.min.x, deltaY = bounds.max.y - bounds.min.y;
                    bounds.min.x = position.x;
                    bounds.max.x = position.x + deltaX;
                    bounds.min.y = position.y;
                    bounds.max.y = position.y + deltaY;
                };
            })();
        /***/ },
        /* 2 */ /***/ function(module1, exports) {
            /**
* The `Matter.Vector` module contains methods for creating and manipulating vectors.
* Vectors are the basis of all the geometry related operations in the engine.
* A `Matter.Vector` object is of the form `{ x: 0, y: 0 }`.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Vector
*/ // TODO: consider params for reusing vector objects
            var Vector = {};
            module1.exports = Vector;
            (function() {
                /**
     * Creates a new vector.
     * @method create
     * @param {number} x
     * @param {number} y
     * @return {vector} A new vector
     */ Vector.create = function(x, y) {
                    return {
                        x: x || 0,
                        y: y || 0
                    };
                };
                /**
     * Returns a new vector with `x` and `y` copied from the given `vector`.
     * @method clone
     * @param {vector} vector
     * @return {vector} A new cloned vector
     */ Vector.clone = function(vector) {
                    return {
                        x: vector.x,
                        y: vector.y
                    };
                };
                /**
     * Returns the magnitude (length) of a vector.
     * @method magnitude
     * @param {vector} vector
     * @return {number} The magnitude of the vector
     */ Vector.magnitude = function(vector) {
                    return Math.sqrt(vector.x * vector.x + vector.y * vector.y);
                };
                /**
     * Returns the magnitude (length) of a vector (therefore saving a `sqrt` operation).
     * @method magnitudeSquared
     * @param {vector} vector
     * @return {number} The squared magnitude of the vector
     */ Vector.magnitudeSquared = function(vector) {
                    return vector.x * vector.x + vector.y * vector.y;
                };
                /**
     * Rotates the vector about (0, 0) by specified angle.
     * @method rotate
     * @param {vector} vector
     * @param {number} angle
     * @param {vector} [output]
     * @return {vector} The vector rotated about (0, 0)
     */ Vector.rotate = function(vector, angle, output) {
                    var cos = Math.cos(angle), sin = Math.sin(angle);
                    if (!output) output = {};
                    var x = vector.x * cos - vector.y * sin;
                    output.y = vector.x * sin + vector.y * cos;
                    output.x = x;
                    return output;
                };
                /**
     * Rotates the vector about a specified point by specified angle.
     * @method rotateAbout
     * @param {vector} vector
     * @param {number} angle
     * @param {vector} point
     * @param {vector} [output]
     * @return {vector} A new vector rotated about the point
     */ Vector.rotateAbout = function(vector, angle, point, output) {
                    var cos = Math.cos(angle), sin = Math.sin(angle);
                    if (!output) output = {};
                    var x = point.x + ((vector.x - point.x) * cos - (vector.y - point.y) * sin);
                    output.y = point.y + ((vector.x - point.x) * sin + (vector.y - point.y) * cos);
                    output.x = x;
                    return output;
                };
                /**
     * Normalises a vector (such that its magnitude is `1`).
     * @method normalise
     * @param {vector} vector
     * @return {vector} A new vector normalised
     */ Vector.normalise = function(vector) {
                    var magnitude = Vector.magnitude(vector);
                    if (magnitude === 0) return {
                        x: 0,
                        y: 0
                    };
                    return {
                        x: vector.x / magnitude,
                        y: vector.y / magnitude
                    };
                };
                /**
     * Returns the dot-product of two vectors.
     * @method dot
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @return {number} The dot product of the two vectors
     */ Vector.dot = function(vectorA, vectorB) {
                    return vectorA.x * vectorB.x + vectorA.y * vectorB.y;
                };
                /**
     * Returns the cross-product of two vectors.
     * @method cross
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @return {number} The cross product of the two vectors
     */ Vector.cross = function(vectorA, vectorB) {
                    return vectorA.x * vectorB.y - vectorA.y * vectorB.x;
                };
                /**
     * Returns the cross-product of three vectors.
     * @method cross3
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @param {vector} vectorC
     * @return {number} The cross product of the three vectors
     */ Vector.cross3 = function(vectorA, vectorB, vectorC) {
                    return (vectorB.x - vectorA.x) * (vectorC.y - vectorA.y) - (vectorB.y - vectorA.y) * (vectorC.x - vectorA.x);
                };
                /**
     * Adds the two vectors.
     * @method add
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @param {vector} [output]
     * @return {vector} A new vector of vectorA and vectorB added
     */ Vector.add = function(vectorA, vectorB, output) {
                    if (!output) output = {};
                    output.x = vectorA.x + vectorB.x;
                    output.y = vectorA.y + vectorB.y;
                    return output;
                };
                /**
     * Subtracts the two vectors.
     * @method sub
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @param {vector} [output]
     * @return {vector} A new vector of vectorA and vectorB subtracted
     */ Vector.sub = function(vectorA, vectorB, output) {
                    if (!output) output = {};
                    output.x = vectorA.x - vectorB.x;
                    output.y = vectorA.y - vectorB.y;
                    return output;
                };
                /**
     * Multiplies a vector and a scalar.
     * @method mult
     * @param {vector} vector
     * @param {number} scalar
     * @return {vector} A new vector multiplied by scalar
     */ Vector.mult = function(vector, scalar) {
                    return {
                        x: vector.x * scalar,
                        y: vector.y * scalar
                    };
                };
                /**
     * Divides a vector and a scalar.
     * @method div
     * @param {vector} vector
     * @param {number} scalar
     * @return {vector} A new vector divided by scalar
     */ Vector.div = function(vector, scalar) {
                    return {
                        x: vector.x / scalar,
                        y: vector.y / scalar
                    };
                };
                /**
     * Returns the perpendicular vector. Set `negate` to true for the perpendicular in the opposite direction.
     * @method perp
     * @param {vector} vector
     * @param {bool} [negate=false]
     * @return {vector} The perpendicular vector
     */ Vector.perp = function(vector, negate) {
                    negate = negate === true ? -1 : 1;
                    return {
                        x: negate * -vector.y,
                        y: negate * vector.x
                    };
                };
                /**
     * Negates both components of a vector such that it points in the opposite direction.
     * @method neg
     * @param {vector} vector
     * @return {vector} The negated vector
     */ Vector.neg = function(vector) {
                    return {
                        x: -vector.x,
                        y: -vector.y
                    };
                };
                /**
     * Returns the angle between the vector `vectorB - vectorA` and the x-axis in radians.
     * @method angle
     * @param {vector} vectorA
     * @param {vector} vectorB
     * @return {number} The angle in radians
     */ Vector.angle = function(vectorA, vectorB) {
                    return Math.atan2(vectorB.y - vectorA.y, vectorB.x - vectorA.x);
                };
                /**
     * Temporary vector pool (not thread-safe).
     * @property _temp
     * @type {vector[]}
     * @private
     */ Vector._temp = [
                    Vector.create(),
                    Vector.create(),
                    Vector.create(),
                    Vector.create(),
                    Vector.create(),
                    Vector.create()
                ];
            })();
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Vertices` module contains methods for creating and manipulating sets of vertices.
* A set of vertices is an array of `Matter.Vector` with additional indexing properties inserted by `Vertices.create`.
* A `Matter.Body` maintains a set of vertices to represent the shape of the object (its convex hull).
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Vertices
*/ var Vertices = {};
            module1.exports = Vertices;
            var Vector = __webpack_require__(2);
            var Common = __webpack_require__(0);
            (function() {
                /**
     * Creates a new set of `Matter.Body` compatible vertices.
     * The `points` argument accepts an array of `Matter.Vector` points orientated around the origin `(0, 0)`, for example:
     *
     *     [{ x: 0, y: 0 }, { x: 25, y: 50 }, { x: 50, y: 0 }]
     *
     * The `Vertices.create` method returns a new array of vertices, which are similar to Matter.Vector objects,
     * but with some additional references required for efficient collision detection routines.
     *
     * Vertices must be specified in clockwise order.
     *
     * Note that the `body` argument is not optional, a `Matter.Body` reference must be provided.
     *
     * @method create
     * @param {vector[]} points
     * @param {body} body
     */ Vertices.create = function(points, body) {
                    var vertices = [];
                    for(var i = 0; i < points.length; i++){
                        var point = points[i], vertex = {
                            x: point.x,
                            y: point.y,
                            index: i,
                            body: body,
                            isInternal: false
                        };
                        vertices.push(vertex);
                    }
                    return vertices;
                };
                /**
     * Parses a string containing ordered x y pairs separated by spaces (and optionally commas), 
     * into a `Matter.Vertices` object for the given `Matter.Body`.
     * For parsing SVG paths, see `Svg.pathToVertices`.
     * @method fromPath
     * @param {string} path
     * @param {body} body
     * @return {vertices} vertices
     */ Vertices.fromPath = function(path, body) {
                    var pathPattern = /L?\s*([-\d.e]+)[\s,]*([-\d.e]+)*/ig, points = [];
                    path.replace(pathPattern, function(match, x, y) {
                        points.push({
                            x: parseFloat(x),
                            y: parseFloat(y)
                        });
                    });
                    return Vertices.create(points, body);
                };
                /**
     * Returns the centre (centroid) of the set of vertices.
     * @method centre
     * @param {vertices} vertices
     * @return {vector} The centre point
     */ Vertices.centre = function(vertices) {
                    var area = Vertices.area(vertices, true), centre = {
                        x: 0,
                        y: 0
                    }, cross, temp, j;
                    for(var i = 0; i < vertices.length; i++){
                        j = (i + 1) % vertices.length;
                        cross = Vector.cross(vertices[i], vertices[j]);
                        temp = Vector.mult(Vector.add(vertices[i], vertices[j]), cross);
                        centre = Vector.add(centre, temp);
                    }
                    return Vector.div(centre, 6 * area);
                };
                /**
     * Returns the average (mean) of the set of vertices.
     * @method mean
     * @param {vertices} vertices
     * @return {vector} The average point
     */ Vertices.mean = function(vertices) {
                    var average = {
                        x: 0,
                        y: 0
                    };
                    for(var i = 0; i < vertices.length; i++){
                        average.x += vertices[i].x;
                        average.y += vertices[i].y;
                    }
                    return Vector.div(average, vertices.length);
                };
                /**
     * Returns the area of the set of vertices.
     * @method area
     * @param {vertices} vertices
     * @param {bool} signed
     * @return {number} The area
     */ Vertices.area = function(vertices, signed) {
                    var area = 0, j = vertices.length - 1;
                    for(var i = 0; i < vertices.length; i++){
                        area += (vertices[j].x - vertices[i].x) * (vertices[j].y + vertices[i].y);
                        j = i;
                    }
                    if (signed) return area / 2;
                    return Math.abs(area) / 2;
                };
                /**
     * Returns the moment of inertia (second moment of area) of the set of vertices given the total mass.
     * @method inertia
     * @param {vertices} vertices
     * @param {number} mass
     * @return {number} The polygon's moment of inertia
     */ Vertices.inertia = function(vertices, mass) {
                    var numerator = 0, denominator = 0, v = vertices, cross, j;
                    // find the polygon's moment of inertia, using second moment of area
                    // from equations at http://www.physicsforums.com/showthread.php?t=25293
                    for(var n = 0; n < v.length; n++){
                        j = (n + 1) % v.length;
                        cross = Math.abs(Vector.cross(v[j], v[n]));
                        numerator += cross * (Vector.dot(v[j], v[j]) + Vector.dot(v[j], v[n]) + Vector.dot(v[n], v[n]));
                        denominator += cross;
                    }
                    return mass / 6 * (numerator / denominator);
                };
                /**
     * Translates the set of vertices in-place.
     * @method translate
     * @param {vertices} vertices
     * @param {vector} vector
     * @param {number} scalar
     */ Vertices.translate = function(vertices, vector, scalar) {
                    scalar = typeof scalar !== "undefined" ? scalar : 1;
                    var verticesLength = vertices.length, translateX = vector.x * scalar, translateY = vector.y * scalar, i;
                    for(i = 0; i < verticesLength; i++){
                        vertices[i].x += translateX;
                        vertices[i].y += translateY;
                    }
                    return vertices;
                };
                /**
     * Rotates the set of vertices in-place.
     * @method rotate
     * @param {vertices} vertices
     * @param {number} angle
     * @param {vector} point
     */ Vertices.rotate = function(vertices, angle, point) {
                    if (angle === 0) return;
                    var cos = Math.cos(angle), sin = Math.sin(angle), pointX = point.x, pointY = point.y, verticesLength = vertices.length, vertex, dx, dy, i;
                    for(i = 0; i < verticesLength; i++){
                        vertex = vertices[i];
                        dx = vertex.x - pointX;
                        dy = vertex.y - pointY;
                        vertex.x = pointX + (dx * cos - dy * sin);
                        vertex.y = pointY + (dx * sin + dy * cos);
                    }
                    return vertices;
                };
                /**
     * Returns `true` if the `point` is inside the set of `vertices`.
     * @method contains
     * @param {vertices} vertices
     * @param {vector} point
     * @return {boolean} True if the vertices contains point, otherwise false
     */ Vertices.contains = function(vertices, point) {
                    var pointX = point.x, pointY = point.y, verticesLength = vertices.length, vertex = vertices[verticesLength - 1], nextVertex;
                    for(var i = 0; i < verticesLength; i++){
                        nextVertex = vertices[i];
                        if ((pointX - vertex.x) * (nextVertex.y - vertex.y) + (pointY - vertex.y) * (vertex.x - nextVertex.x) > 0) return false;
                        vertex = nextVertex;
                    }
                    return true;
                };
                /**
     * Scales the vertices from a point (default is centre) in-place.
     * @method scale
     * @param {vertices} vertices
     * @param {number} scaleX
     * @param {number} scaleY
     * @param {vector} point
     */ Vertices.scale = function(vertices, scaleX, scaleY, point) {
                    if (scaleX === 1 && scaleY === 1) return vertices;
                    point = point || Vertices.centre(vertices);
                    var vertex, delta;
                    for(var i = 0; i < vertices.length; i++){
                        vertex = vertices[i];
                        delta = Vector.sub(vertex, point);
                        vertices[i].x = point.x + delta.x * scaleX;
                        vertices[i].y = point.y + delta.y * scaleY;
                    }
                    return vertices;
                };
                /**
     * Chamfers a set of vertices by giving them rounded corners, returns a new set of vertices.
     * The radius parameter is a single number or an array to specify the radius for each vertex.
     * @method chamfer
     * @param {vertices} vertices
     * @param {number[]} radius
     * @param {number} quality
     * @param {number} qualityMin
     * @param {number} qualityMax
     */ Vertices.chamfer = function(vertices, radius, quality, qualityMin, qualityMax) {
                    if (typeof radius === "number") radius = [
                        radius
                    ];
                    else radius = radius || [
                        8
                    ];
                    // quality defaults to -1, which is auto
                    quality = typeof quality !== "undefined" ? quality : -1;
                    qualityMin = qualityMin || 2;
                    qualityMax = qualityMax || 14;
                    var newVertices = [];
                    for(var i = 0; i < vertices.length; i++){
                        var prevVertex = vertices[i - 1 >= 0 ? i - 1 : vertices.length - 1], vertex = vertices[i], nextVertex = vertices[(i + 1) % vertices.length], currentRadius = radius[i < radius.length ? i : radius.length - 1];
                        if (currentRadius === 0) {
                            newVertices.push(vertex);
                            continue;
                        }
                        var prevNormal = Vector.normalise({
                            x: vertex.y - prevVertex.y,
                            y: prevVertex.x - vertex.x
                        });
                        var nextNormal = Vector.normalise({
                            x: nextVertex.y - vertex.y,
                            y: vertex.x - nextVertex.x
                        });
                        var diagonalRadius = Math.sqrt(2 * Math.pow(currentRadius, 2)), radiusVector = Vector.mult(Common.clone(prevNormal), currentRadius), midNormal = Vector.normalise(Vector.mult(Vector.add(prevNormal, nextNormal), 0.5)), scaledVertex = Vector.sub(vertex, Vector.mult(midNormal, diagonalRadius));
                        var precision = quality;
                        if (quality === -1) // automatically decide precision
                        precision = Math.pow(currentRadius, 0.32) * 1.75;
                        precision = Common.clamp(precision, qualityMin, qualityMax);
                        // use an even value for precision, more likely to reduce axes by using symmetry
                        if (precision % 2 === 1) precision += 1;
                        var alpha = Math.acos(Vector.dot(prevNormal, nextNormal)), theta = alpha / precision;
                        for(var j = 0; j < precision; j++)newVertices.push(Vector.add(Vector.rotate(radiusVector, theta * j), scaledVertex));
                    }
                    return newVertices;
                };
                /**
     * Sorts the input vertices into clockwise order in place.
     * @method clockwiseSort
     * @param {vertices} vertices
     * @return {vertices} vertices
     */ Vertices.clockwiseSort = function(vertices) {
                    var centre = Vertices.mean(vertices);
                    vertices.sort(function(vertexA, vertexB) {
                        return Vector.angle(centre, vertexA) - Vector.angle(centre, vertexB);
                    });
                    return vertices;
                };
                /**
     * Returns true if the vertices form a convex shape (vertices must be in clockwise order).
     * @method isConvex
     * @param {vertices} vertices
     * @return {bool} `true` if the `vertices` are convex, `false` if not (or `null` if not computable).
     */ Vertices.isConvex = function(vertices) {
                    // http://paulbourke.net/geometry/polygonmesh/
                    // Copyright (c) Paul Bourke (use permitted)
                    var flag = 0, n = vertices.length, i, j, k, z;
                    if (n < 3) return null;
                    for(i = 0; i < n; i++){
                        j = (i + 1) % n;
                        k = (i + 2) % n;
                        z = (vertices[j].x - vertices[i].x) * (vertices[k].y - vertices[j].y);
                        z -= (vertices[j].y - vertices[i].y) * (vertices[k].x - vertices[j].x);
                        if (z < 0) flag |= 1;
                        else if (z > 0) flag |= 2;
                        if (flag === 3) return false;
                    }
                    if (flag !== 0) return true;
                    else return null;
                };
                /**
     * Returns the convex hull of the input vertices as a new array of points.
     * @method hull
     * @param {vertices} vertices
     * @return [vertex] vertices
     */ Vertices.hull = function(vertices) {
                    // http://geomalgorithms.com/a10-_hull-1.html
                    var upper = [], lower = [], vertex, i;
                    // sort vertices on x-axis (y-axis for ties)
                    vertices = vertices.slice(0);
                    vertices.sort(function(vertexA, vertexB) {
                        var dx = vertexA.x - vertexB.x;
                        return dx !== 0 ? dx : vertexA.y - vertexB.y;
                    });
                    // build lower hull
                    for(i = 0; i < vertices.length; i += 1){
                        vertex = vertices[i];
                        while(lower.length >= 2 && Vector.cross3(lower[lower.length - 2], lower[lower.length - 1], vertex) <= 0)lower.pop();
                        lower.push(vertex);
                    }
                    // build upper hull
                    for(i = vertices.length - 1; i >= 0; i -= 1){
                        vertex = vertices[i];
                        while(upper.length >= 2 && Vector.cross3(upper[upper.length - 2], upper[upper.length - 1], vertex) <= 0)upper.pop();
                        upper.push(vertex);
                    }
                    // concatenation of the lower and upper hulls gives the convex hull
                    // omit last points because they are repeated at the beginning of the other list
                    upper.pop();
                    lower.pop();
                    return upper.concat(lower);
                };
            })();
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Body` module contains methods for creating and manipulating rigid bodies.
* For creating bodies with common configurations such as rectangles, circles and other polygons see the module `Matter.Bodies`.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).

* @class Body
*/ var Body = {};
            module1.exports = Body;
            var Vertices = __webpack_require__(3);
            var Vector = __webpack_require__(2);
            var Sleeping = __webpack_require__(7);
            var Common = __webpack_require__(0);
            var Bounds = __webpack_require__(1);
            var Axes = __webpack_require__(11);
            (function() {
                Body._timeCorrection = true;
                Body._inertiaScale = 4;
                Body._nextCollidingGroupId = 1;
                Body._nextNonCollidingGroupId = -1;
                Body._nextCategory = 0x0001;
                Body._baseDelta = 1000 / 60;
                /**
     * Creates a new rigid body model. The options parameter is an object that specifies any properties you wish to override the defaults.
     * All properties have default values, and many are pre-calculated automatically based on other properties.
     * Vertices must be specified in clockwise order.
     * See the properties section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @param {} options
     * @return {body} body
     */ Body.create = function(options) {
                    var defaults = {
                        id: Common.nextId(),
                        type: "body",
                        label: "Body",
                        parts: [],
                        plugin: {},
                        angle: 0,
                        vertices: Vertices.fromPath("L 0 0 L 40 0 L 40 40 L 0 40"),
                        position: {
                            x: 0,
                            y: 0
                        },
                        force: {
                            x: 0,
                            y: 0
                        },
                        torque: 0,
                        positionImpulse: {
                            x: 0,
                            y: 0
                        },
                        constraintImpulse: {
                            x: 0,
                            y: 0,
                            angle: 0
                        },
                        totalContacts: 0,
                        speed: 0,
                        angularSpeed: 0,
                        velocity: {
                            x: 0,
                            y: 0
                        },
                        angularVelocity: 0,
                        isSensor: false,
                        isStatic: false,
                        isSleeping: false,
                        motion: 0,
                        sleepThreshold: 60,
                        density: 0.001,
                        restitution: 0,
                        friction: 0.1,
                        frictionStatic: 0.5,
                        frictionAir: 0.01,
                        collisionFilter: {
                            category: 0x0001,
                            mask: 0xFFFFFFFF,
                            group: 0
                        },
                        slop: 0.05,
                        timeScale: 1,
                        render: {
                            visible: true,
                            opacity: 1,
                            strokeStyle: null,
                            fillStyle: null,
                            lineWidth: null,
                            sprite: {
                                xScale: 1,
                                yScale: 1,
                                xOffset: 0,
                                yOffset: 0
                            }
                        },
                        events: null,
                        bounds: null,
                        chamfer: null,
                        circleRadius: 0,
                        positionPrev: null,
                        anglePrev: 0,
                        parent: null,
                        axes: null,
                        area: 0,
                        mass: 0,
                        inertia: 0,
                        deltaTime: 1000 / 60,
                        _original: null
                    };
                    var body = Common.extend(defaults, options);
                    _initProperties(body, options);
                    return body;
                };
                /**
     * Returns the next unique group index for which bodies will collide.
     * If `isNonColliding` is `true`, returns the next unique group index for which bodies will _not_ collide.
     * See `body.collisionFilter` for more information.
     * @method nextGroup
     * @param {bool} [isNonColliding=false]
     * @return {Number} Unique group index
     */ Body.nextGroup = function(isNonColliding) {
                    if (isNonColliding) return Body._nextNonCollidingGroupId--;
                    return Body._nextCollidingGroupId++;
                };
                /**
     * Returns the next unique category bitfield (starting after the initial default category `0x0001`).
     * There are 32 available. See `body.collisionFilter` for more information.
     * @method nextCategory
     * @return {Number} Unique category bitfield
     */ Body.nextCategory = function() {
                    Body._nextCategory = Body._nextCategory << 1;
                    return Body._nextCategory;
                };
                /**
     * Initialises body properties.
     * @method _initProperties
     * @private
     * @param {body} body
     * @param {} [options]
     */ var _initProperties = function(body, options) {
                    options = options || {};
                    // init required properties (order is important)
                    Body.set(body, {
                        bounds: body.bounds || Bounds.create(body.vertices),
                        positionPrev: body.positionPrev || Vector.clone(body.position),
                        anglePrev: body.anglePrev || body.angle,
                        vertices: body.vertices,
                        parts: body.parts || [
                            body
                        ],
                        isStatic: body.isStatic,
                        isSleeping: body.isSleeping,
                        parent: body.parent || body
                    });
                    Vertices.rotate(body.vertices, body.angle, body.position);
                    Axes.rotate(body.axes, body.angle);
                    Bounds.update(body.bounds, body.vertices, body.velocity);
                    // allow options to override the automatically calculated properties
                    Body.set(body, {
                        axes: options.axes || body.axes,
                        area: options.area || body.area,
                        mass: options.mass || body.mass,
                        inertia: options.inertia || body.inertia
                    });
                    // render properties
                    var defaultFillStyle = body.isStatic ? "#14151f" : Common.choose([
                        "#f19648",
                        "#f5d259",
                        "#f55a3c",
                        "#063e7b",
                        "#ececd1"
                    ]), defaultStrokeStyle = body.isStatic ? "#555" : "#ccc", defaultLineWidth = body.isStatic && body.render.fillStyle === null ? 1 : 0;
                    body.render.fillStyle = body.render.fillStyle || defaultFillStyle;
                    body.render.strokeStyle = body.render.strokeStyle || defaultStrokeStyle;
                    body.render.lineWidth = body.render.lineWidth || defaultLineWidth;
                    body.render.sprite.xOffset += -(body.bounds.min.x - body.position.x) / (body.bounds.max.x - body.bounds.min.x);
                    body.render.sprite.yOffset += -(body.bounds.min.y - body.position.y) / (body.bounds.max.y - body.bounds.min.y);
                };
                /**
     * Given a property and a value (or map of), sets the property(s) on the body, using the appropriate setter functions if they exist.
     * Prefer to use the actual setter functions in performance critical situations.
     * @method set
     * @param {body} body
     * @param {} settings A property name (or map of properties and values) to set on the body.
     * @param {} value The value to set if `settings` is a single property name.
     */ Body.set = function(body, settings, value) {
                    var property;
                    if (typeof settings === "string") {
                        property = settings;
                        settings = {};
                        settings[property] = value;
                    }
                    for(property in settings){
                        if (!Object.prototype.hasOwnProperty.call(settings, property)) continue;
                        value = settings[property];
                        switch(property){
                            case "isStatic":
                                Body.setStatic(body, value);
                                break;
                            case "isSleeping":
                                Sleeping.set(body, value);
                                break;
                            case "mass":
                                Body.setMass(body, value);
                                break;
                            case "density":
                                Body.setDensity(body, value);
                                break;
                            case "inertia":
                                Body.setInertia(body, value);
                                break;
                            case "vertices":
                                Body.setVertices(body, value);
                                break;
                            case "position":
                                Body.setPosition(body, value);
                                break;
                            case "angle":
                                Body.setAngle(body, value);
                                break;
                            case "velocity":
                                Body.setVelocity(body, value);
                                break;
                            case "angularVelocity":
                                Body.setAngularVelocity(body, value);
                                break;
                            case "speed":
                                Body.setSpeed(body, value);
                                break;
                            case "angularSpeed":
                                Body.setAngularSpeed(body, value);
                                break;
                            case "parts":
                                Body.setParts(body, value);
                                break;
                            case "centre":
                                Body.setCentre(body, value);
                                break;
                            default:
                                body[property] = value;
                        }
                    }
                };
                /**
     * Sets the body as static, including isStatic flag and setting mass and inertia to Infinity.
     * @method setStatic
     * @param {body} body
     * @param {bool} isStatic
     */ Body.setStatic = function(body, isStatic) {
                    for(var i = 0; i < body.parts.length; i++){
                        var part = body.parts[i];
                        if (isStatic) {
                            if (!part.isStatic) part._original = {
                                restitution: part.restitution,
                                friction: part.friction,
                                mass: part.mass,
                                inertia: part.inertia,
                                density: part.density,
                                inverseMass: part.inverseMass,
                                inverseInertia: part.inverseInertia
                            };
                            part.restitution = 0;
                            part.friction = 1;
                            part.mass = part.inertia = part.density = Infinity;
                            part.inverseMass = part.inverseInertia = 0;
                            part.positionPrev.x = part.position.x;
                            part.positionPrev.y = part.position.y;
                            part.anglePrev = part.angle;
                            part.angularVelocity = 0;
                            part.speed = 0;
                            part.angularSpeed = 0;
                            part.motion = 0;
                        } else if (part._original) {
                            part.restitution = part._original.restitution;
                            part.friction = part._original.friction;
                            part.mass = part._original.mass;
                            part.inertia = part._original.inertia;
                            part.density = part._original.density;
                            part.inverseMass = part._original.inverseMass;
                            part.inverseInertia = part._original.inverseInertia;
                            part._original = null;
                        }
                        part.isStatic = isStatic;
                    }
                };
                /**
     * Sets the mass of the body. Inverse mass, density and inertia are automatically updated to reflect the change.
     * @method setMass
     * @param {body} body
     * @param {number} mass
     */ Body.setMass = function(body, mass) {
                    var moment = body.inertia / (body.mass / 6);
                    body.inertia = moment * (mass / 6);
                    body.inverseInertia = 1 / body.inertia;
                    body.mass = mass;
                    body.inverseMass = 1 / body.mass;
                    body.density = body.mass / body.area;
                };
                /**
     * Sets the density of the body. Mass and inertia are automatically updated to reflect the change.
     * @method setDensity
     * @param {body} body
     * @param {number} density
     */ Body.setDensity = function(body, density) {
                    Body.setMass(body, density * body.area);
                    body.density = density;
                };
                /**
     * Sets the moment of inertia of the body. This is the second moment of area in two dimensions.
     * Inverse inertia is automatically updated to reflect the change. Mass is not changed.
     * @method setInertia
     * @param {body} body
     * @param {number} inertia
     */ Body.setInertia = function(body, inertia) {
                    body.inertia = inertia;
                    body.inverseInertia = 1 / body.inertia;
                };
                /**
     * Sets the body's vertices and updates body properties accordingly, including inertia, area and mass (with respect to `body.density`).
     * Vertices will be automatically transformed to be orientated around their centre of mass as the origin.
     * They are then automatically translated to world space based on `body.position`.
     *
     * The `vertices` argument should be passed as an array of `Matter.Vector` points (or a `Matter.Vertices` array).
     * Vertices must form a convex hull. Concave vertices must be decomposed into convex parts.
     * 
     * @method setVertices
     * @param {body} body
     * @param {vector[]} vertices
     */ Body.setVertices = function(body, vertices) {
                    // change vertices
                    if (vertices[0].body === body) body.vertices = vertices;
                    else body.vertices = Vertices.create(vertices, body);
                    // update properties
                    body.axes = Axes.fromVertices(body.vertices);
                    body.area = Vertices.area(body.vertices);
                    Body.setMass(body, body.density * body.area);
                    // orient vertices around the centre of mass at origin (0, 0)
                    var centre = Vertices.centre(body.vertices);
                    Vertices.translate(body.vertices, centre, -1);
                    // update inertia while vertices are at origin (0, 0)
                    Body.setInertia(body, Body._inertiaScale * Vertices.inertia(body.vertices, body.mass));
                    // update geometry
                    Vertices.translate(body.vertices, body.position);
                    Bounds.update(body.bounds, body.vertices, body.velocity);
                };
                /**
     * Sets the parts of the `body`. 
     * 
     * See `body.parts` for details and requirements on how parts are used.
     * 
     * See Bodies.fromVertices for a related utility.
     * 
     * This function updates `body` mass, inertia and centroid based on the parts geometry.  
     * Sets each `part.parent` to be this `body`.  
     * 
     * The convex hull is computed and set on this `body` (unless `autoHull` is `false`).  
     * Automatically ensures that the first part in `body.parts` is the `body`.
     * @method setParts
     * @param {body} body
     * @param {body[]} parts
     * @param {bool} [autoHull=true]
     */ Body.setParts = function(body, parts, autoHull) {
                    var i;
                    // add all the parts, ensuring that the first part is always the parent body
                    parts = parts.slice(0);
                    body.parts.length = 0;
                    body.parts.push(body);
                    body.parent = body;
                    for(i = 0; i < parts.length; i++){
                        var part = parts[i];
                        if (part !== body) {
                            part.parent = body;
                            body.parts.push(part);
                        }
                    }
                    if (body.parts.length === 1) return;
                    autoHull = typeof autoHull !== "undefined" ? autoHull : true;
                    // find the convex hull of all parts to set on the parent body
                    if (autoHull) {
                        var vertices = [];
                        for(i = 0; i < parts.length; i++)vertices = vertices.concat(parts[i].vertices);
                        Vertices.clockwiseSort(vertices);
                        var hull = Vertices.hull(vertices), hullCentre = Vertices.centre(hull);
                        Body.setVertices(body, hull);
                        Vertices.translate(body.vertices, hullCentre);
                    }
                    // sum the properties of all compound parts of the parent body
                    var total = Body._totalProperties(body);
                    body.area = total.area;
                    body.parent = body;
                    body.position.x = total.centre.x;
                    body.position.y = total.centre.y;
                    body.positionPrev.x = total.centre.x;
                    body.positionPrev.y = total.centre.y;
                    Body.setMass(body, total.mass);
                    Body.setInertia(body, total.inertia);
                    Body.setPosition(body, total.centre);
                };
                /**
     * Set the centre of mass of the body. 
     * The `centre` is a vector in world-space unless `relative` is set, in which case it is a translation.
     * The centre of mass is the point the body rotates about and can be used to simulate non-uniform density.
     * This is equal to moving `body.position` but not the `body.vertices`.
     * Invalid if the `centre` falls outside the body's convex hull.
     * @method setCentre
     * @param {body} body
     * @param {vector} centre
     * @param {bool} relative
     */ Body.setCentre = function(body, centre, relative) {
                    if (!relative) {
                        body.positionPrev.x = centre.x - (body.position.x - body.positionPrev.x);
                        body.positionPrev.y = centre.y - (body.position.y - body.positionPrev.y);
                        body.position.x = centre.x;
                        body.position.y = centre.y;
                    } else {
                        body.positionPrev.x += centre.x;
                        body.positionPrev.y += centre.y;
                        body.position.x += centre.x;
                        body.position.y += centre.y;
                    }
                };
                /**
     * Sets the position of the body. By default velocity is unchanged.
     * If `updateVelocity` is `true` then velocity is inferred from the change in position.
     * @method setPosition
     * @param {body} body
     * @param {vector} position
     * @param {boolean} [updateVelocity=false]
     */ Body.setPosition = function(body, position, updateVelocity) {
                    var delta = Vector.sub(position, body.position);
                    if (updateVelocity) {
                        body.positionPrev.x = body.position.x;
                        body.positionPrev.y = body.position.y;
                        body.velocity.x = delta.x;
                        body.velocity.y = delta.y;
                        body.speed = Vector.magnitude(delta);
                    } else {
                        body.positionPrev.x += delta.x;
                        body.positionPrev.y += delta.y;
                    }
                    for(var i = 0; i < body.parts.length; i++){
                        var part = body.parts[i];
                        part.position.x += delta.x;
                        part.position.y += delta.y;
                        Vertices.translate(part.vertices, delta);
                        Bounds.update(part.bounds, part.vertices, body.velocity);
                    }
                };
                /**
     * Sets the angle of the body. By default angular velocity is unchanged.
     * If `updateVelocity` is `true` then angular velocity is inferred from the change in angle.
     * @method setAngle
     * @param {body} body
     * @param {number} angle
     * @param {boolean} [updateVelocity=false]
     */ Body.setAngle = function(body, angle, updateVelocity) {
                    var delta = angle - body.angle;
                    if (updateVelocity) {
                        body.anglePrev = body.angle;
                        body.angularVelocity = delta;
                        body.angularSpeed = Math.abs(delta);
                    } else body.anglePrev += delta;
                    for(var i = 0; i < body.parts.length; i++){
                        var part = body.parts[i];
                        part.angle += delta;
                        Vertices.rotate(part.vertices, delta, body.position);
                        Axes.rotate(part.axes, delta);
                        Bounds.update(part.bounds, part.vertices, body.velocity);
                        if (i > 0) Vector.rotateAbout(part.position, delta, body.position, part.position);
                    }
                };
                /**
     * Sets the current linear velocity of the body.  
     * Affects body speed.
     * @method setVelocity
     * @param {body} body
     * @param {vector} velocity
     */ Body.setVelocity = function(body, velocity) {
                    var timeScale = body.deltaTime / Body._baseDelta;
                    body.positionPrev.x = body.position.x - velocity.x * timeScale;
                    body.positionPrev.y = body.position.y - velocity.y * timeScale;
                    body.velocity.x = (body.position.x - body.positionPrev.x) / timeScale;
                    body.velocity.y = (body.position.y - body.positionPrev.y) / timeScale;
                    body.speed = Vector.magnitude(body.velocity);
                };
                /**
     * Gets the current linear velocity of the body.
     * @method getVelocity
     * @param {body} body
     * @return {vector} velocity
     */ Body.getVelocity = function(body) {
                    var timeScale = Body._baseDelta / body.deltaTime;
                    return {
                        x: (body.position.x - body.positionPrev.x) * timeScale,
                        y: (body.position.y - body.positionPrev.y) * timeScale
                    };
                };
                /**
     * Gets the current linear speed of the body.  
     * Equivalent to the magnitude of its velocity.
     * @method getSpeed
     * @param {body} body
     * @return {number} speed
     */ Body.getSpeed = function(body) {
                    return Vector.magnitude(Body.getVelocity(body));
                };
                /**
     * Sets the current linear speed of the body.  
     * Direction is maintained. Affects body velocity.
     * @method setSpeed
     * @param {body} body
     * @param {number} speed
     */ Body.setSpeed = function(body, speed) {
                    Body.setVelocity(body, Vector.mult(Vector.normalise(Body.getVelocity(body)), speed));
                };
                /**
     * Sets the current rotational velocity of the body.  
     * Affects body angular speed.
     * @method setAngularVelocity
     * @param {body} body
     * @param {number} velocity
     */ Body.setAngularVelocity = function(body, velocity) {
                    var timeScale = body.deltaTime / Body._baseDelta;
                    body.anglePrev = body.angle - velocity * timeScale;
                    body.angularVelocity = (body.angle - body.anglePrev) / timeScale;
                    body.angularSpeed = Math.abs(body.angularVelocity);
                };
                /**
     * Gets the current rotational velocity of the body.
     * @method getAngularVelocity
     * @param {body} body
     * @return {number} angular velocity
     */ Body.getAngularVelocity = function(body) {
                    return (body.angle - body.anglePrev) * Body._baseDelta / body.deltaTime;
                };
                /**
     * Gets the current rotational speed of the body.  
     * Equivalent to the magnitude of its angular velocity.
     * @method getAngularSpeed
     * @param {body} body
     * @return {number} angular speed
     */ Body.getAngularSpeed = function(body) {
                    return Math.abs(Body.getAngularVelocity(body));
                };
                /**
     * Sets the current rotational speed of the body.  
     * Direction is maintained. Affects body angular velocity.
     * @method setAngularSpeed
     * @param {body} body
     * @param {number} speed
     */ Body.setAngularSpeed = function(body, speed) {
                    Body.setAngularVelocity(body, Common.sign(Body.getAngularVelocity(body)) * speed);
                };
                /**
     * Moves a body by a given vector relative to its current position. By default velocity is unchanged.
     * If `updateVelocity` is `true` then velocity is inferred from the change in position.
     * @method translate
     * @param {body} body
     * @param {vector} translation
     * @param {boolean} [updateVelocity=false]
     */ Body.translate = function(body, translation, updateVelocity) {
                    Body.setPosition(body, Vector.add(body.position, translation), updateVelocity);
                };
                /**
     * Rotates a body by a given angle relative to its current angle. By default angular velocity is unchanged.
     * If `updateVelocity` is `true` then angular velocity is inferred from the change in angle.
     * @method rotate
     * @param {body} body
     * @param {number} rotation
     * @param {vector} [point]
     * @param {boolean} [updateVelocity=false]
     */ Body.rotate = function(body, rotation, point, updateVelocity) {
                    if (!point) Body.setAngle(body, body.angle + rotation, updateVelocity);
                    else {
                        var cos = Math.cos(rotation), sin = Math.sin(rotation), dx = body.position.x - point.x, dy = body.position.y - point.y;
                        Body.setPosition(body, {
                            x: point.x + (dx * cos - dy * sin),
                            y: point.y + (dx * sin + dy * cos)
                        }, updateVelocity);
                        Body.setAngle(body, body.angle + rotation, updateVelocity);
                    }
                };
                /**
     * Scales the body, including updating physical properties (mass, area, axes, inertia), from a world-space point (default is body centre).
     * @method scale
     * @param {body} body
     * @param {number} scaleX
     * @param {number} scaleY
     * @param {vector} [point]
     */ Body.scale = function(body, scaleX, scaleY, point) {
                    var totalArea = 0, totalInertia = 0;
                    point = point || body.position;
                    for(var i = 0; i < body.parts.length; i++){
                        var part = body.parts[i];
                        // scale vertices
                        Vertices.scale(part.vertices, scaleX, scaleY, point);
                        // update properties
                        part.axes = Axes.fromVertices(part.vertices);
                        part.area = Vertices.area(part.vertices);
                        Body.setMass(part, body.density * part.area);
                        // update inertia (requires vertices to be at origin)
                        Vertices.translate(part.vertices, {
                            x: -part.position.x,
                            y: -part.position.y
                        });
                        Body.setInertia(part, Body._inertiaScale * Vertices.inertia(part.vertices, part.mass));
                        Vertices.translate(part.vertices, {
                            x: part.position.x,
                            y: part.position.y
                        });
                        if (i > 0) {
                            totalArea += part.area;
                            totalInertia += part.inertia;
                        }
                        // scale position
                        part.position.x = point.x + (part.position.x - point.x) * scaleX;
                        part.position.y = point.y + (part.position.y - point.y) * scaleY;
                        // update bounds
                        Bounds.update(part.bounds, part.vertices, body.velocity);
                    }
                    // handle parent body
                    if (body.parts.length > 1) {
                        body.area = totalArea;
                        if (!body.isStatic) {
                            Body.setMass(body, body.density * totalArea);
                            Body.setInertia(body, totalInertia);
                        }
                    }
                    // handle circles
                    if (body.circleRadius) {
                        if (scaleX === scaleY) body.circleRadius *= scaleX;
                        else // body is no longer a circle
                        body.circleRadius = null;
                    }
                };
                /**
     * Performs an update by integrating the equations of motion on the `body`.
     * This is applied every update by `Matter.Engine` automatically.
     * @method update
     * @param {body} body
     * @param {number} [deltaTime=16.666]
     */ Body.update = function(body, deltaTime) {
                    deltaTime = (typeof deltaTime !== "undefined" ? deltaTime : 1000 / 60) * body.timeScale;
                    var deltaTimeSquared = deltaTime * deltaTime, correction = Body._timeCorrection ? deltaTime / (body.deltaTime || deltaTime) : 1;
                    // from the previous step
                    var frictionAir = 1 - body.frictionAir * (deltaTime / Common._baseDelta), velocityPrevX = (body.position.x - body.positionPrev.x) * correction, velocityPrevY = (body.position.y - body.positionPrev.y) * correction;
                    // update velocity with Verlet integration
                    body.velocity.x = velocityPrevX * frictionAir + body.force.x / body.mass * deltaTimeSquared;
                    body.velocity.y = velocityPrevY * frictionAir + body.force.y / body.mass * deltaTimeSquared;
                    body.positionPrev.x = body.position.x;
                    body.positionPrev.y = body.position.y;
                    body.position.x += body.velocity.x;
                    body.position.y += body.velocity.y;
                    body.deltaTime = deltaTime;
                    // update angular velocity with Verlet integration
                    body.angularVelocity = (body.angle - body.anglePrev) * frictionAir * correction + body.torque / body.inertia * deltaTimeSquared;
                    body.anglePrev = body.angle;
                    body.angle += body.angularVelocity;
                    // transform the body geometry
                    for(var i = 0; i < body.parts.length; i++){
                        var part = body.parts[i];
                        Vertices.translate(part.vertices, body.velocity);
                        if (i > 0) {
                            part.position.x += body.velocity.x;
                            part.position.y += body.velocity.y;
                        }
                        if (body.angularVelocity !== 0) {
                            Vertices.rotate(part.vertices, body.angularVelocity, body.position);
                            Axes.rotate(part.axes, body.angularVelocity);
                            if (i > 0) Vector.rotateAbout(part.position, body.angularVelocity, body.position, part.position);
                        }
                        Bounds.update(part.bounds, part.vertices, body.velocity);
                    }
                };
                /**
     * Updates properties `body.velocity`, `body.speed`, `body.angularVelocity` and `body.angularSpeed` which are normalised in relation to `Body._baseDelta`.
     * @method updateVelocities
     * @param {body} body
     */ Body.updateVelocities = function(body) {
                    var timeScale = Body._baseDelta / body.deltaTime, bodyVelocity = body.velocity;
                    bodyVelocity.x = (body.position.x - body.positionPrev.x) * timeScale;
                    bodyVelocity.y = (body.position.y - body.positionPrev.y) * timeScale;
                    body.speed = Math.sqrt(bodyVelocity.x * bodyVelocity.x + bodyVelocity.y * bodyVelocity.y);
                    body.angularVelocity = (body.angle - body.anglePrev) * timeScale;
                    body.angularSpeed = Math.abs(body.angularVelocity);
                };
                /**
     * Applies the `force` to the `body` from the force origin `position` in world-space, over a single timestep, including applying any resulting angular torque.
     * 
     * Forces are useful for effects like gravity, wind or rocket thrust, but can be difficult in practice when precise control is needed. In these cases see `Body.setVelocity` and `Body.setPosition` as an alternative.
     * 
     * The force from this function is only applied once for the duration of a single timestep, in other words the duration depends directly on the current engine update `delta` and the rate of calls to this function.
     * 
     * Therefore to account for time, you should apply the force constantly over as many engine updates as equivalent to the intended duration.
     * 
     * If all or part of the force duration is some fraction of a timestep, first multiply the force by `duration / timestep`.
     * 
     * The force origin `position` in world-space must also be specified. Passing `body.position` will result in zero angular effect as the force origin would be at the centre of mass.
     * 
     * The `body` will take time to accelerate under a force, the resulting effect depends on duration of the force, the body mass and other forces on the body including friction combined.
     * @method applyForce
     * @param {body} body
     * @param {vector} position The force origin in world-space. Pass `body.position` to avoid angular torque.
     * @param {vector} force
     */ Body.applyForce = function(body, position, force) {
                    var offset = {
                        x: position.x - body.position.x,
                        y: position.y - body.position.y
                    };
                    body.force.x += force.x;
                    body.force.y += force.y;
                    body.torque += offset.x * force.y - offset.y * force.x;
                };
                /**
     * Returns the sums of the properties of all compound parts of the parent body.
     * @method _totalProperties
     * @private
     * @param {body} body
     * @return {}
     */ Body._totalProperties = function(body) {
                    // from equations at:
                    // https://ecourses.ou.edu/cgi-bin/ebook.cgi?doc=&topic=st&chap_sec=07.2&page=theory
                    // http://output.to/sideway/default.asp?qno=121100087
                    var properties = {
                        mass: 0,
                        area: 0,
                        inertia: 0,
                        centre: {
                            x: 0,
                            y: 0
                        }
                    };
                    // sum the properties of all compound parts of the parent body
                    for(var i = body.parts.length === 1 ? 0 : 1; i < body.parts.length; i++){
                        var part = body.parts[i], mass = part.mass !== Infinity ? part.mass : 1;
                        properties.mass += mass;
                        properties.area += part.area;
                        properties.inertia += part.inertia;
                        properties.centre = Vector.add(properties.centre, Vector.mult(part.position, mass));
                    }
                    properties.centre = Vector.div(properties.centre, properties.mass);
                    return properties;
                };
            /*
    *
    *  Events Documentation
    *
    */ /**
    * Fired when a body starts sleeping (where `this` is the body).
    *
    * @event sleepStart
    * @this {body} The body that has started sleeping
    * @param {} event An event object
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when a body ends sleeping (where `this` is the body).
    *
    * @event sleepEnd
    * @this {body} The body that has ended sleeping
    * @param {} event An event object
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /*
    *
    *  Properties Documentation
    *
    */ /**
     * An integer `Number` uniquely identifying number generated in `Body.create` by `Common.nextId`.
     *
     * @property id
     * @type number
     */ /**
     * _Read only_. Set by `Body.create`.
     * 
     * A `String` denoting the type of object.
     *
     * @readOnly
     * @property type
     * @type string
     * @default "body"
     */ /**
     * An arbitrary `String` name to help the user identify and manage bodies.
     *
     * @property label
     * @type string
     * @default "Body"
     */ /**
     * _Read only_. Use `Body.setParts` to set. 
     * 
     * See `Bodies.fromVertices` for a related utility.
     * 
     * An array of bodies (the 'parts') that make up this body (the 'parent'). The first body in this array must always be a self-reference to this `body`.  
     * 
     * The parts are fixed together and therefore perform as a single unified rigid body.
     * 
     * Parts in relation to each other are allowed to overlap, as well as form gaps or holes, so can be used to create complex concave bodies unlike when using a single part. 
     * 
     * Use properties and functions on the parent `body` rather than on parts.
     *   
     * Outside of their geometry, most properties on parts are not considered or updated.  
     * As such 'per-part' material properties among others are not currently considered.
     * 
     * Parts should be created specifically for their parent body.  
     * Parts should not be shared or reused between bodies, only one parent is supported.  
     * Parts should not have their own parts, they are not handled recursively.  
     * Parts should not be added to the world directly or any other composite.  
     * Parts own vertices must be convex and in clockwise order.   
     * 
     * A body with more than one part is sometimes referred to as a 'compound' body. 
     * 
     * Use `Body.setParts` when setting parts to ensure correct updates of all properties.  
     *
     * @readOnly
     * @property parts
     * @type body[]
     */ /**
     * An object reserved for storing plugin-specific properties.
     *
     * @property plugin
     * @type {}
     */ /**
     * _Read only_. Updated by `Body.setParts`.
     * 
     * A reference to the body that this is a part of. See `body.parts`.
     * This is a self reference if the body is not a part of another body.
     *
     * @readOnly
     * @property parent
     * @type body
     */ /**
     * A `Number` specifying the angle of the body, in radians.
     *
     * @property angle
     * @type number
     * @default 0
     */ /**
     * _Read only_. Use `Body.setVertices` or `Body.setParts` to set. See also `Bodies.fromVertices`.
     * 
     * An array of `Vector` objects that specify the convex hull of the rigid body.
     * These should be provided about the origin `(0, 0)`. E.g.
     *
     * `[{ x: 0, y: 0 }, { x: 25, y: 50 }, { x: 50, y: 0 }]`
     * 
     * Vertices must always be convex, in clockwise order and must not contain any duplicate points.
     * 
     * Concave vertices should be decomposed into convex `parts`, see `Bodies.fromVertices` and `Body.setParts`.
     *
     * When set the vertices are translated such that `body.position` is at the centre of mass.
     * Many other body properties are automatically calculated from these vertices when set including `density`, `area` and `inertia`.
     * 
     * The module `Matter.Vertices` contains useful methods for working with vertices.
     *
     * @readOnly
     * @property vertices
     * @type vector[]
     */ /**
     * _Read only_. Use `Body.setPosition` to set. 
     * 
     * A `Vector` that specifies the current world-space position of the body.
     * 
     * @readOnly
     * @property position
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Vector` that accumulates the total force applied to the body for a single update.
     * Force is zeroed after every `Engine.update`, so constant forces should be applied for every update they are needed. See also `Body.applyForce`.
     * 
     * @property force
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Number` that accumulates the total torque (turning force) applied to the body for a single update. See also `Body.applyForce`.
     * Torque is zeroed after every `Engine.update`, so constant torques should be applied for every update they are needed.
     *
     * Torques result in angular acceleration on every update, which depends on body inertia and the engine update delta.
     * 
     * @property torque
     * @type number
     * @default 0
     */ /**
     * _Read only_. Use `Body.setSpeed` to set. 
     * 
     * See `Body.getSpeed` for details.
     * 
     * Equivalent to the magnitude of `body.velocity` (always positive).
     * 
     * @readOnly
     * @property speed
     * @type number
     * @default 0
     */ /**
     * _Read only_. Use `Body.setVelocity` to set. 
     * 
     * See `Body.getVelocity` for details.
     * 
     * Equivalent to the magnitude of `body.angularVelocity` (always positive).
     * 
     * @readOnly
     * @property velocity
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * _Read only_. Use `Body.setAngularSpeed` to set. 
     * 
     * See `Body.getAngularSpeed` for details.
     * 
     * 
     * @readOnly
     * @property angularSpeed
     * @type number
     * @default 0
     */ /**
     * _Read only_. Use `Body.setAngularVelocity` to set. 
     * 
     * See `Body.getAngularVelocity` for details.
     * 
     *
     * @readOnly
     * @property angularVelocity
     * @type number
     * @default 0
     */ /**
     * _Read only_. Use `Body.setStatic` to set. 
     * 
     * A flag that indicates whether a body is considered static. A static body can never change position or angle and is completely fixed.
     *
     * @readOnly
     * @property isStatic
     * @type boolean
     * @default false
     */ /**
     * A flag that indicates whether a body is a sensor. Sensor triggers collision events, but doesn't react with colliding body physically.
     *
     * @property isSensor
     * @type boolean
     * @default false
     */ /**
     * _Read only_. Use `Sleeping.set` to set. 
     * 
     * A flag that indicates whether the body is considered sleeping. A sleeping body acts similar to a static body, except it is only temporary and can be awoken.
     *
     * @readOnly
     * @property isSleeping
     * @type boolean
     * @default false
     */ /**
     * _Read only_. Calculated during engine update only when sleeping is enabled.
     * 
     * A `Number` that loosely measures the amount of movement a body currently has.
     *
     * Derived from `body.speed^2 + body.angularSpeed^2`. See `Sleeping.update`.
     * 
     * @readOnly
     * @property motion
     * @type number
     * @default 0
     */ /**
     * A `Number` that defines the length of time during which this body must have near-zero velocity before it is set as sleeping by the `Matter.Sleeping` module (if sleeping is enabled by the engine).
     * 
     * @property sleepThreshold
     * @type number
     * @default 60
     */ /**
     * _Read only_. Use `Body.setDensity` to set. 
     * 
     * A `Number` that defines the density of the body (mass per unit area).
     * 
     * Mass will also be updated when set.
     *
     * @readOnly
     * @property density
     * @type number
     * @default 0.001
     */ /**
     * _Read only_. Use `Body.setMass` to set. 
     * 
     * A `Number` that defines the mass of the body.
     * 
     * Density will also be updated when set.
     * 
     * @readOnly
     * @property mass
     * @type number
     */ /**
     * _Read only_. Use `Body.setMass` to set. 
     * 
     * A `Number` that defines the inverse mass of the body (`1 / mass`).
     *
     * @readOnly
     * @property inverseMass
     * @type number
     */ /**
     * _Read only_. Automatically calculated when vertices, mass or density are set or set through `Body.setInertia`.
     * 
     * A `Number` that defines the moment of inertia of the body. This is the second moment of area in two dimensions.
     * 
     * Can be manually set to `Infinity` to prevent rotation of the body. See `Body.setInertia`.
     * 
     * @readOnly
     * @property inertia
     * @type number
     */ /**
     * _Read only_. Automatically calculated when vertices, mass or density are set or calculated by `Body.setInertia`.
     * 
     * A `Number` that defines the inverse moment of inertia of the body (`1 / inertia`).
     * 
     * @readOnly
     * @property inverseInertia
     * @type number
     */ /**
     * A `Number` that defines the restitution (elasticity) of the body. The value is always positive and is in the range `(0, 1)`.
     * A value of `0` means collisions may be perfectly inelastic and no bouncing may occur. 
     * A value of `0.8` means the body may bounce back with approximately 80% of its kinetic energy.
     * Note that collision response is based on _pairs_ of bodies, and that `restitution` values are _combined_ with the following formula:
     *
     * `Math.max(bodyA.restitution, bodyB.restitution)`
     *
     * @property restitution
     * @type number
     * @default 0
     */ /**
     * A `Number` that defines the friction of the body. The value is always positive and is in the range `(0, 1)`.
     * A value of `0` means that the body may slide indefinitely.
     * A value of `1` means the body may come to a stop almost instantly after a force is applied.
     *
     * The effects of the value may be non-linear. 
     * High values may be unstable depending on the body.
     * The engine uses a Coulomb friction model including static and kinetic friction.
     * Note that collision response is based on _pairs_ of bodies, and that `friction` values are _combined_ with the following formula:
     *
     * `Math.min(bodyA.friction, bodyB.friction)`
     *
     * @property friction
     * @type number
     * @default 0.1
     */ /**
     * A `Number` that defines the static friction of the body (in the Coulomb friction model). 
     * A value of `0` means the body will never 'stick' when it is nearly stationary and only dynamic `friction` is used.
     * The higher the value (e.g. `10`), the more force it will take to initially get the body moving when nearly stationary.
     * This value is multiplied with the `friction` property to make it easier to change `friction` and maintain an appropriate amount of static friction.
     *
     * @property frictionStatic
     * @type number
     * @default 0.5
     */ /**
     * A `Number` that defines the air friction of the body (air resistance). 
     * A value of `0` means the body will never slow as it moves through space.
     * The higher the value, the faster a body slows when moving through space.
     * The effects of the value are non-linear. 
     *
     * @property frictionAir
     * @type number
     * @default 0.01
     */ /**
     * An `Object` that specifies the collision filtering properties of this body.
     *
     * Collisions between two bodies will obey the following rules:
     * - If the two bodies have the same non-zero value of `collisionFilter.group`,
     *   they will always collide if the value is positive, and they will never collide
     *   if the value is negative.
     * - If the two bodies have different values of `collisionFilter.group` or if one
     *   (or both) of the bodies has a value of 0, then the category/mask rules apply as follows:
     *
     * Each body belongs to a collision category, given by `collisionFilter.category`. This
     * value is used as a bit field and the category should have only one bit set, meaning that
     * the value of this property is a power of two in the range [1, 2^31]. Thus, there are 32
     * different collision categories available.
     *
     * Each body also defines a collision bitmask, given by `collisionFilter.mask` which specifies
     * the categories it collides with (the value is the bitwise AND value of all these categories).
     *
     * Using the category/mask rules, two bodies `A` and `B` collide if each includes the other's
     * category in its mask, i.e. `(categoryA & maskB) !== 0` and `(categoryB & maskA) !== 0`
     * are both true.
     *
     * @property collisionFilter
     * @type object
     */ /**
     * An Integer `Number`, that specifies the collision group this body belongs to.
     * See `body.collisionFilter` for more information.
     *
     * @property collisionFilter.group
     * @type object
     * @default 0
     */ /**
     * A bit field that specifies the collision category this body belongs to.
     * The category value should have only one bit set, for example `0x0001`.
     * This means there are up to 32 unique collision categories available.
     * See `body.collisionFilter` for more information.
     *
     * @property collisionFilter.category
     * @type object
     * @default 1
     */ /**
     * A bit mask that specifies the collision categories this body may collide with.
     * See `body.collisionFilter` for more information.
     *
     * @property collisionFilter.mask
     * @type object
     * @default -1
     */ /**
     * A `Number` that specifies a thin boundary around the body where it is allowed to slightly sink into other bodies.
     * 
     * This is required for proper collision response, including friction and restitution effects.
     * 
     * The default should generally suffice in most cases. You may need to decrease this value for very small bodies that are nearing the default value in scale.
     *
     * @property slop
     * @type number
     * @default 0.05
     */ /**
     * A `Number` that specifies per-body time scaling.
     *
     * @property timeScale
     * @type number
     * @default 1
     */ /**
     * _Read only_. Updated during engine update.
     * 
     * A `Number` that records the last delta time value used to update this body.
     * Used to calculate speed and velocity.
     *
     * @readOnly
     * @property deltaTime
     * @type number
     * @default 1000 / 60
     */ /**
     * An `Object` that defines the rendering properties to be consumed by the module `Matter.Render`.
     *
     * @property render
     * @type object
     */ /**
     * A flag that indicates if the body should be rendered.
     *
     * @property render.visible
     * @type boolean
     * @default true
     */ /**
     * Sets the opacity to use when rendering.
     *
     * @property render.opacity
     * @type number
     * @default 1
    */ /**
     * An `Object` that defines the sprite properties to use when rendering, if any.
     *
     * @property render.sprite
     * @type object
     */ /**
     * An `String` that defines the path to the image to use as the sprite texture, if any.
     *
     * @property render.sprite.texture
     * @type string
     */ /**
     * A `Number` that defines the scaling in the x-axis for the sprite, if any.
     *
     * @property render.sprite.xScale
     * @type number
     * @default 1
     */ /**
     * A `Number` that defines the scaling in the y-axis for the sprite, if any.
     *
     * @property render.sprite.yScale
     * @type number
     * @default 1
     */ /**
      * A `Number` that defines the offset in the x-axis for the sprite (normalised by texture width).
      *
      * @property render.sprite.xOffset
      * @type number
      * @default 0
      */ /**
      * A `Number` that defines the offset in the y-axis for the sprite (normalised by texture height).
      *
      * @property render.sprite.yOffset
      * @type number
      * @default 0
      */ /**
     * A `Number` that defines the line width to use when rendering the body outline (if a sprite is not defined).
     * A value of `0` means no outline will be rendered.
     *
     * @property render.lineWidth
     * @type number
     * @default 0
     */ /**
     * A `String` that defines the fill style to use when rendering the body (if a sprite is not defined).
     * It is the same as when using a canvas, so it accepts CSS style property values.
     *
     * @property render.fillStyle
     * @type string
     * @default a random colour
     */ /**
     * A `String` that defines the stroke style to use when rendering the body outline (if a sprite is not defined).
     * It is the same as when using a canvas, so it accepts CSS style property values.
     *
     * @property render.strokeStyle
     * @type string
     * @default a random colour
     */ /**
     * _Read only_. Calculated automatically when vertices are set.
     * 
     * An array of unique axis vectors (edge normals) used for collision detection.
     * These are automatically calculated when vertices are set.
     * They are constantly updated by `Body.update` during the simulation.
     *
     * @readOnly
     * @property axes
     * @type vector[]
     */ /**
     * _Read only_. Calculated automatically when vertices are set.
     * 
     * A `Number` that measures the area of the body's convex hull.
     * 
     * @readOnly
     * @property area
     * @type string
     * @default 
     */ /**
     * A `Bounds` object that defines the AABB region for the body.
     * It is automatically calculated when vertices are set and constantly updated by `Body.update` during simulation.
     * 
     * @property bounds
     * @type bounds
     */ /**
     * Temporarily may hold parameters to be passed to `Vertices.chamfer` where supported by external functions.
     * 
     * See `Vertices.chamfer` for possible parameters this object may hold.
     * 
     * Currently only functions inside `Matter.Bodies` provide a utility using this property as a vertices pre-processing option.
     * 
     * Alternatively consider using `Vertices.chamfer` directly on vertices before passing them to a body creation function.
     * 
     * @property chamfer
     * @type object|null|undefined
     */ })();
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Events` module contains methods to fire and listen to events on other objects.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Events
*/ var Events = {};
            module1.exports = Events;
            var Common = __webpack_require__(0);
            (function() {
                /**
     * Subscribes a callback function to the given object's `eventName`.
     * @method on
     * @param {} object
     * @param {string} eventNames
     * @param {function} callback
     */ Events.on = function(object, eventNames, callback) {
                    var names = eventNames.split(" "), name;
                    for(var i = 0; i < names.length; i++){
                        name = names[i];
                        object.events = object.events || {};
                        object.events[name] = object.events[name] || [];
                        object.events[name].push(callback);
                    }
                    return callback;
                };
                /**
     * Removes the given event callback. If no callback, clears all callbacks in `eventNames`. If no `eventNames`, clears all events.
     * @method off
     * @param {} object
     * @param {string} eventNames
     * @param {function} callback
     */ Events.off = function(object, eventNames, callback) {
                    if (!eventNames) {
                        object.events = {};
                        return;
                    }
                    // handle Events.off(object, callback)
                    if (typeof eventNames === "function") {
                        callback = eventNames;
                        eventNames = Common.keys(object.events).join(" ");
                    }
                    var names = eventNames.split(" ");
                    for(var i = 0; i < names.length; i++){
                        var callbacks = object.events[names[i]], newCallbacks = [];
                        if (callback && callbacks) {
                            for(var j = 0; j < callbacks.length; j++)if (callbacks[j] !== callback) newCallbacks.push(callbacks[j]);
                        }
                        object.events[names[i]] = newCallbacks;
                    }
                };
                /**
     * Fires all the callbacks subscribed to the given object's `eventName`, in the order they subscribed, if any.
     * @method trigger
     * @param {} object
     * @param {string} eventNames
     * @param {} event
     */ Events.trigger = function(object, eventNames, event) {
                    var names, name, callbacks, eventClone;
                    var events = object.events;
                    if (events && Common.keys(events).length > 0) {
                        if (!event) event = {};
                        names = eventNames.split(" ");
                        for(var i = 0; i < names.length; i++){
                            name = names[i];
                            callbacks = events[name];
                            if (callbacks) {
                                eventClone = Common.clone(event, false);
                                eventClone.name = name;
                                eventClone.source = object;
                                for(var j = 0; j < callbacks.length; j++)callbacks[j].apply(object, [
                                    eventClone
                                ]);
                            }
                        }
                    }
                };
            })();
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* A composite is a collection of `Matter.Body`, `Matter.Constraint` and other `Matter.Composite` objects.
*
* They are a container that can represent complex objects made of multiple parts, even if they are not physically connected.
* A composite could contain anything from a single body all the way up to a whole world.
* 
* When making any changes to composites, use the included functions rather than changing their properties directly.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Composite
*/ var Composite = {};
            module1.exports = Composite;
            var Events = __webpack_require__(5);
            var Common = __webpack_require__(0);
            var Bounds = __webpack_require__(1);
            var Body = __webpack_require__(4);
            (function() {
                /**
     * Creates a new composite. The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properites section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @param {} [options]
     * @return {composite} A new composite
     */ Composite.create = function(options) {
                    return Common.extend({
                        id: Common.nextId(),
                        type: "composite",
                        parent: null,
                        isModified: false,
                        bodies: [],
                        constraints: [],
                        composites: [],
                        label: "Composite",
                        plugin: {},
                        cache: {
                            allBodies: null,
                            allConstraints: null,
                            allComposites: null
                        }
                    }, options);
                };
                /**
     * Sets the composite's `isModified` flag. 
     * If `updateParents` is true, all parents will be set (default: false).
     * If `updateChildren` is true, all children will be set (default: false).
     * @private
     * @method setModified
     * @param {composite} composite
     * @param {boolean} isModified
     * @param {boolean} [updateParents=false]
     * @param {boolean} [updateChildren=false]
     */ Composite.setModified = function(composite, isModified, updateParents, updateChildren) {
                    composite.isModified = isModified;
                    if (isModified && composite.cache) {
                        composite.cache.allBodies = null;
                        composite.cache.allConstraints = null;
                        composite.cache.allComposites = null;
                    }
                    if (updateParents && composite.parent) Composite.setModified(composite.parent, isModified, updateParents, updateChildren);
                    if (updateChildren) for(var i = 0; i < composite.composites.length; i++){
                        var childComposite = composite.composites[i];
                        Composite.setModified(childComposite, isModified, updateParents, updateChildren);
                    }
                };
                /**
     * Generic single or multi-add function. Adds a single or an array of body(s), constraint(s) or composite(s) to the given composite.
     * Triggers `beforeAdd` and `afterAdd` events on the `composite`.
     * @method add
     * @param {composite} composite
     * @param {object|array} object A single or an array of body(s), constraint(s) or composite(s)
     * @return {composite} The original composite with the objects added
     */ Composite.add = function(composite, object) {
                    var objects = [].concat(object);
                    Events.trigger(composite, "beforeAdd", {
                        object: object
                    });
                    for(var i = 0; i < objects.length; i++){
                        var obj = objects[i];
                        switch(obj.type){
                            case "body":
                                // skip adding compound parts
                                if (obj.parent !== obj) {
                                    Common.warn("Composite.add: skipped adding a compound body part (you must add its parent instead)");
                                    break;
                                }
                                Composite.addBody(composite, obj);
                                break;
                            case "constraint":
                                Composite.addConstraint(composite, obj);
                                break;
                            case "composite":
                                Composite.addComposite(composite, obj);
                                break;
                            case "mouseConstraint":
                                Composite.addConstraint(composite, obj.constraint);
                                break;
                        }
                    }
                    Events.trigger(composite, "afterAdd", {
                        object: object
                    });
                    return composite;
                };
                /**
     * Generic remove function. Removes one or many body(s), constraint(s) or a composite(s) to the given composite.
     * Optionally searching its children recursively.
     * Triggers `beforeRemove` and `afterRemove` events on the `composite`.
     * @method remove
     * @param {composite} composite
     * @param {object|array} object
     * @param {boolean} [deep=false]
     * @return {composite} The original composite with the objects removed
     */ Composite.remove = function(composite, object, deep) {
                    var objects = [].concat(object);
                    Events.trigger(composite, "beforeRemove", {
                        object: object
                    });
                    for(var i = 0; i < objects.length; i++){
                        var obj = objects[i];
                        switch(obj.type){
                            case "body":
                                Composite.removeBody(composite, obj, deep);
                                break;
                            case "constraint":
                                Composite.removeConstraint(composite, obj, deep);
                                break;
                            case "composite":
                                Composite.removeComposite(composite, obj, deep);
                                break;
                            case "mouseConstraint":
                                Composite.removeConstraint(composite, obj.constraint);
                                break;
                        }
                    }
                    Events.trigger(composite, "afterRemove", {
                        object: object
                    });
                    return composite;
                };
                /**
     * Adds a composite to the given composite.
     * @private
     * @method addComposite
     * @param {composite} compositeA
     * @param {composite} compositeB
     * @return {composite} The original compositeA with the objects from compositeB added
     */ Composite.addComposite = function(compositeA, compositeB) {
                    compositeA.composites.push(compositeB);
                    compositeB.parent = compositeA;
                    Composite.setModified(compositeA, true, true, false);
                    return compositeA;
                };
                /**
     * Removes a composite from the given composite, and optionally searching its children recursively.
     * @private
     * @method removeComposite
     * @param {composite} compositeA
     * @param {composite} compositeB
     * @param {boolean} [deep=false]
     * @return {composite} The original compositeA with the composite removed
     */ Composite.removeComposite = function(compositeA, compositeB, deep) {
                    var position = Common.indexOf(compositeA.composites, compositeB);
                    if (position !== -1) {
                        var bodies = Composite.allBodies(compositeB);
                        Composite.removeCompositeAt(compositeA, position);
                        for(var i = 0; i < bodies.length; i++)bodies[i].sleepCounter = 0;
                    }
                    if (deep) for(var i = 0; i < compositeA.composites.length; i++)Composite.removeComposite(compositeA.composites[i], compositeB, true);
                    return compositeA;
                };
                /**
     * Removes a composite from the given composite.
     * @private
     * @method removeCompositeAt
     * @param {composite} composite
     * @param {number} position
     * @return {composite} The original composite with the composite removed
     */ Composite.removeCompositeAt = function(composite, position) {
                    composite.composites.splice(position, 1);
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Adds a body to the given composite.
     * @private
     * @method addBody
     * @param {composite} composite
     * @param {body} body
     * @return {composite} The original composite with the body added
     */ Composite.addBody = function(composite, body) {
                    composite.bodies.push(body);
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Removes a body from the given composite, and optionally searching its children recursively.
     * @private
     * @method removeBody
     * @param {composite} composite
     * @param {body} body
     * @param {boolean} [deep=false]
     * @return {composite} The original composite with the body removed
     */ Composite.removeBody = function(composite, body, deep) {
                    var position = Common.indexOf(composite.bodies, body);
                    if (position !== -1) {
                        Composite.removeBodyAt(composite, position);
                        body.sleepCounter = 0;
                    }
                    if (deep) for(var i = 0; i < composite.composites.length; i++)Composite.removeBody(composite.composites[i], body, true);
                    return composite;
                };
                /**
     * Removes a body from the given composite.
     * @private
     * @method removeBodyAt
     * @param {composite} composite
     * @param {number} position
     * @return {composite} The original composite with the body removed
     */ Composite.removeBodyAt = function(composite, position) {
                    composite.bodies.splice(position, 1);
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Adds a constraint to the given composite.
     * @private
     * @method addConstraint
     * @param {composite} composite
     * @param {constraint} constraint
     * @return {composite} The original composite with the constraint added
     */ Composite.addConstraint = function(composite, constraint) {
                    composite.constraints.push(constraint);
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Removes a constraint from the given composite, and optionally searching its children recursively.
     * @private
     * @method removeConstraint
     * @param {composite} composite
     * @param {constraint} constraint
     * @param {boolean} [deep=false]
     * @return {composite} The original composite with the constraint removed
     */ Composite.removeConstraint = function(composite, constraint, deep) {
                    var position = Common.indexOf(composite.constraints, constraint);
                    if (position !== -1) Composite.removeConstraintAt(composite, position);
                    if (deep) for(var i = 0; i < composite.composites.length; i++)Composite.removeConstraint(composite.composites[i], constraint, true);
                    return composite;
                };
                /**
     * Removes a body from the given composite.
     * @private
     * @method removeConstraintAt
     * @param {composite} composite
     * @param {number} position
     * @return {composite} The original composite with the constraint removed
     */ Composite.removeConstraintAt = function(composite, position) {
                    composite.constraints.splice(position, 1);
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Removes all bodies, constraints and composites from the given composite.
     * Optionally clearing its children recursively.
     * @method clear
     * @param {composite} composite
     * @param {boolean} keepStatic
     * @param {boolean} [deep=false]
     */ Composite.clear = function(composite, keepStatic, deep) {
                    if (deep) for(var i = 0; i < composite.composites.length; i++)Composite.clear(composite.composites[i], keepStatic, true);
                    if (keepStatic) composite.bodies = composite.bodies.filter(function(body) {
                        return body.isStatic;
                    });
                    else composite.bodies.length = 0;
                    composite.constraints.length = 0;
                    composite.composites.length = 0;
                    Composite.setModified(composite, true, true, false);
                    return composite;
                };
                /**
     * Returns all bodies in the given composite, including all bodies in its children, recursively.
     * @method allBodies
     * @param {composite} composite
     * @return {body[]} All the bodies
     */ Composite.allBodies = function(composite) {
                    if (composite.cache && composite.cache.allBodies) return composite.cache.allBodies;
                    var bodies = [].concat(composite.bodies);
                    for(var i = 0; i < composite.composites.length; i++)bodies = bodies.concat(Composite.allBodies(composite.composites[i]));
                    if (composite.cache) composite.cache.allBodies = bodies;
                    return bodies;
                };
                /**
     * Returns all constraints in the given composite, including all constraints in its children, recursively.
     * @method allConstraints
     * @param {composite} composite
     * @return {constraint[]} All the constraints
     */ Composite.allConstraints = function(composite) {
                    if (composite.cache && composite.cache.allConstraints) return composite.cache.allConstraints;
                    var constraints = [].concat(composite.constraints);
                    for(var i = 0; i < composite.composites.length; i++)constraints = constraints.concat(Composite.allConstraints(composite.composites[i]));
                    if (composite.cache) composite.cache.allConstraints = constraints;
                    return constraints;
                };
                /**
     * Returns all composites in the given composite, including all composites in its children, recursively.
     * @method allComposites
     * @param {composite} composite
     * @return {composite[]} All the composites
     */ Composite.allComposites = function(composite) {
                    if (composite.cache && composite.cache.allComposites) return composite.cache.allComposites;
                    var composites = [].concat(composite.composites);
                    for(var i = 0; i < composite.composites.length; i++)composites = composites.concat(Composite.allComposites(composite.composites[i]));
                    if (composite.cache) composite.cache.allComposites = composites;
                    return composites;
                };
                /**
     * Searches the composite recursively for an object matching the type and id supplied, null if not found.
     * @method get
     * @param {composite} composite
     * @param {number} id
     * @param {string} type
     * @return {object} The requested object, if found
     */ Composite.get = function(composite, id, type) {
                    var objects, object;
                    switch(type){
                        case "body":
                            objects = Composite.allBodies(composite);
                            break;
                        case "constraint":
                            objects = Composite.allConstraints(composite);
                            break;
                        case "composite":
                            objects = Composite.allComposites(composite).concat(composite);
                            break;
                    }
                    if (!objects) return null;
                    object = objects.filter(function(object) {
                        return object.id.toString() === id.toString();
                    });
                    return object.length === 0 ? null : object[0];
                };
                /**
     * Moves the given object(s) from compositeA to compositeB (equal to a remove followed by an add).
     * @method move
     * @param {compositeA} compositeA
     * @param {object[]} objects
     * @param {compositeB} compositeB
     * @return {composite} Returns compositeA
     */ Composite.move = function(compositeA, objects, compositeB) {
                    Composite.remove(compositeA, objects);
                    Composite.add(compositeB, objects);
                    return compositeA;
                };
                /**
     * Assigns new ids for all objects in the composite, recursively.
     * @method rebase
     * @param {composite} composite
     * @return {composite} Returns composite
     */ Composite.rebase = function(composite) {
                    var objects = Composite.allBodies(composite).concat(Composite.allConstraints(composite)).concat(Composite.allComposites(composite));
                    for(var i = 0; i < objects.length; i++)objects[i].id = Common.nextId();
                    return composite;
                };
                /**
     * Translates all children in the composite by a given vector relative to their current positions, 
     * without imparting any velocity.
     * @method translate
     * @param {composite} composite
     * @param {vector} translation
     * @param {bool} [recursive=true]
     */ Composite.translate = function(composite, translation, recursive) {
                    var bodies = recursive ? Composite.allBodies(composite) : composite.bodies;
                    for(var i = 0; i < bodies.length; i++)Body.translate(bodies[i], translation);
                    return composite;
                };
                /**
     * Rotates all children in the composite by a given angle about the given point, without imparting any angular velocity.
     * @method rotate
     * @param {composite} composite
     * @param {number} rotation
     * @param {vector} point
     * @param {bool} [recursive=true]
     */ Composite.rotate = function(composite, rotation, point, recursive) {
                    var cos = Math.cos(rotation), sin = Math.sin(rotation), bodies = recursive ? Composite.allBodies(composite) : composite.bodies;
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i], dx = body.position.x - point.x, dy = body.position.y - point.y;
                        Body.setPosition(body, {
                            x: point.x + (dx * cos - dy * sin),
                            y: point.y + (dx * sin + dy * cos)
                        });
                        Body.rotate(body, rotation);
                    }
                    return composite;
                };
                /**
     * Scales all children in the composite, including updating physical properties (mass, area, axes, inertia), from a world-space point.
     * @method scale
     * @param {composite} composite
     * @param {number} scaleX
     * @param {number} scaleY
     * @param {vector} point
     * @param {bool} [recursive=true]
     */ Composite.scale = function(composite, scaleX, scaleY, point, recursive) {
                    var bodies = recursive ? Composite.allBodies(composite) : composite.bodies;
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i], dx = body.position.x - point.x, dy = body.position.y - point.y;
                        Body.setPosition(body, {
                            x: point.x + dx * scaleX,
                            y: point.y + dy * scaleY
                        });
                        Body.scale(body, scaleX, scaleY);
                    }
                    return composite;
                };
                /**
     * Returns the union of the bounds of all of the composite's bodies.
     * @method bounds
     * @param {composite} composite The composite.
     * @returns {bounds} The composite bounds.
     */ Composite.bounds = function(composite) {
                    var bodies = Composite.allBodies(composite), vertices = [];
                    for(var i = 0; i < bodies.length; i += 1){
                        var body = bodies[i];
                        vertices.push(body.bounds.min, body.bounds.max);
                    }
                    return Bounds.create(vertices);
                };
            /*
    *
    *  Events Documentation
    *
    */ /**
    * Fired when a call to `Composite.add` is made, before objects have been added.
    *
    * @event beforeAdd
    * @param {} event An event object
    * @param {} event.object The object(s) to be added (may be a single body, constraint, composite or a mixed array of these)
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when a call to `Composite.add` is made, after objects have been added.
    *
    * @event afterAdd
    * @param {} event An event object
    * @param {} event.object The object(s) that have been added (may be a single body, constraint, composite or a mixed array of these)
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when a call to `Composite.remove` is made, before objects have been removed.
    *
    * @event beforeRemove
    * @param {} event An event object
    * @param {} event.object The object(s) to be removed (may be a single body, constraint, composite or a mixed array of these)
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when a call to `Composite.remove` is made, after objects have been removed.
    *
    * @event afterRemove
    * @param {} event An event object
    * @param {} event.object The object(s) that have been removed (may be a single body, constraint, composite or a mixed array of these)
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /*
    *
    *  Properties Documentation
    *
    */ /**
     * An integer `Number` uniquely identifying number generated in `Composite.create` by `Common.nextId`.
     *
     * @property id
     * @type number
     */ /**
     * A `String` denoting the type of object.
     *
     * @property type
     * @type string
     * @default "composite"
     * @readOnly
     */ /**
     * An arbitrary `String` name to help the user identify and manage composites.
     *
     * @property label
     * @type string
     * @default "Composite"
     */ /**
     * A flag that specifies whether the composite has been modified during the current step.
     * This is automatically managed when bodies, constraints or composites are added or removed.
     *
     * @property isModified
     * @type boolean
     * @default false
     */ /**
     * The `Composite` that is the parent of this composite. It is automatically managed by the `Matter.Composite` methods.
     *
     * @property parent
     * @type composite
     * @default null
     */ /**
     * An array of `Body` that are _direct_ children of this composite.
     * To add or remove bodies you should use `Composite.add` and `Composite.remove` methods rather than directly modifying this property.
     * If you wish to recursively find all descendants, you should use the `Composite.allBodies` method.
     *
     * @property bodies
     * @type body[]
     * @default []
     */ /**
     * An array of `Constraint` that are _direct_ children of this composite.
     * To add or remove constraints you should use `Composite.add` and `Composite.remove` methods rather than directly modifying this property.
     * If you wish to recursively find all descendants, you should use the `Composite.allConstraints` method.
     *
     * @property constraints
     * @type constraint[]
     * @default []
     */ /**
     * An array of `Composite` that are _direct_ children of this composite.
     * To add or remove composites you should use `Composite.add` and `Composite.remove` methods rather than directly modifying this property.
     * If you wish to recursively find all descendants, you should use the `Composite.allComposites` method.
     *
     * @property composites
     * @type composite[]
     * @default []
     */ /**
     * An object reserved for storing plugin-specific properties.
     *
     * @property plugin
     * @type {}
     */ /**
     * An object used for storing cached results for performance reasons.
     * This is used internally only and is automatically managed.
     *
     * @private
     * @property cache
     * @type {}
     */ })();
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Sleeping` module contains methods to manage the sleeping state of bodies.
*
* @class Sleeping
*/ var Sleeping = {};
            module1.exports = Sleeping;
            var Body = __webpack_require__(4);
            var Events = __webpack_require__(5);
            var Common = __webpack_require__(0);
            (function() {
                Sleeping._motionWakeThreshold = 0.18;
                Sleeping._motionSleepThreshold = 0.08;
                Sleeping._minBias = 0.9;
                /**
     * Puts bodies to sleep or wakes them up depending on their motion.
     * @method update
     * @param {body[]} bodies
     * @param {number} delta
     */ Sleeping.update = function(bodies, delta) {
                    var timeScale = delta / Common._baseDelta, motionSleepThreshold = Sleeping._motionSleepThreshold;
                    // update bodies sleeping status
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i], speed = Body.getSpeed(body), angularSpeed = Body.getAngularSpeed(body), motion = speed * speed + angularSpeed * angularSpeed;
                        // wake up bodies if they have a force applied
                        if (body.force.x !== 0 || body.force.y !== 0) {
                            Sleeping.set(body, false);
                            continue;
                        }
                        var minMotion = Math.min(body.motion, motion), maxMotion = Math.max(body.motion, motion);
                        // biased average motion estimation between frames
                        body.motion = Sleeping._minBias * minMotion + (1 - Sleeping._minBias) * maxMotion;
                        if (body.sleepThreshold > 0 && body.motion < motionSleepThreshold) {
                            body.sleepCounter += 1;
                            if (body.sleepCounter >= body.sleepThreshold / timeScale) Sleeping.set(body, true);
                        } else if (body.sleepCounter > 0) body.sleepCounter -= 1;
                    }
                };
                /**
     * Given a set of colliding pairs, wakes the sleeping bodies involved.
     * @method afterCollisions
     * @param {pair[]} pairs
     */ Sleeping.afterCollisions = function(pairs) {
                    var motionSleepThreshold = Sleeping._motionSleepThreshold;
                    // wake up bodies involved in collisions
                    for(var i = 0; i < pairs.length; i++){
                        var pair = pairs[i];
                        // don't wake inactive pairs
                        if (!pair.isActive) continue;
                        var collision = pair.collision, bodyA = collision.bodyA.parent, bodyB = collision.bodyB.parent;
                        // don't wake if at least one body is static
                        if (bodyA.isSleeping && bodyB.isSleeping || bodyA.isStatic || bodyB.isStatic) continue;
                        if (bodyA.isSleeping || bodyB.isSleeping) {
                            var sleepingBody = bodyA.isSleeping && !bodyA.isStatic ? bodyA : bodyB, movingBody = sleepingBody === bodyA ? bodyB : bodyA;
                            if (!sleepingBody.isStatic && movingBody.motion > motionSleepThreshold) Sleeping.set(sleepingBody, false);
                        }
                    }
                };
                /**
     * Set a body as sleeping or awake.
     * @method set
     * @param {body} body
     * @param {boolean} isSleeping
     */ Sleeping.set = function(body, isSleeping) {
                    var wasSleeping = body.isSleeping;
                    if (isSleeping) {
                        body.isSleeping = true;
                        body.sleepCounter = body.sleepThreshold;
                        body.positionImpulse.x = 0;
                        body.positionImpulse.y = 0;
                        body.positionPrev.x = body.position.x;
                        body.positionPrev.y = body.position.y;
                        body.anglePrev = body.angle;
                        body.speed = 0;
                        body.angularSpeed = 0;
                        body.motion = 0;
                        if (!wasSleeping) Events.trigger(body, "sleepStart");
                    } else {
                        body.isSleeping = false;
                        body.sleepCounter = 0;
                        if (wasSleeping) Events.trigger(body, "sleepEnd");
                    }
                };
            })();
        /***/ },
        /* 8 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Collision` module contains methods for detecting collisions between a given pair of bodies.
*
* For efficient detection between a list of bodies, see `Matter.Detector` and `Matter.Query`.
*
* See `Matter.Engine` for collision events.
*
* @class Collision
*/ var Collision = {};
            module1.exports = Collision;
            var Vertices = __webpack_require__(3);
            var Pair = __webpack_require__(9);
            (function() {
                var _supports = [];
                var _overlapAB = {
                    overlap: 0,
                    axis: null
                };
                var _overlapBA = {
                    overlap: 0,
                    axis: null
                };
                /**
     * Creates a new collision record.
     * @method create
     * @param {body} bodyA The first body part represented by the collision record
     * @param {body} bodyB The second body part represented by the collision record
     * @return {collision} A new collision record
     */ Collision.create = function(bodyA, bodyB) {
                    return {
                        pair: null,
                        collided: false,
                        bodyA: bodyA,
                        bodyB: bodyB,
                        parentA: bodyA.parent,
                        parentB: bodyB.parent,
                        depth: 0,
                        normal: {
                            x: 0,
                            y: 0
                        },
                        tangent: {
                            x: 0,
                            y: 0
                        },
                        penetration: {
                            x: 0,
                            y: 0
                        },
                        supports: [
                            null,
                            null
                        ],
                        supportCount: 0
                    };
                };
                /**
     * Detect collision between two bodies.
     * @method collides
     * @param {body} bodyA
     * @param {body} bodyB
     * @param {pairs} [pairs] Optionally reuse collision records from existing pairs.
     * @return {collision|null} A collision record if detected, otherwise null
     */ Collision.collides = function(bodyA, bodyB, pairs) {
                    Collision._overlapAxes(_overlapAB, bodyA.vertices, bodyB.vertices, bodyA.axes);
                    if (_overlapAB.overlap <= 0) return null;
                    Collision._overlapAxes(_overlapBA, bodyB.vertices, bodyA.vertices, bodyB.axes);
                    if (_overlapBA.overlap <= 0) return null;
                    // reuse collision records for gc efficiency
                    var pair = pairs && pairs.table[Pair.id(bodyA, bodyB)], collision;
                    if (!pair) {
                        collision = Collision.create(bodyA, bodyB);
                        collision.collided = true;
                        collision.bodyA = bodyA.id < bodyB.id ? bodyA : bodyB;
                        collision.bodyB = bodyA.id < bodyB.id ? bodyB : bodyA;
                        collision.parentA = collision.bodyA.parent;
                        collision.parentB = collision.bodyB.parent;
                    } else collision = pair.collision;
                    bodyA = collision.bodyA;
                    bodyB = collision.bodyB;
                    var minOverlap;
                    if (_overlapAB.overlap < _overlapBA.overlap) minOverlap = _overlapAB;
                    else minOverlap = _overlapBA;
                    var normal = collision.normal, tangent = collision.tangent, penetration = collision.penetration, supports = collision.supports, depth = minOverlap.overlap, minAxis = minOverlap.axis, normalX = minAxis.x, normalY = minAxis.y, deltaX = bodyB.position.x - bodyA.position.x, deltaY = bodyB.position.y - bodyA.position.y;
                    // ensure normal is facing away from bodyA
                    if (normalX * deltaX + normalY * deltaY >= 0) {
                        normalX = -normalX;
                        normalY = -normalY;
                    }
                    normal.x = normalX;
                    normal.y = normalY;
                    tangent.x = -normalY;
                    tangent.y = normalX;
                    penetration.x = normalX * depth;
                    penetration.y = normalY * depth;
                    collision.depth = depth;
                    // find support points, there is always either exactly one or two
                    var supportsB = Collision._findSupports(bodyA, bodyB, normal, 1), supportCount = 0;
                    // find the supports from bodyB that are inside bodyA
                    if (Vertices.contains(bodyA.vertices, supportsB[0])) supports[supportCount++] = supportsB[0];
                    if (Vertices.contains(bodyA.vertices, supportsB[1])) supports[supportCount++] = supportsB[1];
                    // find the supports from bodyA that are inside bodyB
                    if (supportCount < 2) {
                        var supportsA = Collision._findSupports(bodyB, bodyA, normal, -1);
                        if (Vertices.contains(bodyB.vertices, supportsA[0])) supports[supportCount++] = supportsA[0];
                        if (supportCount < 2 && Vertices.contains(bodyB.vertices, supportsA[1])) supports[supportCount++] = supportsA[1];
                    }
                    // account for the edge case of overlapping but no vertex containment
                    if (supportCount === 0) supports[supportCount++] = supportsB[0];
                    // update support count
                    collision.supportCount = supportCount;
                    return collision;
                };
                /**
     * Find the overlap between two sets of vertices.
     * @method _overlapAxes
     * @private
     * @param {object} result
     * @param {vertices} verticesA
     * @param {vertices} verticesB
     * @param {axes} axes
     */ Collision._overlapAxes = function(result, verticesA, verticesB, axes) {
                    var verticesALength = verticesA.length, verticesBLength = verticesB.length, verticesAX = verticesA[0].x, verticesAY = verticesA[0].y, verticesBX = verticesB[0].x, verticesBY = verticesB[0].y, axesLength = axes.length, overlapMin = Number.MAX_VALUE, overlapAxisNumber = 0, overlap, overlapAB, overlapBA, dot, i, j;
                    for(i = 0; i < axesLength; i++){
                        var axis = axes[i], axisX = axis.x, axisY = axis.y, minA = verticesAX * axisX + verticesAY * axisY, minB = verticesBX * axisX + verticesBY * axisY, maxA = minA, maxB = minB;
                        for(j = 1; j < verticesALength; j += 1){
                            dot = verticesA[j].x * axisX + verticesA[j].y * axisY;
                            if (dot > maxA) maxA = dot;
                            else if (dot < minA) minA = dot;
                        }
                        for(j = 1; j < verticesBLength; j += 1){
                            dot = verticesB[j].x * axisX + verticesB[j].y * axisY;
                            if (dot > maxB) maxB = dot;
                            else if (dot < minB) minB = dot;
                        }
                        overlapAB = maxA - minB;
                        overlapBA = maxB - minA;
                        overlap = overlapAB < overlapBA ? overlapAB : overlapBA;
                        if (overlap < overlapMin) {
                            overlapMin = overlap;
                            overlapAxisNumber = i;
                            if (overlap <= 0) break;
                        }
                    }
                    result.axis = axes[overlapAxisNumber];
                    result.overlap = overlapMin;
                };
                /**
     * Finds supporting vertices given two bodies along a given direction using hill-climbing.
     * @method _findSupports
     * @private
     * @param {body} bodyA
     * @param {body} bodyB
     * @param {vector} normal
     * @param {number} direction
     * @return [vector]
     */ Collision._findSupports = function(bodyA, bodyB, normal, direction) {
                    var vertices = bodyB.vertices, verticesLength = vertices.length, bodyAPositionX = bodyA.position.x, bodyAPositionY = bodyA.position.y, normalX = normal.x * direction, normalY = normal.y * direction, vertexA = vertices[0], vertexB = vertexA, nearestDistance = normalX * (bodyAPositionX - vertexB.x) + normalY * (bodyAPositionY - vertexB.y), vertexC, distance, j;
                    // find deepest vertex relative to the axis
                    for(j = 1; j < verticesLength; j += 1){
                        vertexB = vertices[j];
                        distance = normalX * (bodyAPositionX - vertexB.x) + normalY * (bodyAPositionY - vertexB.y);
                        // convex hill-climbing
                        if (distance < nearestDistance) {
                            nearestDistance = distance;
                            vertexA = vertexB;
                        }
                    }
                    // measure next vertex
                    vertexC = vertices[(verticesLength + vertexA.index - 1) % verticesLength];
                    nearestDistance = normalX * (bodyAPositionX - vertexC.x) + normalY * (bodyAPositionY - vertexC.y);
                    // compare with previous vertex
                    vertexB = vertices[(vertexA.index + 1) % verticesLength];
                    if (normalX * (bodyAPositionX - vertexB.x) + normalY * (bodyAPositionY - vertexB.y) < nearestDistance) {
                        _supports[0] = vertexA;
                        _supports[1] = vertexB;
                        return _supports;
                    }
                    _supports[0] = vertexA;
                    _supports[1] = vertexC;
                    return _supports;
                };
            /*
    *
    *  Properties Documentation
    *
    */ /**
     * A reference to the pair using this collision record, if there is one.
     *
     * @property pair
     * @type {pair|null}
     * @default null
     */ /**
     * A flag that indicates if the bodies were colliding when the collision was last updated.
     * 
     * @property collided
     * @type boolean
     * @default false
     */ /**
     * The first body part represented by the collision (see also `collision.parentA`).
     * 
     * @property bodyA
     * @type body
     */ /**
     * The second body part represented by the collision (see also `collision.parentB`).
     * 
     * @property bodyB
     * @type body
     */ /**
     * The first body represented by the collision (i.e. `collision.bodyA.parent`).
     * 
     * @property parentA
     * @type body
     */ /**
     * The second body represented by the collision (i.e. `collision.bodyB.parent`).
     * 
     * @property parentB
     * @type body
     */ /**
     * A `Number` that represents the minimum separating distance between the bodies along the collision normal.
     *
     * @readOnly
     * @property depth
     * @type number
     * @default 0
     */ /**
     * A normalised `Vector` that represents the direction between the bodies that provides the minimum separating distance.
     *
     * @property normal
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A normalised `Vector` that is the tangent direction to the collision normal.
     *
     * @property tangent
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Vector` that represents the direction and depth of the collision.
     *
     * @property penetration
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * An array of body vertices that represent the support points in the collision.
     * 
     * _Note:_ Only the first `collision.supportCount` items of `collision.supports` are active.
     * Therefore use `collision.supportCount` instead of `collision.supports.length` when iterating the active supports.
     * 
     * These are the deepest vertices (along the collision normal) of each body that are contained by the other body's vertices.
     *
     * @property supports
     * @type vector[]
     * @default []
     */ /**
     * The number of active supports for this collision found in `collision.supports`.
     * 
     * _Note:_ Only the first `collision.supportCount` items of `collision.supports` are active.
     * Therefore use `collision.supportCount` instead of `collision.supports.length` when iterating the active supports.
     *
     * @property supportCount
     * @type number
     * @default 0
     */ })();
        /***/ },
        /* 9 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Pair` module contains methods for creating and manipulating collision pairs.
*
* @class Pair
*/ var Pair = {};
            module1.exports = Pair;
            var Contact = __webpack_require__(16);
            (function() {
                /**
     * Creates a pair.
     * @method create
     * @param {collision} collision
     * @param {number} timestamp
     * @return {pair} A new pair
     */ Pair.create = function(collision, timestamp) {
                    var bodyA = collision.bodyA, bodyB = collision.bodyB;
                    var pair = {
                        id: Pair.id(bodyA, bodyB),
                        bodyA: bodyA,
                        bodyB: bodyB,
                        collision: collision,
                        contacts: [
                            Contact.create(),
                            Contact.create()
                        ],
                        contactCount: 0,
                        separation: 0,
                        isActive: true,
                        isSensor: bodyA.isSensor || bodyB.isSensor,
                        timeCreated: timestamp,
                        timeUpdated: timestamp,
                        inverseMass: 0,
                        friction: 0,
                        frictionStatic: 0,
                        restitution: 0,
                        slop: 0
                    };
                    Pair.update(pair, collision, timestamp);
                    return pair;
                };
                /**
     * Updates a pair given a collision.
     * @method update
     * @param {pair} pair
     * @param {collision} collision
     * @param {number} timestamp
     */ Pair.update = function(pair, collision, timestamp) {
                    var supports = collision.supports, supportCount = collision.supportCount, contacts = pair.contacts, parentA = collision.parentA, parentB = collision.parentB;
                    pair.isActive = true;
                    pair.timeUpdated = timestamp;
                    pair.collision = collision;
                    pair.separation = collision.depth;
                    pair.inverseMass = parentA.inverseMass + parentB.inverseMass;
                    pair.friction = parentA.friction < parentB.friction ? parentA.friction : parentB.friction;
                    pair.frictionStatic = parentA.frictionStatic > parentB.frictionStatic ? parentA.frictionStatic : parentB.frictionStatic;
                    pair.restitution = parentA.restitution > parentB.restitution ? parentA.restitution : parentB.restitution;
                    pair.slop = parentA.slop > parentB.slop ? parentA.slop : parentB.slop;
                    pair.contactCount = supportCount;
                    collision.pair = pair;
                    var supportA = supports[0], contactA = contacts[0], supportB = supports[1], contactB = contacts[1];
                    // match contacts to supports
                    if (contactB.vertex === supportA || contactA.vertex === supportB) {
                        contacts[1] = contactA;
                        contacts[0] = contactA = contactB;
                        contactB = contacts[1];
                    }
                    // update contacts
                    contactA.vertex = supportA;
                    contactB.vertex = supportB;
                };
                /**
     * Set a pair as active or inactive.
     * @method setActive
     * @param {pair} pair
     * @param {bool} isActive
     * @param {number} timestamp
     */ Pair.setActive = function(pair, isActive, timestamp) {
                    if (isActive) {
                        pair.isActive = true;
                        pair.timeUpdated = timestamp;
                    } else {
                        pair.isActive = false;
                        pair.contactCount = 0;
                    }
                };
                /**
     * Get the id for the given pair.
     * @method id
     * @param {body} bodyA
     * @param {body} bodyB
     * @return {string} Unique pairId
     */ Pair.id = function(bodyA, bodyB) {
                    return bodyA.id < bodyB.id ? bodyA.id.toString(36) + ":" + bodyB.id.toString(36) : bodyB.id.toString(36) + ":" + bodyA.id.toString(36);
                };
            })();
        /***/ },
        /* 10 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Constraint` module contains methods for creating and manipulating constraints.
* Constraints are used for specifying that a fixed distance must be maintained between two bodies (or a body and a fixed world-space position).
* The stiffness of constraints can be modified to create springs or elastic.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Constraint
*/ var Constraint = {};
            module1.exports = Constraint;
            var Vertices = __webpack_require__(3);
            var Vector = __webpack_require__(2);
            var Sleeping = __webpack_require__(7);
            var Bounds = __webpack_require__(1);
            var Axes = __webpack_require__(11);
            var Common = __webpack_require__(0);
            (function() {
                Constraint._warming = 0.4;
                Constraint._torqueDampen = 1;
                Constraint._minLength = 0.000001;
                /**
     * Creates a new constraint.
     * All properties have default values, and many are pre-calculated automatically based on other properties.
     * To simulate a revolute constraint (or pin joint) set `length: 0` and a high `stiffness` value (e.g. `0.7` or above).
     * If the constraint is unstable, try lowering the `stiffness` value and / or increasing `engine.constraintIterations`.
     * For compound bodies, constraints must be applied to the parent body (not one of its parts).
     * See the properties section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @param {} options
     * @return {constraint} constraint
     */ Constraint.create = function(options) {
                    var constraint = options;
                    // if bodies defined but no points, use body centre
                    if (constraint.bodyA && !constraint.pointA) constraint.pointA = {
                        x: 0,
                        y: 0
                    };
                    if (constraint.bodyB && !constraint.pointB) constraint.pointB = {
                        x: 0,
                        y: 0
                    };
                    // calculate static length using initial world space points
                    var initialPointA = constraint.bodyA ? Vector.add(constraint.bodyA.position, constraint.pointA) : constraint.pointA, initialPointB = constraint.bodyB ? Vector.add(constraint.bodyB.position, constraint.pointB) : constraint.pointB, length = Vector.magnitude(Vector.sub(initialPointA, initialPointB));
                    constraint.length = typeof constraint.length !== "undefined" ? constraint.length : length;
                    // option defaults
                    constraint.id = constraint.id || Common.nextId();
                    constraint.label = constraint.label || "Constraint";
                    constraint.type = "constraint";
                    constraint.stiffness = constraint.stiffness || (constraint.length > 0 ? 1 : 0.7);
                    constraint.damping = constraint.damping || 0;
                    constraint.angularStiffness = constraint.angularStiffness || 0;
                    constraint.angleA = constraint.bodyA ? constraint.bodyA.angle : constraint.angleA;
                    constraint.angleB = constraint.bodyB ? constraint.bodyB.angle : constraint.angleB;
                    constraint.plugin = {};
                    // render
                    var render = {
                        visible: true,
                        lineWidth: 2,
                        strokeStyle: "#ffffff",
                        type: "line",
                        anchors: true
                    };
                    if (constraint.length === 0 && constraint.stiffness > 0.1) {
                        render.type = "pin";
                        render.anchors = false;
                    } else if (constraint.stiffness < 0.9) render.type = "spring";
                    constraint.render = Common.extend(render, constraint.render);
                    return constraint;
                };
                /**
     * Prepares for solving by constraint warming.
     * @private
     * @method preSolveAll
     * @param {body[]} bodies
     */ Constraint.preSolveAll = function(bodies) {
                    for(var i = 0; i < bodies.length; i += 1){
                        var body = bodies[i], impulse = body.constraintImpulse;
                        if (body.isStatic || impulse.x === 0 && impulse.y === 0 && impulse.angle === 0) continue;
                        body.position.x += impulse.x;
                        body.position.y += impulse.y;
                        body.angle += impulse.angle;
                    }
                };
                /**
     * Solves all constraints in a list of collisions.
     * @private
     * @method solveAll
     * @param {constraint[]} constraints
     * @param {number} delta
     */ Constraint.solveAll = function(constraints, delta) {
                    var timeScale = Common.clamp(delta / Common._baseDelta, 0, 1);
                    // Solve fixed constraints first.
                    for(var i = 0; i < constraints.length; i += 1){
                        var constraint = constraints[i], fixedA = !constraint.bodyA || constraint.bodyA && constraint.bodyA.isStatic, fixedB = !constraint.bodyB || constraint.bodyB && constraint.bodyB.isStatic;
                        if (fixedA || fixedB) Constraint.solve(constraints[i], timeScale);
                    }
                    // Solve free constraints last.
                    for(i = 0; i < constraints.length; i += 1){
                        constraint = constraints[i];
                        fixedA = !constraint.bodyA || constraint.bodyA && constraint.bodyA.isStatic;
                        fixedB = !constraint.bodyB || constraint.bodyB && constraint.bodyB.isStatic;
                        if (!fixedA && !fixedB) Constraint.solve(constraints[i], timeScale);
                    }
                };
                /**
     * Solves a distance constraint with Gauss-Siedel method.
     * @private
     * @method solve
     * @param {constraint} constraint
     * @param {number} timeScale
     */ Constraint.solve = function(constraint, timeScale) {
                    var bodyA = constraint.bodyA, bodyB = constraint.bodyB, pointA = constraint.pointA, pointB = constraint.pointB;
                    if (!bodyA && !bodyB) return;
                    // update reference angle
                    if (bodyA && !bodyA.isStatic) {
                        Vector.rotate(pointA, bodyA.angle - constraint.angleA, pointA);
                        constraint.angleA = bodyA.angle;
                    }
                    // update reference angle
                    if (bodyB && !bodyB.isStatic) {
                        Vector.rotate(pointB, bodyB.angle - constraint.angleB, pointB);
                        constraint.angleB = bodyB.angle;
                    }
                    var pointAWorld = pointA, pointBWorld = pointB;
                    if (bodyA) pointAWorld = Vector.add(bodyA.position, pointA);
                    if (bodyB) pointBWorld = Vector.add(bodyB.position, pointB);
                    if (!pointAWorld || !pointBWorld) return;
                    var delta = Vector.sub(pointAWorld, pointBWorld), currentLength = Vector.magnitude(delta);
                    // prevent singularity
                    if (currentLength < Constraint._minLength) currentLength = Constraint._minLength;
                    // solve distance constraint with Gauss-Siedel method
                    var difference = (currentLength - constraint.length) / currentLength, isRigid = constraint.stiffness >= 1 || constraint.length === 0, stiffness = isRigid ? constraint.stiffness * timeScale : constraint.stiffness * timeScale * timeScale, damping = constraint.damping * timeScale, force = Vector.mult(delta, difference * stiffness), massTotal = (bodyA ? bodyA.inverseMass : 0) + (bodyB ? bodyB.inverseMass : 0), inertiaTotal = (bodyA ? bodyA.inverseInertia : 0) + (bodyB ? bodyB.inverseInertia : 0), resistanceTotal = massTotal + inertiaTotal, torque, share, normal, normalVelocity, relativeVelocity;
                    if (damping > 0) {
                        var zero = Vector.create();
                        normal = Vector.div(delta, currentLength);
                        relativeVelocity = Vector.sub(bodyB && Vector.sub(bodyB.position, bodyB.positionPrev) || zero, bodyA && Vector.sub(bodyA.position, bodyA.positionPrev) || zero);
                        normalVelocity = Vector.dot(normal, relativeVelocity);
                    }
                    if (bodyA && !bodyA.isStatic) {
                        share = bodyA.inverseMass / massTotal;
                        // keep track of applied impulses for post solving
                        bodyA.constraintImpulse.x -= force.x * share;
                        bodyA.constraintImpulse.y -= force.y * share;
                        // apply forces
                        bodyA.position.x -= force.x * share;
                        bodyA.position.y -= force.y * share;
                        // apply damping
                        if (damping > 0) {
                            bodyA.positionPrev.x -= damping * normal.x * normalVelocity * share;
                            bodyA.positionPrev.y -= damping * normal.y * normalVelocity * share;
                        }
                        // apply torque
                        torque = Vector.cross(pointA, force) / resistanceTotal * Constraint._torqueDampen * bodyA.inverseInertia * (1 - constraint.angularStiffness);
                        bodyA.constraintImpulse.angle -= torque;
                        bodyA.angle -= torque;
                    }
                    if (bodyB && !bodyB.isStatic) {
                        share = bodyB.inverseMass / massTotal;
                        // keep track of applied impulses for post solving
                        bodyB.constraintImpulse.x += force.x * share;
                        bodyB.constraintImpulse.y += force.y * share;
                        // apply forces
                        bodyB.position.x += force.x * share;
                        bodyB.position.y += force.y * share;
                        // apply damping
                        if (damping > 0) {
                            bodyB.positionPrev.x += damping * normal.x * normalVelocity * share;
                            bodyB.positionPrev.y += damping * normal.y * normalVelocity * share;
                        }
                        // apply torque
                        torque = Vector.cross(pointB, force) / resistanceTotal * Constraint._torqueDampen * bodyB.inverseInertia * (1 - constraint.angularStiffness);
                        bodyB.constraintImpulse.angle += torque;
                        bodyB.angle += torque;
                    }
                };
                /**
     * Performs body updates required after solving constraints.
     * @private
     * @method postSolveAll
     * @param {body[]} bodies
     */ Constraint.postSolveAll = function(bodies) {
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i], impulse = body.constraintImpulse;
                        if (body.isStatic || impulse.x === 0 && impulse.y === 0 && impulse.angle === 0) continue;
                        Sleeping.set(body, false);
                        // update geometry and reset
                        for(var j = 0; j < body.parts.length; j++){
                            var part = body.parts[j];
                            Vertices.translate(part.vertices, impulse);
                            if (j > 0) {
                                part.position.x += impulse.x;
                                part.position.y += impulse.y;
                            }
                            if (impulse.angle !== 0) {
                                Vertices.rotate(part.vertices, impulse.angle, body.position);
                                Axes.rotate(part.axes, impulse.angle);
                                if (j > 0) Vector.rotateAbout(part.position, impulse.angle, body.position, part.position);
                            }
                            Bounds.update(part.bounds, part.vertices, body.velocity);
                        }
                        // dampen the cached impulse for warming next step
                        impulse.angle *= Constraint._warming;
                        impulse.x *= Constraint._warming;
                        impulse.y *= Constraint._warming;
                    }
                };
                /**
     * Returns the world-space position of `constraint.pointA`, accounting for `constraint.bodyA`.
     * @method pointAWorld
     * @param {constraint} constraint
     * @returns {vector} the world-space position
     */ Constraint.pointAWorld = function(constraint) {
                    return {
                        x: (constraint.bodyA ? constraint.bodyA.position.x : 0) + (constraint.pointA ? constraint.pointA.x : 0),
                        y: (constraint.bodyA ? constraint.bodyA.position.y : 0) + (constraint.pointA ? constraint.pointA.y : 0)
                    };
                };
                /**
     * Returns the world-space position of `constraint.pointB`, accounting for `constraint.bodyB`.
     * @method pointBWorld
     * @param {constraint} constraint
     * @returns {vector} the world-space position
     */ Constraint.pointBWorld = function(constraint) {
                    return {
                        x: (constraint.bodyB ? constraint.bodyB.position.x : 0) + (constraint.pointB ? constraint.pointB.x : 0),
                        y: (constraint.bodyB ? constraint.bodyB.position.y : 0) + (constraint.pointB ? constraint.pointB.y : 0)
                    };
                };
                /**
     * Returns the current length of the constraint. 
     * This is the distance between both of the constraint's end points.
     * See `constraint.length` for the target rest length.
     * @method currentLength
     * @param {constraint} constraint
     * @returns {number} the current length
     */ Constraint.currentLength = function(constraint) {
                    var pointAX = (constraint.bodyA ? constraint.bodyA.position.x : 0) + (constraint.pointA ? constraint.pointA.x : 0);
                    var pointAY = (constraint.bodyA ? constraint.bodyA.position.y : 0) + (constraint.pointA ? constraint.pointA.y : 0);
                    var pointBX = (constraint.bodyB ? constraint.bodyB.position.x : 0) + (constraint.pointB ? constraint.pointB.x : 0);
                    var pointBY = (constraint.bodyB ? constraint.bodyB.position.y : 0) + (constraint.pointB ? constraint.pointB.y : 0);
                    var deltaX = pointAX - pointBX;
                    var deltaY = pointAY - pointBY;
                    return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
                };
            /*
    *
    *  Properties Documentation
    *
    */ /**
     * An integer `Number` uniquely identifying number generated in `Composite.create` by `Common.nextId`.
     *
     * @property id
     * @type number
     */ /**
     * A `String` denoting the type of object.
     *
     * @property type
     * @type string
     * @default "constraint"
     * @readOnly
     */ /**
     * An arbitrary `String` name to help the user identify and manage bodies.
     *
     * @property label
     * @type string
     * @default "Constraint"
     */ /**
     * An `Object` that defines the rendering properties to be consumed by the module `Matter.Render`.
     *
     * @property render
     * @type object
     */ /**
     * A flag that indicates if the constraint should be rendered.
     *
     * @property render.visible
     * @type boolean
     * @default true
     */ /**
     * A `Number` that defines the line width to use when rendering the constraint outline.
     * A value of `0` means no outline will be rendered.
     *
     * @property render.lineWidth
     * @type number
     * @default 2
     */ /**
     * A `String` that defines the stroke style to use when rendering the constraint outline.
     * It is the same as when using a canvas, so it accepts CSS style property values.
     *
     * @property render.strokeStyle
     * @type string
     * @default a random colour
     */ /**
     * A `String` that defines the constraint rendering type. 
     * The possible values are 'line', 'pin', 'spring'.
     * An appropriate render type will be automatically chosen unless one is given in options.
     *
     * @property render.type
     * @type string
     * @default 'line'
     */ /**
     * A `Boolean` that defines if the constraint's anchor points should be rendered.
     *
     * @property render.anchors
     * @type boolean
     * @default true
     */ /**
     * The first possible `Body` that this constraint is attached to.
     *
     * @property bodyA
     * @type body
     * @default null
     */ /**
     * The second possible `Body` that this constraint is attached to.
     *
     * @property bodyB
     * @type body
     * @default null
     */ /**
     * A `Vector` that specifies the offset of the constraint from center of the `constraint.bodyA` if defined, otherwise a world-space position.
     *
     * @property pointA
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Vector` that specifies the offset of the constraint from center of the `constraint.bodyB` if defined, otherwise a world-space position.
     *
     * @property pointB
     * @type vector
     * @default { x: 0, y: 0 }
     */ /**
     * A `Number` that specifies the stiffness of the constraint, i.e. the rate at which it returns to its resting `constraint.length`.
     * A value of `1` means the constraint should be very stiff.
     * A value of `0.2` means the constraint acts like a soft spring.
     *
     * @property stiffness
     * @type number
     * @default 1
     */ /**
     * A `Number` that specifies the damping of the constraint, 
     * i.e. the amount of resistance applied to each body based on their velocities to limit the amount of oscillation.
     * Damping will only be apparent when the constraint also has a very low `stiffness`.
     * A value of `0.1` means the constraint will apply heavy damping, resulting in little to no oscillation.
     * A value of `0` means the constraint will apply no damping.
     *
     * @property damping
     * @type number
     * @default 0
     */ /**
     * A `Number` that specifies the target resting length of the constraint. 
     * It is calculated automatically in `Constraint.create` from initial positions of the `constraint.bodyA` and `constraint.bodyB`.
     *
     * @property length
     * @type number
     */ /**
     * An object reserved for storing plugin-specific properties.
     *
     * @property plugin
     * @type {}
     */ })();
        /***/ },
        /* 11 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Axes` module contains methods for creating and manipulating sets of axes.
*
* @class Axes
*/ var Axes = {};
            module1.exports = Axes;
            var Vector = __webpack_require__(2);
            var Common = __webpack_require__(0);
            (function() {
                /**
     * Creates a new set of axes from the given vertices.
     * @method fromVertices
     * @param {vertices} vertices
     * @return {axes} A new axes from the given vertices
     */ Axes.fromVertices = function(vertices) {
                    var axes = {};
                    // find the unique axes, using edge normal gradients
                    for(var i = 0; i < vertices.length; i++){
                        var j = (i + 1) % vertices.length, normal = Vector.normalise({
                            x: vertices[j].y - vertices[i].y,
                            y: vertices[i].x - vertices[j].x
                        }), gradient = normal.y === 0 ? Infinity : normal.x / normal.y;
                        // limit precision
                        gradient = gradient.toFixed(3).toString();
                        axes[gradient] = normal;
                    }
                    return Common.values(axes);
                };
                /**
     * Rotates a set of axes by the given angle.
     * @method rotate
     * @param {axes} axes
     * @param {number} angle
     */ Axes.rotate = function(axes, angle) {
                    if (angle === 0) return;
                    var cos = Math.cos(angle), sin = Math.sin(angle);
                    for(var i = 0; i < axes.length; i++){
                        var axis = axes[i], xx;
                        xx = axis.x * cos - axis.y * sin;
                        axis.y = axis.x * sin + axis.y * cos;
                        axis.x = xx;
                    }
                };
            })();
        /***/ },
        /* 12 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Bodies` module contains factory methods for creating rigid body models 
* with commonly used body configurations (such as rectangles, circles and other polygons).
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Bodies
*/ // TODO: true circle bodies
            var Bodies = {};
            module1.exports = Bodies;
            var Vertices = __webpack_require__(3);
            var Common = __webpack_require__(0);
            var Body = __webpack_require__(4);
            var Bounds = __webpack_require__(1);
            var Vector = __webpack_require__(2);
            (function() {
                /**
     * Creates a new rigid body model with a rectangle hull. 
     * The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
     * @method rectangle
     * @param {number} x
     * @param {number} y
     * @param {number} width
     * @param {number} height
     * @param {object} [options]
     * @return {body} A new rectangle body
     */ Bodies.rectangle = function(x, y, width, height, options) {
                    options = options || {};
                    var rectangle = {
                        label: "Rectangle Body",
                        position: {
                            x: x,
                            y: y
                        },
                        vertices: Vertices.fromPath("L 0 0 L " + width + " 0 L " + width + " " + height + " L 0 " + height)
                    };
                    if (options.chamfer) {
                        var chamfer = options.chamfer;
                        rectangle.vertices = Vertices.chamfer(rectangle.vertices, chamfer.radius, chamfer.quality, chamfer.qualityMin, chamfer.qualityMax);
                        delete options.chamfer;
                    }
                    return Body.create(Common.extend({}, rectangle, options));
                };
                /**
     * Creates a new rigid body model with a trapezoid hull. 
     * The `slope` is parameterised as a fraction of `width` and must be < 1 to form a valid trapezoid. 
     * The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
     * @method trapezoid
     * @param {number} x
     * @param {number} y
     * @param {number} width
     * @param {number} height
     * @param {number} slope Must be a number < 1.
     * @param {object} [options]
     * @return {body} A new trapezoid body
     */ Bodies.trapezoid = function(x, y, width, height, slope, options) {
                    options = options || {};
                    if (slope >= 1) Common.warn("Bodies.trapezoid: slope parameter must be < 1.");
                    slope *= 0.5;
                    var roof = (1 - slope * 2) * width;
                    var x1 = width * slope, x2 = x1 + roof, x3 = x2 + x1, verticesPath;
                    if (slope < 0.5) verticesPath = "L 0 0 L " + x1 + " " + -height + " L " + x2 + " " + -height + " L " + x3 + " 0";
                    else verticesPath = "L 0 0 L " + x2 + " " + -height + " L " + x3 + " 0";
                    var trapezoid = {
                        label: "Trapezoid Body",
                        position: {
                            x: x,
                            y: y
                        },
                        vertices: Vertices.fromPath(verticesPath)
                    };
                    if (options.chamfer) {
                        var chamfer = options.chamfer;
                        trapezoid.vertices = Vertices.chamfer(trapezoid.vertices, chamfer.radius, chamfer.quality, chamfer.qualityMin, chamfer.qualityMax);
                        delete options.chamfer;
                    }
                    return Body.create(Common.extend({}, trapezoid, options));
                };
                /**
     * Creates a new rigid body model with a circle hull. 
     * The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
     * @method circle
     * @param {number} x
     * @param {number} y
     * @param {number} radius
     * @param {object} [options]
     * @param {number} [maxSides]
     * @return {body} A new circle body
     */ Bodies.circle = function(x, y, radius, options, maxSides) {
                    options = options || {};
                    var circle = {
                        label: "Circle Body",
                        circleRadius: radius
                    };
                    // approximate circles with polygons until true circles implemented in SAT
                    maxSides = maxSides || 25;
                    var sides = Math.ceil(Math.max(10, Math.min(maxSides, radius)));
                    // optimisation: always use even number of sides (half the number of unique axes)
                    if (sides % 2 === 1) sides += 1;
                    return Bodies.polygon(x, y, sides, radius, Common.extend({}, circle, options));
                };
                /**
     * Creates a new rigid body model with a regular polygon hull with the given number of sides. 
     * The options parameter is an object that specifies any properties you wish to override the defaults.
     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
     * @method polygon
     * @param {number} x
     * @param {number} y
     * @param {number} sides
     * @param {number} radius
     * @param {object} [options]
     * @return {body} A new regular polygon body
     */ Bodies.polygon = function(x, y, sides, radius, options) {
                    options = options || {};
                    if (sides < 3) return Bodies.circle(x, y, radius, options);
                    var theta = 2 * Math.PI / sides, path = "", offset = theta * 0.5;
                    for(var i = 0; i < sides; i += 1){
                        var angle = offset + i * theta, xx = Math.cos(angle) * radius, yy = Math.sin(angle) * radius;
                        path += "L " + xx.toFixed(3) + " " + yy.toFixed(3) + " ";
                    }
                    var polygon = {
                        label: "Polygon Body",
                        position: {
                            x: x,
                            y: y
                        },
                        vertices: Vertices.fromPath(path)
                    };
                    if (options.chamfer) {
                        var chamfer = options.chamfer;
                        polygon.vertices = Vertices.chamfer(polygon.vertices, chamfer.radius, chamfer.quality, chamfer.qualityMin, chamfer.qualityMax);
                        delete options.chamfer;
                    }
                    return Body.create(Common.extend({}, polygon, options));
                };
                /**
     * Utility to create a compound body based on set(s) of vertices.
     * 
     * _Note:_ To optionally enable automatic concave vertices decomposition the [poly-decomp](https://github.com/schteppe/poly-decomp.js) 
     * package must be first installed and provided see `Common.setDecomp`, otherwise the convex hull of each vertex set will be used.
     * 
     * The resulting vertices are reorientated about their centre of mass,
     * and offset such that `body.position` corresponds to this point.
     * 
     * The resulting offset may be found if needed by subtracting `body.bounds` from the original input bounds.
     * To later move the centre of mass see `Body.setCentre`.
     * 
     * Note that automatic conconcave decomposition results are not always optimal. 
     * For best results, simplify the input vertices as much as possible first.
     * By default this function applies some addtional simplification to help.
     * 
     * Some outputs may also require further manual processing afterwards to be robust.
     * In particular some parts may need to be overlapped to avoid collision gaps.
     * Thin parts and sharp points should be avoided or removed where possible.
     *
     * The options parameter object specifies any `Matter.Body` properties you wish to override the defaults.
     * 
     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
     * @method fromVertices
     * @param {number} x
     * @param {number} y
     * @param {array} vertexSets One or more arrays of vertex points e.g. `[[{ x: 0, y: 0 }...], ...]`.
     * @param {object} [options] The body options.
     * @param {bool} [flagInternal=false] Optionally marks internal edges with `isInternal`.
     * @param {number} [removeCollinear=0.01] Threshold when simplifying vertices along the same edge.
     * @param {number} [minimumArea=10] Threshold when removing small parts.
     * @param {number} [removeDuplicatePoints=0.01] Threshold when simplifying nearby vertices.
     * @return {body}
     */ Bodies.fromVertices = function(x, y, vertexSets, options, flagInternal, removeCollinear, minimumArea, removeDuplicatePoints) {
                    var decomp = Common.getDecomp(), canDecomp, body, parts, isConvex, isConcave, vertices, i, j, k, v, z;
                    // check decomp is as expected
                    canDecomp = Boolean(decomp && decomp.quickDecomp);
                    options = options || {};
                    parts = [];
                    flagInternal = typeof flagInternal !== "undefined" ? flagInternal : false;
                    removeCollinear = typeof removeCollinear !== "undefined" ? removeCollinear : 0.01;
                    minimumArea = typeof minimumArea !== "undefined" ? minimumArea : 10;
                    removeDuplicatePoints = typeof removeDuplicatePoints !== "undefined" ? removeDuplicatePoints : 0.01;
                    // ensure vertexSets is an array of arrays
                    if (!Common.isArray(vertexSets[0])) vertexSets = [
                        vertexSets
                    ];
                    for(v = 0; v < vertexSets.length; v += 1){
                        vertices = vertexSets[v];
                        isConvex = Vertices.isConvex(vertices);
                        isConcave = !isConvex;
                        if (isConcave && !canDecomp) Common.warnOnce("Bodies.fromVertices: Install the 'poly-decomp' library and use Common.setDecomp or provide 'decomp' as a global to decompose concave vertices.");
                        if (isConvex || !canDecomp) {
                            if (isConvex) vertices = Vertices.clockwiseSort(vertices);
                            else // fallback to convex hull when decomposition is not possible
                            vertices = Vertices.hull(vertices);
                            parts.push({
                                position: {
                                    x: x,
                                    y: y
                                },
                                vertices: vertices
                            });
                        } else {
                            // initialise a decomposition
                            var concave = vertices.map(function(vertex) {
                                return [
                                    vertex.x,
                                    vertex.y
                                ];
                            });
                            // vertices are concave and simple, we can decompose into parts
                            decomp.makeCCW(concave);
                            if (removeCollinear !== false) decomp.removeCollinearPoints(concave, removeCollinear);
                            if (removeDuplicatePoints !== false && decomp.removeDuplicatePoints) decomp.removeDuplicatePoints(concave, removeDuplicatePoints);
                            // use the quick decomposition algorithm (Bayazit)
                            var decomposed = decomp.quickDecomp(concave);
                            // for each decomposed chunk
                            for(i = 0; i < decomposed.length; i++){
                                var chunk = decomposed[i];
                                // convert vertices into the correct structure
                                var chunkVertices = chunk.map(function(vertices) {
                                    return {
                                        x: vertices[0],
                                        y: vertices[1]
                                    };
                                });
                                // skip small chunks
                                if (minimumArea > 0 && Vertices.area(chunkVertices) < minimumArea) continue;
                                // create a compound part
                                parts.push({
                                    position: Vertices.centre(chunkVertices),
                                    vertices: chunkVertices
                                });
                            }
                        }
                    }
                    // create body parts
                    for(i = 0; i < parts.length; i++)parts[i] = Body.create(Common.extend(parts[i], options));
                    // flag internal edges (coincident part edges)
                    if (flagInternal) {
                        var coincident_max_dist = 5;
                        for(i = 0; i < parts.length; i++){
                            var partA = parts[i];
                            for(j = i + 1; j < parts.length; j++){
                                var partB = parts[j];
                                if (Bounds.overlaps(partA.bounds, partB.bounds)) {
                                    var pav = partA.vertices, pbv = partB.vertices;
                                    // iterate vertices of both parts
                                    for(k = 0; k < partA.vertices.length; k++)for(z = 0; z < partB.vertices.length; z++){
                                        // find distances between the vertices
                                        var da = Vector.magnitudeSquared(Vector.sub(pav[(k + 1) % pav.length], pbv[z])), db = Vector.magnitudeSquared(Vector.sub(pav[k], pbv[(z + 1) % pbv.length]));
                                        // if both vertices are very close, consider the edge concident (internal)
                                        if (da < coincident_max_dist && db < coincident_max_dist) {
                                            pav[k].isInternal = true;
                                            pbv[z].isInternal = true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (parts.length > 1) {
                        // create the parent body to be returned, that contains generated compound parts
                        body = Body.create(Common.extend({
                            parts: parts.slice(0)
                        }, options));
                        // offset such that body.position is at the centre off mass
                        Body.setPosition(body, {
                            x: x,
                            y: y
                        });
                        return body;
                    } else return parts[0];
                };
            })();
        /***/ },
        /* 13 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Detector` module contains methods for efficiently detecting collisions between a list of bodies using a broadphase algorithm.
*
* @class Detector
*/ var Detector = {};
            module1.exports = Detector;
            var Common = __webpack_require__(0);
            var Collision = __webpack_require__(8);
            (function() {
                /**
     * Creates a new collision detector.
     * @method create
     * @param {} options
     * @return {detector} A new collision detector
     */ Detector.create = function(options) {
                    var defaults = {
                        bodies: [],
                        collisions: [],
                        pairs: null
                    };
                    return Common.extend(defaults, options);
                };
                /**
     * Sets the list of bodies in the detector.
     * @method setBodies
     * @param {detector} detector
     * @param {body[]} bodies
     */ Detector.setBodies = function(detector, bodies) {
                    detector.bodies = bodies.slice(0);
                };
                /**
     * Clears the detector including its list of bodies.
     * @method clear
     * @param {detector} detector
     */ Detector.clear = function(detector) {
                    detector.bodies = [];
                    detector.collisions = [];
                };
                /**
     * Efficiently finds all collisions among all the bodies in `detector.bodies` using a broadphase algorithm.
     * 
     * _Note:_ The specific ordering of collisions returned is not guaranteed between releases and may change for performance reasons.
     * If a specific ordering is required then apply a sort to the resulting array.
     * @method collisions
     * @param {detector} detector
     * @return {collision[]} collisions
     */ Detector.collisions = function(detector) {
                    var pairs = detector.pairs, bodies = detector.bodies, bodiesLength = bodies.length, canCollide = Detector.canCollide, collides = Collision.collides, collisions = detector.collisions, collisionIndex = 0, i, j;
                    bodies.sort(Detector._compareBoundsX);
                    for(i = 0; i < bodiesLength; i++){
                        var bodyA = bodies[i], boundsA = bodyA.bounds, boundXMax = bodyA.bounds.max.x, boundYMax = bodyA.bounds.max.y, boundYMin = bodyA.bounds.min.y, bodyAStatic = bodyA.isStatic || bodyA.isSleeping, partsALength = bodyA.parts.length, partsASingle = partsALength === 1;
                        for(j = i + 1; j < bodiesLength; j++){
                            var bodyB = bodies[j], boundsB = bodyB.bounds;
                            if (boundsB.min.x > boundXMax) break;
                            if (boundYMax < boundsB.min.y || boundYMin > boundsB.max.y) continue;
                            if (bodyAStatic && (bodyB.isStatic || bodyB.isSleeping)) continue;
                            if (!canCollide(bodyA.collisionFilter, bodyB.collisionFilter)) continue;
                            var partsBLength = bodyB.parts.length;
                            if (partsASingle && partsBLength === 1) {
                                var collision = collides(bodyA, bodyB, pairs);
                                if (collision) collisions[collisionIndex++] = collision;
                            } else {
                                var partsAStart = partsALength > 1 ? 1 : 0, partsBStart = partsBLength > 1 ? 1 : 0;
                                for(var k = partsAStart; k < partsALength; k++){
                                    var partA = bodyA.parts[k], boundsA = partA.bounds;
                                    for(var z = partsBStart; z < partsBLength; z++){
                                        var partB = bodyB.parts[z], boundsB = partB.bounds;
                                        if (boundsA.min.x > boundsB.max.x || boundsA.max.x < boundsB.min.x || boundsA.max.y < boundsB.min.y || boundsA.min.y > boundsB.max.y) continue;
                                        var collision = collides(partA, partB, pairs);
                                        if (collision) collisions[collisionIndex++] = collision;
                                    }
                                }
                            }
                        }
                    }
                    if (collisions.length !== collisionIndex) collisions.length = collisionIndex;
                    return collisions;
                };
                /**
     * Returns `true` if both supplied collision filters will allow a collision to occur.
     * See `body.collisionFilter` for more information.
     * @method canCollide
     * @param {} filterA
     * @param {} filterB
     * @return {bool} `true` if collision can occur
     */ Detector.canCollide = function(filterA, filterB) {
                    if (filterA.group === filterB.group && filterA.group !== 0) return filterA.group > 0;
                    return (filterA.mask & filterB.category) !== 0 && (filterB.mask & filterA.category) !== 0;
                };
                /**
     * The comparison function used in the broadphase algorithm.
     * Returns the signed delta of the bodies bounds on the x-axis.
     * @private
     * @method _sortCompare
     * @param {body} bodyA
     * @param {body} bodyB
     * @return {number} The signed delta used for sorting
     */ Detector._compareBoundsX = function(bodyA, bodyB) {
                    return bodyA.bounds.min.x - bodyB.bounds.min.x;
                };
            /*
    *
    *  Properties Documentation
    *
    */ /**
     * The array of `Matter.Body` between which the detector finds collisions.
     * 
     * _Note:_ The order of bodies in this array _is not fixed_ and will be continually managed by the detector.
     * @property bodies
     * @type body[]
     * @default []
     */ /**
     * The array of `Matter.Collision` found in the last call to `Detector.collisions` on this detector.
     * @property collisions
     * @type collision[]
     * @default []
     */ /**
     * Optional. A `Matter.Pairs` object from which previous collision objects may be reused. Intended for internal `Matter.Engine` usage.
     * @property pairs
     * @type {pairs|null}
     * @default null
     */ })();
        /***/ },
        /* 14 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Mouse` module contains methods for creating and manipulating mouse inputs.
*
* @class Mouse
*/ var Mouse = {};
            module1.exports = Mouse;
            var Common = __webpack_require__(0);
            (function() {
                /**
     * Creates a mouse input.
     * @method create
     * @param {HTMLElement} element
     * @return {mouse} A new mouse
     */ Mouse.create = function(element) {
                    var mouse = {};
                    if (!element) Common.log("Mouse.create: element was undefined, defaulting to document.body", "warn");
                    mouse.element = element || document.body;
                    mouse.absolute = {
                        x: 0,
                        y: 0
                    };
                    mouse.position = {
                        x: 0,
                        y: 0
                    };
                    mouse.mousedownPosition = {
                        x: 0,
                        y: 0
                    };
                    mouse.mouseupPosition = {
                        x: 0,
                        y: 0
                    };
                    mouse.offset = {
                        x: 0,
                        y: 0
                    };
                    mouse.scale = {
                        x: 1,
                        y: 1
                    };
                    mouse.wheelDelta = 0;
                    mouse.button = -1;
                    mouse.pixelRatio = parseInt(mouse.element.getAttribute("data-pixel-ratio"), 10) || 1;
                    mouse.sourceEvents = {
                        mousemove: null,
                        mousedown: null,
                        mouseup: null,
                        mousewheel: null
                    };
                    mouse.mousemove = function(event) {
                        var position = Mouse._getRelativeMousePosition(event, mouse.element, mouse.pixelRatio), touches = event.changedTouches;
                        if (touches) {
                            mouse.button = 0;
                            event.preventDefault();
                        }
                        mouse.absolute.x = position.x;
                        mouse.absolute.y = position.y;
                        mouse.position.x = mouse.absolute.x * mouse.scale.x + mouse.offset.x;
                        mouse.position.y = mouse.absolute.y * mouse.scale.y + mouse.offset.y;
                        mouse.sourceEvents.mousemove = event;
                    };
                    mouse.mousedown = function(event) {
                        var position = Mouse._getRelativeMousePosition(event, mouse.element, mouse.pixelRatio), touches = event.changedTouches;
                        if (touches) {
                            mouse.button = 0;
                            event.preventDefault();
                        } else mouse.button = event.button;
                        mouse.absolute.x = position.x;
                        mouse.absolute.y = position.y;
                        mouse.position.x = mouse.absolute.x * mouse.scale.x + mouse.offset.x;
                        mouse.position.y = mouse.absolute.y * mouse.scale.y + mouse.offset.y;
                        mouse.mousedownPosition.x = mouse.position.x;
                        mouse.mousedownPosition.y = mouse.position.y;
                        mouse.sourceEvents.mousedown = event;
                    };
                    mouse.mouseup = function(event) {
                        var position = Mouse._getRelativeMousePosition(event, mouse.element, mouse.pixelRatio), touches = event.changedTouches;
                        if (touches) event.preventDefault();
                        mouse.button = -1;
                        mouse.absolute.x = position.x;
                        mouse.absolute.y = position.y;
                        mouse.position.x = mouse.absolute.x * mouse.scale.x + mouse.offset.x;
                        mouse.position.y = mouse.absolute.y * mouse.scale.y + mouse.offset.y;
                        mouse.mouseupPosition.x = mouse.position.x;
                        mouse.mouseupPosition.y = mouse.position.y;
                        mouse.sourceEvents.mouseup = event;
                    };
                    mouse.mousewheel = function(event) {
                        mouse.wheelDelta = Math.max(-1, Math.min(1, event.wheelDelta || -event.detail));
                        event.preventDefault();
                        mouse.sourceEvents.mousewheel = event;
                    };
                    Mouse.setElement(mouse, mouse.element);
                    return mouse;
                };
                /**
     * Sets the element the mouse is bound to (and relative to).
     * @method setElement
     * @param {mouse} mouse
     * @param {HTMLElement} element
     */ Mouse.setElement = function(mouse, element) {
                    mouse.element = element;
                    element.addEventListener("mousemove", mouse.mousemove, {
                        passive: true
                    });
                    element.addEventListener("mousedown", mouse.mousedown, {
                        passive: true
                    });
                    element.addEventListener("mouseup", mouse.mouseup, {
                        passive: true
                    });
                    element.addEventListener("wheel", mouse.mousewheel, {
                        passive: false
                    });
                    element.addEventListener("touchmove", mouse.mousemove, {
                        passive: false
                    });
                    element.addEventListener("touchstart", mouse.mousedown, {
                        passive: false
                    });
                    element.addEventListener("touchend", mouse.mouseup, {
                        passive: false
                    });
                };
                /**
     * Clears all captured source events.
     * @method clearSourceEvents
     * @param {mouse} mouse
     */ Mouse.clearSourceEvents = function(mouse) {
                    mouse.sourceEvents.mousemove = null;
                    mouse.sourceEvents.mousedown = null;
                    mouse.sourceEvents.mouseup = null;
                    mouse.sourceEvents.mousewheel = null;
                    mouse.wheelDelta = 0;
                };
                /**
     * Sets the mouse position offset.
     * @method setOffset
     * @param {mouse} mouse
     * @param {vector} offset
     */ Mouse.setOffset = function(mouse, offset) {
                    mouse.offset.x = offset.x;
                    mouse.offset.y = offset.y;
                    mouse.position.x = mouse.absolute.x * mouse.scale.x + mouse.offset.x;
                    mouse.position.y = mouse.absolute.y * mouse.scale.y + mouse.offset.y;
                };
                /**
     * Sets the mouse position scale.
     * @method setScale
     * @param {mouse} mouse
     * @param {vector} scale
     */ Mouse.setScale = function(mouse, scale) {
                    mouse.scale.x = scale.x;
                    mouse.scale.y = scale.y;
                    mouse.position.x = mouse.absolute.x * mouse.scale.x + mouse.offset.x;
                    mouse.position.y = mouse.absolute.y * mouse.scale.y + mouse.offset.y;
                };
                /**
     * Gets the mouse position relative to an element given a screen pixel ratio.
     * @method _getRelativeMousePosition
     * @private
     * @param {} event
     * @param {} element
     * @param {number} pixelRatio
     * @return {}
     */ Mouse._getRelativeMousePosition = function(event, element, pixelRatio) {
                    var elementBounds = element.getBoundingClientRect(), rootNode = document.documentElement || document.body.parentNode || document.body, scrollX = window.pageXOffset !== undefined ? window.pageXOffset : rootNode.scrollLeft, scrollY = window.pageYOffset !== undefined ? window.pageYOffset : rootNode.scrollTop, touches = event.changedTouches, x, y;
                    if (touches) {
                        x = touches[0].pageX - elementBounds.left - scrollX;
                        y = touches[0].pageY - elementBounds.top - scrollY;
                    } else {
                        x = event.pageX - elementBounds.left - scrollX;
                        y = event.pageY - elementBounds.top - scrollY;
                    }
                    return {
                        x: x / (element.clientWidth / (element.width || element.clientWidth) * pixelRatio),
                        y: y / (element.clientHeight / (element.height || element.clientHeight) * pixelRatio)
                    };
                };
            })();
        /***/ },
        /* 15 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Plugin` module contains functions for registering and installing plugins on modules.
*
* @class Plugin
*/ var Plugin = {};
            module1.exports = Plugin;
            var Common = __webpack_require__(0);
            (function() {
                Plugin._registry = {};
                /**
     * Registers a plugin object so it can be resolved later by name.
     * @method register
     * @param plugin {} The plugin to register.
     * @return {object} The plugin.
     */ Plugin.register = function(plugin) {
                    if (!Plugin.isPlugin(plugin)) Common.warn("Plugin.register:", Plugin.toString(plugin), "does not implement all required fields.");
                    if (plugin.name in Plugin._registry) {
                        var registered = Plugin._registry[plugin.name], pluginVersion = Plugin.versionParse(plugin.version).number, registeredVersion = Plugin.versionParse(registered.version).number;
                        if (pluginVersion > registeredVersion) {
                            Common.warn("Plugin.register:", Plugin.toString(registered), "was upgraded to", Plugin.toString(plugin));
                            Plugin._registry[plugin.name] = plugin;
                        } else if (pluginVersion < registeredVersion) Common.warn("Plugin.register:", Plugin.toString(registered), "can not be downgraded to", Plugin.toString(plugin));
                        else if (plugin !== registered) Common.warn("Plugin.register:", Plugin.toString(plugin), "is already registered to different plugin object");
                    } else Plugin._registry[plugin.name] = plugin;
                    return plugin;
                };
                /**
     * Resolves a dependency to a plugin object from the registry if it exists. 
     * The `dependency` may contain a version, but only the name matters when resolving.
     * @method resolve
     * @param dependency {string} The dependency.
     * @return {object} The plugin if resolved, otherwise `undefined`.
     */ Plugin.resolve = function(dependency) {
                    return Plugin._registry[Plugin.dependencyParse(dependency).name];
                };
                /**
     * Returns a pretty printed plugin name and version.
     * @method toString
     * @param plugin {} The plugin.
     * @return {string} Pretty printed plugin name and version.
     */ Plugin.toString = function(plugin) {
                    return typeof plugin === "string" ? plugin : (plugin.name || "anonymous") + "@" + (plugin.version || plugin.range || "0.0.0");
                };
                /**
     * Returns `true` if the object meets the minimum standard to be considered a plugin.
     * This means it must define the following properties:
     * - `name`
     * - `version`
     * - `install`
     * @method isPlugin
     * @param obj {} The obj to test.
     * @return {boolean} `true` if the object can be considered a plugin otherwise `false`.
     */ Plugin.isPlugin = function(obj) {
                    return obj && obj.name && obj.version && obj.install;
                };
                /**
     * Returns `true` if a plugin with the given `name` been installed on `module`.
     * @method isUsed
     * @param module {} The module.
     * @param name {string} The plugin name.
     * @return {boolean} `true` if a plugin with the given `name` been installed on `module`, otherwise `false`.
     */ Plugin.isUsed = function(module1, name) {
                    return module1.used.indexOf(name) > -1;
                };
                /**
     * Returns `true` if `plugin.for` is applicable to `module` by comparing against `module.name` and `module.version`.
     * If `plugin.for` is not specified then it is assumed to be applicable.
     * The value of `plugin.for` is a string of the format `'module-name'` or `'module-name@version'`.
     * @method isFor
     * @param plugin {} The plugin.
     * @param module {} The module.
     * @return {boolean} `true` if `plugin.for` is applicable to `module`, otherwise `false`.
     */ Plugin.isFor = function(plugin, module1) {
                    var parsed = plugin.for && Plugin.dependencyParse(plugin.for);
                    return !plugin.for || module1.name === parsed.name && Plugin.versionSatisfies(module1.version, parsed.range);
                };
                /**
     * Installs the plugins by calling `plugin.install` on each plugin specified in `plugins` if passed, otherwise `module.uses`.
     * For installing plugins on `Matter` see the convenience function `Matter.use`.
     * Plugins may be specified either by their name or a reference to the plugin object.
     * Plugins themselves may specify further dependencies, but each plugin is installed only once.
     * Order is important, a topological sort is performed to find the best resulting order of installation.
     * This sorting attempts to satisfy every dependency's requested ordering, but may not be exact in all cases.
     * This function logs the resulting status of each dependency in the console, along with any warnings.
     * - A green tick ✅ indicates a dependency was resolved and installed.
     * - An orange diamond 🔶 indicates a dependency was resolved but a warning was thrown for it or one if its dependencies.
     * - A red cross ❌ indicates a dependency could not be resolved.
     * Avoid calling this function multiple times on the same module unless you intend to manually control installation order.
     * @method use
     * @param module {} The module install plugins on.
     * @param [plugins=module.uses] {} The plugins to install on module (optional, defaults to `module.uses`).
     */ Plugin.use = function(module1, plugins) {
                    module1.uses = (module1.uses || []).concat(plugins || []);
                    if (module1.uses.length === 0) {
                        Common.warn("Plugin.use:", Plugin.toString(module1), "does not specify any dependencies to install.");
                        return;
                    }
                    var dependencies = Plugin.dependencies(module1), sortedDependencies = Common.topologicalSort(dependencies), status = [];
                    for(var i = 0; i < sortedDependencies.length; i += 1){
                        if (sortedDependencies[i] === module1.name) continue;
                        var plugin = Plugin.resolve(sortedDependencies[i]);
                        if (!plugin) {
                            status.push("\u274C " + sortedDependencies[i]);
                            continue;
                        }
                        if (Plugin.isUsed(module1, plugin.name)) continue;
                        if (!Plugin.isFor(plugin, module1)) {
                            Common.warn("Plugin.use:", Plugin.toString(plugin), "is for", plugin.for, "but installed on", Plugin.toString(module1) + ".");
                            plugin._warned = true;
                        }
                        if (plugin.install) plugin.install(module1);
                        else {
                            Common.warn("Plugin.use:", Plugin.toString(plugin), "does not specify an install function.");
                            plugin._warned = true;
                        }
                        if (plugin._warned) {
                            status.push("\uD83D\uDD36 " + Plugin.toString(plugin));
                            delete plugin._warned;
                        } else status.push("\u2705 " + Plugin.toString(plugin));
                        module1.used.push(plugin.name);
                    }
                    if (status.length > 0) Common.info(status.join("  "));
                };
                /**
     * Recursively finds all of a module's dependencies and returns a flat dependency graph.
     * @method dependencies
     * @param module {} The module.
     * @return {object} A dependency graph.
     */ Plugin.dependencies = function(module1, tracked) {
                    var parsedBase = Plugin.dependencyParse(module1), name = parsedBase.name;
                    tracked = tracked || {};
                    if (name in tracked) return;
                    module1 = Plugin.resolve(module1) || module1;
                    tracked[name] = Common.map(module1.uses || [], function(dependency) {
                        if (Plugin.isPlugin(dependency)) Plugin.register(dependency);
                        var parsed = Plugin.dependencyParse(dependency), resolved = Plugin.resolve(dependency);
                        if (resolved && !Plugin.versionSatisfies(resolved.version, parsed.range)) {
                            Common.warn("Plugin.dependencies:", Plugin.toString(resolved), "does not satisfy", Plugin.toString(parsed), "used by", Plugin.toString(parsedBase) + ".");
                            resolved._warned = true;
                            module1._warned = true;
                        } else if (!resolved) {
                            Common.warn("Plugin.dependencies:", Plugin.toString(dependency), "used by", Plugin.toString(parsedBase), "could not be resolved.");
                            module1._warned = true;
                        }
                        return parsed.name;
                    });
                    for(var i = 0; i < tracked[name].length; i += 1)Plugin.dependencies(tracked[name][i], tracked);
                    return tracked;
                };
                /**
     * Parses a dependency string into its components.
     * The `dependency` is a string of the format `'module-name'` or `'module-name@version'`.
     * See documentation for `Plugin.versionParse` for a description of the format.
     * This function can also handle dependencies that are already resolved (e.g. a module object).
     * @method dependencyParse
     * @param dependency {string} The dependency of the format `'module-name'` or `'module-name@version'`.
     * @return {object} The dependency parsed into its components.
     */ Plugin.dependencyParse = function(dependency) {
                    if (Common.isString(dependency)) {
                        var pattern = /^[\w-]+(@(\*|[\^~]?\d+\.\d+\.\d+(-[0-9A-Za-z-+]+)?))?$/;
                        if (!pattern.test(dependency)) Common.warn("Plugin.dependencyParse:", dependency, "is not a valid dependency string.");
                        return {
                            name: dependency.split("@")[0],
                            range: dependency.split("@")[1] || "*"
                        };
                    }
                    return {
                        name: dependency.name,
                        range: dependency.range || dependency.version
                    };
                };
                /**
     * Parses a version string into its components.  
     * Versions are strictly of the format `x.y.z` (as in [semver](http://semver.org/)).
     * Versions may optionally have a prerelease tag in the format `x.y.z-alpha`.
     * Ranges are a strict subset of [npm ranges](https://docs.npmjs.com/misc/semver#advanced-range-syntax).
     * Only the following range types are supported:
     * - Tilde ranges e.g. `~1.2.3`
     * - Caret ranges e.g. `^1.2.3`
     * - Greater than ranges e.g. `>1.2.3`
     * - Greater than or equal ranges e.g. `>=1.2.3`
     * - Exact version e.g. `1.2.3`
     * - Any version `*`
     * @method versionParse
     * @param range {string} The version string.
     * @return {object} The version range parsed into its components.
     */ Plugin.versionParse = function(range) {
                    var pattern = /^(\*)|(\^|~|>=|>)?\s*((\d+)\.(\d+)\.(\d+))(-[0-9A-Za-z-+]+)?$/;
                    if (!pattern.test(range)) Common.warn("Plugin.versionParse:", range, "is not a valid version or range.");
                    var parts = pattern.exec(range);
                    var major = Number(parts[4]);
                    var minor = Number(parts[5]);
                    var patch = Number(parts[6]);
                    return {
                        isRange: Boolean(parts[1] || parts[2]),
                        version: parts[3],
                        range: range,
                        operator: parts[1] || parts[2] || "",
                        major: major,
                        minor: minor,
                        patch: patch,
                        parts: [
                            major,
                            minor,
                            patch
                        ],
                        prerelease: parts[7],
                        number: major * 1e8 + minor * 1e4 + patch
                    };
                };
                /**
     * Returns `true` if `version` satisfies the given `range`.
     * See documentation for `Plugin.versionParse` for a description of the format.
     * If a version or range is not specified, then any version (`*`) is assumed to satisfy.
     * @method versionSatisfies
     * @param version {string} The version string.
     * @param range {string} The range string.
     * @return {boolean} `true` if `version` satisfies `range`, otherwise `false`.
     */ Plugin.versionSatisfies = function(version, range) {
                    range = range || "*";
                    var r = Plugin.versionParse(range), v = Plugin.versionParse(version);
                    if (r.isRange) {
                        if (r.operator === "*" || version === "*") return true;
                        if (r.operator === ">") return v.number > r.number;
                        if (r.operator === ">=") return v.number >= r.number;
                        if (r.operator === "~") return v.major === r.major && v.minor === r.minor && v.patch >= r.patch;
                        if (r.operator === "^") {
                            if (r.major > 0) return v.major === r.major && v.number >= r.number;
                            if (r.minor > 0) return v.minor === r.minor && v.patch >= r.patch;
                            return v.patch === r.patch;
                        }
                    }
                    return version === range || version === "*";
                };
            })();
        /***/ },
        /* 16 */ /***/ function(module1, exports) {
            /**
* The `Matter.Contact` module contains methods for creating and manipulating collision contacts.
*
* @class Contact
*/ var Contact = {};
            module1.exports = Contact;
            (function() {
                /**
     * Creates a new contact.
     * @method create
     * @param {vertex} [vertex]
     * @return {contact} A new contact
     */ Contact.create = function(vertex) {
                    return {
                        vertex: vertex,
                        normalImpulse: 0,
                        tangentImpulse: 0
                    };
                };
            })();
        /***/ },
        /* 17 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Engine` module contains methods for creating and manipulating engines.
* An engine is a controller that manages updating the simulation of the world.
* See `Matter.Runner` for an optional game loop utility.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Engine
*/ var Engine = {};
            module1.exports = Engine;
            var Sleeping = __webpack_require__(7);
            var Resolver = __webpack_require__(18);
            var Detector = __webpack_require__(13);
            var Pairs = __webpack_require__(19);
            var Events = __webpack_require__(5);
            var Composite = __webpack_require__(6);
            var Constraint = __webpack_require__(10);
            var Common = __webpack_require__(0);
            var Body = __webpack_require__(4);
            (function() {
                Engine._deltaMax = 1000 / 60;
                /**
     * Creates a new engine. The options parameter is an object that specifies any properties you wish to override the defaults.
     * All properties have default values, and many are pre-calculated automatically based on other properties.
     * See the properties section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @param {object} [options]
     * @return {engine} engine
     */ Engine.create = function(options) {
                    options = options || {};
                    var defaults = {
                        positionIterations: 6,
                        velocityIterations: 4,
                        constraintIterations: 2,
                        enableSleeping: false,
                        events: [],
                        plugin: {},
                        gravity: {
                            x: 0,
                            y: 1,
                            scale: 0.001
                        },
                        timing: {
                            timestamp: 0,
                            timeScale: 1,
                            lastDelta: 0,
                            lastElapsed: 0,
                            lastUpdatesPerFrame: 0
                        }
                    };
                    var engine = Common.extend(defaults, options);
                    engine.world = options.world || Composite.create({
                        label: "World"
                    });
                    engine.pairs = options.pairs || Pairs.create();
                    engine.detector = options.detector || Detector.create();
                    engine.detector.pairs = engine.pairs;
                    // for temporary back compatibility only
                    engine.grid = {
                        buckets: []
                    };
                    engine.world.gravity = engine.gravity;
                    engine.broadphase = engine.grid;
                    engine.metrics = {};
                    return engine;
                };
                /**
     * Moves the simulation forward in time by `delta` milliseconds.
     * Triggers `beforeUpdate`, `beforeSolve` and `afterUpdate` events.
     * Triggers `collisionStart`, `collisionActive` and `collisionEnd` events.
     * @method update
     * @param {engine} engine
     * @param {number} [delta=16.666]
     */ Engine.update = function(engine, delta) {
                    var startTime = Common.now();
                    var world = engine.world, detector = engine.detector, pairs = engine.pairs, timing = engine.timing, timestamp = timing.timestamp, i;
                    // warn if high delta
                    if (delta > Engine._deltaMax) Common.warnOnce("Matter.Engine.update: delta argument is recommended to be less than or equal to", Engine._deltaMax.toFixed(3), "ms.");
                    delta = typeof delta !== "undefined" ? delta : Common._baseDelta;
                    delta *= timing.timeScale;
                    // increment timestamp
                    timing.timestamp += delta;
                    timing.lastDelta = delta;
                    // create an event object
                    var event = {
                        timestamp: timing.timestamp,
                        delta: delta
                    };
                    Events.trigger(engine, "beforeUpdate", event);
                    // get all bodies and all constraints in the world
                    var allBodies = Composite.allBodies(world), allConstraints = Composite.allConstraints(world);
                    // if the world has changed
                    if (world.isModified) {
                        // update the detector bodies
                        Detector.setBodies(detector, allBodies);
                        // reset all composite modified flags
                        Composite.setModified(world, false, false, true);
                    }
                    // update sleeping if enabled
                    if (engine.enableSleeping) Sleeping.update(allBodies, delta);
                    // apply gravity to all bodies
                    Engine._bodiesApplyGravity(allBodies, engine.gravity);
                    // update all body position and rotation by integration
                    if (delta > 0) Engine._bodiesUpdate(allBodies, delta);
                    Events.trigger(engine, "beforeSolve", event);
                    // update all constraints (first pass)
                    Constraint.preSolveAll(allBodies);
                    for(i = 0; i < engine.constraintIterations; i++)Constraint.solveAll(allConstraints, delta);
                    Constraint.postSolveAll(allBodies);
                    // find all collisions
                    var collisions = Detector.collisions(detector);
                    // update collision pairs
                    Pairs.update(pairs, collisions, timestamp);
                    // wake up bodies involved in collisions
                    if (engine.enableSleeping) Sleeping.afterCollisions(pairs.list);
                    // trigger collision events
                    if (pairs.collisionStart.length > 0) Events.trigger(engine, "collisionStart", {
                        pairs: pairs.collisionStart,
                        timestamp: timing.timestamp,
                        delta: delta
                    });
                    // iteratively resolve position between collisions
                    var positionDamping = Common.clamp(20 / engine.positionIterations, 0, 1);
                    Resolver.preSolvePosition(pairs.list);
                    for(i = 0; i < engine.positionIterations; i++)Resolver.solvePosition(pairs.list, delta, positionDamping);
                    Resolver.postSolvePosition(allBodies);
                    // update all constraints (second pass)
                    Constraint.preSolveAll(allBodies);
                    for(i = 0; i < engine.constraintIterations; i++)Constraint.solveAll(allConstraints, delta);
                    Constraint.postSolveAll(allBodies);
                    // iteratively resolve velocity between collisions
                    Resolver.preSolveVelocity(pairs.list);
                    for(i = 0; i < engine.velocityIterations; i++)Resolver.solveVelocity(pairs.list, delta);
                    // update body speed and velocity properties
                    Engine._bodiesUpdateVelocities(allBodies);
                    // trigger collision events
                    if (pairs.collisionActive.length > 0) Events.trigger(engine, "collisionActive", {
                        pairs: pairs.collisionActive,
                        timestamp: timing.timestamp,
                        delta: delta
                    });
                    if (pairs.collisionEnd.length > 0) Events.trigger(engine, "collisionEnd", {
                        pairs: pairs.collisionEnd,
                        timestamp: timing.timestamp,
                        delta: delta
                    });
                    // clear force buffers
                    Engine._bodiesClearForces(allBodies);
                    Events.trigger(engine, "afterUpdate", event);
                    // log the time elapsed computing this update
                    engine.timing.lastElapsed = Common.now() - startTime;
                    return engine;
                };
                /**
     * Merges two engines by keeping the configuration of `engineA` but replacing the world with the one from `engineB`.
     * @method merge
     * @param {engine} engineA
     * @param {engine} engineB
     */ Engine.merge = function(engineA, engineB) {
                    Common.extend(engineA, engineB);
                    if (engineB.world) {
                        engineA.world = engineB.world;
                        Engine.clear(engineA);
                        var bodies = Composite.allBodies(engineA.world);
                        for(var i = 0; i < bodies.length; i++){
                            var body = bodies[i];
                            Sleeping.set(body, false);
                            body.id = Common.nextId();
                        }
                    }
                };
                /**
     * Clears the engine pairs and detector.
     * @method clear
     * @param {engine} engine
     */ Engine.clear = function(engine) {
                    Pairs.clear(engine.pairs);
                    Detector.clear(engine.detector);
                };
                /**
     * Zeroes the `body.force` and `body.torque` force buffers.
     * @method _bodiesClearForces
     * @private
     * @param {body[]} bodies
     */ Engine._bodiesClearForces = function(bodies) {
                    var bodiesLength = bodies.length;
                    for(var i = 0; i < bodiesLength; i++){
                        var body = bodies[i];
                        // reset force buffers
                        body.force.x = 0;
                        body.force.y = 0;
                        body.torque = 0;
                    }
                };
                /**
     * Applies gravitational acceleration to all `bodies`.
     * This models a [uniform gravitational field](https://en.wikipedia.org/wiki/Gravity_of_Earth), similar to near the surface of a planet.
     * 
     * @method _bodiesApplyGravity
     * @private
     * @param {body[]} bodies
     * @param {vector} gravity
     */ Engine._bodiesApplyGravity = function(bodies, gravity) {
                    var gravityScale = typeof gravity.scale !== "undefined" ? gravity.scale : 0.001, bodiesLength = bodies.length;
                    if (gravity.x === 0 && gravity.y === 0 || gravityScale === 0) return;
                    for(var i = 0; i < bodiesLength; i++){
                        var body = bodies[i];
                        if (body.isStatic || body.isSleeping) continue;
                        // add the resultant force of gravity
                        body.force.y += body.mass * gravity.y * gravityScale;
                        body.force.x += body.mass * gravity.x * gravityScale;
                    }
                };
                /**
     * Applies `Body.update` to all given `bodies`.
     * @method _bodiesUpdate
     * @private
     * @param {body[]} bodies
     * @param {number} delta The amount of time elapsed between updates
     */ Engine._bodiesUpdate = function(bodies, delta) {
                    var bodiesLength = bodies.length;
                    for(var i = 0; i < bodiesLength; i++){
                        var body = bodies[i];
                        if (body.isStatic || body.isSleeping) continue;
                        Body.update(body, delta);
                    }
                };
                /**
     * Applies `Body.updateVelocities` to all given `bodies`.
     * @method _bodiesUpdateVelocities
     * @private
     * @param {body[]} bodies
     */ Engine._bodiesUpdateVelocities = function(bodies) {
                    var bodiesLength = bodies.length;
                    for(var i = 0; i < bodiesLength; i++)Body.updateVelocities(bodies[i]);
                };
            /**
     * A deprecated alias for `Runner.run`, use `Matter.Runner.run(engine)` instead and see `Matter.Runner` for more information.
     * @deprecated use Matter.Runner.run(engine) instead
     * @method run
     * @param {engine} engine
     */ /**
    * Fired just before an update
    *
    * @event beforeUpdate
    * @param {object} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {number} event.delta The delta time in milliseconds value used in the update
    * @param {engine} event.source The source object of the event
    * @param {string} event.name The name of the event
    */ /**
    * Fired after bodies updated based on their velocity and forces, but before any collision detection, constraints and resolving etc.
    *
    * @event beforeSolve
    * @param {object} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {number} event.delta The delta time in milliseconds value used in the update
    * @param {engine} event.source The source object of the event
    * @param {string} event.name The name of the event
    */ /**
    * Fired after engine update and all collision events
    *
    * @event afterUpdate
    * @param {object} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {number} event.delta The delta time in milliseconds value used in the update
    * @param {engine} event.source The source object of the event
    * @param {string} event.name The name of the event
    */ /**
    * Fired after engine update, provides a list of all pairs that have started to collide in the current tick (if any)
    *
    * @event collisionStart
    * @param {object} event An event object
    * @param {pair[]} event.pairs List of affected pairs
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {number} event.delta The delta time in milliseconds value used in the update
    * @param {engine} event.source The source object of the event
    * @param {string} event.name The name of the event
    */ /**
    * Fired after engine update, provides a list of all pairs that are colliding in the current tick (if any)
    *
    * @event collisionActive
    * @param {object} event An event object
    * @param {pair[]} event.pairs List of affected pairs
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {number} event.delta The delta time in milliseconds value used in the update
    * @param {engine} event.source The source object of the event
    * @param {string} event.name The name of the event
    */ /**
    * Fired after engine update, provides a list of all pairs that have ended collision in the current tick (if any)
    *
    * @event collisionEnd
    * @param {object} event An event object
    * @param {pair[]} event.pairs List of affected pairs
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {number} event.delta The delta time in milliseconds value used in the update
    * @param {engine} event.source The source object of the event
    * @param {string} event.name The name of the event
    */ /*
    *
    *  Properties Documentation
    *
    */ /**
     * An integer `Number` that specifies the number of position iterations to perform each update.
     * The higher the value, the higher quality the simulation will be at the expense of performance.
     *
     * @property positionIterations
     * @type number
     * @default 6
     */ /**
     * An integer `Number` that specifies the number of velocity iterations to perform each update.
     * The higher the value, the higher quality the simulation will be at the expense of performance.
     *
     * @property velocityIterations
     * @type number
     * @default 4
     */ /**
     * An integer `Number` that specifies the number of constraint iterations to perform each update.
     * The higher the value, the higher quality the simulation will be at the expense of performance.
     * The default value of `2` is usually very adequate.
     *
     * @property constraintIterations
     * @type number
     * @default 2
     */ /**
     * A flag that specifies whether the engine should allow sleeping via the `Matter.Sleeping` module.
     * Sleeping can improve stability and performance, but often at the expense of accuracy.
     *
     * @property enableSleeping
     * @type boolean
     * @default false
     */ /**
     * An `Object` containing properties regarding the timing systems of the engine. 
     *
     * @property timing
     * @type object
     */ /**
     * A `Number` that specifies the global scaling factor of time for all bodies.
     * A value of `0` freezes the simulation.
     * A value of `0.1` gives a slow-motion effect.
     * A value of `1.2` gives a speed-up effect.
     *
     * @property timing.timeScale
     * @type number
     * @default 1
     */ /**
     * A `Number` that specifies the current simulation-time in milliseconds starting from `0`. 
     * It is incremented on every `Engine.update` by the given `delta` argument. 
     * 
     * @property timing.timestamp
     * @type number
     * @default 0
     */ /**
     * A `Number` that represents the total execution time elapsed during the last `Engine.update` in milliseconds.
     * It is updated by timing from the start of the last `Engine.update` call until it ends.
     *
     * This value will also include the total execution time of all event handlers directly or indirectly triggered by the engine update.
     * 
     * @property timing.lastElapsed
     * @type number
     * @default 0
     */ /**
     * A `Number` that represents the `delta` value used in the last engine update.
     * 
     * @property timing.lastDelta
     * @type number
     * @default 0
     */ /**
     * A `Matter.Detector` instance.
     *
     * @property detector
     * @type detector
     * @default a Matter.Detector instance
     */ /**
     * A `Matter.Grid` instance.
     *
     * @deprecated replaced by `engine.detector`
     * @property grid
     * @type grid
     * @default a Matter.Grid instance
     */ /**
     * Replaced by and now alias for `engine.grid`.
     *
     * @deprecated replaced by `engine.detector`
     * @property broadphase
     * @type grid
     * @default a Matter.Grid instance
     */ /**
     * The root `Matter.Composite` instance that will contain all bodies, constraints and other composites to be simulated by this engine.
     *
     * @property world
     * @type composite
     * @default a Matter.Composite instance
     */ /**
     * An object reserved for storing plugin-specific properties.
     *
     * @property plugin
     * @type {}
     */ /**
     * An optional gravitational acceleration applied to all bodies in `engine.world` on every update.
     * 
     * This models a [uniform gravitational field](https://en.wikipedia.org/wiki/Gravity_of_Earth), similar to near the surface of a planet. For gravity in other contexts, disable this and apply forces as needed.
     * 
     * To disable set the `scale` component to `0`.
     * 
     * This is split into three components for ease of use:  
     * a normalised direction (`x` and `y`) and magnitude (`scale`).
     *
     * @property gravity
     * @type object
     */ /**
     * The gravitational direction normal `x` component, to be multiplied by `gravity.scale`.
     * 
     * @property gravity.x
     * @type object
     * @default 0
     */ /**
     * The gravitational direction normal `y` component, to be multiplied by `gravity.scale`.
     *
     * @property gravity.y
     * @type object
     * @default 1
     */ /**
     * The magnitude of the gravitational acceleration.
     * 
     * @property gravity.scale
     * @type object
     * @default 0.001
     */ })();
        /***/ },
        /* 18 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Resolver` module contains methods for resolving collision pairs.
*
* @class Resolver
*/ var Resolver = {};
            module1.exports = Resolver;
            var Vertices = __webpack_require__(3);
            var Common = __webpack_require__(0);
            var Bounds = __webpack_require__(1);
            (function() {
                Resolver._restingThresh = 2;
                Resolver._restingThreshTangent = Math.sqrt(6);
                Resolver._positionDampen = 0.9;
                Resolver._positionWarming = 0.8;
                Resolver._frictionNormalMultiplier = 5;
                Resolver._frictionMaxStatic = Number.MAX_VALUE;
                /**
     * Prepare pairs for position solving.
     * @method preSolvePosition
     * @param {pair[]} pairs
     */ Resolver.preSolvePosition = function(pairs) {
                    var i, pair, contactCount, pairsLength = pairs.length;
                    // find total contacts on each body
                    for(i = 0; i < pairsLength; i++){
                        pair = pairs[i];
                        if (!pair.isActive) continue;
                        contactCount = pair.contactCount;
                        pair.collision.parentA.totalContacts += contactCount;
                        pair.collision.parentB.totalContacts += contactCount;
                    }
                };
                /**
     * Find a solution for pair positions.
     * @method solvePosition
     * @param {pair[]} pairs
     * @param {number} delta
     * @param {number} [damping=1]
     */ Resolver.solvePosition = function(pairs, delta, damping) {
                    var i, pair, collision, bodyA, bodyB, normal, contactShare, positionImpulse, positionDampen = Resolver._positionDampen * (damping || 1), slopDampen = Common.clamp(delta / Common._baseDelta, 0, 1), pairsLength = pairs.length;
                    // find impulses required to resolve penetration
                    for(i = 0; i < pairsLength; i++){
                        pair = pairs[i];
                        if (!pair.isActive || pair.isSensor) continue;
                        collision = pair.collision;
                        bodyA = collision.parentA;
                        bodyB = collision.parentB;
                        normal = collision.normal;
                        // get current separation between body edges involved in collision
                        pair.separation = collision.depth + normal.x * (bodyB.positionImpulse.x - bodyA.positionImpulse.x) + normal.y * (bodyB.positionImpulse.y - bodyA.positionImpulse.y);
                    }
                    for(i = 0; i < pairsLength; i++){
                        pair = pairs[i];
                        if (!pair.isActive || pair.isSensor) continue;
                        collision = pair.collision;
                        bodyA = collision.parentA;
                        bodyB = collision.parentB;
                        normal = collision.normal;
                        positionImpulse = pair.separation - pair.slop * slopDampen;
                        if (bodyA.isStatic || bodyB.isStatic) positionImpulse *= 2;
                        if (!(bodyA.isStatic || bodyA.isSleeping)) {
                            contactShare = positionDampen / bodyA.totalContacts;
                            bodyA.positionImpulse.x += normal.x * positionImpulse * contactShare;
                            bodyA.positionImpulse.y += normal.y * positionImpulse * contactShare;
                        }
                        if (!(bodyB.isStatic || bodyB.isSleeping)) {
                            contactShare = positionDampen / bodyB.totalContacts;
                            bodyB.positionImpulse.x -= normal.x * positionImpulse * contactShare;
                            bodyB.positionImpulse.y -= normal.y * positionImpulse * contactShare;
                        }
                    }
                };
                /**
     * Apply position resolution.
     * @method postSolvePosition
     * @param {body[]} bodies
     */ Resolver.postSolvePosition = function(bodies) {
                    var positionWarming = Resolver._positionWarming, bodiesLength = bodies.length, verticesTranslate = Vertices.translate, boundsUpdate = Bounds.update;
                    for(var i = 0; i < bodiesLength; i++){
                        var body = bodies[i], positionImpulse = body.positionImpulse, positionImpulseX = positionImpulse.x, positionImpulseY = positionImpulse.y, velocity = body.velocity;
                        // reset contact count
                        body.totalContacts = 0;
                        if (positionImpulseX !== 0 || positionImpulseY !== 0) {
                            // update body geometry
                            for(var j = 0; j < body.parts.length; j++){
                                var part = body.parts[j];
                                verticesTranslate(part.vertices, positionImpulse);
                                boundsUpdate(part.bounds, part.vertices, velocity);
                                part.position.x += positionImpulseX;
                                part.position.y += positionImpulseY;
                            }
                            // move the body without changing velocity
                            body.positionPrev.x += positionImpulseX;
                            body.positionPrev.y += positionImpulseY;
                            if (positionImpulseX * velocity.x + positionImpulseY * velocity.y < 0) {
                                // reset cached impulse if the body has velocity along it
                                positionImpulse.x = 0;
                                positionImpulse.y = 0;
                            } else {
                                // warm the next iteration
                                positionImpulse.x *= positionWarming;
                                positionImpulse.y *= positionWarming;
                            }
                        }
                    }
                };
                /**
     * Prepare pairs for velocity solving.
     * @method preSolveVelocity
     * @param {pair[]} pairs
     */ Resolver.preSolveVelocity = function(pairs) {
                    var pairsLength = pairs.length, i, j;
                    for(i = 0; i < pairsLength; i++){
                        var pair = pairs[i];
                        if (!pair.isActive || pair.isSensor) continue;
                        var contacts = pair.contacts, contactCount = pair.contactCount, collision = pair.collision, bodyA = collision.parentA, bodyB = collision.parentB, normal = collision.normal, tangent = collision.tangent;
                        // resolve each contact
                        for(j = 0; j < contactCount; j++){
                            var contact = contacts[j], contactVertex = contact.vertex, normalImpulse = contact.normalImpulse, tangentImpulse = contact.tangentImpulse;
                            if (normalImpulse !== 0 || tangentImpulse !== 0) {
                                // total impulse from contact
                                var impulseX = normal.x * normalImpulse + tangent.x * tangentImpulse, impulseY = normal.y * normalImpulse + tangent.y * tangentImpulse;
                                // apply impulse from contact
                                if (!(bodyA.isStatic || bodyA.isSleeping)) {
                                    bodyA.positionPrev.x += impulseX * bodyA.inverseMass;
                                    bodyA.positionPrev.y += impulseY * bodyA.inverseMass;
                                    bodyA.anglePrev += bodyA.inverseInertia * ((contactVertex.x - bodyA.position.x) * impulseY - (contactVertex.y - bodyA.position.y) * impulseX);
                                }
                                if (!(bodyB.isStatic || bodyB.isSleeping)) {
                                    bodyB.positionPrev.x -= impulseX * bodyB.inverseMass;
                                    bodyB.positionPrev.y -= impulseY * bodyB.inverseMass;
                                    bodyB.anglePrev -= bodyB.inverseInertia * ((contactVertex.x - bodyB.position.x) * impulseY - (contactVertex.y - bodyB.position.y) * impulseX);
                                }
                            }
                        }
                    }
                };
                /**
     * Find a solution for pair velocities.
     * @method solveVelocity
     * @param {pair[]} pairs
     * @param {number} delta
     */ Resolver.solveVelocity = function(pairs, delta) {
                    var timeScale = delta / Common._baseDelta, timeScaleSquared = timeScale * timeScale, timeScaleCubed = timeScaleSquared * timeScale, restingThresh = -Resolver._restingThresh * timeScale, restingThreshTangent = Resolver._restingThreshTangent, frictionNormalMultiplier = Resolver._frictionNormalMultiplier * timeScale, frictionMaxStatic = Resolver._frictionMaxStatic, pairsLength = pairs.length, tangentImpulse, maxFriction, i, j;
                    for(i = 0; i < pairsLength; i++){
                        var pair = pairs[i];
                        if (!pair.isActive || pair.isSensor) continue;
                        var collision = pair.collision, bodyA = collision.parentA, bodyB = collision.parentB, normalX = collision.normal.x, normalY = collision.normal.y, tangentX = collision.tangent.x, tangentY = collision.tangent.y, inverseMassTotal = pair.inverseMass, friction = pair.friction * pair.frictionStatic * frictionNormalMultiplier, contacts = pair.contacts, contactCount = pair.contactCount, contactShare = 1 / contactCount;
                        // get body velocities
                        var bodyAVelocityX = bodyA.position.x - bodyA.positionPrev.x, bodyAVelocityY = bodyA.position.y - bodyA.positionPrev.y, bodyAAngularVelocity = bodyA.angle - bodyA.anglePrev, bodyBVelocityX = bodyB.position.x - bodyB.positionPrev.x, bodyBVelocityY = bodyB.position.y - bodyB.positionPrev.y, bodyBAngularVelocity = bodyB.angle - bodyB.anglePrev;
                        // resolve each contact
                        for(j = 0; j < contactCount; j++){
                            var contact = contacts[j], contactVertex = contact.vertex;
                            var offsetAX = contactVertex.x - bodyA.position.x, offsetAY = contactVertex.y - bodyA.position.y, offsetBX = contactVertex.x - bodyB.position.x, offsetBY = contactVertex.y - bodyB.position.y;
                            var velocityPointAX = bodyAVelocityX - offsetAY * bodyAAngularVelocity, velocityPointAY = bodyAVelocityY + offsetAX * bodyAAngularVelocity, velocityPointBX = bodyBVelocityX - offsetBY * bodyBAngularVelocity, velocityPointBY = bodyBVelocityY + offsetBX * bodyBAngularVelocity;
                            var relativeVelocityX = velocityPointAX - velocityPointBX, relativeVelocityY = velocityPointAY - velocityPointBY;
                            var normalVelocity = normalX * relativeVelocityX + normalY * relativeVelocityY, tangentVelocity = tangentX * relativeVelocityX + tangentY * relativeVelocityY;
                            // coulomb friction
                            var normalOverlap = pair.separation + normalVelocity;
                            var normalForce = Math.min(normalOverlap, 1);
                            normalForce = normalOverlap < 0 ? 0 : normalForce;
                            var frictionLimit = normalForce * friction;
                            if (tangentVelocity < -frictionLimit || tangentVelocity > frictionLimit) {
                                maxFriction = tangentVelocity > 0 ? tangentVelocity : -tangentVelocity;
                                tangentImpulse = pair.friction * (tangentVelocity > 0 ? 1 : -1) * timeScaleCubed;
                                if (tangentImpulse < -maxFriction) tangentImpulse = -maxFriction;
                                else if (tangentImpulse > maxFriction) tangentImpulse = maxFriction;
                            } else {
                                tangentImpulse = tangentVelocity;
                                maxFriction = frictionMaxStatic;
                            }
                            // account for mass, inertia and contact offset
                            var oAcN = offsetAX * normalY - offsetAY * normalX, oBcN = offsetBX * normalY - offsetBY * normalX, share = contactShare / (inverseMassTotal + bodyA.inverseInertia * oAcN * oAcN + bodyB.inverseInertia * oBcN * oBcN);
                            // raw impulses
                            var normalImpulse = (1 + pair.restitution) * normalVelocity * share;
                            tangentImpulse *= share;
                            // handle high velocity and resting collisions separately
                            if (normalVelocity < restingThresh) // high normal velocity so clear cached contact normal impulse
                            contact.normalImpulse = 0;
                            else {
                                // solve resting collision constraints using Erin Catto's method (GDC08)
                                // impulse constraint tends to 0
                                var contactNormalImpulse = contact.normalImpulse;
                                contact.normalImpulse += normalImpulse;
                                if (contact.normalImpulse > 0) contact.normalImpulse = 0;
                                normalImpulse = contact.normalImpulse - contactNormalImpulse;
                            }
                            // handle high velocity and resting collisions separately
                            if (tangentVelocity < -restingThreshTangent || tangentVelocity > restingThreshTangent) // high tangent velocity so clear cached contact tangent impulse
                            contact.tangentImpulse = 0;
                            else {
                                // solve resting collision constraints using Erin Catto's method (GDC08)
                                // tangent impulse tends to -tangentSpeed or +tangentSpeed
                                var contactTangentImpulse = contact.tangentImpulse;
                                contact.tangentImpulse += tangentImpulse;
                                if (contact.tangentImpulse < -maxFriction) contact.tangentImpulse = -maxFriction;
                                if (contact.tangentImpulse > maxFriction) contact.tangentImpulse = maxFriction;
                                tangentImpulse = contact.tangentImpulse - contactTangentImpulse;
                            }
                            // total impulse from contact
                            var impulseX = normalX * normalImpulse + tangentX * tangentImpulse, impulseY = normalY * normalImpulse + tangentY * tangentImpulse;
                            // apply impulse from contact
                            if (!(bodyA.isStatic || bodyA.isSleeping)) {
                                bodyA.positionPrev.x += impulseX * bodyA.inverseMass;
                                bodyA.positionPrev.y += impulseY * bodyA.inverseMass;
                                bodyA.anglePrev += (offsetAX * impulseY - offsetAY * impulseX) * bodyA.inverseInertia;
                            }
                            if (!(bodyB.isStatic || bodyB.isSleeping)) {
                                bodyB.positionPrev.x -= impulseX * bodyB.inverseMass;
                                bodyB.positionPrev.y -= impulseY * bodyB.inverseMass;
                                bodyB.anglePrev -= (offsetBX * impulseY - offsetBY * impulseX) * bodyB.inverseInertia;
                            }
                        }
                    }
                };
            })();
        /***/ },
        /* 19 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Pairs` module contains methods for creating and manipulating collision pair sets.
*
* @class Pairs
*/ var Pairs = {};
            module1.exports = Pairs;
            var Pair = __webpack_require__(9);
            var Common = __webpack_require__(0);
            (function() {
                /**
     * Creates a new pairs structure.
     * @method create
     * @param {object} options
     * @return {pairs} A new pairs structure
     */ Pairs.create = function(options) {
                    return Common.extend({
                        table: {},
                        list: [],
                        collisionStart: [],
                        collisionActive: [],
                        collisionEnd: []
                    }, options);
                };
                /**
     * Updates pairs given a list of collisions.
     * @method update
     * @param {object} pairs
     * @param {collision[]} collisions
     * @param {number} timestamp
     */ Pairs.update = function(pairs, collisions, timestamp) {
                    var pairUpdate = Pair.update, pairCreate = Pair.create, pairSetActive = Pair.setActive, pairsTable = pairs.table, pairsList = pairs.list, pairsListLength = pairsList.length, pairsListIndex = pairsListLength, collisionStart = pairs.collisionStart, collisionEnd = pairs.collisionEnd, collisionActive = pairs.collisionActive, collisionsLength = collisions.length, collisionStartIndex = 0, collisionEndIndex = 0, collisionActiveIndex = 0, collision, pair, i;
                    for(i = 0; i < collisionsLength; i++){
                        collision = collisions[i];
                        pair = collision.pair;
                        if (pair) {
                            // pair already exists (but may or may not be active)
                            if (pair.isActive) // pair exists and is active
                            collisionActive[collisionActiveIndex++] = pair;
                            // update the pair
                            pairUpdate(pair, collision, timestamp);
                        } else {
                            // pair did not exist, create a new pair
                            pair = pairCreate(collision, timestamp);
                            pairsTable[pair.id] = pair;
                            // add the new pair
                            collisionStart[collisionStartIndex++] = pair;
                            pairsList[pairsListIndex++] = pair;
                        }
                    }
                    // find pairs that are no longer active
                    pairsListIndex = 0;
                    pairsListLength = pairsList.length;
                    for(i = 0; i < pairsListLength; i++){
                        pair = pairsList[i];
                        // pair is active if updated this timestep
                        if (pair.timeUpdated >= timestamp) // keep active pairs
                        pairsList[pairsListIndex++] = pair;
                        else {
                            pairSetActive(pair, false, timestamp);
                            // keep inactive pairs if both bodies may be sleeping
                            if (pair.collision.bodyA.sleepCounter > 0 && pair.collision.bodyB.sleepCounter > 0) pairsList[pairsListIndex++] = pair;
                            else {
                                // remove inactive pairs if either body awake
                                collisionEnd[collisionEndIndex++] = pair;
                                delete pairsTable[pair.id];
                            }
                        }
                    }
                    // update array lengths if changed
                    if (pairsList.length !== pairsListIndex) pairsList.length = pairsListIndex;
                    if (collisionStart.length !== collisionStartIndex) collisionStart.length = collisionStartIndex;
                    if (collisionEnd.length !== collisionEndIndex) collisionEnd.length = collisionEndIndex;
                    if (collisionActive.length !== collisionActiveIndex) collisionActive.length = collisionActiveIndex;
                };
                /**
     * Clears the given pairs structure.
     * @method clear
     * @param {pairs} pairs
     * @return {pairs} pairs
     */ Pairs.clear = function(pairs) {
                    pairs.table = {};
                    pairs.list.length = 0;
                    pairs.collisionStart.length = 0;
                    pairs.collisionActive.length = 0;
                    pairs.collisionEnd.length = 0;
                    return pairs;
                };
            })();
        /***/ },
        /* 20 */ /***/ function(module1, exports, __webpack_require__) {
            var Matter = module1.exports = __webpack_require__(21);
            Matter.Axes = __webpack_require__(11);
            Matter.Bodies = __webpack_require__(12);
            Matter.Body = __webpack_require__(4);
            Matter.Bounds = __webpack_require__(1);
            Matter.Collision = __webpack_require__(8);
            Matter.Common = __webpack_require__(0);
            Matter.Composite = __webpack_require__(6);
            Matter.Composites = __webpack_require__(22);
            Matter.Constraint = __webpack_require__(10);
            Matter.Contact = __webpack_require__(16);
            Matter.Detector = __webpack_require__(13);
            Matter.Engine = __webpack_require__(17);
            Matter.Events = __webpack_require__(5);
            Matter.Grid = __webpack_require__(23);
            Matter.Mouse = __webpack_require__(14);
            Matter.MouseConstraint = __webpack_require__(24);
            Matter.Pair = __webpack_require__(9);
            Matter.Pairs = __webpack_require__(19);
            Matter.Plugin = __webpack_require__(15);
            Matter.Query = __webpack_require__(25);
            Matter.Render = __webpack_require__(26);
            Matter.Resolver = __webpack_require__(18);
            Matter.Runner = __webpack_require__(27);
            Matter.SAT = __webpack_require__(28);
            Matter.Sleeping = __webpack_require__(7);
            Matter.Svg = __webpack_require__(29);
            Matter.Vector = __webpack_require__(2);
            Matter.Vertices = __webpack_require__(3);
            Matter.World = __webpack_require__(30);
            // temporary back compatibility
            Matter.Engine.run = Matter.Runner.run;
            Matter.Common.deprecated(Matter.Engine, "run", "Engine.run \u27A4 use Matter.Runner.run(engine) instead");
        /***/ },
        /* 21 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter` module is the top level namespace. It also includes a function for installing plugins on top of the library.
*
* @class Matter
*/ var Matter = {};
            module1.exports = Matter;
            var Plugin = __webpack_require__(15);
            var Common = __webpack_require__(0);
            (function() {
                /**
     * The library name.
     * @property name
     * @readOnly
     * @type {String}
     */ Matter.name = "matter-js";
                /**
     * The library version.
     * @property version
     * @readOnly
     * @type {String}
     */ Matter.version = "0.20.0";
                /**
     * A list of plugin dependencies to be installed. These are normally set and installed through `Matter.use`.
     * Alternatively you may set `Matter.uses` manually and install them by calling `Plugin.use(Matter)`.
     * @property uses
     * @type {Array}
     */ Matter.uses = [];
                /**
     * The plugins that have been installed through `Matter.Plugin.install`. Read only.
     * @property used
     * @readOnly
     * @type {Array}
     */ Matter.used = [];
                /**
     * Installs the given plugins on the `Matter` namespace.
     * This is a short-hand for `Plugin.use`, see it for more information.
     * Call this function once at the start of your code, with all of the plugins you wish to install as arguments.
     * Avoid calling this function multiple times unless you intend to manually control installation order.
     * @method use
     * @param ...plugin {Function} The plugin(s) to install on `base` (multi-argument).
     */ Matter.use = function() {
                    Plugin.use(Matter, Array.prototype.slice.call(arguments));
                };
                /**
     * Chains a function to excute before the original function on the given `path` relative to `Matter`.
     * See also docs for `Common.chain`.
     * @method before
     * @param {string} path The path relative to `Matter`
     * @param {function} func The function to chain before the original
     * @return {function} The chained function that replaced the original
     */ Matter.before = function(path, func) {
                    path = path.replace(/^Matter./, "");
                    return Common.chainPathBefore(Matter, path, func);
                };
                /**
     * Chains a function to excute after the original function on the given `path` relative to `Matter`.
     * See also docs for `Common.chain`.
     * @method after
     * @param {string} path The path relative to `Matter`
     * @param {function} func The function to chain after the original
     * @return {function} The chained function that replaced the original
     */ Matter.after = function(path, func) {
                    path = path.replace(/^Matter./, "");
                    return Common.chainPathAfter(Matter, path, func);
                };
            })();
        /***/ },
        /* 22 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Composites` module contains factory methods for creating composite bodies
* with commonly used configurations (such as stacks and chains).
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Composites
*/ var Composites = {};
            module1.exports = Composites;
            var Composite = __webpack_require__(6);
            var Constraint = __webpack_require__(10);
            var Common = __webpack_require__(0);
            var Body = __webpack_require__(4);
            var Bodies = __webpack_require__(12);
            var deprecated = Common.deprecated;
            (function() {
                /**
     * Create a new composite containing bodies created in the callback in a grid arrangement.
     * This function uses the body's bounds to prevent overlaps.
     * @method stack
     * @param {number} x Starting position in X.
     * @param {number} y Starting position in Y.
     * @param {number} columns
     * @param {number} rows
     * @param {number} columnGap
     * @param {number} rowGap
     * @param {function} callback
     * @return {composite} A new composite containing objects created in the callback
     */ Composites.stack = function(x, y, columns, rows, columnGap, rowGap, callback) {
                    var stack = Composite.create({
                        label: "Stack"
                    }), currentX = x, currentY = y, lastBody, i = 0;
                    for(var row = 0; row < rows; row++){
                        var maxHeight = 0;
                        for(var column = 0; column < columns; column++){
                            var body = callback(currentX, currentY, column, row, lastBody, i);
                            if (body) {
                                var bodyHeight = body.bounds.max.y - body.bounds.min.y, bodyWidth = body.bounds.max.x - body.bounds.min.x;
                                if (bodyHeight > maxHeight) maxHeight = bodyHeight;
                                Body.translate(body, {
                                    x: bodyWidth * 0.5,
                                    y: bodyHeight * 0.5
                                });
                                currentX = body.bounds.max.x + columnGap;
                                Composite.addBody(stack, body);
                                lastBody = body;
                                i += 1;
                            } else currentX += columnGap;
                        }
                        currentY += maxHeight + rowGap;
                        currentX = x;
                    }
                    return stack;
                };
                /**
     * Chains all bodies in the given composite together using constraints.
     * @method chain
     * @param {composite} composite
     * @param {number} xOffsetA
     * @param {number} yOffsetA
     * @param {number} xOffsetB
     * @param {number} yOffsetB
     * @param {object} options
     * @return {composite} A new composite containing objects chained together with constraints
     */ Composites.chain = function(composite, xOffsetA, yOffsetA, xOffsetB, yOffsetB, options) {
                    var bodies = composite.bodies;
                    for(var i = 1; i < bodies.length; i++){
                        var bodyA = bodies[i - 1], bodyB = bodies[i], bodyAHeight = bodyA.bounds.max.y - bodyA.bounds.min.y, bodyAWidth = bodyA.bounds.max.x - bodyA.bounds.min.x, bodyBHeight = bodyB.bounds.max.y - bodyB.bounds.min.y, bodyBWidth = bodyB.bounds.max.x - bodyB.bounds.min.x;
                        var defaults = {
                            bodyA: bodyA,
                            pointA: {
                                x: bodyAWidth * xOffsetA,
                                y: bodyAHeight * yOffsetA
                            },
                            bodyB: bodyB,
                            pointB: {
                                x: bodyBWidth * xOffsetB,
                                y: bodyBHeight * yOffsetB
                            }
                        };
                        var constraint = Common.extend(defaults, options);
                        Composite.addConstraint(composite, Constraint.create(constraint));
                    }
                    composite.label += " Chain";
                    return composite;
                };
                /**
     * Connects bodies in the composite with constraints in a grid pattern, with optional cross braces.
     * @method mesh
     * @param {composite} composite
     * @param {number} columns
     * @param {number} rows
     * @param {boolean} crossBrace
     * @param {object} options
     * @return {composite} The composite containing objects meshed together with constraints
     */ Composites.mesh = function(composite, columns, rows, crossBrace, options) {
                    var bodies = composite.bodies, row, col, bodyA, bodyB, bodyC;
                    for(row = 0; row < rows; row++){
                        for(col = 1; col < columns; col++){
                            bodyA = bodies[col - 1 + row * columns];
                            bodyB = bodies[col + row * columns];
                            Composite.addConstraint(composite, Constraint.create(Common.extend({
                                bodyA: bodyA,
                                bodyB: bodyB
                            }, options)));
                        }
                        if (row > 0) for(col = 0; col < columns; col++){
                            bodyA = bodies[col + (row - 1) * columns];
                            bodyB = bodies[col + row * columns];
                            Composite.addConstraint(composite, Constraint.create(Common.extend({
                                bodyA: bodyA,
                                bodyB: bodyB
                            }, options)));
                            if (crossBrace && col > 0) {
                                bodyC = bodies[col - 1 + (row - 1) * columns];
                                Composite.addConstraint(composite, Constraint.create(Common.extend({
                                    bodyA: bodyC,
                                    bodyB: bodyB
                                }, options)));
                            }
                            if (crossBrace && col < columns - 1) {
                                bodyC = bodies[col + 1 + (row - 1) * columns];
                                Composite.addConstraint(composite, Constraint.create(Common.extend({
                                    bodyA: bodyC,
                                    bodyB: bodyB
                                }, options)));
                            }
                        }
                    }
                    composite.label += " Mesh";
                    return composite;
                };
                /**
     * Create a new composite containing bodies created in the callback in a pyramid arrangement.
     * This function uses the body's bounds to prevent overlaps.
     * @method pyramid
     * @param {number} x Starting position in X.
     * @param {number} y Starting position in Y.
     * @param {number} columns
     * @param {number} rows
     * @param {number} columnGap
     * @param {number} rowGap
     * @param {function} callback
     * @return {composite} A new composite containing objects created in the callback
     */ Composites.pyramid = function(x, y, columns, rows, columnGap, rowGap, callback) {
                    return Composites.stack(x, y, columns, rows, columnGap, rowGap, function(stackX, stackY, column, row, lastBody, i) {
                        var actualRows = Math.min(rows, Math.ceil(columns / 2)), lastBodyWidth = lastBody ? lastBody.bounds.max.x - lastBody.bounds.min.x : 0;
                        if (row > actualRows) return;
                        // reverse row order
                        row = actualRows - row;
                        var start = row, end = columns - 1 - row;
                        if (column < start || column > end) return;
                        // retroactively fix the first body's position, since width was unknown
                        if (i === 1) Body.translate(lastBody, {
                            x: (column + (columns % 2 === 1 ? 1 : -1)) * lastBodyWidth,
                            y: 0
                        });
                        var xOffset = lastBody ? column * lastBodyWidth : 0;
                        return callback(x + xOffset + column * columnGap, stackY, column, row, lastBody, i);
                    });
                };
                /**
     * This has now moved to the [newtonsCradle example](https://github.com/liabru/matter-js/blob/master/examples/newtonsCradle.js), follow that instead as this function is deprecated here.
     * @deprecated moved to newtonsCradle example
     * @method newtonsCradle
     * @param {number} x Starting position in X.
     * @param {number} y Starting position in Y.
     * @param {number} number
     * @param {number} size
     * @param {number} length
     * @return {composite} A new composite newtonsCradle body
     */ Composites.newtonsCradle = function(x, y, number, size, length) {
                    var newtonsCradle = Composite.create({
                        label: "Newtons Cradle"
                    });
                    for(var i = 0; i < number; i++){
                        var separation = 1.9, circle = Bodies.circle(x + i * (size * separation), y + length, size, {
                            inertia: Infinity,
                            restitution: 1,
                            friction: 0,
                            frictionAir: 0.0001,
                            slop: 1
                        }), constraint = Constraint.create({
                            pointA: {
                                x: x + i * (size * separation),
                                y: y
                            },
                            bodyB: circle
                        });
                        Composite.addBody(newtonsCradle, circle);
                        Composite.addConstraint(newtonsCradle, constraint);
                    }
                    return newtonsCradle;
                };
                deprecated(Composites, "newtonsCradle", "Composites.newtonsCradle \u27A4 moved to newtonsCradle example");
                /**
     * This has now moved to the [car example](https://github.com/liabru/matter-js/blob/master/examples/car.js), follow that instead as this function is deprecated here.
     * @deprecated moved to car example
     * @method car
     * @param {number} x Starting position in X.
     * @param {number} y Starting position in Y.
     * @param {number} width
     * @param {number} height
     * @param {number} wheelSize
     * @return {composite} A new composite car body
     */ Composites.car = function(x, y, width, height, wheelSize) {
                    var group = Body.nextGroup(true), wheelBase = 20, wheelAOffset = -width * 0.5 + wheelBase, wheelBOffset = width * 0.5 - wheelBase, wheelYOffset = 0;
                    var car = Composite.create({
                        label: "Car"
                    }), body = Bodies.rectangle(x, y, width, height, {
                        collisionFilter: {
                            group: group
                        },
                        chamfer: {
                            radius: height * 0.5
                        },
                        density: 0.0002
                    });
                    var wheelA = Bodies.circle(x + wheelAOffset, y + wheelYOffset, wheelSize, {
                        collisionFilter: {
                            group: group
                        },
                        friction: 0.8
                    });
                    var wheelB = Bodies.circle(x + wheelBOffset, y + wheelYOffset, wheelSize, {
                        collisionFilter: {
                            group: group
                        },
                        friction: 0.8
                    });
                    var axelA = Constraint.create({
                        bodyB: body,
                        pointB: {
                            x: wheelAOffset,
                            y: wheelYOffset
                        },
                        bodyA: wheelA,
                        stiffness: 1,
                        length: 0
                    });
                    var axelB = Constraint.create({
                        bodyB: body,
                        pointB: {
                            x: wheelBOffset,
                            y: wheelYOffset
                        },
                        bodyA: wheelB,
                        stiffness: 1,
                        length: 0
                    });
                    Composite.addBody(car, body);
                    Composite.addBody(car, wheelA);
                    Composite.addBody(car, wheelB);
                    Composite.addConstraint(car, axelA);
                    Composite.addConstraint(car, axelB);
                    return car;
                };
                deprecated(Composites, "car", "Composites.car \u27A4 moved to car example");
                /**
     * This has now moved to the [softBody example](https://github.com/liabru/matter-js/blob/master/examples/softBody.js)
     * and the [cloth example](https://github.com/liabru/matter-js/blob/master/examples/cloth.js), follow those instead as this function is deprecated here.
     * @deprecated moved to softBody and cloth examples
     * @method softBody
     * @param {number} x Starting position in X.
     * @param {number} y Starting position in Y.
     * @param {number} columns
     * @param {number} rows
     * @param {number} columnGap
     * @param {number} rowGap
     * @param {boolean} crossBrace
     * @param {number} particleRadius
     * @param {} particleOptions
     * @param {} constraintOptions
     * @return {composite} A new composite softBody
     */ Composites.softBody = function(x, y, columns, rows, columnGap, rowGap, crossBrace, particleRadius, particleOptions, constraintOptions) {
                    particleOptions = Common.extend({
                        inertia: Infinity
                    }, particleOptions);
                    constraintOptions = Common.extend({
                        stiffness: 0.2,
                        render: {
                            type: "line",
                            anchors: false
                        }
                    }, constraintOptions);
                    var softBody = Composites.stack(x, y, columns, rows, columnGap, rowGap, function(stackX, stackY) {
                        return Bodies.circle(stackX, stackY, particleRadius, particleOptions);
                    });
                    Composites.mesh(softBody, columns, rows, crossBrace, constraintOptions);
                    softBody.label = "Soft Body";
                    return softBody;
                };
                deprecated(Composites, "softBody", "Composites.softBody \u27A4 moved to softBody and cloth examples");
            })();
        /***/ },
        /* 23 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* This module has now been replaced by `Matter.Detector`.
*
* All usage should be migrated to `Matter.Detector` or another alternative.
* For back-compatibility purposes this module will remain for a short term and then later removed in a future release.
*
* The `Matter.Grid` module contains methods for creating and manipulating collision broadphase grid structures.
*
* @class Grid
* @deprecated
*/ var Grid = {};
            module1.exports = Grid;
            var Pair = __webpack_require__(9);
            var Common = __webpack_require__(0);
            var deprecated = Common.deprecated;
            (function() {
                /**
     * Creates a new grid.
     * @deprecated replaced by Matter.Detector
     * @method create
     * @param {} options
     * @return {grid} A new grid
     */ Grid.create = function(options) {
                    var defaults = {
                        buckets: {},
                        pairs: {},
                        pairsList: [],
                        bucketWidth: 48,
                        bucketHeight: 48
                    };
                    return Common.extend(defaults, options);
                };
                /**
     * The width of a single grid bucket.
     *
     * @property bucketWidth
     * @type number
     * @default 48
     */ /**
     * The height of a single grid bucket.
     *
     * @property bucketHeight
     * @type number
     * @default 48
     */ /**
     * Updates the grid.
     * @deprecated replaced by Matter.Detector
     * @method update
     * @param {grid} grid
     * @param {body[]} bodies
     * @param {engine} engine
     * @param {boolean} forceUpdate
     */ Grid.update = function(grid, bodies, engine, forceUpdate) {
                    var i, col, row, world = engine.world, buckets = grid.buckets, bucket, bucketId, gridChanged = false;
                    for(i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        if (body.isSleeping && !forceUpdate) continue;
                        // temporary back compatibility bounds check
                        if (world.bounds && (body.bounds.max.x < world.bounds.min.x || body.bounds.min.x > world.bounds.max.x || body.bounds.max.y < world.bounds.min.y || body.bounds.min.y > world.bounds.max.y)) continue;
                        var newRegion = Grid._getRegion(grid, body);
                        // if the body has changed grid region
                        if (!body.region || newRegion.id !== body.region.id || forceUpdate) {
                            if (!body.region || forceUpdate) body.region = newRegion;
                            var union = Grid._regionUnion(newRegion, body.region);
                            // update grid buckets affected by region change
                            // iterate over the union of both regions
                            for(col = union.startCol; col <= union.endCol; col++)for(row = union.startRow; row <= union.endRow; row++){
                                bucketId = Grid._getBucketId(col, row);
                                bucket = buckets[bucketId];
                                var isInsideNewRegion = col >= newRegion.startCol && col <= newRegion.endCol && row >= newRegion.startRow && row <= newRegion.endRow;
                                var isInsideOldRegion = col >= body.region.startCol && col <= body.region.endCol && row >= body.region.startRow && row <= body.region.endRow;
                                // remove from old region buckets
                                if (!isInsideNewRegion && isInsideOldRegion) {
                                    if (isInsideOldRegion) {
                                        if (bucket) Grid._bucketRemoveBody(grid, bucket, body);
                                    }
                                }
                                // add to new region buckets
                                if (body.region === newRegion || isInsideNewRegion && !isInsideOldRegion || forceUpdate) {
                                    if (!bucket) bucket = Grid._createBucket(buckets, bucketId);
                                    Grid._bucketAddBody(grid, bucket, body);
                                }
                            }
                            // set the new region
                            body.region = newRegion;
                            // flag changes so we can update pairs
                            gridChanged = true;
                        }
                    }
                    // update pairs list only if pairs changed (i.e. a body changed region)
                    if (gridChanged) grid.pairsList = Grid._createActivePairsList(grid);
                };
                deprecated(Grid, "update", "Grid.update \u27A4 replaced by Matter.Detector");
                /**
     * Clears the grid.
     * @deprecated replaced by Matter.Detector
     * @method clear
     * @param {grid} grid
     */ Grid.clear = function(grid) {
                    grid.buckets = {};
                    grid.pairs = {};
                    grid.pairsList = [];
                };
                deprecated(Grid, "clear", "Grid.clear \u27A4 replaced by Matter.Detector");
                /**
     * Finds the union of two regions.
     * @method _regionUnion
     * @deprecated replaced by Matter.Detector
     * @private
     * @param {} regionA
     * @param {} regionB
     * @return {} region
     */ Grid._regionUnion = function(regionA, regionB) {
                    var startCol = Math.min(regionA.startCol, regionB.startCol), endCol = Math.max(regionA.endCol, regionB.endCol), startRow = Math.min(regionA.startRow, regionB.startRow), endRow = Math.max(regionA.endRow, regionB.endRow);
                    return Grid._createRegion(startCol, endCol, startRow, endRow);
                };
                /**
     * Gets the region a given body falls in for a given grid.
     * @method _getRegion
     * @deprecated replaced by Matter.Detector
     * @private
     * @param {} grid
     * @param {} body
     * @return {} region
     */ Grid._getRegion = function(grid, body) {
                    var bounds = body.bounds, startCol = Math.floor(bounds.min.x / grid.bucketWidth), endCol = Math.floor(bounds.max.x / grid.bucketWidth), startRow = Math.floor(bounds.min.y / grid.bucketHeight), endRow = Math.floor(bounds.max.y / grid.bucketHeight);
                    return Grid._createRegion(startCol, endCol, startRow, endRow);
                };
                /**
     * Creates a region.
     * @method _createRegion
     * @deprecated replaced by Matter.Detector
     * @private
     * @param {} startCol
     * @param {} endCol
     * @param {} startRow
     * @param {} endRow
     * @return {} region
     */ Grid._createRegion = function(startCol, endCol, startRow, endRow) {
                    return {
                        id: startCol + "," + endCol + "," + startRow + "," + endRow,
                        startCol: startCol,
                        endCol: endCol,
                        startRow: startRow,
                        endRow: endRow
                    };
                };
                /**
     * Gets the bucket id at the given position.
     * @method _getBucketId
     * @deprecated replaced by Matter.Detector
     * @private
     * @param {} column
     * @param {} row
     * @return {string} bucket id
     */ Grid._getBucketId = function(column, row) {
                    return "C" + column + "R" + row;
                };
                /**
     * Creates a bucket.
     * @method _createBucket
     * @deprecated replaced by Matter.Detector
     * @private
     * @param {} buckets
     * @param {} bucketId
     * @return {} bucket
     */ Grid._createBucket = function(buckets, bucketId) {
                    var bucket = buckets[bucketId] = [];
                    return bucket;
                };
                /**
     * Adds a body to a bucket.
     * @method _bucketAddBody
     * @deprecated replaced by Matter.Detector
     * @private
     * @param {} grid
     * @param {} bucket
     * @param {} body
     */ Grid._bucketAddBody = function(grid, bucket, body) {
                    var gridPairs = grid.pairs, pairId = Pair.id, bucketLength = bucket.length, i;
                    // add new pairs
                    for(i = 0; i < bucketLength; i++){
                        var bodyB = bucket[i];
                        if (body.id === bodyB.id || body.isStatic && bodyB.isStatic) continue;
                        // keep track of the number of buckets the pair exists in
                        // important for Grid.update to work
                        var id = pairId(body, bodyB), pair = gridPairs[id];
                        if (pair) pair[2] += 1;
                        else gridPairs[id] = [
                            body,
                            bodyB,
                            1
                        ];
                    }
                    // add to bodies (after pairs, otherwise pairs with self)
                    bucket.push(body);
                };
                /**
     * Removes a body from a bucket.
     * @method _bucketRemoveBody
     * @deprecated replaced by Matter.Detector
     * @private
     * @param {} grid
     * @param {} bucket
     * @param {} body
     */ Grid._bucketRemoveBody = function(grid, bucket, body) {
                    var gridPairs = grid.pairs, pairId = Pair.id, i;
                    // remove from bucket
                    bucket.splice(Common.indexOf(bucket, body), 1);
                    var bucketLength = bucket.length;
                    // update pair counts
                    for(i = 0; i < bucketLength; i++){
                        // keep track of the number of buckets the pair exists in
                        // important for _createActivePairsList to work
                        var pair = gridPairs[pairId(body, bucket[i])];
                        if (pair) pair[2] -= 1;
                    }
                };
                /**
     * Generates a list of the active pairs in the grid.
     * @method _createActivePairsList
     * @deprecated replaced by Matter.Detector
     * @private
     * @param {} grid
     * @return [] pairs
     */ Grid._createActivePairsList = function(grid) {
                    var pair, gridPairs = grid.pairs, pairKeys = Common.keys(gridPairs), pairKeysLength = pairKeys.length, pairs = [], k;
                    // iterate over grid.pairs
                    for(k = 0; k < pairKeysLength; k++){
                        pair = gridPairs[pairKeys[k]];
                        // if pair exists in at least one bucket
                        // it is a pair that needs further collision testing so push it
                        if (pair[2] > 0) pairs.push(pair);
                        else delete gridPairs[pairKeys[k]];
                    }
                    return pairs;
                };
            })();
        /***/ },
        /* 24 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.MouseConstraint` module contains methods for creating mouse constraints.
* Mouse constraints are used for allowing user interaction, providing the ability to move bodies via the mouse or touch.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class MouseConstraint
*/ var MouseConstraint = {};
            module1.exports = MouseConstraint;
            var Vertices = __webpack_require__(3);
            var Sleeping = __webpack_require__(7);
            var Mouse = __webpack_require__(14);
            var Events = __webpack_require__(5);
            var Detector = __webpack_require__(13);
            var Constraint = __webpack_require__(10);
            var Composite = __webpack_require__(6);
            var Common = __webpack_require__(0);
            var Bounds = __webpack_require__(1);
            (function() {
                /**
     * Creates a new mouse constraint.
     * All properties have default values, and many are pre-calculated automatically based on other properties.
     * See the properties section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @param {engine} engine
     * @param {} options
     * @return {MouseConstraint} A new MouseConstraint
     */ MouseConstraint.create = function(engine, options) {
                    var mouse = (engine ? engine.mouse : null) || (options ? options.mouse : null);
                    if (!mouse) {
                        if (engine && engine.render && engine.render.canvas) mouse = Mouse.create(engine.render.canvas);
                        else if (options && options.element) mouse = Mouse.create(options.element);
                        else {
                            mouse = Mouse.create();
                            Common.warn("MouseConstraint.create: options.mouse was undefined, options.element was undefined, may not function as expected");
                        }
                    }
                    var constraint = Constraint.create({
                        label: "Mouse Constraint",
                        pointA: mouse.position,
                        pointB: {
                            x: 0,
                            y: 0
                        },
                        length: 0.01,
                        stiffness: 0.1,
                        angularStiffness: 1,
                        render: {
                            strokeStyle: "#90EE90",
                            lineWidth: 3
                        }
                    });
                    var defaults = {
                        type: "mouseConstraint",
                        mouse: mouse,
                        element: null,
                        body: null,
                        constraint: constraint,
                        collisionFilter: {
                            category: 0x0001,
                            mask: 0xFFFFFFFF,
                            group: 0
                        }
                    };
                    var mouseConstraint = Common.extend(defaults, options);
                    Events.on(engine, "beforeUpdate", function() {
                        var allBodies = Composite.allBodies(engine.world);
                        MouseConstraint.update(mouseConstraint, allBodies);
                        MouseConstraint._triggerEvents(mouseConstraint);
                    });
                    return mouseConstraint;
                };
                /**
     * Updates the given mouse constraint.
     * @private
     * @method update
     * @param {MouseConstraint} mouseConstraint
     * @param {body[]} bodies
     */ MouseConstraint.update = function(mouseConstraint, bodies) {
                    var mouse = mouseConstraint.mouse, constraint = mouseConstraint.constraint, body = mouseConstraint.body;
                    if (mouse.button === 0) {
                        if (!constraint.bodyB) for(var i = 0; i < bodies.length; i++){
                            body = bodies[i];
                            if (Bounds.contains(body.bounds, mouse.position) && Detector.canCollide(body.collisionFilter, mouseConstraint.collisionFilter)) for(var j = body.parts.length > 1 ? 1 : 0; j < body.parts.length; j++){
                                var part = body.parts[j];
                                if (Vertices.contains(part.vertices, mouse.position)) {
                                    constraint.pointA = mouse.position;
                                    constraint.bodyB = mouseConstraint.body = body;
                                    constraint.pointB = {
                                        x: mouse.position.x - body.position.x,
                                        y: mouse.position.y - body.position.y
                                    };
                                    constraint.angleB = body.angle;
                                    Sleeping.set(body, false);
                                    Events.trigger(mouseConstraint, "startdrag", {
                                        mouse: mouse,
                                        body: body
                                    });
                                    break;
                                }
                            }
                        }
                        else {
                            Sleeping.set(constraint.bodyB, false);
                            constraint.pointA = mouse.position;
                        }
                    } else {
                        constraint.bodyB = mouseConstraint.body = null;
                        constraint.pointB = null;
                        if (body) Events.trigger(mouseConstraint, "enddrag", {
                            mouse: mouse,
                            body: body
                        });
                    }
                };
                /**
     * Triggers mouse constraint events.
     * @method _triggerEvents
     * @private
     * @param {mouse} mouseConstraint
     */ MouseConstraint._triggerEvents = function(mouseConstraint) {
                    var mouse = mouseConstraint.mouse, mouseEvents = mouse.sourceEvents;
                    if (mouseEvents.mousemove) Events.trigger(mouseConstraint, "mousemove", {
                        mouse: mouse
                    });
                    if (mouseEvents.mousedown) Events.trigger(mouseConstraint, "mousedown", {
                        mouse: mouse
                    });
                    if (mouseEvents.mouseup) Events.trigger(mouseConstraint, "mouseup", {
                        mouse: mouse
                    });
                    // reset the mouse state ready for the next step
                    Mouse.clearSourceEvents(mouse);
                };
            /*
    *
    *  Events Documentation
    *
    */ /**
    * Fired when the mouse has moved (or a touch moves) during the last step
    *
    * @event mousemove
    * @param {} event An event object
    * @param {mouse} event.mouse The engine's mouse instance
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when the mouse is down (or a touch has started) during the last step
    *
    * @event mousedown
    * @param {} event An event object
    * @param {mouse} event.mouse The engine's mouse instance
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when the mouse is up (or a touch has ended) during the last step
    *
    * @event mouseup
    * @param {} event An event object
    * @param {mouse} event.mouse The engine's mouse instance
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when the user starts dragging a body
    *
    * @event startdrag
    * @param {} event An event object
    * @param {mouse} event.mouse The engine's mouse instance
    * @param {body} event.body The body being dragged
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired when the user ends dragging a body
    *
    * @event enddrag
    * @param {} event An event object
    * @param {mouse} event.mouse The engine's mouse instance
    * @param {body} event.body The body that has stopped being dragged
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /*
    *
    *  Properties Documentation
    *
    */ /**
     * A `String` denoting the type of object.
     *
     * @property type
     * @type string
     * @default "constraint"
     * @readOnly
     */ /**
     * The `Mouse` instance in use. If not supplied in `MouseConstraint.create`, one will be created.
     *
     * @property mouse
     * @type mouse
     * @default mouse
     */ /**
     * The `Body` that is currently being moved by the user, or `null` if no body.
     *
     * @property body
     * @type body
     * @default null
     */ /**
     * The `Constraint` object that is used to move the body during interaction.
     *
     * @property constraint
     * @type constraint
     */ /**
     * An `Object` that specifies the collision filter properties.
     * The collision filter allows the user to define which types of body this mouse constraint can interact with.
     * See `body.collisionFilter` for more information.
     *
     * @property collisionFilter
     * @type object
     */ })();
        /***/ },
        /* 25 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Query` module contains methods for performing collision queries.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Query
*/ var Query = {};
            module1.exports = Query;
            var Vector = __webpack_require__(2);
            var Collision = __webpack_require__(8);
            var Bounds = __webpack_require__(1);
            var Bodies = __webpack_require__(12);
            var Vertices = __webpack_require__(3);
            (function() {
                /**
     * Returns a list of collisions between `body` and `bodies`.
     * @method collides
     * @param {body} body
     * @param {body[]} bodies
     * @return {collision[]} Collisions
     */ Query.collides = function(body, bodies) {
                    var collisions = [], bodiesLength = bodies.length, bounds = body.bounds, collides = Collision.collides, overlaps = Bounds.overlaps;
                    for(var i = 0; i < bodiesLength; i++){
                        var bodyA = bodies[i], partsALength = bodyA.parts.length, partsAStart = partsALength === 1 ? 0 : 1;
                        if (overlaps(bodyA.bounds, bounds)) for(var j = partsAStart; j < partsALength; j++){
                            var part = bodyA.parts[j];
                            if (overlaps(part.bounds, bounds)) {
                                var collision = collides(part, body);
                                if (collision) {
                                    collisions.push(collision);
                                    break;
                                }
                            }
                        }
                    }
                    return collisions;
                };
                /**
     * Casts a ray segment against a set of bodies and returns all collisions, ray width is optional. Intersection points are not provided.
     * @method ray
     * @param {body[]} bodies
     * @param {vector} startPoint
     * @param {vector} endPoint
     * @param {number} [rayWidth]
     * @return {collision[]} Collisions
     */ Query.ray = function(bodies, startPoint, endPoint, rayWidth) {
                    rayWidth = rayWidth || 1e-100;
                    var rayAngle = Vector.angle(startPoint, endPoint), rayLength = Vector.magnitude(Vector.sub(startPoint, endPoint)), rayX = (endPoint.x + startPoint.x) * 0.5, rayY = (endPoint.y + startPoint.y) * 0.5, ray = Bodies.rectangle(rayX, rayY, rayLength, rayWidth, {
                        angle: rayAngle
                    }), collisions = Query.collides(ray, bodies);
                    for(var i = 0; i < collisions.length; i += 1){
                        var collision = collisions[i];
                        collision.body = collision.bodyB = collision.bodyA;
                    }
                    return collisions;
                };
                /**
     * Returns all bodies whose bounds are inside (or outside if set) the given set of bounds, from the given set of bodies.
     * @method region
     * @param {body[]} bodies
     * @param {bounds} bounds
     * @param {bool} [outside=false]
     * @return {body[]} The bodies matching the query
     */ Query.region = function(bodies, bounds, outside) {
                    var result = [];
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i], overlaps = Bounds.overlaps(body.bounds, bounds);
                        if (overlaps && !outside || !overlaps && outside) result.push(body);
                    }
                    return result;
                };
                /**
     * Returns all bodies whose vertices contain the given point, from the given set of bodies.
     * @method point
     * @param {body[]} bodies
     * @param {vector} point
     * @return {body[]} The bodies matching the query
     */ Query.point = function(bodies, point) {
                    var result = [];
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        if (Bounds.contains(body.bounds, point)) for(var j = body.parts.length === 1 ? 0 : 1; j < body.parts.length; j++){
                            var part = body.parts[j];
                            if (Bounds.contains(part.bounds, point) && Vertices.contains(part.vertices, point)) {
                                result.push(body);
                                break;
                            }
                        }
                    }
                    return result;
                };
            })();
        /***/ },
        /* 26 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Render` module is a lightweight, optional utility which provides a simple canvas based renderer for visualising instances of `Matter.Engine`.
* It is intended for development and debugging purposes, but may also be suitable for simple games.
* It includes a number of drawing options including wireframe, vector with support for sprites and viewports.
*
* @class Render
*/ var Render = {};
            module1.exports = Render;
            var Body = __webpack_require__(4);
            var Common = __webpack_require__(0);
            var Composite = __webpack_require__(6);
            var Bounds = __webpack_require__(1);
            var Events = __webpack_require__(5);
            var Vector = __webpack_require__(2);
            var Mouse = __webpack_require__(14);
            (function() {
                var _requestAnimationFrame, _cancelAnimationFrame;
                if (typeof window !== "undefined") {
                    _requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || function(callback) {
                        window.setTimeout(function() {
                            callback(Common.now());
                        }, 1000 / 60);
                    };
                    _cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.msCancelAnimationFrame;
                }
                Render._goodFps = 30;
                Render._goodDelta = 1000 / 60;
                /**
     * Creates a new renderer. The options parameter is an object that specifies any properties you wish to override the defaults.
     * All properties have default values, and many are pre-calculated automatically based on other properties.
     * See the properties section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @param {object} [options]
     * @return {render} A new renderer
     */ Render.create = function(options) {
                    var defaults = {
                        engine: null,
                        element: null,
                        canvas: null,
                        mouse: null,
                        frameRequestId: null,
                        timing: {
                            historySize: 60,
                            delta: 0,
                            deltaHistory: [],
                            lastTime: 0,
                            lastTimestamp: 0,
                            lastElapsed: 0,
                            timestampElapsed: 0,
                            timestampElapsedHistory: [],
                            engineDeltaHistory: [],
                            engineElapsedHistory: [],
                            engineUpdatesHistory: [],
                            elapsedHistory: []
                        },
                        options: {
                            width: 800,
                            height: 600,
                            pixelRatio: 1,
                            background: "#14151f",
                            wireframeBackground: "#14151f",
                            wireframeStrokeStyle: "#bbb",
                            hasBounds: !!options.bounds,
                            enabled: true,
                            wireframes: true,
                            showSleeping: true,
                            showDebug: false,
                            showStats: false,
                            showPerformance: false,
                            showBounds: false,
                            showVelocity: false,
                            showCollisions: false,
                            showSeparations: false,
                            showAxes: false,
                            showPositions: false,
                            showAngleIndicator: false,
                            showIds: false,
                            showVertexNumbers: false,
                            showConvexHulls: false,
                            showInternalEdges: false,
                            showMousePosition: false
                        }
                    };
                    var render = Common.extend(defaults, options);
                    if (render.canvas) {
                        render.canvas.width = render.options.width || render.canvas.width;
                        render.canvas.height = render.options.height || render.canvas.height;
                    }
                    render.mouse = options.mouse;
                    render.engine = options.engine;
                    render.canvas = render.canvas || _createCanvas(render.options.width, render.options.height);
                    render.context = render.canvas.getContext("2d");
                    render.textures = {};
                    render.bounds = render.bounds || {
                        min: {
                            x: 0,
                            y: 0
                        },
                        max: {
                            x: render.canvas.width,
                            y: render.canvas.height
                        }
                    };
                    // for temporary back compatibility only
                    render.controller = Render;
                    render.options.showBroadphase = false;
                    if (render.options.pixelRatio !== 1) Render.setPixelRatio(render, render.options.pixelRatio);
                    if (Common.isElement(render.element)) render.element.appendChild(render.canvas);
                    return render;
                };
                /**
     * Continuously updates the render canvas on the `requestAnimationFrame` event.
     * @method run
     * @param {render} render
     */ Render.run = function(render) {
                    (function loop(time) {
                        render.frameRequestId = _requestAnimationFrame(loop);
                        _updateTiming(render, time);
                        Render.world(render, time);
                        render.context.setTransform(render.options.pixelRatio, 0, 0, render.options.pixelRatio, 0, 0);
                        if (render.options.showStats || render.options.showDebug) Render.stats(render, render.context, time);
                        if (render.options.showPerformance || render.options.showDebug) Render.performance(render, render.context, time);
                        render.context.setTransform(1, 0, 0, 1, 0, 0);
                    })();
                };
                /**
     * Ends execution of `Render.run` on the given `render`, by canceling the animation frame request event loop.
     * @method stop
     * @param {render} render
     */ Render.stop = function(render) {
                    _cancelAnimationFrame(render.frameRequestId);
                };
                /**
     * Sets the pixel ratio of the renderer and updates the canvas.
     * To automatically detect the correct ratio, pass the string `'auto'` for `pixelRatio`.
     * @method setPixelRatio
     * @param {render} render
     * @param {number} pixelRatio
     */ Render.setPixelRatio = function(render, pixelRatio) {
                    var options = render.options, canvas = render.canvas;
                    if (pixelRatio === "auto") pixelRatio = _getPixelRatio(canvas);
                    options.pixelRatio = pixelRatio;
                    canvas.setAttribute("data-pixel-ratio", pixelRatio);
                    canvas.width = options.width * pixelRatio;
                    canvas.height = options.height * pixelRatio;
                    canvas.style.width = options.width + "px";
                    canvas.style.height = options.height + "px";
                };
                /**
     * Sets the render `width` and `height`.
     * 
     * Updates the canvas accounting for `render.options.pixelRatio`.  
     * 
     * Updates the bottom right render bound `render.bounds.max` relative to the provided `width` and `height`.
     * The top left render bound `render.bounds.min` isn't changed.
     * 
     * Follow this call with `Render.lookAt` if you need to change the render bounds.
     * 
     * See also `Render.setPixelRatio`.
     * @method setSize
     * @param {render} render
     * @param {number} width The width (in CSS pixels)
     * @param {number} height The height (in CSS pixels)
     */ Render.setSize = function(render, width, height) {
                    render.options.width = width;
                    render.options.height = height;
                    render.bounds.max.x = render.bounds.min.x + width;
                    render.bounds.max.y = render.bounds.min.y + height;
                    if (render.options.pixelRatio !== 1) Render.setPixelRatio(render, render.options.pixelRatio);
                    else {
                        render.canvas.width = width;
                        render.canvas.height = height;
                    }
                };
                /**
     * Positions and sizes the viewport around the given object bounds.
     * Objects must have at least one of the following properties:
     * - `object.bounds`
     * - `object.position`
     * - `object.min` and `object.max`
     * - `object.x` and `object.y`
     * @method lookAt
     * @param {render} render
     * @param {object[]} objects
     * @param {vector} [padding]
     * @param {bool} [center=true]
     */ Render.lookAt = function(render, objects, padding, center) {
                    center = typeof center !== "undefined" ? center : true;
                    objects = Common.isArray(objects) ? objects : [
                        objects
                    ];
                    padding = padding || {
                        x: 0,
                        y: 0
                    };
                    // find bounds of all objects
                    var bounds = {
                        min: {
                            x: Infinity,
                            y: Infinity
                        },
                        max: {
                            x: -Infinity,
                            y: -Infinity
                        }
                    };
                    for(var i = 0; i < objects.length; i += 1){
                        var object = objects[i], min = object.bounds ? object.bounds.min : object.min || object.position || object, max = object.bounds ? object.bounds.max : object.max || object.position || object;
                        if (min && max) {
                            if (min.x < bounds.min.x) bounds.min.x = min.x;
                            if (max.x > bounds.max.x) bounds.max.x = max.x;
                            if (min.y < bounds.min.y) bounds.min.y = min.y;
                            if (max.y > bounds.max.y) bounds.max.y = max.y;
                        }
                    }
                    // find ratios
                    var width = bounds.max.x - bounds.min.x + 2 * padding.x, height = bounds.max.y - bounds.min.y + 2 * padding.y, viewHeight = render.canvas.height, viewWidth = render.canvas.width, outerRatio = viewWidth / viewHeight, innerRatio = width / height, scaleX = 1, scaleY = 1;
                    // find scale factor
                    if (innerRatio > outerRatio) scaleY = innerRatio / outerRatio;
                    else scaleX = outerRatio / innerRatio;
                    // enable bounds
                    render.options.hasBounds = true;
                    // position and size
                    render.bounds.min.x = bounds.min.x;
                    render.bounds.max.x = bounds.min.x + width * scaleX;
                    render.bounds.min.y = bounds.min.y;
                    render.bounds.max.y = bounds.min.y + height * scaleY;
                    // center
                    if (center) {
                        render.bounds.min.x += width * 0.5 - width * scaleX * 0.5;
                        render.bounds.max.x += width * 0.5 - width * scaleX * 0.5;
                        render.bounds.min.y += height * 0.5 - height * scaleY * 0.5;
                        render.bounds.max.y += height * 0.5 - height * scaleY * 0.5;
                    }
                    // padding
                    render.bounds.min.x -= padding.x;
                    render.bounds.max.x -= padding.x;
                    render.bounds.min.y -= padding.y;
                    render.bounds.max.y -= padding.y;
                    // update mouse
                    if (render.mouse) {
                        Mouse.setScale(render.mouse, {
                            x: (render.bounds.max.x - render.bounds.min.x) / render.canvas.width,
                            y: (render.bounds.max.y - render.bounds.min.y) / render.canvas.height
                        });
                        Mouse.setOffset(render.mouse, render.bounds.min);
                    }
                };
                /**
     * Applies viewport transforms based on `render.bounds` to a render context.
     * @method startViewTransform
     * @param {render} render
     */ Render.startViewTransform = function(render) {
                    var boundsWidth = render.bounds.max.x - render.bounds.min.x, boundsHeight = render.bounds.max.y - render.bounds.min.y, boundsScaleX = boundsWidth / render.options.width, boundsScaleY = boundsHeight / render.options.height;
                    render.context.setTransform(render.options.pixelRatio / boundsScaleX, 0, 0, render.options.pixelRatio / boundsScaleY, 0, 0);
                    render.context.translate(-render.bounds.min.x, -render.bounds.min.y);
                };
                /**
     * Resets all transforms on the render context.
     * @method endViewTransform
     * @param {render} render
     */ Render.endViewTransform = function(render) {
                    render.context.setTransform(render.options.pixelRatio, 0, 0, render.options.pixelRatio, 0, 0);
                };
                /**
     * Renders the given `engine`'s `Matter.World` object.
     * This is the entry point for all rendering and should be called every time the scene changes.
     * @method world
     * @param {render} render
     */ Render.world = function(render, time) {
                    var startTime = Common.now(), engine = render.engine, world = engine.world, canvas = render.canvas, context = render.context, options = render.options, timing = render.timing;
                    var allBodies = Composite.allBodies(world), allConstraints = Composite.allConstraints(world), background = options.wireframes ? options.wireframeBackground : options.background, bodies = [], constraints = [], i;
                    var event = {
                        timestamp: engine.timing.timestamp
                    };
                    Events.trigger(render, "beforeRender", event);
                    // apply background if it has changed
                    if (render.currentBackground !== background) _applyBackground(render, background);
                    // clear the canvas with a transparent fill, to allow the canvas background to show
                    context.globalCompositeOperation = "source-in";
                    context.fillStyle = "transparent";
                    context.fillRect(0, 0, canvas.width, canvas.height);
                    context.globalCompositeOperation = "source-over";
                    // handle bounds
                    if (options.hasBounds) {
                        // filter out bodies that are not in view
                        for(i = 0; i < allBodies.length; i++){
                            var body = allBodies[i];
                            if (Bounds.overlaps(body.bounds, render.bounds)) bodies.push(body);
                        }
                        // filter out constraints that are not in view
                        for(i = 0; i < allConstraints.length; i++){
                            var constraint = allConstraints[i], bodyA = constraint.bodyA, bodyB = constraint.bodyB, pointAWorld = constraint.pointA, pointBWorld = constraint.pointB;
                            if (bodyA) pointAWorld = Vector.add(bodyA.position, constraint.pointA);
                            if (bodyB) pointBWorld = Vector.add(bodyB.position, constraint.pointB);
                            if (!pointAWorld || !pointBWorld) continue;
                            if (Bounds.contains(render.bounds, pointAWorld) || Bounds.contains(render.bounds, pointBWorld)) constraints.push(constraint);
                        }
                        // transform the view
                        Render.startViewTransform(render);
                        // update mouse
                        if (render.mouse) {
                            Mouse.setScale(render.mouse, {
                                x: (render.bounds.max.x - render.bounds.min.x) / render.options.width,
                                y: (render.bounds.max.y - render.bounds.min.y) / render.options.height
                            });
                            Mouse.setOffset(render.mouse, render.bounds.min);
                        }
                    } else {
                        constraints = allConstraints;
                        bodies = allBodies;
                        if (render.options.pixelRatio !== 1) render.context.setTransform(render.options.pixelRatio, 0, 0, render.options.pixelRatio, 0, 0);
                    }
                    if (!options.wireframes || engine.enableSleeping && options.showSleeping) // fully featured rendering of bodies
                    Render.bodies(render, bodies, context);
                    else {
                        if (options.showConvexHulls) Render.bodyConvexHulls(render, bodies, context);
                        // optimised method for wireframes only
                        Render.bodyWireframes(render, bodies, context);
                    }
                    if (options.showBounds) Render.bodyBounds(render, bodies, context);
                    if (options.showAxes || options.showAngleIndicator) Render.bodyAxes(render, bodies, context);
                    if (options.showPositions) Render.bodyPositions(render, bodies, context);
                    if (options.showVelocity) Render.bodyVelocity(render, bodies, context);
                    if (options.showIds) Render.bodyIds(render, bodies, context);
                    if (options.showSeparations) Render.separations(render, engine.pairs.list, context);
                    if (options.showCollisions) Render.collisions(render, engine.pairs.list, context);
                    if (options.showVertexNumbers) Render.vertexNumbers(render, bodies, context);
                    if (options.showMousePosition) Render.mousePosition(render, render.mouse, context);
                    Render.constraints(constraints, context);
                    if (options.hasBounds) // revert view transforms
                    Render.endViewTransform(render);
                    Events.trigger(render, "afterRender", event);
                    // log the time elapsed computing this update
                    timing.lastElapsed = Common.now() - startTime;
                };
                /**
     * Renders statistics about the engine and world useful for debugging.
     * @private
     * @method stats
     * @param {render} render
     * @param {RenderingContext} context
     * @param {Number} time
     */ Render.stats = function(render, context, time) {
                    var engine = render.engine, world = engine.world, bodies = Composite.allBodies(world), parts = 0, width = 55, height = 44, x = 0, y = 0;
                    // count parts
                    for(var i = 0; i < bodies.length; i += 1)parts += bodies[i].parts.length;
                    // sections
                    var sections = {
                        "Part": parts,
                        "Body": bodies.length,
                        "Cons": Composite.allConstraints(world).length,
                        "Comp": Composite.allComposites(world).length,
                        "Pair": engine.pairs.list.length
                    };
                    // background
                    context.fillStyle = "#0e0f19";
                    context.fillRect(x, y, width * 5.5, height);
                    context.font = "12px Arial";
                    context.textBaseline = "top";
                    context.textAlign = "right";
                    // sections
                    for(var key in sections){
                        var section = sections[key];
                        // label
                        context.fillStyle = "#aaa";
                        context.fillText(key, x + width, y + 8);
                        // value
                        context.fillStyle = "#eee";
                        context.fillText(section, x + width, y + 26);
                        x += width;
                    }
                };
                /**
     * Renders engine and render performance information.
     * @private
     * @method performance
     * @param {render} render
     * @param {RenderingContext} context
     */ Render.performance = function(render, context) {
                    var engine = render.engine, timing = render.timing, deltaHistory = timing.deltaHistory, elapsedHistory = timing.elapsedHistory, timestampElapsedHistory = timing.timestampElapsedHistory, engineDeltaHistory = timing.engineDeltaHistory, engineUpdatesHistory = timing.engineUpdatesHistory, engineElapsedHistory = timing.engineElapsedHistory, lastEngineUpdatesPerFrame = engine.timing.lastUpdatesPerFrame, lastEngineDelta = engine.timing.lastDelta;
                    var deltaMean = _mean(deltaHistory), elapsedMean = _mean(elapsedHistory), engineDeltaMean = _mean(engineDeltaHistory), engineUpdatesMean = _mean(engineUpdatesHistory), engineElapsedMean = _mean(engineElapsedHistory), timestampElapsedMean = _mean(timestampElapsedHistory), rateMean = timestampElapsedMean / deltaMean || 0, neededUpdatesPerFrame = Math.round(deltaMean / lastEngineDelta), fps = 1000 / deltaMean || 0;
                    var graphHeight = 4, gap = 12, width = 60, height = 34, x = 10, y = 69;
                    // background
                    context.fillStyle = "#0e0f19";
                    context.fillRect(0, 50, gap * 5 + width * 6 + 22, height);
                    // show FPS
                    Render.status(context, x, y, width, graphHeight, deltaHistory.length, Math.round(fps) + " fps", fps / Render._goodFps, function(i) {
                        return deltaHistory[i] / deltaMean - 1;
                    });
                    // show engine delta
                    Render.status(context, x + gap + width, y, width, graphHeight, engineDeltaHistory.length, lastEngineDelta.toFixed(2) + " dt", Render._goodDelta / lastEngineDelta, function(i) {
                        return engineDeltaHistory[i] / engineDeltaMean - 1;
                    });
                    // show engine updates per frame
                    Render.status(context, x + (gap + width) * 2, y, width, graphHeight, engineUpdatesHistory.length, lastEngineUpdatesPerFrame + " upf", Math.pow(Common.clamp(engineUpdatesMean / neededUpdatesPerFrame || 1, 0, 1), 4), function(i) {
                        return engineUpdatesHistory[i] / engineUpdatesMean - 1;
                    });
                    // show engine update time
                    Render.status(context, x + (gap + width) * 3, y, width, graphHeight, engineElapsedHistory.length, engineElapsedMean.toFixed(2) + " ut", 1 - lastEngineUpdatesPerFrame * engineElapsedMean / Render._goodFps, function(i) {
                        return engineElapsedHistory[i] / engineElapsedMean - 1;
                    });
                    // show render time
                    Render.status(context, x + (gap + width) * 4, y, width, graphHeight, elapsedHistory.length, elapsedMean.toFixed(2) + " rt", 1 - elapsedMean / Render._goodFps, function(i) {
                        return elapsedHistory[i] / elapsedMean - 1;
                    });
                    // show effective speed
                    Render.status(context, x + (gap + width) * 5, y, width, graphHeight, timestampElapsedHistory.length, rateMean.toFixed(2) + " x", rateMean * rateMean * rateMean, function(i) {
                        return (timestampElapsedHistory[i] / deltaHistory[i] / rateMean || 0) - 1;
                    });
                };
                /**
     * Renders a label, indicator and a chart.
     * @private
     * @method status
     * @param {RenderingContext} context
     * @param {number} x
     * @param {number} y
     * @param {number} width
     * @param {number} height
     * @param {number} count
     * @param {string} label
     * @param {string} indicator
     * @param {function} plotY
     */ Render.status = function(context, x, y, width, height, count, label, indicator, plotY) {
                    // background
                    context.strokeStyle = "#888";
                    context.fillStyle = "#444";
                    context.lineWidth = 1;
                    context.fillRect(x, y + 7, width, 1);
                    // chart
                    context.beginPath();
                    context.moveTo(x, y + 7 - height * Common.clamp(0.4 * plotY(0), -2, 2));
                    for(var i = 0; i < width; i += 1)context.lineTo(x + i, y + 7 - (i < count ? height * Common.clamp(0.4 * plotY(i), -2, 2) : 0));
                    context.stroke();
                    // indicator
                    context.fillStyle = "hsl(" + Common.clamp(25 + 95 * indicator, 0, 120) + ",100%,60%)";
                    context.fillRect(x, y - 7, 4, 4);
                    // label
                    context.font = "12px Arial";
                    context.textBaseline = "middle";
                    context.textAlign = "right";
                    context.fillStyle = "#eee";
                    context.fillText(label, x + width, y - 5);
                };
                /**
     * Description
     * @private
     * @method constraints
     * @param {constraint[]} constraints
     * @param {RenderingContext} context
     */ Render.constraints = function(constraints, context) {
                    var c = context;
                    for(var i = 0; i < constraints.length; i++){
                        var constraint = constraints[i];
                        if (!constraint.render.visible || !constraint.pointA || !constraint.pointB) continue;
                        var bodyA = constraint.bodyA, bodyB = constraint.bodyB, start, end;
                        if (bodyA) start = Vector.add(bodyA.position, constraint.pointA);
                        else start = constraint.pointA;
                        if (constraint.render.type === "pin") {
                            c.beginPath();
                            c.arc(start.x, start.y, 3, 0, 2 * Math.PI);
                            c.closePath();
                        } else {
                            if (bodyB) end = Vector.add(bodyB.position, constraint.pointB);
                            else end = constraint.pointB;
                            c.beginPath();
                            c.moveTo(start.x, start.y);
                            if (constraint.render.type === "spring") {
                                var delta = Vector.sub(end, start), normal = Vector.perp(Vector.normalise(delta)), coils = Math.ceil(Common.clamp(constraint.length / 5, 12, 20)), offset;
                                for(var j = 1; j < coils; j += 1){
                                    offset = j % 2 === 0 ? 1 : -1;
                                    c.lineTo(start.x + delta.x * (j / coils) + normal.x * offset * 4, start.y + delta.y * (j / coils) + normal.y * offset * 4);
                                }
                            }
                            c.lineTo(end.x, end.y);
                        }
                        if (constraint.render.lineWidth) {
                            c.lineWidth = constraint.render.lineWidth;
                            c.strokeStyle = constraint.render.strokeStyle;
                            c.stroke();
                        }
                        if (constraint.render.anchors) {
                            c.fillStyle = constraint.render.strokeStyle;
                            c.beginPath();
                            c.arc(start.x, start.y, 3, 0, 2 * Math.PI);
                            c.arc(end.x, end.y, 3, 0, 2 * Math.PI);
                            c.closePath();
                            c.fill();
                        }
                    }
                };
                /**
     * Description
     * @private
     * @method bodies
     * @param {render} render
     * @param {body[]} bodies
     * @param {RenderingContext} context
     */ Render.bodies = function(render, bodies, context) {
                    var c = context, engine = render.engine, options = render.options, showInternalEdges = options.showInternalEdges || !options.wireframes, body, part, i, k;
                    for(i = 0; i < bodies.length; i++){
                        body = bodies[i];
                        if (!body.render.visible) continue;
                        // handle compound parts
                        for(k = body.parts.length > 1 ? 1 : 0; k < body.parts.length; k++){
                            part = body.parts[k];
                            if (!part.render.visible) continue;
                            if (options.showSleeping && body.isSleeping) c.globalAlpha = 0.5 * part.render.opacity;
                            else if (part.render.opacity !== 1) c.globalAlpha = part.render.opacity;
                            if (part.render.sprite && part.render.sprite.texture && !options.wireframes) {
                                // part sprite
                                var sprite = part.render.sprite, texture = _getTexture(render, sprite.texture);
                                c.translate(part.position.x, part.position.y);
                                c.rotate(part.angle);
                                c.drawImage(texture, texture.width * -sprite.xOffset * sprite.xScale, texture.height * -sprite.yOffset * sprite.yScale, texture.width * sprite.xScale, texture.height * sprite.yScale);
                                // revert translation, hopefully faster than save / restore
                                c.rotate(-part.angle);
                                c.translate(-part.position.x, -part.position.y);
                            } else {
                                // part polygon
                                if (part.circleRadius) {
                                    c.beginPath();
                                    c.arc(part.position.x, part.position.y, part.circleRadius, 0, 2 * Math.PI);
                                } else {
                                    c.beginPath();
                                    c.moveTo(part.vertices[0].x, part.vertices[0].y);
                                    for(var j = 1; j < part.vertices.length; j++){
                                        if (!part.vertices[j - 1].isInternal || showInternalEdges) c.lineTo(part.vertices[j].x, part.vertices[j].y);
                                        else c.moveTo(part.vertices[j].x, part.vertices[j].y);
                                        if (part.vertices[j].isInternal && !showInternalEdges) c.moveTo(part.vertices[(j + 1) % part.vertices.length].x, part.vertices[(j + 1) % part.vertices.length].y);
                                    }
                                    c.lineTo(part.vertices[0].x, part.vertices[0].y);
                                    c.closePath();
                                }
                                if (!options.wireframes) {
                                    c.fillStyle = part.render.fillStyle;
                                    if (part.render.lineWidth) {
                                        c.lineWidth = part.render.lineWidth;
                                        c.strokeStyle = part.render.strokeStyle;
                                        c.stroke();
                                    }
                                    c.fill();
                                } else {
                                    c.lineWidth = 1;
                                    c.strokeStyle = render.options.wireframeStrokeStyle;
                                    c.stroke();
                                }
                            }
                            c.globalAlpha = 1;
                        }
                    }
                };
                /**
     * Optimised method for drawing body wireframes in one pass
     * @private
     * @method bodyWireframes
     * @param {render} render
     * @param {body[]} bodies
     * @param {RenderingContext} context
     */ Render.bodyWireframes = function(render, bodies, context) {
                    var c = context, showInternalEdges = render.options.showInternalEdges, body, part, i, j, k;
                    c.beginPath();
                    // render all bodies
                    for(i = 0; i < bodies.length; i++){
                        body = bodies[i];
                        if (!body.render.visible) continue;
                        // handle compound parts
                        for(k = body.parts.length > 1 ? 1 : 0; k < body.parts.length; k++){
                            part = body.parts[k];
                            c.moveTo(part.vertices[0].x, part.vertices[0].y);
                            for(j = 1; j < part.vertices.length; j++){
                                if (!part.vertices[j - 1].isInternal || showInternalEdges) c.lineTo(part.vertices[j].x, part.vertices[j].y);
                                else c.moveTo(part.vertices[j].x, part.vertices[j].y);
                                if (part.vertices[j].isInternal && !showInternalEdges) c.moveTo(part.vertices[(j + 1) % part.vertices.length].x, part.vertices[(j + 1) % part.vertices.length].y);
                            }
                            c.lineTo(part.vertices[0].x, part.vertices[0].y);
                        }
                    }
                    c.lineWidth = 1;
                    c.strokeStyle = render.options.wireframeStrokeStyle;
                    c.stroke();
                };
                /**
     * Optimised method for drawing body convex hull wireframes in one pass
     * @private
     * @method bodyConvexHulls
     * @param {render} render
     * @param {body[]} bodies
     * @param {RenderingContext} context
     */ Render.bodyConvexHulls = function(render, bodies, context) {
                    var c = context, body, part, i, j, k;
                    c.beginPath();
                    // render convex hulls
                    for(i = 0; i < bodies.length; i++){
                        body = bodies[i];
                        if (!body.render.visible || body.parts.length === 1) continue;
                        c.moveTo(body.vertices[0].x, body.vertices[0].y);
                        for(j = 1; j < body.vertices.length; j++)c.lineTo(body.vertices[j].x, body.vertices[j].y);
                        c.lineTo(body.vertices[0].x, body.vertices[0].y);
                    }
                    c.lineWidth = 1;
                    c.strokeStyle = "rgba(255,255,255,0.2)";
                    c.stroke();
                };
                /**
     * Renders body vertex numbers.
     * @private
     * @method vertexNumbers
     * @param {render} render
     * @param {body[]} bodies
     * @param {RenderingContext} context
     */ Render.vertexNumbers = function(render, bodies, context) {
                    var c = context, i, j, k;
                    for(i = 0; i < bodies.length; i++){
                        var parts = bodies[i].parts;
                        for(k = parts.length > 1 ? 1 : 0; k < parts.length; k++){
                            var part = parts[k];
                            for(j = 0; j < part.vertices.length; j++){
                                c.fillStyle = "rgba(255,255,255,0.2)";
                                c.fillText(i + "_" + j, part.position.x + (part.vertices[j].x - part.position.x) * 0.8, part.position.y + (part.vertices[j].y - part.position.y) * 0.8);
                            }
                        }
                    }
                };
                /**
     * Renders mouse position.
     * @private
     * @method mousePosition
     * @param {render} render
     * @param {mouse} mouse
     * @param {RenderingContext} context
     */ Render.mousePosition = function(render, mouse, context) {
                    var c = context;
                    c.fillStyle = "rgba(255,255,255,0.8)";
                    c.fillText(mouse.position.x + "  " + mouse.position.y, mouse.position.x + 5, mouse.position.y - 5);
                };
                /**
     * Draws body bounds
     * @private
     * @method bodyBounds
     * @param {render} render
     * @param {body[]} bodies
     * @param {RenderingContext} context
     */ Render.bodyBounds = function(render, bodies, context) {
                    var c = context, engine = render.engine, options = render.options;
                    c.beginPath();
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        if (body.render.visible) {
                            var parts = bodies[i].parts;
                            for(var j = parts.length > 1 ? 1 : 0; j < parts.length; j++){
                                var part = parts[j];
                                c.rect(part.bounds.min.x, part.bounds.min.y, part.bounds.max.x - part.bounds.min.x, part.bounds.max.y - part.bounds.min.y);
                            }
                        }
                    }
                    if (options.wireframes) c.strokeStyle = "rgba(255,255,255,0.08)";
                    else c.strokeStyle = "rgba(0,0,0,0.1)";
                    c.lineWidth = 1;
                    c.stroke();
                };
                /**
     * Draws body angle indicators and axes
     * @private
     * @method bodyAxes
     * @param {render} render
     * @param {body[]} bodies
     * @param {RenderingContext} context
     */ Render.bodyAxes = function(render, bodies, context) {
                    var c = context, engine = render.engine, options = render.options, part, i, j, k;
                    c.beginPath();
                    for(i = 0; i < bodies.length; i++){
                        var body = bodies[i], parts = body.parts;
                        if (!body.render.visible) continue;
                        if (options.showAxes) // render all axes
                        for(j = parts.length > 1 ? 1 : 0; j < parts.length; j++){
                            part = parts[j];
                            for(k = 0; k < part.axes.length; k++){
                                var axis = part.axes[k];
                                c.moveTo(part.position.x, part.position.y);
                                c.lineTo(part.position.x + axis.x * 20, part.position.y + axis.y * 20);
                            }
                        }
                        else for(j = parts.length > 1 ? 1 : 0; j < parts.length; j++){
                            part = parts[j];
                            for(k = 0; k < part.axes.length; k++){
                                // render a single axis indicator
                                c.moveTo(part.position.x, part.position.y);
                                c.lineTo((part.vertices[0].x + part.vertices[part.vertices.length - 1].x) / 2, (part.vertices[0].y + part.vertices[part.vertices.length - 1].y) / 2);
                            }
                        }
                    }
                    if (options.wireframes) {
                        c.strokeStyle = "indianred";
                        c.lineWidth = 1;
                    } else {
                        c.strokeStyle = "rgba(255, 255, 255, 0.4)";
                        c.globalCompositeOperation = "overlay";
                        c.lineWidth = 2;
                    }
                    c.stroke();
                    c.globalCompositeOperation = "source-over";
                };
                /**
     * Draws body positions
     * @private
     * @method bodyPositions
     * @param {render} render
     * @param {body[]} bodies
     * @param {RenderingContext} context
     */ Render.bodyPositions = function(render, bodies, context) {
                    var c = context, engine = render.engine, options = render.options, body, part, i, k;
                    c.beginPath();
                    // render current positions
                    for(i = 0; i < bodies.length; i++){
                        body = bodies[i];
                        if (!body.render.visible) continue;
                        // handle compound parts
                        for(k = 0; k < body.parts.length; k++){
                            part = body.parts[k];
                            c.arc(part.position.x, part.position.y, 3, 0, 2 * Math.PI, false);
                            c.closePath();
                        }
                    }
                    if (options.wireframes) c.fillStyle = "indianred";
                    else c.fillStyle = "rgba(0,0,0,0.5)";
                    c.fill();
                    c.beginPath();
                    // render previous positions
                    for(i = 0; i < bodies.length; i++){
                        body = bodies[i];
                        if (body.render.visible) {
                            c.arc(body.positionPrev.x, body.positionPrev.y, 2, 0, 2 * Math.PI, false);
                            c.closePath();
                        }
                    }
                    c.fillStyle = "rgba(255,165,0,0.8)";
                    c.fill();
                };
                /**
     * Draws body velocity
     * @private
     * @method bodyVelocity
     * @param {render} render
     * @param {body[]} bodies
     * @param {RenderingContext} context
     */ Render.bodyVelocity = function(render, bodies, context) {
                    var c = context;
                    c.beginPath();
                    for(var i = 0; i < bodies.length; i++){
                        var body = bodies[i];
                        if (!body.render.visible) continue;
                        var velocity = Body.getVelocity(body);
                        c.moveTo(body.position.x, body.position.y);
                        c.lineTo(body.position.x + velocity.x, body.position.y + velocity.y);
                    }
                    c.lineWidth = 3;
                    c.strokeStyle = "cornflowerblue";
                    c.stroke();
                };
                /**
     * Draws body ids
     * @private
     * @method bodyIds
     * @param {render} render
     * @param {body[]} bodies
     * @param {RenderingContext} context
     */ Render.bodyIds = function(render, bodies, context) {
                    var c = context, i, j;
                    for(i = 0; i < bodies.length; i++){
                        if (!bodies[i].render.visible) continue;
                        var parts = bodies[i].parts;
                        for(j = parts.length > 1 ? 1 : 0; j < parts.length; j++){
                            var part = parts[j];
                            c.font = "12px Arial";
                            c.fillStyle = "rgba(255,255,255,0.5)";
                            c.fillText(part.id, part.position.x + 10, part.position.y - 10);
                        }
                    }
                };
                /**
     * Description
     * @private
     * @method collisions
     * @param {render} render
     * @param {pair[]} pairs
     * @param {RenderingContext} context
     */ Render.collisions = function(render, pairs, context) {
                    var c = context, options = render.options, pair, collision, corrected, bodyA, bodyB, i, j;
                    c.beginPath();
                    // render collision positions
                    for(i = 0; i < pairs.length; i++){
                        pair = pairs[i];
                        if (!pair.isActive) continue;
                        collision = pair.collision;
                        for(j = 0; j < pair.contactCount; j++){
                            var contact = pair.contacts[j], vertex = contact.vertex;
                            c.rect(vertex.x - 1.5, vertex.y - 1.5, 3.5, 3.5);
                        }
                    }
                    if (options.wireframes) c.fillStyle = "rgba(255,255,255,0.7)";
                    else c.fillStyle = "orange";
                    c.fill();
                    c.beginPath();
                    // render collision normals
                    for(i = 0; i < pairs.length; i++){
                        pair = pairs[i];
                        if (!pair.isActive) continue;
                        collision = pair.collision;
                        if (pair.contactCount > 0) {
                            var normalPosX = pair.contacts[0].vertex.x, normalPosY = pair.contacts[0].vertex.y;
                            if (pair.contactCount === 2) {
                                normalPosX = (pair.contacts[0].vertex.x + pair.contacts[1].vertex.x) / 2;
                                normalPosY = (pair.contacts[0].vertex.y + pair.contacts[1].vertex.y) / 2;
                            }
                            if (collision.bodyB === collision.supports[0].body || collision.bodyA.isStatic === true) c.moveTo(normalPosX - collision.normal.x * 8, normalPosY - collision.normal.y * 8);
                            else c.moveTo(normalPosX + collision.normal.x * 8, normalPosY + collision.normal.y * 8);
                            c.lineTo(normalPosX, normalPosY);
                        }
                    }
                    if (options.wireframes) c.strokeStyle = "rgba(255,165,0,0.7)";
                    else c.strokeStyle = "orange";
                    c.lineWidth = 1;
                    c.stroke();
                };
                /**
     * Description
     * @private
     * @method separations
     * @param {render} render
     * @param {pair[]} pairs
     * @param {RenderingContext} context
     */ Render.separations = function(render, pairs, context) {
                    var c = context, options = render.options, pair, collision, corrected, bodyA, bodyB, i, j;
                    c.beginPath();
                    // render separations
                    for(i = 0; i < pairs.length; i++){
                        pair = pairs[i];
                        if (!pair.isActive) continue;
                        collision = pair.collision;
                        bodyA = collision.bodyA;
                        bodyB = collision.bodyB;
                        var k = 1;
                        if (!bodyB.isStatic && !bodyA.isStatic) k = 0.5;
                        if (bodyB.isStatic) k = 0;
                        c.moveTo(bodyB.position.x, bodyB.position.y);
                        c.lineTo(bodyB.position.x - collision.penetration.x * k, bodyB.position.y - collision.penetration.y * k);
                        k = 1;
                        if (!bodyB.isStatic && !bodyA.isStatic) k = 0.5;
                        if (bodyA.isStatic) k = 0;
                        c.moveTo(bodyA.position.x, bodyA.position.y);
                        c.lineTo(bodyA.position.x + collision.penetration.x * k, bodyA.position.y + collision.penetration.y * k);
                    }
                    if (options.wireframes) c.strokeStyle = "rgba(255,165,0,0.5)";
                    else c.strokeStyle = "orange";
                    c.stroke();
                };
                /**
     * Description
     * @private
     * @method inspector
     * @param {inspector} inspector
     * @param {RenderingContext} context
     */ Render.inspector = function(inspector, context) {
                    var engine = inspector.engine, selected = inspector.selected, render = inspector.render, options = render.options, bounds;
                    if (options.hasBounds) {
                        var boundsWidth = render.bounds.max.x - render.bounds.min.x, boundsHeight = render.bounds.max.y - render.bounds.min.y, boundsScaleX = boundsWidth / render.options.width, boundsScaleY = boundsHeight / render.options.height;
                        context.scale(1 / boundsScaleX, 1 / boundsScaleY);
                        context.translate(-render.bounds.min.x, -render.bounds.min.y);
                    }
                    for(var i = 0; i < selected.length; i++){
                        var item = selected[i].data;
                        context.translate(0.5, 0.5);
                        context.lineWidth = 1;
                        context.strokeStyle = "rgba(255,165,0,0.9)";
                        context.setLineDash([
                            1,
                            2
                        ]);
                        switch(item.type){
                            case "body":
                                // render body selections
                                bounds = item.bounds;
                                context.beginPath();
                                context.rect(Math.floor(bounds.min.x - 3), Math.floor(bounds.min.y - 3), Math.floor(bounds.max.x - bounds.min.x + 6), Math.floor(bounds.max.y - bounds.min.y + 6));
                                context.closePath();
                                context.stroke();
                                break;
                            case "constraint":
                                // render constraint selections
                                var point = item.pointA;
                                if (item.bodyA) point = item.pointB;
                                context.beginPath();
                                context.arc(point.x, point.y, 10, 0, 2 * Math.PI);
                                context.closePath();
                                context.stroke();
                                break;
                        }
                        context.setLineDash([]);
                        context.translate(-0.5, -0.5);
                    }
                    // render selection region
                    if (inspector.selectStart !== null) {
                        context.translate(0.5, 0.5);
                        context.lineWidth = 1;
                        context.strokeStyle = "rgba(255,165,0,0.6)";
                        context.fillStyle = "rgba(255,165,0,0.1)";
                        bounds = inspector.selectBounds;
                        context.beginPath();
                        context.rect(Math.floor(bounds.min.x), Math.floor(bounds.min.y), Math.floor(bounds.max.x - bounds.min.x), Math.floor(bounds.max.y - bounds.min.y));
                        context.closePath();
                        context.stroke();
                        context.fill();
                        context.translate(-0.5, -0.5);
                    }
                    if (options.hasBounds) context.setTransform(1, 0, 0, 1, 0, 0);
                };
                /**
     * Updates render timing.
     * @method _updateTiming
     * @private
     * @param {render} render
     * @param {number} time
     */ var _updateTiming = function(render, time) {
                    var engine = render.engine, timing = render.timing, historySize = timing.historySize, timestamp = engine.timing.timestamp;
                    timing.delta = time - timing.lastTime || Render._goodDelta;
                    timing.lastTime = time;
                    timing.timestampElapsed = timestamp - timing.lastTimestamp || 0;
                    timing.lastTimestamp = timestamp;
                    timing.deltaHistory.unshift(timing.delta);
                    timing.deltaHistory.length = Math.min(timing.deltaHistory.length, historySize);
                    timing.engineDeltaHistory.unshift(engine.timing.lastDelta);
                    timing.engineDeltaHistory.length = Math.min(timing.engineDeltaHistory.length, historySize);
                    timing.timestampElapsedHistory.unshift(timing.timestampElapsed);
                    timing.timestampElapsedHistory.length = Math.min(timing.timestampElapsedHistory.length, historySize);
                    timing.engineUpdatesHistory.unshift(engine.timing.lastUpdatesPerFrame);
                    timing.engineUpdatesHistory.length = Math.min(timing.engineUpdatesHistory.length, historySize);
                    timing.engineElapsedHistory.unshift(engine.timing.lastElapsed);
                    timing.engineElapsedHistory.length = Math.min(timing.engineElapsedHistory.length, historySize);
                    timing.elapsedHistory.unshift(timing.lastElapsed);
                    timing.elapsedHistory.length = Math.min(timing.elapsedHistory.length, historySize);
                };
                /**
     * Returns the mean value of the given numbers.
     * @method _mean
     * @private
     * @param {Number[]} values
     * @return {Number} the mean of given values
     */ var _mean = function(values) {
                    var result = 0;
                    for(var i = 0; i < values.length; i += 1)result += values[i];
                    return result / values.length || 0;
                };
                /**
     * @method _createCanvas
     * @private
     * @param {} width
     * @param {} height
     * @return canvas
     */ var _createCanvas = function(width, height) {
                    var canvas = document.createElement("canvas");
                    canvas.width = width;
                    canvas.height = height;
                    canvas.oncontextmenu = function() {
                        return false;
                    };
                    canvas.onselectstart = function() {
                        return false;
                    };
                    return canvas;
                };
                /**
     * Gets the pixel ratio of the canvas.
     * @method _getPixelRatio
     * @private
     * @param {HTMLElement} canvas
     * @return {Number} pixel ratio
     */ var _getPixelRatio = function(canvas) {
                    var context = canvas.getContext("2d"), devicePixelRatio = window.devicePixelRatio || 1, backingStorePixelRatio = context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
                    return devicePixelRatio / backingStorePixelRatio;
                };
                /**
     * Gets the requested texture (an Image) via its path
     * @method _getTexture
     * @private
     * @param {render} render
     * @param {string} imagePath
     * @return {Image} texture
     */ var _getTexture = function(render, imagePath) {
                    var image = render.textures[imagePath];
                    if (image) return image;
                    image = render.textures[imagePath] = new Image();
                    image.src = imagePath;
                    return image;
                };
                /**
     * Applies the background to the canvas using CSS.
     * @method applyBackground
     * @private
     * @param {render} render
     * @param {string} background
     */ var _applyBackground = function(render, background) {
                    var cssBackground = background;
                    if (/(jpg|gif|png)$/.test(background)) cssBackground = "url(" + background + ")";
                    render.canvas.style.background = cssBackground;
                    render.canvas.style.backgroundSize = "contain";
                    render.currentBackground = background;
                };
            /*
    *
    *  Events Documentation
    *
    */ /**
    * Fired before rendering
    *
    * @event beforeRender
    * @param {} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired after rendering
    *
    * @event afterRender
    * @param {} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /*
    *
    *  Properties Documentation
    *
    */ /**
     * A back-reference to the `Matter.Render` module.
     *
     * @deprecated
     * @property controller
     * @type render
     */ /**
     * A reference to the `Matter.Engine` instance to be used.
     *
     * @property engine
     * @type engine
     */ /**
     * A reference to the element where the canvas is to be inserted (if `render.canvas` has not been specified)
     *
     * @property element
     * @type HTMLElement
     * @default null
     */ /**
     * The canvas element to render to. If not specified, one will be created if `render.element` has been specified.
     *
     * @property canvas
     * @type HTMLCanvasElement
     * @default null
     */ /**
     * A `Bounds` object that specifies the drawing view region.
     * Rendering will be automatically transformed and scaled to fit within the canvas size (`render.options.width` and `render.options.height`).
     * This allows for creating views that can pan or zoom around the scene.
     * You must also set `render.options.hasBounds` to `true` to enable bounded rendering.
     *
     * @property bounds
     * @type bounds
     */ /**
     * The 2d rendering context from the `render.canvas` element.
     *
     * @property context
     * @type CanvasRenderingContext2D
     */ /**
     * The sprite texture cache.
     *
     * @property textures
     * @type {}
     */ /**
     * The mouse to render if `render.options.showMousePosition` is enabled.
     *
     * @property mouse
     * @type mouse
     * @default null
     */ /**
     * The configuration options of the renderer.
     *
     * @property options
     * @type {}
     */ /**
     * The target width in pixels of the `render.canvas` to be created.
     * See also the `options.pixelRatio` property to change render quality.
     *
     * @property options.width
     * @type number
     * @default 800
     */ /**
     * The target height in pixels of the `render.canvas` to be created.
     * See also the `options.pixelRatio` property to change render quality.
     *
     * @property options.height
     * @type number
     * @default 600
     */ /**
     * The [pixel ratio](https://developer.mozilla.org/en-US/docs/Web/API/Window/devicePixelRatio) to use when rendering.
     *
     * @property options.pixelRatio
     * @type number
     * @default 1
     */ /**
     * A CSS background color string to use when `render.options.wireframes` is disabled.
     * This may be also set to `'transparent'` or equivalent.
     *
     * @property options.background
     * @type string
     * @default '#14151f'
     */ /**
     * A CSS color string to use for background when `render.options.wireframes` is enabled.
     * This may be also set to `'transparent'` or equivalent.
     *
     * @property options.wireframeBackground
     * @type string
     * @default '#14151f'
     */ /**
     * A CSS color string to use for stroke when `render.options.wireframes` is enabled.
     * This may be also set to `'transparent'` or equivalent.
     *
     * @property options.wireframeStrokeStyle
     * @type string
     * @default '#bbb'
     */ /**
     * A flag that specifies if `render.bounds` should be used when rendering.
     *
     * @property options.hasBounds
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable all debug information overlays together.  
     * This includes and has priority over the values of:
     *
     * - `render.options.showStats`
     * - `render.options.showPerformance`
     *
     * @property options.showDebug
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the engine stats info overlay.  
     * From left to right, the values shown are:
     *
     * - body parts total
     * - body total
     * - constraints total
     * - composites total
     * - collision pairs total
     *
     * @property options.showStats
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable performance charts.  
     * From left to right, the values shown are:
     *
     * - average render frequency (e.g. 60 fps)
     * - exact engine delta time used for last update (e.g. 16.66ms)
     * - average updates per frame (e.g. 1)
     * - average engine execution duration (e.g. 5.00ms)
     * - average render execution duration (e.g. 0.40ms)
     * - average effective play speed (e.g. '1.00x' is 'real-time')
     *
     * Each value is recorded over a fixed sample of past frames (60 frames).
     *
     * A chart shown below each value indicates the variance from the average over the sample.
     * The more stable or fixed the value is the flatter the chart will appear.
     *
     * @property options.showPerformance
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable rendering entirely.
     *
     * @property options.enabled
     * @type boolean
     * @default false
     */ /**
     * A flag to toggle wireframe rendering otherwise solid fill rendering is used.
     *
     * @property options.wireframes
     * @type boolean
     * @default true
     */ /**
     * A flag to enable or disable sleeping bodies indicators.
     *
     * @property options.showSleeping
     * @type boolean
     * @default true
     */ /**
     * A flag to enable or disable the debug information overlay.
     *
     * @property options.showDebug
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the collision broadphase debug overlay.
     *
     * @deprecated no longer implemented
     * @property options.showBroadphase
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the body bounds debug overlay.
     *
     * @property options.showBounds
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the body velocity debug overlay.
     *
     * @property options.showVelocity
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the body collisions debug overlay.
     *
     * @property options.showCollisions
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the collision resolver separations debug overlay.
     *
     * @property options.showSeparations
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the body axes debug overlay.
     *
     * @property options.showAxes
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the body positions debug overlay.
     *
     * @property options.showPositions
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the body angle debug overlay.
     *
     * @property options.showAngleIndicator
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the body and part ids debug overlay.
     *
     * @property options.showIds
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the body vertex numbers debug overlay.
     *
     * @property options.showVertexNumbers
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the body convex hulls debug overlay.
     *
     * @property options.showConvexHulls
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the body internal edges debug overlay.
     *
     * @property options.showInternalEdges
     * @type boolean
     * @default false
     */ /**
     * A flag to enable or disable the mouse position debug overlay.
     *
     * @property options.showMousePosition
     * @type boolean
     * @default false
     */ })();
        /***/ },
        /* 27 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Runner` module is an optional utility that provides a game loop for running a `Matter.Engine` inside a browser environment.
* A runner will continuously update a `Matter.Engine` whilst synchronising engine updates with the browser frame rate.
* This runner favours a smoother user experience over perfect time keeping.
* This runner is optional and is used for development and debugging but could be useful as a starting point for implementing some games and experiences.
* Alternatively see `Engine.update` to step the engine directly inside your own game loop implementation as may be needed inside other environments.
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Runner
*/ var Runner = {};
            module1.exports = Runner;
            var Events = __webpack_require__(5);
            var Engine = __webpack_require__(17);
            var Common = __webpack_require__(0);
            (function() {
                Runner._maxFrameDelta = 1000 / 15;
                Runner._frameDeltaFallback = 1000 / 60;
                Runner._timeBufferMargin = 1.5;
                Runner._elapsedNextEstimate = 1;
                Runner._smoothingLowerBound = 0.1;
                Runner._smoothingUpperBound = 0.9;
                /**
     * Creates a new Runner. 
     * See the properties section below for detailed information on what you can pass via the `options` object.
     * @method create
     * @param {} options
     */ Runner.create = function(options) {
                    var defaults = {
                        delta: 1000 / 60,
                        frameDelta: null,
                        frameDeltaSmoothing: true,
                        frameDeltaSnapping: true,
                        frameDeltaHistory: [],
                        frameDeltaHistorySize: 100,
                        frameRequestId: null,
                        timeBuffer: 0,
                        timeLastTick: null,
                        maxUpdates: null,
                        maxFrameTime: 1000 / 30,
                        lastUpdatesDeferred: 0,
                        enabled: true
                    };
                    var runner = Common.extend(defaults, options);
                    // for temporary back compatibility only
                    runner.fps = 0;
                    return runner;
                };
                /**
     * Runs a `Matter.Engine` whilst synchronising engine updates with the browser frame rate. 
     * See module and properties descriptions for more information on this runner.
     * Alternatively see `Engine.update` to step the engine directly inside your own game loop implementation.
     * @method run
     * @param {runner} runner
     * @param {engine} [engine]
     * @return {runner} runner
     */ Runner.run = function(runner, engine) {
                    // initial time buffer for the first frame
                    runner.timeBuffer = Runner._frameDeltaFallback;
                    (function onFrame(time) {
                        runner.frameRequestId = Runner._onNextFrame(runner, onFrame);
                        if (time && runner.enabled) Runner.tick(runner, engine, time);
                    })();
                    return runner;
                };
                /**
     * Performs a single runner tick as used inside `Runner.run`.
     * See module and properties descriptions for more information on this runner.
     * Alternatively see `Engine.update` to step the engine directly inside your own game loop implementation.
     * @method tick
     * @param {runner} runner
     * @param {engine} engine
     * @param {number} time
     */ Runner.tick = function(runner, engine, time) {
                    var tickStartTime = Common.now(), engineDelta = runner.delta, updateCount = 0;
                    // find frame delta time since last call
                    var frameDelta = time - runner.timeLastTick;
                    // fallback for unusable frame delta values (e.g. 0, NaN, on first frame or long pauses)
                    if (!frameDelta || !runner.timeLastTick || frameDelta > Math.max(Runner._maxFrameDelta, runner.maxFrameTime)) // reuse last accepted frame delta else fallback
                    frameDelta = runner.frameDelta || Runner._frameDeltaFallback;
                    if (runner.frameDeltaSmoothing) {
                        // record frame delta over a number of frames
                        runner.frameDeltaHistory.push(frameDelta);
                        runner.frameDeltaHistory = runner.frameDeltaHistory.slice(-runner.frameDeltaHistorySize);
                        // sort frame delta history
                        var deltaHistorySorted = runner.frameDeltaHistory.slice(0).sort();
                        // sample a central window to limit outliers
                        var deltaHistoryWindow = runner.frameDeltaHistory.slice(deltaHistorySorted.length * Runner._smoothingLowerBound, deltaHistorySorted.length * Runner._smoothingUpperBound);
                        // take the mean of the central window
                        var frameDeltaSmoothed = _mean(deltaHistoryWindow);
                        frameDelta = frameDeltaSmoothed || frameDelta;
                    }
                    if (runner.frameDeltaSnapping) // snap frame delta to the nearest 1 Hz
                    frameDelta = 1000 / Math.round(1000 / frameDelta);
                    // update runner values for next call
                    runner.frameDelta = frameDelta;
                    runner.timeLastTick = time;
                    // accumulate elapsed time
                    runner.timeBuffer += runner.frameDelta;
                    // limit time buffer size to a single frame of updates
                    runner.timeBuffer = Common.clamp(runner.timeBuffer, 0, runner.frameDelta + engineDelta * Runner._timeBufferMargin);
                    // reset count of over budget updates
                    runner.lastUpdatesDeferred = 0;
                    // get max updates per frame
                    var maxUpdates = runner.maxUpdates || Math.ceil(runner.maxFrameTime / engineDelta);
                    // create event object
                    var event = {
                        timestamp: engine.timing.timestamp
                    };
                    // tick events before update
                    Events.trigger(runner, "beforeTick", event);
                    Events.trigger(runner, "tick", event);
                    var updateStartTime = Common.now();
                    // simulate time elapsed between calls
                    while(engineDelta > 0 && runner.timeBuffer >= engineDelta * Runner._timeBufferMargin){
                        // update the engine
                        Events.trigger(runner, "beforeUpdate", event);
                        Engine.update(engine, engineDelta);
                        Events.trigger(runner, "afterUpdate", event);
                        // consume time simulated from buffer
                        runner.timeBuffer -= engineDelta;
                        updateCount += 1;
                        // find elapsed time during this tick
                        var elapsedTimeTotal = Common.now() - tickStartTime, elapsedTimeUpdates = Common.now() - updateStartTime, elapsedNextEstimate = elapsedTimeTotal + Runner._elapsedNextEstimate * elapsedTimeUpdates / updateCount;
                        // defer updates if over performance budgets for this frame
                        if (updateCount >= maxUpdates || elapsedNextEstimate > runner.maxFrameTime) {
                            runner.lastUpdatesDeferred = Math.round(Math.max(0, runner.timeBuffer / engineDelta - Runner._timeBufferMargin));
                            break;
                        }
                    }
                    // track timing metrics
                    engine.timing.lastUpdatesPerFrame = updateCount;
                    // tick events after update
                    Events.trigger(runner, "afterTick", event);
                    // show useful warnings if needed
                    if (runner.frameDeltaHistory.length >= 100) {
                        if (runner.lastUpdatesDeferred && Math.round(runner.frameDelta / engineDelta) > maxUpdates) Common.warnOnce("Matter.Runner: runner reached runner.maxUpdates, see docs.");
                        else if (runner.lastUpdatesDeferred) Common.warnOnce("Matter.Runner: runner reached runner.maxFrameTime, see docs.");
                        if (typeof runner.isFixed !== "undefined") Common.warnOnce("Matter.Runner: runner.isFixed is now redundant, see docs.");
                        if (runner.deltaMin || runner.deltaMax) Common.warnOnce("Matter.Runner: runner.deltaMin and runner.deltaMax were removed, see docs.");
                        if (runner.fps !== 0) Common.warnOnce("Matter.Runner: runner.fps was replaced by runner.delta, see docs.");
                    }
                };
                /**
     * Ends execution of `Runner.run` on the given `runner` by canceling the frame loop.
     * Alternatively to temporarily pause the runner, see `runner.enabled`.
     * @method stop
     * @param {runner} runner
     */ Runner.stop = function(runner) {
                    Runner._cancelNextFrame(runner);
                };
                /**
     * Schedules the `callback` on this `runner` for the next animation frame.
     * @private
     * @method _onNextFrame
     * @param {runner} runner
     * @param {function} callback
     * @return {number} frameRequestId
     */ Runner._onNextFrame = function(runner, callback) {
                    if (typeof window !== "undefined" && window.requestAnimationFrame) runner.frameRequestId = window.requestAnimationFrame(callback);
                    else throw new Error("Matter.Runner: missing required global window.requestAnimationFrame.");
                    return runner.frameRequestId;
                };
                /**
     * Cancels the last callback scheduled by `Runner._onNextFrame` on this `runner`.
     * @private
     * @method _cancelNextFrame
     * @param {runner} runner
     */ Runner._cancelNextFrame = function(runner) {
                    if (typeof window !== "undefined" && window.cancelAnimationFrame) window.cancelAnimationFrame(runner.frameRequestId);
                    else throw new Error("Matter.Runner: missing required global window.cancelAnimationFrame.");
                };
                /**
     * Returns the mean of the given numbers.
     * @method _mean
     * @private
     * @param {Number[]} values
     * @return {Number} the mean of given values.
     */ var _mean = function(values) {
                    var result = 0, valuesLength = values.length;
                    for(var i = 0; i < valuesLength; i += 1)result += values[i];
                    return result / valuesLength || 0;
                };
            /*
    *
    *  Events Documentation
    *
    */ /**
    * Fired once at the start of the browser frame, before any engine updates.
    *
    * @event beforeTick
    * @param {} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired once at the start of the browser frame, after `beforeTick`.
    *
    * @event tick
    * @param {} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired once at the end of the browser frame, after `beforeTick`, `tick` and after any engine updates.
    *
    * @event afterTick
    * @param {} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired before each and every engine update in this browser frame (if any). 
    * There may be multiple engine update calls per browser frame (or none) depending on framerate and timestep delta.
    *
    * @event beforeUpdate
    * @param {} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /**
    * Fired after each and every engine update in this browser frame (if any). 
    * There may be multiple engine update calls per browser frame (or none) depending on framerate and timestep delta.
    *
    * @event afterUpdate
    * @param {} event An event object
    * @param {number} event.timestamp The engine.timing.timestamp of the event
    * @param {} event.source The source object of the event
    * @param {} event.name The name of the event
    */ /*
    *
    *  Properties Documentation
    *
    */ /**
     * The fixed timestep size used for `Engine.update` calls in milliseconds, known as `delta`.
     * 
     * This value is recommended to be `1000 / 60` ms or smaller (i.e. equivalent to at least 60hz).
     * 
     * Smaller `delta` values provide higher quality results at the cost of performance.
     * 
     * You should usually avoid changing `delta` during running, otherwise quality may be affected. 
     * 
     * For smoother frame pacing choose a `delta` that is an even multiple of each display FPS you target, i.e. `1000 / (n * fps)` as this helps distribute an equal number of updates over each display frame.
     * 
     * For example with a 60 Hz `delta` i.e. `1000 / 60` the runner will on average perform one update per frame on displays running 60 FPS and one update every two frames on displays running 120 FPS, etc.
     * 
     * Where as e.g. using a 240 Hz `delta` i.e. `1000 / 240` the runner will on average perform four updates per frame on displays running 60 FPS and two updates per frame on displays running 120 FPS, etc.
     * 
     * Therefore `Runner.run` will call multiple engine updates (or none) as needed to simulate the time elapsed between browser frames. 
     * 
     * In practice the number of updates in any particular frame may be restricted to respect the runner's performance budgets. These are specified by `runner.maxFrameTime` and `runner.maxUpdates`, see those properties for details.
     * 
     * @property delta
     * @type number
     * @default 1000 / 60
     */ /**
     * A flag that can be toggled to enable or disable tick calls on this runner, therefore pausing engine updates and events while the runner loop remains running.
     *
     * @property enabled
     * @type boolean
     * @default true
     */ /**
     * The accumulated time elapsed that has yet to be simulated in milliseconds.
     * This value is clamped within certain limits (see `Runner.tick` code).
     *
     * @private
     * @property timeBuffer
     * @type number
     * @default 0
     */ /**
     * The measured time elapsed between the last two browser frames measured in milliseconds.
     * This is useful e.g. to estimate the current browser FPS using `1000 / runner.frameDelta`.
     *
     * @readonly
     * @property frameDelta
     * @type number
     */ /**
     * Enables averaging to smooth frame rate measurements and therefore stabilise play rate.
     *
     * @property frameDeltaSmoothing
     * @type boolean
     * @default true
     */ /**
     * Rounds measured browser frame delta to the nearest 1 Hz.
     * This option can help smooth frame rate measurements and simplify handling hardware timing differences e.g. 59.94Hz and 60Hz displays.
     * For best results you should also round your `runner.delta` equivalent to the nearest 1 Hz.
     *
     * @property frameDeltaSnapping
     * @type boolean
     * @default true
     */ /**
     * A performance budget that limits execution time allowed for this runner per browser frame in milliseconds.
     * 
     * To calculate the effective browser FPS at which this throttle is applied use `1000 / runner.maxFrameTime`.
     * 
     * This performance budget is intended to help maintain browser interactivity and help improve framerate recovery during temporary high CPU usage.
     * 
     * This budget only covers the measured time elapsed executing the functions called in the scope of the runner tick, including `Engine.update` and its related user event callbacks.
     * 
     * You may also reduce this budget to allow for any significant additional processing you perform on the same thread outside the scope of this runner tick, e.g. rendering time.
     * 
     * See also `runner.maxUpdates`.
     *
     * @property maxFrameTime
     * @type number
     * @default 1000 / 30
     */ /**
     * An optional limit for maximum engine update count allowed per frame tick in addition to `runner.maxFrameTime`.
     * 
     * Unless you set a value it is automatically chosen based on `runner.delta` and `runner.maxFrameTime`.
     * 
     * See also `runner.maxFrameTime`.
     * 
     * @property maxUpdates
     * @type number
     * @default null
     */ /**
     * The timestamp of the last call to `Runner.tick` used to measure `frameDelta`.
     *
     * @private
     * @property timeLastTick
     * @type number
     * @default 0
     */ /**
     * The id of the last call to `Runner._onNextFrame`.
     *
     * @private
     * @property frameRequestId
     * @type number
     * @default null
     */ })();
        /***/ },
        /* 28 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* This module has now been replaced by `Matter.Collision`.
*
* All usage should be migrated to `Matter.Collision`.
* For back-compatibility purposes this module will remain for a short term and then later removed in a future release.
*
* The `Matter.SAT` module contains methods for detecting collisions using the Separating Axis Theorem.
*
* @class SAT
* @deprecated
*/ var SAT = {};
            module1.exports = SAT;
            var Collision = __webpack_require__(8);
            var Common = __webpack_require__(0);
            var deprecated = Common.deprecated;
            (function() {
                /**
     * Detect collision between two bodies using the Separating Axis Theorem.
     * @deprecated replaced by Collision.collides
     * @method collides
     * @param {body} bodyA
     * @param {body} bodyB
     * @return {collision} collision
     */ SAT.collides = function(bodyA, bodyB) {
                    return Collision.collides(bodyA, bodyB);
                };
                deprecated(SAT, "collides", "SAT.collides \u27A4 replaced by Collision.collides");
            })();
        /***/ },
        /* 29 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* The `Matter.Svg` module contains methods for converting SVG images into an array of vector points.
*
* To use this module you also need the SVGPathSeg polyfill: https://github.com/progers/pathseg
*
* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
*
* @class Svg
*/ var Svg = {};
            module1.exports = Svg;
            var Bounds = __webpack_require__(1);
            var Common = __webpack_require__(0);
            (function() {
                /**
     * Converts an SVG path into an array of vector points.
     * If the input path forms a concave shape, you must decompose the result into convex parts before use.
     * See `Bodies.fromVertices` which provides support for this.
     * Note that this function is not guaranteed to support complex paths (such as those with holes).
     * You must load the `pathseg.js` polyfill on newer browsers.
     * @method pathToVertices
     * @param {SVGPathElement} path
     * @param {Number} [sampleLength=15]
     * @return {Vector[]} points
     */ Svg.pathToVertices = function(path, sampleLength) {
                    if (typeof window !== "undefined" && !("SVGPathSeg" in window)) Common.warn("Svg.pathToVertices: SVGPathSeg not defined, a polyfill is required.");
                    // https://github.com/wout/svg.topoly.js/blob/master/svg.topoly.js
                    var i, il, total, point, segment, segments, segmentsQueue, lastSegment, lastPoint, segmentIndex, points = [], lx, ly, length = 0, x = 0, y = 0;
                    sampleLength = sampleLength || 15;
                    var addPoint = function(px, py, pathSegType) {
                        // all odd-numbered path types are relative except PATHSEG_CLOSEPATH (1)
                        var isRelative = pathSegType % 2 === 1 && pathSegType > 1;
                        // when the last point doesn't equal the current point add the current point
                        if (!lastPoint || px != lastPoint.x || py != lastPoint.y) {
                            if (lastPoint && isRelative) {
                                lx = lastPoint.x;
                                ly = lastPoint.y;
                            } else {
                                lx = 0;
                                ly = 0;
                            }
                            var point = {
                                x: lx + px,
                                y: ly + py
                            };
                            // set last point
                            if (isRelative || !lastPoint) lastPoint = point;
                            points.push(point);
                            x = lx + px;
                            y = ly + py;
                        }
                    };
                    var addSegmentPoint = function(segment) {
                        var segType = segment.pathSegTypeAsLetter.toUpperCase();
                        // skip path ends
                        if (segType === "Z") return;
                        // map segment to x and y
                        switch(segType){
                            case "M":
                            case "L":
                            case "T":
                            case "C":
                            case "S":
                            case "Q":
                                x = segment.x;
                                y = segment.y;
                                break;
                            case "H":
                                x = segment.x;
                                break;
                            case "V":
                                y = segment.y;
                                break;
                        }
                        addPoint(x, y, segment.pathSegType);
                    };
                    // ensure path is absolute
                    Svg._svgPathToAbsolute(path);
                    // get total length
                    total = path.getTotalLength();
                    // queue segments
                    segments = [];
                    for(i = 0; i < path.pathSegList.numberOfItems; i += 1)segments.push(path.pathSegList.getItem(i));
                    segmentsQueue = segments.concat();
                    // sample through path
                    while(length < total){
                        // get segment at position
                        segmentIndex = path.getPathSegAtLength(length);
                        segment = segments[segmentIndex];
                        // new segment
                        if (segment != lastSegment) {
                            while(segmentsQueue.length && segmentsQueue[0] != segment)addSegmentPoint(segmentsQueue.shift());
                            lastSegment = segment;
                        }
                        // add points in between when curving
                        // TODO: adaptive sampling
                        switch(segment.pathSegTypeAsLetter.toUpperCase()){
                            case "C":
                            case "T":
                            case "S":
                            case "Q":
                            case "A":
                                point = path.getPointAtLength(length);
                                addPoint(point.x, point.y, 0);
                                break;
                        }
                        // increment by sample value
                        length += sampleLength;
                    }
                    // add remaining segments not passed by sampling
                    for(i = 0, il = segmentsQueue.length; i < il; ++i)addSegmentPoint(segmentsQueue[i]);
                    return points;
                };
                Svg._svgPathToAbsolute = function(path) {
                    // http://phrogz.net/convert-svg-path-to-all-absolute-commands
                    // Copyright (c) Gavin Kistner
                    // http://phrogz.net/js/_ReuseLicense.txt
                    // Modifications: tidy formatting and naming
                    var x0, y0, x1, y1, x2, y2, segs = path.pathSegList, x = 0, y = 0, len = segs.numberOfItems;
                    for(var i = 0; i < len; ++i){
                        var seg = segs.getItem(i), segType = seg.pathSegTypeAsLetter;
                        if (/[MLHVCSQTA]/.test(segType)) {
                            if ("x" in seg) x = seg.x;
                            if ("y" in seg) y = seg.y;
                        } else {
                            if ("x1" in seg) x1 = x + seg.x1;
                            if ("x2" in seg) x2 = x + seg.x2;
                            if ("y1" in seg) y1 = y + seg.y1;
                            if ("y2" in seg) y2 = y + seg.y2;
                            if ("x" in seg) x += seg.x;
                            if ("y" in seg) y += seg.y;
                            switch(segType){
                                case "m":
                                    segs.replaceItem(path.createSVGPathSegMovetoAbs(x, y), i);
                                    break;
                                case "l":
                                    segs.replaceItem(path.createSVGPathSegLinetoAbs(x, y), i);
                                    break;
                                case "h":
                                    segs.replaceItem(path.createSVGPathSegLinetoHorizontalAbs(x), i);
                                    break;
                                case "v":
                                    segs.replaceItem(path.createSVGPathSegLinetoVerticalAbs(y), i);
                                    break;
                                case "c":
                                    segs.replaceItem(path.createSVGPathSegCurvetoCubicAbs(x, y, x1, y1, x2, y2), i);
                                    break;
                                case "s":
                                    segs.replaceItem(path.createSVGPathSegCurvetoCubicSmoothAbs(x, y, x2, y2), i);
                                    break;
                                case "q":
                                    segs.replaceItem(path.createSVGPathSegCurvetoQuadraticAbs(x, y, x1, y1), i);
                                    break;
                                case "t":
                                    segs.replaceItem(path.createSVGPathSegCurvetoQuadraticSmoothAbs(x, y), i);
                                    break;
                                case "a":
                                    segs.replaceItem(path.createSVGPathSegArcAbs(x, y, seg.r1, seg.r2, seg.angle, seg.largeArcFlag, seg.sweepFlag), i);
                                    break;
                                case "z":
                                case "Z":
                                    x = x0;
                                    y = y0;
                                    break;
                            }
                        }
                        if (segType == "M" || segType == "m") {
                            x0 = x;
                            y0 = y;
                        }
                    }
                };
            })();
        /***/ },
        /* 30 */ /***/ function(module1, exports, __webpack_require__) {
            /**
* This module has now been replaced by `Matter.Composite`.
*
* All usage should be migrated to the equivalent functions found on `Matter.Composite`.
* For example `World.add(world, body)` now becomes `Composite.add(world, body)`.
*
* The property `world.gravity` has been moved to `engine.gravity`.
*
* For back-compatibility purposes this module will remain as a direct alias to `Matter.Composite` in the short term during migration.
* Eventually this alias module will be marked as deprecated and then later removed in a future release.
*
* @class World
*/ var World = {};
            module1.exports = World;
            var Composite = __webpack_require__(6);
            var Common = __webpack_require__(0);
            (function() {
                /**
     * See above, aliases for back compatibility only
     */ World.create = Composite.create;
                World.add = Composite.add;
                World.remove = Composite.remove;
                World.clear = Composite.clear;
                World.addComposite = Composite.addComposite;
                World.addBody = Composite.addBody;
                World.addConstraint = Composite.addConstraint;
            })();
        /***/ }
    ]);
});



const $af92b340f4147145$var$THICKNESS = 1;
class $af92b340f4147145$export$2e2bcd8739ae039 {
    init() {
        this._frontWorld.classList.add("is-init");
        this.engine = (0, $0b508cf32695ce57$exports.Engine).create({});
        // this.engine.gravity.y = 0;
        this.render = (0, $0b508cf32695ce57$exports.Render).create({
            element: this._world,
            engine: this.engine,
            options: {
                width: this._world.offsetWidth,
                height: this._world.offsetHeight,
                background: "transparent",
                wireframes: true,
                showAngleIndicator: true
            }
        });
        this.runner = (0, $0b508cf32695ce57$exports.Runner).create({
            delta: 1000 / 600,
            maxFrameTime: 20
        });
        this.mouse = (0, $0b508cf32695ce57$exports.Mouse).create(this.render.canvas);
        this.bodies = [];
        this.createsRectangles();
        this.createCircles();
        this.createBoundaries();
        this.createTriangles();
        this.mouseConstraint = (0, $0b508cf32695ce57$exports.MouseConstraint).create(this.engine, {
            mouse: this.mouse,
            constraint: {
                stiffness: 0.2,
                render: {
                    visible: true
                }
            }
        });
        // Mouseover
        // Events.on(this.mouseConstraint, 'mousemove',  (event)  => {
        //     var foundPhysics = Query.point(this.bodies, event.mouse.position);
        //     if(foundPhysics[0]){
        //         foundPhysics[0].elem.classList.add('is-hover');
        //     }
        //     else{
        //         this.bodies.forEach((el) => {
        //            el.elem.classList.remove('is-hover'); 
        //         });
        //     }
        //
        // });
        (0, $0b508cf32695ce57$exports.Composite).add(this.engine.world, this.mouseConstraint);
        (0, $0b508cf32695ce57$exports.Render).run(this.render);
        (0, $0b508cf32695ce57$exports.Runner).run(this.runner, this.engine);
        this.isInit = true;
    }
    createsRectangles() {
        this.matterRectangles = [];
        if (this._rects.length) {
            this.rectangleDimensions = {
                width: this._rects[0].offsetWidth,
                height: this._rects[0].offsetHeight
            };
            let _rectAElem = document.querySelector(".js-toolbox-world-rect-a");
            let _rectBElem = document.querySelector(".js-toolbox-world-rect-b");
            //Rect A
            let rectAPosition = this.setPosition(this.getPercentX(this.positions.rectA.x), this.positions.rectA.y, this.rectangleDimensions.width, this.rectangleDimensions.height);
            this.rectA = (0, $0b508cf32695ce57$exports.Bodies).rectangle(rectAPosition.x, rectAPosition.y, this.rectangleDimensions.width, this.rectangleDimensions.height);
            this.rectA.elem = _rectAElem;
            (0, $0b508cf32695ce57$exports.Events).on(this.runner, "tick", ()=>{
                this.syncElemWithMatter(this.rectA.elem, this.rectA, this.rectangleDimensions.width, this.rectangleDimensions.height);
            });
            this.matterRectangles.push(this.rectA);
            this.bodies.push(this.rectA);
            //Rect B
            if (_rectBElem) {
                let rectBPosition = this.setPosition(this.getPercentX(this.positions.rectB.x), this.positions.rectB.y, this.rectangleDimensions.width, this.rectangleDimensions.height);
                this.rectB = (0, $0b508cf32695ce57$exports.Bodies).rectangle(rectBPosition.x, rectBPosition.y, this.rectangleDimensions.width, this.rectangleDimensions.height);
                this.rectB.elem = _rectBElem;
                (0, $0b508cf32695ce57$exports.Events).on(this.runner, "tick", ()=>{
                    this.syncElemWithMatter(this.rectB.elem, this.rectB, this.rectangleDimensions.width, this.rectangleDimensions.height);
                });
                this.matterRectangles.push(this.rectB);
                this.bodies.push(this.rectB);
            }
            (0, $0b508cf32695ce57$exports.Composite).add(this.engine.world, this.matterRectangles);
        }
    }
    createCircles() {
        this.matterCircles = [];
        if (this._circles.length) {
            this.circleDiameter = this._circles[0].offsetWidth;
            let _circleAElem = document.querySelector(".js-toolbox-world-circle-a");
            let _circleBElem = document.querySelector(".js-toolbox-world-circle-b");
            //Circle A;
            let circlePositionA = this.setPosition(this.positions.circleA.x, this.positions.circleA.y, this.circleDiameter, this.circleDiameter);
            this.circleA = (0, $0b508cf32695ce57$exports.Bodies).circle(circlePositionA.x, circlePositionA.y, this.circleDiameter / 2);
            this.circleA.elem = _circleAElem;
            (0, $0b508cf32695ce57$exports.Events).on(this.runner, "tick", ()=>{
                this.syncElemWithMatter(this.circleA.elem, this.circleA, this.circleDiameter, this.circleDiameter);
            });
            this.matterCircles.push(this.circleA);
            this.bodies.push(this.circleA);
            //Circle B;
            if (_circleBElem) {
                let circlePositionB = this.setPosition(this.getPercentX(this.positions.circleB.x), this.positions.circleB.y, this.circleDiameter, this.circleDiameter);
                this.circleB = (0, $0b508cf32695ce57$exports.Bodies).circle(circlePositionB.x, circlePositionB.y, this.circleDiameter / 2);
                this.circleB.elem = _circleBElem;
                (0, $0b508cf32695ce57$exports.Events).on(this.runner, "tick", ()=>{
                    this.syncElemWithMatter(this.circleB.elem, this.circleB, this.circleDiameter, this.circleDiameter);
                });
                this.matterCircles.push(this.circleB);
                this.bodies.push(this.circleB);
            }
            (0, $0b508cf32695ce57$exports.Composite).add(this.engine.world, this.matterCircles);
        }
    }
    createTriangles() {
        this.matterTriangles = [];
        if (this._triangles.length) {
            this.triangleDimensions = {
                width: this._triangles[0].offsetWidth,
                height: this._triangles[0].offsetHeight
            };
            const vertices = [
                {
                    x: this.triangleDimensions.width / 2,
                    y: 0
                },
                {
                    x: 0,
                    y: this.triangleDimensions.height
                },
                {
                    x: this.triangleDimensions.width,
                    y: this.triangleDimensions.height
                } // Bas droit
            ];
            let _triangleAElem = document.querySelector(".js-toolbox-world-triangle-a");
            let _triangleBElem = document.querySelector(".js-toolbox-world-triangle-b");
            // Triangle A
            let trianglePositionA = this.setPosition(this.getPercentX(this.positions.triangleA.x), this.positions.triangleA.y, this.triangleDimensions.width, this.triangleDimensions.height);
            this.triangleA = (0, $0b508cf32695ce57$exports.Bodies).fromVertices(trianglePositionA.x, trianglePositionA.y, [
                vertices
            ]);
            this.triangleA.elem = _triangleAElem;
            this.matterTriangles.push(this.triangleA);
            this.bodies.push(this.triangleA);
            (0, $0b508cf32695ce57$exports.Events).on(this.runner, "tick", ()=>{
                this.syncElemWithMatter(this.triangleA.elem, this.triangleA, this.triangleDimensions.width, this.triangleDimensions.height);
            });
            // Triangle B
            if (_triangleBElem) {
                let trianglePositionB = this.setPosition(this.getPercentX(this.positions.triangleB.x), this.positions.triangleB.y, this.triangleDimensions.width, this.triangleDimensions.height);
                this.triangleB = (0, $0b508cf32695ce57$exports.Bodies).fromVertices(trianglePositionB.x, trianglePositionB.y, [
                    vertices
                ]);
                this.triangleB.elem = _triangleBElem;
                this.matterTriangles.push(this.triangleB);
                this.bodies.push(this.triangleB);
                (0, $0b508cf32695ce57$exports.Events).on(this.runner, "tick", ()=>{
                    this.syncElemWithMatter(this.triangleB.elem, this.triangleB, this.triangleDimensions.width, this.triangleDimensions.height);
                });
            }
            (0, $0b508cf32695ce57$exports.Composite).add(this.engine.world, this.matterTriangles);
        }
    }
    bindEvents() {
        window.addEventListener("resize", app.debounce(this.onResize.bind(this)));
        // Button download
        let ease = "power2.out";
        this._frontWorld.addEventListener("mousemove", (e)=>{
            (0, $35069e6098950ce3$export$99ee26438460406a).to(this._btn, {
                x: e.clientX - this._frontWorld.getBoundingClientRect().left + 20,
                y: e.clientY - this._frontWorld.getBoundingClientRect().top + 20,
                ease: ease
            });
        });
        app.nodesEventListener("mouseenter", this._shapes, ()=>{
            (0, $35069e6098950ce3$export$99ee26438460406a).to(this._btn, {
                alpha: 1,
                scale: 1,
                ease: ease
            });
        });
        app.nodesEventListener("mouseleave", this._shapes, ()=>{
            (0, $35069e6098950ce3$export$99ee26438460406a).to(this._btn, {
                alpha: 0,
                scale: 0,
                ease: ease
            });
        });
    }
    createBoundaries() {
        this.left = (0, $0b508cf32695ce57$exports.Bodies).rectangle(0, 0, $af92b340f4147145$var$THICKNESS, 9999, {
            isStatic: true
        });
        this.right = (0, $0b508cf32695ce57$exports.Bodies).rectangle(this._world.offsetWidth, 0, $af92b340f4147145$var$THICKNESS, 9999, {
            isStatic: true
        });
        this.bottom = (0, $0b508cf32695ce57$exports.Bodies).rectangle(this._world.offsetWidth / 2, this._world.offsetHeight, 9999, $af92b340f4147145$var$THICKNESS, {
            isStatic: true
        });
        (0, $0b508cf32695ce57$exports.Composite).add(this.engine.world, [
            this.bottom,
            this.left,
            this.right
        ]);
    }
    onResize() {
        // this.render.canvas.width = this._world.offsetWidth;
        // this.render.canvas.height = this._world.offsetHeight;
        // Body.setPosition(this.bottom, Vector.create(this._world.offsetWidth / 2, this._world.offsetHeight));
        // Body.setPosition(this.left, Vector.create(0,0));
        // Body.setPosition(this.right, Vector.create(this._world.offsetWidth, 0));
        // Body.setPosition(this.top, Vector.create(this._world.offsetWidth / 2));
        if (this.worldWidth !== this._world.offsetWidth) {
            this.worldWidth = this._world.offsetWidth;
            (0, $0b508cf32695ce57$exports.Engine).clear(this.engine);
            (0, $0b508cf32695ce57$exports.Render).stop(this.render);
            (0, $0b508cf32695ce57$exports.Runner).stop(this.runner);
            (0, $0b508cf32695ce57$exports.World).clear(this.engine.world, false);
            (0, $0b508cf32695ce57$exports.Events).off(this.engine);
            (0, $0b508cf32695ce57$exports.Events).off(this.render);
            this.engine = null;
            this.render = null;
            this.runner = null;
            this.isInit = false;
            this._frontWorld.classList.remove("is-init");
            this.init();
        }
    }
    getPercentX(x) {
        let baseSize = 1920;
        let percentFromBaseSize = x / baseSize;
        let currentSize = this._world.offsetWidth;
        return currentSize * percentFromBaseSize;
    }
    setPosition(x, y, width, height) {
        return {
            x: width / 2 + x,
            y: height / 2 + y
        };
    }
    isMobile() {
        return window.matchMedia("(max-width:768px)").matches;
    }
    syncElemWithMatter(divElement, body, bodyWidth, bodyHeight) {
        let angle = body.angle;
        let scale = 1;
        divElement.style.transform = `translate(${body.position.x - bodyWidth / 2}px, ${body.position.y - bodyHeight / 2}px) rotate(${angle}rad) scale(${scale})`;
    }
    constructor(element){
        this._wrapper = element;
        this._world = this._wrapper.querySelector(".js-toolbox-virtual-world");
        this._frontWorld = this._wrapper.querySelector(".js-toolbox-world");
        this._shapes = this._wrapper.querySelectorAll('[class^="js-toolbox-world-circle"], [class^="js-toolbox-world-rect"], [class^="js-toolbox-world-triangle"]');
        this._circles = this._wrapper.querySelectorAll('[class^="js-toolbox-world-circle"]');
        this._rects = this._wrapper.querySelectorAll('[class^="js-toolbox-world-rect"]');
        this._triangles = this._wrapper.querySelectorAll('[class^="js-toolbox-world-triangle"]');
        this._btn = this._wrapper.querySelector(".js-toolbox-world-btn");
        this.worldWidth = this._world.offsetWidth;
        this.positions = {
            rectA: {
                x: this.isMobile() ? 170 : 195,
                y: this.isMobile() ? 0 : 300
            },
            rectB: {
                x: this.isMobile() ? 300 : 1302,
                y: this.isMobile() ? 350 : 0
            },
            circleA: {
                x: this.isMobile() ? 200 : 0,
                y: this.isMobile() ? 0 : 0
            },
            circleB: {
                x: this.isMobile() ? 0 : 735,
                y: this.isMobile() ? 314 : 347
            },
            triangleA: {
                x: this.isMobile() ? 66 : 261,
                y: this.isMobile() ? 380 : 0
            },
            triangleB: {
                x: this.isMobile() ? 0 : 1042,
                y: this.isMobile() ? 300 : 380
            }
        };
        this.isInit = false;
        this.observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    if (!this.isInit) {
                        if (this.isMobile()) setTimeout(()=>{
                            this.init();
                        }, 250);
                        else this.init();
                    }
                }
            });
        }, {
            threshold: 0.5
        });
        this.observer.observe(this._frontWorld);
        // this.init();
        this.bindEvents();
    }
}



var $97zcJ = parcelRequire("97zcJ");


var $8B3mG = parcelRequire("8B3mG");


var $ciZW6 = parcelRequire("ciZW6");















class $bc88b688129f8088$export$3fdc1addc39a1177 {
    async load() {
        await Promise.resolve((parcelRequire("4cwBt")));
        await Promise.resolve((parcelRequire("begiE")));
    }
    create() {
        const layouts = [
            document.createElement("media-audio-layout"),
            document.createElement("media-video-layout")
        ];
        if (this.props) {
            for (const [prop, value] of Object.entries(this.props))for (const el of layouts)el[prop] = value;
        }
        return layouts;
    }
    constructor(props){
        (0, $97zcJ._)(this, "name", "vidstack");
        this.props = props;
    }
}

class $bc88b688129f8088$export$935b3d959635207d {
    async load() {
        await (parcelRequire("e6DOx"));
    }
    create() {
        const layout = document.createElement("media-plyr-layout");
        if (this.props) for (const [prop, value] of Object.entries(this.props))layout[prop] = value;
        return [
            layout
        ];
    }
    constructor(props){
        (0, $97zcJ._)(this, "name", "plyr");
        this.props = props;
    }
}
const $bc88b688129f8088$var$LAYOUT_LOADED = Symbol();

class $bc88b688129f8088$export$24850c8883ce7a0c {
    static async create({ target: target, layout: layout, tracks: tracks, ...props }) {
        if ((0, $8B3mG.isString)(target)) target = document.querySelector(target);
        if (!(0, $ciZW6.isHTMLElement)(target)) throw Error(`[vidstack] target must be of type \`HTMLElement\`, found \`${typeof target}\``);
        let player = document.createElement("media-player"), provider = document.createElement("media-provider"), layouts, isTargetContainer = !(0, $9f21272e0549cf92$export$b83b0880d88b7dec)(target) && !(0, $9f21272e0549cf92$export$334f44aecfa32a9e)(target) && !(0, $9f21272e0549cf92$export$5180e63bc53de6dd)(target);
        player.setAttribute("keep-alive", "");
        if (props.poster && layout?.name !== "plyr") {
            if (!customElements.get("media-poster")) {
                const { MediaPosterElement: MediaPosterElement } = await Promise.resolve((parcelRequire("juFXD")));
                (0, $8B3mG.defineCustomElement)(MediaPosterElement);
            }
            const poster = document.createElement("media-poster");
            if (layout?.name === "vidstack") poster.classList.add("vds-poster");
            provider.append(poster);
        }
        if (layout) {
            target.removeAttribute("controls");
            if (!layout[$bc88b688129f8088$var$LAYOUT_LOADED]) {
                await layout.load();
                layout[$bc88b688129f8088$var$LAYOUT_LOADED] = true;
            }
            layouts = await layout.create();
        }
        const title = target.getAttribute("title");
        if (title) player.setAttribute("title", title);
        const width = target.getAttribute("width"), height = target.getAttribute("height");
        if (width || height) {
            if (width) player.style.width = width;
            if (height) player.style.height = height;
            player.style.aspectRatio = "unset";
        }
        for (const attr of target.attributes){
            const name = attr.name.replace("data-", ""), propName = (0, $8B3mG.kebabToCamelCase)(name);
            if (propName in player) player.setAttribute(name, attr.value);
            else if (layouts?.length) {
                for (const layout2 of layouts)if (propName in layout2) layout2.setAttribute(name, attr.value);
            }
        }
        for (const [prop, value] of Object.entries(props))player[prop] = value;
        if (tracks) for (const track of tracks)player.textTracks.add(track);
        player.append(provider);
        if (layouts) for (const layout2 of layouts)player.append(layout2);
        if (isTargetContainer) target.append(player);
        else {
            for (const child of [
                ...target.children
            ])provider.append(child);
            target.replaceWith(player);
        }
        return player;
    }
}


class $bab3f182bc208b52$export$2e2bcd8739ae039 {
    bindEvents() {
        if (this.type == "youtube") window.addEventListener("borlabs-cookie-consent-saved", ()=>{
            if (window.BorlabsCookie.Consents.hasConsent("youtube", "external-media")) {
                this._wrapper.querySelector(".js-video-consent").remove();
                (0, $bc88b688129f8088$export$24850c8883ce7a0c).create({
                    target: this._wrapper,
                    src: this.src,
                    poster: this.poster,
                    layout: new (0, $bc88b688129f8088$export$3fdc1addc39a1177)({
                        thumbnails: "https://files.vidstack.io/sprite-fight/thumbnails.vtt"
                    })
                });
            }
        });
    }
    constructor(element){
        this._wrapper = element;
        this.type = this._wrapper.getAttribute("data-type");
        this.src = this._wrapper.getAttribute("data-src");
        this.poster = this._wrapper.getAttribute("data-poster");
        this.bindEvents();
    }
}


function $471821aca19a2cc3$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
// Older browsers don't support event options, feature detect it.
// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi
var $471821aca19a2cc3$var$hasPassiveEvents = false;
if (typeof window !== "undefined") {
    var $471821aca19a2cc3$var$passiveTestOptions = {
        get passive () {
            $471821aca19a2cc3$var$hasPassiveEvents = true;
            return undefined;
        }
    };
    window.addEventListener("testPassive", null, $471821aca19a2cc3$var$passiveTestOptions);
    window.removeEventListener("testPassive", null, $471821aca19a2cc3$var$passiveTestOptions);
}
var $471821aca19a2cc3$var$isIosDevice = typeof window !== "undefined" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
var $471821aca19a2cc3$var$locks = [];
var $471821aca19a2cc3$var$documentListenerAdded = false;
var $471821aca19a2cc3$var$initialClientY = -1;
var $471821aca19a2cc3$var$previousBodyOverflowSetting = void 0;
var $471821aca19a2cc3$var$previousBodyPosition = void 0;
var $471821aca19a2cc3$var$previousBodyPaddingRight = void 0;
// returns true if `el` should be allowed to receive touchmove events.
var $471821aca19a2cc3$var$allowTouchMove = function allowTouchMove(el) {
    return $471821aca19a2cc3$var$locks.some(function(lock) {
        if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) return true;
        return false;
    });
};
var $471821aca19a2cc3$var$preventDefault = function preventDefault(rawEvent) {
    var e = rawEvent || window.event;
    // For the case whereby consumers adds a touchmove event listener to document.
    // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
    // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
    // the touchmove event on document will break.
    if ($471821aca19a2cc3$var$allowTouchMove(e.target)) return true;
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1) return true;
    if (e.preventDefault) e.preventDefault();
    return false;
};
var $471821aca19a2cc3$var$setOverflowHidden = function setOverflowHidden(options) {
    // If previousBodyPaddingRight is already set, don't set it again.
    if ($471821aca19a2cc3$var$previousBodyPaddingRight === undefined) {
        var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
        var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
        if (_reserveScrollBarGap && scrollBarGap > 0) {
            var computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right"), 10);
            $471821aca19a2cc3$var$previousBodyPaddingRight = document.body.style.paddingRight;
            document.body.style.paddingRight = computedBodyPaddingRight + scrollBarGap + "px";
        }
    }
    // If previousBodyOverflowSetting is already set, don't set it again.
    if ($471821aca19a2cc3$var$previousBodyOverflowSetting === undefined) {
        $471821aca19a2cc3$var$previousBodyOverflowSetting = document.body.style.overflow;
        document.body.style.overflow = "hidden";
    }
};
var $471821aca19a2cc3$var$restoreOverflowSetting = function restoreOverflowSetting() {
    if ($471821aca19a2cc3$var$previousBodyPaddingRight !== undefined) {
        document.body.style.paddingRight = $471821aca19a2cc3$var$previousBodyPaddingRight;
        // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
        // can be set again.
        $471821aca19a2cc3$var$previousBodyPaddingRight = undefined;
    }
    if ($471821aca19a2cc3$var$previousBodyOverflowSetting !== undefined) {
        document.body.style.overflow = $471821aca19a2cc3$var$previousBodyOverflowSetting;
        // Restore previousBodyOverflowSetting to undefined
        // so setOverflowHidden knows it can be set again.
        $471821aca19a2cc3$var$previousBodyOverflowSetting = undefined;
    }
};
var $471821aca19a2cc3$var$setPositionFixed = function setPositionFixed() {
    return window.requestAnimationFrame(function() {
        // If previousBodyPosition is already set, don't set it again.
        if ($471821aca19a2cc3$var$previousBodyPosition === undefined) {
            $471821aca19a2cc3$var$previousBodyPosition = {
                position: document.body.style.position,
                top: document.body.style.top,
                left: document.body.style.left
            };
            // Update the dom inside an animation frame 
            var _window = window, scrollY = _window.scrollY, scrollX = _window.scrollX, innerHeight = _window.innerHeight;
            document.body.style.position = "fixed";
            document.body.style.top = -scrollY;
            document.body.style.left = -scrollX;
            setTimeout(function() {
                return window.requestAnimationFrame(function() {
                    // Attempt to check if the bottom bar appeared due to the position change
                    var bottomBarHeight = innerHeight - window.innerHeight;
                    if (bottomBarHeight && scrollY >= innerHeight) // Move the content further up so that the bottom bar doesn't hide it
                    document.body.style.top = -(scrollY + bottomBarHeight);
                });
            }, 300);
        }
    });
};
var $471821aca19a2cc3$var$restorePositionSetting = function restorePositionSetting() {
    if ($471821aca19a2cc3$var$previousBodyPosition !== undefined) {
        // Convert the position from "px" to Int
        var y = -parseInt(document.body.style.top, 10);
        var x = -parseInt(document.body.style.left, 10);
        // Restore styles
        document.body.style.position = $471821aca19a2cc3$var$previousBodyPosition.position;
        document.body.style.top = $471821aca19a2cc3$var$previousBodyPosition.top;
        document.body.style.left = $471821aca19a2cc3$var$previousBodyPosition.left;
        // Restore scroll
        window.scrollTo(x, y);
        $471821aca19a2cc3$var$previousBodyPosition = undefined;
    }
};
// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var $471821aca19a2cc3$var$isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
    return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};
var $471821aca19a2cc3$var$handleScroll = function handleScroll(event, targetElement) {
    var clientY = event.targetTouches[0].clientY - $471821aca19a2cc3$var$initialClientY;
    if ($471821aca19a2cc3$var$allowTouchMove(event.target)) return false;
    if (targetElement && targetElement.scrollTop === 0 && clientY > 0) // element is at the top of its scroll.
    return $471821aca19a2cc3$var$preventDefault(event);
    if ($471821aca19a2cc3$var$isTargetElementTotallyScrolled(targetElement) && clientY < 0) // element is at the bottom of its scroll.
    return $471821aca19a2cc3$var$preventDefault(event);
    event.stopPropagation();
    return true;
};
var $471821aca19a2cc3$export$24fdf68abf432c44 = function disableBodyScroll(targetElement, options) {
    // targetElement must be provided
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
        return;
    }
    // disableBodyScroll must not have been called on this targetElement before
    if ($471821aca19a2cc3$var$locks.some(function(lock) {
        return lock.targetElement === targetElement;
    })) return;
    var lock = {
        targetElement: targetElement,
        options: options || {}
    };
    $471821aca19a2cc3$var$locks = [].concat($471821aca19a2cc3$var$_toConsumableArray($471821aca19a2cc3$var$locks), [
        lock
    ]);
    if ($471821aca19a2cc3$var$isIosDevice) $471821aca19a2cc3$var$setPositionFixed();
    else $471821aca19a2cc3$var$setOverflowHidden(options);
    if ($471821aca19a2cc3$var$isIosDevice) {
        targetElement.ontouchstart = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $471821aca19a2cc3$var$initialClientY = event.targetTouches[0].clientY;
        };
        targetElement.ontouchmove = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $471821aca19a2cc3$var$handleScroll(event, targetElement);
        };
        if (!$471821aca19a2cc3$var$documentListenerAdded) {
            document.addEventListener("touchmove", $471821aca19a2cc3$var$preventDefault, $471821aca19a2cc3$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $471821aca19a2cc3$var$documentListenerAdded = true;
        }
    }
};
var $471821aca19a2cc3$export$45a3ef215b2a5866 = function clearAllBodyScrollLocks() {
    if ($471821aca19a2cc3$var$isIosDevice) {
        // Clear all locks ontouchstart/ontouchmove handlers, and the references.
        $471821aca19a2cc3$var$locks.forEach(function(lock) {
            lock.targetElement.ontouchstart = null;
            lock.targetElement.ontouchmove = null;
        });
        if ($471821aca19a2cc3$var$documentListenerAdded) {
            document.removeEventListener("touchmove", $471821aca19a2cc3$var$preventDefault, $471821aca19a2cc3$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $471821aca19a2cc3$var$documentListenerAdded = false;
        }
        // Reset initial clientY.
        $471821aca19a2cc3$var$initialClientY = -1;
    }
    if ($471821aca19a2cc3$var$isIosDevice) $471821aca19a2cc3$var$restorePositionSetting();
    else $471821aca19a2cc3$var$restoreOverflowSetting();
    $471821aca19a2cc3$var$locks = [];
};
var $471821aca19a2cc3$export$e5d0524c3725571e = function enableBodyScroll(targetElement) {
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
        return;
    }
    $471821aca19a2cc3$var$locks = $471821aca19a2cc3$var$locks.filter(function(lock) {
        return lock.targetElement !== targetElement;
    });
    if ($471821aca19a2cc3$var$isIosDevice) {
        targetElement.ontouchstart = null;
        targetElement.ontouchmove = null;
        if ($471821aca19a2cc3$var$documentListenerAdded && $471821aca19a2cc3$var$locks.length === 0) {
            document.removeEventListener("touchmove", $471821aca19a2cc3$var$preventDefault, $471821aca19a2cc3$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $471821aca19a2cc3$var$documentListenerAdded = false;
        }
    }
    if ($471821aca19a2cc3$var$isIosDevice) $471821aca19a2cc3$var$restorePositionSetting();
    else $471821aca19a2cc3$var$restoreOverflowSetting();
};



class $5eefd6e18e446bf4$export$2e2bcd8739ae039 {
    unMute() {
        app.nodesEach(this.players, (el)=>{
            el.muted = false;
        });
    }
    playUntilSuccess(player) {
        // player.muted = false;
        player.play().catch((e)=>{
            console.error(`Error playing: ${e.message}`);
            setTimeout(()=>this.playUntilSuccess(player), 100);
        });
    }
    bindEvents() {
        app.nodesEventListener("click", this._triggers, (el)=>{
            if (this.isMobile()) {
                let id = parseInt(el.getAttribute("data-snap-id") - 1);
                this._wrapper.classList.add("is-open");
                if (id === 0) this.players[0].play();
                else this.swiper.slideTo(id);
                (0, $471821aca19a2cc3$export$24fdf68abf432c44)(this._wrapper);
                this.unMute();
            }
        });
        this._back.addEventListener("click", ()=>{
            app.nodesEach(this.players, (el)=>{
                el.pause();
            });
            (0, $471821aca19a2cc3$export$45a3ef215b2a5866)();
            this._wrapper.classList.remove("is-open");
        });
        if (this._cookiesAccept.length) app.nodesEventListener("click", this._cookiesAccept, ()=>{
            window.location.reload();
        });
    }
    isMobile() {
        return window.matchMedia("(max-width:576px)").matches;
    }
    constructor(element){
        this._wrapper = element;
        this._swiperEl = this._wrapper.querySelector(".swiper");
        this._triggers = document.querySelectorAll(".js-videos-snap-trigger");
        this.players = this._wrapper.querySelectorAll("media-player");
        this._back = this._wrapper.querySelector(".js-videos-snap-back");
        this._cookiesAccept = this._wrapper.querySelectorAll(".js-cookies-consent-youtube");
        this.swiper = new (0, $731acbcb25ce319f$export$25ce5a424b770e84)(this._swiperEl, {
            direction: "vertical"
        });
        this.currentIndex = 0;
        this.isMoving = false;
        this.swiper.on("slideChange", ()=>{
            app.nodesEach(this.players, (el)=>{
                el.pause();
            });
            this.playUntilSuccess(this.players[this.swiper.realIndex]);
        });
        this._swiperEl.addEventListener("touchstart", ()=>{
        // this.unMute();
        });
        this.bindEvents();
    }
}




class $aeabe4adcafdd9ea$export$2e2bcd8739ae039 {
    init() {
        this.slider = new (0, $731acbcb25ce319f$export$25ce5a424b770e84)(this._swiper, {
            slidesPerView: 1,
            loop: true,
            spaceBetween: 24,
            centeredSlides: true,
            modules: [
                (0, $ad4c197f78da2876$export$2e2bcd8739ae039)
            ],
            pagination: {
                el: this._pagination,
                type: "bullets",
                clickable: true
            },
            breakpoints: {
                576: {
                    spaceBetween: 40,
                    slidesPerView: 2
                },
                992: {
                    spaceBetween: 40,
                    slidesPerView: 3
                },
                1200: {
                    spaceBetween: 102,
                    slidesPerView: 3
                }
            }
        });
    }
    constructor(element){
        this._wrapper = element;
        this._swiper = this._wrapper.querySelector(".swiper");
        this.init();
    }
}



/*!
 * Physics2DPlugin 3.12.2
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $f3c2a5d7461717a5$var$gsap, $f3c2a5d7461717a5$var$_coreInitted, $f3c2a5d7461717a5$var$_getUnit, $f3c2a5d7461717a5$var$_getStyleSaver, $f3c2a5d7461717a5$var$_reverting, $f3c2a5d7461717a5$var$_DEG2RAD = Math.PI / 180, $f3c2a5d7461717a5$var$_getGSAP = function _getGSAP() {
    return $f3c2a5d7461717a5$var$gsap || typeof window !== "undefined" && ($f3c2a5d7461717a5$var$gsap = window.gsap) && $f3c2a5d7461717a5$var$gsap.registerPlugin && $f3c2a5d7461717a5$var$gsap;
}, $f3c2a5d7461717a5$var$_round = function _round(value) {
    return Math.round(value * 10000) / 10000;
}, $f3c2a5d7461717a5$var$_bonusValidated = 1, //<name>Physics2DPlugin</name>
$f3c2a5d7461717a5$var$_initCore = function _initCore(core) {
    $f3c2a5d7461717a5$var$gsap = core || $f3c2a5d7461717a5$var$_getGSAP();
    if (!$f3c2a5d7461717a5$var$_coreInitted) {
        $f3c2a5d7461717a5$var$_getUnit = $f3c2a5d7461717a5$var$gsap.utils.getUnit;
        $f3c2a5d7461717a5$var$_getStyleSaver = $f3c2a5d7461717a5$var$gsap.core.getStyleSaver;
        $f3c2a5d7461717a5$var$_reverting = $f3c2a5d7461717a5$var$gsap.core.reverting || function() {};
        $f3c2a5d7461717a5$var$_coreInitted = 1;
    }
};
var $f3c2a5d7461717a5$var$PhysicsProp = function PhysicsProp(target, p, velocity, acceleration, stepsPerTimeUnit) {
    var cache = target._gsap, curVal = cache.get(target, p);
    this.p = p;
    this.set = cache.set(target, p); //setter
    this.s = this.val = parseFloat(curVal);
    this.u = $f3c2a5d7461717a5$var$_getUnit(curVal) || 0;
    this.vel = velocity || 0;
    this.v = this.vel / stepsPerTimeUnit;
    if (acceleration || acceleration === 0) {
        this.acc = acceleration;
        this.a = this.acc / (stepsPerTimeUnit * stepsPerTimeUnit);
    } else this.acc = this.a = 0;
};
var $f3c2a5d7461717a5$export$5d87ab43e45722aa = {
    version: "3.12.2",
    name: "physics2D",
    register: $f3c2a5d7461717a5$var$_initCore,
    init: function init(target, value, tween) {
        $f3c2a5d7461717a5$var$_coreInitted || $f3c2a5d7461717a5$var$_initCore();
        var data = this, angle = +value.angle || 0, velocity = +value.velocity || 0, acceleration = +value.acceleration || 0, xProp = value.xProp || "x", yProp = value.yProp || "y", aAngle = value.accelerationAngle || value.accelerationAngle === 0 ? +value.accelerationAngle : angle;
        data.styles = $f3c2a5d7461717a5$var$_getStyleSaver && $f3c2a5d7461717a5$var$_getStyleSaver(target, value.xProp && value.xProp !== "x" ? value.xProp + "," + value.yProp : "transform");
        data.target = target;
        data.tween = tween;
        data.step = 0;
        data.sps = 30; //steps per second
        if (value.gravity) {
            acceleration = +value.gravity;
            aAngle = 90;
        }
        angle *= $f3c2a5d7461717a5$var$_DEG2RAD;
        aAngle *= $f3c2a5d7461717a5$var$_DEG2RAD;
        data.fr = 1 - (+value.friction || 0);
        data._props.push(xProp, yProp);
        data.xp = new $f3c2a5d7461717a5$var$PhysicsProp(target, xProp, Math.cos(angle) * velocity, Math.cos(aAngle) * acceleration, data.sps);
        data.yp = new $f3c2a5d7461717a5$var$PhysicsProp(target, yProp, Math.sin(angle) * velocity, Math.sin(aAngle) * acceleration, data.sps);
        data.skipX = data.skipY = 0;
    },
    render: function render(ratio, data) {
        var xp = data.xp, yp = data.yp, tween = data.tween, target = data.target, step = data.step, sps = data.sps, fr = data.fr, skipX = data.skipX, skipY = data.skipY, time = tween._from ? tween._dur - tween._time : tween._time, x, y, tt, steps, remainder, i;
        if (tween._time || !$f3c2a5d7461717a5$var$_reverting()) {
            if (fr === 1) {
                tt = time * time * 0.5;
                x = xp.s + xp.vel * time + xp.acc * tt;
                y = yp.s + yp.vel * time + yp.acc * tt;
            } else {
                time *= sps;
                steps = i = (time | 0) - step;
                /*
        Note: rounding errors build up if we walk the calculations backward which we used to do like this to maximize performance:
        	i = -i;
        	while (i--) {
        		xp.val -= xp.v;
        		yp.val -= yp.v;
        		xp.v /= fr;
        		yp.v /= fr;
        		xp.v -= xp.a;
        		yp.v -= yp.a;
        	}
        but now for the sake of accuracy (to ensure rewinding always goes back to EXACTLY the same spot), we force the calculations to go forward every time. So if the tween is going backward, we just start from the beginning and iterate. This is only necessary with friction.
         */ if (i < 0) {
                    xp.v = xp.vel / sps;
                    yp.v = yp.vel / sps;
                    xp.val = xp.s;
                    yp.val = yp.s;
                    data.step = 0;
                    steps = i = time | 0;
                }
                remainder = time % 1 * fr;
                while(i--){
                    xp.v += xp.a;
                    yp.v += yp.a;
                    xp.v *= fr;
                    yp.v *= fr;
                    xp.val += xp.v;
                    yp.val += yp.v;
                }
                x = xp.val + xp.v * remainder;
                y = yp.val + yp.v * remainder;
                data.step += steps;
            }
            skipX || xp.set(target, xp.p, $f3c2a5d7461717a5$var$_round(x) + xp.u);
            skipY || yp.set(target, yp.p, $f3c2a5d7461717a5$var$_round(y) + yp.u);
        } else data.styles.revert();
    },
    kill: function kill(property) {
        if (this.xp.p === property) this.skipX = 1;
        if (this.yp.p === property) this.skipY = 1;
    }
};
$f3c2a5d7461717a5$var$_getGSAP() && $f3c2a5d7461717a5$var$gsap.registerPlugin($f3c2a5d7461717a5$export$5d87ab43e45722aa);


(0, $35069e6098950ce3$export$99ee26438460406a).registerPlugin((0, $f3c2a5d7461717a5$export$5d87ab43e45722aa));
class $fd056df4e50f273d$export$2e2bcd8739ae039 {
    init() {
        this.timelines = [];
        app.nodesEach(this._shapes, (el)=>{
            let timeline = (0, $35069e6098950ce3$export$99ee26438460406a).timeline({
                overwrite: true
            }) // 
            .to(el, {
                x: this.getRandomX(el),
                y: this.getRandomY(el),
                duration: 6,
                ease: "sine.inOut",
                repeat: -1,
                repeatRefresh: true
            }).to(el, {
                rotation: "random(-180, 180, 10)",
                duration: 6,
                ease: "sine.inOut",
                repeat: -1,
                repeatRefresh: true
            }, 2);
            this.timelines.push(timeline);
        });
    }
    bindEvents() {
        window.addEventListener("resize", app.debounce(()=>{
            this.timelines.forEach((item)=>{
                item.kill();
            });
            this.init();
        }));
    }
    getRandomX(el) {
        let offsetWidth = this._marqueeWrapper.offsetWidth;
        let elemWidth = el.offsetWidth;
        let total = offsetWidth - elemWidth;
        return "random(0," + total + ",40)";
    }
    getRandomY(el) {
        let offsetHeight = this._marqueeWrapper.offsetHeight;
        let elemHeight = el.offsetHeight;
        let total = offsetHeight - elemHeight;
        return "random(0," + total + ",40)";
    }
    constructor(element){
        this._wrapper = element;
        this._marqueeWrapper = this._wrapper.querySelector(".js-moving-sectors-marquee-wrapper");
        this._shapes = this._wrapper.querySelectorAll(".js-moving-sectors-shape");
        this.init();
        this.bindEvents();
    }
}


class $e080a3d1894460ec$export$2e2bcd8739ae039 {
    bindEvents() {
        this._burger.addEventListener("click", ()=>{
            this._header.classList.toggle("is-open");
            this._overlay.classList.toggle("is-open");
        });
        this._overlay.addEventListener("click", ()=>{
            this._header.classList.remove("is-open");
            this._overlay.classList.remove("is-open");
        });
        app.nodesEventListener("click", this._searchPopinOpen, this.openSearchPopin.bind(this));
        this._searchPopinOverlay.addEventListener("click", this.closeSearchPopin.bind(this));
    }
    openSearchPopin() {
        this._searchPopin.classList.add("is-open");
        setTimeout(()=>{
            this._searchPopinInput.focus();
        }, 250);
    }
    closeSearchPopin() {
        this._searchPopin.classList.remove("is-open");
    }
    constructor(){
        this._header = document.querySelector(".header");
        this._burger = this._header.querySelector(".js-header-burger");
        this._overlay = document.querySelector(".js-header-overlay");
        this._searchPopin = document.querySelector(".js-header-search");
        this._searchPopinOverlay = document.querySelector(".js-header-search-overlay");
        this._searchPopinInput = document.querySelector(".js-header-search-input");
        this._searchPopinOpen = document.querySelectorAll(".js-search-open");
        this.bindEvents();
    }
}


class $1433b2a5d008d444$export$2e2bcd8739ae039 {
    bindEvents() {
        document.addEventListener("click", (e)=>{
            let _target = false;
            //Open
            if (e.target.classList.contains("js-popin-video-trigger")) _target = e.target;
            else if (e.target.closest(".js-popin-video-trigger")) _target = e.target.closest(".js-popin-video-trigger");
            if (_target) {
                if (_target.getAttribute("data-popin-video-only-desktop")) {
                    if (!this.isMobile()) this.openPopin(_target.getAttribute("data-popin-video-id"));
                } else this.openPopin(_target.getAttribute("data-popin-video-id"));
            }
            //Close
            if (e.target.classList.contains("js-popin-video-close") || e.target.closest(".js-popin-video-close")) this.closePopin();
        });
    }
    openPopin(id) {
        this._popin = document.querySelector('.js-popin-video[data-id="' + id + '"]');
        this._popin.classList.add("is-open");
        this.player = this._popin.querySelector("media-player");
        this.player.play();
    }
    closePopin() {
        this._popin.classList.remove("is-open");
        this.player.pause();
        this.player.currentTime = 0;
    }
    isMobile() {
        return window.matchMedia("(max-width:576px)").matches;
    }
    constructor(){
        this.bindEvents();
    }
}


class $139f0dbfb448c2bf$export$2e2bcd8739ae039 {
    bindEvents() {
        document.addEventListener("facetwp-loaded", this.updateUI.bind(this));
        app.nodesEventListener("click", this._items, this.onClickItem.bind(this));
    }
    updateUI() {
        let activeFacets = FWP.facets[this.facetKey];
        if (!activeFacets.length) app.nodesEach(this._items, (el, n)=>{
            el.checked = true;
        });
        else app.nodesEach(this._items, (el, n)=>{
            if (activeFacets.includes(el.value)) el.checked = true;
        });
    }
    onClickItem(el, n, e) {
        FWP.facets[this.facetKey] = [];
        app.nodesEach(this._items, (el, n)=>{
            if (el.checked) FWP.facets[this.facetKey].push(el.value);
        });
        FWP.fetchData();
        FWP.setHash();
    }
    constructor(element){
        this._wrapper = element;
        this._items = this._wrapper.querySelectorAll(".js-select-checkbox-item");
        this.facetKey = this._wrapper.getAttribute("data-facet");
        this.bindEvents();
    }
}


var $2937ea0c96f7acc8$exports = {};
/**!
 * MixItUp v3.3.2
 * A high-performance, dependency-free library for animated filtering, sorting and more
 * Build 94e0fbf6-cd0b-4987-b3c0-14b59b67b8a0
 *
 * @copyright Copyright 2014-2024 KunkaLabs Limited.
 * @author    KunkaLabs Limited.
 * @link      https://github.com/patrickkunka/mixitup
 * @license   Apache-2.0
 */ (function(window1) {
    "use strict";
    var mixitup = null, h = null;
    (function() {
        var VENDORS = [
            "webkit",
            "moz",
            "o",
            "ms"
        ], canary = window1.document.createElement("div"), i = -1;
        // window.requestAnimationFrame
        for(i = 0; i < VENDORS.length && !window1.requestAnimationFrame; i++)window1.requestAnimationFrame = window1[VENDORS[i] + "RequestAnimationFrame"];
        // Element.nextElementSibling
        if (typeof canary.nextElementSibling === "undefined") Object.defineProperty(window1.Element.prototype, "nextElementSibling", {
            get: function() {
                var el = this.nextSibling;
                while(el){
                    if (el.nodeType === 1) return el;
                    el = el.nextSibling;
                }
                return null;
            }
        });
        // Element.matches
        (function(ElementPrototype) {
            ElementPrototype.matches = ElementPrototype.matches || ElementPrototype.machesSelector || ElementPrototype.mozMatchesSelector || ElementPrototype.msMatchesSelector || ElementPrototype.oMatchesSelector || ElementPrototype.webkitMatchesSelector || function(selector) {
                return Array.prototype.indexOf.call(this.parentElement.querySelectorAll(selector), this) > -1;
            };
        })(window1.Element.prototype);
        // Object.keys
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
        if (!Object.keys) Object.keys = function() {
            var hasOwnProperty = Object.prototype.hasOwnProperty, hasDontEnumBug = false, dontEnums = [], dontEnumsLength = -1;
            hasDontEnumBug = !({
                toString: null
            }).propertyIsEnumerable("toString");
            dontEnums = [
                "toString",
                "toLocaleString",
                "valueOf",
                "hasOwnProperty",
                "isPrototypeOf",
                "propertyIsEnumerable",
                "constructor"
            ];
            dontEnumsLength = dontEnums.length;
            return function(obj) {
                var result = [], prop = "", i = -1;
                if (typeof obj !== "object" && (typeof obj !== "function" || obj === null)) throw new TypeError("Object.keys called on non-object");
                for(prop in obj)if (hasOwnProperty.call(obj, prop)) result.push(prop);
                if (hasDontEnumBug) {
                    for(i = 0; i < dontEnumsLength; i++)if (hasOwnProperty.call(obj, dontEnums[i])) result.push(dontEnums[i]);
                }
                return result;
            };
        }();
        // Array.isArray
        // https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray
        if (!Array.isArray) Array.isArray = function(arg) {
            return Object.prototype.toString.call(arg) === "[object Array]";
        };
        // Object.create
        // https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/create
        if (typeof Object.create !== "function") Object.create = function(undefined) {
            var Temp = function() {};
            return function(prototype, propertiesObject) {
                if (prototype !== Object(prototype) && prototype !== null) throw TypeError("Argument must be an object, or null");
                Temp.prototype = prototype || {};
                var result = new Temp();
                Temp.prototype = null;
                if (propertiesObject !== undefined) Object.defineProperties(result, propertiesObject);
                if (prototype === null) /* jshint ignore:start */ result.__proto__ = null;
                return result;
            };
        }();
        // String.prototyoe.trim
        if (!String.prototype.trim) String.prototype.trim = function() {
            return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
        };
        // Array.prototype.indexOf
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf
        if (!Array.prototype.indexOf) Array.prototype.indexOf = function(searchElement) {
            var n, k, t, len;
            if (this === null) throw new TypeError();
            t = Object(this);
            len = t.length >>> 0;
            if (len === 0) return -1;
            n = 0;
            if (arguments.length > 1) {
                n = Number(arguments[1]);
                if (n !== n) n = 0;
                else if (n !== 0 && n !== Infinity && n !== -Infinity) n = (n > 0 || -1) * Math.floor(Math.abs(n));
            }
            if (n >= len) return -1;
            for(k = n >= 0 ? n : Math.max(len - Math.abs(n), 0); k < len; k++){
                if (k in t && t[k] === searchElement) return k;
            }
            return -1;
        };
        // Function.prototype.bind
        // https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_objects/Function/bind
        if (!Function.prototype.bind) Function.prototype.bind = function(oThis) {
            var aArgs, self, FNOP, fBound;
            if (typeof this !== "function") throw new TypeError();
            aArgs = Array.prototype.slice.call(arguments, 1);
            self = this;
            FNOP = function() {};
            fBound = function() {
                return self.apply(this instanceof FNOP ? this : oThis, aArgs.concat(Array.prototype.slice.call(arguments)));
            };
            if (this.prototype) FNOP.prototype = this.prototype;
            fBound.prototype = new FNOP();
            return fBound;
        };
        // Element.prototype.dispatchEvent
        if (!window1.Element.prototype.dispatchEvent) window1.Element.prototype.dispatchEvent = function(event) {
            try {
                return this.fireEvent("on" + event.type, event);
            } catch (err) {}
        };
    })();
    /**
     * The `mixitup()` "factory" function creates and returns individual instances
     * of MixItUp, known as "mixers", on which API methods can be called.
     *
     * When loading MixItUp via a script tag, the factory function is accessed
     * via the global variable `mixitup`. When using a module loading
     * system (e.g. ES2015, CommonJS, RequireJS), the factory function is
     * exported into your module when you require the MixItUp library.
     *
     * @example
     * mixitup(container [,config] [,foreignDoc])
     *
     * @example <caption>Example 1: Creating a mixer instance with an element reference</caption>
     * var containerEl = document.querySelector('.container');
     *
     * var mixer = mixitup(containerEl);
     *
     * @example <caption>Example 2: Creating a mixer instance with a selector string</caption>
     * var mixer = mixitup('.container');
     *
     * @example <caption>Example 3: Passing a configuration object</caption>
     * var mixer = mixitup(containerEl, {
     *     animation: {
     *         effects: 'fade scale(0.5)'
     *     }
     * });
     *
     * @example <caption>Example 4: Passing an iframe reference</caption>
     * var mixer = mixitup(containerEl, config, foreignDocument);
     *
     * @global
     * @namespace
     * @public
     * @kind        function
     * @since       3.0.0
     * @param       {(Element|string)}  container
     *      A DOM element or selector string representing the container(s) on which to instantiate MixItUp.
     * @param       {object}            [config]
     *      An optional "configuration object" used to customize the behavior of the MixItUp instance.
     * @param       {object}            [foreignDoc]
     *      An optional reference to a `document`, which can be used to control a MixItUp instance in an iframe.
     * @return      {mixitup.Mixer}
     *      A "mixer" object holding the MixItUp instance.
     */ mixitup = function(container, config, foreignDoc) {
        var el = null, returnCollection = false, instance = null, facade = null, doc = null, output = null, instances = [], id = "", elements = [], i = -1;
        doc = foreignDoc || window1.document;
        if (returnCollection = arguments[3]) // A non-documented 4th paramater enabling control of multiple instances
        returnCollection = typeof returnCollection === "boolean";
        if (typeof container === "string") elements = doc.querySelectorAll(container);
        else if (container && typeof container === "object" && h.isElement(container, doc)) elements = [
            container
        ];
        else if (container && typeof container === "object" && container.length) // Although not documented, the container may also be an array-like list of
        // elements such as a NodeList or jQuery collection, is returnCollection is true
        elements = container;
        else throw new Error(mixitup.messages.errorFactoryInvalidContainer());
        if (elements.length < 1) throw new Error(mixitup.messages.errorFactoryContainerNotFound());
        for(i = 0; el = elements[i]; i++){
            if (i > 0 && !returnCollection) break;
            if (!el.id) {
                id = "MixItUp" + h.randomHex();
                el.id = id;
            } else id = el.id;
            if (mixitup.instances[id] instanceof mixitup.Mixer) {
                instance = mixitup.instances[id];
                if (!config || config && config.debug && config.debug.showWarnings !== false) console.warn(mixitup.messages.warningFactoryPreexistingInstance());
            } else {
                instance = new mixitup.Mixer();
                instance.attach(el, doc, id, config);
                mixitup.instances[id] = instance;
            }
            facade = new mixitup.Facade(instance);
            if (config && config.debug && config.debug.enable) instances.push(instance);
            else instances.push(facade);
        }
        if (returnCollection) output = new mixitup.Collection(instances);
        else // Return the first instance regardless
        output = instances[0];
        return output;
    };
    /**
     * The `.use()` static method is used to extend the functionality of mixitup with compatible
     * extensions and libraries in an environment with modular scoping e.g. ES2015, CommonJS, or RequireJS.
     *
     * You need only call the `.use()` function once per project, per extension, as module loaders
     * will cache a single reference to MixItUp inclusive of all changes made.
     *
     * @example
     * mixitup.use(extension)
     *
     * @example <caption>Example 1: Extending MixItUp with the Pagination Extension</caption>
     *
     * import mixitup from 'mixitup';
     * import mixitupPagination from 'mixitup-pagination';
     *
     * mixitup.use(mixitupPagination);
     *
     * // All mixers created by the factory function in all modules will now
     * // have pagination functionality
     *
     * var mixer = mixitup('.container');
     *
     * @public
     * @name     use
     * @memberof mixitup
     * @kind     function
     * @static
     * @since    3.0.0
     * @param    {*}  extension   A reference to the extension or library to be used.
     * @return   {void}
     */ mixitup.use = function(extension) {
        mixitup.Base.prototype.callActions.call(mixitup, "beforeUse", arguments);
        // Call the extension's factory function, passing
        // the mixitup factory as a paramater
        if (typeof extension === "function" && extension.TYPE === "mixitup-extension") // Mixitup extension
        {
            if (typeof mixitup.extensions[extension.NAME] === "undefined") {
                extension(mixitup);
                mixitup.extensions[extension.NAME] = extension;
            }
        } else if (extension.fn && extension.fn.jquery) // jQuery
        mixitup.libraries.$ = extension;
        mixitup.Base.prototype.callActions.call(mixitup, "afterUse", arguments);
    };
    mixitup.instances = {};
    mixitup.extensions = {};
    mixitup.libraries = {};
    /**
     * @private
     */ h = {
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        cls
         * @return  {boolean}
         */ hasClass: function(el, cls) {
            return !!el.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"));
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        cls
         * @return  {void}
         */ addClass: function(el, cls) {
            if (!this.hasClass(el, cls)) el.className += el.className ? " " + cls : cls;
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        cls
         * @return  {void}
         */ removeClass: function(el, cls) {
            if (this.hasClass(el, cls)) {
                var reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
                el.className = el.className.replace(reg, " ").trim();
            }
        },
        /**
         * Merges the properties of the source object onto the
         * target object. Alters the target object.
         *
         * @private
         * @param   {object}    destination
         * @param   {object}    source
         * @param   {boolean}   [deep=false]
         * @param   {boolean}   [handleErrors=false]
         * @return  {void}
         */ extend: function(destination, source, deep, handleErrors) {
            var sourceKeys = [], key = "", i = -1;
            deep = deep || false;
            handleErrors = handleErrors || false;
            try {
                if (Array.isArray(source)) for(i = 0; i < source.length; i++)sourceKeys.push(i);
                else if (source) sourceKeys = Object.keys(source);
                for(i = 0; i < sourceKeys.length; i++){
                    key = sourceKeys[i];
                    if (!deep || typeof source[key] !== "object" || this.isElement(source[key])) // All non-object properties, or all properties if shallow extend
                    destination[key] = source[key];
                    else if (Array.isArray(source[key])) {
                        // Arrays
                        if (!destination[key]) destination[key] = [];
                        this.extend(destination[key], source[key], deep, handleErrors);
                    } else {
                        // Objects
                        if (!destination[key]) destination[key] = {};
                        this.extend(destination[key], source[key], deep, handleErrors);
                    }
                }
            } catch (err) {
                if (handleErrors) this.handleExtendError(err, destination);
                else throw err;
            }
            return destination;
        },
        /**
         * @private
         * @param   {Error}  err
         * @param   {object} destination
         * @return  {void}
         */ handleExtendError: function(err, destination) {
            var re = /property "?(\w*)"?[,:] object/i, matches = null, erroneous = "", message = "", suggestion = "", probableMatch = "", key = "", mostMatchingChars = -1, i = -1;
            if (err instanceof TypeError && (matches = re.exec(err.message))) {
                erroneous = matches[1];
                for(key in destination){
                    i = 0;
                    while(i < erroneous.length && erroneous.charAt(i) === key.charAt(i))i++;
                    if (i > mostMatchingChars) {
                        mostMatchingChars = i;
                        probableMatch = key;
                    }
                }
                if (mostMatchingChars > 1) suggestion = mixitup.messages.errorConfigInvalidPropertySuggestion({
                    probableMatch: probableMatch
                });
                message = mixitup.messages.errorConfigInvalidProperty({
                    erroneous: erroneous,
                    suggestion: suggestion
                });
                throw new TypeError(message);
            }
            throw err;
        },
        /**
         * @private
         * @param   {string} str
         * @return  {function}
         */ template: function(str) {
            var re = /\${([\w]*)}/g, dynamics = {}, matches = null;
            while(matches = re.exec(str))dynamics[matches[1]] = new RegExp("\\${" + matches[1] + "}", "g");
            return function(data) {
                var key = "", output = str;
                data = data || {};
                for(key in dynamics)output = output.replace(dynamics[key], typeof data[key] !== "undefined" ? data[key] : "");
                return output;
            };
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        type
         * @param   {function}      fn
         * @param   {boolean}       useCapture
         * @return  {void}
         */ on: function(el, type, fn, useCapture) {
            if (!el) return;
            if (el.addEventListener) el.addEventListener(type, fn, useCapture);
            else if (el.attachEvent) {
                el["e" + type + fn] = fn;
                el[type + fn] = function() {
                    el["e" + type + fn](window1.event);
                };
                el.attachEvent("on" + type, el[type + fn]);
            }
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        type
         * @param   {function}      fn
         * @return  {void}
         */ off: function(el, type, fn) {
            if (!el) return;
            if (el.removeEventListener) el.removeEventListener(type, fn, false);
            else if (el.detachEvent) {
                el.detachEvent("on" + type, el[type + fn]);
                el[type + fn] = null;
            }
        },
        /**
         * @private
         * @param   {string}      eventType
         * @param   {object}      detail
         * @param   {Document}    [doc]
         * @return  {CustomEvent}
         */ getCustomEvent: function(eventType, detail, doc) {
            var event = null;
            doc = doc || window1.document;
            if (typeof window1.CustomEvent === "function") event = new window1.CustomEvent(eventType, {
                detail: detail,
                bubbles: true,
                cancelable: true
            });
            else if (typeof doc.createEvent === "function") {
                event = doc.createEvent("CustomEvent");
                event.initCustomEvent(eventType, true, true, detail);
            } else {
                event = doc.createEventObject(), event.type = eventType;
                event.returnValue = false;
                event.cancelBubble = false;
                event.detail = detail;
            }
            return event;
        },
        /**
         * @private
         * @param   {Event} e
         * @return  {Event}
         */ getOriginalEvent: function(e) {
            if (e.touches && e.touches.length) return e.touches[0];
            else if (e.changedTouches && e.changedTouches.length) return e.changedTouches[0];
            else return e;
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        selector
         * @return  {Number}
         */ index: function(el, selector) {
            var i = 0;
            while((el = el.previousElementSibling) !== null)if (!selector || el.matches(selector)) ++i;
            return i;
        },
        /**
         * Converts a dash or snake-case string to camel case.
         *
         * @private
         * @param   {string}    str
         * @param   {boolean}   [isPascal]
         * @return  {string}
         */ camelCase: function(str) {
            return str.toLowerCase().replace(/([_-][a-z])/g, function($1) {
                return $1.toUpperCase().replace(/[_-]/, "");
            });
        },
        /**
         * Converts a dash or snake-case string to pascal case.
         *
         * @private
         * @param   {string}    str
         * @param   {boolean}   [isPascal]
         * @return  {string}
         */ pascalCase: function(str) {
            return (str = this.camelCase(str)).charAt(0).toUpperCase() + str.slice(1);
        },
        /**
         * Converts a camel or pascal-case string to dash case.
         *
         * @private
         * @param   {string}    str
         * @return  {string}
         */ dashCase: function(str) {
            return str.replace(/([A-Z])/g, "-$1").replace(/^-/, "").toLowerCase();
        },
        /**
         * @private
         * @param   {HTMLElement}       el
         * @param   {HTMLHtmlElement}   [doc]
         * @return  {boolean}
         */ isElement: function(el, doc) {
            doc = doc || window1.document;
            if (window1.HTMLElement && el instanceof window1.HTMLElement) return true;
            else if (doc.defaultView && doc.defaultView.HTMLElement && el instanceof doc.defaultView.HTMLElement) return true;
            else return el !== null && el.nodeType === 1 && typeof el.nodeName === "string";
        },
        /**
         * @private
         * @param   {string}            htmlString
         * @param   {HTMLHtmlElement}   [doc]
         * @return  {DocumentFragment}
         */ createElement: function(htmlString, doc) {
            var frag = null, temp = null;
            doc = doc || window1.document;
            frag = doc.createDocumentFragment();
            temp = doc.createElement("div");
            temp.innerHTML = htmlString.trim();
            while(temp.firstChild)frag.appendChild(temp.firstChild);
            return frag;
        },
        /**
         * @private
         * @param   {Node} node
         * @return  {void}
         */ removeWhitespace: function(node) {
            var deleting;
            while(node && node.nodeName === "#text"){
                deleting = node;
                node = node.previousSibling;
                deleting.parentElement && deleting.parentElement.removeChild(deleting);
            }
        },
        /**
         * @private
         * @param   {Array<*>}  a
         * @param   {Array<*>}  b
         * @return  {boolean}
         */ isEqualArray: function(a, b) {
            var i = a.length;
            if (i !== b.length) return false;
            while(i--){
                if (a[i] !== b[i]) return false;
            }
            return true;
        },
        /**
         * @private
         * @param   {object}  a
         * @param   {object}  b
         * @return  {boolean}
         */ deepEquals: function(a, b) {
            var key;
            if (typeof a === "object" && a && typeof b === "object" && b) {
                if (Object.keys(a).length !== Object.keys(b).length) return false;
                for(key in a){
                    if (!b.hasOwnProperty(key) || !this.deepEquals(a[key], b[key])) return false;
                }
            } else if (a !== b) return false;
            return true;
        },
        /**
         * @private
         * @param   {Array<*>}  oldArray
         * @return  {Array<*>}
         */ arrayShuffle: function(oldArray) {
            var newArray = oldArray.slice(), len = newArray.length, i = len, p = -1, t = [];
            while(i--){
                p = ~~(Math.random() * len);
                t = newArray[i];
                newArray[i] = newArray[p];
                newArray[p] = t;
            }
            return newArray;
        },
        /**
         * @private
         * @param   {object}    list
         */ arrayFromList: function(list) {
            var output, i;
            try {
                return Array.prototype.slice.call(list);
            } catch (err) {
                output = [];
                for(i = 0; i < list.length; i++)output.push(list[i]);
                return output;
            }
        },
        /**
         * @private
         * @param   {function}  func
         * @param   {Number}    wait
         * @param   {boolean}   immediate
         * @return  {function}
         */ debounce: function(func, wait, immediate) {
            var timeout;
            return function() {
                var self = this, args = arguments, callNow = immediate && !timeout, later = null;
                later = function() {
                    timeout = null;
                    if (!immediate) func.apply(self, args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(self, args);
            };
        },
        /**
         * @private
         * @param   {HTMLElement}   element
         * @return  {object}
         */ position: function(element) {
            var xPosition = 0, yPosition = 0, offsetParent = element;
            while(element){
                xPosition -= element.scrollLeft;
                yPosition -= element.scrollTop;
                if (element === offsetParent) {
                    xPosition += element.offsetLeft;
                    yPosition += element.offsetTop;
                    offsetParent = element.offsetParent;
                }
                element = element.parentElement;
            }
            return {
                x: xPosition,
                y: yPosition
            };
        },
        /**
         * @private
         * @param   {object}    node1
         * @param   {object}    node2
         * @return  {Number}
         */ getHypotenuse: function(node1, node2) {
            var distanceX = node1.x - node2.x, distanceY = node1.y - node2.y;
            distanceX = distanceX < 0 ? distanceX * -1 : distanceX, distanceY = distanceY < 0 ? distanceY * -1 : distanceY;
            return Math.sqrt(Math.pow(distanceX, 2) + Math.pow(distanceY, 2));
        },
        /**
         * Calcuates the area of intersection between two rectangles and expresses it as
         * a ratio in comparison to the area of the first rectangle.
         *
         * @private
         * @param   {Rect}  box1
         * @param   {Rect}  box2
         * @return  {number}
         */ getIntersectionRatio: function(box1, box2) {
            var controlArea = box1.width * box1.height, intersectionX = -1, intersectionY = -1, intersectionArea = -1, ratio = -1;
            intersectionX = Math.max(0, Math.min(box1.left + box1.width, box2.left + box2.width) - Math.max(box1.left, box2.left));
            intersectionY = Math.max(0, Math.min(box1.top + box1.height, box2.top + box2.height) - Math.max(box1.top, box2.top));
            intersectionArea = intersectionY * intersectionX;
            ratio = intersectionArea / controlArea;
            return ratio;
        },
        /**
         * @private
         * @param   {object}            el
         * @param   {string}            selector
         * @param   {boolean}           [includeSelf]
         * @param   {HTMLHtmlElement}   [doc]
         * @return  {Element|null}
         */ closestParent: function(el, selector, includeSelf, doc) {
            var parent = el.parentNode;
            doc = doc || window1.document;
            if (includeSelf && el.matches(selector)) return el;
            while(parent && parent != doc.body){
                if (parent.matches && parent.matches(selector)) return parent;
                else if (parent.parentNode) parent = parent.parentNode;
                else return null;
            }
            return null;
        },
        /**
         * @private
         * @param   {HTMLElement}       el
         * @param   {string}            selector
         * @param   {HTMLHtmlElement}   [doc]
         * @return  {NodeList}
         */ children: function(el, selector, doc) {
            var children = [], tempId = "";
            doc = doc || window1.doc;
            if (el) {
                if (!el.id) {
                    tempId = "Temp" + this.randomHexKey();
                    el.id = tempId;
                }
                children = doc.querySelectorAll("#" + el.id + " > " + selector);
                if (tempId) el.removeAttribute("id");
            }
            return children;
        },
        /**
         * Creates a clone of a provided array, with any empty strings removed.
         *
         * @private
         * @param   {Array<*>} originalArray
         * @return  {Array<*>}
         */ clean: function(originalArray) {
            var cleanArray = [], i = -1;
            for(i = 0; i < originalArray.length; i++)if (originalArray[i] !== "") cleanArray.push(originalArray[i]);
            return cleanArray;
        },
        /**
         * Abstracts an ES6 promise into a q-like deferred interface for storage and deferred resolution.
         *
         * @private
         * @param  {object} libraries
         * @return {h.Deferred}
         */ defer: function(libraries) {
            var deferred = null, promiseWrapper = null, $ = null;
            promiseWrapper = new this.Deferred();
            if (mixitup.features.has.promises) // ES6 native promise or polyfill
            promiseWrapper.promise = new Promise(function(resolve, reject) {
                promiseWrapper.resolve = resolve;
                promiseWrapper.reject = reject;
            });
            else if (($ = window1.jQuery || libraries.$) && typeof $.Deferred === "function") {
                // jQuery
                deferred = $.Deferred();
                promiseWrapper.promise = deferred.promise();
                promiseWrapper.resolve = deferred.resolve;
                promiseWrapper.reject = deferred.reject;
            } else if (window1.console) // No implementation
            console.warn(mixitup.messages.warningNoPromiseImplementation());
            return promiseWrapper;
        },
        /**
         * @private
         * @param   {Array<Promise>}    tasks
         * @param   {object}            libraries
         * @return  {Promise<Array>}
         */ all: function(tasks, libraries) {
            var $ = null;
            if (mixitup.features.has.promises) return Promise.all(tasks);
            else if (($ = window1.jQuery || libraries.$) && typeof $.when === "function") return $.when.apply($, tasks).done(function() {
                // jQuery when returns spread arguments rather than an array or resolutions
                return arguments;
            });
            // No implementation
            if (window1.console) console.warn(mixitup.messages.warningNoPromiseImplementation());
            return [];
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @param   {string}        property
         * @param   {Array<string>} vendors
         * @return  {string}
         */ getPrefix: function(el, property, vendors) {
            var i = -1, prefix = "";
            if (h.dashCase(property) in el.style) return "";
            for(i = 0; prefix = vendors[i]; i++){
                if (prefix + property in el.style) return prefix.toLowerCase();
            }
            return "unsupported";
        },
        /**
         * @private
         * @return  {string}
         */ randomHex: function() {
            return ("00000" + (Math.random() * 16777216 << 0).toString(16)).substr(-6).toUpperCase();
        },
        /**
         * @private
         * @param   {HTMLDocument}  [doc]
         * @return  {object}
         */ getDocumentState: function(doc) {
            doc = typeof doc.body === "object" ? doc : window1.document;
            return {
                scrollTop: window1.pageYOffset,
                scrollLeft: window1.pageXOffset,
                docHeight: doc.documentElement.scrollHeight,
                docWidth: doc.documentElement.scrollWidth,
                viewportHeight: doc.documentElement.clientHeight,
                viewportWidth: doc.documentElement.clientWidth
            };
        },
        /**
         * @private
         * @param   {object}    obj
         * @param   {function}  fn
         * @return  {function}
         */ bind: function(obj, fn) {
            return function() {
                return fn.apply(obj, arguments);
            };
        },
        /**
         * @private
         * @param   {HTMLElement}   el
         * @return  {boolean}
         */ isVisible: function(el) {
            var styles = null;
            if (el.offsetParent) return true;
            styles = window1.getComputedStyle(el);
            if (styles.position === "fixed" && styles.visibility !== "hidden" && styles.opacity !== "0") // Fixed elements report no offsetParent,
            // but may still be invisible
            return true;
            return false;
        },
        /**
         * @private
         * @param   {object}    obj
         */ seal: function(obj) {
            if (typeof Object.seal === "function") Object.seal(obj);
        },
        /**
         * @private
         * @param   {object}    obj
         */ freeze: function(obj) {
            if (typeof Object.freeze === "function") Object.freeze(obj);
        },
        /**
         * @private
         * @param   {string}    control
         * @param   {string}    specimen
         * @return  {boolean}
         */ compareVersions: function(control, specimen) {
            var controlParts = control.split("."), specimenParts = specimen.split("."), controlPart = -1, specimenPart = -1, i = -1;
            for(i = 0; i < controlParts.length; i++){
                controlPart = parseInt(controlParts[i].replace(/[^\d.]/g, ""));
                specimenPart = parseInt(specimenParts[i].replace(/[^\d.]/g, "") || 0);
                if (specimenPart < controlPart) return false;
                else if (specimenPart > controlPart) return true;
            }
            return true;
        },
        /**
         * @private
         * @constructor
         */ Deferred: function() {
            this.promise = null;
            this.resolve = null;
            this.reject = null;
            this.id = h.randomHex();
        },
        /**
         * @private
         * @param   {object}  obj
         * @return  {boolean}
         */ isEmptyObject: function(obj) {
            var key = "";
            if (typeof Object.keys === "function") return Object.keys(obj).length === 0;
            for(key in obj){
                if (obj.hasOwnProperty(key)) return false;
            }
            return true;
        },
        /**
         * @param   {mixitup.Config.ClassNames}   classNames
         * @param   {string}                      elementName
         * @param   {string}                      [modifier]
         * @return  {string}
         */ getClassname: function(classNames, elementName, modifier) {
            var classname = "";
            classname += classNames.block;
            if (classname.length) classname += classNames.delineatorElement;
            classname += classNames["element" + this.pascalCase(elementName)];
            if (!modifier) return classname;
            if (classname.length) classname += classNames.delineatorModifier;
            classname += modifier;
            return classname;
        },
        /**
         * Returns the value of a property on a given object via its string key.
         *
         * @param   {object}    obj
         * @param   {string}    stringKey
         * @return  {*} value
         */ getProperty: function(obj, stringKey) {
            var parts = stringKey.split("."), returnCurrent = null, current = "", i = 0;
            if (!stringKey) return obj;
            returnCurrent = function(obj) {
                if (!obj) return null;
                else return obj[current];
            };
            while(i < parts.length){
                current = parts[i];
                obj = returnCurrent(obj);
                i++;
            }
            if (typeof obj !== "undefined") return obj;
            else return null;
        }
    };
    mixitup.h = h;
    /**
     * The Base class adds instance methods to all other extensible MixItUp classes,
     * enabling the calling of any registered hooks.
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Base = function() {};
    mixitup.Base.prototype = {
        constructor: mixitup.Base,
        /**
         * Calls any registered hooks for the provided action.
         *
         * @memberof    mixitup.Base
         * @private
         * @instance
         * @since       2.0.0
         * @param       {string}    actionName
         * @param       {Array<*>}  args
         * @return      {void}
         */ callActions: function(actionName, args) {
            var self = this, hooks = self.constructor.actions[actionName], extensionName = "";
            if (!hooks || h.isEmptyObject(hooks)) return;
            for(extensionName in hooks)hooks[extensionName].apply(self, args);
        },
        /**
         * Calls any registered hooks for the provided filter.
         *
         * @memberof    mixitup.Base
         * @private
         * @instance
         * @since       2.0.0
         * @param       {string}    filterName
         * @param       {*}         input
         * @param       {Array<*>}  args
         * @return      {*}
         */ callFilters: function(filterName, input, args) {
            var self = this, hooks = self.constructor.filters[filterName], output = input, extensionName = "";
            if (!hooks || h.isEmptyObject(hooks)) return output;
            args = args || [];
            for(extensionName in hooks){
                args = h.arrayFromList(args);
                args.unshift(output);
                output = hooks[extensionName].apply(self, args);
            }
            return output;
        }
    };
    /**
     * The BaseStatic class holds a set of static methods which are then added to all other
     * extensible MixItUp classes as a means of integrating extensions via the addition of new
     * methods and/or actions and hooks.
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.BaseStatic = function() {
        this.actions = {};
        this.filters = {};
        /**
         * Performs a shallow extend on the class's prototype, adding one or more new members to
         * the class in a single operation.
         *
         * @memberof    mixitup.BaseStatic
         * @public
         * @static
         * @since       2.1.0
         * @param       {object} extension
         * @return      {void}
         */ this.extend = function(extension) {
            h.extend(this.prototype, extension);
        };
        /**
         * Registers a function to be called on the action hook of the provided name.
         *
         * @memberof    mixitup.BaseStatic
         * @public
         * @static
         * @since       2.1.0
         * @param       {string}    hookName
         * @param       {string}    extensionName
         * @param       {function}  func
         * @return      {void}
         */ this.registerAction = function(hookName, extensionName, func) {
            (this.actions[hookName] = this.actions[hookName] || {})[extensionName] = func;
        };
        /**
         * Registers a function to be called on the filter of the provided name.
         *
         * @memberof    mixitup.BaseStatic
         * @public
         * @static
         * @since       2.1.0
         * @param       {string}    hookName
         * @param       {string}    extensionName
         * @param       {function}  func
         * @return      {void}
         */ this.registerFilter = function(hookName, extensionName, func) {
            (this.filters[hookName] = this.filters[hookName] || {})[extensionName] = func;
        };
    };
    /**
     * The `mixitup.Features` class performs all feature and CSS prefix detection
     * neccessary for MixItUp to function correctly, as well as storing various
     * string and array constants. All feature decection is on evaluation of the
     * library and stored in a singleton instance for use by other internal classes.
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Features = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.boxSizingPrefix = "";
        this.transformPrefix = "";
        this.transitionPrefix = "";
        this.boxSizingPrefix = "";
        this.transformProp = "";
        this.transformRule = "";
        this.transitionProp = "";
        this.perspectiveProp = "";
        this.perspectiveOriginProp = "";
        this.has = new mixitup.Has();
        this.canary = null;
        this.BOX_SIZING_PROP = "boxSizing";
        this.TRANSITION_PROP = "transition";
        this.TRANSFORM_PROP = "transform";
        this.PERSPECTIVE_PROP = "perspective";
        this.PERSPECTIVE_ORIGIN_PROP = "perspectiveOrigin";
        this.VENDORS = [
            "Webkit",
            "moz",
            "O",
            "ms"
        ];
        this.TWEENABLE = [
            "opacity",
            "width",
            "height",
            "marginRight",
            "marginBottom",
            "x",
            "y",
            "scale",
            "translateX",
            "translateY",
            "translateZ",
            "rotateX",
            "rotateY",
            "rotateZ"
        ];
        this.callActions("afterConstruct");
    };
    mixitup.BaseStatic.call(mixitup.Features);
    mixitup.Features.prototype = Object.create(mixitup.Base.prototype);
    h.extend(mixitup.Features.prototype, /** @lends mixitup.Features */ {
        constructor: mixitup.Features,
        /**
         * @private
         * @return  {void}
         */ init: function() {
            var self = this;
            self.callActions("beforeInit", arguments);
            self.canary = document.createElement("div");
            self.setPrefixes();
            self.runTests();
            self.callActions("beforeInit", arguments);
        },
        /**
         * @private
         * @return  {void}
         */ runTests: function() {
            var self = this;
            self.callActions("beforeRunTests", arguments);
            self.has.promises = typeof window1.Promise === "function";
            self.has.transitions = self.transitionPrefix !== "unsupported";
            self.callActions("afterRunTests", arguments);
            h.freeze(self.has);
        },
        /**
         * @private
         * @return  {void}
         */ setPrefixes: function() {
            var self = this;
            self.callActions("beforeSetPrefixes", arguments);
            self.transitionPrefix = h.getPrefix(self.canary, "Transition", self.VENDORS);
            self.transformPrefix = h.getPrefix(self.canary, "Transform", self.VENDORS);
            self.boxSizingPrefix = h.getPrefix(self.canary, "BoxSizing", self.VENDORS);
            self.boxSizingProp = self.boxSizingPrefix ? self.boxSizingPrefix + h.pascalCase(self.BOX_SIZING_PROP) : self.BOX_SIZING_PROP;
            self.transitionProp = self.transitionPrefix ? self.transitionPrefix + h.pascalCase(self.TRANSITION_PROP) : self.TRANSITION_PROP;
            self.transformProp = self.transformPrefix ? self.transformPrefix + h.pascalCase(self.TRANSFORM_PROP) : self.TRANSFORM_PROP;
            self.transformRule = self.transformPrefix ? "-" + self.transformPrefix + "-" + self.TRANSFORM_PROP : self.TRANSFORM_PROP;
            self.perspectiveProp = self.transformPrefix ? self.transformPrefix + h.pascalCase(self.PERSPECTIVE_PROP) : self.PERSPECTIVE_PROP;
            self.perspectiveOriginProp = self.transformPrefix ? self.transformPrefix + h.pascalCase(self.PERSPECTIVE_ORIGIN_PROP) : self.PERSPECTIVE_ORIGIN_PROP;
            self.callActions("afterSetPrefixes", arguments);
        }
    });
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Has = function() {
        this.transitions = false;
        this.promises = false;
        h.seal(this);
    };
    // Assign a singleton instance to `mixitup.features` and initialise:
    mixitup.features = new mixitup.Features();
    mixitup.features.init();
    /**
     * A group of properties defining the mixer's animation and effects settings.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        animation
     * @namespace
     * @public
     * @since       2.0.0
     */ mixitup.ConfigAnimation = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A boolean dictating whether or not animation should be enabled for the MixItUp instance.
         * If `false`, all operations will occur instantly and syncronously, although callback
         * functions and any returned promises will still be fulfilled.
         *
         * @example <caption>Example: Create a mixer with all animations disabled</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         enable: false
         *     }
         * });
         *
         * @name        enable
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.enable = true;
        /**
         * A string of one or more space-separated properties to which transitions will be
         * applied for all filtering animations.
         *
         * Properties can be listed any order or combination, although they will be applied in a specific
         * predefined order to produce consistent results.
         *
         * To learn more about available effects, experiment by providing different animation configurations to any of our [demos](https://patrickunka.github.io/mixitup/demos).
         *
         * @example <caption>Example: Apply "fade" and "translateZ" effects to all animations</caption>
         * // As targets are filtered in and out, they will fade between
         * // opacity 1 and 0 and transform between translateZ(-100px) and
         * // translateZ(0).
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effects: 'fade translateZ(-100px)'
         *     }
         * });
         *
         * @name        effects
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {string}
         * @default     'fade scale'
         */ this.effects = "fade scale";
        /**
         * A string of one or more space-seperated effects to be applied only to filter-in
         * animations, overriding `config.animation.effects` if set.
         *
         * @example <caption>Example: Apply downwards vertical translate to targets being filtered in</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effectsIn: 'fade translateY(-100%)'
         *     }
         * });
         *
         * @name        effectsIn
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {string}
         * @default     ''
         */ this.effectsIn = "";
        /**
         * A string of one or more space-seperated effects to be applied only to filter-out
         * animations, overriding `config.animation.effects` if set.
         *
         * @example <caption>Example: Apply upwards vertical translate to targets being filtered out</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effectsOut: 'fade translateY(-100%)'
         *     }
         * });
         *
         * @name        effectsOut
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {string}
         * @default     ''
         */ this.effectsOut = "";
        /**
         * An integer dictating the duration of all MixItUp animations in milliseconds, not
         * including any additional delay apllied via the `'stagger'` effect.
         *
         * @example <caption>Example: Apply an animation duration of 200ms to all mixitup animations</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         duration: 200
         *     }
         * });
         *
         * @name        duration
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {number}
         * @default     600
         */ this.duration = 600;
        /**
         * A valid CSS3 transition-timing function or shorthand. For a full list of accepted
         * values, visit <a href="http://easings.net" target="_blank">easings.net</a>.
         *
         * @example <caption>Example 1: Apply "ease-in-out" easing to all animations</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         easing: 'ease-in-out'
         *     }
         * });
         *
         * @example <caption>Example 2: Apply a custom "cubic-bezier" easing function to all animations</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)'
         *     }
         * });
         *
         * @name        easing
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {string}
         * @default     'ease'
         */ this.easing = "ease";
        /**
         * A boolean dictating whether or not to apply perspective to the MixItUp container
         * during animations. By default, perspective is always applied and creates the
         * illusion of three-dimensional space for effects such as `translateZ`, `rotateX`,
         * and `rotateY`.
         *
         * You may wish to disable this and define your own perspective settings via CSS.
         *
         * @example <caption>Example: Prevent perspective from being applied to any 3D transforms</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         applyPerspective: false
         *     }
         * });
         *
         * @name        applyPerspective
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {bolean}
         * @default     true
         */ this.applyPerspective = true;
        /**
         * The perspective distance value to be applied to the container during animations,
         * affecting any 3D-transform-based effects.
         *
         * @example <caption>Example: Set a perspective distance of 2000px</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effects: 'rotateY(-25deg)',
         *         perspectiveDistance: '2000px'
         *     }
         * });
         *
         * @name        perspectiveDistance
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {string}
         * @default     '3000px'
         */ this.perspectiveDistance = "3000px";
        /**
         * The perspective-origin value to be applied to the container during animations,
         * affecting any 3D-transform-based effects.
         *
         * @example <caption>Example: Set a perspective origin in the top-right of the container</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effects: 'transateZ(-200px)',
         *         perspectiveOrigin: '100% 0'
         *     }
         * });
         *
         * @name        perspectiveOrigin
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {string}
         * @default     '50% 50%'
         */ this.perspectiveOrigin = "50% 50%";
        /**
         * A boolean dictating whether or not to enable the queuing of operations.
         *
         * If `true` (default), and a control is clicked or an API call is made while another
         * operation is progress, the operation will go into the queue and will be automatically exectuted
         * when the previous operaitons is finished.
         *
         * If `false`, any requested operations will be ignored, and the `onMixBusy` callback and `mixBusy`
         * event will be fired. If `debug.showWarnings` is enabled, a console warning will also occur.
         *
         * @example <caption>Example: Disable queuing</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         queue: false
         *     }
         * });
         *
         * @name        queue
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.queue = true;
        /**
         * An integer dictacting the maximum number of operations allowed in the queue at
         * any time, when queuing is enabled.
         *
         * @example <caption>Example: Allow a maximum of 5 operations in the queue at any time</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         queueLimit: 5
         *     }
         * });
         *
         * @name        queueLimit
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {number}
         * @default     3
         */ this.queueLimit = 3;
        /**
         * A boolean dictating whether or not to transition the height and width of the
         * container as elements are filtered in and out. If disabled, the container height
         * will change abruptly.
         *
         * It may be desirable to disable this on mobile devices as the CSS `height` and
         * `width` properties do not receive GPU-acceleration and can therefore cause stuttering.
         *
         * @example <caption>Example 1: Disable the transitioning of the container height and/or width</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         animateResizeContainer: false
         *     }
         * });
         *
         * @example <caption>Example 2: Disable the transitioning of the container height and/or width for mobile devices only</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         animateResizeContainer: myFeatureTests.isMobile ? false : true
         *     }
         * });
         *
         * @name        animateResizeContainer
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.animateResizeContainer = true;
        /**
         * A boolean dictating whether or not to transition the height and width of target
         * elements as they change throughout the course of an animation.
         *
         * This is often a must for flex-box grid layouts where the size of target elements may change
         * depending on final their position in relation to their siblings, or for `.changeLayout()`
         * operations where the size of targets change between layouts.
         *
         * NB: This feature requires additional calculations and manipulation to non-hardware-accelerated
         * properties which may adversely affect performance on slower devices, and is therefore
         * disabled by default.
         *
         * @example <caption>Example: Enable the transitioning of target widths and heights</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         animateResizeTargets: true
         *     }
         * });
         *
         * @name        animateResizeTargets
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.animateResizeTargets = false;
        /**
         * A custom function used to manipulate the order in which the stagger delay is
         * incremented when using the ‘stagger’ effect.
         *
         * When using the 'stagger' effect, the delay applied to each target element is incremented
         * based on its index. You may create a custom function to manipulate the order in which the
         * delay is incremented and create engaging non-linear stagger effects.
         *
         * The function receives the index of the target element as a parameter, and must
         * return an integer which serves as the multiplier for the stagger delay.
         *
         * @example <caption>Example 1: Stagger target elements by column in a 3-column grid</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effects: 'fade stagger(100ms)',
         *         staggerSequence: function(i) {
         *             return i % 3;
         *         }
         *     }
         * });
         *
         * @example <caption>Example 2: Using an algorithm to produce a more complex sequence</caption>
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effects: 'fade stagger(100ms)',
         *         staggerSequence: function(i) {
         *             return (2*i) - (5*((i/3) - ((1/3) * (i%3))));
         *         }
         *     }
         * });
         *
         * @name        staggerSequence
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {function}
         * @default     null
         */ this.staggerSequence = null;
        /**
         * A boolean dictating whether or not to reverse the direction of `translate`
         * and `rotate` transforms for elements being filtered out.
         *
         * It can be used to create carousel-like animations where elements enter and exit
         * from opposite directions. If enabled, the effect `translateX(-100%)` for elements
         * being filtered in would become `translateX(100%)` for targets being filtered out.
         *
         * This functionality can also be achieved by providing seperate effects
         * strings for `config.animation.effectsIn` and `config.animation.effectsOut`.
         *
         * @example <caption>Example: Reverse the desired direction on any translate/rotate effect for targets being filtered out</caption>
         * // Elements being filtered in will be translated from '100%' to '0' while
         * // elements being filtered out will be translated from 0 to '-100%'
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         effects: 'fade translateX(100%)',
         *         reverseOut: true,
         *         nudge: false // Disable nudging to create a carousel-like effect
         *     }
         * });
         *
         * @name        reverseOut
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.reverseOut = false;
        /**
         * A boolean dictating whether or not to "nudge" the animation path of targets
         * when they are being filtered in and out simulatenously.
         *
         * This has been the default behavior of MixItUp since version 1, but it
         * may be desirable to disable this effect when filtering directly from
         * one exclusive set of targets to a different exclusive set of targets,
         * to create a carousel-like effect, or a generally more subtle animation.
         *
         * @example <caption>Example: Disable the "nudging" of targets being filtered in and out simulatenously</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         nudge: false
         *     }
         * });
         *
         * @name        nudge
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.nudge = true;
        /**
         * A boolean dictating whether or not to clamp the height of the container while MixItUp's
         * geometry tests are carried out before an operation.
         *
         * To prevent scroll-bar flicker, clamping is turned on by default. But in the case where the
         * height of the container might affect its vertical positioning in the viewport
         * (e.g. a vertically-centered container), this should be turned off to ensure accurate
         * test results and a smooth animation.
         *
         * @example <caption>Example: Disable container height-clamping</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         clampHeight: false
         *     }
         * });
         *
         * @name        clampHeight
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.clampHeight = true;
        /**
         * A boolean dictating whether or not to clamp the width of the container while MixItUp's
         * geometry tests are carried out before an operation.
         *
         * To prevent scroll-bar flicker, clamping is turned on by default. But in the case where the
         * width of the container might affect its horitzontal positioning in the viewport
         * (e.g. a horizontall-centered container), this should be turned off to ensure accurate
         * test results and a smooth animation.
         *
         * @example <caption>Example: Disable container width-clamping</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     animation: {
         *         clampWidth: false
         *     }
         * });
         *
         * @name        clampWidth
         * @memberof    mixitup.Config.animation
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.clampWidth = true;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigAnimation);
    mixitup.ConfigAnimation.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigAnimation.prototype.constructor = mixitup.ConfigAnimation;
    /**
     * A group of properties relating to the behavior of the Mixer.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        behavior
     * @namespace
     * @public
     * @since       3.1.12
     */ mixitup.ConfigBehavior = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A boolean dictating whether to allow "live" sorting of the mixer.
         *
         * Because of the expensive nature of sorting, MixItUp makes use of several
         * internal optimizations to skip redundant sorting operations, such as when
         * the newly requested sort command is the same as the active one. The caveat
         * to this optimization is that "live" edits to the value of a target's sorting
         * attribute will be ignored when requesting a re-sort by the same attribute.
         *
         * By setting to `behavior.liveSort` to `true`, the mixer will always re-sort
         * regardless of whether or not the sorting attribute and order have changed.
         *
         * @example <caption>Example: Enabling `liveSort` to allow for re-sorting</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     behavior: {
         *         liveSort: true
         *     },
         *     load: {
         *         sort: 'edited:desc'
         *     }
         * });
         *
         * var target = containerEl.children[3];
         *
         * console.log(target.getAttribute('data-edited')); // '2015-04-24'
         *
         * target.setAttribute('data-edited', '2017-08-10'); // Update the target's edited date
         *
         * mixer.sort('edited:desc')
         *     .then(function(state) {
         *         // The target is now at the top of the list
         *
         *         console.log(state.targets[0] === target); // true
         *     });
         *
         * @name        liveSort
         * @memberof    mixitup.Config.behavior
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.liveSort = false;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigBehavior);
    mixitup.ConfigBehavior.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigBehavior.prototype.constructor = mixitup.ConfigBehavior;
    /**
     * A group of optional callback functions to be invoked at various
     * points within the lifecycle of a mixer operation.
     *
     * Each function is analogous to an event of the same name triggered from the
     * container element, and is invoked immediately after it.
     *
     * All callback functions receive the current `state` object as their first
     * argument, as well as other more specific arguments described below.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        callbacks
     * @namespace
     * @public
     * @since       2.0.0
     */ mixitup.ConfigCallbacks = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A callback function invoked immediately after any MixItUp operation is requested
         * and before animations have begun.
         *
         * A second `futureState` argument is passed to the function which represents the final
         * state of the mixer once the requested operation has completed.
         *
         * @example <caption>Example: Adding an `onMixStart` callback function</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixStart: function(state, futureState) {
         *              console.log('Starting operation...');
         *         }
         *     }
         * });
         *
         * @name        onMixStart
         * @memberof    mixitup.Config.callbacks
         * @instance
         * @type        {function}
         * @default     null
         */ this.onMixStart = null;
        /**
         * A callback function invoked when a MixItUp operation is requested while another
         * operation is in progress, and the animation queue is full, or queueing
         * is disabled.
         *
         * @example <caption>Example: Adding an `onMixBusy` callback function</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixBusy: function(state) {
         *              console.log('Mixer busy');
         *         }
         *     }
         * });
         *
         * @name        onMixBusy
         * @memberof    mixitup.Config.callbacks
         * @instance
         * @type        {function}
         * @default     null
         */ this.onMixBusy = null;
        /**
         * A callback function invoked after any MixItUp operation has completed, and the
         * state has been updated.
         *
         * @example <caption>Example: Adding an `onMixEnd` callback function</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixEnd: function(state) {
         *              console.log('Operation complete');
         *         }
         *     }
         * });
         *
         * @name        onMixEnd
         * @memberof    mixitup.Config.callbacks
         * @instance
         * @type        {function}
         * @default     null
         */ this.onMixEnd = null;
        /**
         * A callback function invoked whenever an operation "fails", i.e. no targets
         * could be found matching the requested filter.
         *
         * @example <caption>Example: Adding an `onMixFail` callback function</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixFail: function(state) {
         *              console.log('No items could be found matching the requested filter');
         *         }
         *     }
         * });
         *
         * @name        onMixFail
         * @memberof    mixitup.Config.callbacks
         * @instance
         * @type        {function}
         * @default     null
         */ this.onMixFail = null;
        /**
         * A callback function invoked whenever a MixItUp control is clicked, and before its
         * respective operation is requested.
         *
         * The clicked element is assigned to the `this` keyword within the function. The original
         * click event is passed to the function as the second argument, which can be useful if
         * using `<a>` tags as controls where the default behavior needs to be prevented.
         *
         * Returning `false` from the callback will prevent the control click from triggering
         * an operation.
         *
         * @example <caption>Example 1: Adding an `onMixClick` callback function</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixClick: function(state, originalEvent) {
         *              console.log('The control "' + this.innerText + '" was clicked');
         *         }
         *     }
         * });
         *
         * @example <caption>Example 2: Using `onMixClick` to manipulate the original click event</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixClick: function(state, originalEvent) {
         *              // Prevent original click event from bubbling up:
         *              originalEvent.stopPropagation();
         *
         *              // Prevent default behavior of clicked element:
         *              originalEvent.preventDefault();
         *         }
         *     }
         * });
         *
         * @example <caption>Example 3: Using `onMixClick` to conditionally cancel operations</caption>
         * var mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixClick: function(state, originalEvent) {
         *              // Perform some conditional check:
         *
         *              if (myApp.isLoading) {
         *                  // By returning false, we can prevent the control click from triggering an operation.
         *
         *                  return false;
         *              }
         *         }
         *     }
         * });
         *
         * @name        onMixClick
         * @memberof    mixitup.Config.callbacks
         * @instance
         * @type        {function}
         * @default     null
         */ this.onMixClick = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigCallbacks);
    mixitup.ConfigCallbacks.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigCallbacks.prototype.constructor = mixitup.ConfigCallbacks;
    /**
     * A group of properties relating to clickable control elements.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        controls
     * @namespace
     * @public
     * @since       2.0.0
     */ mixitup.ConfigControls = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A boolean dictating whether or not controls should be enabled for the mixer instance.
         *
         * If `true` (default behavior), MixItUp will search the DOM for any clickable elements with
         * `data-filter`, `data-sort` or `data-toggle` attributes, and bind them for click events.
         *
         * If `false`, no click handlers will be bound, and all functionality must therefore be performed
         * via the mixer's API methods.
         *
         * If you do not intend to use the default controls, setting this property to `false` will
         * marginally improve the startup time of your mixer instance, and will also prevent any other active
         * mixer instances in the DOM which are bound to controls from controlling the instance.
         *
         * @example <caption>Example: Disabling controls</caption>
         * var mixer = mixitup(containerEl, {
         *     controls: {
         *         enable: false
         *     }
         * });
         *
         * // With the default controls disabled, we can only control
         * // the mixer via its API methods, e.g.:
         *
         * mixer.filter('.cat-1');
         *
         * @name        enable
         * @memberof    mixitup.Config.controls
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.enable = true;
        /**
         * A boolean dictating whether or not to use event delegation when binding click events
         * to the default controls.
         *
         * If `false` (default behavior), each control button in the DOM will be found and
         * individually bound when a mixer is instantiated, with their corresponding actions
         * cached for performance.
         *
         * If `true`, a single click handler will be applied to the `window` (or container element - see
         * `config.controls.scope`), and any click events triggered by elements with `data-filter`,
         * `data-sort` or `data-toggle` attributes present will be handled as they propagate upwards.
         *
         * If you require a user interface where control buttons may be added, removed, or changed during the
         * lifetime of a mixer, `controls.live` should be set to `true`. There is a marginal but unavoidable
         * performance deficit when using live controls, as the value of each control button must be read
         * from the DOM in real time once the click event has propagated.
         *
         * @example <caption>Example: Setting live controls</caption>
         * var mixer = mixitup(containerEl, {
         *     controls: {
         *         live: true
         *     }
         * });
         *
         * // Control buttons can now be added, remove and changed without breaking
         * // the mixer's UI
         *
         * @name        live
         * @memberof    mixitup.Config.controls
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.live = false;
        /**
         * A string dictating the "scope" to use when binding or querying the default controls. The available
         * values are `'global'` or `'local'`.
         *
         * When set to `'global'` (default behavior), MixItUp will query the entire document for control buttons
         * to bind, or delegate click events from (see `config.controls.live`).
         *
         * When set to `'local'`, MixItUp will only query (or bind click events to) its own container element.
         * This may be desireable if you require multiple active mixer instances within the same document, with
         * controls that would otherwise intefere with each other if scoped globally.
         *
         * Conversely, if you wish to control multiple instances with a single UI, you would create one
         * set of controls and keep the controls scope of each mixer set to `global`.
         *
         * @example <caption>Example: Setting 'local' scoped controls</caption>
         * var mixerOne = mixitup(containerOne, {
         *     controls: {
         *         scope: 'local'
         *     }
         * });
         *
         * var mixerTwo = mixitup(containerTwo, {
         *     controls: {
         *         scope: 'local'
         *     }
         * });
         *
         * // Both mixers can now exist within the same document with
         * // isolated controls placed within their container elements.
         *
         * @name        scope
         * @memberof    mixitup.Config.controls
         * @instance
         * @type        {string}
         * @default     'global'
         */ this.scope = "global"; // enum: ['local' ,'global']
        /**
         * A string dictating the type of logic to apply when concatenating the filter selectors of
         * active toggle buttons (i.e. any clickable element with a `data-toggle` attribute).
         *
         * If set to `'or'` (default behavior), selectors will be concatenated together as
         * a comma-seperated list. For example:
         *
         * `'.cat-1, .cat-2'` (shows any elements matching `'.cat-1'` OR `'.cat-2'`)
         *
         * If set to `'and'`, selectors will be directly concatenated together. For example:
         *
         * `'.cat-1.cat-2'` (shows any elements which match both `'.cat-1'` AND `'.cat-2'`)
         *
         * @example <caption>Example: Setting "and" toggle logic</caption>
         * var mixer = mixitup(containerEl, {
         *     controls: {
         *         toggleLogic: 'and'
         *     }
         * });
         *
         * @name        toggleLogic
         * @memberof    mixitup.Config.controls
         * @instance
         * @type        {string}
         * @default     'or'
         */ this.toggleLogic = "or"; // enum: ['or', 'and']
        /**
         * A string dictating the filter behavior when all toggles are inactive.
         *
         * When set to `'all'` (default behavior), *all* targets will be shown by default
         * when no toggles are active, or at the moment all active toggles are toggled off.
         *
         * When set to `'none'`, no targets will be shown by default when no toggles are
         * active, or at the moment all active toggles are toggled off.
         *
         * @example <caption>Example 1: Setting the default toggle behavior to `'all'`</caption>
         * var mixer = mixitup(containerEl, {
         *     controls: {
         *         toggleDefault: 'all'
         *     }
         * });
         *
         * mixer.toggleOn('.cat-2')
         *     .then(function() {
         *         // Deactivate all active toggles
         *
         *         return mixer.toggleOff('.cat-2')
         *     })
         *     .then(function(state) {
         *          console.log(state.activeFilter.selector); // 'all'
         *          console.log(state.totalShow); // 12
         *     });
         *
         * @example <caption>Example 2: Setting the default toggle behavior to `'none'`</caption>
         * var mixer = mixitup(containerEl, {
         *     controls: {
         *         toggleDefault: 'none'
         *     }
         * });
         *
         * mixer.toggleOn('.cat-2')
         *     .then(function() {
         *         // Deactivate all active toggles
         *
         *         return mixer.toggleOff('.cat-2')
         *     })
         *     .then(function(state) {
         *          console.log(state.activeFilter.selector); // 'none'
         *          console.log(state.totalShow); // 0
         *     });
         *
         * @name        toggleDefault
         * @memberof    mixitup.Config.controls
         * @instance
         * @type        {string}
         * @default     'all'
         */ this.toggleDefault = "all"; // enum: ['all', 'none']
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigControls);
    mixitup.ConfigControls.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigControls.prototype.constructor = mixitup.ConfigControls;
    /**
     * A group of properties defining the output and structure of class names programmatically
     * added to controls and containers to reflect the state of the mixer.
     *
     * Most commonly, class names are added to controls by MixItUp to indicate that
     * the control is active so that it can be styled accordingly - `'mixitup-control-active'` by default.
     *
     * Using a "BEM" like structure, each classname is broken into the three parts:
     * a block namespace (`'mixitup'`), an element name (e.g. `'control'`), and an optional modifier
     * name (e.g. `'active'`) reflecting the state of the element.
     *
     * By default, each part of the classname is concatenated together using single hyphens as
     * delineators, but this can be easily customised to match the naming convention and style of
     * your project.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        classNames
     * @namespace
     * @public
     * @since       3.0.0
     */ mixitup.ConfigClassNames = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * The "block" portion, or top-level namespace added to the start of any class names created by MixItUp.
         *
         * @example <caption>Example 1: changing the `config.classNames.block` value</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         block: 'portfolio'
         *     }
         * });
         *
         * // Active control output: "portfolio-control-active"
         *
         * @example <caption>Example 2: Removing `config.classNames.block`</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         block: ''
         *     }
         * });
         *
         * // Active control output: "control-active"
         *
         * @name        block
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'mixitup'
         */ this.block = "mixitup";
        /**
         * The "element" portion of the class name added to container.
         *
         * @name        elementContainer
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'container'
         */ this.elementContainer = "container";
        /**
         * The "element" portion of the class name added to filter controls.
         *
         * By default, all filter, sort, multimix and toggle controls take the same element value of `'control'`, but
         * each type's element value can be individually overwritten to match the unique classNames of your controls as needed.
         *
         * @example <caption>Example 1: changing the `config.classNames.elementFilter` value</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         elementFilter: 'filter'
         *     }
         * });
         *
         * // Active filter output: "mixitup-filter-active"
         *
         * @example <caption>Example 2: changing the `config.classNames.block` and `config.classNames.elementFilter` values</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         block: 'portfolio',
         *         elementFilter: 'filter'
         *     }
         * });
         *
         * // Active filter output: "portfolio-filter-active"
         *
         * @name        elementFilter
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'control'
         */ this.elementFilter = "control";
        /**
         * The "element" portion of the class name added to sort controls.
         *
         * By default, all filter, sort, multimix and toggle controls take the same element value of `'control'`, but
         * each type's element value can be individually overwritten to match the unique classNames of your controls as needed.
         *
         * @example <caption>Example 1: changing the `config.classNames.elementSort` value</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         elementSort: 'sort'
         *     }
         * });
         *
         * // Active sort output: "mixitup-sort-active"
         *
         * @example <caption>Example 2: changing the `config.classNames.block` and `config.classNames.elementSort` values</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         block: 'portfolio',
         *         elementSort: 'sort'
         *     }
         * });
         *
         * // Active sort output: "portfolio-sort-active"
         *
         * @name        elementSort
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'control'
         */ this.elementSort = "control";
        /**
         * The "element" portion of the class name added to multimix controls.
         *
         * By default, all filter, sort, multimix and toggle controls take the same element value of `'control'`, but
         * each type's element value can be individually overwritten to match the unique classNames of your controls as needed.
         *
         * @example <caption>Example 1: changing the `config.classNames.elementMultimix` value</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         elementMultimix: 'multimix'
         *     }
         * });
         *
         * // Active multimix output: "mixitup-multimix-active"
         *
         * @example <caption>Example 2: changing the `config.classNames.block` and `config.classNames.elementMultimix` values</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         block: 'portfolio',
         *         elementSort: 'multimix'
         *     }
         * });
         *
         * // Active multimix output: "portfolio-multimix-active"
         *
         * @name        elementMultimix
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'control'
         */ this.elementMultimix = "control";
        /**
         * The "element" portion of the class name added to toggle controls.
         *
         * By default, all filter, sort, multimix and toggle controls take the same element value of `'control'`, but
         * each type's element value can be individually overwritten to match the unique classNames of your controls as needed.
         *
         * @example <caption>Example 1: changing the `config.classNames.elementToggle` value</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         elementToggle: 'toggle'
         *     }
         * });
         *
         * // Active toggle output: "mixitup-toggle-active"
         *
         * @example <caption>Example 2: changing the `config.classNames.block` and `config.classNames.elementToggle` values</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         block: 'portfolio',
         *         elementToggle: 'toggle'
         *     }
         * });
         *
         * // Active toggle output: "portfolio-toggle-active"
         *
         * @name        elementToggle
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'control'
         */ this.elementToggle = "control";
        /**
         * The "modifier" portion of the class name added to active controls.
         * @name        modifierActive
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'active'
         */ this.modifierActive = "active";
        /**
         * The "modifier" portion of the class name added to disabled controls.
         *
         * @name        modifierDisabled
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'disabled'
         */ this.modifierDisabled = "disabled";
        /**
         * The "modifier" portion of the class name added to the container when in a "failed" state.
         *
         * @name        modifierFailed
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     'failed'
         */ this.modifierFailed = "failed";
        /**
         * The delineator used between the "block" and "element" portions of any class name added by MixItUp.
         *
         * If the block portion is ommited by setting it to an empty string, no delineator will be added.
         *
         * @example <caption>Example: changing the delineator to match BEM convention</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         delineatorElement: '__'
         *     }
         * });
         *
         * // example active control output: "mixitup__control-active"
         *
         * @name        delineatorElement
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     '-'
         */ this.delineatorElement = "-";
        /**
         * The delineator used between the "element" and "modifier" portions of any class name added by MixItUp.
         *
         * If the element portion is ommited by setting it to an empty string, no delineator will be added.
         *
         * @example <caption>Example: changing both delineators to match BEM convention</caption>
         * var mixer = mixitup(containerEl, {
         *     classNames: {
         *         delineatorElement: '__'
         *         delineatorModifier: '--'
         *     }
         * });
         *
         * // Active control output: "mixitup__control--active"
         *
         * @name        delineatorModifier
         * @memberof    mixitup.Config.classNames
         * @instance
         * @type        {string}
         * @default     '-'
         */ this.delineatorModifier = "-";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigClassNames);
    mixitup.ConfigClassNames.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigClassNames.prototype.constructor = mixitup.ConfigClassNames;
    /**
     * A group of properties relating to MixItUp's dataset API.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        data
     * @namespace
     * @public
     * @since       3.0.0
     */ mixitup.ConfigData = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A string specifying the name of the key containing your data model's unique
         * identifier (UID). To use the dataset API, a UID key must be specified and
         * be present and unique on all objects in the dataset you provide to MixItUp.
         *
         * For example, if your dataset is made up of MongoDB documents, the UID
         * key would be `'id'` or `'_id'`.
         *
         * @example <caption>Example: Setting the UID to `'id'`</caption>
         * var mixer = mixitup(containerEl, {
         *     data: {
         *         uidKey: 'id'
         *     }
         * });
         *
         * @name        uidKey
         * @memberof    mixitup.Config.data
         * @instance
         * @type        {string}
         * @default     ''
         */ this.uidKey = "";
        /**
         * A boolean dictating whether or not MixItUp should "dirty check" each object in
         * your dataset for changes whenever `.dataset()` is called, and re-render any targets
         * for which a change is found.
         *
         * Depending on the complexity of your data model, dirty checking can be expensive
         * and is therefore disabled by default.
         *
         * NB: For changes to be detected, a new immutable instance of the edited model must be
         * provided to mixitup, rather than manipulating properties on the existing instance.
         * If your changes are a result of a DB write and read, you will most likely be calling
         * `.dataset()` with a clean set of objects each time, so this will not be an issue.
         *
         * @example <caption>Example: Enabling dirty checking</caption>
         *
         * var myDataset = [
         *     {
         *         id: 0,
         *         title: "Blog Post Title 0"
         *         ...
         *     },
         *     {
         *         id: 1,
         *         title: "Blog Post Title 1"
         *         ...
         *     }
         * ];
         *
         * // Instantiate a mixer with a pre-loaded dataset, and a target renderer
         * // function defined
         *
         * var mixer = mixitup(containerEl, {
         *     data: {
         *         uidKey: 'id',
         *         dirtyCheck: true
         *     },
         *     load: {
         *         dataset: myDataset
         *     },
         *     render: {
         *         target: function() { ... }
         *     }
         * });
         *
         * // For illustration, we will clone and edit the second object in the dataset.
         * // NB: this would typically be done server-side in response to a DB update,
         * and then re-queried via an API.
         *
         * myDataset[1] = Object.assign({}, myDataset[1]);
         *
         * myDataset[1].title = 'Blog Post Title 11';
         *
         * mixer.dataset(myDataset)
         *    .then(function() {
         *        // the target with ID "1", will be re-rendered reflecting its new title
         *    });
         *
         * @name        dirtyCheck
         * @memberof    mixitup.Config.data
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.dirtyCheck = false;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigData);
    mixitup.ConfigData.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigData.prototype.constructor = mixitup.ConfigData;
    /**
     * A group of properties allowing the toggling of various debug features.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        debug
     * @namespace
     * @public
     * @since       3.0.0
     */ mixitup.ConfigDebug = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A boolean dictating whether or not the mixer instance returned by the
         * `mixitup()` factory function should expose private properties and methods.
         *
         * By default, mixer instances only expose their public API, but enabling
         * debug mode will give you access to various mixer internals which may aid
         * in debugging, or the authoring of extensions.
         *
         * @example <caption>Example: Enabling debug mode</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     debug: {
         *         enable: true
         *     }
         * });
         *
         * // Private properties and methods will now be visible on the mixer instance:
         *
         * console.log(mixer);
         *
         * @name        enable
         * @memberof    mixitup.Config.debug
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.enable = false;
        /**
         * A boolean dictating whether or not warnings should be shown when various
         * common gotchas occur.
         *
         * Warnings are intended to provide insights during development when something
         * occurs that is not a fatal, but may indicate an issue with your integration,
         * and are therefore turned on by default. However, you may wish to disable
         * them in production.
         *
         * @example <caption>Example 1: Disabling warnings</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     debug: {
         *         showWarnings: false
         *     }
         * });
         *
         * @example <caption>Example 2: Disabling warnings based on environment</caption>
         *
         * var showWarnings = myAppConfig.environment === 'development' ? true : false;
         *
         * var mixer = mixitup(containerEl, {
         *     debug: {
         *         showWarnings: showWarnings
         *     }
         * });
         *
         * @name        showWarnings
         * @memberof    mixitup.Config.debug
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.showWarnings = true;
        /**
         * Used for server-side testing only.
         *
         * @private
         * @name        fauxAsync
         * @memberof    mixitup.Config.debug
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.fauxAsync = false;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigDebug);
    mixitup.ConfigDebug.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigDebug.prototype.constructor = mixitup.ConfigDebug;
    /**
     * A group of properties relating to the layout of the container.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        layout
     * @namespace
     * @public
     * @since       3.0.0
     */ mixitup.ConfigLayout = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A boolean dictating whether or not mixitup should query all descendants
         * of the container for targets, or only immediate children.
         *
         * By default, mixitup will query all descendants matching the
         * `selectors.target` selector when indexing targets upon instantiation.
         * This allows for targets to be nested inside a sub-container which is
         * useful when ring-fencing targets from locally scoped controls in your
         * markup (see `controls.scope`).
         *
         * However, if you are building a more complex UI requiring the nesting
         * of mixers within mixers, you will most likely want to limit targets to
         * immediate children of the container by setting this property to `false`.
         *
         * @example <caption>Example: Restricting targets to immediate children</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     layout: {
         *         allowNestedTargets: false
         *     }
         * });
         *
         * @name        allowNestedTargets
         * @memberof    mixitup.Config.layout
         * @instance
         * @type        {boolean}
         * @default     true
         */ this.allowNestedTargets = true;
        /**
         * A string specifying an optional class name to apply to the container when in
         * its default state.
         *
         * By changing this class name or adding a class name to the container via the
         * `.changeLayout()` API method, the CSS layout of the container can be changed,
         * and MixItUp will attemp to gracefully animate the container and its targets
         * between states.
         *
         * @example <caption>Example 1: Specifying a container class name</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     layout: {
         *         containerClassName: 'grid'
         *     }
         * });
         *
         * @example <caption>Example 2: Changing the default class name with `.changeLayout()`</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     layout: {
         *         containerClassName: 'grid'
         *     }
         * });
         *
         * mixer.changeLayout('list')
         *     .then(function(state) {
         *          console.log(state.activeContainerClass); // "list"
         *     });
         *
         * @name        containerClassName
         * @memberof    mixitup.Config.layout
         * @instance
         * @type        {string}
         * @default     ''
         */ this.containerClassName = "";
        /**
         * A reference to a non-target sibling element after which to insert targets
         * when there are no targets in the container.
         *
         * @example <caption>Example: Setting a `siblingBefore` reference element</caption>
         *
         * var addButton = containerEl.querySelector('button');
         *
         * var mixer = mixitup(containerEl, {
         *     layout: {
         *         siblingBefore: addButton
         *     }
         * });
         *
         * @name        siblingBefore
         * @memberof    mixitup.Config.layout
         * @instance
         * @type        {HTMLElement}
         * @default     null
         */ this.siblingBefore = null;
        /**
         * A reference to a non-target sibling element before which to insert targets
         * when there are no targets in the container.
         *
         * @example <caption>Example: Setting an `siblingAfter` reference element</caption>
         *
         * var gap = containerEl.querySelector('.gap');
         *
         * var mixer = mixitup(containerEl, {
         *     layout: {
         *         siblingAfter: gap
         *     }
         * });
         *
         * @name        siblingAfter
         * @memberof    mixitup.Config.layout
         * @instance
         * @type        {HTMLElement}
         * @default     null
         */ this.siblingAfter = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigLayout);
    mixitup.ConfigLayout.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigLayout.prototype.constructor = mixitup.ConfigLayout;
    /**
     * A group of properties defining the initial state of the mixer on load (instantiation).
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        load
     * @namespace
     * @public
     * @since       2.0.0
     */ mixitup.ConfigLoad = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A string defining any filtering to be statically applied to the mixer on load.
         * As per the `.filter()` API, this can be any valid selector string, or the
         * values `'all'` or `'none'`.
         *
         * @example <caption>Example 1: Defining an initial filter selector to be applied on load</caption>
         *
         * // The mixer will show only those targets matching '.category-a' on load.
         *
         * var mixer = mixitup(containerEl, {
         *     load: {
         *         filter: '.category-a'
         *     }
         * });
         *
         * @example <caption>Example 2: Hiding all targets on load</caption>
         *
         * // The mixer will show hide all targets on load.
         *
         * var mixer = mixitup(containerEl, {
         *     load: {
         *         filter: 'none'
         *     }
         * });
         *
         * @name        filter
         * @memberof    mixitup.Config.load
         * @instance
         * @type        {string}
         * @default     'all'
         */ this.filter = "all";
        /**
         * A string defining any sorting to be statically applied to the mixer on load.
         * As per the `.sort()` API, this should be a valid "sort string" made up of
         * an attribute to sort by (or `'default'`) followed by an optional sorting
         * order, or the value `'random'`;
         *
         * @example <caption>Example: Defining sorting to be applied on load</caption>
         *
         * // The mixer will sort the container by the value of the `data-published-date`
         * // attribute, in descending order.
         *
         * var mixer = mixitup(containerEl, {
         *     load: {
         *         sort: 'published-date:desc'
         *     }
         * });
         *
         * @name        sort
         * @memberof    mixitup.Config.load
         * @instance
         * @type        {string}
         * @default     'default:asc'
         */ this.sort = "default:asc";
        /**
         * An array of objects representing the underlying data of any pre-rendered targets,
         * when using the `.dataset()` API.
         *
         * NB: If targets are pre-rendered when the mixer is instantiated, this must be set.
         *
         * @example <caption>Example: Defining the initial underyling dataset</caption>
         *
         * var myDataset = [
         *     {
         *         id: 0,
         *         title: "Blog Post Title 0",
         *         ...
         *     },
         *     {
         *         id: 1,
         *         title: "Blog Post Title 1",
         *         ...
         *     }
         * ];
         *
         * var mixer = mixitup(containerEl, {
         *     data: {
         *         uidKey: 'id'
         *     },
         *     load: {
         *         dataset: myDataset
         *     }
         * });
         *
         * @name        dataset
         * @memberof    mixitup.Config.load
         * @instance
         * @type        {Array.<object>}
         * @default     null
         */ this.dataset = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigLoad);
    mixitup.ConfigLoad.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigLoad.prototype.constructor = mixitup.ConfigLoad;
    /**
     * A group of properties defining the selectors used to query elements within a mixitup container.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        selectors
     * @namespace
     * @public
     * @since       3.0.0
     */ mixitup.ConfigSelectors = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A selector string used to query and index target elements within the container.
         *
         * By default, the class selector `'.mix'` is used, but this can be changed to an
         * attribute or element selector to match the style of your project.
         *
         * @example <caption>Example 1: Changing the target selector</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     selectors: {
         *         target: '.portfolio-item'
         *     }
         * });
         *
         * @example <caption>Example 2: Using an attribute selector as a target selector</caption>
         *
         * // The mixer will search for any children with the attribute `data-ref="mix"`
         *
         * var mixer = mixitup(containerEl, {
         *     selectors: {
         *         target: '[data-ref="mix"]'
         *     }
         * });
         *
         * @name        target
         * @memberof    mixitup.Config.selectors
         * @instance
         * @type        {string}
         * @default     '.mix'
         */ this.target = ".mix";
        /**
         * A optional selector string used to add further specificity to the querying of control elements,
         * in addition to their mandatory data attribute (e.g. `data-filter`, `data-toggle`, `data-sort`).
         *
         * This can be used if other elements in your document must contain the above attributes
         * (e.g. for use in third-party scripts), and would otherwise interfere with MixItUp. Adding
         * an additional `control` selector of your choice allows MixItUp to restrict event handling
         * to only those elements matching the defined selector.
         *
         * @name        control
         * @memberof    mixitup.Config.selectors
         * @instance
         * @type        {string}
         * @default     ''
         *
         * @example <caption>Example 1: Adding a `selectors.control` selector</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     selectors: {
         *         control: '.mixitup-control'
         *     }
         * });
         *
         * // Will not be handled:
         * // <button data-filter=".category-a"></button>
         *
         * // Will be handled:
         * // <button class="mixitup-control" data-filter=".category-a"></button>
         */ this.control = "";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigSelectors);
    mixitup.ConfigSelectors.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigSelectors.prototype.constructor = mixitup.ConfigSelectors;
    /**
     * A group of optional render functions for creating and updating elements.
     *
     * All render functions receive a data object, and should return a valid HTML string.
     *
     * @constructor
     * @memberof    mixitup.Config
     * @name        render
     * @namespace
     * @public
     * @since       3.0.0
     */ mixitup.ConfigRender = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A function returning an HTML string representing a target element, or a reference to a
         * single DOM element.
         *
         * The function is invoked as part of the `.dataset()` API, whenever a new item is added
         * to the dataset, or an item in the dataset changes (if `dataset.dirtyCheck` is enabled).
         *
         * The function receives the relevant dataset item as its first parameter.
         *
         * @example <caption>Example 1: Using string concatenation</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     render: {
         *         target: function(item) {
         *             return (
         *                 '&lt;div class="mix"&gt;' +
         *                     '&lt;h2&gt;' + item.title + '&lt;/h2&gt;' +
         *                 '&lt;/div&gt;'
         *             );
         *         }
         *     }
         * });
         *
         * @example <caption>Example 2: Using an ES2015 template literal</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     render: {
         *         target: function(item) {
         *             return (
         *                 `&lt;div class="mix"&gt;
         *                     &lt;h2&gt;${item.title}&lt;/h2&gt;
         *                  &lt;/div&gt;`
         *             );
         *         }
         *     }
         * });
         *
         * @example <caption>Example 3: Using a Handlebars template</caption>
         *
         * var targetTemplate = Handlebars.compile('&lt;div class="mix"&gt;&lt;h2&gt;{{title}}&lt;/h2&gt;&lt;/div&gt;');
         *
         * var mixer = mixitup(containerEl, {
         *     render: {
         *         target: targetTemplate
         *     }
         * });
         *
         * @example <caption>Example 4: Returning a DOM element</caption>
         *
         * var mixer = mixitup(containerEl, {
         *     render: {
         *         target: function(item) {
         *              // Create a single element using your framework's built-in renderer
         *
         *              var el = ...
         *
         *              return el;
         *         }
         *     }
         * });
         *
         * @name        target
         * @memberof    mixitup.Config.render
         * @instance
         * @type        {function}
         * @default     'null'
         */ this.target = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigRender);
    mixitup.ConfigRender.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigRender.prototype.constructor = mixitup.ConfigRender;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.ConfigTemplates = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ConfigTemplates);
    mixitup.ConfigTemplates.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ConfigTemplates.prototype.constructor = mixitup.ConfigTemplates;
    /**
     * `mixitup.Config` is an interface used for customising the functionality of a
     * mixer instance. It is organised into several semantically distinct sub-objects,
     * each one pertaining to a particular aspect of MixItUp functionality.
     *
     * An object literal containing any or all of the available properies,
     * known as the "configuration object", can be passed as the second parameter to
     * the `mixitup` factory function when creating a mixer instance to customise its
     * functionality as needed.
     *
     * If no configuration object is passed, the mixer instance will take on the default
     * configuration values detailed below.
     *
     * @example <caption>Example 1: Creating and passing the configuration object</caption>
     * // Create a configuration object with desired values
     *
     * var config = {
     *     animation: {
     *         enable: false
     *     },
     *     selectors: {
     *         target: '.item'
     *     }
     * };
     *
     * // Pass the configuration object to the mixitup factory function
     *
     * var mixer = mixitup(containerEl, config);
     *
     * @example <caption>Example 2: Passing the configuration object inline</caption>
     * // Typically, the configuration object is passed inline for brevity.
     *
     * var mixer = mixitup(containerEl, {
     *     controls: {
     *         live: true,
     *         toggleLogic: 'and'
     *     }
     * });
     *
     *
     * @constructor
     * @memberof    mixitup
     * @namespace
     * @public
     * @since       2.0.0
     */ mixitup.Config = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.animation = new mixitup.ConfigAnimation();
        this.behavior = new mixitup.ConfigBehavior();
        this.callbacks = new mixitup.ConfigCallbacks();
        this.controls = new mixitup.ConfigControls();
        this.classNames = new mixitup.ConfigClassNames();
        this.data = new mixitup.ConfigData();
        this.debug = new mixitup.ConfigDebug();
        this.layout = new mixitup.ConfigLayout();
        this.load = new mixitup.ConfigLoad();
        this.selectors = new mixitup.ConfigSelectors();
        this.render = new mixitup.ConfigRender();
        this.templates = new mixitup.ConfigTemplates();
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Config);
    mixitup.Config.prototype = Object.create(mixitup.Base.prototype);
    mixitup.Config.prototype.constructor = mixitup.Config;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.MixerDom = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.document = null;
        this.body = null;
        this.container = null;
        this.parent = null;
        this.targets = [];
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.MixerDom);
    mixitup.MixerDom.prototype = Object.create(mixitup.Base.prototype);
    mixitup.MixerDom.prototype.constructor = mixitup.MixerDom;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.UiClassNames = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.base = "";
        this.active = "";
        this.disabled = "";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.UiClassNames);
    mixitup.UiClassNames.prototype = Object.create(mixitup.Base.prototype);
    mixitup.UiClassNames.prototype.constructor = mixitup.UiClassNames;
    /**
     * An object into which all arbitrary arguments sent to '.dataset()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandDataset = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.dataset = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandDataset);
    mixitup.CommandDataset.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandDataset.prototype.constructor = mixitup.CommandDataset;
    /**
     * An object into which all arbitrary arguments sent to '.multimix()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandMultimix = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.filter = null;
        this.sort = null;
        this.insert = null;
        this.remove = null;
        this.changeLayout = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandMultimix);
    mixitup.CommandMultimix.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandMultimix.prototype.constructor = mixitup.CommandMultimix;
    /**
     * An object into which all arbitrary arguments sent to '.filter()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandFilter = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.selector = "";
        this.collection = null;
        this.action = "show"; // enum: ['show', 'hide']
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandFilter);
    mixitup.CommandFilter.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandFilter.prototype.constructor = mixitup.CommandFilter;
    /**
     * An object into which all arbitrary arguments sent to '.sort()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandSort = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.sortString = "";
        this.attribute = "";
        this.order = "asc";
        this.collection = null;
        this.next = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandSort);
    mixitup.CommandSort.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandSort.prototype.constructor = mixitup.CommandSort;
    /**
     * An object into which all arbitrary arguments sent to '.insert()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandInsert = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.index = 0;
        this.collection = [];
        this.position = "before"; // enum: ['before', 'after']
        this.sibling = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandInsert);
    mixitup.CommandInsert.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandInsert.prototype.constructor = mixitup.CommandInsert;
    /**
     * An object into which all arbitrary arguments sent to '.remove()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandRemove = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.targets = [];
        this.collection = [];
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandRemove);
    mixitup.CommandRemove.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandRemove.prototype.constructor = mixitup.CommandRemove;
    /**
     * An object into which all arbitrary arguments sent to '.changeLayout()' are mapped.
     *
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.CommandChangeLayout = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.containerClassName = "";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.CommandChangeLayout);
    mixitup.CommandChangeLayout.prototype = Object.create(mixitup.Base.prototype);
    mixitup.CommandChangeLayout.prototype.constructor = mixitup.CommandChangeLayout;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     * @param       {string}        type
     * @param       {string}        selector
     * @param       {boolean}       [live]
     * @param       {string}        [parent]
     *     An optional string representing the name of the mixer.dom property containing a reference to a parent element.
     */ mixitup.ControlDefinition = function(type, selector, live, parent) {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.type = type;
        this.selector = selector;
        this.live = live || false;
        this.parent = parent || "";
        this.callActions("afterConstruct");
        h.freeze(this);
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.ControlDefinition);
    mixitup.ControlDefinition.prototype = Object.create(mixitup.Base.prototype);
    mixitup.ControlDefinition.prototype.constructor = mixitup.ControlDefinition;
    mixitup.controlDefinitions = [];
    mixitup.controlDefinitions.push(new mixitup.ControlDefinition("multimix", "[data-filter][data-sort]"));
    mixitup.controlDefinitions.push(new mixitup.ControlDefinition("filter", "[data-filter]"));
    mixitup.controlDefinitions.push(new mixitup.ControlDefinition("sort", "[data-sort]"));
    mixitup.controlDefinitions.push(new mixitup.ControlDefinition("toggle", "[data-toggle]"));
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Control = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.el = null;
        this.selector = "";
        this.bound = [];
        this.pending = -1;
        this.type = "";
        this.status = "inactive"; // enum: ['inactive', 'active', 'disabled', 'live']
        this.filter = "";
        this.sort = "";
        this.canDisable = false;
        this.handler = null;
        this.classNames = new mixitup.UiClassNames();
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Control);
    mixitup.Control.prototype = Object.create(mixitup.Base.prototype);
    h.extend(mixitup.Control.prototype, /** @lends mixitup.Control */ {
        constructor: mixitup.Control,
        /**
         * @private
         * @param {HTMLElement} el
         * @param {string}      type
         * @param {string}      selector
         */ init: function(el, type, selector) {
            var self = this;
            this.callActions("beforeInit", arguments);
            self.el = el;
            self.type = type;
            self.selector = selector;
            if (self.selector) self.status = "live";
            else {
                self.canDisable = typeof self.el.disable === "boolean";
                switch(self.type){
                    case "filter":
                        self.filter = self.el.getAttribute("data-filter");
                        break;
                    case "toggle":
                        self.filter = self.el.getAttribute("data-toggle");
                        break;
                    case "sort":
                        self.sort = self.el.getAttribute("data-sort");
                        break;
                    case "multimix":
                        self.filter = self.el.getAttribute("data-filter");
                        self.sort = self.el.getAttribute("data-sort");
                        break;
                }
            }
            self.bindClick();
            mixitup.controls.push(self);
            this.callActions("afterInit", arguments);
        },
        /**
         * @private
         * @param  {mixitup.Mixer} mixer
         * @return {boolean}
         */ isBound: function(mixer) {
            var self = this, isBound = false;
            this.callActions("beforeIsBound", arguments);
            isBound = self.bound.indexOf(mixer) > -1;
            return self.callFilters("afterIsBound", isBound, arguments);
        },
        /**
         * @private
         * @param  {mixitup.Mixer} mixer
         * @return {void}
         */ addBinding: function(mixer) {
            var self = this;
            this.callActions("beforeAddBinding", arguments);
            if (!self.isBound()) self.bound.push(mixer);
            this.callActions("afterAddBinding", arguments);
        },
        /**
         * @private
         * @param  {mixitup.Mixer} mixer
         * @return {void}
         */ removeBinding: function(mixer) {
            var self = this, removeIndex = -1;
            this.callActions("beforeRemoveBinding", arguments);
            if ((removeIndex = self.bound.indexOf(mixer)) > -1) self.bound.splice(removeIndex, 1);
            if (self.bound.length < 1) {
                // No bindings exist, unbind event click handlers
                self.unbindClick();
                // Remove from `mixitup.controls` list
                removeIndex = mixitup.controls.indexOf(self);
                mixitup.controls.splice(removeIndex, 1);
                if (self.status === "active") self.renderStatus(self.el, "inactive");
            }
            this.callActions("afterRemoveBinding", arguments);
        },
        /**
         * @private
         * @return {void}
         */ bindClick: function() {
            var self = this;
            this.callActions("beforeBindClick", arguments);
            self.handler = function(e) {
                self.handleClick(e);
            };
            h.on(self.el, "click", self.handler);
            this.callActions("afterBindClick", arguments);
        },
        /**
         * @private
         * @return {void}
         */ unbindClick: function() {
            var self = this;
            this.callActions("beforeUnbindClick", arguments);
            h.off(self.el, "click", self.handler);
            self.handler = null;
            this.callActions("afterUnbindClick", arguments);
        },
        /**
         * @private
         * @param   {MouseEvent} e
         * @return  {void}
         */ handleClick: function(e) {
            var self = this, button = null, mixer = null, isActive = false, returnValue = void 0, command = {}, clone = null, commands = [], i = -1;
            this.callActions("beforeHandleClick", arguments);
            this.pending = 0;
            mixer = self.bound[0];
            if (!self.selector) button = self.el;
            else button = h.closestParent(e.target, mixer.config.selectors.control + self.selector, true, mixer.dom.document);
            if (!button) {
                self.callActions("afterHandleClick", arguments);
                return;
            }
            switch(self.type){
                case "filter":
                    command.filter = self.filter || button.getAttribute("data-filter");
                    break;
                case "sort":
                    command.sort = self.sort || button.getAttribute("data-sort");
                    break;
                case "multimix":
                    command.filter = self.filter || button.getAttribute("data-filter");
                    command.sort = self.sort || button.getAttribute("data-sort");
                    break;
                case "toggle":
                    command.filter = self.filter || button.getAttribute("data-toggle");
                    if (self.status === "live") isActive = h.hasClass(button, self.classNames.active);
                    else isActive = self.status === "active";
                    break;
            }
            for(i = 0; i < self.bound.length; i++){
                // Create a clone of the command for each bound mixer instance
                clone = new mixitup.CommandMultimix();
                h.extend(clone, command);
                commands.push(clone);
            }
            commands = self.callFilters("commandsHandleClick", commands, arguments);
            self.pending = self.bound.length;
            for(i = 0; mixer = self.bound[i]; i++){
                command = commands[i];
                if (!command) continue;
                if (!mixer.lastClicked) mixer.lastClicked = button;
                mixitup.events.fire("mixClick", mixer.dom.container, {
                    state: mixer.state,
                    instance: mixer,
                    originalEvent: e,
                    control: mixer.lastClicked
                }, mixer.dom.document);
                if (typeof mixer.config.callbacks.onMixClick === "function") {
                    returnValue = mixer.config.callbacks.onMixClick.call(mixer.lastClicked, mixer.state, e, mixer);
                    if (returnValue === false) continue;
                }
                if (self.type === "toggle") isActive ? mixer.toggleOff(command.filter) : mixer.toggleOn(command.filter);
                else mixer.multimix(command);
            }
            this.callActions("afterHandleClick", arguments);
        },
        /**
         * @param   {object}          command
         * @param   {Array<string>}   toggleArray
         * @return  {void}
         */ update: function(command, toggleArray) {
            var self = this, actions = new mixitup.CommandMultimix();
            self.callActions("beforeUpdate", arguments);
            self.pending--;
            self.pending = Math.max(0, self.pending);
            if (self.pending > 0) return;
            if (self.status === "live") // Live control (status unknown)
            self.updateLive(command, toggleArray);
            else {
                // Static control
                actions.sort = self.sort;
                actions.filter = self.filter;
                self.callFilters("actionsUpdate", actions, arguments);
                self.parseStatusChange(self.el, command, actions, toggleArray);
            }
            self.callActions("afterUpdate", arguments);
        },
        /**
         * @param   {mixitup.CommandMultimix} command
         * @param   {Array<string>}           toggleArray
         * @return  {void}
         */ updateLive: function(command, toggleArray) {
            var self = this, controlButtons = null, actions = null, button = null, i = -1;
            self.callActions("beforeUpdateLive", arguments);
            if (!self.el) return;
            controlButtons = self.el.querySelectorAll(self.selector);
            for(i = 0; button = controlButtons[i]; i++){
                actions = new mixitup.CommandMultimix();
                switch(self.type){
                    case "filter":
                        actions.filter = button.getAttribute("data-filter");
                        break;
                    case "sort":
                        actions.sort = button.getAttribute("data-sort");
                        break;
                    case "multimix":
                        actions.filter = button.getAttribute("data-filter");
                        actions.sort = button.getAttribute("data-sort");
                        break;
                    case "toggle":
                        actions.filter = button.getAttribute("data-toggle");
                        break;
                }
                actions = self.callFilters("actionsUpdateLive", actions, arguments);
                self.parseStatusChange(button, command, actions, toggleArray);
            }
            self.callActions("afterUpdateLive", arguments);
        },
        /**
         * @param   {HTMLElement}             button
         * @param   {mixitup.CommandMultimix} command
         * @param   {mixitup.CommandMultimix} actions
         * @param   {Array<string>}           toggleArray
         * @return  {void}
         */ parseStatusChange: function(button, command, actions, toggleArray) {
            var self = this, alias = "", toggle = "", i = -1;
            self.callActions("beforeParseStatusChange", arguments);
            switch(self.type){
                case "filter":
                    if (command.filter === actions.filter) self.renderStatus(button, "active");
                    else self.renderStatus(button, "inactive");
                    break;
                case "multimix":
                    if (command.sort === actions.sort && command.filter === actions.filter) self.renderStatus(button, "active");
                    else self.renderStatus(button, "inactive");
                    break;
                case "sort":
                    if (command.sort.match(/:asc/g)) alias = command.sort.replace(/:asc/g, "");
                    if (command.sort === actions.sort || alias === actions.sort) self.renderStatus(button, "active");
                    else self.renderStatus(button, "inactive");
                    break;
                case "toggle":
                    if (toggleArray.length < 1) self.renderStatus(button, "inactive");
                    if (command.filter === actions.filter) self.renderStatus(button, "active");
                    for(i = 0; i < toggleArray.length; i++){
                        toggle = toggleArray[i];
                        if (toggle === actions.filter) {
                            // Button matches one active toggle
                            self.renderStatus(button, "active");
                            break;
                        }
                        self.renderStatus(button, "inactive");
                    }
                    break;
            }
            self.callActions("afterParseStatusChange", arguments);
        },
        /**
         * @param   {HTMLElement}   button
         * @param   {string}        status
         * @return  {void}
         */ renderStatus: function(button, status) {
            var self = this;
            self.callActions("beforeRenderStatus", arguments);
            switch(status){
                case "active":
                    h.addClass(button, self.classNames.active);
                    h.removeClass(button, self.classNames.disabled);
                    if (self.canDisable) self.el.disabled = false;
                    break;
                case "inactive":
                    h.removeClass(button, self.classNames.active);
                    h.removeClass(button, self.classNames.disabled);
                    if (self.canDisable) self.el.disabled = false;
                    break;
                case "disabled":
                    if (self.canDisable) self.el.disabled = true;
                    h.addClass(button, self.classNames.disabled);
                    h.removeClass(button, self.classNames.active);
                    break;
            }
            if (self.status !== "live") // Update the control's status propery if not live
            self.status = status;
            self.callActions("afterRenderStatus", arguments);
        }
    });
    mixitup.controls = [];
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.StyleData = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.x = 0;
        this.y = 0;
        this.top = 0;
        this.right = 0;
        this.bottom = 0;
        this.left = 0;
        this.width = 0;
        this.height = 0;
        this.marginRight = 0;
        this.marginBottom = 0;
        this.opacity = 0;
        this.scale = new mixitup.TransformData();
        this.translateX = new mixitup.TransformData();
        this.translateY = new mixitup.TransformData();
        this.translateZ = new mixitup.TransformData();
        this.rotateX = new mixitup.TransformData();
        this.rotateY = new mixitup.TransformData();
        this.rotateZ = new mixitup.TransformData();
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.StyleData);
    mixitup.StyleData.prototype = Object.create(mixitup.Base.prototype);
    mixitup.StyleData.prototype.constructor = mixitup.StyleData;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.TransformData = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.value = 0;
        this.unit = "";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.TransformData);
    mixitup.TransformData.prototype = Object.create(mixitup.Base.prototype);
    mixitup.TransformData.prototype.constructor = mixitup.TransformData;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.TransformDefaults = function() {
        mixitup.StyleData.apply(this);
        this.callActions("beforeConstruct");
        this.scale.value = 0.01;
        this.scale.unit = "";
        this.translateX.value = 20;
        this.translateX.unit = "px";
        this.translateY.value = 20;
        this.translateY.unit = "px";
        this.translateZ.value = 20;
        this.translateZ.unit = "px";
        this.rotateX.value = 90;
        this.rotateX.unit = "deg";
        this.rotateY.value = 90;
        this.rotateY.unit = "deg";
        this.rotateX.value = 90;
        this.rotateX.unit = "deg";
        this.rotateZ.value = 180;
        this.rotateZ.unit = "deg";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.TransformDefaults);
    mixitup.TransformDefaults.prototype = Object.create(mixitup.StyleData.prototype);
    mixitup.TransformDefaults.prototype.constructor = mixitup.TransformDefaults;
    /**
     * @private
     * @static
     * @since   3.0.0
     * @type    {mixitup.TransformDefaults}
     */ mixitup.transformDefaults = new mixitup.TransformDefaults();
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.EventDetail = function() {
        this.state = null;
        this.futureState = null;
        this.instance = null;
        this.originalEvent = null;
    };
    /**
     * The `mixitup.Events` class contains all custom events dispatched by MixItUp at various
     * points within the lifecycle of a mixer operation.
     *
     * Each event is analogous to the callback function of the same name defined in
     * the `callbacks` configuration object, and is triggered immediately before it.
     *
     * Events are always triggered from the container element on which MixItUp is instantiated
     * upon.
     *
     * As with any event, registered event handlers receive the event object as a parameter
     * which includes a `detail` property containting references to the current `state`,
     * the `mixer` instance, and other event-specific properties described below.
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @public
     * @since       3.0.0
     */ mixitup.Events = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * A custom event triggered immediately after any MixItUp operation is requested
         * and before animations have begun.
         *
         * The `mixStart` event also exposes a `futureState` property via the
         * `event.detail` object, which represents the final state of the mixer once
         * the requested operation has completed.
         *
         * @name        mixStart
         * @memberof    mixitup.Events
         * @static
         * @type        {CustomEvent}
         */ this.mixStart = null;
        /**
         * A custom event triggered when a MixItUp operation is requested while another
         * operation is in progress, and the animation queue is full, or queueing
         * is disabled.
         *
         * @name        mixBusy
         * @memberof    mixitup.Events
         * @static
         * @type        {CustomEvent}
         */ this.mixBusy = null;
        /**
         * A custom event triggered after any MixItUp operation has completed, and the
         * state has been updated.
         *
         * @name        mixEnd
         * @memberof    mixitup.Events
         * @static
         * @type        {CustomEvent}
         */ this.mixEnd = null;
        /**
         * A custom event triggered whenever a filter operation "fails", i.e. no targets
         * could be found matching the requested filter.
         *
         * @name        mixFail
         * @memberof    mixitup.Events
         * @static
         * @type        {CustomEvent}
         */ this.mixFail = null;
        /**
         * A custom event triggered whenever a MixItUp control is clicked, and before its
         * respective operation is requested.
         *
         * This event also exposes an `originalEvent` property via the `event.detail`
         * object, which holds a reference to the original click event.
         *
         * @name        mixClick
         * @memberof    mixitup.Events
         * @static
         * @type        {CustomEvent}
         */ this.mixClick = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Events);
    mixitup.Events.prototype = Object.create(mixitup.Base.prototype);
    mixitup.Events.prototype.constructor = mixitup.Events;
    /**
     * @private
     * @param   {string}      eventType
     * @param   {Element}     el
     * @param   {object}      detail
     * @param   {Document}    [doc]
     */ mixitup.Events.prototype.fire = function(eventType, el, detail, doc) {
        var self = this, event = null, eventDetail = new mixitup.EventDetail();
        self.callActions("beforeFire", arguments);
        if (typeof self[eventType] === "undefined") throw new Error('Event type "' + eventType + '" not found.');
        eventDetail.state = new mixitup.State();
        h.extend(eventDetail.state, detail.state);
        if (detail.futureState) {
            eventDetail.futureState = new mixitup.State();
            h.extend(eventDetail.futureState, detail.futureState);
        }
        eventDetail.instance = detail.instance;
        if (detail.originalEvent) eventDetail.originalEvent = detail.originalEvent;
        event = h.getCustomEvent(eventType, eventDetail, doc);
        self.callFilters("eventFire", event, arguments);
        el.dispatchEvent(event);
    };
    // Asign a singleton instance to `mixitup.events`:
    mixitup.events = new mixitup.Events();
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.QueueItem = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.args = [];
        this.instruction = null;
        this.triggerElement = null;
        this.deferred = null;
        this.isToggling = false;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.QueueItem);
    mixitup.QueueItem.prototype = Object.create(mixitup.Base.prototype);
    mixitup.QueueItem.prototype.constructor = mixitup.QueueItem;
    /**
     * The `mixitup.Mixer` class is used to hold discreet, user-configured
     * instances of MixItUp on a provided container element.
     *
     * Mixer instances are returned whenever the `mixitup()` factory function is called,
     * which expose a range of methods enabling API-based filtering, sorting,
     * insertion, removal and more.
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @public
     * @since       3.0.0
     */ mixitup.Mixer = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.config = new mixitup.Config();
        this.id = "";
        this.isBusy = false;
        this.isToggling = false;
        this.incPadding = true;
        this.controls = [];
        this.targets = [];
        this.origOrder = [];
        this.cache = {};
        this.toggleArray = [];
        this.targetsMoved = 0;
        this.targetsImmovable = 0;
        this.targetsBound = 0;
        this.targetsDone = 0;
        this.staggerDuration = 0;
        this.effectsIn = null;
        this.effectsOut = null;
        this.transformIn = [];
        this.transformOut = [];
        this.queue = [];
        this.state = null;
        this.lastOperation = null;
        this.lastClicked = null;
        this.userCallback = null;
        this.userDeferred = null;
        this.dom = new mixitup.MixerDom();
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Mixer);
    mixitup.Mixer.prototype = Object.create(mixitup.Base.prototype);
    h.extend(mixitup.Mixer.prototype, /** @lends mixitup.Mixer */ {
        constructor: mixitup.Mixer,
        /**
         * @private
         * @instance
         * @since 3.0.0
         * @param {HTMLElement} container
         * @param {HTMLElement} document
         * @param {string}      id
         * @param {object}      [config]
         */ attach: function(container, document1, id, config) {
            var self = this, target = null, i = -1;
            self.callActions("beforeAttach", arguments);
            self.id = id;
            if (config) h.extend(self.config, config, true, true);
            self.sanitizeConfig();
            self.cacheDom(container, document1);
            if (self.config.layout.containerClassName) h.addClass(self.dom.container, self.config.layout.containerClassName);
            if (!mixitup.features.has.transitions) self.config.animation.enable = false;
            if (typeof window1.console === "undefined") self.config.debug.showWarnings = false;
            if (self.config.data.uidKey) // If the dataset API is in use, force disable controls
            self.config.controls.enable = false;
            self.indexTargets();
            self.state = self.getInitialState();
            for(i = 0; target = self.lastOperation.toHide[i]; i++)target.hide();
            if (self.config.controls.enable) {
                self.initControls();
                self.buildToggleArray(null, self.state);
                self.updateControls({
                    filter: self.state.activeFilter,
                    sort: self.state.activeSort
                });
            }
            self.parseEffects();
            self.callActions("afterAttach", arguments);
        },
        /**
         * @private
         * @instance
         * @since 3.0.0
         * @return {void}
         */ sanitizeConfig: function() {
            var self = this;
            self.callActions("beforeSanitizeConfig", arguments);
            // Sanitize enum/string config options
            self.config.controls.scope = self.config.controls.scope.toLowerCase().trim();
            self.config.controls.toggleLogic = self.config.controls.toggleLogic.toLowerCase().trim();
            self.config.controls.toggleDefault = self.config.controls.toggleDefault.toLowerCase().trim();
            self.config.animation.effects = self.config.animation.effects.trim();
            self.callActions("afterSanitizeConfig", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @return  {mixitup.State}
         */ getInitialState: function() {
            var self = this, state = new mixitup.State(), operation = new mixitup.Operation();
            self.callActions("beforeGetInitialState", arguments);
            // Map initial values into a mock state object in order to construct an operation
            state.activeContainerClassName = self.config.layout.containerClassName;
            if (self.config.load.dataset) {
                // Dataset API
                if (!self.config.data.uidKey || typeof self.config.data.uidKey !== "string") throw new TypeError(mixitup.messages.errorConfigDataUidKeyNotSet());
                operation.startDataset = operation.newDataset = state.activeDataset = self.config.load.dataset.slice();
                operation.startContainerClassName = operation.newContainerClassName = state.activeContainerClassName;
                operation.show = self.targets.slice();
                state = self.callFilters("stateGetInitialState", state, arguments);
            } else {
                // DOM API
                state.activeFilter = self.parseFilterArgs([
                    self.config.load.filter
                ]).command;
                state.activeSort = self.parseSortArgs([
                    self.config.load.sort
                ]).command;
                state.totalTargets = self.targets.length;
                state = self.callFilters("stateGetInitialState", state, arguments);
                if (state.activeSort.collection || state.activeSort.attribute || state.activeSort.order === "random" || state.activeSort.order === "desc") {
                    // Sorting on load
                    operation.newSort = state.activeSort;
                    self.sortOperation(operation);
                    self.printSort(false, operation);
                    self.targets = operation.newOrder;
                } else operation.startOrder = operation.newOrder = self.targets;
                operation.startFilter = operation.newFilter = state.activeFilter;
                operation.startSort = operation.newSort = state.activeSort;
                operation.startContainerClassName = operation.newContainerClassName = state.activeContainerClassName;
                if (operation.newFilter.selector === "all") operation.newFilter.selector = self.config.selectors.target;
                else if (operation.newFilter.selector === "none") operation.newFilter.selector = "";
            }
            operation = self.callFilters("operationGetInitialState", operation, [
                state
            ]);
            self.lastOperation = operation;
            if (operation.newFilter) self.filterOperation(operation);
            state = self.buildState(operation);
            return state;
        },
        /**
         * Caches references of DOM elements neccessary for the mixer's functionality.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {HTMLElement}       el
         * @param   {HTMLHtmlElement}   document
         * @return  {void}
         */ cacheDom: function(el, document1) {
            var self = this;
            self.callActions("beforeCacheDom", arguments);
            self.dom.document = document1;
            self.dom.body = self.dom.document.querySelector("body");
            self.dom.container = el;
            self.dom.parent = el;
            self.callActions("afterCacheDom", arguments);
        },
        /**
         * Indexes all child elements of the mixer matching the `selectors.target`
         * selector, instantiating a mixitup.Target for each one.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @return  {void}
         */ indexTargets: function() {
            var self = this, target = null, el = null, dataset = null, i = -1;
            self.callActions("beforeIndexTargets", arguments);
            self.dom.targets = self.config.layout.allowNestedTargets ? self.dom.container.querySelectorAll(self.config.selectors.target) : h.children(self.dom.container, self.config.selectors.target, self.dom.document);
            self.dom.targets = h.arrayFromList(self.dom.targets);
            self.targets = [];
            if ((dataset = self.config.load.dataset) && dataset.length !== self.dom.targets.length) throw new Error(mixitup.messages.errorDatasetPrerenderedMismatch());
            if (self.dom.targets.length) {
                for(i = 0; el = self.dom.targets[i]; i++){
                    target = new mixitup.Target();
                    target.init(el, self, dataset ? dataset[i] : void 0);
                    target.isInDom = true;
                    self.targets.push(target);
                }
                self.dom.parent = self.dom.targets[0].parentElement === self.dom.container ? self.dom.container : self.dom.targets[0].parentElement;
            }
            self.origOrder = self.targets;
            self.callActions("afterIndexTargets", arguments);
        },
        initControls: function() {
            var self = this, definition = "", controlElements = null, el = null, parent = null, delagators = null, control = null, i = -1, j = -1;
            self.callActions("beforeInitControls", arguments);
            switch(self.config.controls.scope){
                case "local":
                    parent = self.dom.container;
                    break;
                case "global":
                    parent = self.dom.document;
                    break;
                default:
                    throw new Error(mixitup.messages.errorConfigInvalidControlsScope());
            }
            for(i = 0; definition = mixitup.controlDefinitions[i]; i++)if (self.config.controls.live || definition.live) {
                if (definition.parent) {
                    delagators = self.dom[definition.parent];
                    if (!delagators || delagators.length < 0) continue;
                    if (typeof delagators.length !== "number") delagators = [
                        delagators
                    ];
                } else delagators = [
                    parent
                ];
                for(j = 0; el = delagators[j]; j++){
                    control = self.getControl(el, definition.type, definition.selector);
                    self.controls.push(control);
                }
            } else {
                controlElements = parent.querySelectorAll(self.config.selectors.control + definition.selector);
                for(j = 0; el = controlElements[j]; j++){
                    control = self.getControl(el, definition.type, "");
                    if (!control) continue;
                    self.controls.push(control);
                }
            }
            self.callActions("afterInitControls", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {HTMLElement} el
         * @param   {string}      type
         * @param   {string}      selector
         * @return  {mixitup.Control|null}
         */ getControl: function(el, type, selector) {
            var self = this, control = null, i = -1;
            self.callActions("beforeGetControl", arguments);
            if (!selector) // Static controls only
            for(i = 0; control = mixitup.controls[i]; i++){
                if (control.el === el && control.isBound(self)) // Control already bound to this mixer (as another type).
                // NB: This prevents duplicate controls from being registered where a selector
                // might collide, eg: "[data-filter]" and "[data-filter][data-sort]"
                return self.callFilters("controlGetControl", null, arguments);
                else if (control.el === el && control.type === type && control.selector === selector) {
                    // Another mixer is already using this control, add this mixer as a binding
                    control.addBinding(self);
                    return self.callFilters("controlGetControl", control, arguments);
                }
            }
            // Create new control
            control = new mixitup.Control();
            control.init(el, type, selector);
            control.classNames.base = h.getClassname(self.config.classNames, type);
            control.classNames.active = h.getClassname(self.config.classNames, type, self.config.classNames.modifierActive);
            control.classNames.disabled = h.getClassname(self.config.classNames, type, self.config.classNames.modifierDisabled);
            // Add a reference to this mixer as a binding
            control.addBinding(self);
            return self.callFilters("controlGetControl", control, arguments);
        },
        /**
         * Creates a compound selector by joining the `toggleArray` value as per the
         * defined toggle logic.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @return  {string}
         */ getToggleSelector: function() {
            var self = this, delineator = self.config.controls.toggleLogic === "or" ? ", " : "", toggleSelector = "";
            self.callActions("beforeGetToggleSelector", arguments);
            self.toggleArray = h.clean(self.toggleArray);
            toggleSelector = self.toggleArray.join(delineator);
            if (toggleSelector === "") toggleSelector = self.config.controls.toggleDefault;
            return self.callFilters("selectorGetToggleSelector", toggleSelector, arguments);
        },
        /**
         * Breaks compound selector strings in an array of discreet selectors,
         * as per the active `controls.toggleLogic` configuration option. Accepts
         * either a dynamic command object, or a state object.
         *
         * @private
         * @instance
         * @since   2.0.0
         * @param   {object}        [command]
         * @param   {mixitup.State} [state]
         * @return  {void}
         */ buildToggleArray: function(command, state) {
            var self = this, activeFilterSelector = "";
            self.callActions("beforeBuildToggleArray", arguments);
            if (command && command.filter) activeFilterSelector = command.filter.selector.replace(/\s/g, "");
            else if (state) activeFilterSelector = state.activeFilter.selector.replace(/\s/g, "");
            else return;
            if (activeFilterSelector === self.config.selectors.target || activeFilterSelector === "all") activeFilterSelector = "";
            if (self.config.controls.toggleLogic === "or") self.toggleArray = activeFilterSelector.split(",");
            else self.toggleArray = self.splitCompoundSelector(activeFilterSelector);
            self.toggleArray = h.clean(self.toggleArray);
            self.callActions("afterBuildToggleArray", arguments);
        },
        /**
         * Takes a compound selector (e.g. `.cat-1.cat-2`, `[data-cat="1"][data-cat="2"]`)
         * and breaks into its individual selectors.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {string} compoundSelector
         * @return  {string[]}
         */ splitCompoundSelector: function(compoundSelector) {
            // Break at a `.` or `[`, capturing the delineator
            var partials = compoundSelector.split(/([\.\[])/g), toggleArray = [], selector = "", i = -1;
            if (partials[0] === "") partials.shift();
            for(i = 0; i < partials.length; i++){
                if (i % 2 === 0) selector = "";
                selector += partials[i];
                if (i % 2 !== 0) toggleArray.push(selector);
            }
            return toggleArray;
        },
        /**
         * Updates controls to their active/inactive state based on the command or
         * current state of the mixer.
         *
         * @private
         * @instance
         * @since   2.0.0
         * @param   {object} command
         * @return  {void}
         */ updateControls: function(command) {
            var self = this, control = null, output = new mixitup.CommandMultimix(), i = -1;
            self.callActions("beforeUpdateControls", arguments);
            // Sanitise to defaults
            if (command.filter) output.filter = command.filter.selector;
            else output.filter = self.state.activeFilter.selector;
            if (command.sort) output.sort = self.buildSortString(command.sort);
            else output.sort = self.buildSortString(self.state.activeSort);
            if (output.filter === self.config.selectors.target) output.filter = "all";
            if (output.filter === "") output.filter = "none";
            h.freeze(output);
            for(i = 0; control = self.controls[i]; i++)control.update(output, self.toggleArray);
            self.callActions("afterUpdateControls", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {mixitup.CommandSort}   command
         * @return  {string}
         */ buildSortString: function(command) {
            var self = this;
            var output = "";
            output += command.sortString;
            if (command.next) output += " " + self.buildSortString(command.next);
            return output;
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {object}        command
         * @param   {Operation}     operation
         * @return  {Promise.<mixitup.State>}
         */ insertTargets: function(command, operation) {
            var self = this, nextSibling = null, insertionIndex = -1, frag = null, target = null, el = null, i = -1;
            self.callActions("beforeInsertTargets", arguments);
            if (typeof command.index === "undefined") command.index = 0;
            nextSibling = self.getNextSibling(command.index, command.sibling, command.position);
            frag = self.dom.document.createDocumentFragment();
            if (nextSibling) insertionIndex = h.index(nextSibling, self.config.selectors.target);
            else insertionIndex = self.targets.length;
            if (command.collection) {
                for(i = 0; el = command.collection[i]; i++){
                    if (self.dom.targets.indexOf(el) > -1) throw new Error(mixitup.messages.errorInsertPreexistingElement());
                    // Ensure elements are hidden when they are added to the DOM, so they can
                    // be animated in gracefully
                    el.style.display = "none";
                    frag.appendChild(el);
                    frag.appendChild(self.dom.document.createTextNode(" "));
                    if (!h.isElement(el, self.dom.document) || !el.matches(self.config.selectors.target)) continue;
                    target = new mixitup.Target();
                    target.init(el, self);
                    target.isInDom = true;
                    self.targets.splice(insertionIndex, 0, target);
                    insertionIndex++;
                }
                self.dom.parent.insertBefore(frag, nextSibling);
            }
            // Since targets have been added, the original order must be updated
            operation.startOrder = self.origOrder = self.targets;
            self.callActions("afterInsertTargets", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Number}      [index]
         * @param   {Element}     [sibling]
         * @param   {string}      [position]
         * @return  {Element}
         */ getNextSibling: function(index, sibling, position) {
            var self = this, element = null;
            index = Math.max(index, 0);
            if (sibling && position === "before") // Explicit sibling
            element = sibling;
            else if (sibling && position === "after") // Explicit sibling
            element = sibling.nextElementSibling || null;
            else if (self.targets.length > 0 && typeof index !== "undefined") // Index and targets exist
            element = index < self.targets.length || !self.targets.length ? self.targets[index].dom.el : self.targets[self.targets.length - 1].dom.el.nextElementSibling;
            else if (self.targets.length === 0 && self.dom.parent.children.length > 0) {
                // No targets but other siblings
                if (self.config.layout.siblingAfter) element = self.config.layout.siblingAfter;
                else if (self.config.layout.siblingBefore) element = self.config.layout.siblingBefore.nextElementSibling;
                else self.dom.parent.children[0];
            } else element;
            return self.callFilters("elementGetNextSibling", element, arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ filterOperation: function(operation) {
            var self = this, testResult = false, index = -1, action = "", target = null, i = -1;
            self.callActions("beforeFilterOperation", arguments);
            action = operation.newFilter.action;
            for(i = 0; target = operation.newOrder[i]; i++){
                if (operation.newFilter.collection) // show via collection
                testResult = operation.newFilter.collection.indexOf(target.dom.el) > -1;
                else // show via selector
                if (operation.newFilter.selector === "") testResult = false;
                else testResult = target.dom.el.matches(operation.newFilter.selector);
                self.evaluateHideShow(testResult, target, action, operation);
            }
            if (operation.toRemove.length) {
                for(i = 0; target = operation.show[i]; i++)if (operation.toRemove.indexOf(target) > -1) {
                    // If any shown targets should be removed, move them into the toHide array
                    operation.show.splice(i, 1);
                    if ((index = operation.toShow.indexOf(target)) > -1) operation.toShow.splice(index, 1);
                    operation.toHide.push(target);
                    operation.hide.push(target);
                    i--;
                }
            }
            operation.matching = operation.show.slice();
            if (operation.show.length === 0 && operation.newFilter.selector !== "" && self.targets.length !== 0) operation.hasFailed = true;
            self.callActions("afterFilterOperation", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {boolean}   testResult
         * @param   {Element}   target
         * @param   {string}    action
         * @param   {Operation} operation
         * @return  {void}
         */ evaluateHideShow: function(testResult, target, action, operation) {
            var self = this, filteredTestResult = false, args = Array.prototype.slice.call(arguments, 1);
            filteredTestResult = self.callFilters("testResultEvaluateHideShow", testResult, args);
            self.callActions("beforeEvaluateHideShow", arguments);
            if (filteredTestResult === true && action === "show" || filteredTestResult === false && action === "hide") {
                operation.show.push(target);
                !target.isShown && operation.toShow.push(target);
            } else {
                operation.hide.push(target);
                target.isShown && operation.toHide.push(target);
            }
            self.callActions("afterEvaluateHideShow", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ sortOperation: function(operation) {
            var self = this, newOrder = [], target = null, el = null, i = -1;
            self.callActions("beforeSortOperation", arguments);
            operation.startOrder = self.targets;
            if (operation.newSort.collection) {
                // Sort by collection
                newOrder = [];
                for(i = 0; el = operation.newSort.collection[i]; i++){
                    if (self.dom.targets.indexOf(el) < 0) throw new Error(mixitup.messages.errorSortNonExistentElement());
                    target = new mixitup.Target();
                    target.init(el, self);
                    target.isInDom = true;
                    newOrder.push(target);
                }
                operation.newOrder = newOrder;
            } else if (operation.newSort.order === "random") // Sort random
            operation.newOrder = h.arrayShuffle(operation.startOrder);
            else if (operation.newSort.attribute === "") {
                // Sort by default
                operation.newOrder = self.origOrder.slice();
                if (operation.newSort.order === "desc") operation.newOrder.reverse();
            } else {
                // Sort by attribute
                operation.newOrder = operation.startOrder.slice();
                operation.newOrder.sort(function(a, b) {
                    return self.compare(a, b, operation.newSort);
                });
            }
            if (h.isEqualArray(operation.newOrder, operation.startOrder)) operation.willSort = false;
            self.callActions("afterSortOperation", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {mixitup.Target}        a
         * @param   {mixitup.Target}        b
         * @param   {mixitup.CommandSort}   command
         * @return  {Number}
         */ compare: function(a, b, command) {
            var self = this, order = command.order, attrA = self.getAttributeValue(a, command.attribute), attrB = self.getAttributeValue(b, command.attribute);
            if (isNaN(attrA * 1) || isNaN(attrB * 1)) {
                attrA = attrA.toLowerCase();
                attrB = attrB.toLowerCase();
            } else {
                attrA = attrA * 1;
                attrB = attrB * 1;
            }
            if (attrA < attrB) return order === "asc" ? -1 : 1;
            if (attrA > attrB) return order === "asc" ? 1 : -1;
            if (attrA === attrB && command.next) return self.compare(a, b, command.next);
            return 0;
        },
        /**
         * Reads the values of any data attributes present the provided target element
         * which match the current sort command.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {mixitup.Target}    target
         * @param   {string}            [attribute]
         * @return  {(String|Number)}
         */ getAttributeValue: function(target, attribute) {
            var self = this, value = "";
            value = target.dom.el.getAttribute("data-" + attribute);
            if (value === null) {
                if (self.config.debug.showWarnings) // Encourage users to assign values to all targets to avoid erroneous sorting
                // when types are mixed
                console.warn(mixitup.messages.warningInconsistentSortingAttributes({
                    attribute: "data-" + attribute
                }));
            }
            // If an attribute is not present, return 0 as a safety value
            return self.callFilters("valueGetAttributeValue", value || 0, arguments);
        },
        /**
         * Inserts elements into the DOM in the appropriate
         * order using a document fragment for minimal
         * DOM thrashing
         *
         * @private
         * @instance
         * @since   2.0.0
         * @param   {boolean}   isResetting
         * @param   {Operation} operation
         * @return  {void}
         */ printSort: function(isResetting, operation) {
            var self = this, startOrder = isResetting ? operation.newOrder : operation.startOrder, newOrder = isResetting ? operation.startOrder : operation.newOrder, nextSibling = startOrder.length ? startOrder[startOrder.length - 1].dom.el.nextElementSibling : null, frag = window1.document.createDocumentFragment(), whitespace = null, target = null, el = null, i = -1;
            self.callActions("beforePrintSort", arguments);
            // Empty the container
            for(i = 0; target = startOrder[i]; i++){
                el = target.dom.el;
                if (el.style.position === "absolute") continue;
                h.removeWhitespace(el.previousSibling);
                el.parentElement.removeChild(el);
            }
            whitespace = nextSibling ? nextSibling.previousSibling : self.dom.parent.lastChild;
            if (whitespace && whitespace.nodeName === "#text") h.removeWhitespace(whitespace);
            for(i = 0; target = newOrder[i]; i++){
                // Add targets into a document fragment
                el = target.dom.el;
                if (h.isElement(frag.lastChild)) frag.appendChild(window1.document.createTextNode(" "));
                frag.appendChild(el);
            }
            // Insert the document fragment into the container
            // before any other non-target elements
            if (self.dom.parent.firstChild && self.dom.parent.firstChild !== nextSibling) frag.insertBefore(window1.document.createTextNode(" "), frag.childNodes[0]);
            if (nextSibling) {
                frag.appendChild(window1.document.createTextNode(" "));
                self.dom.parent.insertBefore(frag, nextSibling);
            } else self.dom.parent.appendChild(frag);
            self.callActions("afterPrintSort", arguments);
        },
        /**
         * Parses user-defined sort strings (i.e. `default:asc`) into sort commands objects.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {string}                sortString
         * @param   {mixitup.CommandSort}   command
         * @return  {mixitup.CommandSort}
         */ parseSortString: function(sortString, command) {
            var self = this, rules = sortString.split(" "), current = command, rule = [], i = -1;
            // command.sortString = sortString;
            for(i = 0; i < rules.length; i++){
                rule = rules[i].split(":");
                current.sortString = rules[i];
                current.attribute = h.dashCase(rule[0]);
                current.order = rule[1] || "asc";
                switch(current.attribute){
                    case "default":
                        // treat "default" as sorting by no attribute
                        current.attribute = "";
                        break;
                    case "random":
                        // treat "random" as an order not an attribute
                        current.attribute = "";
                        current.order = "random";
                        break;
                }
                if (!current.attribute || current.order === "random") break;
                if (i < rules.length - 1) {
                    // Embed reference to the next command
                    current.next = new mixitup.CommandSort();
                    h.freeze(current);
                    current = current.next;
                }
            }
            return self.callFilters("commandsParseSort", command, arguments);
        },
        /**
         * Parses all effects out of the user-defined `animation.effects` string into
         * their respective properties and units.
         *
         * @private
         * @instance
         * @since   2.0.0
         * @return  {void}
         */ parseEffects: function() {
            var self = this, transformName = "", effectsIn = self.config.animation.effectsIn || self.config.animation.effects, effectsOut = self.config.animation.effectsOut || self.config.animation.effects;
            self.callActions("beforeParseEffects", arguments);
            self.effectsIn = new mixitup.StyleData();
            self.effectsOut = new mixitup.StyleData();
            self.transformIn = [];
            self.transformOut = [];
            self.effectsIn.opacity = self.effectsOut.opacity = 1;
            self.parseEffect("fade", effectsIn, self.effectsIn, self.transformIn);
            self.parseEffect("fade", effectsOut, self.effectsOut, self.transformOut, true);
            for(transformName in mixitup.transformDefaults){
                if (!(mixitup.transformDefaults[transformName] instanceof mixitup.TransformData)) continue;
                self.parseEffect(transformName, effectsIn, self.effectsIn, self.transformIn);
                self.parseEffect(transformName, effectsOut, self.effectsOut, self.transformOut, true);
            }
            self.parseEffect("stagger", effectsIn, self.effectsIn, self.transformIn);
            self.parseEffect("stagger", effectsOut, self.effectsOut, self.transformOut, true);
            self.callActions("afterParseEffects", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {string}    effectName
         * @param   {string}    effectString
         * @param   {StyleData} effects
         * @param   {String[]}  transform
         * @param   {boolean}   [isOut]
         */ parseEffect: function(effectName, effectString, effects, transform, isOut) {
            var self = this, re = /\(([^)]+)\)/, propIndex = -1, str = "", match = [], val = "", units = [
                "%",
                "px",
                "em",
                "rem",
                "vh",
                "vw",
                "deg"
            ], unit = "", i = -1;
            self.callActions("beforeParseEffect", arguments);
            if (typeof effectString !== "string") throw new TypeError(mixitup.messages.errorConfigInvalidAnimationEffects());
            if (effectString.indexOf(effectName) < 0) {
                // The effect is not present in the effects string
                if (effectName === "stagger") // Reset stagger to 0
                self.staggerDuration = 0;
                return;
            }
            // The effect is present
            propIndex = effectString.indexOf(effectName + "(");
            if (propIndex > -1) {
                // The effect has a user defined value in parentheses
                // Extract from the first parenthesis to the end of string
                str = effectString.substring(propIndex);
                // Match any number of characters between "(" and ")"
                match = re.exec(str);
                val = match[1];
            }
            switch(effectName){
                case "fade":
                    effects.opacity = val ? parseFloat(val) : 0;
                    break;
                case "stagger":
                    self.staggerDuration = val ? parseFloat(val) : 100;
                    break;
                default:
                    // All other effects are transforms following the same structure
                    if (isOut && self.config.animation.reverseOut && effectName !== "scale") effects[effectName].value = (val ? parseFloat(val) : mixitup.transformDefaults[effectName].value) * -1;
                    else effects[effectName].value = val ? parseFloat(val) : mixitup.transformDefaults[effectName].value;
                    if (val) {
                        for(i = 0; unit = units[i]; i++)if (val.indexOf(unit) > -1) {
                            effects[effectName].unit = unit;
                            break;
                        }
                    } else effects[effectName].unit = mixitup.transformDefaults[effectName].unit;
                    transform.push(effectName + "(" + effects[effectName].value + effects[effectName].unit + ")");
            }
            self.callActions("afterParseEffect", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {State}
         */ buildState: function(operation) {
            var self = this, state = new mixitup.State(), target = null, i = -1;
            self.callActions("beforeBuildState", arguments);
            // Map target elements into state arrays.
            // the real target objects should never be exposed
            for(i = 0; target = self.targets[i]; i++)if (!operation.toRemove.length || operation.toRemove.indexOf(target) < 0) state.targets.push(target.dom.el);
            for(i = 0; target = operation.matching[i]; i++)state.matching.push(target.dom.el);
            for(i = 0; target = operation.show[i]; i++)state.show.push(target.dom.el);
            for(i = 0; target = operation.hide[i]; i++)if (!operation.toRemove.length || operation.toRemove.indexOf(target) < 0) state.hide.push(target.dom.el);
            state.id = self.id;
            state.container = self.dom.container;
            state.activeFilter = operation.newFilter;
            state.activeSort = operation.newSort;
            state.activeDataset = operation.newDataset;
            state.activeContainerClassName = operation.newContainerClassName;
            state.hasFailed = operation.hasFailed;
            state.totalTargets = self.targets.length;
            state.totalShow = operation.show.length;
            state.totalHide = operation.hide.length;
            state.totalMatching = operation.matching.length;
            state.triggerElement = operation.triggerElement;
            return self.callFilters("stateBuildState", state, arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {boolean}   shouldAnimate
         * @param   {Operation} operation
         * @return  {void}
         */ goMix: function(shouldAnimate, operation) {
            var self = this, deferred = null;
            self.callActions("beforeGoMix", arguments);
            // If the animation duration is set to 0ms,
            // or no effects specified,
            // or the container is hidden
            // then abort animation
            if (!self.config.animation.duration || !self.config.animation.effects || !h.isVisible(self.dom.container)) shouldAnimate = false;
            if (!operation.toShow.length && !operation.toHide.length && !operation.willSort && !operation.willChangeLayout) // If nothing to show or hide, and not sorting or
            // changing layout
            shouldAnimate = false;
            if (!operation.startState.show.length && !operation.show.length) // If nothing currently shown, nothing to show
            shouldAnimate = false;
            mixitup.events.fire("mixStart", self.dom.container, {
                state: operation.startState,
                futureState: operation.newState,
                instance: self
            }, self.dom.document);
            if (typeof self.config.callbacks.onMixStart === "function") self.config.callbacks.onMixStart.call(self.dom.container, operation.startState, operation.newState, self);
            h.removeClass(self.dom.container, h.getClassname(self.config.classNames, "container", self.config.classNames.modifierFailed));
            if (!self.userDeferred) // Queue empty, no pending operations
            deferred = self.userDeferred = h.defer(mixitup.libraries);
            else // Use existing deferred
            deferred = self.userDeferred;
            self.isBusy = true;
            if (!shouldAnimate || !mixitup.features.has.transitions) {
                // Abort
                if (self.config.debug.fauxAsync) setTimeout(function() {
                    self.cleanUp(operation);
                }, self.config.animation.duration);
                else self.cleanUp(operation);
                return self.callFilters("promiseGoMix", deferred.promise, arguments);
            }
            // If we should animate and the platform supports transitions, go for it
            if (window1.pageYOffset !== operation.docState.scrollTop) window1.scrollTo(operation.docState.scrollLeft, operation.docState.scrollTop);
            if (self.config.animation.applyPerspective) {
                self.dom.parent.style[mixitup.features.perspectiveProp] = self.config.animation.perspectiveDistance;
                self.dom.parent.style[mixitup.features.perspectiveOriginProp] = self.config.animation.perspectiveOrigin;
            }
            if (self.config.animation.animateResizeContainer && operation.startHeight !== operation.newHeight && operation.viewportDeltaY !== operation.startHeight - operation.newHeight) self.dom.parent.style.height = operation.startHeight + "px";
            if (self.config.animation.animateResizeContainer && operation.startWidth !== operation.newWidth && operation.viewportDeltaX !== operation.startWidth - operation.newWidth) self.dom.parent.style.width = operation.startWidth + "px";
            if (operation.startHeight === operation.newHeight) self.dom.parent.style.height = operation.startHeight + "px";
            if (operation.startWidth === operation.newWidth) self.dom.parent.style.width = operation.startWidth + "px";
            if (operation.startHeight === operation.newHeight && operation.startWidth === operation.newWidth) self.dom.parent.style.overflow = "hidden";
            requestAnimationFrame(function() {
                self.moveTargets(operation);
            });
            return self.callFilters("promiseGoMix", deferred.promise, arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ getStartMixData: function(operation) {
            var self = this, parentStyle = window1.getComputedStyle(self.dom.parent), parentRect = self.dom.parent.getBoundingClientRect(), target = null, data = {}, i = -1, boxSizing = parentStyle[mixitup.features.boxSizingProp];
            self.incPadding = boxSizing === "border-box";
            self.callActions("beforeGetStartMixData", arguments);
            for(i = 0; target = operation.show[i]; i++){
                data = target.getPosData();
                operation.showPosData[i] = {
                    startPosData: data
                };
            }
            for(i = 0; target = operation.toHide[i]; i++){
                data = target.getPosData();
                operation.toHidePosData[i] = {
                    startPosData: data
                };
            }
            operation.startX = parentRect.left;
            operation.startY = parentRect.top;
            operation.startHeight = self.incPadding ? parentRect.height : parentRect.height - parseFloat(parentStyle.paddingTop) - parseFloat(parentStyle.paddingBottom) - parseFloat(parentStyle.borderTop) - parseFloat(parentStyle.borderBottom);
            operation.startWidth = self.incPadding ? parentRect.width : parentRect.width - parseFloat(parentStyle.paddingLeft) - parseFloat(parentStyle.paddingRight) - parseFloat(parentStyle.borderLeft) - parseFloat(parentStyle.borderRight);
            self.callActions("afterGetStartMixData", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ setInter: function(operation) {
            var self = this, target = null, i = -1;
            self.callActions("beforeSetInter", arguments);
            // Prevent scrollbar flicker on non-inertial scroll platforms by clamping height/width
            if (self.config.animation.clampHeight) {
                self.dom.parent.style.height = operation.startHeight + "px";
                self.dom.parent.style.overflow = "hidden";
            }
            if (self.config.animation.clampWidth) {
                self.dom.parent.style.width = operation.startWidth + "px";
                self.dom.parent.style.overflow = "hidden";
            }
            for(i = 0; target = operation.toShow[i]; i++)target.show();
            if (operation.willChangeLayout) {
                h.removeClass(self.dom.container, operation.startContainerClassName);
                h.addClass(self.dom.container, operation.newContainerClassName);
            }
            self.callActions("afterSetInter", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ getInterMixData: function(operation) {
            var self = this, target = null, i = -1;
            self.callActions("beforeGetInterMixData", arguments);
            for(i = 0; target = operation.show[i]; i++)operation.showPosData[i].interPosData = target.getPosData();
            for(i = 0; target = operation.toHide[i]; i++)operation.toHidePosData[i].interPosData = target.getPosData();
            self.callActions("afterGetInterMixData", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ setFinal: function(operation) {
            var self = this, target = null, i = -1;
            self.callActions("beforeSetFinal", arguments);
            operation.willSort && self.printSort(false, operation);
            for(i = 0; target = operation.toHide[i]; i++)target.hide();
            self.callActions("afterSetFinal", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ getFinalMixData: function(operation) {
            var self = this, parentStyle = null, parentRect = null, target = null, i = -1;
            self.callActions("beforeGetFinalMixData", arguments);
            for(i = 0; target = operation.show[i]; i++)operation.showPosData[i].finalPosData = target.getPosData();
            for(i = 0; target = operation.toHide[i]; i++)operation.toHidePosData[i].finalPosData = target.getPosData();
            // Remove clamping
            if (self.config.animation.clampHeight || self.config.animation.clampWidth) self.dom.parent.style.height = self.dom.parent.style.width = self.dom.parent.style.overflow = "";
            if (!self.incPadding) parentStyle = window1.getComputedStyle(self.dom.parent);
            parentRect = self.dom.parent.getBoundingClientRect();
            operation.newX = parentRect.left;
            operation.newY = parentRect.top;
            operation.newHeight = self.incPadding ? parentRect.height : parentRect.height - parseFloat(parentStyle.paddingTop) - parseFloat(parentStyle.paddingBottom) - parseFloat(parentStyle.borderTop) - parseFloat(parentStyle.borderBottom);
            operation.newWidth = self.incPadding ? parentRect.width : parentRect.width - parseFloat(parentStyle.paddingLeft) - parseFloat(parentStyle.paddingRight) - parseFloat(parentStyle.borderLeft) - parseFloat(parentStyle.borderRight);
            operation.viewportDeltaX = operation.docState.viewportWidth - this.dom.document.documentElement.clientWidth;
            operation.viewportDeltaY = operation.docState.viewportHeight - this.dom.document.documentElement.clientHeight;
            if (operation.willSort) self.printSort(true, operation);
            for(i = 0; target = operation.toShow[i]; i++)target.hide();
            for(i = 0; target = operation.toHide[i]; i++)target.show();
            if (operation.willChangeLayout) {
                h.removeClass(self.dom.container, operation.newContainerClassName);
                h.addClass(self.dom.container, self.config.layout.containerClassName);
            }
            self.callActions("afterGetFinalMixData", arguments);
        },
        /**
         * @private
         * @instance
         * @since    3.0.0
         * @param    {Operation}     operation
         */ getTweenData: function(operation) {
            var self = this, target = null, posData = null, effectNames = Object.getOwnPropertyNames(self.effectsIn), effectName = "", effect = null, widthChange = -1, heightChange = -1, i = -1, j = -1;
            self.callActions("beforeGetTweenData", arguments);
            for(i = 0; target = operation.show[i]; i++){
                posData = operation.showPosData[i];
                posData.posIn = new mixitup.StyleData();
                posData.posOut = new mixitup.StyleData();
                posData.tweenData = new mixitup.StyleData();
                // Process x and y
                if (target.isShown) {
                    posData.posIn.x = posData.startPosData.x - posData.interPosData.x;
                    posData.posIn.y = posData.startPosData.y - posData.interPosData.y;
                } else posData.posIn.x = posData.posIn.y = 0;
                posData.posOut.x = posData.finalPosData.x - posData.interPosData.x;
                posData.posOut.y = posData.finalPosData.y - posData.interPosData.y;
                // Process opacity
                posData.posIn.opacity = target.isShown ? 1 : self.effectsIn.opacity;
                posData.posOut.opacity = 1;
                posData.tweenData.opacity = posData.posOut.opacity - posData.posIn.opacity;
                // Adjust x and y if not nudging
                if (!target.isShown && !self.config.animation.nudge) {
                    posData.posIn.x = posData.posOut.x;
                    posData.posIn.y = posData.posOut.y;
                }
                posData.tweenData.x = posData.posOut.x - posData.posIn.x;
                posData.tweenData.y = posData.posOut.y - posData.posIn.y;
                // Process width, height, and margins
                if (self.config.animation.animateResizeTargets) {
                    posData.posIn.width = posData.startPosData.width;
                    posData.posIn.height = posData.startPosData.height;
                    // "||" Prevents width/height change from including 0 width/height if hiding or showing
                    widthChange = (posData.startPosData.width || posData.finalPosData.width) - posData.interPosData.width;
                    posData.posIn.marginRight = posData.startPosData.marginRight - widthChange;
                    heightChange = (posData.startPosData.height || posData.finalPosData.height) - posData.interPosData.height;
                    posData.posIn.marginBottom = posData.startPosData.marginBottom - heightChange;
                    posData.posOut.width = posData.finalPosData.width;
                    posData.posOut.height = posData.finalPosData.height;
                    widthChange = (posData.finalPosData.width || posData.startPosData.width) - posData.interPosData.width;
                    posData.posOut.marginRight = posData.finalPosData.marginRight - widthChange;
                    heightChange = (posData.finalPosData.height || posData.startPosData.height) - posData.interPosData.height;
                    posData.posOut.marginBottom = posData.finalPosData.marginBottom - heightChange;
                    posData.tweenData.width = posData.posOut.width - posData.posIn.width;
                    posData.tweenData.height = posData.posOut.height - posData.posIn.height;
                    posData.tweenData.marginRight = posData.posOut.marginRight - posData.posIn.marginRight;
                    posData.tweenData.marginBottom = posData.posOut.marginBottom - posData.posIn.marginBottom;
                }
                // Process transforms
                for(j = 0; effectName = effectNames[j]; j++){
                    effect = self.effectsIn[effectName];
                    if (!(effect instanceof mixitup.TransformData) || !effect.value) continue;
                    posData.posIn[effectName].value = effect.value;
                    posData.posOut[effectName].value = 0;
                    posData.tweenData[effectName].value = posData.posOut[effectName].value - posData.posIn[effectName].value;
                    posData.posIn[effectName].unit = posData.posOut[effectName].unit = posData.tweenData[effectName].unit = effect.unit;
                }
            }
            for(i = 0; target = operation.toHide[i]; i++){
                posData = operation.toHidePosData[i];
                posData.posIn = new mixitup.StyleData();
                posData.posOut = new mixitup.StyleData();
                posData.tweenData = new mixitup.StyleData();
                // Process x and y
                posData.posIn.x = target.isShown ? posData.startPosData.x - posData.interPosData.x : 0;
                posData.posIn.y = target.isShown ? posData.startPosData.y - posData.interPosData.y : 0;
                posData.posOut.x = self.config.animation.nudge ? 0 : posData.posIn.x;
                posData.posOut.y = self.config.animation.nudge ? 0 : posData.posIn.y;
                posData.tweenData.x = posData.posOut.x - posData.posIn.x;
                posData.tweenData.y = posData.posOut.y - posData.posIn.y;
                // Process width, height, and margins
                if (self.config.animation.animateResizeTargets) {
                    posData.posIn.width = posData.startPosData.width;
                    posData.posIn.height = posData.startPosData.height;
                    widthChange = posData.startPosData.width - posData.interPosData.width;
                    posData.posIn.marginRight = posData.startPosData.marginRight - widthChange;
                    heightChange = posData.startPosData.height - posData.interPosData.height;
                    posData.posIn.marginBottom = posData.startPosData.marginBottom - heightChange;
                }
                // Process opacity
                posData.posIn.opacity = 1;
                posData.posOut.opacity = self.effectsOut.opacity;
                posData.tweenData.opacity = posData.posOut.opacity - posData.posIn.opacity;
                // Process transforms
                for(j = 0; effectName = effectNames[j]; j++){
                    effect = self.effectsOut[effectName];
                    if (!(effect instanceof mixitup.TransformData) || !effect.value) continue;
                    posData.posIn[effectName].value = 0;
                    posData.posOut[effectName].value = effect.value;
                    posData.tweenData[effectName].value = posData.posOut[effectName].value - posData.posIn[effectName].value;
                    posData.posIn[effectName].unit = posData.posOut[effectName].unit = posData.tweenData[effectName].unit = effect.unit;
                }
            }
            self.callActions("afterGetTweenData", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ moveTargets: function(operation) {
            var self = this, target = null, moveData = null, posData = null, statusChange = "", willTransition = false, staggerIndex = -1, i = -1, checkProgress = self.checkProgress.bind(self);
            self.callActions("beforeMoveTargets", arguments);
            // TODO: this is an extra loop in addition to the calcs
            // done in getOperation, could some of this be done there?
            for(i = 0; target = operation.show[i]; i++){
                moveData = new mixitup.IMoveData();
                posData = operation.showPosData[i];
                statusChange = target.isShown ? "none" : "show";
                willTransition = self.willTransition(statusChange, operation.hasEffect, posData.posIn, posData.posOut);
                if (willTransition) // Prevent non-transitioning targets from incrementing the staggerIndex
                staggerIndex++;
                target.show();
                moveData.posIn = posData.posIn;
                moveData.posOut = posData.posOut;
                moveData.statusChange = statusChange;
                moveData.staggerIndex = staggerIndex;
                moveData.operation = operation;
                moveData.callback = willTransition ? checkProgress : null;
                target.move(moveData);
            }
            for(i = 0; target = operation.toHide[i]; i++){
                posData = operation.toHidePosData[i];
                moveData = new mixitup.IMoveData();
                statusChange = "hide";
                willTransition = self.willTransition(statusChange, posData.posIn, posData.posOut);
                moveData.posIn = posData.posIn;
                moveData.posOut = posData.posOut;
                moveData.statusChange = statusChange;
                moveData.staggerIndex = i;
                moveData.operation = operation;
                moveData.callback = willTransition ? checkProgress : null;
                target.move(moveData);
            }
            if (self.config.animation.animateResizeContainer) {
                self.dom.parent.style[mixitup.features.transitionProp] = "height " + self.config.animation.duration + "ms ease, " + "width " + self.config.animation.duration + "ms ease ";
                requestAnimationFrame(function() {
                    if (operation.startHeight !== operation.newHeight && operation.viewportDeltaY !== operation.startHeight - operation.newHeight) self.dom.parent.style.height = operation.newHeight + "px";
                    if (operation.startWidth !== operation.newWidth && operation.viewportDeltaX !== operation.startWidth - operation.newWidth) self.dom.parent.style.width = operation.newWidth + "px";
                });
            }
            if (operation.willChangeLayout) {
                h.removeClass(self.dom.container, self.config.layout.ContainerClassName);
                h.addClass(self.dom.container, operation.newContainerClassName);
            }
            self.callActions("afterMoveTargets", arguments);
        },
        /**
         * @private
         * @instance
         * @return  {boolean}
         */ hasEffect: function() {
            var self = this, EFFECTABLES = [
                "scale",
                "translateX",
                "translateY",
                "translateZ",
                "rotateX",
                "rotateY",
                "rotateZ"
            ], effectName = "", effect = null, result = false, value = -1, i = -1;
            if (self.effectsIn.opacity !== 1) return self.callFilters("resultHasEffect", true, arguments);
            for(i = 0; effectName = EFFECTABLES[i]; i++){
                effect = self.effectsIn[effectName];
                value = typeof effect && effect.value !== "undefined" ? effect.value : effect;
                if (value !== 0) {
                    result = true;
                    break;
                }
            }
            return self.callFilters("resultHasEffect", result, arguments);
        },
        /**
         * Determines if a target element will transition in
         * some fasion and therefore requires binding of
         * transitionEnd
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {string}        statusChange
         * @param   {boolean}       hasEffect
         * @param   {StyleData}     posIn
         * @param   {StyleData}     posOut
         * @return  {boolean}
         */ willTransition: function(statusChange, hasEffect, posIn, posOut) {
            var self = this, result = false;
            if (!h.isVisible(self.dom.container)) // If the container is not visible, the transitionEnd
            // event will not occur and MixItUp will hang
            result = false;
            else if (statusChange !== "none" && hasEffect || posIn.x !== posOut.x || posIn.y !== posOut.y) // If opacity and/or translate will change
            result = true;
            else if (self.config.animation.animateResizeTargets) // Check if width, height or margins will change
            result = posIn.width !== posOut.width || posIn.height !== posOut.height || posIn.marginRight !== posOut.marginRight || posIn.marginTop !== posOut.marginTop;
            else result = false;
            return self.callFilters("resultWillTransition", result, arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ checkProgress: function(operation) {
            var self = this;
            self.targetsDone++;
            if (self.targetsBound === self.targetsDone) self.cleanUp(operation);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Operation}     operation
         * @return  {void}
         */ cleanUp: function(operation) {
            var self = this, target = null, whitespaceBefore = null, whitespaceAfter = null, nextInQueue = null, i = -1;
            self.callActions("beforeCleanUp", arguments);
            self.targetsMoved = self.targetsImmovable = self.targetsBound = self.targetsDone = 0;
            for(i = 0; target = operation.show[i]; i++){
                target.cleanUp();
                target.show();
            }
            for(i = 0; target = operation.toHide[i]; i++){
                target.cleanUp();
                target.hide();
            }
            if (operation.willSort) self.printSort(false, operation);
            // Remove any styles applied to the parent container
            self.dom.parent.style[mixitup.features.transitionProp] = self.dom.parent.style.height = self.dom.parent.style.width = self.dom.parent.style.overflow = self.dom.parent.style[mixitup.features.perspectiveProp] = self.dom.parent.style[mixitup.features.perspectiveOriginProp] = "";
            if (operation.willChangeLayout) {
                h.removeClass(self.dom.container, operation.startContainerClassName);
                h.addClass(self.dom.container, operation.newContainerClassName);
            }
            if (operation.toRemove.length) {
                for(i = 0; target = self.targets[i]; i++)if (operation.toRemove.indexOf(target) > -1) {
                    if ((whitespaceBefore = target.dom.el.previousSibling) && whitespaceBefore.nodeName === "#text" && (whitespaceAfter = target.dom.el.nextSibling) && whitespaceAfter.nodeName === "#text") h.removeWhitespace(whitespaceBefore);
                    if (!operation.willSort) // NB: Sorting will remove targets as a bi-product of `printSort()`
                    self.dom.parent.removeChild(target.dom.el);
                    self.targets.splice(i, 1);
                    target.isInDom = false;
                    i--;
                }
                // Since targets have been removed, the original order must be updated
                self.origOrder = self.targets;
            }
            if (operation.willSort) self.targets = operation.newOrder;
            self.state = operation.newState;
            self.lastOperation = operation;
            self.dom.targets = self.state.targets;
            // mixEnd
            mixitup.events.fire("mixEnd", self.dom.container, {
                state: self.state,
                instance: self
            }, self.dom.document);
            if (typeof self.config.callbacks.onMixEnd === "function") self.config.callbacks.onMixEnd.call(self.dom.container, self.state, self);
            if (operation.hasFailed) {
                // mixFail
                mixitup.events.fire("mixFail", self.dom.container, {
                    state: self.state,
                    instance: self
                }, self.dom.document);
                if (typeof self.config.callbacks.onMixFail === "function") self.config.callbacks.onMixFail.call(self.dom.container, self.state, self);
                h.addClass(self.dom.container, h.getClassname(self.config.classNames, "container", self.config.classNames.modifierFailed));
            }
            // User-defined callback function
            if (typeof self.userCallback === "function") self.userCallback.call(self.dom.container, self.state, self);
            if (typeof self.userDeferred.resolve === "function") self.userDeferred.resolve(self.state);
            self.userCallback = null;
            self.userDeferred = null;
            self.lastClicked = null;
            self.isToggling = false;
            self.isBusy = false;
            if (self.queue.length) {
                self.callActions("beforeReadQueueCleanUp", arguments);
                nextInQueue = self.queue.shift();
                // Update non-public API properties stored in queue
                self.userDeferred = nextInQueue.deferred;
                self.isToggling = nextInQueue.isToggling;
                self.lastClicked = nextInQueue.triggerElement;
                if (nextInQueue.instruction.command instanceof mixitup.CommandMultimix) self.multimix.apply(self, nextInQueue.args);
                else self.dataset.apply(self, nextInQueue.args);
            }
            self.callActions("afterCleanUp", arguments);
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Array<*>}  args
         * @return  {mixitup.UserInstruction}
         */ parseMultimixArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), arg = null, i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandMultimix();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (arg === null) continue;
                if (typeof arg === "object") h.extend(instruction.command, arg);
                else if (typeof arg === "boolean") instruction.animate = arg;
                else if (typeof arg === "function") instruction.callback = arg;
            }
            // Coerce arbitrary command arguments into typed command objects
            if (instruction.command.insert && !(instruction.command.insert instanceof mixitup.CommandInsert)) instruction.command.insert = self.parseInsertArgs([
                instruction.command.insert
            ]).command;
            if (instruction.command.remove && !(instruction.command.remove instanceof mixitup.CommandRemove)) instruction.command.remove = self.parseRemoveArgs([
                instruction.command.remove
            ]).command;
            if (instruction.command.filter && !(instruction.command.filter instanceof mixitup.CommandFilter)) instruction.command.filter = self.parseFilterArgs([
                instruction.command.filter
            ]).command;
            if (instruction.command.sort && !(instruction.command.sort instanceof mixitup.CommandSort)) instruction.command.sort = self.parseSortArgs([
                instruction.command.sort
            ]).command;
            if (instruction.command.changeLayout && !(instruction.command.changeLayout instanceof mixitup.CommandChangeLayout)) instruction.command.changeLayout = self.parseChangeLayoutArgs([
                instruction.command.changeLayout
            ]).command;
            instruction = self.callFilters("instructionParseMultimixArgs", instruction, arguments);
            h.freeze(instruction);
            return instruction;
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Array<*>}  args
         * @return  {mixitup.UserInstruction}
         */ parseFilterArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), arg = null, i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandFilter();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (typeof arg === "string") // Selector
                instruction.command.selector = arg;
                else if (arg === null) instruction.command.collection = [];
                else if (typeof arg === "object" && h.isElement(arg, self.dom.document)) // Single element
                instruction.command.collection = [
                    arg
                ];
                else if (typeof arg === "object" && typeof arg.length !== "undefined") // Multiple elements in array, NodeList or jQuery collection
                instruction.command.collection = h.arrayFromList(arg);
                else if (typeof arg === "object") // Filter command
                h.extend(instruction.command, arg);
                else if (typeof arg === "boolean") instruction.animate = arg;
                else if (typeof arg === "function") instruction.callback = arg;
            }
            if (instruction.command.selector && instruction.command.collection) throw new Error(mixitup.messages.errorFilterInvalidArguments());
            instruction = self.callFilters("instructionParseFilterArgs", instruction, arguments);
            h.freeze(instruction);
            return instruction;
        },
        parseSortArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), arg = null, sortString = "", i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandSort();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (arg === null) continue;
                switch(typeof arg){
                    case "string":
                        // Sort string
                        sortString = arg;
                        break;
                    case "object":
                        // Array of element references
                        if (arg.length) instruction.command.collection = h.arrayFromList(arg);
                        break;
                    case "boolean":
                        instruction.animate = arg;
                        break;
                    case "function":
                        instruction.callback = arg;
                        break;
                }
            }
            if (sortString) instruction.command = self.parseSortString(sortString, instruction.command);
            instruction = self.callFilters("instructionParseSortArgs", instruction, arguments);
            h.freeze(instruction);
            return instruction;
        },
        /**
         * @private
         * @instance
         * @since   2.0.0
         * @param   {Array<*>}  args
         * @return  {mixitup.UserInstruction}
         */ parseInsertArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), arg = null, i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandInsert();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (arg === null) continue;
                if (typeof arg === "number") // Insert index
                instruction.command.index = arg;
                else if (typeof arg === "string" && [
                    "before",
                    "after"
                ].indexOf(arg) > -1) // 'before'/'after'
                instruction.command.position = arg;
                else if (typeof arg === "string") // Markup
                instruction.command.collection = h.arrayFromList(h.createElement(arg).childNodes);
                else if (typeof arg === "object" && h.isElement(arg, self.dom.document)) // Single element
                !instruction.command.collection.length ? instruction.command.collection = [
                    arg
                ] : instruction.command.sibling = arg;
                else if (typeof arg === "object" && arg.length) // Multiple elements in array or jQuery collection
                !instruction.command.collection.length ? instruction.command.collection = arg : instruction.command.sibling = arg[0];
                else if (typeof arg === "object" && arg.childNodes && arg.childNodes.length) // Document fragment
                !instruction.command.collection.length ? instruction.command.collection = h.arrayFromList(arg.childNodes) : instruction.command.sibling = arg.childNodes[0];
                else if (typeof arg === "object") // Insert command
                h.extend(instruction.command, arg);
                else if (typeof arg === "boolean") instruction.animate = arg;
                else if (typeof arg === "function") instruction.callback = arg;
            }
            if (instruction.command.index && instruction.command.sibling) throw new Error(mixitup.messages.errorInsertInvalidArguments());
            if (!instruction.command.collection.length && self.config.debug.showWarnings) console.warn(mixitup.messages.warningInsertNoElements());
            instruction = self.callFilters("instructionParseInsertArgs", instruction, arguments);
            h.freeze(instruction);
            return instruction;
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Array<*>}  args
         * @return  {mixitup.UserInstruction}
         */ parseRemoveArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), target = null, arg = null, i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandRemove();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (arg === null) continue;
                switch(typeof arg){
                    case "number":
                        if (self.targets[arg]) instruction.command.targets[0] = self.targets[arg];
                        break;
                    case "string":
                        instruction.command.collection = h.arrayFromList(self.dom.parent.querySelectorAll(arg));
                        break;
                    case "object":
                        if (arg && arg.length) instruction.command.collection = arg;
                        else if (h.isElement(arg, self.dom.document)) instruction.command.collection = [
                            arg
                        ];
                        else // Remove command
                        h.extend(instruction.command, arg);
                        break;
                    case "boolean":
                        instruction.animate = arg;
                        break;
                    case "function":
                        instruction.callback = arg;
                        break;
                }
            }
            if (instruction.command.collection.length) {
                for(i = 0; target = self.targets[i]; i++)if (instruction.command.collection.indexOf(target.dom.el) > -1) instruction.command.targets.push(target);
            }
            if (!instruction.command.targets.length && self.config.debug.showWarnings) console.warn(mixitup.messages.warningRemoveNoElements());
            h.freeze(instruction);
            return instruction;
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Array<*>}  args
         * @return  {mixitup.UserInstruction}
         */ parseDatasetArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), arg = null, i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandDataset();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (arg === null) continue;
                switch(typeof arg){
                    case "object":
                        if (Array.isArray(arg) || typeof arg.length === "number") instruction.command.dataset = arg;
                        else // Change layout command
                        h.extend(instruction.command, arg);
                        break;
                    case "boolean":
                        instruction.animate = arg;
                        break;
                    case "function":
                        instruction.callback = arg;
                        break;
                }
            }
            h.freeze(instruction);
            return instruction;
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Array<*>}  args
         * @return  {mixitup.UserInstruction}
         */ parseChangeLayoutArgs: function(args) {
            var self = this, instruction = new mixitup.UserInstruction(), arg = null, i = -1;
            instruction.animate = self.config.animation.enable;
            instruction.command = new mixitup.CommandChangeLayout();
            for(i = 0; i < args.length; i++){
                arg = args[i];
                if (arg === null) continue;
                switch(typeof arg){
                    case "string":
                        instruction.command.containerClassName = arg;
                        break;
                    case "object":
                        // Change layout command
                        h.extend(instruction.command, arg);
                        break;
                    case "boolean":
                        instruction.animate = arg;
                        break;
                    case "function":
                        instruction.callback = arg;
                        break;
                }
            }
            h.freeze(instruction);
            return instruction;
        },
        /**
         * @private
         * @instance
         * @since       3.0.0
         * @param       {mixitup.QueueItem}         queueItem
         * @return      {Promise.<mixitup.State>}
         */ queueMix: function(queueItem) {
            var self = this, deferred = null, toggleSelector = "";
            self.callActions("beforeQueueMix", arguments);
            deferred = h.defer(mixitup.libraries);
            if (self.config.animation.queue && self.queue.length < self.config.animation.queueLimit) {
                queueItem.deferred = deferred;
                self.queue.push(queueItem);
                // Keep controls in sync with user interactions. Mixer will catch up as it drains the queue.
                if (self.config.controls.enable) {
                    if (self.isToggling) {
                        self.buildToggleArray(queueItem.instruction.command);
                        toggleSelector = self.getToggleSelector();
                        self.updateControls({
                            filter: {
                                selector: toggleSelector
                            }
                        });
                    } else self.updateControls(queueItem.instruction.command);
                }
            } else {
                if (self.config.debug.showWarnings) console.warn(mixitup.messages.warningMultimixInstanceQueueFull());
                deferred.resolve(self.state);
                mixitup.events.fire("mixBusy", self.dom.container, {
                    state: self.state,
                    instance: self
                }, self.dom.document);
                if (typeof self.config.callbacks.onMixBusy === "function") self.config.callbacks.onMixBusy.call(self.dom.container, self.state, self);
            }
            return self.callFilters("promiseQueueMix", deferred.promise, arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Array.<object>}    newDataset
         * @return  {Operation}
         */ getDataOperation: function(newDataset) {
            var self = this, operation = new mixitup.Operation(), startDataset = [];
            operation = self.callFilters("operationUnmappedGetDataOperation", operation, arguments);
            if (self.dom.targets.length && !(startDataset = self.state.activeDataset || []).length) throw new Error(mixitup.messages.errorDatasetNotSet());
            operation.id = h.randomHex();
            operation.startState = self.state;
            operation.startDataset = startDataset;
            operation.newDataset = newDataset.slice();
            self.diffDatasets(operation);
            operation.startOrder = self.targets;
            operation.newOrder = operation.show;
            if (self.config.animation.enable) {
                self.getStartMixData(operation);
                self.setInter(operation);
                operation.docState = h.getDocumentState(self.dom.document);
                self.getInterMixData(operation);
                self.setFinal(operation);
                self.getFinalMixData(operation);
                self.parseEffects();
                operation.hasEffect = self.hasEffect();
                self.getTweenData(operation);
            }
            self.targets = operation.show.slice();
            operation.newState = self.buildState(operation);
            // NB: Targets to be removed must be included in `self.targets` for removal during clean up,
            // but are added after state is built so that state is accurate
            Array.prototype.push.apply(self.targets, operation.toRemove);
            operation = self.callFilters("operationMappedGetDataOperation", operation, arguments);
            return operation;
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {mixitup.Operation} operation
         * @return  {void}
         */ diffDatasets: function(operation) {
            var self = this, persistantStartIds = [], persistantNewIds = [], insertedTargets = [], data = null, target = null, el = null, frag = null, nextEl = null, uids = {}, id = "", i = -1;
            self.callActions("beforeDiffDatasets", arguments);
            for(i = 0; data = operation.newDataset[i]; i++){
                if (typeof (id = data[self.config.data.uidKey]) === "undefined" || id.toString().length < 1) throw new TypeError(mixitup.messages.errorDatasetInvalidUidKey({
                    uidKey: self.config.data.uidKey
                }));
                if (!uids[id]) uids[id] = true;
                else throw new Error(mixitup.messages.errorDatasetDuplicateUid({
                    uid: id
                }));
                if ((target = self.cache[id]) instanceof mixitup.Target) {
                    // Already in cache
                    if (self.config.data.dirtyCheck && !h.deepEquals(data, target.data)) {
                        // change detected
                        el = target.render(data);
                        target.data = data;
                        if (el !== target.dom.el) {
                            // Update target element reference
                            if (target.isInDom) {
                                target.unbindEvents();
                                self.dom.parent.replaceChild(el, target.dom.el);
                            }
                            if (!target.isShown) el.style.display = "none";
                            target.dom.el = el;
                            if (target.isInDom) target.bindEvents();
                        }
                    }
                    el = target.dom.el;
                } else {
                    // New target
                    target = new mixitup.Target();
                    target.init(null, self, data);
                    target.hide();
                }
                if (!target.isInDom) {
                    // Adding to DOM
                    if (!frag) // Open frag
                    frag = self.dom.document.createDocumentFragment();
                    if (frag.lastElementChild) frag.appendChild(self.dom.document.createTextNode(" "));
                    frag.appendChild(target.dom.el);
                    target.isInDom = true;
                    target.unbindEvents();
                    target.bindEvents();
                    target.hide();
                    operation.toShow.push(target);
                    insertedTargets.push(target);
                } else {
                    // Already in DOM
                    nextEl = target.dom.el.nextElementSibling;
                    persistantNewIds.push(id);
                    if (frag) {
                        // Close and insert previously opened frag
                        if (frag.lastElementChild) frag.appendChild(self.dom.document.createTextNode(" "));
                        self.insertDatasetFrag(frag, target.dom.el, insertedTargets);
                        frag = null;
                    }
                }
                operation.show.push(target);
            }
            if (frag) {
                // Unclosed frag remaining
                nextEl = nextEl || self.config.layout.siblingAfter;
                if (nextEl) frag.appendChild(self.dom.document.createTextNode(" "));
                self.insertDatasetFrag(frag, nextEl, insertedTargets);
            }
            for(i = 0; data = operation.startDataset[i]; i++){
                id = data[self.config.data.uidKey];
                target = self.cache[id];
                if (operation.show.indexOf(target) < 0) {
                    // Previously shown but now absent
                    operation.hide.push(target);
                    operation.toHide.push(target);
                    operation.toRemove.push(target);
                } else persistantStartIds.push(id);
            }
            if (!h.isEqualArray(persistantStartIds, persistantNewIds)) operation.willSort = true;
            self.callActions("afterDiffDatasets", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.1.5
         * @param   {DocumentFragment}          frag
         * @param   {(HTMLElement|null)}        nextEl
         * @param   {Array.<mixitup.Target>}    targets
         * @return  {void}
         */ insertDatasetFrag: function(frag, nextEl, targets) {
            var self = this;
            var insertAt = nextEl ? h.arrayFromList(self.dom.parent.children).indexOf(nextEl) : self.targets.length;
            self.dom.parent.insertBefore(frag, nextEl);
            while(targets.length){
                self.targets.splice(insertAt, 0, targets.shift());
                insertAt++;
            }
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {mixitup.CommandSort} sortCommandA
         * @param   {mixitup.CommandSort} sortCommandB
         * @return  {boolean}
         */ willSort: function(sortCommandA, sortCommandB) {
            var self = this, result = false;
            if (self.config.behavior.liveSort || sortCommandA.order === "random" || sortCommandA.attribute !== sortCommandB.attribute || sortCommandA.order !== sortCommandB.order || sortCommandA.collection !== sortCommandB.collection || sortCommandA.next === null && sortCommandB.next || sortCommandA.next && sortCommandB.next === null) result = true;
            else if (sortCommandA.next && sortCommandB.next) result = self.willSort(sortCommandA.next, sortCommandB.next);
            else result = false;
            return self.callFilters("resultWillSort", result, arguments);
        },
        /**
         * A shorthand method for `.filter('all')`. Shows all targets in the container.
         *
         * @example
         *
         * .show()
         *
         * @example <caption>Example: Showing all targets</caption>
         *
         * mixer.show()
         *     .then(function(state) {
         *         console.log(state.totalShow === state.totalTargets); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @return      {Promise.<mixitup.State>}
         */ show: function() {
            var self = this;
            return self.filter("all");
        },
        /**
         * A shorthand method for `.filter('none')`. Hides all targets in the container.
         *
         * @example
         *
         * .hide()
         *
         * @example <caption>Example: Hiding all targets</caption>
         *
         * mixer.hide()
         *     .then(function(state) {
         *         console.log(state.totalShow === 0); // true
         *         console.log(state.totalHide === state.totalTargets); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @return      {Promise.<mixitup.State>}
         */ hide: function() {
            var self = this;
            return self.filter("none");
        },
        /**
         * Returns a boolean indicating whether or not a MixItUp operation is
         * currently in progress.
         *
         * @example
         *
         * .isMixing()
         *
         * @example <caption>Example: Checking the status of a mixer</caption>
         *
         * mixer.sort('random', function() {
         *     console.log(mixer.isMixing()) // false
         * });
         *
         * console.log(mixer.isMixing()) // true
         *
         * @public
         * @instance
         * @since   2.0.0
         * @return  {boolean}
         */ isMixing: function() {
            var self = this;
            return self.isBusy;
        },
        /**
         * Filters all targets in the container by a provided selector string, or the values `'all'`
         * or `'none'`. Only targets matching the selector will be shown.
         *
         * @example
         *
         * .filter(selector [, animate] [, callback])
         *
         * @example <caption>Example 1: Filtering targets by a class selector</caption>
         *
         * mixer.filter('.category-a')
         *     .then(function(state) {
         *         console.log(state.totalShow === containerEl.querySelectorAll('.category-a').length); // true
         *     });
         *
         * @example <caption>Example 2: Filtering targets by an attribute selector</caption>
         *
         * mixer.filter('[data-category~="a"]')
         *     .then(function(state) {
         *         console.log(state.totalShow === containerEl.querySelectorAll('[data-category~="a"]').length); // true
         *     });
         *
         * @example <caption>Example 3: Filtering targets by a compound selector</caption>
         *
         * // Show only those targets with the classes 'category-a' AND 'category-b'
         *
         * mixer.filter('.category-a.category-c')
         *     .then(function(state) {
         *         console.log(state.totalShow === containerEl.querySelectorAll('.category-a.category-c').length); // true
         *     });
         *
         * @example <caption>Example 4: Filtering via an element collection</caption>
         *
         * var collection = Array.from(container.querySelectorAll('.mix'));
         *
         * console.log(collection.length); // 34
         *
         * // Filter the collection manually using Array.prototype.filter
         *
         * var filtered = collection.filter(function(target) {
         *    return parseInt(target.getAttribute('data-price')) > 10;
         * });
         *
         * console.log(filtered.length); // 22
         *
         * // Pass the filtered collection to MixItUp
         *
         * mixer.filter(filtered)
         *    .then(function(state) {
         *        console.log(state.activeFilter.collection.length === 22); // true
         *    });
         *
         * @public
         * @instance
         * @since       2.0.0
         * @param       {(string|HTMLElement|Array.<HTMLElement>)} selector
         *      Any valid CSS selector (i.e. `'.category-a'`), or the values `'all'` or `'none'`. The filter method also accepts a reference to single target element or a collection of target elements to show.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ filter: function() {
            var self = this, instruction = self.parseFilterArgs(arguments);
            return self.multimix({
                filter: instruction.command
            }, instruction.animate, instruction.callback);
        },
        /**
         * Adds an additional selector to the currently active filter selector, concatenating
         * as per the logic defined in `controls.toggleLogic`.
         *
         * @example
         *
         * .toggleOn(selector [, animate] [, callback])
         *
         * @example <caption>Example: Toggling on a filter selector</caption>
         *
         * console.log(mixer.getState().activeFilter.selector); // '.category-a'
         *
         * mixer.toggleOn('.category-b')
         *     .then(function(state) {
         *         console.log(state.activeFilter.selector); // '.category-a, .category-b'
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {string}    selector
         *      Any valid CSS selector (i.e. `'.category-a'`)
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ toggleOn: function() {
            var self = this, instruction = self.parseFilterArgs(arguments), selector = instruction.command.selector, toggleSelector = "";
            self.isToggling = true;
            if (self.toggleArray.indexOf(selector) < 0) self.toggleArray.push(selector);
            toggleSelector = self.getToggleSelector();
            return self.multimix({
                filter: toggleSelector
            }, instruction.animate, instruction.callback);
        },
        /**
         * Removes a selector from the active filter selector.
         *
         * @example
         *
         * .toggleOff(selector [, animate] [, callback])
         *
         * @example <caption>Example: Toggling off a filter selector</caption>
         *
         * console.log(mixer.getState().activeFilter.selector); // '.category-a, .category-b'
         *
         * mixer.toggleOff('.category-b')
         *     .then(function(state) {
         *         console.log(state.activeFilter.selector); // '.category-a'
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {string}    selector
         *      Any valid CSS selector (i.e. `'.category-a'`)
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ toggleOff: function() {
            var self = this, instruction = self.parseFilterArgs(arguments), selector = instruction.command.selector, selectorIndex = self.toggleArray.indexOf(selector), toggleSelector = "";
            self.isToggling = true;
            if (selectorIndex > -1) self.toggleArray.splice(selectorIndex, 1);
            toggleSelector = self.getToggleSelector();
            return self.multimix({
                filter: toggleSelector
            }, instruction.animate, instruction.callback);
        },
        /**
         * Sorts all targets in the container according to a provided sort string.
         *
         * @example
         *
         * .sort(sortString [, animate] [, callback])
         *
         * @example <caption>Example 1: Sorting by the default DOM order</caption>
         *
         * // Reverse the default order of the targets
         *
         * mixer.sort('default:desc')
         *     .then(function(state) {
         *         console.log(state.activeSort.attribute === 'default'); // true
         *         console.log(state.activeSort.order === 'desc'); // true
         *     });
         *
         * @example <caption>Example 2: Sorting by a custom data-attribute</caption>
         *
         * // Sort the targets by the value of a `data-published-date` attribute
         *
         * mixer.sort('published-date:asc')
         *     .then(function(state) {
         *         console.log(state.activeSort.attribute === 'published-date'); // true
         *         console.log(state.activeSort.order === 'asc'); // true
         *     });
         *
         * @example <caption>Example 3: Sorting by multiple attributes</caption>
         *
         * // Sort the targets by the value of a `data-published-date` attribute, then by `data-title`
         *
         * mixer.sort('published-date:desc data-title:asc')
         *     .then(function(state) {
         *         console.log(state.activeSort.attribute === 'published-date'); // true
         *         console.log(state.activeSort.order === 'desc'); // true
         *
         *         console.log(state.activeSort.next.attribute === 'title'); // true
         *         console.log(state.activeSort.next.order === 'asc'); // true
         *     });
         *
         * @example <caption>Example 4: Sorting by random</caption>
         *
         * mixer.sort('random')
         *     .then(function(state) {
         *         console.log(state.activeSort.order === 'random') // true
         *     });
         *
         * @example <caption>Example 5: Sorting via an element collection</caption>
         *
         * var collection = Array.from(container.querySelectorAll('.mix'));
         *
         * // Swap the position of two elements in the collection:
         *
         * var temp = collection[1];
         *
         * collection[1] = collection[0];
         * collection[0] = temp;
         *
         * // Pass the sorted collection to MixItUp
         *
         * mixer.sort(collection)
         *     .then(function(state) {
         *         console.log(state.targets[0] === collection[0]); // true
         *     });
         *
         * @public
         * @instance
         * @since       2.0.0
         * @param       {(string|Array.<HTMLElement>)}    sortString
         *      A valid sort string (e.g. `'default'`, `'published-date:asc'`, or `'random'`). The sort method also accepts an array of all target elements in a user-defined order.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ sort: function() {
            var self = this, instruction = self.parseSortArgs(arguments);
            return self.multimix({
                sort: instruction.command
            }, instruction.animate, instruction.callback);
        },
        /**
         * Changes the layout of the container by adding, removing or updating a
         * layout-specific class name. If `animation.animateResizetargets` is
         * enabled, MixItUp will attempt to gracefully animate the width, height,
         * and position of targets between layout states.
         *
         * @example
         *
         * .changeLayout(containerClassName [, animate] [, callback])
         *
         * @example <caption>Example 1: Adding a new class name to the container</caption>
         *
         * mixer.changeLayout('container-list')
         *      .then(function(state) {
         *          console.log(state.activeContainerClass === 'container-list'); // true
         *      });
         *
         * @example <caption>Example 2: Removing a previously added class name from the container</caption>
         *
         * mixer.changeLayout('')
         *      .then(function(state) {
         *          console.log(state.activeContainerClass === ''); // true
         *      });
         *
         * @public
         * @instance
         * @since       2.0.0
         * @param       {string}    containerClassName
         *      A layout-specific class name to add to the container.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ changeLayout: function() {
            var self = this, instruction = self.parseChangeLayoutArgs(arguments);
            return self.multimix({
                changeLayout: instruction.command
            }, instruction.animate, instruction.callback);
        },
        /**
         * Updates the contents and order of the container to reflect the provided dataset,
         * if the dataset API is in use.
         *
         * The dataset API is designed for use in API-driven JavaScript applications, and
         * can be used instead of DOM-based methods such as `.filter()`, `.sort()`,
         * `.insert()`, etc. When used, insertion, removal, sorting and pagination can be
         * achieved purely via changes to your data model, without the uglyness of having
         * to interact with or query the DOM directly.
         *
         * @example
         *
         * .dataset(dataset [, animate] [, callback])
         *
         * @example <caption>Example 1: Rendering a dataset</caption>
         *
         * var myDataset = [
         *     {id: 1, ...},
         *     {id: 2, ...},
         *     {id: 3, ...}
         * ];
         *
         * mixer.dataset(myDataset)
         *     .then(function(state) {
         *         console.log(state.totalShow === 3); // true
         *     });
         *
         * @example <caption>Example 2: Sorting a dataset</caption>
         *
         * // Create a new dataset in reverse order
         *
         * var newDataset = myDataset.slice().reverse();
         *
         * mixer.dataset(newDataset)
         *     .then(function(state) {
         *         console.log(state.activeDataset[0] === myDataset[2]); // true
         *     });
         *
         * @example <caption>Example 3: Removing an item from the dataset</caption>
         *
         * console.log(myDataset.length); // 3
         *
         * // Create a new dataset with the last item removed.
         *
         * var newDataset = myDataset.slice().pop();
         *
         * mixer.dataset(newDataset)
         *     .then(function(state) {
         *         console.log(state.totalShow === 2); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {Array.<object>}    dataset
         *      An array of objects, each one representing the underlying data model of a target to be rendered.
         * @param       {boolean}           [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}          [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ dataset: function() {
            var self = this, instruction = self.parseDatasetArgs(arguments), operation = null, queueItem = null, animate = false;
            self.callActions("beforeDataset", arguments);
            if (!self.isBusy) {
                if (instruction.callback) self.userCallback = instruction.callback;
                animate = instruction.animate ^ self.config.animation.enable ? instruction.animate : self.config.animation.enable;
                operation = self.getDataOperation(instruction.command.dataset);
                return self.goMix(animate, operation);
            } else {
                queueItem = new mixitup.QueueItem();
                queueItem.args = arguments;
                queueItem.instruction = instruction;
                return self.queueMix(queueItem);
            }
        },
        /**
         * Performs simultaneous `filter`, `sort`, `insert`, `remove` and `changeLayout`
         * operations as requested.
         *
         * @example
         *
         * .multimix(multimixCommand [, animate] [, callback])
         *
         * @example <caption>Example 1: Performing simultaneous filtering and sorting</caption>
         *
         * mixer.multimix({
         *     filter: '.category-b',
         *     sort: 'published-date:desc'
         * })
         *     .then(function(state) {
         *         console.log(state.activeFilter.selector === '.category-b'); // true
         *         console.log(state.activeSort.attribute === 'published-date'); // true
         *     });
         *
         * @example <caption>Example 2: Performing simultaneous sorting, insertion, and removal</caption>
         *
         * console.log(mixer.getState().totalShow); // 6
         *
         * // NB: When inserting via `multimix()`, an object should be provided as the value
         * // for the `insert` portion of the command, allowing for a collection of elements
         * // and an insertion index to be specified.
         *
         * mixer.multimix({
         *     sort: 'published-date:desc', // Sort the container, including any new elements
         *     insert: {
         *         collection: [newElementReferenceA, newElementReferenceB], // Add 2 new elements at index 5
         *         index: 5
         *     },
         *     remove: existingElementReference // Remove 1 existing element
         * })
         *     .then(function(state) {
         *         console.log(state.activeSort.attribute === 'published-date'); // true
         *         console.log(state.totalShow === 7); // true
         *     });
         *
         * @public
         * @instance
         * @since       2.0.0
         * @param       {object}    multimixCommand
         *      An object containing one or more things to do
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ multimix: function() {
            var self = this, operation = null, animate = false, queueItem = null, instruction = self.parseMultimixArgs(arguments);
            self.callActions("beforeMultimix", arguments);
            if (!self.isBusy) {
                operation = self.getOperation(instruction.command);
                if (self.config.controls.enable) {
                    // Update controls for API calls
                    if (instruction.command.filter && !self.isToggling) {
                        // As we are not toggling, reset the toggle array
                        // so new filter overrides existing toggles
                        self.toggleArray.length = 0;
                        self.buildToggleArray(operation.command);
                    }
                    if (self.queue.length < 1) self.updateControls(operation.command);
                }
                if (instruction.callback) self.userCallback = instruction.callback;
                // Always allow the instruction to override the instance setting
                animate = instruction.animate ^ self.config.animation.enable ? instruction.animate : self.config.animation.enable;
                self.callFilters("operationMultimix", operation, arguments);
                return self.goMix(animate, operation);
            } else {
                queueItem = new mixitup.QueueItem();
                queueItem.args = arguments;
                queueItem.instruction = instruction;
                queueItem.triggerElement = self.lastClicked;
                queueItem.isToggling = self.isToggling;
                return self.queueMix(queueItem);
            }
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {object}            multimixCommand
         * @param   {boolean}           [isPreFetch]
         *      An optional boolean indicating that the operation is being pre-fetched for execution at a later time.
         * @return  {Operation|null}
         */ getOperation: function(multimixCommand) {
            var self = this, sortCommand = multimixCommand.sort, filterCommand = multimixCommand.filter, changeLayoutCommand = multimixCommand.changeLayout, removeCommand = multimixCommand.remove, insertCommand = multimixCommand.insert, operation = new mixitup.Operation();
            operation = self.callFilters("operationUnmappedGetOperation", operation, arguments);
            operation.id = h.randomHex();
            operation.command = multimixCommand;
            operation.startState = self.state;
            operation.triggerElement = self.lastClicked;
            if (self.isBusy) {
                if (self.config.debug.showWarnings) console.warn(mixitup.messages.warningGetOperationInstanceBusy());
                return null;
            }
            if (insertCommand) self.insertTargets(insertCommand, operation);
            if (removeCommand) operation.toRemove = removeCommand.targets;
            operation.startSort = operation.newSort = operation.startState.activeSort;
            operation.startOrder = operation.newOrder = self.targets;
            if (sortCommand) {
                operation.startSort = operation.startState.activeSort;
                operation.newSort = sortCommand;
                operation.willSort = self.willSort(sortCommand, operation.startState.activeSort);
                if (operation.willSort) self.sortOperation(operation);
            }
            operation.startFilter = operation.startState.activeFilter;
            if (filterCommand) operation.newFilter = filterCommand;
            else operation.newFilter = h.extend(new mixitup.CommandFilter(), operation.startFilter);
            if (operation.newFilter.selector === "all") operation.newFilter.selector = self.config.selectors.target;
            else if (operation.newFilter.selector === "none") operation.newFilter.selector = "";
            self.filterOperation(operation);
            operation.startContainerClassName = operation.startState.activeContainerClassName;
            if (changeLayoutCommand) {
                operation.newContainerClassName = changeLayoutCommand.containerClassName;
                if (operation.newContainerClassName !== operation.startContainerClassName) operation.willChangeLayout = true;
            } else operation.newContainerClassName = operation.startContainerClassName;
            if (self.config.animation.enable) {
                // Populate the operation's position data
                self.getStartMixData(operation);
                self.setInter(operation);
                operation.docState = h.getDocumentState(self.dom.document);
                self.getInterMixData(operation);
                self.setFinal(operation);
                self.getFinalMixData(operation);
                self.parseEffects();
                operation.hasEffect = self.hasEffect();
                self.getTweenData(operation);
            }
            if (operation.willSort) self.targets = operation.newOrder;
            operation.newState = self.buildState(operation);
            return self.callFilters("operationMappedGetOperation", operation, arguments);
        },
        /**
         * Renders a previously created operation at a specific point in its path, as
         * determined by a multiplier between 0 and 1.
         *
         * @example
         * .tween(operation, multiplier)
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {mixitup.Operation}     operation
         *      An operation object created via the `getOperation` method
         *
         * @param   {Float}                 multiplier
         *      Any number between 0 and 1 representing the percentage complete of the operation
         * @return  {void}
         */ tween: function(operation, multiplier) {
            var target = null, posData = null, toHideIndex = -1, i = -1;
            multiplier = Math.min(multiplier, 1);
            multiplier = Math.max(multiplier, 0);
            for(i = 0; target = operation.show[i]; i++){
                posData = operation.showPosData[i];
                target.applyTween(posData, multiplier);
            }
            for(i = 0; target = operation.hide[i]; i++){
                if (target.isShown) target.hide();
                if ((toHideIndex = operation.toHide.indexOf(target)) > -1) {
                    posData = operation.toHidePosData[toHideIndex];
                    if (!target.isShown) target.show();
                    target.applyTween(posData, multiplier);
                }
            }
        },
        /**
         * Inserts one or more new target elements into the container at a specified
         * index.
         *
         * To be indexed as targets, new elements must match the `selectors.target`
         * selector (`'.mix'` by default).
         *
         * @example
         *
         * .insert(newElements [, index] [, animate], [, callback])
         *
         * @example <caption>Example 1: Inserting a single element via reference</caption>
         *
         * console.log(mixer.getState().totalShow); // 0
         *
         * // Create a new element
         *
         * var newElement = document.createElement('div');
         * newElement.classList.add('mix');
         *
         * mixer.insert(newElement)
         *     .then(function(state) {
         *         console.log(state.totalShow === 1); // true
         *     });
         *
         * @example <caption>Example 2: Inserting a single element via HTML string</caption>
         *
         * console.log(mixer.getState().totalShow); // 1
         *
         * // Create a new element via reference
         *
         * var newElementHtml = '&lt;div class="mix"&gt;&lt;/div&gt;';
         *
         * // Create and insert the new element at index 1
         *
         * mixer.insert(newElementHtml, 1)
         *     .then(function(state) {
         *         console.log(state.totalShow === 2); // true
         *         console.log(state.show[1].outerHTML === newElementHtml); // true
         *     });
         *
         * @example <caption>Example 3: Inserting multiple elements via reference</caption>
         *
         * console.log(mixer.getState().totalShow); // 2
         *
         * // Create an array of new elements to insert.
         *
         * var newElement1 = document.createElement('div');
         * var newElement2 = document.createElement('div');
         *
         * newElement1.classList.add('mix');
         * newElement2.classList.add('mix');
         *
         * var newElementsCollection = [newElement1, newElement2];
         *
         * // Insert the new elements starting at index 1
         *
         * mixer.insert(newElementsCollection, 1)
         *     .then(function(state) {
         *         console.log(state.totalShow === 4); // true
         *         console.log(state.show[1] === newElement1); // true
         *         console.log(state.show[2] === newElement2); // true
         *     });
         *
         * @example <caption>Example 4: Inserting a jQuery collection object containing one or more elements</caption>
         *
         * console.log(mixer.getState().totalShow); // 4
         *
         * var $newElement = $('&lt;div class="mix"&gt;&lt;/div&gt;');
         *
         * // Insert the new elements starting at index 3
         *
         * mixer.insert($newElement, 3)
         *     .then(function(state) {
         *         console.log(state.totalShow === 5); // true
         *         console.log(state.show[3] === $newElement[0]); // true
         *     });
         *
         * @public
         * @instance
         * @since       2.0.0
         * @param       {(HTMLElement|Array.<HTMLElement>|string)}    newElements
         *      A reference to a single element to insert, an array-like collection of elements, or an HTML string representing a single element.
         * @param       {number}    index=0
         *      The index at which to insert the new element(s). `0` by default.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ insert: function() {
            var self = this, args = self.parseInsertArgs(arguments);
            return self.multimix({
                insert: args.command
            }, args.animate, args.callback);
        },
        /**
         * Inserts one or more new elements before a provided reference element.
         *
         * @example
         *
         * .insertBefore(newElements, referenceElement [, animate] [, callback])
         *
         * @example <caption>Example: Inserting a new element before a reference element</caption>
         *
         * // An existing reference element is chosen at index 2
         *
         * var referenceElement = mixer.getState().show[2];
         *
         * // Create a new element
         *
         * var newElement = document.createElement('div');
         * newElement.classList.add('mix');
         *
         * mixer.insertBefore(newElement, referenceElement)
         *     .then(function(state) {
         *         // The new element is inserted into the container at index 2, before the reference element
         *
         *         console.log(state.show[2] === newElement); // true
         *
         *         // The reference element is now at index 3
         *
         *         console.log(state.show[3] === referenceElement); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {(HTMLElement|Array.<HTMLElement>|string)}    newElements
         *      A reference to a single element to insert, an array-like collection of elements, or an HTML string representing a single element.
         * @param       {HTMLElement}    referenceElement
         *      A reference to an existing element in the container to insert new elements before.
         *@param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ insertBefore: function() {
            var self = this, args = self.parseInsertArgs(arguments);
            return self.insert(args.command.collection, "before", args.command.sibling, args.animate, args.callback);
        },
        /**
         * Inserts one or more new elements after a provided reference element.
         *
         * @example
         *
         * .insertAfter(newElements, referenceElement [, animate] [, callback])
         *
         * @example <caption>Example: Inserting a new element after a reference element</caption>
         *
         * // An existing reference element is chosen at index 2
         *
         * var referenceElement = mixer.getState().show[2];
         *
         * // Create a new element
         *
         * var newElement = document.createElement('div');
         * newElement.classList.add('mix');
         *
         * mixer.insertAfter(newElement, referenceElement)
         *     .then(function(state) {
         *         // The new element is inserted into the container at index 3, after the reference element
         *
         *         console.log(state.show[3] === newElement); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {(HTMLElement|Array.<HTMLElement>|string)}    newElements
         *      A reference to a single element to insert, an array-like collection of elements, or an HTML string representing a single element.
         * @param       {HTMLElement}    referenceElement
         *      A reference to an existing element in the container to insert new elements after.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ insertAfter: function() {
            var self = this, args = self.parseInsertArgs(arguments);
            return self.insert(args.command.collection, "after", args.command.sibling, args.animate, args.callback);
        },
        /**
         * Inserts one or more new elements into the container before all existing targets.
         *
         * @example
         *
         * .prepend(newElements [,animate] [,callback])
         *
         * @example <caption>Example: Prepending a new element</caption>
         *
         * // Create a new element
         *
         * var newElement = document.createElement('div');
         * newElement.classList.add('mix');
         *
         * // Insert the element into the container
         *
         * mixer.prepend(newElement)
         *     .then(function(state) {
         *         console.log(state.show[0] === newElement); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {(HTMLElement|Array.<HTMLElement>|string)}    newElements
         *      A reference to a single element to insert, an array-like collection of elements, or an HTML string representing a single element.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ prepend: function() {
            var self = this, args = self.parseInsertArgs(arguments);
            return self.insert(0, args.command.collection, args.animate, args.callback);
        },
        /**
         * Inserts one or more new elements into the container after all existing targets.
         *
         * @example
         *
         * .append(newElements [,animate] [,callback])
         *
         * @example <caption>Example: Appending a new element</caption>
         *
         * // Create a new element
         *
         * var newElement = document.createElement('div');
         * newElement.classList.add('mix');
         *
         * // Insert the element into the container
         *
         * mixer.append(newElement)
         *     .then(function(state) {
         *         console.log(state.show[state.show.length - 1] === newElement); // true
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {(HTMLElement|Array.<HTMLElement>|string)}    newElements
         *      A reference to a single element to insert, an array-like collection of elements, or an HTML string representing a single element.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ append: function() {
            var self = this, args = self.parseInsertArgs(arguments);
            return self.insert(self.state.totalTargets, args.command.collection, args.animate, args.callback);
        },
        /**
         * Removes one or more existing target elements from the container.
         *
         * @example
         *
         * .remove(elements [, animate] [, callback])
         *
         * @example <caption>Example 1: Removing an element by reference</caption>
         *
         * var elementToRemove = containerEl.firstElementChild;
         *
         * mixer.remove(elementToRemove)
         *      .then(function(state) {
         *          console.log(state.targets.indexOf(elementToRemove) === -1); // true
         *      });
         *
         * @example <caption>Example 2: Removing a collection of elements by reference</caption>
         *
         * var elementsToRemove = containerEl.querySelectorAll('.category-a');
         *
         * console.log(elementsToRemove.length) // 3
         *
         * mixer.remove(elementsToRemove)
         *      .then(function() {
         *          console.log(containerEl.querySelectorAll('.category-a').length); // 0
         *      });
         *
         * @example <caption>Example 3: Removing one or more elements by selector</caption>
         *
         * mixer.remove('.category-a')
         *      .then(function() {
         *          console.log(containerEl.querySelectorAll('.category-a').length); // 0
         *      });
         *
         * @example <caption>Example 4: Removing an element by index</caption>
         *
         * console.log(mixer.getState.totalShow); // 4
         *
         * // Remove the element at index 3
         *
         * mixer.remove(3)
         *      .then(function(state) {
         *          console.log(state.totalShow); // 3
         *          console.log(state.show[3]); // undefined
         *      });
         *
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {(HTMLElement|Array.<HTMLElement>|string|number)}    elements
         *      A reference to a single element to remove, an array-like collection of elements, a selector string, or the index of an element to remove.
         * @param       {boolean}   [animate=true]
         *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
         * @param       {function}  [callback=null]
         *      An optional callback function to be invoked after the operation has completed.
         * @return      {Promise.<mixitup.State>}
         *      A promise resolving with the current state object.
         */ remove: function() {
            var self = this, args = self.parseRemoveArgs(arguments);
            return self.multimix({
                remove: args.command
            }, args.animate, args.callback);
        },
        /**
         * Retrieves the the value of any property or sub-object within the current
         * mixitup configuration, or the whole configuration object.
         *
         * @example
         *
         * .getConfig([stringKey])
         *
         * @example <caption>Example 1: retrieve the entire configuration object</caption>
         *
         * var config = mixer.getConfig(); // Config { ... }
         *
         * @example <caption>Example 2: retrieve a named sub-object of configuration object</caption>
         *
         * var animation = mixer.getConfig('animation'); // ConfigAnimation { ... }
         *
         * @example <caption>Example 3: retrieve a value of configuration object via a dot-notation string key</caption>
         *
         * var effects = mixer.getConfig('animation.effects'); // 'fade scale'
         *
         * @public
         * @instance
         * @since       2.0.0
         * @param       {string}    [stringKey]    A "dot-notation" string key
         * @return      {*}
         */ getConfig: function(stringKey) {
            var self = this, value = null;
            if (!stringKey) value = self.config;
            else value = h.getProperty(self.config, stringKey);
            return self.callFilters("valueGetConfig", value, arguments);
        },
        /**
         * Updates the configuration of the mixer, after it has been instantiated.
         *
         * See the Configuration Object documentation for a full list of avilable
         * configuration options.
         *
         * @example
         *
         * .configure(config)
         *
         * @example <caption>Example 1: Updating animation options</caption>
         *
         * mixer.configure({
         *     animation: {
         *         effects: 'fade translateX(-100%)',
         *         duration: 300
         *     }
         * });
         *
         * @example <caption>Example 2: Removing a callback after it has been set</caption>
         *
         * var mixer;
         *
         * function handleMixEndOnce() {
         *     // Do something ..
         *
         *     // Then nullify the callback
         *
         *     mixer.configure({
         *         callbacks: {
         *             onMixEnd: null
         *         }
         *     });
         * };
         *
         * // Instantiate a mixer with a callback defined
         *
         * mixer = mixitup(containerEl, {
         *     callbacks: {
         *         onMixEnd: handleMixEndOnce
         *     }
         * });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {object}    config
         *      An object containing one of more configuration options.
         * @return      {void}
         */ configure: function(config) {
            var self = this;
            self.callActions("beforeConfigure", arguments);
            h.extend(self.config, config, true, true);
            self.callActions("afterConfigure", arguments);
        },
        /**
         * Returns an object containing information about the current state of the
         * mixer. See the State Object documentation for more information.
         *
         * NB: State objects are immutable and should therefore be regenerated
         * after any operation.
         *
         * @example
         *
         * .getState();
         *
         * @example <caption>Example: Retrieving a state object</caption>
         *
         * var state = mixer.getState();
         *
         * console.log(state.totalShow + 'targets are currently shown');
         *
         * @public
         * @instance
         * @since       2.0.0
         * @return      {mixitup.State} An object reflecting the current state of the mixer.
         */ getState: function() {
            var self = this, state = null;
            state = new mixitup.State();
            h.extend(state, self.state);
            h.freeze(state);
            return self.callFilters("stateGetState", state, arguments);
        },
        /**
         * Forces the re-indexing all targets within the container.
         *
         * This should only be used if some other piece of code in your application
         * has manipulated the contents of your container, which should be avoided.
         *
         * If you need to add or remove target elements from the container, use
         * the built-in `.insert()` or `.remove()` methods, and MixItUp will keep
         * itself up to date.
         *
         * @example
         *
         * .forceRefresh()
         *
         * @example <caption>Example: Force refreshing the mixer after external DOM manipulation</caption>
         *
         * console.log(mixer.getState().totalShow); // 3
         *
         * // An element is removed from the container via some external DOM manipulation code:
         *
         * containerEl.removeChild(containerEl.firstElementChild);
         *
         * // The mixer does not know that the number of targets has changed:
         *
         * console.log(mixer.getState().totalShow); // 3
         *
         * mixer.forceRefresh();
         *
         * // After forceRefresh, the mixer is in sync again:
         *
         * console.log(mixer.getState().totalShow); // 2
         *
         * @public
         * @instance
         * @since 2.1.2
         * @return {void}
         */ forceRefresh: function() {
            var self = this;
            self.indexTargets();
        },
        /**
         * Forces the re-rendering of all targets when using the Dataset API.
         *
         * By default, targets are only re-rendered when `data.dirtyCheck` is
         * enabled, and an item's data has changed when `dataset()` is called.
         *
         * The `forceRender()` method allows for the re-rendering of all targets
         * in response to some arbitrary event, such as the changing of the target
         * render function.
         *
         * Targets are rendered against their existing data.
         *
         * @example
         *
         * .forceRender()
         *
         * @example <caption>Example: Force render targets after changing the target render function</caption>
         *
         * console.log(container.innerHTML); // ... &lt;span class="mix"&gt;Foo&lt;/span&gt; ...
         *
         * mixer.configure({
         *     render: {
         *         target: (item) => `&lt;a href="/${item.slug}/" class="mix"&gt;${item.title}&lt;/a&gt;`
         *     }
         * });
         *
         * mixer.forceRender();
         *
         * console.log(container.innerHTML); // ... &lt;a href="/foo/" class="mix"&gt;Foo&lt;/a&gt; ...
         *
         * @public
         * @instance
         * @since 3.2.1
         * @return {void}
         */ forceRender: function() {
            var self = this, target = null, el = null, id = "";
            for(id in self.cache){
                target = self.cache[id];
                el = target.render(target.data);
                if (el !== target.dom.el) {
                    // Update target element reference
                    if (target.isInDom) {
                        target.unbindEvents();
                        self.dom.parent.replaceChild(el, target.dom.el);
                    }
                    if (!target.isShown) el.style.display = "none";
                    target.dom.el = el;
                    if (target.isInDom) target.bindEvents();
                }
            }
            self.state = self.buildState(self.lastOperation);
        },
        /**
         * Removes mixitup functionality from the container, unbinds all control
         * event handlers, and deletes the mixer instance from MixItUp's internal
         * cache.
         *
         * This should be performed whenever a mixer's container is removed from
         * the DOM, such as during a page change in a single page application,
         * or React's `componentWillUnmount()`.
         *
         * @example
         *
         * .destroy([cleanUp])
         *
         * @example <caption>Example: Destroying the mixer before removing its container element</caption>
         *
         * mixer.destroy();
         *
         * containerEl.parentElement.removeChild(containerEl);
         *
         * @public
         * @instance
         * @since   2.0.0
         * @param   {boolean}   [cleanUp=false]
         *     An optional boolean dictating whether or not to clean up any inline `display: none;` styling applied to hidden targets.
         * @return  {void}
         */ destroy: function(cleanUp) {
            var self = this, control = null, target = null, i = 0;
            self.callActions("beforeDestroy", arguments);
            for(i = 0; control = self.controls[i]; i++)control.removeBinding(self);
            for(i = 0; target = self.targets[i]; i++){
                if (cleanUp) target.show();
                target.unbindEvents();
            }
            if (self.dom.container.id.match(/^MixItUp/)) self.dom.container.removeAttribute("id");
            delete mixitup.instances[self.id];
            self.callActions("afterDestroy", arguments);
        }
    });
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.IMoveData = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.posIn = null;
        this.posOut = null;
        this.operation = null;
        this.callback = null;
        this.statusChange = "";
        this.duration = -1;
        this.staggerIndex = -1;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.IMoveData);
    mixitup.IMoveData.prototype = Object.create(mixitup.Base.prototype);
    mixitup.IMoveData.prototype.constructor = mixitup.IMoveData;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.TargetDom = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.el = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.TargetDom);
    mixitup.TargetDom.prototype = Object.create(mixitup.Base.prototype);
    mixitup.TargetDom.prototype.constructor = mixitup.TargetDom;
    /**
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Target = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.id = "";
        this.sortString = "";
        this.mixer = null;
        this.callback = null;
        this.isShown = false;
        this.isBound = false;
        this.isExcluded = false;
        this.isInDom = false;
        this.handler = null;
        this.operation = null;
        this.data = null;
        this.dom = new mixitup.TargetDom();
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Target);
    mixitup.Target.prototype = Object.create(mixitup.Base.prototype);
    h.extend(mixitup.Target.prototype, {
        constructor: mixitup.Target,
        /**
         * Initialises a newly instantiated Target.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {(Element|null)}    el
         * @param   {object}            mixer
         * @param   {object}            [data]
         * @return  {void}
         */ init: function(el, mixer, data) {
            var self = this, id = "";
            self.callActions("beforeInit", arguments);
            self.mixer = mixer;
            if (!el) // If no element is provided, render it
            el = self.render(data);
            self.cacheDom(el);
            self.bindEvents();
            if (self.dom.el.style.display !== "none") self.isShown = true;
            if (data && mixer.config.data.uidKey) {
                if (typeof (id = data[mixer.config.data.uidKey]) === "undefined" || id.toString().length < 1) throw new TypeError(mixitup.messages.errorDatasetInvalidUidKey({
                    uidKey: mixer.config.data.uidKey
                }));
                self.id = id;
                self.data = data;
                mixer.cache[id] = self;
            }
            self.callActions("afterInit", arguments);
        },
        /**
         * Renders the target element using a user-defined renderer function.
         *
         * @private
         * @instance
         * @since   3.1.4
         * @param   {object} data
         * @return  {void}
         */ render: function(data) {
            var self = this, render = null, el = null, temp = null, output = "";
            self.callActions("beforeRender", arguments);
            render = self.callFilters("renderRender", self.mixer.config.render.target, arguments);
            if (typeof render !== "function") throw new TypeError(mixitup.messages.errorDatasetRendererNotSet());
            output = render(data);
            if (output && typeof output === "object" && h.isElement(output)) el = output;
            else if (typeof output === "string") {
                temp = document.createElement("div");
                temp.innerHTML = output;
                el = temp.firstElementChild;
            }
            return self.callFilters("elRender", el, arguments);
        },
        /**
         * Caches references of DOM elements neccessary for the target's functionality.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Element} el
         * @return  {void}
         */ cacheDom: function(el) {
            var self = this;
            self.callActions("beforeCacheDom", arguments);
            self.dom.el = el;
            self.callActions("afterCacheDom", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {string}    attributeName
         * @return  {void}
         */ getSortString: function(attributeName) {
            var self = this, value = self.dom.el.getAttribute("data-" + attributeName) || "";
            self.callActions("beforeGetSortString", arguments);
            value = isNaN(value * 1) ? value.toLowerCase() : value * 1;
            self.sortString = value;
            self.callActions("afterGetSortString", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @return  {void}
         */ show: function() {
            var self = this;
            self.callActions("beforeShow", arguments);
            if (!self.isShown) {
                self.dom.el.style.display = "";
                self.isShown = true;
            }
            self.callActions("afterShow", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @return  {void}
         */ hide: function() {
            var self = this;
            self.callActions("beforeHide", arguments);
            if (self.isShown) {
                self.dom.el.style.display = "none";
                self.isShown = false;
            }
            self.callActions("afterHide", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {mixitup.IMoveData} moveData
         * @return  {void}
         */ move: function(moveData) {
            var self = this;
            self.callActions("beforeMove", arguments);
            if (!self.isExcluded) self.mixer.targetsMoved++;
            self.applyStylesIn(moveData);
            requestAnimationFrame(function() {
                self.applyStylesOut(moveData);
            });
            self.callActions("afterMove", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {object}    posData
         * @param   {number}    multiplier
         * @return  {void}
         */ applyTween: function(posData, multiplier) {
            var self = this, propertyName = "", tweenData = null, posIn = posData.posIn, currentTransformValues = [], currentValues = new mixitup.StyleData(), i = -1;
            self.callActions("beforeApplyTween", arguments);
            currentValues.x = posIn.x;
            currentValues.y = posIn.y;
            if (multiplier === 0) self.hide();
            else if (!self.isShown) self.show();
            for(i = 0; propertyName = mixitup.features.TWEENABLE[i]; i++){
                tweenData = posData.tweenData[propertyName];
                if (propertyName === "x") {
                    if (!tweenData) continue;
                    currentValues.x = posIn.x + tweenData * multiplier;
                } else if (propertyName === "y") {
                    if (!tweenData) continue;
                    currentValues.y = posIn.y + tweenData * multiplier;
                } else if (tweenData instanceof mixitup.TransformData) {
                    if (!tweenData.value) continue;
                    currentValues[propertyName].value = posIn[propertyName].value + tweenData.value * multiplier;
                    currentValues[propertyName].unit = tweenData.unit;
                    currentTransformValues.push(propertyName + "(" + currentValues[propertyName].value + tweenData.unit + ")");
                } else {
                    if (!tweenData) continue;
                    currentValues[propertyName] = posIn[propertyName] + tweenData * multiplier;
                    self.dom.el.style[propertyName] = currentValues[propertyName];
                }
            }
            if (currentValues.x || currentValues.y) currentTransformValues.unshift("translate(" + currentValues.x + "px, " + currentValues.y + "px)");
            if (currentTransformValues.length) self.dom.el.style[mixitup.features.transformProp] = currentTransformValues.join(" ");
            self.callActions("afterApplyTween", arguments);
        },
        /**
         * Applies the initial styling to a target element before any transition
         * is applied.
         *
         * @private
         * @instance
         * @param   {mixitup.IMoveData} moveData
         * @return  {void}
         */ applyStylesIn: function(moveData) {
            var self = this, posIn = moveData.posIn, isFading = self.mixer.effectsIn.opacity !== 1, transformValues = [];
            self.callActions("beforeApplyStylesIn", arguments);
            transformValues.push("translate(" + posIn.x + "px, " + posIn.y + "px)");
            if (self.mixer.config.animation.animateResizeTargets) {
                if (moveData.statusChange !== "show") {
                    // Don't apply posIn width or height or showing, as will be 0
                    self.dom.el.style.width = posIn.width + "px";
                    self.dom.el.style.height = posIn.height + "px";
                }
                self.dom.el.style.marginRight = posIn.marginRight + "px";
                self.dom.el.style.marginBottom = posIn.marginBottom + "px";
            }
            isFading && (self.dom.el.style.opacity = posIn.opacity);
            if (moveData.statusChange === "show") transformValues = transformValues.concat(self.mixer.transformIn);
            self.dom.el.style[mixitup.features.transformProp] = transformValues.join(" ");
            self.callActions("afterApplyStylesIn", arguments);
        },
        /**
         * Applies a transition followed by the final styles for the element to
         * transition towards.
         *
         * @private
         * @instance
         * @param   {mixitup.IMoveData} moveData
         * @return  {void}
         */ applyStylesOut: function(moveData) {
            var self = this, transitionRules = [], transformValues = [], isResizing = self.mixer.config.animation.animateResizeTargets, isFading = typeof self.mixer.effectsIn.opacity !== "undefined";
            self.callActions("beforeApplyStylesOut", arguments);
            // Build the transition rules
            transitionRules.push(self.writeTransitionRule(mixitup.features.transformRule, moveData.staggerIndex));
            if (moveData.statusChange !== "none") transitionRules.push(self.writeTransitionRule("opacity", moveData.staggerIndex, moveData.duration));
            if (isResizing) {
                transitionRules.push(self.writeTransitionRule("width", moveData.staggerIndex, moveData.duration));
                transitionRules.push(self.writeTransitionRule("height", moveData.staggerIndex, moveData.duration));
                transitionRules.push(self.writeTransitionRule("margin", moveData.staggerIndex, moveData.duration));
            }
            // If no callback was provided, the element will
            // not transition in any way so tag it as "immovable"
            if (!moveData.callback) {
                self.mixer.targetsImmovable++;
                if (self.mixer.targetsMoved === self.mixer.targetsImmovable) // If the total targets moved is equal to the
                // number of immovable targets, the operation
                // should be considered finished
                self.mixer.cleanUp(moveData.operation);
                return;
            }
            // If the target will transition in some fasion,
            // assign a callback function
            self.operation = moveData.operation;
            self.callback = moveData.callback;
            // As long as the target is not excluded, increment
            // the total number of targets bound
            !self.isExcluded && self.mixer.targetsBound++;
            // Tag the target as bound to differentiate from transitionEnd
            // events that may come from stylesheet driven effects
            self.isBound = true;
            // Apply the transition
            self.applyTransition(transitionRules);
            // Apply width, height and margin negation
            if (isResizing && moveData.posOut.width > 0 && moveData.posOut.height > 0) {
                self.dom.el.style.width = moveData.posOut.width + "px";
                self.dom.el.style.height = moveData.posOut.height + "px";
                self.dom.el.style.marginRight = moveData.posOut.marginRight + "px";
                self.dom.el.style.marginBottom = moveData.posOut.marginBottom + "px";
            }
            if (!self.mixer.config.animation.nudge && moveData.statusChange === "hide") // If we're not nudging, the translation should be
            // applied before any other transforms to prevent
            // lateral movement
            transformValues.push("translate(" + moveData.posOut.x + "px, " + moveData.posOut.y + "px)");
            // Apply fade
            switch(moveData.statusChange){
                case "hide":
                    isFading && (self.dom.el.style.opacity = self.mixer.effectsOut.opacity);
                    transformValues = transformValues.concat(self.mixer.transformOut);
                    break;
                case "show":
                    isFading && (self.dom.el.style.opacity = 1);
            }
            if (self.mixer.config.animation.nudge || !self.mixer.config.animation.nudge && moveData.statusChange !== "hide") // Opposite of above - apply translate after
            // other transform
            transformValues.push("translate(" + moveData.posOut.x + "px, " + moveData.posOut.y + "px)");
            // Apply transforms
            self.dom.el.style[mixitup.features.transformProp] = transformValues.join(" ");
            self.callActions("afterApplyStylesOut", arguments);
        },
        /**
         * Combines the name of a CSS property with the appropriate duration and delay
         * values to created a valid transition rule.
         *
         * @private
         * @instance
         * @since   3.0.0
         * @param   {string}    property
         * @param   {number}    staggerIndex
         * @param   {number}    duration
         * @return  {string}
         */ writeTransitionRule: function(property, staggerIndex, duration) {
            var self = this, delay = self.getDelay(staggerIndex), rule = "";
            rule = property + " " + (duration > 0 ? duration : self.mixer.config.animation.duration) + "ms " + delay + "ms " + (property === "opacity" ? "linear" : self.mixer.config.animation.easing);
            return self.callFilters("ruleWriteTransitionRule", rule, arguments);
        },
        /**
         * Calculates the transition delay for each target element based on its index, if
         * staggering is applied. If defined, A custom `animation.staggerSeqeuence`
         * function can be used to manipulate the order of indices to produce custom
         * stagger effects (e.g. for use in a grid with irregular row lengths).
         *
         * @private
         * @instance
         * @since   2.0.0
         * @param   {number}    index
         * @return  {number}
         */ getDelay: function(index) {
            var self = this, delay = -1;
            if (typeof self.mixer.config.animation.staggerSequence === "function") index = self.mixer.config.animation.staggerSequence.call(self, index, self.state);
            delay = !!self.mixer.staggerDuration ? index * self.mixer.staggerDuration : 0;
            return self.callFilters("delayGetDelay", delay, arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {string[]}  rules
         * @return  {void}
         */ applyTransition: function(rules) {
            var self = this, transitionString = rules.join(", ");
            self.callActions("beforeApplyTransition", arguments);
            self.dom.el.style[mixitup.features.transitionProp] = transitionString;
            self.callActions("afterApplyTransition", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Event} e
         * @return  {void}
         */ handleTransitionEnd: function(e) {
            var self = this, propName = e.propertyName, canResize = self.mixer.config.animation.animateResizeTargets;
            self.callActions("beforeHandleTransitionEnd", arguments);
            if (self.isBound && e.target.matches(self.mixer.config.selectors.target) && (propName.indexOf("transform") > -1 || propName.indexOf("opacity") > -1 || canResize && propName.indexOf("height") > -1 || canResize && propName.indexOf("width") > -1 || canResize && propName.indexOf("margin") > -1)) {
                self.callback.call(self, self.operation);
                self.isBound = false;
                self.callback = null;
                self.operation = null;
            }
            self.callActions("afterHandleTransitionEnd", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {Event}     e
         * @return  {void}
         */ eventBus: function(e) {
            var self = this;
            self.callActions("beforeEventBus", arguments);
            switch(e.type){
                case "webkitTransitionEnd":
                case "transitionend":
                    self.handleTransitionEnd(e);
            }
            self.callActions("afterEventBus", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @return  {void}
         */ unbindEvents: function() {
            var self = this;
            self.callActions("beforeUnbindEvents", arguments);
            h.off(self.dom.el, "webkitTransitionEnd", self.handler);
            h.off(self.dom.el, "transitionend", self.handler);
            self.callActions("afterUnbindEvents", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @return  {void}
         */ bindEvents: function() {
            var self = this, transitionEndEvent = "";
            self.callActions("beforeBindEvents", arguments);
            transitionEndEvent = mixitup.features.transitionPrefix === "webkit" ? "webkitTransitionEnd" : "transitionend";
            self.handler = function(e) {
                return self.eventBus(e);
            };
            h.on(self.dom.el, transitionEndEvent, self.handler);
            self.callActions("afterBindEvents", arguments);
        },
        /**
         * @private
         * @instance
         * @since   3.0.0
         * @param   {boolean}   [getBox]
         * @return  {PosData}
         */ getPosData: function(getBox) {
            var self = this, styles = {}, rect = null, posData = new mixitup.StyleData();
            self.callActions("beforeGetPosData", arguments);
            posData.x = self.dom.el.offsetLeft;
            posData.y = self.dom.el.offsetTop;
            if (self.mixer.config.animation.animateResizeTargets || getBox) {
                rect = self.dom.el.getBoundingClientRect();
                posData.top = rect.top;
                posData.right = rect.right;
                posData.bottom = rect.bottom;
                posData.left = rect.left;
                posData.width = rect.width;
                posData.height = rect.height;
            }
            if (self.mixer.config.animation.animateResizeTargets) {
                styles = window1.getComputedStyle(self.dom.el);
                posData.marginBottom = parseFloat(styles.marginBottom);
                posData.marginRight = parseFloat(styles.marginRight);
            }
            return self.callFilters("posDataGetPosData", posData, arguments);
        },
        /**
         * @private
         * @instance
         * @since       3.0.0
         * @return      {void}
         */ cleanUp: function() {
            var self = this;
            self.callActions("beforeCleanUp", arguments);
            self.dom.el.style[mixitup.features.transformProp] = "";
            self.dom.el.style[mixitup.features.transitionProp] = "";
            self.dom.el.style.opacity = "";
            if (self.mixer.config.animation.animateResizeTargets) {
                self.dom.el.style.width = "";
                self.dom.el.style.height = "";
                self.dom.el.style.marginRight = "";
                self.dom.el.style.marginBottom = "";
            }
            self.callActions("afterCleanUp", arguments);
        }
    });
    /**
     * A jQuery-collection-like wrapper around one or more `mixitup.Mixer` instances
     * allowing simultaneous control of said instances similar to the MixItUp 2 API.
     *
     * @example
     * new mixitup.Collection(instances)
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     * @param       {mixitup.Mixer[]}   instances
     */ mixitup.Collection = function(instances) {
        var instance = null, i = -1;
        this.callActions("beforeConstruct");
        for(i = 0; instance = instances[i]; i++)this[i] = instance;
        this.length = instances.length;
        this.callActions("afterConstruct");
        h.freeze(this);
    };
    mixitup.BaseStatic.call(mixitup.Collection);
    mixitup.Collection.prototype = Object.create(mixitup.Base.prototype);
    h.extend(mixitup.Collection.prototype, /** @lends mixitup.Collection */ {
        constructor: mixitup.Collection,
        /**
         * Calls a method on all instances in the collection by passing the method
         * name as a string followed by any applicable parameters to be curried into
         * to the method.
         *
         * @example
         * .mixitup(methodName[,arg1][,arg2..]);
         *
         * @example
         * var collection = new Collection([mixer1, mixer2]);
         *
         * return collection.mixitup('filter', '.category-a')
         *     .then(function(states) {
         *         state.forEach(function(state) {
         *             console.log(state.activeFilter.selector); // .category-a
         *         });
         *     });
         *
         * @public
         * @instance
         * @since       3.0.0
         * @param       {string}  methodName
         * @return      {Promise<Array<mixitup.State>>}
         */ mixitup: function(methodName) {
            var self = this, instance = null, args = Array.prototype.slice.call(arguments), tasks = [], i = -1;
            this.callActions("beforeMixitup");
            args.shift();
            for(i = 0; instance = self[i]; i++)tasks.push(instance[methodName].apply(instance, args));
            return self.callFilters("promiseMixitup", h.all(tasks, mixitup.libraries), arguments);
        }
    });
    /**
     * `mixitup.Operation` objects contain all data neccessary to describe the full
     * lifecycle of any MixItUp operation. They can be used to compute and store an
     * operation for use at a later time (e.g. programmatic tweening).
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Operation = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.id = "";
        this.args = [];
        this.command = null;
        this.showPosData = [];
        this.toHidePosData = [];
        this.startState = null;
        this.newState = null;
        this.docState = null;
        this.willSort = false;
        this.willChangeLayout = false;
        this.hasEffect = false;
        this.hasFailed = false;
        this.triggerElement = null;
        this.show = [];
        this.hide = [];
        this.matching = [];
        this.toShow = [];
        this.toHide = [];
        this.toMove = [];
        this.toRemove = [];
        this.startOrder = [];
        this.newOrder = [];
        this.startSort = null;
        this.newSort = null;
        this.startFilter = null;
        this.newFilter = null;
        this.startDataset = null;
        this.newDataset = null;
        this.viewportDeltaX = 0;
        this.viewportDeltaY = 0;
        this.startX = 0;
        this.startY = 0;
        this.startHeight = 0;
        this.startWidth = 0;
        this.newX = 0;
        this.newY = 0;
        this.newHeight = 0;
        this.newWidth = 0;
        this.startContainerClassName = "";
        this.startDisplay = "";
        this.newContainerClassName = "";
        this.newDisplay = "";
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Operation);
    mixitup.Operation.prototype = Object.create(mixitup.Base.prototype);
    mixitup.Operation.prototype.constructor = mixitup.Operation;
    /**
     * `mixitup.State` objects expose various pieces of data detailing the state of
     * a MixItUp instance. They are provided at the start and end of any operation via
     * callbacks and events, with the most recent state stored between operations
     * for retrieval at any time via the API.
     *
     * @constructor
     * @namespace
     * @memberof    mixitup
     * @public
     * @since       3.0.0
     */ mixitup.State = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /**
         * The ID of the mixer instance.
         *
         * @name        id
         * @memberof    mixitup.State
         * @instance
         * @type        {string}
         * @default     ''
         */ this.id = "";
        /**
         * The currently active filter command as set by a control click or API call.
         *
         * @name        activeFilter
         * @memberof    mixitup.State
         * @instance
         * @type        {mixitup.CommandFilter}
         * @default     null
         */ this.activeFilter = null;
        /**
         * The currently active sort command as set by a control click or API call.
         *
         * @name        activeSort
         * @memberof    mixitup.State
         * @instance
         * @type        {mixitup.CommandSort}
         * @default     null
         */ this.activeSort = null;
        /**
         * The current layout-specific container class name, if applied.
         *
         * @name        activeContainerClassName
         * @memberof    mixitup.State
         * @instance
         * @type        {string}
         * @default     ''
         */ this.activeContainerClassName = "";
        /**
         * A reference to the container element that the mixer is instantiated on.
         *
         * @name        container
         * @memberof    mixitup.State
         * @instance
         * @type        {Element}
         * @default     null
         */ this.container = null;
        /**
         * An array of all target elements indexed by the mixer.
         *
         * @name        targets
         * @memberof    mixitup.State
         * @instance
         * @type        {Array.<Element>}
         * @default     []
         */ this.targets = [];
        /**
         * An array of all target elements not matching the current filter.
         *
         * @name        hide
         * @memberof    mixitup.State
         * @instance
         * @type        {Array.<Element>}
         * @default     []
         */ this.hide = [];
        /**
         * An array of all target elements matching the current filter and any additional
         * limits applied such as pagination.
         *
         * @name        show
         * @memberof    mixitup.State
         * @instance
         * @type        {Array.<Element>}
         * @default     []
         */ this.show = [];
        /**
         * An array of all target elements matching the current filter irrespective of
         * any additional limits applied such as pagination.
         *
         * @name        matching
         * @memberof    mixitup.State
         * @instance
         * @type        {Array.<Element>}
         * @default     []
         */ this.matching = [];
        /**
         * An integer representing the total number of target elements indexed by the
         * mixer. Equivalent to `state.targets.length`.
         *
         * @name        totalTargets
         * @memberof    mixitup.State
         * @instance
         * @type        {number}
         * @default     -1
         */ this.totalTargets = -1;
        /**
         * An integer representing the total number of target elements matching the
         * current filter and any additional limits applied such as pagination.
         * Equivalent to `state.show.length`.
         *
         * @name        totalShow
         * @memberof    mixitup.State
         * @instance
         * @type        {number}
         * @default     -1
         */ this.totalShow = -1;
        /**
         * An integer representing the total number of target elements not matching
         * the current filter. Equivalent to `state.hide.length`.
         *
         * @name        totalHide
         * @memberof    mixitup.State
         * @instance
         * @type        {number}
         * @default     -1
         */ this.totalHide = -1;
        /**
         * An integer representing the total number of target elements matching the
         * current filter irrespective of any other limits applied such as pagination.
         * Equivalent to `state.matching.length`.
         *
         * @name        totalMatching
         * @memberof    mixitup.State
         * @instance
         * @type        {number}
         * @default     -1
         */ this.totalMatching = -1;
        /**
         * A boolean indicating whether the last operation "failed", i.e. no targets
         * could be found matching the filter.
         *
         * @name        hasFailed
         * @memberof    mixitup.State
         * @instance
         * @type        {boolean}
         * @default     false
         */ this.hasFailed = false;
        /**
         * The DOM element that was clicked if the last operation was triggered by the
         * clicking of a control and not an API call.
         *
         * @name        triggerElement
         * @memberof    mixitup.State
         * @instance
         * @type        {Element|null}
         * @default     null
         */ this.triggerElement = null;
        /**
         * The currently active dataset underlying the rendered targets, if the
         * dataset API is in use.
         *
         * @name        activeDataset
         * @memberof    mixitup.State
         * @instance
         * @type        {Array.<object>}
         * @default     null
         */ this.activeDataset = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.State);
    mixitup.State.prototype = Object.create(mixitup.Base.prototype);
    mixitup.State.prototype.constructor = mixitup.State;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.UserInstruction = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        this.command = {};
        this.animate = false;
        this.callback = null;
        this.callActions("afterConstruct");
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.UserInstruction);
    mixitup.UserInstruction.prototype = Object.create(mixitup.Base.prototype);
    mixitup.UserInstruction.prototype.constructor = mixitup.UserInstruction;
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     */ mixitup.Messages = function() {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct");
        /* Errors
        ----------------------------------------------------------------------------- */ this.ERROR_FACTORY_INVALID_CONTAINER = "[MixItUp] An invalid selector or element reference was passed to the mixitup factory function";
        this.ERROR_FACTORY_CONTAINER_NOT_FOUND = "[MixItUp] The provided selector yielded no container element";
        this.ERROR_CONFIG_INVALID_ANIMATION_EFFECTS = "[MixItUp] Invalid value for `animation.effects`";
        this.ERROR_CONFIG_INVALID_CONTROLS_SCOPE = "[MixItUp] Invalid value for `controls.scope`";
        this.ERROR_CONFIG_INVALID_PROPERTY = '[MixitUp] Invalid configuration object property "${erroneous}"${suggestion}';
        this.ERROR_CONFIG_INVALID_PROPERTY_SUGGESTION = '. Did you mean "${probableMatch}"?';
        this.ERROR_CONFIG_DATA_UID_KEY_NOT_SET = "[MixItUp] To use the dataset API, a UID key must be specified using `data.uidKey`";
        this.ERROR_DATASET_INVALID_UID_KEY = '[MixItUp] The specified UID key "${uidKey}" is not present on one or more dataset items';
        this.ERROR_DATASET_DUPLICATE_UID = '[MixItUp] The UID "${uid}" was found on two or more dataset items. UIDs must be unique.';
        this.ERROR_INSERT_INVALID_ARGUMENTS = "[MixItUp] Please provider either an index or a sibling and position to insert, not both";
        this.ERROR_INSERT_PREEXISTING_ELEMENT = "[MixItUp] An element to be inserted already exists in the container";
        this.ERROR_FILTER_INVALID_ARGUMENTS = "[MixItUp] Please provide either a selector or collection `.filter()`, not both";
        this.ERROR_DATASET_NOT_SET = "[MixItUp] To use the dataset API with pre-rendered targets, a starting dataset must be set using `load.dataset`";
        this.ERROR_DATASET_PRERENDERED_MISMATCH = "[MixItUp] `load.dataset` does not match pre-rendered targets";
        this.ERROR_DATASET_RENDERER_NOT_SET = "[MixItUp] To insert an element via the dataset API, a target renderer function must be provided to `render.target`";
        this.ERROR_SORT_NON_EXISTENT_ELEMENT = "[MixItUp] An element to be sorted does not already exist in the container";
        /* Warnings
        ----------------------------------------------------------------------------- */ this.WARNING_FACTORY_PREEXISTING_INSTANCE = "[MixItUp] WARNING: This element already has an active MixItUp instance. The provided configuration object will be ignored. If you wish to perform additional methods on this instance, please create a reference.";
        this.WARNING_INSERT_NO_ELEMENTS = "[MixItUp] WARNING: No valid elements were passed to `.insert()`";
        this.WARNING_REMOVE_NO_ELEMENTS = "[MixItUp] WARNING: No valid elements were passed to `.remove()`";
        this.WARNING_MULTIMIX_INSTANCE_QUEUE_FULL = "[MixItUp] WARNING: An operation was requested but the MixItUp instance was busy. The operation was rejected because the queue is full or queuing is disabled.";
        this.WARNING_GET_OPERATION_INSTANCE_BUSY = "[MixItUp] WARNING: Operations can be be created while the MixItUp instance is busy.";
        this.WARNING_NO_PROMISE_IMPLEMENTATION = "[MixItUp] WARNING: No Promise implementations could be found. If you wish to use promises with MixItUp please install an ES6 Promise polyfill.";
        this.WARNING_INCONSISTENT_SORTING_ATTRIBUTES = '[MixItUp] WARNING: The requested sorting data attribute "${attribute}" was not present on one or more target elements which may product unexpected sort output';
        this.callActions("afterConstruct");
        this.compileTemplates();
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Messages);
    mixitup.Messages.prototype = Object.create(mixitup.Base.prototype);
    mixitup.Messages.prototype.constructor = mixitup.Messages;
    /**
     * @return {void}
     */ mixitup.Messages.prototype.compileTemplates = function() {
        var errorKey = "";
        var errorMessage = "";
        for(errorKey in this){
            if (typeof (errorMessage = this[errorKey]) !== "string") continue;
            this[h.camelCase(errorKey)] = h.template(errorMessage);
        }
    };
    mixitup.messages = new mixitup.Messages();
    /**
     * @constructor
     * @memberof    mixitup
     * @private
     * @since       3.0.0
     * @param       {mixitup.Mixer} mixer
     */ mixitup.Facade = function Mixer(mixer) {
        mixitup.Base.call(this);
        this.callActions("beforeConstruct", arguments);
        this.configure = mixer.configure.bind(mixer);
        this.show = mixer.show.bind(mixer);
        this.hide = mixer.hide.bind(mixer);
        this.filter = mixer.filter.bind(mixer);
        this.toggleOn = mixer.toggleOn.bind(mixer);
        this.toggleOff = mixer.toggleOff.bind(mixer);
        this.sort = mixer.sort.bind(mixer);
        this.changeLayout = mixer.changeLayout.bind(mixer);
        this.multimix = mixer.multimix.bind(mixer);
        this.dataset = mixer.dataset.bind(mixer);
        this.tween = mixer.tween.bind(mixer);
        this.insert = mixer.insert.bind(mixer);
        this.insertBefore = mixer.insertBefore.bind(mixer);
        this.insertAfter = mixer.insertAfter.bind(mixer);
        this.prepend = mixer.prepend.bind(mixer);
        this.append = mixer.append.bind(mixer);
        this.remove = mixer.remove.bind(mixer);
        this.destroy = mixer.destroy.bind(mixer);
        this.forceRefresh = mixer.forceRefresh.bind(mixer);
        this.forceRender = mixer.forceRender.bind(mixer);
        this.isMixing = mixer.isMixing.bind(mixer);
        this.getOperation = mixer.getOperation.bind(mixer);
        this.getConfig = mixer.getConfig.bind(mixer);
        this.getState = mixer.getState.bind(mixer);
        this.callActions("afterConstruct", arguments);
        h.freeze(this);
        h.seal(this);
    };
    mixitup.BaseStatic.call(mixitup.Facade);
    mixitup.Facade.prototype = Object.create(mixitup.Base.prototype);
    mixitup.Facade.prototype.constructor = mixitup.Facade;
    $2937ea0c96f7acc8$exports = mixitup;
    mixitup.BaseStatic.call(mixitup.constructor);
    mixitup.NAME = "mixitup";
    mixitup.CORE_VERSION = "3.3.2";
})(window);


var $b5abcff591ac2127$exports = {};
/**!
 * MixItUp Pagination v3.3.2
 * Client-side pagination for filtered and sorted content
 * Build 875b7d31-63d1-4040-ac6f-b1c814027891
 *
 * Requires mixitup.js >= v^3.1.8
 *
 * @copyright Copyright 2014-2024 KunkaLabs Limited.
 * @author    KunkaLabs Limited.
 * @link      https://github.com/patrickkunka/mixitup-pagination/
 * @license   Apache-2.0
 */ (function(window1) {
    "use strict";
    var mixitupPagination = function(mixitup) {
        var h = mixitup.h;
        if (!mixitup.CORE_VERSION || !h.compareVersions(mixitupPagination.REQUIRE_CORE_VERSION, mixitup.CORE_VERSION)) throw new Error("[MixItUp Pagination] MixItUp Pagination " + mixitupPagination.EXTENSION_VERSION + " requires at least MixItUp " + mixitupPagination.REQUIRE_CORE_VERSION);
        /**
         * A group of optional callback functions to be invoked at various
         * points within the lifecycle of a mixer operation.
         *
         * @constructor
         * @memberof    mixitup.Config
         * @name        callbacks
         * @namespace
         * @public
         * @since       2.0.0
         */ mixitup.ConfigCallbacks.registerAction("afterConstruct", "pagination", function() {
            /**
             * A callback function invoked whenever a pagination operation starts.
             *
             * This function is equivalent to `onMixStart`, and is invoked immediately
             * after it with the same arguments. Unlike `onMixStart` however, it will
             * not be invoked for filter or sort operations.
             *
             *
             * @name        onPaginateStart
             * @memberof    mixitup.Config.callbacks
             * @instance
             * @type        {function}
             * @default     null
             */ this.onPaginateStart = null;
            /**
             * A callback function invoked whenever a pagination operation ends.
             *
             * This function is equivalent to `onMixEnd`, and is invoked immediately
             * after it with the same arguments. Unlike `onMixEnd` however, it will
             * not be invoked for filter or sort operations.
             *
             * @name        onPaginateStart
             * @memberof    mixitup.Config.callbacks
             * @instance
             * @type        {function}
             * @default     null
             */ this.onPaginateEnd = null;
        });
        /**
         * A group of properties defining the output and structure of class names programmatically
         * added to controls and containers to reflect the state of the mixer.
         *
         * @constructor
         * @memberof    mixitup.Config
         * @name        classNames
         * @namespace
         * @public
         * @since       3.0.0
         */ mixitup.ConfigClassNames.registerAction("afterConstruct", "pagination", function() {
            /**
             * The "element" portion of the class name added to pager controls.
             *
             * @example <caption>Example: changing the `config.classNames.elementPager` value</caption>
             *
             * // Change from the default value of 'control' to 'pager'
             *
             * var mixer = mixitup(containerEl, {
             *     classNames: {
             *         elementPager: 'pager'
             *     }
             * });
             *
             * // Base pager output: "mixitup-pager"
             *
             * @name        elementPager
             * @memberof    mixitup.Config.classNames
             * @instance
             * @type        {string}
             * @default     'control'
             */ this.elementPager = "control";
            /**
             * The "element" portion of the class name added to the page list element, when it is
             * in its disabled state.
             *
             * The page list element is the containing element in which pagers are rendered.
             *
             * @example <caption>Example: changing the `config.classNames.elementPageList` value</caption>
             *
             * // Change from the default value of 'page-list' to 'pagination-links'
             *
             * var mixer = mixitup(containerEl, {
             *     classNames: {
             *         elementPageList: 'pagination-links'
             *     }
             * });
             *
             * // Disabled page-list output: "mixitup-pagination-links-disabled"
             *
             * @name        elementPageList
             * @memberof    mixitup.Config.classNames
             * @instance
             * @type        {string}
             * @default     'page-list'
             */ this.elementPageList = "page-list";
            /**
             * The "element" portion of the class name added to the page stats element, when it is
             * in its disabled state.
             *
             * The page stats element is the containing element in which information about the
             * current page and total number of pages is rendered.
             *
             * @example <caption>Example: changing the `config.classNames.elementPageStats` value</caption>
             *
             * // Change from the default value of 'page-stats' to 'pagination-info'
             *
             * var mixer = mixitup(containerEl, {
             *     classNames: {
             *         elementPageList: 'pagination-info'
             *     }
             * });
             *
             * // Disabled page-list output: "mixitup-pagination-info-disabled"
             *
             * @name        elementPageStats
             * @memberof    mixitup.Config.classNames
             * @instance
             * @type        {string}
             * @default     'page-stats'
             */ this.elementPageStats = "page-stats";
            /**
             * The "modifier" portion of the class name added to the first pager in the list of pager controls.
             *
             * @name        modifierFirst
             * @memberof    mixitup.Config.classNames
             * @instance
             * @type        {string}
             * @default     'first'
             */ this.modifierFirst = "first";
            /**
             * The "modifier" portion of the class name added to the last pager in the list of pager controls.
             *
             * @name        modifierLast
             * @memberof    mixitup.Config.classNames
             * @instance
             * @type        {string}
             * @default     'last'
             */ this.modifierLast = "last";
            /**
             * The "modifier" portion of the class name added to the previous pager in the list of pager controls.
             *
             * @name        modifierLast
             * @memberof    mixitup.Config.classNames
             * @instance
             * @type        {string}
             * @default     'prev'
             */ this.modifierPrev = "prev";
            /**
             * The "modifier" portion of the class name added to the next pager in the list of pager controls.
             *
             * @name        modifierNext
             * @memberof    mixitup.Config.classNames
             * @instance
             * @type        {string}
             * @default     'next'
             */ this.modifierNext = "next";
            /**
             * The "modifier" portion of the class name added to truncation markers in the list of pager controls.
             *
             * @name        modifierTruncationMarker
             * @memberof    mixitup.Config.classNames
             * @instance
             * @type        {string}
             * @default     'truncation-marker'
             */ this.modifierTruncationMarker = "truncation-marker";
        });
        /**
         * A group of properties defining the initial state of the mixer on load (instantiation).
         *
         * @constructor
         * @memberof    mixitup.Config
         * @name        load
         * @namespace
         * @public
         * @since       2.0.0
         */ mixitup.ConfigLoad.registerAction("afterConstruct", "pagination", function() {
            /**
             * An integer defining the starting page on load, if a page limit is active.
             *
             * @example <caption>Example: Defining a start page other than 1 to be applied on load</caption>
             *
             * // The mixer will show page 3 on load, with 8 items per page.
             *
             * var mixer = mixitup(containerEl, {
             *     pagination: {
             *         limit: 8
             *     },
             *     load: {
             *         page: 3
             *     }
             * });
             *
             * @name        page
             * @memberof    mixitup.Config.load
             * @instance
             * @type        {number}
             * @default     1
             */ this.page = 1;
        });
        /**
         * A group of properties defining the mixer's pagination behavior.
         *
         * @constructor
         * @memberof    mixitup.Config
         * @name        pagination
         * @namespace
         * @public
         * @since       2.0.0
         */ mixitup.ConfigPagination = function() {
            /**
             * A boolean dictating whether or not MixItUp should render a list of pager controls.
             *
             * If you wish to control pagination functionality via the API, or your own UI, this can be set to `false`.
             *
             * In order for this functionality to work, you must provide MixItUp with a `pageList`
             * element matching the selector defined in `selectors.pageList`. Pager controls will be
             * rendered inside this element as per the templates defined for the `templates.pager`
             * and related configuration options, or if set, a custom render
             * function supplied to the `render.pager` configuration option.
             *
             * @example <caption>Example: Disabling the rendering of the built-in "page list" UI</caption>
             *
             * var mixer = mixitup(containerEl, {
             *     pagination: {
             *         limit: 8,
             *         generatePageList: false
             *     }
             * });
             *
             * @name        generatePageList
             * @memberof    mixitup.Config.pagination
             * @instance
             * @type        {boolean}
             * @default     true
             */ this.generatePageList = true;
            /**
             * A boolean dictating whether or not MixItUp should render a stats about the
             * current page (e.g. "1 to 4 of 16").
             *
             * In order for this functionality to work, you must provide MixItUp with a `pageStats`
             * element matching the selector defined in `selectors.pageStats`. Page stats content will
             * be rendered inside this element as per the templates defined for the `templates.pageStats`
             * and `templates.pageStatsSingle` configuration options, or if set, a custom render
             * function supplied to the `render.pageStats` configuration option.
             *
             * @example <caption>Example: Disabling the rendering of the built-in "page stats" UI</caption>
             *
             * var mixer = mixitup(containerEl, {
             *     pagination: {
             *         limit: 8,
             *         generatePageStats: false
             *     }
             * });
             *
             * @name        generatePageStats
             * @memberof    mixitup.Config.pagination
             * @instance
             * @type        {boolean}
             * @default     true
             */ this.generatePageStats = true;
            /**
             * A boolean dictating whether or not to maintain the active page when switching
             * from filter to filter.
             *
             * By default, MixItUp will attempt to maintain the active page or its highest
             * equivalent in the new collection of matching targets (e.g. page 3 would become
             * page 2 if there are not enough targets in the new collection), but by setting
             * this option to `false`, changing the active filter will always cause the mixer
             * to revert to page one of the new collection.
             *
             * @example <caption>Example: Ensuring that the mixer reverts to page one when filtered</caption>
             *
             * var mixer = mixitup(containerEl, {
             *     pagination: {
             *         limit: 8,
             *         maintainActivePage: false
             *     }
             * });
             *
             * @name        maintainActivePage
             * @memberof    mixitup.Config.pagination
             * @instance
             * @type        {boolean}
             * @default     true
             */ this.maintainActivePage = true;
            /**
             * A boolean dictating whether or not to allow "looping" of the built-in previous
             * and next pagination controls.
             *
             * By default, when on the first page, the "previous" button will be disabled,
             * and when on the last page, the "next" button will be disabled. By setting
             * this option to `true`, the user may loop from the first to last page and
             * vice-versa.
             *
             * @example <caption>Example: Allowing prev/next controls to "loop" through pages</caption>
             *
             * var mixer = mixitup(containerEl, {
             *     pagination: {
             *         limit: 8,
             *         loop: true
             *     }
             * });
             *
             * @name        loop
             * @memberof    mixitup.Config.pagination
             * @instance
             * @type        {boolean}
             * @default     false
             */ this.loop = false;
            /**
             * A boolean dictating whether or not to prevent rendering of the built-in
             * "page list" UI if the matching collection of targets has only enough content
             * for one page.
             *
             * @example <caption>Example: Hiding the page list UI if only one page</caption>
             *
             * var mixer = mixitup(containerEl, {
             *     pagination: {
             *         limit: 8,
             *         hidePageListIfSinglePage: true
             *     }
             * });
             *
             * @name        hidePageListIfSinglePage
             * @memberof    mixitup.Config.pagination
             * @instance
             * @type        {boolean}
             * @default     false
             */ this.hidePageListIfSinglePage = false;
            /**
             * A boolean dictating whether or not to prevent rendering of the built-in
             * "page stats" UI if the matching collection of targets has only enough content
             * for one page.
             *
             * @example <caption>Example: Hiding the page stats UI if only one page</caption>
             *
             * var mixer = mixitup(containerEl, {
             *     pagination: {
             *         limit: 8,
             *         hidePageStatsIfSinglePage: true
             *     }
             * });
             *
             * @name        hidePageStatsIfSinglePage
             * @memberof    mixitup.Config.pagination
             * @instance
             * @type        {boolean}
             * @default     false
             */ this.hidePageStatsIfSinglePage = false;
            /**
             * A number defining the maximum number of items per page.
             *
             * By default, this is set to `-1` and pagination is effectively
             * disabled. By setting this to any number greater than 0, pagination
             * will be applied to the mixers targets, effectively activating the
             * extension.
             *
             * @example <caption>Example: Activating the pagination extension by defining a valid limit</caption>
             *
             * var mixer = mixitup(containerEl, {
             *     pagination: {
             *         limit: 8
             *     }
             * });
             *
             * @name        limit
             * @memberof    mixitup.Config.pagination
             * @instance
             * @type        {number}
             * @default     -1
             */ this.limit = -1;
            /**
             * A number dictating the maximum number of individual pager controls to render before
             * truncating the list (e.g. adding an ellipses between non-consecutive pagers).
             *
             * The minimum value permitted for this option is 5, which ensures
             * there will always be at least a first, last, and two padding pagers, in addition
             * to the pager representing the currently active page.
             *
             * @name        maxPagers
             * @memberof    mixitup.Config.pagination
             * @instance
             * @type        {number}
             * @default     5
             */ this.maxPagers = 5;
            h.seal(this);
        };
        /**
         * A group of optional render functions for creating and updating elements.
         *
         * @constructor
         * @memberof    mixitup.Config
         * @name        render
         * @namespace
         * @public
         * @since       3.0.0
         */ mixitup.ConfigRender.registerAction("afterConstruct", "pagination", function() {
            /**
             * A function returning an HTML string representing a single pager control element.
             *
             * By default, MixItUp will render pager controls using its own internal renderer
             * and templates (see `templates.pager`), but you may override this functionality by
             * providing your own render function here instead. All pager elements must have a
             * data-page element indicating the action of the control.
             *
             * The function receives an object containing all neccessary information
             * about the pager as its first parameter.
             *
             * @name        pager
             * @memberof    mixitup.Config.render
             * @instance
             * @type        {function}
             * @default     'null'
             */ this.pager = null;
            /**
             * A function returning an HTML string forming the contents of the "page stats" element.
             *
             * By default, MixItUp will render page stats using its own internal renderer
             * and templates (see `templates.pageStats`), but you may override this functionality by
             * providing your own render function here instead.
             *
             * The function receives an object containing all neccessary information
             * about the current page and total pages as its first parameter.
             *
             * @name        pageStats
             * @memberof    mixitup.Config.render
             * @instance
             * @type        {function}
             * @default     'null'
             */ this.pageStats = null;
        });
        /**
         * A group of properties defining the selectors used to query elements within a mixitup container.
         *
         * @constructor
         * @memberof    mixitup.Config
         * @name        selectors
         * @namespace
         * @public
         * @since       2.0.0
         */ mixitup.ConfigSelectors.registerAction("afterConstruct", "pagination", function() {
            /**
             * A selector string used to query the page list element.
             *
             * Depending on the value of `controls.scope`, MixItUp will either query the
             * entire document for the page list element, or just the container.
             *
             * @name        pageList
             * @memberof    mixitup.Config.selectors
             * @instance
             * @type        {string}
             * @default     '.mixitup-page-list'
             */ this.pageList = ".mixitup-page-list";
            /**
             * A selector string used to query the page stats element.
             *
             * Depending on the value of `controls.scope`, MixItUp will either query the
             * entire document for the page stats element, or just the container.
             *
             * @name        pageStats
             * @memberof    mixitup.Config.selectors
             * @instance
             * @type        {string}
             * @default     '.mixitup-page-stats'
             */ this.pageStats = ".mixitup-page-stats";
        });
        /**
         * A group of template strings used to render pager controls and page stats elements.
         *
         * @constructor
         * @memberof    mixitup.Config
         * @name        templates
         * @namespace
         * @public
         * @since       3.0.0
         */ mixitup.ConfigTemplates.registerAction("afterConstruct", "pagination", function() {
            /**
             * @name        pager
             * @memberof    mixitup.Config.templates
             * @instance
             * @type        {string}
             * @default     '<button type="button" class="${classNames}" data-page="${pageNumber}">${pageNumber}</button>'
             */ this.pager = '<button type="button" class="${classNames}" data-page="${pageNumber}">${pageNumber}</button>';
            /**
             * @name        pagerPrev
             * @memberof    mixitup.Config.templates
             * @instance
             * @type        {string}
             * @default     '<button type="button" class="${classNames}" data-page="prev">&laquo;</button>'
             */ this.pagerPrev = '<button type="button" class="${classNames}" data-page="prev">&laquo;</button>';
            /**
             * @name        pagerNext
             * @memberof    mixitup.Config.templates
             * @instance
             * @type        {string}
             * @default     '<button type="button" class="${classNames}" data-page="next">&raquo;</button>'
             */ this.pagerNext = '<button type="button" class="${classNames}" data-page="next">&raquo;</button>';
            /**
             * @name        pagerTruncationMarker
             * @memberof    mixitup.Config.templates
             * @instance
             * @type        {string}
             * @default     '<span class="${classNames}">&hellip;</span>'
             */ this.pagerTruncationMarker = '<span class="${classNames}">&hellip;</span>';
            /**
             * @name        pageStats
             * @memberof    mixitup.Config.templates
             * @instance
             * @type        {string}
             * @default     '${startPageAt} to ${endPageAt} of ${totalTargets}'
             */ this.pageStats = "${startPageAt} to ${endPageAt} of ${totalTargets}";
            /**
             * @name        pageStatsSingle
             * @memberof    mixitup.Config.templates
             * @instance
             * @type        {string}
             * @default     '${startPageAt} of ${totalTargets}'
             */ this.pageStatsSingle = "${startPageAt} of ${totalTargets}";
            /**
             * @name        pageStatsFail
             * @memberof    mixitup.Config.templates
             * @instance
             * @type        {string}
             * @default     'None found'
             */ this.pageStatsFail = "None found";
        });
        /**
         * The MixItUp configuration object is extended with the following properties
         * relating to the Pagination extension.
         *
         * For the full list of configuration options, please refer to the MixItUp
         * core documentation.
         *
         * @constructor
         * @memberof    mixitup
         * @name        Config
         * @namespace
         * @public
         * @since       2.0.0
         */ mixitup.Config.registerAction("beforeConstruct", "pagination", function() {
            this.pagination = new mixitup.ConfigPagination();
        });
        mixitup.ModelPager = function() {
            this.pageNumber = -1;
            this.classNames = "";
            this.classList = [];
            this.isDisabled = false;
            this.isPrev = false;
            this.isNext = false;
            this.isPageLink = false;
            this.isTruncationMarker = false;
            h.seal(this);
        };
        mixitup.ModelPageStats = function() {
            this.startPageAt = -1;
            this.endPageAt = -1;
            this.totalTargets = -1;
            h.seal(this);
        };
        mixitup.UiClassNames.registerAction("afterConstruct", "pagination", function() {
            this.first = "";
            this.last = "";
            this.prev = "";
            this.next = "";
            this.first = "";
            this.last = "";
            this.truncated = "";
            this.truncationMarker = "";
        });
        mixitup.controlDefinitions.push(new mixitup.ControlDefinition("pager", "[data-page]", true, "pageListEls"));
        /**
         * @param   {mixitup.MultimixCommand[]} commands
         * @param   {ClickEvent}                e
         * @return  {object|null}
         */ mixitup.Control.registerFilter("commandsHandleClick", "pagination", function(commands, e) {
            var self = this, command = {}, page = "", pageNumber = -1, mixer = null, button = null, i = -1;
            if (!self.selector || self.selector !== "[data-page]") // Static control or non-pager live control
            return commands;
            button = h.closestParent(e.target, self.selector, true, self.bound[0].dom.document);
            for(i = 0; mixer = self.bound[i]; i++){
                command = commands[i];
                if (!mixer.config.pagination || mixer.config.pagination.limit < 0 || mixer.config.pagination.limit === Infinity) {
                    // Pagination is disabled for this instance. Do not handle.
                    commands[i] = null;
                    continue;
                }
                if (!button || h.hasClass(button, mixer.classNamesPager.active) || h.hasClass(button, mixer.classNamesPager.disabled)) {
                    // No button was clicked or button is already active. Do not handle.
                    commands[i] = null;
                    continue;
                }
                page = button.getAttribute("data-page");
                if (page === "prev") command.paginate = "prev";
                else if (page === "next") command.paginate = "next";
                else if (pageNumber) command.paginate = parseInt(page);
                if (mixer.lastClicked) mixer.lastClicked = button;
            }
            return commands;
        });
        mixitup.CommandMultimix.registerAction("afterConstruct", "pagination", function() {
            this.paginate = null;
        });
        /**
         * @constructor
         * @memberof    mixitup
         * @private
         * @since       3.0.0
         */ mixitup.CommandPaginate = function() {
            this.page = -1;
            this.limit = -1;
            this.action = ""; // enum: ['prev', 'next']
            this.anchor = null;
            h.seal(this);
        };
        mixitup.Events.registerAction("afterConstruct", "pagination", function() {
            /**
             * A custom event triggered whenever a pagination operation starts.
             *
             * @name        paginateStart
             * @memberof    mixitup.Events
             * @static
             * @type        {CustomEvent}
             */ this.paginateStart = null;
            /**
             * A custom event triggered whenever a pagination operation ends.
             *
             * @name        paginateEnd
             * @memberof    mixitup.Events
             * @static
             * @type        {CustomEvent}
             */ this.paginateEnd = null;
        });
        mixitup.events = new mixitup.Events();
        mixitup.Operation.registerAction("afterConstruct", "pagination", function() {
            this.startPagination = null;
            this.newPagination = null;
            this.startTotalPages = -1;
            this.newTotalPages = -1;
        });
        /**
         * `mixitup.State` objects expose various pieces of data detailing the state of
         * a MixItUp instance. They are provided at the start and end of any operation via
         * callbacks and events, with the most recent state stored between operations
         * for retrieval at any time via the API.
         *
         * @constructor
         * @namespace
         * @name        State
         * @memberof    mixitup
         * @public
         * @since       3.0.0
         */ mixitup.State.registerAction("afterConstruct", "pagination", function() {
            /**
             * The currently active pagination command as set by a control click or API call.
             *
             * @name        activePagination
             * @memberof    mixitup.State
             * @instance
             * @type        {mixitup.CommandPagination}
             * @default     null
             */ this.activePagination = null;
            /**
             * The total number of pages produced as a combination of the current page
             * limit and active filter.
             *
             * @name        totalPages
             * @memberof    mixitup.State
             * @instance
             * @type        {number}
             * @default     -1
             */ this.totalPages = -1;
        });
        mixitup.MixerDom.registerAction("afterConstruct", "pagination", function() {
            this.pageListEls = [];
            this.pageStatsEls = [];
        });
        /**
         * The mixitup.Mixer class is extended with the following methods relating to
         * the Pagination extension.
         *
         * For the full list of methods, please refer to the MixItUp core documentation.
         *
         * @constructor
         * @namespace
         * @name        Mixer
         * @memberof    mixitup
         * @public
         * @since       3.0.0
         */ mixitup.Mixer.registerAction("afterConstruct", "pagination", function() {
            this.classNamesPager = new mixitup.UiClassNames();
            this.classNamesPageList = new mixitup.UiClassNames();
            this.classNamesPageStats = new mixitup.UiClassNames();
        });
        /**
         * @private
         * @return  {void}
         */ mixitup.Mixer.registerAction("afterAttach", "pagination", function() {
            var self = this, el = null, i = -1;
            if (self.config.pagination.limit < 0) return;
            // Map pagination ui classNames
            // jscs:disable
            self.classNamesPager.base = h.getClassname(self.config.classNames, "pager");
            self.classNamesPager.active = h.getClassname(self.config.classNames, "pager", self.config.classNames.modifierActive);
            self.classNamesPager.disabled = h.getClassname(self.config.classNames, "pager", self.config.classNames.modifierDisabled);
            self.classNamesPager.first = h.getClassname(self.config.classNames, "pager", self.config.classNames.modifierFirst);
            self.classNamesPager.last = h.getClassname(self.config.classNames, "pager", self.config.classNames.modifierLast);
            self.classNamesPager.prev = h.getClassname(self.config.classNames, "pager", self.config.classNames.modifierPrev);
            self.classNamesPager.next = h.getClassname(self.config.classNames, "pager", self.config.classNames.modifierNext);
            self.classNamesPager.truncationMarker = h.getClassname(self.config.classNames, "pager", self.config.classNames.modifierTruncationMarker);
            self.classNamesPageList.base = h.getClassname(self.config.classNames, "page-list");
            self.classNamesPageList.disabled = h.getClassname(self.config.classNames, "page-list", self.config.classNames.modifierDisabled);
            self.classNamesPageStats.base = h.getClassname(self.config.classNames, "page-stats");
            self.classNamesPageStats.disabled = h.getClassname(self.config.classNames, "page-stats", self.config.classNames.modifierDisabled);
            // jscs:enable
            if (self.config.pagination.generatePageList && self.dom.pageListEls.length > 0) for(i = 0; el = self.dom.pageListEls[i]; i++)self.renderPageListEl(el, self.lastOperation);
            if (self.config.pagination.generatePageStats && self.dom.pageStatsEls.length > 0) for(i = 0; el = self.dom.pageStatsEls[i]; i++)self.renderPageStatsEl(el, self.lastOperation);
        });
        mixitup.Mixer.registerAction("afterSanitizeConfig", "pagination", function() {
            var self = this, onMixStart = self.config.callbacks.onMixStart, onMixEnd = self.config.callbacks.onMixEnd, onPaginateStart = self.config.callbacks.onPaginateStart, onPaginateEnd = self.config.callbacks.onPaginateEnd, didPaginate = false;
            if (self.config.pagination.limit < 0) return;
            self.classNamesPager = new mixitup.UiClassNames();
            self.classNamesPageList = new mixitup.UiClassNames();
            self.classNamesPageStats = new mixitup.UiClassNames();
            self.config.callbacks.onMixStart = function(prevState, nextState) {
                if (prevState.activePagination.limit !== nextState.activePagination.limit || prevState.activePagination.page !== nextState.activePagination.page) didPaginate = true;
                if (typeof onMixStart === "function") onMixStart.apply(self.dom.container, arguments);
                if (!didPaginate) return;
                mixitup.events.fire("paginateStart", self.dom.container, {
                    state: prevState,
                    futureState: nextState,
                    instance: self
                }, self.dom.document);
                if (typeof onPaginateStart === "function") onPaginateStart.apply(self.dom.container, arguments);
            };
            self.config.callbacks.onMixEnd = function(state) {
                if (typeof onMixEnd === "function") onMixEnd.apply(self.dom.container, arguments);
                if (!didPaginate) return;
                didPaginate = false;
                mixitup.events.fire("paginateEnd", self.dom.container, {
                    state: state,
                    instance: self
                }, self.dom.document);
                if (typeof onPaginateEnd === "function") onPaginateEnd.apply(self.dom.container, arguments);
            };
        });
        /**
         * @private
         * @param   {mixitup.Operation} operation
         * @param   {mixitup.State}     state
         * @return  {mixitup.Operation}
         */ mixitup.Mixer.registerFilter("operationGetInitialState", "pagination", function(operation, state) {
            var self = this;
            if (self.config.pagination.limit < 0) return operation;
            operation.newPagination = state.activePagination;
            return operation;
        });
        /**
         * @private
         * @param   {mixitup.State} state
         * @return  {mixitup.State}
         */ mixitup.Mixer.registerFilter("stateGetInitialState", "pagination", function(state) {
            var self = this;
            if (self.config.pagination.limit < 0) return state;
            state.activePagination = new mixitup.CommandPaginate();
            state.activePagination.page = self.config.load.page;
            state.activePagination.limit = self.config.pagination.limit;
            return state;
        });
        /**
         * @private
         * @return  {void}
         */ mixitup.Mixer.registerAction("afterGetFinalMixData", "pagination", function() {
            var self = this;
            if (self.config.pagination.limit < 0) return;
            if (typeof self.config.pagination.maxPagers === "number") // Restrict max pagers to a minimum of 5. There must always
            // be a first, last, and one on either side of the active pager.
            // e.g. « 1 ... 4 5 6 ... 10 »
            self.config.pagination.maxPagers = Math.max(5, self.config.pagination.maxPagers);
        });
        /**
         * @private
         * @return  {void}
         */ mixitup.Mixer.registerAction("afterCacheDom", "pagination", function() {
            var self = this, parent = null;
            if (self.config.pagination.limit < 0) return;
            if (!self.config.pagination.generatePageList) return;
            switch(self.config.controls.scope){
                case "local":
                    parent = self.dom.container;
                    break;
                case "global":
                    parent = self.dom.document;
                    break;
                default:
                    throw new Error(mixitup.messages.ERROR_CONFIG_INVALID_CONTROLS_SCOPE);
            }
            self.dom.pageListEls = parent.querySelectorAll(self.config.selectors.pageList);
            self.dom.pageStatsEls = parent.querySelectorAll(self.config.selectors.pageStats);
        });
        /**
         * @private
         * @param   {mixitup.State}     state
         * @param   {mixitup.Operation} operation
         * @return  {mixitup.State}
         */ mixitup.Mixer.registerFilter("stateBuildState", "pagination", function(state, operation) {
            var self = this;
            if (self.config.pagination.limit < 0) return state;
            // Map pagination-specific properties into state
            state.activePagination = operation.newPagination;
            state.totalPages = operation.newTotalPages;
            return state;
        });
        /**
         * @private
         * @param   {mixitup.UserInstruction}     instruction
         * @return  {mixitup.UserInstruction}
         */ mixitup.Mixer.registerFilter("instructionParseMultimixArgs", "pagination", function(instruction) {
            var self = this;
            if (self.config.pagination.limit < 0) return instruction;
            if (instruction.command.paginate && !(instruction.command.paginate instanceof mixitup.CommandPaginate)) instruction.command.paginate = self.parsePaginateArgs([
                instruction.command.paginate
            ]).command;
            return instruction;
        });
        /**
         * @private
         * @param   {mixitup.Operation} operation
         * @return  {void}
         */ mixitup.Mixer.registerAction("afterFilterOperation", "pagination", function(operation) {
            var self = this, startPageAt = -1, endPageAt = -1, inPage = [], notInPage = [], target = null, index = -1, i = -1;
            if (self.config.pagination.limit < 0) return;
            // Calculate the new total pages as a matter of course (i.e. a change in filter)
            // New matching array has already been set at this point
            operation.newTotalPages = operation.newPagination.limit ? Math.max(Math.ceil(operation.matching.length / operation.newPagination.limit), 1) : 1;
            if (self.config.pagination.maintainActivePage) operation.newPagination.page = operation.newPagination.page > operation.newTotalPages ? operation.newTotalPages : operation.newPagination.page;
            // Keep config in sync with latest limit
            self.config.pagination.limit = operation.newPagination.limit;
            if (operation.newPagination.anchor) {
                // Start page at an anchor element
                for(i = 0; target = operation.matching[i]; i++){
                    if (target.dom.el === operation.newPagination.anchor) break;
                }
                startPageAt = i;
                endPageAt = i + operation.newPagination.limit - 1;
            } else {
                // Start page based on limit and page index
                startPageAt = operation.newPagination.limit * (operation.newPagination.page - 1);
                endPageAt = operation.newPagination.limit * operation.newPagination.page - 1;
                if (isNaN(startPageAt)) startPageAt = 0;
            }
            if (operation.newPagination.limit < 0) return;
            for(i = 0; target = operation.show[i]; i++)// For each target in `show`, include in page, only if within the range
            if (i >= startPageAt && i <= endPageAt) inPage.push(target);
            else // Else move to `notInPage`
            notInPage.push(target);
            // override the operation's `show` array with the newly constructed `inPage` array
            operation.show = inPage;
            // For anything not in the page, make sure it is correctly assigned:
            for(i = 0; target = operation.toHide[i]; i++)// For example, if a target would normally be included in `toHide`, but is
            // now already hidden as not in the page, make sure it is removed from `toHide`
            // so it is not included in the operation.
            if (!target.isShown) {
                operation.toHide.splice(i, 1);
                target.isShown = false;
                i--;
            }
            for(i = 0; target = notInPage[i]; i++){
                // For each target not in page, move into `hide`
                operation.hide.push(target);
                if ((index = operation.toShow.indexOf(target)) > -1) // Any targets due to be shown will no longer be shown
                operation.toShow.splice(index, 1);
                if (target.isShown) // If currently shown, move to `toHide`
                operation.toHide.push(target);
            }
        });
        /**
         * @private
         * @param   {mixitup.Operation}         operation
         * @param   {mixitup.CommandMultimix}   command
         * @return  {mixitup.Operation}
         */ mixitup.Mixer.registerFilter("operationUnmappedGetOperation", "pagination", function(operation, command) {
            var self = this;
            if (self.config.pagination.limit < 0) return operation;
            operation.startState = self.state;
            operation.startPagination = self.state.activePagination;
            operation.startTotalPages = self.state.totalPages;
            operation.newPagination = new mixitup.CommandPaginate();
            operation.newPagination.limit = operation.startPagination.limit;
            operation.newPagination.page = operation.startPagination.page;
            if (command.paginate) self.parsePaginateCommand(command.paginate, operation);
            else if (command.filter || command.sort) {
                h.extend(operation.newPagination, operation.startPagination);
                // Reset to 1, or maintain active:
                if (!self.config.pagination.maintainActivePage) operation.newPagination.page = 1;
                else operation.newPagination.page = self.state.activePagination.page;
            }
            return operation;
        });
        /**
         * @private
         * @param   {mixitup.Operation} operation
         * @param   {object}            command
         * @param   {boolean}           [isPreFetch=false]
         * @return  {mixitup.Operation}
         */ mixitup.Mixer.registerFilter("operationMappedGetOperation", "pagination", function(operation, command, isPreFetch) {
            var self = this, el = null, i = -1;
            if (self.config.pagination.limit < 0) return operation;
            if (isPreFetch) // The operation is being pre-fetched, so don't update the pagers or stats yet.
            return operation;
            if (self.config.pagination.generatePageList && self.dom.pageListEls.length > 0) for(i = 0; el = self.dom.pageListEls[i]; i++)self.renderPageListEl(el, operation);
            if (self.config.pagination.generatePageStats && self.dom.pageStatsEls.length > 0) for(i = 0; el = self.dom.pageStatsEls[i]; i++)self.renderPageStatsEl(el, operation);
            return operation;
        });
        mixitup.Mixer.extend(/** @lends mixitup.Mixer */ {
            /**
             * @private
             * @param   {mixitup.CommandPaginate}   command
             * @param   {mixitup.Operation}         operation
             * @return  {void}
             */ parsePaginateCommand: function(command, operation) {
                var self = this;
                // e.g. mixer.paginate({page: 3, limit: 2});
                // e.g. mixer.paginate({action: 'next'});
                // e.g. mixer.paginate({anchor: anchorTarget, limit: 5});
                if (command.page > -1) {
                    if (command.page === 0) throw new Error(mixitup.messages.ERROR_PAGINATE_INDEX_RANGE);
                    // TODO: replace Infinity with the highest possible page index
                    operation.newPagination.page = Math.max(1, Math.min(Infinity, command.page));
                } else if (command.action === "next") operation.newPagination.page = self.getNextPage();
                else if (command.action === "prev") operation.newPagination.page = self.getPrevPage();
                else if (command.anchor) operation.newPagination.anchor = command.anchor;
                if (command.limit > -1) operation.newPagination.limit = command.limit;
                if (operation.newPagination.limit !== operation.startPagination.limit) // A new limit has been sent via the API, calculate total pages
                operation.newTotalPages = operation.newPagination.limit ? Math.max(Math.ceil(operation.startState.matching.length / operation.newPagination.limit), 1) : 1;
                if (operation.newPagination.limit <= 0 || operation.newPagination.limit === Infinity) operation.newPagination.page = 1;
            },
            /**
             * @private
             * @return  {number}    page
             */ getNextPage: function() {
                var self = this, page = -1;
                page = self.state.activePagination.page + 1;
                if (page > self.state.totalPages) page = self.config.pagination.loop ? 1 : self.state.activePagination.page;
                return page;
            },
            /**
             * @private
             * @return  {Number}    page
             */ getPrevPage: function() {
                var self = this, page = -1;
                page = self.state.activePagination.page - 1;
                if (page < 1) page = self.config.pagination.loop ? self.state.totalPages : self.state.activePagination.page;
                return page;
            },
            /**
             * @private
             * @param   {HTMLElement}        pageListEl
             * @param   {mixitup.Operation}  operation
             * @return  {void}
             */ renderPageListEl: function(pageListEl, operation) {
                var self = this, activeIndex = -1, pagerHtml = "", buttonList = [], model = null, renderer = null, allowedIndices = [], truncatedBefore = false, truncatedAfter = false, disabled = null, el = null, html = "", i = -1;
                if (operation.newPagination.limit < 0 || operation.newPagination.limit === Infinity || operation.newTotalPages < 2 && self.config.pagination.hidePageListIfSinglePage) {
                    // Empty the pager list, and add disabled class
                    pageListEl.innerHTML = "";
                    h.addClass(pageListEl, self.classNamesPageList.disabled);
                    return;
                }
                activeIndex = operation.newPagination.page - 1;
                renderer = typeof (renderer = self.config.render.pager) === "function" ? renderer : null;
                if (self.config.pagination.maxPagers < Infinity && operation.newTotalPages > self.config.pagination.maxPagers) allowedIndices = self.getAllowedIndices(operation);
                // Render prev button
                model = new mixitup.ModelPager();
                model.isPrev = true;
                model.classList.push(self.classNamesPager.base, self.classNamesPager.prev);
                // If first and not looping, disable the prev button
                if (operation.newPagination.page === 1 && !self.config.pagination.loop) {
                    model.classList.push(self.classNamesPager.disabled);
                    model.isDisabled = true;
                }
                model.classNames = model.classList.join(" ");
                if (renderer) pagerHtml = renderer(model);
                else pagerHtml = h.template(self.config.templates.pagerPrev)(model);
                buttonList.push(pagerHtml);
                // Render per-page pagers
                for(i = 0; i < operation.newTotalPages; i++){
                    pagerHtml = self.renderPager(i, operation, allowedIndices);
                    if (pagerHtml || i < activeIndex && truncatedBefore || i > activeIndex && truncatedAfter) {
                        if (pagerHtml) buttonList.push(pagerHtml);
                        continue;
                    }
                    // Replace gaps between pagers with a truncation maker, but only once
                    model = new mixitup.ModelPager();
                    model.isTruncationMarker = true;
                    model.classList.push(self.classNamesPager.base, self.classNamesPager.truncationMarker);
                    model.classNames = model.classList.join(" ");
                    if (renderer) pagerHtml = renderer(model);
                    else pagerHtml = h.template(self.config.templates.pagerTruncationMarker)(model);
                    buttonList.push(pagerHtml);
                    // Prevent multiple truncation markers
                    if (i < activeIndex) truncatedBefore = true;
                    if (i > activeIndex) truncatedAfter = true;
                }
                // Render next button
                model = new mixitup.ModelPager();
                model.isNext = true;
                model.classList.push(self.classNamesPager.base, self.classNamesPager.next);
                // If last page and not looping, disable the next button
                if (operation.newPagination.page === operation.newTotalPages && !self.config.pagination.loop) model.classList.push(self.classNamesPager.disabled);
                model.classNames = model.classList.join(" ");
                if (renderer) pagerHtml = renderer(model);
                else pagerHtml = h.template(self.config.templates.pagerNext)(model);
                buttonList.push(pagerHtml);
                // Replace markup
                html = buttonList.join(" ");
                pageListEl.innerHTML = html;
                // Add disabled attribute to disabled buttons
                disabled = pageListEl.querySelectorAll("." + self.classNamesPager.disabled);
                for(i = 0; el = disabled[i]; i++)if (typeof el.disabled === "boolean") el.disabled = true;
                if (truncatedBefore || truncatedAfter) h.addClass(pageListEl, self.classNamesPageList.truncated);
                else h.removeClass(pageListEl, self.classNamesPageList.truncated);
                if (operation.newTotalPages > 1) h.removeClass(pageListEl, self.classNamesPageList.disabled);
                else h.addClass(pageListEl, self.classNamesPageList.disabled);
            },
            /**
             * An algorithm defining which pagers should be rendered based on their index
             * and the current active page, when a `pagination.maxPagers` value is applied.
             *
             * @private
             * @param   {mixitup.Operation} operation
             * @return  {number[]}
             */ getAllowedIndices: function(operation) {
                var self = this, activeIndex = operation.newPagination.page - 1, lastIndex = operation.newTotalPages - 1, indices = [], paddingRange = -1, paddingBack = -1, paddingFront = -1, paddingRangeStart = -1, paddingRangeEnd = -1, paddingRangeOffset = -1, i = -1;
                // Examples:
                // « 1 2 *3* 4 5 »                  maxPagers = 5
                // « 1 ... 4 *5* 6 ... 10 »         maxPagers = 5
                // « 1 ... 6 7 *8* 9 10 »           maxPagers = 6
                // « 1 ... 3 4 *5* 6 ... 10 »       maxPagers = 6
                // « 1 ... 3 4 *5* 6 7 ... 10 »     maxPagers = 7
                // « *1* 2 3 4 5 6 ... 10 »         maxPagers = 7
                // This algorithm ensures that at any time, the active pager
                // should be surrounded by as many "padding" pagers as possible to equal the
                // value of `pagination.maxPagers`, accounting for the fact the first and last
                // pager should also always be rendered.
                // Push in index 0 to represent the first pager
                indices.push(0);
                // Calculate the "padding range" by subtracting 2 from `pagination.maxPagers`
                paddingRange = self.config.pagination.maxPagers - 2;
                // Distribute the padding equally behind and in front of the active pager.
                // If the padding range is an even number, we allow an extra pager behind the active pager.
                paddingBack = Math.ceil((paddingRange - 1) / 2);
                paddingFront = Math.floor((paddingRange - 1) / 2);
                // Calculate where the range should start and finish based on the active index
                paddingRangeStart = activeIndex - paddingBack;
                paddingRangeEnd = activeIndex + paddingFront;
                // Set the offset to 0
                paddingRangeOffset = 0;
                // If the start of the range has collided with the first pager, positively offset as needed
                if (paddingRangeStart < 1) paddingRangeOffset = 1 - paddingRangeStart;
                // If the end of the range has collided with the last pager, negatively offset as needed
                if (paddingRangeEnd > lastIndex - 1) paddingRangeOffset = lastIndex - 1 - paddingRangeEnd;
                // Calcuate the first index of the range taking into account any offset
                i = paddingRangeStart + paddingRangeOffset;
                // Iteratate through the range, adding the respective indices:
                while(paddingRange){
                    indices.push(i);
                    i++;
                    paddingRange--;
                }
                indices.push(lastIndex);
                return indices;
            },
            /**
             * Renderes individual, per-page pagers.
             *
             * @private
             * @param   {number}              i
             * @param   {mixitup.Operation}   operation
             * @param   {number[]}            [allowedIndices]
             * @return  {string}
             */ renderPager: function(i, operation, allowedIndices) {
                var self = this, renderer = null, activePage = operation.newPagination.page - 1, model = new mixitup.ModelPager(), output = "";
                if (self.config.pagination.maxPagers < Infinity && allowedIndices.length && allowedIndices.indexOf(i) < 0) // maxPagers is set, and this pager is not in the allowed range
                return "";
                renderer = typeof (renderer = self.config.render.pager) === "function" ? renderer : null;
                model.isPageLink = true;
                model.classList.push(self.classNamesPager.base);
                if (i === 0) model.classList.push(self.classNamesPager.first);
                if (i === operation.newTotalPages - 1) model.classList.push(self.classNamesPager.last);
                if (i === activePage) model.classList.push(self.classNamesPager.active);
                model.classNames = model.classList.join(" ");
                model.pageNumber = i + 1;
                if (renderer) output = renderer(model);
                else output = h.template(self.config.templates.pager)(model);
                return output;
            },
            /**
             * @private
             * @param   {HTMLElement}       pageStatsEl
             * @param   {mixitup.Operation} operation
             * @return  {void}
             */ renderPageStatsEl: function(pageStatsEl, operation) {
                var self = this, model = new mixitup.ModelPageStats(), renderer = null, output = "", template = "";
                if (operation.newPagination.limit < 0 || operation.newPagination.limit === Infinity || operation.newTotalPages < 2 && self.config.pagination.hidePageStatsIfSinglePage) {
                    // Empty the pager list, and add disabled class
                    pageStatsEl.innerHTML = "";
                    h.addClass(pageStatsEl, self.classNamesPageStats.disabled);
                    return;
                }
                renderer = typeof (renderer = self.config.render.pageStats) === "function" ? renderer : null;
                model.totalTargets = operation.matching.length;
                if (model.totalTargets) template = operation.newPagination.limit === 1 ? self.config.templates.pageStatsSingle : self.config.templates.pageStats;
                else template = self.config.templates.pageStatsFail;
                if (model.totalTargets && operation.newPagination.limit > 0) {
                    model.startPageAt = (operation.newPagination.page - 1) * operation.newPagination.limit + 1;
                    model.endPageAt = Math.min(model.startPageAt + operation.newPagination.limit - 1, model.totalTargets);
                } else model.startPageAt = model.endPageAt = 0;
                if (renderer) output = renderer(model);
                else output = h.template(template)(model);
                pageStatsEl.innerHTML = output;
                if (model.totalTargets) h.removeClass(pageStatsEl, self.classNamesPageStats.disabled);
                else h.addClass(pageStatsEl, self.classNamesPageStats.disabled);
            },
            /**
             * @private
             * @param   {Array<*>}                  args
             * @return  {mixitup.UserInstruction}   instruction
             */ parsePaginateArgs: function(args) {
                var self = this, instruction = new mixitup.UserInstruction(), arg = null, i = -1;
                instruction.animate = self.config.animation.enable;
                instruction.command = new mixitup.CommandPaginate();
                for(i = 0; i < args.length; i++){
                    arg = args[i];
                    if (arg === null) continue;
                    if (typeof arg === "object" && h.isElement(arg, self.dom.document)) instruction.command.anchor = arg;
                    else if (arg instanceof mixitup.CommandPaginate || typeof arg === "object") h.extend(instruction.command, arg);
                    else if (typeof arg === "number") instruction.command.page = arg;
                    else if (typeof arg === "string" && !isNaN(parseInt(arg))) // e.g. "4"
                    instruction.command.page = parseInt(arg);
                    else if (typeof arg === "string") instruction.command.action = arg;
                    else if (typeof arg === "boolean") instruction.animate = arg;
                    else if (typeof arg === "function") instruction.callback = arg;
                }
                h.freeze(instruction);
                // NB: Don't freeze command as may need to be sanitized later by other methods
                return instruction;
            },
            /**
             * Changes the current page and/or the current page limit.
             *
             * @example
             *
             * .paginate(page [, animate] [, callback])
             *
             * @example <caption>Example 1: Changing the active page</caption>
             *
             * console.log(mixer.getState().activePagination.page); // 1
             *
             * mixer.paginate(2)
             *     .then(function(state) {
             *         console.log(mixer.getState().activePagination.page === 2); // true
             *     });
             *
             * @example <caption>Example 2: Progressing to the next page</caption>
             *
             * console.log(mixer.getState().activePagination.page); // 1
             *
             * mixer.paginate('next')
             *     .then(function(state) {
             *         console.log(mixer.getState().activePagination.page === 2); // true
             *     });
             *
             * @example <caption>Example 3: Starting a page from an abitrary "anchor" element</caption>
             *
             * var anchorEl = mixer.getState().show[3];
             *
             * mixer.paginate(anchorEl)
             *     .then(function(state) {
             *         console.log(mixer.getState().activePagination.anchor === anchorEl); // true
             *         console.log(mixer.getState().show[0] === anchorEl); // true
             *     });
             *
             * @example <caption>Example 4: Changing the page limit</caption>
             *
             * var anchorEl = mixer.getState().show[3];
             *
             * console.log(mixer.getState().activePagination.limit); // 8
             *
             * mixer.paginate({
             *    limit: 4
             * })
             *     .then(function(state) {
             *         console.log(mixer.getState().activePagination.limit === 4); // true
             *     });
             *
             * @example <caption>Example 5: Changing the active page and page limit</caption>
             *
             * mixer.paginate({
             *    limit: 4,
             *    page: 2
             * })
             *     .then(function(state) {
             *         console.log(mixer.getState().activePagination.page === 2); // true
             *         console.log(mixer.getState().activePagination.limit === 4); // true
             *     });
             *
             * @public
             * @instance
             * @param       {(number|string|object|HTMLElement)}    page
             *     A page number, string (`'next'`, `'prev'`), HTML element reference, or command object.
             * @param       {boolean}   [animate=true]
             *      An optional boolean dictating whether the operation should animate, or occur syncronously with no animation. `true` by default.
             * @param       {function}  [callback=null]
             *      An optional callback function to be invoked after the operation has completed.
             * @return      {Promise.<mixitup.State>}
             *     A promise resolving with the current state object.
             */ paginate: function() {
                var self = this, instruction = self.parsePaginateArgs(arguments);
                return self.multimix({
                    paginate: instruction.command
                }, instruction.animate, instruction.callback);
            },
            /**
             * A shorthand for `.paginate('next')`. Moves to the next page.
             *
             * @example
             *
             * .nextPage()
             *
             * @example <caption>Example: Moving to the next page</caption>
             *
             * console.log(mixer.getState().activePagination.page); // 1
             *
             * mixer.nextPage()
             *     .then(function(state) {
             *         console.log(mixer.getState().activePagination.page === 2); // true
             *     });
             *
             * @public
             * @instance
             * @return      {Promise.<mixitup.State>}
             *     A promise resolving with the current state object.
             */ nextPage: function() {
                var self = this, instruction = self.parsePaginateArgs(arguments);
                return self.multimix({
                    paginate: {
                        action: "next"
                    }
                }, instruction.animate, instruction.callback);
            },
            /**
             * A shorthand for `.paginate('prev')`. Moves to the previous page.
             *
             * @example
             *
             * .prevPage()
             *
             * @example <caption>Example: Moving to the previous page</caption>
             *
             * console.log(mixer.getState().activePagination.page); // 5
             *
             * mixer.prevPage()
             *     .then(function(state) {
             *         console.log(mixer.getState().activePagination.page === 4); // true
             *     });
             *
             * @public
             * @instance
             * @return      {Promise.<mixitup.State>}
             *     A promise resolving with the current state object.
             */ prevPage: function() {
                var self = this, instruction = self.parsePaginateArgs(arguments);
                return self.multimix({
                    paginate: {
                        action: "prev"
                    }
                }, instruction.animate, instruction.callback);
            }
        });
        mixitup.Facade.registerAction("afterConstruct", "pagination", function(mixer) {
            this.paginate = mixer.paginate.bind(mixer);
            this.nextPage = mixer.nextPage.bind(mixer);
            this.prevPage = mixer.prevPage.bind(mixer);
        });
    };
    mixitupPagination.TYPE = "mixitup-extension";
    mixitupPagination.NAME = "mixitup-pagination";
    mixitupPagination.EXTENSION_VERSION = "3.3.2";
    mixitupPagination.REQUIRE_CORE_VERSION = "^3.1.8";
    $b5abcff591ac2127$exports = mixitupPagination;
})(window);


(0, (/*@__PURE__*/$parcel$interopDefault($2937ea0c96f7acc8$exports))).use((0, (/*@__PURE__*/$parcel$interopDefault($b5abcff591ac2127$exports))));
class $a24a10d549e9a0b4$export$2e2bcd8739ae039 {
    bindEvents() {
        window.addEventListener("resize", app.debounce(()=>{
            this.mix.paginate({
                limit: this.getLimit()
            });
        }));
    }
    init() {
        this.mix = (0, (/*@__PURE__*/$parcel$interopDefault($2937ea0c96f7acc8$exports)))(this._mix, {
            controls: {
                scope: "local"
            },
            pagination: {
                limit: this.getLimit(),
                hidePageListIfSinglePage: true
            }
        });
    }
    getLimit() {
        if (window.matchMedia("(max-width:576px").matches) return 1;
        if (window.matchMedia("(max-width:1200px").matches) return 2;
        if (window.matchMedia("(max-width:1400px").matches) return 3;
        return 4;
    }
    constructor(element){
        this._wrapper = element;
        this._mix = this._wrapper.querySelector(".js-front-pagination-mix");
        this.init();
        this.bindEvents();
    }
}


/**
 * MicroEvent - to make any js object an event emitter
 *
 * - pure javascript - server compatible, browser compatible
 * - dont rely on the browser doms
 * - super simple - you get it immediatly, no mistery, no magic involved
 *
 * @author Jerome Etienne (https://github.com/jeromeetienne)
 */ /**
 * Execute callback for each event in space separated list of event names
 *
 */ function $2a55e105345981df$var$forEvents(events, callback) {
    events.split(/\s+/).forEach((event)=>{
        callback(event);
    });
}
class $2a55e105345981df$export$2e2bcd8739ae039 {
    on(events, fct) {
        $2a55e105345981df$var$forEvents(events, (event)=>{
            const event_array = this._events[event] || [];
            event_array.push(fct);
            this._events[event] = event_array;
        });
    }
    off(events, fct) {
        var n = arguments.length;
        if (n === 0) {
            this._events = {};
            return;
        }
        $2a55e105345981df$var$forEvents(events, (event)=>{
            if (n === 1) {
                delete this._events[event];
                return;
            }
            const event_array = this._events[event];
            if (event_array === undefined) return;
            event_array.splice(event_array.indexOf(fct), 1);
            this._events[event] = event_array;
        });
    }
    trigger(events, ...args) {
        var self = this;
        $2a55e105345981df$var$forEvents(events, (event)=>{
            const event_array = self._events[event];
            if (event_array === undefined) return;
            event_array.forEach((fct)=>{
                fct.apply(self, args);
            });
        });
    }
    constructor(){
        this._events = {};
    }
}


/**
 * microplugin.js
 * Copyright (c) 2013 Brian Reavis & contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
 * file except in compliance with the License. You may obtain a copy of the License at:
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 *
 * @author Brian Reavis <brian@thirdroute.com>
 */ function $3fb38749c825becf$export$2e2bcd8739ae039(Interface) {
    Interface.plugins = {};
    return class extends Interface {
        /**
         * Registers a plugin.
         *
         * @param {function} fn
         */ static define(name, fn) {
            Interface.plugins[name] = {
                "name": name,
                "fn": fn
            };
        }
        /**
         * Initializes the listed plugins (with options).
         * Acceptable formats:
         *
         * List (without options):
         *   ['a', 'b', 'c']
         *
         * List (with options):
         *   [{'name': 'a', options: {}}, {'name': 'b', options: {}}]
         *
         * Hash (with options):
         *   {'a': { ... }, 'b': { ... }, 'c': { ... }}
         *
         * @param {array|object} plugins
         */ initializePlugins(plugins) {
            var key, name;
            const self = this;
            const queue = [];
            if (Array.isArray(plugins)) plugins.forEach((plugin)=>{
                if (typeof plugin === "string") queue.push(plugin);
                else {
                    self.plugins.settings[plugin.name] = plugin.options;
                    queue.push(plugin.name);
                }
            });
            else if (plugins) {
                for(key in plugins)if (plugins.hasOwnProperty(key)) {
                    self.plugins.settings[key] = plugins[key];
                    queue.push(key);
                }
            }
            while(name = queue.shift())self.require(name);
        }
        loadPlugin(name) {
            var self = this;
            var plugins = self.plugins;
            var plugin = Interface.plugins[name];
            if (!Interface.plugins.hasOwnProperty(name)) throw new Error('Unable to find "' + name + '" plugin');
            plugins.requested[name] = true;
            plugins.loaded[name] = plugin.fn.apply(self, [
                self.plugins.settings[name] || {}
            ]);
            plugins.names.push(name);
        }
        /**
         * Initializes a plugin.
         *
         */ require(name) {
            var self = this;
            var plugins = self.plugins;
            if (!self.plugins.loaded.hasOwnProperty(name)) {
                if (plugins.requested[name]) throw new Error('Plugin has circular dependency ("' + name + '")');
                self.loadPlugin(name);
            }
            return plugins.loaded[name];
        }
        constructor(){
            super(...arguments);
            this.plugins = {
                names: [],
                settings: {},
                requested: {},
                loaded: {}
            };
        }
    };
}


/**
 * sifter.js
 * Copyright (c) 2013–2020 Brian Reavis & contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
 * file except in compliance with the License. You may obtain a copy of the License at:
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 *
 * @author Brian Reavis <brian@thirdroute.com>
 */ 
var $97zcJ = parcelRequire("97zcJ");

var $97zcJ = parcelRequire("97zcJ");
/**
 * Convert array of strings to a regular expression
 *	ex ['ab','a'] => (?:ab|a)
 * 	ex ['a','b'] => [ab]
 */ const $f4b355b8d0d2d0c3$export$8f25ce56c4b86744 = (chars)=>{
    chars = chars.filter(Boolean);
    if (chars.length < 2) return chars[0] || "";
    return $f4b355b8d0d2d0c3$export$647c192a1232817d(chars) == 1 ? "[" + chars.join("") + "]" : "(?:" + chars.join("|") + ")";
};
const $f4b355b8d0d2d0c3$export$9935d1245f2c9373 = (array)=>{
    if (!$f4b355b8d0d2d0c3$export$5755112ce53ffe60(array)) return array.join("");
    let pattern = "";
    let prev_char_count = 0;
    const prev_pattern = ()=>{
        if (prev_char_count > 1) pattern += "{" + prev_char_count + "}";
    };
    array.forEach((char, i)=>{
        if (char === array[i - 1]) {
            prev_char_count++;
            return;
        }
        prev_pattern();
        pattern += char;
        prev_char_count = 1;
    });
    prev_pattern();
    return pattern;
};
const $f4b355b8d0d2d0c3$export$45a6f122a2476582 = (chars)=>{
    let array = Array.from(chars);
    return $f4b355b8d0d2d0c3$export$8f25ce56c4b86744(array);
};
const $f4b355b8d0d2d0c3$export$5755112ce53ffe60 = (array)=>{
    return new Set(array).size !== array.length;
};
const $f4b355b8d0d2d0c3$export$beead15d1f9cee78 = (str)=>{
    return (str + "").replace(/([\$\(\)\*\+\.\?\[\]\^\{\|\}\\])/gu, "\\$1");
};
const $f4b355b8d0d2d0c3$export$647c192a1232817d = (array)=>{
    return array.reduce((longest, value)=>Math.max(longest, $f4b355b8d0d2d0c3$export$ccd3a52f1fc38f17(value)), 0);
};
const $f4b355b8d0d2d0c3$export$ccd3a52f1fc38f17 = (str)=>{
    return Array.from(str).length;
};


/**
 * Get all possible combinations of substrings that add up to the given string
 * https://stackoverflow.com/questions/30169587/find-all-the-combination-of-substrings-that-add-up-to-the-given-string
 */ const $7935615d20b66dc6$export$3106be2ea0f29c35 = (input)=>{
    if (input.length === 1) return [
        [
            input
        ]
    ];
    let result = [];
    const start = input.substring(1);
    const suba = $7935615d20b66dc6$export$3106be2ea0f29c35(start);
    suba.forEach(function(subresult) {
        let tmp = subresult.slice(0);
        tmp[0] = input.charAt(0) + tmp[0];
        result.push(tmp);
        tmp = subresult.slice(0);
        tmp.unshift(input.charAt(0));
        result.push(tmp);
    });
    return result;
};


const $506932f8bcde4f7a$export$b1c570ac28acf858 = [
    [
        0,
        65535
    ]
];
const $506932f8bcde4f7a$var$accent_pat = "[\u0300-\u036F\xb7\u02BE\u02BC]";
let $506932f8bcde4f7a$export$cee88a302431d7ab;
let $506932f8bcde4f7a$var$multi_char_reg;
const $506932f8bcde4f7a$var$max_char_length = 3;
const $506932f8bcde4f7a$var$latin_convert = {};
const $506932f8bcde4f7a$var$latin_condensed = {
    "/": "\u2044\u2215",
    "0": "\u07C0",
    "a": "\u2C65\u0250\u0251",
    "aa": "\uA733",
    "ae": "\xe6\u01FD\u01E3",
    "ao": "\uA735",
    "au": "\uA737",
    "av": "\uA739\uA73B",
    "ay": "\uA73D",
    "b": "\u0180\u0253\u0183",
    "c": "\uA73F\u0188\u023C\u2184",
    "d": "\u0111\u0257\u0256\u1D05\u018C\uABB7\u0501\u0266",
    "e": "\u025B\u01DD\u1D07\u0247",
    "f": "\uA77C\u0192",
    "g": "\u01E5\u0260\uA7A1\u1D79\uA77F\u0262",
    "h": "\u0127\u2C68\u2C76\u0265",
    "i": "\u0268\u0131",
    "j": "\u0249\u0237",
    "k": "\u0199\u2C6A\uA741\uA743\uA745\uA7A3",
    "l": "\u0142\u019A\u026B\u2C61\uA749\uA747\uA781\u026D",
    "m": "\u0271\u026F\u03FB",
    "n": "\uA7A5\u019E\u0272\uA791\u1D0E\u043B\u0509",
    "o": "\xf8\u01FF\u0254\u0275\uA74B\uA74D\u1D11",
    "oe": "\u0153",
    "oi": "\u01A3",
    "oo": "\uA74F",
    "ou": "\u0223",
    "p": "\u01A5\u1D7D\uA751\uA753\uA755\u03C1",
    "q": "\uA757\uA759\u024B",
    "r": "\u024D\u027D\uA75B\uA7A7\uA783",
    "s": "\xdf\u023F\uA7A9\uA785\u0282",
    "t": "\u0167\u01AD\u0288\u2C66\uA787",
    "th": "\xfe",
    "tz": "\uA729",
    "u": "\u0289",
    "v": "\u028B\uA75F\u028C",
    "vy": "\uA761",
    "w": "\u2C73",
    "y": "\u01B4\u024F\u1EFF",
    "z": "\u01B6\u0225\u0240\u2C6C\uA763",
    "hv": "\u0195"
};
for(let latin in $506932f8bcde4f7a$var$latin_condensed){
    let unicode = $506932f8bcde4f7a$var$latin_condensed[latin] || "";
    for(let i = 0; i < unicode.length; i++){
        let char = unicode.substring(i, i + 1);
        $506932f8bcde4f7a$var$latin_convert[char] = latin;
    }
}
const $506932f8bcde4f7a$var$convert_pat = new RegExp(Object.keys($506932f8bcde4f7a$var$latin_convert).join("|") + "|" + $506932f8bcde4f7a$var$accent_pat, "gu");
const $506932f8bcde4f7a$export$2a47f398eeff8b01 = (_code_points)=>{
    if ($506932f8bcde4f7a$export$cee88a302431d7ab !== undefined) return;
    $506932f8bcde4f7a$export$cee88a302431d7ab = $506932f8bcde4f7a$export$22f25daf944a7dfc(_code_points || $506932f8bcde4f7a$export$b1c570ac28acf858);
};
const $506932f8bcde4f7a$export$a3295358bff77e = (str, form = "NFKD")=>str.normalize(form);
const $506932f8bcde4f7a$export$f92c680a56a020c2 = (str)=>{
    return Array.from(str).reduce(/**
     * @param {string} result
     * @param {string} char
     */ (result, char)=>{
        return result + $506932f8bcde4f7a$export$ff7c6355025f99d8(char);
    }, "");
};
const $506932f8bcde4f7a$export$ff7c6355025f99d8 = (str)=>{
    str = $506932f8bcde4f7a$export$a3295358bff77e(str).toLowerCase().replace($506932f8bcde4f7a$var$convert_pat, (/** @type {string} */ char)=>{
        return $506932f8bcde4f7a$var$latin_convert[char] || "";
    });
    //return str;
    return $506932f8bcde4f7a$export$a3295358bff77e(str, "NFC");
};
function* $506932f8bcde4f7a$export$2b513308e642d699(code_points) {
    for (const [code_point_min, code_point_max] of code_points)for(let i = code_point_min; i <= code_point_max; i++){
        let composed = String.fromCharCode(i);
        let folded = $506932f8bcde4f7a$export$f92c680a56a020c2(composed);
        if (folded == composed.toLowerCase()) continue;
        // skip when folded is a string longer than 3 characters long
        // bc the resulting regex patterns will be long
        // eg:
        // folded صلى الله عليه وسلم length 18 code point 65018
        // folded جل جلاله length 8 code point 65019
        if (folded.length > $506932f8bcde4f7a$var$max_char_length) continue;
        if (folded.length == 0) continue;
        yield {
            folded: folded,
            composed: composed,
            code_point: i
        };
    }
}
const $506932f8bcde4f7a$export$a3992f04d343962 = (code_points)=>{
    const unicode_sets = {};
    const addMatching = (folded, to_add)=>{
        /** @type {Set<string>} */ const folded_set = unicode_sets[folded] || new Set();
        const patt = new RegExp("^" + (0, $f4b355b8d0d2d0c3$export$45a6f122a2476582)(folded_set) + "$", "iu");
        if (to_add.match(patt)) return;
        folded_set.add((0, $f4b355b8d0d2d0c3$export$beead15d1f9cee78)(to_add));
        unicode_sets[folded] = folded_set;
    };
    for (let value of $506932f8bcde4f7a$export$2b513308e642d699(code_points)){
        addMatching(value.folded, value.folded);
        addMatching(value.folded, value.composed);
    }
    return unicode_sets;
};
const $506932f8bcde4f7a$export$22f25daf944a7dfc = (code_points)=>{
    const unicode_sets = $506932f8bcde4f7a$export$a3992f04d343962(code_points);
    const unicode_map = {};
    let multi_char = [];
    for(let folded in unicode_sets){
        let set = unicode_sets[folded];
        if (set) unicode_map[folded] = (0, $f4b355b8d0d2d0c3$export$45a6f122a2476582)(set);
        if (folded.length > 1) multi_char.push((0, $f4b355b8d0d2d0c3$export$beead15d1f9cee78)(folded));
    }
    multi_char.sort((a, b)=>b.length - a.length);
    const multi_char_patt = (0, $f4b355b8d0d2d0c3$export$8f25ce56c4b86744)(multi_char);
    $506932f8bcde4f7a$var$multi_char_reg = new RegExp("^" + multi_char_patt, "u");
    return unicode_map;
};
const $506932f8bcde4f7a$export$b019fdfe6cf20344 = (strings, min_replacement = 1)=>{
    let chars_replaced = 0;
    strings = strings.map((str)=>{
        if ($506932f8bcde4f7a$export$cee88a302431d7ab[str]) chars_replaced += str.length;
        return $506932f8bcde4f7a$export$cee88a302431d7ab[str] || str;
    });
    if (chars_replaced >= min_replacement) return (0, $f4b355b8d0d2d0c3$export$9935d1245f2c9373)(strings);
    return "";
};
const $506932f8bcde4f7a$export$91d3676c56a07133 = (str, min_replacement = 1)=>{
    min_replacement = Math.max(min_replacement, str.length - 1);
    return (0, $f4b355b8d0d2d0c3$export$8f25ce56c4b86744)((0, $7935615d20b66dc6$export$3106be2ea0f29c35)(str).map((sub_pat)=>{
        return $506932f8bcde4f7a$export$b019fdfe6cf20344(sub_pat, min_replacement);
    }));
};
/**
 * Convert an array of sequences into a pattern
 * [{start:0,end:3,length:3,substr:'iii'}...] => (?:iii...)
 */ const $506932f8bcde4f7a$var$sequencesToPattern = (sequences, all = true)=>{
    let min_replacement = sequences.length > 1 ? 1 : 0;
    return (0, $f4b355b8d0d2d0c3$export$8f25ce56c4b86744)(sequences.map((sequence)=>{
        let seq = [];
        const len = all ? sequence.length() : sequence.length() - 1;
        for(let j = 0; j < len; j++)seq.push($506932f8bcde4f7a$export$91d3676c56a07133(sequence.substrs[j] || "", min_replacement));
        return (0, $f4b355b8d0d2d0c3$export$9935d1245f2c9373)(seq);
    }));
};
/**
 * Return true if the sequence is already in the sequences
 */ const $506932f8bcde4f7a$var$inSequences = (needle_seq, sequences)=>{
    for (const seq of sequences){
        if (seq.start != needle_seq.start || seq.end != needle_seq.end) continue;
        if (seq.substrs.join("") !== needle_seq.substrs.join("")) continue;
        let needle_parts = needle_seq.parts;
        const filter = (part)=>{
            for (const needle_part of needle_parts){
                if (needle_part.start === part.start && needle_part.substr === part.substr) return false;
                if (part.length == 1 || needle_part.length == 1) continue;
                // check for overlapping parts
                // a = ['::=','==']
                // b = ['::','===']
                // a = ['r','sm']
                // b = ['rs','m']
                if (part.start < needle_part.start && part.end > needle_part.start) return true;
                if (needle_part.start < part.start && needle_part.end > part.start) return true;
            }
            return false;
        };
        let filtered = seq.parts.filter(filter);
        if (filtered.length > 0) continue;
        return true;
    }
    return false;
};
class $506932f8bcde4f7a$var$Sequence {
    add(part) {
        if (part) {
            this.parts.push(part);
            this.substrs.push(part.substr);
            this.start = Math.min(part.start, this.start);
            this.end = Math.max(part.end, this.end);
        }
    }
    last() {
        return this.parts[this.parts.length - 1];
    }
    length() {
        return this.parts.length;
    }
    clone(position, last_piece) {
        let clone = new $506932f8bcde4f7a$var$Sequence();
        let parts = JSON.parse(JSON.stringify(this.parts));
        let last_part = parts.pop();
        for (const part of parts)clone.add(part);
        let last_substr = last_piece.substr.substring(0, position - last_part.start);
        let clone_last_len = last_substr.length;
        clone.add({
            start: last_part.start,
            end: last_part.start + clone_last_len,
            length: clone_last_len,
            substr: last_substr
        });
        return clone;
    }
    constructor(){
        (0, $97zcJ._)(this, "parts", void 0);
        (0, $97zcJ._)(this, "substrs", void 0);
        (0, $97zcJ._)(this, "start", void 0);
        (0, $97zcJ._)(this, "end", void 0);
        this.parts = [];
        this.substrs = [];
        this.start = 0;
        this.end = 0;
    }
}
const $506932f8bcde4f7a$export$2adb6bbc893073f4 = (str)=>{
    $506932f8bcde4f7a$export$2a47f398eeff8b01();
    str = $506932f8bcde4f7a$export$f92c680a56a020c2(str);
    let pattern = "";
    let sequences = [
        new $506932f8bcde4f7a$var$Sequence()
    ];
    for(let i = 0; i < str.length; i++){
        let substr = str.substring(i);
        let match = substr.match($506932f8bcde4f7a$var$multi_char_reg);
        const char = str.substring(i, i + 1);
        const match_str = match ? match[0] : null;
        // loop through sequences
        // add either the char or multi_match
        let overlapping = [];
        let added_types = new Set();
        for (const sequence of sequences){
            const last_piece = sequence.last();
            if (!last_piece || last_piece.length == 1 || last_piece.end <= i) {
                // if we have a multi match
                if (match_str) {
                    const len = match_str.length;
                    sequence.add({
                        start: i,
                        end: i + len,
                        length: len,
                        substr: match_str
                    });
                    added_types.add("1");
                } else {
                    sequence.add({
                        start: i,
                        end: i + 1,
                        length: 1,
                        substr: char
                    });
                    added_types.add("2");
                }
            } else if (match_str) {
                let clone = sequence.clone(i, last_piece);
                const len = match_str.length;
                clone.add({
                    start: i,
                    end: i + len,
                    length: len,
                    substr: match_str
                });
                overlapping.push(clone);
            } else // don't add char
            // adding would create invalid patterns: 234 => [2,34,4]
            added_types.add("3");
        }
        // if we have overlapping
        if (overlapping.length > 0) {
            // ['ii','iii'] before ['i','i','iii']
            overlapping = overlapping.sort((a, b)=>{
                return a.length() - b.length();
            });
            for (let clone of overlapping){
                // don't add if we already have an equivalent sequence
                if ($506932f8bcde4f7a$var$inSequences(clone, sequences)) continue;
                sequences.push(clone);
            }
            continue;
        }
        // if we haven't done anything unique
        // clean up the patterns
        // helps keep patterns smaller
        // if str = 'r₨㎧aarss', pattern will be 446 instead of 655
        if (i > 0 && added_types.size == 1 && !added_types.has("3")) {
            pattern += $506932f8bcde4f7a$var$sequencesToPattern(sequences, false);
            let new_seq = new $506932f8bcde4f7a$var$Sequence();
            const old_seq = sequences[0];
            if (old_seq) new_seq.add(old_seq.last());
            sequences = [
                new_seq
            ];
        }
    }
    pattern += $506932f8bcde4f7a$var$sequencesToPattern(sequences, true);
    return pattern;
};


const $9b5304a79d4d0206$export$6a93fe6b2b4c71a0 = (obj, name)=>{
    if (!obj) return;
    return obj[name];
};
const $9b5304a79d4d0206$export$822bdaf388f520e1 = (obj, name)=>{
    if (!obj) return;
    var part, names = name.split(".");
    while((part = names.shift()) && (obj = obj[part]));
    return obj;
};
const $9b5304a79d4d0206$export$ebd65387a559a3c6 = (value, token, weight)=>{
    var score, pos;
    if (!value) return 0;
    value = value + "";
    if (token.regex == null) return 0;
    pos = value.search(token.regex);
    if (pos === -1) return 0;
    score = token.string.length / value.length;
    if (pos === 0) score += 0.5;
    return score * weight;
};
const $9b5304a79d4d0206$export$689033fc54f24876 = (obj, key)=>{
    var value = obj[key];
    if (typeof value == "function") return value;
    if (value && !Array.isArray(value)) obj[key] = [
        value
    ];
};
const $9b5304a79d4d0206$export$c1a059043cc9c119 = (object, callback)=>{
    if (Array.isArray(object)) object.forEach(callback);
    else {
        for(var key in object)if (object.hasOwnProperty(key)) callback(object[key], key);
    }
};
const $9b5304a79d4d0206$export$6154dcdb7d23e37b = (a, b)=>{
    if (typeof a === "number" && typeof b === "number") return a > b ? 1 : a < b ? -1 : 0;
    a = (0, $506932f8bcde4f7a$export$f92c680a56a020c2)(a + "").toLowerCase();
    b = (0, $506932f8bcde4f7a$export$f92c680a56a020c2)(b + "").toLowerCase();
    if (a > b) return 1;
    if (b > a) return -1;
    return 0;
};





class $b7675fb2ce40e3a1$export$6340a962c95c3b9 {
    /**
     * Splits a search string into an array of individual
     * regexps to be used to match results.
     *
     */ tokenize(query, respect_word_boundaries, weights) {
        if (!query || !query.length) return [];
        const tokens = [];
        const words = query.split(/\s+/);
        var field_regex;
        if (weights) field_regex = new RegExp("^(" + Object.keys(weights).map((0, $f4b355b8d0d2d0c3$export$beead15d1f9cee78)).join("|") + "):(.*)$");
        words.forEach((word)=>{
            let field_match;
            let field = null;
            let regex = null;
            // look for "field:query" tokens
            if (field_regex && (field_match = word.match(field_regex))) {
                field = field_match[1];
                word = field_match[2];
            }
            if (word.length > 0) {
                if (this.settings.diacritics) regex = (0, $506932f8bcde4f7a$export$2adb6bbc893073f4)(word) || null;
                else regex = (0, $f4b355b8d0d2d0c3$export$beead15d1f9cee78)(word);
                if (regex && respect_word_boundaries) regex = "\\b" + regex;
            }
            tokens.push({
                string: word,
                regex: regex ? new RegExp(regex, "iu") : null,
                field: field
            });
        });
        return tokens;
    }
    /**
     * Returns a function to be used to score individual results.
     *
     * Good matches will have a higher score than poor matches.
     * If an item is not a match, 0 will be returned by the function.
     *
     * @returns {T.ScoreFn}
     */ getScoreFunction(query, options) {
        var search = this.prepareSearch(query, options);
        return this._getScoreFunction(search);
    }
    /**
     * @returns {T.ScoreFn}
     *
     */ _getScoreFunction(search) {
        const tokens = search.tokens, token_count = tokens.length;
        if (!token_count) return function() {
            return 0;
        };
        const fields = search.options.fields, weights = search.weights, field_count = fields.length, getAttrFn = search.getAttrFn;
        if (!field_count) return function() {
            return 1;
        };
        /**
         * Calculates the score of an object
         * against the search query.
         *
         */ const scoreObject = function() {
            if (field_count === 1) return function(token, data) {
                const field = fields[0].field;
                return (0, $9b5304a79d4d0206$export$ebd65387a559a3c6)(getAttrFn(data, field), token, weights[field] || 1);
            };
            return function(token, data) {
                var sum = 0;
                // is the token specific to a field?
                if (token.field) {
                    const value = getAttrFn(data, token.field);
                    if (!token.regex && value) sum += 1 / field_count;
                    else sum += (0, $9b5304a79d4d0206$export$ebd65387a559a3c6)(value, token, 1);
                } else (0, $9b5304a79d4d0206$export$c1a059043cc9c119)(weights, (weight, field)=>{
                    sum += (0, $9b5304a79d4d0206$export$ebd65387a559a3c6)(getAttrFn(data, field), token, weight);
                });
                return sum / field_count;
            };
        }();
        if (token_count === 1) return function(data) {
            return scoreObject(tokens[0], data);
        };
        if (search.options.conjunction === "and") return function(data) {
            var score, sum = 0;
            for (let token of tokens){
                score = scoreObject(token, data);
                if (score <= 0) return 0;
                sum += score;
            }
            return sum / token_count;
        };
        else return function(data) {
            var sum = 0;
            (0, $9b5304a79d4d0206$export$c1a059043cc9c119)(tokens, (token)=>{
                sum += scoreObject(token, data);
            });
            return sum / token_count;
        };
    }
    /**
     * Returns a function that can be used to compare two
     * results, for sorting purposes. If no sorting should
     * be performed, `null` will be returned.
     *
     * @return function(a,b)
     */ getSortFunction(query, options) {
        var search = this.prepareSearch(query, options);
        return this._getSortFunction(search);
    }
    _getSortFunction(search) {
        var implicit_score, sort_flds = [];
        const self = this, options = search.options, sort = !search.query && options.sort_empty ? options.sort_empty : options.sort;
        if (typeof sort == "function") return sort.bind(this);
        /**
         * Fetches the specified sort field value
         * from a search result item.
         *
         */ const get_field = function(name, result) {
            if (name === "$score") return result.score;
            return search.getAttrFn(self.items[result.id], name);
        };
        // parse options
        if (sort) {
            for (let s of sort)if (search.query || s.field !== "$score") sort_flds.push(s);
        }
        // the "$score" field is implied to be the primary
        // sort field, unless it's manually specified
        if (search.query) {
            implicit_score = true;
            for (let fld of sort_flds)if (fld.field === "$score") {
                implicit_score = false;
                break;
            }
            if (implicit_score) sort_flds.unshift({
                field: "$score",
                direction: "desc"
            });
        // without a search.query, all items will have the same score
        } else sort_flds = sort_flds.filter((fld)=>fld.field !== "$score");
        // build function
        const sort_flds_count = sort_flds.length;
        if (!sort_flds_count) return null;
        return function(a, b) {
            var result, field;
            for (let sort_fld of sort_flds){
                field = sort_fld.field;
                let multiplier = sort_fld.direction === "desc" ? -1 : 1;
                result = multiplier * (0, $9b5304a79d4d0206$export$6154dcdb7d23e37b)(get_field(field, a), get_field(field, b));
                if (result) return result;
            }
            return 0;
        };
    }
    /**
     * Parses a search query and returns an object
     * with tokens and fields ready to be populated
     * with results.
     *
     */ prepareSearch(query, optsUser) {
        const weights = {};
        var options = Object.assign({}, optsUser);
        (0, $9b5304a79d4d0206$export$689033fc54f24876)(options, "sort");
        (0, $9b5304a79d4d0206$export$689033fc54f24876)(options, "sort_empty");
        // convert fields to new format
        if (options.fields) {
            (0, $9b5304a79d4d0206$export$689033fc54f24876)(options, "fields");
            const fields = [];
            options.fields.forEach((field)=>{
                if (typeof field == "string") field = {
                    field: field,
                    weight: 1
                };
                fields.push(field);
                weights[field.field] = "weight" in field ? field.weight : 1;
            });
            options.fields = fields;
        }
        return {
            options: options,
            query: query.toLowerCase().trim(),
            tokens: this.tokenize(query, options.respect_word_boundaries, weights),
            total: 0,
            items: [],
            weights: weights,
            getAttrFn: options.nesting ? (0, $9b5304a79d4d0206$export$822bdaf388f520e1) : (0, $9b5304a79d4d0206$export$6a93fe6b2b4c71a0)
        };
    }
    /**
     * Searches through all items and returns a sorted array of matches.
     *
     */ search(query, options) {
        var self = this, score, search;
        search = this.prepareSearch(query, options);
        options = search.options;
        query = search.query;
        // generate result scoring function
        const fn_score = options.score || self._getScoreFunction(search);
        // perform search and sort
        if (query.length) (0, $9b5304a79d4d0206$export$c1a059043cc9c119)(self.items, (item, id)=>{
            score = fn_score(item);
            if (options.filter === false || score > 0) search.items.push({
                "score": score,
                "id": id
            });
        });
        else (0, $9b5304a79d4d0206$export$c1a059043cc9c119)(self.items, (_, id)=>{
            search.items.push({
                "score": 1,
                "id": id
            });
        });
        const fn_sort = self._getSortFunction(search);
        if (fn_sort) search.items.sort(fn_sort);
        // apply limits
        search.total = search.items.length;
        if (typeof options.limit === "number") search.items = search.items.slice(0, options.limit);
        return search;
    }
    /**
     * Textually searches arrays and hashes of objects
     * by property (or multiple properties). Designed
     * specifically for autocomplete.
     *
     */ constructor(items, settings){
        (0, $97zcJ._)(this, "items", void 0 // []|{};
        );
        (0, $97zcJ._)(this, "settings", void 0);
        this.items = items;
        this.settings = settings || {
            diacritics: true
        };
    }
}



/**
 * highlight v3 | MIT license | Johann Burkard <jb@eaio.com>
 * Highlights arbitrary terms in a node.
 *
 * - Modified by Marshal <beatgates@gmail.com> 2011-6-24 (added regex)
 * - Modified by Brian Reavis <brian@thirdroute.com> 2012-8-27 (cleanup)
 */ /**
 * Converts a scalar to its best string representation
 * for hash keys and HTML attribute values.
 *
 * Transformations:
 *   'str'     -> 'str'
 *   null      -> ''
 *   undefined -> ''
 *   true      -> '1'
 *   false     -> '0'
 *   0         -> '0'
 *   1         -> '1'
 *
 */ const $c530096da023d8a6$export$4e00787be681ebe0 = (value)=>{
    if (typeof value === "undefined" || value === null) return null;
    return $c530096da023d8a6$export$e59fe9173a7a0aac(value);
};
const $c530096da023d8a6$export$e59fe9173a7a0aac = (value)=>{
    if (typeof value === "boolean") return value ? "1" : "0";
    return value + "";
};
const $c530096da023d8a6$export$1e6f422d3087f91c = (str)=>{
    return (str + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
};
const $c530096da023d8a6$export$83e74882c5df8fe1 = (fn, timeout)=>{
    if (timeout > 0) return window.setTimeout(fn, timeout);
    fn.call(null);
    return null;
};
const $c530096da023d8a6$export$84b68745395ddf0b = (fn, delay)=>{
    var timeout;
    return function(value, callback) {
        var self = this;
        if (timeout) {
            self.loading = Math.max(self.loading - 1, 0);
            clearTimeout(timeout);
        }
        timeout = setTimeout(function() {
            timeout = null;
            self.loadedSearches[value] = true;
            fn.call(self, value, callback);
        }, delay);
    };
};
const $c530096da023d8a6$export$2c9747a4208fe65f = (self, types, fn)=>{
    var type;
    var trigger = self.trigger;
    var event_args = {};
    // override trigger method
    self.trigger = function() {
        var type = arguments[0];
        if (types.indexOf(type) !== -1) event_args[type] = arguments;
        else return trigger.apply(self, arguments);
    };
    // invoke provided function
    fn.apply(self, []);
    self.trigger = trigger;
    // trigger queued events
    for (type of types)if (type in event_args) trigger.apply(self, event_args[type]);
};
const $c530096da023d8a6$export$ca798a7e6e94638c = (input)=>{
    return {
        start: input.selectionStart || 0,
        length: (input.selectionEnd || 0) - (input.selectionStart || 0)
    };
};
const $c530096da023d8a6$export$fa3b29edae795ef4 = (evt, stop = false)=>{
    if (evt) {
        evt.preventDefault();
        if (stop) evt.stopPropagation();
    }
};
const $c530096da023d8a6$export$f531f92e2a15358f = (target, type, callback, options)=>{
    target.addEventListener(type, callback, options);
};
const $c530096da023d8a6$export$e7bf60a870f429b0 = (key_name, evt)=>{
    if (!evt) return false;
    if (!evt[key_name]) return false;
    var count = (evt.altKey ? 1 : 0) + (evt.ctrlKey ? 1 : 0) + (evt.shiftKey ? 1 : 0) + (evt.metaKey ? 1 : 0);
    if (count === 1) return true;
    return false;
};
const $c530096da023d8a6$export$218c8c3169c024d2 = (el, id)=>{
    const existing_id = el.getAttribute("id");
    if (existing_id) return existing_id;
    el.setAttribute("id", id);
    return id;
};
const $c530096da023d8a6$export$c34459d1aef61885 = (str)=>{
    return str.replace(/[\\"']/g, "\\$&");
};
const $c530096da023d8a6$export$10d8903dec122b9d = (parent, node)=>{
    if (node) parent.append(node);
};
const $c530096da023d8a6$export$c1a059043cc9c119 = (object, callback)=>{
    if (Array.isArray(object)) object.forEach(callback);
    else {
        for(var key in object)if (object.hasOwnProperty(key)) callback(object[key], key);
    }
};


const $809748f5374a81d3$export$6c34eab6e99e0f60 = (query)=>{
    if (query.jquery) return query[0];
    if (query instanceof HTMLElement) return query;
    if ($809748f5374a81d3$export$c59330865007bdef(query)) {
        var tpl = document.createElement("template");
        tpl.innerHTML = query.trim(); // Never return a text node of whitespace as the result
        return tpl.content.firstChild;
    }
    return document.querySelector(query);
};
const $809748f5374a81d3$export$c59330865007bdef = (arg)=>{
    if (typeof arg === "string" && arg.indexOf("<") > -1) return true;
    return false;
};
const $809748f5374a81d3$export$8ec014f0032c0767 = (query)=>{
    return query.replace(/['"\\]/g, "\\$&");
};
const $809748f5374a81d3$export$bf5e5f0a0e9ca89d = (dom_el, event_name)=>{
    var event = document.createEvent("HTMLEvents");
    event.initEvent(event_name, true, false);
    dom_el.dispatchEvent(event);
};
const $809748f5374a81d3$export$3a26aa64e59aeaff = (dom_el, css)=>{
    Object.assign(dom_el.style, css);
};
const $809748f5374a81d3$export$34a1a93008ee28b5 = (elmts, ...classes)=>{
    var norm_classes = $809748f5374a81d3$export$ebf018fc05eb8290(classes);
    elmts = $809748f5374a81d3$export$ca73cb1e19b0cfb8(elmts);
    elmts.map((el)=>{
        norm_classes.map((cls)=>{
            el.classList.add(cls);
        });
    });
};
const $809748f5374a81d3$export$33233bd73e8de239 = (elmts, ...classes)=>{
    var norm_classes = $809748f5374a81d3$export$ebf018fc05eb8290(classes);
    elmts = $809748f5374a81d3$export$ca73cb1e19b0cfb8(elmts);
    elmts.map((el)=>{
        norm_classes.map((cls)=>{
            el.classList.remove(cls);
        });
    });
};
const $809748f5374a81d3$export$ebf018fc05eb8290 = (args)=>{
    var classes = [];
    (0, $c530096da023d8a6$export$c1a059043cc9c119)(args, (_classes)=>{
        if (typeof _classes === "string") _classes = _classes.trim().split(/[\t\n\f\r\s]/);
        if (Array.isArray(_classes)) classes = classes.concat(_classes);
    });
    return classes.filter(Boolean);
};
const $809748f5374a81d3$export$ca73cb1e19b0cfb8 = (arg)=>{
    if (!Array.isArray(arg)) arg = [
        arg
    ];
    return arg;
};
const $809748f5374a81d3$export$f5dd2e7a81a974e9 = (target, selector, wrapper)=>{
    if (wrapper && !wrapper.contains(target)) return;
    while(target && target.matches){
        if (target.matches(selector)) return target;
        target = target.parentNode;
    }
};
const $809748f5374a81d3$export$22db25736bd2dc5f = (list, direction = 0)=>{
    if (direction > 0) return list[list.length - 1];
    return list[0];
};
const $809748f5374a81d3$export$83b788b1a3698c03 = (obj)=>{
    return Object.keys(obj).length === 0;
};
const $809748f5374a81d3$export$e5c4cfab14d02c5d = (el, amongst)=>{
    if (!el) return -1;
    amongst = amongst || el.nodeName;
    var i = 0;
    while(el = el.previousElementSibling)if (el.matches(amongst)) i++;
    return i;
};
const $809748f5374a81d3$export$c609e428011345f3 = (el, attrs)=>{
    (0, $c530096da023d8a6$export$c1a059043cc9c119)(attrs, (val, attr)=>{
        if (val == null) el.removeAttribute(attr);
        else el.setAttribute(attr, "" + val);
    });
};
const $809748f5374a81d3$export$5542201de9311ab2 = (existing, replacement)=>{
    if (existing.parentNode) existing.parentNode.replaceChild(replacement, existing);
};


const $0cd7c1360495bac5$export$e4043f67d36cbb26 = (element, regex)=>{
    if (regex === null) return;
    // convet string to regex
    if (typeof regex === "string") {
        if (!regex.length) return;
        regex = new RegExp(regex, "i");
    }
    // Wrap matching part of text node with highlighting <span>, e.g.
    // Soccer  ->  <span class="highlight">Soc</span>cer  for regex = /soc/i
    const highlightText = (node)=>{
        var match = node.data.match(regex);
        if (match && node.data.length > 0) {
            var spannode = document.createElement("span");
            spannode.className = "highlight";
            var middlebit = node.splitText(match.index);
            middlebit.splitText(match[0].length);
            var middleclone = middlebit.cloneNode(true);
            spannode.appendChild(middleclone);
            (0, $809748f5374a81d3$export$5542201de9311ab2)(middlebit, spannode);
            return 1;
        }
        return 0;
    };
    // Recurse element node, looking for child text nodes to highlight, unless element
    // is childless, <script>, <style>, or already highlighted: <span class="hightlight">
    const highlightChildren = (node)=>{
        if (node.nodeType === 1 && node.childNodes && !/(script|style)/i.test(node.tagName) && (node.className !== "highlight" || node.tagName !== "SPAN")) Array.from(node.childNodes).forEach((element)=>{
            highlightRecursive(element);
        });
    };
    const highlightRecursive = (node)=>{
        if (node.nodeType === 3) return highlightText(node);
        highlightChildren(node);
        return 0;
    };
    highlightRecursive(element);
};
const $0cd7c1360495bac5$export$7854b6fa03b6c2ef = (el)=>{
    var elements = el.querySelectorAll("span.highlight");
    Array.prototype.forEach.call(elements, function(el) {
        var parent = el.parentNode;
        parent.replaceChild(el.firstChild, el);
        parent.normalize();
    });
};


const $00f1a247f08d3ec5$export$a62be707b936c199 = 65;
const $00f1a247f08d3ec5$export$a38a780d07123ee = 13;
const $00f1a247f08d3ec5$export$f0fcadf25a56f096 = 27;
const $00f1a247f08d3ec5$export$fc4577f2a2af0ae3 = 37;
const $00f1a247f08d3ec5$export$390330c10ff2b9a1 = 38;
const $00f1a247f08d3ec5$export$c40f9845adc73fb5 = 39;
const $00f1a247f08d3ec5$export$a80636c6f41931fe = 40;
const $00f1a247f08d3ec5$export$7cd8f621642ff61e = 8;
const $00f1a247f08d3ec5$export$1fd7871db6041a84 = 46;
const $00f1a247f08d3ec5$export$10f6869ed0a7d75b = 9;
const $00f1a247f08d3ec5$export$ff23e6b4c4401383 = typeof navigator === "undefined" ? false : /Mac/.test(navigator.userAgent);
const $00f1a247f08d3ec5$export$7f209867a1e996c7 = $00f1a247f08d3ec5$export$ff23e6b4c4401383 ? "metaKey" : "ctrlKey"; // ctrl key or apple key for ma


var $2700b18e6eb4c6b6$export$2e2bcd8739ae039 = {
    options: [],
    optgroups: [],
    plugins: [],
    delimiter: ",",
    splitOn: null,
    persist: true,
    diacritics: true,
    create: null,
    createOnBlur: false,
    createFilter: null,
    highlight: true,
    openOnFocus: true,
    shouldOpen: null,
    maxOptions: 50,
    maxItems: null,
    hideSelected: null,
    duplicates: false,
    addPrecedence: false,
    selectOnTab: false,
    preload: null,
    allowEmptyOption: false,
    //closeAfterSelect: false,
    refreshThrottle: 300,
    loadThrottle: 300,
    loadingClass: "loading",
    dataAttr: null,
    optgroupField: "optgroup",
    valueField: "value",
    labelField: "text",
    disabledField: "disabled",
    optgroupLabelField: "label",
    optgroupValueField: "value",
    lockOptgroupOrder: false,
    sortField: "$order",
    searchField: [
        "text"
    ],
    searchConjunction: "and",
    mode: null,
    wrapperClass: "ts-wrapper",
    controlClass: "ts-control",
    dropdownClass: "ts-dropdown",
    dropdownContentClass: "ts-dropdown-content",
    itemClass: "item",
    optionClass: "option",
    dropdownParent: null,
    controlInput: '<input type="text" autocomplete="off" size="1" />',
    copyClassesToDropdown: false,
    placeholder: null,
    hidePlaceholder: null,
    shouldLoad: function(query) {
        return query.length > 0;
    },
    /*
    load                 : null, // function(query, callback) { ... }
    score                : null, // function(search) { ... }
    onInitialize         : null, // function() { ... }
    onChange             : null, // function(value) { ... }
    onItemAdd            : null, // function(value, $item) { ... }
    onItemRemove         : null, // function(value) { ... }
    onClear              : null, // function() { ... }
    onOptionAdd          : null, // function(value, data) { ... }
    onOptionRemove       : null, // function(value) { ... }
    onOptionClear        : null, // function() { ... }
    onOptionGroupAdd     : null, // function(id, data) { ... }
    onOptionGroupRemove  : null, // function(id) { ... }
    onOptionGroupClear   : null, // function() { ... }
    onDropdownOpen       : null, // function(dropdown) { ... }
    onDropdownClose      : null, // function(dropdown) { ... }
    onType               : null, // function(str) { ... }
    onDelete             : null, // function(values) { ... }
    */ render: {
    }
};



function $b4af95e4536e8abe$export$2e2bcd8739ae039(input, settings_user) {
    var settings = Object.assign({}, (0, $2700b18e6eb4c6b6$export$2e2bcd8739ae039), settings_user);
    var attr_data = settings.dataAttr;
    var field_label = settings.labelField;
    var field_value = settings.valueField;
    var field_disabled = settings.disabledField;
    var field_optgroup = settings.optgroupField;
    var field_optgroup_label = settings.optgroupLabelField;
    var field_optgroup_value = settings.optgroupValueField;
    var tag_name = input.tagName.toLowerCase();
    var placeholder = input.getAttribute("placeholder") || input.getAttribute("data-placeholder");
    if (!placeholder && !settings.allowEmptyOption) {
        let option = input.querySelector('option[value=""]');
        if (option) placeholder = option.textContent;
    }
    var settings_element = {
        placeholder: placeholder,
        options: [],
        optgroups: [],
        items: [],
        maxItems: null
    };
    /**
     * Initialize from a <select> element.
     *
     */ var init_select = ()=>{
        var tagName;
        var options = settings_element.options;
        var optionsMap = {};
        var group_count = 1;
        let $order = 0;
        var readData = (el)=>{
            var data = Object.assign({}, el.dataset); // get plain object from DOMStringMap
            var json = attr_data && data[attr_data];
            if (typeof json === "string" && json.length) data = Object.assign(data, JSON.parse(json));
            return data;
        };
        var addOption = (option, group)=>{
            var value = (0, $c530096da023d8a6$export$4e00787be681ebe0)(option.value);
            if (value == null) return;
            if (!value && !settings.allowEmptyOption) return;
            // if the option already exists, it's probably been
            // duplicated in another optgroup. in this case, push
            // the current group to the "optgroup" property on the
            // existing option so that it's rendered in both places.
            if (optionsMap.hasOwnProperty(value)) {
                if (group) {
                    var arr = optionsMap[value][field_optgroup];
                    if (!arr) optionsMap[value][field_optgroup] = group;
                    else if (!Array.isArray(arr)) optionsMap[value][field_optgroup] = [
                        arr,
                        group
                    ];
                    else arr.push(group);
                }
            } else {
                var option_data = readData(option);
                option_data[field_label] = option_data[field_label] || option.textContent;
                option_data[field_value] = option_data[field_value] || value;
                option_data[field_disabled] = option_data[field_disabled] || option.disabled;
                option_data[field_optgroup] = option_data[field_optgroup] || group;
                option_data.$option = option;
                option_data.$order = option_data.$order || ++$order;
                optionsMap[value] = option_data;
                options.push(option_data);
            }
            if (option.selected) settings_element.items.push(value);
        };
        var addGroup = (optgroup)=>{
            var id, optgroup_data;
            optgroup_data = readData(optgroup);
            optgroup_data[field_optgroup_label] = optgroup_data[field_optgroup_label] || optgroup.getAttribute("label") || "";
            optgroup_data[field_optgroup_value] = optgroup_data[field_optgroup_value] || group_count++;
            optgroup_data[field_disabled] = optgroup_data[field_disabled] || optgroup.disabled;
            optgroup_data.$order = optgroup_data.$order || ++$order;
            settings_element.optgroups.push(optgroup_data);
            id = optgroup_data[field_optgroup_value];
            (0, $c530096da023d8a6$export$c1a059043cc9c119)(optgroup.children, (option)=>{
                addOption(option, id);
            });
        };
        settings_element.maxItems = input.hasAttribute("multiple") ? null : 1;
        (0, $c530096da023d8a6$export$c1a059043cc9c119)(input.children, (child)=>{
            tagName = child.tagName.toLowerCase();
            if (tagName === "optgroup") addGroup(child);
            else if (tagName === "option") addOption(child);
        });
    };
    /**
     * Initialize from a <input type="text"> element.
     *
     */ var init_textbox = ()=>{
        const data_raw = input.getAttribute(attr_data);
        if (!data_raw) {
            var value = input.value.trim() || "";
            if (!settings.allowEmptyOption && !value.length) return;
            const values = value.split(settings.delimiter);
            (0, $c530096da023d8a6$export$c1a059043cc9c119)(values, (value)=>{
                const option = {};
                option[field_label] = value;
                option[field_value] = value;
                settings_element.options.push(option);
            });
            settings_element.items = values;
        } else {
            settings_element.options = JSON.parse(data_raw);
            (0, $c530096da023d8a6$export$c1a059043cc9c119)(settings_element.options, (opt)=>{
                settings_element.items.push(opt[field_value]);
            });
        }
    };
    if (tag_name === "select") init_select();
    else init_textbox();
    return Object.assign({}, (0, $2700b18e6eb4c6b6$export$2e2bcd8739ae039), settings_element, settings_user);
}




var $fd20d2d1040a5c5d$var$instance_i = 0;
class $fd20d2d1040a5c5d$export$2e2bcd8739ae039 extends (0, $3fb38749c825becf$export$2e2bcd8739ae039)((0, $2a55e105345981df$export$2e2bcd8739ae039)) {
    /**
     * set up event bindings.
     *
     */ setup() {
        const self = this;
        const settings = self.settings;
        const control_input = self.control_input;
        const dropdown = self.dropdown;
        const dropdown_content = self.dropdown_content;
        const wrapper = self.wrapper;
        const control = self.control;
        const input = self.input;
        const focus_node = self.focus_node;
        const passive_event = {
            passive: true
        };
        const listboxId = self.inputId + "-ts-dropdown";
        (0, $809748f5374a81d3$export$c609e428011345f3)(dropdown_content, {
            id: listboxId
        });
        (0, $809748f5374a81d3$export$c609e428011345f3)(focus_node, {
            role: "combobox",
            "aria-haspopup": "listbox",
            "aria-expanded": "false",
            "aria-controls": listboxId
        });
        const control_id = (0, $c530096da023d8a6$export$218c8c3169c024d2)(focus_node, self.inputId + "-ts-control");
        const query = "label[for='" + (0, $809748f5374a81d3$export$8ec014f0032c0767)(self.inputId) + "']";
        const label = document.querySelector(query);
        const label_click = self.focus.bind(self);
        if (label) {
            (0, $c530096da023d8a6$export$f531f92e2a15358f)(label, "click", label_click);
            (0, $809748f5374a81d3$export$c609e428011345f3)(label, {
                for: control_id
            });
            const label_id = (0, $c530096da023d8a6$export$218c8c3169c024d2)(label, self.inputId + "-ts-label");
            (0, $809748f5374a81d3$export$c609e428011345f3)(focus_node, {
                "aria-labelledby": label_id
            });
            (0, $809748f5374a81d3$export$c609e428011345f3)(dropdown_content, {
                "aria-labelledby": label_id
            });
        }
        wrapper.style.width = input.style.width;
        if (self.plugins.names.length) {
            const classes_plugins = "plugin-" + self.plugins.names.join(" plugin-");
            (0, $809748f5374a81d3$export$34a1a93008ee28b5)([
                wrapper,
                dropdown
            ], classes_plugins);
        }
        if ((settings.maxItems === null || settings.maxItems > 1) && self.is_select_tag) (0, $809748f5374a81d3$export$c609e428011345f3)(input, {
            multiple: "multiple"
        });
        if (settings.placeholder) (0, $809748f5374a81d3$export$c609e428011345f3)(control_input, {
            placeholder: settings.placeholder
        });
        // if splitOn was not passed in, construct it from the delimiter to allow pasting universally
        if (!settings.splitOn && settings.delimiter) settings.splitOn = new RegExp("\\s*" + (0, $f4b355b8d0d2d0c3$export$beead15d1f9cee78)(settings.delimiter) + "+\\s*");
        // debounce user defined load() if loadThrottle > 0
        // after initializePlugins() so plugins can create/modify user defined loaders
        if (settings.load && settings.loadThrottle) settings.load = (0, $c530096da023d8a6$export$84b68745395ddf0b)(settings.load, settings.loadThrottle);
        (0, $c530096da023d8a6$export$f531f92e2a15358f)(dropdown, "mousemove", ()=>{
            self.ignoreHover = false;
        });
        (0, $c530096da023d8a6$export$f531f92e2a15358f)(dropdown, "mouseenter", (e)=>{
            var target_match = (0, $809748f5374a81d3$export$f5dd2e7a81a974e9)(e.target, "[data-selectable]", dropdown);
            if (target_match) self.onOptionHover(e, target_match);
        }, {
            capture: true
        });
        // clicking on an option should select it
        (0, $c530096da023d8a6$export$f531f92e2a15358f)(dropdown, "click", (evt)=>{
            const option = (0, $809748f5374a81d3$export$f5dd2e7a81a974e9)(evt.target, "[data-selectable]");
            if (option) {
                self.onOptionSelect(evt, option);
                (0, $c530096da023d8a6$export$fa3b29edae795ef4)(evt, true);
            }
        });
        (0, $c530096da023d8a6$export$f531f92e2a15358f)(control, "click", (evt)=>{
            var target_match = (0, $809748f5374a81d3$export$f5dd2e7a81a974e9)(evt.target, "[data-ts-item]", control);
            if (target_match && self.onItemSelect(evt, target_match)) {
                (0, $c530096da023d8a6$export$fa3b29edae795ef4)(evt, true);
                return;
            }
            // retain focus (see control_input mousedown)
            if (control_input.value != "") return;
            self.onClick();
            (0, $c530096da023d8a6$export$fa3b29edae795ef4)(evt, true);
        });
        // keydown on focus_node for arrow_down/arrow_up
        (0, $c530096da023d8a6$export$f531f92e2a15358f)(focus_node, "keydown", (e)=>self.onKeyDown(e));
        // keypress and input/keyup
        (0, $c530096da023d8a6$export$f531f92e2a15358f)(control_input, "keypress", (e)=>self.onKeyPress(e));
        (0, $c530096da023d8a6$export$f531f92e2a15358f)(control_input, "input", (e)=>self.onInput(e));
        (0, $c530096da023d8a6$export$f531f92e2a15358f)(focus_node, "blur", (e)=>self.onBlur(e));
        (0, $c530096da023d8a6$export$f531f92e2a15358f)(focus_node, "focus", (e)=>self.onFocus(e));
        (0, $c530096da023d8a6$export$f531f92e2a15358f)(control_input, "paste", (e)=>self.onPaste(e));
        const doc_mousedown = (evt)=>{
            // blur if target is outside of this instance
            // dropdown is not always inside wrapper
            const target = evt.composedPath()[0];
            if (!wrapper.contains(target) && !dropdown.contains(target)) {
                if (self.isFocused) self.blur();
                self.inputState();
                return;
            }
            // retain focus by preventing native handling. if the
            // event target is the input it should not be modified.
            // otherwise, text selection within the input won't work.
            // Fixes bug #212 which is no covered by tests
            if (target == control_input && self.isOpen) evt.stopPropagation();
            else (0, $c530096da023d8a6$export$fa3b29edae795ef4)(evt, true);
        };
        const win_scroll = ()=>{
            if (self.isOpen) self.positionDropdown();
        };
        (0, $c530096da023d8a6$export$f531f92e2a15358f)(document, "mousedown", doc_mousedown);
        (0, $c530096da023d8a6$export$f531f92e2a15358f)(window, "scroll", win_scroll, passive_event);
        (0, $c530096da023d8a6$export$f531f92e2a15358f)(window, "resize", win_scroll, passive_event);
        this._destroy = ()=>{
            document.removeEventListener("mousedown", doc_mousedown);
            window.removeEventListener("scroll", win_scroll);
            window.removeEventListener("resize", win_scroll);
            if (label) label.removeEventListener("click", label_click);
        };
        // store original html and tab index so that they can be
        // restored when the destroy() method is called.
        this.revertSettings = {
            innerHTML: input.innerHTML,
            tabIndex: input.tabIndex
        };
        input.tabIndex = -1;
        input.insertAdjacentElement("afterend", self.wrapper);
        self.sync(false);
        settings.items = [];
        delete settings.optgroups;
        delete settings.options;
        (0, $c530096da023d8a6$export$f531f92e2a15358f)(input, "invalid", ()=>{
            if (self.isValid) {
                self.isValid = false;
                self.isInvalid = true;
                self.refreshState();
            }
        });
        self.updateOriginalInput();
        self.refreshItems();
        self.close(false);
        self.inputState();
        self.isSetup = true;
        if (input.disabled) self.disable();
        else if (input.readOnly) self.setReadOnly(true);
        else self.enable(); //sets tabIndex
        self.on("change", this.onChange);
        (0, $809748f5374a81d3$export$34a1a93008ee28b5)(input, "tomselected", "ts-hidden-accessible");
        self.trigger("initialize");
        // preload options
        if (settings.preload === true) self.preload();
    }
    /**
     * Register options and optgroups
     *
     */ setupOptions(options = [], optgroups = []) {
        // build options table
        this.addOptions(options);
        // build optgroup table
        (0, $c530096da023d8a6$export$c1a059043cc9c119)(optgroups, (optgroup)=>{
            this.registerOptionGroup(optgroup);
        });
    }
    /**
     * Sets up default rendering functions.
     */ setupTemplates() {
        var self = this;
        var field_label = self.settings.labelField;
        var field_optgroup = self.settings.optgroupLabelField;
        var templates = {
            "optgroup": (data)=>{
                let optgroup = document.createElement("div");
                optgroup.className = "optgroup";
                optgroup.appendChild(data.options);
                return optgroup;
            },
            "optgroup_header": (data, escape)=>{
                return '<div class="optgroup-header">' + escape(data[field_optgroup]) + "</div>";
            },
            "option": (data, escape)=>{
                return "<div>" + escape(data[field_label]) + "</div>";
            },
            "item": (data, escape)=>{
                return "<div>" + escape(data[field_label]) + "</div>";
            },
            "option_create": (data, escape)=>{
                return '<div class="create">Add <strong>' + escape(data.input) + "</strong>&hellip;</div>";
            },
            "no_results": ()=>{
                return '<div class="no-results">No results found</div>';
            },
            "loading": ()=>{
                return '<div class="spinner"></div>';
            },
            "not_loading": ()=>{},
            "dropdown": ()=>{
                return "<div></div>";
            }
        };
        self.settings.render = Object.assign({}, templates, self.settings.render);
    }
    /**
     * Maps fired events to callbacks provided
     * in the settings used when creating the control.
     */ setupCallbacks() {
        var key, fn;
        var callbacks = {
            "initialize": "onInitialize",
            "change": "onChange",
            "item_add": "onItemAdd",
            "item_remove": "onItemRemove",
            "item_select": "onItemSelect",
            "clear": "onClear",
            "option_add": "onOptionAdd",
            "option_remove": "onOptionRemove",
            "option_clear": "onOptionClear",
            "optgroup_add": "onOptionGroupAdd",
            "optgroup_remove": "onOptionGroupRemove",
            "optgroup_clear": "onOptionGroupClear",
            "dropdown_open": "onDropdownOpen",
            "dropdown_close": "onDropdownClose",
            "type": "onType",
            "load": "onLoad",
            "focus": "onFocus",
            "blur": "onBlur"
        };
        for(key in callbacks){
            fn = this.settings[callbacks[key]];
            if (fn) this.on(key, fn);
        }
    }
    /**
     * Sync the Tom Select instance with the original input or select
     *
     */ sync(get_settings = true) {
        const self = this;
        const settings = get_settings ? (0, $b4af95e4536e8abe$export$2e2bcd8739ae039)(self.input, {
            delimiter: self.settings.delimiter
        }) : self.settings;
        self.setupOptions(settings.options, settings.optgroups);
        self.setValue(settings.items || [], true); // silent prevents recursion
        self.lastQuery = null; // so updated options will be displayed in dropdown
    }
    /**
     * Triggered when the main control element
     * has a click event.
     *
     */ onClick() {
        var self = this;
        if (self.activeItems.length > 0) {
            self.clearActiveItems();
            self.focus();
            return;
        }
        if (self.isFocused && self.isOpen) self.blur();
        else self.focus();
    }
    /**
     * @deprecated v1.7
     *
     */ onMouseDown() {}
    /**
     * Triggered when the value of the control has been changed.
     * This should propagate the event to the original DOM
     * input / select element.
     */ onChange() {
        (0, $809748f5374a81d3$export$bf5e5f0a0e9ca89d)(this.input, "input");
        (0, $809748f5374a81d3$export$bf5e5f0a0e9ca89d)(this.input, "change");
    }
    /**
     * Triggered on <input> paste.
     *
     */ onPaste(e) {
        var self = this;
        if (self.isInputHidden || self.isLocked) {
            (0, $c530096da023d8a6$export$fa3b29edae795ef4)(e);
            return;
        }
        // If a regex or string is included, this will split the pasted
        // input and create Items for each separate value
        if (!self.settings.splitOn) return;
        // Wait for pasted text to be recognized in value
        setTimeout(()=>{
            var pastedText = self.inputValue();
            if (!pastedText.match(self.settings.splitOn)) return;
            var splitInput = pastedText.trim().split(self.settings.splitOn);
            (0, $c530096da023d8a6$export$c1a059043cc9c119)(splitInput, (piece)=>{
                const hash = (0, $c530096da023d8a6$export$4e00787be681ebe0)(piece);
                if (hash) {
                    if (this.options[piece]) self.addItem(piece);
                    else self.createItem(piece);
                }
            });
        }, 0);
    }
    /**
     * Triggered on <input> keypress.
     *
     */ onKeyPress(e) {
        var self = this;
        if (self.isLocked) {
            (0, $c530096da023d8a6$export$fa3b29edae795ef4)(e);
            return;
        }
        var character = String.fromCharCode(e.keyCode || e.which);
        if (self.settings.create && self.settings.mode === "multi" && character === self.settings.delimiter) {
            self.createItem();
            (0, $c530096da023d8a6$export$fa3b29edae795ef4)(e);
            return;
        }
    }
    /**
     * Triggered on <input> keydown.
     *
     */ onKeyDown(e) {
        var self = this;
        self.ignoreHover = true;
        if (self.isLocked) {
            if (e.keyCode !== $00f1a247f08d3ec5$export$10f6869ed0a7d75b) (0, $c530096da023d8a6$export$fa3b29edae795ef4)(e);
            return;
        }
        switch(e.keyCode){
            // ctrl+A: select all
            case $00f1a247f08d3ec5$export$a62be707b936c199:
                if ((0, $c530096da023d8a6$export$e7bf60a870f429b0)($00f1a247f08d3ec5$export$7f209867a1e996c7, e)) {
                    if (self.control_input.value == "") {
                        (0, $c530096da023d8a6$export$fa3b29edae795ef4)(e);
                        self.selectAll();
                        return;
                    }
                }
                break;
            // esc: close dropdown
            case $00f1a247f08d3ec5$export$f0fcadf25a56f096:
                if (self.isOpen) {
                    (0, $c530096da023d8a6$export$fa3b29edae795ef4)(e, true);
                    self.close();
                }
                self.clearActiveItems();
                return;
            // down: open dropdown or move selection down
            case $00f1a247f08d3ec5$export$a80636c6f41931fe:
                if (!self.isOpen && self.hasOptions) self.open();
                else if (self.activeOption) {
                    let next = self.getAdjacent(self.activeOption, 1);
                    if (next) self.setActiveOption(next);
                }
                (0, $c530096da023d8a6$export$fa3b29edae795ef4)(e);
                return;
            // up: move selection up
            case $00f1a247f08d3ec5$export$390330c10ff2b9a1:
                if (self.activeOption) {
                    let prev = self.getAdjacent(self.activeOption, -1);
                    if (prev) self.setActiveOption(prev);
                }
                (0, $c530096da023d8a6$export$fa3b29edae795ef4)(e);
                return;
            // return: select active option
            case $00f1a247f08d3ec5$export$a38a780d07123ee:
                if (self.canSelect(self.activeOption)) {
                    self.onOptionSelect(e, self.activeOption);
                    (0, $c530096da023d8a6$export$fa3b29edae795ef4)(e);
                // if the option_create=null, the dropdown might be closed
                } else if (self.settings.create && self.createItem()) (0, $c530096da023d8a6$export$fa3b29edae795ef4)(e);
                else if (document.activeElement == self.control_input && self.isOpen) (0, $c530096da023d8a6$export$fa3b29edae795ef4)(e);
                return;
            // left: modifiy item selection to the left
            case $00f1a247f08d3ec5$export$fc4577f2a2af0ae3:
                self.advanceSelection(-1, e);
                return;
            // right: modifiy item selection to the right
            case $00f1a247f08d3ec5$export$c40f9845adc73fb5:
                self.advanceSelection(1, e);
                return;
            // tab: select active option and/or create item
            case $00f1a247f08d3ec5$export$10f6869ed0a7d75b:
                if (self.settings.selectOnTab) {
                    if (self.canSelect(self.activeOption)) {
                        self.onOptionSelect(e, self.activeOption);
                        // prevent default [tab] behaviour of jump to the next field
                        // if select isFull, then the dropdown won't be open and [tab] will work normally
                        (0, $c530096da023d8a6$export$fa3b29edae795ef4)(e);
                    }
                    if (self.settings.create && self.createItem()) (0, $c530096da023d8a6$export$fa3b29edae795ef4)(e);
                }
                return;
            // delete|backspace: delete items
            case $00f1a247f08d3ec5$export$7cd8f621642ff61e:
            case $00f1a247f08d3ec5$export$1fd7871db6041a84:
                self.deleteSelection(e);
                return;
        }
        // don't enter text in the control_input when active items are selected
        if (self.isInputHidden && !(0, $c530096da023d8a6$export$e7bf60a870f429b0)($00f1a247f08d3ec5$export$7f209867a1e996c7, e)) (0, $c530096da023d8a6$export$fa3b29edae795ef4)(e);
    }
    /**
     * Triggered on <input> keyup.
     *
     */ onInput(e) {
        if (this.isLocked) return;
        const value = this.inputValue();
        if (this.lastValue === value) return;
        this.lastValue = value;
        if (value == "") {
            this._onInput();
            return;
        }
        if (this.refreshTimeout) window.clearTimeout(this.refreshTimeout);
        this.refreshTimeout = (0, $c530096da023d8a6$export$83e74882c5df8fe1)(()=>{
            this.refreshTimeout = null;
            this._onInput();
        }, this.settings.refreshThrottle);
    }
    _onInput() {
        const value = this.lastValue;
        if (this.settings.shouldLoad.call(this, value)) this.load(value);
        this.refreshOptions();
        this.trigger("type", value);
    }
    /**
     * Triggered when the user rolls over
     * an option in the autocomplete dropdown menu.
     *
     */ onOptionHover(evt, option) {
        if (this.ignoreHover) return;
        this.setActiveOption(option, false);
    }
    /**
     * Triggered on <input> focus.
     *
     */ onFocus(e) {
        var self = this;
        var wasFocused = self.isFocused;
        if (self.isDisabled || self.isReadOnly) {
            self.blur();
            (0, $c530096da023d8a6$export$fa3b29edae795ef4)(e);
            return;
        }
        if (self.ignoreFocus) return;
        self.isFocused = true;
        if (self.settings.preload === "focus") self.preload();
        if (!wasFocused) self.trigger("focus");
        if (!self.activeItems.length) {
            self.inputState();
            self.refreshOptions(!!self.settings.openOnFocus);
        }
        self.refreshState();
    }
    /**
     * Triggered on <input> blur.
     *
     */ onBlur(e) {
        if (document.hasFocus() === false) return;
        var self = this;
        if (!self.isFocused) return;
        self.isFocused = false;
        self.ignoreFocus = false;
        var deactivate = ()=>{
            self.close();
            self.setActiveItem();
            self.setCaret(self.items.length);
            self.trigger("blur");
        };
        if (self.settings.create && self.settings.createOnBlur) self.createItem(null, deactivate);
        else deactivate();
    }
    /**
     * Triggered when the user clicks on an option
     * in the autocomplete dropdown menu.
     *
     */ onOptionSelect(evt, option) {
        var value, self = this;
        // should not be possible to trigger a option under a disabled optgroup
        if (option.parentElement && option.parentElement.matches("[data-disabled]")) return;
        if (option.classList.contains("create")) self.createItem(null, ()=>{
            if (self.settings.closeAfterSelect) self.close();
        });
        else {
            value = option.dataset.value;
            if (typeof value !== "undefined") {
                self.lastQuery = null;
                self.addItem(value);
                if (self.settings.closeAfterSelect) self.close();
                if (!self.settings.hideSelected && evt.type && /click/.test(evt.type)) self.setActiveOption(option);
            }
        }
    }
    /**
     * Return true if the given option can be selected
     *
     */ canSelect(option) {
        if (this.isOpen && option && this.dropdown_content.contains(option)) return true;
        return false;
    }
    /**
     * Triggered when the user clicks on an item
     * that has been selected.
     *
     */ onItemSelect(evt, item) {
        var self = this;
        if (!self.isLocked && self.settings.mode === "multi") {
            (0, $c530096da023d8a6$export$fa3b29edae795ef4)(evt);
            self.setActiveItem(item, evt);
            return true;
        }
        return false;
    }
    /**
     * Determines whether or not to invoke
     * the user-provided option provider / loader
     *
     * Note, there is a subtle difference between
     * this.canLoad() and this.settings.shouldLoad();
     *
     *	- settings.shouldLoad() is a user-input validator.
     *	When false is returned, the not_loading template
     *	will be added to the dropdown
     *
     *	- canLoad() is lower level validator that checks
     * 	the Tom Select instance. There is no inherent user
     *	feedback when canLoad returns false
     *
     */ canLoad(value) {
        if (!this.settings.load) return false;
        if (this.loadedSearches.hasOwnProperty(value)) return false;
        return true;
    }
    /**
     * Invokes the user-provided option provider / loader.
     *
     */ load(value) {
        const self = this;
        if (!self.canLoad(value)) return;
        (0, $809748f5374a81d3$export$34a1a93008ee28b5)(self.wrapper, self.settings.loadingClass);
        self.loading++;
        const callback = self.loadCallback.bind(self);
        self.settings.load.call(self, value, callback);
    }
    /**
     * Invoked by the user-provided option provider
     *
     */ loadCallback(options, optgroups) {
        const self = this;
        self.loading = Math.max(self.loading - 1, 0);
        self.lastQuery = null;
        self.clearActiveOption(); // when new results load, focus should be on first option
        self.setupOptions(options, optgroups);
        self.refreshOptions(self.isFocused && !self.isInputHidden);
        if (!self.loading) (0, $809748f5374a81d3$export$33233bd73e8de239)(self.wrapper, self.settings.loadingClass);
        self.trigger("load", options, optgroups);
    }
    preload() {
        var classList = this.wrapper.classList;
        if (classList.contains("preloaded")) return;
        classList.add("preloaded");
        this.load("");
    }
    /**
     * Sets the input field of the control to the specified value.
     *
     */ setTextboxValue(value = "") {
        var input = this.control_input;
        var changed = input.value !== value;
        if (changed) {
            input.value = value;
            (0, $809748f5374a81d3$export$bf5e5f0a0e9ca89d)(input, "update");
            this.lastValue = value;
        }
    }
    /**
     * Returns the value of the control. If multiple items
     * can be selected (e.g. <select multiple>), this returns
     * an array. If only one item can be selected, this
     * returns a string.
     *
     */ getValue() {
        if (this.is_select_tag && this.input.hasAttribute("multiple")) return this.items;
        return this.items.join(this.settings.delimiter);
    }
    /**
     * Resets the selected items to the given value.
     *
     */ setValue(value, silent) {
        var events = silent ? [] : [
            "change"
        ];
        (0, $c530096da023d8a6$export$2c9747a4208fe65f)(this, events, ()=>{
            this.clear(silent);
            this.addItems(value, silent);
        });
    }
    /**
     * Resets the number of max items to the given value
     *
     */ setMaxItems(value) {
        if (value === 0) value = null; //reset to unlimited items.
        this.settings.maxItems = value;
        this.refreshState();
    }
    /**
     * Sets the selected item.
     *
     */ setActiveItem(item, e) {
        var self = this;
        var eventName;
        var i, begin, end, swap;
        var last;
        if (self.settings.mode === "single") return;
        // clear the active selection
        if (!item) {
            self.clearActiveItems();
            if (self.isFocused) self.inputState();
            return;
        }
        // modify selection
        eventName = e && e.type.toLowerCase();
        if (eventName === "click" && (0, $c530096da023d8a6$export$e7bf60a870f429b0)("shiftKey", e) && self.activeItems.length) {
            last = self.getLastActive();
            begin = Array.prototype.indexOf.call(self.control.children, last);
            end = Array.prototype.indexOf.call(self.control.children, item);
            if (begin > end) {
                swap = begin;
                begin = end;
                end = swap;
            }
            for(i = begin; i <= end; i++){
                item = self.control.children[i];
                if (self.activeItems.indexOf(item) === -1) self.setActiveItemClass(item);
            }
            (0, $c530096da023d8a6$export$fa3b29edae795ef4)(e);
        } else if (eventName === "click" && (0, $c530096da023d8a6$export$e7bf60a870f429b0)($00f1a247f08d3ec5$export$7f209867a1e996c7, e) || eventName === "keydown" && (0, $c530096da023d8a6$export$e7bf60a870f429b0)("shiftKey", e)) {
            if (item.classList.contains("active")) self.removeActiveItem(item);
            else self.setActiveItemClass(item);
        } else {
            self.clearActiveItems();
            self.setActiveItemClass(item);
        }
        // ensure control has focus
        self.inputState();
        if (!self.isFocused) self.focus();
    }
    /**
     * Set the active and last-active classes
     *
     */ setActiveItemClass(item) {
        const self = this;
        const last_active = self.control.querySelector(".last-active");
        if (last_active) (0, $809748f5374a81d3$export$33233bd73e8de239)(last_active, "last-active");
        (0, $809748f5374a81d3$export$34a1a93008ee28b5)(item, "active last-active");
        self.trigger("item_select", item);
        if (self.activeItems.indexOf(item) == -1) self.activeItems.push(item);
    }
    /**
     * Remove active item
     *
     */ removeActiveItem(item) {
        var idx = this.activeItems.indexOf(item);
        this.activeItems.splice(idx, 1);
        (0, $809748f5374a81d3$export$33233bd73e8de239)(item, "active");
    }
    /**
     * Clears all the active items
     *
     */ clearActiveItems() {
        (0, $809748f5374a81d3$export$33233bd73e8de239)(this.activeItems, "active");
        this.activeItems = [];
    }
    /**
     * Sets the selected item in the dropdown menu
     * of available options.
     *
     */ setActiveOption(option, scroll = true) {
        if (option === this.activeOption) return;
        this.clearActiveOption();
        if (!option) return;
        this.activeOption = option;
        (0, $809748f5374a81d3$export$c609e428011345f3)(this.focus_node, {
            "aria-activedescendant": option.getAttribute("id")
        });
        (0, $809748f5374a81d3$export$c609e428011345f3)(option, {
            "aria-selected": "true"
        });
        (0, $809748f5374a81d3$export$34a1a93008ee28b5)(option, "active");
        if (scroll) this.scrollToOption(option);
    }
    /**
     * Sets the dropdown_content scrollTop to display the option
     *
     */ scrollToOption(option, behavior) {
        if (!option) return;
        const content = this.dropdown_content;
        const height_menu = content.clientHeight;
        const scrollTop = content.scrollTop || 0;
        const height_item = option.offsetHeight;
        const y = option.getBoundingClientRect().top - content.getBoundingClientRect().top + scrollTop;
        if (y + height_item > height_menu + scrollTop) this.scroll(y - height_menu + height_item, behavior);
        else if (y < scrollTop) this.scroll(y, behavior);
    }
    /**
     * Scroll the dropdown to the given position
     *
     */ scroll(scrollTop, behavior) {
        const content = this.dropdown_content;
        if (behavior) content.style.scrollBehavior = behavior;
        content.scrollTop = scrollTop;
        content.style.scrollBehavior = "";
    }
    /**
     * Clears the active option
     *
     */ clearActiveOption() {
        if (this.activeOption) {
            (0, $809748f5374a81d3$export$33233bd73e8de239)(this.activeOption, "active");
            (0, $809748f5374a81d3$export$c609e428011345f3)(this.activeOption, {
                "aria-selected": null
            });
        }
        this.activeOption = null;
        (0, $809748f5374a81d3$export$c609e428011345f3)(this.focus_node, {
            "aria-activedescendant": null
        });
    }
    /**
     * Selects all items (CTRL + A).
     */ selectAll() {
        const self = this;
        if (self.settings.mode === "single") return;
        const activeItems = self.controlChildren();
        if (!activeItems.length) return;
        self.inputState();
        self.close();
        self.activeItems = activeItems;
        (0, $c530096da023d8a6$export$c1a059043cc9c119)(activeItems, (item)=>{
            self.setActiveItemClass(item);
        });
    }
    /**
     * Determines if the control_input should be in a hidden or visible state
     *
     */ inputState() {
        var self = this;
        if (!self.control.contains(self.control_input)) return;
        (0, $809748f5374a81d3$export$c609e428011345f3)(self.control_input, {
            placeholder: self.settings.placeholder
        });
        if (self.activeItems.length > 0 || !self.isFocused && self.settings.hidePlaceholder && self.items.length > 0) {
            self.setTextboxValue();
            self.isInputHidden = true;
        } else {
            if (self.settings.hidePlaceholder && self.items.length > 0) (0, $809748f5374a81d3$export$c609e428011345f3)(self.control_input, {
                placeholder: ""
            });
            self.isInputHidden = false;
        }
        self.wrapper.classList.toggle("input-hidden", self.isInputHidden);
    }
    /**
     * Get the input value
     */ inputValue() {
        return this.control_input.value.trim();
    }
    /**
     * Gives the control focus.
     */ focus() {
        var self = this;
        if (self.isDisabled || self.isReadOnly) return;
        self.ignoreFocus = true;
        if (self.control_input.offsetWidth) self.control_input.focus();
        else self.focus_node.focus();
        setTimeout(()=>{
            self.ignoreFocus = false;
            self.onFocus();
        }, 0);
    }
    /**
     * Forces the control out of focus.
     *
     */ blur() {
        this.focus_node.blur();
        this.onBlur();
    }
    /**
     * Returns a function that scores an object
     * to show how good of a match it is to the
     * provided query.
     *
     * @return {function}
     */ getScoreFunction(query) {
        return this.sifter.getScoreFunction(query, this.getSearchOptions());
    }
    /**
     * Returns search options for sifter (the system
     * for scoring and sorting results).
     *
     * @see https://github.com/orchidjs/sifter.js
     * @return {object}
     */ getSearchOptions() {
        var settings = this.settings;
        var sort = settings.sortField;
        if (typeof settings.sortField === "string") sort = [
            {
                field: settings.sortField
            }
        ];
        return {
            fields: settings.searchField,
            conjunction: settings.searchConjunction,
            sort: sort,
            nesting: settings.nesting
        };
    }
    /**
     * Searches through available options and returns
     * a sorted array of matches.
     *
     */ search(query) {
        var result, calculateScore;
        var self = this;
        var options = this.getSearchOptions();
        // validate user-provided result scoring function
        if (self.settings.score) {
            calculateScore = self.settings.score.call(self, query);
            if (typeof calculateScore !== "function") throw new Error('Tom Select "score" setting must be a function that returns a function');
        }
        // perform search
        if (query !== self.lastQuery) {
            self.lastQuery = query;
            result = self.sifter.search(query, Object.assign(options, {
                score: calculateScore
            }));
            self.currentResults = result;
        } else result = Object.assign({}, self.currentResults);
        // filter out selected items
        if (self.settings.hideSelected) result.items = result.items.filter((item)=>{
            let hashed = (0, $c530096da023d8a6$export$4e00787be681ebe0)(item.id);
            return !(hashed && self.items.indexOf(hashed) !== -1);
        });
        return result;
    }
    /**
     * Refreshes the list of available options shown
     * in the autocomplete dropdown menu.
     *
     */ refreshOptions(triggerDropdown = true) {
        var i, j, k, n, optgroup, optgroups, html, has_create_option, active_group;
        var create;
        const groups = {};
        const groups_order = [];
        var self = this;
        var query = self.inputValue();
        const same_query = query === self.lastQuery || query == "" && self.lastQuery == null;
        var results = self.search(query);
        var active_option = null;
        var show_dropdown = self.settings.shouldOpen || false;
        var dropdown_content = self.dropdown_content;
        if (same_query) {
            active_option = self.activeOption;
            if (active_option) active_group = active_option.closest("[data-group]");
        }
        // build markup
        n = results.items.length;
        if (typeof self.settings.maxOptions === "number") n = Math.min(n, self.settings.maxOptions);
        if (n > 0) show_dropdown = true;
        // get fragment for group and the position of the group in group_order
        const getGroupFragment = (optgroup, order)=>{
            let group_order_i = groups[optgroup];
            if (group_order_i !== undefined) {
                let order_group = groups_order[group_order_i];
                if (order_group !== undefined) return [
                    group_order_i,
                    order_group.fragment
                ];
            }
            let group_fragment = document.createDocumentFragment();
            group_order_i = groups_order.length;
            groups_order.push({
                fragment: group_fragment,
                order: order,
                optgroup: optgroup
            });
            return [
                group_order_i,
                group_fragment
            ];
        };
        // render and group available options individually
        for(i = 0; i < n; i++){
            // get option dom element
            let item = results.items[i];
            if (!item) continue;
            let opt_value = item.id;
            let option = self.options[opt_value];
            if (option === undefined) continue;
            let opt_hash = (0, $c530096da023d8a6$export$e59fe9173a7a0aac)(opt_value);
            let option_el = self.getOption(opt_hash, true);
            // toggle 'selected' class
            if (!self.settings.hideSelected) option_el.classList.toggle("selected", self.items.includes(opt_hash));
            optgroup = option[self.settings.optgroupField] || "";
            optgroups = Array.isArray(optgroup) ? optgroup : [
                optgroup
            ];
            for(j = 0, k = optgroups && optgroups.length; j < k; j++){
                optgroup = optgroups[j];
                let order = option.$order;
                let self_optgroup = self.optgroups[optgroup];
                if (self_optgroup === undefined) optgroup = "";
                else order = self_optgroup.$order;
                const [group_order_i, group_fragment] = getGroupFragment(optgroup, order);
                // nodes can only have one parent, so if the option is in mutple groups, we need a clone
                if (j > 0) {
                    option_el = option_el.cloneNode(true);
                    (0, $809748f5374a81d3$export$c609e428011345f3)(option_el, {
                        id: option.$id + "-clone-" + j,
                        "aria-selected": null
                    });
                    option_el.classList.add("ts-cloned");
                    (0, $809748f5374a81d3$export$33233bd73e8de239)(option_el, "active");
                    // make sure we keep the activeOption in the same group
                    if (self.activeOption && self.activeOption.dataset.value == opt_value) {
                        if (active_group && active_group.dataset.group === optgroup.toString()) active_option = option_el;
                    }
                }
                group_fragment.appendChild(option_el);
                if (optgroup != "") groups[optgroup] = group_order_i;
            }
        }
        // sort optgroups
        if (self.settings.lockOptgroupOrder) groups_order.sort((a, b)=>{
            return a.order - b.order;
        });
        // render optgroup headers & join groups
        html = document.createDocumentFragment();
        (0, $c530096da023d8a6$export$c1a059043cc9c119)(groups_order, (group_order)=>{
            let group_fragment = group_order.fragment;
            let optgroup = group_order.optgroup;
            if (!group_fragment || !group_fragment.children.length) return;
            let group_heading = self.optgroups[optgroup];
            if (group_heading !== undefined) {
                let group_options = document.createDocumentFragment();
                let header = self.render("optgroup_header", group_heading);
                (0, $c530096da023d8a6$export$10d8903dec122b9d)(group_options, header);
                (0, $c530096da023d8a6$export$10d8903dec122b9d)(group_options, group_fragment);
                let group_html = self.render("optgroup", {
                    group: group_heading,
                    options: group_options
                });
                (0, $c530096da023d8a6$export$10d8903dec122b9d)(html, group_html);
            } else (0, $c530096da023d8a6$export$10d8903dec122b9d)(html, group_fragment);
        });
        dropdown_content.innerHTML = "";
        (0, $c530096da023d8a6$export$10d8903dec122b9d)(dropdown_content, html);
        // highlight matching terms inline
        if (self.settings.highlight) {
            (0, $0cd7c1360495bac5$export$7854b6fa03b6c2ef)(dropdown_content);
            if (results.query.length && results.tokens.length) (0, $c530096da023d8a6$export$c1a059043cc9c119)(results.tokens, (tok)=>{
                (0, $0cd7c1360495bac5$export$e4043f67d36cbb26)(dropdown_content, tok.regex);
            });
        }
        // helper method for adding templates to dropdown
        var add_template = (template)=>{
            let content = self.render(template, {
                input: query
            });
            if (content) {
                show_dropdown = true;
                dropdown_content.insertBefore(content, dropdown_content.firstChild);
            }
            return content;
        };
        // add loading message
        if (self.loading) add_template("loading");
        else if (!self.settings.shouldLoad.call(self, query)) add_template("not_loading");
        else if (results.items.length === 0) add_template("no_results");
        // add create option
        has_create_option = self.canCreate(query);
        if (has_create_option) create = add_template("option_create");
        // activate
        self.hasOptions = results.items.length > 0 || has_create_option;
        if (show_dropdown) {
            if (results.items.length > 0) {
                if (!active_option && self.settings.mode === "single" && self.items[0] != undefined) active_option = self.getOption(self.items[0]);
                if (!dropdown_content.contains(active_option)) {
                    let active_index = 0;
                    if (create && !self.settings.addPrecedence) active_index = 1;
                    active_option = self.selectable()[active_index];
                }
            } else if (create) active_option = create;
            if (triggerDropdown && !self.isOpen) {
                self.open();
                self.scrollToOption(active_option, "auto");
            }
            self.setActiveOption(active_option);
        } else {
            self.clearActiveOption();
            if (triggerDropdown && self.isOpen) self.close(false); // if create_option=null, we want the dropdown to close but not reset the textbox value
        }
    }
    /**
     * Return list of selectable options
     *
     */ selectable() {
        return this.dropdown_content.querySelectorAll("[data-selectable]");
    }
    /**
     * Adds an available option. If it already exists,
     * nothing will happen. Note: this does not refresh
     * the options list dropdown (use `refreshOptions`
     * for that).
     *
     * Usage:
     *
     *   this.addOption(data)
     *
     */ addOption(data, user_created = false) {
        const self = this;
        // @deprecated 1.7.7
        // use addOptions( array, user_created ) for adding multiple options
        if (Array.isArray(data)) {
            self.addOptions(data, user_created);
            return false;
        }
        const key = (0, $c530096da023d8a6$export$4e00787be681ebe0)(data[self.settings.valueField]);
        if (key === null || self.options.hasOwnProperty(key)) return false;
        data.$order = data.$order || ++self.order;
        data.$id = self.inputId + "-opt-" + data.$order;
        self.options[key] = data;
        self.lastQuery = null;
        if (user_created) {
            self.userOptions[key] = user_created;
            self.trigger("option_add", key, data);
        }
        return key;
    }
    /**
     * Add multiple options
     *
     */ addOptions(data, user_created = false) {
        (0, $c530096da023d8a6$export$c1a059043cc9c119)(data, (dat)=>{
            this.addOption(dat, user_created);
        });
    }
    /**
     * @deprecated 1.7.7
     */ registerOption(data) {
        return this.addOption(data);
    }
    /**
     * Registers an option group to the pool of option groups.
     *
     * @return {boolean|string}
     */ registerOptionGroup(data) {
        var key = (0, $c530096da023d8a6$export$4e00787be681ebe0)(data[this.settings.optgroupValueField]);
        if (key === null) return false;
        data.$order = data.$order || ++this.order;
        this.optgroups[key] = data;
        return key;
    }
    /**
     * Registers a new optgroup for options
     * to be bucketed into.
     *
     */ addOptionGroup(id, data) {
        var hashed_id;
        data[this.settings.optgroupValueField] = id;
        if (hashed_id = this.registerOptionGroup(data)) this.trigger("optgroup_add", hashed_id, data);
    }
    /**
     * Removes an existing option group.
     *
     */ removeOptionGroup(id) {
        if (this.optgroups.hasOwnProperty(id)) {
            delete this.optgroups[id];
            this.clearCache();
            this.trigger("optgroup_remove", id);
        }
    }
    /**
     * Clears all existing option groups.
     */ clearOptionGroups() {
        this.optgroups = {};
        this.clearCache();
        this.trigger("optgroup_clear");
    }
    /**
     * Updates an option available for selection. If
     * it is visible in the selected items or options
     * dropdown, it will be re-rendered automatically.
     *
     */ updateOption(value, data) {
        const self = this;
        var item_new;
        var index_item;
        const value_old = (0, $c530096da023d8a6$export$4e00787be681ebe0)(value);
        const value_new = (0, $c530096da023d8a6$export$4e00787be681ebe0)(data[self.settings.valueField]);
        // sanity checks
        if (value_old === null) return;
        const data_old = self.options[value_old];
        if (data_old == undefined) return;
        if (typeof value_new !== "string") throw new Error("Value must be set in option data");
        const option = self.getOption(value_old);
        const item = self.getItem(value_old);
        data.$order = data.$order || data_old.$order;
        delete self.options[value_old];
        // invalidate render cache
        // don't remove existing node yet, we'll remove it after replacing it
        self.uncacheValue(value_new);
        self.options[value_new] = data;
        // update the option if it's in the dropdown
        if (option) {
            if (self.dropdown_content.contains(option)) {
                const option_new = self._render("option", data);
                (0, $809748f5374a81d3$export$5542201de9311ab2)(option, option_new);
                if (self.activeOption === option) self.setActiveOption(option_new);
            }
            option.remove();
        }
        // update the item if we have one
        if (item) {
            index_item = self.items.indexOf(value_old);
            if (index_item !== -1) self.items.splice(index_item, 1, value_new);
            item_new = self._render("item", data);
            if (item.classList.contains("active")) (0, $809748f5374a81d3$export$34a1a93008ee28b5)(item_new, "active");
            (0, $809748f5374a81d3$export$5542201de9311ab2)(item, item_new);
        }
        // invalidate last query because we might have updated the sortField
        self.lastQuery = null;
    }
    /**
     * Removes a single option.
     *
     */ removeOption(value, silent) {
        const self = this;
        value = (0, $c530096da023d8a6$export$e59fe9173a7a0aac)(value);
        self.uncacheValue(value);
        delete self.userOptions[value];
        delete self.options[value];
        self.lastQuery = null;
        self.trigger("option_remove", value);
        self.removeItem(value, silent);
    }
    /**
     * Clears all options.
     */ clearOptions(filter) {
        const boundFilter = (filter || this.clearFilter).bind(this);
        this.loadedSearches = {};
        this.userOptions = {};
        this.clearCache();
        const selected = {};
        (0, $c530096da023d8a6$export$c1a059043cc9c119)(this.options, (option, key)=>{
            if (boundFilter(option, key)) selected[key] = option;
        });
        this.options = this.sifter.items = selected;
        this.lastQuery = null;
        this.trigger("option_clear");
    }
    /**
     * Used by clearOptions() to decide whether or not an option should be removed
     * Return true to keep an option, false to remove
     *
     */ clearFilter(option, value) {
        if (this.items.indexOf(value) >= 0) return true;
        return false;
    }
    /**
     * Returns the dom element of the option
     * matching the given value.
     *
     */ getOption(value, create = false) {
        const hashed = (0, $c530096da023d8a6$export$4e00787be681ebe0)(value);
        if (hashed === null) return null;
        const option = this.options[hashed];
        if (option != undefined) {
            if (option.$div) return option.$div;
            if (create) return this._render("option", option);
        }
        return null;
    }
    /**
     * Returns the dom element of the next or previous dom element of the same type
     * Note: adjacent options may not be adjacent DOM elements (optgroups)
     *
     */ getAdjacent(option, direction, type = "option") {
        var self = this, all;
        if (!option) return null;
        if (type == "item") all = self.controlChildren();
        else all = self.dropdown_content.querySelectorAll("[data-selectable]");
        for(let i = 0; i < all.length; i++){
            if (all[i] != option) continue;
            if (direction > 0) return all[i + 1];
            return all[i - 1];
        }
        return null;
    }
    /**
     * Returns the dom element of the item
     * matching the given value.
     *
     */ getItem(item) {
        if (typeof item == "object") return item;
        var value = (0, $c530096da023d8a6$export$4e00787be681ebe0)(item);
        return value !== null ? this.control.querySelector(`[data-value="${(0, $c530096da023d8a6$export$c34459d1aef61885)(value)}"]`) : null;
    }
    /**
     * "Selects" multiple items at once. Adds them to the list
     * at the current caret position.
     *
     */ addItems(values, silent) {
        var self = this;
        var items = Array.isArray(values) ? values : [
            values
        ];
        items = items.filter((x)=>self.items.indexOf(x) === -1);
        const last_item = items[items.length - 1];
        items.forEach((item)=>{
            self.isPending = item !== last_item;
            self.addItem(item, silent);
        });
    }
    /**
     * "Selects" an item. Adds it to the list
     * at the current caret position.
     *
     */ addItem(value, silent) {
        var events = silent ? [] : [
            "change",
            "dropdown_close"
        ];
        (0, $c530096da023d8a6$export$2c9747a4208fe65f)(this, events, ()=>{
            var item, wasFull;
            const self = this;
            const inputMode = self.settings.mode;
            const hashed = (0, $c530096da023d8a6$export$4e00787be681ebe0)(value);
            if (hashed && self.items.indexOf(hashed) !== -1) {
                if (inputMode === "single") self.close();
                if (inputMode === "single" || !self.settings.duplicates) return;
            }
            if (hashed === null || !self.options.hasOwnProperty(hashed)) return;
            if (inputMode === "single") self.clear(silent);
            if (inputMode === "multi" && self.isFull()) return;
            item = self._render("item", self.options[hashed]);
            if (self.control.contains(item)) item = item.cloneNode(true);
            wasFull = self.isFull();
            self.items.splice(self.caretPos, 0, hashed);
            self.insertAtCaret(item);
            if (self.isSetup) {
                // update menu / remove the option (if this is not one item being added as part of series)
                if (!self.isPending && self.settings.hideSelected) {
                    let option = self.getOption(hashed);
                    let next = self.getAdjacent(option, 1);
                    if (next) self.setActiveOption(next);
                }
                // refreshOptions after setActiveOption(),
                // otherwise setActiveOption() will be called by refreshOptions() with the wrong value
                if (!self.isPending && !self.settings.closeAfterSelect) self.refreshOptions(self.isFocused && inputMode !== "single");
                // hide the menu if the maximum number of items have been selected or no options are left
                if (self.settings.closeAfterSelect != false && self.isFull()) self.close();
                else if (!self.isPending) self.positionDropdown();
                self.trigger("item_add", hashed, item);
                if (!self.isPending) self.updateOriginalInput({
                    silent: silent
                });
            }
            if (!self.isPending || !wasFull && self.isFull()) {
                self.inputState();
                self.refreshState();
            }
        });
    }
    /**
     * Removes the selected item matching
     * the provided value.
     *
     */ removeItem(item = null, silent) {
        const self = this;
        item = self.getItem(item);
        if (!item) return;
        var i, idx;
        const value = item.dataset.value;
        i = (0, $809748f5374a81d3$export$e5c4cfab14d02c5d)(item);
        item.remove();
        if (item.classList.contains("active")) {
            idx = self.activeItems.indexOf(item);
            self.activeItems.splice(idx, 1);
            (0, $809748f5374a81d3$export$33233bd73e8de239)(item, "active");
        }
        self.items.splice(i, 1);
        self.lastQuery = null;
        if (!self.settings.persist && self.userOptions.hasOwnProperty(value)) self.removeOption(value, silent);
        if (i < self.caretPos) self.setCaret(self.caretPos - 1);
        self.updateOriginalInput({
            silent: silent
        });
        self.refreshState();
        self.positionDropdown();
        self.trigger("item_remove", value, item);
    }
    /**
     * Invokes the `create` method provided in the
     * TomSelect options that should provide the data
     * for the new item, given the user input.
     *
     * Once this completes, it will be added
     * to the item list.
     *
     */ createItem(input = null, callback = ()=>{}) {
        // triggerDropdown parameter @deprecated 2.1.1
        if (arguments.length === 3) callback = arguments[2];
        if (typeof callback != "function") callback = ()=>{};
        var self = this;
        var caret = self.caretPos;
        var output;
        input = input || self.inputValue();
        if (!self.canCreate(input)) {
            callback();
            return false;
        }
        self.lock();
        var created = false;
        var create = (data)=>{
            self.unlock();
            if (!data || typeof data !== "object") return callback();
            var value = (0, $c530096da023d8a6$export$4e00787be681ebe0)(data[self.settings.valueField]);
            if (typeof value !== "string") return callback();
            self.setTextboxValue();
            self.addOption(data, true);
            self.setCaret(caret);
            self.addItem(value);
            callback(data);
            created = true;
        };
        if (typeof self.settings.create === "function") output = self.settings.create.call(this, input, create);
        else output = {
            [self.settings.labelField]: input,
            [self.settings.valueField]: input
        };
        if (!created) create(output);
        return true;
    }
    /**
     * Re-renders the selected item lists.
     */ refreshItems() {
        var self = this;
        self.lastQuery = null;
        if (self.isSetup) self.addItems(self.items);
        self.updateOriginalInput();
        self.refreshState();
    }
    /**
     * Updates all state-dependent attributes
     * and CSS classes.
     */ refreshState() {
        const self = this;
        self.refreshValidityState();
        const isFull = self.isFull();
        const isLocked = self.isLocked;
        self.wrapper.classList.toggle("rtl", self.rtl);
        const wrap_classList = self.wrapper.classList;
        wrap_classList.toggle("focus", self.isFocused);
        wrap_classList.toggle("disabled", self.isDisabled);
        wrap_classList.toggle("readonly", self.isReadOnly);
        wrap_classList.toggle("required", self.isRequired);
        wrap_classList.toggle("invalid", !self.isValid);
        wrap_classList.toggle("locked", isLocked);
        wrap_classList.toggle("full", isFull);
        wrap_classList.toggle("input-active", self.isFocused && !self.isInputHidden);
        wrap_classList.toggle("dropdown-active", self.isOpen);
        wrap_classList.toggle("has-options", (0, $809748f5374a81d3$export$83b788b1a3698c03)(self.options));
        wrap_classList.toggle("has-items", self.items.length > 0);
    }
    /**
     * Update the `required` attribute of both input and control input.
     *
     * The `required` property needs to be activated on the control input
     * for the error to be displayed at the right place. `required` also
     * needs to be temporarily deactivated on the input since the input is
     * hidden and can't show errors.
     */ refreshValidityState() {
        var self = this;
        if (!self.input.validity) return;
        self.isValid = self.input.validity.valid;
        self.isInvalid = !self.isValid;
    }
    /**
     * Determines whether or not more items can be added
     * to the control without exceeding the user-defined maximum.
     *
     * @returns {boolean}
     */ isFull() {
        return this.settings.maxItems !== null && this.items.length >= this.settings.maxItems;
    }
    /**
     * Refreshes the original <select> or <input>
     * element to reflect the current state.
     *
     */ updateOriginalInput(opts = {}) {
        const self = this;
        var option, label;
        const empty_option = self.input.querySelector('option[value=""]');
        if (self.is_select_tag) {
            const selected = [];
            const has_selected = self.input.querySelectorAll("option:checked").length;
            function AddSelected(option_el, value, label) {
                if (!option_el) option_el = (0, $809748f5374a81d3$export$6c34eab6e99e0f60)('<option value="' + (0, $c530096da023d8a6$export$1e6f422d3087f91c)(value) + '">' + (0, $c530096da023d8a6$export$1e6f422d3087f91c)(label) + "</option>");
                // don't move empty option from top of list
                // fixes bug in firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1725293
                if (option_el != empty_option) self.input.append(option_el);
                selected.push(option_el);
                // marking empty option as selected can break validation
                // fixes https://github.com/orchidjs/tom-select/issues/303
                if (option_el != empty_option || has_selected > 0) option_el.selected = true;
                return option_el;
            }
            // unselect all selected options
            self.input.querySelectorAll("option:checked").forEach((option_el)=>{
                option_el.selected = false;
            });
            // nothing selected?
            if (self.items.length == 0 && self.settings.mode == "single") AddSelected(empty_option, "", "");
            else self.items.forEach((value)=>{
                option = self.options[value];
                label = option[self.settings.labelField] || "";
                if (selected.includes(option.$option)) {
                    const reuse_opt = self.input.querySelector(`option[value="${(0, $c530096da023d8a6$export$c34459d1aef61885)(value)}"]:not(:checked)`);
                    AddSelected(reuse_opt, value, label);
                } else option.$option = AddSelected(option.$option, value, label);
            });
        } else self.input.value = self.getValue();
        if (self.isSetup) {
            if (!opts.silent) self.trigger("change", self.getValue());
        }
    }
    /**
     * Shows the autocomplete dropdown containing
     * the available options.
     */ open() {
        var self = this;
        if (self.isLocked || self.isOpen || self.settings.mode === "multi" && self.isFull()) return;
        self.isOpen = true;
        (0, $809748f5374a81d3$export$c609e428011345f3)(self.focus_node, {
            "aria-expanded": "true"
        });
        self.refreshState();
        (0, $809748f5374a81d3$export$3a26aa64e59aeaff)(self.dropdown, {
            visibility: "hidden",
            display: "block"
        });
        self.positionDropdown();
        (0, $809748f5374a81d3$export$3a26aa64e59aeaff)(self.dropdown, {
            visibility: "visible",
            display: "block"
        });
        self.focus();
        self.trigger("dropdown_open", self.dropdown);
    }
    /**
     * Closes the autocomplete dropdown menu.
     */ close(setTextboxValue = true) {
        var self = this;
        var trigger = self.isOpen;
        if (setTextboxValue) {
            // before blur() to prevent form onchange event
            self.setTextboxValue();
            if (self.settings.mode === "single" && self.items.length) self.inputState();
        }
        self.isOpen = false;
        (0, $809748f5374a81d3$export$c609e428011345f3)(self.focus_node, {
            "aria-expanded": "false"
        });
        (0, $809748f5374a81d3$export$3a26aa64e59aeaff)(self.dropdown, {
            display: "none"
        });
        if (self.settings.hideSelected) self.clearActiveOption();
        self.refreshState();
        if (trigger) self.trigger("dropdown_close", self.dropdown);
    }
    /**
     * Calculates and applies the appropriate
     * position of the dropdown if dropdownParent = 'body'.
     * Otherwise, position is determined by css
     */ positionDropdown() {
        if (this.settings.dropdownParent !== "body") return;
        var context = this.control;
        var rect = context.getBoundingClientRect();
        var top = context.offsetHeight + rect.top + window.scrollY;
        var left = rect.left + window.scrollX;
        (0, $809748f5374a81d3$export$3a26aa64e59aeaff)(this.dropdown, {
            width: rect.width + "px",
            top: top + "px",
            left: left + "px"
        });
    }
    /**
     * Resets / clears all selected items
     * from the control.
     *
     */ clear(silent) {
        var self = this;
        if (!self.items.length) return;
        var items = self.controlChildren();
        (0, $c530096da023d8a6$export$c1a059043cc9c119)(items, (item)=>{
            self.removeItem(item, true);
        });
        self.inputState();
        if (!silent) self.updateOriginalInput();
        self.trigger("clear");
    }
    /**
     * A helper method for inserting an element
     * at the current caret position.
     *
     */ insertAtCaret(el) {
        const self = this;
        const caret = self.caretPos;
        const target = self.control;
        target.insertBefore(el, target.children[caret] || null);
        self.setCaret(caret + 1);
    }
    /**
     * Removes the current selected item(s).
     *
     */ deleteSelection(e) {
        var direction, selection, caret, tail;
        var self = this;
        direction = e && e.keyCode === $00f1a247f08d3ec5$export$7cd8f621642ff61e ? -1 : 1;
        selection = (0, $c530096da023d8a6$export$ca798a7e6e94638c)(self.control_input);
        // determine items that will be removed
        const rm_items = [];
        if (self.activeItems.length) {
            tail = (0, $809748f5374a81d3$export$22db25736bd2dc5f)(self.activeItems, direction);
            caret = (0, $809748f5374a81d3$export$e5c4cfab14d02c5d)(tail);
            if (direction > 0) caret++;
            (0, $c530096da023d8a6$export$c1a059043cc9c119)(self.activeItems, (item)=>rm_items.push(item));
        } else if ((self.isFocused || self.settings.mode === "single") && self.items.length) {
            const items = self.controlChildren();
            let rm_item;
            if (direction < 0 && selection.start === 0 && selection.length === 0) rm_item = items[self.caretPos - 1];
            else if (direction > 0 && selection.start === self.inputValue().length) rm_item = items[self.caretPos];
            if (rm_item !== undefined) rm_items.push(rm_item);
        }
        if (!self.shouldDelete(rm_items, e)) return false;
        (0, $c530096da023d8a6$export$fa3b29edae795ef4)(e, true);
        // perform removal
        if (typeof caret !== "undefined") self.setCaret(caret);
        while(rm_items.length)self.removeItem(rm_items.pop());
        self.inputState();
        self.positionDropdown();
        self.refreshOptions(false);
        return true;
    }
    /**
     * Return true if the items should be deleted
     */ shouldDelete(items, evt) {
        const values = items.map((item)=>item.dataset.value);
        // allow the callback to abort
        if (!values.length || typeof this.settings.onDelete === "function" && this.settings.onDelete(values, evt) === false) return false;
        return true;
    }
    /**
     * Selects the previous / next item (depending on the `direction` argument).
     *
     * > 0 - right
     * < 0 - left
     *
     */ advanceSelection(direction, e) {
        var last_active, adjacent, self = this;
        if (self.rtl) direction *= -1;
        if (self.inputValue().length) return;
        // add or remove to active items
        if ((0, $c530096da023d8a6$export$e7bf60a870f429b0)($00f1a247f08d3ec5$export$7f209867a1e996c7, e) || (0, $c530096da023d8a6$export$e7bf60a870f429b0)("shiftKey", e)) {
            last_active = self.getLastActive(direction);
            if (last_active) {
                if (!last_active.classList.contains("active")) adjacent = last_active;
                else adjacent = self.getAdjacent(last_active, direction, "item");
            } else if (direction > 0) adjacent = self.control_input.nextElementSibling;
            else adjacent = self.control_input.previousElementSibling;
            if (adjacent) {
                if (adjacent.classList.contains("active")) self.removeActiveItem(last_active);
                self.setActiveItemClass(adjacent); // mark as last_active !! after removeActiveItem() on last_active
            }
        // move caret to the left or right
        } else self.moveCaret(direction);
    }
    moveCaret(direction) {}
    /**
     * Get the last active item
     *
     */ getLastActive(direction) {
        let last_active = this.control.querySelector(".last-active");
        if (last_active) return last_active;
        var result = this.control.querySelectorAll(".active");
        if (result) return (0, $809748f5374a81d3$export$22db25736bd2dc5f)(result, direction);
    }
    /**
     * Moves the caret to the specified index.
     *
     * The input must be moved by leaving it in place and moving the
     * siblings, due to the fact that focus cannot be restored once lost
     * on mobile webkit devices
     *
     */ setCaret(new_pos) {
        this.caretPos = this.items.length;
    }
    /**
     * Return list of item dom elements
     *
     */ controlChildren() {
        return Array.from(this.control.querySelectorAll("[data-ts-item]"));
    }
    /**
     * Disables user input on the control. Used while
     * items are being asynchronously created.
     */ lock() {
        this.setLocked(true);
    }
    /**
     * Re-enables user input on the control.
     */ unlock() {
        this.setLocked(false);
    }
    /**
     * Disable or enable user input on the control
     */ setLocked(lock = this.isReadOnly || this.isDisabled) {
        this.isLocked = lock;
        this.refreshState();
    }
    /**
     * Disables user input on the control completely.
     * While disabled, it cannot receive focus.
     */ disable() {
        this.setDisabled(true);
        this.close();
    }
    /**
     * Enables the control so that it can respond
     * to focus and user input.
     */ enable() {
        this.setDisabled(false);
    }
    setDisabled(disabled) {
        this.focus_node.tabIndex = disabled ? -1 : this.tabIndex;
        this.isDisabled = disabled;
        this.input.disabled = disabled;
        this.control_input.disabled = disabled;
        this.setLocked();
    }
    setReadOnly(isReadOnly) {
        this.isReadOnly = isReadOnly;
        this.input.readOnly = isReadOnly;
        this.control_input.readOnly = isReadOnly;
        this.setLocked();
    }
    /**
     * Completely destroys the control and
     * unbinds all event listeners so that it can
     * be garbage collected.
     */ destroy() {
        var self = this;
        var revertSettings = self.revertSettings;
        self.trigger("destroy");
        self.off();
        self.wrapper.remove();
        self.dropdown.remove();
        self.input.innerHTML = revertSettings.innerHTML;
        self.input.tabIndex = revertSettings.tabIndex;
        (0, $809748f5374a81d3$export$33233bd73e8de239)(self.input, "tomselected", "ts-hidden-accessible");
        self._destroy();
        delete self.input.tomselect;
    }
    /**
     * A helper method for rendering "item" and
     * "option" templates, given the data.
     *
     */ render(templateName, data) {
        var id, html;
        const self = this;
        if (typeof this.settings.render[templateName] !== "function") return null;
        // render markup
        html = self.settings.render[templateName].call(this, data, (0, $c530096da023d8a6$export$1e6f422d3087f91c));
        if (!html) return null;
        html = (0, $809748f5374a81d3$export$6c34eab6e99e0f60)(html);
        // add mandatory attributes
        if (templateName === "option" || templateName === "option_create") {
            if (data[self.settings.disabledField]) (0, $809748f5374a81d3$export$c609e428011345f3)(html, {
                "aria-disabled": "true"
            });
            else (0, $809748f5374a81d3$export$c609e428011345f3)(html, {
                "data-selectable": ""
            });
        } else if (templateName === "optgroup") {
            id = data.group[self.settings.optgroupValueField];
            (0, $809748f5374a81d3$export$c609e428011345f3)(html, {
                "data-group": id
            });
            if (data.group[self.settings.disabledField]) (0, $809748f5374a81d3$export$c609e428011345f3)(html, {
                "data-disabled": ""
            });
        }
        if (templateName === "option" || templateName === "item") {
            const value = (0, $c530096da023d8a6$export$e59fe9173a7a0aac)(data[self.settings.valueField]);
            (0, $809748f5374a81d3$export$c609e428011345f3)(html, {
                "data-value": value
            });
            // make sure we have some classes if a template is overwritten
            if (templateName === "item") {
                (0, $809748f5374a81d3$export$34a1a93008ee28b5)(html, self.settings.itemClass);
                (0, $809748f5374a81d3$export$c609e428011345f3)(html, {
                    "data-ts-item": ""
                });
            } else {
                (0, $809748f5374a81d3$export$34a1a93008ee28b5)(html, self.settings.optionClass);
                (0, $809748f5374a81d3$export$c609e428011345f3)(html, {
                    role: "option",
                    id: data.$id
                });
                // update cache
                data.$div = html;
                self.options[value] = data;
            }
        }
        return html;
    }
    /**
     * Type guarded rendering
     *
     */ _render(templateName, data) {
        const html = this.render(templateName, data);
        if (html == null) throw "HTMLElement expected";
        return html;
    }
    /**
     * Clears the render cache for a template. If
     * no template is given, clears all render
     * caches.
     *
     */ clearCache() {
        (0, $c530096da023d8a6$export$c1a059043cc9c119)(this.options, (option)=>{
            if (option.$div) {
                option.$div.remove();
                delete option.$div;
            }
        });
    }
    /**
     * Removes a value from item and option caches
     *
     */ uncacheValue(value) {
        const option_el = this.getOption(value);
        if (option_el) option_el.remove();
    }
    /**
     * Determines whether or not to display the
     * create item prompt, given a user input.
     *
     */ canCreate(input) {
        return this.settings.create && input.length > 0 && this.settings.createFilter.call(this, input);
    }
    /**
     * Wraps this.`method` so that `new_fn` can be invoked 'before', 'after', or 'instead' of the original method
     *
     * this.hook('instead','onKeyDown',function( arg1, arg2 ...){
     *
     * });
     */ hook(when, method, new_fn) {
        var self = this;
        var orig_method = self[method];
        self[method] = function() {
            var result, result_new;
            if (when === "after") result = orig_method.apply(self, arguments);
            result_new = new_fn.apply(self, arguments);
            if (when === "instead") return result_new;
            if (when === "before") result = orig_method.apply(self, arguments);
            return result;
        };
    }
    constructor(input_arg, user_settings){
        super();
        this.order = 0;
        this.isOpen = false;
        this.isDisabled = false;
        this.isReadOnly = false;
        this.isInvalid = false; // @deprecated 1.8
        this.isValid = true;
        this.isLocked = false;
        this.isFocused = false;
        this.isInputHidden = false;
        this.isSetup = false;
        this.ignoreFocus = false;
        this.ignoreHover = false;
        this.hasOptions = false;
        this.lastValue = "";
        this.caretPos = 0;
        this.loading = 0;
        this.loadedSearches = {};
        this.activeOption = null;
        this.activeItems = [];
        this.optgroups = {};
        this.options = {};
        this.userOptions = {};
        this.items = [];
        this.refreshTimeout = null;
        $fd20d2d1040a5c5d$var$instance_i++;
        var dir;
        var input = (0, $809748f5374a81d3$export$6c34eab6e99e0f60)(input_arg);
        if (input.tomselect) throw new Error("Tom Select already initialized on this element");
        input.tomselect = this;
        // detect rtl environment
        var computedStyle = window.getComputedStyle && window.getComputedStyle(input, null);
        dir = computedStyle.getPropertyValue("direction");
        // setup default state
        const settings = (0, $b4af95e4536e8abe$export$2e2bcd8739ae039)(input, user_settings);
        this.settings = settings;
        this.input = input;
        this.tabIndex = input.tabIndex || 0;
        this.is_select_tag = input.tagName.toLowerCase() === "select";
        this.rtl = /rtl/i.test(dir);
        this.inputId = (0, $c530096da023d8a6$export$218c8c3169c024d2)(input, "tomselect-" + $fd20d2d1040a5c5d$var$instance_i);
        this.isRequired = input.required;
        // search system
        this.sifter = new (0, $b7675fb2ce40e3a1$export$6340a962c95c3b9)(this.options, {
            diacritics: settings.diacritics
        });
        // option-dependent defaults
        settings.mode = settings.mode || (settings.maxItems === 1 ? "single" : "multi");
        if (typeof settings.hideSelected !== "boolean") settings.hideSelected = settings.mode === "multi";
        if (typeof settings.hidePlaceholder !== "boolean") settings.hidePlaceholder = settings.mode !== "multi";
        // set up createFilter callback
        var filter = settings.createFilter;
        if (typeof filter !== "function") {
            if (typeof filter === "string") filter = new RegExp(filter);
            if (filter instanceof RegExp) settings.createFilter = (input)=>filter.test(input);
            else settings.createFilter = (value)=>{
                return this.settings.duplicates || !this.options[value];
            };
        }
        this.initializePlugins(settings.plugins);
        this.setupCallbacks();
        this.setupTemplates();
        // Create all elements
        const wrapper = (0, $809748f5374a81d3$export$6c34eab6e99e0f60)("<div>");
        const control = (0, $809748f5374a81d3$export$6c34eab6e99e0f60)("<div>");
        const dropdown = this._render("dropdown");
        const dropdown_content = (0, $809748f5374a81d3$export$6c34eab6e99e0f60)(`<div role="listbox" tabindex="-1">`);
        const classes = this.input.getAttribute("class") || "";
        const inputMode = settings.mode;
        var control_input;
        (0, $809748f5374a81d3$export$34a1a93008ee28b5)(wrapper, settings.wrapperClass, classes, inputMode);
        (0, $809748f5374a81d3$export$34a1a93008ee28b5)(control, settings.controlClass);
        (0, $c530096da023d8a6$export$10d8903dec122b9d)(wrapper, control);
        (0, $809748f5374a81d3$export$34a1a93008ee28b5)(dropdown, settings.dropdownClass, inputMode);
        if (settings.copyClassesToDropdown) (0, $809748f5374a81d3$export$34a1a93008ee28b5)(dropdown, classes);
        (0, $809748f5374a81d3$export$34a1a93008ee28b5)(dropdown_content, settings.dropdownContentClass);
        (0, $c530096da023d8a6$export$10d8903dec122b9d)(dropdown, dropdown_content);
        (0, $809748f5374a81d3$export$6c34eab6e99e0f60)(settings.dropdownParent || wrapper).appendChild(dropdown);
        // default controlInput
        if ((0, $809748f5374a81d3$export$c59330865007bdef)(settings.controlInput)) {
            control_input = (0, $809748f5374a81d3$export$6c34eab6e99e0f60)(settings.controlInput);
            // set attributes
            var attrs = [
                "autocorrect",
                "autocapitalize",
                "autocomplete",
                "spellcheck"
            ];
            (0, $c530096da023d8a6$export$c1a059043cc9c119)(attrs, (attr)=>{
                if (input.getAttribute(attr)) (0, $809748f5374a81d3$export$c609e428011345f3)(control_input, {
                    [attr]: input.getAttribute(attr)
                });
            });
            control_input.tabIndex = -1;
            control.appendChild(control_input);
            this.focus_node = control_input;
        // dom element
        } else if (settings.controlInput) {
            control_input = (0, $809748f5374a81d3$export$6c34eab6e99e0f60)(settings.controlInput);
            this.focus_node = control_input;
        } else {
            control_input = (0, $809748f5374a81d3$export$6c34eab6e99e0f60)("<input/>");
            this.focus_node = control;
        }
        this.wrapper = wrapper;
        this.dropdown = dropdown;
        this.dropdown_content = dropdown_content;
        this.control = control;
        this.control_input = control_input;
        this.setup();
    }
}


class $97ba5cb75142f565$export$2e2bcd8739ae039 {
    init() {
        this.ts = new (0, $fd20d2d1040a5c5d$export$2e2bcd8739ae039)(this._select, {
            // controlInput: null
            render: {
                item: function(data, escape) {
                    return "<div>" + (this.items.length > 0 ? ", " : "") + escape(data.text) + "</div>";
                }
            }
        });
        this._tags = app.createElement('<div class="js-custom-select-tags"></div>');
        this._tags = this._tags[0];
        this.ts.wrapper.insertAdjacentElement("afterend", this._tags);
    }
    bindEvents() {
        this.ts.on("change", this.updateTags.bind(this));
    }
    updateTags() {
        this._tags.innerHTML = "";
        let selectedOptions = Array.from(this._select.options).filter((option)=>option.selected);
        selectedOptions.forEach((el, i)=>{
            let _tag = app.createElement('<div class="js-custom-select-tag">' + el.innerText + '<i class="fa-regular fa-xmark"></i></div>');
            _tag = _tag[0];
            this._tags.appendChild(_tag);
            _tag.addEventListener("click", ()=>{
                this.ts.removeItem(el.value);
            });
        });
    }
    constructor(element){
        this._wrapper = element;
        this._select = this._wrapper.querySelector("select");
        this.init();
        this.bindEvents();
    }
}


var $58aa29bab4c853ac$export$c34bb18505e1e253 = [
    "onChange",
    "onClose",
    "onDayCreate",
    "onDestroy",
    "onKeyDown",
    "onMonthChange",
    "onOpen",
    "onParseConfig",
    "onReady",
    "onValueUpdate",
    "onYearChange",
    "onPreCalendarPosition"
];
var $58aa29bab4c853ac$export$ebe90cb607ad99e = {
    _disable: [],
    allowInput: false,
    allowInvalidPreload: false,
    altFormat: "F j, Y",
    altInput: false,
    altInputClass: "form-control input",
    animate: typeof window === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
    ariaDateFormat: "F j, Y",
    autoFillDefaultTime: true,
    clickOpens: true,
    closeOnSelect: true,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: false,
    enableSeconds: false,
    enableTime: false,
    errorHandler: function(err) {
        return typeof console !== "undefined" && console.warn(err);
    },
    getWeek: function(givenDate) {
        var date = new Date(givenDate.getTime());
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
        var week1 = new Date(date.getFullYear(), 0, 4);
        return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: false,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    monthSelectorType: "dropdown",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: false,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: undefined,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: false,
    showMonths: 1,
    static: false,
    time_24hr: false,
    weekNumbers: false,
    wrap: false
};


var $6f079fc1cfb44f50$export$33e6c23ebe2ee669 = {
    weekdays: {
        shorthand: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ]
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        longhand: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ]
    },
    daysInMonth: [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ],
    firstDayOfWeek: 0,
    ordinal: function(nth) {
        var s = nth % 100;
        if (s > 3 && s < 21) return "th";
        switch(s % 10){
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: [
        "AM",
        "PM"
    ],
    yearAriaLabel: "Year",
    monthAriaLabel: "Month",
    hourAriaLabel: "Hour",
    minuteAriaLabel: "Minute",
    time_24hr: false
};
var $6f079fc1cfb44f50$export$2e2bcd8739ae039 = $6f079fc1cfb44f50$export$33e6c23ebe2ee669;


var $32e60cc21ee14845$export$5d04458e2a6c373e = function(number, length) {
    if (length === void 0) length = 2;
    return ("000" + number).slice(length * -1);
};
var $32e60cc21ee14845$export$7d260a2a5f8bc19e = function(bool) {
    return bool === true ? 1 : 0;
};
function $32e60cc21ee14845$export$61fc7d43ac8f84b0(fn, wait) {
    var t;
    return function() {
        var _this = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function() {
            return fn.apply(_this, args);
        }, wait);
    };
}
var $32e60cc21ee14845$export$3131421a7d01b4fb = function(obj) {
    return obj instanceof Array ? obj : [
        obj
    ];
};


function $06166fcd929d8091$export$4a80062ca50b57c7(elem, className, bool) {
    if (bool === true) return elem.classList.add(className);
    elem.classList.remove(className);
}
function $06166fcd929d8091$export$c8a8987d4410bf2d(tag, className, content) {
    var e = window.document.createElement(tag);
    className = className || "";
    content = content || "";
    e.className = className;
    if (content !== undefined) e.textContent = content;
    return e;
}
function $06166fcd929d8091$export$51cfe97d637c237c(node) {
    while(node.firstChild)node.removeChild(node.firstChild);
}
function $06166fcd929d8091$export$25245567f53f158f(node, condition) {
    if (condition(node)) return node;
    else if (node.parentNode) return $06166fcd929d8091$export$25245567f53f158f(node.parentNode, condition);
    return undefined;
}
function $06166fcd929d8091$export$afe9d610a3284048(inputClassName, opts) {
    var wrapper = $06166fcd929d8091$export$c8a8987d4410bf2d("div", "numInputWrapper"), numInput = $06166fcd929d8091$export$c8a8987d4410bf2d("input", "numInput " + inputClassName), arrowUp = $06166fcd929d8091$export$c8a8987d4410bf2d("span", "arrowUp"), arrowDown = $06166fcd929d8091$export$c8a8987d4410bf2d("span", "arrowDown");
    if (navigator.userAgent.indexOf("MSIE 9.0") === -1) numInput.type = "number";
    else {
        numInput.type = "text";
        numInput.pattern = "\\d*";
    }
    if (opts !== undefined) for(var key in opts)numInput.setAttribute(key, opts[key]);
    wrapper.appendChild(numInput);
    wrapper.appendChild(arrowUp);
    wrapper.appendChild(arrowDown);
    return wrapper;
}
function $06166fcd929d8091$export$e58f029f0fbfdb29(event) {
    try {
        if (typeof event.composedPath === "function") {
            var path = event.composedPath();
            return path[0];
        }
        return event.target;
    } catch (error) {
        return event.target;
    }
}



var $e443451069a38044$var$doNothing = function() {
    return undefined;
};
var $e443451069a38044$export$27a2dd9af757e89c = function(monthNumber, shorthand, locale) {
    return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
};
var $e443451069a38044$export$9490b78b888a863f = {
    D: $e443451069a38044$var$doNothing,
    F: function(dateObj, monthName, locale) {
        dateObj.setMonth(locale.months.longhand.indexOf(monthName));
    },
    G: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    H: function(dateObj, hour) {
        dateObj.setHours(parseFloat(hour));
    },
    J: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    K: function(dateObj, amPM, locale) {
        dateObj.setHours(dateObj.getHours() % 12 + 12 * (0, $32e60cc21ee14845$export$7d260a2a5f8bc19e)(new RegExp(locale.amPM[1], "i").test(amPM)));
    },
    M: function(dateObj, shortMonth, locale) {
        dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
    },
    S: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    U: function(_, unixSeconds) {
        return new Date(parseFloat(unixSeconds) * 1000);
    },
    W: function(dateObj, weekNum, locale) {
        var weekNumber = parseInt(weekNum);
        var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
        date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
        return date;
    },
    Y: function(dateObj, year) {
        dateObj.setFullYear(parseFloat(year));
    },
    Z: function(_, ISODate) {
        return new Date(ISODate);
    },
    d: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    h: function(dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    i: function(dateObj, minutes) {
        dateObj.setMinutes(parseFloat(minutes));
    },
    j: function(dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    l: $e443451069a38044$var$doNothing,
    m: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    n: function(dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    s: function(dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    u: function(_, unixMillSeconds) {
        return new Date(parseFloat(unixMillSeconds));
    },
    w: $e443451069a38044$var$doNothing,
    y: function(dateObj, year) {
        dateObj.setFullYear(2000 + parseFloat(year));
    }
};
var $e443451069a38044$export$f5a8dc72fbf63af5 = {
    D: "",
    F: "",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    u: "(.+)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})"
};
var $e443451069a38044$export$55069460464ca7a9 = {
    Z: function(date) {
        return date.toISOString();
    },
    D: function(date, locale, options) {
        return locale.weekdays.shorthand[$e443451069a38044$export$55069460464ca7a9.w(date, locale, options)];
    },
    F: function(date, locale, options) {
        return $e443451069a38044$export$27a2dd9af757e89c($e443451069a38044$export$55069460464ca7a9.n(date, locale, options) - 1, false, locale);
    },
    G: function(date, locale, options) {
        return (0, $32e60cc21ee14845$export$5d04458e2a6c373e)($e443451069a38044$export$55069460464ca7a9.h(date, locale, options));
    },
    H: function(date) {
        return (0, $32e60cc21ee14845$export$5d04458e2a6c373e)(date.getHours());
    },
    J: function(date, locale) {
        return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
    },
    K: function(date, locale) {
        return locale.amPM[(0, $32e60cc21ee14845$export$7d260a2a5f8bc19e)(date.getHours() > 11)];
    },
    M: function(date, locale) {
        return $e443451069a38044$export$27a2dd9af757e89c(date.getMonth(), true, locale);
    },
    S: function(date) {
        return (0, $32e60cc21ee14845$export$5d04458e2a6c373e)(date.getSeconds());
    },
    U: function(date) {
        return date.getTime() / 1000;
    },
    W: function(date, _, options) {
        return options.getWeek(date);
    },
    Y: function(date) {
        return (0, $32e60cc21ee14845$export$5d04458e2a6c373e)(date.getFullYear(), 4);
    },
    d: function(date) {
        return (0, $32e60cc21ee14845$export$5d04458e2a6c373e)(date.getDate());
    },
    h: function(date) {
        return date.getHours() % 12 ? date.getHours() % 12 : 12;
    },
    i: function(date) {
        return (0, $32e60cc21ee14845$export$5d04458e2a6c373e)(date.getMinutes());
    },
    j: function(date) {
        return date.getDate();
    },
    l: function(date, locale) {
        return locale.weekdays.longhand[date.getDay()];
    },
    m: function(date) {
        return (0, $32e60cc21ee14845$export$5d04458e2a6c373e)(date.getMonth() + 1);
    },
    n: function(date) {
        return date.getMonth() + 1;
    },
    s: function(date) {
        return date.getSeconds();
    },
    u: function(date) {
        return date.getTime();
    },
    w: function(date) {
        return date.getDay();
    },
    y: function(date) {
        return String(date.getFullYear()).substring(2);
    }
};




var $385e5c50c70a2a66$export$ff1a0b75284ac636 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $58aa29bab4c853ac$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $6f079fc1cfb44f50$export$33e6c23ebe2ee669) : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
    return function(dateObj, frmt, overrideLocale) {
        var locale = overrideLocale || l10n;
        if (config.formatDate !== undefined && !isMobile) return config.formatDate(dateObj, frmt, locale);
        return frmt.split("").map(function(c, i, arr) {
            return (0, $e443451069a38044$export$55069460464ca7a9)[c] && arr[i - 1] !== "\\" ? (0, $e443451069a38044$export$55069460464ca7a9)[c](dateObj, locale, config) : c !== "\\" ? c : "";
        }).join("");
    };
};
var $385e5c50c70a2a66$export$cfa2ef2687faeda2 = function(_a) {
    var _b = _a.config, config = _b === void 0 ? (0, $58aa29bab4c853ac$export$ebe90cb607ad99e) : _b, _c = _a.l10n, l10n = _c === void 0 ? (0, $6f079fc1cfb44f50$export$33e6c23ebe2ee669) : _c;
    return function(date, givenFormat, timeless, customLocale) {
        if (date !== 0 && !date) return undefined;
        var locale = customLocale || l10n;
        var parsedDate;
        var dateOrig = date;
        if (date instanceof Date) parsedDate = new Date(date.getTime());
        else if (typeof date !== "string" && date.toFixed !== undefined) parsedDate = new Date(date);
        else if (typeof date === "string") {
            var format = givenFormat || (config || (0, $58aa29bab4c853ac$export$ebe90cb607ad99e)).dateFormat;
            var datestr = String(date).trim();
            if (datestr === "today") {
                parsedDate = new Date();
                timeless = true;
            } else if (config && config.parseDate) parsedDate = config.parseDate(date, format);
            else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) parsedDate = new Date(date);
            else {
                var matched = void 0, ops = [];
                for(var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++){
                    var token = format[i];
                    var isBackSlash = token === "\\";
                    var escaped = format[i - 1] === "\\" || isBackSlash;
                    if ((0, $e443451069a38044$export$f5a8dc72fbf63af5)[token] && !escaped) {
                        regexStr += (0, $e443451069a38044$export$f5a8dc72fbf63af5)[token];
                        var match = new RegExp(regexStr).exec(date);
                        if (match && (matched = true)) ops[token !== "Y" ? "push" : "unshift"]({
                            fn: (0, $e443451069a38044$export$9490b78b888a863f)[token],
                            val: match[++matchIndex]
                        });
                    } else if (!isBackSlash) regexStr += ".";
                }
                parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
                ops.forEach(function(_a) {
                    var fn = _a.fn, val = _a.val;
                    return parsedDate = fn(parsedDate, val, locale) || parsedDate;
                });
                parsedDate = matched ? parsedDate : undefined;
            }
        }
        if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
            config.errorHandler(new Error("Invalid date provided: " + dateOrig));
            return undefined;
        }
        if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
        return parsedDate;
    };
};
function $385e5c50c70a2a66$export$c4c806e061935577(date1, date2, timeless) {
    if (timeless === void 0) timeless = true;
    if (timeless !== false) return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
    return date1.getTime() - date2.getTime();
}
function $385e5c50c70a2a66$export$15d252ed5f5f8636(date1, date2) {
    return 3600 * (date1.getHours() - date2.getHours()) + 60 * (date1.getMinutes() - date2.getMinutes()) + date1.getSeconds() - date2.getSeconds();
}
var $385e5c50c70a2a66$export$a4d69fb5f2026c35 = function(ts, ts1, ts2) {
    return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
var $385e5c50c70a2a66$export$9fafc166baa96839 = function(hours, minutes, seconds) {
    return hours * 3600 + minutes * 60 + seconds;
};
var $385e5c50c70a2a66$export$a4ce0def660bfe9e = function(secondsSinceMidnight) {
    var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
    return [
        hours,
        minutes,
        secondsSinceMidnight - hours * 3600 - minutes * 60
    ];
};
var $385e5c50c70a2a66$export$1f34108aa9eb96ab = {
    DAY: 86400000
};
function $385e5c50c70a2a66$export$6df0e87d3fffbd14(config) {
    var hours = config.defaultHour;
    var minutes = config.defaultMinute;
    var seconds = config.defaultSeconds;
    if (config.minDate !== undefined) {
        var minHour = config.minDate.getHours();
        var minMinutes = config.minDate.getMinutes();
        var minSeconds = config.minDate.getSeconds();
        if (hours < minHour) hours = minHour;
        if (hours === minHour && minutes < minMinutes) minutes = minMinutes;
        if (hours === minHour && minutes === minMinutes && seconds < minSeconds) seconds = config.minDate.getSeconds();
    }
    if (config.maxDate !== undefined) {
        var maxHr = config.maxDate.getHours();
        var maxMinutes = config.maxDate.getMinutes();
        hours = Math.min(hours, maxHr);
        if (hours === maxHr) minutes = Math.min(maxMinutes, minutes);
        if (hours === maxHr && minutes === maxMinutes) seconds = config.maxDate.getSeconds();
    }
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}



"use strict";
if (typeof Object.assign !== "function") Object.assign = function(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (!target) throw TypeError("Cannot convert undefined or null to object");
    var _loop_1 = function(source) {
        if (source) Object.keys(source).forEach(function(key) {
            return target[key] = source[key];
        });
    };
    for(var _a = 0, args_1 = args; _a < args_1.length; _a++){
        var source = args_1[_a];
        _loop_1(source);
    }
    return target;
};


var $5b9a57937d2f7ba5$var$__assign = undefined && undefined.__assign || function() {
    $5b9a57937d2f7ba5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5b9a57937d2f7ba5$var$__assign.apply(this, arguments);
};
var $5b9a57937d2f7ba5$var$__spreadArrays = undefined && undefined.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
var $5b9a57937d2f7ba5$var$DEBOUNCED_CHANGE_MS = 300;
function $5b9a57937d2f7ba5$var$FlatpickrInstance(element, instanceConfig) {
    var self = {
        config: $5b9a57937d2f7ba5$var$__assign($5b9a57937d2f7ba5$var$__assign({}, (0, $58aa29bab4c853ac$export$ebe90cb607ad99e)), $5b9a57937d2f7ba5$var$flatpickr.defaultConfig),
        l10n: (0, $6f079fc1cfb44f50$export$2e2bcd8739ae039)
    };
    self.parseDate = (0, $385e5c50c70a2a66$export$cfa2ef2687faeda2)({
        config: self.config,
        l10n: self.l10n
    });
    self._handlers = [];
    self.pluginElements = [];
    self.loadedPlugins = [];
    self._bind = bind;
    self._setHoursFromDate = setHoursFromDate;
    self._positionCalendar = positionCalendar;
    self.changeMonth = changeMonth;
    self.changeYear = changeYear;
    self.clear = clear;
    self.close = close;
    self.onMouseOver = onMouseOver;
    self._createElement = (0, $06166fcd929d8091$export$c8a8987d4410bf2d);
    self.createDay = createDay;
    self.destroy = destroy;
    self.isEnabled = isEnabled;
    self.jumpToDate = jumpToDate;
    self.updateValue = updateValue;
    self.open = open;
    self.redraw = redraw;
    self.set = set;
    self.setDate = setDate;
    self.toggle = toggle;
    function setupHelperFunctions() {
        self.utils = {
            getDaysInMonth: function(month, yr) {
                if (month === void 0) month = self.currentMonth;
                if (yr === void 0) yr = self.currentYear;
                if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
                return self.l10n.daysInMonth[month];
            }
        };
    }
    function init() {
        self.element = self.input = element;
        self.isOpen = false;
        parseConfig();
        setupLocale();
        setupInputs();
        setupDates();
        setupHelperFunctions();
        if (!self.isMobile) build();
        bindEvents();
        if (self.selectedDates.length || self.config.noCalendar) {
            if (self.config.enableTime) setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj : undefined);
            updateValue(false);
        }
        setCalendarWidth();
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (!self.isMobile && isSafari) positionCalendar();
        triggerEvent("onReady");
    }
    function getClosestActiveElement() {
        var _a;
        return ((_a = self.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode()).activeElement || document.activeElement;
    }
    function bindToInstance(fn) {
        return fn.bind(self);
    }
    function setCalendarWidth() {
        var config = self.config;
        if (config.weekNumbers === false && config.showMonths === 1) return;
        else if (config.noCalendar !== true) window.requestAnimationFrame(function() {
            if (self.calendarContainer !== undefined) {
                self.calendarContainer.style.visibility = "hidden";
                self.calendarContainer.style.display = "block";
            }
            if (self.daysContainer !== undefined) {
                var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
                self.daysContainer.style.width = daysWidth + "px";
                self.calendarContainer.style.width = daysWidth + (self.weekWrapper !== undefined ? self.weekWrapper.offsetWidth : 0) + "px";
                self.calendarContainer.style.removeProperty("visibility");
                self.calendarContainer.style.removeProperty("display");
            }
        });
    }
    function updateTime(e) {
        if (self.selectedDates.length === 0) {
            var defaultDate = self.config.minDate === undefined || (0, $385e5c50c70a2a66$export$c4c806e061935577)(new Date(), self.config.minDate) >= 0 ? new Date() : new Date(self.config.minDate.getTime());
            var defaults = (0, $385e5c50c70a2a66$export$6df0e87d3fffbd14)(self.config);
            defaultDate.setHours(defaults.hours, defaults.minutes, defaults.seconds, defaultDate.getMilliseconds());
            self.selectedDates = [
                defaultDate
            ];
            self.latestSelectedDateObj = defaultDate;
        }
        if (e !== undefined && e.type !== "blur") timeWrapper(e);
        var prevValue = self._input.value;
        setHoursFromInputs();
        updateValue();
        if (self._input.value !== prevValue) self._debouncedChange();
    }
    function ampm2military(hour, amPM) {
        return hour % 12 + 12 * (0, $32e60cc21ee14845$export$7d260a2a5f8bc19e)(amPM === self.l10n.amPM[1]);
    }
    function military2ampm(hour) {
        switch(hour % 24){
            case 0:
            case 12:
                return 12;
            default:
                return hour % 12;
        }
    }
    function setHoursFromInputs() {
        if (self.hourElement === undefined || self.minuteElement === undefined) return;
        var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;
        if (self.amPM !== undefined) hours = ampm2military(hours, self.amPM.textContent);
        var limitMinHours = self.config.minTime !== undefined || self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && (0, $385e5c50c70a2a66$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.minDate, true) === 0;
        var limitMaxHours = self.config.maxTime !== undefined || self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && (0, $385e5c50c70a2a66$export$c4c806e061935577)(self.latestSelectedDateObj, self.config.maxDate, true) === 0;
        if (self.config.maxTime !== undefined && self.config.minTime !== undefined && self.config.minTime > self.config.maxTime) {
            var minBound = (0, $385e5c50c70a2a66$export$9fafc166baa96839)(self.config.minTime.getHours(), self.config.minTime.getMinutes(), self.config.minTime.getSeconds());
            var maxBound = (0, $385e5c50c70a2a66$export$9fafc166baa96839)(self.config.maxTime.getHours(), self.config.maxTime.getMinutes(), self.config.maxTime.getSeconds());
            var currentTime = (0, $385e5c50c70a2a66$export$9fafc166baa96839)(hours, minutes, seconds);
            if (currentTime > maxBound && currentTime < minBound) {
                var result = (0, $385e5c50c70a2a66$export$a4ce0def660bfe9e)(minBound);
                hours = result[0];
                minutes = result[1];
                seconds = result[2];
            }
        } else {
            if (limitMaxHours) {
                var maxTime = self.config.maxTime !== undefined ? self.config.maxTime : self.config.maxDate;
                hours = Math.min(hours, maxTime.getHours());
                if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
                if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
            }
            if (limitMinHours) {
                var minTime = self.config.minTime !== undefined ? self.config.minTime : self.config.minDate;
                hours = Math.max(hours, minTime.getHours());
                if (hours === minTime.getHours() && minutes < minTime.getMinutes()) minutes = minTime.getMinutes();
                if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
            }
        }
        setHours(hours, minutes, seconds);
    }
    function setHoursFromDate(dateObj) {
        var date = dateObj || self.latestSelectedDateObj;
        if (date && date instanceof Date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
    }
    function setHours(hours, minutes, seconds) {
        if (self.latestSelectedDateObj !== undefined) self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
        if (!self.hourElement || !self.minuteElement || self.isMobile) return;
        self.hourElement.value = (0, $32e60cc21ee14845$export$5d04458e2a6c373e)(!self.config.time_24hr ? (12 + hours) % 12 + 12 * (0, $32e60cc21ee14845$export$7d260a2a5f8bc19e)(hours % 12 === 0) : hours);
        self.minuteElement.value = (0, $32e60cc21ee14845$export$5d04458e2a6c373e)(minutes);
        if (self.amPM !== undefined) self.amPM.textContent = self.l10n.amPM[(0, $32e60cc21ee14845$export$7d260a2a5f8bc19e)(hours >= 12)];
        if (self.secondElement !== undefined) self.secondElement.value = (0, $32e60cc21ee14845$export$5d04458e2a6c373e)(seconds);
    }
    function onYearInput(event) {
        var eventTarget = (0, $06166fcd929d8091$export$e58f029f0fbfdb29)(event);
        var year = parseInt(eventTarget.value) + (event.delta || 0);
        if (year / 1000 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) changeYear(year);
    }
    function bind(element, event, handler, options) {
        if (event instanceof Array) return event.forEach(function(ev) {
            return bind(element, ev, handler, options);
        });
        if (element instanceof Array) return element.forEach(function(el) {
            return bind(el, event, handler, options);
        });
        element.addEventListener(event, handler, options);
        self._handlers.push({
            remove: function() {
                return element.removeEventListener(event, handler, options);
            }
        });
    }
    function triggerChange() {
        triggerEvent("onChange");
    }
    function bindEvents() {
        if (self.config.wrap) [
            "open",
            "close",
            "toggle",
            "clear"
        ].forEach(function(evt) {
            Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function(el) {
                return bind(el, "click", self[evt]);
            });
        });
        if (self.isMobile) {
            setupMobile();
            return;
        }
        var debouncedResize = (0, $32e60cc21ee14845$export$61fc7d43ac8f84b0)(onResize, 50);
        self._debouncedChange = (0, $32e60cc21ee14845$export$61fc7d43ac8f84b0)(triggerChange, $5b9a57937d2f7ba5$var$DEBOUNCED_CHANGE_MS);
        if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self.daysContainer, "mouseover", function(e) {
            if (self.config.mode === "range") onMouseOver((0, $06166fcd929d8091$export$e58f029f0fbfdb29)(e));
        });
        bind(self._input, "keydown", onKeyDown);
        if (self.calendarContainer !== undefined) bind(self.calendarContainer, "keydown", onKeyDown);
        if (!self.config.inline && !self.config.static) bind(window, "resize", debouncedResize);
        if (window.ontouchstart !== undefined) bind(window.document, "touchstart", documentClick);
        else bind(window.document, "mousedown", documentClick);
        bind(window.document, "focus", documentClick, {
            capture: true
        });
        if (self.config.clickOpens === true) {
            bind(self._input, "focus", self.open);
            bind(self._input, "click", self.open);
        }
        if (self.daysContainer !== undefined) {
            bind(self.monthNav, "click", onMonthNavClick);
            bind(self.monthNav, [
                "keyup",
                "increment"
            ], onYearInput);
            bind(self.daysContainer, "click", selectDate);
        }
        if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
            var selText = function(e) {
                return (0, $06166fcd929d8091$export$e58f029f0fbfdb29)(e).select();
            };
            bind(self.timeContainer, [
                "increment"
            ], updateTime);
            bind(self.timeContainer, "blur", updateTime, {
                capture: true
            });
            bind(self.timeContainer, "click", timeIncrement);
            bind([
                self.hourElement,
                self.minuteElement
            ], [
                "focus",
                "click"
            ], selText);
            if (self.secondElement !== undefined) bind(self.secondElement, "focus", function() {
                return self.secondElement && self.secondElement.select();
            });
            if (self.amPM !== undefined) bind(self.amPM, "click", function(e) {
                updateTime(e);
            });
        }
        if (self.config.allowInput) bind(self._input, "blur", onBlur);
    }
    function jumpToDate(jumpDate, triggerChange) {
        var jumpTo = jumpDate !== undefined ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
        var oldYear = self.currentYear;
        var oldMonth = self.currentMonth;
        try {
            if (jumpTo !== undefined) {
                self.currentYear = jumpTo.getFullYear();
                self.currentMonth = jumpTo.getMonth();
            }
        } catch (e) {
            e.message = "Invalid date supplied: " + jumpTo;
            self.config.errorHandler(e);
        }
        if (triggerChange && self.currentYear !== oldYear) {
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        if (triggerChange && (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) triggerEvent("onMonthChange");
        self.redraw();
    }
    function timeIncrement(e) {
        var eventTarget = (0, $06166fcd929d8091$export$e58f029f0fbfdb29)(e);
        if (~eventTarget.className.indexOf("arrow")) incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
    }
    function incrementNumInput(e, delta, inputElem) {
        var target = e && (0, $06166fcd929d8091$export$e58f029f0fbfdb29)(e);
        var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
        var event = createEvent("increment");
        event.delta = delta;
        input && input.dispatchEvent(event);
    }
    function build() {
        var fragment = window.document.createDocumentFragment();
        self.calendarContainer = (0, $06166fcd929d8091$export$c8a8987d4410bf2d)("div", "flatpickr-calendar");
        self.calendarContainer.tabIndex = -1;
        if (!self.config.noCalendar) {
            fragment.appendChild(buildMonthNav());
            self.innerContainer = (0, $06166fcd929d8091$export$c8a8987d4410bf2d)("div", "flatpickr-innerContainer");
            if (self.config.weekNumbers) {
                var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
                self.innerContainer.appendChild(weekWrapper);
                self.weekNumbers = weekNumbers;
                self.weekWrapper = weekWrapper;
            }
            self.rContainer = (0, $06166fcd929d8091$export$c8a8987d4410bf2d)("div", "flatpickr-rContainer");
            self.rContainer.appendChild(buildWeekdays());
            if (!self.daysContainer) {
                self.daysContainer = (0, $06166fcd929d8091$export$c8a8987d4410bf2d)("div", "flatpickr-days");
                self.daysContainer.tabIndex = -1;
            }
            buildDays();
            self.rContainer.appendChild(self.daysContainer);
            self.innerContainer.appendChild(self.rContainer);
            fragment.appendChild(self.innerContainer);
        }
        if (self.config.enableTime) fragment.appendChild(buildTime());
        (0, $06166fcd929d8091$export$4a80062ca50b57c7)(self.calendarContainer, "rangeMode", self.config.mode === "range");
        (0, $06166fcd929d8091$export$4a80062ca50b57c7)(self.calendarContainer, "animate", self.config.animate === true);
        (0, $06166fcd929d8091$export$4a80062ca50b57c7)(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
        self.calendarContainer.appendChild(fragment);
        var customAppend = self.config.appendTo !== undefined && self.config.appendTo.nodeType !== undefined;
        if (self.config.inline || self.config.static) {
            self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
            if (self.config.inline) {
                if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
                else if (self.config.appendTo !== undefined) self.config.appendTo.appendChild(self.calendarContainer);
            }
            if (self.config.static) {
                var wrapper = (0, $06166fcd929d8091$export$c8a8987d4410bf2d)("div", "flatpickr-wrapper");
                if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
                wrapper.appendChild(self.element);
                if (self.altInput) wrapper.appendChild(self.altInput);
                wrapper.appendChild(self.calendarContainer);
            }
        }
        if (!self.config.static && !self.config.inline) (self.config.appendTo !== undefined ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
    }
    function createDay(className, date, _dayNumber, i) {
        var dateIsEnabled = isEnabled(date, true), dayElement = (0, $06166fcd929d8091$export$c8a8987d4410bf2d)("span", className, date.getDate().toString());
        dayElement.dateObj = date;
        dayElement.$i = i;
        dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
        if (className.indexOf("hidden") === -1 && (0, $385e5c50c70a2a66$export$c4c806e061935577)(date, self.now) === 0) {
            self.todayDateElem = dayElement;
            dayElement.classList.add("today");
            dayElement.setAttribute("aria-current", "date");
        }
        if (dateIsEnabled) {
            dayElement.tabIndex = -1;
            if (isDateSelected(date)) {
                dayElement.classList.add("selected");
                self.selectedDateElem = dayElement;
                if (self.config.mode === "range") {
                    (0, $06166fcd929d8091$export$4a80062ca50b57c7)(dayElement, "startRange", self.selectedDates[0] && (0, $385e5c50c70a2a66$export$c4c806e061935577)(date, self.selectedDates[0], true) === 0);
                    (0, $06166fcd929d8091$export$4a80062ca50b57c7)(dayElement, "endRange", self.selectedDates[1] && (0, $385e5c50c70a2a66$export$c4c806e061935577)(date, self.selectedDates[1], true) === 0);
                    if (className === "nextMonthDay") dayElement.classList.add("inRange");
                }
            }
        } else dayElement.classList.add("flatpickr-disabled");
        if (self.config.mode === "range") {
            if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
        }
        if (self.weekNumbers && self.config.showMonths === 1 && className !== "prevMonthDay" && i % 7 === 6) self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
        triggerEvent("onDayCreate", dayElement);
        return dayElement;
    }
    function focusOnDayElem(targetNode) {
        targetNode.focus();
        if (self.config.mode === "range") onMouseOver(targetNode);
    }
    function getFirstAvailableDay(delta) {
        var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        for(var m = startMonth; m != endMonth; m += delta){
            var month = self.daysContainer.children[m];
            var startIndex = delta > 0 ? 0 : month.children.length - 1;
            var endIndex = delta > 0 ? month.children.length : -1;
            for(var i = startIndex; i != endIndex; i += delta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
            }
        }
        return undefined;
    }
    function getNextAvailableDay(current, delta) {
        var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self.currentMonth;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        var loopDelta = delta > 0 ? 1 : -1;
        for(var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta){
            var month = self.daysContainer.children[m];
            var startIndex = givenMonth - self.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
            var numMonthDays = month.children.length;
            for(var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta){
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
            }
        }
        self.changeMonth(loopDelta);
        focusOnDay(getFirstAvailableDay(loopDelta), 0);
        return undefined;
    }
    function focusOnDay(current, offset) {
        var activeElement = getClosestActiveElement();
        var dayFocused = isInView(activeElement || document.body);
        var startElem = current !== undefined ? current : dayFocused ? activeElement : self.selectedDateElem !== undefined && isInView(self.selectedDateElem) ? self.selectedDateElem : self.todayDateElem !== undefined && isInView(self.todayDateElem) ? self.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
        if (startElem === undefined) self._input.focus();
        else if (!dayFocused) focusOnDayElem(startElem);
        else getNextAvailableDay(startElem, offset);
    }
    function buildMonthDays(year, month) {
        var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
        var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
        var daysInMonth = self.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
        var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
        for(; dayNumber <= prevMonthDays; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
        for(dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++)days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
        for(var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++)days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
        var dayContainer = (0, $06166fcd929d8091$export$c8a8987d4410bf2d)("div", "dayContainer");
        dayContainer.appendChild(days);
        return dayContainer;
    }
    function buildDays() {
        if (self.daysContainer === undefined) return;
        (0, $06166fcd929d8091$export$51cfe97d637c237c)(self.daysContainer);
        if (self.weekNumbers) (0, $06166fcd929d8091$export$51cfe97d637c237c)(self.weekNumbers);
        var frag = document.createDocumentFragment();
        for(var i = 0; i < self.config.showMonths; i++){
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
        }
        self.daysContainer.appendChild(frag);
        self.days = self.daysContainer.firstChild;
        if (self.config.mode === "range" && self.selectedDates.length === 1) onMouseOver();
    }
    function buildMonthSwitch() {
        if (self.config.showMonths > 1 || self.config.monthSelectorType !== "dropdown") return;
        var shouldBuildMonth = function(month) {
            if (self.config.minDate !== undefined && self.currentYear === self.config.minDate.getFullYear() && month < self.config.minDate.getMonth()) return false;
            return !(self.config.maxDate !== undefined && self.currentYear === self.config.maxDate.getFullYear() && month > self.config.maxDate.getMonth());
        };
        self.monthsDropdownContainer.tabIndex = -1;
        self.monthsDropdownContainer.innerHTML = "";
        for(var i = 0; i < 12; i++){
            if (!shouldBuildMonth(i)) continue;
            var month = (0, $06166fcd929d8091$export$c8a8987d4410bf2d)("option", "flatpickr-monthDropdown-month");
            month.value = new Date(self.currentYear, i).getMonth().toString();
            month.textContent = (0, $e443451069a38044$export$27a2dd9af757e89c)(i, self.config.shorthandCurrentMonth, self.l10n);
            month.tabIndex = -1;
            if (self.currentMonth === i) month.selected = true;
            self.monthsDropdownContainer.appendChild(month);
        }
    }
    function buildMonth() {
        var container = (0, $06166fcd929d8091$export$c8a8987d4410bf2d)("div", "flatpickr-month");
        var monthNavFragment = window.document.createDocumentFragment();
        var monthElement;
        if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") monthElement = (0, $06166fcd929d8091$export$c8a8987d4410bf2d)("span", "cur-month");
        else {
            self.monthsDropdownContainer = (0, $06166fcd929d8091$export$c8a8987d4410bf2d)("select", "flatpickr-monthDropdown-months");
            self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
            bind(self.monthsDropdownContainer, "change", function(e) {
                var target = (0, $06166fcd929d8091$export$e58f029f0fbfdb29)(e);
                var selectedMonth = parseInt(target.value, 10);
                self.changeMonth(selectedMonth - self.currentMonth);
                triggerEvent("onMonthChange");
            });
            buildMonthSwitch();
            monthElement = self.monthsDropdownContainer;
        }
        var yearInput = (0, $06166fcd929d8091$export$afe9d610a3284048)("cur-year", {
            tabindex: "-1"
        });
        var yearElement = yearInput.getElementsByTagName("input")[0];
        yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
        if (self.config.minDate) yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
        if (self.config.maxDate) {
            yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
            yearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
        }
        var currentMonth = (0, $06166fcd929d8091$export$c8a8987d4410bf2d)("div", "flatpickr-current-month");
        currentMonth.appendChild(monthElement);
        currentMonth.appendChild(yearInput);
        monthNavFragment.appendChild(currentMonth);
        container.appendChild(monthNavFragment);
        return {
            container: container,
            yearElement: yearElement,
            monthElement: monthElement
        };
    }
    function buildMonths() {
        (0, $06166fcd929d8091$export$51cfe97d637c237c)(self.monthNav);
        self.monthNav.appendChild(self.prevMonthNav);
        if (self.config.showMonths) {
            self.yearElements = [];
            self.monthElements = [];
        }
        for(var m = self.config.showMonths; m--;){
            var month = buildMonth();
            self.yearElements.push(month.yearElement);
            self.monthElements.push(month.monthElement);
            self.monthNav.appendChild(month.container);
        }
        self.monthNav.appendChild(self.nextMonthNav);
    }
    function buildMonthNav() {
        self.monthNav = (0, $06166fcd929d8091$export$c8a8987d4410bf2d)("div", "flatpickr-months");
        self.yearElements = [];
        self.monthElements = [];
        self.prevMonthNav = (0, $06166fcd929d8091$export$c8a8987d4410bf2d)("span", "flatpickr-prev-month");
        self.prevMonthNav.innerHTML = self.config.prevArrow;
        self.nextMonthNav = (0, $06166fcd929d8091$export$c8a8987d4410bf2d)("span", "flatpickr-next-month");
        self.nextMonthNav.innerHTML = self.config.nextArrow;
        buildMonths();
        Object.defineProperty(self, "_hidePrevMonthArrow", {
            get: function() {
                return self.__hidePrevMonthArrow;
            },
            set: function(bool) {
                if (self.__hidePrevMonthArrow !== bool) {
                    (0, $06166fcd929d8091$export$4a80062ca50b57c7)(self.prevMonthNav, "flatpickr-disabled", bool);
                    self.__hidePrevMonthArrow = bool;
                }
            }
        });
        Object.defineProperty(self, "_hideNextMonthArrow", {
            get: function() {
                return self.__hideNextMonthArrow;
            },
            set: function(bool) {
                if (self.__hideNextMonthArrow !== bool) {
                    (0, $06166fcd929d8091$export$4a80062ca50b57c7)(self.nextMonthNav, "flatpickr-disabled", bool);
                    self.__hideNextMonthArrow = bool;
                }
            }
        });
        self.currentYearElement = self.yearElements[0];
        updateNavigationCurrentMonth();
        return self.monthNav;
    }
    function buildTime() {
        self.calendarContainer.classList.add("hasTime");
        if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
        var defaults = (0, $385e5c50c70a2a66$export$6df0e87d3fffbd14)(self.config);
        self.timeContainer = (0, $06166fcd929d8091$export$c8a8987d4410bf2d)("div", "flatpickr-time");
        self.timeContainer.tabIndex = -1;
        var separator = (0, $06166fcd929d8091$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":");
        var hourInput = (0, $06166fcd929d8091$export$afe9d610a3284048)("flatpickr-hour", {
            "aria-label": self.l10n.hourAriaLabel
        });
        self.hourElement = hourInput.getElementsByTagName("input")[0];
        var minuteInput = (0, $06166fcd929d8091$export$afe9d610a3284048)("flatpickr-minute", {
            "aria-label": self.l10n.minuteAriaLabel
        });
        self.minuteElement = minuteInput.getElementsByTagName("input")[0];
        self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
        self.hourElement.value = (0, $32e60cc21ee14845$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? defaults.hours : military2ampm(defaults.hours));
        self.minuteElement.value = (0, $32e60cc21ee14845$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : defaults.minutes);
        self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
        self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
        self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
        self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
        self.hourElement.setAttribute("maxlength", "2");
        self.minuteElement.setAttribute("min", "0");
        self.minuteElement.setAttribute("max", "59");
        self.minuteElement.setAttribute("maxlength", "2");
        self.timeContainer.appendChild(hourInput);
        self.timeContainer.appendChild(separator);
        self.timeContainer.appendChild(minuteInput);
        if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");
        if (self.config.enableSeconds) {
            self.timeContainer.classList.add("hasSeconds");
            var secondInput = (0, $06166fcd929d8091$export$afe9d610a3284048)("flatpickr-second");
            self.secondElement = secondInput.getElementsByTagName("input")[0];
            self.secondElement.value = (0, $32e60cc21ee14845$export$5d04458e2a6c373e)(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : defaults.seconds);
            self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
            self.secondElement.setAttribute("min", "0");
            self.secondElement.setAttribute("max", "59");
            self.secondElement.setAttribute("maxlength", "2");
            self.timeContainer.appendChild((0, $06166fcd929d8091$export$c8a8987d4410bf2d)("span", "flatpickr-time-separator", ":"));
            self.timeContainer.appendChild(secondInput);
        }
        if (!self.config.time_24hr) {
            self.amPM = (0, $06166fcd929d8091$export$c8a8987d4410bf2d)("span", "flatpickr-am-pm", self.l10n.amPM[(0, $32e60cc21ee14845$export$7d260a2a5f8bc19e)((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
            self.amPM.title = self.l10n.toggleTitle;
            self.amPM.tabIndex = -1;
            self.timeContainer.appendChild(self.amPM);
        }
        return self.timeContainer;
    }
    function buildWeekdays() {
        if (!self.weekdayContainer) self.weekdayContainer = (0, $06166fcd929d8091$export$c8a8987d4410bf2d)("div", "flatpickr-weekdays");
        else (0, $06166fcd929d8091$export$51cfe97d637c237c)(self.weekdayContainer);
        for(var i = self.config.showMonths; i--;){
            var container = (0, $06166fcd929d8091$export$c8a8987d4410bf2d)("div", "flatpickr-weekdaycontainer");
            self.weekdayContainer.appendChild(container);
        }
        updateWeekdays();
        return self.weekdayContainer;
    }
    function updateWeekdays() {
        if (!self.weekdayContainer) return;
        var firstDayOfWeek = self.l10n.firstDayOfWeek;
        var weekdays = $5b9a57937d2f7ba5$var$__spreadArrays(self.l10n.weekdays.shorthand);
        if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) weekdays = $5b9a57937d2f7ba5$var$__spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
        for(var i = self.config.showMonths; i--;)self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
    }
    function buildWeeks() {
        self.calendarContainer.classList.add("hasWeeks");
        var weekWrapper = (0, $06166fcd929d8091$export$c8a8987d4410bf2d)("div", "flatpickr-weekwrapper");
        weekWrapper.appendChild((0, $06166fcd929d8091$export$c8a8987d4410bf2d)("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
        var weekNumbers = (0, $06166fcd929d8091$export$c8a8987d4410bf2d)("div", "flatpickr-weeks");
        weekWrapper.appendChild(weekNumbers);
        return {
            weekWrapper: weekWrapper,
            weekNumbers: weekNumbers
        };
    }
    function changeMonth(value, isOffset) {
        if (isOffset === void 0) isOffset = true;
        var delta = isOffset ? value : value - self.currentMonth;
        if (delta < 0 && self._hidePrevMonthArrow === true || delta > 0 && self._hideNextMonthArrow === true) return;
        self.currentMonth += delta;
        if (self.currentMonth < 0 || self.currentMonth > 11) {
            self.currentYear += self.currentMonth > 11 ? 1 : -1;
            self.currentMonth = (self.currentMonth + 12) % 12;
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        buildDays();
        triggerEvent("onMonthChange");
        updateNavigationCurrentMonth();
    }
    function clear(triggerChangeEvent, toInitial) {
        if (triggerChangeEvent === void 0) triggerChangeEvent = true;
        if (toInitial === void 0) toInitial = true;
        self.input.value = "";
        if (self.altInput !== undefined) self.altInput.value = "";
        if (self.mobileInput !== undefined) self.mobileInput.value = "";
        self.selectedDates = [];
        self.latestSelectedDateObj = undefined;
        if (toInitial === true) {
            self.currentYear = self._initialDate.getFullYear();
            self.currentMonth = self._initialDate.getMonth();
        }
        if (self.config.enableTime === true) {
            var _a = (0, $385e5c50c70a2a66$export$6df0e87d3fffbd14)(self.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
            setHours(hours, minutes, seconds);
        }
        self.redraw();
        if (triggerChangeEvent) triggerEvent("onChange");
    }
    function close() {
        self.isOpen = false;
        if (!self.isMobile) {
            if (self.calendarContainer !== undefined) self.calendarContainer.classList.remove("open");
            if (self._input !== undefined) self._input.classList.remove("active");
        }
        triggerEvent("onClose");
    }
    function destroy() {
        if (self.config !== undefined) triggerEvent("onDestroy");
        for(var i = self._handlers.length; i--;)self._handlers[i].remove();
        self._handlers = [];
        if (self.mobileInput) {
            if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
            self.mobileInput = undefined;
        } else if (self.calendarContainer && self.calendarContainer.parentNode) {
            if (self.config.static && self.calendarContainer.parentNode) {
                var wrapper = self.calendarContainer.parentNode;
                wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
                if (wrapper.parentNode) {
                    while(wrapper.firstChild)wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                }
            } else self.calendarContainer.parentNode.removeChild(self.calendarContainer);
        }
        if (self.altInput) {
            self.input.type = "text";
            if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
            delete self.altInput;
        }
        if (self.input) {
            self.input.type = self.input._type;
            self.input.classList.remove("flatpickr-input");
            self.input.removeAttribute("readonly");
        }
        [
            "_showTimeInput",
            "latestSelectedDateObj",
            "_hideNextMonthArrow",
            "_hidePrevMonthArrow",
            "__hideNextMonthArrow",
            "__hidePrevMonthArrow",
            "isMobile",
            "isOpen",
            "selectedDateElem",
            "minDateHasTime",
            "maxDateHasTime",
            "days",
            "daysContainer",
            "_input",
            "_positionElement",
            "innerContainer",
            "rContainer",
            "monthNav",
            "todayDateElem",
            "calendarContainer",
            "weekdayContainer",
            "prevMonthNav",
            "nextMonthNav",
            "monthsDropdownContainer",
            "currentMonthElement",
            "currentYearElement",
            "navigationCurrentMonth",
            "selectedDateElem",
            "config"
        ].forEach(function(k) {
            try {
                delete self[k];
            } catch (_) {}
        });
    }
    function isCalendarElem(elem) {
        return self.calendarContainer.contains(elem);
    }
    function documentClick(e) {
        if (self.isOpen && !self.config.inline) {
            var eventTarget_1 = (0, $06166fcd929d8091$export$e58f029f0fbfdb29)(e);
            var isCalendarElement = isCalendarElem(eventTarget_1);
            var isInput = eventTarget_1 === self.input || eventTarget_1 === self.altInput || self.element.contains(eventTarget_1) || e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));
            var lostFocus = !isInput && !isCalendarElement && !isCalendarElem(e.relatedTarget);
            var isIgnored = !self.config.ignoredFocusElements.some(function(elem) {
                return elem.contains(eventTarget_1);
            });
            if (lostFocus && isIgnored) {
                if (self.config.allowInput) self.setDate(self._input.value, false, self.config.altInput ? self.config.altFormat : self.config.dateFormat);
                if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined && self.input.value !== "" && self.input.value !== undefined) updateTime();
                self.close();
                if (self.config && self.config.mode === "range" && self.selectedDates.length === 1) self.clear(false);
            }
        }
    }
    function changeYear(newYear) {
        if (!newYear || self.config.minDate && newYear < self.config.minDate.getFullYear() || self.config.maxDate && newYear > self.config.maxDate.getFullYear()) return;
        var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
        self.currentYear = newYearNum || self.currentYear;
        if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
        else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
        if (isNewYear) {
            self.redraw();
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
    }
    function isEnabled(date, timeless) {
        var _a;
        if (timeless === void 0) timeless = true;
        var dateToCheck = self.parseDate(date, undefined, timeless);
        if (self.config.minDate && dateToCheck && (0, $385e5c50c70a2a66$export$c4c806e061935577)(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0 || self.config.maxDate && dateToCheck && (0, $385e5c50c70a2a66$export$c4c806e061935577)(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0) return false;
        if (!self.config.enable && self.config.disable.length === 0) return true;
        if (dateToCheck === undefined) return false;
        var bool = !!self.config.enable, array = (_a = self.config.enable) !== null && _a !== void 0 ? _a : self.config.disable;
        for(var i = 0, d = void 0; i < array.length; i++){
            d = array[i];
            if (typeof d === "function" && d(dateToCheck)) return bool;
            else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime()) return bool;
            else if (typeof d === "string") {
                var parsed = self.parseDate(d, undefined, true);
                return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
            } else if (typeof d === "object" && dateToCheck !== undefined && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
        }
        return !bool;
    }
    function isInView(elem) {
        if (self.daysContainer !== undefined) return elem.className.indexOf("hidden") === -1 && elem.className.indexOf("flatpickr-disabled") === -1 && self.daysContainer.contains(elem);
        return false;
    }
    function onBlur(e) {
        var isInput = e.target === self._input;
        var valueChanged = self._input.value.trimEnd() !== getDateStr();
        if (isInput && valueChanged && !(e.relatedTarget && isCalendarElem(e.relatedTarget))) self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
    }
    function onKeyDown(e) {
        var eventTarget = (0, $06166fcd929d8091$export$e58f029f0fbfdb29)(e);
        var isInput = self.config.wrap ? element.contains(eventTarget) : eventTarget === self._input;
        var allowInput = self.config.allowInput;
        var allowKeydown = self.isOpen && (!allowInput || !isInput);
        var allowInlineKeydown = self.config.inline && isInput && !allowInput;
        if (e.keyCode === 13 && isInput) {
            if (allowInput) {
                self.setDate(self._input.value, true, eventTarget === self.altInput ? self.config.altFormat : self.config.dateFormat);
                self.close();
                return eventTarget.blur();
            } else self.open();
        } else if (isCalendarElem(eventTarget) || allowKeydown || allowInlineKeydown) {
            var isTimeObj = !!self.timeContainer && self.timeContainer.contains(eventTarget);
            switch(e.keyCode){
                case 13:
                    if (isTimeObj) {
                        e.preventDefault();
                        updateTime();
                        focusAndClose();
                    } else selectDate(e);
                    break;
                case 27:
                    e.preventDefault();
                    focusAndClose();
                    break;
                case 8:
                case 46:
                    if (isInput && !self.config.allowInput) {
                        e.preventDefault();
                        self.clear();
                    }
                    break;
                case 37:
                case 39:
                    if (!isTimeObj && !isInput) {
                        e.preventDefault();
                        var activeElement = getClosestActiveElement();
                        if (self.daysContainer !== undefined && (allowInput === false || activeElement && isInView(activeElement))) {
                            var delta_1 = e.keyCode === 39 ? 1 : -1;
                            if (!e.ctrlKey) focusOnDay(undefined, delta_1);
                            else {
                                e.stopPropagation();
                                changeMonth(delta_1);
                                focusOnDay(getFirstAvailableDay(1), 0);
                            }
                        }
                    } else if (self.hourElement) self.hourElement.focus();
                    break;
                case 38:
                case 40:
                    e.preventDefault();
                    var delta = e.keyCode === 40 ? 1 : -1;
                    if (self.daysContainer && eventTarget.$i !== undefined || eventTarget === self.input || eventTarget === self.altInput) {
                        if (e.ctrlKey) {
                            e.stopPropagation();
                            changeYear(self.currentYear - delta);
                            focusOnDay(getFirstAvailableDay(1), 0);
                        } else if (!isTimeObj) focusOnDay(undefined, delta * 7);
                    } else if (eventTarget === self.currentYearElement) changeYear(self.currentYear - delta);
                    else if (self.config.enableTime) {
                        if (!isTimeObj && self.hourElement) self.hourElement.focus();
                        updateTime(e);
                        self._debouncedChange();
                    }
                    break;
                case 9:
                    if (isTimeObj) {
                        var elems = [
                            self.hourElement,
                            self.minuteElement,
                            self.secondElement,
                            self.amPM
                        ].concat(self.pluginElements).filter(function(x) {
                            return x;
                        });
                        var i = elems.indexOf(eventTarget);
                        if (i !== -1) {
                            var target = elems[i + (e.shiftKey ? -1 : 1)];
                            e.preventDefault();
                            (target || self._input).focus();
                        }
                    } else if (!self.config.noCalendar && self.daysContainer && self.daysContainer.contains(eventTarget) && e.shiftKey) {
                        e.preventDefault();
                        self._input.focus();
                    }
                    break;
                default:
                    break;
            }
        }
        if (self.amPM !== undefined && eventTarget === self.amPM) switch(e.key){
            case self.l10n.amPM[0].charAt(0):
            case self.l10n.amPM[0].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[0];
                setHoursFromInputs();
                updateValue();
                break;
            case self.l10n.amPM[1].charAt(0):
            case self.l10n.amPM[1].charAt(0).toLowerCase():
                self.amPM.textContent = self.l10n.amPM[1];
                setHoursFromInputs();
                updateValue();
                break;
        }
        if (isInput || isCalendarElem(eventTarget)) triggerEvent("onKeyDown", e);
    }
    function onMouseOver(elem, cellClass) {
        if (cellClass === void 0) cellClass = "flatpickr-day";
        if (self.selectedDates.length !== 1 || elem && (!elem.classList.contains(cellClass) || elem.classList.contains("flatpickr-disabled"))) return;
        var hoverDate = elem ? elem.dateObj.getTime() : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
        var containsDisabled = false;
        var minRange = 0, maxRange = 0;
        for(var t = rangeStartDate; t < rangeEndDate; t += (0, $385e5c50c70a2a66$export$1f34108aa9eb96ab).DAY)if (!isEnabled(new Date(t), true)) {
            containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
            if (t < initialDate && (!minRange || t > minRange)) minRange = t;
            else if (t > initialDate && (!maxRange || t < maxRange)) maxRange = t;
        }
        var hoverableCells = Array.from(self.rContainer.querySelectorAll("*:nth-child(-n+" + self.config.showMonths + ") > ." + cellClass));
        hoverableCells.forEach(function(dayElem) {
            var date = dayElem.dateObj;
            var timestamp = date.getTime();
            var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;
            if (outOfRange) {
                dayElem.classList.add("notAllowed");
                [
                    "inRange",
                    "startRange",
                    "endRange"
                ].forEach(function(c) {
                    dayElem.classList.remove(c);
                });
                return;
            } else if (containsDisabled && !outOfRange) return;
            [
                "startRange",
                "inRange",
                "endRange",
                "notAllowed"
            ].forEach(function(c) {
                dayElem.classList.remove(c);
            });
            if (elem !== undefined) {
                elem.classList.add(hoverDate <= self.selectedDates[0].getTime() ? "startRange" : "endRange");
                if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");
                else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
                if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && (0, $385e5c50c70a2a66$export$a4d69fb5f2026c35)(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
            }
        });
    }
    function onResize() {
        if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();
    }
    function open(e, positionElement) {
        if (positionElement === void 0) positionElement = self._positionElement;
        if (self.isMobile === true) {
            if (e) {
                e.preventDefault();
                var eventTarget = (0, $06166fcd929d8091$export$e58f029f0fbfdb29)(e);
                if (eventTarget) eventTarget.blur();
            }
            if (self.mobileInput !== undefined) {
                self.mobileInput.focus();
                self.mobileInput.click();
            }
            triggerEvent("onOpen");
            return;
        } else if (self._input.disabled || self.config.inline) return;
        var wasOpen = self.isOpen;
        self.isOpen = true;
        if (!wasOpen) {
            self.calendarContainer.classList.add("open");
            self._input.classList.add("active");
            triggerEvent("onOpen");
            positionCalendar(positionElement);
        }
        if (self.config.enableTime === true && self.config.noCalendar === true) {
            if (self.config.allowInput === false && (e === undefined || !self.timeContainer.contains(e.relatedTarget))) setTimeout(function() {
                return self.hourElement.select();
            }, 50);
        }
    }
    function minMaxDateSetter(type) {
        return function(date) {
            var dateObj = self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat);
            var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
            if (dateObj !== undefined) self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
            if (self.selectedDates) {
                self.selectedDates = self.selectedDates.filter(function(d) {
                    return isEnabled(d);
                });
                if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
                updateValue();
            }
            if (self.daysContainer) {
                redraw();
                if (dateObj !== undefined) self.currentYearElement[type] = dateObj.getFullYear().toString();
                else self.currentYearElement.removeAttribute(type);
                self.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
            }
        };
    }
    function parseConfig() {
        var boolOpts = [
            "wrap",
            "weekNumbers",
            "allowInput",
            "allowInvalidPreload",
            "clickOpens",
            "time_24hr",
            "enableTime",
            "noCalendar",
            "altInput",
            "shorthandCurrentMonth",
            "inline",
            "static",
            "enableSeconds",
            "disableMobile"
        ];
        var userConfig = $5b9a57937d2f7ba5$var$__assign($5b9a57937d2f7ba5$var$__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
        var formats = {};
        self.config.parseDate = userConfig.parseDate;
        self.config.formatDate = userConfig.formatDate;
        Object.defineProperty(self.config, "enable", {
            get: function() {
                return self.config._enable;
            },
            set: function(dates) {
                self.config._enable = parseDateRules(dates);
            }
        });
        Object.defineProperty(self.config, "disable", {
            get: function() {
                return self.config._disable;
            },
            set: function(dates) {
                self.config._disable = parseDateRules(dates);
            }
        });
        var timeMode = userConfig.mode === "time";
        if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
            var defaultDateFormat = $5b9a57937d2f7ba5$var$flatpickr.defaultConfig.dateFormat || (0, $58aa29bab4c853ac$export$ebe90cb607ad99e).dateFormat;
            formats.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
        }
        if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
            var defaultAltFormat = $5b9a57937d2f7ba5$var$flatpickr.defaultConfig.altFormat || (0, $58aa29bab4c853ac$export$ebe90cb607ad99e).altFormat;
            formats.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
        }
        Object.defineProperty(self.config, "minDate", {
            get: function() {
                return self.config._minDate;
            },
            set: minMaxDateSetter("min")
        });
        Object.defineProperty(self.config, "maxDate", {
            get: function() {
                return self.config._maxDate;
            },
            set: minMaxDateSetter("max")
        });
        var minMaxTimeSetter = function(type) {
            return function(val) {
                self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
            };
        };
        Object.defineProperty(self.config, "minTime", {
            get: function() {
                return self.config._minTime;
            },
            set: minMaxTimeSetter("min")
        });
        Object.defineProperty(self.config, "maxTime", {
            get: function() {
                return self.config._maxTime;
            },
            set: minMaxTimeSetter("max")
        });
        if (userConfig.mode === "time") {
            self.config.noCalendar = true;
            self.config.enableTime = true;
        }
        Object.assign(self.config, formats, userConfig);
        for(var i = 0; i < boolOpts.length; i++)self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
        (0, $58aa29bab4c853ac$export$c34bb18505e1e253).filter(function(hook) {
            return self.config[hook] !== undefined;
        }).forEach(function(hook) {
            self.config[hook] = (0, $32e60cc21ee14845$export$3131421a7d01b4fb)(self.config[hook] || []).map(bindToInstance);
        });
        self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        for(var i = 0; i < self.config.plugins.length; i++){
            var pluginConf = self.config.plugins[i](self) || {};
            for(var key in pluginConf){
                if ((0, $58aa29bab4c853ac$export$c34bb18505e1e253).indexOf(key) > -1) self.config[key] = (0, $32e60cc21ee14845$export$3131421a7d01b4fb)(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
                else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
            }
        }
        if (!userConfig.altInputClass) self.config.altInputClass = getInputElem().className + " " + self.config.altInputClass;
        triggerEvent("onParseConfig");
    }
    function getInputElem() {
        return self.config.wrap ? element.querySelector("[data-input]") : element;
    }
    function setupLocale() {
        if (typeof self.config.locale !== "object" && typeof $5b9a57937d2f7ba5$var$flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
        self.l10n = $5b9a57937d2f7ba5$var$__assign($5b9a57937d2f7ba5$var$__assign({}, $5b9a57937d2f7ba5$var$flatpickr.l10ns.default), typeof self.config.locale === "object" ? self.config.locale : self.config.locale !== "default" ? $5b9a57937d2f7ba5$var$flatpickr.l10ns[self.config.locale] : undefined);
        (0, $e443451069a38044$export$f5a8dc72fbf63af5).D = "(" + self.l10n.weekdays.shorthand.join("|") + ")";
        (0, $e443451069a38044$export$f5a8dc72fbf63af5).l = "(" + self.l10n.weekdays.longhand.join("|") + ")";
        (0, $e443451069a38044$export$f5a8dc72fbf63af5).M = "(" + self.l10n.months.shorthand.join("|") + ")";
        (0, $e443451069a38044$export$f5a8dc72fbf63af5).F = "(" + self.l10n.months.longhand.join("|") + ")";
        (0, $e443451069a38044$export$f5a8dc72fbf63af5).K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
        var userConfig = $5b9a57937d2f7ba5$var$__assign($5b9a57937d2f7ba5$var$__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
        if (userConfig.time_24hr === undefined && $5b9a57937d2f7ba5$var$flatpickr.defaultConfig.time_24hr === undefined) self.config.time_24hr = self.l10n.time_24hr;
        self.formatDate = (0, $385e5c50c70a2a66$export$ff1a0b75284ac636)(self);
        self.parseDate = (0, $385e5c50c70a2a66$export$cfa2ef2687faeda2)({
            config: self.config,
            l10n: self.l10n
        });
    }
    function positionCalendar(customPositionElement) {
        if (typeof self.config.position === "function") return void self.config.position(self, customPositionElement);
        if (self.calendarContainer === undefined) return;
        triggerEvent("onPreCalendarPosition");
        var positionElement = customPositionElement || self._positionElement;
        var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, function(acc, child) {
            return acc + child.offsetHeight;
        }, 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
        var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
        (0, $06166fcd929d8091$export$4a80062ca50b57c7)(self.calendarContainer, "arrowTop", !showOnTop);
        (0, $06166fcd929d8091$export$4a80062ca50b57c7)(self.calendarContainer, "arrowBottom", showOnTop);
        if (self.config.inline) return;
        var left = window.pageXOffset + inputBounds.left;
        var isCenter = false;
        var isRight = false;
        if (configPosHorizontal === "center") {
            left -= (calendarWidth - inputBounds.width) / 2;
            isCenter = true;
        } else if (configPosHorizontal === "right") {
            left -= calendarWidth - inputBounds.width;
            isRight = true;
        }
        (0, $06166fcd929d8091$export$4a80062ca50b57c7)(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
        (0, $06166fcd929d8091$export$4a80062ca50b57c7)(self.calendarContainer, "arrowCenter", isCenter);
        (0, $06166fcd929d8091$export$4a80062ca50b57c7)(self.calendarContainer, "arrowRight", isRight);
        var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
        var rightMost = left + calendarWidth > window.document.body.offsetWidth;
        var centerMost = right + calendarWidth > window.document.body.offsetWidth;
        (0, $06166fcd929d8091$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", rightMost);
        if (self.config.static) return;
        self.calendarContainer.style.top = top + "px";
        if (!rightMost) {
            self.calendarContainer.style.left = left + "px";
            self.calendarContainer.style.right = "auto";
        } else if (!centerMost) {
            self.calendarContainer.style.left = "auto";
            self.calendarContainer.style.right = right + "px";
        } else {
            var doc = getDocumentStyleSheet();
            if (doc === undefined) return;
            var bodyWidth = window.document.body.offsetWidth;
            var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
            var centerBefore = ".flatpickr-calendar.centerMost:before";
            var centerAfter = ".flatpickr-calendar.centerMost:after";
            var centerIndex = doc.cssRules.length;
            var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
            (0, $06166fcd929d8091$export$4a80062ca50b57c7)(self.calendarContainer, "rightMost", false);
            (0, $06166fcd929d8091$export$4a80062ca50b57c7)(self.calendarContainer, "centerMost", true);
            doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
            self.calendarContainer.style.left = centerLeft + "px";
            self.calendarContainer.style.right = "auto";
        }
    }
    function getDocumentStyleSheet() {
        var editableSheet = null;
        for(var i = 0; i < document.styleSheets.length; i++){
            var sheet = document.styleSheets[i];
            if (!sheet.cssRules) continue;
            try {
                sheet.cssRules;
            } catch (err) {
                continue;
            }
            editableSheet = sheet;
            break;
        }
        return editableSheet != null ? editableSheet : createStyleSheet();
    }
    function createStyleSheet() {
        var style = document.createElement("style");
        document.head.appendChild(style);
        return style.sheet;
    }
    function redraw() {
        if (self.config.noCalendar || self.isMobile) return;
        buildMonthSwitch();
        updateNavigationCurrentMonth();
        buildDays();
    }
    function focusAndClose() {
        self._input.focus();
        if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) setTimeout(self.close, 0);
        else self.close();
    }
    function selectDate(e) {
        e.preventDefault();
        e.stopPropagation();
        var isSelectable = function(day) {
            return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("flatpickr-disabled") && !day.classList.contains("notAllowed");
        };
        var t = (0, $06166fcd929d8091$export$25245567f53f158f)((0, $06166fcd929d8091$export$e58f029f0fbfdb29)(e), isSelectable);
        if (t === undefined) return;
        var target = t;
        var selectedDate = self.latestSelectedDateObj = new Date(target.dateObj.getTime());
        var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth || selectedDate.getMonth() > self.currentMonth + self.config.showMonths - 1) && self.config.mode !== "range";
        self.selectedDateElem = target;
        if (self.config.mode === "single") self.selectedDates = [
            selectedDate
        ];
        else if (self.config.mode === "multiple") {
            var selectedIndex = isDateSelected(selectedDate);
            if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);
            else self.selectedDates.push(selectedDate);
        } else if (self.config.mode === "range") {
            if (self.selectedDates.length === 2) self.clear(false, false);
            self.latestSelectedDateObj = selectedDate;
            self.selectedDates.push(selectedDate);
            if ((0, $385e5c50c70a2a66$export$c4c806e061935577)(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
        }
        setHoursFromInputs();
        if (shouldChangeMonth) {
            var isNewYear = self.currentYear !== selectedDate.getFullYear();
            self.currentYear = selectedDate.getFullYear();
            self.currentMonth = selectedDate.getMonth();
            if (isNewYear) {
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            triggerEvent("onMonthChange");
        }
        updateNavigationCurrentMonth();
        buildDays();
        updateValue();
        if (!shouldChangeMonth && self.config.mode !== "range" && self.config.showMonths === 1) focusOnDayElem(target);
        else if (self.selectedDateElem !== undefined && self.hourElement === undefined) self.selectedDateElem && self.selectedDateElem.focus();
        if (self.hourElement !== undefined) self.hourElement !== undefined && self.hourElement.focus();
        if (self.config.closeOnSelect) {
            var single = self.config.mode === "single" && !self.config.enableTime;
            var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;
            if (single || range) focusAndClose();
        }
        triggerChange();
    }
    var CALLBACKS = {
        locale: [
            setupLocale,
            updateWeekdays
        ],
        showMonths: [
            buildMonths,
            setCalendarWidth,
            buildWeekdays
        ],
        minDate: [
            jumpToDate
        ],
        maxDate: [
            jumpToDate
        ],
        positionElement: [
            updatePositionElement
        ],
        clickOpens: [
            function() {
                if (self.config.clickOpens === true) {
                    bind(self._input, "focus", self.open);
                    bind(self._input, "click", self.open);
                } else {
                    self._input.removeEventListener("focus", self.open);
                    self._input.removeEventListener("click", self.open);
                }
            }
        ]
    };
    function set(option, value) {
        if (option !== null && typeof option === "object") {
            Object.assign(self.config, option);
            for(var key in option)if (CALLBACKS[key] !== undefined) CALLBACKS[key].forEach(function(x) {
                return x();
            });
        } else {
            self.config[option] = value;
            if (CALLBACKS[option] !== undefined) CALLBACKS[option].forEach(function(x) {
                return x();
            });
            else if ((0, $58aa29bab4c853ac$export$c34bb18505e1e253).indexOf(option) > -1) self.config[option] = (0, $32e60cc21ee14845$export$3131421a7d01b4fb)(value);
        }
        self.redraw();
        updateValue(true);
    }
    function setSelectedDate(inputDate, format) {
        var dates = [];
        if (inputDate instanceof Array) dates = inputDate.map(function(d) {
            return self.parseDate(d, format);
        });
        else if (inputDate instanceof Date || typeof inputDate === "number") dates = [
            self.parseDate(inputDate, format)
        ];
        else if (typeof inputDate === "string") switch(self.config.mode){
            case "single":
            case "time":
                dates = [
                    self.parseDate(inputDate, format)
                ];
                break;
            case "multiple":
                dates = inputDate.split(self.config.conjunction).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            case "range":
                dates = inputDate.split(self.l10n.rangeSeparator).map(function(date) {
                    return self.parseDate(date, format);
                });
                break;
            default:
                break;
        }
        else self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
        self.selectedDates = self.config.allowInvalidPreload ? dates : dates.filter(function(d) {
            return d instanceof Date && isEnabled(d, false);
        });
        if (self.config.mode === "range") self.selectedDates.sort(function(a, b) {
            return a.getTime() - b.getTime();
        });
    }
    function setDate(date, triggerChange, format) {
        if (triggerChange === void 0) triggerChange = false;
        if (format === void 0) format = self.config.dateFormat;
        if (date !== 0 && !date || date instanceof Array && date.length === 0) return self.clear(triggerChange);
        setSelectedDate(date, format);
        self.latestSelectedDateObj = self.selectedDates[self.selectedDates.length - 1];
        self.redraw();
        jumpToDate(undefined, triggerChange);
        setHoursFromDate();
        if (self.selectedDates.length === 0) self.clear(false);
        updateValue(triggerChange);
        if (triggerChange) triggerEvent("onChange");
    }
    function parseDateRules(arr) {
        return arr.slice().map(function(rule) {
            if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) return self.parseDate(rule, undefined, true);
            else if (rule && typeof rule === "object" && rule.from && rule.to) return {
                from: self.parseDate(rule.from, undefined),
                to: self.parseDate(rule.to, undefined)
            };
            return rule;
        }).filter(function(x) {
            return x;
        });
    }
    function setupDates() {
        self.selectedDates = [];
        self.now = self.parseDate(self.config.now) || new Date();
        var preloadedDate = self.config.defaultDate || ((self.input.nodeName === "INPUT" || self.input.nodeName === "TEXTAREA") && self.input.placeholder && self.input.value === self.input.placeholder ? null : self.input.value);
        if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
        self._initialDate = self.selectedDates.length > 0 ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
        self.currentYear = self._initialDate.getFullYear();
        self.currentMonth = self._initialDate.getMonth();
        if (self.selectedDates.length > 0) self.latestSelectedDateObj = self.selectedDates[0];
        if (self.config.minTime !== undefined) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
        if (self.config.maxTime !== undefined) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
        self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
        self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
    }
    function setupInputs() {
        self.input = getInputElem();
        if (!self.input) {
            self.config.errorHandler(new Error("Invalid input element specified"));
            return;
        }
        self.input._type = self.input.type;
        self.input.type = "text";
        self.input.classList.add("flatpickr-input");
        self._input = self.input;
        if (self.config.altInput) {
            self.altInput = (0, $06166fcd929d8091$export$c8a8987d4410bf2d)(self.input.nodeName, self.config.altInputClass);
            self._input = self.altInput;
            self.altInput.placeholder = self.input.placeholder;
            self.altInput.disabled = self.input.disabled;
            self.altInput.required = self.input.required;
            self.altInput.tabIndex = self.input.tabIndex;
            self.altInput.type = "text";
            self.input.setAttribute("type", "hidden");
            if (!self.config.static && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
        }
        if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
        updatePositionElement();
    }
    function updatePositionElement() {
        self._positionElement = self.config.positionElement || self._input;
    }
    function setupMobile() {
        var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
        self.mobileInput = (0, $06166fcd929d8091$export$c8a8987d4410bf2d)("input", self.input.className + " flatpickr-mobile");
        self.mobileInput.tabIndex = 1;
        self.mobileInput.type = inputType;
        self.mobileInput.disabled = self.input.disabled;
        self.mobileInput.required = self.input.required;
        self.mobileInput.placeholder = self.input.placeholder;
        self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
        if (self.selectedDates.length > 0) self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
        if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
        if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
        if (self.input.getAttribute("step")) self.mobileInput.step = String(self.input.getAttribute("step"));
        self.input.type = "hidden";
        if (self.altInput !== undefined) self.altInput.type = "hidden";
        try {
            if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
        } catch (_a) {}
        bind(self.mobileInput, "change", function(e) {
            self.setDate((0, $06166fcd929d8091$export$e58f029f0fbfdb29)(e).value, false, self.mobileFormatStr);
            triggerEvent("onChange");
            triggerEvent("onClose");
        });
    }
    function toggle(e) {
        if (self.isOpen === true) return self.close();
        self.open(e);
    }
    function triggerEvent(event, data) {
        if (self.config === undefined) return;
        var hooks = self.config[event];
        if (hooks !== undefined && hooks.length > 0) for(var i = 0; hooks[i] && i < hooks.length; i++)hooks[i](self.selectedDates, self.input.value, self, data);
        if (event === "onChange") {
            self.input.dispatchEvent(createEvent("change"));
            self.input.dispatchEvent(createEvent("input"));
        }
    }
    function createEvent(name) {
        var e = document.createEvent("Event");
        e.initEvent(name, true, true);
        return e;
    }
    function isDateSelected(date) {
        for(var i = 0; i < self.selectedDates.length; i++){
            var selectedDate = self.selectedDates[i];
            if (selectedDate instanceof Date && (0, $385e5c50c70a2a66$export$c4c806e061935577)(selectedDate, date) === 0) return "" + i;
        }
        return false;
    }
    function isDateInRange(date) {
        if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
        return (0, $385e5c50c70a2a66$export$c4c806e061935577)(date, self.selectedDates[0]) >= 0 && (0, $385e5c50c70a2a66$export$c4c806e061935577)(date, self.selectedDates[1]) <= 0;
    }
    function updateNavigationCurrentMonth() {
        if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
        self.yearElements.forEach(function(yearElement, i) {
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            if (self.config.showMonths > 1 || self.config.monthSelectorType === "static") self.monthElements[i].textContent = (0, $e443451069a38044$export$27a2dd9af757e89c)(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
            else self.monthsDropdownContainer.value = d.getMonth().toString();
            yearElement.value = d.getFullYear().toString();
        });
        self._hidePrevMonthArrow = self.config.minDate !== undefined && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
        self._hideNextMonthArrow = self.config.maxDate !== undefined && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
    }
    function getDateStr(specificFormat) {
        var format = specificFormat || (self.config.altInput ? self.config.altFormat : self.config.dateFormat);
        return self.selectedDates.map(function(dObj) {
            return self.formatDate(dObj, format);
        }).filter(function(d, i, arr) {
            return self.config.mode !== "range" || self.config.enableTime || arr.indexOf(d) === i;
        }).join(self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator);
    }
    function updateValue(triggerChange) {
        if (triggerChange === void 0) triggerChange = true;
        if (self.mobileInput !== undefined && self.mobileFormatStr) self.mobileInput.value = self.latestSelectedDateObj !== undefined ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
        self.input.value = getDateStr(self.config.dateFormat);
        if (self.altInput !== undefined) self.altInput.value = getDateStr(self.config.altFormat);
        if (triggerChange !== false) triggerEvent("onValueUpdate");
    }
    function onMonthNavClick(e) {
        var eventTarget = (0, $06166fcd929d8091$export$e58f029f0fbfdb29)(e);
        var isPrevMonth = self.prevMonthNav.contains(eventTarget);
        var isNextMonth = self.nextMonthNav.contains(eventTarget);
        if (isPrevMonth || isNextMonth) changeMonth(isPrevMonth ? -1 : 1);
        else if (self.yearElements.indexOf(eventTarget) >= 0) eventTarget.select();
        else if (eventTarget.classList.contains("arrowUp")) self.changeYear(self.currentYear + 1);
        else if (eventTarget.classList.contains("arrowDown")) self.changeYear(self.currentYear - 1);
    }
    function timeWrapper(e) {
        e.preventDefault();
        var isKeyDown = e.type === "keydown", eventTarget = (0, $06166fcd929d8091$export$e58f029f0fbfdb29)(e), input = eventTarget;
        if (self.amPM !== undefined && eventTarget === self.amPM) self.amPM.textContent = self.l10n.amPM[(0, $32e60cc21ee14845$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
        var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
        var newValue = curValue + step * delta;
        if (typeof input.value !== "undefined" && input.value.length === 2) {
            var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
            if (newValue < min) {
                newValue = max + newValue + (0, $32e60cc21ee14845$export$7d260a2a5f8bc19e)(!isHourElem) + ((0, $32e60cc21ee14845$export$7d260a2a5f8bc19e)(isHourElem) && (0, $32e60cc21ee14845$export$7d260a2a5f8bc19e)(!self.amPM));
                if (isMinuteElem) incrementNumInput(undefined, -1, self.hourElement);
            } else if (newValue > max) {
                newValue = input === self.hourElement ? newValue - max - (0, $32e60cc21ee14845$export$7d260a2a5f8bc19e)(!self.amPM) : min;
                if (isMinuteElem) incrementNumInput(undefined, 1, self.hourElement);
            }
            if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) self.amPM.textContent = self.l10n.amPM[(0, $32e60cc21ee14845$export$7d260a2a5f8bc19e)(self.amPM.textContent === self.l10n.amPM[0])];
            input.value = (0, $32e60cc21ee14845$export$5d04458e2a6c373e)(newValue);
        }
    }
    init();
    return self;
}
function $5b9a57937d2f7ba5$var$_flatpickr(nodeList, config) {
    var nodes = Array.prototype.slice.call(nodeList).filter(function(x) {
        return x instanceof HTMLElement;
    });
    var instances = [];
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        try {
            if (node.getAttribute("data-fp-omit") !== null) continue;
            if (node._flatpickr !== undefined) {
                node._flatpickr.destroy();
                node._flatpickr = undefined;
            }
            node._flatpickr = $5b9a57937d2f7ba5$var$FlatpickrInstance(node, config || {});
            instances.push(node._flatpickr);
        } catch (e) {
            console.error(e);
        }
    }
    return instances.length === 1 ? instances[0] : instances;
}
if (typeof HTMLElement !== "undefined" && typeof HTMLCollection !== "undefined" && typeof NodeList !== "undefined") {
    HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(config) {
        return $5b9a57937d2f7ba5$var$_flatpickr(this, config);
    };
    HTMLElement.prototype.flatpickr = function(config) {
        return $5b9a57937d2f7ba5$var$_flatpickr([
            this
        ], config);
    };
}
var $5b9a57937d2f7ba5$var$flatpickr = function(selector, config) {
    if (typeof selector === "string") return $5b9a57937d2f7ba5$var$_flatpickr(window.document.querySelectorAll(selector), config);
    else if (selector instanceof Node) return $5b9a57937d2f7ba5$var$_flatpickr([
        selector
    ], config);
    else return $5b9a57937d2f7ba5$var$_flatpickr(selector, config);
};
$5b9a57937d2f7ba5$var$flatpickr.defaultConfig = {};
$5b9a57937d2f7ba5$var$flatpickr.l10ns = {
    en: $5b9a57937d2f7ba5$var$__assign({}, (0, $6f079fc1cfb44f50$export$2e2bcd8739ae039)),
    default: $5b9a57937d2f7ba5$var$__assign({}, (0, $6f079fc1cfb44f50$export$2e2bcd8739ae039))
};
$5b9a57937d2f7ba5$var$flatpickr.localize = function(l10n) {
    $5b9a57937d2f7ba5$var$flatpickr.l10ns.default = $5b9a57937d2f7ba5$var$__assign($5b9a57937d2f7ba5$var$__assign({}, $5b9a57937d2f7ba5$var$flatpickr.l10ns.default), l10n);
};
$5b9a57937d2f7ba5$var$flatpickr.setDefaults = function(config) {
    $5b9a57937d2f7ba5$var$flatpickr.defaultConfig = $5b9a57937d2f7ba5$var$__assign($5b9a57937d2f7ba5$var$__assign({}, $5b9a57937d2f7ba5$var$flatpickr.defaultConfig), config);
};
$5b9a57937d2f7ba5$var$flatpickr.parseDate = (0, $385e5c50c70a2a66$export$cfa2ef2687faeda2)({});
$5b9a57937d2f7ba5$var$flatpickr.formatDate = (0, $385e5c50c70a2a66$export$ff1a0b75284ac636)({});
$5b9a57937d2f7ba5$var$flatpickr.compareDates = (0, $385e5c50c70a2a66$export$c4c806e061935577);
if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") jQuery.fn.flatpickr = function(config) {
    return $5b9a57937d2f7ba5$var$_flatpickr(this, config);
};
Date.prototype.fp_incr = function(days) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};
if (typeof window !== "undefined") window.flatpickr = $5b9a57937d2f7ba5$var$flatpickr;
var $5b9a57937d2f7ba5$export$2e2bcd8739ae039 = $5b9a57937d2f7ba5$var$flatpickr;


var $4b0b8fb52a405144$exports = {};
(function(global, factory) {
    factory($4b0b8fb52a405144$exports);
})($4b0b8fb52a405144$exports, function(exports1) {
    "use strict";
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
        l10ns: {}
    };
    var French = {
        firstDayOfWeek: 1,
        weekdays: {
            shorthand: [
                "dim",
                "lun",
                "mar",
                "mer",
                "jeu",
                "ven",
                "sam"
            ],
            longhand: [
                "dimanche",
                "lundi",
                "mardi",
                "mercredi",
                "jeudi",
                "vendredi",
                "samedi"
            ]
        },
        months: {
            shorthand: [
                "janv",
                "f\xe9vr",
                "mars",
                "avr",
                "mai",
                "juin",
                "juil",
                "ao\xfbt",
                "sept",
                "oct",
                "nov",
                "d\xe9c"
            ],
            longhand: [
                "janvier",
                "f\xe9vrier",
                "mars",
                "avril",
                "mai",
                "juin",
                "juillet",
                "ao\xfbt",
                "septembre",
                "octobre",
                "novembre",
                "d\xe9cembre"
            ]
        },
        ordinal: function(nth) {
            if (nth > 1) return "";
            return "er";
        },
        rangeSeparator: " au ",
        weekAbbreviation: "Sem",
        scrollTitle: "D\xe9filer pour augmenter la valeur",
        toggleTitle: "Cliquer pour basculer",
        time_24hr: true
    };
    fp.l10ns.fr = French;
    var fr = fp.l10ns;
    exports1.French = French;
    exports1.default = fr;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});


class $923309b8b2bbee62$export$2e2bcd8739ae039 {
    init() {
        this.picker = (0, $5b9a57937d2f7ba5$export$2e2bcd8739ae039)(this._input, {
            locale: (0, $4b0b8fb52a405144$exports.French),
            dateFormat: "d-m-Y"
        });
    }
    constructor(element){
        this._wrapper = element;
        this._input = this._wrapper.querySelector("input");
        this.init();
    }
}



class $686834993310d117$export$2e2bcd8739ae039 {
    init() {
        this.picker = (0, $5b9a57937d2f7ba5$export$2e2bcd8739ae039)(this._input, {
            enableTime: true,
            noCalendar: true,
            dateFormat: "H:i",
            time_24hr: true
        });
    }
    constructor(element){
        this._wrapper = element;
        this._input = this._wrapper.querySelector("input");
        this.init();
    }
}


class $7bd45705ff25b3e9$export$2e2bcd8739ae039 {
    bindEvents() {
        this._input.addEventListener("change", ()=>{
            if (this._input.checked) {
                this._target.disabled = false;
                this._targetLabel.classList.remove("disabled");
            } else {
                this._target.disabled = true;
                this._target.value = "";
                this._targetLabel.classList.add("disabled");
            }
        });
    }
    constructor(element){
        this._input = element;
        this._target = document.querySelector('input[name="' + this._input.getAttribute("data-target") + '"]');
        this._targetLabel = document.querySelector('label[for="' + this._input.getAttribute("data-target") + '"]');
        this.bindEvents();
    }
}


class $790b48f623a35f09$export$2e2bcd8739ae039 {
    bindEvents() {
        this._wrapper.addEventListener("dragover", (e)=>{
            this._wrapper.classList.add("dragover");
        });
        this._wrapper.addEventListener("dragleave", (e)=>{
            this._wrapper.classList.remove("dragover");
        });
        this._wrapper.addEventListener("drop", (e)=>{
            this._wrapper.classList.remove("dragover");
        });
        this._button.addEventListener("click", (e)=>{
            e.preventDefault();
            this._input.click();
        });
        this._input.addEventListener("change", (e)=>{
            if (this.isMultiple) {
                Array.from(this._input.files).forEach((file)=>{
                    this.files.push(file);
                });
                this.updateFileList();
            } else this.updateTemplate();
        });
    }
    updateFileList() {
        this._list.innerHTML = "";
        this.files.forEach((item, n)=>{
            let element = app.createElement(`
            <div class="input-upload__list__item">
                <div class="input-upload__list__item__left">
                    <i class="fa-regular fa-file"></i><span>${item.name}</span>
                </div> 
                <div class="input-upload__list__item__right">
                <button class="js-input-upload-remove"><i class="fa-regular fa-trash"></i><span>Supprimer ce document</span></button>
                </div>
            </div>`);
            element = element[0];
            let _button = element.querySelector(".js-input-upload-remove");
            _button.addEventListener("click", (e)=>{
                e.preventDefault();
                this.removeFile(n);
            });
            this._list.appendChild(element);
        });
        this.syncWithInput();
    //
    // console.log(this._input.files);
    }
    removeFile(index) {
        this.files.splice(index, 1);
        this.syncWithInput();
        this.updateFileList();
    }
    syncWithInput() {
        const dataTransfer = new DataTransfer();
        this.files.forEach((file)=>{
            dataTransfer.items.add(file);
        });
        this._input.files = dataTransfer.files;
        let customEvent = new CustomEvent("input-upload:change");
        this._input.dispatchEvent(customEvent);
    }
    updateTemplate() {
        let filename = this._input.value;
        if (filename) {
            filename = filename.replace(/^.*\\/, ""); // Remove fakepath
            this._filename.innerText = filename;
            this._baseText.classList.add("d-none");
            this._filename.classList.remove("d-none");
        } else {
            this._filename.innerText = "";
            this._baseText.classList.remove("d-none");
            this._filename.classList.add("d-none");
        }
    }
    reset() {}
    constructor(element){
        this._wrapper = element;
        this._button = this._wrapper.querySelector("button");
        this._input = this._wrapper.querySelector("input");
        this._baseText = this._wrapper.querySelector(".js-input-upload-basetext");
        this._filename = this._wrapper.querySelector(".js-input-upload-filename");
        this._list = this._wrapper.querySelector(".js-input-upload-list");
        this.isMultiple = !!this._list;
        this.files = [];
        this.bindEvents();
    }
}


var $0006268ef1215632$exports = {};
(function(global, factory) {
    $0006268ef1215632$exports = factory();
})($0006268ef1215632$exports, function() {
    "use strict";
    var lang = {
        en: {
            required: "This field is required",
            email: "This field requires a valid e-mail address",
            number: "This field requires a number",
            integer: "This field requires an integer value",
            url: "This field requires a valid website URL",
            tel: "This field requires a valid telephone number",
            maxlength: "This fields length must be < ${1}",
            minlength: "This fields length must be > ${1}",
            min: "Minimum value for this field is ${1}",
            max: "Maximum value for this field is ${1}",
            pattern: "Please match the requested format",
            equals: "The two fields do not match",
            default: "Please enter a correct value"
        }
    };
    function findAncestor(el, cls) {
        while((el = el.parentElement) && !el.classList.contains(cls));
        return el;
    }
    function tmpl(o) {
        var _arguments = arguments;
        return this.replace(/\${([^{}]*)}/g, function(a, b) {
            return _arguments[b];
        });
    }
    function groupedElemCount(input) {
        return input.pristine.self.form.querySelectorAll('input[name="' + input.getAttribute("name") + '"]:checked').length;
    }
    function mergeConfig(obj1, obj2) {
        for(var attr in obj2)if (!(attr in obj1)) obj1[attr] = obj2[attr];
        return obj1;
    }
    var defaultConfig = {
        classTo: "form-group",
        errorClass: "has-danger",
        successClass: "has-success",
        errorTextParent: "form-group",
        errorTextTag: "div",
        errorTextClass: "text-help"
    };
    var PRISTINE_ERROR = "pristine-error";
    var SELECTOR = "input:not([type^=hidden]):not([type^=submit]), select, textarea";
    var ALLOWED_ATTRIBUTES = [
        "required",
        "min",
        "max",
        "minlength",
        "maxlength",
        "pattern"
    ];
    var EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var MESSAGE_REGEX = /-message(?:-([a-z]{2}(?:_[A-Z]{2})?))?/; // matches, -message, -message-en, -message-en_US
    var currentLocale = "en";
    var validators = {};
    var _ = function _(name, validator) {
        validator.name = name;
        if (validator.priority === undefined) validator.priority = 1;
        validators[name] = validator;
    };
    _("text", {
        fn: function fn(val) {
            return true;
        },
        priority: 0
    });
    _("required", {
        fn: function fn(val) {
            return this.type === "radio" || this.type === "checkbox" ? groupedElemCount(this) : val !== undefined && val.trim() !== "";
        },
        priority: 99,
        halt: true
    });
    _("email", {
        fn: function fn(val) {
            return !val || EMAIL_REGEX.test(val);
        }
    });
    _("number", {
        fn: function fn(val) {
            return !val || !isNaN(parseFloat(val));
        },
        priority: 2
    });
    _("integer", {
        fn: function fn(val) {
            return !val || /^\d+$/.test(val);
        }
    });
    _("minlength", {
        fn: function fn(val, length) {
            return !val || val.length >= parseInt(length);
        }
    });
    _("maxlength", {
        fn: function fn(val, length) {
            return !val || val.length <= parseInt(length);
        }
    });
    _("min", {
        fn: function fn(val, limit) {
            return !val || (this.type === "checkbox" ? groupedElemCount(this) >= parseInt(limit) : parseFloat(val) >= parseFloat(limit));
        }
    });
    _("max", {
        fn: function fn(val, limit) {
            return !val || (this.type === "checkbox" ? groupedElemCount(this) <= parseInt(limit) : parseFloat(val) <= parseFloat(limit));
        }
    });
    _("pattern", {
        fn: function fn(val, pattern) {
            var m = pattern.match(new RegExp("^/(.*?)/([gimy]*)$"));
            return !val || new RegExp(m[1], m[2]).test(val);
        }
    });
    _("equals", {
        fn: function fn(val, otherFieldSelector) {
            var other = document.querySelector(otherFieldSelector);
            return other && (!val && !other.value || other.value === val);
        }
    });
    function Pristine(form, config, live) {
        var self = this;
        init(form, config, live);
        function init(form, config, live) {
            form.setAttribute("novalidate", "true");
            self.form = form;
            self.config = mergeConfig(config || {}, defaultConfig);
            self.live = !(live === false);
            self.fields = Array.from(form.querySelectorAll(SELECTOR)).map((function(input) {
                var fns = [];
                var params = {};
                var messages = {};
                [].forEach.call(input.attributes, function(attr) {
                    if (/^data-pristine-/.test(attr.name)) {
                        var name = attr.name.substr(14);
                        var messageMatch = name.match(MESSAGE_REGEX);
                        if (messageMatch !== null) {
                            var locale = messageMatch[1] === undefined ? "en" : messageMatch[1];
                            if (!messages.hasOwnProperty(locale)) messages[locale] = {};
                            messages[locale][name.slice(0, name.length - messageMatch[0].length)] = attr.value;
                            return;
                        }
                        if (name === "type") name = attr.value;
                        _addValidatorToField(fns, params, name, attr.value);
                    } else if (~ALLOWED_ATTRIBUTES.indexOf(attr.name)) _addValidatorToField(fns, params, attr.name, attr.value);
                    else if (attr.name === "type") _addValidatorToField(fns, params, attr.value);
                });
                fns.sort(function(a, b) {
                    return b.priority - a.priority;
                });
                self.live && input.addEventListener(!~[
                    "radio",
                    "checkbox"
                ].indexOf(input.getAttribute("type")) ? "input" : "change", (function(e) {
                    self.validate(e.target);
                }).bind(self));
                return input.pristine = {
                    input: input,
                    validators: fns,
                    params: params,
                    messages: messages,
                    self: self
                };
            }).bind(self));
        }
        function _addValidatorToField(fns, params, name, value) {
            var validator = validators[name];
            if (validator) {
                fns.push(validator);
                if (value) {
                    var valueParams = name === "pattern" ? [
                        value
                    ] : value.split(",");
                    valueParams.unshift(null); // placeholder for input's value
                    params[name] = valueParams;
                }
            }
        }
        /***
         * Checks whether the form/input elements are valid
         * @param input => input element(s) or a jquery selector, null for full form validation
         * @param silent => do not show error messages, just return true/false
         * @returns {boolean} return true when valid false otherwise
         */ self.validate = function(input, silent) {
            silent = input && silent === true || input === true;
            var fields = self.fields;
            if (input !== true && input !== false) {
                if (input instanceof HTMLElement) fields = [
                    input.pristine
                ];
                else if (input instanceof NodeList || input instanceof (window.$ || Array) || input instanceof Array) fields = Array.from(input).map(function(el) {
                    return el.pristine;
                });
            }
            var valid = true;
            for(var i = 0; fields[i]; i++){
                var field = fields[i];
                if (_validateField(field)) !silent && _showSuccess(field);
                else {
                    valid = false;
                    !silent && _showError(field);
                }
            }
            return valid;
        };
        /***
         * Get errors of a specific field or the whole form
         * @param input
         * @returns {Array|*}
         */ self.getErrors = function(input) {
            if (!input) {
                var erroneousFields = [];
                for(var i = 0; i < self.fields.length; i++){
                    var field = self.fields[i];
                    if (field.errors.length) erroneousFields.push({
                        input: field.input,
                        errors: field.errors
                    });
                }
                return erroneousFields;
            }
            if (input.tagName && input.tagName.toLowerCase() === "select") return input.pristine.errors;
            return input.length ? input[0].pristine.errors : input.pristine.errors;
        };
        /***
         * Validates a single field, all validator functions are called and error messages are generated
         * when a validator fails
         * @param field
         * @returns {boolean}
         * @private
         */ function _validateField(field) {
            var errors = [];
            var valid = true;
            for(var i = 0; field.validators[i]; i++){
                var validator = field.validators[i];
                var params = field.params[validator.name] ? field.params[validator.name] : [];
                params[0] = field.input.value;
                if (!validator.fn.apply(field.input, params)) {
                    valid = false;
                    if (typeof validator.msg === "function") errors.push(validator.msg(field.input.value, params));
                    else if (typeof validator.msg === "string") errors.push(tmpl.apply(validator.msg, params));
                    else if (validator.msg === Object(validator.msg) && validator.msg[currentLocale]) // typeof generates unnecessary babel code
                    errors.push(tmpl.apply(validator.msg[currentLocale], params));
                    else if (field.messages[currentLocale] && field.messages[currentLocale][validator.name]) errors.push(tmpl.apply(field.messages[currentLocale][validator.name], params));
                    else if (lang[currentLocale] && lang[currentLocale][validator.name]) errors.push(tmpl.apply(lang[currentLocale][validator.name], params));
                    else errors.push(tmpl.apply(lang[currentLocale].default, params));
                    if (validator.halt === true) break;
                }
            }
            field.errors = errors;
            return valid;
        }
        /***
         * Add a validator to a specific dom element in a form
         * @param elem => The dom element where the validator is applied to
         * @param fn => validator function
         * @param msg => message to show when validation fails. Supports templating. ${0} for the input's value, ${1} and
         * so on are for the attribute values
         * @param priority => priority of the validator function, higher valued function gets called first.
         * @param halt => whether validation should stop for this field after current validation function
         */ self.addValidator = function(elem, fn, msg, priority, halt) {
            if (elem instanceof HTMLElement) {
                elem.pristine.validators.push({
                    fn: fn,
                    msg: msg,
                    priority: priority,
                    halt: halt
                });
                elem.pristine.validators.sort(function(a, b) {
                    return b.priority - a.priority;
                });
            } else console.warn("The parameter elem must be a dom element");
        };
        /***
         * An utility function that returns a 2-element array, first one is the element where error/success class is
         * applied. 2nd one is the element where error message is displayed. 2nd element is created if doesn't exist and cached.
         * @param field
         * @returns {*}
         * @private
         */ function _getErrorElements(field) {
            if (field.errorElements) return field.errorElements;
            var errorClassElement = findAncestor(field.input, self.config.classTo);
            var errorTextParent = null, errorTextElement = null;
            if (self.config.classTo === self.config.errorTextParent) errorTextParent = errorClassElement;
            else errorTextParent = errorClassElement.querySelector("." + self.config.errorTextParent);
            if (errorTextParent) {
                errorTextElement = errorTextParent.querySelector("." + PRISTINE_ERROR);
                if (!errorTextElement) {
                    errorTextElement = document.createElement(self.config.errorTextTag);
                    errorTextElement.className = PRISTINE_ERROR + " " + self.config.errorTextClass;
                    errorTextParent.appendChild(errorTextElement);
                    errorTextElement.pristineDisplay = errorTextElement.style.display;
                }
            }
            return field.errorElements = [
                errorClassElement,
                errorTextElement
            ];
        }
        function _showError(field) {
            var errorElements = _getErrorElements(field);
            var errorClassElement = errorElements[0], errorTextElement = errorElements[1];
            var input = field.input;
            var inputId = input.id || Math.floor(new Date().valueOf() * Math.random());
            var errorId = "error-" + inputId;
            if (errorClassElement) {
                errorClassElement.classList.remove(self.config.successClass);
                errorClassElement.classList.add(self.config.errorClass);
                input.setAttribute("aria-describedby", errorId);
                input.setAttribute("aria-invalid", "true");
            }
            if (errorTextElement) {
                errorTextElement.setAttribute("id", errorId);
                errorTextElement.setAttribute("role", "alert");
                errorTextElement.innerHTML = field.errors.join("<br/>");
                errorTextElement.style.display = errorTextElement.pristineDisplay || "";
            }
        }
        /***
         * Adds error to a specific field
         * @param input
         * @param error
         */ self.addError = function(input, error) {
            input = input.length ? input[0] : input;
            input.pristine.errors.push(error);
            _showError(input.pristine);
        };
        function _removeError(field) {
            var errorElements = _getErrorElements(field);
            var errorClassElement = errorElements[0], errorTextElement = errorElements[1];
            var input = field.input;
            if (errorClassElement) {
                // IE > 9 doesn't support multiple class removal
                errorClassElement.classList.remove(self.config.errorClass);
                errorClassElement.classList.remove(self.config.successClass);
                input.removeAttribute("aria-describedby");
                input.removeAttribute("aria-invalid");
            }
            if (errorTextElement) {
                errorTextElement.removeAttribute("id");
                errorTextElement.removeAttribute("role");
                errorTextElement.innerHTML = "";
                errorTextElement.style.display = "none";
            }
            return errorElements;
        }
        function _showSuccess(field) {
            var errorClassElement = _removeError(field)[0];
            errorClassElement && errorClassElement.classList.add(self.config.successClass);
        }
        /***
         * Resets the errors
         */ self.reset = function() {
            for(var i = 0; self.fields[i]; i++)self.fields[i].errorElements = null;
            Array.from(self.form.querySelectorAll("." + PRISTINE_ERROR)).map(function(elem) {
                elem.parentNode.removeChild(elem);
            });
            Array.from(self.form.querySelectorAll("." + self.config.classTo)).map(function(elem) {
                elem.classList.remove(self.config.successClass);
                elem.classList.remove(self.config.errorClass);
            });
        };
        /***
         * Resets the errors and deletes all pristine fields
         */ self.destroy = function() {
            self.reset();
            self.fields.forEach(function(field) {
                delete field.input.pristine;
            });
            self.fields = [];
        };
        self.setGlobalConfig = function(config) {
            defaultConfig = config;
        };
        return self;
    }
    /***
     *
     * @param name => Name of the global validator
     * @param fn => validator function
     * @param msg => message to show when validation fails. Supports templating. ${0} for the input's value, ${1} and
     * so on are for the attribute values
     * @param priority => priority of the validator function, higher valued function gets called first.
     * @param halt => whether validation should stop for this field after current validation function
     */ Pristine.addValidator = function(name, fn, msg, priority, halt) {
        _(name, {
            fn: fn,
            msg: msg,
            priority: priority,
            halt: halt
        });
    };
    Pristine.addMessages = function(locale, messages) {
        var langObj = lang.hasOwnProperty(locale) ? lang[locale] : lang[locale] = {};
        Object.keys(messages).forEach(function(key, index) {
            langObj[key] = messages[key];
        });
    };
    Pristine.setLocale = function(locale) {
        currentLocale = locale;
    };
    return Pristine;
});



class $7823f63f6e12eb2e$export$2e2bcd8739ae039 {
    init() {}
    bindEvents() {
        this._toggle.addEventListener("click", (e)=>{
            e.preventDefault();
            this._addressSearch.removeAttribute("required");
            this._addressSearch.removeAttribute("data-to-validate");
            this._addressSearch.value = "";
            this._addressValue.value = "";
            let _target = this._form.querySelector(this._toggle.getAttribute("data-target"));
            _target.classList.remove("d-none");
        });
        this._form.addEventListener("submit", (e)=>{
            if (!this.pristine.validate(this._form.querySelectorAll('[data-to-validate="true"]'))) {
                e.preventDefault();
                let _firstError = this._form.querySelector(".has-danger");
                _firstError.scrollIntoView();
            }
        });
        app.nodesEventListener("click", this._duplicateBtns, (el, n, e)=>{
            e.preventDefault();
            let target = document.querySelector(el.getAttribute("data-target"));
            this.duplicateTemplate(target);
        });
        app.nodesEventListener("input-upload:change", this._inputUploadMultiples, (el, n, e)=>{
            this.pristine.validate(el);
        });
    }
    duplicateTemplate(target) {
        let _clone = target.cloneNode(true);
        let id = _clone.getAttribute("id");
        _clone.setAttribute("data-duplicate-id", id);
        _clone.removeAttribute("id");
        let _otherClones = this._form.querySelectorAll('[data-duplicate-id="' + id + '"]');
        let index = _otherClones.length + 1;
        this.setIndexToClone(_clone, index);
        if (_otherClones.length) _otherClones[_otherClones.length - 1].insertAdjacentElement("afterend", _clone);
        else target.insertAdjacentElement("afterend", _clone);
        let _remove = _clone.querySelector(".js-form-submit-event-duplicate-remove");
        _remove.classList.remove("d-none");
        _remove.addEventListener("click", ()=>{
            _clone.remove();
            this.onRemoveClone(id); // Update indexes;
        });
        // Init various form controls
        _clone.querySelectorAll(".js-input-upload").forEach((el)=>{
            let inputUpload = new (0, $790b48f623a35f09$export$2e2bcd8739ae039)(el);
            if (!inputUpload.isMultiple) inputUpload.updateTemplate();
        });
        this.pristine.destroy();
        this.pristine = new (0, (/*@__PURE__*/$parcel$interopDefault($0006268ef1215632$exports)))(this._form);
    }
    setIndexToClone(_clone, index) {
        _clone.querySelectorAll(".js-form-submit-event-duplicate-count").forEach((el)=>{
            el.innerText = index + 1;
        });
        _clone.querySelectorAll("[name], [for]").forEach((el)=>{
            if (el.name) el.name = el.name.replace(/\[\d+]/, `[${index}]`);
            if (el.getAttribute("for")) el.setAttribute("for", el.getAttribute("for").replace(/\[\d+]/, `[${index}]`));
            if (el.value) el.value = "";
            if (el.checked) el.checked = false;
        });
    }
    onRemoveClone(id) {
        let _clones = this._form.querySelectorAll('[data-duplicate-id="' + id + '"]');
        _clones.forEach((el, n)=>{
            this.setIndexToClone(el, n + 1);
        });
    }
    constructor(element){
        this._form = element;
        this._duplicateBtns = this._form.querySelectorAll(".js-form-submit-event-duplicate-button");
        this._inputUploadMultiples = this._form.querySelectorAll(".js-input-upload.is-multiple input");
        this._submitBtn = this._form.querySelector(".js-form-submit-event-submit-btn");
        this._toggle = this._form.querySelector(".js-form-submit-event-toggle");
        this._addressSearch = this._form.querySelector(".js-input-address-search");
        this._addressValue = this._form.querySelector(".js-input-address-input");
        (0, (/*@__PURE__*/$parcel$interopDefault($0006268ef1215632$exports))).addMessages("fr", {
            required: "Ce champ est requis",
            email: "L'adresse e-mail est invalide",
            number: "Ce champ requiert un nombre",
            integer: "Ce champ requiert une valeur enti\xe8re",
            url: "Ce champ requiert une URL valide",
            tel: "Ce champ requiert un num\xe9ro de t\xe9l\xe9phone valide",
            maxlength: "La longueur de ce champ doit \xeatre inf\xe9rieure \xe0 ${1}",
            minlength: "La longueur de ce champ doit \xeatre sup\xe9rieure \xe0 ${1}",
            min: "La valeur minimale pour ce champ est ${1}",
            max: "La valeur maximale pour ce champ est ${1}",
            pattern: "Veuillez respecter le format requis",
            equals: "Les deux champs ne correspondent pas",
            default: "Veuillez entrer une valeur correcte"
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($0006268ef1215632$exports))).setLocale("fr");
        let currentUnvalidFilename = "";
        let currentUnvalidFileExtension = "";
        (0, (/*@__PURE__*/$parcel$interopDefault($0006268ef1215632$exports))).addValidator("filesize", function(value, maxSizeInMo) {
            let maxSizeInOctets = parseInt(maxSizeInMo) * 1048576;
            for (const file of this.files)if (file.size > maxSizeInOctets) {
                currentUnvalidFilename = file.name;
                return false;
            }
            return true;
        }, function(value, value2) {
            return `Le fichier ${currentUnvalidFilename} est trop volumineux, la taille maximale est de ${value2[1]}Mo`;
        }, 5, false);
        (0, (/*@__PURE__*/$parcel$interopDefault($0006268ef1215632$exports))).addValidator("extensions", function(value, extensions) {
            for (const file of this.files){
                let extension = file.name.split(".").pop().toLowerCase();
                let validExtensions = extensions.split(";");
                if (!validExtensions.includes(extension)) {
                    currentUnvalidFilename = file.name;
                    currentUnvalidFileExtension = extension;
                    return false;
                }
            }
            return true;
        }, function(value, value2) {
            let validExtensions = value2[1].split(";").map((ext)=>"." + ext).join(" ");
            return `Seul les extensions ${validExtensions} sont autoris\xe9es. Le fichier ${currentUnvalidFilename} a pour extension .${currentUnvalidFileExtension}`;
        }, 5, false);
        this.pristine = new (0, (/*@__PURE__*/$parcel$interopDefault($0006268ef1215632$exports)))(this._form, {}, true);
        this.init();
        this.bindEvents();
    }
}



var $97zcJ = parcelRequire("97zcJ");
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $f17a27133160f7ba$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $f17a27133160f7ba$export$2e2bcd8739ae039 = $f17a27133160f7ba$var$listCacheClear;


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $a1fc17bf3c9673a4$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $a1fc17bf3c9673a4$export$2e2bcd8739ae039 = $a1fc17bf3c9673a4$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ec5a4e7b3c1dd153$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $a1fc17bf3c9673a4$export$2e2bcd8739ae039)(array[length][0], key)) return length;
    }
    return -1;
}
var $ec5a4e7b3c1dd153$export$2e2bcd8739ae039 = $ec5a4e7b3c1dd153$var$assocIndexOf;


/** Used for built-in method references. */ var $e8b8f2d423fd27a6$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $e8b8f2d423fd27a6$var$splice = $e8b8f2d423fd27a6$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e8b8f2d423fd27a6$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $ec5a4e7b3c1dd153$export$2e2bcd8739ae039)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $e8b8f2d423fd27a6$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $e8b8f2d423fd27a6$export$2e2bcd8739ae039 = $e8b8f2d423fd27a6$var$listCacheDelete;



/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $83da1c3171c4bbce$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $ec5a4e7b3c1dd153$export$2e2bcd8739ae039)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $83da1c3171c4bbce$export$2e2bcd8739ae039 = $83da1c3171c4bbce$var$listCacheGet;



/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a1d9b14fa7726d8d$var$listCacheHas(key) {
    return (0, $ec5a4e7b3c1dd153$export$2e2bcd8739ae039)(this.__data__, key) > -1;
}
var $a1d9b14fa7726d8d$export$2e2bcd8739ae039 = $a1d9b14fa7726d8d$var$listCacheHas;



/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $859e0643cb19be67$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $ec5a4e7b3c1dd153$export$2e2bcd8739ae039)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $859e0643cb19be67$export$2e2bcd8739ae039 = $859e0643cb19be67$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $88770652b786d92f$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$88770652b786d92f$var$ListCache.prototype.clear = (0, $f17a27133160f7ba$export$2e2bcd8739ae039);
$88770652b786d92f$var$ListCache.prototype["delete"] = (0, $e8b8f2d423fd27a6$export$2e2bcd8739ae039);
$88770652b786d92f$var$ListCache.prototype.get = (0, $83da1c3171c4bbce$export$2e2bcd8739ae039);
$88770652b786d92f$var$ListCache.prototype.has = (0, $a1d9b14fa7726d8d$export$2e2bcd8739ae039);
$88770652b786d92f$var$ListCache.prototype.set = (0, $859e0643cb19be67$export$2e2bcd8739ae039);
var $88770652b786d92f$export$2e2bcd8739ae039 = $88770652b786d92f$var$ListCache;



/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $0e44af62b92e06e8$var$stackClear() {
    this.__data__ = new (0, $88770652b786d92f$export$2e2bcd8739ae039);
    this.size = 0;
}
var $0e44af62b92e06e8$export$2e2bcd8739ae039 = $0e44af62b92e06e8$var$stackClear;


/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $407af5d3225200cf$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
var $407af5d3225200cf$export$2e2bcd8739ae039 = $407af5d3225200cf$var$stackDelete;


/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $133f4cf841017a07$var$stackGet(key) {
    return this.__data__.get(key);
}
var $133f4cf841017a07$export$2e2bcd8739ae039 = $133f4cf841017a07$var$stackGet;


/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e1790078af01b3e6$var$stackHas(key) {
    return this.__data__.has(key);
}
var $e1790078af01b3e6$export$2e2bcd8739ae039 = $e1790078af01b3e6$var$stackHas;




var $fshLi = parcelRequire("fshLi");
/** Built-in value references. */ var $dbd68291cf58beb2$var$Symbol = (0, $fshLi.default).Symbol;
var $dbd68291cf58beb2$export$2e2bcd8739ae039 = $dbd68291cf58beb2$var$Symbol;



/** Used for built-in method references. */ var $4af459863ae24c2c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4af459863ae24c2c$var$hasOwnProperty = $4af459863ae24c2c$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $4af459863ae24c2c$var$nativeObjectToString = $4af459863ae24c2c$var$objectProto.toString;
/** Built-in value references. */ var $4af459863ae24c2c$var$symToStringTag = (0, $dbd68291cf58beb2$export$2e2bcd8739ae039) ? (0, $dbd68291cf58beb2$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $4af459863ae24c2c$var$getRawTag(value) {
    var isOwn = $4af459863ae24c2c$var$hasOwnProperty.call(value, $4af459863ae24c2c$var$symToStringTag), tag = value[$4af459863ae24c2c$var$symToStringTag];
    try {
        value[$4af459863ae24c2c$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $4af459863ae24c2c$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$4af459863ae24c2c$var$symToStringTag] = tag;
        else delete value[$4af459863ae24c2c$var$symToStringTag];
    }
    return result;
}
var $4af459863ae24c2c$export$2e2bcd8739ae039 = $4af459863ae24c2c$var$getRawTag;


/** Used for built-in method references. */ var $197812e16d0142e1$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $197812e16d0142e1$var$nativeObjectToString = $197812e16d0142e1$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $197812e16d0142e1$var$objectToString(value) {
    return $197812e16d0142e1$var$nativeObjectToString.call(value);
}
var $197812e16d0142e1$export$2e2bcd8739ae039 = $197812e16d0142e1$var$objectToString;


/** `Object#toString` result references. */ var $64fb6e2e9109eff6$var$nullTag = "[object Null]", $64fb6e2e9109eff6$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $64fb6e2e9109eff6$var$symToStringTag = (0, $dbd68291cf58beb2$export$2e2bcd8739ae039) ? (0, $dbd68291cf58beb2$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $64fb6e2e9109eff6$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $64fb6e2e9109eff6$var$undefinedTag : $64fb6e2e9109eff6$var$nullTag;
    return $64fb6e2e9109eff6$var$symToStringTag && $64fb6e2e9109eff6$var$symToStringTag in Object(value) ? (0, $4af459863ae24c2c$export$2e2bcd8739ae039)(value) : (0, $197812e16d0142e1$export$2e2bcd8739ae039)(value);
}
var $64fb6e2e9109eff6$export$2e2bcd8739ae039 = $64fb6e2e9109eff6$var$baseGetTag;


/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $97e1fd59e0a392d4$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $97e1fd59e0a392d4$export$2e2bcd8739ae039 = $97e1fd59e0a392d4$var$isObject;


/** `Object#toString` result references. */ var $fe3e403a57673301$var$asyncTag = "[object AsyncFunction]", $fe3e403a57673301$var$funcTag = "[object Function]", $fe3e403a57673301$var$genTag = "[object GeneratorFunction]", $fe3e403a57673301$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $fe3e403a57673301$var$isFunction(value) {
    if (!(0, $97e1fd59e0a392d4$export$2e2bcd8739ae039)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $64fb6e2e9109eff6$export$2e2bcd8739ae039)(value);
    return tag == $fe3e403a57673301$var$funcTag || tag == $fe3e403a57673301$var$genTag || tag == $fe3e403a57673301$var$asyncTag || tag == $fe3e403a57673301$var$proxyTag;
}
var $fe3e403a57673301$export$2e2bcd8739ae039 = $fe3e403a57673301$var$isFunction;



var $fshLi = parcelRequire("fshLi");
/** Used to detect overreaching core-js shims. */ var $eb7e1c4cb55d13d9$var$coreJsData = (0, $fshLi.default)["__core-js_shared__"];
var $eb7e1c4cb55d13d9$export$2e2bcd8739ae039 = $eb7e1c4cb55d13d9$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $e3d8325168446f74$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $eb7e1c4cb55d13d9$export$2e2bcd8739ae039) && (0, $eb7e1c4cb55d13d9$export$2e2bcd8739ae039).keys && (0, $eb7e1c4cb55d13d9$export$2e2bcd8739ae039).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $e3d8325168446f74$var$isMasked(func) {
    return !!$e3d8325168446f74$var$maskSrcKey && $e3d8325168446f74$var$maskSrcKey in func;
}
var $e3d8325168446f74$export$2e2bcd8739ae039 = $e3d8325168446f74$var$isMasked;



/** Used for built-in method references. */ var $6f9ce694399d2bb3$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $6f9ce694399d2bb3$var$funcToString = $6f9ce694399d2bb3$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $6f9ce694399d2bb3$var$toSource(func) {
    if (func != null) {
        try {
            return $6f9ce694399d2bb3$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
var $6f9ce694399d2bb3$export$2e2bcd8739ae039 = $6f9ce694399d2bb3$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $559f1fb1630754a8$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $559f1fb1630754a8$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $559f1fb1630754a8$var$funcProto = Function.prototype, $559f1fb1630754a8$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $559f1fb1630754a8$var$funcToString = $559f1fb1630754a8$var$funcProto.toString;
/** Used to check objects for own properties. */ var $559f1fb1630754a8$var$hasOwnProperty = $559f1fb1630754a8$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $559f1fb1630754a8$var$reIsNative = RegExp("^" + $559f1fb1630754a8$var$funcToString.call($559f1fb1630754a8$var$hasOwnProperty).replace($559f1fb1630754a8$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $559f1fb1630754a8$var$baseIsNative(value) {
    if (!(0, $97e1fd59e0a392d4$export$2e2bcd8739ae039)(value) || (0, $e3d8325168446f74$export$2e2bcd8739ae039)(value)) return false;
    var pattern = (0, $fe3e403a57673301$export$2e2bcd8739ae039)(value) ? $559f1fb1630754a8$var$reIsNative : $559f1fb1630754a8$var$reIsHostCtor;
    return pattern.test((0, $6f9ce694399d2bb3$export$2e2bcd8739ae039)(value));
}
var $559f1fb1630754a8$export$2e2bcd8739ae039 = $559f1fb1630754a8$var$baseIsNative;


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $2c694f0db89f7ee6$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $2c694f0db89f7ee6$export$2e2bcd8739ae039 = $2c694f0db89f7ee6$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $b805a149580bacf7$var$getNative(object, key) {
    var value = (0, $2c694f0db89f7ee6$export$2e2bcd8739ae039)(object, key);
    return (0, $559f1fb1630754a8$export$2e2bcd8739ae039)(value) ? value : undefined;
}
var $b805a149580bacf7$export$2e2bcd8739ae039 = $b805a149580bacf7$var$getNative;



var $fshLi = parcelRequire("fshLi");
/* Built-in method references that are verified to be native. */ var $322e42da3acd1ad9$var$Map = (0, $b805a149580bacf7$export$2e2bcd8739ae039)((0, $fshLi.default), "Map");
var $322e42da3acd1ad9$export$2e2bcd8739ae039 = $322e42da3acd1ad9$var$Map;



/* Built-in method references that are verified to be native. */ var $3f4dc9f1c955bc63$var$nativeCreate = (0, $b805a149580bacf7$export$2e2bcd8739ae039)(Object, "create");
var $3f4dc9f1c955bc63$export$2e2bcd8739ae039 = $3f4dc9f1c955bc63$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $47391e356bd61f2b$var$hashClear() {
    this.__data__ = (0, $3f4dc9f1c955bc63$export$2e2bcd8739ae039) ? (0, $3f4dc9f1c955bc63$export$2e2bcd8739ae039)(null) : {};
    this.size = 0;
}
var $47391e356bd61f2b$export$2e2bcd8739ae039 = $47391e356bd61f2b$var$hashClear;


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6854b815474d486b$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $6854b815474d486b$export$2e2bcd8739ae039 = $6854b815474d486b$var$hashDelete;



/** Used to stand-in for `undefined` hash values. */ var $ad1c52d527fe6f03$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $ad1c52d527fe6f03$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ad1c52d527fe6f03$var$hasOwnProperty = $ad1c52d527fe6f03$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ad1c52d527fe6f03$var$hashGet(key) {
    var data = this.__data__;
    if (0, $3f4dc9f1c955bc63$export$2e2bcd8739ae039) {
        var result = data[key];
        return result === $ad1c52d527fe6f03$var$HASH_UNDEFINED ? undefined : result;
    }
    return $ad1c52d527fe6f03$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $ad1c52d527fe6f03$export$2e2bcd8739ae039 = $ad1c52d527fe6f03$var$hashGet;



/** Used for built-in method references. */ var $94caba44c175813d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $94caba44c175813d$var$hasOwnProperty = $94caba44c175813d$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $94caba44c175813d$var$hashHas(key) {
    var data = this.__data__;
    return (0, $3f4dc9f1c955bc63$export$2e2bcd8739ae039) ? data[key] !== undefined : $94caba44c175813d$var$hasOwnProperty.call(data, key);
}
var $94caba44c175813d$export$2e2bcd8739ae039 = $94caba44c175813d$var$hashHas;



/** Used to stand-in for `undefined` hash values. */ var $91d0cfd54abb45bb$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $91d0cfd54abb45bb$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $3f4dc9f1c955bc63$export$2e2bcd8739ae039) && value === undefined ? $91d0cfd54abb45bb$var$HASH_UNDEFINED : value;
    return this;
}
var $91d0cfd54abb45bb$export$2e2bcd8739ae039 = $91d0cfd54abb45bb$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $1aa680c56368ffe5$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$1aa680c56368ffe5$var$Hash.prototype.clear = (0, $47391e356bd61f2b$export$2e2bcd8739ae039);
$1aa680c56368ffe5$var$Hash.prototype["delete"] = (0, $6854b815474d486b$export$2e2bcd8739ae039);
$1aa680c56368ffe5$var$Hash.prototype.get = (0, $ad1c52d527fe6f03$export$2e2bcd8739ae039);
$1aa680c56368ffe5$var$Hash.prototype.has = (0, $94caba44c175813d$export$2e2bcd8739ae039);
$1aa680c56368ffe5$var$Hash.prototype.set = (0, $91d0cfd54abb45bb$export$2e2bcd8739ae039);
var $1aa680c56368ffe5$export$2e2bcd8739ae039 = $1aa680c56368ffe5$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $b14e57d0fb36c9b0$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, $1aa680c56368ffe5$export$2e2bcd8739ae039),
        "map": new ((0, $322e42da3acd1ad9$export$2e2bcd8739ae039) || (0, $88770652b786d92f$export$2e2bcd8739ae039)),
        "string": new (0, $1aa680c56368ffe5$export$2e2bcd8739ae039)
    };
}
var $b14e57d0fb36c9b0$export$2e2bcd8739ae039 = $b14e57d0fb36c9b0$var$mapCacheClear;


/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $45234b42091c7f56$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var $45234b42091c7f56$export$2e2bcd8739ae039 = $45234b42091c7f56$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $2a82af75b0406a54$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $45234b42091c7f56$export$2e2bcd8739ae039)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var $2a82af75b0406a54$export$2e2bcd8739ae039 = $2a82af75b0406a54$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9e51575dd51668d4$var$mapCacheDelete(key) {
    var result = (0, $2a82af75b0406a54$export$2e2bcd8739ae039)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $9e51575dd51668d4$export$2e2bcd8739ae039 = $9e51575dd51668d4$var$mapCacheDelete;



/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $5ea51c702ffa480a$var$mapCacheGet(key) {
    return (0, $2a82af75b0406a54$export$2e2bcd8739ae039)(this, key).get(key);
}
var $5ea51c702ffa480a$export$2e2bcd8739ae039 = $5ea51c702ffa480a$var$mapCacheGet;



/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $cad95e057625e17f$var$mapCacheHas(key) {
    return (0, $2a82af75b0406a54$export$2e2bcd8739ae039)(this, key).has(key);
}
var $cad95e057625e17f$export$2e2bcd8739ae039 = $cad95e057625e17f$var$mapCacheHas;



/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $3c698b160c742f12$var$mapCacheSet(key, value) {
    var data = (0, $2a82af75b0406a54$export$2e2bcd8739ae039)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $3c698b160c742f12$export$2e2bcd8739ae039 = $3c698b160c742f12$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $06e9eb975eb9e1e5$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$06e9eb975eb9e1e5$var$MapCache.prototype.clear = (0, $b14e57d0fb36c9b0$export$2e2bcd8739ae039);
$06e9eb975eb9e1e5$var$MapCache.prototype["delete"] = (0, $9e51575dd51668d4$export$2e2bcd8739ae039);
$06e9eb975eb9e1e5$var$MapCache.prototype.get = (0, $5ea51c702ffa480a$export$2e2bcd8739ae039);
$06e9eb975eb9e1e5$var$MapCache.prototype.has = (0, $cad95e057625e17f$export$2e2bcd8739ae039);
$06e9eb975eb9e1e5$var$MapCache.prototype.set = (0, $3c698b160c742f12$export$2e2bcd8739ae039);
var $06e9eb975eb9e1e5$export$2e2bcd8739ae039 = $06e9eb975eb9e1e5$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $cb351c5f95b1a836$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $cb351c5f95b1a836$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $88770652b786d92f$export$2e2bcd8739ae039)) {
        var pairs = data.__data__;
        if (!(0, $322e42da3acd1ad9$export$2e2bcd8739ae039) || pairs.length < $cb351c5f95b1a836$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $06e9eb975eb9e1e5$export$2e2bcd8739ae039)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $cb351c5f95b1a836$export$2e2bcd8739ae039 = $cb351c5f95b1a836$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dec20d54409d2f2d$var$Stack(entries) {
    var data = this.__data__ = new (0, $88770652b786d92f$export$2e2bcd8739ae039)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$dec20d54409d2f2d$var$Stack.prototype.clear = (0, $0e44af62b92e06e8$export$2e2bcd8739ae039);
$dec20d54409d2f2d$var$Stack.prototype["delete"] = (0, $407af5d3225200cf$export$2e2bcd8739ae039);
$dec20d54409d2f2d$var$Stack.prototype.get = (0, $133f4cf841017a07$export$2e2bcd8739ae039);
$dec20d54409d2f2d$var$Stack.prototype.has = (0, $e1790078af01b3e6$export$2e2bcd8739ae039);
$dec20d54409d2f2d$var$Stack.prototype.set = (0, $cb351c5f95b1a836$export$2e2bcd8739ae039);
var $dec20d54409d2f2d$export$2e2bcd8739ae039 = $dec20d54409d2f2d$var$Stack;



var $3109e237cd9de07f$var$defineProperty = function() {
    try {
        var func = (0, $b805a149580bacf7$export$2e2bcd8739ae039)(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
var $3109e237cd9de07f$export$2e2bcd8739ae039 = $3109e237cd9de07f$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $2d1ea61fb95249f0$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && (0, $3109e237cd9de07f$export$2e2bcd8739ae039)) (0, $3109e237cd9de07f$export$2e2bcd8739ae039)(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
var $2d1ea61fb95249f0$export$2e2bcd8739ae039 = $2d1ea61fb95249f0$var$baseAssignValue;



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $3350fb5062313fc7$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, $a1fc17bf3c9673a4$export$2e2bcd8739ae039)(object[key], value) || value === undefined && !(key in object)) (0, $2d1ea61fb95249f0$export$2e2bcd8739ae039)(object, key, value);
}
var $3350fb5062313fc7$export$2e2bcd8739ae039 = $3350fb5062313fc7$var$assignMergeValue;


/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $702416d1ba7be38e$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $702416d1ba7be38e$export$2e2bcd8739ae039 = $702416d1ba7be38e$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $acba1b6152d3ae5b$var$baseFor = (0, $702416d1ba7be38e$export$2e2bcd8739ae039)();
var $acba1b6152d3ae5b$export$2e2bcd8739ae039 = $acba1b6152d3ae5b$var$baseFor;




var $6nnFN = parcelRequire("6nnFN");

var $fshLi = parcelRequire("fshLi");
/** Built-in value references. */ var $35fd122c9034db7f$var$Uint8Array = (0, $fshLi.default).Uint8Array;
var $35fd122c9034db7f$export$2e2bcd8739ae039 = $35fd122c9034db7f$var$Uint8Array;


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $f7af92ec9d8ef87f$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $35fd122c9034db7f$export$2e2bcd8739ae039)(result).set(new (0, $35fd122c9034db7f$export$2e2bcd8739ae039)(arrayBuffer));
    return result;
}
var $f7af92ec9d8ef87f$export$2e2bcd8739ae039 = $f7af92ec9d8ef87f$var$cloneArrayBuffer;


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $9b604d3b769eeba8$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $f7af92ec9d8ef87f$export$2e2bcd8739ae039)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $9b604d3b769eeba8$export$2e2bcd8739ae039 = $9b604d3b769eeba8$var$cloneTypedArray;


/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $ba8eed531ba68a89$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $ba8eed531ba68a89$export$2e2bcd8739ae039 = $ba8eed531ba68a89$var$copyArray;



/** Built-in value references. */ var $a342d65b785f30c1$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $a342d65b785f30c1$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $97e1fd59e0a392d4$export$2e2bcd8739ae039)(proto)) return {};
        if ($a342d65b785f30c1$var$objectCreate) return $a342d65b785f30c1$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $a342d65b785f30c1$export$2e2bcd8739ae039 = $a342d65b785f30c1$var$baseCreate;


/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $d0fb1d1c76f7af6d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $d0fb1d1c76f7af6d$export$2e2bcd8739ae039 = $d0fb1d1c76f7af6d$var$overArg;


/** Built-in value references. */ var $fc85ad3eee846b47$var$getPrototype = (0, $d0fb1d1c76f7af6d$export$2e2bcd8739ae039)(Object.getPrototypeOf, Object);
var $fc85ad3eee846b47$export$2e2bcd8739ae039 = $fc85ad3eee846b47$var$getPrototype;


/** Used for built-in method references. */ var $c4b37195c52b7c20$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $c4b37195c52b7c20$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $c4b37195c52b7c20$var$objectProto;
    return value === proto;
}
var $c4b37195c52b7c20$export$2e2bcd8739ae039 = $c4b37195c52b7c20$var$isPrototype;


/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $82723ed9ea65b904$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !(0, $c4b37195c52b7c20$export$2e2bcd8739ae039)(object) ? (0, $a342d65b785f30c1$export$2e2bcd8739ae039)((0, $fc85ad3eee846b47$export$2e2bcd8739ae039)(object)) : {};
}
var $82723ed9ea65b904$export$2e2bcd8739ae039 = $82723ed9ea65b904$var$initCloneObject;



/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $4757a366dbe9cf5c$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $4757a366dbe9cf5c$export$2e2bcd8739ae039 = $4757a366dbe9cf5c$var$isObjectLike;


/** `Object#toString` result references. */ var $c915bbd73a056bea$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $c915bbd73a056bea$var$baseIsArguments(value) {
    return (0, $4757a366dbe9cf5c$export$2e2bcd8739ae039)(value) && (0, $64fb6e2e9109eff6$export$2e2bcd8739ae039)(value) == $c915bbd73a056bea$var$argsTag;
}
var $c915bbd73a056bea$export$2e2bcd8739ae039 = $c915bbd73a056bea$var$baseIsArguments;



/** Used for built-in method references. */ var $ec49f3d2aee73883$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ec49f3d2aee73883$var$hasOwnProperty = $ec49f3d2aee73883$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $ec49f3d2aee73883$var$propertyIsEnumerable = $ec49f3d2aee73883$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $ec49f3d2aee73883$var$isArguments = (0, $c915bbd73a056bea$export$2e2bcd8739ae039)(function() {
    return arguments;
}()) ? (0, $c915bbd73a056bea$export$2e2bcd8739ae039) : function(value) {
    return (0, $4757a366dbe9cf5c$export$2e2bcd8739ae039)(value) && $ec49f3d2aee73883$var$hasOwnProperty.call(value, "callee") && !$ec49f3d2aee73883$var$propertyIsEnumerable.call(value, "callee");
};
var $ec49f3d2aee73883$export$2e2bcd8739ae039 = $ec49f3d2aee73883$var$isArguments;


/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $93b249752024ad0a$var$isArray = Array.isArray;
var $93b249752024ad0a$export$2e2bcd8739ae039 = $93b249752024ad0a$var$isArray;



/** Used as references for various `Number` constants. */ var $a46b7b33126b409e$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $a46b7b33126b409e$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $a46b7b33126b409e$var$MAX_SAFE_INTEGER;
}
var $a46b7b33126b409e$export$2e2bcd8739ae039 = $a46b7b33126b409e$var$isLength;


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $38dc911623597bb2$var$isArrayLike(value) {
    return value != null && (0, $a46b7b33126b409e$export$2e2bcd8739ae039)(value.length) && !(0, $fe3e403a57673301$export$2e2bcd8739ae039)(value);
}
var $38dc911623597bb2$export$2e2bcd8739ae039 = $38dc911623597bb2$var$isArrayLike;



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $1497e74d44ac2a0a$var$isArrayLikeObject(value) {
    return (0, $4757a366dbe9cf5c$export$2e2bcd8739ae039)(value) && (0, $38dc911623597bb2$export$2e2bcd8739ae039)(value);
}
var $1497e74d44ac2a0a$export$2e2bcd8739ae039 = $1497e74d44ac2a0a$var$isArrayLikeObject;



var $42CIw = parcelRequire("42CIw");





/** `Object#toString` result references. */ var $6bab660559d3a968$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $6bab660559d3a968$var$funcProto = Function.prototype, $6bab660559d3a968$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $6bab660559d3a968$var$funcToString = $6bab660559d3a968$var$funcProto.toString;
/** Used to check objects for own properties. */ var $6bab660559d3a968$var$hasOwnProperty = $6bab660559d3a968$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $6bab660559d3a968$var$objectCtorString = $6bab660559d3a968$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $6bab660559d3a968$var$isPlainObject(value) {
    if (!(0, $4757a366dbe9cf5c$export$2e2bcd8739ae039)(value) || (0, $64fb6e2e9109eff6$export$2e2bcd8739ae039)(value) != $6bab660559d3a968$var$objectTag) return false;
    var proto = (0, $fc85ad3eee846b47$export$2e2bcd8739ae039)(value);
    if (proto === null) return true;
    var Ctor = $6bab660559d3a968$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $6bab660559d3a968$var$funcToString.call(Ctor) == $6bab660559d3a968$var$objectCtorString;
}
var $6bab660559d3a968$export$2e2bcd8739ae039 = $6bab660559d3a968$var$isPlainObject;





/** `Object#toString` result references. */ var $f174426d0f14b884$var$argsTag = "[object Arguments]", $f174426d0f14b884$var$arrayTag = "[object Array]", $f174426d0f14b884$var$boolTag = "[object Boolean]", $f174426d0f14b884$var$dateTag = "[object Date]", $f174426d0f14b884$var$errorTag = "[object Error]", $f174426d0f14b884$var$funcTag = "[object Function]", $f174426d0f14b884$var$mapTag = "[object Map]", $f174426d0f14b884$var$numberTag = "[object Number]", $f174426d0f14b884$var$objectTag = "[object Object]", $f174426d0f14b884$var$regexpTag = "[object RegExp]", $f174426d0f14b884$var$setTag = "[object Set]", $f174426d0f14b884$var$stringTag = "[object String]", $f174426d0f14b884$var$weakMapTag = "[object WeakMap]";
var $f174426d0f14b884$var$arrayBufferTag = "[object ArrayBuffer]", $f174426d0f14b884$var$dataViewTag = "[object DataView]", $f174426d0f14b884$var$float32Tag = "[object Float32Array]", $f174426d0f14b884$var$float64Tag = "[object Float64Array]", $f174426d0f14b884$var$int8Tag = "[object Int8Array]", $f174426d0f14b884$var$int16Tag = "[object Int16Array]", $f174426d0f14b884$var$int32Tag = "[object Int32Array]", $f174426d0f14b884$var$uint8Tag = "[object Uint8Array]", $f174426d0f14b884$var$uint8ClampedTag = "[object Uint8ClampedArray]", $f174426d0f14b884$var$uint16Tag = "[object Uint16Array]", $f174426d0f14b884$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $f174426d0f14b884$var$typedArrayTags = {};
$f174426d0f14b884$var$typedArrayTags[$f174426d0f14b884$var$float32Tag] = $f174426d0f14b884$var$typedArrayTags[$f174426d0f14b884$var$float64Tag] = $f174426d0f14b884$var$typedArrayTags[$f174426d0f14b884$var$int8Tag] = $f174426d0f14b884$var$typedArrayTags[$f174426d0f14b884$var$int16Tag] = $f174426d0f14b884$var$typedArrayTags[$f174426d0f14b884$var$int32Tag] = $f174426d0f14b884$var$typedArrayTags[$f174426d0f14b884$var$uint8Tag] = $f174426d0f14b884$var$typedArrayTags[$f174426d0f14b884$var$uint8ClampedTag] = $f174426d0f14b884$var$typedArrayTags[$f174426d0f14b884$var$uint16Tag] = $f174426d0f14b884$var$typedArrayTags[$f174426d0f14b884$var$uint32Tag] = true;
$f174426d0f14b884$var$typedArrayTags[$f174426d0f14b884$var$argsTag] = $f174426d0f14b884$var$typedArrayTags[$f174426d0f14b884$var$arrayTag] = $f174426d0f14b884$var$typedArrayTags[$f174426d0f14b884$var$arrayBufferTag] = $f174426d0f14b884$var$typedArrayTags[$f174426d0f14b884$var$boolTag] = $f174426d0f14b884$var$typedArrayTags[$f174426d0f14b884$var$dataViewTag] = $f174426d0f14b884$var$typedArrayTags[$f174426d0f14b884$var$dateTag] = $f174426d0f14b884$var$typedArrayTags[$f174426d0f14b884$var$errorTag] = $f174426d0f14b884$var$typedArrayTags[$f174426d0f14b884$var$funcTag] = $f174426d0f14b884$var$typedArrayTags[$f174426d0f14b884$var$mapTag] = $f174426d0f14b884$var$typedArrayTags[$f174426d0f14b884$var$numberTag] = $f174426d0f14b884$var$typedArrayTags[$f174426d0f14b884$var$objectTag] = $f174426d0f14b884$var$typedArrayTags[$f174426d0f14b884$var$regexpTag] = $f174426d0f14b884$var$typedArrayTags[$f174426d0f14b884$var$setTag] = $f174426d0f14b884$var$typedArrayTags[$f174426d0f14b884$var$stringTag] = $f174426d0f14b884$var$typedArrayTags[$f174426d0f14b884$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $f174426d0f14b884$var$baseIsTypedArray(value) {
    return (0, $4757a366dbe9cf5c$export$2e2bcd8739ae039)(value) && (0, $a46b7b33126b409e$export$2e2bcd8739ae039)(value.length) && !!$f174426d0f14b884$var$typedArrayTags[(0, $64fb6e2e9109eff6$export$2e2bcd8739ae039)(value)];
}
var $f174426d0f14b884$export$2e2bcd8739ae039 = $f174426d0f14b884$var$baseIsTypedArray;


/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $d92dccaad4cc131c$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $d92dccaad4cc131c$export$2e2bcd8739ae039 = $d92dccaad4cc131c$var$baseUnary;



var $fe9Eu = parcelRequire("fe9Eu");
/* Node.js helper references. */ var $36b8ee2290529be7$var$nodeIsTypedArray = (0, $fe9Eu.default) && (0, $fe9Eu.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $36b8ee2290529be7$var$isTypedArray = $36b8ee2290529be7$var$nodeIsTypedArray ? (0, $d92dccaad4cc131c$export$2e2bcd8739ae039)($36b8ee2290529be7$var$nodeIsTypedArray) : (0, $f174426d0f14b884$export$2e2bcd8739ae039);
var $36b8ee2290529be7$export$2e2bcd8739ae039 = $36b8ee2290529be7$var$isTypedArray;


/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $e28a1203dc2185eb$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
var $e28a1203dc2185eb$export$2e2bcd8739ae039 = $e28a1203dc2185eb$var$safeGet;




/** Used for built-in method references. */ var $e4d7a301c848fa48$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e4d7a301c848fa48$var$hasOwnProperty = $e4d7a301c848fa48$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $e4d7a301c848fa48$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($e4d7a301c848fa48$var$hasOwnProperty.call(object, key) && (0, $a1fc17bf3c9673a4$export$2e2bcd8739ae039)(objValue, value)) || value === undefined && !(key in object)) (0, $2d1ea61fb95249f0$export$2e2bcd8739ae039)(object, key, value);
}
var $e4d7a301c848fa48$export$2e2bcd8739ae039 = $e4d7a301c848fa48$var$assignValue;



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $1da977d0f00c42cc$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $2d1ea61fb95249f0$export$2e2bcd8739ae039)(object, key, newValue);
        else (0, $e4d7a301c848fa48$export$2e2bcd8739ae039)(object, key, newValue);
    }
    return object;
}
var $1da977d0f00c42cc$export$2e2bcd8739ae039 = $1da977d0f00c42cc$var$copyObject;


/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $df1e4299083077c9$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $df1e4299083077c9$export$2e2bcd8739ae039 = $df1e4299083077c9$var$baseTimes;





var $42CIw = parcelRequire("42CIw");
/** Used as references for various `Number` constants. */ var $3a09257973ef1195$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $3a09257973ef1195$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $3a09257973ef1195$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $3a09257973ef1195$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $3a09257973ef1195$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $3a09257973ef1195$export$2e2bcd8739ae039 = $3a09257973ef1195$var$isIndex;



/** Used for built-in method references. */ var $294a8bd41f7467e4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $294a8bd41f7467e4$var$hasOwnProperty = $294a8bd41f7467e4$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $294a8bd41f7467e4$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $93b249752024ad0a$export$2e2bcd8739ae039)(value), isArg = !isArr && (0, $ec49f3d2aee73883$export$2e2bcd8739ae039)(value), isBuff = !isArr && !isArg && (0, $42CIw.default)(value), isType = !isArr && !isArg && !isBuff && (0, $36b8ee2290529be7$export$2e2bcd8739ae039)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $df1e4299083077c9$export$2e2bcd8739ae039)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $294a8bd41f7467e4$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    (0, $3a09257973ef1195$export$2e2bcd8739ae039)(key, length)))) result.push(key);
    return result;
}
var $294a8bd41f7467e4$export$2e2bcd8739ae039 = $294a8bd41f7467e4$var$arrayLikeKeys;




/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $310e85342f0cd2a4$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $310e85342f0cd2a4$export$2e2bcd8739ae039 = $310e85342f0cd2a4$var$nativeKeysIn;


/** Used for built-in method references. */ var $90b7ffcb32222929$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $90b7ffcb32222929$var$hasOwnProperty = $90b7ffcb32222929$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $90b7ffcb32222929$var$baseKeysIn(object) {
    if (!(0, $97e1fd59e0a392d4$export$2e2bcd8739ae039)(object)) return (0, $310e85342f0cd2a4$export$2e2bcd8739ae039)(object);
    var isProto = (0, $c4b37195c52b7c20$export$2e2bcd8739ae039)(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$90b7ffcb32222929$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $90b7ffcb32222929$export$2e2bcd8739ae039 = $90b7ffcb32222929$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $e28c6d98ceb59df4$var$keysIn(object) {
    return (0, $38dc911623597bb2$export$2e2bcd8739ae039)(object) ? (0, $294a8bd41f7467e4$export$2e2bcd8739ae039)(object, true) : (0, $90b7ffcb32222929$export$2e2bcd8739ae039)(object);
}
var $e28c6d98ceb59df4$export$2e2bcd8739ae039 = $e28c6d98ceb59df4$var$keysIn;


/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $a4e16236929079ac$var$toPlainObject(value) {
    return (0, $1da977d0f00c42cc$export$2e2bcd8739ae039)(value, (0, $e28c6d98ceb59df4$export$2e2bcd8739ae039)(value));
}
var $a4e16236929079ac$export$2e2bcd8739ae039 = $a4e16236929079ac$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $52e5146340e64545$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, $e28a1203dc2185eb$export$2e2bcd8739ae039)(object, key), srcValue = (0, $e28a1203dc2185eb$export$2e2bcd8739ae039)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, $3350fb5062313fc7$export$2e2bcd8739ae039)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, $93b249752024ad0a$export$2e2bcd8739ae039)(srcValue), isBuff = !isArr && (0, $42CIw.default)(srcValue), isTyped = !isArr && !isBuff && (0, $36b8ee2290529be7$export$2e2bcd8739ae039)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, $93b249752024ad0a$export$2e2bcd8739ae039)(objValue)) newValue = objValue;
            else if ((0, $1497e74d44ac2a0a$export$2e2bcd8739ae039)(objValue)) newValue = (0, $ba8eed531ba68a89$export$2e2bcd8739ae039)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, $6nnFN.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, $9b604d3b769eeba8$export$2e2bcd8739ae039)(srcValue, true);
            } else newValue = [];
        } else if ((0, $6bab660559d3a968$export$2e2bcd8739ae039)(srcValue) || (0, $ec49f3d2aee73883$export$2e2bcd8739ae039)(srcValue)) {
            newValue = objValue;
            if ((0, $ec49f3d2aee73883$export$2e2bcd8739ae039)(objValue)) newValue = (0, $a4e16236929079ac$export$2e2bcd8739ae039)(objValue);
            else if (!(0, $97e1fd59e0a392d4$export$2e2bcd8739ae039)(objValue) || (0, $fe3e403a57673301$export$2e2bcd8739ae039)(objValue)) newValue = (0, $82723ed9ea65b904$export$2e2bcd8739ae039)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    (0, $3350fb5062313fc7$export$2e2bcd8739ae039)(object, key, newValue);
}
var $52e5146340e64545$export$2e2bcd8739ae039 = $52e5146340e64545$var$baseMergeDeep;





/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $4812213862bb16df$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, $acba1b6152d3ae5b$export$2e2bcd8739ae039)(source, function(srcValue, key) {
        stack || (stack = new (0, $dec20d54409d2f2d$export$2e2bcd8739ae039));
        if ((0, $97e1fd59e0a392d4$export$2e2bcd8739ae039)(srcValue)) (0, $52e5146340e64545$export$2e2bcd8739ae039)(object, source, key, srcIndex, $4812213862bb16df$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, $e28a1203dc2185eb$export$2e2bcd8739ae039)(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, $3350fb5062313fc7$export$2e2bcd8739ae039)(object, key, newValue);
        }
    }, (0, $e28c6d98ceb59df4$export$2e2bcd8739ae039));
}
var $4812213862bb16df$export$2e2bcd8739ae039 = $4812213862bb16df$var$baseMerge;


/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $9aaf98d05e19af61$var$identity(value) {
    return value;
}
var $9aaf98d05e19af61$export$2e2bcd8739ae039 = $9aaf98d05e19af61$var$identity;


/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $c49862eb7d350c90$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $c49862eb7d350c90$export$2e2bcd8739ae039 = $c49862eb7d350c90$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $c47fe452ed07a7fc$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $c47fe452ed07a7fc$var$overRest(func, start, transform) {
    start = $c47fe452ed07a7fc$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $c47fe452ed07a7fc$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $c49862eb7d350c90$export$2e2bcd8739ae039)(func, this, otherArgs);
    };
}
var $c47fe452ed07a7fc$export$2e2bcd8739ae039 = $c47fe452ed07a7fc$var$overRest;


/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $5d87c5ca31199945$var$constant(value) {
    return function() {
        return value;
    };
}
var $5d87c5ca31199945$export$2e2bcd8739ae039 = $5d87c5ca31199945$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $bb1185375f632f5d$var$baseSetToString = !(0, $3109e237cd9de07f$export$2e2bcd8739ae039) ? (0, $9aaf98d05e19af61$export$2e2bcd8739ae039) : function(func, string) {
    return (0, $3109e237cd9de07f$export$2e2bcd8739ae039)(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": (0, $5d87c5ca31199945$export$2e2bcd8739ae039)(string),
        "writable": true
    });
};
var $bb1185375f632f5d$export$2e2bcd8739ae039 = $bb1185375f632f5d$var$baseSetToString;


/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $00c80c177847c198$var$HOT_COUNT = 800, $00c80c177847c198$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $00c80c177847c198$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $00c80c177847c198$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $00c80c177847c198$var$nativeNow(), remaining = $00c80c177847c198$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $00c80c177847c198$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $00c80c177847c198$export$2e2bcd8739ae039 = $00c80c177847c198$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $3a82fa290399b8c5$var$setToString = (0, $00c80c177847c198$export$2e2bcd8739ae039)((0, $bb1185375f632f5d$export$2e2bcd8739ae039));
var $3a82fa290399b8c5$export$2e2bcd8739ae039 = $3a82fa290399b8c5$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $3e3294c693c9c426$var$baseRest(func, start) {
    return (0, $3a82fa290399b8c5$export$2e2bcd8739ae039)((0, $c47fe452ed07a7fc$export$2e2bcd8739ae039)(func, start, (0, $9aaf98d05e19af61$export$2e2bcd8739ae039)), func + "");
}
var $3e3294c693c9c426$export$2e2bcd8739ae039 = $3e3294c693c9c426$var$baseRest;






/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $9c36e9ae400d2dcb$var$isIterateeCall(value, index, object) {
    if (!(0, $97e1fd59e0a392d4$export$2e2bcd8739ae039)(object)) return false;
    var type = typeof index;
    if (type == "number" ? (0, $38dc911623597bb2$export$2e2bcd8739ae039)(object) && (0, $3a09257973ef1195$export$2e2bcd8739ae039)(index, object.length) : type == "string" && index in object) return (0, $a1fc17bf3c9673a4$export$2e2bcd8739ae039)(object[index], value);
    return false;
}
var $9c36e9ae400d2dcb$export$2e2bcd8739ae039 = $9c36e9ae400d2dcb$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $0175bc0208c87bf7$var$createAssigner(assigner) {
    return (0, $3e3294c693c9c426$export$2e2bcd8739ae039)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && (0, $9c36e9ae400d2dcb$export$2e2bcd8739ae039)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
var $0175bc0208c87bf7$export$2e2bcd8739ae039 = $0175bc0208c87bf7$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $47c6e52c26bddb86$var$merge = (0, $0175bc0208c87bf7$export$2e2bcd8739ae039)(function(object, source, srcIndex) {
    (0, $4812213862bb16df$export$2e2bcd8739ae039)(object, source, srcIndex);
});
var $47c6e52c26bddb86$export$2e2bcd8739ae039 = $47c6e52c26bddb86$var$merge;


var $8324d048851d53b4$exports = {};

$parcel$export($8324d048851d53b4$exports, "Scope", function () { return $8324d048851d53b4$export$775b6bb06e53a214; });
$parcel$export($8324d048851d53b4$exports, "Attributor", function () { return $8324d048851d53b4$export$217610c4183502d0; });
$parcel$export($8324d048851d53b4$exports, "Registry", function () { return $8324d048851d53b4$export$4d9facee29974f3; });
$parcel$export($8324d048851d53b4$exports, "ClassAttributor", function () { return $8324d048851d53b4$export$651d45509677cf07; });
$parcel$export($8324d048851d53b4$exports, "StyleAttributor", function () { return $8324d048851d53b4$export$7c8099bbfe87b94d; });
$parcel$export($8324d048851d53b4$exports, "AttributorStore", function () { return $8324d048851d53b4$export$68ad86ab95e8de42; });
$parcel$export($8324d048851d53b4$exports, "LeafBlot", function () { return $8324d048851d53b4$export$7420b9c542181544; });
$parcel$export($8324d048851d53b4$exports, "ParentBlot", function () { return $8324d048851d53b4$export$e43113f0aad76fe; });
$parcel$export($8324d048851d53b4$exports, "InlineBlot", function () { return $8324d048851d53b4$export$f67a34bc25a7a861; });
$parcel$export($8324d048851d53b4$exports, "BlockBlot", function () { return $8324d048851d53b4$export$4f7f03641f7bfc8c; });
$parcel$export($8324d048851d53b4$exports, "ContainerBlot", function () { return $8324d048851d53b4$export$c898d510319704c0; });
$parcel$export($8324d048851d53b4$exports, "EmbedBlot", function () { return $8324d048851d53b4$export$297a1fa96f55f00f; });
$parcel$export($8324d048851d53b4$exports, "ScrollBlot", function () { return $8324d048851d53b4$export$7175329dad7a46f1; });
$parcel$export($8324d048851d53b4$exports, "TextBlot", function () { return $8324d048851d53b4$export$10ac0c5716409de6; });
var $8324d048851d53b4$export$775b6bb06e53a214 = /* @__PURE__ */ ((Scope2)=>(Scope2[Scope2.TYPE = 3] = "TYPE", Scope2[Scope2.LEVEL = 12] = "LEVEL", Scope2[Scope2.ATTRIBUTE = 13] = "ATTRIBUTE", Scope2[Scope2.BLOT = 14] = "BLOT", Scope2[Scope2.INLINE = 7] = "INLINE", Scope2[Scope2.BLOCK = 11] = "BLOCK", Scope2[Scope2.BLOCK_BLOT = 10] = "BLOCK_BLOT", Scope2[Scope2.INLINE_BLOT = 6] = "INLINE_BLOT", Scope2[Scope2.BLOCK_ATTRIBUTE = 9] = "BLOCK_ATTRIBUTE", Scope2[Scope2.INLINE_ATTRIBUTE = 5] = "INLINE_ATTRIBUTE", Scope2[Scope2.ANY = 15] = "ANY", Scope2))($8324d048851d53b4$export$775b6bb06e53a214 || {});
class $8324d048851d53b4$export$217610c4183502d0 {
    static keys(node) {
        return Array.from(node.attributes).map((item)=>item.name);
    }
    add(node, value) {
        return this.canAdd(node, value) ? (node.setAttribute(this.keyName, value), !0) : !1;
    }
    canAdd(_node, value) {
        return this.whitelist == null ? !0 : typeof value == "string" ? this.whitelist.indexOf(value.replace(/["']/g, "")) > -1 : this.whitelist.indexOf(value) > -1;
    }
    remove(node) {
        node.removeAttribute(this.keyName);
    }
    value(node) {
        const value = node.getAttribute(this.keyName);
        return this.canAdd(node, value) && value ? value : "";
    }
    constructor(attrName, keyName, options = {}){
        this.attrName = attrName, this.keyName = keyName;
        const attributeBit = $8324d048851d53b4$export$775b6bb06e53a214.TYPE & $8324d048851d53b4$export$775b6bb06e53a214.ATTRIBUTE;
        this.scope = options.scope != null ? // Ignore type bits, force attribute bit
        options.scope & $8324d048851d53b4$export$775b6bb06e53a214.LEVEL | attributeBit : $8324d048851d53b4$export$775b6bb06e53a214.ATTRIBUTE, options.whitelist != null && (this.whitelist = options.whitelist);
    }
}
class $8324d048851d53b4$var$ParchmentError extends Error {
    constructor(message){
        message = "[Parchment] " + message, super(message), this.message = message, this.name = this.constructor.name;
    }
}
const $8324d048851d53b4$var$_Registry = class _Registry {
    static find(node, bubble = !1) {
        if (node == null) return null;
        if (this.blots.has(node)) return this.blots.get(node) || null;
        if (bubble) {
            let parentNode = null;
            try {
                parentNode = node.parentNode;
            } catch  {
                return null;
            }
            return this.find(parentNode, bubble);
        }
        return null;
    }
    create(scroll, input, value) {
        const match2 = this.query(input);
        if (match2 == null) throw new $8324d048851d53b4$var$ParchmentError(`Unable to create ${input} blot`);
        const blotClass = match2, node = // @ts-expect-error Fix me later
        input instanceof Node || input.nodeType === Node.TEXT_NODE ? input : blotClass.create(value), blot = new blotClass(scroll, node, value);
        return _Registry.blots.set(blot.domNode, blot), blot;
    }
    find(node, bubble = !1) {
        return _Registry.find(node, bubble);
    }
    query(query, scope = $8324d048851d53b4$export$775b6bb06e53a214.ANY) {
        let match2;
        return typeof query == "string" ? match2 = this.types[query] || this.attributes[query] : query instanceof Text || query.nodeType === Node.TEXT_NODE ? match2 = this.types.text : typeof query == "number" ? query & $8324d048851d53b4$export$775b6bb06e53a214.LEVEL & $8324d048851d53b4$export$775b6bb06e53a214.BLOCK ? match2 = this.types.block : query & $8324d048851d53b4$export$775b6bb06e53a214.LEVEL & $8324d048851d53b4$export$775b6bb06e53a214.INLINE && (match2 = this.types.inline) : query instanceof Element && ((query.getAttribute("class") || "").split(/\s+/).some((name)=>(match2 = this.classes[name], !!match2)), match2 = match2 || this.tags[query.tagName]), match2 == null ? null : "scope" in match2 && scope & $8324d048851d53b4$export$775b6bb06e53a214.LEVEL & match2.scope && scope & $8324d048851d53b4$export$775b6bb06e53a214.TYPE & match2.scope ? match2 : null;
    }
    register(...definitions) {
        return definitions.map((definition)=>{
            const isBlot = "blotName" in definition, isAttr = "attrName" in definition;
            if (!isBlot && !isAttr) throw new $8324d048851d53b4$var$ParchmentError("Invalid definition");
            if (isBlot && definition.blotName === "abstract") throw new $8324d048851d53b4$var$ParchmentError("Cannot register abstract class");
            const key = isBlot ? definition.blotName : isAttr ? definition.attrName : void 0;
            return this.types[key] = definition, isAttr ? typeof definition.keyName == "string" && (this.attributes[definition.keyName] = definition) : isBlot && (definition.className && (this.classes[definition.className] = definition), definition.tagName && (Array.isArray(definition.tagName) ? definition.tagName = definition.tagName.map((tagName)=>tagName.toUpperCase()) : definition.tagName = definition.tagName.toUpperCase(), (Array.isArray(definition.tagName) ? definition.tagName : [
                definition.tagName
            ]).forEach((tag)=>{
                (this.tags[tag] == null || definition.className == null) && (this.tags[tag] = definition);
            }))), definition;
        });
    }
    constructor(){
        this.attributes = {}, this.classes = {}, this.tags = {}, this.types = {};
    }
};
$8324d048851d53b4$var$_Registry.blots = /* @__PURE__ */ new WeakMap();
let $8324d048851d53b4$export$4d9facee29974f3 = $8324d048851d53b4$var$_Registry;
function $8324d048851d53b4$var$match(node, prefix) {
    return (node.getAttribute("class") || "").split(/\s+/).filter((name)=>name.indexOf(`${prefix}-`) === 0);
}
class $8324d048851d53b4$var$ClassAttributor extends $8324d048851d53b4$export$217610c4183502d0 {
    static keys(node) {
        return (node.getAttribute("class") || "").split(/\s+/).map((name)=>name.split("-").slice(0, -1).join("-"));
    }
    add(node, value) {
        return this.canAdd(node, value) ? (this.remove(node), node.classList.add(`${this.keyName}-${value}`), !0) : !1;
    }
    remove(node) {
        $8324d048851d53b4$var$match(node, this.keyName).forEach((name)=>{
            node.classList.remove(name);
        }), node.classList.length === 0 && node.removeAttribute("class");
    }
    value(node) {
        const value = ($8324d048851d53b4$var$match(node, this.keyName)[0] || "").slice(this.keyName.length + 1);
        return this.canAdd(node, value) ? value : "";
    }
}
const $8324d048851d53b4$export$651d45509677cf07 = $8324d048851d53b4$var$ClassAttributor;
function $8324d048851d53b4$var$camelize(name) {
    const parts = name.split("-"), rest = parts.slice(1).map((part)=>part[0].toUpperCase() + part.slice(1)).join("");
    return parts[0] + rest;
}
class $8324d048851d53b4$var$StyleAttributor extends $8324d048851d53b4$export$217610c4183502d0 {
    static keys(node) {
        return (node.getAttribute("style") || "").split(";").map((value)=>value.split(":")[0].trim());
    }
    add(node, value) {
        return this.canAdd(node, value) ? (node.style[$8324d048851d53b4$var$camelize(this.keyName)] = value, !0) : !1;
    }
    remove(node) {
        node.style[$8324d048851d53b4$var$camelize(this.keyName)] = "", node.getAttribute("style") || node.removeAttribute("style");
    }
    value(node) {
        const value = node.style[$8324d048851d53b4$var$camelize(this.keyName)];
        return this.canAdd(node, value) ? value : "";
    }
}
const $8324d048851d53b4$export$7c8099bbfe87b94d = $8324d048851d53b4$var$StyleAttributor;
class $8324d048851d53b4$var$AttributorStore {
    attribute(attribute, value) {
        value ? attribute.add(this.domNode, value) && (attribute.value(this.domNode) != null ? this.attributes[attribute.attrName] = attribute : delete this.attributes[attribute.attrName]) : (attribute.remove(this.domNode), delete this.attributes[attribute.attrName]);
    }
    build() {
        this.attributes = {};
        const blot = $8324d048851d53b4$export$4d9facee29974f3.find(this.domNode);
        if (blot == null) return;
        const attributes = $8324d048851d53b4$export$217610c4183502d0.keys(this.domNode), classes = $8324d048851d53b4$export$651d45509677cf07.keys(this.domNode), styles = $8324d048851d53b4$export$7c8099bbfe87b94d.keys(this.domNode);
        attributes.concat(classes).concat(styles).forEach((name)=>{
            const attr = blot.scroll.query(name, $8324d048851d53b4$export$775b6bb06e53a214.ATTRIBUTE);
            attr instanceof $8324d048851d53b4$export$217610c4183502d0 && (this.attributes[attr.attrName] = attr);
        });
    }
    copy(target) {
        Object.keys(this.attributes).forEach((key)=>{
            const value = this.attributes[key].value(this.domNode);
            target.format(key, value);
        });
    }
    move(target) {
        this.copy(target), Object.keys(this.attributes).forEach((key)=>{
            this.attributes[key].remove(this.domNode);
        }), this.attributes = {};
    }
    values() {
        return Object.keys(this.attributes).reduce((attributes, name)=>(attributes[name] = this.attributes[name].value(this.domNode), attributes), {});
    }
    constructor(domNode){
        this.attributes = {}, this.domNode = domNode, this.build();
    }
}
const $8324d048851d53b4$export$68ad86ab95e8de42 = $8324d048851d53b4$var$AttributorStore, $8324d048851d53b4$var$_ShadowBlot = class _ShadowBlot {
    static create(rawValue) {
        if (this.tagName == null) throw new $8324d048851d53b4$var$ParchmentError("Blot definition missing tagName");
        let node, value;
        return Array.isArray(this.tagName) ? (typeof rawValue == "string" ? (value = rawValue.toUpperCase(), parseInt(value, 10).toString() === value && (value = parseInt(value, 10))) : typeof rawValue == "number" && (value = rawValue), typeof value == "number" ? node = document.createElement(this.tagName[value - 1]) : value && this.tagName.indexOf(value) > -1 ? node = document.createElement(value) : node = document.createElement(this.tagName[0])) : node = document.createElement(this.tagName), this.className && node.classList.add(this.className), node;
    }
    // Hack for accessing inherited static methods
    get statics() {
        return this.constructor;
    }
    attach() {}
    clone() {
        const domNode = this.domNode.cloneNode(!1);
        return this.scroll.create(domNode);
    }
    detach() {
        this.parent != null && this.parent.removeChild(this), $8324d048851d53b4$export$4d9facee29974f3.blots.delete(this.domNode);
    }
    deleteAt(index, length) {
        this.isolate(index, length).remove();
    }
    formatAt(index, length, name, value) {
        const blot = this.isolate(index, length);
        if (this.scroll.query(name, $8324d048851d53b4$export$775b6bb06e53a214.BLOT) != null && value) blot.wrap(name, value);
        else if (this.scroll.query(name, $8324d048851d53b4$export$775b6bb06e53a214.ATTRIBUTE) != null) {
            const parent = this.scroll.create(this.statics.scope);
            blot.wrap(parent), parent.format(name, value);
        }
    }
    insertAt(index, value, def) {
        const blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def), ref = this.split(index);
        this.parent.insertBefore(blot, ref || void 0);
    }
    isolate(index, length) {
        const target = this.split(index);
        if (target == null) throw new Error("Attempt to isolate at end");
        return target.split(length), target;
    }
    length() {
        return 1;
    }
    offset(root = this.parent) {
        return this.parent == null || this === root ? 0 : this.parent.children.offset(this) + this.parent.offset(root);
    }
    optimize(_context) {
        this.statics.requiredContainer && !(this.parent instanceof this.statics.requiredContainer) && this.wrap(this.statics.requiredContainer.blotName);
    }
    remove() {
        this.domNode.parentNode != null && this.domNode.parentNode.removeChild(this.domNode), this.detach();
    }
    replaceWith(name, value) {
        const replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
        return this.parent != null && (this.parent.insertBefore(replacement, this.next || void 0), this.remove()), replacement;
    }
    split(index, _force) {
        return index === 0 ? this : this.next;
    }
    update(_mutations, _context) {}
    wrap(name, value) {
        const wrapper = typeof name == "string" ? this.scroll.create(name, value) : name;
        if (this.parent != null && this.parent.insertBefore(wrapper, this.next || void 0), typeof wrapper.appendChild != "function") throw new $8324d048851d53b4$var$ParchmentError(`Cannot wrap ${name}`);
        return wrapper.appendChild(this), wrapper;
    }
    constructor(scroll, domNode){
        this.scroll = scroll, this.domNode = domNode, $8324d048851d53b4$export$4d9facee29974f3.blots.set(domNode, this), this.prev = null, this.next = null;
    }
};
$8324d048851d53b4$var$_ShadowBlot.blotName = "abstract";
let $8324d048851d53b4$var$ShadowBlot = $8324d048851d53b4$var$_ShadowBlot;
const $8324d048851d53b4$var$_LeafBlot = class _LeafBlot extends $8324d048851d53b4$var$ShadowBlot {
    /**
   * Returns the value represented by domNode if it is this Blot's type
   * No checking that domNode can represent this Blot type is required so
   * applications needing it should check externally before calling.
   */ static value(_domNode) {
        return !0;
    }
    /**
   * Given location represented by node and offset from DOM Selection Range,
   * return index to that location.
   */ index(node, offset) {
        return this.domNode === node || this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY ? Math.min(offset, 1) : -1;
    }
    /**
   * Given index to location within blot, return node and offset representing
   * that location, consumable by DOM Selection Range
   */ position(index, _inclusive) {
        let offset = Array.from(this.parent.domNode.childNodes).indexOf(this.domNode);
        return index > 0 && (offset += 1), [
            this.parent.domNode,
            offset
        ];
    }
    /**
   * Return value represented by this blot
   * Should not change without interaction from API or
   * user change detectable by update()
   */ value() {
        return {
            [this.statics.blotName]: this.statics.value(this.domNode) || !0
        };
    }
};
$8324d048851d53b4$var$_LeafBlot.scope = $8324d048851d53b4$export$775b6bb06e53a214.INLINE_BLOT;
let $8324d048851d53b4$var$LeafBlot = $8324d048851d53b4$var$_LeafBlot;
const $8324d048851d53b4$export$7420b9c542181544 = $8324d048851d53b4$var$LeafBlot;
class $8324d048851d53b4$var$LinkedList {
    append(...nodes) {
        if (this.insertBefore(nodes[0], null), nodes.length > 1) {
            const rest = nodes.slice(1);
            this.append(...rest);
        }
    }
    at(index) {
        const next = this.iterator();
        let cur = next();
        for(; cur && index > 0;)index -= 1, cur = next();
        return cur;
    }
    contains(node) {
        const next = this.iterator();
        let cur = next();
        for(; cur;){
            if (cur === node) return !0;
            cur = next();
        }
        return !1;
    }
    indexOf(node) {
        const next = this.iterator();
        let cur = next(), index = 0;
        for(; cur;){
            if (cur === node) return index;
            index += 1, cur = next();
        }
        return -1;
    }
    insertBefore(node, refNode) {
        node != null && (this.remove(node), node.next = refNode, refNode != null ? (node.prev = refNode.prev, refNode.prev != null && (refNode.prev.next = node), refNode.prev = node, refNode === this.head && (this.head = node)) : this.tail != null ? (this.tail.next = node, node.prev = this.tail, this.tail = node) : (node.prev = null, this.head = this.tail = node), this.length += 1);
    }
    offset(target) {
        let index = 0, cur = this.head;
        for(; cur != null;){
            if (cur === target) return index;
            index += cur.length(), cur = cur.next;
        }
        return -1;
    }
    remove(node) {
        this.contains(node) && (node.prev != null && (node.prev.next = node.next), node.next != null && (node.next.prev = node.prev), node === this.head && (this.head = node.next), node === this.tail && (this.tail = node.prev), this.length -= 1);
    }
    iterator(curNode = this.head) {
        return ()=>{
            const ret = curNode;
            return curNode != null && (curNode = curNode.next), ret;
        };
    }
    find(index, inclusive = !1) {
        const next = this.iterator();
        let cur = next();
        for(; cur;){
            const length = cur.length();
            if (index < length || inclusive && index === length && (cur.next == null || cur.next.length() !== 0)) return [
                cur,
                index
            ];
            index -= length, cur = next();
        }
        return [
            null,
            0
        ];
    }
    forEach(callback) {
        const next = this.iterator();
        let cur = next();
        for(; cur;)callback(cur), cur = next();
    }
    forEachAt(index, length, callback) {
        if (length <= 0) return;
        const [startNode, offset] = this.find(index);
        let curIndex = index - offset;
        const next = this.iterator(startNode);
        let cur = next();
        for(; cur && curIndex < index + length;){
            const curLength = cur.length();
            index > curIndex ? callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index)) : callback(cur, 0, Math.min(curLength, index + length - curIndex)), curIndex += curLength, cur = next();
        }
    }
    map(callback) {
        return this.reduce((memo, cur)=>(memo.push(callback(cur)), memo), []);
    }
    reduce(callback, memo) {
        const next = this.iterator();
        let cur = next();
        for(; cur;)memo = callback(memo, cur), cur = next();
        return memo;
    }
    constructor(){
        this.head = null, this.tail = null, this.length = 0;
    }
}
function $8324d048851d53b4$var$makeAttachedBlot(node, scroll) {
    const found = scroll.find(node);
    if (found) return found;
    try {
        return scroll.create(node);
    } catch  {
        const blot = scroll.create($8324d048851d53b4$export$775b6bb06e53a214.INLINE);
        return Array.from(node.childNodes).forEach((child)=>{
            blot.domNode.appendChild(child);
        }), node.parentNode && node.parentNode.replaceChild(blot.domNode, node), blot.attach(), blot;
    }
}
const $8324d048851d53b4$var$_ParentBlot = class _ParentBlot extends $8324d048851d53b4$var$ShadowBlot {
    appendChild(other) {
        this.insertBefore(other);
    }
    attach() {
        super.attach(), this.children.forEach((child)=>{
            child.attach();
        });
    }
    attachUI(node) {
        this.uiNode != null && this.uiNode.remove(), this.uiNode = node, _ParentBlot.uiClass && this.uiNode.classList.add(_ParentBlot.uiClass), this.uiNode.setAttribute("contenteditable", "false"), this.domNode.insertBefore(this.uiNode, this.domNode.firstChild);
    }
    /**
   * Called during construction, should fill its own children LinkedList.
   */ build() {
        this.children = new $8324d048851d53b4$var$LinkedList(), Array.from(this.domNode.childNodes).filter((node)=>node !== this.uiNode).reverse().forEach((node)=>{
            try {
                const child = $8324d048851d53b4$var$makeAttachedBlot(node, this.scroll);
                this.insertBefore(child, this.children.head || void 0);
            } catch (err) {
                if (err instanceof $8324d048851d53b4$var$ParchmentError) return;
                throw err;
            }
        });
    }
    deleteAt(index, length) {
        if (index === 0 && length === this.length()) return this.remove();
        this.children.forEachAt(index, length, (child, offset, childLength)=>{
            child.deleteAt(offset, childLength);
        });
    }
    descendant(criteria, index = 0) {
        const [child, offset] = this.children.find(index);
        return criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria ? [
            child,
            offset
        ] : child instanceof _ParentBlot ? child.descendant(criteria, offset) : [
            null,
            -1
        ];
    }
    descendants(criteria, index = 0, length = Number.MAX_VALUE) {
        let descendants = [], lengthLeft = length;
        return this.children.forEachAt(index, length, (child, childIndex, childLength)=>{
            (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) && descendants.push(child), child instanceof _ParentBlot && (descendants = descendants.concat(child.descendants(criteria, childIndex, lengthLeft))), lengthLeft -= childLength;
        }), descendants;
    }
    detach() {
        this.children.forEach((child)=>{
            child.detach();
        }), super.detach();
    }
    enforceAllowedChildren() {
        let done = !1;
        this.children.forEach((child)=>{
            done || this.statics.allowedChildren.some((def)=>child instanceof def) || (child.statics.scope === $8324d048851d53b4$export$775b6bb06e53a214.BLOCK_BLOT ? (child.next != null && this.splitAfter(child), child.prev != null && this.splitAfter(child.prev), child.parent.unwrap(), done = !0) : child instanceof _ParentBlot ? child.unwrap() : child.remove());
        });
    }
    formatAt(index, length, name, value) {
        this.children.forEachAt(index, length, (child, offset, childLength)=>{
            child.formatAt(offset, childLength, name, value);
        });
    }
    insertAt(index, value, def) {
        const [child, offset] = this.children.find(index);
        if (child) child.insertAt(offset, value, def);
        else {
            const blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def);
            this.appendChild(blot);
        }
    }
    insertBefore(childBlot, refBlot) {
        childBlot.parent != null && childBlot.parent.children.remove(childBlot);
        let refDomNode = null;
        this.children.insertBefore(childBlot, refBlot || null), childBlot.parent = this, refBlot != null && (refDomNode = refBlot.domNode), (this.domNode.parentNode !== childBlot.domNode || this.domNode.nextSibling !== refDomNode) && this.domNode.insertBefore(childBlot.domNode, refDomNode), childBlot.attach();
    }
    length() {
        return this.children.reduce((memo, child)=>memo + child.length(), 0);
    }
    moveChildren(targetParent, refNode) {
        this.children.forEach((child)=>{
            targetParent.insertBefore(child, refNode);
        });
    }
    optimize(context) {
        if (super.optimize(context), this.enforceAllowedChildren(), this.uiNode != null && this.uiNode !== this.domNode.firstChild && this.domNode.insertBefore(this.uiNode, this.domNode.firstChild), this.children.length === 0) {
            if (this.statics.defaultChild != null) {
                const child = this.scroll.create(this.statics.defaultChild.blotName);
                this.appendChild(child);
            } else this.remove();
        }
    }
    path(index, inclusive = !1) {
        const [child, offset] = this.children.find(index, inclusive), position = [
            [
                this,
                index
            ]
        ];
        return child instanceof _ParentBlot ? position.concat(child.path(offset, inclusive)) : (child != null && position.push([
            child,
            offset
        ]), position);
    }
    removeChild(child) {
        this.children.remove(child);
    }
    replaceWith(name, value) {
        const replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
        return replacement instanceof _ParentBlot && this.moveChildren(replacement), super.replaceWith(replacement);
    }
    split(index, force = !1) {
        if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
        }
        const after = this.clone();
        return this.parent && this.parent.insertBefore(after, this.next || void 0), this.children.forEachAt(index, this.length(), (child, offset, _length)=>{
            const split = child.split(offset, force);
            split != null && after.appendChild(split);
        }), after;
    }
    splitAfter(child) {
        const after = this.clone();
        for(; child.next != null;)after.appendChild(child.next);
        return this.parent && this.parent.insertBefore(after, this.next || void 0), after;
    }
    unwrap() {
        this.parent && this.moveChildren(this.parent, this.next || void 0), this.remove();
    }
    update(mutations, _context) {
        const addedNodes = [], removedNodes = [];
        mutations.forEach((mutation)=>{
            mutation.target === this.domNode && mutation.type === "childList" && (addedNodes.push(...mutation.addedNodes), removedNodes.push(...mutation.removedNodes));
        }), removedNodes.forEach((node)=>{
            if (node.parentNode != null && // @ts-expect-error Fix me later
            node.tagName !== "IFRAME" && document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) return;
            const blot = this.scroll.find(node);
            blot != null && (blot.domNode.parentNode == null || blot.domNode.parentNode === this.domNode) && blot.detach();
        }), addedNodes.filter((node)=>node.parentNode === this.domNode && node !== this.uiNode).sort((a, b)=>a === b ? 0 : a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? 1 : -1).forEach((node)=>{
            let refBlot = null;
            node.nextSibling != null && (refBlot = this.scroll.find(node.nextSibling));
            const blot = $8324d048851d53b4$var$makeAttachedBlot(node, this.scroll);
            (blot.next !== refBlot || blot.next == null) && (blot.parent != null && blot.parent.removeChild(this), this.insertBefore(blot, refBlot || void 0));
        }), this.enforceAllowedChildren();
    }
    constructor(scroll, domNode){
        super(scroll, domNode), this.uiNode = null, this.build();
    }
};
$8324d048851d53b4$var$_ParentBlot.uiClass = "";
let $8324d048851d53b4$var$ParentBlot = $8324d048851d53b4$var$_ParentBlot;
const $8324d048851d53b4$export$e43113f0aad76fe = $8324d048851d53b4$var$ParentBlot;
function $8324d048851d53b4$var$isEqual(obj1, obj2) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length) return !1;
    for(const prop in obj1)if (obj1[prop] !== obj2[prop]) return !1;
    return !0;
}
const $8324d048851d53b4$var$_InlineBlot = class _InlineBlot extends $8324d048851d53b4$export$e43113f0aad76fe {
    static create(value) {
        return super.create(value);
    }
    static formats(domNode, scroll) {
        const match2 = scroll.query(_InlineBlot.blotName);
        if (!(match2 != null && domNode.tagName === match2.tagName)) {
            if (typeof this.tagName == "string") return !0;
            if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
        }
    }
    format(name, value) {
        if (name === this.statics.blotName && !value) this.children.forEach((child)=>{
            child instanceof _InlineBlot || (child = child.wrap(_InlineBlot.blotName, !0)), this.attributes.copy(child);
        }), this.unwrap();
        else {
            const format = this.scroll.query(name, $8324d048851d53b4$export$775b6bb06e53a214.INLINE);
            if (format == null) return;
            format instanceof $8324d048851d53b4$export$217610c4183502d0 ? this.attributes.attribute(format, value) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value);
        }
    }
    formats() {
        const formats = this.attributes.values(), format = this.statics.formats(this.domNode, this.scroll);
        return format != null && (formats[this.statics.blotName] = format), formats;
    }
    formatAt(index, length, name, value) {
        this.formats()[name] != null || this.scroll.query(name, $8324d048851d53b4$export$775b6bb06e53a214.ATTRIBUTE) ? this.isolate(index, length).format(name, value) : super.formatAt(index, length, name, value);
    }
    optimize(context) {
        super.optimize(context);
        const formats = this.formats();
        if (Object.keys(formats).length === 0) return this.unwrap();
        const next = this.next;
        next instanceof _InlineBlot && next.prev === this && $8324d048851d53b4$var$isEqual(formats, next.formats()) && (next.moveChildren(this), next.remove());
    }
    replaceWith(name, value) {
        const replacement = super.replaceWith(name, value);
        return this.attributes.copy(replacement), replacement;
    }
    update(mutations, context) {
        super.update(mutations, context), mutations.some((mutation)=>mutation.target === this.domNode && mutation.type === "attributes") && this.attributes.build();
    }
    wrap(name, value) {
        const wrapper = super.wrap(name, value);
        return wrapper instanceof _InlineBlot && this.attributes.move(wrapper), wrapper;
    }
    constructor(scroll, domNode){
        super(scroll, domNode), this.attributes = new $8324d048851d53b4$export$68ad86ab95e8de42(this.domNode);
    }
};
$8324d048851d53b4$var$_InlineBlot.allowedChildren = [
    $8324d048851d53b4$var$_InlineBlot,
    $8324d048851d53b4$export$7420b9c542181544
], $8324d048851d53b4$var$_InlineBlot.blotName = "inline", $8324d048851d53b4$var$_InlineBlot.scope = $8324d048851d53b4$export$775b6bb06e53a214.INLINE_BLOT, $8324d048851d53b4$var$_InlineBlot.tagName = "SPAN";
let $8324d048851d53b4$var$InlineBlot = $8324d048851d53b4$var$_InlineBlot;
const $8324d048851d53b4$export$f67a34bc25a7a861 = $8324d048851d53b4$var$InlineBlot, $8324d048851d53b4$var$_BlockBlot = class _BlockBlot extends $8324d048851d53b4$export$e43113f0aad76fe {
    static create(value) {
        return super.create(value);
    }
    static formats(domNode, scroll) {
        const match2 = scroll.query(_BlockBlot.blotName);
        if (!(match2 != null && domNode.tagName === match2.tagName)) {
            if (typeof this.tagName == "string") return !0;
            if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
        }
    }
    format(name, value) {
        const format = this.scroll.query(name, $8324d048851d53b4$export$775b6bb06e53a214.BLOCK);
        format != null && (format instanceof $8324d048851d53b4$export$217610c4183502d0 ? this.attributes.attribute(format, value) : name === this.statics.blotName && !value ? this.replaceWith(_BlockBlot.blotName) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value));
    }
    formats() {
        const formats = this.attributes.values(), format = this.statics.formats(this.domNode, this.scroll);
        return format != null && (formats[this.statics.blotName] = format), formats;
    }
    formatAt(index, length, name, value) {
        this.scroll.query(name, $8324d048851d53b4$export$775b6bb06e53a214.BLOCK) != null ? this.format(name, value) : super.formatAt(index, length, name, value);
    }
    insertAt(index, value, def) {
        if (def == null || this.scroll.query(value, $8324d048851d53b4$export$775b6bb06e53a214.INLINE) != null) super.insertAt(index, value, def);
        else {
            const after = this.split(index);
            if (after != null) {
                const blot = this.scroll.create(value, def);
                after.parent.insertBefore(blot, after);
            } else throw new Error("Attempt to insertAt after block boundaries");
        }
    }
    replaceWith(name, value) {
        const replacement = super.replaceWith(name, value);
        return this.attributes.copy(replacement), replacement;
    }
    update(mutations, context) {
        super.update(mutations, context), mutations.some((mutation)=>mutation.target === this.domNode && mutation.type === "attributes") && this.attributes.build();
    }
    constructor(scroll, domNode){
        super(scroll, domNode), this.attributes = new $8324d048851d53b4$export$68ad86ab95e8de42(this.domNode);
    }
};
$8324d048851d53b4$var$_BlockBlot.blotName = "block", $8324d048851d53b4$var$_BlockBlot.scope = $8324d048851d53b4$export$775b6bb06e53a214.BLOCK_BLOT, $8324d048851d53b4$var$_BlockBlot.tagName = "P", $8324d048851d53b4$var$_BlockBlot.allowedChildren = [
    $8324d048851d53b4$export$f67a34bc25a7a861,
    $8324d048851d53b4$var$_BlockBlot,
    $8324d048851d53b4$export$7420b9c542181544
];
let $8324d048851d53b4$var$BlockBlot = $8324d048851d53b4$var$_BlockBlot;
const $8324d048851d53b4$export$4f7f03641f7bfc8c = $8324d048851d53b4$var$BlockBlot, $8324d048851d53b4$var$_ContainerBlot = class _ContainerBlot extends $8324d048851d53b4$export$e43113f0aad76fe {
    checkMerge() {
        return this.next !== null && this.next.statics.blotName === this.statics.blotName;
    }
    deleteAt(index, length) {
        super.deleteAt(index, length), this.enforceAllowedChildren();
    }
    formatAt(index, length, name, value) {
        super.formatAt(index, length, name, value), this.enforceAllowedChildren();
    }
    insertAt(index, value, def) {
        super.insertAt(index, value, def), this.enforceAllowedChildren();
    }
    optimize(context) {
        super.optimize(context), this.children.length > 0 && this.next != null && this.checkMerge() && (this.next.moveChildren(this), this.next.remove());
    }
};
$8324d048851d53b4$var$_ContainerBlot.blotName = "container", $8324d048851d53b4$var$_ContainerBlot.scope = $8324d048851d53b4$export$775b6bb06e53a214.BLOCK_BLOT;
let $8324d048851d53b4$var$ContainerBlot = $8324d048851d53b4$var$_ContainerBlot;
const $8324d048851d53b4$export$c898d510319704c0 = $8324d048851d53b4$var$ContainerBlot;
class $8324d048851d53b4$var$EmbedBlot extends $8324d048851d53b4$export$7420b9c542181544 {
    static formats(_domNode, _scroll) {}
    format(name, value) {
        super.formatAt(0, this.length(), name, value);
    }
    formatAt(index, length, name, value) {
        index === 0 && length === this.length() ? this.format(name, value) : super.formatAt(index, length, name, value);
    }
    formats() {
        return this.statics.formats(this.domNode, this.scroll);
    }
}
const $8324d048851d53b4$export$297a1fa96f55f00f = $8324d048851d53b4$var$EmbedBlot, $8324d048851d53b4$var$OBSERVER_CONFIG = {
    attributes: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
}, $8324d048851d53b4$var$MAX_OPTIMIZE_ITERATIONS = 100, $8324d048851d53b4$var$_ScrollBlot = class _ScrollBlot extends $8324d048851d53b4$export$e43113f0aad76fe {
    create(input, value) {
        return this.registry.create(this, input, value);
    }
    find(node, bubble = !1) {
        const blot = this.registry.find(node, bubble);
        return blot ? blot.scroll === this ? blot : bubble ? this.find(blot.scroll.domNode.parentNode, !0) : null : null;
    }
    query(query, scope = $8324d048851d53b4$export$775b6bb06e53a214.ANY) {
        return this.registry.query(query, scope);
    }
    register(...definitions) {
        return this.registry.register(...definitions);
    }
    build() {
        this.scroll != null && super.build();
    }
    detach() {
        super.detach(), this.observer.disconnect();
    }
    deleteAt(index, length) {
        this.update(), index === 0 && length === this.length() ? this.children.forEach((child)=>{
            child.remove();
        }) : super.deleteAt(index, length);
    }
    formatAt(index, length, name, value) {
        this.update(), super.formatAt(index, length, name, value);
    }
    insertAt(index, value, def) {
        this.update(), super.insertAt(index, value, def);
    }
    optimize(mutations = [], context = {}) {
        super.optimize(context);
        const mutationsMap = context.mutationsMap || /* @__PURE__ */ new WeakMap();
        let records = Array.from(this.observer.takeRecords());
        for(; records.length > 0;)mutations.push(records.pop());
        const mark = (blot, markParent = !0)=>{
            blot == null || blot === this || blot.domNode.parentNode != null && (mutationsMap.has(blot.domNode) || mutationsMap.set(blot.domNode, []), markParent && mark(blot.parent));
        }, optimize = (blot)=>{
            mutationsMap.has(blot.domNode) && (blot instanceof $8324d048851d53b4$export$e43113f0aad76fe && blot.children.forEach(optimize), mutationsMap.delete(blot.domNode), blot.optimize(context));
        };
        let remaining = mutations;
        for(let i = 0; remaining.length > 0; i += 1){
            if (i >= $8324d048851d53b4$var$MAX_OPTIMIZE_ITERATIONS) throw new Error("[Parchment] Maximum optimize iterations reached");
            for(remaining.forEach((mutation)=>{
                const blot = this.find(mutation.target, !0);
                blot != null && (blot.domNode === mutation.target && (mutation.type === "childList" ? (mark(this.find(mutation.previousSibling, !1)), Array.from(mutation.addedNodes).forEach((node)=>{
                    const child = this.find(node, !1);
                    mark(child, !1), child instanceof $8324d048851d53b4$export$e43113f0aad76fe && child.children.forEach((grandChild)=>{
                        mark(grandChild, !1);
                    });
                })) : mutation.type === "attributes" && mark(blot.prev)), mark(blot));
            }), this.children.forEach(optimize), remaining = Array.from(this.observer.takeRecords()), records = remaining.slice(); records.length > 0;)mutations.push(records.pop());
        }
    }
    update(mutations, context = {}) {
        mutations = mutations || this.observer.takeRecords();
        const mutationsMap = /* @__PURE__ */ new WeakMap();
        mutations.map((mutation)=>{
            const blot = this.find(mutation.target, !0);
            return blot == null ? null : mutationsMap.has(blot.domNode) ? (mutationsMap.get(blot.domNode).push(mutation), null) : (mutationsMap.set(blot.domNode, [
                mutation
            ]), blot);
        }).forEach((blot)=>{
            blot != null && blot !== this && mutationsMap.has(blot.domNode) && blot.update(mutationsMap.get(blot.domNode) || [], context);
        }), context.mutationsMap = mutationsMap, mutationsMap.has(this.domNode) && super.update(mutationsMap.get(this.domNode), context), this.optimize(mutations, context);
    }
    constructor(registry, node){
        super(null, node), this.registry = registry, this.scroll = this, this.build(), this.observer = new MutationObserver((mutations)=>{
            this.update(mutations);
        }), this.observer.observe(this.domNode, $8324d048851d53b4$var$OBSERVER_CONFIG), this.attach();
    }
};
$8324d048851d53b4$var$_ScrollBlot.blotName = "scroll", $8324d048851d53b4$var$_ScrollBlot.defaultChild = $8324d048851d53b4$export$4f7f03641f7bfc8c, $8324d048851d53b4$var$_ScrollBlot.allowedChildren = [
    $8324d048851d53b4$export$4f7f03641f7bfc8c,
    $8324d048851d53b4$export$c898d510319704c0
], $8324d048851d53b4$var$_ScrollBlot.scope = $8324d048851d53b4$export$775b6bb06e53a214.BLOCK_BLOT, $8324d048851d53b4$var$_ScrollBlot.tagName = "DIV";
let $8324d048851d53b4$var$ScrollBlot = $8324d048851d53b4$var$_ScrollBlot;
const $8324d048851d53b4$export$7175329dad7a46f1 = $8324d048851d53b4$var$ScrollBlot, $8324d048851d53b4$var$_TextBlot = class _TextBlot extends $8324d048851d53b4$export$7420b9c542181544 {
    static create(value) {
        return document.createTextNode(value);
    }
    static value(domNode) {
        return domNode.data;
    }
    deleteAt(index, length) {
        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
    }
    index(node, offset) {
        return this.domNode === node ? offset : -1;
    }
    insertAt(index, value, def) {
        def == null ? (this.text = this.text.slice(0, index) + value + this.text.slice(index), this.domNode.data = this.text) : super.insertAt(index, value, def);
    }
    length() {
        return this.text.length;
    }
    optimize(context) {
        super.optimize(context), this.text = this.statics.value(this.domNode), this.text.length === 0 ? this.remove() : this.next instanceof _TextBlot && this.next.prev === this && (this.insertAt(this.length(), this.next.value()), this.next.remove());
    }
    position(index, _inclusive = !1) {
        return [
            this.domNode,
            index
        ];
    }
    split(index, force = !1) {
        if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
        }
        const after = this.scroll.create(this.domNode.splitText(index));
        return this.parent.insertBefore(after, this.next || void 0), this.text = this.statics.value(this.domNode), after;
    }
    update(mutations, _context) {
        mutations.some((mutation)=>mutation.type === "characterData" && mutation.target === this.domNode) && (this.text = this.statics.value(this.domNode));
    }
    value() {
        return this.text;
    }
    constructor(scroll, node){
        super(scroll, node), this.text = this.statics.value(this.domNode);
    }
};
$8324d048851d53b4$var$_TextBlot.blotName = "text", $8324d048851d53b4$var$_TextBlot.scope = $8324d048851d53b4$export$775b6bb06e53a214.INLINE_BLOT;
let $8324d048851d53b4$var$TextBlot = $8324d048851d53b4$var$_TextBlot;
const $8324d048851d53b4$export$10ac0c5716409de6 = $8324d048851d53b4$var$TextBlot;


var $f5af2faee6afab08$exports = {};
"use strict";
Object.defineProperty($f5af2faee6afab08$exports, "__esModule", {
    value: true
});
$f5af2faee6afab08$exports.AttributeMap = $f5af2faee6afab08$exports.OpIterator = $f5af2faee6afab08$exports.Op = void 0;
var $d613a92b30f394c7$exports = {};
/**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */ var $d613a92b30f394c7$var$DIFF_DELETE = -1;
var $d613a92b30f394c7$var$DIFF_INSERT = 1;
var $d613a92b30f394c7$var$DIFF_EQUAL = 0;
/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int|Object} [cursor_pos] Edit position in text1 or object with more info
 * @param {boolean} [cleanup] Apply semantic cleanup before returning.
 * @return {Array} Array of diff tuples.
 */ function $d613a92b30f394c7$var$diff_main(text1, text2, cursor_pos, cleanup, _fix_unicode) {
    // Check for equality
    if (text1 === text2) {
        if (text1) return [
            [
                $d613a92b30f394c7$var$DIFF_EQUAL,
                text1
            ]
        ];
        return [];
    }
    if (cursor_pos != null) {
        var editdiff = $d613a92b30f394c7$var$find_cursor_edit_diff(text1, text2, cursor_pos);
        if (editdiff) return editdiff;
    }
    // Trim off common prefix (speedup).
    var commonlength = $d613a92b30f394c7$var$diff_commonPrefix(text1, text2);
    var commonprefix = text1.substring(0, commonlength);
    text1 = text1.substring(commonlength);
    text2 = text2.substring(commonlength);
    // Trim off common suffix (speedup).
    commonlength = $d613a92b30f394c7$var$diff_commonSuffix(text1, text2);
    var commonsuffix = text1.substring(text1.length - commonlength);
    text1 = text1.substring(0, text1.length - commonlength);
    text2 = text2.substring(0, text2.length - commonlength);
    // Compute the diff on the middle block.
    var diffs = $d613a92b30f394c7$var$diff_compute_(text1, text2);
    // Restore the prefix and suffix.
    if (commonprefix) diffs.unshift([
        $d613a92b30f394c7$var$DIFF_EQUAL,
        commonprefix
    ]);
    if (commonsuffix) diffs.push([
        $d613a92b30f394c7$var$DIFF_EQUAL,
        commonsuffix
    ]);
    $d613a92b30f394c7$var$diff_cleanupMerge(diffs, _fix_unicode);
    if (cleanup) $d613a92b30f394c7$var$diff_cleanupSemantic(diffs);
    return diffs;
}
/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */ function $d613a92b30f394c7$var$diff_compute_(text1, text2) {
    var diffs;
    if (!text1) // Just add some text (speedup).
    return [
        [
            $d613a92b30f394c7$var$DIFF_INSERT,
            text2
        ]
    ];
    if (!text2) // Just delete some text (speedup).
    return [
        [
            $d613a92b30f394c7$var$DIFF_DELETE,
            text1
        ]
    ];
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    var i = longtext.indexOf(shorttext);
    if (i !== -1) {
        // Shorter text is inside the longer text (speedup).
        diffs = [
            [
                $d613a92b30f394c7$var$DIFF_INSERT,
                longtext.substring(0, i)
            ],
            [
                $d613a92b30f394c7$var$DIFF_EQUAL,
                shorttext
            ],
            [
                $d613a92b30f394c7$var$DIFF_INSERT,
                longtext.substring(i + shorttext.length)
            ]
        ];
        // Swap insertions for deletions if diff is reversed.
        if (text1.length > text2.length) diffs[0][0] = diffs[2][0] = $d613a92b30f394c7$var$DIFF_DELETE;
        return diffs;
    }
    if (shorttext.length === 1) // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [
        [
            $d613a92b30f394c7$var$DIFF_DELETE,
            text1
        ],
        [
            $d613a92b30f394c7$var$DIFF_INSERT,
            text2
        ]
    ];
    // Check to see if the problem can be split in two.
    var hm = $d613a92b30f394c7$var$diff_halfMatch_(text1, text2);
    if (hm) {
        // A half-match was found, sort out the return data.
        var text1_a = hm[0];
        var text1_b = hm[1];
        var text2_a = hm[2];
        var text2_b = hm[3];
        var mid_common = hm[4];
        // Send both pairs off for separate processing.
        var diffs_a = $d613a92b30f394c7$var$diff_main(text1_a, text2_a);
        var diffs_b = $d613a92b30f394c7$var$diff_main(text1_b, text2_b);
        // Merge the results.
        return diffs_a.concat([
            [
                $d613a92b30f394c7$var$DIFF_EQUAL,
                mid_common
            ]
        ], diffs_b);
    }
    return $d613a92b30f394c7$var$diff_bisect_(text1, text2);
}
/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */ function $d613a92b30f394c7$var$diff_bisect_(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    var max_d = Math.ceil((text1_length + text2_length) / 2);
    var v_offset = max_d;
    var v_length = 2 * max_d;
    var v1 = new Array(v_length);
    var v2 = new Array(v_length);
    // Setting all elements to -1 is faster in Chrome & Firefox than mixing
    // integers and undefined.
    for(var x = 0; x < v_length; x++){
        v1[x] = -1;
        v2[x] = -1;
    }
    v1[v_offset + 1] = 0;
    v2[v_offset + 1] = 0;
    var delta = text1_length - text2_length;
    // If the total number of characters is odd, then the front path will collide
    // with the reverse path.
    var front = delta % 2 !== 0;
    // Offsets for start and end of k loop.
    // Prevents mapping of space beyond the grid.
    var k1start = 0;
    var k1end = 0;
    var k2start = 0;
    var k2end = 0;
    for(var d = 0; d < max_d; d++){
        // Walk the front path one step.
        for(var k1 = -d + k1start; k1 <= d - k1end; k1 += 2){
            var k1_offset = v_offset + k1;
            var x1;
            if (k1 === -d || k1 !== d && v1[k1_offset - 1] < v1[k1_offset + 1]) x1 = v1[k1_offset + 1];
            else x1 = v1[k1_offset - 1] + 1;
            var y1 = x1 - k1;
            while(x1 < text1_length && y1 < text2_length && text1.charAt(x1) === text2.charAt(y1)){
                x1++;
                y1++;
            }
            v1[k1_offset] = x1;
            if (x1 > text1_length) // Ran off the right of the graph.
            k1end += 2;
            else if (y1 > text2_length) // Ran off the bottom of the graph.
            k1start += 2;
            else if (front) {
                var k2_offset = v_offset + delta - k1;
                if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] !== -1) {
                    // Mirror x2 onto top-left coordinate system.
                    var x2 = text1_length - v2[k2_offset];
                    if (x1 >= x2) // Overlap detected.
                    return $d613a92b30f394c7$var$diff_bisectSplit_(text1, text2, x1, y1);
                }
            }
        }
        // Walk the reverse path one step.
        for(var k2 = -d + k2start; k2 <= d - k2end; k2 += 2){
            var k2_offset = v_offset + k2;
            var x2;
            if (k2 === -d || k2 !== d && v2[k2_offset - 1] < v2[k2_offset + 1]) x2 = v2[k2_offset + 1];
            else x2 = v2[k2_offset - 1] + 1;
            var y2 = x2 - k2;
            while(x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) === text2.charAt(text2_length - y2 - 1)){
                x2++;
                y2++;
            }
            v2[k2_offset] = x2;
            if (x2 > text1_length) // Ran off the left of the graph.
            k2end += 2;
            else if (y2 > text2_length) // Ran off the top of the graph.
            k2start += 2;
            else if (!front) {
                var k1_offset = v_offset + delta - k2;
                if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] !== -1) {
                    var x1 = v1[k1_offset];
                    var y1 = v_offset + x1 - k1_offset;
                    // Mirror x2 onto top-left coordinate system.
                    x2 = text1_length - x2;
                    if (x1 >= x2) // Overlap detected.
                    return $d613a92b30f394c7$var$diff_bisectSplit_(text1, text2, x1, y1);
                }
            }
        }
    }
    // Diff took too long and hit the deadline or
    // number of diffs equals number of characters, no commonality at all.
    return [
        [
            $d613a92b30f394c7$var$DIFF_DELETE,
            text1
        ],
        [
            $d613a92b30f394c7$var$DIFF_INSERT,
            text2
        ]
    ];
}
/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */ function $d613a92b30f394c7$var$diff_bisectSplit_(text1, text2, x, y) {
    var text1a = text1.substring(0, x);
    var text2a = text2.substring(0, y);
    var text1b = text1.substring(x);
    var text2b = text2.substring(y);
    // Compute both diffs serially.
    var diffs = $d613a92b30f394c7$var$diff_main(text1a, text2a);
    var diffsb = $d613a92b30f394c7$var$diff_main(text1b, text2b);
    return diffs.concat(diffsb);
}
/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */ function $d613a92b30f394c7$var$diff_commonPrefix(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.charAt(0) !== text2.charAt(0)) return 0;
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerstart = 0;
    while(pointermin < pointermid){
        if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
            pointermin = pointermid;
            pointerstart = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    if ($d613a92b30f394c7$var$is_surrogate_pair_start(text1.charCodeAt(pointermid - 1))) pointermid--;
    return pointermid;
}
/**
 * Determine if the suffix of one string is the prefix of another.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of the first
 *     string and the start of the second string.
 * @private
 */ function $d613a92b30f394c7$var$diff_commonOverlap_(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    // Eliminate the null case.
    if (text1_length == 0 || text2_length == 0) return 0;
    // Truncate the longer string.
    if (text1_length > text2_length) text1 = text1.substring(text1_length - text2_length);
    else if (text1_length < text2_length) text2 = text2.substring(0, text1_length);
    var text_length = Math.min(text1_length, text2_length);
    // Quick check for the worst case.
    if (text1 == text2) return text_length;
    // Start by looking for a single character match
    // and increase length until no match is found.
    // Performance analysis: http://neil.fraser.name/news/2010/11/04/
    var best = 0;
    var length = 1;
    while(true){
        var pattern = text1.substring(text_length - length);
        var found = text2.indexOf(pattern);
        if (found == -1) return best;
        length += found;
        if (found == 0 || text1.substring(text_length - length) == text2.substring(0, length)) {
            best = length;
            length++;
        }
    }
}
/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */ function $d613a92b30f394c7$var$diff_commonSuffix(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.slice(-1) !== text2.slice(-1)) return 0;
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerend = 0;
    while(pointermin < pointermid){
        if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
            pointermin = pointermid;
            pointerend = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    if ($d613a92b30f394c7$var$is_surrogate_pair_end(text1.charCodeAt(text1.length - pointermid))) pointermid--;
    return pointermid;
}
/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */ function $d613a92b30f394c7$var$diff_halfMatch_(text1, text2) {
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    if (longtext.length < 4 || shorttext.length * 2 < longtext.length) return null; // Pointless.
    /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */ function diff_halfMatchI_(longtext, shorttext, i) {
        // Start with a 1/4 length substring at position i as a seed.
        var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
        var j = -1;
        var best_common = "";
        var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
        while((j = shorttext.indexOf(seed, j + 1)) !== -1){
            var prefixLength = $d613a92b30f394c7$var$diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
            var suffixLength = $d613a92b30f394c7$var$diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
            if (best_common.length < suffixLength + prefixLength) {
                best_common = shorttext.substring(j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
                best_longtext_a = longtext.substring(0, i - suffixLength);
                best_longtext_b = longtext.substring(i + prefixLength);
                best_shorttext_a = shorttext.substring(0, j - suffixLength);
                best_shorttext_b = shorttext.substring(j + prefixLength);
            }
        }
        if (best_common.length * 2 >= longtext.length) return [
            best_longtext_a,
            best_longtext_b,
            best_shorttext_a,
            best_shorttext_b,
            best_common
        ];
        else return null;
    }
    // First check if the second quarter is the seed for a half-match.
    var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
    // Check again based on the third quarter.
    var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
    var hm;
    if (!hm1 && !hm2) return null;
    else if (!hm2) hm = hm1;
    else if (!hm1) hm = hm2;
    else // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
    // A half-match was found, sort out the return data.
    var text1_a, text1_b, text2_a, text2_b;
    if (text1.length > text2.length) {
        text1_a = hm[0];
        text1_b = hm[1];
        text2_a = hm[2];
        text2_b = hm[3];
    } else {
        text2_a = hm[0];
        text2_b = hm[1];
        text1_a = hm[2];
        text1_b = hm[3];
    }
    var mid_common = hm[4];
    return [
        text1_a,
        text1_b,
        text2_a,
        text2_b,
        mid_common
    ];
}
/**
 * Reduce the number of edits by eliminating semantically trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ function $d613a92b30f394c7$var$diff_cleanupSemantic(diffs) {
    var changes = false;
    var equalities = []; // Stack of indices where equalities are found.
    var equalitiesLength = 0; // Keeping our own length var is faster in JS.
    /** @type {?string} */ var lastequality = null;
    // Always equal to diffs[equalities[equalitiesLength - 1]][1]
    var pointer = 0; // Index of current position.
    // Number of characters that changed prior to the equality.
    var length_insertions1 = 0;
    var length_deletions1 = 0;
    // Number of characters that changed after the equality.
    var length_insertions2 = 0;
    var length_deletions2 = 0;
    while(pointer < diffs.length){
        if (diffs[pointer][0] == $d613a92b30f394c7$var$DIFF_EQUAL) {
            // Equality found.
            equalities[equalitiesLength++] = pointer;
            length_insertions1 = length_insertions2;
            length_deletions1 = length_deletions2;
            length_insertions2 = 0;
            length_deletions2 = 0;
            lastequality = diffs[pointer][1];
        } else {
            // An insertion or deletion.
            if (diffs[pointer][0] == $d613a92b30f394c7$var$DIFF_INSERT) length_insertions2 += diffs[pointer][1].length;
            else length_deletions2 += diffs[pointer][1].length;
            // Eliminate an equality that is smaller or equal to the edits on both
            // sides of it.
            if (lastequality && lastequality.length <= Math.max(length_insertions1, length_deletions1) && lastequality.length <= Math.max(length_insertions2, length_deletions2)) {
                // Duplicate record.
                diffs.splice(equalities[equalitiesLength - 1], 0, [
                    $d613a92b30f394c7$var$DIFF_DELETE,
                    lastequality
                ]);
                // Change second copy to insert.
                diffs[equalities[equalitiesLength - 1] + 1][0] = $d613a92b30f394c7$var$DIFF_INSERT;
                // Throw away the equality we just deleted.
                equalitiesLength--;
                // Throw away the previous equality (it needs to be reevaluated).
                equalitiesLength--;
                pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
                length_insertions1 = 0; // Reset the counters.
                length_deletions1 = 0;
                length_insertions2 = 0;
                length_deletions2 = 0;
                lastequality = null;
                changes = true;
            }
        }
        pointer++;
    }
    // Normalize the diff.
    if (changes) $d613a92b30f394c7$var$diff_cleanupMerge(diffs);
    $d613a92b30f394c7$var$diff_cleanupSemanticLossless(diffs);
    // Find any overlaps between deletions and insertions.
    // e.g: <del>abcxxx</del><ins>xxxdef</ins>
    //   -> <del>abc</del>xxx<ins>def</ins>
    // e.g: <del>xxxabc</del><ins>defxxx</ins>
    //   -> <ins>def</ins>xxx<del>abc</del>
    // Only extract an overlap if it is as big as the edit ahead or behind it.
    pointer = 1;
    while(pointer < diffs.length){
        if (diffs[pointer - 1][0] == $d613a92b30f394c7$var$DIFF_DELETE && diffs[pointer][0] == $d613a92b30f394c7$var$DIFF_INSERT) {
            var deletion = diffs[pointer - 1][1];
            var insertion = diffs[pointer][1];
            var overlap_length1 = $d613a92b30f394c7$var$diff_commonOverlap_(deletion, insertion);
            var overlap_length2 = $d613a92b30f394c7$var$diff_commonOverlap_(insertion, deletion);
            if (overlap_length1 >= overlap_length2) {
                if (overlap_length1 >= deletion.length / 2 || overlap_length1 >= insertion.length / 2) {
                    // Overlap found.  Insert an equality and trim the surrounding edits.
                    diffs.splice(pointer, 0, [
                        $d613a92b30f394c7$var$DIFF_EQUAL,
                        insertion.substring(0, overlap_length1)
                    ]);
                    diffs[pointer - 1][1] = deletion.substring(0, deletion.length - overlap_length1);
                    diffs[pointer + 1][1] = insertion.substring(overlap_length1);
                    pointer++;
                }
            } else if (overlap_length2 >= deletion.length / 2 || overlap_length2 >= insertion.length / 2) {
                // Reverse overlap found.
                // Insert an equality and swap and trim the surrounding edits.
                diffs.splice(pointer, 0, [
                    $d613a92b30f394c7$var$DIFF_EQUAL,
                    deletion.substring(0, overlap_length2)
                ]);
                diffs[pointer - 1][0] = $d613a92b30f394c7$var$DIFF_INSERT;
                diffs[pointer - 1][1] = insertion.substring(0, insertion.length - overlap_length2);
                diffs[pointer + 1][0] = $d613a92b30f394c7$var$DIFF_DELETE;
                diffs[pointer + 1][1] = deletion.substring(overlap_length2);
                pointer++;
            }
            pointer++;
        }
        pointer++;
    }
}
var $d613a92b30f394c7$var$nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
var $d613a92b30f394c7$var$whitespaceRegex_ = /\s/;
var $d613a92b30f394c7$var$linebreakRegex_ = /[\r\n]/;
var $d613a92b30f394c7$var$blanklineEndRegex_ = /\n\r?\n$/;
var $d613a92b30f394c7$var$blanklineStartRegex_ = /^\r?\n\r?\n/;
/**
 * Look for single edits surrounded on both sides by equalities
 * which can be shifted sideways to align the edit to a word boundary.
 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ function $d613a92b30f394c7$var$diff_cleanupSemanticLossless(diffs) {
    /**
   * Given two strings, compute a score representing whether the internal
   * boundary falls on logical boundaries.
   * Scores range from 6 (best) to 0 (worst).
   * Closure, but does not reference any external variables.
   * @param {string} one First string.
   * @param {string} two Second string.
   * @return {number} The score.
   * @private
   */ function diff_cleanupSemanticScore_(one, two) {
        if (!one || !two) // Edges are the best.
        return 6;
        // Each port of this function behaves slightly differently due to
        // subtle differences in each language's definition of things like
        // 'whitespace'.  Since this function's purpose is largely cosmetic,
        // the choice has been made to use each language's native features
        // rather than force total conformity.
        var char1 = one.charAt(one.length - 1);
        var char2 = two.charAt(0);
        var nonAlphaNumeric1 = char1.match($d613a92b30f394c7$var$nonAlphaNumericRegex_);
        var nonAlphaNumeric2 = char2.match($d613a92b30f394c7$var$nonAlphaNumericRegex_);
        var whitespace1 = nonAlphaNumeric1 && char1.match($d613a92b30f394c7$var$whitespaceRegex_);
        var whitespace2 = nonAlphaNumeric2 && char2.match($d613a92b30f394c7$var$whitespaceRegex_);
        var lineBreak1 = whitespace1 && char1.match($d613a92b30f394c7$var$linebreakRegex_);
        var lineBreak2 = whitespace2 && char2.match($d613a92b30f394c7$var$linebreakRegex_);
        var blankLine1 = lineBreak1 && one.match($d613a92b30f394c7$var$blanklineEndRegex_);
        var blankLine2 = lineBreak2 && two.match($d613a92b30f394c7$var$blanklineStartRegex_);
        if (blankLine1 || blankLine2) // Five points for blank lines.
        return 5;
        else if (lineBreak1 || lineBreak2) // Four points for line breaks.
        return 4;
        else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) // Three points for end of sentences.
        return 3;
        else if (whitespace1 || whitespace2) // Two points for whitespace.
        return 2;
        else if (nonAlphaNumeric1 || nonAlphaNumeric2) // One point for non-alphanumeric.
        return 1;
        return 0;
    }
    var pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] == $d613a92b30f394c7$var$DIFF_EQUAL && diffs[pointer + 1][0] == $d613a92b30f394c7$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            var equality1 = diffs[pointer - 1][1];
            var edit = diffs[pointer][1];
            var equality2 = diffs[pointer + 1][1];
            // First, shift the edit as far left as possible.
            var commonOffset = $d613a92b30f394c7$var$diff_commonSuffix(equality1, edit);
            if (commonOffset) {
                var commonString = edit.substring(edit.length - commonOffset);
                equality1 = equality1.substring(0, equality1.length - commonOffset);
                edit = commonString + edit.substring(0, edit.length - commonOffset);
                equality2 = commonString + equality2;
            }
            // Second, step character by character right, looking for the best fit.
            var bestEquality1 = equality1;
            var bestEdit = edit;
            var bestEquality2 = equality2;
            var bestScore = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
            while(edit.charAt(0) === equality2.charAt(0)){
                equality1 += edit.charAt(0);
                edit = edit.substring(1) + equality2.charAt(0);
                equality2 = equality2.substring(1);
                var score = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
                // The >= encourages trailing rather than leading whitespace on edits.
                if (score >= bestScore) {
                    bestScore = score;
                    bestEquality1 = equality1;
                    bestEdit = edit;
                    bestEquality2 = equality2;
                }
            }
            if (diffs[pointer - 1][1] != bestEquality1) {
                // We have an improvement, save it back to the diff.
                if (bestEquality1) diffs[pointer - 1][1] = bestEquality1;
                else {
                    diffs.splice(pointer - 1, 1);
                    pointer--;
                }
                diffs[pointer][1] = bestEdit;
                if (bestEquality2) diffs[pointer + 1][1] = bestEquality2;
                else {
                    diffs.splice(pointer + 1, 1);
                    pointer--;
                }
            }
        }
        pointer++;
    }
}
/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 * @param {boolean} fix_unicode Whether to normalize to a unicode-correct diff
 */ function $d613a92b30f394c7$var$diff_cleanupMerge(diffs, fix_unicode) {
    diffs.push([
        $d613a92b30f394c7$var$DIFF_EQUAL,
        ""
    ]); // Add a dummy entry at the end.
    var pointer = 0;
    var count_delete = 0;
    var count_insert = 0;
    var text_delete = "";
    var text_insert = "";
    var commonlength;
    while(pointer < diffs.length){
        if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
            diffs.splice(pointer, 1);
            continue;
        }
        switch(diffs[pointer][0]){
            case $d613a92b30f394c7$var$DIFF_INSERT:
                count_insert++;
                text_insert += diffs[pointer][1];
                pointer++;
                break;
            case $d613a92b30f394c7$var$DIFF_DELETE:
                count_delete++;
                text_delete += diffs[pointer][1];
                pointer++;
                break;
            case $d613a92b30f394c7$var$DIFF_EQUAL:
                var previous_equality = pointer - count_insert - count_delete - 1;
                if (fix_unicode) {
                    // prevent splitting of unicode surrogate pairs.  when fix_unicode is true,
                    // we assume that the old and new text in the diff are complete and correct
                    // unicode-encoded JS strings, but the tuple boundaries may fall between
                    // surrogate pairs.  we fix this by shaving off stray surrogates from the end
                    // of the previous equality and the beginning of this equality.  this may create
                    // empty equalities or a common prefix or suffix.  for example, if AB and AC are
                    // emojis, `[[0, 'A'], [-1, 'BA'], [0, 'C']]` would turn into deleting 'ABAC' and
                    // inserting 'AC', and then the common suffix 'AC' will be eliminated.  in this
                    // particular case, both equalities go away, we absorb any previous inequalities,
                    // and we keep scanning for the next equality before rewriting the tuples.
                    if (previous_equality >= 0 && $d613a92b30f394c7$var$ends_with_pair_start(diffs[previous_equality][1])) {
                        var stray = diffs[previous_equality][1].slice(-1);
                        diffs[previous_equality][1] = diffs[previous_equality][1].slice(0, -1);
                        text_delete = stray + text_delete;
                        text_insert = stray + text_insert;
                        if (!diffs[previous_equality][1]) {
                            // emptied out previous equality, so delete it and include previous delete/insert
                            diffs.splice(previous_equality, 1);
                            pointer--;
                            var k = previous_equality - 1;
                            if (diffs[k] && diffs[k][0] === $d613a92b30f394c7$var$DIFF_INSERT) {
                                count_insert++;
                                text_insert = diffs[k][1] + text_insert;
                                k--;
                            }
                            if (diffs[k] && diffs[k][0] === $d613a92b30f394c7$var$DIFF_DELETE) {
                                count_delete++;
                                text_delete = diffs[k][1] + text_delete;
                                k--;
                            }
                            previous_equality = k;
                        }
                    }
                    if ($d613a92b30f394c7$var$starts_with_pair_end(diffs[pointer][1])) {
                        var stray = diffs[pointer][1].charAt(0);
                        diffs[pointer][1] = diffs[pointer][1].slice(1);
                        text_delete += stray;
                        text_insert += stray;
                    }
                }
                if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
                    // for empty equality not at end, wait for next equality
                    diffs.splice(pointer, 1);
                    break;
                }
                if (text_delete.length > 0 || text_insert.length > 0) {
                    // note that diff_commonPrefix and diff_commonSuffix are unicode-aware
                    if (text_delete.length > 0 && text_insert.length > 0) {
                        // Factor out any common prefixes.
                        commonlength = $d613a92b30f394c7$var$diff_commonPrefix(text_insert, text_delete);
                        if (commonlength !== 0) {
                            if (previous_equality >= 0) diffs[previous_equality][1] += text_insert.substring(0, commonlength);
                            else {
                                diffs.splice(0, 0, [
                                    $d613a92b30f394c7$var$DIFF_EQUAL,
                                    text_insert.substring(0, commonlength)
                                ]);
                                pointer++;
                            }
                            text_insert = text_insert.substring(commonlength);
                            text_delete = text_delete.substring(commonlength);
                        }
                        // Factor out any common suffixes.
                        commonlength = $d613a92b30f394c7$var$diff_commonSuffix(text_insert, text_delete);
                        if (commonlength !== 0) {
                            diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                            text_insert = text_insert.substring(0, text_insert.length - commonlength);
                            text_delete = text_delete.substring(0, text_delete.length - commonlength);
                        }
                    }
                    // Delete the offending records and add the merged ones.
                    var n = count_insert + count_delete;
                    if (text_delete.length === 0 && text_insert.length === 0) {
                        diffs.splice(pointer - n, n);
                        pointer = pointer - n;
                    } else if (text_delete.length === 0) {
                        diffs.splice(pointer - n, n, [
                            $d613a92b30f394c7$var$DIFF_INSERT,
                            text_insert
                        ]);
                        pointer = pointer - n + 1;
                    } else if (text_insert.length === 0) {
                        diffs.splice(pointer - n, n, [
                            $d613a92b30f394c7$var$DIFF_DELETE,
                            text_delete
                        ]);
                        pointer = pointer - n + 1;
                    } else {
                        diffs.splice(pointer - n, n, [
                            $d613a92b30f394c7$var$DIFF_DELETE,
                            text_delete
                        ], [
                            $d613a92b30f394c7$var$DIFF_INSERT,
                            text_insert
                        ]);
                        pointer = pointer - n + 2;
                    }
                }
                if (pointer !== 0 && diffs[pointer - 1][0] === $d613a92b30f394c7$var$DIFF_EQUAL) {
                    // Merge this equality with the previous one.
                    diffs[pointer - 1][1] += diffs[pointer][1];
                    diffs.splice(pointer, 1);
                } else pointer++;
                count_insert = 0;
                count_delete = 0;
                text_delete = "";
                text_insert = "";
                break;
        }
    }
    if (diffs[diffs.length - 1][1] === "") diffs.pop(); // Remove the dummy entry at the end.
    // Second pass: look for single edits surrounded on both sides by equalities
    // which can be shifted sideways to eliminate an equality.
    // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
    var changes = false;
    pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] === $d613a92b30f394c7$var$DIFF_EQUAL && diffs[pointer + 1][0] === $d613a92b30f394c7$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) === diffs[pointer - 1][1]) {
                // Shift the edit over the previous equality.
                diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
                diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
                diffs.splice(pointer - 1, 1);
                changes = true;
            } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
                // Shift the edit over the next equality.
                diffs[pointer - 1][1] += diffs[pointer + 1][1];
                diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
                diffs.splice(pointer + 1, 1);
                changes = true;
            }
        }
        pointer++;
    }
    // If shifts were made, the diff needs reordering and another shift sweep.
    if (changes) $d613a92b30f394c7$var$diff_cleanupMerge(diffs, fix_unicode);
}
function $d613a92b30f394c7$var$is_surrogate_pair_start(charCode) {
    return charCode >= 0xd800 && charCode <= 0xdbff;
}
function $d613a92b30f394c7$var$is_surrogate_pair_end(charCode) {
    return charCode >= 0xdc00 && charCode <= 0xdfff;
}
function $d613a92b30f394c7$var$starts_with_pair_end(str) {
    return $d613a92b30f394c7$var$is_surrogate_pair_end(str.charCodeAt(0));
}
function $d613a92b30f394c7$var$ends_with_pair_start(str) {
    return $d613a92b30f394c7$var$is_surrogate_pair_start(str.charCodeAt(str.length - 1));
}
function $d613a92b30f394c7$var$remove_empty_tuples(tuples) {
    var ret = [];
    for(var i = 0; i < tuples.length; i++)if (tuples[i][1].length > 0) ret.push(tuples[i]);
    return ret;
}
function $d613a92b30f394c7$var$make_edit_splice(before, oldMiddle, newMiddle, after) {
    if ($d613a92b30f394c7$var$ends_with_pair_start(before) || $d613a92b30f394c7$var$starts_with_pair_end(after)) return null;
    return $d613a92b30f394c7$var$remove_empty_tuples([
        [
            $d613a92b30f394c7$var$DIFF_EQUAL,
            before
        ],
        [
            $d613a92b30f394c7$var$DIFF_DELETE,
            oldMiddle
        ],
        [
            $d613a92b30f394c7$var$DIFF_INSERT,
            newMiddle
        ],
        [
            $d613a92b30f394c7$var$DIFF_EQUAL,
            after
        ]
    ]);
}
function $d613a92b30f394c7$var$find_cursor_edit_diff(oldText, newText, cursor_pos) {
    // note: this runs after equality check has ruled out exact equality
    var oldRange = typeof cursor_pos === "number" ? {
        index: cursor_pos,
        length: 0
    } : cursor_pos.oldRange;
    var newRange = typeof cursor_pos === "number" ? null : cursor_pos.newRange;
    // take into account the old and new selection to generate the best diff
    // possible for a text edit.  for example, a text change from "xxx" to "xx"
    // could be a delete or forwards-delete of any one of the x's, or the
    // result of selecting two of the x's and typing "x".
    var oldLength = oldText.length;
    var newLength = newText.length;
    if (oldRange.length === 0 && (newRange === null || newRange.length === 0)) {
        // see if we have an insert or delete before or after cursor
        var oldCursor = oldRange.index;
        var oldBefore = oldText.slice(0, oldCursor);
        var oldAfter = oldText.slice(oldCursor);
        var maybeNewCursor = newRange ? newRange.index : null;
        editBefore: {
            // is this an insert or delete right before oldCursor?
            var newCursor = oldCursor + newLength - oldLength;
            if (maybeNewCursor !== null && maybeNewCursor !== newCursor) break editBefore;
            if (newCursor < 0 || newCursor > newLength) break editBefore;
            var newBefore = newText.slice(0, newCursor);
            var newAfter = newText.slice(newCursor);
            if (newAfter !== oldAfter) break editBefore;
            var prefixLength = Math.min(oldCursor, newCursor);
            var oldPrefix = oldBefore.slice(0, prefixLength);
            var newPrefix = newBefore.slice(0, prefixLength);
            if (oldPrefix !== newPrefix) break editBefore;
            var oldMiddle = oldBefore.slice(prefixLength);
            var newMiddle = newBefore.slice(prefixLength);
            return $d613a92b30f394c7$var$make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldAfter);
        }
        editAfter: {
            // is this an insert or delete right after oldCursor?
            if (maybeNewCursor !== null && maybeNewCursor !== oldCursor) break editAfter;
            var cursor = oldCursor;
            var newBefore = newText.slice(0, cursor);
            var newAfter = newText.slice(cursor);
            if (newBefore !== oldBefore) break editAfter;
            var suffixLength = Math.min(oldLength - cursor, newLength - cursor);
            var oldSuffix = oldAfter.slice(oldAfter.length - suffixLength);
            var newSuffix = newAfter.slice(newAfter.length - suffixLength);
            if (oldSuffix !== newSuffix) break editAfter;
            var oldMiddle = oldAfter.slice(0, oldAfter.length - suffixLength);
            var newMiddle = newAfter.slice(0, newAfter.length - suffixLength);
            return $d613a92b30f394c7$var$make_edit_splice(oldBefore, oldMiddle, newMiddle, oldSuffix);
        }
    }
    if (oldRange.length > 0 && newRange && newRange.length === 0) replaceRange: {
        // see if diff could be a splice of the old selection range
        var oldPrefix = oldText.slice(0, oldRange.index);
        var oldSuffix = oldText.slice(oldRange.index + oldRange.length);
        var prefixLength = oldPrefix.length;
        var suffixLength = oldSuffix.length;
        if (newLength < prefixLength + suffixLength) break replaceRange;
        var newPrefix = newText.slice(0, prefixLength);
        var newSuffix = newText.slice(newLength - suffixLength);
        if (oldPrefix !== newPrefix || oldSuffix !== newSuffix) break replaceRange;
        var oldMiddle = oldText.slice(prefixLength, oldLength - suffixLength);
        var newMiddle = newText.slice(prefixLength, newLength - suffixLength);
        return $d613a92b30f394c7$var$make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldSuffix);
    }
    return null;
}
function $d613a92b30f394c7$var$diff(text1, text2, cursor_pos, cleanup) {
    // only pass fix_unicode=true at the top level, not when diff_main is
    // recursively invoked
    return $d613a92b30f394c7$var$diff_main(text1, text2, cursor_pos, cleanup, true);
}
$d613a92b30f394c7$var$diff.INSERT = $d613a92b30f394c7$var$DIFF_INSERT;
$d613a92b30f394c7$var$diff.DELETE = $d613a92b30f394c7$var$DIFF_DELETE;
$d613a92b30f394c7$var$diff.EQUAL = $d613a92b30f394c7$var$DIFF_EQUAL;
$d613a92b30f394c7$exports = $d613a92b30f394c7$var$diff;



var $6d3lL = parcelRequire("6d3lL");

var $lj5HN = parcelRequire("lj5HN");
var $e33f3d0be8911994$exports = {};
"use strict";
Object.defineProperty($e33f3d0be8911994$exports, "__esModule", {
    value: true
});

var $6d3lL = parcelRequire("6d3lL");

var $lj5HN = parcelRequire("lj5HN");
var $e33f3d0be8911994$var$AttributeMap;
(function(AttributeMap) {
    function compose(a = {}, b = {}, keepNull = false) {
        if (typeof a !== "object") a = {};
        if (typeof b !== "object") b = {};
        let attributes = $6d3lL(b);
        if (!keepNull) attributes = Object.keys(attributes).reduce((copy, key)=>{
            if (attributes[key] != null) copy[key] = attributes[key];
            return copy;
        }, {});
        for(const key in a)if (a[key] !== undefined && b[key] === undefined) attributes[key] = a[key];
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.compose = compose;
    function diff(a = {}, b = {}) {
        if (typeof a !== "object") a = {};
        if (typeof b !== "object") b = {};
        const attributes = Object.keys(a).concat(Object.keys(b)).reduce((attrs, key)=>{
            if (!$lj5HN(a[key], b[key])) attrs[key] = b[key] === undefined ? null : b[key];
            return attrs;
        }, {});
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.diff = diff;
    function invert(attr = {}, base = {}) {
        attr = attr || {};
        const baseInverted = Object.keys(base).reduce((memo, key)=>{
            if (base[key] !== attr[key] && attr[key] !== undefined) memo[key] = base[key];
            return memo;
        }, {});
        return Object.keys(attr).reduce((memo, key)=>{
            if (attr[key] !== base[key] && base[key] === undefined) memo[key] = null;
            return memo;
        }, baseInverted);
    }
    AttributeMap.invert = invert;
    function transform(a, b, priority = false) {
        if (typeof a !== "object") return b;
        if (typeof b !== "object") return undefined;
        if (!priority) return b; // b simply overwrites us without priority
        const attributes = Object.keys(b).reduce((attrs, key)=>{
            if (a[key] === undefined) attrs[key] = b[key]; // null is a valid value
            return attrs;
        }, {});
        return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
    AttributeMap.transform = transform;
})($e33f3d0be8911994$var$AttributeMap || ($e33f3d0be8911994$var$AttributeMap = {}));
$e33f3d0be8911994$exports.default = $e33f3d0be8911994$var$AttributeMap;


$f5af2faee6afab08$exports.AttributeMap = $e33f3d0be8911994$exports.default;
var $e5aa29c01f64f7da$exports = {};
"use strict";
Object.defineProperty($e5aa29c01f64f7da$exports, "__esModule", {
    value: true
});
var $e5aa29c01f64f7da$var$Op;
(function(Op) {
    function length(op) {
        if (typeof op.delete === "number") return op.delete;
        else if (typeof op.retain === "number") return op.retain;
        else if (typeof op.retain === "object" && op.retain !== null) return 1;
        else return typeof op.insert === "string" ? op.insert.length : 1;
    }
    Op.length = length;
})($e5aa29c01f64f7da$var$Op || ($e5aa29c01f64f7da$var$Op = {}));
$e5aa29c01f64f7da$exports.default = $e5aa29c01f64f7da$var$Op;


$f5af2faee6afab08$exports.Op = $e5aa29c01f64f7da$exports.default;
var $b797e6a5d13387bc$exports = {};
"use strict";
Object.defineProperty($b797e6a5d13387bc$exports, "__esModule", {
    value: true
});

class $b797e6a5d13387bc$var$Iterator {
    hasNext() {
        return this.peekLength() < Infinity;
    }
    next(length) {
        if (!length) length = Infinity;
        const nextOp = this.ops[this.index];
        if (nextOp) {
            const offset = this.offset;
            const opLength = $e5aa29c01f64f7da$exports.default.length(nextOp);
            if (length >= opLength - offset) {
                length = opLength - offset;
                this.index += 1;
                this.offset = 0;
            } else this.offset += length;
            if (typeof nextOp.delete === "number") return {
                delete: length
            };
            else {
                const retOp = {};
                if (nextOp.attributes) retOp.attributes = nextOp.attributes;
                if (typeof nextOp.retain === "number") retOp.retain = length;
                else if (typeof nextOp.retain === "object" && nextOp.retain !== null) // offset should === 0, length should === 1
                retOp.retain = nextOp.retain;
                else if (typeof nextOp.insert === "string") retOp.insert = nextOp.insert.substr(offset, length);
                else // offset should === 0, length should === 1
                retOp.insert = nextOp.insert;
                return retOp;
            }
        } else return {
            retain: Infinity
        };
    }
    peek() {
        return this.ops[this.index];
    }
    peekLength() {
        if (this.ops[this.index]) // Should never return 0 if our index is being managed correctly
        return $e5aa29c01f64f7da$exports.default.length(this.ops[this.index]) - this.offset;
        else return Infinity;
    }
    peekType() {
        const op = this.ops[this.index];
        if (op) {
            if (typeof op.delete === "number") return "delete";
            else if (typeof op.retain === "number" || typeof op.retain === "object" && op.retain !== null) return "retain";
            else return "insert";
        }
        return "retain";
    }
    rest() {
        if (!this.hasNext()) return [];
        else if (this.offset === 0) return this.ops.slice(this.index);
        else {
            const offset = this.offset;
            const index = this.index;
            const next = this.next();
            const rest = this.ops.slice(this.index);
            this.offset = offset;
            this.index = index;
            return [
                next
            ].concat(rest);
        }
    }
    constructor(ops){
        this.ops = ops;
        this.index = 0;
        this.offset = 0;
    }
}
$b797e6a5d13387bc$exports.default = $b797e6a5d13387bc$var$Iterator;


$f5af2faee6afab08$exports.OpIterator = $b797e6a5d13387bc$exports.default;
const $f5af2faee6afab08$var$NULL_CHARACTER = String.fromCharCode(0); // Placeholder char for embed in diff()
const $f5af2faee6afab08$var$getEmbedTypeAndData = (a, b)=>{
    if (typeof a !== "object" || a === null) throw new Error(`cannot retain a ${typeof a}`);
    if (typeof b !== "object" || b === null) throw new Error(`cannot retain a ${typeof b}`);
    const embedType = Object.keys(a)[0];
    if (!embedType || embedType !== Object.keys(b)[0]) throw new Error(`embed types not matched: ${embedType} != ${Object.keys(b)[0]}`);
    return [
        embedType,
        a[embedType],
        b[embedType]
    ];
};
class $f5af2faee6afab08$var$Delta {
    static registerEmbed(embedType, handler) {
        this.handlers[embedType] = handler;
    }
    static unregisterEmbed(embedType) {
        delete this.handlers[embedType];
    }
    static getHandler(embedType) {
        const handler = this.handlers[embedType];
        if (!handler) throw new Error(`no handlers for embed type "${embedType}"`);
        return handler;
    }
    insert(arg, attributes) {
        const newOp = {};
        if (typeof arg === "string" && arg.length === 0) return this;
        newOp.insert = arg;
        if (attributes != null && typeof attributes === "object" && Object.keys(attributes).length > 0) newOp.attributes = attributes;
        return this.push(newOp);
    }
    delete(length) {
        if (length <= 0) return this;
        return this.push({
            delete: length
        });
    }
    retain(length, attributes) {
        if (typeof length === "number" && length <= 0) return this;
        const newOp = {
            retain: length
        };
        if (attributes != null && typeof attributes === "object" && Object.keys(attributes).length > 0) newOp.attributes = attributes;
        return this.push(newOp);
    }
    push(newOp) {
        let index = this.ops.length;
        let lastOp = this.ops[index - 1];
        newOp = $6d3lL(newOp);
        if (typeof lastOp === "object") {
            if (typeof newOp.delete === "number" && typeof lastOp.delete === "number") {
                this.ops[index - 1] = {
                    delete: lastOp.delete + newOp.delete
                };
                return this;
            }
            // Since it does not matter if we insert before or after deleting at the same index,
            // always prefer to insert first
            if (typeof lastOp.delete === "number" && newOp.insert != null) {
                index -= 1;
                lastOp = this.ops[index - 1];
                if (typeof lastOp !== "object") {
                    this.ops.unshift(newOp);
                    return this;
                }
            }
            if ($lj5HN(newOp.attributes, lastOp.attributes)) {
                if (typeof newOp.insert === "string" && typeof lastOp.insert === "string") {
                    this.ops[index - 1] = {
                        insert: lastOp.insert + newOp.insert
                    };
                    if (typeof newOp.attributes === "object") this.ops[index - 1].attributes = newOp.attributes;
                    return this;
                } else if (typeof newOp.retain === "number" && typeof lastOp.retain === "number") {
                    this.ops[index - 1] = {
                        retain: lastOp.retain + newOp.retain
                    };
                    if (typeof newOp.attributes === "object") this.ops[index - 1].attributes = newOp.attributes;
                    return this;
                }
            }
        }
        if (index === this.ops.length) this.ops.push(newOp);
        else this.ops.splice(index, 0, newOp);
        return this;
    }
    chop() {
        const lastOp = this.ops[this.ops.length - 1];
        if (lastOp && typeof lastOp.retain === "number" && !lastOp.attributes) this.ops.pop();
        return this;
    }
    filter(predicate) {
        return this.ops.filter(predicate);
    }
    forEach(predicate) {
        this.ops.forEach(predicate);
    }
    map(predicate) {
        return this.ops.map(predicate);
    }
    partition(predicate) {
        const passed = [];
        const failed = [];
        this.forEach((op)=>{
            const target = predicate(op) ? passed : failed;
            target.push(op);
        });
        return [
            passed,
            failed
        ];
    }
    reduce(predicate, initialValue) {
        return this.ops.reduce(predicate, initialValue);
    }
    changeLength() {
        return this.reduce((length, elem)=>{
            if (elem.insert) return length + $e5aa29c01f64f7da$exports.default.length(elem);
            else if (elem.delete) return length - elem.delete;
            return length;
        }, 0);
    }
    length() {
        return this.reduce((length, elem)=>{
            return length + $e5aa29c01f64f7da$exports.default.length(elem);
        }, 0);
    }
    slice(start = 0, end = Infinity) {
        const ops = [];
        const iter = new $b797e6a5d13387bc$exports.default(this.ops);
        let index = 0;
        while(index < end && iter.hasNext()){
            let nextOp;
            if (index < start) nextOp = iter.next(start - index);
            else {
                nextOp = iter.next(end - index);
                ops.push(nextOp);
            }
            index += $e5aa29c01f64f7da$exports.default.length(nextOp);
        }
        return new $f5af2faee6afab08$var$Delta(ops);
    }
    compose(other) {
        const thisIter = new $b797e6a5d13387bc$exports.default(this.ops);
        const otherIter = new $b797e6a5d13387bc$exports.default(other.ops);
        const ops = [];
        const firstOther = otherIter.peek();
        if (firstOther != null && typeof firstOther.retain === "number" && firstOther.attributes == null) {
            let firstLeft = firstOther.retain;
            while(thisIter.peekType() === "insert" && thisIter.peekLength() <= firstLeft){
                firstLeft -= thisIter.peekLength();
                ops.push(thisIter.next());
            }
            if (firstOther.retain - firstLeft > 0) otherIter.next(firstOther.retain - firstLeft);
        }
        const delta = new $f5af2faee6afab08$var$Delta(ops);
        while(thisIter.hasNext() || otherIter.hasNext()){
            if (otherIter.peekType() === "insert") delta.push(otherIter.next());
            else if (thisIter.peekType() === "delete") delta.push(thisIter.next());
            else {
                const length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                const thisOp = thisIter.next(length);
                const otherOp = otherIter.next(length);
                if (otherOp.retain) {
                    const newOp = {};
                    if (typeof thisOp.retain === "number") newOp.retain = typeof otherOp.retain === "number" ? length : otherOp.retain;
                    else if (typeof otherOp.retain === "number") {
                        if (thisOp.retain == null) newOp.insert = thisOp.insert;
                        else newOp.retain = thisOp.retain;
                    } else {
                        const action = thisOp.retain == null ? "insert" : "retain";
                        const [embedType, thisData, otherData] = $f5af2faee6afab08$var$getEmbedTypeAndData(thisOp[action], otherOp.retain);
                        const handler = $f5af2faee6afab08$var$Delta.getHandler(embedType);
                        newOp[action] = {
                            [embedType]: handler.compose(thisData, otherData, action === "retain")
                        };
                    }
                    // Preserve null when composing with a retain, otherwise remove it for inserts
                    const attributes = $e33f3d0be8911994$exports.default.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === "number");
                    if (attributes) newOp.attributes = attributes;
                    delta.push(newOp);
                    // Optimization if rest of other is just retain
                    if (!otherIter.hasNext() && $lj5HN(delta.ops[delta.ops.length - 1], newOp)) {
                        const rest = new $f5af2faee6afab08$var$Delta(thisIter.rest());
                        return delta.concat(rest).chop();
                    }
                // Other op should be delete, we could be an insert or retain
                // Insert + delete cancels out
                } else if (typeof otherOp.delete === "number" && (typeof thisOp.retain === "number" || typeof thisOp.retain === "object" && thisOp.retain !== null)) delta.push(otherOp);
            }
        }
        return delta.chop();
    }
    concat(other) {
        const delta = new $f5af2faee6afab08$var$Delta(this.ops.slice());
        if (other.ops.length > 0) {
            delta.push(other.ops[0]);
            delta.ops = delta.ops.concat(other.ops.slice(1));
        }
        return delta;
    }
    diff(other, cursor) {
        if (this.ops === other.ops) return new $f5af2faee6afab08$var$Delta();
        const strings = [
            this,
            other
        ].map((delta)=>{
            return delta.map((op)=>{
                if (op.insert != null) return typeof op.insert === "string" ? op.insert : $f5af2faee6afab08$var$NULL_CHARACTER;
                const prep = delta === other ? "on" : "with";
                throw new Error("diff() called " + prep + " non-document");
            }).join("");
        });
        const retDelta = new $f5af2faee6afab08$var$Delta();
        const diffResult = $d613a92b30f394c7$exports(strings[0], strings[1], cursor, true);
        const thisIter = new $b797e6a5d13387bc$exports.default(this.ops);
        const otherIter = new $b797e6a5d13387bc$exports.default(other.ops);
        diffResult.forEach((component)=>{
            let length = component[1].length;
            while(length > 0){
                let opLength = 0;
                switch(component[0]){
                    case $d613a92b30f394c7$exports.INSERT:
                        opLength = Math.min(otherIter.peekLength(), length);
                        retDelta.push(otherIter.next(opLength));
                        break;
                    case $d613a92b30f394c7$exports.DELETE:
                        opLength = Math.min(length, thisIter.peekLength());
                        thisIter.next(opLength);
                        retDelta.delete(opLength);
                        break;
                    case $d613a92b30f394c7$exports.EQUAL:
                        opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
                        const thisOp = thisIter.next(opLength);
                        const otherOp = otherIter.next(opLength);
                        if ($lj5HN(thisOp.insert, otherOp.insert)) retDelta.retain(opLength, $e33f3d0be8911994$exports.default.diff(thisOp.attributes, otherOp.attributes));
                        else retDelta.push(otherOp).delete(opLength);
                        break;
                }
                length -= opLength;
            }
        });
        return retDelta.chop();
    }
    eachLine(predicate, newline = "\n") {
        const iter = new $b797e6a5d13387bc$exports.default(this.ops);
        let line = new $f5af2faee6afab08$var$Delta();
        let i = 0;
        while(iter.hasNext()){
            if (iter.peekType() !== "insert") return;
            const thisOp = iter.peek();
            const start = $e5aa29c01f64f7da$exports.default.length(thisOp) - iter.peekLength();
            const index = typeof thisOp.insert === "string" ? thisOp.insert.indexOf(newline, start) - start : -1;
            if (index < 0) line.push(iter.next());
            else if (index > 0) line.push(iter.next(index));
            else {
                if (predicate(line, iter.next(1).attributes || {}, i) === false) return;
                i += 1;
                line = new $f5af2faee6afab08$var$Delta();
            }
        }
        if (line.length() > 0) predicate(line, {}, i);
    }
    invert(base) {
        const inverted = new $f5af2faee6afab08$var$Delta();
        this.reduce((baseIndex, op)=>{
            if (op.insert) inverted.delete($e5aa29c01f64f7da$exports.default.length(op));
            else if (typeof op.retain === "number" && op.attributes == null) {
                inverted.retain(op.retain);
                return baseIndex + op.retain;
            } else if (op.delete || typeof op.retain === "number") {
                const length = op.delete || op.retain;
                const slice = base.slice(baseIndex, baseIndex + length);
                slice.forEach((baseOp)=>{
                    if (op.delete) inverted.push(baseOp);
                    else if (op.retain && op.attributes) inverted.retain($e5aa29c01f64f7da$exports.default.length(baseOp), $e33f3d0be8911994$exports.default.invert(op.attributes, baseOp.attributes));
                });
                return baseIndex + length;
            } else if (typeof op.retain === "object" && op.retain !== null) {
                const slice = base.slice(baseIndex, baseIndex + 1);
                const baseOp = new $b797e6a5d13387bc$exports.default(slice.ops).next();
                const [embedType, opData, baseOpData] = $f5af2faee6afab08$var$getEmbedTypeAndData(op.retain, baseOp.insert);
                const handler = $f5af2faee6afab08$var$Delta.getHandler(embedType);
                inverted.retain({
                    [embedType]: handler.invert(opData, baseOpData)
                }, $e33f3d0be8911994$exports.default.invert(op.attributes, baseOp.attributes));
                return baseIndex + 1;
            }
            return baseIndex;
        }, 0);
        return inverted.chop();
    }
    transform(arg, priority = false) {
        priority = !!priority;
        if (typeof arg === "number") return this.transformPosition(arg, priority);
        const other = arg;
        const thisIter = new $b797e6a5d13387bc$exports.default(this.ops);
        const otherIter = new $b797e6a5d13387bc$exports.default(other.ops);
        const delta = new $f5af2faee6afab08$var$Delta();
        while(thisIter.hasNext() || otherIter.hasNext()){
            if (thisIter.peekType() === "insert" && (priority || otherIter.peekType() !== "insert")) delta.retain($e5aa29c01f64f7da$exports.default.length(thisIter.next()));
            else if (otherIter.peekType() === "insert") delta.push(otherIter.next());
            else {
                const length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                const thisOp = thisIter.next(length);
                const otherOp = otherIter.next(length);
                if (thisOp.delete) continue;
                else if (otherOp.delete) delta.push(otherOp);
                else {
                    const thisData = thisOp.retain;
                    const otherData = otherOp.retain;
                    let transformedData = typeof otherData === "object" && otherData !== null ? otherData : length;
                    if (typeof thisData === "object" && thisData !== null && typeof otherData === "object" && otherData !== null) {
                        const embedType = Object.keys(thisData)[0];
                        if (embedType === Object.keys(otherData)[0]) {
                            const handler = $f5af2faee6afab08$var$Delta.getHandler(embedType);
                            if (handler) transformedData = {
                                [embedType]: handler.transform(thisData[embedType], otherData[embedType], priority)
                            };
                        }
                    }
                    // We retain either their retain or insert
                    delta.retain(transformedData, $e33f3d0be8911994$exports.default.transform(thisOp.attributes, otherOp.attributes, priority));
                }
            }
        }
        return delta.chop();
    }
    transformPosition(index, priority = false) {
        priority = !!priority;
        const thisIter = new $b797e6a5d13387bc$exports.default(this.ops);
        let offset = 0;
        while(thisIter.hasNext() && offset <= index){
            const length = thisIter.peekLength();
            const nextType = thisIter.peekType();
            thisIter.next();
            if (nextType === "delete") {
                index -= Math.min(length, index - offset);
                continue;
            } else if (nextType === "insert" && (offset < index || !priority)) index += length;
            offset += length;
        }
        return index;
    }
    constructor(ops){
        // Assume we are given a well formed ops
        if (Array.isArray(ops)) this.ops = ops;
        else if (ops != null && Array.isArray(ops.ops)) this.ops = ops.ops;
        else this.ops = [];
    }
}
$f5af2faee6afab08$var$Delta.Op = $e5aa29c01f64f7da$exports.default;
$f5af2faee6afab08$var$Delta.OpIterator = $b797e6a5d13387bc$exports.default;
$f5af2faee6afab08$var$Delta.AttributeMap = $e33f3d0be8911994$exports.default;
$f5af2faee6afab08$var$Delta.handlers = {};
$f5af2faee6afab08$exports.default = $f5af2faee6afab08$var$Delta;
$f5af2faee6afab08$exports = $f5af2faee6afab08$var$Delta;
$f5af2faee6afab08$exports.default = $f5af2faee6afab08$var$Delta;



/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $b7a56a54f0c009dd$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $b7a56a54f0c009dd$export$2e2bcd8739ae039 = $b7a56a54f0c009dd$var$arrayEach;







/* Built-in method references for those with the same name as other `lodash` methods. */ var $14a6bcdebf39f36e$var$nativeKeys = (0, $d0fb1d1c76f7af6d$export$2e2bcd8739ae039)(Object.keys, Object);
var $14a6bcdebf39f36e$export$2e2bcd8739ae039 = $14a6bcdebf39f36e$var$nativeKeys;


/** Used for built-in method references. */ var $d4198941877eba43$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d4198941877eba43$var$hasOwnProperty = $d4198941877eba43$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $d4198941877eba43$var$baseKeys(object) {
    if (!(0, $c4b37195c52b7c20$export$2e2bcd8739ae039)(object)) return (0, $14a6bcdebf39f36e$export$2e2bcd8739ae039)(object);
    var result = [];
    for(var key in Object(object))if ($d4198941877eba43$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
var $d4198941877eba43$export$2e2bcd8739ae039 = $d4198941877eba43$var$baseKeys;



/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $98e843b55f7357cb$var$keys(object) {
    return (0, $38dc911623597bb2$export$2e2bcd8739ae039)(object) ? (0, $294a8bd41f7467e4$export$2e2bcd8739ae039)(object) : (0, $d4198941877eba43$export$2e2bcd8739ae039)(object);
}
var $98e843b55f7357cb$export$2e2bcd8739ae039 = $98e843b55f7357cb$var$keys;


/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $3c499e5c2361f139$var$baseAssign(object, source) {
    return object && (0, $1da977d0f00c42cc$export$2e2bcd8739ae039)(source, (0, $98e843b55f7357cb$export$2e2bcd8739ae039)(source), object);
}
var $3c499e5c2361f139$export$2e2bcd8739ae039 = $3c499e5c2361f139$var$baseAssign;




/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $30f768aea238eab9$var$baseAssignIn(object, source) {
    return object && (0, $1da977d0f00c42cc$export$2e2bcd8739ae039)(source, (0, $e28c6d98ceb59df4$export$2e2bcd8739ae039)(source), object);
}
var $30f768aea238eab9$export$2e2bcd8739ae039 = $30f768aea238eab9$var$baseAssignIn;



var $6nnFN = parcelRequire("6nnFN");


/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $e2969334a506b020$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $e2969334a506b020$export$2e2bcd8739ae039 = $e2969334a506b020$var$arrayFilter;


/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $6bc7b59d5557b5f7$var$stubArray() {
    return [];
}
var $6bc7b59d5557b5f7$export$2e2bcd8739ae039 = $6bc7b59d5557b5f7$var$stubArray;


/** Used for built-in method references. */ var $3dd6c1bc514c8ade$var$objectProto = Object.prototype;
/** Built-in value references. */ var $3dd6c1bc514c8ade$var$propertyIsEnumerable = $3dd6c1bc514c8ade$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3dd6c1bc514c8ade$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $3dd6c1bc514c8ade$var$getSymbols = !$3dd6c1bc514c8ade$var$nativeGetSymbols ? (0, $6bc7b59d5557b5f7$export$2e2bcd8739ae039) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $e2969334a506b020$export$2e2bcd8739ae039)($3dd6c1bc514c8ade$var$nativeGetSymbols(object), function(symbol) {
        return $3dd6c1bc514c8ade$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $3dd6c1bc514c8ade$export$2e2bcd8739ae039 = $3dd6c1bc514c8ade$var$getSymbols;


/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $9cf23d6610cd6422$var$copySymbols(source, object) {
    return (0, $1da977d0f00c42cc$export$2e2bcd8739ae039)(source, (0, $3dd6c1bc514c8ade$export$2e2bcd8739ae039)(source), object);
}
var $9cf23d6610cd6422$export$2e2bcd8739ae039 = $9cf23d6610cd6422$var$copySymbols;



/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $47ba58eec887dcf6$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $47ba58eec887dcf6$export$2e2bcd8739ae039 = $47ba58eec887dcf6$var$arrayPush;





/* Built-in method references for those with the same name as other `lodash` methods. */ var $8cb0f381f93d61e2$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $8cb0f381f93d61e2$var$getSymbolsIn = !$8cb0f381f93d61e2$var$nativeGetSymbols ? (0, $6bc7b59d5557b5f7$export$2e2bcd8739ae039) : function(object) {
    var result = [];
    while(object){
        (0, $47ba58eec887dcf6$export$2e2bcd8739ae039)(result, (0, $3dd6c1bc514c8ade$export$2e2bcd8739ae039)(object));
        object = (0, $fc85ad3eee846b47$export$2e2bcd8739ae039)(object);
    }
    return result;
};
var $8cb0f381f93d61e2$export$2e2bcd8739ae039 = $8cb0f381f93d61e2$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $84e2b69dc59638d7$var$copySymbolsIn(source, object) {
    return (0, $1da977d0f00c42cc$export$2e2bcd8739ae039)(source, (0, $8cb0f381f93d61e2$export$2e2bcd8739ae039)(source), object);
}
var $84e2b69dc59638d7$export$2e2bcd8739ae039 = $84e2b69dc59638d7$var$copySymbolsIn;




/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $2b8fbe576a5aab02$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $93b249752024ad0a$export$2e2bcd8739ae039)(object) ? result : (0, $47ba58eec887dcf6$export$2e2bcd8739ae039)(result, symbolsFunc(object));
}
var $2b8fbe576a5aab02$export$2e2bcd8739ae039 = $2b8fbe576a5aab02$var$baseGetAllKeys;




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $3c06b2f92a5e2346$var$getAllKeys(object) {
    return (0, $2b8fbe576a5aab02$export$2e2bcd8739ae039)(object, (0, $98e843b55f7357cb$export$2e2bcd8739ae039), (0, $3dd6c1bc514c8ade$export$2e2bcd8739ae039));
}
var $3c06b2f92a5e2346$export$2e2bcd8739ae039 = $3c06b2f92a5e2346$var$getAllKeys;





/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $0fe0c15997facc31$var$getAllKeysIn(object) {
    return (0, $2b8fbe576a5aab02$export$2e2bcd8739ae039)(object, (0, $e28c6d98ceb59df4$export$2e2bcd8739ae039), (0, $8cb0f381f93d61e2$export$2e2bcd8739ae039));
}
var $0fe0c15997facc31$export$2e2bcd8739ae039 = $0fe0c15997facc31$var$getAllKeysIn;




var $fshLi = parcelRequire("fshLi");
/* Built-in method references that are verified to be native. */ var $cc1e36687ec5017a$var$DataView = (0, $b805a149580bacf7$export$2e2bcd8739ae039)((0, $fshLi.default), "DataView");
var $cc1e36687ec5017a$export$2e2bcd8739ae039 = $cc1e36687ec5017a$var$DataView;





var $fshLi = parcelRequire("fshLi");
/* Built-in method references that are verified to be native. */ var $13c3f45d0483832e$var$Promise = (0, $b805a149580bacf7$export$2e2bcd8739ae039)((0, $fshLi.default), "Promise");
var $13c3f45d0483832e$export$2e2bcd8739ae039 = $13c3f45d0483832e$var$Promise;




var $fshLi = parcelRequire("fshLi");
/* Built-in method references that are verified to be native. */ var $d4deda59fd139a8f$var$Set = (0, $b805a149580bacf7$export$2e2bcd8739ae039)((0, $fshLi.default), "Set");
var $d4deda59fd139a8f$export$2e2bcd8739ae039 = $d4deda59fd139a8f$var$Set;




var $fshLi = parcelRequire("fshLi");
/* Built-in method references that are verified to be native. */ var $65125fd2eb8919a5$var$WeakMap = (0, $b805a149580bacf7$export$2e2bcd8739ae039)((0, $fshLi.default), "WeakMap");
var $65125fd2eb8919a5$export$2e2bcd8739ae039 = $65125fd2eb8919a5$var$WeakMap;




/** `Object#toString` result references. */ var $77ed2e44816ca23c$var$mapTag = "[object Map]", $77ed2e44816ca23c$var$objectTag = "[object Object]", $77ed2e44816ca23c$var$promiseTag = "[object Promise]", $77ed2e44816ca23c$var$setTag = "[object Set]", $77ed2e44816ca23c$var$weakMapTag = "[object WeakMap]";
var $77ed2e44816ca23c$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $77ed2e44816ca23c$var$dataViewCtorString = (0, $6f9ce694399d2bb3$export$2e2bcd8739ae039)((0, $cc1e36687ec5017a$export$2e2bcd8739ae039)), $77ed2e44816ca23c$var$mapCtorString = (0, $6f9ce694399d2bb3$export$2e2bcd8739ae039)((0, $322e42da3acd1ad9$export$2e2bcd8739ae039)), $77ed2e44816ca23c$var$promiseCtorString = (0, $6f9ce694399d2bb3$export$2e2bcd8739ae039)((0, $13c3f45d0483832e$export$2e2bcd8739ae039)), $77ed2e44816ca23c$var$setCtorString = (0, $6f9ce694399d2bb3$export$2e2bcd8739ae039)((0, $d4deda59fd139a8f$export$2e2bcd8739ae039)), $77ed2e44816ca23c$var$weakMapCtorString = (0, $6f9ce694399d2bb3$export$2e2bcd8739ae039)((0, $65125fd2eb8919a5$export$2e2bcd8739ae039));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $77ed2e44816ca23c$var$getTag = (0, $64fb6e2e9109eff6$export$2e2bcd8739ae039);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $cc1e36687ec5017a$export$2e2bcd8739ae039) && $77ed2e44816ca23c$var$getTag(new (0, $cc1e36687ec5017a$export$2e2bcd8739ae039)(new ArrayBuffer(1))) != $77ed2e44816ca23c$var$dataViewTag || (0, $322e42da3acd1ad9$export$2e2bcd8739ae039) && $77ed2e44816ca23c$var$getTag(new (0, $322e42da3acd1ad9$export$2e2bcd8739ae039)) != $77ed2e44816ca23c$var$mapTag || (0, $13c3f45d0483832e$export$2e2bcd8739ae039) && $77ed2e44816ca23c$var$getTag((0, $13c3f45d0483832e$export$2e2bcd8739ae039).resolve()) != $77ed2e44816ca23c$var$promiseTag || (0, $d4deda59fd139a8f$export$2e2bcd8739ae039) && $77ed2e44816ca23c$var$getTag(new (0, $d4deda59fd139a8f$export$2e2bcd8739ae039)) != $77ed2e44816ca23c$var$setTag || (0, $65125fd2eb8919a5$export$2e2bcd8739ae039) && $77ed2e44816ca23c$var$getTag(new (0, $65125fd2eb8919a5$export$2e2bcd8739ae039)) != $77ed2e44816ca23c$var$weakMapTag) $77ed2e44816ca23c$var$getTag = function(value) {
    var result = (0, $64fb6e2e9109eff6$export$2e2bcd8739ae039)(value), Ctor = result == $77ed2e44816ca23c$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $6f9ce694399d2bb3$export$2e2bcd8739ae039)(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $77ed2e44816ca23c$var$dataViewCtorString:
            return $77ed2e44816ca23c$var$dataViewTag;
        case $77ed2e44816ca23c$var$mapCtorString:
            return $77ed2e44816ca23c$var$mapTag;
        case $77ed2e44816ca23c$var$promiseCtorString:
            return $77ed2e44816ca23c$var$promiseTag;
        case $77ed2e44816ca23c$var$setCtorString:
            return $77ed2e44816ca23c$var$setTag;
        case $77ed2e44816ca23c$var$weakMapCtorString:
            return $77ed2e44816ca23c$var$weakMapTag;
    }
    return result;
};
var $77ed2e44816ca23c$export$2e2bcd8739ae039 = $77ed2e44816ca23c$var$getTag;


/** Used for built-in method references. */ var $f756e3cf4ded6c17$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f756e3cf4ded6c17$var$hasOwnProperty = $f756e3cf4ded6c17$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $f756e3cf4ded6c17$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $f756e3cf4ded6c17$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $f756e3cf4ded6c17$export$2e2bcd8739ae039 = $f756e3cf4ded6c17$var$initCloneArray;




/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $e1b684a704c4794e$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $f7af92ec9d8ef87f$export$2e2bcd8739ae039)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $e1b684a704c4794e$export$2e2bcd8739ae039 = $e1b684a704c4794e$var$cloneDataView;


/** Used to match `RegExp` flags from their coerced string values. */ var $77caa85735ad85c9$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $77caa85735ad85c9$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $77caa85735ad85c9$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $77caa85735ad85c9$export$2e2bcd8739ae039 = $77caa85735ad85c9$var$cloneRegExp;



/** Used to convert symbols to primitives and strings. */ var $84f1aa0adb443314$var$symbolProto = (0, $dbd68291cf58beb2$export$2e2bcd8739ae039) ? (0, $dbd68291cf58beb2$export$2e2bcd8739ae039).prototype : undefined, $84f1aa0adb443314$var$symbolValueOf = $84f1aa0adb443314$var$symbolProto ? $84f1aa0adb443314$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $84f1aa0adb443314$var$cloneSymbol(symbol) {
    return $84f1aa0adb443314$var$symbolValueOf ? Object($84f1aa0adb443314$var$symbolValueOf.call(symbol)) : {};
}
var $84f1aa0adb443314$export$2e2bcd8739ae039 = $84f1aa0adb443314$var$cloneSymbol;



/** `Object#toString` result references. */ var $b2fc970f7cd11a52$var$boolTag = "[object Boolean]", $b2fc970f7cd11a52$var$dateTag = "[object Date]", $b2fc970f7cd11a52$var$mapTag = "[object Map]", $b2fc970f7cd11a52$var$numberTag = "[object Number]", $b2fc970f7cd11a52$var$regexpTag = "[object RegExp]", $b2fc970f7cd11a52$var$setTag = "[object Set]", $b2fc970f7cd11a52$var$stringTag = "[object String]", $b2fc970f7cd11a52$var$symbolTag = "[object Symbol]";
var $b2fc970f7cd11a52$var$arrayBufferTag = "[object ArrayBuffer]", $b2fc970f7cd11a52$var$dataViewTag = "[object DataView]", $b2fc970f7cd11a52$var$float32Tag = "[object Float32Array]", $b2fc970f7cd11a52$var$float64Tag = "[object Float64Array]", $b2fc970f7cd11a52$var$int8Tag = "[object Int8Array]", $b2fc970f7cd11a52$var$int16Tag = "[object Int16Array]", $b2fc970f7cd11a52$var$int32Tag = "[object Int32Array]", $b2fc970f7cd11a52$var$uint8Tag = "[object Uint8Array]", $b2fc970f7cd11a52$var$uint8ClampedTag = "[object Uint8ClampedArray]", $b2fc970f7cd11a52$var$uint16Tag = "[object Uint16Array]", $b2fc970f7cd11a52$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $b2fc970f7cd11a52$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $b2fc970f7cd11a52$var$arrayBufferTag:
            return (0, $f7af92ec9d8ef87f$export$2e2bcd8739ae039)(object);
        case $b2fc970f7cd11a52$var$boolTag:
        case $b2fc970f7cd11a52$var$dateTag:
            return new Ctor(+object);
        case $b2fc970f7cd11a52$var$dataViewTag:
            return (0, $e1b684a704c4794e$export$2e2bcd8739ae039)(object, isDeep);
        case $b2fc970f7cd11a52$var$float32Tag:
        case $b2fc970f7cd11a52$var$float64Tag:
        case $b2fc970f7cd11a52$var$int8Tag:
        case $b2fc970f7cd11a52$var$int16Tag:
        case $b2fc970f7cd11a52$var$int32Tag:
        case $b2fc970f7cd11a52$var$uint8Tag:
        case $b2fc970f7cd11a52$var$uint8ClampedTag:
        case $b2fc970f7cd11a52$var$uint16Tag:
        case $b2fc970f7cd11a52$var$uint32Tag:
            return (0, $9b604d3b769eeba8$export$2e2bcd8739ae039)(object, isDeep);
        case $b2fc970f7cd11a52$var$mapTag:
            return new Ctor;
        case $b2fc970f7cd11a52$var$numberTag:
        case $b2fc970f7cd11a52$var$stringTag:
            return new Ctor(object);
        case $b2fc970f7cd11a52$var$regexpTag:
            return (0, $77caa85735ad85c9$export$2e2bcd8739ae039)(object);
        case $b2fc970f7cd11a52$var$setTag:
            return new Ctor;
        case $b2fc970f7cd11a52$var$symbolTag:
            return (0, $84f1aa0adb443314$export$2e2bcd8739ae039)(object);
    }
}
var $b2fc970f7cd11a52$export$2e2bcd8739ae039 = $b2fc970f7cd11a52$var$initCloneByTag;





var $42CIw = parcelRequire("42CIw");


/** `Object#toString` result references. */ var $453e4d9b90909fc0$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $453e4d9b90909fc0$var$baseIsMap(value) {
    return (0, $4757a366dbe9cf5c$export$2e2bcd8739ae039)(value) && (0, $77ed2e44816ca23c$export$2e2bcd8739ae039)(value) == $453e4d9b90909fc0$var$mapTag;
}
var $453e4d9b90909fc0$export$2e2bcd8739ae039 = $453e4d9b90909fc0$var$baseIsMap;




var $fe9Eu = parcelRequire("fe9Eu");
/* Node.js helper references. */ var $072ebec899a26396$var$nodeIsMap = (0, $fe9Eu.default) && (0, $fe9Eu.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $072ebec899a26396$var$isMap = $072ebec899a26396$var$nodeIsMap ? (0, $d92dccaad4cc131c$export$2e2bcd8739ae039)($072ebec899a26396$var$nodeIsMap) : (0, $453e4d9b90909fc0$export$2e2bcd8739ae039);
var $072ebec899a26396$export$2e2bcd8739ae039 = $072ebec899a26396$var$isMap;





/** `Object#toString` result references. */ var $87f45409d680a12d$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $87f45409d680a12d$var$baseIsSet(value) {
    return (0, $4757a366dbe9cf5c$export$2e2bcd8739ae039)(value) && (0, $77ed2e44816ca23c$export$2e2bcd8739ae039)(value) == $87f45409d680a12d$var$setTag;
}
var $87f45409d680a12d$export$2e2bcd8739ae039 = $87f45409d680a12d$var$baseIsSet;




var $fe9Eu = parcelRequire("fe9Eu");
/* Node.js helper references. */ var $1a8c7c41d5ec4fa3$var$nodeIsSet = (0, $fe9Eu.default) && (0, $fe9Eu.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $1a8c7c41d5ec4fa3$var$isSet = $1a8c7c41d5ec4fa3$var$nodeIsSet ? (0, $d92dccaad4cc131c$export$2e2bcd8739ae039)($1a8c7c41d5ec4fa3$var$nodeIsSet) : (0, $87f45409d680a12d$export$2e2bcd8739ae039);
var $1a8c7c41d5ec4fa3$export$2e2bcd8739ae039 = $1a8c7c41d5ec4fa3$var$isSet;




/** Used to compose bitmasks for cloning. */ var $329e9e4a64ac660e$var$CLONE_DEEP_FLAG = 1, $329e9e4a64ac660e$var$CLONE_FLAT_FLAG = 2, $329e9e4a64ac660e$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $329e9e4a64ac660e$var$argsTag = "[object Arguments]", $329e9e4a64ac660e$var$arrayTag = "[object Array]", $329e9e4a64ac660e$var$boolTag = "[object Boolean]", $329e9e4a64ac660e$var$dateTag = "[object Date]", $329e9e4a64ac660e$var$errorTag = "[object Error]", $329e9e4a64ac660e$var$funcTag = "[object Function]", $329e9e4a64ac660e$var$genTag = "[object GeneratorFunction]", $329e9e4a64ac660e$var$mapTag = "[object Map]", $329e9e4a64ac660e$var$numberTag = "[object Number]", $329e9e4a64ac660e$var$objectTag = "[object Object]", $329e9e4a64ac660e$var$regexpTag = "[object RegExp]", $329e9e4a64ac660e$var$setTag = "[object Set]", $329e9e4a64ac660e$var$stringTag = "[object String]", $329e9e4a64ac660e$var$symbolTag = "[object Symbol]", $329e9e4a64ac660e$var$weakMapTag = "[object WeakMap]";
var $329e9e4a64ac660e$var$arrayBufferTag = "[object ArrayBuffer]", $329e9e4a64ac660e$var$dataViewTag = "[object DataView]", $329e9e4a64ac660e$var$float32Tag = "[object Float32Array]", $329e9e4a64ac660e$var$float64Tag = "[object Float64Array]", $329e9e4a64ac660e$var$int8Tag = "[object Int8Array]", $329e9e4a64ac660e$var$int16Tag = "[object Int16Array]", $329e9e4a64ac660e$var$int32Tag = "[object Int32Array]", $329e9e4a64ac660e$var$uint8Tag = "[object Uint8Array]", $329e9e4a64ac660e$var$uint8ClampedTag = "[object Uint8ClampedArray]", $329e9e4a64ac660e$var$uint16Tag = "[object Uint16Array]", $329e9e4a64ac660e$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $329e9e4a64ac660e$var$cloneableTags = {};
$329e9e4a64ac660e$var$cloneableTags[$329e9e4a64ac660e$var$argsTag] = $329e9e4a64ac660e$var$cloneableTags[$329e9e4a64ac660e$var$arrayTag] = $329e9e4a64ac660e$var$cloneableTags[$329e9e4a64ac660e$var$arrayBufferTag] = $329e9e4a64ac660e$var$cloneableTags[$329e9e4a64ac660e$var$dataViewTag] = $329e9e4a64ac660e$var$cloneableTags[$329e9e4a64ac660e$var$boolTag] = $329e9e4a64ac660e$var$cloneableTags[$329e9e4a64ac660e$var$dateTag] = $329e9e4a64ac660e$var$cloneableTags[$329e9e4a64ac660e$var$float32Tag] = $329e9e4a64ac660e$var$cloneableTags[$329e9e4a64ac660e$var$float64Tag] = $329e9e4a64ac660e$var$cloneableTags[$329e9e4a64ac660e$var$int8Tag] = $329e9e4a64ac660e$var$cloneableTags[$329e9e4a64ac660e$var$int16Tag] = $329e9e4a64ac660e$var$cloneableTags[$329e9e4a64ac660e$var$int32Tag] = $329e9e4a64ac660e$var$cloneableTags[$329e9e4a64ac660e$var$mapTag] = $329e9e4a64ac660e$var$cloneableTags[$329e9e4a64ac660e$var$numberTag] = $329e9e4a64ac660e$var$cloneableTags[$329e9e4a64ac660e$var$objectTag] = $329e9e4a64ac660e$var$cloneableTags[$329e9e4a64ac660e$var$regexpTag] = $329e9e4a64ac660e$var$cloneableTags[$329e9e4a64ac660e$var$setTag] = $329e9e4a64ac660e$var$cloneableTags[$329e9e4a64ac660e$var$stringTag] = $329e9e4a64ac660e$var$cloneableTags[$329e9e4a64ac660e$var$symbolTag] = $329e9e4a64ac660e$var$cloneableTags[$329e9e4a64ac660e$var$uint8Tag] = $329e9e4a64ac660e$var$cloneableTags[$329e9e4a64ac660e$var$uint8ClampedTag] = $329e9e4a64ac660e$var$cloneableTags[$329e9e4a64ac660e$var$uint16Tag] = $329e9e4a64ac660e$var$cloneableTags[$329e9e4a64ac660e$var$uint32Tag] = true;
$329e9e4a64ac660e$var$cloneableTags[$329e9e4a64ac660e$var$errorTag] = $329e9e4a64ac660e$var$cloneableTags[$329e9e4a64ac660e$var$funcTag] = $329e9e4a64ac660e$var$cloneableTags[$329e9e4a64ac660e$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $329e9e4a64ac660e$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $329e9e4a64ac660e$var$CLONE_DEEP_FLAG, isFlat = bitmask & $329e9e4a64ac660e$var$CLONE_FLAT_FLAG, isFull = bitmask & $329e9e4a64ac660e$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $97e1fd59e0a392d4$export$2e2bcd8739ae039)(value)) return value;
    var isArr = (0, $93b249752024ad0a$export$2e2bcd8739ae039)(value);
    if (isArr) {
        result = (0, $f756e3cf4ded6c17$export$2e2bcd8739ae039)(value);
        if (!isDeep) return (0, $ba8eed531ba68a89$export$2e2bcd8739ae039)(value, result);
    } else {
        var tag = (0, $77ed2e44816ca23c$export$2e2bcd8739ae039)(value), isFunc = tag == $329e9e4a64ac660e$var$funcTag || tag == $329e9e4a64ac660e$var$genTag;
        if ((0, $42CIw.default)(value)) return (0, $6nnFN.default)(value, isDeep);
        if (tag == $329e9e4a64ac660e$var$objectTag || tag == $329e9e4a64ac660e$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $82723ed9ea65b904$export$2e2bcd8739ae039)(value);
            if (!isDeep) return isFlat ? (0, $84e2b69dc59638d7$export$2e2bcd8739ae039)(value, (0, $30f768aea238eab9$export$2e2bcd8739ae039)(result, value)) : (0, $9cf23d6610cd6422$export$2e2bcd8739ae039)(value, (0, $3c499e5c2361f139$export$2e2bcd8739ae039)(result, value));
        } else {
            if (!$329e9e4a64ac660e$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $b2fc970f7cd11a52$export$2e2bcd8739ae039)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $dec20d54409d2f2d$export$2e2bcd8739ae039));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $1a8c7c41d5ec4fa3$export$2e2bcd8739ae039)(value)) value.forEach(function(subValue) {
        result.add($329e9e4a64ac660e$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $072ebec899a26396$export$2e2bcd8739ae039)(value)) value.forEach(function(subValue, key) {
        result.set(key, $329e9e4a64ac660e$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $0fe0c15997facc31$export$2e2bcd8739ae039) : (0, $3c06b2f92a5e2346$export$2e2bcd8739ae039) : isFlat ? (0, $e28c6d98ceb59df4$export$2e2bcd8739ae039) : (0, $98e843b55f7357cb$export$2e2bcd8739ae039);
    var props = isArr ? undefined : keysFunc(value);
    (0, $b7a56a54f0c009dd$export$2e2bcd8739ae039)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $e4d7a301c848fa48$export$2e2bcd8739ae039)(result, key, $329e9e4a64ac660e$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $329e9e4a64ac660e$export$2e2bcd8739ae039 = $329e9e4a64ac660e$var$baseClone;


/** Used to compose bitmasks for cloning. */ var $668add1f662a6818$var$CLONE_DEEP_FLAG = 1, $668add1f662a6818$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $668add1f662a6818$var$cloneDeep(value) {
    return (0, $329e9e4a64ac660e$export$2e2bcd8739ae039)(value, $668add1f662a6818$var$CLONE_DEEP_FLAG | $668add1f662a6818$var$CLONE_SYMBOLS_FLAG);
}
var $668add1f662a6818$export$2e2bcd8739ae039 = $668add1f662a6818$var$cloneDeep;



/** Used to stand-in for `undefined` hash values. */ var $18299706d8b329dd$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $18299706d8b329dd$var$setCacheAdd(value) {
    this.__data__.set(value, $18299706d8b329dd$var$HASH_UNDEFINED);
    return this;
}
var $18299706d8b329dd$export$2e2bcd8739ae039 = $18299706d8b329dd$var$setCacheAdd;


/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $707952831fb08fc3$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $707952831fb08fc3$export$2e2bcd8739ae039 = $707952831fb08fc3$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $ce43a2c4fc288ab0$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $06e9eb975eb9e1e5$export$2e2bcd8739ae039);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$ce43a2c4fc288ab0$var$SetCache.prototype.add = $ce43a2c4fc288ab0$var$SetCache.prototype.push = (0, $18299706d8b329dd$export$2e2bcd8739ae039);
$ce43a2c4fc288ab0$var$SetCache.prototype.has = (0, $707952831fb08fc3$export$2e2bcd8739ae039);
var $ce43a2c4fc288ab0$export$2e2bcd8739ae039 = $ce43a2c4fc288ab0$var$SetCache;


/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $53bae777fe1404f8$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $53bae777fe1404f8$export$2e2bcd8739ae039 = $53bae777fe1404f8$var$arraySome;


/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $72afb9aa0ee1ca09$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $72afb9aa0ee1ca09$export$2e2bcd8739ae039 = $72afb9aa0ee1ca09$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $92c54468f4f815dc$var$COMPARE_PARTIAL_FLAG = 1, $92c54468f4f815dc$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $92c54468f4f815dc$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $92c54468f4f815dc$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $92c54468f4f815dc$var$COMPARE_UNORDERED_FLAG ? new (0, $ce43a2c4fc288ab0$export$2e2bcd8739ae039) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $53bae777fe1404f8$export$2e2bcd8739ae039)(other, function(othValue, othIndex) {
                if (!(0, $72afb9aa0ee1ca09$export$2e2bcd8739ae039)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
var $92c54468f4f815dc$export$2e2bcd8739ae039 = $92c54468f4f815dc$var$equalArrays;






/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $f4f39a70fc8835b2$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $f4f39a70fc8835b2$export$2e2bcd8739ae039 = $f4f39a70fc8835b2$var$mapToArray;


/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $47dcdfae940a6696$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $47dcdfae940a6696$export$2e2bcd8739ae039 = $47dcdfae940a6696$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $1a45a05db06c3018$var$COMPARE_PARTIAL_FLAG = 1, $1a45a05db06c3018$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $1a45a05db06c3018$var$boolTag = "[object Boolean]", $1a45a05db06c3018$var$dateTag = "[object Date]", $1a45a05db06c3018$var$errorTag = "[object Error]", $1a45a05db06c3018$var$mapTag = "[object Map]", $1a45a05db06c3018$var$numberTag = "[object Number]", $1a45a05db06c3018$var$regexpTag = "[object RegExp]", $1a45a05db06c3018$var$setTag = "[object Set]", $1a45a05db06c3018$var$stringTag = "[object String]", $1a45a05db06c3018$var$symbolTag = "[object Symbol]";
var $1a45a05db06c3018$var$arrayBufferTag = "[object ArrayBuffer]", $1a45a05db06c3018$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $1a45a05db06c3018$var$symbolProto = (0, $dbd68291cf58beb2$export$2e2bcd8739ae039) ? (0, $dbd68291cf58beb2$export$2e2bcd8739ae039).prototype : undefined, $1a45a05db06c3018$var$symbolValueOf = $1a45a05db06c3018$var$symbolProto ? $1a45a05db06c3018$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $1a45a05db06c3018$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $1a45a05db06c3018$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $1a45a05db06c3018$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $35fd122c9034db7f$export$2e2bcd8739ae039)(object), new (0, $35fd122c9034db7f$export$2e2bcd8739ae039)(other))) return false;
            return true;
        case $1a45a05db06c3018$var$boolTag:
        case $1a45a05db06c3018$var$dateTag:
        case $1a45a05db06c3018$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $a1fc17bf3c9673a4$export$2e2bcd8739ae039)(+object, +other);
        case $1a45a05db06c3018$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $1a45a05db06c3018$var$regexpTag:
        case $1a45a05db06c3018$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $1a45a05db06c3018$var$mapTag:
            var convert = (0, $f4f39a70fc8835b2$export$2e2bcd8739ae039);
        case $1a45a05db06c3018$var$setTag:
            var isPartial = bitmask & $1a45a05db06c3018$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $47dcdfae940a6696$export$2e2bcd8739ae039));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $1a45a05db06c3018$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $92c54468f4f815dc$export$2e2bcd8739ae039)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $1a45a05db06c3018$var$symbolTag:
            if ($1a45a05db06c3018$var$symbolValueOf) return $1a45a05db06c3018$var$symbolValueOf.call(object) == $1a45a05db06c3018$var$symbolValueOf.call(other);
    }
    return false;
}
var $1a45a05db06c3018$export$2e2bcd8739ae039 = $1a45a05db06c3018$var$equalByTag;



/** Used to compose bitmasks for value comparisons. */ var $49ee07010b3dbd16$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $49ee07010b3dbd16$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $49ee07010b3dbd16$var$hasOwnProperty = $49ee07010b3dbd16$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $49ee07010b3dbd16$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $49ee07010b3dbd16$var$COMPARE_PARTIAL_FLAG, objProps = (0, $3c06b2f92a5e2346$export$2e2bcd8739ae039)(object), objLength = objProps.length, othProps = (0, $3c06b2f92a5e2346$export$2e2bcd8739ae039)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $49ee07010b3dbd16$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
var $49ee07010b3dbd16$export$2e2bcd8739ae039 = $49ee07010b3dbd16$var$equalObjects;





var $42CIw = parcelRequire("42CIw");

/** Used to compose bitmasks for value comparisons. */ var $da6461fd5d3501ef$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $da6461fd5d3501ef$var$argsTag = "[object Arguments]", $da6461fd5d3501ef$var$arrayTag = "[object Array]", $da6461fd5d3501ef$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $da6461fd5d3501ef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $da6461fd5d3501ef$var$hasOwnProperty = $da6461fd5d3501ef$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $da6461fd5d3501ef$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $93b249752024ad0a$export$2e2bcd8739ae039)(object), othIsArr = (0, $93b249752024ad0a$export$2e2bcd8739ae039)(other), objTag = objIsArr ? $da6461fd5d3501ef$var$arrayTag : (0, $77ed2e44816ca23c$export$2e2bcd8739ae039)(object), othTag = othIsArr ? $da6461fd5d3501ef$var$arrayTag : (0, $77ed2e44816ca23c$export$2e2bcd8739ae039)(other);
    objTag = objTag == $da6461fd5d3501ef$var$argsTag ? $da6461fd5d3501ef$var$objectTag : objTag;
    othTag = othTag == $da6461fd5d3501ef$var$argsTag ? $da6461fd5d3501ef$var$objectTag : othTag;
    var objIsObj = objTag == $da6461fd5d3501ef$var$objectTag, othIsObj = othTag == $da6461fd5d3501ef$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $42CIw.default)(object)) {
        if (!(0, $42CIw.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $dec20d54409d2f2d$export$2e2bcd8739ae039));
        return objIsArr || (0, $36b8ee2290529be7$export$2e2bcd8739ae039)(object) ? (0, $92c54468f4f815dc$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack) : (0, $1a45a05db06c3018$export$2e2bcd8739ae039)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $da6461fd5d3501ef$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $da6461fd5d3501ef$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $da6461fd5d3501ef$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $dec20d54409d2f2d$export$2e2bcd8739ae039));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $dec20d54409d2f2d$export$2e2bcd8739ae039));
    return (0, $49ee07010b3dbd16$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack);
}
var $da6461fd5d3501ef$export$2e2bcd8739ae039 = $da6461fd5d3501ef$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $2d8e8f59f9cdb8b2$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $4757a366dbe9cf5c$export$2e2bcd8739ae039)(value) && !(0, $4757a366dbe9cf5c$export$2e2bcd8739ae039)(other)) return value !== value && other !== other;
    return (0, $da6461fd5d3501ef$export$2e2bcd8739ae039)(value, other, bitmask, customizer, $2d8e8f59f9cdb8b2$var$baseIsEqual, stack);
}
var $2d8e8f59f9cdb8b2$export$2e2bcd8739ae039 = $2d8e8f59f9cdb8b2$var$baseIsEqual;


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $bb412d2abfa43c6c$var$isEqual(value, other) {
    return (0, $2d8e8f59f9cdb8b2$export$2e2bcd8739ae039)(value, other);
}
var $bb412d2abfa43c6c$export$2e2bcd8739ae039 = $bb412d2abfa43c6c$var$isEqual;





var $97zcJ = parcelRequire("97zcJ");



class $aac85a10314b6a4e$var$Break extends (0, $8324d048851d53b4$export$297a1fa96f55f00f) {
    static value() {
        return undefined;
    }
    optimize() {
        if (this.prev || this.next) this.remove();
    }
    length() {
        return 0;
    }
    value() {
        return "";
    }
}
$aac85a10314b6a4e$var$Break.blotName = "break";
$aac85a10314b6a4e$var$Break.tagName = "BR";
var $aac85a10314b6a4e$export$2e2bcd8739ae039 = $aac85a10314b6a4e$var$Break;



var $97zcJ = parcelRequire("97zcJ");



class $44fdb97bacc13d2d$export$2e2bcd8739ae039 extends (0, $8324d048851d53b4$export$10ac0c5716409de6) {
}
// https://lodash.com/docs#escape
const $44fdb97bacc13d2d$var$entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
function $44fdb97bacc13d2d$export$96e6fc3a139b2555(text) {
    return text.replace(/[&<>"']/g, (s)=>$44fdb97bacc13d2d$var$entityMap[s]);
}


class $fd4ff9e1d56c8673$var$Inline extends (0, $8324d048851d53b4$export$f67a34bc25a7a861) {
    static compare(self, other) {
        const selfIndex = $fd4ff9e1d56c8673$var$Inline.order.indexOf(self);
        const otherIndex = $fd4ff9e1d56c8673$var$Inline.order.indexOf(other);
        if (selfIndex >= 0 || otherIndex >= 0) return selfIndex - otherIndex;
        if (self === other) return 0;
        if (self < other) return -1;
        return 1;
    }
    formatAt(index, length, name, value) {
        if ($fd4ff9e1d56c8673$var$Inline.compare(this.statics.blotName, name) < 0 && this.scroll.query(name, (0, $8324d048851d53b4$export$775b6bb06e53a214).BLOT)) {
            const blot = this.isolate(index, length);
            if (value) blot.wrap(name, value);
        } else super.formatAt(index, length, name, value);
    }
    optimize(context) {
        super.optimize(context);
        if (this.parent instanceof $fd4ff9e1d56c8673$var$Inline && $fd4ff9e1d56c8673$var$Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
            const parent = this.parent.isolate(this.offset(), this.length());
            // @ts-expect-error TODO: make isolate generic
            this.moveChildren(parent);
            parent.wrap(this);
        }
    }
}
(0, $97zcJ._)($fd4ff9e1d56c8673$var$Inline, "allowedChildren", [
    $fd4ff9e1d56c8673$var$Inline,
    (0, $aac85a10314b6a4e$export$2e2bcd8739ae039),
    (0, $8324d048851d53b4$export$297a1fa96f55f00f),
    (0, $44fdb97bacc13d2d$export$2e2bcd8739ae039)
]);
// Lower index means deeper in the DOM tree, since not found (-1) is for embeds
(0, $97zcJ._)($fd4ff9e1d56c8673$var$Inline, "order", [
    "cursor",
    "inline",
    // Must be lower
    "link",
    // Chrome wants <a> to be lower
    "underline",
    "strike",
    "italic",
    "bold",
    "script",
    "code" // Must be higher
]);
var $fd4ff9e1d56c8673$export$2e2bcd8739ae039 = $fd4ff9e1d56c8673$var$Inline;



const $421348c10218bc50$var$NEWLINE_LENGTH = 1;
class $421348c10218bc50$export$2e2bcd8739ae039 extends (0, $8324d048851d53b4$export$4f7f03641f7bfc8c) {
    delta() {
        if (this.cache.delta == null) this.cache.delta = $421348c10218bc50$export$992ff47219af5a2b(this);
        return this.cache.delta;
    }
    deleteAt(index, length) {
        super.deleteAt(index, length);
        this.cache = {};
    }
    formatAt(index, length, name, value) {
        if (length <= 0) return;
        if (this.scroll.query(name, (0, $8324d048851d53b4$export$775b6bb06e53a214).BLOCK)) {
            if (index + length === this.length()) this.format(name, value);
        } else super.formatAt(index, Math.min(length, this.length() - index - 1), name, value);
        this.cache = {};
    }
    insertAt(index, value, def) {
        if (def != null) {
            super.insertAt(index, value, def);
            this.cache = {};
            return;
        }
        if (value.length === 0) return;
        const lines = value.split("\n");
        const text = lines.shift();
        if (text.length > 0) {
            if (index < this.length() - 1 || this.children.tail == null) super.insertAt(Math.min(index, this.length() - 1), text);
            else this.children.tail.insertAt(this.children.tail.length(), text);
            this.cache = {};
        }
        // TODO: Fix this next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let block = this;
        lines.reduce((lineIndex, line)=>{
            // @ts-expect-error Fix me later
            block = block.split(lineIndex, true);
            block.insertAt(0, line);
            return line.length;
        }, index + text.length);
    }
    insertBefore(blot, ref) {
        const { head: head } = this.children;
        super.insertBefore(blot, ref);
        if (head instanceof (0, $aac85a10314b6a4e$export$2e2bcd8739ae039)) head.remove();
        this.cache = {};
    }
    length() {
        if (this.cache.length == null) this.cache.length = super.length() + $421348c10218bc50$var$NEWLINE_LENGTH;
        return this.cache.length;
    }
    moveChildren(target, ref) {
        super.moveChildren(target, ref);
        this.cache = {};
    }
    optimize(context) {
        super.optimize(context);
        this.cache = {};
    }
    path(index) {
        return super.path(index, true);
    }
    removeChild(child) {
        super.removeChild(child);
        this.cache = {};
    }
    split(index) {
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (force && (index === 0 || index >= this.length() - $421348c10218bc50$var$NEWLINE_LENGTH)) {
            const clone = this.clone();
            if (index === 0) {
                this.parent.insertBefore(clone, this);
                return this;
            }
            this.parent.insertBefore(clone, this.next);
            return clone;
        }
        const next = super.split(index, force);
        this.cache = {};
        return next;
    }
    constructor(...args){
        super(...args);
        (0, $97zcJ._)(this, "cache", {});
    }
}
$421348c10218bc50$export$2e2bcd8739ae039.blotName = "block";
$421348c10218bc50$export$2e2bcd8739ae039.tagName = "P";
$421348c10218bc50$export$2e2bcd8739ae039.defaultChild = (0, $aac85a10314b6a4e$export$2e2bcd8739ae039);
$421348c10218bc50$export$2e2bcd8739ae039.allowedChildren = [
    (0, $aac85a10314b6a4e$export$2e2bcd8739ae039),
    (0, $fd4ff9e1d56c8673$export$2e2bcd8739ae039),
    (0, $8324d048851d53b4$export$297a1fa96f55f00f),
    (0, $44fdb97bacc13d2d$export$2e2bcd8739ae039)
];
class $421348c10218bc50$export$48b9f0688962d028 extends (0, $8324d048851d53b4$export$297a1fa96f55f00f) {
    attach() {
        super.attach();
        this.attributes = new (0, $8324d048851d53b4$export$68ad86ab95e8de42)(this.domNode);
    }
    delta() {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().insert(this.value(), {
            ...this.formats(),
            ...this.attributes.values()
        });
    }
    format(name, value) {
        const attribute = this.scroll.query(name, (0, $8324d048851d53b4$export$775b6bb06e53a214).BLOCK_ATTRIBUTE);
        if (attribute != null) // @ts-expect-error TODO: Scroll#query() should return Attributor when scope is attribute
        this.attributes.attribute(attribute, value);
    }
    formatAt(index, length, name, value) {
        this.format(name, value);
    }
    insertAt(index, value, def) {
        if (def != null) {
            super.insertAt(index, value, def);
            return;
        }
        const lines = value.split("\n");
        const text = lines.pop();
        const blocks = lines.map((line)=>{
            const block = this.scroll.create($421348c10218bc50$export$2e2bcd8739ae039.blotName);
            block.insertAt(0, line);
            return block;
        });
        const ref = this.split(index);
        blocks.forEach((block)=>{
            this.parent.insertBefore(block, ref);
        });
        if (text) this.parent.insertBefore(this.scroll.create("text", text), ref);
    }
}
$421348c10218bc50$export$48b9f0688962d028.scope = (0, $8324d048851d53b4$export$775b6bb06e53a214).BLOCK_BLOT;
// It is important for cursor behavior BlockEmbeds use tags that are block level elements
function $421348c10218bc50$export$992ff47219af5a2b(blot) {
    let filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return blot.descendants((0, $8324d048851d53b4$export$7420b9c542181544)).reduce((delta, leaf)=>{
        if (leaf.length() === 0) return delta;
        return delta.insert(leaf.value(), $421348c10218bc50$export$e4bb5a6163449612(leaf, {}, filter));
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))()).insert("\n", $421348c10218bc50$export$e4bb5a6163449612(blot));
}
function $421348c10218bc50$export$e4bb5a6163449612(blot) {
    let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (blot == null) return formats;
    if ("formats" in blot && typeof blot.formats === "function") {
        formats = {
            ...formats,
            ...blot.formats()
        };
        if (filter) // exclude syntax highlighting from deltas and getFormat()
        delete formats["code-token"];
    }
    if (blot.parent == null || blot.parent.statics.blotName === "scroll" || blot.parent.statics.scope !== blot.statics.scope) return formats;
    return $421348c10218bc50$export$e4bb5a6163449612(blot.parent, formats, filter);
}




var $97zcJ = parcelRequire("97zcJ");


class $ff66e5de053048df$var$Cursor extends (0, $8324d048851d53b4$export$297a1fa96f55f00f) {
    static value() {
        return undefined;
    }
    detach() {
        // super.detach() will also clear domNode.__blot
        if (this.parent != null) this.parent.removeChild(this);
    }
    format(name, value) {
        if (this.savedLength !== 0) {
            super.format(name, value);
            return;
        }
        // TODO: Fix this next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let target = this;
        let index = 0;
        while(target != null && target.statics.scope !== (0, $8324d048851d53b4$export$775b6bb06e53a214).BLOCK_BLOT){
            index += target.offset(target.parent);
            target = target.parent;
        }
        if (target != null) {
            this.savedLength = $ff66e5de053048df$var$Cursor.CONTENTS.length;
            // @ts-expect-error TODO: allow empty context in Parchment
            target.optimize();
            target.formatAt(index, $ff66e5de053048df$var$Cursor.CONTENTS.length, name, value);
            this.savedLength = 0;
        }
    }
    index(node, offset) {
        if (node === this.textNode) return 0;
        return super.index(node, offset);
    }
    length() {
        return this.savedLength;
    }
    position() {
        return [
            this.textNode,
            this.textNode.data.length
        ];
    }
    remove() {
        super.remove();
        // @ts-expect-error Fix me later
        this.parent = null;
    }
    restore() {
        if (this.selection.composing || this.parent == null) return null;
        const range = this.selection.getNativeRange();
        // Browser may push down styles/nodes inside the cursor blot.
        // https://dvcs.w3.org/hg/editing/raw-file/tip/editing.html#push-down-values
        while(this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode)// @ts-expect-error Fix me later
        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
        const prevTextBlot = this.prev instanceof (0, $44fdb97bacc13d2d$export$2e2bcd8739ae039) ? this.prev : null;
        const prevTextLength = prevTextBlot ? prevTextBlot.length() : 0;
        const nextTextBlot = this.next instanceof (0, $44fdb97bacc13d2d$export$2e2bcd8739ae039) ? this.next : null;
        // @ts-expect-error TODO: make TextBlot.text public
        const nextText = nextTextBlot ? nextTextBlot.text : "";
        const { textNode: textNode } = this;
        // take text from inside this blot and reset it
        const newText = textNode.data.split($ff66e5de053048df$var$Cursor.CONTENTS).join("");
        textNode.data = $ff66e5de053048df$var$Cursor.CONTENTS;
        // proactively merge TextBlots around cursor so that optimization
        // doesn't lose the cursor.  the reason we are here in cursor.restore
        // could be that the user clicked in prevTextBlot or nextTextBlot, or
        // the user typed something.
        let mergedTextBlot;
        if (prevTextBlot) {
            mergedTextBlot = prevTextBlot;
            if (newText || nextTextBlot) {
                prevTextBlot.insertAt(prevTextBlot.length(), newText + nextText);
                if (nextTextBlot) nextTextBlot.remove();
            }
        } else if (nextTextBlot) {
            mergedTextBlot = nextTextBlot;
            nextTextBlot.insertAt(0, newText);
        } else {
            const newTextNode = document.createTextNode(newText);
            mergedTextBlot = this.scroll.create(newTextNode);
            this.parent.insertBefore(mergedTextBlot, this);
        }
        this.remove();
        if (range) {
            // calculate selection to restore
            const remapOffset = (node, offset)=>{
                if (prevTextBlot && node === prevTextBlot.domNode) return offset;
                if (node === textNode) return prevTextLength + offset - 1;
                if (nextTextBlot && node === nextTextBlot.domNode) return prevTextLength + newText.length + offset;
                return null;
            };
            const start = remapOffset(range.start.node, range.start.offset);
            const end = remapOffset(range.end.node, range.end.offset);
            if (start !== null && end !== null) return {
                startNode: mergedTextBlot.domNode,
                startOffset: start,
                endNode: mergedTextBlot.domNode,
                endOffset: end
            };
        }
        return null;
    }
    update(mutations, context) {
        if (mutations.some((mutation)=>{
            return mutation.type === "characterData" && mutation.target === this.textNode;
        })) {
            const range = this.restore();
            if (range) context.range = range;
        }
    }
    // Avoid .ql-cursor being a descendant of `<a/>`.
    // The reason is Safari pushes down `<a/>` on text insertion.
    // That will cause DOM nodes not sync with the model.
    //
    // For example ({I} is the caret), given the markup:
    //    <a><span class="ql-cursor">\uFEFF{I}</span></a>
    // When typing a char "x", `<a/>` will be pushed down inside the `<span>` first:
    //    <span class="ql-cursor"><a>\uFEFF{I}</a></span>
    // And then "x" will be inserted after `<a/>`:
    //    <span class="ql-cursor"><a>\uFEFF</a>d{I}</span>
    optimize(context) {
        // @ts-expect-error Fix me later
        super.optimize(context);
        let { parent: parent } = this;
        while(parent){
            if (parent.domNode.tagName === "A") {
                this.savedLength = $ff66e5de053048df$var$Cursor.CONTENTS.length;
                // @ts-expect-error TODO: make isolate generic
                parent.isolate(this.offset(parent), this.length()).unwrap();
                this.savedLength = 0;
                break;
            }
            parent = parent.parent;
        }
    }
    value() {
        return "";
    }
    constructor(scroll, domNode, selection){
        super(scroll, domNode);
        this.selection = selection;
        this.textNode = document.createTextNode($ff66e5de053048df$var$Cursor.CONTENTS);
        this.domNode.appendChild(this.textNode);
        this.savedLength = 0;
    }
}
(0, $97zcJ._)($ff66e5de053048df$var$Cursor, "blotName", "cursor");
(0, $97zcJ._)($ff66e5de053048df$var$Cursor, "className", "ql-cursor");
(0, $97zcJ._)($ff66e5de053048df$var$Cursor, "tagName", "span");
(0, $97zcJ._)($ff66e5de053048df$var$Cursor, "CONTENTS", "\uFEFF") // Zero width no break space
;
var $ff66e5de053048df$export$2e2bcd8739ae039 = $ff66e5de053048df$var$Cursor;






var $97zcJ = parcelRequire("97zcJ");
var $372e6e9c4767d079$exports = {};
"use strict";
var $372e6e9c4767d079$var$has = Object.prototype.hasOwnProperty, $372e6e9c4767d079$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $372e6e9c4767d079$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $372e6e9c4767d079$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $372e6e9c4767d079$var$Events().__proto__) $372e6e9c4767d079$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $372e6e9c4767d079$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $372e6e9c4767d079$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $372e6e9c4767d079$var$EE(fn, context || emitter, once), evt = $372e6e9c4767d079$var$prefix ? $372e6e9c4767d079$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $372e6e9c4767d079$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $372e6e9c4767d079$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $372e6e9c4767d079$var$EventEmitter() {
    this._events = new $372e6e9c4767d079$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $372e6e9c4767d079$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($372e6e9c4767d079$var$has.call(events, name)) names.push($372e6e9c4767d079$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $372e6e9c4767d079$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $372e6e9c4767d079$var$prefix ? $372e6e9c4767d079$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $372e6e9c4767d079$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $372e6e9c4767d079$var$prefix ? $372e6e9c4767d079$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $372e6e9c4767d079$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $372e6e9c4767d079$var$prefix ? $372e6e9c4767d079$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $372e6e9c4767d079$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $372e6e9c4767d079$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $372e6e9c4767d079$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $372e6e9c4767d079$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $372e6e9c4767d079$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $372e6e9c4767d079$var$prefix ? $372e6e9c4767d079$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $372e6e9c4767d079$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $372e6e9c4767d079$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $372e6e9c4767d079$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $372e6e9c4767d079$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $372e6e9c4767d079$var$prefix ? $372e6e9c4767d079$var$prefix + event : event;
        if (this._events[evt]) $372e6e9c4767d079$var$clearEvent(this, evt);
    } else {
        this._events = new $372e6e9c4767d079$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$372e6e9c4767d079$var$EventEmitter.prototype.off = $372e6e9c4767d079$var$EventEmitter.prototype.removeListener;
$372e6e9c4767d079$var$EventEmitter.prototype.addListener = $372e6e9c4767d079$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$372e6e9c4767d079$var$EventEmitter.prefixed = $372e6e9c4767d079$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$372e6e9c4767d079$var$EventEmitter.EventEmitter = $372e6e9c4767d079$var$EventEmitter;
$372e6e9c4767d079$exports = $372e6e9c4767d079$var$EventEmitter;


var $8cc91e4bad1af9de$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($372e6e9c4767d079$exports)));


var $88e1fb7104a935c6$export$2e2bcd8739ae039 = new WeakMap();


const $8673b628d4423f23$var$levels = [
    "error",
    "warn",
    "log",
    "info"
];
let $8673b628d4423f23$var$level = "warn";
function $8673b628d4423f23$var$debug(method) {
    if ($8673b628d4423f23$var$level) {
        if ($8673b628d4423f23$var$levels.indexOf(method) <= $8673b628d4423f23$var$levels.indexOf($8673b628d4423f23$var$level)) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            console[method](...args); // eslint-disable-line no-console
        }
    }
}
function $8673b628d4423f23$var$namespace(ns) {
    return $8673b628d4423f23$var$levels.reduce((logger, method)=>{
        logger[method] = $8673b628d4423f23$var$debug.bind(console, method, ns);
        return logger;
    }, {});
}
$8673b628d4423f23$var$namespace.level = (newLevel)=>{
    $8673b628d4423f23$var$level = newLevel;
};
$8673b628d4423f23$var$debug.level = $8673b628d4423f23$var$namespace.level;
var $8673b628d4423f23$export$2e2bcd8739ae039 = $8673b628d4423f23$var$namespace;


const $6c311a36f0b35611$var$debug = (0, $8673b628d4423f23$export$2e2bcd8739ae039)("quill:events");
const $6c311a36f0b35611$var$EVENTS = [
    "selectionchange",
    "mousedown",
    "mouseup",
    "click"
];
$6c311a36f0b35611$var$EVENTS.forEach((eventName)=>{
    document.addEventListener(eventName, function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        Array.from(document.querySelectorAll(".ql-container")).forEach((node)=>{
            const quill = (0, $88e1fb7104a935c6$export$2e2bcd8739ae039).get(node);
            if (quill && quill.emitter) quill.emitter.handleDOM(...args);
        });
    });
});
class $6c311a36f0b35611$var$Emitter extends (0, (/*@__PURE__*/$parcel$interopDefault($372e6e9c4767d079$exports))) {
    emit() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $6c311a36f0b35611$var$debug.log.call($6c311a36f0b35611$var$debug, ...args);
        // @ts-expect-error
        return super.emit(...args);
    }
    handleDOM(event) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        (this.domListeners[event.type] || []).forEach((_ref)=>{
            let { node: node, handler: handler } = _ref;
            if (event.target === node || node.contains(event.target)) handler(event, ...args);
        });
    }
    listenDOM(eventName, node, handler) {
        if (!this.domListeners[eventName]) this.domListeners[eventName] = [];
        this.domListeners[eventName].push({
            node: node,
            handler: handler
        });
    }
    constructor(){
        super();
        this.domListeners = {};
        this.on("error", $6c311a36f0b35611$var$debug.error);
    }
}
(0, $97zcJ._)($6c311a36f0b35611$var$Emitter, "events", {
    EDITOR_CHANGE: "editor-change",
    SCROLL_BEFORE_UPDATE: "scroll-before-update",
    SCROLL_BLOT_MOUNT: "scroll-blot-mount",
    SCROLL_BLOT_UNMOUNT: "scroll-blot-unmount",
    SCROLL_OPTIMIZE: "scroll-optimize",
    SCROLL_UPDATE: "scroll-update",
    SCROLL_EMBED_UPDATE: "scroll-embed-update",
    SELECTION_CHANGE: "selection-change",
    TEXT_CHANGE: "text-change",
    COMPOSITION_BEFORE_START: "composition-before-start",
    COMPOSITION_START: "composition-start",
    COMPOSITION_BEFORE_END: "composition-before-end",
    COMPOSITION_END: "composition-end"
});
(0, $97zcJ._)($6c311a36f0b35611$var$Emitter, "sources", {
    API: "api",
    SILENT: "silent",
    USER: "user"
});
var $6c311a36f0b35611$export$2e2bcd8739ae039 = $6c311a36f0b35611$var$Emitter;



const $df4239af590079e1$var$debug = (0, $8673b628d4423f23$export$2e2bcd8739ae039)("quill:selection");
class $df4239af590079e1$export$9a58ef0d7ad3278c {
    constructor(index){
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        this.index = index;
        this.length = length;
    }
}
class $df4239af590079e1$var$Selection {
    handleComposition() {
        this.emitter.on((0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.COMPOSITION_BEFORE_START, ()=>{
            this.composing = true;
        });
        this.emitter.on((0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.COMPOSITION_END, ()=>{
            this.composing = false;
            if (this.cursor.parent) {
                const range = this.cursor.restore();
                if (!range) return;
                setTimeout(()=>{
                    this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
                }, 1);
            }
        });
    }
    handleDragging() {
        this.emitter.listenDOM("mousedown", document.body, ()=>{
            this.mouseDown = true;
        });
        this.emitter.listenDOM("mouseup", document.body, ()=>{
            this.mouseDown = false;
            this.update((0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.USER);
        });
    }
    focus() {
        if (this.hasFocus()) return;
        this.root.focus({
            preventScroll: true
        });
        this.setRange(this.savedRange);
    }
    format(format, value) {
        this.scroll.update();
        const nativeRange = this.getNativeRange();
        if (nativeRange == null || !nativeRange.native.collapsed || this.scroll.query(format, (0, $8324d048851d53b4$export$775b6bb06e53a214).BLOCK)) return;
        if (nativeRange.start.node !== this.cursor.textNode) {
            const blot = this.scroll.find(nativeRange.start.node, false);
            if (blot == null) return;
            // TODO Give blot ability to not split
            if (blot instanceof (0, $8324d048851d53b4$export$7420b9c542181544)) {
                const after = blot.split(nativeRange.start.offset);
                blot.parent.insertBefore(this.cursor, after);
            } else // @ts-expect-error TODO: nativeRange.start.node doesn't seem to match function signature
            blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
            this.cursor.attach();
        }
        this.cursor.format(format, value);
        this.scroll.optimize();
        this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
        this.update();
    }
    getBounds(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        const scrollLength = this.scroll.length();
        index = Math.min(index, scrollLength - 1);
        length = Math.min(index + length, scrollLength - 1) - index;
        let node;
        let [leaf, offset] = this.scroll.leaf(index);
        if (leaf == null) return null;
        if (length > 0 && offset === leaf.length()) {
            const [next] = this.scroll.leaf(index + 1);
            if (next) {
                const [line] = this.scroll.line(index);
                const [nextLine] = this.scroll.line(index + 1);
                if (line === nextLine) {
                    leaf = next;
                    offset = 0;
                }
            }
        }
        [node, offset] = leaf.position(offset, true);
        const range = document.createRange();
        if (length > 0) {
            range.setStart(node, offset);
            [leaf, offset] = this.scroll.leaf(index + length);
            if (leaf == null) return null;
            [node, offset] = leaf.position(offset, true);
            range.setEnd(node, offset);
            return range.getBoundingClientRect();
        }
        let side = "left";
        let rect;
        if (node instanceof Text) {
            // Return null if the text node is empty because it is
            // not able to get a useful client rect:
            // https://github.com/w3c/csswg-drafts/issues/2514.
            // Empty text nodes are most likely caused by TextBlot#optimize()
            // not getting called when editor content changes.
            if (!node.data.length) return null;
            if (offset < node.data.length) {
                range.setStart(node, offset);
                range.setEnd(node, offset + 1);
            } else {
                range.setStart(node, offset - 1);
                range.setEnd(node, offset);
                side = "right";
            }
            rect = range.getBoundingClientRect();
        } else {
            if (!(leaf.domNode instanceof Element)) return null;
            rect = leaf.domNode.getBoundingClientRect();
            if (offset > 0) side = "right";
        }
        return {
            bottom: rect.top + rect.height,
            height: rect.height,
            left: rect[side],
            right: rect[side],
            top: rect.top,
            width: 0
        };
    }
    getNativeRange() {
        const selection = document.getSelection();
        if (selection == null || selection.rangeCount <= 0) return null;
        const nativeRange = selection.getRangeAt(0);
        if (nativeRange == null) return null;
        const range = this.normalizeNative(nativeRange);
        $df4239af590079e1$var$debug.info("getNativeRange", range);
        return range;
    }
    getRange() {
        const root = this.scroll.domNode;
        if ("isConnected" in root && !root.isConnected) // document.getSelection() forces layout on Blink, so we trend to
        // not calling it.
        return [
            null,
            null
        ];
        const normalized = this.getNativeRange();
        if (normalized == null) return [
            null,
            null
        ];
        const range = this.normalizedToRange(normalized);
        return [
            range,
            normalized
        ];
    }
    hasFocus() {
        return document.activeElement === this.root || document.activeElement != null && $df4239af590079e1$var$contains(this.root, document.activeElement);
    }
    normalizedToRange(range) {
        const positions = [
            [
                range.start.node,
                range.start.offset
            ]
        ];
        if (!range.native.collapsed) positions.push([
            range.end.node,
            range.end.offset
        ]);
        const indexes = positions.map((position)=>{
            const [node, offset] = position;
            const blot = this.scroll.find(node, true);
            // @ts-expect-error Fix me later
            const index = blot.offset(this.scroll);
            if (offset === 0) return index;
            if (blot instanceof (0, $8324d048851d53b4$export$7420b9c542181544)) return index + blot.index(node, offset);
            // @ts-expect-error Fix me later
            return index + blot.length();
        });
        const end = Math.min(Math.max(...indexes), this.scroll.length() - 1);
        const start = Math.min(end, ...indexes);
        return new $df4239af590079e1$export$9a58ef0d7ad3278c(start, end - start);
    }
    normalizeNative(nativeRange) {
        if (!$df4239af590079e1$var$contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !$df4239af590079e1$var$contains(this.root, nativeRange.endContainer)) return null;
        const range = {
            start: {
                node: nativeRange.startContainer,
                offset: nativeRange.startOffset
            },
            end: {
                node: nativeRange.endContainer,
                offset: nativeRange.endOffset
            },
            native: nativeRange
        };
        [
            range.start,
            range.end
        ].forEach((position)=>{
            let { node: node, offset: offset } = position;
            while(!(node instanceof Text) && node.childNodes.length > 0){
                if (node.childNodes.length > offset) {
                    node = node.childNodes[offset];
                    offset = 0;
                } else if (node.childNodes.length === offset) {
                    // @ts-expect-error Fix me later
                    node = node.lastChild;
                    if (node instanceof Text) offset = node.data.length;
                    else if (node.childNodes.length > 0) // Container case
                    offset = node.childNodes.length;
                    else // Embed case
                    offset = node.childNodes.length + 1;
                } else break;
            }
            position.node = node;
            position.offset = offset;
        });
        return range;
    }
    rangeToNative(range) {
        const scrollLength = this.scroll.length();
        const getPosition = (index, inclusive)=>{
            index = Math.min(scrollLength - 1, index);
            const [leaf, leafOffset] = this.scroll.leaf(index);
            return leaf ? leaf.position(leafOffset, inclusive) : [
                null,
                -1
            ];
        };
        return [
            ...getPosition(range.index, false),
            ...getPosition(range.index + range.length, true)
        ];
    }
    setNativeRange(startNode, startOffset) {
        let endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
        let endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
        let force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        $df4239af590079e1$var$debug.info("setNativeRange", startNode, startOffset, endNode, endOffset);
        if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || // @ts-expect-error Fix me later
        endNode.parentNode == null)) return;
        const selection = document.getSelection();
        if (selection == null) return;
        if (startNode != null) {
            if (!this.hasFocus()) this.root.focus({
                preventScroll: true
            });
            const { native: native } = this.getNativeRange() || {};
            if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
                if (startNode instanceof Element && startNode.tagName === "BR") {
                    // @ts-expect-error Fix me later
                    startOffset = Array.from(startNode.parentNode.childNodes).indexOf(startNode);
                    startNode = startNode.parentNode;
                }
                if (endNode instanceof Element && endNode.tagName === "BR") {
                    // @ts-expect-error Fix me later
                    endOffset = Array.from(endNode.parentNode.childNodes).indexOf(endNode);
                    endNode = endNode.parentNode;
                }
                const range = document.createRange();
                // @ts-expect-error Fix me later
                range.setStart(startNode, startOffset);
                // @ts-expect-error Fix me later
                range.setEnd(endNode, endOffset);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        } else {
            selection.removeAllRanges();
            this.root.blur();
        }
    }
    setRange(range) {
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.API;
        if (typeof force === "string") {
            source = force;
            force = false;
        }
        $df4239af590079e1$var$debug.info("setRange", range);
        if (range != null) {
            const args = this.rangeToNative(range);
            this.setNativeRange(...args, force);
        } else this.setNativeRange(null);
        this.update(source);
    }
    update() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.USER;
        const oldRange = this.lastRange;
        const [lastRange, nativeRange] = this.getRange();
        this.lastRange = lastRange;
        this.lastNative = nativeRange;
        if (this.lastRange != null) this.savedRange = this.lastRange;
        if (!(0, $bb412d2abfa43c6c$export$2e2bcd8739ae039)(oldRange, this.lastRange)) {
            if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
                const range = this.cursor.restore();
                if (range) this.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
            }
            const args = [
                (0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.SELECTION_CHANGE,
                (0, $668add1f662a6818$export$2e2bcd8739ae039)(this.lastRange),
                (0, $668add1f662a6818$export$2e2bcd8739ae039)(oldRange),
                source
            ];
            this.emitter.emit((0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.EDITOR_CHANGE, ...args);
            if (source !== (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.SILENT) this.emitter.emit(...args);
        }
    }
    constructor(scroll, emitter){
        this.emitter = emitter;
        this.scroll = scroll;
        this.composing = false;
        this.mouseDown = false;
        this.root = this.scroll.domNode;
        // @ts-expect-error
        this.cursor = this.scroll.create("cursor", this);
        // savedRange is last non-null range
        this.savedRange = new $df4239af590079e1$export$9a58ef0d7ad3278c(0, 0);
        this.lastRange = this.savedRange;
        this.lastNative = null;
        this.handleComposition();
        this.handleDragging();
        this.emitter.listenDOM("selectionchange", document, ()=>{
            if (!this.mouseDown && !this.composing) setTimeout(this.update.bind(this, (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.USER), 1);
        });
        this.emitter.on((0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.SCROLL_BEFORE_UPDATE, ()=>{
            if (!this.hasFocus()) return;
            const native = this.getNativeRange();
            if (native == null) return;
            if (native.start.node === this.cursor.textNode) return; // cursor.restore() will handle
            this.emitter.once((0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.SCROLL_UPDATE, (source, mutations)=>{
                try {
                    if (this.root.contains(native.start.node) && this.root.contains(native.end.node)) this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
                    const triggeredByTyping = mutations.some((mutation)=>mutation.type === "characterData" || mutation.type === "childList" || mutation.type === "attributes" && mutation.target === this.root);
                    this.update(triggeredByTyping ? (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.SILENT : source);
                } catch (ignored) {
                // ignore
                }
            });
        });
        this.emitter.on((0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, (mutations, context)=>{
            if (context.range) {
                const { startNode: startNode, startOffset: startOffset, endNode: endNode, endOffset: endOffset } = context.range;
                this.setNativeRange(startNode, startOffset, endNode, endOffset);
                this.update((0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.SILENT);
            }
        });
        this.update((0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.SILENT);
    }
}
function $df4239af590079e1$var$contains(parent, descendant) {
    try {
        // Firefox inserts inaccessible nodes around video elements
        descendant.parentNode; // eslint-disable-line @typescript-eslint/no-unused-expressions
    } catch (e) {
        return false;
    }
    return parent.contains(descendant);
}
var $df4239af590079e1$export$2e2bcd8739ae039 = $df4239af590079e1$var$Selection;


const $8266d55eb96b041c$var$ASCII = /^[ -~]*$/;
class $8266d55eb96b041c$var$Editor {
    applyDelta(delta) {
        this.scroll.update();
        let scrollLength = this.scroll.length();
        this.scroll.batchStart();
        const normalizedDelta = $8266d55eb96b041c$var$normalizeDelta(delta);
        const deleteDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))();
        const normalizedOps = $8266d55eb96b041c$var$splitOpLines(normalizedDelta.ops.slice());
        normalizedOps.reduce((index, op)=>{
            const length = (0, $f5af2faee6afab08$exports.Op).length(op);
            let attributes = op.attributes || {};
            let isImplicitNewlinePrepended = false;
            let isImplicitNewlineAppended = false;
            if (op.insert != null) {
                deleteDelta.retain(length);
                if (typeof op.insert === "string") {
                    const text = op.insert;
                    isImplicitNewlineAppended = !text.endsWith("\n") && (scrollLength <= index || !!this.scroll.descendant((0, $421348c10218bc50$export$48b9f0688962d028), index)[0]);
                    this.scroll.insertAt(index, text);
                    const [line, offset] = this.scroll.line(index);
                    let formats = (0, $47c6e52c26bddb86$export$2e2bcd8739ae039)({}, (0, $421348c10218bc50$export$e4bb5a6163449612)(line));
                    if (line instanceof (0, $421348c10218bc50$export$2e2bcd8739ae039)) {
                        const [leaf] = line.descendant((0, $8324d048851d53b4$export$7420b9c542181544), offset);
                        if (leaf) formats = (0, $47c6e52c26bddb86$export$2e2bcd8739ae039)(formats, (0, $421348c10218bc50$export$e4bb5a6163449612)(leaf));
                    }
                    attributes = (0, $f5af2faee6afab08$exports.AttributeMap).diff(formats, attributes) || {};
                } else if (typeof op.insert === "object") {
                    const key = Object.keys(op.insert)[0]; // There should only be one key
                    if (key == null) return index;
                    const isInlineEmbed = this.scroll.query(key, (0, $8324d048851d53b4$export$775b6bb06e53a214).INLINE) != null;
                    if (isInlineEmbed) {
                        if (scrollLength <= index || !!this.scroll.descendant((0, $421348c10218bc50$export$48b9f0688962d028), index)[0]) isImplicitNewlineAppended = true;
                    } else if (index > 0) {
                        const [leaf, offset] = this.scroll.descendant((0, $8324d048851d53b4$export$7420b9c542181544), index - 1);
                        if (leaf instanceof (0, $44fdb97bacc13d2d$export$2e2bcd8739ae039)) {
                            const text = leaf.value();
                            if (text[offset] !== "\n") isImplicitNewlinePrepended = true;
                        } else if (leaf instanceof (0, $8324d048851d53b4$export$297a1fa96f55f00f) && leaf.statics.scope === (0, $8324d048851d53b4$export$775b6bb06e53a214).INLINE_BLOT) isImplicitNewlinePrepended = true;
                    }
                    this.scroll.insertAt(index, key, op.insert[key]);
                    if (isInlineEmbed) {
                        const [leaf] = this.scroll.descendant((0, $8324d048851d53b4$export$7420b9c542181544), index);
                        if (leaf) {
                            const formats = (0, $47c6e52c26bddb86$export$2e2bcd8739ae039)({}, (0, $421348c10218bc50$export$e4bb5a6163449612)(leaf));
                            attributes = (0, $f5af2faee6afab08$exports.AttributeMap).diff(formats, attributes) || {};
                        }
                    }
                }
                scrollLength += length;
            } else {
                deleteDelta.push(op);
                if (op.retain !== null && typeof op.retain === "object") {
                    const key = Object.keys(op.retain)[0];
                    if (key == null) return index;
                    this.scroll.updateEmbedAt(index, key, op.retain[key]);
                }
            }
            Object.keys(attributes).forEach((name)=>{
                this.scroll.formatAt(index, length, name, attributes[name]);
            });
            const prependedLength = isImplicitNewlinePrepended ? 1 : 0;
            const addedLength = isImplicitNewlineAppended ? 1 : 0;
            scrollLength += prependedLength + addedLength;
            deleteDelta.retain(prependedLength);
            deleteDelta.delete(addedLength);
            return index + length + prependedLength + addedLength;
        }, 0);
        deleteDelta.reduce((index, op)=>{
            if (typeof op.delete === "number") {
                this.scroll.deleteAt(index, op.delete);
                return index;
            }
            return index + (0, $f5af2faee6afab08$exports.Op).length(op);
        }, 0);
        this.scroll.batchEnd();
        this.scroll.optimize();
        return this.update(normalizedDelta);
    }
    deleteText(index, length) {
        this.scroll.deleteAt(index, length);
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().retain(index).delete(length));
    }
    formatLine(index, length) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.scroll.update();
        Object.keys(formats).forEach((format)=>{
            this.scroll.lines(index, Math.max(length, 1)).forEach((line)=>{
                line.format(format, formats[format]);
            });
        });
        this.scroll.optimize();
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().retain(index).retain(length, (0, $668add1f662a6818$export$2e2bcd8739ae039)(formats));
        return this.update(delta);
    }
    formatText(index, length) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        Object.keys(formats).forEach((format)=>{
            this.scroll.formatAt(index, length, format, formats[format]);
        });
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().retain(index).retain(length, (0, $668add1f662a6818$export$2e2bcd8739ae039)(formats));
        return this.update(delta);
    }
    getContents(index, length) {
        return this.delta.slice(index, index + length);
    }
    getDelta() {
        return this.scroll.lines().reduce((delta, line)=>{
            return delta.concat(line.delta());
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))());
    }
    getFormat(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let lines = [];
        let leaves = [];
        if (length === 0) this.scroll.path(index).forEach((path)=>{
            const [blot] = path;
            if (blot instanceof (0, $421348c10218bc50$export$2e2bcd8739ae039)) lines.push(blot);
            else if (blot instanceof (0, $8324d048851d53b4$export$7420b9c542181544)) leaves.push(blot);
        });
        else {
            lines = this.scroll.lines(index, length);
            leaves = this.scroll.descendants((0, $8324d048851d53b4$export$7420b9c542181544), index, length);
        }
        const [lineFormats, leafFormats] = [
            lines,
            leaves
        ].map((blots)=>{
            const blot = blots.shift();
            if (blot == null) return {};
            let formats = (0, $421348c10218bc50$export$e4bb5a6163449612)(blot);
            while(Object.keys(formats).length > 0){
                const blot = blots.shift();
                if (blot == null) return formats;
                formats = $8266d55eb96b041c$var$combineFormats((0, $421348c10218bc50$export$e4bb5a6163449612)(blot), formats);
            }
            return formats;
        });
        return {
            ...lineFormats,
            ...leafFormats
        };
    }
    getHTML(index, length) {
        const [line, lineOffset] = this.scroll.line(index);
        if (line) {
            const lineLength = line.length();
            const isWithinLine = line.length() >= lineOffset + length;
            if (isWithinLine && !(lineOffset === 0 && length === lineLength)) return $8266d55eb96b041c$var$convertHTML(line, lineOffset, length, true);
            return $8266d55eb96b041c$var$convertHTML(this.scroll, index, length, true);
        }
        return "";
    }
    getText(index, length) {
        return this.getContents(index, length).filter((op)=>typeof op.insert === "string").map((op)=>op.insert).join("");
    }
    insertContents(index, contents) {
        const normalizedDelta = $8266d55eb96b041c$var$normalizeDelta(contents);
        const change = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().retain(index).concat(normalizedDelta);
        this.scroll.insertContents(index, normalizedDelta);
        return this.update(change);
    }
    insertEmbed(index, embed, value) {
        this.scroll.insertAt(index, embed, value);
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().retain(index).insert({
            [embed]: value
        }));
    }
    insertText(index, text) {
        let formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        text = text.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
        this.scroll.insertAt(index, text);
        Object.keys(formats).forEach((format)=>{
            this.scroll.formatAt(index, text.length, format, formats[format]);
        });
        return this.update(new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().retain(index).insert(text, (0, $668add1f662a6818$export$2e2bcd8739ae039)(formats)));
    }
    isBlank() {
        if (this.scroll.children.length === 0) return true;
        if (this.scroll.children.length > 1) return false;
        const blot = this.scroll.children.head;
        if (blot?.statics.blotName !== (0, $421348c10218bc50$export$2e2bcd8739ae039).blotName) return false;
        const block = blot;
        if (block.children.length > 1) return false;
        return block.children.head instanceof (0, $aac85a10314b6a4e$export$2e2bcd8739ae039);
    }
    removeFormat(index, length) {
        const text = this.getText(index, length);
        const [line, offset] = this.scroll.line(index + length);
        let suffixLength = 0;
        let suffix = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))();
        if (line != null) {
            suffixLength = line.length() - offset;
            suffix = line.delta().slice(offset, offset + suffixLength - 1).insert("\n");
        }
        const contents = this.getContents(index, length + suffixLength);
        const diff = contents.diff(new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().insert(text).concat(suffix));
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().retain(index).concat(diff);
        return this.applyDelta(delta);
    }
    update(change) {
        let mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        let selectionInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
        const oldDelta = this.delta;
        if (mutations.length === 1 && mutations[0].type === "characterData" && // @ts-expect-error Fix me later
        mutations[0].target.data.match($8266d55eb96b041c$var$ASCII) && this.scroll.find(mutations[0].target)) {
            // Optimization for character changes
            const textBlot = this.scroll.find(mutations[0].target);
            const formats = (0, $421348c10218bc50$export$e4bb5a6163449612)(textBlot);
            const index = textBlot.offset(this.scroll);
            // @ts-expect-error Fix me later
            const oldValue = mutations[0].oldValue.replace((0, $ff66e5de053048df$export$2e2bcd8739ae039).CONTENTS, "");
            const oldText = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().insert(oldValue);
            // @ts-expect-error
            const newText = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().insert(textBlot.value());
            const relativeSelectionInfo = selectionInfo && {
                oldRange: $8266d55eb96b041c$var$shiftRange(selectionInfo.oldRange, -index),
                newRange: $8266d55eb96b041c$var$shiftRange(selectionInfo.newRange, -index)
            };
            const diffDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().retain(index).concat(oldText.diff(newText, relativeSelectionInfo));
            change = diffDelta.reduce((delta, op)=>{
                if (op.insert) return delta.insert(op.insert, formats);
                return delta.push(op);
            }, new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))());
            this.delta = oldDelta.compose(change);
        } else {
            this.delta = this.getDelta();
            if (!change || !(0, $bb412d2abfa43c6c$export$2e2bcd8739ae039)(oldDelta.compose(change), this.delta)) change = oldDelta.diff(this.delta, selectionInfo);
        }
        return change;
    }
    constructor(scroll){
        this.scroll = scroll;
        this.delta = this.getDelta();
    }
}
function $8266d55eb96b041c$var$convertListHTML(items, lastIndent, types) {
    if (items.length === 0) {
        const [endTag] = $8266d55eb96b041c$var$getListType(types.pop());
        if (lastIndent <= 0) return `</li></${endTag}>`;
        return `</li></${endTag}>${$8266d55eb96b041c$var$convertListHTML([], lastIndent - 1, types)}`;
    }
    const [{ child: child, offset: offset, length: length, indent: indent, type: type }, ...rest] = items;
    const [tag, attribute] = $8266d55eb96b041c$var$getListType(type);
    if (indent > lastIndent) {
        types.push(type);
        if (indent === lastIndent + 1) return `<${tag}><li${attribute}>${$8266d55eb96b041c$var$convertHTML(child, offset, length)}${$8266d55eb96b041c$var$convertListHTML(rest, indent, types)}`;
        return `<${tag}><li>${$8266d55eb96b041c$var$convertListHTML(items, lastIndent + 1, types)}`;
    }
    const previousType = types[types.length - 1];
    if (indent === lastIndent && type === previousType) return `</li><li${attribute}>${$8266d55eb96b041c$var$convertHTML(child, offset, length)}${$8266d55eb96b041c$var$convertListHTML(rest, indent, types)}`;
    const [endTag] = $8266d55eb96b041c$var$getListType(types.pop());
    return `</li></${endTag}>${$8266d55eb96b041c$var$convertListHTML(items, lastIndent - 1, types)}`;
}
function $8266d55eb96b041c$var$convertHTML(blot, index, length) {
    let isRoot = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if ("html" in blot && typeof blot.html === "function") return blot.html(index, length);
    if (blot instanceof (0, $44fdb97bacc13d2d$export$2e2bcd8739ae039)) {
        const escapedText = (0, $44fdb97bacc13d2d$export$96e6fc3a139b2555)(blot.value().slice(index, index + length));
        return escapedText.replaceAll(" ", "&nbsp;");
    }
    if (blot instanceof (0, $8324d048851d53b4$export$e43113f0aad76fe)) {
        // TODO fix API
        if (blot.statics.blotName === "list-container") {
            const items = [];
            blot.children.forEachAt(index, length, (child, offset, childLength)=>{
                const formats = "formats" in child && typeof child.formats === "function" ? child.formats() : {};
                items.push({
                    child: child,
                    offset: offset,
                    length: childLength,
                    indent: formats.indent || 0,
                    type: formats.list
                });
            });
            return $8266d55eb96b041c$var$convertListHTML(items, -1, []);
        }
        const parts = [];
        blot.children.forEachAt(index, length, (child, offset, childLength)=>{
            parts.push($8266d55eb96b041c$var$convertHTML(child, offset, childLength));
        });
        if (isRoot || blot.statics.blotName === "list") return parts.join("");
        const { outerHTML: outerHTML, innerHTML: innerHTML } = blot.domNode;
        const [start, end] = outerHTML.split(`>${innerHTML}<`);
        // TODO cleanup
        if (start === "<table") return `<table style="border: 1px solid #000;">${parts.join("")}<${end}`;
        return `${start}>${parts.join("")}<${end}`;
    }
    return blot.domNode instanceof Element ? blot.domNode.outerHTML : "";
}
function $8266d55eb96b041c$var$combineFormats(formats, combined) {
    return Object.keys(combined).reduce((merged, name)=>{
        if (formats[name] == null) return merged;
        const combinedValue = combined[name];
        if (combinedValue === formats[name]) merged[name] = combinedValue;
        else if (Array.isArray(combinedValue)) {
            if (combinedValue.indexOf(formats[name]) < 0) merged[name] = combinedValue.concat([
                formats[name]
            ]);
            else // If style already exists, don't add to an array, but don't lose other styles
            merged[name] = combinedValue;
        } else merged[name] = [
            combinedValue,
            formats[name]
        ];
        return merged;
    }, {});
}
function $8266d55eb96b041c$var$getListType(type) {
    const tag = type === "ordered" ? "ol" : "ul";
    switch(type){
        case "checked":
            return [
                tag,
                ' data-list="checked"'
            ];
        case "unchecked":
            return [
                tag,
                ' data-list="unchecked"'
            ];
        default:
            return [
                tag,
                ""
            ];
    }
}
function $8266d55eb96b041c$var$normalizeDelta(delta) {
    return delta.reduce((normalizedDelta, op)=>{
        if (typeof op.insert === "string") {
            const text = op.insert.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
            return normalizedDelta.insert(text, op.attributes);
        }
        return normalizedDelta.push(op);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))());
}
function $8266d55eb96b041c$var$shiftRange(_ref, amount) {
    let { index: index, length: length } = _ref;
    return new (0, $df4239af590079e1$export$9a58ef0d7ad3278c)(index + amount, length);
}
function $8266d55eb96b041c$var$splitOpLines(ops) {
    const split = [];
    ops.forEach((op)=>{
        if (typeof op.insert === "string") {
            const lines = op.insert.split("\n");
            lines.forEach((line, index)=>{
                if (index) split.push({
                    insert: "\n",
                    attributes: op.attributes
                });
                if (line) split.push({
                    insert: line,
                    attributes: op.attributes
                });
            });
        } else split.push(op);
    });
    return split;
}
var $8266d55eb96b041c$export$2e2bcd8739ae039 = $8266d55eb96b041c$var$Editor;






var $97zcJ = parcelRequire("97zcJ");
class $0fe56fdf6098eabb$var$Module {
    constructor(quill){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.quill = quill;
        this.options = options;
    }
}
(0, $97zcJ._)($0fe56fdf6098eabb$var$Module, "DEFAULTS", {});
var $0fe56fdf6098eabb$export$2e2bcd8739ae039 = $0fe56fdf6098eabb$var$Module;




var $97zcJ = parcelRequire("97zcJ");


const $940861127aa87418$var$GUARD_TEXT = "\uFEFF";
class $940861127aa87418$var$Embed extends (0, $8324d048851d53b4$export$297a1fa96f55f00f) {
    index(node, offset) {
        if (node === this.leftGuard) return 0;
        if (node === this.rightGuard) return 1;
        return super.index(node, offset);
    }
    restore(node) {
        let range = null;
        let textNode;
        const text = node.data.split($940861127aa87418$var$GUARD_TEXT).join("");
        if (node === this.leftGuard) {
            if (this.prev instanceof (0, $44fdb97bacc13d2d$export$2e2bcd8739ae039)) {
                const prevLength = this.prev.length();
                this.prev.insertAt(prevLength, text);
                range = {
                    startNode: this.prev.domNode,
                    startOffset: prevLength + text.length
                };
            } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(this.scroll.create(textNode), this);
                range = {
                    startNode: textNode,
                    startOffset: text.length
                };
            }
        } else if (node === this.rightGuard) {
            if (this.next instanceof (0, $44fdb97bacc13d2d$export$2e2bcd8739ae039)) {
                this.next.insertAt(0, text);
                range = {
                    startNode: this.next.domNode,
                    startOffset: text.length
                };
            } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(this.scroll.create(textNode), this.next);
                range = {
                    startNode: textNode,
                    startOffset: text.length
                };
            }
        }
        node.data = $940861127aa87418$var$GUARD_TEXT;
        return range;
    }
    update(mutations, context) {
        mutations.forEach((mutation)=>{
            if (mutation.type === "characterData" && (mutation.target === this.leftGuard || mutation.target === this.rightGuard)) {
                const range = this.restore(mutation.target);
                if (range) context.range = range;
            }
        });
    }
    constructor(scroll, node){
        super(scroll, node);
        this.contentNode = document.createElement("span");
        this.contentNode.setAttribute("contenteditable", "false");
        Array.from(this.domNode.childNodes).forEach((childNode)=>{
            this.contentNode.appendChild(childNode);
        });
        this.leftGuard = document.createTextNode($940861127aa87418$var$GUARD_TEXT);
        this.rightGuard = document.createTextNode($940861127aa87418$var$GUARD_TEXT);
        this.domNode.appendChild(this.leftGuard);
        this.domNode.appendChild(this.contentNode);
        this.domNode.appendChild(this.rightGuard);
    }
}
var $940861127aa87418$export$2e2bcd8739ae039 = $940861127aa87418$var$Embed;



class $ffb3cd2429da0c08$var$Composition {
    setupListeners() {
        this.scroll.domNode.addEventListener("compositionstart", (event)=>{
            if (!this.isComposing) this.handleCompositionStart(event);
        });
        this.scroll.domNode.addEventListener("compositionend", (event)=>{
            if (this.isComposing) // Webkit makes DOM changes after compositionend, so we use microtask to
            // ensure the order.
            // https://bugs.webkit.org/show_bug.cgi?id=31902
            queueMicrotask(()=>{
                this.handleCompositionEnd(event);
            });
        });
    }
    handleCompositionStart(event) {
        const blot = event.target instanceof Node ? this.scroll.find(event.target, true) : null;
        if (blot && !(blot instanceof (0, $940861127aa87418$export$2e2bcd8739ae039))) {
            this.emitter.emit((0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.COMPOSITION_BEFORE_START, event);
            this.scroll.batchStart();
            this.emitter.emit((0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.COMPOSITION_START, event);
            this.isComposing = true;
        }
    }
    handleCompositionEnd(event) {
        this.emitter.emit((0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.COMPOSITION_BEFORE_END, event);
        this.scroll.batchEnd();
        this.emitter.emit((0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.COMPOSITION_END, event);
        this.isComposing = false;
    }
    constructor(scroll, emitter){
        (0, $97zcJ._)(this, "isComposing", false);
        this.scroll = scroll;
        this.emitter = emitter;
        this.setupListeners();
    }
}
var $ffb3cd2429da0c08$export$2e2bcd8739ae039 = $ffb3cd2429da0c08$var$Composition;



var $97zcJ = parcelRequire("97zcJ");
class $5c563bda509d6d32$var$Theme {
    init() {
        Object.keys(this.options.modules).forEach((name)=>{
            if (this.modules[name] == null) this.addModule(name);
        });
    }
    addModule(name) {
        // @ts-expect-error
        const ModuleClass = this.quill.constructor.import(`modules/${name}`);
        this.modules[name] = new ModuleClass(this.quill, this.options.modules[name] || {});
        return this.modules[name];
    }
    constructor(quill, options){
        (0, $97zcJ._)(this, "modules", {});
        this.quill = quill;
        this.options = options;
    }
}
(0, $97zcJ._)($5c563bda509d6d32$var$Theme, "DEFAULTS", {
    modules: {}
});
(0, $97zcJ._)($5c563bda509d6d32$var$Theme, "themes", {
    default: $5c563bda509d6d32$var$Theme
});
var $5c563bda509d6d32$export$2e2bcd8739ae039 = $5c563bda509d6d32$var$Theme;


const $a3581499503597c2$var$getParentElement = (element)=>element.parentElement || element.getRootNode().host || null;
const $a3581499503597c2$var$getElementRect = (element)=>{
    const rect = element.getBoundingClientRect();
    const scaleX = "offsetWidth" in element && Math.abs(rect.width) / element.offsetWidth || 1;
    const scaleY = "offsetHeight" in element && Math.abs(rect.height) / element.offsetHeight || 1;
    return {
        top: rect.top,
        right: rect.left + element.clientWidth * scaleX,
        bottom: rect.top + element.clientHeight * scaleY,
        left: rect.left
    };
};
const $a3581499503597c2$var$paddingValueToInt = (value)=>{
    const number = parseInt(value, 10);
    return Number.isNaN(number) ? 0 : number;
};
// Follow the steps described in https://www.w3.org/TR/cssom-view-1/#element-scrolling-members,
// assuming that the scroll option is set to 'nearest'.
const $a3581499503597c2$var$getScrollDistance = (targetStart, targetEnd, scrollStart, scrollEnd, scrollPaddingStart, scrollPaddingEnd)=>{
    if (targetStart < scrollStart && targetEnd > scrollEnd) return 0;
    if (targetStart < scrollStart) return -(scrollStart - targetStart + scrollPaddingStart);
    if (targetEnd > scrollEnd) return targetEnd - targetStart > scrollEnd - scrollStart ? targetStart + scrollPaddingStart - scrollStart : targetEnd - scrollEnd + scrollPaddingEnd;
    return 0;
};
const $a3581499503597c2$var$scrollRectIntoView = (root, targetRect)=>{
    const document = root.ownerDocument;
    let rect = targetRect;
    let current = root;
    while(current){
        const isDocumentBody = current === document.body;
        const bounding = isDocumentBody ? {
            top: 0,
            right: window.visualViewport?.width ?? document.documentElement.clientWidth,
            bottom: window.visualViewport?.height ?? document.documentElement.clientHeight,
            left: 0
        } : $a3581499503597c2$var$getElementRect(current);
        const style = getComputedStyle(current);
        const scrollDistanceX = $a3581499503597c2$var$getScrollDistance(rect.left, rect.right, bounding.left, bounding.right, $a3581499503597c2$var$paddingValueToInt(style.scrollPaddingLeft), $a3581499503597c2$var$paddingValueToInt(style.scrollPaddingRight));
        const scrollDistanceY = $a3581499503597c2$var$getScrollDistance(rect.top, rect.bottom, bounding.top, bounding.bottom, $a3581499503597c2$var$paddingValueToInt(style.scrollPaddingTop), $a3581499503597c2$var$paddingValueToInt(style.scrollPaddingBottom));
        if (scrollDistanceX || scrollDistanceY) {
            if (isDocumentBody) document.defaultView?.scrollBy(scrollDistanceX, scrollDistanceY);
            else {
                const { scrollLeft: scrollLeft, scrollTop: scrollTop } = current;
                if (scrollDistanceY) current.scrollTop += scrollDistanceY;
                if (scrollDistanceX) current.scrollLeft += scrollDistanceX;
                const scrolledLeft = current.scrollLeft - scrollLeft;
                const scrolledTop = current.scrollTop - scrollTop;
                rect = {
                    left: rect.left - scrolledLeft,
                    top: rect.top - scrolledTop,
                    right: rect.right - scrolledLeft,
                    bottom: rect.bottom - scrolledTop
                };
            }
        }
        current = isDocumentBody || style.position === "fixed" ? null : $a3581499503597c2$var$getParentElement(current);
    }
};
var $a3581499503597c2$export$2e2bcd8739ae039 = $a3581499503597c2$var$scrollRectIntoView;



const $4d637634b4d84da1$var$MAX_REGISTER_ITERATIONS = 100;
const $4d637634b4d84da1$var$CORE_FORMATS = [
    "block",
    "break",
    "cursor",
    "inline",
    "scroll",
    "text"
];
const $4d637634b4d84da1$var$createRegistryWithFormats = (formats, sourceRegistry, debug)=>{
    const registry = new (0, $8324d048851d53b4$export$4d9facee29974f3)();
    $4d637634b4d84da1$var$CORE_FORMATS.forEach((name)=>{
        const coreBlot = sourceRegistry.query(name);
        if (coreBlot) registry.register(coreBlot);
    });
    formats.forEach((name)=>{
        let format = sourceRegistry.query(name);
        if (!format) debug.error(`Cannot register "${name}" specified in "formats" config. Are you sure it was registered?`);
        let iterations = 0;
        while(format){
            registry.register(format);
            format = "blotName" in format ? format.requiredContainer ?? null : null;
            iterations += 1;
            if (iterations > $4d637634b4d84da1$var$MAX_REGISTER_ITERATIONS) {
                debug.error(`Cycle detected in registering blot requiredContainer: "${name}"`);
                break;
            }
        }
    });
    return registry;
};
var $4d637634b4d84da1$export$2e2bcd8739ae039 = $4d637634b4d84da1$var$createRegistryWithFormats;


const $c868a5e4990268d1$var$debug = (0, $8673b628d4423f23$export$2e2bcd8739ae039)("quill");
const $c868a5e4990268d1$export$bc58ce2776ecdb6f = new $8324d048851d53b4$exports.Registry();
$8324d048851d53b4$exports.ParentBlot.uiClass = "ql-ui";
/**
 * Options for initializing a Quill instance
 */ /**
 * Similar to QuillOptions, but with all properties expanded to their default values,
 * and all selectors resolved to HTMLElements.
 */ class $c868a5e4990268d1$export$2e2bcd8739ae039 {
    static debug(limit) {
        if (limit === true) limit = "log";
        (0, $8673b628d4423f23$export$2e2bcd8739ae039).level(limit);
    }
    static find(node) {
        let bubble = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return (0, $88e1fb7104a935c6$export$2e2bcd8739ae039).get(node) || $c868a5e4990268d1$export$bc58ce2776ecdb6f.find(node, bubble);
    }
    static import(name) {
        if (this.imports[name] == null) $c868a5e4990268d1$var$debug.error(`Cannot import ${name}. Are you sure it was registered?`);
        return this.imports[name];
    }
    static register() {
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) !== "string") {
            const target = arguments.length <= 0 ? undefined : arguments[0];
            const overwrite = !!(arguments.length <= 1 ? undefined : arguments[1]);
            const name = "attrName" in target ? target.attrName : target.blotName;
            if (typeof name === "string") // Shortcut for formats:
            // register(Blot | Attributor, overwrite)
            this.register(`formats/${name}`, target, overwrite);
            else Object.keys(target).forEach((key)=>{
                this.register(key, target[key], overwrite);
            });
        } else {
            const path = arguments.length <= 0 ? undefined : arguments[0];
            const target = arguments.length <= 1 ? undefined : arguments[1];
            const overwrite = !!(arguments.length <= 2 ? undefined : arguments[2]);
            if (this.imports[path] != null && !overwrite) $c868a5e4990268d1$var$debug.warn(`Overwriting ${path} with`, target);
            this.imports[path] = target;
            if ((path.startsWith("blots/") || path.startsWith("formats/")) && target && typeof target !== "boolean" && target.blotName !== "abstract") $c868a5e4990268d1$export$bc58ce2776ecdb6f.register(target);
            if (typeof target.register === "function") target.register($c868a5e4990268d1$export$bc58ce2776ecdb6f);
        }
    }
    addContainer(container) {
        let refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        if (typeof container === "string") {
            const className = container;
            container = document.createElement("div");
            container.classList.add(className);
        }
        this.container.insertBefore(container, refNode);
        return container;
    }
    blur() {
        this.selection.setRange(null);
    }
    deleteText(index, length, source) {
        // @ts-expect-error
        [index, length, , source] = $c868a5e4990268d1$export$e336952123c0bccd(index, length, source);
        return $c868a5e4990268d1$var$modify.call(this, ()=>{
            return this.editor.deleteText(index, length);
        }, source, index, -1 * length);
    }
    disable() {
        this.enable(false);
    }
    editReadOnly(modifier) {
        this.allowReadOnlyEdits = true;
        const value = modifier();
        this.allowReadOnlyEdits = false;
        return value;
    }
    enable() {
        let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.scroll.enable(enabled);
        this.container.classList.toggle("ql-disabled", !enabled);
    }
    focus() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.selection.focus();
        if (!options.preventScroll) this.scrollSelectionIntoView();
    }
    format(name, value) {
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.API;
        return $c868a5e4990268d1$var$modify.call(this, ()=>{
            const range = this.getSelection(true);
            let change = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))();
            if (range == null) return change;
            if (this.scroll.query(name, $8324d048851d53b4$exports.Scope.BLOCK)) change = this.editor.formatLine(range.index, range.length, {
                [name]: value
            });
            else if (range.length === 0) {
                this.selection.format(name, value);
                return change;
            } else change = this.editor.formatText(range.index, range.length, {
                [name]: value
            });
            this.setSelection(range, (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.SILENT);
            return change;
        }, source);
    }
    formatLine(index, length, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        [index, length, formats, source] = $c868a5e4990268d1$export$e336952123c0bccd(index, length, // @ts-expect-error
        name, value, source);
        return $c868a5e4990268d1$var$modify.call(this, ()=>{
            return this.editor.formatLine(index, length, formats);
        }, source, index, 0);
    }
    formatText(index, length, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        [index, length, formats, source] = $c868a5e4990268d1$export$e336952123c0bccd(// @ts-expect-error
        index, length, name, value, source);
        return $c868a5e4990268d1$var$modify.call(this, ()=>{
            return this.editor.formatText(index, length, formats);
        }, source, index, 0);
    }
    getBounds(index) {
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        let bounds = null;
        if (typeof index === "number") bounds = this.selection.getBounds(index, length);
        else bounds = this.selection.getBounds(index.index, index.length);
        if (!bounds) return null;
        const containerBounds = this.container.getBoundingClientRect();
        return {
            bottom: bounds.bottom - containerBounds.top,
            height: bounds.height,
            left: bounds.left - containerBounds.left,
            right: bounds.right - containerBounds.left,
            top: bounds.top - containerBounds.top,
            width: bounds.width
        };
    }
    getContents() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
        [index, length] = $c868a5e4990268d1$export$e336952123c0bccd(index, length);
        return this.editor.getContents(index, length);
    }
    getFormat() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        if (typeof index === "number") return this.editor.getFormat(index, length);
        return this.editor.getFormat(index.index, index.length);
    }
    getIndex(blot) {
        return blot.offset(this.scroll);
    }
    getLength() {
        return this.scroll.length();
    }
    getLeaf(index) {
        return this.scroll.leaf(index);
    }
    getLine(index) {
        return this.scroll.line(index);
    }
    getLines() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
        if (typeof index !== "number") return this.scroll.lines(index.index, index.length);
        return this.scroll.lines(index, length);
    }
    getModule(name) {
        return this.theme.modules[name];
    }
    getSelection() {
        let focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (focus) this.focus();
        this.update(); // Make sure we access getRange with editor in consistent state
        return this.selection.getRange()[0];
    }
    getSemanticHTML() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof index === "number") length = length ?? this.getLength() - index;
        // @ts-expect-error
        [index, length] = $c868a5e4990268d1$export$e336952123c0bccd(index, length);
        return this.editor.getHTML(index, length);
    }
    getText() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof index === "number") length = length ?? this.getLength() - index;
        // @ts-expect-error
        [index, length] = $c868a5e4990268d1$export$e336952123c0bccd(index, length);
        return this.editor.getText(index, length);
    }
    hasFocus() {
        return this.selection.hasFocus();
    }
    insertEmbed(index, embed, value) {
        let source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $c868a5e4990268d1$export$2e2bcd8739ae039.sources.API;
        return $c868a5e4990268d1$var$modify.call(this, ()=>{
            return this.editor.insertEmbed(index, embed, value);
        }, source, index);
    }
    insertText(index, text, name, value, source) {
        let formats;
        // eslint-disable-next-line prefer-const
        // @ts-expect-error
        [index, , formats, source] = $c868a5e4990268d1$export$e336952123c0bccd(index, 0, name, value, source);
        return $c868a5e4990268d1$var$modify.call(this, ()=>{
            return this.editor.insertText(index, text, formats);
        }, source, index, text.length);
    }
    isEnabled() {
        return this.scroll.isEnabled();
    }
    off() {
        return this.emitter.off(...arguments);
    }
    on() {
        return this.emitter.on(...arguments);
    }
    once() {
        return this.emitter.once(...arguments);
    }
    removeFormat(index, length, source) {
        [index, length, , source] = $c868a5e4990268d1$export$e336952123c0bccd(index, length, source);
        return $c868a5e4990268d1$var$modify.call(this, ()=>{
            return this.editor.removeFormat(index, length);
        }, source, index);
    }
    scrollRectIntoView(rect) {
        (0, $a3581499503597c2$export$2e2bcd8739ae039)(this.root, rect);
    }
    /**
   * @deprecated Use Quill#scrollSelectionIntoView() instead.
   */ scrollIntoView() {
        console.warn("Quill#scrollIntoView() has been deprecated and will be removed in the near future. Please use Quill#scrollSelectionIntoView() instead.");
        this.scrollSelectionIntoView();
    }
    /**
   * Scroll the current selection into the visible area.
   * If the selection is already visible, no scrolling will occur.
   */ scrollSelectionIntoView() {
        const range = this.selection.lastRange;
        const bounds = range && this.selection.getBounds(range.index, range.length);
        if (bounds) this.scrollRectIntoView(bounds);
    }
    setContents(delta) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.API;
        return $c868a5e4990268d1$var$modify.call(this, ()=>{
            delta = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))(delta);
            const length = this.getLength();
            // Quill will set empty editor to \n
            const delete1 = this.editor.deleteText(0, length);
            const applied = this.editor.insertContents(0, delta);
            // Remove extra \n from empty editor initialization
            const delete2 = this.editor.deleteText(this.getLength() - 1, 1);
            return delete1.compose(applied).compose(delete2);
        }, source);
    }
    setSelection(index, length, source) {
        if (index == null) // @ts-expect-error https://github.com/microsoft/TypeScript/issues/22609
        this.selection.setRange(null, length || $c868a5e4990268d1$export$2e2bcd8739ae039.sources.API);
        else {
            // @ts-expect-error
            [index, length, , source] = $c868a5e4990268d1$export$e336952123c0bccd(index, length, source);
            this.selection.setRange(new (0, $df4239af590079e1$export$9a58ef0d7ad3278c)(Math.max(0, index), length), source);
            if (source !== (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.SILENT) this.scrollSelectionIntoView();
        }
    }
    setText(text) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.API;
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().insert(text);
        return this.setContents(delta, source);
    }
    update() {
        let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.USER;
        const change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
        this.selection.update(source);
        // TODO this is usually undefined
        return change;
    }
    updateContents(delta) {
        let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.API;
        return $c868a5e4990268d1$var$modify.call(this, ()=>{
            delta = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))(delta);
            return this.editor.applyDelta(delta);
        }, source, true);
    }
    constructor(container){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.options = $c868a5e4990268d1$export$72ab7189806b6df5(container, options);
        this.container = this.options.container;
        if (this.container == null) {
            $c868a5e4990268d1$var$debug.error("Invalid Quill container", container);
            return;
        }
        if (this.options.debug) $c868a5e4990268d1$export$2e2bcd8739ae039.debug(this.options.debug);
        const html = this.container.innerHTML.trim();
        this.container.classList.add("ql-container");
        this.container.innerHTML = "";
        (0, $88e1fb7104a935c6$export$2e2bcd8739ae039).set(this.container, this);
        this.root = this.addContainer("ql-editor");
        this.root.classList.add("ql-blank");
        this.emitter = new (0, $6c311a36f0b35611$export$2e2bcd8739ae039)();
        const scrollBlotName = $8324d048851d53b4$exports.ScrollBlot.blotName;
        const ScrollBlot = this.options.registry.query(scrollBlotName);
        if (!ScrollBlot || !("blotName" in ScrollBlot)) throw new Error(`Cannot initialize Quill without "${scrollBlotName}" blot`);
        this.scroll = new ScrollBlot(this.options.registry, this.root, {
            emitter: this.emitter
        });
        this.editor = new (0, $8266d55eb96b041c$export$2e2bcd8739ae039)(this.scroll);
        this.selection = new (0, $df4239af590079e1$export$2e2bcd8739ae039)(this.scroll, this.emitter);
        this.composition = new (0, $ffb3cd2429da0c08$export$2e2bcd8739ae039)(this.scroll, this.emitter);
        this.theme = new this.options.theme(this, this.options); // eslint-disable-line new-cap
        this.keyboard = this.theme.addModule("keyboard");
        this.clipboard = this.theme.addModule("clipboard");
        this.history = this.theme.addModule("history");
        this.uploader = this.theme.addModule("uploader");
        this.theme.addModule("input");
        this.theme.addModule("uiNode");
        this.theme.init();
        this.emitter.on((0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.EDITOR_CHANGE, (type)=>{
            if (type === (0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.TEXT_CHANGE) this.root.classList.toggle("ql-blank", this.editor.isBlank());
        });
        this.emitter.on((0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.SCROLL_UPDATE, (source, mutations)=>{
            const oldRange = this.selection.lastRange;
            const [newRange] = this.selection.getRange();
            const selectionInfo = oldRange && newRange ? {
                oldRange: oldRange,
                newRange: newRange
            } : undefined;
            $c868a5e4990268d1$var$modify.call(this, ()=>this.editor.update(null, mutations, selectionInfo), source);
        });
        this.emitter.on((0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.SCROLL_EMBED_UPDATE, (blot, delta)=>{
            const oldRange = this.selection.lastRange;
            const [newRange] = this.selection.getRange();
            const selectionInfo = oldRange && newRange ? {
                oldRange: oldRange,
                newRange: newRange
            } : undefined;
            $c868a5e4990268d1$var$modify.call(this, ()=>{
                const change = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().retain(blot.offset(this)).retain({
                    [blot.statics.blotName]: delta
                });
                return this.editor.update(change, [], selectionInfo);
            }, $c868a5e4990268d1$export$2e2bcd8739ae039.sources.USER);
        });
        if (html) {
            const contents = this.clipboard.convert({
                html: `${html}<p><br></p>`,
                text: "\n"
            });
            this.setContents(contents);
        }
        this.history.clear();
        if (this.options.placeholder) this.root.setAttribute("data-placeholder", this.options.placeholder);
        if (this.options.readOnly) this.disable();
        this.allowReadOnlyEdits = false;
    }
}
(0, $97zcJ._)($c868a5e4990268d1$export$2e2bcd8739ae039, "DEFAULTS", {
    bounds: null,
    modules: {
        clipboard: true,
        keyboard: true,
        history: true,
        uploader: true
    },
    placeholder: "",
    readOnly: false,
    registry: $c868a5e4990268d1$export$bc58ce2776ecdb6f,
    theme: "default"
});
(0, $97zcJ._)($c868a5e4990268d1$export$2e2bcd8739ae039, "events", (0, $6c311a36f0b35611$export$2e2bcd8739ae039).events);
(0, $97zcJ._)($c868a5e4990268d1$export$2e2bcd8739ae039, "sources", (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources);
(0, $97zcJ._)($c868a5e4990268d1$export$2e2bcd8739ae039, "version", "2.0.3");
(0, $97zcJ._)($c868a5e4990268d1$export$2e2bcd8739ae039, "imports", {
    delta: (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports))),
    parchment: $8324d048851d53b4$exports,
    "core/module": (0, $0fe56fdf6098eabb$export$2e2bcd8739ae039),
    "core/theme": (0, $5c563bda509d6d32$export$2e2bcd8739ae039)
});
function $c868a5e4990268d1$var$resolveSelector(selector) {
    return typeof selector === "string" ? document.querySelector(selector) : selector;
}
function $c868a5e4990268d1$var$expandModuleConfig(config) {
    return Object.entries(config ?? {}).reduce((expanded, _ref)=>{
        let [key, value] = _ref;
        return {
            ...expanded,
            [key]: value === true ? {} : value
        };
    }, {});
}
function $c868a5e4990268d1$var$omitUndefinedValuesFromOptions(obj) {
    return Object.fromEntries(Object.entries(obj).filter((entry)=>entry[1] !== undefined));
}
function $c868a5e4990268d1$export$72ab7189806b6df5(containerOrSelector, options) {
    const container = $c868a5e4990268d1$var$resolveSelector(containerOrSelector);
    if (!container) throw new Error("Invalid Quill container");
    const shouldUseDefaultTheme = !options.theme || options.theme === $c868a5e4990268d1$export$2e2bcd8739ae039.DEFAULTS.theme;
    const theme = shouldUseDefaultTheme ? (0, $5c563bda509d6d32$export$2e2bcd8739ae039) : $c868a5e4990268d1$export$2e2bcd8739ae039.import(`themes/${options.theme}`);
    if (!theme) throw new Error(`Invalid theme ${options.theme}. Did you register it?`);
    const { modules: quillModuleDefaults, ...quillDefaults } = $c868a5e4990268d1$export$2e2bcd8739ae039.DEFAULTS;
    const { modules: themeModuleDefaults, ...themeDefaults } = theme.DEFAULTS;
    let userModuleOptions = $c868a5e4990268d1$var$expandModuleConfig(options.modules);
    // Special case toolbar shorthand
    if (userModuleOptions != null && userModuleOptions.toolbar && userModuleOptions.toolbar.constructor !== Object) userModuleOptions = {
        ...userModuleOptions,
        toolbar: {
            container: userModuleOptions.toolbar
        }
    };
    const modules = (0, $47c6e52c26bddb86$export$2e2bcd8739ae039)({}, $c868a5e4990268d1$var$expandModuleConfig(quillModuleDefaults), $c868a5e4990268d1$var$expandModuleConfig(themeModuleDefaults), userModuleOptions);
    const config = {
        ...quillDefaults,
        ...$c868a5e4990268d1$var$omitUndefinedValuesFromOptions(themeDefaults),
        ...$c868a5e4990268d1$var$omitUndefinedValuesFromOptions(options)
    };
    let registry = options.registry;
    if (registry) {
        if (options.formats) $c868a5e4990268d1$var$debug.warn('Ignoring "formats" option because "registry" is specified');
    } else registry = options.formats ? (0, $4d637634b4d84da1$export$2e2bcd8739ae039)(options.formats, config.registry, $c868a5e4990268d1$var$debug) : config.registry;
    return {
        ...config,
        registry: registry,
        container: container,
        theme: theme,
        modules: Object.entries(modules).reduce((modulesWithDefaults, _ref2)=>{
            let [name, value] = _ref2;
            if (!value) return modulesWithDefaults;
            const moduleClass = $c868a5e4990268d1$export$2e2bcd8739ae039.import(`modules/${name}`);
            if (moduleClass == null) {
                $c868a5e4990268d1$var$debug.error(`Cannot load ${name} module. Are you sure you registered it?`);
                return modulesWithDefaults;
            }
            return {
                ...modulesWithDefaults,
                // @ts-expect-error
                [name]: (0, $47c6e52c26bddb86$export$2e2bcd8739ae039)({}, moduleClass.DEFAULTS || {}, value)
            };
        }, {}),
        bounds: $c868a5e4990268d1$var$resolveSelector(config.bounds)
    };
}
// Handle selection preservation and TEXT_CHANGE emission
// common to modification APIs
function $c868a5e4990268d1$var$modify(modifier, source, index, shift) {
    if (!this.isEnabled() && source === (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.USER && !this.allowReadOnlyEdits) return new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))();
    let range = index == null ? null : this.getSelection();
    const oldDelta = this.editor.delta;
    const change = modifier();
    if (range != null) {
        if (index === true) index = range.index; // eslint-disable-line prefer-destructuring
        if (shift == null) range = $c868a5e4990268d1$var$shiftRange(range, change, source);
        else if (shift !== 0) // @ts-expect-error index should always be number
        range = $c868a5e4990268d1$var$shiftRange(range, index, shift, source);
        this.setSelection(range, (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.SILENT);
    }
    if (change.length() > 0) {
        const args = [
            (0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.TEXT_CHANGE,
            change,
            oldDelta,
            source
        ];
        this.emitter.emit((0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.EDITOR_CHANGE, ...args);
        if (source !== (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.SILENT) this.emitter.emit(...args);
    }
    return change;
}
function $c868a5e4990268d1$export$e336952123c0bccd(index, length, name, value, source) {
    let formats = {};
    // @ts-expect-error
    if (typeof index.index === "number" && typeof index.length === "number") {
        // Allow for throwaway end (used by insertText/insertEmbed)
        if (typeof length !== "number") {
            // @ts-expect-error
            source = value;
            value = name;
            name = length;
            // @ts-expect-error
            length = index.length; // eslint-disable-line prefer-destructuring
            // @ts-expect-error
            index = index.index; // eslint-disable-line prefer-destructuring
        } else {
            // @ts-expect-error
            length = index.length; // eslint-disable-line prefer-destructuring
            // @ts-expect-error
            index = index.index; // eslint-disable-line prefer-destructuring
        }
    } else if (typeof length !== "number") {
        // @ts-expect-error
        source = value;
        value = name;
        name = length;
        length = 0;
    }
    // Handle format being object, two format name/value strings or excluded
    if (typeof name === "object") {
        // @ts-expect-error Fix me later
        formats = name;
        // @ts-expect-error
        source = value;
    } else if (typeof name === "string") {
        if (value != null) formats[name] = value;
        else // @ts-expect-error
        source = name;
    }
    // Handle optional source
    source = source || (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.API;
    // @ts-expect-error
    return [
        index,
        length,
        formats,
        source
    ];
}
function $c868a5e4990268d1$var$shiftRange(range, index, lengthOrSource, source) {
    const length = typeof lengthOrSource === "number" ? lengthOrSource : 0;
    if (range == null) return null;
    let start;
    let end;
    // @ts-expect-error -- TODO: add a better type guard around `index`
    if (index && typeof index.transformPosition === "function") [start, end] = [
        range.index,
        range.index + range.length
    ].map((pos)=>// @ts-expect-error -- TODO: add a better type guard around `index`
        index.transformPosition(pos, source !== (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.USER));
    else [start, end] = [
        range.index,
        range.index + range.length
    ].map((pos)=>{
        // @ts-expect-error -- TODO: add a better type guard around `index`
        if (pos < index || pos === index && source === (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.USER) return pos;
        if (length >= 0) return pos + length;
        // @ts-expect-error -- TODO: add a better type guard around `index`
        return Math.max(index, pos + length);
    });
    return new (0, $df4239af590079e1$export$9a58ef0d7ad3278c)(start, end - start);
}





class $d5d72b42a1ba7785$var$Container extends (0, $8324d048851d53b4$export$c898d510319704c0) {
}
var $d5d72b42a1ba7785$export$2e2bcd8739ae039 = $d5d72b42a1ba7785$var$Container;






var $97zcJ = parcelRequire("97zcJ");






function $b086038ab50867f0$var$isLine(blot) {
    return blot instanceof (0, $421348c10218bc50$export$2e2bcd8739ae039) || blot instanceof (0, $421348c10218bc50$export$48b9f0688962d028);
}
function $b086038ab50867f0$var$isUpdatable(blot) {
    return typeof blot.updateContent === "function";
}
class $b086038ab50867f0$var$Scroll extends (0, $8324d048851d53b4$export$7175329dad7a46f1) {
    batchStart() {
        if (!Array.isArray(this.batch)) this.batch = [];
    }
    batchEnd() {
        if (!this.batch) return;
        const mutations = this.batch;
        this.batch = false;
        this.update(mutations);
    }
    emitMount(blot) {
        this.emitter.emit((0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.SCROLL_BLOT_MOUNT, blot);
    }
    emitUnmount(blot) {
        this.emitter.emit((0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.SCROLL_BLOT_UNMOUNT, blot);
    }
    emitEmbedUpdate(blot, change) {
        this.emitter.emit((0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.SCROLL_EMBED_UPDATE, blot, change);
    }
    deleteAt(index, length) {
        const [first, offset] = this.line(index);
        const [last] = this.line(index + length);
        super.deleteAt(index, length);
        if (last != null && first !== last && offset > 0) {
            if (first instanceof (0, $421348c10218bc50$export$48b9f0688962d028) || last instanceof (0, $421348c10218bc50$export$48b9f0688962d028)) {
                this.optimize();
                return;
            }
            const ref = last.children.head instanceof (0, $aac85a10314b6a4e$export$2e2bcd8739ae039) ? null : last.children.head;
            // @ts-expect-error
            first.moveChildren(last, ref);
            // @ts-expect-error
            first.remove();
        }
        this.optimize();
    }
    enable() {
        let enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.domNode.setAttribute("contenteditable", enabled ? "true" : "false");
    }
    formatAt(index, length, format, value) {
        super.formatAt(index, length, format, value);
        this.optimize();
    }
    insertAt(index, value, def) {
        if (index >= this.length()) {
            if (def == null || this.scroll.query(value, (0, $8324d048851d53b4$export$775b6bb06e53a214).BLOCK) == null) {
                const blot = this.scroll.create(this.statics.defaultChild.blotName);
                this.appendChild(blot);
                if (def == null && value.endsWith("\n")) blot.insertAt(0, value.slice(0, -1), def);
                else blot.insertAt(0, value, def);
            } else {
                const embed = this.scroll.create(value, def);
                this.appendChild(embed);
            }
        } else super.insertAt(index, value, def);
        this.optimize();
    }
    insertBefore(blot, ref) {
        if (blot.statics.scope === (0, $8324d048851d53b4$export$775b6bb06e53a214).INLINE_BLOT) {
            const wrapper = this.scroll.create(this.statics.defaultChild.blotName);
            wrapper.appendChild(blot);
            super.insertBefore(wrapper, ref);
        } else super.insertBefore(blot, ref);
    }
    insertContents(index, delta) {
        const renderBlocks = this.deltaToRenderBlocks(delta.concat(new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().insert("\n")));
        const last = renderBlocks.pop();
        if (last == null) return;
        this.batchStart();
        const first = renderBlocks.shift();
        if (first) {
            const shouldInsertNewlineChar = first.type === "block" && (first.delta.length() === 0 || !this.descendant((0, $421348c10218bc50$export$48b9f0688962d028), index)[0] && index < this.length());
            const delta = first.type === "block" ? first.delta : new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().insert({
                [first.key]: first.value
            });
            $b086038ab50867f0$var$insertInlineContents(this, index, delta);
            const newlineCharLength = first.type === "block" ? 1 : 0;
            const lineEndIndex = index + delta.length() + newlineCharLength;
            if (shouldInsertNewlineChar) this.insertAt(lineEndIndex - 1, "\n");
            const formats = (0, $421348c10218bc50$export$e4bb5a6163449612)(this.line(index)[0]);
            const attributes = (0, $f5af2faee6afab08$exports.AttributeMap).diff(formats, first.attributes) || {};
            Object.keys(attributes).forEach((name)=>{
                this.formatAt(lineEndIndex - 1, 1, name, attributes[name]);
            });
            index = lineEndIndex;
        }
        let [refBlot, refBlotOffset] = this.children.find(index);
        if (renderBlocks.length) {
            if (refBlot) {
                refBlot = refBlot.split(refBlotOffset);
                refBlotOffset = 0;
            }
            renderBlocks.forEach((renderBlock)=>{
                if (renderBlock.type === "block") {
                    const block = this.createBlock(renderBlock.attributes, refBlot || undefined);
                    $b086038ab50867f0$var$insertInlineContents(block, 0, renderBlock.delta);
                } else {
                    const blockEmbed = this.create(renderBlock.key, renderBlock.value);
                    this.insertBefore(blockEmbed, refBlot || undefined);
                    Object.keys(renderBlock.attributes).forEach((name)=>{
                        blockEmbed.format(name, renderBlock.attributes[name]);
                    });
                }
            });
        }
        if (last.type === "block" && last.delta.length()) {
            const offset = refBlot ? refBlot.offset(refBlot.scroll) + refBlotOffset : this.length();
            $b086038ab50867f0$var$insertInlineContents(this, offset, last.delta);
        }
        this.batchEnd();
        this.optimize();
    }
    isEnabled() {
        return this.domNode.getAttribute("contenteditable") === "true";
    }
    leaf(index) {
        const last = this.path(index).pop();
        if (!last) return [
            null,
            -1
        ];
        const [blot, offset] = last;
        return blot instanceof (0, $8324d048851d53b4$export$7420b9c542181544) ? [
            blot,
            offset
        ] : [
            null,
            -1
        ];
    }
    line(index) {
        if (index === this.length()) return this.line(index - 1);
        // @ts-expect-error TODO: make descendant() generic
        return this.descendant($b086038ab50867f0$var$isLine, index);
    }
    lines() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
        const getLines = (blot, blotIndex, blotLength)=>{
            let lines = [];
            let lengthLeft = blotLength;
            blot.children.forEachAt(blotIndex, blotLength, (child, childIndex, childLength)=>{
                if ($b086038ab50867f0$var$isLine(child)) lines.push(child);
                else if (child instanceof (0, $8324d048851d53b4$export$c898d510319704c0)) lines = lines.concat(getLines(child, childIndex, lengthLeft));
                lengthLeft -= childLength;
            });
            return lines;
        };
        return getLines(this, index, length);
    }
    optimize() {
        let mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.batch) return;
        super.optimize(mutations, context);
        if (mutations.length > 0) this.emitter.emit((0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, mutations, context);
    }
    path(index) {
        return super.path(index).slice(1); // Exclude self
    }
    remove() {
    // Never remove self
    }
    update(mutations) {
        if (this.batch) {
            if (Array.isArray(mutations)) this.batch = this.batch.concat(mutations);
            return;
        }
        let source = (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.USER;
        if (typeof mutations === "string") source = mutations;
        if (!Array.isArray(mutations)) mutations = this.observer.takeRecords();
        mutations = mutations.filter((_ref2)=>{
            let { target: target } = _ref2;
            const blot = this.find(target, true);
            return blot && !$b086038ab50867f0$var$isUpdatable(blot);
        });
        if (mutations.length > 0) this.emitter.emit((0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.SCROLL_BEFORE_UPDATE, source, mutations);
        super.update(mutations.concat([])); // pass copy
        if (mutations.length > 0) this.emitter.emit((0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.SCROLL_UPDATE, source, mutations);
    }
    updateEmbedAt(index, key, change) {
        // Currently it only supports top-level embeds (BlockEmbed).
        // We can update `ParentBlot` in parchment to support inline embeds.
        const [blot] = this.descendant((b)=>b instanceof (0, $421348c10218bc50$export$48b9f0688962d028), index);
        if (blot && blot.statics.blotName === key && $b086038ab50867f0$var$isUpdatable(blot)) blot.updateContent(change);
    }
    handleDragStart(event) {
        event.preventDefault();
    }
    deltaToRenderBlocks(delta) {
        const renderBlocks = [];
        let currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))();
        delta.forEach((op)=>{
            const insert = op?.insert;
            if (!insert) return;
            if (typeof insert === "string") {
                const splitted = insert.split("\n");
                splitted.slice(0, -1).forEach((text)=>{
                    currentBlockDelta.insert(text, op.attributes);
                    renderBlocks.push({
                        type: "block",
                        delta: currentBlockDelta,
                        attributes: op.attributes ?? {}
                    });
                    currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))();
                });
                const last = splitted[splitted.length - 1];
                if (last) currentBlockDelta.insert(last, op.attributes);
            } else {
                const key = Object.keys(insert)[0];
                if (!key) return;
                if (this.query(key, (0, $8324d048851d53b4$export$775b6bb06e53a214).INLINE)) currentBlockDelta.push(op);
                else {
                    if (currentBlockDelta.length()) renderBlocks.push({
                        type: "block",
                        delta: currentBlockDelta,
                        attributes: {}
                    });
                    currentBlockDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))();
                    renderBlocks.push({
                        type: "blockEmbed",
                        key: key,
                        value: insert[key],
                        attributes: op.attributes ?? {}
                    });
                }
            }
        });
        if (currentBlockDelta.length()) renderBlocks.push({
            type: "block",
            delta: currentBlockDelta,
            attributes: {}
        });
        return renderBlocks;
    }
    createBlock(attributes, refBlot) {
        let blotName;
        const formats = {};
        Object.entries(attributes).forEach((_ref3)=>{
            let [key, value] = _ref3;
            const isBlockBlot = this.query(key, (0, $8324d048851d53b4$export$775b6bb06e53a214).BLOCK & (0, $8324d048851d53b4$export$775b6bb06e53a214).BLOT) != null;
            if (isBlockBlot) blotName = key;
            else formats[key] = value;
        });
        const block = this.create(blotName || this.statics.defaultChild.blotName, blotName ? attributes[blotName] : undefined);
        this.insertBefore(block, refBlot || undefined);
        const length = block.length();
        Object.entries(formats).forEach((_ref4)=>{
            let [key, value] = _ref4;
            block.formatAt(0, length, key, value);
        });
        return block;
    }
    constructor(registry, domNode, _ref){
        let { emitter: emitter } = _ref;
        super(registry, domNode);
        this.emitter = emitter;
        this.batch = false;
        this.optimize();
        this.enable();
        this.domNode.addEventListener("dragstart", (e)=>this.handleDragStart(e));
    }
}
(0, $97zcJ._)($b086038ab50867f0$var$Scroll, "blotName", "scroll");
(0, $97zcJ._)($b086038ab50867f0$var$Scroll, "className", "ql-editor");
(0, $97zcJ._)($b086038ab50867f0$var$Scroll, "tagName", "DIV");
(0, $97zcJ._)($b086038ab50867f0$var$Scroll, "defaultChild", (0, $421348c10218bc50$export$2e2bcd8739ae039));
(0, $97zcJ._)($b086038ab50867f0$var$Scroll, "allowedChildren", [
    (0, $421348c10218bc50$export$2e2bcd8739ae039),
    (0, $421348c10218bc50$export$48b9f0688962d028),
    (0, $d5d72b42a1ba7785$export$2e2bcd8739ae039)
]);
function $b086038ab50867f0$var$insertInlineContents(parent, index, inlineContents) {
    inlineContents.reduce((index, op)=>{
        const length = (0, $f5af2faee6afab08$exports.Op).length(op);
        let attributes = op.attributes || {};
        if (op.insert != null) {
            if (typeof op.insert === "string") {
                const text = op.insert;
                parent.insertAt(index, text);
                const [leaf] = parent.descendant((0, $8324d048851d53b4$export$7420b9c542181544), index);
                const formats = (0, $421348c10218bc50$export$e4bb5a6163449612)(leaf);
                attributes = (0, $f5af2faee6afab08$exports.AttributeMap).diff(formats, attributes) || {};
            } else if (typeof op.insert === "object") {
                const key = Object.keys(op.insert)[0]; // There should only be one key
                if (key == null) return index;
                parent.insertAt(index, key, op.insert[key]);
                const isInlineEmbed = parent.scroll.query(key, (0, $8324d048851d53b4$export$775b6bb06e53a214).INLINE) != null;
                if (isInlineEmbed) {
                    const [leaf] = parent.descendant((0, $8324d048851d53b4$export$7420b9c542181544), index);
                    const formats = (0, $421348c10218bc50$export$e4bb5a6163449612)(leaf);
                    attributes = (0, $f5af2faee6afab08$exports.AttributeMap).diff(formats, attributes) || {};
                }
            }
        }
        Object.keys(attributes).forEach((key)=>{
            parent.formatAt(index, length, key, attributes[key]);
        });
        return index + length;
    }, index);
}
var $b086038ab50867f0$export$2e2bcd8739ae039 = $b086038ab50867f0$var$Scroll;




var $97zcJ = parcelRequire("97zcJ");







const $fabb70fc3b74eee9$var$config = {
    scope: (0, $8324d048851d53b4$export$775b6bb06e53a214).BLOCK,
    whitelist: [
        "right",
        "center",
        "justify"
    ]
};
const $fabb70fc3b74eee9$export$2ef0f9fb04a51388 = new (0, $8324d048851d53b4$export$217610c4183502d0)("align", "align", $fabb70fc3b74eee9$var$config);
const $fabb70fc3b74eee9$export$7f3685f5846c07da = new (0, $8324d048851d53b4$export$651d45509677cf07)("align", "ql-align", $fabb70fc3b74eee9$var$config);
const $fabb70fc3b74eee9$export$d2060f5d114c9fe8 = new (0, $8324d048851d53b4$export$7c8099bbfe87b94d)("align", "text-align", $fabb70fc3b74eee9$var$config);




class $e83e82854e7f7981$export$c992e3369f248f6e extends (0, $8324d048851d53b4$export$7c8099bbfe87b94d) {
    value(domNode) {
        let value = super.value(domNode);
        if (!value.startsWith("rgb(")) return value;
        value = value.replace(/^[^\d]+/, "").replace(/[^\d]+$/, "");
        const hex = value.split(",").map((component)=>`00${parseInt(component, 10).toString(16)}`.slice(-2)).join("");
        return `#${hex}`;
    }
}
const $e83e82854e7f7981$export$42795dcf0ec6f3c8 = new (0, $8324d048851d53b4$export$651d45509677cf07)("color", "ql-color", {
    scope: (0, $8324d048851d53b4$export$775b6bb06e53a214).INLINE
});
const $e83e82854e7f7981$export$1415f56796d9a5a9 = new $e83e82854e7f7981$export$c992e3369f248f6e("color", "color", {
    scope: (0, $8324d048851d53b4$export$775b6bb06e53a214).INLINE
});


const $34ad99861d7d9ec9$export$8aa96c8963152b12 = new (0, $8324d048851d53b4$export$651d45509677cf07)("background", "ql-bg", {
    scope: (0, $8324d048851d53b4$export$775b6bb06e53a214).INLINE
});
const $34ad99861d7d9ec9$export$dc1cbcab4c682ef = new (0, $e83e82854e7f7981$export$c992e3369f248f6e)("background", "background-color", {
    scope: (0, $8324d048851d53b4$export$775b6bb06e53a214).INLINE
});



var $97zcJ = parcelRequire("97zcJ");







class $95fd90350cc017ea$export$3b131632d3d15165 extends (0, $d5d72b42a1ba7785$export$2e2bcd8739ae039) {
    static create(value) {
        const domNode = super.create(value);
        domNode.setAttribute("spellcheck", "false");
        return domNode;
    }
    code(index, length) {
        return this.children// @ts-expect-error
        .map((child)=>child.length() <= 1 ? "" : child.domNode.innerText).join("\n").slice(index, index + length);
    }
    html(index, length) {
        // `\n`s are needed in order to support empty lines at the beginning and the end.
        // https://html.spec.whatwg.org/multipage/syntax.html#element-restrictions
        return `<pre>\n${(0, $44fdb97bacc13d2d$export$96e6fc3a139b2555)(this.code(index, length))}\n</pre>`;
    }
}
class $95fd90350cc017ea$export$2e2bcd8739ae039 extends (0, $421348c10218bc50$export$2e2bcd8739ae039) {
    static register() {
        (0, $c868a5e4990268d1$export$2e2bcd8739ae039).register($95fd90350cc017ea$export$3b131632d3d15165);
    }
}
(0, $97zcJ._)($95fd90350cc017ea$export$2e2bcd8739ae039, "TAB", "  ");
class $95fd90350cc017ea$export$52f0f02147b12c03 extends (0, $fd4ff9e1d56c8673$export$2e2bcd8739ae039) {
}
$95fd90350cc017ea$export$52f0f02147b12c03.blotName = "code";
$95fd90350cc017ea$export$52f0f02147b12c03.tagName = "CODE";
$95fd90350cc017ea$export$2e2bcd8739ae039.blotName = "code-block";
$95fd90350cc017ea$export$2e2bcd8739ae039.className = "ql-code-block";
$95fd90350cc017ea$export$2e2bcd8739ae039.tagName = "DIV";
$95fd90350cc017ea$export$3b131632d3d15165.blotName = "code-block-container";
$95fd90350cc017ea$export$3b131632d3d15165.className = "ql-code-block-container";
$95fd90350cc017ea$export$3b131632d3d15165.tagName = "DIV";
$95fd90350cc017ea$export$3b131632d3d15165.allowedChildren = [
    $95fd90350cc017ea$export$2e2bcd8739ae039
];
$95fd90350cc017ea$export$2e2bcd8739ae039.allowedChildren = [
    (0, $44fdb97bacc13d2d$export$2e2bcd8739ae039),
    (0, $aac85a10314b6a4e$export$2e2bcd8739ae039),
    (0, $ff66e5de053048df$export$2e2bcd8739ae039)
];
$95fd90350cc017ea$export$2e2bcd8739ae039.requiredContainer = $95fd90350cc017ea$export$3b131632d3d15165;




const $0f48d508e188d6f9$var$config = {
    scope: (0, $8324d048851d53b4$export$775b6bb06e53a214).BLOCK,
    whitelist: [
        "rtl"
    ]
};
const $0f48d508e188d6f9$export$4158215dafad9efa = new (0, $8324d048851d53b4$export$217610c4183502d0)("direction", "dir", $0f48d508e188d6f9$var$config);
const $0f48d508e188d6f9$export$630028b3af294dec = new (0, $8324d048851d53b4$export$651d45509677cf07)("direction", "ql-direction", $0f48d508e188d6f9$var$config);
const $0f48d508e188d6f9$export$175979e518d1dfd1 = new (0, $8324d048851d53b4$export$7c8099bbfe87b94d)("direction", "direction", $0f48d508e188d6f9$var$config);



const $451e84313c3d6754$var$config = {
    scope: (0, $8324d048851d53b4$export$775b6bb06e53a214).INLINE,
    whitelist: [
        "serif",
        "monospace"
    ]
};
const $451e84313c3d6754$export$78a99ee601572ab = new (0, $8324d048851d53b4$export$651d45509677cf07)("font", "ql-font", $451e84313c3d6754$var$config);
class $451e84313c3d6754$var$FontStyleAttributor extends (0, $8324d048851d53b4$export$7c8099bbfe87b94d) {
    value(node) {
        return super.value(node).replace(/["']/g, "");
    }
}
const $451e84313c3d6754$export$23b468d4ca3f8c96 = new $451e84313c3d6754$var$FontStyleAttributor("font", "font-family", $451e84313c3d6754$var$config);



const $de0c2b1e0a6b32a7$export$c84684d52bca9684 = new (0, $8324d048851d53b4$export$651d45509677cf07)("size", "ql-size", {
    scope: (0, $8324d048851d53b4$export$775b6bb06e53a214).INLINE,
    whitelist: [
        "small",
        "large",
        "huge"
    ]
});
const $de0c2b1e0a6b32a7$export$5443b95a30e89ac5 = new (0, $8324d048851d53b4$export$7c8099bbfe87b94d)("size", "font-size", {
    scope: (0, $8324d048851d53b4$export$775b6bb06e53a214).INLINE,
    whitelist: [
        "10px",
        "18px",
        "32px"
    ]
});








const $a3554dec5716af91$var$debug = (0, $8673b628d4423f23$export$2e2bcd8739ae039)("quill:keyboard");
const $a3554dec5716af91$export$34a157fc58f3dd07 = /Mac/i.test(navigator.platform) ? "metaKey" : "ctrlKey";
class $a3554dec5716af91$export$2e2bcd8739ae039 extends (0, $0fe56fdf6098eabb$export$2e2bcd8739ae039) {
    static match(evt, binding) {
        if ([
            "altKey",
            "ctrlKey",
            "metaKey",
            "shiftKey"
        ].some((key)=>{
            return !!binding[key] !== evt[key] && binding[key] !== null;
        })) return false;
        return binding.key === evt.key || binding.key === evt.which;
    }
    addBinding(keyBinding) {
        let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const binding = $a3554dec5716af91$export$a3295358bff77e(keyBinding);
        if (binding == null) {
            $a3554dec5716af91$var$debug.warn("Attempted to add invalid keyboard binding", binding);
            return;
        }
        if (typeof context === "function") context = {
            handler: context
        };
        if (typeof handler === "function") handler = {
            handler: handler
        };
        const keys = Array.isArray(binding.key) ? binding.key : [
            binding.key
        ];
        keys.forEach((key)=>{
            const singleBinding = {
                ...binding,
                key: key,
                ...context,
                ...handler
            };
            this.bindings[singleBinding.key] = this.bindings[singleBinding.key] || [];
            this.bindings[singleBinding.key].push(singleBinding);
        });
    }
    listen() {
        this.quill.root.addEventListener("keydown", (evt)=>{
            if (evt.defaultPrevented || evt.isComposing) return;
            // evt.isComposing is false when pressing Enter/Backspace when composing in Safari
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            const isComposing = evt.keyCode === 229 && (evt.key === "Enter" || evt.key === "Backspace");
            if (isComposing) return;
            const bindings = (this.bindings[evt.key] || []).concat(this.bindings[evt.which] || []);
            const matches = bindings.filter((binding)=>$a3554dec5716af91$export$2e2bcd8739ae039.match(evt, binding));
            if (matches.length === 0) return;
            // @ts-expect-error
            const blot = (0, $c868a5e4990268d1$export$2e2bcd8739ae039).find(evt.target, true);
            if (blot && blot.scroll !== this.quill.scroll) return;
            const range = this.quill.getSelection();
            if (range == null || !this.quill.hasFocus()) return;
            const [line, offset] = this.quill.getLine(range.index);
            const [leafStart, offsetStart] = this.quill.getLeaf(range.index);
            const [leafEnd, offsetEnd] = range.length === 0 ? [
                leafStart,
                offsetStart
            ] : this.quill.getLeaf(range.index + range.length);
            const prefixText = leafStart instanceof (0, $8324d048851d53b4$export$10ac0c5716409de6) ? leafStart.value().slice(0, offsetStart) : "";
            const suffixText = leafEnd instanceof (0, $8324d048851d53b4$export$10ac0c5716409de6) ? leafEnd.value().slice(offsetEnd) : "";
            const curContext = {
                collapsed: range.length === 0,
                // @ts-expect-error Fix me later
                empty: range.length === 0 && line.length() <= 1,
                format: this.quill.getFormat(range),
                line: line,
                offset: offset,
                prefix: prefixText,
                suffix: suffixText,
                event: evt
            };
            const prevented = matches.some((binding)=>{
                if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
                if (binding.empty != null && binding.empty !== curContext.empty) return false;
                if (binding.offset != null && binding.offset !== curContext.offset) return false;
                if (Array.isArray(binding.format)) {
                    // any format is present
                    if (binding.format.every((name)=>curContext.format[name] == null)) return false;
                } else if (typeof binding.format === "object") {
                    // all formats must match
                    if (!Object.keys(binding.format).every((name)=>{
                        // @ts-expect-error Fix me later
                        if (binding.format[name] === true) return curContext.format[name] != null;
                        // @ts-expect-error Fix me later
                        if (binding.format[name] === false) return curContext.format[name] == null;
                        // @ts-expect-error Fix me later
                        return (0, $bb412d2abfa43c6c$export$2e2bcd8739ae039)(binding.format[name], curContext.format[name]);
                    })) return false;
                }
                if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
                if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
                // @ts-expect-error Fix me later
                return binding.handler.call(this, range, curContext, binding) !== true;
            });
            if (prevented) evt.preventDefault();
        });
    }
    handleBackspace(range, context) {
        // Check for astral symbols
        const length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
        if (range.index === 0 || this.quill.getLength() <= 1) return;
        let formats = {};
        const [line] = this.quill.getLine(range.index);
        let delta = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().retain(range.index - length).delete(length);
        if (context.offset === 0) {
            // Always deleting newline here, length always 1
            const [prev] = this.quill.getLine(range.index - 1);
            if (prev) {
                const isPrevLineEmpty = prev.statics.blotName === "block" && prev.length() <= 1;
                if (!isPrevLineEmpty) {
                    // @ts-expect-error Fix me later
                    const curFormats = line.formats();
                    const prevFormats = this.quill.getFormat(range.index - 1, 1);
                    formats = (0, $f5af2faee6afab08$exports.AttributeMap).diff(curFormats, prevFormats) || {};
                    if (Object.keys(formats).length > 0) {
                        // line.length() - 1 targets \n in line, another -1 for newline being deleted
                        const formatDelta = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))()// @ts-expect-error Fix me later
                        .retain(range.index + line.length() - 2).retain(1, formats);
                        delta = delta.compose(formatDelta);
                    }
                }
            }
        }
        this.quill.updateContents(delta, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
        this.quill.focus();
    }
    handleDelete(range, context) {
        // Check for astral symbols
        const length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
        if (range.index >= this.quill.getLength() - length) return;
        let formats = {};
        const [line] = this.quill.getLine(range.index);
        let delta = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().retain(range.index).delete(length);
        // @ts-expect-error Fix me later
        if (context.offset >= line.length() - 1) {
            const [next] = this.quill.getLine(range.index + 1);
            if (next) {
                // @ts-expect-error Fix me later
                const curFormats = line.formats();
                const nextFormats = this.quill.getFormat(range.index, 1);
                formats = (0, $f5af2faee6afab08$exports.AttributeMap).diff(curFormats, nextFormats) || {};
                if (Object.keys(formats).length > 0) delta = delta.retain(next.length() - 1).retain(1, formats);
            }
        }
        this.quill.updateContents(delta, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
        this.quill.focus();
    }
    handleDeleteRange(range) {
        $a3554dec5716af91$export$a6c813797f379898({
            range: range,
            quill: this.quill
        });
        this.quill.focus();
    }
    handleEnter(range, context) {
        const lineFormats = Object.keys(context.format).reduce((formats, format)=>{
            if (this.quill.scroll.query(format, (0, $8324d048851d53b4$export$775b6bb06e53a214).BLOCK) && !Array.isArray(context.format[format])) formats[format] = context.format[format];
            return formats;
        }, {});
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().retain(range.index).delete(range.length).insert("\n", lineFormats);
        this.quill.updateContents(delta, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
        this.quill.setSelection(range.index + 1, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.SILENT);
        this.quill.focus();
    }
    constructor(quill, options){
        super(quill, options);
        this.bindings = {};
        // @ts-expect-error Fix me later
        Object.keys(this.options.bindings).forEach((name)=>{
            // @ts-expect-error Fix me later
            if (this.options.bindings[name]) // @ts-expect-error Fix me later
            this.addBinding(this.options.bindings[name]);
        });
        this.addBinding({
            key: "Enter",
            shiftKey: null
        }, this.handleEnter);
        this.addBinding({
            key: "Enter",
            metaKey: null,
            ctrlKey: null,
            altKey: null
        }, ()=>{});
        if (/Firefox/i.test(navigator.userAgent)) {
            // Need to handle delete and backspace for Firefox in the general case #1171
            this.addBinding({
                key: "Backspace"
            }, {
                collapsed: true
            }, this.handleBackspace);
            this.addBinding({
                key: "Delete"
            }, {
                collapsed: true
            }, this.handleDelete);
        } else {
            this.addBinding({
                key: "Backspace"
            }, {
                collapsed: true,
                prefix: /^.?$/
            }, this.handleBackspace);
            this.addBinding({
                key: "Delete"
            }, {
                collapsed: true,
                suffix: /^.?$/
            }, this.handleDelete);
        }
        this.addBinding({
            key: "Backspace"
        }, {
            collapsed: false
        }, this.handleDeleteRange);
        this.addBinding({
            key: "Delete"
        }, {
            collapsed: false
        }, this.handleDeleteRange);
        this.addBinding({
            key: "Backspace",
            altKey: null,
            ctrlKey: null,
            metaKey: null,
            shiftKey: null
        }, {
            collapsed: true,
            offset: 0
        }, this.handleBackspace);
        this.listen();
    }
}
const $a3554dec5716af91$var$defaultOptions = {
    bindings: {
        bold: $a3554dec5716af91$var$makeFormatHandler("bold"),
        italic: $a3554dec5716af91$var$makeFormatHandler("italic"),
        underline: $a3554dec5716af91$var$makeFormatHandler("underline"),
        indent: {
            // highlight tab or tab at beginning of list, indent or blockquote
            key: "Tab",
            format: [
                "blockquote",
                "indent",
                "list"
            ],
            handler (range, context) {
                if (context.collapsed && context.offset !== 0) return true;
                this.quill.format("indent", "+1", (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
                return false;
            }
        },
        outdent: {
            key: "Tab",
            shiftKey: true,
            format: [
                "blockquote",
                "indent",
                "list"
            ],
            // highlight tab or tab at beginning of list, indent or blockquote
            handler (range, context) {
                if (context.collapsed && context.offset !== 0) return true;
                this.quill.format("indent", "-1", (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
                return false;
            }
        },
        "outdent backspace": {
            key: "Backspace",
            collapsed: true,
            shiftKey: null,
            metaKey: null,
            ctrlKey: null,
            altKey: null,
            format: [
                "indent",
                "list"
            ],
            offset: 0,
            handler (range, context) {
                if (context.format.indent != null) this.quill.format("indent", "-1", (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
                else if (context.format.list != null) this.quill.format("list", false, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
            }
        },
        "indent code-block": $a3554dec5716af91$var$makeCodeBlockHandler(true),
        "outdent code-block": $a3554dec5716af91$var$makeCodeBlockHandler(false),
        "remove tab": {
            key: "Tab",
            shiftKey: true,
            collapsed: true,
            prefix: /\t$/,
            handler (range) {
                this.quill.deleteText(range.index - 1, 1, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
            }
        },
        tab: {
            key: "Tab",
            handler (range, context) {
                if (context.format.table) return true;
                this.quill.history.cutoff();
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().retain(range.index).delete(range.length).insert("	");
                this.quill.updateContents(delta, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
                this.quill.history.cutoff();
                this.quill.setSelection(range.index + 1, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.SILENT);
                return false;
            }
        },
        "blockquote empty enter": {
            key: "Enter",
            collapsed: true,
            format: [
                "blockquote"
            ],
            empty: true,
            handler () {
                this.quill.format("blockquote", false, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
            }
        },
        "list empty enter": {
            key: "Enter",
            collapsed: true,
            format: [
                "list"
            ],
            empty: true,
            handler (range, context) {
                const formats = {
                    list: false
                };
                if (context.format.indent) formats.indent = false;
                this.quill.formatLine(range.index, range.length, formats, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
            }
        },
        "checklist enter": {
            key: "Enter",
            collapsed: true,
            format: {
                list: "checked"
            },
            handler (range) {
                const [line, offset] = this.quill.getLine(range.index);
                const formats = {
                    // @ts-expect-error Fix me later
                    ...line.formats(),
                    list: "checked"
                };
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().retain(range.index).insert("\n", formats)// @ts-expect-error Fix me later
                .retain(line.length() - offset - 1).retain(1, {
                    list: "unchecked"
                });
                this.quill.updateContents(delta, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
                this.quill.setSelection(range.index + 1, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.SILENT);
                this.quill.scrollSelectionIntoView();
            }
        },
        "header enter": {
            key: "Enter",
            collapsed: true,
            format: [
                "header"
            ],
            suffix: /^$/,
            handler (range, context) {
                const [line, offset] = this.quill.getLine(range.index);
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().retain(range.index).insert("\n", context.format)// @ts-expect-error Fix me later
                .retain(line.length() - offset - 1).retain(1, {
                    header: null
                });
                this.quill.updateContents(delta, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
                this.quill.setSelection(range.index + 1, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.SILENT);
                this.quill.scrollSelectionIntoView();
            }
        },
        "table backspace": {
            key: "Backspace",
            format: [
                "table"
            ],
            collapsed: true,
            offset: 0,
            handler () {}
        },
        "table delete": {
            key: "Delete",
            format: [
                "table"
            ],
            collapsed: true,
            suffix: /^$/,
            handler () {}
        },
        "table enter": {
            key: "Enter",
            shiftKey: null,
            format: [
                "table"
            ],
            handler (range) {
                const module = this.quill.getModule("table");
                if (module) {
                    // @ts-expect-error
                    const [table, row, cell, offset] = module.getTable(range);
                    const shift = $a3554dec5716af91$var$tableSide(table, row, cell, offset);
                    if (shift == null) return;
                    let index = table.offset();
                    if (shift < 0) {
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().retain(index).insert("\n");
                        this.quill.updateContents(delta, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
                        this.quill.setSelection(range.index + 1, range.length, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.SILENT);
                    } else if (shift > 0) {
                        index += table.length();
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().retain(index).insert("\n");
                        this.quill.updateContents(delta, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
                        this.quill.setSelection(index, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
                    }
                }
            }
        },
        "table tab": {
            key: "Tab",
            shiftKey: null,
            format: [
                "table"
            ],
            handler (range, context) {
                const { event: event, line: cell } = context;
                const offset = cell.offset(this.quill.scroll);
                if (event.shiftKey) this.quill.setSelection(offset - 1, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
                else this.quill.setSelection(offset + cell.length(), (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
            }
        },
        "list autofill": {
            key: " ",
            shiftKey: null,
            collapsed: true,
            format: {
                "code-block": false,
                blockquote: false,
                table: false
            },
            prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
            handler (range, context) {
                if (this.quill.scroll.query("list") == null) return true;
                const { length: length } = context.prefix;
                const [line, offset] = this.quill.getLine(range.index);
                if (offset > length) return true;
                let value;
                switch(context.prefix.trim()){
                    case "[]":
                    case "[ ]":
                        value = "unchecked";
                        break;
                    case "[x]":
                        value = "checked";
                        break;
                    case "-":
                    case "*":
                        value = "bullet";
                        break;
                    default:
                        value = "ordered";
                }
                this.quill.insertText(range.index, " ", (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
                this.quill.history.cutoff();
                const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().retain(range.index - offset).delete(length + 1)// @ts-expect-error Fix me later
                .retain(line.length() - 2 - offset).retain(1, {
                    list: value
                });
                this.quill.updateContents(delta, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
                this.quill.history.cutoff();
                this.quill.setSelection(range.index - length, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.SILENT);
                return false;
            }
        },
        "code exit": {
            key: "Enter",
            collapsed: true,
            format: [
                "code-block"
            ],
            prefix: /^$/,
            suffix: /^\s*$/,
            handler (range) {
                const [line, offset] = this.quill.getLine(range.index);
                let numLines = 2;
                let cur = line;
                while(cur != null && cur.length() <= 1 && cur.formats()["code-block"]){
                    // @ts-expect-error
                    cur = cur.prev;
                    numLines -= 1;
                    // Requisite prev lines are empty
                    if (numLines <= 0) {
                        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))()// @ts-expect-error Fix me later
                        .retain(range.index + line.length() - offset - 2).retain(1, {
                            "code-block": null
                        }).delete(1);
                        this.quill.updateContents(delta, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
                        this.quill.setSelection(range.index - 1, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.SILENT);
                        return false;
                    }
                }
                return true;
            }
        },
        "embed left": $a3554dec5716af91$var$makeEmbedArrowHandler("ArrowLeft", false),
        "embed left shift": $a3554dec5716af91$var$makeEmbedArrowHandler("ArrowLeft", true),
        "embed right": $a3554dec5716af91$var$makeEmbedArrowHandler("ArrowRight", false),
        "embed right shift": $a3554dec5716af91$var$makeEmbedArrowHandler("ArrowRight", true),
        "table down": $a3554dec5716af91$var$makeTableArrowHandler(false),
        "table up": $a3554dec5716af91$var$makeTableArrowHandler(true)
    }
};
$a3554dec5716af91$export$2e2bcd8739ae039.DEFAULTS = $a3554dec5716af91$var$defaultOptions;
function $a3554dec5716af91$var$makeCodeBlockHandler(indent) {
    return {
        key: "Tab",
        shiftKey: !indent,
        format: {
            "code-block": true
        },
        handler (range, _ref) {
            let { event: event } = _ref;
            const CodeBlock = this.quill.scroll.query("code-block");
            // @ts-expect-error
            const { TAB: TAB } = CodeBlock;
            if (range.length === 0 && !event.shiftKey) {
                this.quill.insertText(range.index, TAB, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
                this.quill.setSelection(range.index + TAB.length, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.SILENT);
                return;
            }
            const lines = range.length === 0 ? this.quill.getLines(range.index, 1) : this.quill.getLines(range);
            let { index: index, length: length } = range;
            lines.forEach((line, i)=>{
                if (indent) {
                    line.insertAt(0, TAB);
                    if (i === 0) index += TAB.length;
                    else length += TAB.length;
                // @ts-expect-error Fix me later
                } else if (line.domNode.textContent.startsWith(TAB)) {
                    line.deleteAt(0, TAB.length);
                    if (i === 0) index -= TAB.length;
                    else length -= TAB.length;
                }
            });
            this.quill.update((0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
            this.quill.setSelection(index, length, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.SILENT);
        }
    };
}
function $a3554dec5716af91$var$makeEmbedArrowHandler(key, shiftKey) {
    const where = key === "ArrowLeft" ? "prefix" : "suffix";
    return {
        key: key,
        shiftKey: shiftKey,
        altKey: null,
        [where]: /^$/,
        handler (range) {
            let { index: index } = range;
            if (key === "ArrowRight") index += range.length + 1;
            const [leaf] = this.quill.getLeaf(index);
            if (!(leaf instanceof (0, $8324d048851d53b4$export$297a1fa96f55f00f))) return true;
            if (key === "ArrowLeft") {
                if (shiftKey) this.quill.setSelection(range.index - 1, range.length + 1, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
                else this.quill.setSelection(range.index - 1, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
            } else if (shiftKey) this.quill.setSelection(range.index, range.length + 1, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
            else this.quill.setSelection(range.index + range.length + 1, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
            return false;
        }
    };
}
function $a3554dec5716af91$var$makeFormatHandler(format) {
    return {
        key: format[0],
        shortKey: true,
        handler (range, context) {
            this.quill.format(format, !context.format[format], (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
        }
    };
}
function $a3554dec5716af91$var$makeTableArrowHandler(up) {
    return {
        key: up ? "ArrowUp" : "ArrowDown",
        collapsed: true,
        format: [
            "table"
        ],
        handler (range, context) {
            // TODO move to table module
            const key = up ? "prev" : "next";
            const cell = context.line;
            const targetRow = cell.parent[key];
            if (targetRow != null) {
                if (targetRow.statics.blotName === "table-row") {
                    // @ts-expect-error
                    let targetCell = targetRow.children.head;
                    let cur = cell;
                    while(cur.prev != null){
                        // @ts-expect-error
                        cur = cur.prev;
                        targetCell = targetCell.next;
                    }
                    const index = targetCell.offset(this.quill.scroll) + Math.min(context.offset, targetCell.length() - 1);
                    this.quill.setSelection(index, 0, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
                }
            } else {
                // @ts-expect-error
                const targetLine = cell.table()[key];
                if (targetLine != null) {
                    if (up) this.quill.setSelection(targetLine.offset(this.quill.scroll) + targetLine.length() - 1, 0, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
                    else this.quill.setSelection(targetLine.offset(this.quill.scroll), 0, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
                }
            }
            return false;
        }
    };
}
function $a3554dec5716af91$export$a3295358bff77e(binding) {
    if (typeof binding === "string" || typeof binding === "number") binding = {
        key: binding
    };
    else if (typeof binding === "object") binding = (0, $668add1f662a6818$export$2e2bcd8739ae039)(binding);
    else return null;
    if (binding.shortKey) {
        binding[$a3554dec5716af91$export$34a157fc58f3dd07] = binding.shortKey;
        delete binding.shortKey;
    }
    return binding;
}
// TODO: Move into quill.ts or editor.ts
function $a3554dec5716af91$export$a6c813797f379898(_ref2) {
    let { quill: quill, range: range } = _ref2;
    const lines = quill.getLines(range);
    let formats = {};
    if (lines.length > 1) {
        const firstFormats = lines[0].formats();
        const lastFormats = lines[lines.length - 1].formats();
        formats = (0, $f5af2faee6afab08$exports.AttributeMap).diff(lastFormats, firstFormats) || {};
    }
    quill.deleteText(range, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
    if (Object.keys(formats).length > 0) quill.formatLine(range.index, 1, formats, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
    quill.setSelection(range.index, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.SILENT);
}
function $a3554dec5716af91$var$tableSide(_table, row, cell, offset) {
    if (row.prev == null && row.next == null) {
        if (cell.prev == null && cell.next == null) return offset === 0 ? -1 : 1;
        return cell.prev == null ? -1 : 1;
    }
    if (row.prev == null) return -1;
    if (row.next == null) return 1;
    return null;
}


const $6eeddaada38b4da8$var$normalWeightRegexp = /font-weight:\s*normal/;
const $6eeddaada38b4da8$var$blockTagNames = [
    "P",
    "OL",
    "UL"
];
const $6eeddaada38b4da8$var$isBlockElement = (element)=>{
    return element && $6eeddaada38b4da8$var$blockTagNames.includes(element.tagName);
};
const $6eeddaada38b4da8$var$normalizeEmptyLines = (doc)=>{
    Array.from(doc.querySelectorAll("br")).filter((br)=>$6eeddaada38b4da8$var$isBlockElement(br.previousElementSibling) && $6eeddaada38b4da8$var$isBlockElement(br.nextElementSibling)).forEach((br)=>{
        br.parentNode?.removeChild(br);
    });
};
const $6eeddaada38b4da8$var$normalizeFontWeight = (doc)=>{
    Array.from(doc.querySelectorAll('b[style*="font-weight"]')).filter((node)=>node.getAttribute("style")?.match($6eeddaada38b4da8$var$normalWeightRegexp)).forEach((node)=>{
        const fragment = doc.createDocumentFragment();
        fragment.append(...node.childNodes);
        node.parentNode?.replaceChild(fragment, node);
    });
};
function $6eeddaada38b4da8$export$2e2bcd8739ae039(doc) {
    if (doc.querySelector('[id^="docs-internal-guid-"]')) {
        $6eeddaada38b4da8$var$normalizeFontWeight(doc);
        $6eeddaada38b4da8$var$normalizeEmptyLines(doc);
    }
}


const $92166360b0b4ae68$var$ignoreRegexp = /\bmso-list:[^;]*ignore/i;
const $92166360b0b4ae68$var$idRegexp = /\bmso-list:[^;]*\bl(\d+)/i;
const $92166360b0b4ae68$var$indentRegexp = /\bmso-list:[^;]*\blevel(\d+)/i;
const $92166360b0b4ae68$var$parseListItem = (element, html)=>{
    const style = element.getAttribute("style");
    const idMatch = style?.match($92166360b0b4ae68$var$idRegexp);
    if (!idMatch) return null;
    const id = Number(idMatch[1]);
    const indentMatch = style?.match($92166360b0b4ae68$var$indentRegexp);
    const indent = indentMatch ? Number(indentMatch[1]) : 1;
    const typeRegexp = new RegExp(`@list l${id}:level${indent}\\s*\\{[^\\}]*mso-level-number-format:\\s*([\\w-]+)`, "i");
    const typeMatch = html.match(typeRegexp);
    const type = typeMatch && typeMatch[1] === "bullet" ? "bullet" : "ordered";
    return {
        id: id,
        indent: indent,
        type: type,
        element: element
    };
};
// list items are represented as `p` tags with styles like `mso-list: l0 level1` where:
// 1. "0" in "l0" means the list item id;
// 2. "1" in "level1" means the indent level, starting from 1.
const $92166360b0b4ae68$var$normalizeListItem = (doc)=>{
    const msoList = Array.from(doc.querySelectorAll("[style*=mso-list]"));
    const ignored = [];
    const others = [];
    msoList.forEach((node)=>{
        const shouldIgnore = (node.getAttribute("style") || "").match($92166360b0b4ae68$var$ignoreRegexp);
        if (shouldIgnore) ignored.push(node);
        else others.push(node);
    });
    // Each list item contains a marker wrapped with "mso-list: Ignore".
    ignored.forEach((node)=>node.parentNode?.removeChild(node));
    // The list stype is not defined inline with the tag, instead, it's in the
    // style tag so we need to pass the html as a string.
    const html = doc.documentElement.innerHTML;
    const listItems = others.map((element)=>$92166360b0b4ae68$var$parseListItem(element, html)).filter((parsed)=>parsed);
    while(listItems.length){
        const childListItems = [];
        let current = listItems.shift();
        // Group continuous items into the same group (aka "ul")
        while(current){
            childListItems.push(current);
            current = listItems.length && listItems[0]?.element === current.element.nextElementSibling && // Different id means the next item doesn't belong to this group.
            listItems[0].id === current.id ? listItems.shift() : null;
        }
        const ul = document.createElement("ul");
        childListItems.forEach((listItem)=>{
            const li = document.createElement("li");
            li.setAttribute("data-list", listItem.type);
            if (listItem.indent > 1) li.setAttribute("class", `ql-indent-${listItem.indent - 1}`);
            li.innerHTML = listItem.element.innerHTML;
            ul.appendChild(li);
        });
        const element = childListItems[0]?.element;
        const { parentNode: parentNode } = element ?? {};
        if (element) parentNode?.replaceChild(ul, element);
        childListItems.slice(1).forEach((_ref)=>{
            let { element: e } = _ref;
            parentNode?.removeChild(e);
        });
    }
};
function $92166360b0b4ae68$export$2e2bcd8739ae039(doc) {
    if (doc.documentElement.getAttribute("xmlns:w") === "urn:schemas-microsoft-com:office:word") $92166360b0b4ae68$var$normalizeListItem(doc);
}


const $dd2930e583ecfebd$var$NORMALIZERS = [
    (0, $92166360b0b4ae68$export$2e2bcd8739ae039),
    (0, $6eeddaada38b4da8$export$2e2bcd8739ae039)
];
const $dd2930e583ecfebd$var$normalizeExternalHTML = (doc)=>{
    if (doc.documentElement) $dd2930e583ecfebd$var$NORMALIZERS.forEach((normalize)=>{
        normalize(doc);
    });
};
var $dd2930e583ecfebd$export$2e2bcd8739ae039 = $dd2930e583ecfebd$var$normalizeExternalHTML;


const $1db49f8428c77f89$var$debug = (0, $8673b628d4423f23$export$2e2bcd8739ae039)("quill:clipboard");
const $1db49f8428c77f89$var$CLIPBOARD_CONFIG = [
    [
        Node.TEXT_NODE,
        $1db49f8428c77f89$export$9b884371b5570711
    ],
    [
        Node.TEXT_NODE,
        $1db49f8428c77f89$export$c695b9637111f586
    ],
    [
        "br",
        $1db49f8428c77f89$var$matchBreak
    ],
    [
        Node.ELEMENT_NODE,
        $1db49f8428c77f89$export$c695b9637111f586
    ],
    [
        Node.ELEMENT_NODE,
        $1db49f8428c77f89$export$e9719de873a22c03
    ],
    [
        Node.ELEMENT_NODE,
        $1db49f8428c77f89$export$7da59a717dc94488
    ],
    [
        Node.ELEMENT_NODE,
        $1db49f8428c77f89$var$matchStyles
    ],
    [
        "li",
        $1db49f8428c77f89$var$matchIndent
    ],
    [
        "ol, ul",
        $1db49f8428c77f89$var$matchList
    ],
    [
        "pre",
        $1db49f8428c77f89$var$matchCodeBlock
    ],
    [
        "tr",
        $1db49f8428c77f89$var$matchTable
    ],
    [
        "b",
        $1db49f8428c77f89$var$createMatchAlias("bold")
    ],
    [
        "i",
        $1db49f8428c77f89$var$createMatchAlias("italic")
    ],
    [
        "strike",
        $1db49f8428c77f89$var$createMatchAlias("strike")
    ],
    [
        "style",
        $1db49f8428c77f89$var$matchIgnore
    ]
];
const $1db49f8428c77f89$var$ATTRIBUTE_ATTRIBUTORS = [
    (0, $fabb70fc3b74eee9$export$2ef0f9fb04a51388),
    (0, $0f48d508e188d6f9$export$4158215dafad9efa)
].reduce((memo, attr)=>{
    memo[attr.keyName] = attr;
    return memo;
}, {});
const $1db49f8428c77f89$var$STYLE_ATTRIBUTORS = [
    (0, $fabb70fc3b74eee9$export$d2060f5d114c9fe8),
    (0, $34ad99861d7d9ec9$export$dc1cbcab4c682ef),
    (0, $e83e82854e7f7981$export$1415f56796d9a5a9),
    (0, $0f48d508e188d6f9$export$175979e518d1dfd1),
    (0, $451e84313c3d6754$export$23b468d4ca3f8c96),
    (0, $de0c2b1e0a6b32a7$export$5443b95a30e89ac5)
].reduce((memo, attr)=>{
    memo[attr.keyName] = attr;
    return memo;
}, {});
class $1db49f8428c77f89$export$2e2bcd8739ae039 extends (0, $0fe56fdf6098eabb$export$2e2bcd8739ae039) {
    addMatcher(selector, matcher) {
        this.matchers.push([
            selector,
            matcher
        ]);
    }
    convert(_ref2) {
        let { html: html, text: text } = _ref2;
        let formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (formats[(0, $95fd90350cc017ea$export$2e2bcd8739ae039).blotName]) return new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().insert(text || "", {
            [(0, $95fd90350cc017ea$export$2e2bcd8739ae039).blotName]: formats[(0, $95fd90350cc017ea$export$2e2bcd8739ae039).blotName]
        });
        if (!html) return new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().insert(text || "", formats);
        const delta = this.convertHTML(html);
        // Remove trailing newline
        if ($1db49f8428c77f89$var$deltaEndsWith(delta, "\n") && (delta.ops[delta.ops.length - 1].attributes == null || formats.table)) return delta.compose(new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().retain(delta.length() - 1).delete(1));
        return delta;
    }
    normalizeHTML(doc) {
        (0, $dd2930e583ecfebd$export$2e2bcd8739ae039)(doc);
    }
    convertHTML(html) {
        const doc = new DOMParser().parseFromString(html, "text/html");
        this.normalizeHTML(doc);
        const container = doc.body;
        const nodeMatches = new WeakMap();
        const [elementMatchers, textMatchers] = this.prepareMatching(container, nodeMatches);
        return $1db49f8428c77f89$export$df3f009e3d155b20(this.quill.scroll, container, elementMatchers, textMatchers, nodeMatches);
    }
    dangerouslyPasteHTML(index, html) {
        let source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.API;
        if (typeof index === "string") {
            const delta = this.convert({
                html: index,
                text: ""
            });
            // @ts-expect-error
            this.quill.setContents(delta, html);
            this.quill.setSelection(0, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.SILENT);
        } else {
            const paste = this.convert({
                html: html,
                text: ""
            });
            this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().retain(index).concat(paste), source);
            this.quill.setSelection(index + paste.length(), (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.SILENT);
        }
    }
    onCaptureCopy(e) {
        let isCut = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (e.defaultPrevented) return;
        e.preventDefault();
        const [range] = this.quill.selection.getRange();
        if (range == null) return;
        const { html: html, text: text } = this.onCopy(range, isCut);
        e.clipboardData?.setData("text/plain", text);
        e.clipboardData?.setData("text/html", html);
        if (isCut) (0, $a3554dec5716af91$export$a6c813797f379898)({
            range: range,
            quill: this.quill
        });
    }
    /*
   * https://www.iana.org/assignments/media-types/text/uri-list
   */ normalizeURIList(urlList) {
        return urlList.split(/\r?\n/)// Ignore all comments
        .filter((url)=>url[0] !== "#").join("\n");
    }
    onCapturePaste(e) {
        if (e.defaultPrevented || !this.quill.isEnabled()) return;
        e.preventDefault();
        const range = this.quill.getSelection(true);
        if (range == null) return;
        const html = e.clipboardData?.getData("text/html");
        let text = e.clipboardData?.getData("text/plain");
        if (!html && !text) {
            const urlList = e.clipboardData?.getData("text/uri-list");
            if (urlList) text = this.normalizeURIList(urlList);
        }
        const files = Array.from(e.clipboardData?.files || []);
        if (!html && files.length > 0) {
            this.quill.uploader.upload(range, files);
            return;
        }
        if (html && files.length > 0) {
            const doc = new DOMParser().parseFromString(html, "text/html");
            if (doc.body.childElementCount === 1 && doc.body.firstElementChild?.tagName === "IMG") {
                this.quill.uploader.upload(range, files);
                return;
            }
        }
        this.onPaste(range, {
            html: html,
            text: text
        });
    }
    onCopy(range) {
        const text = this.quill.getText(range);
        const html = this.quill.getSemanticHTML(range);
        return {
            html: html,
            text: text
        };
    }
    onPaste(range, _ref3) {
        let { text: text, html: html } = _ref3;
        const formats = this.quill.getFormat(range.index);
        const pastedDelta = this.convert({
            text: text,
            html: html
        }, formats);
        $1db49f8428c77f89$var$debug.log("onPaste", pastedDelta, {
            text: text,
            html: html
        });
        const delta = new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().retain(range.index).delete(range.length).concat(pastedDelta);
        this.quill.updateContents(delta, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
        // range.length contributes to delta.length()
        this.quill.setSelection(delta.length() - range.length, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.SILENT);
        this.quill.scrollSelectionIntoView();
    }
    prepareMatching(container, nodeMatches) {
        const elementMatchers = [];
        const textMatchers = [];
        this.matchers.forEach((pair)=>{
            const [selector, matcher] = pair;
            switch(selector){
                case Node.TEXT_NODE:
                    textMatchers.push(matcher);
                    break;
                case Node.ELEMENT_NODE:
                    elementMatchers.push(matcher);
                    break;
                default:
                    Array.from(container.querySelectorAll(selector)).forEach((node)=>{
                        if (nodeMatches.has(node)) {
                            const matches = nodeMatches.get(node);
                            matches?.push(matcher);
                        } else nodeMatches.set(node, [
                            matcher
                        ]);
                    });
                    break;
            }
        });
        return [
            elementMatchers,
            textMatchers
        ];
    }
    constructor(quill, options){
        super(quill, options);
        this.quill.root.addEventListener("copy", (e)=>this.onCaptureCopy(e, false));
        this.quill.root.addEventListener("cut", (e)=>this.onCaptureCopy(e, true));
        this.quill.root.addEventListener("paste", this.onCapturePaste.bind(this));
        this.matchers = [];
        $1db49f8428c77f89$var$CLIPBOARD_CONFIG.concat(this.options.matchers ?? []).forEach((_ref)=>{
            let [selector, matcher] = _ref;
            this.addMatcher(selector, matcher);
        });
    }
}
(0, $97zcJ._)($1db49f8428c77f89$export$2e2bcd8739ae039, "DEFAULTS", {
    matchers: []
});
function $1db49f8428c77f89$var$applyFormat(delta, format, value, scroll) {
    if (!scroll.query(format)) return delta;
    return delta.reduce((newDelta, op)=>{
        if (!op.insert) return newDelta;
        if (op.attributes && op.attributes[format]) return newDelta.push(op);
        const formats = value ? {
            [format]: value
        } : {};
        return newDelta.insert(op.insert, {
            ...formats,
            ...op.attributes
        });
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))());
}
function $1db49f8428c77f89$var$deltaEndsWith(delta, text) {
    let endText = "";
    for(let i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i // eslint-disable-line no-plusplus
    ){
        const op = delta.ops[i];
        if (typeof op.insert !== "string") break;
        endText = op.insert + endText;
    }
    return endText.slice(-1 * text.length) === text;
}
function $1db49f8428c77f89$var$isLine(node, scroll) {
    if (!(node instanceof Element)) return false;
    const match = scroll.query(node);
    // @ts-expect-error
    if (match && match.prototype instanceof (0, $8324d048851d53b4$export$297a1fa96f55f00f)) return false;
    return [
        "address",
        "article",
        "blockquote",
        "canvas",
        "dd",
        "div",
        "dl",
        "dt",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "header",
        "iframe",
        "li",
        "main",
        "nav",
        "ol",
        "output",
        "p",
        "pre",
        "section",
        "table",
        "td",
        "tr",
        "ul",
        "video"
    ].includes(node.tagName.toLowerCase());
}
function $1db49f8428c77f89$var$isBetweenInlineElements(node, scroll) {
    return node.previousElementSibling && node.nextElementSibling && !$1db49f8428c77f89$var$isLine(node.previousElementSibling, scroll) && !$1db49f8428c77f89$var$isLine(node.nextElementSibling, scroll);
}
const $1db49f8428c77f89$var$preNodes = new WeakMap();
function $1db49f8428c77f89$var$isPre(node) {
    if (node == null) return false;
    if (!$1db49f8428c77f89$var$preNodes.has(node)) {
        // @ts-expect-error
        if (node.tagName === "PRE") $1db49f8428c77f89$var$preNodes.set(node, true);
        else $1db49f8428c77f89$var$preNodes.set(node, $1db49f8428c77f89$var$isPre(node.parentNode));
    }
    return $1db49f8428c77f89$var$preNodes.get(node);
}
function $1db49f8428c77f89$export$df3f009e3d155b20(scroll, node, elementMatchers, textMatchers, nodeMatches) {
    // Post-order
    if (node.nodeType === node.TEXT_NODE) return textMatchers.reduce((delta, matcher)=>{
        return matcher(node, delta, scroll);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))());
    if (node.nodeType === node.ELEMENT_NODE) return Array.from(node.childNodes || []).reduce((delta, childNode)=>{
        let childrenDelta = $1db49f8428c77f89$export$df3f009e3d155b20(scroll, childNode, elementMatchers, textMatchers, nodeMatches);
        if (childNode.nodeType === node.ELEMENT_NODE) {
            childrenDelta = elementMatchers.reduce((reducedDelta, matcher)=>{
                return matcher(childNode, reducedDelta, scroll);
            }, childrenDelta);
            childrenDelta = (nodeMatches.get(childNode) || []).reduce((reducedDelta, matcher)=>{
                return matcher(childNode, reducedDelta, scroll);
            }, childrenDelta);
        }
        return delta.concat(childrenDelta);
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))());
    return new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))();
}
function $1db49f8428c77f89$var$createMatchAlias(format) {
    return (_node, delta, scroll)=>{
        return $1db49f8428c77f89$var$applyFormat(delta, format, true, scroll);
    };
}
function $1db49f8428c77f89$export$7da59a717dc94488(node, delta, scroll) {
    const attributes = (0, $8324d048851d53b4$export$217610c4183502d0).keys(node);
    const classes = (0, $8324d048851d53b4$export$651d45509677cf07).keys(node);
    const styles = (0, $8324d048851d53b4$export$7c8099bbfe87b94d).keys(node);
    const formats = {};
    attributes.concat(classes).concat(styles).forEach((name)=>{
        let attr = scroll.query(name, (0, $8324d048851d53b4$export$775b6bb06e53a214).ATTRIBUTE);
        if (attr != null) {
            formats[attr.attrName] = attr.value(node);
            if (formats[attr.attrName]) return;
        }
        attr = $1db49f8428c77f89$var$ATTRIBUTE_ATTRIBUTORS[name];
        if (attr != null && (attr.attrName === name || attr.keyName === name)) formats[attr.attrName] = attr.value(node) || undefined;
        attr = $1db49f8428c77f89$var$STYLE_ATTRIBUTORS[name];
        if (attr != null && (attr.attrName === name || attr.keyName === name)) {
            attr = $1db49f8428c77f89$var$STYLE_ATTRIBUTORS[name];
            formats[attr.attrName] = attr.value(node) || undefined;
        }
    });
    return Object.entries(formats).reduce((newDelta, _ref4)=>{
        let [name, value] = _ref4;
        return $1db49f8428c77f89$var$applyFormat(newDelta, name, value, scroll);
    }, delta);
}
function $1db49f8428c77f89$export$e9719de873a22c03(node, delta, scroll) {
    const match = scroll.query(node);
    if (match == null) return delta;
    // @ts-expect-error
    if (match.prototype instanceof (0, $8324d048851d53b4$export$297a1fa96f55f00f)) {
        const embed = {};
        // @ts-expect-error
        const value = match.value(node);
        if (value != null) {
            // @ts-expect-error
            embed[match.blotName] = value;
            // @ts-expect-error
            return new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().insert(embed, match.formats(node, scroll));
        }
    } else {
        // @ts-expect-error
        if (match.prototype instanceof (0, $8324d048851d53b4$export$4f7f03641f7bfc8c) && !$1db49f8428c77f89$var$deltaEndsWith(delta, "\n")) delta.insert("\n");
        if ("blotName" in match && "formats" in match && typeof match.formats === "function") return $1db49f8428c77f89$var$applyFormat(delta, match.blotName, match.formats(node, scroll), scroll);
    }
    return delta;
}
function $1db49f8428c77f89$var$matchBreak(node, delta) {
    if (!$1db49f8428c77f89$var$deltaEndsWith(delta, "\n")) delta.insert("\n");
    return delta;
}
function $1db49f8428c77f89$var$matchCodeBlock(node, delta, scroll) {
    const match = scroll.query("code-block");
    const language = match && "formats" in match && typeof match.formats === "function" ? match.formats(node, scroll) : true;
    return $1db49f8428c77f89$var$applyFormat(delta, "code-block", language, scroll);
}
function $1db49f8428c77f89$var$matchIgnore() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))();
}
function $1db49f8428c77f89$var$matchIndent(node, delta, scroll) {
    const match = scroll.query(node);
    if (match == null || // @ts-expect-error
    match.blotName !== "list" || !$1db49f8428c77f89$var$deltaEndsWith(delta, "\n")) return delta;
    let indent = -1;
    let parent = node.parentNode;
    while(parent != null){
        // @ts-expect-error
        if ([
            "OL",
            "UL"
        ].includes(parent.tagName)) indent += 1;
        parent = parent.parentNode;
    }
    if (indent <= 0) return delta;
    return delta.reduce((composed, op)=>{
        if (!op.insert) return composed;
        if (op.attributes && typeof op.attributes.indent === "number") return composed.push(op);
        return composed.insert(op.insert, {
            indent: indent,
            ...op.attributes || {}
        });
    }, new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))());
}
function $1db49f8428c77f89$var$matchList(node, delta, scroll) {
    const element = node;
    let list = element.tagName === "OL" ? "ordered" : "bullet";
    const checkedAttr = element.getAttribute("data-checked");
    if (checkedAttr) list = checkedAttr === "true" ? "checked" : "unchecked";
    return $1db49f8428c77f89$var$applyFormat(delta, "list", list, scroll);
}
function $1db49f8428c77f89$export$c695b9637111f586(node, delta, scroll) {
    if (!$1db49f8428c77f89$var$deltaEndsWith(delta, "\n")) {
        if ($1db49f8428c77f89$var$isLine(node, scroll) && (node.childNodes.length > 0 || node instanceof HTMLParagraphElement)) return delta.insert("\n");
        if (delta.length() > 0 && node.nextSibling) {
            let nextSibling = node.nextSibling;
            while(nextSibling != null){
                if ($1db49f8428c77f89$var$isLine(nextSibling, scroll)) return delta.insert("\n");
                const match = scroll.query(nextSibling);
                // @ts-expect-error
                if (match && match.prototype instanceof (0, $421348c10218bc50$export$48b9f0688962d028)) return delta.insert("\n");
                nextSibling = nextSibling.firstChild;
            }
        }
    }
    return delta;
}
function $1db49f8428c77f89$var$matchStyles(node, delta, scroll) {
    const formats = {};
    const style = node.style || {};
    if (style.fontStyle === "italic") formats.italic = true;
    if (style.textDecoration === "underline") formats.underline = true;
    if (style.textDecoration === "line-through") formats.strike = true;
    if (style.fontWeight?.startsWith("bold") || // @ts-expect-error Fix me later
    parseInt(style.fontWeight, 10) >= 700) formats.bold = true;
    delta = Object.entries(formats).reduce((newDelta, _ref5)=>{
        let [name, value] = _ref5;
        return $1db49f8428c77f89$var$applyFormat(newDelta, name, value, scroll);
    }, delta);
    // @ts-expect-error
    if (parseFloat(style.textIndent || 0) > 0) // Could be 0.5in
    return new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().insert("	").concat(delta);
    return delta;
}
function $1db49f8428c77f89$var$matchTable(node, delta, scroll) {
    const table = node.parentElement?.tagName === "TABLE" ? node.parentElement : node.parentElement?.parentElement;
    if (table != null) {
        const rows = Array.from(table.querySelectorAll("tr"));
        const row = rows.indexOf(node) + 1;
        return $1db49f8428c77f89$var$applyFormat(delta, "table", row, scroll);
    }
    return delta;
}
function $1db49f8428c77f89$export$9b884371b5570711(node, delta, scroll) {
    // @ts-expect-error
    let text = node.data;
    // Word represents empty line with <o:p>&nbsp;</o:p>
    if (node.parentElement?.tagName === "O:P") return delta.insert(text.trim());
    if (!$1db49f8428c77f89$var$isPre(node)) {
        if (text.trim().length === 0 && text.includes("\n") && !$1db49f8428c77f89$var$isBetweenInlineElements(node, scroll)) return delta;
        // convert all non-nbsp whitespace into regular space
        text = text.replace(/[^\S\u00a0]/g, " ");
        // collapse consecutive spaces into one
        text = text.replace(/ {2,}/g, " ");
        if (node.previousSibling == null && node.parentElement != null && $1db49f8428c77f89$var$isLine(node.parentElement, scroll) || node.previousSibling instanceof Element && $1db49f8428c77f89$var$isLine(node.previousSibling, scroll)) // block structure means we don't need leading space
        text = text.replace(/^ /, "");
        if (node.nextSibling == null && node.parentElement != null && $1db49f8428c77f89$var$isLine(node.parentElement, scroll) || node.nextSibling instanceof Element && $1db49f8428c77f89$var$isLine(node.nextSibling, scroll)) // block structure means we don't need trailing space
        text = text.replace(/ $/, "");
        // done removing whitespace and can normalize all to regular space
        text = text.replaceAll("\xa0", " ");
    }
    return delta.insert(text);
}



var $97zcJ = parcelRequire("97zcJ");



class $3737a1635e95f12e$export$2e2bcd8739ae039 extends (0, $0fe56fdf6098eabb$export$2e2bcd8739ae039) {
    change(source, dest) {
        if (this.stack[source].length === 0) return;
        const item = this.stack[source].pop();
        if (!item) return;
        const base = this.quill.getContents();
        const inverseDelta = item.delta.invert(base);
        this.stack[dest].push({
            delta: inverseDelta,
            range: $3737a1635e95f12e$var$transformRange(item.range, inverseDelta)
        });
        this.lastRecorded = 0;
        this.ignoreChange = true;
        this.quill.updateContents(item.delta, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
        this.ignoreChange = false;
        this.restoreSelection(item);
    }
    clear() {
        this.stack = {
            undo: [],
            redo: []
        };
    }
    cutoff() {
        this.lastRecorded = 0;
    }
    record(changeDelta, oldDelta) {
        if (changeDelta.ops.length === 0) return;
        this.stack.redo = [];
        let undoDelta = changeDelta.invert(oldDelta);
        let undoRange = this.currentRange;
        const timestamp = Date.now();
        if (// @ts-expect-error Fix me later
        this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
            const item = this.stack.undo.pop();
            if (item) {
                undoDelta = undoDelta.compose(item.delta);
                undoRange = item.range;
            }
        } else this.lastRecorded = timestamp;
        if (undoDelta.length() === 0) return;
        this.stack.undo.push({
            delta: undoDelta,
            range: undoRange
        });
        // @ts-expect-error Fix me later
        if (this.stack.undo.length > this.options.maxStack) this.stack.undo.shift();
    }
    redo() {
        this.change("redo", "undo");
    }
    transform(delta) {
        $3737a1635e95f12e$var$transformStack(this.stack.undo, delta);
        $3737a1635e95f12e$var$transformStack(this.stack.redo, delta);
    }
    undo() {
        this.change("undo", "redo");
    }
    restoreSelection(stackItem) {
        if (stackItem.range) this.quill.setSelection(stackItem.range, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
        else {
            const index = $3737a1635e95f12e$export$64042f78dc41d29e(this.quill.scroll, stackItem.delta);
            this.quill.setSelection(index, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
        }
    }
    constructor(quill, options){
        super(quill, options);
        (0, $97zcJ._)(this, "lastRecorded", 0);
        (0, $97zcJ._)(this, "ignoreChange", false);
        (0, $97zcJ._)(this, "stack", {
            undo: [],
            redo: []
        });
        (0, $97zcJ._)(this, "currentRange", null);
        this.quill.on((0, $c868a5e4990268d1$export$2e2bcd8739ae039).events.EDITOR_CHANGE, (eventName, value, oldValue, source)=>{
            if (eventName === (0, $c868a5e4990268d1$export$2e2bcd8739ae039).events.SELECTION_CHANGE) {
                if (value && source !== (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.SILENT) this.currentRange = value;
            } else if (eventName === (0, $c868a5e4990268d1$export$2e2bcd8739ae039).events.TEXT_CHANGE) {
                if (!this.ignoreChange) {
                    if (!this.options.userOnly || source === (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER) this.record(value, oldValue);
                    else this.transform(value);
                }
                this.currentRange = $3737a1635e95f12e$var$transformRange(this.currentRange, value);
            }
        });
        this.quill.keyboard.addBinding({
            key: "z",
            shortKey: true
        }, this.undo.bind(this));
        this.quill.keyboard.addBinding({
            key: [
                "z",
                "Z"
            ],
            shortKey: true,
            shiftKey: true
        }, this.redo.bind(this));
        if (/Win/i.test(navigator.platform)) this.quill.keyboard.addBinding({
            key: "y",
            shortKey: true
        }, this.redo.bind(this));
        this.quill.root.addEventListener("beforeinput", (event)=>{
            if (event.inputType === "historyUndo") {
                this.undo();
                event.preventDefault();
            } else if (event.inputType === "historyRedo") {
                this.redo();
                event.preventDefault();
            }
        });
    }
}
(0, $97zcJ._)($3737a1635e95f12e$export$2e2bcd8739ae039, "DEFAULTS", {
    delay: 1000,
    maxStack: 100,
    userOnly: false
});
function $3737a1635e95f12e$var$transformStack(stack, delta) {
    let remoteDelta = delta;
    for(let i = stack.length - 1; i >= 0; i -= 1){
        const oldItem = stack[i];
        stack[i] = {
            delta: remoteDelta.transform(oldItem.delta, true),
            range: oldItem.range && $3737a1635e95f12e$var$transformRange(oldItem.range, remoteDelta)
        };
        remoteDelta = oldItem.delta.transform(remoteDelta);
        if (stack[i].delta.length() === 0) stack.splice(i, 1);
    }
}
function $3737a1635e95f12e$var$endsWithNewlineChange(scroll, delta) {
    const lastOp = delta.ops[delta.ops.length - 1];
    if (lastOp == null) return false;
    if (lastOp.insert != null) return typeof lastOp.insert === "string" && lastOp.insert.endsWith("\n");
    if (lastOp.attributes != null) return Object.keys(lastOp.attributes).some((attr)=>{
        return scroll.query(attr, (0, $8324d048851d53b4$export$775b6bb06e53a214).BLOCK) != null;
    });
    return false;
}
function $3737a1635e95f12e$export$64042f78dc41d29e(scroll, delta) {
    const deleteLength = delta.reduce((length, op)=>{
        return length + (op.delete || 0);
    }, 0);
    let changeIndex = delta.length() - deleteLength;
    if ($3737a1635e95f12e$var$endsWithNewlineChange(scroll, delta)) changeIndex -= 1;
    return changeIndex;
}
function $3737a1635e95f12e$var$transformRange(range, delta) {
    if (!range) return range;
    const start = delta.transformPosition(range.index);
    const end = delta.transformPosition(range.index + range.length);
    return {
        index: start,
        length: end - start
    };
}






class $e6552ee1597b1e5d$var$Uploader extends (0, $0fe56fdf6098eabb$export$2e2bcd8739ae039) {
    upload(range, files) {
        const uploads = [];
        Array.from(files).forEach((file)=>{
            if (file && this.options.mimetypes?.includes(file.type)) uploads.push(file);
        });
        if (uploads.length > 0) // @ts-expect-error Fix me later
        this.options.handler.call(this, range, uploads);
    }
    constructor(quill, options){
        super(quill, options);
        quill.root.addEventListener("drop", (e)=>{
            e.preventDefault();
            let native = null;
            if (document.caretRangeFromPoint) native = document.caretRangeFromPoint(e.clientX, e.clientY);
            else if (document.caretPositionFromPoint) {
                // @ts-expect-error
                const position = document.caretPositionFromPoint(e.clientX, e.clientY);
                native = document.createRange();
                native.setStart(position.offsetNode, position.offset);
                native.setEnd(position.offsetNode, position.offset);
            }
            const normalized = native && quill.selection.normalizeNative(native);
            if (normalized) {
                const range = quill.selection.normalizedToRange(normalized);
                if (e.dataTransfer?.files) this.upload(range, e.dataTransfer.files);
            }
        });
    }
}
$e6552ee1597b1e5d$var$Uploader.DEFAULTS = {
    mimetypes: [
        "image/png",
        "image/jpeg"
    ],
    handler (range, files) {
        if (!this.quill.scroll.query("image")) return;
        const promises = files.map((file)=>{
            return new Promise((resolve)=>{
                const reader = new FileReader();
                reader.onload = ()=>{
                    resolve(reader.result);
                };
                reader.readAsDataURL(file);
            });
        });
        Promise.all(promises).then((images)=>{
            const update = images.reduce((delta, image)=>{
                return delta.insert({
                    image: image
                });
            }, new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().retain(range.index).delete(range.length));
            this.quill.updateContents(update, (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.USER);
            this.quill.setSelection(range.index + images.length, (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.SILENT);
        });
    }
};
var $e6552ee1597b1e5d$export$2e2bcd8739ae039 = $e6552ee1597b1e5d$var$Uploader;







const $ab9016344676d495$var$INSERT_TYPES = [
    "insertText",
    "insertReplacementText"
];
class $ab9016344676d495$var$Input extends (0, $0fe56fdf6098eabb$export$2e2bcd8739ae039) {
    deleteRange(range) {
        (0, $a3554dec5716af91$export$a6c813797f379898)({
            range: range,
            quill: this.quill
        });
    }
    replaceText(range) {
        let text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        if (range.length === 0) return false;
        if (text) {
            // Follow the native behavior that inherits the formats of the first character
            const formats = this.quill.getFormat(range.index, 1);
            this.deleteRange(range);
            this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().retain(range.index).insert(text, formats), (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
        } else this.deleteRange(range);
        this.quill.setSelection(range.index + text.length, 0, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.SILENT);
        return true;
    }
    handleBeforeInput(event) {
        if (this.quill.composition.isComposing || event.defaultPrevented || !$ab9016344676d495$var$INSERT_TYPES.includes(event.inputType)) return;
        const staticRange = event.getTargetRanges ? event.getTargetRanges()[0] : null;
        if (!staticRange || staticRange.collapsed === true) return;
        const text = $ab9016344676d495$var$getPlainTextFromInputEvent(event);
        if (text == null) return;
        const normalized = this.quill.selection.normalizeNative(staticRange);
        const range = normalized ? this.quill.selection.normalizedToRange(normalized) : null;
        if (range && this.replaceText(range, text)) event.preventDefault();
    }
    handleCompositionStart() {
        const range = this.quill.getSelection();
        if (range) this.replaceText(range);
    }
    constructor(quill, options){
        super(quill, options);
        quill.root.addEventListener("beforeinput", (event)=>{
            this.handleBeforeInput(event);
        });
        // Gboard with English input on Android triggers `compositionstart` sometimes even
        // users are not going to type anything.
        if (!/Android/i.test(navigator.userAgent)) quill.on((0, $c868a5e4990268d1$export$2e2bcd8739ae039).events.COMPOSITION_BEFORE_START, ()=>{
            this.handleCompositionStart();
        });
    }
}
function $ab9016344676d495$var$getPlainTextFromInputEvent(event) {
    // When `inputType` is "insertText":
    // - `event.data` should be string (Safari uses `event.dataTransfer`).
    // - `event.dataTransfer` should be null.
    // When `inputType` is "insertReplacementText":
    // - `event.data` should be null.
    // - `event.dataTransfer` should contain "text/plain" data.
    if (typeof event.data === "string") return event.data;
    if (event.dataTransfer?.types.includes("text/plain")) return event.dataTransfer.getData("text/plain");
    return null;
}
var $ab9016344676d495$export$2e2bcd8739ae039 = $ab9016344676d495$var$Input;



var $97zcJ = parcelRequire("97zcJ");



const $0cf5988918757d7b$var$isMac = /Mac/i.test(navigator.platform);
const $0cf5988918757d7b$export$b6cc50769bf06658 = 100;
// A loose check to determine if the shortcut can move the caret before a UI node:
// <ANY_PARENT>[CARET]<div class="ql-ui"></div>[CONTENT]</ANY_PARENT>
const $0cf5988918757d7b$var$canMoveCaretBeforeUINode = (event)=>{
    if (event.key === "ArrowLeft" || event.key === "ArrowRight" || // RTL scripts or moving from the end of the previous line
    event.key === "ArrowUp" || event.key === "ArrowDown" || event.key === "Home") return true;
    if ($0cf5988918757d7b$var$isMac && event.key === "a" && event.ctrlKey === true) return true;
    return false;
};
class $0cf5988918757d7b$var$UINode extends (0, $0fe56fdf6098eabb$export$2e2bcd8739ae039) {
    handleArrowKeys() {
        this.quill.keyboard.addBinding({
            key: [
                "ArrowLeft",
                "ArrowRight"
            ],
            offset: 0,
            shiftKey: null,
            handler (range, _ref) {
                let { line: line, event: event } = _ref;
                if (!(line instanceof (0, $8324d048851d53b4$export$e43113f0aad76fe)) || !line.uiNode) return true;
                const isRTL = getComputedStyle(line.domNode)["direction"] === "rtl";
                if (isRTL && event.key !== "ArrowRight" || !isRTL && event.key !== "ArrowLeft") return true;
                this.quill.setSelection(range.index - 1, range.length + (event.shiftKey ? 1 : 0), (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
                return false;
            }
        });
    }
    handleNavigationShortcuts() {
        this.quill.root.addEventListener("keydown", (event)=>{
            if (!event.defaultPrevented && $0cf5988918757d7b$var$canMoveCaretBeforeUINode(event)) this.ensureListeningToSelectionChange();
        });
    }
    /**
   * We only listen to the `selectionchange` event when
   * there is an intention of moving the caret to the beginning using shortcuts.
   * This is primarily implemented to prevent infinite loops, as we are changing
   * the selection within the handler of a `selectionchange` event.
   */ ensureListeningToSelectionChange() {
        this.selectionChangeDeadline = Date.now() + $0cf5988918757d7b$export$b6cc50769bf06658;
        if (this.isListening) return;
        this.isListening = true;
        const listener = ()=>{
            this.isListening = false;
            if (Date.now() <= this.selectionChangeDeadline) this.handleSelectionChange();
        };
        document.addEventListener("selectionchange", listener, {
            once: true
        });
    }
    handleSelectionChange() {
        const selection = document.getSelection();
        if (!selection) return;
        const range = selection.getRangeAt(0);
        if (range.collapsed !== true || range.startOffset !== 0) return;
        const line = this.quill.scroll.find(range.startContainer);
        if (!(line instanceof (0, $8324d048851d53b4$export$e43113f0aad76fe)) || !line.uiNode) return;
        const newRange = document.createRange();
        newRange.setStartAfter(line.uiNode);
        newRange.setEndAfter(line.uiNode);
        selection.removeAllRanges();
        selection.addRange(newRange);
    }
    constructor(quill, options){
        super(quill, options);
        (0, $97zcJ._)(this, "isListening", false);
        (0, $97zcJ._)(this, "selectionChangeDeadline", 0);
        this.handleArrowKeys();
        this.handleNavigationShortcuts();
    }
}
var $0cf5988918757d7b$export$2e2bcd8739ae039 = $0cf5988918757d7b$var$UINode;



(0, $c868a5e4990268d1$export$2e2bcd8739ae039).register({
    "blots/block": (0, $421348c10218bc50$export$2e2bcd8739ae039),
    "blots/block/embed": (0, $421348c10218bc50$export$48b9f0688962d028),
    "blots/break": (0, $aac85a10314b6a4e$export$2e2bcd8739ae039),
    "blots/container": (0, $d5d72b42a1ba7785$export$2e2bcd8739ae039),
    "blots/cursor": (0, $ff66e5de053048df$export$2e2bcd8739ae039),
    "blots/embed": (0, $940861127aa87418$export$2e2bcd8739ae039),
    "blots/inline": (0, $fd4ff9e1d56c8673$export$2e2bcd8739ae039),
    "blots/scroll": (0, $b086038ab50867f0$export$2e2bcd8739ae039),
    "blots/text": (0, $44fdb97bacc13d2d$export$2e2bcd8739ae039),
    "modules/clipboard": (0, $1db49f8428c77f89$export$2e2bcd8739ae039),
    "modules/history": (0, $3737a1635e95f12e$export$2e2bcd8739ae039),
    "modules/keyboard": (0, $a3554dec5716af91$export$2e2bcd8739ae039),
    "modules/uploader": (0, $e6552ee1597b1e5d$export$2e2bcd8739ae039),
    "modules/input": (0, $ab9016344676d495$export$2e2bcd8739ae039),
    "modules/uiNode": (0, $0cf5988918757d7b$export$2e2bcd8739ae039)
});
var $b7eaeeafee7196fc$export$2e2bcd8739ae039 = (0, $c868a5e4990268d1$export$2e2bcd8739ae039);





class $052f709c27328c7a$var$IndentAttributor extends (0, $8324d048851d53b4$export$651d45509677cf07) {
    add(node, value) {
        let normalizedValue = 0;
        if (value === "+1" || value === "-1") {
            const indent = this.value(node) || 0;
            normalizedValue = value === "+1" ? indent + 1 : indent - 1;
        } else if (typeof value === "number") normalizedValue = value;
        if (normalizedValue === 0) {
            this.remove(node);
            return true;
        }
        return super.add(node, normalizedValue.toString());
    }
    canAdd(node, value) {
        return super.canAdd(node, value) || super.canAdd(node, parseInt(value, 10));
    }
    value(node) {
        return parseInt(super.value(node), 10) || undefined; // Don't return NaN
    }
}
const $052f709c27328c7a$var$IndentClass = new $052f709c27328c7a$var$IndentAttributor("indent", "ql-indent", {
    scope: (0, $8324d048851d53b4$export$775b6bb06e53a214).BLOCK,
    // @ts-expect-error
    whitelist: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
    ]
});
var $052f709c27328c7a$export$2e2bcd8739ae039 = $052f709c27328c7a$var$IndentClass;



var $97zcJ = parcelRequire("97zcJ");

class $4b9dbc4cfb9b755f$var$Blockquote extends (0, $421348c10218bc50$export$2e2bcd8739ae039) {
}
(0, $97zcJ._)($4b9dbc4cfb9b755f$var$Blockquote, "blotName", "blockquote");
(0, $97zcJ._)($4b9dbc4cfb9b755f$var$Blockquote, "tagName", "blockquote");
var $4b9dbc4cfb9b755f$export$2e2bcd8739ae039 = $4b9dbc4cfb9b755f$var$Blockquote;



var $97zcJ = parcelRequire("97zcJ");

class $3edefb217ec26d32$var$Header extends (0, $421348c10218bc50$export$2e2bcd8739ae039) {
    static formats(domNode) {
        return this.tagName.indexOf(domNode.tagName) + 1;
    }
}
(0, $97zcJ._)($3edefb217ec26d32$var$Header, "blotName", "header");
(0, $97zcJ._)($3edefb217ec26d32$var$Header, "tagName", [
    "H1",
    "H2",
    "H3",
    "H4",
    "H5",
    "H6"
]);
var $3edefb217ec26d32$export$2e2bcd8739ae039 = $3edefb217ec26d32$var$Header;





class $d4deee66c7c4bf27$export$122a2a667e12876b extends (0, $d5d72b42a1ba7785$export$2e2bcd8739ae039) {
}
$d4deee66c7c4bf27$export$122a2a667e12876b.blotName = "list-container";
$d4deee66c7c4bf27$export$122a2a667e12876b.tagName = "OL";
class $d4deee66c7c4bf27$export$2e2bcd8739ae039 extends (0, $421348c10218bc50$export$2e2bcd8739ae039) {
    static create(value) {
        const node = super.create();
        node.setAttribute("data-list", value);
        return node;
    }
    static formats(domNode) {
        return domNode.getAttribute("data-list") || undefined;
    }
    static register() {
        (0, $c868a5e4990268d1$export$2e2bcd8739ae039).register($d4deee66c7c4bf27$export$122a2a667e12876b);
    }
    format(name, value) {
        if (name === this.statics.blotName && value) this.domNode.setAttribute("data-list", value);
        else super.format(name, value);
    }
    constructor(scroll, domNode){
        super(scroll, domNode);
        const ui = domNode.ownerDocument.createElement("span");
        const listEventHandler = (e)=>{
            if (!scroll.isEnabled()) return;
            const format = this.statics.formats(domNode, scroll);
            if (format === "checked") {
                this.format("list", "unchecked");
                e.preventDefault();
            } else if (format === "unchecked") {
                this.format("list", "checked");
                e.preventDefault();
            }
        };
        ui.addEventListener("mousedown", listEventHandler);
        ui.addEventListener("touchstart", listEventHandler);
        this.attachUI(ui);
    }
}
$d4deee66c7c4bf27$export$2e2bcd8739ae039.blotName = "list";
$d4deee66c7c4bf27$export$2e2bcd8739ae039.tagName = "LI";
$d4deee66c7c4bf27$export$122a2a667e12876b.allowedChildren = [
    $d4deee66c7c4bf27$export$2e2bcd8739ae039
];
$d4deee66c7c4bf27$export$2e2bcd8739ae039.requiredContainer = $d4deee66c7c4bf27$export$122a2a667e12876b;







var $97zcJ = parcelRequire("97zcJ");

class $bed7d67d4387fb15$var$Bold extends (0, $fd4ff9e1d56c8673$export$2e2bcd8739ae039) {
    static create() {
        return super.create();
    }
    static formats() {
        return true;
    }
    optimize(context) {
        super.optimize(context);
        if (this.domNode.tagName !== this.statics.tagName[0]) this.replaceWith(this.statics.blotName);
    }
}
(0, $97zcJ._)($bed7d67d4387fb15$var$Bold, "blotName", "bold");
(0, $97zcJ._)($bed7d67d4387fb15$var$Bold, "tagName", [
    "STRONG",
    "B"
]);
var $bed7d67d4387fb15$export$2e2bcd8739ae039 = $bed7d67d4387fb15$var$Bold;



var $97zcJ = parcelRequire("97zcJ");

class $7cc8e2e81822ef45$var$Italic extends (0, $bed7d67d4387fb15$export$2e2bcd8739ae039) {
}
(0, $97zcJ._)($7cc8e2e81822ef45$var$Italic, "blotName", "italic");
(0, $97zcJ._)($7cc8e2e81822ef45$var$Italic, "tagName", [
    "EM",
    "I"
]);
var $7cc8e2e81822ef45$export$2e2bcd8739ae039 = $7cc8e2e81822ef45$var$Italic;



var $97zcJ = parcelRequire("97zcJ");

class $68007fb83d8b2db6$export$2e2bcd8739ae039 extends (0, $fd4ff9e1d56c8673$export$2e2bcd8739ae039) {
    static create(value) {
        const node = super.create(value);
        node.setAttribute("href", this.sanitize(value));
        node.setAttribute("rel", "noopener noreferrer");
        node.setAttribute("target", "_blank");
        return node;
    }
    static formats(domNode) {
        return domNode.getAttribute("href");
    }
    static sanitize(url) {
        return $68007fb83d8b2db6$export$83d2e9e3e4ee39ed(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
    }
    format(name, value) {
        if (name !== this.statics.blotName || !value) super.format(name, value);
        else // @ts-expect-error
        this.domNode.setAttribute("href", this.constructor.sanitize(value));
    }
}
(0, $97zcJ._)($68007fb83d8b2db6$export$2e2bcd8739ae039, "blotName", "link");
(0, $97zcJ._)($68007fb83d8b2db6$export$2e2bcd8739ae039, "tagName", "A");
(0, $97zcJ._)($68007fb83d8b2db6$export$2e2bcd8739ae039, "SANITIZED_URL", "about:blank");
(0, $97zcJ._)($68007fb83d8b2db6$export$2e2bcd8739ae039, "PROTOCOL_WHITELIST", [
    "http",
    "https",
    "mailto",
    "tel",
    "sms"
]);
function $68007fb83d8b2db6$export$83d2e9e3e4ee39ed(url, protocols) {
    const anchor = document.createElement("a");
    anchor.href = url;
    const protocol = anchor.href.slice(0, anchor.href.indexOf(":"));
    return protocols.indexOf(protocol) > -1;
}



var $97zcJ = parcelRequire("97zcJ");

class $d5fe0dfbae2887ac$var$Script extends (0, $fd4ff9e1d56c8673$export$2e2bcd8739ae039) {
    static create(value) {
        if (value === "super") return document.createElement("sup");
        if (value === "sub") return document.createElement("sub");
        return super.create(value);
    }
    static formats(domNode) {
        if (domNode.tagName === "SUB") return "sub";
        if (domNode.tagName === "SUP") return "super";
        return undefined;
    }
}
(0, $97zcJ._)($d5fe0dfbae2887ac$var$Script, "blotName", "script");
(0, $97zcJ._)($d5fe0dfbae2887ac$var$Script, "tagName", [
    "SUB",
    "SUP"
]);
var $d5fe0dfbae2887ac$export$2e2bcd8739ae039 = $d5fe0dfbae2887ac$var$Script;



var $97zcJ = parcelRequire("97zcJ");

class $3122b997bf022136$var$Strike extends (0, $bed7d67d4387fb15$export$2e2bcd8739ae039) {
}
(0, $97zcJ._)($3122b997bf022136$var$Strike, "blotName", "strike");
(0, $97zcJ._)($3122b997bf022136$var$Strike, "tagName", [
    "S",
    "STRIKE"
]);
var $3122b997bf022136$export$2e2bcd8739ae039 = $3122b997bf022136$var$Strike;



var $97zcJ = parcelRequire("97zcJ");

class $84764d6832d8c50c$var$Underline extends (0, $fd4ff9e1d56c8673$export$2e2bcd8739ae039) {
}
(0, $97zcJ._)($84764d6832d8c50c$var$Underline, "blotName", "underline");
(0, $97zcJ._)($84764d6832d8c50c$var$Underline, "tagName", "U");
var $84764d6832d8c50c$export$2e2bcd8739ae039 = $84764d6832d8c50c$var$Underline;



var $97zcJ = parcelRequire("97zcJ");

class $d2068614501120d3$var$Formula extends (0, $940861127aa87418$export$2e2bcd8739ae039) {
    static create(value) {
        // @ts-expect-error
        if (window.katex == null) throw new Error("Formula module requires KaTeX.");
        const node = super.create(value);
        if (typeof value === "string") {
            // @ts-expect-error
            window.katex.render(value, node, {
                throwOnError: false,
                errorColor: "#f00"
            });
            node.setAttribute("data-value", value);
        }
        return node;
    }
    static value(domNode) {
        return domNode.getAttribute("data-value");
    }
    html() {
        const { formula: formula } = this.value();
        return `<span>${formula}</span>`;
    }
}
(0, $97zcJ._)($d2068614501120d3$var$Formula, "blotName", "formula");
(0, $97zcJ._)($d2068614501120d3$var$Formula, "className", "ql-formula");
(0, $97zcJ._)($d2068614501120d3$var$Formula, "tagName", "SPAN");
var $d2068614501120d3$export$2e2bcd8739ae039 = $d2068614501120d3$var$Formula;



var $97zcJ = parcelRequire("97zcJ");


const $d91c712bbe22143a$var$ATTRIBUTES = [
    "alt",
    "height",
    "width"
];
class $d91c712bbe22143a$var$Image extends (0, $8324d048851d53b4$export$297a1fa96f55f00f) {
    static create(value) {
        const node = super.create(value);
        if (typeof value === "string") node.setAttribute("src", this.sanitize(value));
        return node;
    }
    static formats(domNode) {
        return $d91c712bbe22143a$var$ATTRIBUTES.reduce((formats, attribute)=>{
            if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
            return formats;
        }, {});
    }
    static match(url) {
        return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url);
    }
    static sanitize(url) {
        return (0, $68007fb83d8b2db6$export$83d2e9e3e4ee39ed)(url, [
            "http",
            "https",
            "data"
        ]) ? url : "//:0";
    }
    static value(domNode) {
        return domNode.getAttribute("src");
    }
    format(name, value) {
        if ($d91c712bbe22143a$var$ATTRIBUTES.indexOf(name) > -1) {
            if (value) this.domNode.setAttribute(name, value);
            else this.domNode.removeAttribute(name);
        } else super.format(name, value);
    }
}
(0, $97zcJ._)($d91c712bbe22143a$var$Image, "blotName", "image");
(0, $97zcJ._)($d91c712bbe22143a$var$Image, "tagName", "IMG");
var $d91c712bbe22143a$export$2e2bcd8739ae039 = $d91c712bbe22143a$var$Image;



var $97zcJ = parcelRequire("97zcJ");


const $19f5b03754cd6d52$var$ATTRIBUTES = [
    "height",
    "width"
];
class $19f5b03754cd6d52$var$Video extends (0, $421348c10218bc50$export$48b9f0688962d028) {
    static create(value) {
        const node = super.create(value);
        node.setAttribute("frameborder", "0");
        node.setAttribute("allowfullscreen", "true");
        node.setAttribute("src", this.sanitize(value));
        return node;
    }
    static formats(domNode) {
        return $19f5b03754cd6d52$var$ATTRIBUTES.reduce((formats, attribute)=>{
            if (domNode.hasAttribute(attribute)) formats[attribute] = domNode.getAttribute(attribute);
            return formats;
        }, {});
    }
    static sanitize(url) {
        return (0, $68007fb83d8b2db6$export$2e2bcd8739ae039).sanitize(url);
    }
    static value(domNode) {
        return domNode.getAttribute("src");
    }
    format(name, value) {
        if ($19f5b03754cd6d52$var$ATTRIBUTES.indexOf(name) > -1) {
            if (value) this.domNode.setAttribute(name, value);
            else this.domNode.removeAttribute(name);
        } else super.format(name, value);
    }
    html() {
        const { video: video } = this.value();
        return `<a href="${video}">${video}</a>`;
    }
}
(0, $97zcJ._)($19f5b03754cd6d52$var$Video, "blotName", "video");
(0, $97zcJ._)($19f5b03754cd6d52$var$Video, "className", "ql-video");
(0, $97zcJ._)($19f5b03754cd6d52$var$Video, "tagName", "IFRAME");
var $19f5b03754cd6d52$export$2e2bcd8739ae039 = $19f5b03754cd6d52$var$Video;














const $c0d487dd2607ae92$var$TokenAttributor = new (0, $8324d048851d53b4$export$651d45509677cf07)("code-token", "hljs", {
    scope: (0, $8324d048851d53b4$export$775b6bb06e53a214).INLINE
});
class $c0d487dd2607ae92$export$9460eee64f276be7 extends (0, $fd4ff9e1d56c8673$export$2e2bcd8739ae039) {
    static formats(node, scroll) {
        while(node != null && node !== scroll.domNode){
            if (node.classList && node.classList.contains((0, $95fd90350cc017ea$export$2e2bcd8739ae039).className)) // @ts-expect-error
            return super.formats(node, scroll);
            // @ts-expect-error
            node = node.parentNode;
        }
        return undefined;
    }
    format(format, value) {
        if (format !== $c0d487dd2607ae92$export$9460eee64f276be7.blotName) super.format(format, value);
        else if (value) $c0d487dd2607ae92$var$TokenAttributor.add(this.domNode, value);
        else {
            $c0d487dd2607ae92$var$TokenAttributor.remove(this.domNode);
            this.domNode.classList.remove(this.statics.className);
        }
    }
    optimize() {
        // @ts-expect-error
        super.optimize(...arguments);
        if (!$c0d487dd2607ae92$var$TokenAttributor.value(this.domNode)) this.unwrap();
    }
    constructor(scroll, domNode, value){
        // @ts-expect-error
        super(scroll, domNode, value);
        $c0d487dd2607ae92$var$TokenAttributor.add(this.domNode, value);
    }
}
$c0d487dd2607ae92$export$9460eee64f276be7.blotName = "code-token";
$c0d487dd2607ae92$export$9460eee64f276be7.className = "ql-token";
class $c0d487dd2607ae92$export$6c415d1fdae3dfdb extends (0, $95fd90350cc017ea$export$2e2bcd8739ae039) {
    static create(value) {
        const domNode = super.create(value);
        if (typeof value === "string") domNode.setAttribute("data-language", value);
        return domNode;
    }
    static formats(domNode) {
        // @ts-expect-error
        return domNode.getAttribute("data-language") || "plain";
    }
    static register() {}
    format(name, value) {
        if (name === this.statics.blotName && value) // @ts-expect-error
        this.domNode.setAttribute("data-language", value);
        else super.format(name, value);
    }
    replaceWith(name, value) {
        this.formatAt(0, this.length(), $c0d487dd2607ae92$export$9460eee64f276be7.blotName, false);
        return super.replaceWith(name, value);
    }
}
class $c0d487dd2607ae92$var$SyntaxCodeBlockContainer extends (0, $95fd90350cc017ea$export$3b131632d3d15165) {
    attach() {
        super.attach();
        this.forceNext = false;
        // @ts-expect-error
        this.scroll.emitMount(this);
    }
    format(name, value) {
        if (name === $c0d487dd2607ae92$export$6c415d1fdae3dfdb.blotName) {
            this.forceNext = true;
            this.children.forEach((child)=>{
                // @ts-expect-error
                child.format(name, value);
            });
        }
    }
    formatAt(index, length, name, value) {
        if (name === $c0d487dd2607ae92$export$6c415d1fdae3dfdb.blotName) this.forceNext = true;
        super.formatAt(index, length, name, value);
    }
    highlight(highlight) {
        let forced = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (this.children.head == null) return;
        const nodes = Array.from(this.domNode.childNodes).filter((node)=>node !== this.uiNode);
        const text = `${nodes.map((node)=>node.textContent).join("\n")}\n`;
        const language = $c0d487dd2607ae92$export$6c415d1fdae3dfdb.formats(this.children.head.domNode);
        if (forced || this.forceNext || this.cachedText !== text) {
            if (text.trim().length > 0 || this.cachedText == null) {
                const oldDelta = this.children.reduce((delta, child)=>{
                    // @ts-expect-error
                    return delta.concat((0, $421348c10218bc50$export$992ff47219af5a2b)(child, false));
                }, new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))());
                const delta = highlight(text, language);
                oldDelta.diff(delta).reduce((index, _ref)=>{
                    let { retain: retain, attributes: attributes } = _ref;
                    // Should be all retains
                    if (!retain) return index;
                    if (attributes) Object.keys(attributes).forEach((format)=>{
                        if ([
                            $c0d487dd2607ae92$export$6c415d1fdae3dfdb.blotName,
                            $c0d487dd2607ae92$export$9460eee64f276be7.blotName
                        ].includes(format)) // @ts-expect-error
                        this.formatAt(index, retain, format, attributes[format]);
                    });
                    // @ts-expect-error
                    return index + retain;
                }, 0);
            }
            this.cachedText = text;
            this.forceNext = false;
        }
    }
    html(index, length) {
        const [codeBlock] = this.children.find(index);
        const language = codeBlock ? $c0d487dd2607ae92$export$6c415d1fdae3dfdb.formats(codeBlock.domNode) : "plain";
        return `<pre data-language="${language}">\n${(0, $44fdb97bacc13d2d$export$96e6fc3a139b2555)(this.code(index, length))}\n</pre>`;
    }
    optimize(context) {
        super.optimize(context);
        if (this.parent != null && this.children.head != null && this.uiNode != null) {
            const language = $c0d487dd2607ae92$export$6c415d1fdae3dfdb.formats(this.children.head.domNode);
            // @ts-expect-error
            if (language !== this.uiNode.value) // @ts-expect-error
            this.uiNode.value = language;
        }
    }
}
$c0d487dd2607ae92$var$SyntaxCodeBlockContainer.allowedChildren = [
    $c0d487dd2607ae92$export$6c415d1fdae3dfdb
];
$c0d487dd2607ae92$export$6c415d1fdae3dfdb.requiredContainer = $c0d487dd2607ae92$var$SyntaxCodeBlockContainer;
$c0d487dd2607ae92$export$6c415d1fdae3dfdb.allowedChildren = [
    $c0d487dd2607ae92$export$9460eee64f276be7,
    (0, $ff66e5de053048df$export$2e2bcd8739ae039),
    (0, $44fdb97bacc13d2d$export$2e2bcd8739ae039),
    (0, $aac85a10314b6a4e$export$2e2bcd8739ae039)
];
const $c0d487dd2607ae92$var$highlight = (lib, language, text)=>{
    if (typeof lib.versionString === "string") {
        const majorVersion = lib.versionString.split(".")[0];
        if (parseInt(majorVersion, 10) >= 11) return lib.highlight(text, {
            language: language
        }).value;
    }
    return lib.highlight(language, text).value;
};
class $c0d487dd2607ae92$export$2e2bcd8739ae039 extends (0, $0fe56fdf6098eabb$export$2e2bcd8739ae039) {
    static register() {
        (0, $c868a5e4990268d1$export$2e2bcd8739ae039).register($c0d487dd2607ae92$export$9460eee64f276be7, true);
        (0, $c868a5e4990268d1$export$2e2bcd8739ae039).register($c0d487dd2607ae92$export$6c415d1fdae3dfdb, true);
        (0, $c868a5e4990268d1$export$2e2bcd8739ae039).register($c0d487dd2607ae92$var$SyntaxCodeBlockContainer, true);
    }
    initListener() {
        this.quill.on((0, $c868a5e4990268d1$export$2e2bcd8739ae039).events.SCROLL_BLOT_MOUNT, (blot)=>{
            if (!(blot instanceof $c0d487dd2607ae92$var$SyntaxCodeBlockContainer)) return;
            const select = this.quill.root.ownerDocument.createElement("select");
            // @ts-expect-error Fix me later
            this.options.languages.forEach((_ref3)=>{
                let { key: key, label: label } = _ref3;
                const option = select.ownerDocument.createElement("option");
                option.textContent = label;
                option.setAttribute("value", key);
                select.appendChild(option);
            });
            select.addEventListener("change", ()=>{
                blot.format($c0d487dd2607ae92$export$6c415d1fdae3dfdb.blotName, select.value);
                this.quill.root.focus(); // Prevent scrolling
                this.highlight(blot, true);
            });
            if (blot.uiNode == null) {
                blot.attachUI(select);
                if (blot.children.head) select.value = $c0d487dd2607ae92$export$6c415d1fdae3dfdb.formats(blot.children.head.domNode);
            }
        });
    }
    initTimer() {
        let timer = null;
        this.quill.on((0, $c868a5e4990268d1$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, ()=>{
            if (timer) clearTimeout(timer);
            timer = setTimeout(()=>{
                this.highlight();
                timer = null;
            }, this.options.interval);
        });
    }
    highlight() {
        let blot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (this.quill.selection.composing) return;
        this.quill.update((0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
        const range = this.quill.getSelection();
        const blots = blot == null ? this.quill.scroll.descendants($c0d487dd2607ae92$var$SyntaxCodeBlockContainer) : [
            blot
        ];
        blots.forEach((container)=>{
            container.highlight(this.highlightBlot, force);
        });
        this.quill.update((0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.SILENT);
        if (range != null) this.quill.setSelection(range, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.SILENT);
    }
    highlightBlot(text) {
        let language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "plain";
        language = this.languages[language] ? language : "plain";
        if (language === "plain") return (0, $44fdb97bacc13d2d$export$96e6fc3a139b2555)(text).split("\n").reduce((delta, line, i)=>{
            if (i !== 0) delta.insert("\n", {
                [(0, $95fd90350cc017ea$export$2e2bcd8739ae039).blotName]: language
            });
            return delta.insert(line);
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))());
        const container = this.quill.root.ownerDocument.createElement("div");
        container.classList.add((0, $95fd90350cc017ea$export$2e2bcd8739ae039).className);
        container.innerHTML = $c0d487dd2607ae92$var$highlight(this.options.hljs, language, text);
        return (0, $1db49f8428c77f89$export$df3f009e3d155b20)(this.quill.scroll, container, [
            (node, delta)=>{
                // @ts-expect-error
                const value = $c0d487dd2607ae92$var$TokenAttributor.value(node);
                if (value) return delta.compose(new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().retain(delta.length(), {
                    [$c0d487dd2607ae92$export$9460eee64f276be7.blotName]: value
                }));
                return delta;
            }
        ], [
            (node, delta)=>{
                // @ts-expect-error
                return node.data.split("\n").reduce((memo, nodeText, i)=>{
                    if (i !== 0) memo.insert("\n", {
                        [(0, $95fd90350cc017ea$export$2e2bcd8739ae039).blotName]: language
                    });
                    return memo.insert(nodeText);
                }, delta);
            }
        ], new WeakMap());
    }
    constructor(quill, options){
        super(quill, options);
        if (this.options.hljs == null) throw new Error("Syntax module requires highlight.js. Please include the library on the page before Quill.");
        // @ts-expect-error Fix me later
        this.languages = this.options.languages.reduce((memo, _ref2)=>{
            let { key: key } = _ref2;
            memo[key] = true;
            return memo;
        }, {});
        this.highlightBlot = this.highlightBlot.bind(this);
        this.initListener();
        this.initTimer();
    }
}
$c0d487dd2607ae92$export$2e2bcd8739ae039.DEFAULTS = {
    hljs: (()=>{
        return window.hljs;
    })(),
    interval: 1000,
    languages: [
        {
            key: "plain",
            label: "Plain"
        },
        {
            key: "bash",
            label: "Bash"
        },
        {
            key: "cpp",
            label: "C++"
        },
        {
            key: "cs",
            label: "C#"
        },
        {
            key: "css",
            label: "CSS"
        },
        {
            key: "diff",
            label: "Diff"
        },
        {
            key: "xml",
            label: "HTML/XML"
        },
        {
            key: "java",
            label: "Java"
        },
        {
            key: "javascript",
            label: "JavaScript"
        },
        {
            key: "markdown",
            label: "Markdown"
        },
        {
            key: "php",
            label: "PHP"
        },
        {
            key: "python",
            label: "Python"
        },
        {
            key: "ruby",
            label: "Ruby"
        },
        {
            key: "sql",
            label: "SQL"
        }
    ]
};






var $97zcJ = parcelRequire("97zcJ");


class $fed008c4b2575b05$export$1e4baea7053fc0e3 extends (0, $421348c10218bc50$export$2e2bcd8739ae039) {
    static create(value) {
        const node = super.create();
        if (value) node.setAttribute("data-row", value);
        else node.setAttribute("data-row", $fed008c4b2575b05$export$9bd6f73cbe857f1b());
        return node;
    }
    static formats(domNode) {
        if (domNode.hasAttribute("data-row")) return domNode.getAttribute("data-row");
        return undefined;
    }
    cellOffset() {
        if (this.parent) return this.parent.children.indexOf(this);
        return -1;
    }
    format(name, value) {
        if (name === $fed008c4b2575b05$export$1e4baea7053fc0e3.blotName && value) this.domNode.setAttribute("data-row", value);
        else super.format(name, value);
    }
    row() {
        return this.parent;
    }
    rowOffset() {
        if (this.row()) return this.row().rowOffset();
        return -1;
    }
    table() {
        return this.row() && this.row().table();
    }
}
(0, $97zcJ._)($fed008c4b2575b05$export$1e4baea7053fc0e3, "blotName", "table");
(0, $97zcJ._)($fed008c4b2575b05$export$1e4baea7053fc0e3, "tagName", "TD");
class $fed008c4b2575b05$export$b05581f4e764e162 extends (0, $d5d72b42a1ba7785$export$2e2bcd8739ae039) {
    checkMerge() {
        // @ts-expect-error
        if (super.checkMerge() && this.next.children.head != null) {
            // @ts-expect-error
            const thisHead = this.children.head.formats();
            // @ts-expect-error
            const thisTail = this.children.tail.formats();
            // @ts-expect-error
            const nextHead = this.next.children.head.formats();
            // @ts-expect-error
            const nextTail = this.next.children.tail.formats();
            return thisHead.table === thisTail.table && thisHead.table === nextHead.table && thisHead.table === nextTail.table;
        }
        return false;
    }
    optimize(context) {
        super.optimize(context);
        this.children.forEach((child)=>{
            if (child.next == null) return;
            const childFormats = child.formats();
            const nextFormats = child.next.formats();
            if (childFormats.table !== nextFormats.table) {
                const next = this.splitAfter(child);
                if (next) // @ts-expect-error TODO: parameters of optimize() should be a optional
                next.optimize();
                // We might be able to merge with prev now
                if (this.prev) // @ts-expect-error TODO: parameters of optimize() should be a optional
                this.prev.optimize();
            }
        });
    }
    rowOffset() {
        if (this.parent) return this.parent.children.indexOf(this);
        return -1;
    }
    table() {
        return this.parent && this.parent.parent;
    }
}
(0, $97zcJ._)($fed008c4b2575b05$export$b05581f4e764e162, "blotName", "table-row");
(0, $97zcJ._)($fed008c4b2575b05$export$b05581f4e764e162, "tagName", "TR");
class $fed008c4b2575b05$export$76ccd210b9029917 extends (0, $d5d72b42a1ba7785$export$2e2bcd8739ae039) {
}
(0, $97zcJ._)($fed008c4b2575b05$export$76ccd210b9029917, "blotName", "table-body");
(0, $97zcJ._)($fed008c4b2575b05$export$76ccd210b9029917, "tagName", "TBODY");
class $fed008c4b2575b05$export$f2c3aea42b2a048f extends (0, $d5d72b42a1ba7785$export$2e2bcd8739ae039) {
    balanceCells() {
        const rows = this.descendants($fed008c4b2575b05$export$b05581f4e764e162);
        const maxColumns = rows.reduce((max, row)=>{
            return Math.max(row.children.length, max);
        }, 0);
        rows.forEach((row)=>{
            new Array(maxColumns - row.children.length).fill(0).forEach(()=>{
                let value;
                if (row.children.head != null) value = $fed008c4b2575b05$export$1e4baea7053fc0e3.formats(row.children.head.domNode);
                const blot = this.scroll.create($fed008c4b2575b05$export$1e4baea7053fc0e3.blotName, value);
                row.appendChild(blot);
                // @ts-expect-error TODO: parameters of optimize() should be a optional
                blot.optimize(); // Add break blot
            });
        });
    }
    cells(column) {
        return this.rows().map((row)=>row.children.at(column));
    }
    deleteColumn(index) {
        // @ts-expect-error
        const [body] = this.descendant($fed008c4b2575b05$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        body.children.forEach((row)=>{
            const cell = row.children.at(index);
            if (cell != null) cell.remove();
        });
    }
    insertColumn(index) {
        // @ts-expect-error
        const [body] = this.descendant($fed008c4b2575b05$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        body.children.forEach((row)=>{
            const ref = row.children.at(index);
            // @ts-expect-error
            const value = $fed008c4b2575b05$export$1e4baea7053fc0e3.formats(row.children.head.domNode);
            const cell = this.scroll.create($fed008c4b2575b05$export$1e4baea7053fc0e3.blotName, value);
            row.insertBefore(cell, ref);
        });
    }
    insertRow(index) {
        // @ts-expect-error
        const [body] = this.descendant($fed008c4b2575b05$export$76ccd210b9029917);
        if (body == null || body.children.head == null) return;
        const id = $fed008c4b2575b05$export$9bd6f73cbe857f1b();
        const row = this.scroll.create($fed008c4b2575b05$export$b05581f4e764e162.blotName);
        body.children.head.children.forEach(()=>{
            const cell = this.scroll.create($fed008c4b2575b05$export$1e4baea7053fc0e3.blotName, id);
            row.appendChild(cell);
        });
        const ref = body.children.at(index);
        body.insertBefore(row, ref);
    }
    rows() {
        const body = this.children.head;
        if (body == null) return [];
        return body.children.map((row)=>row);
    }
}
(0, $97zcJ._)($fed008c4b2575b05$export$f2c3aea42b2a048f, "blotName", "table-container");
(0, $97zcJ._)($fed008c4b2575b05$export$f2c3aea42b2a048f, "tagName", "TABLE");
$fed008c4b2575b05$export$f2c3aea42b2a048f.allowedChildren = [
    $fed008c4b2575b05$export$76ccd210b9029917
];
$fed008c4b2575b05$export$76ccd210b9029917.requiredContainer = $fed008c4b2575b05$export$f2c3aea42b2a048f;
$fed008c4b2575b05$export$76ccd210b9029917.allowedChildren = [
    $fed008c4b2575b05$export$b05581f4e764e162
];
$fed008c4b2575b05$export$b05581f4e764e162.requiredContainer = $fed008c4b2575b05$export$76ccd210b9029917;
$fed008c4b2575b05$export$b05581f4e764e162.allowedChildren = [
    $fed008c4b2575b05$export$1e4baea7053fc0e3
];
$fed008c4b2575b05$export$1e4baea7053fc0e3.requiredContainer = $fed008c4b2575b05$export$b05581f4e764e162;
function $fed008c4b2575b05$export$9bd6f73cbe857f1b() {
    const id = Math.random().toString(36).slice(2, 6);
    return `row-${id}`;
}


class $7b22eecda11f5be9$var$Table extends (0, $0fe56fdf6098eabb$export$2e2bcd8739ae039) {
    static register() {
        (0, $c868a5e4990268d1$export$2e2bcd8739ae039).register((0, $fed008c4b2575b05$export$1e4baea7053fc0e3));
        (0, $c868a5e4990268d1$export$2e2bcd8739ae039).register((0, $fed008c4b2575b05$export$b05581f4e764e162));
        (0, $c868a5e4990268d1$export$2e2bcd8739ae039).register((0, $fed008c4b2575b05$export$76ccd210b9029917));
        (0, $c868a5e4990268d1$export$2e2bcd8739ae039).register((0, $fed008c4b2575b05$export$f2c3aea42b2a048f));
    }
    balanceTables() {
        this.quill.scroll.descendants((0, $fed008c4b2575b05$export$f2c3aea42b2a048f)).forEach((table)=>{
            table.balanceCells();
        });
    }
    deleteColumn() {
        const [table, , cell] = this.getTable();
        if (cell == null) return;
        // @ts-expect-error
        table.deleteColumn(cell.cellOffset());
        this.quill.update((0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
    }
    deleteRow() {
        const [, row] = this.getTable();
        if (row == null) return;
        row.remove();
        this.quill.update((0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
    }
    deleteTable() {
        const [table] = this.getTable();
        if (table == null) return;
        // @ts-expect-error
        const offset = table.offset();
        // @ts-expect-error
        table.remove();
        this.quill.update((0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
        this.quill.setSelection(offset, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.SILENT);
    }
    getTable() {
        let range = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.quill.getSelection();
        if (range == null) return [
            null,
            null,
            null,
            -1
        ];
        const [cell, offset] = this.quill.getLine(range.index);
        if (cell == null || cell.statics.blotName !== (0, $fed008c4b2575b05$export$1e4baea7053fc0e3).blotName) return [
            null,
            null,
            null,
            -1
        ];
        const row = cell.parent;
        const table = row.parent.parent;
        // @ts-expect-error
        return [
            table,
            row,
            cell,
            offset
        ];
    }
    insertColumn(offset) {
        const range = this.quill.getSelection();
        if (!range) return;
        const [table, row, cell] = this.getTable(range);
        if (cell == null) return;
        const column = cell.cellOffset();
        table.insertColumn(column + offset);
        this.quill.update((0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
        let shift = row.rowOffset();
        if (offset === 0) shift += 1;
        this.quill.setSelection(range.index + shift, range.length, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.SILENT);
    }
    insertColumnLeft() {
        this.insertColumn(0);
    }
    insertColumnRight() {
        this.insertColumn(1);
    }
    insertRow(offset) {
        const range = this.quill.getSelection();
        if (!range) return;
        const [table, row, cell] = this.getTable(range);
        if (cell == null) return;
        const index = row.rowOffset();
        table.insertRow(index + offset);
        this.quill.update((0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
        if (offset > 0) this.quill.setSelection(range, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.SILENT);
        else this.quill.setSelection(range.index + row.children.length, range.length, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.SILENT);
    }
    insertRowAbove() {
        this.insertRow(0);
    }
    insertRowBelow() {
        this.insertRow(1);
    }
    insertTable(rows, columns) {
        const range = this.quill.getSelection();
        if (range == null) return;
        const delta = new Array(rows).fill(0).reduce((memo)=>{
            const text = new Array(columns).fill("\n").join("");
            return memo.insert(text, {
                table: (0, $fed008c4b2575b05$export$9bd6f73cbe857f1b)()
            });
        }, new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))().retain(range.index));
        this.quill.updateContents(delta, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
        this.quill.setSelection(range.index, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.SILENT);
        this.balanceTables();
    }
    listenBalanceCells() {
        this.quill.on((0, $c868a5e4990268d1$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, (mutations)=>{
            mutations.some((mutation)=>{
                if ([
                    "TD",
                    "TR",
                    "TBODY",
                    "TABLE"
                ].includes(mutation.target.tagName)) {
                    this.quill.once((0, $c868a5e4990268d1$export$2e2bcd8739ae039).events.TEXT_CHANGE, (delta, old, source)=>{
                        if (source !== (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER) return;
                        this.balanceTables();
                    });
                    return true;
                }
                return false;
            });
        });
    }
    constructor(){
        super(...arguments);
        this.listenBalanceCells();
    }
}
var $7b22eecda11f5be9$export$2e2bcd8739ae039 = $7b22eecda11f5be9$var$Table;







const $f75d599411e07a8a$var$debug = (0, $8673b628d4423f23$export$2e2bcd8739ae039)("quill:toolbar");
class $f75d599411e07a8a$export$2e2bcd8739ae039 extends (0, $0fe56fdf6098eabb$export$2e2bcd8739ae039) {
    addHandler(format, handler) {
        this.handlers[format] = handler;
    }
    attach(input) {
        let format = Array.from(input.classList).find((className)=>{
            return className.indexOf("ql-") === 0;
        });
        if (!format) return;
        format = format.slice(3);
        if (input.tagName === "BUTTON") input.setAttribute("type", "button");
        if (this.handlers[format] == null && this.quill.scroll.query(format) == null) {
            $f75d599411e07a8a$var$debug.warn("ignoring attaching to nonexistent format", format, input);
            return;
        }
        const eventName = input.tagName === "SELECT" ? "change" : "click";
        input.addEventListener(eventName, (e)=>{
            let value;
            if (input.tagName === "SELECT") {
                // @ts-expect-error
                if (input.selectedIndex < 0) return;
                // @ts-expect-error
                const selected = input.options[input.selectedIndex];
                if (selected.hasAttribute("selected")) value = false;
                else value = selected.value || false;
            } else {
                if (input.classList.contains("ql-active")) value = false;
                else // @ts-expect-error
                value = input.value || !input.hasAttribute("value");
                e.preventDefault();
            }
            this.quill.focus();
            const [range] = this.quill.selection.getRange();
            if (this.handlers[format] != null) this.handlers[format].call(this, value);
            else if (// @ts-expect-error
            this.quill.scroll.query(format).prototype instanceof (0, $8324d048851d53b4$export$297a1fa96f55f00f)) {
                value = prompt(`Enter ${format}`); // eslint-disable-line no-alert
                if (!value) return;
                this.quill.updateContents(new (0, (/*@__PURE__*/$parcel$interopDefault($f5af2faee6afab08$exports)))()// @ts-expect-error Fix me later
                .retain(range.index)// @ts-expect-error Fix me later
                .delete(range.length).insert({
                    [format]: value
                }), (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
            } else this.quill.format(format, value, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
            this.update(range);
        });
        this.controls.push([
            format,
            input
        ]);
    }
    update(range) {
        const formats = range == null ? {} : this.quill.getFormat(range);
        this.controls.forEach((pair)=>{
            const [format, input] = pair;
            if (input.tagName === "SELECT") {
                let option = null;
                if (range == null) option = null;
                else if (formats[format] == null) option = input.querySelector("option[selected]");
                else if (!Array.isArray(formats[format])) {
                    let value = formats[format];
                    if (typeof value === "string") value = value.replace(/"/g, '\\"');
                    option = input.querySelector(`option[value="${value}"]`);
                }
                if (option == null) {
                    // @ts-expect-error TODO fix me later
                    input.value = ""; // TODO make configurable?
                    // @ts-expect-error TODO fix me later
                    input.selectedIndex = -1;
                } else option.selected = true;
            } else if (range == null) {
                input.classList.remove("ql-active");
                input.setAttribute("aria-pressed", "false");
            } else if (input.hasAttribute("value")) {
                // both being null should match (default values)
                // '1' should match with 1 (headers)
                const value = formats[format];
                const isActive = value === input.getAttribute("value") || value != null && value.toString() === input.getAttribute("value") || value == null && !input.getAttribute("value");
                input.classList.toggle("ql-active", isActive);
                input.setAttribute("aria-pressed", isActive.toString());
            } else {
                const isActive = formats[format] != null;
                input.classList.toggle("ql-active", isActive);
                input.setAttribute("aria-pressed", isActive.toString());
            }
        });
    }
    constructor(quill, options){
        super(quill, options);
        if (Array.isArray(this.options.container)) {
            const container = document.createElement("div");
            container.setAttribute("role", "toolbar");
            $f75d599411e07a8a$export$faadaf0198b97fbe(container, this.options.container);
            quill.container?.parentNode?.insertBefore(container, quill.container);
            this.container = container;
        } else if (typeof this.options.container === "string") this.container = document.querySelector(this.options.container);
        else this.container = this.options.container;
        if (!(this.container instanceof HTMLElement)) {
            $f75d599411e07a8a$var$debug.error("Container required for toolbar", this.options);
            return;
        }
        this.container.classList.add("ql-toolbar");
        this.controls = [];
        this.handlers = {};
        if (this.options.handlers) Object.keys(this.options.handlers).forEach((format)=>{
            const handler = this.options.handlers?.[format];
            if (handler) this.addHandler(format, handler);
        });
        Array.from(this.container.querySelectorAll("button, select")).forEach((input)=>{
            // @ts-expect-error
            this.attach(input);
        });
        this.quill.on((0, $c868a5e4990268d1$export$2e2bcd8739ae039).events.EDITOR_CHANGE, ()=>{
            const [range] = this.quill.selection.getRange(); // quill.getSelection triggers update
            this.update(range);
        });
    }
}
$f75d599411e07a8a$export$2e2bcd8739ae039.DEFAULTS = {};
function $f75d599411e07a8a$var$addButton(container, format, value) {
    const input = document.createElement("button");
    input.setAttribute("type", "button");
    input.classList.add(`ql-${format}`);
    input.setAttribute("aria-pressed", "false");
    if (value != null) {
        input.value = value;
        input.setAttribute("aria-label", `${format}: ${value}`);
    } else input.setAttribute("aria-label", format);
    container.appendChild(input);
}
function $f75d599411e07a8a$export$faadaf0198b97fbe(container, groups) {
    if (!Array.isArray(groups[0])) // @ts-expect-error
    groups = [
        groups
    ];
    groups.forEach((controls)=>{
        const group = document.createElement("span");
        group.classList.add("ql-formats");
        controls.forEach((control)=>{
            if (typeof control === "string") $f75d599411e07a8a$var$addButton(group, control);
            else {
                const format = Object.keys(control)[0];
                const value = control[format];
                if (Array.isArray(value)) $f75d599411e07a8a$var$addSelect(group, format, value);
                else $f75d599411e07a8a$var$addButton(group, format, value);
            }
        });
        container.appendChild(group);
    });
}
function $f75d599411e07a8a$var$addSelect(container, format, values) {
    const input = document.createElement("select");
    input.classList.add(`ql-${format}`);
    values.forEach((value)=>{
        const option = document.createElement("option");
        if (value !== false) option.setAttribute("value", String(value));
        else option.setAttribute("selected", "selected");
        input.appendChild(option);
    });
    container.appendChild(input);
}
$f75d599411e07a8a$export$2e2bcd8739ae039.DEFAULTS = {
    container: null,
    handlers: {
        clean () {
            const range = this.quill.getSelection();
            if (range == null) return;
            if (range.length === 0) {
                const formats = this.quill.getFormat();
                Object.keys(formats).forEach((name)=>{
                    // Clean functionality in existing apps only clean inline formats
                    if (this.quill.scroll.query(name, (0, $8324d048851d53b4$export$775b6bb06e53a214).INLINE) != null) this.quill.format(name, false, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
                });
            } else this.quill.removeFormat(range.index, range.length, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
        },
        direction (value) {
            const { align: align } = this.quill.getFormat();
            if (value === "rtl" && align == null) this.quill.format("align", "right", (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
            else if (!value && align === "right") this.quill.format("align", false, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
            this.quill.format("direction", value, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
        },
        indent (value) {
            const range = this.quill.getSelection();
            // @ts-expect-error
            const formats = this.quill.getFormat(range);
            // @ts-expect-error
            const indent = parseInt(formats.indent || 0, 10);
            if (value === "+1" || value === "-1") {
                let modifier = value === "+1" ? 1 : -1;
                if (formats.direction === "rtl") modifier *= -1;
                this.quill.format("indent", indent + modifier, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
            }
        },
        link (value) {
            if (value === true) value = prompt("Enter link URL:"); // eslint-disable-line no-alert
            this.quill.format("link", value, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
        },
        list (value) {
            const range = this.quill.getSelection();
            // @ts-expect-error
            const formats = this.quill.getFormat(range);
            if (value === "check") {
                if (formats.list === "checked" || formats.list === "unchecked") this.quill.format("list", false, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
                else this.quill.format("list", "unchecked", (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
            } else this.quill.format("list", value, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
        }
    }
};


const $1401db88e437449c$var$alignLeftIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="3" x2="15" y1="9" y2="9"/><line class="ql-stroke" x1="3" x2="13" y1="14" y2="14"/><line class="ql-stroke" x1="3" x2="9" y1="4" y2="4"/></svg>';
const $1401db88e437449c$var$alignCenterIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"/><line class="ql-stroke" x1="14" x2="4" y1="14" y2="14"/><line class="ql-stroke" x1="12" x2="6" y1="4" y2="4"/></svg>';
const $1401db88e437449c$var$alignRightIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"/><line class="ql-stroke" x1="15" x2="5" y1="14" y2="14"/><line class="ql-stroke" x1="15" x2="9" y1="4" y2="4"/></svg>';
const $1401db88e437449c$var$alignJustifyIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="15" x2="3" y1="9" y2="9"/><line class="ql-stroke" x1="15" x2="3" y1="14" y2="14"/><line class="ql-stroke" x1="15" x2="3" y1="4" y2="4"/></svg>';
const $1401db88e437449c$var$backgroundIcon = '<svg viewbox="0 0 18 18"><g class="ql-fill ql-color-label"><polygon points="6 6.868 6 6 5 6 5 7 5.942 7 6 6.868"/><rect height="1" width="1" x="4" y="4"/><polygon points="6.817 5 6 5 6 6 6.38 6 6.817 5"/><rect height="1" width="1" x="2" y="6"/><rect height="1" width="1" x="3" y="5"/><rect height="1" width="1" x="4" y="7"/><polygon points="4 11.439 4 11 3 11 3 12 3.755 12 4 11.439"/><rect height="1" width="1" x="2" y="12"/><rect height="1" width="1" x="2" y="9"/><rect height="1" width="1" x="2" y="15"/><polygon points="4.63 10 4 10 4 11 4.192 11 4.63 10"/><rect height="1" width="1" x="3" y="8"/><path d="M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z"/><path d="M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z"/><path d="M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z"/><rect height="1" width="1" x="12" y="2"/><rect height="1" width="1" x="11" y="3"/><path d="M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z"/><rect height="1" width="1" x="2" y="3"/><rect height="1" width="1" x="6" y="2"/><rect height="1" width="1" x="3" y="2"/><rect height="1" width="1" x="5" y="3"/><rect height="1" width="1" x="9" y="2"/><rect height="1" width="1" x="15" y="14"/><polygon points="13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174"/><rect height="1" width="1" x="13" y="7"/><rect height="1" width="1" x="15" y="5"/><rect height="1" width="1" x="14" y="6"/><rect height="1" width="1" x="15" y="8"/><rect height="1" width="1" x="14" y="9"/><path d="M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z"/><rect height="1" width="1" x="14" y="3"/><polygon points="12 6.868 12 6 11.62 6 12 6.868"/><rect height="1" width="1" x="15" y="2"/><rect height="1" width="1" x="12" y="5"/><rect height="1" width="1" x="13" y="4"/><polygon points="12.933 9 13 9 13 8 12.495 8 12.933 9"/><rect height="1" width="1" x="9" y="14"/><rect height="1" width="1" x="8" y="15"/><path d="M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z"/><rect height="1" width="1" x="5" y="15"/><path d="M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z"/><rect height="1" width="1" x="11" y="15"/><path d="M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z"/><rect height="1" width="1" x="14" y="15"/><rect height="1" width="1" x="15" y="11"/></g><polyline class="ql-stroke" points="5.5 13 9 5 12.5 13"/><line class="ql-stroke" x1="11.63" x2="6.38" y1="11" y2="11"/></svg>';
const $1401db88e437449c$var$blockquoteIcon = '<svg viewbox="0 0 18 18"><rect class="ql-fill ql-stroke" height="3" width="3" x="4" y="5"/><rect class="ql-fill ql-stroke" height="3" width="3" x="11" y="5"/><path class="ql-even ql-fill ql-stroke" d="M7,8c0,4.031-3,5-3,5"/><path class="ql-even ql-fill ql-stroke" d="M14,8c0,4.031-3,5-3,5"/></svg>';
const $1401db88e437449c$var$boldIcon = '<svg viewbox="0 0 18 18"><path class="ql-stroke" d="M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z"/><path class="ql-stroke" d="M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z"/></svg>';
const $1401db88e437449c$var$cleanIcon = '<svg class="" viewbox="0 0 18 18"><line class="ql-stroke" x1="5" x2="13" y1="3" y2="3"/><line class="ql-stroke" x1="6" x2="9.35" y1="12" y2="3"/><line class="ql-stroke" x1="11" x2="15" y1="11" y2="15"/><line class="ql-stroke" x1="15" x2="11" y1="11" y2="15"/><rect class="ql-fill" height="1" rx="0.5" ry="0.5" width="7" x="2" y="14"/></svg>';
const $1401db88e437449c$var$codeIcon = '<svg viewbox="0 0 18 18"><polyline class="ql-even ql-stroke" points="5 7 3 9 5 11"/><polyline class="ql-even ql-stroke" points="13 7 15 9 13 11"/><line class="ql-stroke" x1="10" x2="8" y1="5" y2="13"/></svg>';
const $1401db88e437449c$var$colorIcon = '<svg viewbox="0 0 18 18"><line class="ql-color-label ql-stroke ql-transparent" x1="3" x2="15" y1="15" y2="15"/><polyline class="ql-stroke" points="5.5 11 9 3 12.5 11"/><line class="ql-stroke" x1="11.63" x2="6.38" y1="9" y2="9"/></svg>';
const $1401db88e437449c$var$directionLeftToRightIcon = '<svg viewbox="0 0 18 18"><polygon class="ql-stroke ql-fill" points="3 11 5 9 3 7 3 11"/><line class="ql-stroke ql-fill" x1="15" x2="11" y1="4" y2="4"/><path class="ql-fill" d="M11,3a3,3,0,0,0,0,6h1V3H11Z"/><rect class="ql-fill" height="11" width="1" x="11" y="4"/><rect class="ql-fill" height="11" width="1" x="13" y="4"/></svg>';
const $1401db88e437449c$var$directionRightToLeftIcon = '<svg viewbox="0 0 18 18"><polygon class="ql-stroke ql-fill" points="15 12 13 10 15 8 15 12"/><line class="ql-stroke ql-fill" x1="9" x2="5" y1="4" y2="4"/><path class="ql-fill" d="M5,3A3,3,0,0,0,5,9H6V3H5Z"/><rect class="ql-fill" height="11" width="1" x="5" y="4"/><rect class="ql-fill" height="11" width="1" x="7" y="4"/></svg>';
const $1401db88e437449c$var$formulaIcon = '<svg viewbox="0 0 18 18"><path class="ql-fill" d="M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z"/><rect class="ql-fill" height="1.6" rx="0.8" ry="0.8" width="5" x="5.15" y="6.2"/><path class="ql-fill" d="M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z"/></svg>';
const $1401db88e437449c$var$headerIcon = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z"/></svg>';
const $1401db88e437449c$var$header2Icon = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z"/></svg>';
const $1401db88e437449c$var$header3Icon = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M16.65186,12.30664a2.6742,2.6742,0,0,1-2.915,2.68457,3.96592,3.96592,0,0,1-2.25537-.6709.56007.56007,0,0,1-.13232-.83594L11.64648,13c.209-.34082.48389-.36328.82471-.1543a2.32654,2.32654,0,0,0,1.12256.33008c.71484,0,1.12207-.35156,1.12207-.78125,0-.61523-.61621-.86816-1.46338-.86816H13.2085a.65159.65159,0,0,1-.68213-.41895l-.05518-.10937a.67114.67114,0,0,1,.14307-.78125l.71533-.86914a8.55289,8.55289,0,0,1,.68213-.7373V8.58887a3.93913,3.93913,0,0,1-.748.05469H11.9873a.54085.54085,0,0,1-.605-.60547V7.59863a.54085.54085,0,0,1,.605-.60547h3.75146a.53773.53773,0,0,1,.60547.59375v.17676a1.03723,1.03723,0,0,1-.27539.748L14.74854,10.0293A2.31132,2.31132,0,0,1,16.65186,12.30664ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z"/></svg>';
const $1401db88e437449c$var$header4Icon = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm7.05371,7.96582v.38477c0,.39648-.165.60547-.46191.60547h-.47314v1.29785a.54085.54085,0,0,1-.605.60547h-.69336a.54085.54085,0,0,1-.605-.60547V12.95605H11.333a.5412.5412,0,0,1-.60547-.60547v-.15332a1.199,1.199,0,0,1,.22021-.748l2.56348-4.05957a.7819.7819,0,0,1,.72607-.39648h1.27637a.54085.54085,0,0,1,.605.60547v3.7627h.33008A.54055.54055,0,0,1,17.05371,11.96582ZM14.28125,8.7207h-.022a4.18969,4.18969,0,0,1-.38525.81348l-1.188,1.80469v.02246h1.5293V9.60059A7.04058,7.04058,0,0,1,14.28125,8.7207Z"/></svg>';
const $1401db88e437449c$var$header5Icon = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M16.74023,12.18555a2.75131,2.75131,0,0,1-2.91553,2.80566,3.908,3.908,0,0,1-2.25537-.68164.54809.54809,0,0,1-.13184-.8252L11.73438,13c.209-.34082.48389-.36328.8252-.1543a2.23757,2.23757,0,0,0,1.1001.33008,1.01827,1.01827,0,0,0,1.1001-.96777c0-.61621-.53906-.97949-1.25439-.97949a2.15554,2.15554,0,0,0-.64893.09961,1.15209,1.15209,0,0,1-.814.01074l-.12109-.04395a.64116.64116,0,0,1-.45117-.71484l.231-3.00391a.56666.56666,0,0,1,.62744-.583H15.541a.54085.54085,0,0,1,.605.60547v.43945a.54085.54085,0,0,1-.605.60547H13.41748l-.04395.72559a1.29306,1.29306,0,0,1-.04395.30859h.022a2.39776,2.39776,0,0,1,.57227-.07715A2.53266,2.53266,0,0,1,16.74023,12.18555ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z"/></svg>';
const $1401db88e437449c$var$header6Icon = '<svg viewBox="0 0 18 18"><path class="ql-fill" d="M14.51758,9.64453a1.85627,1.85627,0,0,0-1.24316.38477H13.252a1.73532,1.73532,0,0,1,1.72754-1.4082,2.66491,2.66491,0,0,1,.5498.06641c.35254.05469.57227.01074.70508-.40723l.16406-.5166a.53393.53393,0,0,0-.373-.75977,4.83723,4.83723,0,0,0-1.17773-.14258c-2.43164,0-3.7627,2.17773-3.7627,4.43359,0,2.47559,1.60645,3.69629,3.19043,3.69629A2.70585,2.70585,0,0,0,16.96,12.19727,2.43861,2.43861,0,0,0,14.51758,9.64453Zm-.23047,3.58691c-.67187,0-1.22168-.81445-1.22168-1.45215,0-.47363.30762-.583.72559-.583.96875,0,1.27734.59375,1.27734,1.12207A.82182.82182,0,0,1,14.28711,13.23145ZM10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Z"/></svg>';
const $1401db88e437449c$var$italicIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="7" x2="13" y1="4" y2="4"/><line class="ql-stroke" x1="5" x2="11" y1="14" y2="14"/><line class="ql-stroke" x1="8" x2="10" y1="14" y2="4"/></svg>';
const $1401db88e437449c$var$imageIcon = '<svg viewbox="0 0 18 18"><rect class="ql-stroke" height="10" width="12" x="3" y="4"/><circle class="ql-fill" cx="6" cy="7" r="1"/><polyline class="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"/></svg>';
const $1401db88e437449c$var$indentIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="3" x2="15" y1="14" y2="14"/><line class="ql-stroke" x1="3" x2="15" y1="4" y2="4"/><line class="ql-stroke" x1="9" x2="15" y1="9" y2="9"/><polyline class="ql-fill ql-stroke" points="3 7 3 11 5 9 3 7"/></svg>';
const $1401db88e437449c$var$outdentIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="3" x2="15" y1="14" y2="14"/><line class="ql-stroke" x1="3" x2="15" y1="4" y2="4"/><line class="ql-stroke" x1="9" x2="15" y1="9" y2="9"/><polyline class="ql-stroke" points="5 7 5 11 3 9 5 7"/></svg>';
const $1401db88e437449c$var$linkIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="7" x2="11" y1="7" y2="11"/><path class="ql-even ql-stroke" d="M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z"/><path class="ql-even ql-stroke" d="M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z"/></svg>';
const $1401db88e437449c$var$listBulletIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="6" x2="15" y1="4" y2="4"/><line class="ql-stroke" x1="6" x2="15" y1="9" y2="9"/><line class="ql-stroke" x1="6" x2="15" y1="14" y2="14"/><line class="ql-stroke" x1="3" x2="3" y1="4" y2="4"/><line class="ql-stroke" x1="3" x2="3" y1="9" y2="9"/><line class="ql-stroke" x1="3" x2="3" y1="14" y2="14"/></svg>';
const $1401db88e437449c$var$listCheckIcon = '<svg class="" viewbox="0 0 18 18"><line class="ql-stroke" x1="9" x2="15" y1="4" y2="4"/><polyline class="ql-stroke" points="3 4 4 5 6 3"/><line class="ql-stroke" x1="9" x2="15" y1="14" y2="14"/><polyline class="ql-stroke" points="3 14 4 15 6 13"/><line class="ql-stroke" x1="9" x2="15" y1="9" y2="9"/><polyline class="ql-stroke" points="3 9 4 10 6 8"/></svg>';
const $1401db88e437449c$var$listOrderedIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke" x1="7" x2="15" y1="4" y2="4"/><line class="ql-stroke" x1="7" x2="15" y1="9" y2="9"/><line class="ql-stroke" x1="7" x2="15" y1="14" y2="14"/><line class="ql-stroke ql-thin" x1="2.5" x2="4.5" y1="5.5" y2="5.5"/><path class="ql-fill" d="M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z"/><path class="ql-stroke ql-thin" d="M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156"/><path class="ql-stroke ql-thin" d="M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109"/></svg>';
const $1401db88e437449c$var$subscriptIcon = '<svg viewbox="0 0 18 18"><path class="ql-fill" d="M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z"/><path class="ql-fill" d="M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z"/></svg>';
const $1401db88e437449c$var$superscriptIcon = '<svg viewbox="0 0 18 18"><path class="ql-fill" d="M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z"/><path class="ql-fill" d="M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z"/></svg>';
const $1401db88e437449c$var$strikeIcon = '<svg viewbox="0 0 18 18"><line class="ql-stroke ql-thin" x1="15.5" x2="2.5" y1="8.5" y2="9.5"/><path class="ql-fill" d="M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z"/><path class="ql-fill" d="M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z"/></svg>';
const $1401db88e437449c$var$tableIcon = '<svg viewbox="0 0 18 18"><rect class="ql-stroke" height="12" width="12" x="3" y="3"/><rect class="ql-fill" height="2" width="3" x="5" y="5"/><rect class="ql-fill" height="2" width="4" x="9" y="5"/><g class="ql-fill ql-transparent"><rect height="2" width="3" x="5" y="8"/><rect height="2" width="4" x="9" y="8"/><rect height="2" width="3" x="5" y="11"/><rect height="2" width="4" x="9" y="11"/></g></svg>';
const $1401db88e437449c$var$underlineIcon = '<svg viewbox="0 0 18 18"><path class="ql-stroke" d="M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3"/><rect class="ql-fill" height="1" rx="0.5" ry="0.5" width="12" x="3" y="15"/></svg>';
const $1401db88e437449c$var$videoIcon = '<svg viewbox="0 0 18 18"><rect class="ql-stroke" height="12" width="12" x="3" y="3"/><rect class="ql-fill" height="12" width="1" x="5" y="3"/><rect class="ql-fill" height="12" width="1" x="12" y="3"/><rect class="ql-fill" height="2" width="8" x="5" y="8"/><rect class="ql-fill" height="1" width="3" x="3" y="5"/><rect class="ql-fill" height="1" width="3" x="3" y="7"/><rect class="ql-fill" height="1" width="3" x="3" y="10"/><rect class="ql-fill" height="1" width="3" x="3" y="12"/><rect class="ql-fill" height="1" width="3" x="12" y="5"/><rect class="ql-fill" height="1" width="3" x="12" y="7"/><rect class="ql-fill" height="1" width="3" x="12" y="10"/><rect class="ql-fill" height="1" width="3" x="12" y="12"/></svg>';
var $1401db88e437449c$export$2e2bcd8739ae039 = {
    align: {
        "": $1401db88e437449c$var$alignLeftIcon,
        center: $1401db88e437449c$var$alignCenterIcon,
        right: $1401db88e437449c$var$alignRightIcon,
        justify: $1401db88e437449c$var$alignJustifyIcon
    },
    background: $1401db88e437449c$var$backgroundIcon,
    blockquote: $1401db88e437449c$var$blockquoteIcon,
    bold: $1401db88e437449c$var$boldIcon,
    clean: $1401db88e437449c$var$cleanIcon,
    code: $1401db88e437449c$var$codeIcon,
    "code-block": $1401db88e437449c$var$codeIcon,
    color: $1401db88e437449c$var$colorIcon,
    direction: {
        "": $1401db88e437449c$var$directionLeftToRightIcon,
        rtl: $1401db88e437449c$var$directionRightToLeftIcon
    },
    formula: $1401db88e437449c$var$formulaIcon,
    header: {
        "1": $1401db88e437449c$var$headerIcon,
        "2": $1401db88e437449c$var$header2Icon,
        "3": $1401db88e437449c$var$header3Icon,
        "4": $1401db88e437449c$var$header4Icon,
        "5": $1401db88e437449c$var$header5Icon,
        "6": $1401db88e437449c$var$header6Icon
    },
    italic: $1401db88e437449c$var$italicIcon,
    image: $1401db88e437449c$var$imageIcon,
    indent: {
        "+1": $1401db88e437449c$var$indentIcon,
        "-1": $1401db88e437449c$var$outdentIcon
    },
    link: $1401db88e437449c$var$linkIcon,
    list: {
        bullet: $1401db88e437449c$var$listBulletIcon,
        check: $1401db88e437449c$var$listCheckIcon,
        ordered: $1401db88e437449c$var$listOrderedIcon
    },
    script: {
        sub: $1401db88e437449c$var$subscriptIcon,
        super: $1401db88e437449c$var$superscriptIcon
    },
    strike: $1401db88e437449c$var$strikeIcon,
    table: $1401db88e437449c$var$tableIcon,
    underline: $1401db88e437449c$var$underlineIcon,
    video: $1401db88e437449c$var$videoIcon
};


const $bbc7850c168ff488$var$DropdownIcon = '<svg viewbox="0 0 18 18"><polygon class="ql-stroke" points="7 11 9 13 11 11 7 11"/><polygon class="ql-stroke" points="7 7 9 5 11 7 7 7"/></svg>';
let $bbc7850c168ff488$var$optionsCounter = 0;
function $bbc7850c168ff488$var$toggleAriaAttribute(element, attribute) {
    element.setAttribute(attribute, `${!(element.getAttribute(attribute) === "true")}`);
}
class $bbc7850c168ff488$var$Picker {
    togglePicker() {
        this.container.classList.toggle("ql-expanded");
        // Toggle aria-expanded and aria-hidden to make the picker accessible
        $bbc7850c168ff488$var$toggleAriaAttribute(this.label, "aria-expanded");
        // @ts-expect-error
        $bbc7850c168ff488$var$toggleAriaAttribute(this.options, "aria-hidden");
    }
    buildItem(option) {
        const item = document.createElement("span");
        // @ts-expect-error
        item.tabIndex = "0";
        item.setAttribute("role", "button");
        item.classList.add("ql-picker-item");
        const value = option.getAttribute("value");
        if (value) item.setAttribute("data-value", value);
        if (option.textContent) item.setAttribute("data-label", option.textContent);
        item.addEventListener("click", ()=>{
            this.selectItem(item, true);
        });
        item.addEventListener("keydown", (event)=>{
            switch(event.key){
                case "Enter":
                    this.selectItem(item, true);
                    event.preventDefault();
                    break;
                case "Escape":
                    this.escape();
                    event.preventDefault();
                    break;
                default:
            }
        });
        return item;
    }
    buildLabel() {
        const label = document.createElement("span");
        label.classList.add("ql-picker-label");
        label.innerHTML = $bbc7850c168ff488$var$DropdownIcon;
        // @ts-expect-error
        label.tabIndex = "0";
        label.setAttribute("role", "button");
        label.setAttribute("aria-expanded", "false");
        this.container.appendChild(label);
        return label;
    }
    buildOptions() {
        const options = document.createElement("span");
        options.classList.add("ql-picker-options");
        // Don't want screen readers to read this until options are visible
        options.setAttribute("aria-hidden", "true");
        // @ts-expect-error
        options.tabIndex = "-1";
        // Need a unique id for aria-controls
        options.id = `ql-picker-options-${$bbc7850c168ff488$var$optionsCounter}`;
        $bbc7850c168ff488$var$optionsCounter += 1;
        this.label.setAttribute("aria-controls", options.id);
        // @ts-expect-error
        this.options = options;
        Array.from(this.select.options).forEach((option)=>{
            const item = this.buildItem(option);
            options.appendChild(item);
            if (option.selected === true) this.selectItem(item);
        });
        this.container.appendChild(options);
    }
    buildPicker() {
        Array.from(this.select.attributes).forEach((item)=>{
            this.container.setAttribute(item.name, item.value);
        });
        this.container.classList.add("ql-picker");
        this.label = this.buildLabel();
        this.buildOptions();
    }
    escape() {
        // Close menu and return focus to trigger label
        this.close();
        // Need setTimeout for accessibility to ensure that the browser executes
        // focus on the next process thread and after any DOM content changes
        setTimeout(()=>this.label.focus(), 1);
    }
    close() {
        this.container.classList.remove("ql-expanded");
        this.label.setAttribute("aria-expanded", "false");
        // @ts-expect-error
        this.options.setAttribute("aria-hidden", "true");
    }
    selectItem(item) {
        let trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        const selected = this.container.querySelector(".ql-selected");
        if (item === selected) return;
        if (selected != null) selected.classList.remove("ql-selected");
        if (item == null) return;
        item.classList.add("ql-selected");
        // @ts-expect-error Fix me later
        this.select.selectedIndex = Array.from(item.parentNode.children).indexOf(item);
        if (item.hasAttribute("data-value")) // @ts-expect-error Fix me later
        this.label.setAttribute("data-value", item.getAttribute("data-value"));
        else this.label.removeAttribute("data-value");
        if (item.hasAttribute("data-label")) // @ts-expect-error Fix me later
        this.label.setAttribute("data-label", item.getAttribute("data-label"));
        else this.label.removeAttribute("data-label");
        if (trigger) {
            this.select.dispatchEvent(new Event("change"));
            this.close();
        }
    }
    update() {
        let option;
        if (this.select.selectedIndex > -1) {
            const item = // @ts-expect-error Fix me later
            this.container.querySelector(".ql-picker-options").children[this.select.selectedIndex];
            option = this.select.options[this.select.selectedIndex];
            // @ts-expect-error
            this.selectItem(item);
        } else this.selectItem(null);
        const isActive = option != null && option !== this.select.querySelector("option[selected]");
        this.label.classList.toggle("ql-active", isActive);
    }
    constructor(select){
        this.select = select;
        this.container = document.createElement("span");
        this.buildPicker();
        this.select.style.display = "none";
        // @ts-expect-error Fix me later
        this.select.parentNode.insertBefore(this.container, this.select);
        this.label.addEventListener("mousedown", ()=>{
            this.togglePicker();
        });
        this.label.addEventListener("keydown", (event)=>{
            switch(event.key){
                case "Enter":
                    this.togglePicker();
                    break;
                case "Escape":
                    this.escape();
                    event.preventDefault();
                    break;
                default:
            }
        });
        this.select.addEventListener("change", this.update.bind(this));
    }
}
var $bbc7850c168ff488$export$2e2bcd8739ae039 = $bbc7850c168ff488$var$Picker;



class $a86e9bdea598e051$var$ColorPicker extends (0, $bbc7850c168ff488$export$2e2bcd8739ae039) {
    buildItem(option) {
        const item = super.buildItem(option);
        item.style.backgroundColor = option.getAttribute("value") || "";
        return item;
    }
    selectItem(item, trigger) {
        super.selectItem(item, trigger);
        const colorLabel = this.label.querySelector(".ql-color-label");
        const value = item ? item.getAttribute("data-value") || "" : "";
        if (colorLabel) {
            if (colorLabel.tagName === "line") colorLabel.style.stroke = value;
            else colorLabel.style.fill = value;
        }
    }
    constructor(select, label){
        super(select);
        this.label.innerHTML = label;
        this.container.classList.add("ql-color-picker");
        Array.from(this.container.querySelectorAll(".ql-picker-item")).slice(0, 7).forEach((item)=>{
            item.classList.add("ql-primary");
        });
    }
}
var $a86e9bdea598e051$export$2e2bcd8739ae039 = $a86e9bdea598e051$var$ColorPicker;



class $4029713c4c15f54e$var$IconPicker extends (0, $bbc7850c168ff488$export$2e2bcd8739ae039) {
    selectItem(target, trigger) {
        super.selectItem(target, trigger);
        const item = target || this.defaultItem;
        if (item != null) {
            if (this.label.innerHTML === item.innerHTML) return;
            this.label.innerHTML = item.innerHTML;
        }
    }
    constructor(select, icons){
        super(select);
        this.container.classList.add("ql-icon-picker");
        Array.from(this.container.querySelectorAll(".ql-picker-item")).forEach((item)=>{
            item.innerHTML = icons[item.getAttribute("data-value") || ""];
        });
        this.defaultItem = this.container.querySelector(".ql-selected");
        this.selectItem(this.defaultItem);
    }
}
var $4029713c4c15f54e$export$2e2bcd8739ae039 = $4029713c4c15f54e$var$IconPicker;


const $8d3ba9207edbf82d$var$isScrollable = (el)=>{
    const { overflowY: overflowY } = getComputedStyle(el, null);
    return overflowY !== "visible" && overflowY !== "clip";
};
class $8d3ba9207edbf82d$var$Tooltip {
    hide() {
        this.root.classList.add("ql-hidden");
    }
    position(reference) {
        const left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
        // root.scrollTop should be 0 if scrollContainer !== root
        const top = reference.bottom + this.quill.root.scrollTop;
        this.root.style.left = `${left}px`;
        this.root.style.top = `${top}px`;
        this.root.classList.remove("ql-flip");
        const containerBounds = this.boundsContainer.getBoundingClientRect();
        const rootBounds = this.root.getBoundingClientRect();
        let shift = 0;
        if (rootBounds.right > containerBounds.right) {
            shift = containerBounds.right - rootBounds.right;
            this.root.style.left = `${left + shift}px`;
        }
        if (rootBounds.left < containerBounds.left) {
            shift = containerBounds.left - rootBounds.left;
            this.root.style.left = `${left + shift}px`;
        }
        if (rootBounds.bottom > containerBounds.bottom) {
            const height = rootBounds.bottom - rootBounds.top;
            const verticalShift = reference.bottom - reference.top + height;
            this.root.style.top = `${top - verticalShift}px`;
            this.root.classList.add("ql-flip");
        }
        return shift;
    }
    show() {
        this.root.classList.remove("ql-editing");
        this.root.classList.remove("ql-hidden");
    }
    constructor(quill, boundsContainer){
        this.quill = quill;
        this.boundsContainer = boundsContainer || document.body;
        this.root = quill.addContainer("ql-tooltip");
        // @ts-expect-error
        this.root.innerHTML = this.constructor.TEMPLATE;
        if ($8d3ba9207edbf82d$var$isScrollable(this.quill.root)) this.quill.root.addEventListener("scroll", ()=>{
            this.root.style.marginTop = `${-1 * this.quill.root.scrollTop}px`;
        });
        this.hide();
    }
}
var $8d3ba9207edbf82d$export$2e2bcd8739ae039 = $8d3ba9207edbf82d$var$Tooltip;



var $97zcJ = parcelRequire("97zcJ");









const $f5a6e21c592e6119$var$ALIGNS = [
    false,
    "center",
    "right",
    "justify"
];
const $f5a6e21c592e6119$var$COLORS = [
    "#000000",
    "#e60000",
    "#ff9900",
    "#ffff00",
    "#008a00",
    "#0066cc",
    "#9933ff",
    "#ffffff",
    "#facccc",
    "#ffebcc",
    "#ffffcc",
    "#cce8cc",
    "#cce0f5",
    "#ebd6ff",
    "#bbbbbb",
    "#f06666",
    "#ffc266",
    "#ffff66",
    "#66b966",
    "#66a3e0",
    "#c285ff",
    "#888888",
    "#a10000",
    "#b26b00",
    "#b2b200",
    "#006100",
    "#0047b2",
    "#6b24b2",
    "#444444",
    "#5c0000",
    "#663d00",
    "#666600",
    "#003700",
    "#002966",
    "#3d1466"
];
const $f5a6e21c592e6119$var$FONTS = [
    false,
    "serif",
    "monospace"
];
const $f5a6e21c592e6119$var$HEADERS = [
    "1",
    "2",
    "3",
    false
];
const $f5a6e21c592e6119$var$SIZES = [
    "small",
    false,
    "large",
    "huge"
];
class $f5a6e21c592e6119$export$2e2bcd8739ae039 extends (0, $5c563bda509d6d32$export$2e2bcd8739ae039) {
    addModule(name) {
        const module = super.addModule(name);
        if (name === "toolbar") // @ts-expect-error
        this.extendToolbar(module);
        return module;
    }
    buildButtons(buttons, icons) {
        Array.from(buttons).forEach((button)=>{
            const className = button.getAttribute("class") || "";
            className.split(/\s+/).forEach((name)=>{
                if (!name.startsWith("ql-")) return;
                name = name.slice(3);
                if (icons[name] == null) return;
                if (name === "direction") // @ts-expect-error
                button.innerHTML = icons[name][""] + icons[name].rtl;
                else if (typeof icons[name] === "string") // @ts-expect-error
                button.innerHTML = icons[name];
                else {
                    // @ts-expect-error
                    const value = button.value || "";
                    // @ts-expect-error
                    if (value != null && icons[name][value]) // @ts-expect-error
                    button.innerHTML = icons[name][value];
                }
            });
        });
    }
    buildPickers(selects, icons) {
        this.pickers = Array.from(selects).map((select)=>{
            if (select.classList.contains("ql-align")) {
                if (select.querySelector("option") == null) $f5a6e21c592e6119$var$fillSelect(select, $f5a6e21c592e6119$var$ALIGNS);
                if (typeof icons.align === "object") return new (0, $4029713c4c15f54e$export$2e2bcd8739ae039)(select, icons.align);
            }
            if (select.classList.contains("ql-background") || select.classList.contains("ql-color")) {
                const format = select.classList.contains("ql-background") ? "background" : "color";
                if (select.querySelector("option") == null) $f5a6e21c592e6119$var$fillSelect(select, $f5a6e21c592e6119$var$COLORS, format === "background" ? "#ffffff" : "#000000");
                return new (0, $a86e9bdea598e051$export$2e2bcd8739ae039)(select, icons[format]);
            }
            if (select.querySelector("option") == null) {
                if (select.classList.contains("ql-font")) $f5a6e21c592e6119$var$fillSelect(select, $f5a6e21c592e6119$var$FONTS);
                else if (select.classList.contains("ql-header")) $f5a6e21c592e6119$var$fillSelect(select, $f5a6e21c592e6119$var$HEADERS);
                else if (select.classList.contains("ql-size")) $f5a6e21c592e6119$var$fillSelect(select, $f5a6e21c592e6119$var$SIZES);
            }
            return new (0, $bbc7850c168ff488$export$2e2bcd8739ae039)(select);
        });
        const update = ()=>{
            this.pickers.forEach((picker)=>{
                picker.update();
            });
        };
        this.quill.on((0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.EDITOR_CHANGE, update);
    }
    constructor(quill, options){
        super(quill, options);
        const listener = (e)=>{
            if (!document.body.contains(quill.root)) {
                document.body.removeEventListener("click", listener);
                return;
            }
            if (this.tooltip != null && // @ts-expect-error
            !this.tooltip.root.contains(e.target) && // @ts-expect-error
            document.activeElement !== this.tooltip.textbox && !this.quill.hasFocus()) this.tooltip.hide();
            if (this.pickers != null) this.pickers.forEach((picker)=>{
                // @ts-expect-error
                if (!picker.container.contains(e.target)) picker.close();
            });
        };
        quill.emitter.listenDOM("click", document.body, listener);
    }
}
$f5a6e21c592e6119$export$2e2bcd8739ae039.DEFAULTS = (0, $47c6e52c26bddb86$export$2e2bcd8739ae039)({}, (0, $5c563bda509d6d32$export$2e2bcd8739ae039).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                formula () {
                    this.quill.theme.tooltip.edit("formula");
                },
                image () {
                    let fileInput = this.container.querySelector("input.ql-image[type=file]");
                    if (fileInput == null) {
                        fileInput = document.createElement("input");
                        fileInput.setAttribute("type", "file");
                        fileInput.setAttribute("accept", this.quill.uploader.options.mimetypes.join(", "));
                        fileInput.classList.add("ql-image");
                        fileInput.addEventListener("change", ()=>{
                            const range = this.quill.getSelection(true);
                            this.quill.uploader.upload(range, fileInput.files);
                            fileInput.value = "";
                        });
                        this.container.appendChild(fileInput);
                    }
                    fileInput.click();
                },
                video () {
                    this.quill.theme.tooltip.edit("video");
                }
            }
        }
    }
});
class $f5a6e21c592e6119$export$ba0102162f9e195c extends (0, $8d3ba9207edbf82d$export$2e2bcd8739ae039) {
    listen() {
        // @ts-expect-error Fix me later
        this.textbox.addEventListener("keydown", (event)=>{
            if (event.key === "Enter") {
                this.save();
                event.preventDefault();
            } else if (event.key === "Escape") {
                this.cancel();
                event.preventDefault();
            }
        });
    }
    cancel() {
        this.hide();
        this.restoreFocus();
    }
    edit() {
        let mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "link";
        let preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        this.root.classList.remove("ql-hidden");
        this.root.classList.add("ql-editing");
        if (this.textbox == null) return;
        if (preview != null) this.textbox.value = preview;
        else if (mode !== this.root.getAttribute("data-mode")) this.textbox.value = "";
        const bounds = this.quill.getBounds(this.quill.selection.savedRange);
        if (bounds != null) this.position(bounds);
        this.textbox.select();
        this.textbox.setAttribute("placeholder", this.textbox.getAttribute(`data-${mode}`) || "");
        this.root.setAttribute("data-mode", mode);
    }
    restoreFocus() {
        this.quill.focus({
            preventScroll: true
        });
    }
    save() {
        // @ts-expect-error Fix me later
        let { value: value } = this.textbox;
        switch(this.root.getAttribute("data-mode")){
            case "link":
                {
                    const { scrollTop: scrollTop } = this.quill.root;
                    if (this.linkRange) {
                        this.quill.formatText(this.linkRange, "link", value, (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.USER);
                        delete this.linkRange;
                    } else {
                        this.restoreFocus();
                        this.quill.format("link", value, (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.USER);
                    }
                    this.quill.root.scrollTop = scrollTop;
                    break;
                }
            case "video":
                value = $f5a6e21c592e6119$var$extractVideoUrl(value);
            // eslint-disable-next-line no-fallthrough
            case "formula":
                {
                    if (!value) break;
                    const range = this.quill.getSelection(true);
                    if (range != null) {
                        const index = range.index + range.length;
                        this.quill.insertEmbed(index, // @ts-expect-error Fix me later
                        this.root.getAttribute("data-mode"), value, (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.USER);
                        if (this.root.getAttribute("data-mode") === "formula") this.quill.insertText(index + 1, " ", (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.USER);
                        this.quill.setSelection(index + 2, (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.USER);
                    }
                    break;
                }
            default:
        }
        // @ts-expect-error Fix me later
        this.textbox.value = "";
        this.hide();
    }
    constructor(quill, boundsContainer){
        super(quill, boundsContainer);
        this.textbox = this.root.querySelector('input[type="text"]');
        this.listen();
    }
}
function $f5a6e21c592e6119$var$extractVideoUrl(url) {
    let match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
    if (match) return `${match[1] || "https"}://www.youtube.com/embed/${match[2]}?showinfo=0`;
    // eslint-disable-next-line no-cond-assign
    if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) return `${match[1] || "https"}://player.vimeo.com/video/${match[2]}/`;
    return url;
}
function $f5a6e21c592e6119$var$fillSelect(select, values) {
    let defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    values.forEach((value)=>{
        const option = document.createElement("option");
        if (value === defaultValue) option.setAttribute("selected", "selected");
        else option.setAttribute("value", String(value));
        select.appendChild(option);
    });
}





const $28932e066b4fa6fc$var$TOOLBAR_CONFIG = [
    [
        "bold",
        "italic",
        "link"
    ],
    [
        {
            header: 1
        },
        {
            header: 2
        },
        "blockquote"
    ]
];
class $28932e066b4fa6fc$export$572b56f7a5e9813a extends (0, $f5a6e21c592e6119$export$ba0102162f9e195c) {
    listen() {
        super.listen();
        // @ts-expect-error Fix me later
        this.root.querySelector(".ql-close").addEventListener("click", ()=>{
            this.root.classList.remove("ql-editing");
        });
        this.quill.on((0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.SCROLL_OPTIMIZE, ()=>{
            // Let selection be restored by toolbar handlers before repositioning
            setTimeout(()=>{
                if (this.root.classList.contains("ql-hidden")) return;
                const range = this.quill.getSelection();
                if (range != null) {
                    const bounds = this.quill.getBounds(range);
                    if (bounds != null) this.position(bounds);
                }
            }, 1);
        });
    }
    cancel() {
        this.show();
    }
    position(reference) {
        const shift = super.position(reference);
        const arrow = this.root.querySelector(".ql-tooltip-arrow");
        // @ts-expect-error
        arrow.style.marginLeft = "";
        if (shift !== 0) // @ts-expect-error
        arrow.style.marginLeft = `${-1 * shift - arrow.offsetWidth / 2}px`;
        return shift;
    }
    constructor(quill, bounds){
        super(quill, bounds);
        this.quill.on((0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.EDITOR_CHANGE, (type, range, oldRange, source)=>{
            if (type !== (0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.SELECTION_CHANGE) return;
            if (range != null && range.length > 0 && source === (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.USER) {
                this.show();
                // Lock our width so we will expand beyond our offsetParent boundaries
                this.root.style.left = "0px";
                this.root.style.width = "";
                this.root.style.width = `${this.root.offsetWidth}px`;
                const lines = this.quill.getLines(range.index, range.length);
                if (lines.length === 1) {
                    const bounds = this.quill.getBounds(range);
                    if (bounds != null) this.position(bounds);
                } else {
                    const lastLine = lines[lines.length - 1];
                    const index = this.quill.getIndex(lastLine);
                    const length = Math.min(lastLine.length() - 1, range.index + range.length - index);
                    const indexBounds = this.quill.getBounds(new (0, $df4239af590079e1$export$9a58ef0d7ad3278c)(index, length));
                    if (indexBounds != null) this.position(indexBounds);
                }
            } else if (document.activeElement !== this.textbox && this.quill.hasFocus()) this.hide();
        });
    }
}
(0, $97zcJ._)($28932e066b4fa6fc$export$572b56f7a5e9813a, "TEMPLATE", [
    '<span class="ql-tooltip-arrow"></span>',
    '<div class="ql-tooltip-editor">',
    '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
    '<a class="ql-close"></a>',
    "</div>"
].join(""));
class $28932e066b4fa6fc$export$2e2bcd8739ae039 extends (0, $f5a6e21c592e6119$export$2e2bcd8739ae039) {
    extendToolbar(toolbar) {
        // @ts-expect-error
        this.tooltip = new $28932e066b4fa6fc$export$572b56f7a5e9813a(this.quill, this.options.bounds);
        if (toolbar.container != null) {
            this.tooltip.root.appendChild(toolbar.container);
            this.buildButtons(toolbar.container.querySelectorAll("button"), (0, $1401db88e437449c$export$2e2bcd8739ae039));
            this.buildPickers(toolbar.container.querySelectorAll("select"), (0, $1401db88e437449c$export$2e2bcd8739ae039));
        }
    }
    constructor(quill, options){
        if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = $28932e066b4fa6fc$var$TOOLBAR_CONFIG;
        super(quill, options);
        this.quill.container.classList.add("ql-bubble");
    }
}
$28932e066b4fa6fc$export$2e2bcd8739ae039.DEFAULTS = (0, $47c6e52c26bddb86$export$2e2bcd8739ae039)({}, (0, $f5a6e21c592e6119$export$2e2bcd8739ae039).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                link (value) {
                    if (!value) this.quill.format("link", false, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
                    else // @ts-expect-error
                    this.quill.theme.tooltip.edit();
                }
            }
        }
    }
});



var $97zcJ = parcelRequire("97zcJ");







const $c86e397362fa2d50$var$TOOLBAR_CONFIG = [
    [
        {
            header: [
                "1",
                "2",
                "3",
                false
            ]
        }
    ],
    [
        "bold",
        "italic",
        "underline",
        "link"
    ],
    [
        {
            list: "ordered"
        },
        {
            list: "bullet"
        }
    ],
    [
        "clean"
    ]
];
class $c86e397362fa2d50$var$SnowTooltip extends (0, $f5a6e21c592e6119$export$ba0102162f9e195c) {
    listen() {
        super.listen();
        // @ts-expect-error Fix me later
        this.root.querySelector("a.ql-action").addEventListener("click", (event)=>{
            if (this.root.classList.contains("ql-editing")) this.save();
            else // @ts-expect-error Fix me later
            this.edit("link", this.preview.textContent);
            event.preventDefault();
        });
        // @ts-expect-error Fix me later
        this.root.querySelector("a.ql-remove").addEventListener("click", (event)=>{
            if (this.linkRange != null) {
                const range = this.linkRange;
                this.restoreFocus();
                this.quill.formatText(range, "link", false, (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.USER);
                delete this.linkRange;
            }
            event.preventDefault();
            this.hide();
        });
        this.quill.on((0, $6c311a36f0b35611$export$2e2bcd8739ae039).events.SELECTION_CHANGE, (range, oldRange, source)=>{
            if (range == null) return;
            if (range.length === 0 && source === (0, $6c311a36f0b35611$export$2e2bcd8739ae039).sources.USER) {
                const [link, offset] = this.quill.scroll.descendant((0, $68007fb83d8b2db6$export$2e2bcd8739ae039), range.index);
                if (link != null) {
                    this.linkRange = new (0, $df4239af590079e1$export$9a58ef0d7ad3278c)(range.index - offset, link.length());
                    const preview = (0, $68007fb83d8b2db6$export$2e2bcd8739ae039).formats(link.domNode);
                    // @ts-expect-error Fix me later
                    this.preview.textContent = preview;
                    // @ts-expect-error Fix me later
                    this.preview.setAttribute("href", preview);
                    this.show();
                    const bounds = this.quill.getBounds(this.linkRange);
                    if (bounds != null) this.position(bounds);
                    return;
                }
            } else delete this.linkRange;
            this.hide();
        });
    }
    show() {
        super.show();
        this.root.removeAttribute("data-mode");
    }
    constructor(...args){
        super(...args);
        (0, $97zcJ._)(this, "preview", this.root.querySelector("a.ql-preview"));
    }
}
(0, $97zcJ._)($c86e397362fa2d50$var$SnowTooltip, "TEMPLATE", [
    '<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>',
    '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">',
    '<a class="ql-action"></a>',
    '<a class="ql-remove"></a>'
].join(""));
class $c86e397362fa2d50$var$SnowTheme extends (0, $f5a6e21c592e6119$export$2e2bcd8739ae039) {
    extendToolbar(toolbar) {
        if (toolbar.container != null) {
            toolbar.container.classList.add("ql-snow");
            this.buildButtons(toolbar.container.querySelectorAll("button"), (0, $1401db88e437449c$export$2e2bcd8739ae039));
            this.buildPickers(toolbar.container.querySelectorAll("select"), (0, $1401db88e437449c$export$2e2bcd8739ae039));
            // @ts-expect-error
            this.tooltip = new $c86e397362fa2d50$var$SnowTooltip(this.quill, this.options.bounds);
            if (toolbar.container.querySelector(".ql-link")) this.quill.keyboard.addBinding({
                key: "k",
                shortKey: true
            }, (_range, context)=>{
                toolbar.handlers.link.call(toolbar, !context.format.link);
            });
        }
    }
    constructor(quill, options){
        if (options.modules.toolbar != null && options.modules.toolbar.container == null) options.modules.toolbar.container = $c86e397362fa2d50$var$TOOLBAR_CONFIG;
        super(quill, options);
        this.quill.container.classList.add("ql-snow");
    }
}
$c86e397362fa2d50$var$SnowTheme.DEFAULTS = (0, $47c6e52c26bddb86$export$2e2bcd8739ae039)({}, (0, $f5a6e21c592e6119$export$2e2bcd8739ae039).DEFAULTS, {
    modules: {
        toolbar: {
            handlers: {
                link (value) {
                    if (value) {
                        const range = this.quill.getSelection();
                        if (range == null || range.length === 0) return;
                        let preview = this.quill.getText(range);
                        if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf("mailto:") !== 0) preview = `mailto:${preview}`;
                        // @ts-expect-error
                        const { tooltip: tooltip } = this.quill.theme;
                        tooltip.edit("link", preview);
                    } else this.quill.format("link", false, (0, $c868a5e4990268d1$export$2e2bcd8739ae039).sources.USER);
                }
            }
        }
    }
});
var $c86e397362fa2d50$export$2e2bcd8739ae039 = $c86e397362fa2d50$var$SnowTheme;


(0, $b7eaeeafee7196fc$export$2e2bcd8739ae039).register({
    "attributors/attribute/direction": (0, $0f48d508e188d6f9$export$4158215dafad9efa),
    "attributors/class/align": (0, $fabb70fc3b74eee9$export$7f3685f5846c07da),
    "attributors/class/background": (0, $34ad99861d7d9ec9$export$8aa96c8963152b12),
    "attributors/class/color": (0, $e83e82854e7f7981$export$42795dcf0ec6f3c8),
    "attributors/class/direction": (0, $0f48d508e188d6f9$export$630028b3af294dec),
    "attributors/class/font": (0, $451e84313c3d6754$export$78a99ee601572ab),
    "attributors/class/size": (0, $de0c2b1e0a6b32a7$export$c84684d52bca9684),
    "attributors/style/align": (0, $fabb70fc3b74eee9$export$d2060f5d114c9fe8),
    "attributors/style/background": (0, $34ad99861d7d9ec9$export$dc1cbcab4c682ef),
    "attributors/style/color": (0, $e83e82854e7f7981$export$1415f56796d9a5a9),
    "attributors/style/direction": (0, $0f48d508e188d6f9$export$175979e518d1dfd1),
    "attributors/style/font": (0, $451e84313c3d6754$export$23b468d4ca3f8c96),
    "attributors/style/size": (0, $de0c2b1e0a6b32a7$export$5443b95a30e89ac5)
}, true);
(0, $b7eaeeafee7196fc$export$2e2bcd8739ae039).register({
    "formats/align": (0, $fabb70fc3b74eee9$export$7f3685f5846c07da),
    "formats/direction": (0, $0f48d508e188d6f9$export$630028b3af294dec),
    "formats/indent": (0, $052f709c27328c7a$export$2e2bcd8739ae039),
    "formats/background": (0, $34ad99861d7d9ec9$export$dc1cbcab4c682ef),
    "formats/color": (0, $e83e82854e7f7981$export$1415f56796d9a5a9),
    "formats/font": (0, $451e84313c3d6754$export$78a99ee601572ab),
    "formats/size": (0, $de0c2b1e0a6b32a7$export$c84684d52bca9684),
    "formats/blockquote": (0, $4b9dbc4cfb9b755f$export$2e2bcd8739ae039),
    "formats/code-block": (0, $95fd90350cc017ea$export$2e2bcd8739ae039),
    "formats/header": (0, $3edefb217ec26d32$export$2e2bcd8739ae039),
    "formats/list": (0, $d4deee66c7c4bf27$export$2e2bcd8739ae039),
    "formats/bold": (0, $bed7d67d4387fb15$export$2e2bcd8739ae039),
    "formats/code": (0, $95fd90350cc017ea$export$52f0f02147b12c03),
    "formats/italic": (0, $7cc8e2e81822ef45$export$2e2bcd8739ae039),
    "formats/link": (0, $68007fb83d8b2db6$export$2e2bcd8739ae039),
    "formats/script": (0, $d5fe0dfbae2887ac$export$2e2bcd8739ae039),
    "formats/strike": (0, $3122b997bf022136$export$2e2bcd8739ae039),
    "formats/underline": (0, $84764d6832d8c50c$export$2e2bcd8739ae039),
    "formats/formula": (0, $d2068614501120d3$export$2e2bcd8739ae039),
    "formats/image": (0, $d91c712bbe22143a$export$2e2bcd8739ae039),
    "formats/video": (0, $19f5b03754cd6d52$export$2e2bcd8739ae039),
    "modules/syntax": (0, $c0d487dd2607ae92$export$2e2bcd8739ae039),
    "modules/table": (0, $7b22eecda11f5be9$export$2e2bcd8739ae039),
    "modules/toolbar": (0, $f75d599411e07a8a$export$2e2bcd8739ae039),
    "themes/bubble": (0, $28932e066b4fa6fc$export$2e2bcd8739ae039),
    "themes/snow": (0, $c86e397362fa2d50$export$2e2bcd8739ae039),
    "ui/icons": (0, $1401db88e437449c$export$2e2bcd8739ae039),
    "ui/picker": (0, $bbc7850c168ff488$export$2e2bcd8739ae039),
    "ui/icon-picker": (0, $4029713c4c15f54e$export$2e2bcd8739ae039),
    "ui/color-picker": (0, $a86e9bdea598e051$export$2e2bcd8739ae039),
    "ui/tooltip": (0, $8d3ba9207edbf82d$export$2e2bcd8739ae039)
}, true);
var $024edda8866a1868$export$2e2bcd8739ae039 = (0, $b7eaeeafee7196fc$export$2e2bcd8739ae039);


class $01acdaba83a4a6d7$export$2e2bcd8739ae039 {
    init() {
        this.quill = new (0, $024edda8866a1868$export$2e2bcd8739ae039)(this._editor, {
            modules: {
                toolbar: [
                    // [{ header: [2, 3, false] }],
                    [
                        "bold",
                        "italic"
                    ],
                    [
                        "link"
                    ],
                    [
                        {
                            list: "bullet"
                        },
                        {
                            list: "ordered"
                        }
                    ]
                ]
            },
            theme: "snow"
        });
        this.quill.on("text-change", ()=>{
            this._textarea.value = this.quill.root.innerHTML;
        });
    }
    constructor(element){
        this._wrapper = element;
        this._editor = this._wrapper.querySelector(".js-input-quill-editor");
        this._textarea = this._wrapper.querySelector("textarea");
        this.init();
    }
}


class $1e930eaa3afdc932$export$2e2bcd8739ae039 {
    bindEvents() {
        this._input.addEventListener("input", ()=>{
            if (this._input.value) {
                [
                    ...this._dropdown.querySelectorAll(".js-input-address-list-item")
                ].forEach((item)=>item.remove());
                this._dropdown.classList.remove("d-none");
                this._loader.classList.remove("d-none");
            }
        });
        this._input.addEventListener("input", app.debounce(()=>{
            fetch(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(this._input.value)}&format=json&addressdetails=1&limit=5`).then((response)=>response.json()).then((data)=>{
                data.forEach((item, n)=>{
                    let _elem = app.createElement('<span class="js-input-address-list-item">' + item.display_name + "</span>");
                    _elem = _elem[0];
                    this._dropdown.appendChild(_elem);
                    _elem.addEventListener("click", ()=>{
                        this._input.value = item.display_name;
                        let value = this.transformNominatimToACF(item);
                        this._realInput.value = JSON.stringify(value);
                        this._inputZipcode.value = item.address.postcode;
                        this._inputLng.value = item.lon;
                        this._inputLat.value = item.lat;
                        //Nominatim is a bit random
                        if (item.address.city) this._inputCity.value = item.address.city;
                        else if (item.address.village) this._inputCity.value = item.address.village;
                        else if (item.address.town) this._inputCity.value = item.address.town;
                        else if (item.address.municipality) this._inputCity.value = item.address.municipality;
                        this.closeDropdown();
                    });
                });
                this._loader.classList.add("d-none");
            // this._acfData = this.transformNominatimToACF(data[0]);
            }).catch((err)=>{
                console.log(err);
            });
        }, 1500));
    }
    transformNominatimToACF(place) {
        const lat = parseFloat(place.lat);
        const lng = parseFloat(place.lon);
        const bbox = {
            _southWest: {
                lat: parseFloat(place.boundingbox[0]),
                lng: parseFloat(place.boundingbox[2])
            },
            _northEast: {
                lat: parseFloat(place.boundingbox[1]),
                lng: parseFloat(place.boundingbox[3])
            }
        };
        const geocode = [
            {
                name: place.display_name,
                html: place.display_name,
                bbox: bbox,
                center: {
                    lat: lat,
                    lng: lng
                },
                properties: {
                    place_id: place.place_id,
                    licence: place.licence,
                    osm_type: place.osm_type,
                    osm_id: place.osm_id,
                    lat: lat,
                    lon: lng,
                    class: place.class,
                    type: place.type,
                    place_rank: place.place_rank,
                    importance: place.importance,
                    addresstype: place.addresstype,
                    name: place.address?.road || place.address?.pedestrian || place.address?.footway || "",
                    display_name: place.display_name,
                    address: place.address,
                    boundingbox: place.boundingbox.map(parseFloat)
                }
            }
        ];
        return {
            lat: lat,
            lng: lng,
            zoom: 12,
            markers: [
                {
                    label: place.display_name,
                    default_label: place.display_name,
                    lat: lat,
                    lng: lng,
                    geocode: geocode,
                    uuid: "marker_" + Math.random().toString(36).slice(2, 12)
                }
            ],
            address: place.display_name,
            layers: [
                "OpenStreetMap.Mapnik"
            ],
            version: "1.6.1"
        };
    }
    closeDropdown() {
        this._dropdown.classList.add("d-none");
        this._loader.classList.add("d-none");
    }
    constructor(element){
        this._wrapper = element;
        this._input = this._wrapper.querySelector(".js-input-address-search");
        this._realInput = this._wrapper.querySelector(".js-input-address-input");
        this._dropdown = this._wrapper.querySelector(".js-input-address-list");
        this._loader = this._wrapper.querySelector(".js-input-address-list-loader");
        this._inputZipcode = document.querySelector('input[name="' + this._wrapper.getAttribute("data-zipcote-input") + '"]');
        this._inputCity = document.querySelector('input[name="' + this._wrapper.getAttribute("data-city-input") + '"]');
        this._inputLat = document.querySelector('input[name="' + this._wrapper.getAttribute("data-lat-input") + '"]');
        this._inputLng = document.querySelector('input[name="' + this._wrapper.getAttribute("data-lng-input") + '"]');
        this._acfData = false;
        this.bindEvents();
    }
}


// Adapted from the base64-arraybuffer package implementation
// (https://github.com/niklasvh/base64-arraybuffer, MIT licensed)
const $2dbce77a3175cae7$var$CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
const $2dbce77a3175cae7$var$EQ_CHAR = "=".charCodeAt(0);
// Use a lookup table to find the index.
const $2dbce77a3175cae7$var$lookup = new Uint8Array(256);
for(let i = 0; i < $2dbce77a3175cae7$var$CHARS.length; i++)$2dbce77a3175cae7$var$lookup[$2dbce77a3175cae7$var$CHARS.charCodeAt(i)] = i;
function $2dbce77a3175cae7$var$encode(bytes) {
    const len = bytes.length;
    let base64 = "";
    for(let i = 0; i < len; i += 3){
        const b0 = bytes[i + 0];
        const b1 = bytes[i + 1];
        const b2 = bytes[i + 2];
        // This temporary variable stops the NextJS 13 compiler from breaking this code in optimization.
        // See issue https://github.com/FriendlyCaptcha/friendly-challenge/issues/165
        let t = "";
        t += $2dbce77a3175cae7$var$CHARS.charAt(b0 >>> 2);
        t += $2dbce77a3175cae7$var$CHARS.charAt((b0 & 3) << 4 | b1 >>> 4);
        t += $2dbce77a3175cae7$var$CHARS.charAt((b1 & 15) << 2 | b2 >>> 6);
        t += $2dbce77a3175cae7$var$CHARS.charAt(b2 & 63);
        base64 += t;
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
}
function $2dbce77a3175cae7$var$decode(base64) {
    const len = base64.length;
    let bufferLength = len * 3 >>> 2; // * 0.75
    if (base64.charCodeAt(len - 1) === $2dbce77a3175cae7$var$EQ_CHAR) bufferLength--;
    if (base64.charCodeAt(len - 2) === $2dbce77a3175cae7$var$EQ_CHAR) bufferLength--;
    const bytes = new Uint8Array(bufferLength);
    for(let i = 0, p = 0; i < len; i += 4){
        const encoded1 = $2dbce77a3175cae7$var$lookup[base64.charCodeAt(i + 0)];
        const encoded2 = $2dbce77a3175cae7$var$lookup[base64.charCodeAt(i + 1)];
        const encoded3 = $2dbce77a3175cae7$var$lookup[base64.charCodeAt(i + 2)];
        const encoded4 = $2dbce77a3175cae7$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return bytes;
}
var $2dbce77a3175cae7$var$css = ".frc-captcha *{margin:0;padding:0;border:0;text-align:initial;border-radius:0;filter:none!important;transition:none!important;font-weight:400;font-size:14px;line-height:1.2;text-decoration:none;background-color:initial;color:#222}.frc-captcha{position:relative;min-width:250px;max-width:312px;border:1px solid #f4f4f4;padding-bottom:12px;background-color:#fff}.frc-captcha b{font-weight:700}.frc-container{display:flex;align-items:center;min-height:52px}.frc-icon{fill:#222;stroke:#222;flex-shrink:0;margin:8px 8px 0}.frc-icon.frc-warning{fill:#c00}.frc-success .frc-icon{animation:1s ease-in both frc-fade-in}.frc-content{white-space:nowrap;display:flex;flex-direction:column;margin:4px 6px 0 0;overflow-x:auto;flex-grow:1}.frc-banner{position:absolute;bottom:0;right:6px;line-height:1}.frc-banner *{font-size:10px;opacity:.8;text-decoration:none}.frc-progress{-webkit-appearance:none;-moz-appearance:none;appearance:none;margin:3px 0;height:4px;border:none;background-color:#eee;color:#222;width:100%;transition:.5s linear}.frc-progress::-webkit-progress-bar{background:#eee}.frc-progress::-webkit-progress-value{background:#222}.frc-progress::-moz-progress-bar{background:#222}.frc-button{cursor:pointer;padding:2px 6px;background-color:#f1f1f1;border:1px solid transparent;text-align:center;font-weight:600;text-transform:none}.frc-button:focus{border:1px solid #333}.frc-button:hover{background-color:#ddd}.frc-captcha-solution{display:none}.frc-err-url{text-decoration:underline;font-size:.9em}.frc-rtl{direction:rtl}.frc-rtl .frc-content{margin:4px 0 0 6px}.frc-banner.frc-rtl{left:6px;right:auto}.dark.frc-captcha{color:#fff;background-color:#222;border-color:#333}.dark.frc-captcha *{color:#fff}.dark.frc-captcha button{background-color:#444}.dark .frc-icon{fill:#fff;stroke:#fff}.dark .frc-progress{background-color:#444}.dark .frc-progress::-webkit-progress-bar{background:#444}.dark .frc-progress::-webkit-progress-value{background:#ddd}.dark .frc-progress::-moz-progress-bar{background:#ddd}@keyframes frc-fade-in{from{opacity:0}to{opacity:1}}";
// This is not an enum to save some bytes in the output bundle.
const $2dbce77a3175cae7$var$SOLVER_TYPE_JS = 1;
const $2dbce77a3175cae7$var$CHALLENGE_SIZE_BYTES = 128;
// @ts-ignore
const $2dbce77a3175cae7$var$loaderSVG = `<circle cx="12" cy="12" r="8" stroke-width="3" stroke-dasharray="15 10" fill="none" stroke-linecap="round" transform="rotate(0 12 12)"><animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.9s" values="0 12 12;360 12 12"/></circle>`;
const $2dbce77a3175cae7$var$errorSVG = `<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>`;
/**
 * Base template used for all widget states
 * The reason we use raw string interpolation here is so we don't have to ship something like lit-html.
 */ function $2dbce77a3175cae7$var$getTemplate(fieldName, rtl, svgContent, svgAriaHidden, textContent, solutionString, buttonText, progress = false, debugData, additionalContainerClasses) {
    return `<div class="frc-container${additionalContainerClasses ? " " + additionalContainerClasses : ""}${rtl ? " frc-rtl" : ""}">
<svg class="frc-icon"${svgAriaHidden ? ' aria-hidden="true"' : ""} role="img" xmlns="http://www.w3.org/2000/svg" height="32" width="32" viewBox="0 0 24 24">${svgContent}</svg>
<div class="frc-content">
    <span class="frc-text" ${debugData ? `data-debug="${debugData}"` : ``}>${textContent}</span>
    ${buttonText ? `<button type="button" class="frc-button">${buttonText}</button>` : ""}
    ${progress ? `<progress class="frc-progress" value="0">0%</progress>` : ""}
</div>
</div><span class="frc-banner${rtl ? " frc-rtl" : ""}"><a lang="en" href="https://friendlycaptcha.com/" rel="noopener" target="_blank"><b>Friendly</b>Captcha \u{21D7}</a></span>
${fieldName === "-" ? "" : `<input name="${fieldName}" class="frc-captcha-solution" type="hidden" value="${solutionString}">`}`;
}
/**
 * Used when the widget is ready to start solving.
 */ function $2dbce77a3175cae7$var$getReadyHTML(fieldName, l) {
    return $2dbce77a3175cae7$var$getTemplate(fieldName, l.rtl, `<path d="M17,11c0.34,0,0.67,0.04,1,0.09V6.27L10.5,3L3,6.27v4.91c0,4.54,3.2,8.79,7.5,9.82c0.55-0.13,1.08-0.32,1.6-0.55 C11.41,19.47,11,18.28,11,17C11,13.69,13.69,11,17,11z"/><path d="M17,13c-2.21,0-4,1.79-4,4c0,2.21,1.79,4,4,4s4-1.79,4-4C21,14.79,19.21,13,17,13z M17,14.38"/>`, true, l.text_ready, ".UNSTARTED", l.button_start, false);
}
/**
 * Used when the widget is retrieving a puzzle
 */ function $2dbce77a3175cae7$var$getFetchingHTML(fieldName, l) {
    return $2dbce77a3175cae7$var$getTemplate(fieldName, l.rtl, $2dbce77a3175cae7$var$loaderSVG, true, l.text_fetching, ".FETCHING", undefined, true);
}
/**
 * Used when the solver is running, displays a progress bar.
 */ function $2dbce77a3175cae7$var$getRunningHTML(fieldName, l) {
    return $2dbce77a3175cae7$var$getTemplate(fieldName, l.rtl, $2dbce77a3175cae7$var$loaderSVG, true, l.text_solving, ".UNFINISHED", undefined, true);
}
function $2dbce77a3175cae7$var$getDoneHTML(fieldName, l, solution, data) {
    const timeData = `${data.t.toFixed(0)}s (${(data.h / data.t * 0.001).toFixed(0)}K/s)${data.solver === $2dbce77a3175cae7$var$SOLVER_TYPE_JS ? " JS Fallback" : ""}`;
    return $2dbce77a3175cae7$var$getTemplate(fieldName, l.rtl, `<title>${l.text_completed_sr}</title><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"></path>`, false, l.text_completed, solution, undefined, false, timeData, "frc-success");
}
function $2dbce77a3175cae7$var$getExpiredHTML(fieldName, l) {
    return $2dbce77a3175cae7$var$getTemplate(fieldName, l.rtl, $2dbce77a3175cae7$var$errorSVG, true, l.text_expired, ".EXPIRED", l.button_restart);
}
function $2dbce77a3175cae7$var$getErrorHTML(fieldName, l, errorDescription, recoverable = true, headless = false) {
    return $2dbce77a3175cae7$var$getTemplate(fieldName, l.rtl, $2dbce77a3175cae7$var$errorSVG, true, `<b>${l.text_error}</b><br>${errorDescription}`, headless ? ".HEADLESS_ERROR" : ".ERROR", recoverable ? l.button_retry : undefined);
}
/**
 * Injects the style if no #frc-style element is already present
 * (to support custom stylesheets)
 */ function $2dbce77a3175cae7$var$injectStyle(styleNonce = null) {
    if (!document.querySelector("#frc-style")) {
        const styleSheet = document.createElement("style");
        styleSheet.id = "frc-style";
        styleSheet.innerHTML = $2dbce77a3175cae7$var$css;
        if (styleNonce) styleSheet.setAttribute("nonce", styleNonce);
        document.head.appendChild(styleSheet);
    }
}
/**
 * @param element parent element of friendlycaptcha
 * @param progress value between 0 and 1
 */ function $2dbce77a3175cae7$var$updateProgressBar(element, data) {
    const p = element.querySelector(".frc-progress");
    const perc = (data.i + 1) / data.n;
    if (p) {
        p.value = perc;
        p.innerText = (perc * 100).toFixed(1) + "%";
        p.title = data.i + 1 + "/" + data.n + " (" + (data.h / data.t * 0.001).toFixed(0) + "K/s)";
    }
}
/**
 * Traverses parent nodes until a <form> is found, returns null if not found.
 */ function $2dbce77a3175cae7$var$findParentFormElement(element) {
    while(element.tagName !== "FORM"){
        element = element.parentElement;
        if (!element) return null;
    }
    return element;
}
/**
 * Add listener to specified element that will only fire once on focus.
 */ function $2dbce77a3175cae7$var$executeOnceOnFocusInEvent(element, listener) {
    element.addEventListener("focusin", listener, {
        once: true,
        passive: true
    });
}
// Defensive init to make it easier to integrate with Gatsby, NextJS, and friends.
let $2dbce77a3175cae7$var$nav;
let $2dbce77a3175cae7$var$ua;
if (typeof navigator !== "undefined" && typeof navigator.userAgent === "string") {
    $2dbce77a3175cae7$var$nav = navigator;
    $2dbce77a3175cae7$var$ua = $2dbce77a3175cae7$var$nav.userAgent.toLowerCase();
}
/**
 * Headless browser detection on the clientside is imperfect. One can modify any clientside code to disable or change this check,
 * and one can spoof whatever is checked here. However, that doesn't make it worthless: it's yet another hurdle for spammers and
 * it stops unsophisticated scripters from making any request whatsoever.
 */ function $2dbce77a3175cae7$var$isHeadless() {
    return(//tell-tale bot signs
    $2dbce77a3175cae7$var$ua.indexOf("headless") !== -1 || $2dbce77a3175cae7$var$nav.appVersion.indexOf("Headless") !== -1 || $2dbce77a3175cae7$var$ua.indexOf("bot") !== -1 || // http://www.useragentstring.com/pages/useragentstring.php?typ=Browser
    $2dbce77a3175cae7$var$ua.indexOf("crawl") !== -1 || // Only IE5 has two distributions that has this on windows NT.. so yeah.
    $2dbce77a3175cae7$var$nav.webdriver === true || !$2dbce77a3175cae7$var$nav.language || $2dbce77a3175cae7$var$nav.languages !== undefined && !$2dbce77a3175cae7$var$nav.languages.length // IE 11 does not support NavigatorLanguage.languages https://developer.mozilla.org/en-US/docs/Web/API/NavigatorLanguage/languages
    );
}
/**
 * Maps a value between 0 and 255 to a difficulty threshold (as uint32)
 * Difficulty 0 maps to 99.99% probability of being right on the first attempt
 * Anything above 250 needs 2^32 tries on average to solve.
 * 150 to 180 seems reasonable
 */ function $2dbce77a3175cae7$var$difficultyToThreshold(value) {
    if (value > 255) value = 255;
    else if (value < 0) value = 0;
    return Math.pow(2, (255.999 - value) / 8.0) >>> 0;
}
const $2dbce77a3175cae7$var$PUZZLE_EXPIRY_OFFSET = 13;
const $2dbce77a3175cae7$var$NUMBER_OF_PUZZLES_OFFSET = 14;
const $2dbce77a3175cae7$var$PUZZLE_DIFFICULTY_OFFSET = 15;
function $2dbce77a3175cae7$var$getPuzzleSolverInputs(puzzleBuffer, numPuzzles) {
    const startingPoints = [];
    for(let i = 0; i < numPuzzles; i++){
        const input = new Uint8Array($2dbce77a3175cae7$var$CHALLENGE_SIZE_BYTES);
        input.set(puzzleBuffer);
        input[120] = i;
        startingPoints.push(input);
    }
    return startingPoints;
}
function $2dbce77a3175cae7$var$decodeBase64Puzzle(base64Puzzle) {
    const parts = base64Puzzle.split(".");
    const puzzle = parts[1];
    const arr = $2dbce77a3175cae7$var$decode(puzzle);
    return {
        signature: parts[0],
        base64: puzzle,
        buffer: arr,
        n: arr[$2dbce77a3175cae7$var$NUMBER_OF_PUZZLES_OFFSET],
        threshold: $2dbce77a3175cae7$var$difficultyToThreshold(arr[$2dbce77a3175cae7$var$PUZZLE_DIFFICULTY_OFFSET]),
        expiry: arr[$2dbce77a3175cae7$var$PUZZLE_EXPIRY_OFFSET] * 300000
    };
}
async function $2dbce77a3175cae7$var$getPuzzle(urlsSeparatedByComma, siteKey, lang) {
    const urls = urlsSeparatedByComma.split(",");
    for(let i = 0; i < urls.length; i++)try {
        const response = await $2dbce77a3175cae7$var$fetchAndRetryWithBackoff(urls[i] + "?sitekey=" + siteKey, {
            headers: [
                [
                    "x-frc-client",
                    "js-0.9.19"
                ]
            ],
            mode: "cors"
        }, 2);
        if (response.ok) {
            const json = await response.json();
            return json.data.puzzle;
        } else {
            let json;
            try {
                json = await response.json();
            } catch (e) {
            /* Do nothing, the error is not valid JSON */ }
            if (json && json.errors && json.errors[0] === "endpoint_not_enabled") throw Error(`Endpoint not allowed (${response.status})`);
            if (i === urls.length - 1) throw Error(`Response status ${response.status} ${response.statusText} ${json ? json.errors : ""}`);
        }
    } catch (e) {
        console.error("[FRC Fetch]:", e);
        const err = new Error(`${lang.text_fetch_error} <a class="frc-err-url" href="${urls[i]}">${urls[i]}</a>`);
        err.rawError = e;
        throw err;
    }
    // This code should never be reached.
    throw Error(`Internal error`);
}
/**
 * Retries given request with exponential backoff (starting with 1000ms delay, multiplying by 4 every time)
 * @param url Request (can be string url) to fetch
 * @param opts Options for fetch
 * @param n Number of times to attempt before giving up.
 */ async function $2dbce77a3175cae7$var$fetchAndRetryWithBackoff(url, opts, n) {
    let time = 1000;
    return fetch(url, opts).catch(async (error)=>{
        if (n === 0) throw error;
        await new Promise((r)=>setTimeout(r, time));
        time *= 4;
        return $2dbce77a3175cae7$var$fetchAndRetryWithBackoff(url, opts, n - 1);
    });
}
// English
const $2dbce77a3175cae7$var$LANG_EN = {
    text_init: "Initializing...",
    text_ready: "Anti-Robot Verification",
    button_start: "Click to start verification",
    text_fetching: "Fetching Challenge",
    text_solving: "Verifying you are human...",
    text_completed: "I am human",
    text_completed_sr: "Automatic spam check completed",
    text_expired: "Anti-Robot verification expired",
    button_restart: "Restart",
    text_error: "Verification failed",
    button_retry: "Retry",
    text_fetch_error: "Failed to connect to"
};
// French
const $2dbce77a3175cae7$var$LANG_FR = {
    text_init: "Chargement...",
    text_ready: "V\xe9rification Anti-Robot",
    button_start: "Clique ici pour v\xe9rifier",
    text_fetching: "Chargement du d\xe9fi",
    text_solving: "Nous v\xe9rifions que vous n'\xeates pas un robot...",
    text_completed: "Je ne suis pas un robot",
    text_completed_sr: "V\xe9rification automatique des spams termin\xe9e",
    text_expired: "V\xe9rification anti-robot expir\xe9e",
    button_restart: "Red\xe9marrer",
    text_error: "\xc9chec de la v\xe9rification",
    button_retry: "Recommencer",
    text_fetch_error: "Probl\xe8me de connexion avec"
};
// German
const $2dbce77a3175cae7$var$LANG_DE = {
    text_init: "Initialisierung...",
    text_ready: "Anti-Roboter-Verifizierung",
    button_start: "Hier klicken",
    text_fetching: "Herausforderung laden...",
    text_solving: "Verifizierung, dass Sie ein Mensch sind...",
    text_completed: "Ich bin ein Mensch",
    text_completed_sr: "Automatische Spampr\xfcfung abgeschlossen",
    text_expired: "Verifizierung abgelaufen",
    button_restart: "Erneut starten",
    text_error: "Verifizierung fehlgeschlagen",
    button_retry: "Erneut versuchen",
    text_fetch_error: "Verbindungsproblem mit"
};
// Dutch
const $2dbce77a3175cae7$var$LANG_NL = {
    text_init: "Initializeren...",
    text_ready: "Anti-robotverificatie",
    button_start: "Klik om te starten",
    text_fetching: "Aan het laden...",
    text_solving: "Anti-robotverificatie bezig...",
    text_completed: "Ik ben een mens",
    text_completed_sr: "Automatische anti-spamcheck voltooid",
    text_expired: "Verificatie verlopen",
    button_restart: "Opnieuw starten",
    text_error: "Verificatie mislukt",
    button_retry: "Opnieuw proberen",
    text_fetch_error: "Verbinding mislukt met"
};
// Italian
const $2dbce77a3175cae7$var$LANG_IT = {
    text_init: "Inizializzazione...",
    text_ready: "Verifica Anti-Robot",
    button_start: "Clicca per iniziare",
    text_fetching: "Caricamento...",
    text_solving: "Verificando che sei umano...",
    text_completed: "Non sono un robot",
    text_completed_sr: "Controllo automatico dello spam completato",
    text_expired: "Verifica Anti-Robot scaduta",
    button_restart: "Ricomincia",
    text_error: "Verifica fallita",
    button_retry: "Riprova",
    text_fetch_error: "Problema di connessione con"
};
// Portuguese
const $2dbce77a3175cae7$var$LANG_PT = {
    text_init: "Inicializando...",
    text_ready: "Verifica\xe7\xe3o Anti-Rob\xf4",
    button_start: "Clique para iniciar verifica\xe7\xe3o",
    text_fetching: "Carregando...",
    text_solving: "Verificando se voc\xea \xe9 humano...",
    text_completed: "Eu sou humano",
    text_completed_sr: "Verifica\xe7\xe3o autom\xe1tica de spam conclu\xedda",
    text_expired: "Verifica\xe7\xe3o Anti-Rob\xf4 expirada",
    button_restart: "Reiniciar",
    text_error: "Verifica\xe7\xe3o falhou",
    button_retry: "Tentar novamente",
    text_fetch_error: "Falha de conex\xe3o com"
};
// Spanish
const $2dbce77a3175cae7$var$LANG_ES = {
    text_init: "Inicializando...",
    text_ready: "Verificaci\xf3n Anti-Robot",
    button_start: "Haga clic para iniciar la verificaci\xf3n",
    text_fetching: "Cargando desaf\xedo",
    text_solving: "Verificando que eres humano...",
    text_completed: "Soy humano",
    text_completed_sr: "Verificaci\xf3n autom\xe1tica de spam completada",
    text_expired: "Verificaci\xf3n Anti-Robot expirada",
    button_restart: "Reiniciar",
    text_error: "Ha fallado la verificaci\xf3n",
    button_retry: "Intentar de nuevo",
    text_fetch_error: "Error al conectarse a"
};
// Catalan
const $2dbce77a3175cae7$var$LANG_CA = {
    text_init: "Inicialitzant...",
    text_ready: "Verificaci\xf3 Anti-Robot",
    button_start: "Fes clic per comen\xe7ar la verificaci\xf3",
    text_fetching: "Carregant repte",
    text_solving: "Verificant que ets hum\xe0...",
    text_completed: "Soc hum\xe0",
    text_completed_sr: "Verificaci\xf3 autom\xe0tica de correu brossa completada",
    text_expired: "La verificaci\xf3 Anti-Robot ha expirat",
    button_restart: "Reiniciar",
    text_error: "Ha fallat la verificaci\xf3",
    button_retry: "Tornar a provar",
    text_fetch_error: "Error connectant a"
};
// Japanese
const $2dbce77a3175cae7$var$LANG_JA = {
    text_init: "\u958B\u59CB\u3057\u3066\u3044\u307E\u3059...",
    text_ready: "\u30A2\u30F3\u30C1\u30ED\u30DC\u30C3\u30C8\u8A8D\u8A3C",
    button_start: "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u8A8D\u8A3C\u3092\u958B\u59CB",
    text_fetching: "\u30ED\u30FC\u30C9\u3057\u3066\u3044\u307E\u3059",
    text_solving: "\u8A8D\u8A3C\u4E2D...",
    text_completed: "\u79C1\u306F\u30ED\u30DC\u30C3\u30C8\u3067\u306F\u3042\u308A\u307E\u305B\u3093",
    text_completed_sr: "\u81EA\u52D5\u30B9\u30D1\u30E0\u30C1\u30A7\u30C3\u30AF\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F",
    text_expired: "\u8A8D\u8A3C\u306E\u671F\u9650\u304C\u5207\u308C\u3066\u3044\u307E\u3059",
    button_restart: "\u518D\u5EA6\u8A8D\u8A3C\u3092\u884C\u3046",
    text_error: "\u8A8D\u8A3C\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F",
    button_retry: "\u518D\u5EA6\u8A8D\u8A3C\u3092\u884C\u3046",
    text_fetch_error: "\u63A5\u7D9A\u304C\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F"
};
// Danish
const $2dbce77a3175cae7$var$LANG_DA = {
    text_init: "Aktiverer...",
    text_ready: "Jeg er ikke en robot",
    button_start: "Klik for at starte verifikationen",
    text_fetching: "Henter data",
    text_solving: "Kontrollerer at du er et menneske...",
    text_completed: "Jeg er et menneske.",
    text_completed_sr: "Automatisk spamkontrol gennemf\xf8rt",
    text_expired: "Verifikationen kunne ikke fuldf\xf8res",
    button_restart: "Genstart",
    text_error: "Bekr\xe6ftelse mislykkedes",
    button_retry: "Pr\xf8v igen",
    text_fetch_error: "Forbindelsen mislykkedes"
};
// Russian
const $2dbce77a3175cae7$var$LANG_RU = {
    text_init: "\u0418\u043D\u0438\u0446\u0438\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F...",
    text_ready: "\u0410\u043D\u0442\u0438\u0420\u043E\u0431\u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430",
    button_start: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043D\u0430\u0447\u0430\u0442\u044C \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0443",
    text_fetching: "\u041F\u043E\u043B\u0443\u0447\u0430\u044E \u0437\u0430\u0434\u0430\u0447\u0443",
    text_solving: "\u041F\u0440\u043E\u0432\u0435\u0440\u044F\u044E, \u0447\u0442\u043E \u0432\u044B \u0447\u0435\u043B\u043E\u0432\u0435\u043A...",
    text_completed: "\u042F \u0447\u0435\u043B\u043E\u0432\u0435\u043A",
    text_completed_sr: "A\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u043D\u0430 \u0441\u043F\u0430\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430",
    text_expired: "\u0421\u0440\u043E\u043A \u0410\u043D\u0442\u0438\u0420\u043E\u0431\u043E\u0442\u043D\u043E\u0439 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 \u0438\u0441\u0442\u0451\u043A",
    button_restart: "\u041D\u0430\u0447\u0430\u0442\u044C \u0437\u0430\u043D\u043E\u0432\u043E",
    text_error: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438",
    button_retry: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u0435\u0449\u0451 \u0440\u0430\u0437",
    text_fetch_error: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F"
};
// Swedish
const $2dbce77a3175cae7$var$LANG_SV = {
    text_init: "Aktiverar...",
    text_ready: "Jag \xe4r inte en robot",
    button_start: "Klicka f\xf6r att verifiera",
    text_fetching: "H\xe4mtar data",
    text_solving: "Kontrollerar att du \xe4r m\xe4nniska...",
    text_completed: "Jag \xe4r en m\xe4nniska",
    text_completed_sr: "Automatisk spamkontroll slutf\xf6rd",
    text_expired: "Anti-robot-verifieringen har l\xf6pt ut",
    button_restart: "B\xf6rja om",
    text_error: "Verifiering kunde inte slutf\xf6ras",
    button_retry: "Omstart",
    text_fetch_error: "Verifiering misslyckades"
};
// Turkish
const $2dbce77a3175cae7$var$LANG_TR = {
    text_init: "Ba\u015Flat\u0131l\u0131yor...",
    text_ready: "Anti-Robot Do\u011Frulamas\u0131",
    button_start: "Do\u011Frulamay\u0131 ba\u015Flatmak i\xe7in t\u0131klay\u0131n",
    text_fetching: "Y\xfckleniyor",
    text_solving: "Robot olmad\u0131\u011F\u0131n\u0131z do\u011Frulan\u0131yor...",
    text_completed: "Ben bir insan\u0131m",
    text_completed_sr: "Otomatik spam kontrol\xfc tamamland\u0131",
    text_expired: "Anti-Robot do\u011Frulamas\u0131n\u0131n s\xfcresi doldu",
    button_restart: "Yeniden ba\u015Flat",
    text_error: "Do\u011Frulama ba\u015Far\u0131s\u0131z oldu",
    button_retry: "Tekrar dene",
    text_fetch_error: "Ba\u011Flant\u0131 ba\u015Far\u0131s\u0131z oldu"
};
// Greek
const $2dbce77a3175cae7$var$LANG_EL = {
    text_init: "\u03A0\u03C1\u03BF\u03B5\u03C4\u03BF\u03B9\u03BC\u03B1\u03C3\u03AF\u03B1...",
    text_ready: "Anti-Robot \u0395\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7",
    button_start: " \u039A\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BE\u03B5\u03BA\u03B9\u03BD\u03AE\u03C3\u03B5\u03B9 \u03B7 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7",
    text_fetching: " \u039B\u03AE\u03C8\u03B7 \u03C0\u03C1\u03CC\u03BA\u03BB\u03B7\u03C3\u03B7\u03C2",
    text_solving: " \u0395\u03C0\u03B9\u03B2\u03B5\u03B2\u03B1\u03AF\u03C9\u03C3\u03B7 \u03B1\u03BD\u03B8\u03C1\u03CE\u03C0\u03BF\u03C5...",
    text_completed: "\u0395\u03AF\u03BC\u03B1\u03B9 \u03AC\u03BD\u03B8\u03C1\u03C9\u03C0\u03BF\u03C2",
    text_completed_sr: " \u039F \u03B1\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03BF\u03C2 \u03AD\u03BB\u03B5\u03B3\u03C7\u03BF\u03C2 \u03B1\u03BD\u03B5\u03C0\u03B9\u03B8\u03CD\u03BC\u03B7\u03C4\u03BF\u03C5 \u03C0\u03B5\u03C1\u03B9\u03B5\u03C7\u03BF\u03BC\u03AD\u03BD\u03BF\u03C5 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5",
    text_expired: " \u0397 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7 Anti-Robot \u03AD\u03BB\u03B7\u03BE\u03B5",
    button_restart: " \u0395\u03C0\u03B1\u03BD\u03B5\u03BA\u03BA\u03AF\u03BD\u03B7\u03C3\u03B7",
    text_error: " \u0397 \u03B5\u03C0\u03B1\u03BB\u03AE\u03B8\u03B5\u03C5\u03C3\u03B7 \u03B1\u03C0\u03AD\u03C4\u03C5\u03C7\u03B5",
    button_retry: " \u0394\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC",
    text_fetch_error: " \u0391\u03C0\u03BF\u03C4\u03C5\u03C7\u03AF\u03B1 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7\u03C2 \u03BC\u03B5"
};
// Ukrainian
const $2dbce77a3175cae7$var$LANG_UK = {
    text_init: "\u0406\u043D\u0456\u0446\u0456\u0430\u043B\u0456\u0437\u0430\u0446\u0456\u044F...",
    text_ready: "\u0410\u043D\u0442\u0438\u0440\u043E\u0431\u043E\u0442 \u0432\u0435\u0440\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u044F",
    button_start: "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u0440\u043E\u0437\u043F\u043E\u0447\u0430\u0442\u0438 \u0432\u0435\u0440\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u044E",
    text_fetching: "\u0417\u2019\u0454\u0434\u043D\u0430\u043D\u043D\u044F",
    text_solving: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0430, \u0449\u043E \u0432\u0438 \u043D\u0435 \u0440\u043E\u0431\u043E\u0442...",
    text_completed: "\u042F \u043D\u0435 \u0440\u043E\u0431\u043E\u0442",
    text_completed_sr: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0430 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0430 \u0441\u043F\u0430\u043C\u0443 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430",
    text_expired: "\u0427\u0430\u0441 \u0432\u0438\u0447\u0435\u0440\u043F\u0430\u043D\u043E",
    button_restart: "\u041F\u043E\u0447\u0430\u0442\u0438 \u0437\u043D\u043E\u0432\u0443",
    text_error: "\u0412\u0435\u0440\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u044F \u043D\u0435 \u0432\u0434\u0430\u043B\u0430\u0441\u044C",
    button_retry: "\u0421\u043F\u0440\u043E\u0431\u0443\u0432\u0430\u0442\u0438 \u0437\u043D\u043E\u0432\u0443",
    text_fetch_error: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044C \u0437\u2019\u0454\u0434\u043D\u0430\u0442\u0438\u0441\u044C"
};
// Bulgarian
const $2dbce77a3175cae7$var$LANG_BG = {
    text_init: "\u0418\u043D\u0438\u0446\u0438\u0430\u043B\u0438\u0437\u0438\u0440\u0430\u043D\u0435...",
    text_ready: "\u0410\u043D\u0442\u0438-\u0440\u043E\u0431\u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430",
    button_start: "\u0429\u0440\u0430\u043A\u043D\u0435\u0442\u0435, \u0437\u0430 \u0434\u0430 \u0437\u0430\u043F\u043E\u0447\u043D\u0435\u0442\u0435 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430\u0442\u0430",
    text_fetching: "\u041F\u0440\u0435\u0434\u0438\u0437\u0432\u0438\u043A\u0430\u0442\u0435\u043B\u0441\u0442\u0432\u043E",
    text_solving: "\u041F\u0440\u043E\u0432\u0435\u0440\u044F\u0432\u0430\u043C\u0435 \u0434\u0430\u043B\u0438 \u0441\u0438 \u0447\u043E\u0432\u0435\u043A...",
    text_completed: "\u0410\u0437 \u0441\u044A\u043C \u0447\u043E\u0432\u0435\u043A",
    text_completed_sr: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0430\u0442\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0437\u0430 \u0441\u043F\u0430\u043C \u0435 \u0437\u0430\u0432\u044A\u0440\u0448\u0435\u043D\u0430",
    text_expired: "\u0410\u043D\u0442\u0438-\u0420\u043E\u0431\u043E\u0442 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430\u0442\u0430 \u0438\u0437\u0442\u0435\u0447\u0435",
    button_restart: "\u0420\u0435\u0441\u0442\u0430\u0440\u0442\u0438\u0440\u0430\u0439\u0442\u0435",
    text_error: "\u041D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430",
    button_retry: "\u041E\u043F\u0438\u0442\u0430\u0439\u0442\u0435 \u043F\u0430\u043A",
    text_fetch_error: "\u041D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u0432\u044A\u0440\u0437\u0432\u0430\u043D\u0435 \u0441"
};
// Czech
const $2dbce77a3175cae7$var$LANG_CS = {
    text_init: "Inicializace...",
    text_ready: "Ov\u011B\u0159en\xed proti robot\u016Fm",
    button_start: "Klikn\u011Bte pro ov\u011B\u0159en\xed",
    text_fetching: "Probl\xe9m p\u0159i na\u010D\xedt\xe1n\xed",
    text_solving: "Ov\u011B\u0159en\xed, \u017Ee jste \u010Dlov\u011Bk...",
    text_completed: "Jsem \u010Dlov\u011Bk",
    text_completed_sr: "Automatick\xe1 kontrola spamu dokon\u010Dena",
    text_expired: "Ov\u011B\u0159en\xed proti robot\u016Fm vypr\u0161elo",
    button_restart: "Restartovat",
    text_error: "Ov\u011B\u0159en\xed se nezda\u0159ilo",
    button_retry: "Zkusit znovu",
    text_fetch_error: "P\u0159ipojen\xed se nezda\u0159ilo"
};
// Slovak
const $2dbce77a3175cae7$var$LANG_SK = {
    text_init: "Inicializ\xe1cia...",
    text_ready: "Overenie proti robotom",
    button_start: "Kliknite pre overenie",
    text_fetching: "Probl\xe9m pri na\u010D\xedtan\xed",
    text_solving: "Overenie, \u017Ee ste \u010Dlovek...",
    text_completed: "Som \u010Dlovek",
    text_completed_sr: "Automatick\xe1 kontrola spamu dokon\u010Den\xe1",
    text_expired: "Overenie proti robotom vypr\u0161alo",
    button_restart: "Re\u0161tartova\u0165",
    text_error: "Overenie sa nepodarilo",
    button_retry: "Sk\xfasi\u0165 znova",
    text_fetch_error: "Pripojenie sa nepodarilo"
};
// Norwegian
const $2dbce77a3175cae7$var$LANG_NO = {
    text_init: " Aktiverer...",
    text_ready: "Jeg er ikke en robot",
    button_start: "Klikk for \xe5 starte verifiseringen",
    text_fetching: "Henter data",
    text_solving: "Sjekker at du er et menneske...",
    text_completed: "Jeg er et menneske",
    text_completed_sr: "Automatisk spam-sjekk fullf\xf8rt",
    text_expired: "Verifisering kunne ikke fullf\xf8res",
    button_restart: "Omstart",
    text_error: "Bekreftelsen mislyktes",
    button_retry: "Pr\xf8v p\xe5 nytt",
    text_fetch_error: "Tilkoblingen mislyktes"
};
// Finnish
const $2dbce77a3175cae7$var$LANG_FI = {
    text_init: "Aktivoidaan...",
    text_ready: "En ole robotti",
    button_start: "Aloita vahvistus klikkaamalla",
    text_fetching: "Haetaan tietoja",
    text_solving: "Tarkistaa, ett\xe4 olet ihminen...",
    text_completed: "Olen ihminen",
    text_completed_sr: "Automaattinen roskapostin tarkistus suoritettu",
    text_expired: "Vahvistusta ei voitu suorittaa loppuun",
    button_restart: "Uudelleenk\xe4ynnistys",
    text_error: "Vahvistus ep\xe4onnistui",
    button_retry: "Yrit\xe4 uudelleen",
    text_fetch_error: "Yhteys ep\xe4onnistui"
};
// Latvian
const $2dbce77a3175cae7$var$LANG_LV = {
    text_init: "Notiek inicializ\u0113\u0161ana...",
    text_ready: "Verifik\u0101cija, ka neesat robots",
    button_start: "Noklik\u0161\u0137iniet, lai s\u0101ktu verifik\u0101ciju",
    text_fetching: "Notiek dro\u0161\u012Bbas uzdevuma izg\u016B\u0161ana",
    text_solving: "Notiek p\u0101rbaude, vai esat cilv\u0113ks...",
    text_completed: "Es esmu cilv\u0113ks",
    text_completed_sr: "Autom\u0101tiska surog\u0101tpasta p\u0101rbaude pabeigta",
    text_expired: "Verifik\u0101cijas, ka neesat robots, der\u012Bgums beidzies",
    button_restart: "Restart\u0113t",
    text_error: "Verifik\u0101cija neizdev\u0101s",
    button_retry: "M\u0113\u0123in\u0101t v\u0113lreiz",
    text_fetch_error: "Neizdev\u0101s izveidot savienojumu ar"
};
// Lithuanian
const $2dbce77a3175cae7$var$LANG_LT = {
    text_init: "Inicijuojama...",
    text_ready: "Patikrinimas, ar nesate robotas",
    button_start: "Spustel\u0117kite patikrinimui prad\u0117ti",
    text_fetching: "Gavimo i\u0161\u0161\u016Bkis",
    text_solving: "Tikrinama, ar esate \u017Emogus...",
    text_completed: "Esu \u017Emogus",
    text_completed_sr: "Automatin\u0117 patikra d\u0117l pa\u0161to \u0161iuk\u0161li\u0173 atlikta",
    text_expired: "Patikrinimas, ar nesate robotas, baig\u0117 galioti",
    button_restart: "Prad\u0117ti i\u0161 naujo",
    text_error: "Patikrinimas nepavyko",
    button_retry: "Kartoti",
    text_fetch_error: "Nepavyko prisijungti prie"
};
// Polish
const $2dbce77a3175cae7$var$LANG_PL = {
    text_init: "Inicjowanie...",
    text_ready: "Weryfikacja antybotowa",
    button_start: "Kliknij, aby rozpocz\u0105\u0107 weryfikacj\u0119",
    text_fetching: "Pobieranie",
    text_solving: "Weryfikacja, czy nie jeste\u015B robotem...",
    text_completed: "Nie jestem robotem",
    text_completed_sr: "Zako\u0144czono automatyczne sprawdzanie spamu",
    text_expired: "Weryfikacja antybotowa wygas\u0142a",
    button_restart: "Uruchom ponownie",
    text_error: "Weryfikacja nie powiod\u0142a si\u0119",
    button_retry: "Spr\xf3buj ponownie",
    text_fetch_error: "Nie uda\u0142o si\u0119 po\u0142\u0105czy\u0107 z"
};
// Estonian
const $2dbce77a3175cae7$var$LANG_ET = {
    text_init: "Initsialiseerimine...",
    text_ready: "Robotivastane kinnitus",
    button_start: "Kinnitamisega alustamiseks kl\xf5psake",
    text_fetching: "V\xe4ljakutse toomine",
    text_solving: "Kinnitatakse, et sa oled inimene...",
    text_completed: "Ma olen inimene",
    text_completed_sr: "Automaatne r\xe4mpsposti kontroll on l\xf5petatud",
    text_expired: "Robotivastane kinnitus aegus",
    button_restart: "Taask\xe4ivita",
    text_error: "Kinnitamine nurjus",
    button_retry: "Proovi uuesti",
    text_fetch_error: "\xdchenduse loomine nurjus"
};
// Croatian
const $2dbce77a3175cae7$var$LANG_HR = {
    text_init: "Po\u010Detno postavljanje...",
    text_ready: "Provjera protiv robota",
    button_start: "Kliknite za po\u010Detak provjere",
    text_fetching: "Dohva\u0107anje izazova",
    text_solving: "Provjeravamo jeste li \u010Dovjek...",
    text_completed: "Nisam robot",
    text_completed_sr: "Automatska provjera je zavr\u0161ena",
    text_expired: "Vrijeme za provjeru protiv robota je isteklo",
    button_restart: "Osvje\u017Ei",
    text_error: "Provjera nije uspjlela",
    button_retry: " Ponovo pokreni",
    text_fetch_error: "Nije mogu\u0107e uspostaviti vezu"
};
// Serbian
const $2dbce77a3175cae7$var$LANG_SR = {
    text_init: "Pokretanje...",
    text_ready: "Anti-Robot Verifikacija",
    button_start: "Kliknite da biste zapo\u010Deli verifikaciju",
    text_fetching: "U\u010Ditavanje izazova",
    text_solving: "Verifikacija da ste \u010Dovek...",
    text_completed: "Ja sam \u010Dovek",
    text_completed_sr: "Automatska provera ne\u017Eeljene po\u0161te je zavr\u0161ena",
    text_expired: "Anti-Robot verifikacija je istekla",
    button_restart: "Ponovo pokrenuti",
    text_error: "Verifikacija nije uspela",
    button_retry: "Poku\u0161ajte ponovo",
    text_fetch_error: "Neuspelo povezivanje sa..."
};
// Slovenian
const $2dbce77a3175cae7$var$LANG_SL = {
    text_init: "Inicializiranje...",
    text_ready: "Preverjanje robotov",
    button_start: "Kliknite za za\u010Detek preverjanja",
    text_fetching: "Prena\u0161anje izziva",
    text_solving: "Preverjamo, ali ste \u010Dlovek",
    text_completed: "Nisem robot",
    text_completed_sr: "Avtomatsko preverjanje je zaklju\u010Deno",
    text_expired: "Preverjanje robotov je poteklo",
    button_restart: "Osve\u017Ei",
    text_error: "Preverjanje ni uspelo",
    button_retry: "Poskusi ponovno",
    text_fetch_error: "Povezave ni bilo mogo\u010De vzpostaviti"
};
// Hungarian
const $2dbce77a3175cae7$var$LANG_HU = {
    text_init: "Inicializ\xe1l\xe1s...",
    text_ready: "Robotellenes ellen\u0151rz\xe9s",
    button_start: "Kattintson az ellen\u0151rz\xe9s megkezd\xe9s\xe9hez",
    text_fetching: "Feladv\xe1ny lek\xe9r\xe9se",
    text_solving: "Annak igazol\xe1sa, hogy \xd6n nem robot...",
    text_completed: "Nem vagyok robot",
    text_completed_sr: "Automatikus spam ellen\u0151rz\xe9s befejez\u0151d\xf6tt",
    text_expired: "Robotellenes ellen\u0151rz\xe9s lej\xe1rt",
    button_restart: "\xdajraind\xedt\xe1s",
    text_error: "Az ellen\u0151rz\xe9s nem siker\xfclt",
    button_retry: "Pr\xf3b\xe1lja \xfajra",
    text_fetch_error: "Nem siker\xfclt csatlakozni"
};
// Romanian
const $2dbce77a3175cae7$var$LANG_RO = {
    text_init: "Se ini\u021Bializeaz\u0103...",
    text_ready: "Verificare anti-robot",
    button_start: "Click pentru a \xeencepe verificarea",
    text_fetching: "Downloading",
    text_solving: "Verificare c\u0103 e\u0219ti om...",
    text_completed: "Sunt om",
    text_completed_sr: "Verificarea automat\u0103 a spam-ului a fost finalizat\u0103",
    text_expired: "Verificarea anti-robot a expirat",
    button_restart: "Restart",
    text_error: "Verificare e\u0219uat\u0103",
    button_retry: "Re\xeencearc\u0103",
    text_fetch_error: "Nu s-a putut conecta"
};
// Chinese
const $2dbce77a3175cae7$var$LANG_ZH = {
    text_init: "\u521D\u59CB\u5316\u4E2D\u2026\u2026",
    text_ready: "\u4EBA\u673A\u9A8C\u8BC1",
    button_start: "\u70B9\u51FB\u5F00\u59CB",
    text_fetching: "\u6B63\u5728\u52A0\u8F7D",
    text_solving: "\u4EBA\u673A\u6821\u9A8C\u4E2D\u2026\u2026",
    text_completed: "\u6211\u4E0D\u662F\u673A\u5668\u4EBA",
    text_completed_sr: "\u4EBA\u673A\u9A8C\u8BC1\u5B8C\u6210",
    text_expired: "\u9A8C\u8BC1\u5DF2\u8FC7\u671F",
    button_restart: "\u91CD\u65B0\u5F00\u59CB",
    text_error: "\u6821\u9A8C\u5931\u8D25",
    button_retry: "\u91CD\u8BD5",
    text_fetch_error: "\u65E0\u6CD5\u8FDE\u63A5\u5230"
};
// Traditional Chinese
const $2dbce77a3175cae7$var$LANG_ZH_TW = {
    text_init: "\u6B63\u5728\u521D\u59CB\u5316\u2026\u2026",
    text_ready: "\u53CD\u6A5F\u5668\u4EBA\u9A57\u8B49",
    button_start: "\u9EDE\u64CA\u958B\u59CB\u9A57\u8B49",
    text_fetching: "\u8F09\u5165\u4E2D",
    text_solving: "\u53CD\u6A5F\u5668\u4EBA\u9A57\u8B49\u4E2D\u2026\u2026",
    text_completed: "\u6211\u4E0D\u662F\u6A5F\u5668\u4EBA",
    text_completed_sr: "\u9A57\u8B49\u5B8C\u6210",
    text_expired: "\u9A57\u8B49\u8D85\u6642",
    button_restart: "\u91CD\u65B0\u958B\u59CB",
    text_error: "\u9A57\u8B49\u5931\u6557",
    button_retry: "\u91CD\u8A66",
    text_fetch_error: "\u7121\u6CD5\u9023\u7DDA\u5230"
};
// Vietnamese
const $2dbce77a3175cae7$var$LANG_VI = {
    text_init: "\u0110ang kh\u1EDFi t\u1EA1o...",
    text_ready: "X\xe1c minh ch\u1ED1ng Robot",
    button_start: "B\u1EA5m v\xe0o \u0111\xe2y \u0111\u1EC3 x\xe1c minh",
    text_fetching: "T\xecm n\u1EA1p v\xe0 x\u1EED l\xfd th\u1EED th\xe1ch",
    text_solving: "X\xe1c minh b\u1EA1n l\xe0 ng\u01B0\u1EDDi...",
    text_completed: "B\u1EA1n l\xe0 con ng\u01B0\u1EDDi",
    text_completed_sr: "X\xe1c minh ho\xe0n t\u1EA5t",
    text_expired: "X\xe1c minh \u0111\xe3 h\u1EBFt h\u1EA1n",
    button_restart: "Kh\u1EDFi \u0111\u1ED9ng l\u1EA1i",
    text_error: "X\xe1c minh th\u1EA5t b\u1EA1i",
    button_retry: "Th\u1EED l\u1EA1i",
    text_fetch_error: "Kh\xf4ng k\u1EBFt n\u1ED1i \u0111\u01B0\u1EE3c"
};
// Hebrew
const $2dbce77a3175cae7$var$LANG_HE = {
    text_init: "\u05D1\u05D1\u05D9\u05E6\u05D5\u05E2...",
    text_ready: "\u05D0\u05D9\u05DE\u05D5\u05EA \u05D0\u05E0\u05D5\u05E9",
    button_start: "\u05E6\u05E8\u05D9\u05DA \u05DC\u05DC\u05D7\u05D5\u05E5 \u05DC\u05D4\u05EA\u05D7\u05DC\u05EA \u05D4\u05D0\u05D9\u05DE\u05D5\u05EA",
    text_fetching: "\u05D0\u05EA\u05D2\u05E8 \u05D4\u05DE\u05E2\u05E0\u05D4 \u05D1\u05D4\u05DB\u05E0\u05D4",
    text_solving: "\u05DE\u05EA\u05D1\u05E6\u05E2 \u05D0\u05D9\u05DE\u05D5\u05EA \u05D0\u05E0\u05D5\u05E9...",
    text_completed: "\u05D0\u05E0\u05D9 \u05DC\u05D0 \u05E8\u05D5\u05D1\u05D5\u05D8",
    text_completed_sr: "\u05D1\u05D3\u05D9\u05E7\u05EA \u05D4\u05E1\u05E4\u05D0\u05DD \u05D4\u05D0\u05D5\u05D8\u05D5\u05DE\u05D8\u05D9\u05EA \u05D4\u05E1\u05EA\u05D9\u05D9\u05DE\u05D4",
    text_expired: "\u05E4\u05D2 \u05EA\u05D5\u05E7\u05E3 \u05D0\u05D9\u05DE\u05D5\u05EA \u05D4\u05D0\u05E0\u05D5\u05E9",
    button_restart: "\u05DC\u05D4\u05EA\u05D7\u05D9\u05DC \u05E9\u05D5\u05D1",
    text_error: "\u05D0\u05D9\u05DE\u05D5\u05EA \u05D4\u05D0\u05E0\u05D5\u05E9 \u05E0\u05DB\u05E9\u05DC",
    button_retry: "\u05DC\u05E0\u05E1\u05D5\u05EA \u05E9\u05D5\u05D1",
    text_fetch_error: "\u05E0\u05DB\u05E9\u05DC \u05D4\u05D7\u05D9\u05D1\u05D5\u05E8 \u05D0\u05DC",
    rtl: true
};
// Thai
const $2dbce77a3175cae7$var$LANG_TH = {
    text_init: "\u0E01\u0E32\u0E23\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19...",
    text_ready: " \u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E15\u0E48\u0E2D\u0E15\u0E49\u0E32\u0E19\u0E2B\u0E38\u0E48\u0E19\u0E22\u0E19\u0E15\u0E4C",
    button_start: "\u0E04\u0E25\u0E34\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E34\u0E48\u0E21\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A",
    text_fetching: "\u0E01\u0E32\u0E23\u0E14\u0E36\u0E07\u0E04\u0E27\u0E32\u0E21\u0E17\u0E49\u0E32\u0E17\u0E32\u0E22",
    text_solving: "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E40\u0E1B\u0E47\u0E19\u0E21\u0E19\u0E38\u0E29\u0E22\u0E4C...",
    text_completed: "\u0E09\u0E31\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E21\u0E19\u0E38\u0E29\u0E22\u0E4C",
    text_completed_sr: "\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E2A\u0E41\u0E1B\u0E21\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E21\u0E1A\u0E39\u0E23\u0E13\u0E4C",
    text_expired: "\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A \u0E15\u0E48\u0E2D\u0E15\u0E49\u0E32\u0E19\u0E2B\u0E38\u0E48\u0E19\u0E22\u0E19\u0E15\u0E4C \u0E2B\u0E21\u0E14\u0E2D\u0E32\u0E22\u0E38",
    button_restart: "\u0E23\u0E35\u0E2A\u0E15\u0E32\u0E23\u0E4C\u0E17",
    text_error: "\u0E01\u0E32\u0E23\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27",
    button_retry: "\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48",
    text_fetch_error: "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E44\u0E14\u0E49"
};
// South Korean
const $2dbce77a3175cae7$var$LANG_KR = {
    text_init: "\uCD08\uAE30\uD654 \uC911",
    text_ready: "Anti-Robot \uAC80\uC99D",
    button_start: "\uAC80\uC99D\uC744 \uC704\uD574 \uD074\uB9AD\uD574 \uC8FC\uC138\uC694",
    text_fetching: "\uAC80\uC99D \uC900\uBE44 \uC911",
    text_solving: "\uAC80\uC99D \uC911",
    text_completed: "\uAC80\uC99D\uC774 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
    text_completed_sr: "\uC790\uB3D9 \uC2A4\uD338 \uD655\uC778 \uC644\uB8CC",
    text_expired: "Anti-Robot \uAC80\uC99D \uB9CC\uB8CC",
    button_restart: "\uB2E4\uC2DC \uC2DC\uC791\uD569\uB2C8\uB2E4",
    text_error: "\uAC80\uC99D \uC2E4\uD328",
    button_retry: "\uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694",
    text_fetch_error: "\uC5F0\uACB0\uD558\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4"
};
// Arabic
const $2dbce77a3175cae7$var$LANG_AR = {
    text_init: "...\u0627\u0644\u062A\u0647\u064A\u0626\u0629",
    text_ready: "\u064A\u062A\u0645 \u0627\u0644\u062A\u062D\u0642\u064A\u0642",
    button_start: "\u0625\u0636\u063A\u0637 \u0647\u0646\u0627 \u0644\u0644\u062A\u062D\u0642\u064A\u0642",
    text_fetching: "\u062A\u0647\u064A\u0626\u0629 \u0627\u0644\u062A\u062D\u062F\u064A",
    text_solving: "\u0646\u062A\u062D\u0642\u0642 \u0645\u0646 \u0623\u0646\u0643 \u0644\u0633\u062A \u0631\u0648\u0628\u0648\u062A\u064B\u0627...",
    text_completed: "\u0623\u0646\u0627 \u0644\u0633\u062A \u0631\u0648\u0628\u0648\u062A\u064B\u0627",
    text_completed_sr: "\u062A\u0645 \u0627\u0644\u0627\u0646\u062A\u0647\u0627\u0621 \u0645\u0646 \u0627\u0644\u062A\u062D\u0642\u0642 \u0627\u0644\u062A\u0644\u0642\u0627\u0626\u064A \u0645\u0646 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0639\u0634\u0648\u0627\u0626\u064A",
    text_expired: "\u0627\u0646\u062A\u0647\u062A \u0635\u0644\u0627\u062D\u064A\u0629 \u0627\u0644\u062A\u062D\u0642\u0642",
    button_restart: "\u0625\u0639\u0627\u062F\u0629 \u062A\u0634\u063A\u064A\u0644",
    text_error: "\u0641\u0634\u0644 \u0627\u0644\u062A\u062D\u0642\u0642",
    button_retry: "\u0627\u0628\u062F\u0623 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649",
    text_fetch_error: "\u0645\u0634\u0643\u0644\u0629 \u0641\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0645\u0639"
};
const $2dbce77a3175cae7$export$d783a6dfa09e83d0 = {
    en: $2dbce77a3175cae7$var$LANG_EN,
    de: $2dbce77a3175cae7$var$LANG_DE,
    nl: $2dbce77a3175cae7$var$LANG_NL,
    fr: $2dbce77a3175cae7$var$LANG_FR,
    it: $2dbce77a3175cae7$var$LANG_IT,
    pt: $2dbce77a3175cae7$var$LANG_PT,
    es: $2dbce77a3175cae7$var$LANG_ES,
    ca: $2dbce77a3175cae7$var$LANG_CA,
    ja: $2dbce77a3175cae7$var$LANG_JA,
    da: $2dbce77a3175cae7$var$LANG_DA,
    ru: $2dbce77a3175cae7$var$LANG_RU,
    sv: $2dbce77a3175cae7$var$LANG_SV,
    tr: $2dbce77a3175cae7$var$LANG_TR,
    el: $2dbce77a3175cae7$var$LANG_EL,
    uk: $2dbce77a3175cae7$var$LANG_UK,
    bg: $2dbce77a3175cae7$var$LANG_BG,
    cs: $2dbce77a3175cae7$var$LANG_CS,
    sk: $2dbce77a3175cae7$var$LANG_SK,
    no: $2dbce77a3175cae7$var$LANG_NO,
    fi: $2dbce77a3175cae7$var$LANG_FI,
    lv: $2dbce77a3175cae7$var$LANG_LV,
    lt: $2dbce77a3175cae7$var$LANG_LT,
    pl: $2dbce77a3175cae7$var$LANG_PL,
    et: $2dbce77a3175cae7$var$LANG_ET,
    hr: $2dbce77a3175cae7$var$LANG_HR,
    sr: $2dbce77a3175cae7$var$LANG_SR,
    sl: $2dbce77a3175cae7$var$LANG_SL,
    hu: $2dbce77a3175cae7$var$LANG_HU,
    ro: $2dbce77a3175cae7$var$LANG_RO,
    zh: $2dbce77a3175cae7$var$LANG_ZH,
    zh_tw: $2dbce77a3175cae7$var$LANG_ZH_TW,
    vi: $2dbce77a3175cae7$var$LANG_VI,
    he: $2dbce77a3175cae7$var$LANG_HE,
    th: $2dbce77a3175cae7$var$LANG_TH,
    kr: $2dbce77a3175cae7$var$LANG_KR,
    ar: $2dbce77a3175cae7$var$LANG_AR,
    // alternative language codes
    nb: $2dbce77a3175cae7$var$LANG_NO
};
function $2dbce77a3175cae7$var$createDiagnosticsBuffer(solverID, timeToSolved) {
    const arr = new Uint8Array(3);
    const view = new DataView(arr.buffer);
    view.setUint8(0, solverID);
    view.setUint16(1, timeToSolved);
    return arr;
}
var $2dbce77a3175cae7$var$workerString = '!function(){"use strict";const A="=".charCodeAt(0),I=new Uint8Array(256);for(let A=0;A<64;A++)I["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charCodeAt(A)]=A;function g(A){const I={},g=A.exports,C=g.memory,Q=g.__alloc,t=g.__retain,B=g.__rtti_base||-1;return I.__allocArray=(A,I)=>{const g=function(A){return new Uint32Array(C.buffer)[(B+4>>>2)+2*A]}(A),e=31-Math.clz32(g>>>6&31),o=I.length,i=Q(o<<e,0),r=Q(12,A),n=new Uint32Array(C.buffer);n[r+0>>>2]=t(i),n[r+4>>>2]=i,n[r+8>>>2]=o<<e;const E=C.buffer,s=new Uint8Array(E);if(16384&g)for(let A=0;A<o;++A)s[(i>>>e)+A]=t(I[A]);else s.set(I,i>>>e);return r},I.__getUint8Array=A=>{const I=new Uint32Array(C.buffer),g=I[A+4>>>2];return new Uint8Array(C.buffer,g,I[g-4>>>2]>>>0)},function(A,I={}){const g=A.__argumentsLength?I=>{A.__argumentsLength.value=I}:A.__setArgumentsLength||A.__setargc||(()=>({}));for(const C in A){if(!Object.prototype.hasOwnProperty.call(A,C))continue;const Q=A[C],t=C.split(".")[0];"function"==typeof Q&&Q!==g?(I[t]=(...A)=>(g(A.length),Q(...A))).original=Q:I[t]=Q}return I}(g,I)}class C{constructor(A){this.b=new Uint8Array(128),this.h=new Uint32Array(16),this.t=0,this.c=0,this.v=new Uint32Array(32),this.m=new Uint32Array(32),this.outlen=A}}function Q(A,I){return A[I]^A[I+1]<<8^A[I+2]<<16^A[I+3]<<24}function t(A,I,g,C,Q,t,B,e){const o=I[B],i=I[B+1],r=I[e],n=I[e+1];let E,s,w,a,c=A[g],D=A[g+1],f=A[C],h=A[C+1],y=A[Q],l=A[Q+1],u=A[t],N=A[t+1];E=c+f,s=(c&f|(c|f)&~E)>>>31,c=E,D=D+h+s,E=c+o,s=(c&o|(c|o)&~E)>>>31,c=E,D=D+i+s,w=u^c,a=N^D,u=a,N=w,E=y+u,s=(y&u|(y|u)&~E)>>>31,y=E,l=l+N+s,w=f^y,a=h^l,f=w>>>24^a<<8,h=a>>>24^w<<8,E=c+f,s=(c&f|(c|f)&~E)>>>31,c=E,D=D+h+s,E=c+r,s=(c&r|(c|r)&~E)>>>31,c=E,D=D+n+s,w=u^c,a=N^D,u=w>>>16^a<<16,N=a>>>16^w<<16,E=y+u,s=(y&u|(y|u)&~E)>>>31,y=E,l=l+N+s,w=f^y,a=h^l,f=a>>>31^w<<1,h=w>>>31^a<<1,A[g]=c,A[g+1]=D,A[C]=f,A[C+1]=h,A[Q]=y,A[Q+1]=l,A[t]=u,A[t+1]=N}const B=[4089235720,1779033703,2227873595,3144134277,4271175723,1013904242,1595750129,2773480762,2917565137,1359893119,725511199,2600822924,4215389547,528734635,327033209,1541459225],e=[0,2,4,6,8,10,12,14,16,18,20,22,24,26,28,30,28,20,8,16,18,30,26,12,2,24,0,4,22,14,10,6,22,16,24,0,10,4,30,26,20,28,6,12,14,2,18,8,14,18,6,2,26,24,22,28,4,12,10,20,8,0,30,16,18,0,10,14,4,8,20,30,28,2,22,24,12,16,6,26,4,24,12,20,0,22,16,6,8,26,14,10,30,28,2,18,24,10,2,30,28,26,8,20,0,14,12,6,18,4,16,22,26,22,14,28,24,2,6,18,10,0,30,8,16,12,4,20,12,30,28,18,22,6,0,16,24,4,26,14,2,8,20,10,20,4,16,8,14,12,2,10,30,22,18,28,6,24,26,0,0,2,4,6,8,10,12,14,16,18,20,22,24,26,28,30,28,20,8,16,18,30,26,12,2,24,0,4,22,14,10,6];function o(A,I){const g=A.v,C=A.m;for(let I=0;I<16;I++)g[I]=A.h[I],g[I+16]=B[I];g[24]=g[24]^A.t,g[25]=g[25]^A.t/4294967296,I&&(g[28]=~g[28],g[29]=~g[29]);for(let I=0;I<32;I++)C[I]=Q(A.b,4*I);for(let A=0;A<12;A++)t(g,C,0,8,16,24,e[16*A+0],e[16*A+1]),t(g,C,2,10,18,26,e[16*A+2],e[16*A+3]),t(g,C,4,12,20,28,e[16*A+4],e[16*A+5]),t(g,C,6,14,22,30,e[16*A+6],e[16*A+7]),t(g,C,0,10,20,30,e[16*A+8],e[16*A+9]),t(g,C,2,12,22,24,e[16*A+10],e[16*A+11]),t(g,C,4,14,16,26,e[16*A+12],e[16*A+13]),t(g,C,6,8,18,28,e[16*A+14],e[16*A+15]);for(let I=0;I<16;I++)A.h[I]=A.h[I]^g[I]^g[I+16]}function i(A,I){for(let I=0;I<16;I++)A.h[I]=B[I];A.b.set(I),A.h[0]^=16842752^A.outlen}async function r(){return(A,I,g=4294967295)=>{const Q=function(A,I,g){if(128!=A.length)throw Error("Invalid input");const Q=A.buffer,t=new DataView(Q),B=new C(32);B.t=128;const e=t.getUint32(124,!0),r=e+g;for(let g=e;g<r;g++)if(t.setUint32(124,g,!0),i(B,A),o(B,!0),B.h[0]<I)return 0==ASC_TARGET?new Uint8Array(B.h.buffer):Uint8Array.wrap(B.h.buffer);return new Uint8Array(0)}(A,I,g);return[A,Q]}}let n,E;Uint8Array.prototype.slice||Object.defineProperty(Uint8Array.prototype,"slice",{value:function(A,I){return new Uint8Array(Array.prototype.slice.call(this,A,I))}}),self.ASC_TARGET=0;const s=new Promise((A=>E=A));self.onerror=A=>{self.postMessage({type:"error",message:JSON.stringify(A)})},self.onmessage=async C=>{const Q=C.data;try{if("solver"===Q.type){if(Q.forceJS){n=1;const A=await r();E(A)}else try{n=2;const C=WebAssembly.compile(function(g){let C=3285;g.charCodeAt(4379)===A&&C--,g.charCodeAt(4378)===A&&C--;const Q=new Uint8Array(C);for(let A=0,C=0;A<4380;A+=4){const t=I[g.charCodeAt(A+0)],B=I[g.charCodeAt(A+1)],e=I[g.charCodeAt(A+2)],o=I[g.charCodeAt(A+3)];Q[C++]=t<<2|B>>4,Q[C++]=(15&B)<<4|e>>2,Q[C++]=(3&e)<<6|63&o}return Q}("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")),Q=await async function(A){const I=await async function(A){const I={env:{abort(){throw Error("Wasm aborted")}}};return{exports:g(await WebAssembly.instantiate(A,I))}}(A),C=I.exports.__retain(I.exports.__allocArray(I.exports.Uint8Array_ID,new Uint8Array(128)));let Q=I.exports.__getUint8Array(C);return(A,g,t=4294967295)=>{Q.set(A);const B=I.exports.solveBlake2b(C,g,t);Q=I.exports.__getUint8Array(C);const e=I.exports.__getUint8Array(B);return I.exports.__release(B),[Q,e]}}(await C);E(Q)}catch(A){console.log("FriendlyCaptcha failed to initialize WebAssembly, falling back to Javascript solver: "+A.toString()),n=1;const I=await r();E(I)}self.postMessage({type:"ready",solver:n})}else if("start"===Q.type){const A=await s;self.postMessage({type:"started"});let I,g=0;for(let C=0;C<256;C++){Q.puzzleSolverInput[123]=C;const[t,B]=A(Q.puzzleSolverInput,Q.threshold);if(0!==B.length){I=t;break}console.warn("FC: Internal error or no solution found"),g+=Math.pow(2,32)-1}g+=new DataView(I.slice(-4).buffer).getUint32(0,!0),self.postMessage({type:"done",solution:I.slice(-8),h:g,puzzleIndex:Q.puzzleIndex,puzzleNumber:Q.puzzleNumber})}}catch(A){setTimeout((()=>{throw A}))}}}();';
// Defensive init to make it easier to integrate with Gatsby and friends.
let $2dbce77a3175cae7$var$URL;
if (typeof window !== "undefined") $2dbce77a3175cae7$var$URL = window.URL || window.webkitURL;
class $2dbce77a3175cae7$var$WorkerGroup {
    init() {
        this.terminateWorkers();
        this.progress = 0;
        this.totalHashes = 0;
        let setReady;
        this.readyPromise = new Promise((resolve)=>setReady = resolve);
        this.readyCount = 0;
        this.startCount = 0;
        // Setup four workers for now - later we could calculate this depending on the device
        this.workers = new Array(4);
        const workerBlob = new Blob([
            $2dbce77a3175cae7$var$workerString
        ], {
            type: "text/javascript"
        });
        for(let i = 0; i < this.workers.length; i++){
            this.workers[i] = new Worker($2dbce77a3175cae7$var$URL.createObjectURL(workerBlob));
            this.workers[i].onerror = (e)=>this.errorCallback(e);
            this.workers[i].onmessage = (e)=>{
                const data = e.data;
                if (!data) return;
                if (data.type === "ready") {
                    this.readyCount++;
                    this.solverType = data.solver;
                    // We are ready, when all workers are ready
                    if (this.readyCount == this.workers.length) {
                        setReady();
                        this.readyCallback();
                    }
                } else if (data.type === "started") {
                    this.startCount++;
                    // We started, when the first worker starts working
                    if (this.startCount == 1) {
                        this.startTime = Date.now();
                        this.startedCallback();
                    }
                } else if (data.type === "done") {
                    if (data.puzzleNumber !== this.puzzleNumber) return; // solution belongs to a previous puzzle
                    if (this.puzzleIndex < this.puzzleSolverInputs.length) {
                        this.workers[i].postMessage({
                            type: "start",
                            puzzleSolverInput: this.puzzleSolverInputs[this.puzzleIndex],
                            threshold: this.threshold,
                            puzzleIndex: this.puzzleIndex,
                            puzzleNumber: this.puzzleNumber
                        });
                        this.puzzleIndex++;
                    }
                    this.progress++;
                    this.totalHashes += data.h;
                    this.progressCallback({
                        n: this.numPuzzles,
                        h: this.totalHashes,
                        t: (Date.now() - this.startTime) / 1000,
                        i: this.progress
                    });
                    this.solutionBuffer.set(data.solution, data.puzzleIndex * 8);
                    // We are done, when all puzzles have been solved
                    if (this.progress == this.numPuzzles) {
                        const totalTime = (Date.now() - this.startTime) / 1000;
                        this.doneCallback({
                            solution: this.solutionBuffer,
                            h: this.totalHashes,
                            t: totalTime,
                            diagnostics: $2dbce77a3175cae7$var$createDiagnosticsBuffer(this.solverType, totalTime),
                            solver: this.solverType
                        });
                    }
                } else if (data.type === "error") this.errorCallback(data);
            };
        }
    }
    setupSolver(forceJS = false) {
        const msg = {
            type: "solver",
            forceJS: forceJS
        };
        for(let i = 0; i < this.workers.length; i++)this.workers[i].postMessage(msg);
    }
    async start(puzzle) {
        await this.readyPromise;
        this.puzzleSolverInputs = $2dbce77a3175cae7$var$getPuzzleSolverInputs(puzzle.buffer, puzzle.n);
        this.solutionBuffer = new Uint8Array(8 * puzzle.n);
        this.numPuzzles = puzzle.n;
        this.threshold = puzzle.threshold;
        this.puzzleIndex = 0;
        this.puzzleNumber++;
        for(let i = 0; i < this.workers.length; i++){
            if (this.puzzleIndex === this.puzzleSolverInputs.length) break;
            this.workers[i].postMessage({
                type: "start",
                puzzleSolverInput: this.puzzleSolverInputs[i],
                threshold: this.threshold,
                puzzleIndex: this.puzzleIndex,
                puzzleNumber: this.puzzleNumber
            });
            this.puzzleIndex++;
        }
    }
    terminateWorkers() {
        if (this.workers.length == 0) return;
        for(let i = 0; i < this.workers.length; i++)this.workers[i].terminate();
        this.workers = [];
    }
    constructor(){
        this.workers = [];
        this.puzzleNumber = 0;
        this.numPuzzles = 0;
        this.threshold = 0;
        this.startTime = 0;
        this.progress = 0;
        this.totalHashes = 0;
        this.puzzleSolverInputs = [];
        // The index of the next puzzle
        this.puzzleIndex = 0;
        this.solutionBuffer = new Uint8Array(0);
        // initialize some value, so ts is happy
        this.solverType = 1;
        this.readyPromise = new Promise(()=>{});
        this.readyCount = 0;
        this.startCount = 0;
        this.progressCallback = ()=>0;
        this.readyCallback = ()=>0;
        this.startedCallback = ()=>0;
        this.doneCallback = ()=>0;
        this.errorCallback = ()=>0;
    }
}
const $2dbce77a3175cae7$var$PUZZLE_ENDPOINT_URL = "https://api.friendlycaptcha.com/api/v1/puzzle";
class $2dbce77a3175cae7$export$ddd516cefd6a7a04 {
    init(forceStart) {
        if (this.hasBeenDestroyed) {
            console.error("FriendlyCaptcha widget has been destroyed using destroy(), it can not be used anymore.");
            return;
        }
        this.initWorkerGroup();
        if (forceStart) this.start();
        else if (this.e.dataset["start"] !== "none" && (this.opts.startMode === "focus" || this.e.dataset["start"] === "focus")) {
            const form = $2dbce77a3175cae7$var$findParentFormElement(this.e);
            if (form) $2dbce77a3175cae7$var$executeOnceOnFocusInEvent(form, ()=>this.start());
            else console.log("FriendlyCaptcha div seems not to be contained in a form, autostart will not work");
        }
    }
    /**
     * Loads the configured language, or a language passed to this function.
     * Note that only the next update will be in the new language, consider calling `reset()` after switching languages.
     */ loadLanguage(lang) {
        if (lang !== undefined) this.opts.language = lang;
        else if (this.e.dataset["lang"]) this.opts.language = this.e.dataset["lang"];
        if (typeof this.opts.language === "string") {
            let langCode = this.opts.language.toLowerCase();
            let l = $2dbce77a3175cae7$export$d783a6dfa09e83d0[langCode];
            if (l === undefined && langCode[2] === "-") {
                // Language has a locale '-' separator, remove it and try again
                langCode = langCode.substring(0, 2);
                l = $2dbce77a3175cae7$export$d783a6dfa09e83d0[langCode];
            }
            if (l === undefined) {
                console.error('FriendlyCaptcha: language "' + this.opts.language + '" not found.');
                // Fall back to English
                l = $2dbce77a3175cae7$export$d783a6dfa09e83d0.en;
            }
            this.lang = l;
        } else // We assign to a copy of the English language localization, so that any missing values will be English
        this.lang = Object.assign(Object.assign({}, $2dbce77a3175cae7$export$d783a6dfa09e83d0.en), this.opts.language);
    }
    /**
     * Add a listener to the button that calls `this.start` on click.
     */ makeButtonStart() {
        const b = this.e.querySelector("button");
        if (b) {
            b.addEventListener("click", (e)=>this.start(), {
                once: true,
                passive: true
            });
            b.addEventListener("touchstart", (e)=>this.start(), {
                once: true,
                passive: true
            });
        }
    }
    onWorkerError(e) {
        this.hasBeenStarted = false;
        this.needsReInit = true;
        if (this.expiryTimeout) clearTimeout(this.expiryTimeout);
        console.error("[FRC]", e);
        this.e.innerHTML = $2dbce77a3175cae7$var$getErrorHTML(this.opts.solutionFieldName, this.lang, "Background worker error " + e.message);
        this.makeButtonStart();
        // Just out of precaution
        this.opts.forceJSFallback = true;
    }
    initWorkerGroup() {
        this.workerGroup.progressCallback = (progress)=>{
            $2dbce77a3175cae7$var$updateProgressBar(this.e, progress);
        };
        this.workerGroup.readyCallback = ()=>{
            this.e.innerHTML = $2dbce77a3175cae7$var$getReadyHTML(this.opts.solutionFieldName, this.lang);
            this.makeButtonStart();
            this.opts.readyCallback();
        };
        this.workerGroup.startedCallback = ()=>{
            this.e.innerHTML = $2dbce77a3175cae7$var$getRunningHTML(this.opts.solutionFieldName, this.lang);
            this.opts.startedCallback();
        };
        this.workerGroup.doneCallback = (data)=>{
            const solutionPayload = this.handleDone(data);
            this.opts.doneCallback(solutionPayload);
            const callback = this.e.dataset["callback"];
            if (callback) window[callback](solutionPayload);
        };
        this.workerGroup.errorCallback = (e)=>{
            this.onWorkerError(e);
        };
        this.workerGroup.init();
        this.workerGroup.setupSolver(this.opts.forceJSFallback);
    }
    expire() {
        this.hasBeenStarted = false;
        // Node.isConnected will be undefined in older browsers
        if (this.e.isConnected !== false) {
            this.e.innerHTML = $2dbce77a3175cae7$var$getExpiredHTML(this.opts.solutionFieldName, this.lang);
            this.makeButtonStart();
        }
    }
    async start() {
        if (this.hasBeenDestroyed) {
            console.error("Can not start FriendlyCaptcha widget which has been destroyed");
            return;
        }
        if (this.hasBeenStarted) {
            console.warn("Can not start FriendlyCaptcha widget which has already been started");
            return;
        }
        const sitekey = this.opts.sitekey || this.e.dataset["sitekey"];
        if (!sitekey) {
            console.error("FriendlyCaptcha: sitekey not set on frc-captcha element");
            this.e.innerHTML = $2dbce77a3175cae7$var$getErrorHTML(this.opts.solutionFieldName, this.lang, "Website problem: sitekey not set", false);
            return;
        }
        if ($2dbce77a3175cae7$var$isHeadless()) {
            this.e.innerHTML = $2dbce77a3175cae7$var$getErrorHTML(this.opts.solutionFieldName, this.lang, "Browser check failed, try a different browser", false, true);
            return;
        }
        if (this.needsReInit) {
            this.needsReInit = false;
            this.init(true);
            return;
        }
        this.hasBeenStarted = true;
        try {
            this.e.innerHTML = $2dbce77a3175cae7$var$getFetchingHTML(this.opts.solutionFieldName, this.lang);
            this.puzzle = $2dbce77a3175cae7$var$decodeBase64Puzzle(await $2dbce77a3175cae7$var$getPuzzle(this.opts.puzzleEndpoint, sitekey, this.lang));
            if (this.expiryTimeout) clearTimeout(this.expiryTimeout);
            this.expiryTimeout = setTimeout(()=>this.expire(), this.puzzle.expiry - 30000); // 30s grace
        } catch (e) {
            console.error("[FRC]", e);
            this.hasBeenStarted = false;
            if (this.expiryTimeout) clearTimeout(this.expiryTimeout);
            this.e.innerHTML = $2dbce77a3175cae7$var$getErrorHTML(this.opts.solutionFieldName, this.lang, e.message);
            this.makeButtonStart();
            const code = "error_getting_puzzle";
            this.opts.errorCallback({
                code: code,
                description: e.toString(),
                error: e
            });
            const callback = this.e.dataset["callback-error"];
            if (callback) window[callback](this);
            return;
        }
        await this.workerGroup.start(this.puzzle);
    }
    /**
     * This is to be called when the puzzle has been succesfully completed.
     * Here the hidden field gets updated with the solution.
     * @param data message from the webworker
     */ handleDone(data) {
        this.valid = true;
        const puzzleSolutionMessage = `${this.puzzle.signature}.${this.puzzle.base64}.${$2dbce77a3175cae7$var$encode(data.solution)}.${$2dbce77a3175cae7$var$encode(data.diagnostics)}`;
        this.e.innerHTML = $2dbce77a3175cae7$var$getDoneHTML(this.opts.solutionFieldName, this.lang, puzzleSolutionMessage, data);
        // this.worker = null; // This literally crashes very old browsers..
        this.needsReInit = true;
        return puzzleSolutionMessage;
    }
    /**
     * Cleans up the widget entirely, removing any DOM elements and terminating any background workers.
     * After it is destroyed it can no longer be used for any purpose.
     */ destroy() {
        this.workerGroup.terminateWorkers();
        this.needsReInit = false;
        this.hasBeenStarted = false;
        if (this.expiryTimeout) clearTimeout(this.expiryTimeout);
        if (this.e) {
            this.e.remove();
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            delete this.e;
        }
        this.hasBeenDestroyed = true;
    }
    /**
     * Resets the widget to the initial state.
     * This is useful in situations where the page does not refresh when you submit and the form may be re-submitted again
     */ reset() {
        if (this.hasBeenDestroyed) {
            console.error("FriendlyCaptcha widget has been destroyed, it can not be used anymore");
            return;
        }
        this.workerGroup.terminateWorkers();
        this.needsReInit = false;
        this.hasBeenStarted = false;
        if (this.expiryTimeout) clearTimeout(this.expiryTimeout);
        this.init(this.opts.startMode === "auto" || this.e.dataset["start"] === "auto");
    }
    constructor(element, options = {}){
        this.workerGroup = new $2dbce77a3175cae7$var$WorkerGroup();
        /**
         * The captcha has been succesfully solved.
         */ this.valid = false;
        /**
         * Some errors may cause a need for the (worker) to be reinitialized. If this is
         * true `init` will be called again when start is called.
         */ this.needsReInit = false;
        /**
         * Start() has been called at least once ever.
         */ this.hasBeenStarted = false;
        this.hasBeenDestroyed = false;
        this.opts = Object.assign({
            forceJSFallback: false,
            skipStyleInjection: false,
            startMode: "focus",
            puzzleEndpoint: element.dataset["puzzleEndpoint"] || $2dbce77a3175cae7$var$PUZZLE_ENDPOINT_URL,
            startedCallback: ()=>0,
            readyCallback: ()=>0,
            doneCallback: ()=>0,
            errorCallback: ()=>0,
            sitekey: element.dataset["sitekey"] || "",
            language: element.dataset["lang"] || "en",
            solutionFieldName: element.dataset["solutionFieldName"] || "frc-captcha-solution",
            styleNonce: null
        }, options);
        this.e = element;
        this.e.friendlyChallengeWidget = this;
        this.loadLanguage();
        // @ts-ignore Ignore is required as TS thinks that `this.lang` is not assigned yet, but it happens in `this.loadLanguage()` above.
        element.innerText = this.lang.text_init;
        if (!this.opts.skipStyleInjection) $2dbce77a3175cae7$var$injectStyle(this.opts.styleNonce);
        this.init(this.opts.startMode === "auto" || this.e.dataset["start"] === "auto");
    }
}


class $258cd0a622844f83$export$2e2bcd8739ae039 {
    constructor(element){
        this._wrapper = element;
        this.widget = new (0, $2dbce77a3175cae7$export$ddd516cefd6a7a04)(this._wrapper, {
            sitekey: "FCMTM158QGNMV5RS"
        });
    }
}


class $ca1fb913bac19cbd$export$2e2bcd8739ae039 {
    bindEvents() {
        app.nodesEventListener("click", this._closes, (el, n, e)=>{
            this.markers[n].setIcon(this.icon);
            this._blocks[n].classList.add("d-none");
        });
        this._geoloc.addEventListener("click", ()=>{
            if (!navigator.geolocation) return;
            navigator.geolocation.getCurrentPosition((position)=>{
                const userLatLng = [
                    position.coords.latitude,
                    position.coords.longitude
                ];
                L.circleMarker(userLatLng, {
                    radius: 6,
                    color: "#007BFF",
                    fillColor: "#007BFF",
                    fillOpacity: 0.8
                }).addTo(this.leaflet).bindPopup("Vous \xeates ici").openPopup();
                this.leaflet.setView(userLatLng, 8);
            });
        });
    }
    initMap() {
        this.leaflet = L.map(this._map).setView([
            46.6031,
            1.8883
        ], 6);
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        }).addTo(this.leaflet);
        map_markers.forEach((point, n)=>{
            const marker = L.marker(point.coords, {
                icon: this.icon
            }).addTo(this.leaflet);
            marker.on("click", ()=>{
                app.nodesAddClass(this._blocks, "d-none");
                this.markers.forEach((item)=>{
                    item.setIcon(this.icon);
                    this._blocks[n].classList.remove("d-none");
                });
                marker.setIcon(this.icon_yellow);
            });
            this.markers.push(marker);
        });
    }
    constructor(element){
        this._wrapper = element;
        this._map = this._wrapper.querySelector(".js-maps-events-rmc-map");
        this._blocks = this._wrapper.querySelectorAll(".js-maps-events-rmc-block");
        this._closes = this._wrapper.querySelectorAll(".js-maps-events-rmc-close");
        this._geoloc = this._wrapper.querySelector(".js-maps-events-rmc-geoloc");
        this.markers = [];
        this._markersData = [
            {
                name: "Paris",
                coords: [
                    48.8566,
                    2.3522
                ],
                description: "Capitale de la France"
            },
            {
                name: "Lyon",
                coords: [
                    45.75,
                    4.85
                ],
                description: "Ville des lumi\xe8res"
            },
            {
                name: "Marseille",
                coords: [
                    43.2965,
                    5.3698
                ],
                description: "Ville portuaire de la M\xe9diterran\xe9e"
            }
        ];
        this.icon = L.icon({
            iconUrl: template_directory + "/dist/images/svg/marker.svg",
            iconSize: [
                25,
                33
            ],
            iconAnchor: [
                12,
                33
            ]
        });
        this.icon_yellow = L.icon({
            iconUrl: template_directory + "/dist/images/svg/marker_clicked.svg",
            iconSize: [
                25,
                33
            ],
            iconAnchor: [
                12,
                33
            ]
        });
        this.initMap();
        this.bindEvents();
    }
}


class $8045e455776efd36$export$2e2bcd8739ae039 {
    bindEvents() {
        document.addEventListener("facetwp-refresh", function() {
            Object.entries(FWP.facets).forEach(([key, value])=>{
                let _facet = document.querySelector('.facetwp-facet[data-name="' + key + '"]');
                if (value.length) _facet.classList.add("has-value");
                else _facet.classList.remove("has-value");
            });
        });
    }
    constructor(element){
        this._wrapper = element;
        this.bindEvents();
    }
}


class $38f23f7012812e01$export$2e2bcd8739ae039 {
    bindEvents() {
        document.addEventListener("facetwp-refresh", ()=>{
            let _facet = this._wrapper.querySelector(".facetwp-facet");
            let facetName = _facet.getAttribute("data-name");
            this._start.value = FWP.facets[facetName][0] ? FWP.facets[facetName][0].split("-").reverse().join("-") : "";
            this._end.value = FWP.facets[facetName][1] ? FWP.facets[facetName][1].split("-").reverse().join("-") : "";
        });
    }
    constructor(element){
        this._wrapper = element;
        this._start = this._wrapper.querySelector(".js-custom-facet-calendar-start");
        this._end = this._wrapper.querySelector(".js-custom-facet-calendar-end");
        this.bindEvents();
    }
}


class $11ddb76517fd5f12$export$2e2bcd8739ae039 {
    bindEvents() {
        app.nodesEventListener("click", this._btns, (el, n, e)=>{
            el.classList.toggle("is-active");
            let values = el.getAttribute("data-value");
            values = values.split(",");
            values.forEach((value)=>{
                const index = this.values[el.getAttribute("data-type")].indexOf(value);
                if (index !== -1) this.values[el.getAttribute("data-type")].splice(index, 1);
                else this.values[el.getAttribute("data-type")].push(value);
            });
            let has_values = this._wrapper.querySelectorAll(".js-events-rmc-filter.is-active");
            if (has_values.length) this._btnSubmit.classList.remove("d-none");
            else this._btnSubmit.classList.add("d-none");
        });
        this._btnSubmit.addEventListener("click", (el)=>{
            this._loader.classList.remove("d-none");
            this._ajaxWrapper.innerHTML = "";
            const formData = new FormData();
            formData.append("action", "submit_find_events_rmc");
            formData.append("values", JSON.stringify(this.values));
            fetch(ajaxurl, {
                method: "POST",
                body: formData
            }).then((response)=>{
                if (!response.ok) throw new Error("Erreur r\xe9seau");
                return response.text();
            }).then((data)=>{
                this._loader.classList.add("d-none");
                if (this._ajaxWrapper) this._ajaxWrapper.innerHTML = data;
            }).catch((error)=>{
                console.error("Erreur AJAX :", error);
            });
        });
    }
    constructor(element){
        this._wrapper = element;
        this._btns = this._wrapper.querySelectorAll(".js-events-rmc-filter");
        this._ajaxWrapper = this._wrapper.querySelector(".js-events-rmc-ajax");
        this._btnSubmit = this._wrapper.querySelector(".js-events-rmc-submit");
        this._loader = this._wrapper.querySelector(".loader");
        this.values = {
            im: [],
            looking_for: [],
            regions: []
        };
        this.bindEvents();
    }
}


window.addEventListener("load", ()=>{
    document.body.classList.add("css-animation-ready"); // Wait for the DOM to be fully loaded (with fonts), to run animations (wrong width if font not loaded for example)
});
app.domReady(()=>{
    const els = {
        _flexibleSlider: document.querySelectorAll(".js-flexible-slider"),
        _flexiblesAnchors: document.querySelectorAll(".js-flexibles-anchors"),
        _relatedArticles: document.querySelectorAll(".js-related-articles"),
        _relatedJobs: document.querySelectorAll(".js-related-jobs"),
        _relatedNews: document.querySelectorAll(".js-related-news"),
        _addToCalendars: document.querySelectorAll(".js-add-to-calendar"),
        _marquee: document.querySelectorAll(".js-marquee"),
        _sectorsList: document.querySelectorAll(".js-sectors-list"),
        _sliderVideo: document.querySelectorAll(".js-slider-video"),
        _formationsList: document.querySelectorAll(".js-formations-list"),
        _toolBox: document.querySelectorAll(".js-toolbox"),
        _videos: document.querySelectorAll(".js-video"),
        _videosSnap: document.querySelectorAll(".js-videos-snap"),
        _pushVideoJob: document.querySelectorAll(".js-push-video-job"),
        _movingSectors: document.querySelectorAll(".js-moving-sectors"),
        _selectCheckbox: document.querySelectorAll(".js-select-checkbox"),
        _customSelects: document.querySelectorAll(".js-custom-select"),
        _dateInput: document.querySelectorAll(".js-date-input"),
        _inputControlDisables: document.querySelectorAll(".js-input-control-disable"),
        _hourInputs: document.querySelectorAll(".js-hour-input"),
        _inputUpload: document.querySelectorAll(".js-input-upload"),
        _formSubmitEvent: document.querySelectorAll(".js-form-submit-event"),
        _inputQuills: document.querySelectorAll(".js-input-quill"),
        _inputAddress: document.querySelectorAll(".js-input-address"),
        _captchas: document.querySelectorAll(".js-captcha"),
        _mapEventsRmc: document.querySelectorAll(".js-maps-events-rmc"),
        _searchEventsRmc: document.querySelectorAll(".js-search-events-rmc"),
        _customFacetCalendars: document.querySelectorAll(".js-custom-facet-calendar"),
        _eventsRmc: document.querySelectorAll(".js-events-rmc")
    };
    new (0, $e080a3d1894460ec$export$2e2bcd8739ae039)();
    new (0, $1433b2a5d008d444$export$2e2bcd8739ae039)();
    if (els._flexibleSlider.length) [
        ...els._flexibleSlider
    ].map((el)=>{
        new (0, $43e69f558dbbb285$export$2e2bcd8739ae039)(el);
    });
    if (els._flexiblesAnchors.length) [
        ...els._flexiblesAnchors
    ].map((el)=>{
        new (0, $299a04d279521f55$export$2e2bcd8739ae039)(el);
    });
    if (els._relatedArticles.length) [
        ...els._relatedArticles
    ].map((el)=>{
        new (0, $bd0ced7f3757fcf6$export$2e2bcd8739ae039)(el);
    });
    if (els._relatedNews.length) [
        ...els._relatedNews
    ].map((el)=>{
        new (0, $7eaf8133ffc569dd$export$2e2bcd8739ae039)(el);
    });
    if (els._relatedJobs.length) [
        ...els._relatedJobs
    ].map((el)=>{
        new (0, $a74bd482019d7be3$export$2e2bcd8739ae039)(el);
    });
    if (els._addToCalendars.length) [
        ...els._addToCalendars
    ].map((el)=>{
        new (0, $de5b88a996a03fad$export$2e2bcd8739ae039)(el);
    });
    if (els._marquee.length) [
        ...els._marquee
    ].map((el)=>{
        new (0, $5ba741c30eea73e0$export$2e2bcd8739ae039)(el);
    });
    if (els._sectorsList.length) [
        ...els._sectorsList
    ].map((el)=>{
        new (0, $43abcced49545ed4$export$2e2bcd8739ae039)(el);
    });
    if (els._sliderVideo.length) [
        ...els._sliderVideo
    ].map((el)=>{
        new (0, $6185d5206e00a777$export$2e2bcd8739ae039)(el);
    });
    if (els._formationsList.length) [
        ...els._formationsList
    ].map((el)=>{
        new (0, $e641f985927f5a57$export$2e2bcd8739ae039)(el);
    });
    if (els._toolBox.length) [
        ...els._toolBox
    ].map((el)=>{
        new (0, $af92b340f4147145$export$2e2bcd8739ae039)(el);
    });
    if (els._videos.length) [
        ...els._videos
    ].map((el)=>{
        new (0, $bab3f182bc208b52$export$2e2bcd8739ae039)(el);
    });
    if (els._videosSnap.length) [
        ...els._videosSnap
    ].map((el)=>{
        new (0, $5eefd6e18e446bf4$export$2e2bcd8739ae039)(el);
    });
    if (els._pushVideoJob.length) [
        ...els._pushVideoJob
    ].map((el)=>{
        new (0, $aeabe4adcafdd9ea$export$2e2bcd8739ae039)(el);
    });
    if (els._movingSectors.length) [
        ...els._movingSectors
    ].map((el)=>{
        new (0, $fd056df4e50f273d$export$2e2bcd8739ae039)(el);
    });
    if (els._selectCheckbox.length) [
        ...els._selectCheckbox
    ].map((el)=>{
        new (0, $139f0dbfb448c2bf$export$2e2bcd8739ae039)(el);
    });
    if (els._customSelects.length) [
        ...els._customSelects
    ].map((el)=>{
        new (0, $97ba5cb75142f565$export$2e2bcd8739ae039)(el);
    });
    if (els._dateInput.length) [
        ...els._dateInput
    ].map((el)=>{
        new (0, $923309b8b2bbee62$export$2e2bcd8739ae039)(el);
    });
    if (els._hourInputs.length) [
        ...els._hourInputs
    ].map((el)=>{
        new (0, $686834993310d117$export$2e2bcd8739ae039)(el);
    });
    if (els._inputControlDisables.length) [
        ...els._inputControlDisables
    ].map((el)=>{
        new (0, $7bd45705ff25b3e9$export$2e2bcd8739ae039)(el);
    });
    if (els._inputUpload.length) [
        ...els._inputUpload
    ].map((el)=>{
        new (0, $790b48f623a35f09$export$2e2bcd8739ae039)(el);
    });
    if (els._formSubmitEvent.length) [
        ...els._formSubmitEvent
    ].map((el)=>{
        new (0, $7823f63f6e12eb2e$export$2e2bcd8739ae039)(el);
    });
    if (els._inputQuills.length) [
        ...els._inputQuills
    ].map((el)=>{
        new (0, $01acdaba83a4a6d7$export$2e2bcd8739ae039)(el);
    });
    if (els._inputAddress.length) [
        ...els._inputAddress
    ].map((el)=>{
        new (0, $1e930eaa3afdc932$export$2e2bcd8739ae039)(el);
    });
    if (els._captchas.length) [
        ...els._captchas
    ].map((el)=>{
        new (0, $258cd0a622844f83$export$2e2bcd8739ae039)(el);
    });
    if (els._customFacetCalendars.length) [
        ...els._customFacetCalendars
    ].map((el)=>{
        new (0, $38f23f7012812e01$export$2e2bcd8739ae039)(el);
    });
    if (els._mapEventsRmc.length) [
        ...els._mapEventsRmc
    ].map((el)=>{
        new (0, $ca1fb913bac19cbd$export$2e2bcd8739ae039)(el);
    });
    if (els._searchEventsRmc.length) [
        ...els._searchEventsRmc
    ].map((el)=>{
        new (0, $8045e455776efd36$export$2e2bcd8739ae039)(el);
    });
    if (els._eventsRmc.length) [
        ...els._eventsRmc
    ].map((el)=>{
        new (0, $11ddb76517fd5f12$export$2e2bcd8739ae039)(el);
    });
    document.addEventListener("facetwp-loaded", ()=>{
        // Video 
        let _videos = document.querySelectorAll(".js-video");
        [
            ..._videos
        ].map((el)=>{
            if (!el.isInit) new (0, $bab3f182bc208b52$export$2e2bcd8739ae039)(el);
        });
        let _videoSnap = document.querySelector(".js-videos-snap");
        if (_videoSnap) new (0, $5eefd6e18e446bf4$export$2e2bcd8739ae039)(_videoSnap);
        //Front pagination
        let _frontPaginations = document.querySelectorAll(".js-front-pagination");
        if (_frontPaginations.length) [
            ..._frontPaginations
        ].map((el)=>{
            new (0, $a24a10d549e9a0b4$export$2e2bcd8739ae039)(el);
        });
        //Calendars 
        let _addToCalendars = document.querySelectorAll(".js-add-to-calendar");
        if (_addToCalendars.length) [
            ..._addToCalendars
        ].map((el)=>{
            if (!el.isInit) new (0, $de5b88a996a03fad$export$2e2bcd8739ae039)(el);
        });
    });
    document.addEventListener("click", (e)=>{
        if (e.target.classList.contains("js-cookies-consent-youtube")) {
            console.log("here");
            window.BorlabsCookie.Consents.addConsent("youtube", "external-media");
        }
    });
});

})();
//# sourceMappingURL=main.js.map
